function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9d3f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9d3f"] = parcelRequire;
}
parcelRequire.register("hi5z5", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c9686f2ae6fd93b8$export$ffb0004e005737fa; }, function (v) { return $c9686f2ae6fd93b8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b; }, function (v) { return $c9686f2ae6fd93b8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $c9686f2ae6fd93b8$export$25062201e9e25d76; }, function (v) { return $c9686f2ae6fd93b8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9686f2ae6fd93b8$export$ffb0004e005737fa;
var $c9686f2ae6fd93b8$export$34b9dba7ce09269b;
var $c9686f2ae6fd93b8$export$25062201e9e25d76;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
var $c9686f2ae6fd93b8$var$k = Symbol.for("react.element"), $c9686f2ae6fd93b8$var$l = Symbol.for("react.fragment"), $c9686f2ae6fd93b8$var$m = Object.prototype.hasOwnProperty, $c9686f2ae6fd93b8$var$n = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c9686f2ae6fd93b8$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c9686f2ae6fd93b8$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c9686f2ae6fd93b8$var$m.call(a, b) && !$c9686f2ae6fd93b8$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c9686f2ae6fd93b8$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c9686f2ae6fd93b8$var$n.current
    };
}
$c9686f2ae6fd93b8$export$ffb0004e005737fa = $c9686f2ae6fd93b8$var$l;
$c9686f2ae6fd93b8$export$34b9dba7ce09269b = $c9686f2ae6fd93b8$var$q;
$c9686f2ae6fd93b8$export$25062201e9e25d76 = $c9686f2ae6fd93b8$var$q;

});
parcelRequire.register("4Iuzv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ip19S"));

});
parcelRequire.register("ip19S", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954; }, function (v) { return $d65b75cac4e2d5f6$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8; }, function (v) { return $d65b75cac4e2d5f6$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d65b75cac4e2d5f6$export$ffb0004e005737fa; }, function (v) { return $d65b75cac4e2d5f6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d65b75cac4e2d5f6$export$e2c29f18771995cb; }, function (v) { return $d65b75cac4e2d5f6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd; }, function (v) { return $d65b75cac4e2d5f6$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d65b75cac4e2d5f6$export$5f8d39834fd61797; }, function (v) { return $d65b75cac4e2d5f6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5; }, function (v) { return $d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d65b75cac4e2d5f6$export$ae55be85d98224ed; }, function (v) { return $d65b75cac4e2d5f6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d65b75cac4e2d5f6$export$e530037191fcd5d7; }, function (v) { return $d65b75cac4e2d5f6$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109; }, function (v) { return $d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d; }, function (v) { return $d65b75cac4e2d5f6$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9; }, function (v) { return $d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43; }, function (v) { return $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d65b75cac4e2d5f6$export$257a8862b851cb5b; }, function (v) { return $d65b75cac4e2d5f6$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d65b75cac4e2d5f6$export$a8257692ac88316c; }, function (v) { return $d65b75cac4e2d5f6$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d65b75cac4e2d5f6$export$488013bae63b21da; }, function (v) { return $d65b75cac4e2d5f6$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d65b75cac4e2d5f6$export$7c73462e0d25e514; }, function (v) { return $d65b75cac4e2d5f6$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d65b75cac4e2d5f6$export$7568632d0d33d16d; }, function (v) { return $d65b75cac4e2d5f6$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $d65b75cac4e2d5f6$export$88948ce120ea2619; }, function (v) { return $d65b75cac4e2d5f6$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d65b75cac4e2d5f6$export$35808ee640e87ca7; }, function (v) { return $d65b75cac4e2d5f6$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d65b75cac4e2d5f6$export$fae74005e78b1a27; }, function (v) { return $d65b75cac4e2d5f6$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e; }, function (v) { return $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf; }, function (v) { return $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591; }, function (v) { return $d65b75cac4e2d5f6$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $d65b75cac4e2d5f6$export$f680877a34711e37; }, function (v) { return $d65b75cac4e2d5f6$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2; }, function (v) { return $d65b75cac4e2d5f6$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969; }, function (v) { return $d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c; }, function (v) { return $d65b75cac4e2d5f6$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d65b75cac4e2d5f6$export$1538c33de8887b59; }, function (v) { return $d65b75cac4e2d5f6$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $d65b75cac4e2d5f6$export$13e3392192263954; }, function (v) { return $d65b75cac4e2d5f6$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca; }, function (v) { return $d65b75cac4e2d5f6$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d65b75cac4e2d5f6$export$60241385465d0a34; }, function (v) { return $d65b75cac4e2d5f6$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16; }, function (v) { return $d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf; }, function (v) { return $d65b75cac4e2d5f6$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d65b75cac4e2d5f6$export$83d89fbfd8236492; }, function (v) { return $d65b75cac4e2d5f6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d65b75cac4e2d5f6$export$dca3b0875bd9a954;
var $d65b75cac4e2d5f6$export$16fa2f45be04daa8;
var $d65b75cac4e2d5f6$export$ffb0004e005737fa;
var $d65b75cac4e2d5f6$export$e2c29f18771995cb;
var $d65b75cac4e2d5f6$export$221d75b3f55bb0bd;
var $d65b75cac4e2d5f6$export$5f8d39834fd61797;
var $d65b75cac4e2d5f6$export$74bf444e3cd11ea5;
var $d65b75cac4e2d5f6$export$ae55be85d98224ed;
var $d65b75cac4e2d5f6$export$e530037191fcd5d7;
var $d65b75cac4e2d5f6$export$fd42f52fd3ae1109;
var $d65b75cac4e2d5f6$export$c8a8987d4410bf2d;
var $d65b75cac4e2d5f6$export$d38cd72104c1f0e9;
var $d65b75cac4e2d5f6$export$7d1e3a5e95ceca43;
var $d65b75cac4e2d5f6$export$257a8862b851cb5b;
var $d65b75cac4e2d5f6$export$a8257692ac88316c;
var $d65b75cac4e2d5f6$export$488013bae63b21da;
var $d65b75cac4e2d5f6$export$7c73462e0d25e514;
var $d65b75cac4e2d5f6$export$7568632d0d33d16d;
var $d65b75cac4e2d5f6$export$88948ce120ea2619;
var $d65b75cac4e2d5f6$export$35808ee640e87ca7;
var $d65b75cac4e2d5f6$export$fae74005e78b1a27;
var $d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e;
var $d65b75cac4e2d5f6$export$6a7bc4e911dc01cf;
var $d65b75cac4e2d5f6$export$6d9c69b0de29b591;
var $d65b75cac4e2d5f6$export$f680877a34711e37;
var $d65b75cac4e2d5f6$export$d5a552a76deda3c2;
var $d65b75cac4e2d5f6$export$aaabe4eda9ed9969;
var $d65b75cac4e2d5f6$export$e5c5a5f917a5871c;
var $d65b75cac4e2d5f6$export$1538c33de8887b59;
var $d65b75cac4e2d5f6$export$13e3392192263954;
var $d65b75cac4e2d5f6$export$b8f5890fc79d6aca;
var $d65b75cac4e2d5f6$export$60241385465d0a34;
var $d65b75cac4e2d5f6$export$306c0aa65ff9ec16;
var $d65b75cac4e2d5f6$export$7b286972b8d8ccbf;
var $d65b75cac4e2d5f6$export$83d89fbfd8236492;
"use strict";
var $d65b75cac4e2d5f6$var$l = Symbol.for("react.element"), $d65b75cac4e2d5f6$var$n = Symbol.for("react.portal"), $d65b75cac4e2d5f6$var$p = Symbol.for("react.fragment"), $d65b75cac4e2d5f6$var$q = Symbol.for("react.strict_mode"), $d65b75cac4e2d5f6$var$r = Symbol.for("react.profiler"), $d65b75cac4e2d5f6$var$t = Symbol.for("react.provider"), $d65b75cac4e2d5f6$var$u = Symbol.for("react.context"), $d65b75cac4e2d5f6$var$v = Symbol.for("react.forward_ref"), $d65b75cac4e2d5f6$var$w = Symbol.for("react.suspense"), $d65b75cac4e2d5f6$var$x = Symbol.for("react.memo"), $d65b75cac4e2d5f6$var$y = Symbol.for("react.lazy"), $d65b75cac4e2d5f6$var$z = Symbol.iterator;
function $d65b75cac4e2d5f6$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d65b75cac4e2d5f6$var$z && a[$d65b75cac4e2d5f6$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d65b75cac4e2d5f6$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d65b75cac4e2d5f6$var$C = Object.assign, $d65b75cac4e2d5f6$var$D = {};
function $d65b75cac4e2d5f6$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
$d65b75cac4e2d5f6$var$E.prototype.isReactComponent = {};
$d65b75cac4e2d5f6$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$d65b75cac4e2d5f6$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $d65b75cac4e2d5f6$var$F() {}
$d65b75cac4e2d5f6$var$F.prototype = $d65b75cac4e2d5f6$var$E.prototype;
function $d65b75cac4e2d5f6$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d65b75cac4e2d5f6$var$D;
    this.updater = e || $d65b75cac4e2d5f6$var$B;
}
var $d65b75cac4e2d5f6$var$H = $d65b75cac4e2d5f6$var$G.prototype = new $d65b75cac4e2d5f6$var$F;
$d65b75cac4e2d5f6$var$H.constructor = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$var$C($d65b75cac4e2d5f6$var$H, $d65b75cac4e2d5f6$var$E.prototype);
$d65b75cac4e2d5f6$var$H.isPureReactComponent = !0;
var $d65b75cac4e2d5f6$var$I = Array.isArray, $d65b75cac4e2d5f6$var$J = Object.prototype.hasOwnProperty, $d65b75cac4e2d5f6$var$K = {
    current: null
}, $d65b75cac4e2d5f6$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d65b75cac4e2d5f6$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$d65b75cac4e2d5f6$var$J.call(b, d) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $d65b75cac4e2d5f6$var$K.current
    };
}
function $d65b75cac4e2d5f6$var$N(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $d65b75cac4e2d5f6$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d65b75cac4e2d5f6$var$l;
}
function $d65b75cac4e2d5f6$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $d65b75cac4e2d5f6$var$P = /\/+/g;
function $d65b75cac4e2d5f6$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $d65b75cac4e2d5f6$var$escape("" + a.key) : b.toString(36);
}
function $d65b75cac4e2d5f6$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $d65b75cac4e2d5f6$var$l:
                case $d65b75cac4e2d5f6$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $d65b75cac4e2d5f6$var$Q(h, 0) : d, $d65b75cac4e2d5f6$var$I(c) ? (e = "", null != a && (e = a.replace($d65b75cac4e2d5f6$var$P, "$&/") + "/"), $d65b75cac4e2d5f6$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($d65b75cac4e2d5f6$var$O(c) && (c = $d65b75cac4e2d5f6$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($d65b75cac4e2d5f6$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($d65b75cac4e2d5f6$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $d65b75cac4e2d5f6$var$Q(k, g);
        h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    }
    else if (f = $d65b75cac4e2d5f6$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $d65b75cac4e2d5f6$var$Q(k, g++), h += $d65b75cac4e2d5f6$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $d65b75cac4e2d5f6$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $d65b75cac4e2d5f6$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $d65b75cac4e2d5f6$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $d65b75cac4e2d5f6$var$U = {
    current: null
}, $d65b75cac4e2d5f6$var$V = {
    transition: null
}, $d65b75cac4e2d5f6$var$W = {
    ReactCurrentDispatcher: $d65b75cac4e2d5f6$var$U,
    ReactCurrentBatchConfig: $d65b75cac4e2d5f6$var$V,
    ReactCurrentOwner: $d65b75cac4e2d5f6$var$K
};
$d65b75cac4e2d5f6$export$dca3b0875bd9a954 = {
    map: $d65b75cac4e2d5f6$var$S,
    forEach: function(a, b, e) {
        $d65b75cac4e2d5f6$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $d65b75cac4e2d5f6$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $d65b75cac4e2d5f6$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$d65b75cac4e2d5f6$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$d65b75cac4e2d5f6$export$16fa2f45be04daa8 = $d65b75cac4e2d5f6$var$E;
$d65b75cac4e2d5f6$export$ffb0004e005737fa = $d65b75cac4e2d5f6$var$p;
$d65b75cac4e2d5f6$export$e2c29f18771995cb = $d65b75cac4e2d5f6$var$r;
$d65b75cac4e2d5f6$export$221d75b3f55bb0bd = $d65b75cac4e2d5f6$var$G;
$d65b75cac4e2d5f6$export$5f8d39834fd61797 = $d65b75cac4e2d5f6$var$q;
$d65b75cac4e2d5f6$export$74bf444e3cd11ea5 = $d65b75cac4e2d5f6$var$w;
$d65b75cac4e2d5f6$export$ae55be85d98224ed = $d65b75cac4e2d5f6$var$W;
$d65b75cac4e2d5f6$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $d65b75cac4e2d5f6$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $d65b75cac4e2d5f6$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$d65b75cac4e2d5f6$var$J.call(b, f) && !$d65b75cac4e2d5f6$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $d65b75cac4e2d5f6$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$d65b75cac4e2d5f6$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $d65b75cac4e2d5f6$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $d65b75cac4e2d5f6$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$d65b75cac4e2d5f6$export$c8a8987d4410bf2d = $d65b75cac4e2d5f6$var$M;
$d65b75cac4e2d5f6$export$d38cd72104c1f0e9 = function(a) {
    var b = $d65b75cac4e2d5f6$var$M.bind(null, a);
    b.type = a;
    return b;
};
$d65b75cac4e2d5f6$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d65b75cac4e2d5f6$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$v,
        render: a
    };
};
$d65b75cac4e2d5f6$export$a8257692ac88316c = $d65b75cac4e2d5f6$var$O;
$d65b75cac4e2d5f6$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $d65b75cac4e2d5f6$var$T
    };
};
$d65b75cac4e2d5f6$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $d65b75cac4e2d5f6$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$d65b75cac4e2d5f6$export$7568632d0d33d16d = function(a) {
    var b = $d65b75cac4e2d5f6$var$V.transition;
    $d65b75cac4e2d5f6$var$V.transition = {};
    try {
        a();
    } finally{
        $d65b75cac4e2d5f6$var$V.transition = b;
    }
};
$d65b75cac4e2d5f6$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$d65b75cac4e2d5f6$export$35808ee640e87ca7 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useCallback(a, b);
};
$d65b75cac4e2d5f6$export$fae74005e78b1a27 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useContext(a);
};
$d65b75cac4e2d5f6$export$dc8fbce3eb94dc1e = function() {};
$d65b75cac4e2d5f6$export$6a7bc4e911dc01cf = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useDeferredValue(a);
};
$d65b75cac4e2d5f6$export$6d9c69b0de29b591 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useEffect(a, b);
};
$d65b75cac4e2d5f6$export$f680877a34711e37 = function() {
    return $d65b75cac4e2d5f6$var$U.current.useId();
};
$d65b75cac4e2d5f6$export$d5a552a76deda3c2 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useImperativeHandle(a, b, e);
};
$d65b75cac4e2d5f6$export$aaabe4eda9ed9969 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useInsertionEffect(a, b);
};
$d65b75cac4e2d5f6$export$e5c5a5f917a5871c = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useLayoutEffect(a, b);
};
$d65b75cac4e2d5f6$export$1538c33de8887b59 = function(a, b) {
    return $d65b75cac4e2d5f6$var$U.current.useMemo(a, b);
};
$d65b75cac4e2d5f6$export$13e3392192263954 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useReducer(a, b, e);
};
$d65b75cac4e2d5f6$export$b8f5890fc79d6aca = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useRef(a);
};
$d65b75cac4e2d5f6$export$60241385465d0a34 = function(a) {
    return $d65b75cac4e2d5f6$var$U.current.useState(a);
};
$d65b75cac4e2d5f6$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $d65b75cac4e2d5f6$var$U.current.useSyncExternalStore(a, b, e);
};
$d65b75cac4e2d5f6$export$7b286972b8d8ccbf = function() {
    return $d65b75cac4e2d5f6$var$U.current.useTransition();
};
$d65b75cac4e2d5f6$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("68oCn", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $477696120c5741dc$export$ae55be85d98224ed; }, function (v) { return $477696120c5741dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $477696120c5741dc$export$d39a5bbd09211389; }, function (v) { return $477696120c5741dc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $477696120c5741dc$export$882461b6382ed46c; }, function (v) { return $477696120c5741dc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $477696120c5741dc$export$466bfc07425424d5; }, function (v) { return $477696120c5741dc$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $477696120c5741dc$export$cd75ccfd720a3cd4; }, function (v) { return $477696120c5741dc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $477696120c5741dc$export$fa8d919ba61d84db; }, function (v) { return $477696120c5741dc$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $477696120c5741dc$export$757ceba2d55c277e; }, function (v) { return $477696120c5741dc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $477696120c5741dc$export$b3890eb0ae9dca99; }, function (v) { return $477696120c5741dc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $477696120c5741dc$export$502457920280e6be; }, function (v) { return $477696120c5741dc$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $477696120c5741dc$export$c78a37762a8d58e1; }, function (v) { return $477696120c5741dc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $477696120c5741dc$export$dc54d992c10e8a18; }, function (v) { return $477696120c5741dc$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $477696120c5741dc$export$83d89fbfd8236492; }, function (v) { return $477696120c5741dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $477696120c5741dc$export$ae55be85d98224ed;
var $477696120c5741dc$export$d39a5bbd09211389;
var $477696120c5741dc$export$882461b6382ed46c;
var $477696120c5741dc$export$466bfc07425424d5;
var $477696120c5741dc$export$cd75ccfd720a3cd4;
var $477696120c5741dc$export$fa8d919ba61d84db;
var $477696120c5741dc$export$757ceba2d55c277e;
var $477696120c5741dc$export$b3890eb0ae9dca99;
var $477696120c5741dc$export$502457920280e6be;
var $477696120c5741dc$export$c78a37762a8d58e1;
var $477696120c5741dc$export$dc54d992c10e8a18;
var $477696120c5741dc$export$83d89fbfd8236492;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");

var $1c3ne = parcelRequire("1c3ne");
function $477696120c5741dc$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $477696120c5741dc$var$da = new Set, $477696120c5741dc$var$ea = {};
function $477696120c5741dc$var$fa(a, b) {
    $477696120c5741dc$var$ha(a, b);
    $477696120c5741dc$var$ha(a + "Capture", b);
}
function $477696120c5741dc$var$ha(a, b) {
    $477696120c5741dc$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$477696120c5741dc$var$da.add(b[a]);
}
var $477696120c5741dc$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $477696120c5741dc$var$ja = Object.prototype.hasOwnProperty, $477696120c5741dc$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $477696120c5741dc$var$la = {}, $477696120c5741dc$var$ma = {};
function $477696120c5741dc$var$oa(a) {
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$ma, a)) return !0;
    if ($477696120c5741dc$var$ja.call($477696120c5741dc$var$la, a)) return !1;
    if ($477696120c5741dc$var$ka.test(a)) return $477696120c5741dc$var$ma[a] = !0;
    $477696120c5741dc$var$la[a] = !0;
    return !1;
}
function $477696120c5741dc$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $477696120c5741dc$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $477696120c5741dc$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $477696120c5741dc$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $477696120c5741dc$var$ra = /[\-:]([a-z])/g;
function $477696120c5741dc$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($477696120c5741dc$var$ra, $477696120c5741dc$var$sa);
    $477696120c5741dc$var$z[b] = new $477696120c5741dc$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$477696120c5741dc$var$z.xlinkHref = new $477696120c5741dc$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $477696120c5741dc$var$z[a] = new $477696120c5741dc$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $477696120c5741dc$var$ta(a, b, c, d) {
    var e = $477696120c5741dc$var$z.hasOwnProperty(b) ? $477696120c5741dc$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $477696120c5741dc$var$qa(b, c, e, d) && (c = null), d || null === e ? $477696120c5741dc$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $477696120c5741dc$var$ua = $4Iuzv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $477696120c5741dc$var$va = Symbol.for("react.element"), $477696120c5741dc$var$wa = Symbol.for("react.portal"), $477696120c5741dc$var$ya = Symbol.for("react.fragment"), $477696120c5741dc$var$za = Symbol.for("react.strict_mode"), $477696120c5741dc$var$Aa = Symbol.for("react.profiler"), $477696120c5741dc$var$Ba = Symbol.for("react.provider"), $477696120c5741dc$var$Ca = Symbol.for("react.context"), $477696120c5741dc$var$Da = Symbol.for("react.forward_ref"), $477696120c5741dc$var$Ea = Symbol.for("react.suspense"), $477696120c5741dc$var$Fa = Symbol.for("react.suspense_list"), $477696120c5741dc$var$Ga = Symbol.for("react.memo"), $477696120c5741dc$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $477696120c5741dc$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $477696120c5741dc$var$Ja = Symbol.iterator;
function $477696120c5741dc$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $477696120c5741dc$var$Ja && a[$477696120c5741dc$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $477696120c5741dc$var$A = Object.assign, $477696120c5741dc$var$La;
function $477696120c5741dc$var$Ma(a) {
    if (void 0 === $477696120c5741dc$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $477696120c5741dc$var$La = b && b[1] || "";
    }
    return "\n" + $477696120c5741dc$var$La + a;
}
var $477696120c5741dc$var$Na = !1;
function $477696120c5741dc$var$Oa(a, b) {
    if (!a || $477696120c5741dc$var$Na) return "";
    $477696120c5741dc$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $477696120c5741dc$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $477696120c5741dc$var$Ma(a) : "";
}
function $477696120c5741dc$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $477696120c5741dc$var$Ma(a.type);
        case 16:
            return $477696120c5741dc$var$Ma("Lazy");
        case 13:
            return $477696120c5741dc$var$Ma("Suspense");
        case 19:
            return $477696120c5741dc$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $477696120c5741dc$var$Oa(a.type, !1), a;
        case 11:
            return a = $477696120c5741dc$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $477696120c5741dc$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $477696120c5741dc$var$ya:
            return "Fragment";
        case $477696120c5741dc$var$wa:
            return "Portal";
        case $477696120c5741dc$var$Aa:
            return "Profiler";
        case $477696120c5741dc$var$za:
            return "StrictMode";
        case $477696120c5741dc$var$Ea:
            return "Suspense";
        case $477696120c5741dc$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $477696120c5741dc$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $477696120c5741dc$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $477696120c5741dc$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $477696120c5741dc$var$Ga:
            return b = a.displayName || null, null !== b ? b : $477696120c5741dc$var$Qa(a.type) || "Memo";
        case $477696120c5741dc$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $477696120c5741dc$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $477696120c5741dc$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $477696120c5741dc$var$Qa(b);
        case 8:
            return b === $477696120c5741dc$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $477696120c5741dc$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $477696120c5741dc$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $477696120c5741dc$var$Ua(a) {
    var b = $477696120c5741dc$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $477696120c5741dc$var$Va(a) {
    a._valueTracker || (a._valueTracker = $477696120c5741dc$var$Ua(a));
}
function $477696120c5741dc$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $477696120c5741dc$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $477696120c5741dc$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $477696120c5741dc$var$Ya(a, b) {
    var c = b.checked;
    return $477696120c5741dc$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $477696120c5741dc$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $477696120c5741dc$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $477696120c5741dc$var$ab(a, b) {
    b = b.checked;
    null != b && $477696120c5741dc$var$ta(a, "checked", b, !1);
}
function $477696120c5741dc$var$bb(a, b) {
    $477696120c5741dc$var$ab(a, b);
    var c = $477696120c5741dc$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $477696120c5741dc$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $477696120c5741dc$var$cb(a, b.type, $477696120c5741dc$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $477696120c5741dc$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $477696120c5741dc$var$cb(a, b, c) {
    if ("number" !== b || $477696120c5741dc$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $477696120c5741dc$var$eb = Array.isArray;
function $477696120c5741dc$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $477696120c5741dc$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $477696120c5741dc$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($477696120c5741dc$var$p(91));
    return $477696120c5741dc$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $477696120c5741dc$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($477696120c5741dc$var$p(92));
            if ($477696120c5741dc$var$eb(c)) {
                if (1 < c.length) throw Error($477696120c5741dc$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $477696120c5741dc$var$Sa(c)
    };
}
function $477696120c5741dc$var$ib(a, b) {
    var c = $477696120c5741dc$var$Sa(b.value), d = $477696120c5741dc$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $477696120c5741dc$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $477696120c5741dc$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $477696120c5741dc$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $477696120c5741dc$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $477696120c5741dc$var$mb, $477696120c5741dc$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $477696120c5741dc$var$mb = $477696120c5741dc$var$mb || document.createElement("div");
        $477696120c5741dc$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $477696120c5741dc$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $477696120c5741dc$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $477696120c5741dc$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $477696120c5741dc$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($477696120c5741dc$var$pb).forEach(function(a) {
    $477696120c5741dc$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $477696120c5741dc$var$pb[b] = $477696120c5741dc$var$pb[a];
    });
});
function $477696120c5741dc$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $477696120c5741dc$var$pb.hasOwnProperty(a) && $477696120c5741dc$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $477696120c5741dc$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $477696120c5741dc$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $477696120c5741dc$var$tb = $477696120c5741dc$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $477696120c5741dc$var$ub(a, b) {
    if (b) {
        if ($477696120c5741dc$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($477696120c5741dc$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($477696120c5741dc$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($477696120c5741dc$var$p(62));
    }
}
function $477696120c5741dc$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $477696120c5741dc$var$wb = null;
function $477696120c5741dc$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $477696120c5741dc$var$yb = null, $477696120c5741dc$var$zb = null, $477696120c5741dc$var$Ab = null;
function $477696120c5741dc$var$Bb(a) {
    if (a = $477696120c5741dc$var$Cb(a)) {
        if ("function" !== typeof $477696120c5741dc$var$yb) throw Error($477696120c5741dc$var$p(280));
        var b = a.stateNode;
        b && (b = $477696120c5741dc$var$Db(b), $477696120c5741dc$var$yb(a.stateNode, a.type, b));
    }
}
function $477696120c5741dc$var$Eb(a) {
    $477696120c5741dc$var$zb ? $477696120c5741dc$var$Ab ? $477696120c5741dc$var$Ab.push(a) : $477696120c5741dc$var$Ab = [
        a
    ] : $477696120c5741dc$var$zb = a;
}
function $477696120c5741dc$var$Fb() {
    if ($477696120c5741dc$var$zb) {
        var a = $477696120c5741dc$var$zb, b = $477696120c5741dc$var$Ab;
        $477696120c5741dc$var$Ab = $477696120c5741dc$var$zb = null;
        $477696120c5741dc$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$477696120c5741dc$var$Bb(b[a]);
    }
}
function $477696120c5741dc$var$Gb(a, b) {
    return a(b);
}
function $477696120c5741dc$var$Hb() {}
var $477696120c5741dc$var$Ib = !1;
function $477696120c5741dc$var$Jb(a, b, c) {
    if ($477696120c5741dc$var$Ib) return a(b, c);
    $477696120c5741dc$var$Ib = !0;
    try {
        return $477696120c5741dc$var$Gb(a, b, c);
    } finally{
        if ($477696120c5741dc$var$Ib = !1, null !== $477696120c5741dc$var$zb || null !== $477696120c5741dc$var$Ab) $477696120c5741dc$var$Hb(), $477696120c5741dc$var$Fb();
    }
}
function $477696120c5741dc$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $477696120c5741dc$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($477696120c5741dc$var$p(231, b, typeof c));
    return c;
}
var $477696120c5741dc$var$Lb = !1;
if ($477696120c5741dc$var$ia) try {
    var $477696120c5741dc$var$Mb = {};
    Object.defineProperty($477696120c5741dc$var$Mb, "passive", {
        get: function() {
            $477696120c5741dc$var$Lb = !0;
        }
    });
    window.addEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
    window.removeEventListener("test", $477696120c5741dc$var$Mb, $477696120c5741dc$var$Mb);
} catch (a) {
    $477696120c5741dc$var$Lb = !1;
}
function $477696120c5741dc$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $477696120c5741dc$var$Ob = !1, $477696120c5741dc$var$Pb = null, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, $477696120c5741dc$var$Sb = {
    onError: function(a) {
        $477696120c5741dc$var$Ob = !0;
        $477696120c5741dc$var$Pb = a;
    }
};
function $477696120c5741dc$var$Tb(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Ob = !1;
    $477696120c5741dc$var$Pb = null;
    $477696120c5741dc$var$Nb.apply($477696120c5741dc$var$Sb, arguments);
}
function $477696120c5741dc$var$Ub(a, b, c, d, e, f, g, h, k) {
    $477696120c5741dc$var$Tb.apply(this, arguments);
    if ($477696120c5741dc$var$Ob) {
        if ($477696120c5741dc$var$Ob) {
            var l = $477696120c5741dc$var$Pb;
            $477696120c5741dc$var$Ob = !1;
            $477696120c5741dc$var$Pb = null;
        } else throw Error($477696120c5741dc$var$p(198));
        $477696120c5741dc$var$Qb || ($477696120c5741dc$var$Qb = !0, $477696120c5741dc$var$Rb = l);
    }
}
function $477696120c5741dc$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $477696120c5741dc$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $477696120c5741dc$var$Xb(a) {
    if ($477696120c5741dc$var$Vb(a) !== a) throw Error($477696120c5741dc$var$p(188));
}
function $477696120c5741dc$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $477696120c5741dc$var$Vb(a);
        if (null === b) throw Error($477696120c5741dc$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $477696120c5741dc$var$Xb(e), a;
                if (f === d) return $477696120c5741dc$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($477696120c5741dc$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($477696120c5741dc$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($477696120c5741dc$var$p(190));
    }
    if (3 !== c.tag) throw Error($477696120c5741dc$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $477696120c5741dc$var$Zb(a) {
    a = $477696120c5741dc$var$Yb(a);
    return null !== a ? $477696120c5741dc$var$$b(a) : null;
}
function $477696120c5741dc$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $477696120c5741dc$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $477696120c5741dc$var$ac = $1c3ne.unstable_scheduleCallback, $477696120c5741dc$var$bc = $1c3ne.unstable_cancelCallback, $477696120c5741dc$var$cc = $1c3ne.unstable_shouldYield, $477696120c5741dc$var$dc = $1c3ne.unstable_requestPaint, $477696120c5741dc$var$B = $1c3ne.unstable_now, $477696120c5741dc$var$ec = $1c3ne.unstable_getCurrentPriorityLevel, $477696120c5741dc$var$fc = $1c3ne.unstable_ImmediatePriority, $477696120c5741dc$var$gc = $1c3ne.unstable_UserBlockingPriority, $477696120c5741dc$var$hc = $1c3ne.unstable_NormalPriority, $477696120c5741dc$var$ic = $1c3ne.unstable_LowPriority, $477696120c5741dc$var$jc = $1c3ne.unstable_IdlePriority, $477696120c5741dc$var$kc = null, $477696120c5741dc$var$lc = null;
function $477696120c5741dc$var$mc(a) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberRoot) try {
        $477696120c5741dc$var$lc.onCommitFiberRoot($477696120c5741dc$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $477696120c5741dc$var$oc = Math.clz32 ? Math.clz32 : $477696120c5741dc$var$nc, $477696120c5741dc$var$pc = Math.log, $477696120c5741dc$var$qc = Math.LN2;
function $477696120c5741dc$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($477696120c5741dc$var$pc(a) / $477696120c5741dc$var$qc | 0) | 0;
}
var $477696120c5741dc$var$rc = 64, $477696120c5741dc$var$sc = 4194304;
function $477696120c5741dc$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $477696120c5741dc$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $477696120c5741dc$var$tc(h) : (f &= g, 0 !== f && (d = $477696120c5741dc$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $477696120c5741dc$var$tc(g) : 0 !== f && (d = $477696120c5741dc$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $477696120c5741dc$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $477696120c5741dc$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $477696120c5741dc$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $477696120c5741dc$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $477696120c5741dc$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $477696120c5741dc$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $477696120c5741dc$var$yc() {
    var a = $477696120c5741dc$var$rc;
    $477696120c5741dc$var$rc <<= 1;
    0 === ($477696120c5741dc$var$rc & 4194240) && ($477696120c5741dc$var$rc = 64);
    return a;
}
function $477696120c5741dc$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $477696120c5741dc$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $477696120c5741dc$var$oc(b);
    a[b] = c;
}
function $477696120c5741dc$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $477696120c5741dc$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $477696120c5741dc$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $477696120c5741dc$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $477696120c5741dc$var$C = 0;
function $477696120c5741dc$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $477696120c5741dc$var$Ec, $477696120c5741dc$var$Fc, $477696120c5741dc$var$Gc, $477696120c5741dc$var$Hc, $477696120c5741dc$var$Ic, $477696120c5741dc$var$Jc = !1, $477696120c5741dc$var$Kc = [], $477696120c5741dc$var$Lc = null, $477696120c5741dc$var$Mc = null, $477696120c5741dc$var$Nc = null, $477696120c5741dc$var$Oc = new Map, $477696120c5741dc$var$Pc = new Map, $477696120c5741dc$var$Qc = [], $477696120c5741dc$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $477696120c5741dc$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $477696120c5741dc$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $477696120c5741dc$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $477696120c5741dc$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $477696120c5741dc$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $477696120c5741dc$var$Pc.delete(b.pointerId);
    }
}
function $477696120c5741dc$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $477696120c5741dc$var$Cb(b), null !== b && $477696120c5741dc$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $477696120c5741dc$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $477696120c5741dc$var$Lc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $477696120c5741dc$var$Mc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $477696120c5741dc$var$Nc = $477696120c5741dc$var$Tc($477696120c5741dc$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $477696120c5741dc$var$Oc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $477696120c5741dc$var$Pc.set(f, $477696120c5741dc$var$Tc($477696120c5741dc$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $477696120c5741dc$var$Vc(a) {
    var b = $477696120c5741dc$var$Wc(a.target);
    if (null !== b) {
        var c = $477696120c5741dc$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $477696120c5741dc$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $477696120c5741dc$var$Ic(a.priority, function() {
                        $477696120c5741dc$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $477696120c5741dc$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $477696120c5741dc$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $477696120c5741dc$var$wb = d;
            c.target.dispatchEvent(d);
            $477696120c5741dc$var$wb = null;
        } else return b = $477696120c5741dc$var$Cb(c), null !== b && $477696120c5741dc$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $477696120c5741dc$var$Zc(a, b, c) {
    $477696120c5741dc$var$Xc(a) && c.delete(b);
}
function $477696120c5741dc$var$$c() {
    $477696120c5741dc$var$Jc = !1;
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Lc) && ($477696120c5741dc$var$Lc = null);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Mc) && ($477696120c5741dc$var$Mc = null);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$Xc($477696120c5741dc$var$Nc) && ($477696120c5741dc$var$Nc = null);
    $477696120c5741dc$var$Oc.forEach($477696120c5741dc$var$Zc);
    $477696120c5741dc$var$Pc.forEach($477696120c5741dc$var$Zc);
}
function $477696120c5741dc$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $477696120c5741dc$var$Jc || ($477696120c5741dc$var$Jc = !0, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, $477696120c5741dc$var$$c)));
}
function $477696120c5741dc$var$bd(a) {
    function b(b) {
        return $477696120c5741dc$var$ad(b, a);
    }
    if (0 < $477696120c5741dc$var$Kc.length) {
        $477696120c5741dc$var$ad($477696120c5741dc$var$Kc[0], a);
        for(var c = 1; c < $477696120c5741dc$var$Kc.length; c++){
            var d = $477696120c5741dc$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $477696120c5741dc$var$Lc && $477696120c5741dc$var$ad($477696120c5741dc$var$Lc, a);
    null !== $477696120c5741dc$var$Mc && $477696120c5741dc$var$ad($477696120c5741dc$var$Mc, a);
    null !== $477696120c5741dc$var$Nc && $477696120c5741dc$var$ad($477696120c5741dc$var$Nc, a);
    $477696120c5741dc$var$Oc.forEach(b);
    $477696120c5741dc$var$Pc.forEach(b);
    for(c = 0; c < $477696120c5741dc$var$Qc.length; c++)d = $477696120c5741dc$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $477696120c5741dc$var$Qc.length && (c = $477696120c5741dc$var$Qc[0], null === c.blockedOn);)$477696120c5741dc$var$Vc(c), null === c.blockedOn && $477696120c5741dc$var$Qc.shift();
}
var $477696120c5741dc$var$cd = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$dd = !0;
function $477696120c5741dc$var$ed(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 1, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$gd(a, b, c, d) {
    var e = $477696120c5741dc$var$C, f = $477696120c5741dc$var$cd.transition;
    $477696120c5741dc$var$cd.transition = null;
    try {
        $477696120c5741dc$var$C = 4, $477696120c5741dc$var$fd(a, b, c, d);
    } finally{
        $477696120c5741dc$var$C = e, $477696120c5741dc$var$cd.transition = f;
    }
}
function $477696120c5741dc$var$fd(a, b, c, d) {
    if ($477696120c5741dc$var$dd) {
        var e = $477696120c5741dc$var$Yc(a, b, c, d);
        if (null === e) $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c), $477696120c5741dc$var$Sc(a, d);
        else if ($477696120c5741dc$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($477696120c5741dc$var$Sc(a, d), b & 4 && -1 < $477696120c5741dc$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $477696120c5741dc$var$Cb(e);
                null !== f && $477696120c5741dc$var$Ec(f);
                f = $477696120c5741dc$var$Yc(a, b, c, d);
                null === f && $477696120c5741dc$var$hd(a, b, d, $477696120c5741dc$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $477696120c5741dc$var$hd(a, b, d, null, c);
    }
}
var $477696120c5741dc$var$id = null;
function $477696120c5741dc$var$Yc(a, b, c, d) {
    $477696120c5741dc$var$id = null;
    a = $477696120c5741dc$var$xb(d);
    a = $477696120c5741dc$var$Wc(a);
    if (null !== a) {
        if (b = $477696120c5741dc$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $477696120c5741dc$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $477696120c5741dc$var$id = a;
    return null;
}
function $477696120c5741dc$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($477696120c5741dc$var$ec()){
                case $477696120c5741dc$var$fc:
                    return 1;
                case $477696120c5741dc$var$gc:
                    return 4;
                case $477696120c5741dc$var$hc:
                case $477696120c5741dc$var$ic:
                    return 16;
                case $477696120c5741dc$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ld = null, $477696120c5741dc$var$md = null;
function $477696120c5741dc$var$nd() {
    if ($477696120c5741dc$var$md) return $477696120c5741dc$var$md;
    var a, b = $477696120c5741dc$var$ld, c = b.length, d, e = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $477696120c5741dc$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $477696120c5741dc$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $477696120c5741dc$var$pd() {
    return !0;
}
function $477696120c5741dc$var$qd() {
    return !1;
}
function $477696120c5741dc$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $477696120c5741dc$var$pd : $477696120c5741dc$var$qd;
        this.isPropagationStopped = $477696120c5741dc$var$qd;
        return this;
    }
    $477696120c5741dc$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $477696120c5741dc$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $477696120c5741dc$var$pd);
        },
        persist: function() {},
        isPersistent: $477696120c5741dc$var$pd
    });
    return b;
}
var $477696120c5741dc$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $477696120c5741dc$var$td = $477696120c5741dc$var$rd($477696120c5741dc$var$sd), $477696120c5741dc$var$ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    view: 0,
    detail: 0
}), $477696120c5741dc$var$vd = $477696120c5741dc$var$rd($477696120c5741dc$var$ud), $477696120c5741dc$var$wd, $477696120c5741dc$var$xd, $477696120c5741dc$var$yd, $477696120c5741dc$var$Ad = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $477696120c5741dc$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $477696120c5741dc$var$yd && ($477696120c5741dc$var$yd && "mousemove" === a.type ? ($477696120c5741dc$var$wd = a.screenX - $477696120c5741dc$var$yd.screenX, $477696120c5741dc$var$xd = a.screenY - $477696120c5741dc$var$yd.screenY) : $477696120c5741dc$var$xd = $477696120c5741dc$var$wd = 0, $477696120c5741dc$var$yd = a);
        return $477696120c5741dc$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $477696120c5741dc$var$xd;
    }
}), $477696120c5741dc$var$Bd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ad), $477696120c5741dc$var$Cd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    dataTransfer: 0
}), $477696120c5741dc$var$Dd = $477696120c5741dc$var$rd($477696120c5741dc$var$Cd), $477696120c5741dc$var$Ed = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    relatedTarget: 0
}), $477696120c5741dc$var$Fd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ed), $477696120c5741dc$var$Gd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Hd = $477696120c5741dc$var$rd($477696120c5741dc$var$Gd), $477696120c5741dc$var$Id = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $477696120c5741dc$var$Jd = $477696120c5741dc$var$rd($477696120c5741dc$var$Id), $477696120c5741dc$var$Kd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    data: 0
}), $477696120c5741dc$var$Ld = $477696120c5741dc$var$rd($477696120c5741dc$var$Kd), $477696120c5741dc$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $477696120c5741dc$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $477696120c5741dc$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $477696120c5741dc$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $477696120c5741dc$var$Od[a]) ? !!b[a] : !1;
}
function $477696120c5741dc$var$zd() {
    return $477696120c5741dc$var$Pd;
}
var $477696120c5741dc$var$Qd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $477696120c5741dc$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $477696120c5741dc$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $477696120c5741dc$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $477696120c5741dc$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $477696120c5741dc$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $477696120c5741dc$var$Rd = $477696120c5741dc$var$rd($477696120c5741dc$var$Qd), $477696120c5741dc$var$Sd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $477696120c5741dc$var$Td = $477696120c5741dc$var$rd($477696120c5741dc$var$Sd), $477696120c5741dc$var$Ud = $477696120c5741dc$var$A({}, $477696120c5741dc$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $477696120c5741dc$var$zd
}), $477696120c5741dc$var$Vd = $477696120c5741dc$var$rd($477696120c5741dc$var$Ud), $477696120c5741dc$var$Wd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $477696120c5741dc$var$Xd = $477696120c5741dc$var$rd($477696120c5741dc$var$Wd), $477696120c5741dc$var$Yd = $477696120c5741dc$var$A({}, $477696120c5741dc$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $477696120c5741dc$var$Zd = $477696120c5741dc$var$rd($477696120c5741dc$var$Yd), $477696120c5741dc$var$$d = [
    9,
    13,
    27,
    32
], $477696120c5741dc$var$ae = $477696120c5741dc$var$ia && "CompositionEvent" in window, $477696120c5741dc$var$be = null;
$477696120c5741dc$var$ia && "documentMode" in document && ($477696120c5741dc$var$be = document.documentMode);
var $477696120c5741dc$var$ce = $477696120c5741dc$var$ia && "TextEvent" in window && !$477696120c5741dc$var$be, $477696120c5741dc$var$de = $477696120c5741dc$var$ia && (!$477696120c5741dc$var$ae || $477696120c5741dc$var$be && 8 < $477696120c5741dc$var$be && 11 >= $477696120c5741dc$var$be), $477696120c5741dc$var$ee = String.fromCharCode(32), $477696120c5741dc$var$fe = !1;
function $477696120c5741dc$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $477696120c5741dc$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $477696120c5741dc$var$ie = !1;
function $477696120c5741dc$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $477696120c5741dc$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $477696120c5741dc$var$fe = !0;
            return $477696120c5741dc$var$ee;
        case "textInput":
            return a = b.data, a === $477696120c5741dc$var$ee && $477696120c5741dc$var$fe ? null : a;
        default:
            return null;
    }
}
function $477696120c5741dc$var$ke(a, b) {
    if ($477696120c5741dc$var$ie) return "compositionend" === a || !$477696120c5741dc$var$ae && $477696120c5741dc$var$ge(a, b) ? (a = $477696120c5741dc$var$nd(), $477696120c5741dc$var$md = $477696120c5741dc$var$ld = $477696120c5741dc$var$kd = null, $477696120c5741dc$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $477696120c5741dc$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $477696120c5741dc$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $477696120c5741dc$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$477696120c5741dc$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $477696120c5741dc$var$ne(a, b, c, d) {
    $477696120c5741dc$var$Eb(d);
    b = $477696120c5741dc$var$oe(b, "onChange");
    0 < b.length && (c = new $477696120c5741dc$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $477696120c5741dc$var$pe = null, $477696120c5741dc$var$qe = null;
function $477696120c5741dc$var$re(a) {
    $477696120c5741dc$var$se(a, 0);
}
function $477696120c5741dc$var$te(a) {
    var b = $477696120c5741dc$var$ue(a);
    if ($477696120c5741dc$var$Wa(b)) return a;
}
function $477696120c5741dc$var$ve(a, b) {
    if ("change" === a) return b;
}
var $477696120c5741dc$var$we = !1;
if ($477696120c5741dc$var$ia) {
    var $477696120c5741dc$var$xe;
    if ($477696120c5741dc$var$ia) {
        var $477696120c5741dc$var$ye = "oninput" in document;
        if (!$477696120c5741dc$var$ye) {
            var $477696120c5741dc$var$ze = document.createElement("div");
            $477696120c5741dc$var$ze.setAttribute("oninput", "return;");
            $477696120c5741dc$var$ye = "function" === typeof $477696120c5741dc$var$ze.oninput;
        }
        $477696120c5741dc$var$xe = $477696120c5741dc$var$ye;
    } else $477696120c5741dc$var$xe = !1;
    $477696120c5741dc$var$we = $477696120c5741dc$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $477696120c5741dc$var$Ae() {
    $477696120c5741dc$var$pe && ($477696120c5741dc$var$pe.detachEvent("onpropertychange", $477696120c5741dc$var$Be), $477696120c5741dc$var$qe = $477696120c5741dc$var$pe = null);
}
function $477696120c5741dc$var$Be(a) {
    if ("value" === a.propertyName && $477696120c5741dc$var$te($477696120c5741dc$var$qe)) {
        var b = [];
        $477696120c5741dc$var$ne(b, $477696120c5741dc$var$qe, a, $477696120c5741dc$var$xb(a));
        $477696120c5741dc$var$Jb($477696120c5741dc$var$re, b);
    }
}
function $477696120c5741dc$var$Ce(a, b, c) {
    "focusin" === a ? ($477696120c5741dc$var$Ae(), $477696120c5741dc$var$pe = b, $477696120c5741dc$var$qe = c, $477696120c5741dc$var$pe.attachEvent("onpropertychange", $477696120c5741dc$var$Be)) : "focusout" === a && $477696120c5741dc$var$Ae();
}
function $477696120c5741dc$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $477696120c5741dc$var$te($477696120c5741dc$var$qe);
}
function $477696120c5741dc$var$Ee(a, b) {
    if ("click" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $477696120c5741dc$var$te(b);
}
function $477696120c5741dc$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $477696120c5741dc$var$He = "function" === typeof Object.is ? Object.is : $477696120c5741dc$var$Ge;
function $477696120c5741dc$var$Ie(a, b) {
    if ($477696120c5741dc$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$477696120c5741dc$var$ja.call(b, e) || !$477696120c5741dc$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $477696120c5741dc$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $477696120c5741dc$var$Ke(a, b) {
    var c = $477696120c5741dc$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $477696120c5741dc$var$Je(c);
    }
}
function $477696120c5741dc$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $477696120c5741dc$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $477696120c5741dc$var$Me() {
    for(var a = window, b = $477696120c5741dc$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $477696120c5741dc$var$Xa(a.document);
    }
    return b;
}
function $477696120c5741dc$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $477696120c5741dc$var$Oe(a) {
    var b = $477696120c5741dc$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $477696120c5741dc$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $477696120c5741dc$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $477696120c5741dc$var$Ke(c, f);
                var g = $477696120c5741dc$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $477696120c5741dc$var$Pe = $477696120c5741dc$var$ia && "documentMode" in document && 11 >= document.documentMode, $477696120c5741dc$var$Qe = null, $477696120c5741dc$var$Re = null, $477696120c5741dc$var$Se = null, $477696120c5741dc$var$Te = !1;
function $477696120c5741dc$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $477696120c5741dc$var$Te || null == $477696120c5741dc$var$Qe || $477696120c5741dc$var$Qe !== $477696120c5741dc$var$Xa(d) || (d = $477696120c5741dc$var$Qe, "selectionStart" in d && $477696120c5741dc$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $477696120c5741dc$var$Se && $477696120c5741dc$var$Ie($477696120c5741dc$var$Se, d) || ($477696120c5741dc$var$Se = d, d = $477696120c5741dc$var$oe($477696120c5741dc$var$Re, "onSelect"), 0 < d.length && (b = new $477696120c5741dc$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $477696120c5741dc$var$Qe)));
}
function $477696120c5741dc$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $477696120c5741dc$var$We = {
    animationend: $477696120c5741dc$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $477696120c5741dc$var$Ve("Animation", "AnimationIteration"),
    animationstart: $477696120c5741dc$var$Ve("Animation", "AnimationStart"),
    transitionend: $477696120c5741dc$var$Ve("Transition", "TransitionEnd")
}, $477696120c5741dc$var$Xe = {}, $477696120c5741dc$var$Ye = {};
$477696120c5741dc$var$ia && ($477696120c5741dc$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $477696120c5741dc$var$We.animationend.animation, delete $477696120c5741dc$var$We.animationiteration.animation, delete $477696120c5741dc$var$We.animationstart.animation), "TransitionEvent" in window || delete $477696120c5741dc$var$We.transitionend.transition);
function $477696120c5741dc$var$Ze(a) {
    if ($477696120c5741dc$var$Xe[a]) return $477696120c5741dc$var$Xe[a];
    if (!$477696120c5741dc$var$We[a]) return a;
    var b = $477696120c5741dc$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $477696120c5741dc$var$Ye) return $477696120c5741dc$var$Xe[a] = b[c];
    return a;
}
var $477696120c5741dc$var$$e = $477696120c5741dc$var$Ze("animationend"), $477696120c5741dc$var$af = $477696120c5741dc$var$Ze("animationiteration"), $477696120c5741dc$var$bf = $477696120c5741dc$var$Ze("animationstart"), $477696120c5741dc$var$cf = $477696120c5741dc$var$Ze("transitionend"), $477696120c5741dc$var$df = new Map, $477696120c5741dc$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $477696120c5741dc$var$ff(a, b) {
    $477696120c5741dc$var$df.set(a, b);
    $477696120c5741dc$var$fa(b, [
        a
    ]);
}
for(var $477696120c5741dc$var$gf = 0; $477696120c5741dc$var$gf < $477696120c5741dc$var$ef.length; $477696120c5741dc$var$gf++){
    var $477696120c5741dc$var$hf = $477696120c5741dc$var$ef[$477696120c5741dc$var$gf], $477696120c5741dc$var$jf = $477696120c5741dc$var$hf.toLowerCase(), $477696120c5741dc$var$kf = $477696120c5741dc$var$hf[0].toUpperCase() + $477696120c5741dc$var$hf.slice(1);
    $477696120c5741dc$var$ff($477696120c5741dc$var$jf, "on" + $477696120c5741dc$var$kf);
}
$477696120c5741dc$var$ff($477696120c5741dc$var$$e, "onAnimationEnd");
$477696120c5741dc$var$ff($477696120c5741dc$var$af, "onAnimationIteration");
$477696120c5741dc$var$ff($477696120c5741dc$var$bf, "onAnimationStart");
$477696120c5741dc$var$ff("dblclick", "onDoubleClick");
$477696120c5741dc$var$ff("focusin", "onFocus");
$477696120c5741dc$var$ff("focusout", "onBlur");
$477696120c5741dc$var$ff($477696120c5741dc$var$cf, "onTransitionEnd");
$477696120c5741dc$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$477696120c5741dc$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$477696120c5741dc$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$477696120c5741dc$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$477696120c5741dc$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$477696120c5741dc$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$477696120c5741dc$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $477696120c5741dc$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $477696120c5741dc$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($477696120c5741dc$var$lf));
function $477696120c5741dc$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $477696120c5741dc$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $477696120c5741dc$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $477696120c5741dc$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($477696120c5741dc$var$Qb) throw a = $477696120c5741dc$var$Rb, $477696120c5741dc$var$Qb = !1, $477696120c5741dc$var$Rb = null, a;
}
function $477696120c5741dc$var$D(a, b) {
    var c = b[$477696120c5741dc$var$of];
    void 0 === c && (c = b[$477696120c5741dc$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($477696120c5741dc$var$pf(b, a, 2, !1), c.add(d));
}
function $477696120c5741dc$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $477696120c5741dc$var$pf(c, a, d, b);
}
var $477696120c5741dc$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $477696120c5741dc$var$sf(a) {
    if (!a[$477696120c5741dc$var$rf]) {
        a[$477696120c5741dc$var$rf] = !0;
        $477696120c5741dc$var$da.forEach(function(b) {
            "selectionchange" !== b && ($477696120c5741dc$var$mf.has(b) || $477696120c5741dc$var$qf(b, !1, a), $477696120c5741dc$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$477696120c5741dc$var$rf] || (b[$477696120c5741dc$var$rf] = !0, $477696120c5741dc$var$qf("selectionchange", !1, b));
    }
}
function $477696120c5741dc$var$pf(a, b, c, d) {
    switch($477696120c5741dc$var$jd(b)){
        case 1:
            var e = $477696120c5741dc$var$ed;
            break;
        case 4:
            e = $477696120c5741dc$var$gd;
            break;
        default:
            e = $477696120c5741dc$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$477696120c5741dc$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $477696120c5741dc$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $477696120c5741dc$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $477696120c5741dc$var$Jb(function() {
        var d = f, e = $477696120c5741dc$var$xb(c), g = [];
        a: {
            var h = $477696120c5741dc$var$df.get(a);
            if (void 0 !== h) {
                var k = $477696120c5741dc$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $477696120c5741dc$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $477696120c5741dc$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $477696120c5741dc$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $477696120c5741dc$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $477696120c5741dc$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $477696120c5741dc$var$Vd;
                        break;
                    case $477696120c5741dc$var$$e:
                    case $477696120c5741dc$var$af:
                    case $477696120c5741dc$var$bf:
                        k = $477696120c5741dc$var$Hd;
                        break;
                    case $477696120c5741dc$var$cf:
                        k = $477696120c5741dc$var$Xd;
                        break;
                    case "scroll":
                        k = $477696120c5741dc$var$vd;
                        break;
                    case "wheel":
                        k = $477696120c5741dc$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $477696120c5741dc$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $477696120c5741dc$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $477696120c5741dc$var$Kb(w, x), null != F && t.push($477696120c5741dc$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $477696120c5741dc$var$wb && (n = c.relatedTarget || c.fromElement) && ($477696120c5741dc$var$Wc(n) || n[$477696120c5741dc$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $477696120c5741dc$var$Wc(n) : null, null !== n && (J = $477696120c5741dc$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $477696120c5741dc$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $477696120c5741dc$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $477696120c5741dc$var$ue(k);
                        u = null == n ? h : $477696120c5741dc$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $477696120c5741dc$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $477696120c5741dc$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $477696120c5741dc$var$vf(F))u++;
                            for(; 0 < w - u;)t = $477696120c5741dc$var$vf(t), w--;
                            for(; 0 < u - w;)x = $477696120c5741dc$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $477696120c5741dc$var$vf(t);
                                x = $477696120c5741dc$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $477696120c5741dc$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $477696120c5741dc$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $477696120c5741dc$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $477696120c5741dc$var$ve;
                else if ($477696120c5741dc$var$me(h)) {
                    if ($477696120c5741dc$var$we) na = $477696120c5741dc$var$Fe;
                    else {
                        na = $477696120c5741dc$var$De;
                        var xa = $477696120c5741dc$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $477696120c5741dc$var$Ee);
                if (na && (na = na(a, d))) {
                    $477696120c5741dc$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $477696120c5741dc$var$cb(h, "number", h.value);
            }
            xa = d ? $477696120c5741dc$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($477696120c5741dc$var$me(xa) || "true" === xa.contentEditable) $477696120c5741dc$var$Qe = xa, $477696120c5741dc$var$Re = d, $477696120c5741dc$var$Se = null;
                    break;
                case "focusout":
                    $477696120c5741dc$var$Se = $477696120c5741dc$var$Re = $477696120c5741dc$var$Qe = null;
                    break;
                case "mousedown":
                    $477696120c5741dc$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $477696120c5741dc$var$Te = !1;
                    $477696120c5741dc$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($477696120c5741dc$var$Pe) break;
                case "keydown":
                case "keyup":
                    $477696120c5741dc$var$Ue(g, c, e);
            }
            var $a;
            if ($477696120c5741dc$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $477696120c5741dc$var$ie ? $477696120c5741dc$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($477696120c5741dc$var$de && "ko" !== c.locale && ($477696120c5741dc$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $477696120c5741dc$var$ie && ($a = $477696120c5741dc$var$nd()) : ($477696120c5741dc$var$kd = e, $477696120c5741dc$var$ld = "value" in $477696120c5741dc$var$kd ? $477696120c5741dc$var$kd.value : $477696120c5741dc$var$kd.textContent, $477696120c5741dc$var$ie = !0)), xa = $477696120c5741dc$var$oe(d, ba), 0 < xa.length && (ba = new $477696120c5741dc$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $477696120c5741dc$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $477696120c5741dc$var$ce ? $477696120c5741dc$var$je(a, c) : $477696120c5741dc$var$ke(a, c)) d = $477696120c5741dc$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $477696120c5741dc$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $477696120c5741dc$var$se(g, b);
    });
}
function $477696120c5741dc$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $477696120c5741dc$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $477696120c5741dc$var$Kb(a, c), null != f && d.unshift($477696120c5741dc$var$tf(a, f, e)), f = $477696120c5741dc$var$Kb(a, b), null != f && d.push($477696120c5741dc$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $477696120c5741dc$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $477696120c5741dc$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $477696120c5741dc$var$Kb(c, f), null != k && g.unshift($477696120c5741dc$var$tf(c, k, h))) : e || (k = $477696120c5741dc$var$Kb(c, f), null != k && g.push($477696120c5741dc$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $477696120c5741dc$var$xf = /\r\n?/g, $477696120c5741dc$var$yf = /\u0000|\uFFFD/g;
function $477696120c5741dc$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($477696120c5741dc$var$xf, "\n").replace($477696120c5741dc$var$yf, "");
}
function $477696120c5741dc$var$Af(a, b, c) {
    b = $477696120c5741dc$var$zf(b);
    if ($477696120c5741dc$var$zf(a) !== b && c) throw Error($477696120c5741dc$var$p(425));
}
function $477696120c5741dc$var$Bf() {}
var $477696120c5741dc$var$Cf = null, $477696120c5741dc$var$Df = null;
function $477696120c5741dc$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $477696120c5741dc$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $477696120c5741dc$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $477696120c5741dc$var$Hf = "function" === typeof Promise ? Promise : void 0, $477696120c5741dc$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $477696120c5741dc$var$Hf ? function(a) {
    return $477696120c5741dc$var$Hf.resolve(null).then(a).catch($477696120c5741dc$var$If);
} : $477696120c5741dc$var$Ff;
function $477696120c5741dc$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $477696120c5741dc$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $477696120c5741dc$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $477696120c5741dc$var$bd(b);
}
function $477696120c5741dc$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $477696120c5741dc$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $477696120c5741dc$var$Nf = Math.random().toString(36).slice(2), $477696120c5741dc$var$Of = "__reactFiber$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Pf = "__reactProps$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$uf = "__reactContainer$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$of = "__reactEvents$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Qf = "__reactListeners$" + $477696120c5741dc$var$Nf, $477696120c5741dc$var$Rf = "__reactHandles$" + $477696120c5741dc$var$Nf;
function $477696120c5741dc$var$Wc(a) {
    var b = a[$477696120c5741dc$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$477696120c5741dc$var$uf] || c[$477696120c5741dc$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $477696120c5741dc$var$Mf(a); null !== a;){
                if (c = a[$477696120c5741dc$var$Of]) return c;
                a = $477696120c5741dc$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $477696120c5741dc$var$Cb(a) {
    a = a[$477696120c5741dc$var$Of] || a[$477696120c5741dc$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $477696120c5741dc$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($477696120c5741dc$var$p(33));
}
function $477696120c5741dc$var$Db(a) {
    return a[$477696120c5741dc$var$Pf] || null;
}
var $477696120c5741dc$var$Sf = [], $477696120c5741dc$var$Tf = -1;
function $477696120c5741dc$var$Uf(a) {
    return {
        current: a
    };
}
function $477696120c5741dc$var$E(a) {
    0 > $477696120c5741dc$var$Tf || (a.current = $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf], $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = null, $477696120c5741dc$var$Tf--);
}
function $477696120c5741dc$var$G(a, b) {
    $477696120c5741dc$var$Tf++;
    $477696120c5741dc$var$Sf[$477696120c5741dc$var$Tf] = a.current;
    a.current = b;
}
var $477696120c5741dc$var$Vf = {}, $477696120c5741dc$var$H = $477696120c5741dc$var$Uf($477696120c5741dc$var$Vf), $477696120c5741dc$var$Wf = $477696120c5741dc$var$Uf(!1), $477696120c5741dc$var$Xf = $477696120c5741dc$var$Vf;
function $477696120c5741dc$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $477696120c5741dc$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $477696120c5741dc$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $477696120c5741dc$var$$f() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$E($477696120c5741dc$var$H);
}
function $477696120c5741dc$var$ag(a, b, c) {
    if ($477696120c5741dc$var$H.current !== $477696120c5741dc$var$Vf) throw Error($477696120c5741dc$var$p(168));
    $477696120c5741dc$var$G($477696120c5741dc$var$H, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
function $477696120c5741dc$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($477696120c5741dc$var$p(108, $477696120c5741dc$var$Ra(a) || "Unknown", e));
    return $477696120c5741dc$var$A({}, c, d);
}
function $477696120c5741dc$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $477696120c5741dc$var$Vf;
    $477696120c5741dc$var$Xf = $477696120c5741dc$var$H.current;
    $477696120c5741dc$var$G($477696120c5741dc$var$H, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, $477696120c5741dc$var$Wf.current);
    return !0;
}
function $477696120c5741dc$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($477696120c5741dc$var$p(169));
    c ? (a = $477696120c5741dc$var$bg(a, b, $477696120c5741dc$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$G($477696120c5741dc$var$H, a)) : $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
    $477696120c5741dc$var$G($477696120c5741dc$var$Wf, c);
}
var $477696120c5741dc$var$eg = null, $477696120c5741dc$var$fg = !1, $477696120c5741dc$var$gg = !1;
function $477696120c5741dc$var$hg(a) {
    null === $477696120c5741dc$var$eg ? $477696120c5741dc$var$eg = [
        a
    ] : $477696120c5741dc$var$eg.push(a);
}
function $477696120c5741dc$var$ig(a) {
    $477696120c5741dc$var$fg = !0;
    $477696120c5741dc$var$hg(a);
}
function $477696120c5741dc$var$jg() {
    if (!$477696120c5741dc$var$gg && null !== $477696120c5741dc$var$eg) {
        $477696120c5741dc$var$gg = !0;
        var a = 0, b = $477696120c5741dc$var$C;
        try {
            var c = $477696120c5741dc$var$eg;
            for($477696120c5741dc$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $477696120c5741dc$var$eg = null;
            $477696120c5741dc$var$fg = !1;
        } catch (e) {
            throw null !== $477696120c5741dc$var$eg && ($477696120c5741dc$var$eg = $477696120c5741dc$var$eg.slice(a + 1)), $477696120c5741dc$var$ac($477696120c5741dc$var$fc, $477696120c5741dc$var$jg), e;
        } finally{
            $477696120c5741dc$var$C = b, $477696120c5741dc$var$gg = !1;
        }
    }
    return null;
}
var $477696120c5741dc$var$kg = [], $477696120c5741dc$var$lg = 0, $477696120c5741dc$var$mg = null, $477696120c5741dc$var$ng = 0, $477696120c5741dc$var$og = [], $477696120c5741dc$var$pg = 0, $477696120c5741dc$var$qg = null, $477696120c5741dc$var$rg = 1, $477696120c5741dc$var$sg = "";
function $477696120c5741dc$var$tg(a, b) {
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$ng;
    $477696120c5741dc$var$kg[$477696120c5741dc$var$lg++] = $477696120c5741dc$var$mg;
    $477696120c5741dc$var$mg = a;
    $477696120c5741dc$var$ng = b;
}
function $477696120c5741dc$var$ug(a, b, c) {
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg;
    $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg;
    $477696120c5741dc$var$qg = a;
    var d = $477696120c5741dc$var$rg;
    a = $477696120c5741dc$var$sg;
    var e = 32 - $477696120c5741dc$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $477696120c5741dc$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $477696120c5741dc$var$rg = 1 << 32 - $477696120c5741dc$var$oc(b) + e | c << e | d;
        $477696120c5741dc$var$sg = f + a;
    } else $477696120c5741dc$var$rg = 1 << f | c << e | d, $477696120c5741dc$var$sg = a;
}
function $477696120c5741dc$var$vg(a) {
    null !== a.return && ($477696120c5741dc$var$tg(a, 1), $477696120c5741dc$var$ug(a, 1, 0));
}
function $477696120c5741dc$var$wg(a) {
    for(; a === $477696120c5741dc$var$mg;)$477696120c5741dc$var$mg = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null, $477696120c5741dc$var$ng = $477696120c5741dc$var$kg[--$477696120c5741dc$var$lg], $477696120c5741dc$var$kg[$477696120c5741dc$var$lg] = null;
    for(; a === $477696120c5741dc$var$qg;)$477696120c5741dc$var$qg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$sg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null, $477696120c5741dc$var$rg = $477696120c5741dc$var$og[--$477696120c5741dc$var$pg], $477696120c5741dc$var$og[$477696120c5741dc$var$pg] = null;
}
var $477696120c5741dc$var$xg = null, $477696120c5741dc$var$yg = null, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$zg = null;
function $477696120c5741dc$var$Ag(a, b) {
    var c = $477696120c5741dc$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $477696120c5741dc$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $477696120c5741dc$var$qg ? {
                id: $477696120c5741dc$var$rg,
                overflow: $477696120c5741dc$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $477696120c5741dc$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $477696120c5741dc$var$xg = a, $477696120c5741dc$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $477696120c5741dc$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $477696120c5741dc$var$Eg(a) {
    if ($477696120c5741dc$var$I) {
        var b = $477696120c5741dc$var$yg;
        if (b) {
            var c = b;
            if (!$477696120c5741dc$var$Cg(a, b)) {
                if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
                b = $477696120c5741dc$var$Lf(c.nextSibling);
                var d = $477696120c5741dc$var$xg;
                b && $477696120c5741dc$var$Cg(a, b) ? $477696120c5741dc$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $477696120c5741dc$var$I = !1, $477696120c5741dc$var$xg = a);
            }
        } else {
            if ($477696120c5741dc$var$Dg(a)) throw Error($477696120c5741dc$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $477696120c5741dc$var$I = !1;
            $477696120c5741dc$var$xg = a;
        }
    }
}
function $477696120c5741dc$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $477696120c5741dc$var$xg = a;
}
function $477696120c5741dc$var$Gg(a) {
    if (a !== $477696120c5741dc$var$xg) return !1;
    if (!$477696120c5741dc$var$I) return $477696120c5741dc$var$Fg(a), $477696120c5741dc$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$477696120c5741dc$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $477696120c5741dc$var$yg)) {
        if ($477696120c5741dc$var$Dg(a)) throw $477696120c5741dc$var$Hg(), Error($477696120c5741dc$var$p(418));
        for(; b;)$477696120c5741dc$var$Ag(a, b), b = $477696120c5741dc$var$Lf(b.nextSibling);
    }
    $477696120c5741dc$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($477696120c5741dc$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $477696120c5741dc$var$yg = null;
        }
    } else $477696120c5741dc$var$yg = $477696120c5741dc$var$xg ? $477696120c5741dc$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $477696120c5741dc$var$Hg() {
    for(var a = $477696120c5741dc$var$yg; a;)a = $477696120c5741dc$var$Lf(a.nextSibling);
}
function $477696120c5741dc$var$Ig() {
    $477696120c5741dc$var$yg = $477696120c5741dc$var$xg = null;
    $477696120c5741dc$var$I = !1;
}
function $477696120c5741dc$var$Jg(a) {
    null === $477696120c5741dc$var$zg ? $477696120c5741dc$var$zg = [
        a
    ] : $477696120c5741dc$var$zg.push(a);
}
var $477696120c5741dc$var$Kg = $477696120c5741dc$var$ua.ReactCurrentBatchConfig;
function $477696120c5741dc$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $477696120c5741dc$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $477696120c5741dc$var$Mg = $477696120c5741dc$var$Uf(null), $477696120c5741dc$var$Ng = null, $477696120c5741dc$var$Og = null, $477696120c5741dc$var$Pg = null;
function $477696120c5741dc$var$Qg() {
    $477696120c5741dc$var$Pg = $477696120c5741dc$var$Og = $477696120c5741dc$var$Ng = null;
}
function $477696120c5741dc$var$Rg(a) {
    var b = $477696120c5741dc$var$Mg.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$Mg);
    a._currentValue = b;
}
function $477696120c5741dc$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $477696120c5741dc$var$Tg(a, b) {
    $477696120c5741dc$var$Ng = a;
    $477696120c5741dc$var$Pg = $477696120c5741dc$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($477696120c5741dc$var$Ug = !0), a.firstContext = null);
}
function $477696120c5741dc$var$Vg(a) {
    var b = a._currentValue;
    if ($477696120c5741dc$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $477696120c5741dc$var$Og) {
            if (null === $477696120c5741dc$var$Ng) throw Error($477696120c5741dc$var$p(308));
            $477696120c5741dc$var$Og = a;
            $477696120c5741dc$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $477696120c5741dc$var$Og = $477696120c5741dc$var$Og.next = a;
    }
    return b;
}
var $477696120c5741dc$var$Wg = null;
function $477696120c5741dc$var$Xg(a) {
    null === $477696120c5741dc$var$Wg ? $477696120c5741dc$var$Wg = [
        a
    ] : $477696120c5741dc$var$Wg.push(a);
}
function $477696120c5741dc$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $477696120c5741dc$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $477696120c5741dc$var$Zg(a, d);
}
function $477696120c5741dc$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $477696120c5741dc$var$$g = !1;
function $477696120c5741dc$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $477696120c5741dc$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $477696120c5741dc$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $477696120c5741dc$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($477696120c5741dc$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $477696120c5741dc$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $477696120c5741dc$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $477696120c5741dc$var$Zg(a, c);
}
function $477696120c5741dc$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
function $477696120c5741dc$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $477696120c5741dc$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $477696120c5741dc$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $477696120c5741dc$var$A({}, q, r);
                            break a;
                        case 2:
                            $477696120c5741dc$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $477696120c5741dc$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $477696120c5741dc$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($477696120c5741dc$var$p(191, e));
            e.call(d);
        }
    }
}
var $477696120c5741dc$var$jh = (new $4Iuzv.Component).refs;
function $477696120c5741dc$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $477696120c5741dc$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $477696120c5741dc$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $477696120c5741dc$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$L(), e = $477696120c5741dc$var$lh(a), f = $477696120c5741dc$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$dh(a, f, e);
        null !== b && ($477696120c5741dc$var$mh(b, a, e, d), $477696120c5741dc$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $477696120c5741dc$var$L(), e = $477696120c5741dc$var$lh(a), f = $477696120c5741dc$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $477696120c5741dc$var$dh(a, f, e);
        null !== b && ($477696120c5741dc$var$mh(b, a, e, d), $477696120c5741dc$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $477696120c5741dc$var$L(), d = $477696120c5741dc$var$lh(a), e = $477696120c5741dc$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $477696120c5741dc$var$dh(a, e, d);
        null !== b && ($477696120c5741dc$var$mh(b, a, d, c), $477696120c5741dc$var$eh(b, a, d));
    }
};
function $477696120c5741dc$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$477696120c5741dc$var$Ie(c, d) || !$477696120c5741dc$var$Ie(e, f) : !0;
}
function $477696120c5741dc$var$ph(a, b, c) {
    var d = !1, e = $477696120c5741dc$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $477696120c5741dc$var$Vg(f) : (e = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $477696120c5741dc$var$Yf(a, e) : $477696120c5741dc$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $477696120c5741dc$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $477696120c5741dc$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $477696120c5741dc$var$nh.enqueueReplaceState(b, b.state, null);
}
function $477696120c5741dc$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $477696120c5741dc$var$jh;
    $477696120c5741dc$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $477696120c5741dc$var$Vg(f) : (f = $477696120c5741dc$var$Zf(b) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, e.context = $477696120c5741dc$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($477696120c5741dc$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $477696120c5741dc$var$nh.enqueueReplaceState(e, e.state, null), $477696120c5741dc$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $477696120c5741dc$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($477696120c5741dc$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($477696120c5741dc$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $477696120c5741dc$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($477696120c5741dc$var$p(284));
        if (!c._owner) throw Error($477696120c5741dc$var$p(290, a));
    }
    return a;
}
function $477696120c5741dc$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($477696120c5741dc$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $477696120c5741dc$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $477696120c5741dc$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $477696120c5741dc$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $477696120c5741dc$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $477696120c5741dc$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $477696120c5741dc$var$sh(a, b, c), d.return = a, d;
        d = $477696120c5741dc$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $477696120c5741dc$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $477696120c5741dc$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $477696120c5741dc$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $477696120c5741dc$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $477696120c5741dc$var$va:
                    return c = $477696120c5741dc$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $477696120c5741dc$var$sh(a, null, b), c.return = a, c;
                case $477696120c5741dc$var$wa:
                    return b = $477696120c5741dc$var$zh(b, a.mode, c), b.return = a, b;
                case $477696120c5741dc$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($477696120c5741dc$var$eb(b) || $477696120c5741dc$var$Ka(b)) return b = $477696120c5741dc$var$Ah(b, a.mode, c, null), b.return = a, b;
            $477696120c5741dc$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $477696120c5741dc$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $477696120c5741dc$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $477696120c5741dc$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($477696120c5741dc$var$eb(c) || $477696120c5741dc$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $477696120c5741dc$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $477696120c5741dc$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $477696120c5741dc$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $477696120c5741dc$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($477696120c5741dc$var$eb(d) || $477696120c5741dc$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $477696120c5741dc$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $477696120c5741dc$var$Ka(h);
        if ("function" !== typeof l) throw Error($477696120c5741dc$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($477696120c5741dc$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $477696120c5741dc$var$I && $477696120c5741dc$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $477696120c5741dc$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $477696120c5741dc$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $477696120c5741dc$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $477696120c5741dc$var$Ha && $477696120c5741dc$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $477696120c5741dc$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $477696120c5741dc$var$ya ? (d = $477696120c5741dc$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $477696120c5741dc$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $477696120c5741dc$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $477696120c5741dc$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $477696120c5741dc$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $477696120c5741dc$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($477696120c5741dc$var$eb(f)) return n(a, d, f, h);
            if ($477696120c5741dc$var$Ka(f)) return t(a, d, f, h);
            $477696120c5741dc$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $477696120c5741dc$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $477696120c5741dc$var$Bh = $477696120c5741dc$var$vh(!0), $477696120c5741dc$var$Ch = $477696120c5741dc$var$vh(!1), $477696120c5741dc$var$Dh = {}, $477696120c5741dc$var$Eh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh), $477696120c5741dc$var$Fh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh), $477696120c5741dc$var$Gh = $477696120c5741dc$var$Uf($477696120c5741dc$var$Dh);
function $477696120c5741dc$var$Hh(a) {
    if (a === $477696120c5741dc$var$Dh) throw Error($477696120c5741dc$var$p(174));
    return a;
}
function $477696120c5741dc$var$Ih(a, b) {
    $477696120c5741dc$var$G($477696120c5741dc$var$Gh, b);
    $477696120c5741dc$var$G($477696120c5741dc$var$Fh, a);
    $477696120c5741dc$var$G($477696120c5741dc$var$Eh, $477696120c5741dc$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $477696120c5741dc$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $477696120c5741dc$var$lb(b, a);
    }
    $477696120c5741dc$var$E($477696120c5741dc$var$Eh);
    $477696120c5741dc$var$G($477696120c5741dc$var$Eh, b);
}
function $477696120c5741dc$var$Jh() {
    $477696120c5741dc$var$E($477696120c5741dc$var$Eh);
    $477696120c5741dc$var$E($477696120c5741dc$var$Fh);
    $477696120c5741dc$var$E($477696120c5741dc$var$Gh);
}
function $477696120c5741dc$var$Kh(a) {
    $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
    var b = $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
    var c = $477696120c5741dc$var$lb(b, a.type);
    b !== c && ($477696120c5741dc$var$G($477696120c5741dc$var$Fh, a), $477696120c5741dc$var$G($477696120c5741dc$var$Eh, c));
}
function $477696120c5741dc$var$Lh(a) {
    $477696120c5741dc$var$Fh.current === a && ($477696120c5741dc$var$E($477696120c5741dc$var$Eh), $477696120c5741dc$var$E($477696120c5741dc$var$Fh));
}
var $477696120c5741dc$var$M = $477696120c5741dc$var$Uf(0);
function $477696120c5741dc$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $477696120c5741dc$var$Nh = [];
function $477696120c5741dc$var$Oh() {
    for(var a = 0; a < $477696120c5741dc$var$Nh.length; a++)$477696120c5741dc$var$Nh[a]._workInProgressVersionPrimary = null;
    $477696120c5741dc$var$Nh.length = 0;
}
var $477696120c5741dc$var$Ph = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$Qh = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$Rh = 0, $477696120c5741dc$var$N = null, $477696120c5741dc$var$O = null, $477696120c5741dc$var$P = null, $477696120c5741dc$var$Sh = !1, $477696120c5741dc$var$Th = !1, $477696120c5741dc$var$Uh = 0, $477696120c5741dc$var$Vh = 0;
function $477696120c5741dc$var$Q() {
    throw Error($477696120c5741dc$var$p(321));
}
function $477696120c5741dc$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$477696120c5741dc$var$He(a[c], b[c])) return !1;
    return !0;
}
function $477696120c5741dc$var$Xh(a, b, c, d, e, f) {
    $477696120c5741dc$var$Rh = f;
    $477696120c5741dc$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $477696120c5741dc$var$Ph.current = null === a || null === a.memoizedState ? $477696120c5741dc$var$Yh : $477696120c5741dc$var$Zh;
    a = c(d, e);
    if ($477696120c5741dc$var$Th) {
        f = 0;
        do {
            $477696120c5741dc$var$Th = !1;
            $477696120c5741dc$var$Uh = 0;
            if (25 <= f) throw Error($477696120c5741dc$var$p(301));
            f += 1;
            $477696120c5741dc$var$P = $477696120c5741dc$var$O = null;
            b.updateQueue = null;
            $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$$h;
            a = c(d, e);
        }while ($477696120c5741dc$var$Th);
    }
    $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$ai;
    b = null !== $477696120c5741dc$var$O && null !== $477696120c5741dc$var$O.next;
    $477696120c5741dc$var$Rh = 0;
    $477696120c5741dc$var$P = $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
    $477696120c5741dc$var$Sh = !1;
    if (b) throw Error($477696120c5741dc$var$p(300));
    return a;
}
function $477696120c5741dc$var$bi() {
    var a = 0 !== $477696120c5741dc$var$Uh;
    $477696120c5741dc$var$Uh = 0;
    return a;
}
function $477696120c5741dc$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState = $477696120c5741dc$var$P = a : $477696120c5741dc$var$P = $477696120c5741dc$var$P.next = a;
    return $477696120c5741dc$var$P;
}
function $477696120c5741dc$var$di() {
    if (null === $477696120c5741dc$var$O) {
        var a = $477696120c5741dc$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $477696120c5741dc$var$O.next;
    var b = null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState : $477696120c5741dc$var$P.next;
    if (null !== b) $477696120c5741dc$var$P = b, $477696120c5741dc$var$O = a;
    else {
        if (null === a) throw Error($477696120c5741dc$var$p(310));
        $477696120c5741dc$var$O = a;
        a = {
            memoizedState: $477696120c5741dc$var$O.memoizedState,
            baseState: $477696120c5741dc$var$O.baseState,
            baseQueue: $477696120c5741dc$var$O.baseQueue,
            queue: $477696120c5741dc$var$O.queue,
            next: null
        };
        null === $477696120c5741dc$var$P ? $477696120c5741dc$var$N.memoizedState = $477696120c5741dc$var$P = a : $477696120c5741dc$var$P = $477696120c5741dc$var$P.next = a;
    }
    return $477696120c5741dc$var$P;
}
function $477696120c5741dc$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $477696120c5741dc$var$fi(a) {
    var b = $477696120c5741dc$var$di(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = $477696120c5741dc$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($477696120c5741dc$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $477696120c5741dc$var$N.lanes |= m;
                $477696120c5741dc$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $477696120c5741dc$var$He(d, b.memoizedState) || ($477696120c5741dc$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $477696120c5741dc$var$N.lanes |= f, $477696120c5741dc$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $477696120c5741dc$var$gi(a) {
    var b = $477696120c5741dc$var$di(), c = b.queue;
    if (null === c) throw Error($477696120c5741dc$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $477696120c5741dc$var$He(f, b.memoizedState) || ($477696120c5741dc$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $477696120c5741dc$var$hi() {}
function $477696120c5741dc$var$ii(a, b) {
    var c = $477696120c5741dc$var$N, d = $477696120c5741dc$var$di(), e = b(), f = !$477696120c5741dc$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $477696120c5741dc$var$Ug = !0);
    d = d.queue;
    $477696120c5741dc$var$ji($477696120c5741dc$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $477696120c5741dc$var$P && $477696120c5741dc$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $477696120c5741dc$var$li(9, $477696120c5741dc$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $477696120c5741dc$var$R) throw Error($477696120c5741dc$var$p(349));
        0 !== ($477696120c5741dc$var$Rh & 30) || $477696120c5741dc$var$ni(c, b, e);
    }
    return e;
}
function $477696120c5741dc$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $477696120c5741dc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $477696120c5741dc$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $477696120c5741dc$var$oi(b) && $477696120c5741dc$var$pi(a);
}
function $477696120c5741dc$var$ki(a, b, c) {
    return c(function() {
        $477696120c5741dc$var$oi(b) && $477696120c5741dc$var$pi(a);
    });
}
function $477696120c5741dc$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$477696120c5741dc$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $477696120c5741dc$var$pi(a) {
    var b = $477696120c5741dc$var$Zg(a, 1);
    null !== b && $477696120c5741dc$var$mh(b, a, 1, -1);
}
function $477696120c5741dc$var$qi(a) {
    var b = $477696120c5741dc$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $477696120c5741dc$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $477696120c5741dc$var$ri.bind(null, $477696120c5741dc$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $477696120c5741dc$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $477696120c5741dc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $477696120c5741dc$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $477696120c5741dc$var$si() {
    return $477696120c5741dc$var$di().memoizedState;
}
function $477696120c5741dc$var$ti(a, b, c, d) {
    var e = $477696120c5741dc$var$ci();
    $477696120c5741dc$var$N.flags |= a;
    e.memoizedState = $477696120c5741dc$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $477696120c5741dc$var$ui(a, b, c, d) {
    var e = $477696120c5741dc$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $477696120c5741dc$var$O) {
        var g = $477696120c5741dc$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $477696120c5741dc$var$Wh(d, g.deps)) {
            e.memoizedState = $477696120c5741dc$var$li(b, c, f, d);
            return;
        }
    }
    $477696120c5741dc$var$N.flags |= a;
    e.memoizedState = $477696120c5741dc$var$li(1 | b, c, f, d);
}
function $477696120c5741dc$var$vi(a, b) {
    return $477696120c5741dc$var$ti(8390656, 8, a, b);
}
function $477696120c5741dc$var$ji(a, b) {
    return $477696120c5741dc$var$ui(2048, 8, a, b);
}
function $477696120c5741dc$var$wi(a, b) {
    return $477696120c5741dc$var$ui(4, 2, a, b);
}
function $477696120c5741dc$var$xi(a, b) {
    return $477696120c5741dc$var$ui(4, 4, a, b);
}
function $477696120c5741dc$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $477696120c5741dc$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $477696120c5741dc$var$ui(4, 4, $477696120c5741dc$var$yi.bind(null, b, a), c);
}
function $477696120c5741dc$var$Ai() {}
function $477696120c5741dc$var$Bi(a, b) {
    var c = $477696120c5741dc$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$Ci(a, b) {
    var c = $477696120c5741dc$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $477696120c5741dc$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $477696120c5741dc$var$Di(a, b, c) {
    if (0 === ($477696120c5741dc$var$Rh & 21)) return a.baseState && (a.baseState = !1, $477696120c5741dc$var$Ug = !0), a.memoizedState = c;
    $477696120c5741dc$var$He(c, b) || (c = $477696120c5741dc$var$yc(), $477696120c5741dc$var$N.lanes |= c, $477696120c5741dc$var$hh |= c, a.baseState = !0);
    return b;
}
function $477696120c5741dc$var$Ei(a, b) {
    var c = $477696120c5741dc$var$C;
    $477696120c5741dc$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $477696120c5741dc$var$Qh.transition;
    $477696120c5741dc$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $477696120c5741dc$var$C = c, $477696120c5741dc$var$Qh.transition = d;
    }
}
function $477696120c5741dc$var$Fi() {
    return $477696120c5741dc$var$di().memoizedState;
}
function $477696120c5741dc$var$Gi(a, b, c) {
    var d = $477696120c5741dc$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$Hi(a)) $477696120c5741dc$var$Ii(b, c);
    else if (c = $477696120c5741dc$var$Yg(a, b, c, d), null !== c) {
        var e = $477696120c5741dc$var$L();
        $477696120c5741dc$var$mh(c, a, d, e);
        $477696120c5741dc$var$Ji(c, b, d);
    }
}
function $477696120c5741dc$var$ri(a, b, c) {
    var d = $477696120c5741dc$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($477696120c5741dc$var$Hi(a)) $477696120c5741dc$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($477696120c5741dc$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $477696120c5741dc$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $477696120c5741dc$var$Yg(a, b, e, d);
        null !== c && (e = $477696120c5741dc$var$L(), $477696120c5741dc$var$mh(c, a, d, e), $477696120c5741dc$var$Ji(c, b, d));
    }
}
function $477696120c5741dc$var$Hi(a) {
    var b = a.alternate;
    return a === $477696120c5741dc$var$N || null !== b && b === $477696120c5741dc$var$N;
}
function $477696120c5741dc$var$Ii(a, b) {
    $477696120c5741dc$var$Th = $477696120c5741dc$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $477696120c5741dc$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $477696120c5741dc$var$Cc(a, c);
    }
}
var $477696120c5741dc$var$ai = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Q,
    useContext: $477696120c5741dc$var$Q,
    useEffect: $477696120c5741dc$var$Q,
    useImperativeHandle: $477696120c5741dc$var$Q,
    useInsertionEffect: $477696120c5741dc$var$Q,
    useLayoutEffect: $477696120c5741dc$var$Q,
    useMemo: $477696120c5741dc$var$Q,
    useReducer: $477696120c5741dc$var$Q,
    useRef: $477696120c5741dc$var$Q,
    useState: $477696120c5741dc$var$Q,
    useDebugValue: $477696120c5741dc$var$Q,
    useDeferredValue: $477696120c5741dc$var$Q,
    useTransition: $477696120c5741dc$var$Q,
    useMutableSource: $477696120c5741dc$var$Q,
    useSyncExternalStore: $477696120c5741dc$var$Q,
    useId: $477696120c5741dc$var$Q,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Yh = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: function(a, b) {
        $477696120c5741dc$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $477696120c5741dc$var$ti(4194308, 4, $477696120c5741dc$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $477696120c5741dc$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $477696120c5741dc$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $477696120c5741dc$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $477696120c5741dc$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $477696120c5741dc$var$Gi.bind(null, $477696120c5741dc$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $477696120c5741dc$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $477696120c5741dc$var$qi,
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        return $477696120c5741dc$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$qi(!1), b = a[0];
        a = $477696120c5741dc$var$Ei.bind(null, a[1]);
        $477696120c5741dc$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $477696120c5741dc$var$N, e = $477696120c5741dc$var$ci();
        if ($477696120c5741dc$var$I) {
            if (void 0 === c) throw Error($477696120c5741dc$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $477696120c5741dc$var$R) throw Error($477696120c5741dc$var$p(349));
            0 !== ($477696120c5741dc$var$Rh & 30) || $477696120c5741dc$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $477696120c5741dc$var$vi($477696120c5741dc$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $477696120c5741dc$var$li(9, $477696120c5741dc$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $477696120c5741dc$var$ci(), b = $477696120c5741dc$var$R.identifierPrefix;
        if ($477696120c5741dc$var$I) {
            var c = $477696120c5741dc$var$sg;
            var d = $477696120c5741dc$var$rg;
            c = (d & ~(1 << 32 - $477696120c5741dc$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $477696120c5741dc$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $477696120c5741dc$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$Zh = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Bi,
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$ji,
    useImperativeHandle: $477696120c5741dc$var$zi,
    useInsertionEffect: $477696120c5741dc$var$wi,
    useLayoutEffect: $477696120c5741dc$var$xi,
    useMemo: $477696120c5741dc$var$Ci,
    useReducer: $477696120c5741dc$var$fi,
    useRef: $477696120c5741dc$var$si,
    useState: function() {
        return $477696120c5741dc$var$fi($477696120c5741dc$var$ei);
    },
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$di();
        return $477696120c5741dc$var$Di(b, $477696120c5741dc$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$fi($477696120c5741dc$var$ei)[0], b = $477696120c5741dc$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$hi,
    useSyncExternalStore: $477696120c5741dc$var$ii,
    useId: $477696120c5741dc$var$Fi,
    unstable_isNewReconciler: !1
}, $477696120c5741dc$var$$h = {
    readContext: $477696120c5741dc$var$Vg,
    useCallback: $477696120c5741dc$var$Bi,
    useContext: $477696120c5741dc$var$Vg,
    useEffect: $477696120c5741dc$var$ji,
    useImperativeHandle: $477696120c5741dc$var$zi,
    useInsertionEffect: $477696120c5741dc$var$wi,
    useLayoutEffect: $477696120c5741dc$var$xi,
    useMemo: $477696120c5741dc$var$Ci,
    useReducer: $477696120c5741dc$var$gi,
    useRef: $477696120c5741dc$var$si,
    useState: function() {
        return $477696120c5741dc$var$gi($477696120c5741dc$var$ei);
    },
    useDebugValue: $477696120c5741dc$var$Ai,
    useDeferredValue: function(a) {
        var b = $477696120c5741dc$var$di();
        return null === $477696120c5741dc$var$O ? b.memoizedState = a : $477696120c5741dc$var$Di(b, $477696120c5741dc$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $477696120c5741dc$var$gi($477696120c5741dc$var$ei)[0], b = $477696120c5741dc$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $477696120c5741dc$var$hi,
    useSyncExternalStore: $477696120c5741dc$var$ii,
    useId: $477696120c5741dc$var$Fi,
    unstable_isNewReconciler: !1
};
function $477696120c5741dc$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $477696120c5741dc$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $477696120c5741dc$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $477696120c5741dc$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $477696120c5741dc$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $477696120c5741dc$var$Oi(a, b, c) {
    c = $477696120c5741dc$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $477696120c5741dc$var$Pi || ($477696120c5741dc$var$Pi = !0, $477696120c5741dc$var$Qi = d);
        $477696120c5741dc$var$Mi(a, b);
    };
    return c;
}
function $477696120c5741dc$var$Ri(a, b, c) {
    c = $477696120c5741dc$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $477696120c5741dc$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $477696120c5741dc$var$Mi(a, b);
        "function" !== typeof d && (null === $477696120c5741dc$var$Si ? $477696120c5741dc$var$Si = new Set([
            this
        ]) : $477696120c5741dc$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $477696120c5741dc$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $477696120c5741dc$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $477696120c5741dc$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $477696120c5741dc$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $477696120c5741dc$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $477696120c5741dc$var$ch(-1, 1), b.tag = 2, $477696120c5741dc$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $477696120c5741dc$var$Xi = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$Ug = !1;
function $477696120c5741dc$var$Yi(a, b, c, d) {
    b.child = null === a ? $477696120c5741dc$var$Ch(b, null, c, d) : $477696120c5741dc$var$Bh(b, a.child, c, d);
}
function $477696120c5741dc$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $477696120c5741dc$var$Tg(b, e);
    d = $477696120c5741dc$var$Xh(a, b, c, d, f, e);
    c = $477696120c5741dc$var$bi();
    if (null !== a && !$477696120c5741dc$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$$i(a, b, e);
    $477696120c5741dc$var$I && c && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Yi(a, b, d, e);
    return b.child;
}
function $477696120c5741dc$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$477696120c5741dc$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $477696120c5741dc$var$cj(a, b, f, d, e);
        a = $477696120c5741dc$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $477696120c5741dc$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $477696120c5741dc$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $477696120c5741dc$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $477696120c5741dc$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($477696120c5741dc$var$Ie(f, d) && a.ref === b.ref) {
            if ($477696120c5741dc$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($477696120c5741dc$var$Ug = !0);
            else return b.lanes = a.lanes, $477696120c5741dc$var$$i(a, b, e);
        }
    }
    return $477696120c5741dc$var$dj(a, b, c, d, e);
}
function $477696120c5741dc$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj);
            $477696120c5741dc$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $477696120c5741dc$var$G($477696120c5741dc$var$fj, $477696120c5741dc$var$gj), $477696120c5741dc$var$gj |= d;
    $477696120c5741dc$var$Yi(a, b, e, c);
    return b.child;
}
function $477696120c5741dc$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $477696120c5741dc$var$dj(a, b, c, d, e) {
    var f = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current;
    f = $477696120c5741dc$var$Yf(b, f);
    $477696120c5741dc$var$Tg(b, e);
    c = $477696120c5741dc$var$Xh(a, b, c, d, f, e);
    d = $477696120c5741dc$var$bi();
    if (null !== a && !$477696120c5741dc$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $477696120c5741dc$var$$i(a, b, e);
    $477696120c5741dc$var$I && d && $477696120c5741dc$var$vg(b);
    b.flags |= 1;
    $477696120c5741dc$var$Yi(a, b, c, e);
    return b.child;
}
function $477696120c5741dc$var$ij(a, b, c, d, e) {
    if ($477696120c5741dc$var$Zf(c)) {
        var f = !0;
        $477696120c5741dc$var$cg(b);
    } else f = !1;
    $477696120c5741dc$var$Tg(b, e);
    if (null === b.stateNode) $477696120c5741dc$var$jj(a, b), $477696120c5741dc$var$ph(b, c, d), $477696120c5741dc$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $477696120c5741dc$var$Vg(l) : (l = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, l = $477696120c5741dc$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $477696120c5741dc$var$qh(b, g, d, l);
        $477696120c5741dc$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$$g ? ("function" === typeof m && ($477696120c5741dc$var$kh(b, c, m, d), k = b.memoizedState), (h = $477696120c5741dc$var$$g || $477696120c5741dc$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $477696120c5741dc$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $477696120c5741dc$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $477696120c5741dc$var$Vg(k) : (k = $477696120c5741dc$var$Zf(c) ? $477696120c5741dc$var$Xf : $477696120c5741dc$var$H.current, k = $477696120c5741dc$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $477696120c5741dc$var$qh(b, g, d, k);
        $477696120c5741dc$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $477696120c5741dc$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $477696120c5741dc$var$Wf.current || $477696120c5741dc$var$$g ? ("function" === typeof y && ($477696120c5741dc$var$kh(b, c, y, d), n = b.memoizedState), (l = $477696120c5741dc$var$$g || $477696120c5741dc$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $477696120c5741dc$var$kj(a, b, c, d, f, e);
}
function $477696120c5741dc$var$kj(a, b, c, d, e, f) {
    $477696120c5741dc$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $477696120c5741dc$var$dg(b, c, !1), $477696120c5741dc$var$$i(a, b, f);
    d = b.stateNode;
    $477696120c5741dc$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $477696120c5741dc$var$Bh(b, a.child, null, f), b.child = $477696120c5741dc$var$Bh(b, null, h, f)) : $477696120c5741dc$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $477696120c5741dc$var$dg(b, c, !0);
    return b.child;
}
function $477696120c5741dc$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $477696120c5741dc$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $477696120c5741dc$var$ag(a, b.context, !1);
    $477696120c5741dc$var$Ih(a, b.containerInfo);
}
function $477696120c5741dc$var$mj(a, b, c, d, e) {
    $477696120c5741dc$var$Ig();
    $477696120c5741dc$var$Jg(e);
    b.flags |= 256;
    $477696120c5741dc$var$Yi(a, b, c, d);
    return b.child;
}
var $477696120c5741dc$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $477696120c5741dc$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $477696120c5741dc$var$pj(a, b, c) {
    var d = b.pendingProps, e = $477696120c5741dc$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $477696120c5741dc$var$G($477696120c5741dc$var$M, e & 1);
    if (null === a) {
        $477696120c5741dc$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $477696120c5741dc$var$qj(g, d, 0, null), a = $477696120c5741dc$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $477696120c5741dc$var$oj(c), b.memoizedState = $477696120c5741dc$var$nj, a) : $477696120c5741dc$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $477696120c5741dc$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $477696120c5741dc$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $477696120c5741dc$var$wh(h, f) : (f = $477696120c5741dc$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $477696120c5741dc$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $477696120c5741dc$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $477696120c5741dc$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $477696120c5741dc$var$rj(a, b) {
    b = $477696120c5741dc$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $477696120c5741dc$var$tj(a, b, c, d) {
    null !== d && $477696120c5741dc$var$Jg(d);
    $477696120c5741dc$var$Bh(b, a.child, null, c);
    a = $477696120c5741dc$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $477696120c5741dc$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $477696120c5741dc$var$Li(Error($477696120c5741dc$var$p(422))), $477696120c5741dc$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $477696120c5741dc$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $477696120c5741dc$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $477696120c5741dc$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $477696120c5741dc$var$oj(g);
        b.memoizedState = $477696120c5741dc$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $477696120c5741dc$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($477696120c5741dc$var$p(419));
        d = $477696120c5741dc$var$Li(f, d, void 0);
        return $477696120c5741dc$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($477696120c5741dc$var$Ug || h) {
        d = $477696120c5741dc$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $477696120c5741dc$var$Zg(a, e), $477696120c5741dc$var$mh(d, a, e, -1));
        }
        $477696120c5741dc$var$uj();
        d = $477696120c5741dc$var$Li(Error($477696120c5741dc$var$p(421)));
        return $477696120c5741dc$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $477696120c5741dc$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(e.nextSibling);
    $477696120c5741dc$var$xg = b;
    $477696120c5741dc$var$I = !0;
    $477696120c5741dc$var$zg = null;
    null !== a && ($477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$rg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$sg, $477696120c5741dc$var$og[$477696120c5741dc$var$pg++] = $477696120c5741dc$var$qg, $477696120c5741dc$var$rg = a.id, $477696120c5741dc$var$sg = a.overflow, $477696120c5741dc$var$qg = b);
    b = $477696120c5741dc$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $477696120c5741dc$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $477696120c5741dc$var$Sg(a.return, b, c);
}
function $477696120c5741dc$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $477696120c5741dc$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $477696120c5741dc$var$Yi(a, b, d.children, c);
    d = $477696120c5741dc$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $477696120c5741dc$var$wj(a, c, b);
            else if (19 === a.tag) $477696120c5741dc$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $477696120c5741dc$var$G($477696120c5741dc$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $477696120c5741dc$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $477696120c5741dc$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $477696120c5741dc$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $477696120c5741dc$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $477696120c5741dc$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $477696120c5741dc$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $477696120c5741dc$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $477696120c5741dc$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($477696120c5741dc$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $477696120c5741dc$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $477696120c5741dc$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $477696120c5741dc$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $477696120c5741dc$var$lj(b);
            $477696120c5741dc$var$Ig();
            break;
        case 5:
            $477696120c5741dc$var$Kh(b);
            break;
        case 1:
            $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$cg(b);
            break;
        case 4:
            $477696120c5741dc$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $477696120c5741dc$var$G($477696120c5741dc$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $477696120c5741dc$var$pj(a, b, c);
                $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1);
                a = $477696120c5741dc$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $477696120c5741dc$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $477696120c5741dc$var$ej(a, b, c);
    }
    return $477696120c5741dc$var$$i(a, b, c);
}
var $477696120c5741dc$var$Aj, $477696120c5741dc$var$Bj, $477696120c5741dc$var$Cj, $477696120c5741dc$var$Dj;
$477696120c5741dc$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$477696120c5741dc$var$Bj = function() {};
$477696120c5741dc$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $477696120c5741dc$var$Ya(a, e);
                d = $477696120c5741dc$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $477696120c5741dc$var$A({}, e, {
                    value: void 0
                });
                d = $477696120c5741dc$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $477696120c5741dc$var$gb(a, e);
                d = $477696120c5741dc$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $477696120c5741dc$var$Bf);
        }
        $477696120c5741dc$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($477696120c5741dc$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $477696120c5741dc$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$477696120c5741dc$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $477696120c5741dc$var$Ej(a, b) {
    if (!$477696120c5741dc$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $477696120c5741dc$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $477696120c5741dc$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $477696120c5741dc$var$S(b), null;
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 3:
            d = b.stateNode;
            $477696120c5741dc$var$Jh();
            $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
            $477696120c5741dc$var$E($477696120c5741dc$var$H);
            $477696120c5741dc$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $477696120c5741dc$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Gj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null));
            $477696120c5741dc$var$Bj(a, b);
            $477696120c5741dc$var$S(b);
            return null;
        case 5:
            $477696120c5741dc$var$Lh(b);
            var e = $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $477696120c5741dc$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                    $477696120c5741dc$var$S(b);
                    return null;
                }
                a = $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    d[$477696120c5741dc$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $477696120c5741dc$var$D("cancel", d);
                            $477696120c5741dc$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], d);
                            break;
                        case "source":
                            $477696120c5741dc$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $477696120c5741dc$var$D("error", d);
                            $477696120c5741dc$var$D("load", d);
                            break;
                        case "details":
                            $477696120c5741dc$var$D("toggle", d);
                            break;
                        case "input":
                            $477696120c5741dc$var$Za(d, f);
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $477696120c5741dc$var$D("invalid", d);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$hb(d, f), $477696120c5741dc$var$D("invalid", d);
                    }
                    $477696120c5741dc$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $477696120c5741dc$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $477696120c5741dc$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $477696120c5741dc$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$Va(d);
                            $477696120c5741dc$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $477696120c5741dc$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $477696120c5741dc$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$477696120c5741dc$var$Of] = b;
                    a[$477696120c5741dc$var$Pf] = d;
                    $477696120c5741dc$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $477696120c5741dc$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $477696120c5741dc$var$D("cancel", a);
                                $477696120c5741dc$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $477696120c5741dc$var$lf.length; e++)$477696120c5741dc$var$D($477696120c5741dc$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $477696120c5741dc$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $477696120c5741dc$var$D("error", a);
                                $477696120c5741dc$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $477696120c5741dc$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $477696120c5741dc$var$Za(a, d);
                                e = $477696120c5741dc$var$Ya(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $477696120c5741dc$var$A({}, d, {
                                    value: void 0
                                });
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$hb(a, d);
                                e = $477696120c5741dc$var$gb(a, d);
                                $477696120c5741dc$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $477696120c5741dc$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $477696120c5741dc$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $477696120c5741dc$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $477696120c5741dc$var$ob(a, k) : "number" === typeof k && $477696120c5741dc$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($477696120c5741dc$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $477696120c5741dc$var$D("scroll", a) : null != k && $477696120c5741dc$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $477696120c5741dc$var$Va(a);
                                $477696120c5741dc$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $477696120c5741dc$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $477696120c5741dc$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $477696120c5741dc$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $477696120c5741dc$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $477696120c5741dc$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($477696120c5741dc$var$p(166));
                c = $477696120c5741dc$var$Hh($477696120c5741dc$var$Gh.current);
                $477696120c5741dc$var$Hh($477696120c5741dc$var$Eh.current);
                if ($477696120c5741dc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$477696120c5741dc$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $477696120c5741dc$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $477696120c5741dc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$477696120c5741dc$var$Of] = b, b.stateNode = d;
            }
            $477696120c5741dc$var$S(b);
            return null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($477696120c5741dc$var$I && null !== $477696120c5741dc$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $477696120c5741dc$var$Hg(), $477696120c5741dc$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $477696120c5741dc$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($477696120c5741dc$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($477696120c5741dc$var$p(317));
                        f[$477696120c5741dc$var$Of] = b;
                    } else $477696120c5741dc$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $477696120c5741dc$var$S(b);
                    f = !1;
                } else null !== $477696120c5741dc$var$zg && ($477696120c5741dc$var$Gj($477696120c5741dc$var$zg), $477696120c5741dc$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($477696120c5741dc$var$M.current & 1) ? 0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 3) : $477696120c5741dc$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $477696120c5741dc$var$S(b);
            return null;
        case 4:
            return $477696120c5741dc$var$Jh(), $477696120c5741dc$var$Bj(a, b), null === a && $477696120c5741dc$var$sf(b.stateNode.containerInfo), $477696120c5741dc$var$S(b), null;
        case 10:
            return $477696120c5741dc$var$Rg(b.type._context), $477696120c5741dc$var$S(b), null;
        case 17:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), $477696120c5741dc$var$S(b), null;
        case 19:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            f = b.memoizedState;
            if (null === f) return $477696120c5741dc$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $477696120c5741dc$var$Ej(f, !1);
                else {
                    if (0 !== $477696120c5741dc$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $477696120c5741dc$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $477696120c5741dc$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $477696120c5741dc$var$G($477696120c5741dc$var$M, $477696120c5741dc$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $477696120c5741dc$var$B() > $477696120c5741dc$var$Hj && (b.flags |= 128, d = !0, $477696120c5741dc$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $477696120c5741dc$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $477696120c5741dc$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$477696120c5741dc$var$I) return $477696120c5741dc$var$S(b), null;
                    } else 2 * $477696120c5741dc$var$B() - f.renderingStartTime > $477696120c5741dc$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $477696120c5741dc$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $477696120c5741dc$var$B(), b.sibling = null, c = $477696120c5741dc$var$M.current, $477696120c5741dc$var$G($477696120c5741dc$var$M, d ? c & 1 | 2 : c & 1), b;
            $477696120c5741dc$var$S(b);
            return null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($477696120c5741dc$var$gj & 1073741824) && ($477696120c5741dc$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $477696120c5741dc$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
}
function $477696120c5741dc$var$Jj(a, b) {
    $477696120c5741dc$var$wg(b);
    switch(b.tag){
        case 1:
            return $477696120c5741dc$var$Zf(b.type) && $477696120c5741dc$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $477696120c5741dc$var$Jh(), $477696120c5741dc$var$E($477696120c5741dc$var$Wf), $477696120c5741dc$var$E($477696120c5741dc$var$H), $477696120c5741dc$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $477696120c5741dc$var$Lh(b), null;
        case 13:
            $477696120c5741dc$var$E($477696120c5741dc$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($477696120c5741dc$var$p(340));
                $477696120c5741dc$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $477696120c5741dc$var$E($477696120c5741dc$var$M), null;
        case 4:
            return $477696120c5741dc$var$Jh(), null;
        case 10:
            return $477696120c5741dc$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $477696120c5741dc$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $477696120c5741dc$var$Kj = !1, $477696120c5741dc$var$U = !1, $477696120c5741dc$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $477696120c5741dc$var$V = null;
function $477696120c5741dc$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $477696120c5741dc$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $477696120c5741dc$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $477696120c5741dc$var$W(a, b, d);
    }
}
var $477696120c5741dc$var$Oj = !1;
function $477696120c5741dc$var$Pj(a, b) {
    $477696120c5741dc$var$Cf = $477696120c5741dc$var$dd;
    a = $477696120c5741dc$var$Me();
    if ($477696120c5741dc$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $477696120c5741dc$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $477696120c5741dc$var$dd = !1;
    for($477696120c5741dc$var$V = b; null !== $477696120c5741dc$var$V;)if (b = $477696120c5741dc$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $477696120c5741dc$var$V = a;
    else for(; null !== $477696120c5741dc$var$V;){
        b = $477696120c5741dc$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $477696120c5741dc$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(163));
            }
        } catch (F) {
            $477696120c5741dc$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $477696120c5741dc$var$V = a;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
    n = $477696120c5741dc$var$Oj;
    $477696120c5741dc$var$Oj = !1;
    return n;
}
function $477696120c5741dc$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $477696120c5741dc$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $477696120c5741dc$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $477696120c5741dc$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $477696120c5741dc$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $477696120c5741dc$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$477696120c5741dc$var$Of], delete b[$477696120c5741dc$var$Pf], delete b[$477696120c5741dc$var$of], delete b[$477696120c5741dc$var$Qf], delete b[$477696120c5741dc$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $477696120c5741dc$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $477696120c5741dc$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $477696120c5741dc$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $477696120c5741dc$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $477696120c5741dc$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Wj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Wj(a, b, c), a = a.sibling;
}
function $477696120c5741dc$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($477696120c5741dc$var$Xj(a, b, c), a = a.sibling; null !== a;)$477696120c5741dc$var$Xj(a, b, c), a = a.sibling;
}
var $477696120c5741dc$var$X = null, $477696120c5741dc$var$Yj = !1;
function $477696120c5741dc$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$477696120c5741dc$var$ak(a, b, c), c = c.sibling;
}
function $477696120c5741dc$var$ak(a, b, c) {
    if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onCommitFiberUnmount) try {
        $477696120c5741dc$var$lc.onCommitFiberUnmount($477696120c5741dc$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $477696120c5741dc$var$U || $477696120c5741dc$var$Mj(c, b);
        case 6:
            var d = $477696120c5741dc$var$X, e = $477696120c5741dc$var$Yj;
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Zj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Yj = e;
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Yj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $477696120c5741dc$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $477696120c5741dc$var$X && ($477696120c5741dc$var$Yj ? (a = $477696120c5741dc$var$X, c = c.stateNode, 8 === a.nodeType ? $477696120c5741dc$var$Kf(a.parentNode, c) : 1 === a.nodeType && $477696120c5741dc$var$Kf(a, c), $477696120c5741dc$var$bd(a)) : $477696120c5741dc$var$Kf($477696120c5741dc$var$X, c.stateNode));
            break;
        case 4:
            d = $477696120c5741dc$var$X;
            e = $477696120c5741dc$var$Yj;
            $477696120c5741dc$var$X = c.stateNode.containerInfo;
            $477696120c5741dc$var$Yj = !0;
            $477696120c5741dc$var$Zj(a, b, c);
            $477696120c5741dc$var$X = d;
            $477696120c5741dc$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$477696120c5741dc$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $477696120c5741dc$var$Nj(c, b, g) : 0 !== (f & 4) && $477696120c5741dc$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 1:
            if (!$477696120c5741dc$var$U && ($477696120c5741dc$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $477696120c5741dc$var$W(c, b, h);
            }
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 21:
            $477696120c5741dc$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($477696120c5741dc$var$U = (d = $477696120c5741dc$var$U) || null !== c.memoizedState, $477696120c5741dc$var$Zj(a, b, c), $477696120c5741dc$var$U = d) : $477696120c5741dc$var$Zj(a, b, c);
            break;
        default:
            $477696120c5741dc$var$Zj(a, b, c);
    }
}
function $477696120c5741dc$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $477696120c5741dc$var$Lj);
        b.forEach(function(b) {
            var d = $477696120c5741dc$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $477696120c5741dc$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $477696120c5741dc$var$X = h.stateNode;
                        $477696120c5741dc$var$Yj = !1;
                        break a;
                    case 3:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Yj = !0;
                        break a;
                    case 4:
                        $477696120c5741dc$var$X = h.stateNode.containerInfo;
                        $477696120c5741dc$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $477696120c5741dc$var$X) throw Error($477696120c5741dc$var$p(160));
            $477696120c5741dc$var$ak(f, g, e);
            $477696120c5741dc$var$X = null;
            $477696120c5741dc$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $477696120c5741dc$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$477696120c5741dc$var$ek(b, a), b = b.sibling;
}
function $477696120c5741dc$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4) {
                try {
                    $477696120c5741dc$var$Qj(3, a, a.return), $477696120c5741dc$var$Rj(3, a);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
                try {
                    $477696120c5741dc$var$Qj(5, a, a.return);
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 512 && null !== c && $477696120c5741dc$var$Mj(c, c.return);
            break;
        case 5:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 512 && null !== c && $477696120c5741dc$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $477696120c5741dc$var$ob(e, "");
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $477696120c5741dc$var$ab(e, f);
                    $477696120c5741dc$var$vb(h, g);
                    var l = $477696120c5741dc$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $477696120c5741dc$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $477696120c5741dc$var$nb(e, q) : "children" === m ? $477696120c5741dc$var$ob(e, q) : $477696120c5741dc$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $477696120c5741dc$var$bb(e, f);
                            break;
                        case "textarea":
                            $477696120c5741dc$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $477696120c5741dc$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $477696120c5741dc$var$fb(e, !!f.multiple, f.defaultValue, !0) : $477696120c5741dc$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$477696120c5741dc$var$Pf] = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($477696120c5741dc$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $477696120c5741dc$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $477696120c5741dc$var$bd(b.containerInfo);
            } catch (t) {
                $477696120c5741dc$var$W(a, a.return, t);
            }
            break;
        case 4:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            break;
        case 13:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($477696120c5741dc$var$gk = $477696120c5741dc$var$B()));
            d & 4 && $477696120c5741dc$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($477696120c5741dc$var$U = (l = $477696120c5741dc$var$U) || m, $477696120c5741dc$var$dk(b, a), $477696120c5741dc$var$U = l) : $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($477696120c5741dc$var$V = a, m = a.child; null !== m;){
                    for(q = $477696120c5741dc$var$V = m; null !== $477696120c5741dc$var$V;){
                        r = $477696120c5741dc$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $477696120c5741dc$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $477696120c5741dc$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $477696120c5741dc$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $477696120c5741dc$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $477696120c5741dc$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $477696120c5741dc$var$V = y) : $477696120c5741dc$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $477696120c5741dc$var$rb("display", g));
                            } catch (t) {
                                $477696120c5741dc$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $477696120c5741dc$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $477696120c5741dc$var$dk(b, a);
            $477696120c5741dc$var$fk(a);
            d & 4 && $477696120c5741dc$var$bk(a);
            break;
        case 21:
            break;
        default:
            $477696120c5741dc$var$dk(b, a), $477696120c5741dc$var$fk(a);
    }
}
function $477696120c5741dc$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($477696120c5741dc$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($477696120c5741dc$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($477696120c5741dc$var$ob(e, ""), d.flags &= -33);
                    var f = $477696120c5741dc$var$Vj(a);
                    $477696120c5741dc$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $477696120c5741dc$var$Vj(a);
                    $477696120c5741dc$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(161));
            }
        } catch (k) {
            $477696120c5741dc$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $477696120c5741dc$var$ik(a, b, c) {
    $477696120c5741dc$var$V = a;
    $477696120c5741dc$var$jk(a, b, c);
}
function $477696120c5741dc$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $477696120c5741dc$var$V;){
        var e = $477696120c5741dc$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $477696120c5741dc$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $477696120c5741dc$var$U;
                h = $477696120c5741dc$var$Kj;
                var l = $477696120c5741dc$var$U;
                $477696120c5741dc$var$Kj = g;
                if (($477696120c5741dc$var$U = k) && !l) for($477696120c5741dc$var$V = e; null !== $477696120c5741dc$var$V;)g = $477696120c5741dc$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $477696120c5741dc$var$kk(e) : null !== k ? (k.return = g, $477696120c5741dc$var$V = k) : $477696120c5741dc$var$kk(e);
                for(; null !== f;)$477696120c5741dc$var$V = f, $477696120c5741dc$var$jk(f, b, c), f = f.sibling;
                $477696120c5741dc$var$V = e;
                $477696120c5741dc$var$Kj = h;
                $477696120c5741dc$var$U = l;
            }
            $477696120c5741dc$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $477696120c5741dc$var$V = f) : $477696120c5741dc$var$lk(a, b, c);
    }
}
function $477696120c5741dc$var$lk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $477696120c5741dc$var$U || $477696120c5741dc$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$477696120c5741dc$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $477696120c5741dc$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $477696120c5741dc$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $477696120c5741dc$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $477696120c5741dc$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($477696120c5741dc$var$p(163));
                }
                $477696120c5741dc$var$U || b.flags & 512 && $477696120c5741dc$var$Sj(b);
            } catch (r) {
                $477696120c5741dc$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$hk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $477696120c5741dc$var$V = c;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
function $477696120c5741dc$var$kk(a) {
    for(; null !== $477696120c5741dc$var$V;){
        var b = $477696120c5741dc$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $477696120c5741dc$var$Rj(4, b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $477696120c5741dc$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $477696120c5741dc$var$Sj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $477696120c5741dc$var$Sj(b);
                    } catch (k) {
                        $477696120c5741dc$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $477696120c5741dc$var$W(b, b.return, k);
        }
        if (b === a) {
            $477696120c5741dc$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $477696120c5741dc$var$V = h;
            break;
        }
        $477696120c5741dc$var$V = b.return;
    }
}
var $477696120c5741dc$var$mk = Math.ceil, $477696120c5741dc$var$nk = $477696120c5741dc$var$ua.ReactCurrentDispatcher, $477696120c5741dc$var$ok = $477696120c5741dc$var$ua.ReactCurrentOwner, $477696120c5741dc$var$pk = $477696120c5741dc$var$ua.ReactCurrentBatchConfig, $477696120c5741dc$var$K = 0, $477696120c5741dc$var$R = null, $477696120c5741dc$var$Y = null, $477696120c5741dc$var$Z = 0, $477696120c5741dc$var$gj = 0, $477696120c5741dc$var$fj = $477696120c5741dc$var$Uf(0), $477696120c5741dc$var$T = 0, $477696120c5741dc$var$qk = null, $477696120c5741dc$var$hh = 0, $477696120c5741dc$var$rk = 0, $477696120c5741dc$var$sk = 0, $477696120c5741dc$var$tk = null, $477696120c5741dc$var$uk = null, $477696120c5741dc$var$gk = 0, $477696120c5741dc$var$Hj = Infinity, $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Pi = !1, $477696120c5741dc$var$Qi = null, $477696120c5741dc$var$Si = null, $477696120c5741dc$var$wk = !1, $477696120c5741dc$var$xk = null, $477696120c5741dc$var$yk = 0, $477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = null, $477696120c5741dc$var$Bk = -1, $477696120c5741dc$var$Ck = 0;
function $477696120c5741dc$var$L() {
    return 0 !== ($477696120c5741dc$var$K & 6) ? $477696120c5741dc$var$B() : -1 !== $477696120c5741dc$var$Bk ? $477696120c5741dc$var$Bk : $477696120c5741dc$var$Bk = $477696120c5741dc$var$B();
}
function $477696120c5741dc$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($477696120c5741dc$var$K & 2) && 0 !== $477696120c5741dc$var$Z) return $477696120c5741dc$var$Z & -$477696120c5741dc$var$Z;
    if (null !== $477696120c5741dc$var$Kg.transition) return 0 === $477696120c5741dc$var$Ck && ($477696120c5741dc$var$Ck = $477696120c5741dc$var$yc()), $477696120c5741dc$var$Ck;
    a = $477696120c5741dc$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $477696120c5741dc$var$jd(a.type);
    return a;
}
function $477696120c5741dc$var$mh(a, b, c, d) {
    if (50 < $477696120c5741dc$var$zk) throw $477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = null, Error($477696120c5741dc$var$p(185));
    $477696120c5741dc$var$Ac(a, c, d);
    if (0 === ($477696120c5741dc$var$K & 2) || a !== $477696120c5741dc$var$R) a === $477696120c5741dc$var$R && (0 === ($477696120c5741dc$var$K & 2) && ($477696120c5741dc$var$rk |= c), 4 === $477696120c5741dc$var$T && $477696120c5741dc$var$Dk(a, $477696120c5741dc$var$Z)), $477696120c5741dc$var$Ek(a, d), 1 === c && 0 === $477696120c5741dc$var$K && 0 === (b.mode & 1) && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
}
function $477696120c5741dc$var$Ek(a, b) {
    var c = a.callbackNode;
    $477696120c5741dc$var$wc(a, b);
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$R ? $477696120c5741dc$var$Z : 0);
    if (0 === d) null !== c && $477696120c5741dc$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $477696120c5741dc$var$bc(c);
        if (1 === b) 0 === a.tag ? $477696120c5741dc$var$ig($477696120c5741dc$var$Fk.bind(null, a)) : $477696120c5741dc$var$hg($477696120c5741dc$var$Fk.bind(null, a)), $477696120c5741dc$var$Jf(function() {
            0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
        }), c = null;
        else {
            switch($477696120c5741dc$var$Dc(d)){
                case 1:
                    c = $477696120c5741dc$var$fc;
                    break;
                case 4:
                    c = $477696120c5741dc$var$gc;
                    break;
                case 16:
                    c = $477696120c5741dc$var$hc;
                    break;
                case 536870912:
                    c = $477696120c5741dc$var$jc;
                    break;
                default:
                    c = $477696120c5741dc$var$hc;
            }
            c = $477696120c5741dc$var$Gk(c, $477696120c5741dc$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $477696120c5741dc$var$Hk(a, b) {
    $477696120c5741dc$var$Bk = -1;
    $477696120c5741dc$var$Ck = 0;
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    var c = a.callbackNode;
    if ($477696120c5741dc$var$Ik() && a.callbackNode !== c) return null;
    var d = $477696120c5741dc$var$uc(a, a === $477696120c5741dc$var$R ? $477696120c5741dc$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $477696120c5741dc$var$Jk(a, d);
    else {
        b = d;
        var e = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 2;
        var f = $477696120c5741dc$var$Kk();
        if ($477696120c5741dc$var$R !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$Lk(a, b);
        for(;;)try {
            $477696120c5741dc$var$Mk();
            break;
        } catch (h) {
            $477696120c5741dc$var$Nk(a, h);
        }
        $477696120c5741dc$var$Qg();
        $477696120c5741dc$var$nk.current = f;
        $477696120c5741dc$var$K = e;
        null !== $477696120c5741dc$var$Y ? b = 0 : ($477696120c5741dc$var$R = null, $477696120c5741dc$var$Z = 0, b = $477696120c5741dc$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $477696120c5741dc$var$xc(a), 0 !== e && (d = e, b = $477696120c5741dc$var$Ok(a, e)));
        if (1 === b) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, d), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
        if (6 === b) $477696120c5741dc$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$477696120c5741dc$var$Pk(e) && (b = $477696120c5741dc$var$Jk(a, d), 2 === b && (f = $477696120c5741dc$var$xc(a), 0 !== f && (d = f, b = $477696120c5741dc$var$Ok(a, f))), 1 === b)) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, d), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($477696120c5741dc$var$p(345));
                case 2:
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 3:
                    $477696120c5741dc$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $477696120c5741dc$var$gk + 500 - $477696120c5741dc$var$B(), 10 < b)) {
                        if (0 !== $477696120c5741dc$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $477696120c5741dc$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Qk.bind(null, a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk), b);
                        break;
                    }
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 4:
                    $477696120c5741dc$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $477696120c5741dc$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $477696120c5741dc$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $477696120c5741dc$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $477696120c5741dc$var$Ff($477696120c5741dc$var$Qk.bind(null, a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk), d);
                        break;
                    }
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                case 5:
                    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
                    break;
                default:
                    throw Error($477696120c5741dc$var$p(329));
            }
        }
    }
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    return a.callbackNode === c ? $477696120c5741dc$var$Hk.bind(null, a) : null;
}
function $477696120c5741dc$var$Ok(a, b) {
    var c = $477696120c5741dc$var$tk;
    a.current.memoizedState.isDehydrated && ($477696120c5741dc$var$Lk(a, b).flags |= 256);
    a = $477696120c5741dc$var$Jk(a, b);
    2 !== a && (b = $477696120c5741dc$var$uk, $477696120c5741dc$var$uk = c, null !== b && $477696120c5741dc$var$Gj(b));
    return a;
}
function $477696120c5741dc$var$Gj(a) {
    null === $477696120c5741dc$var$uk ? $477696120c5741dc$var$uk = a : $477696120c5741dc$var$uk.push.apply($477696120c5741dc$var$uk, a);
}
function $477696120c5741dc$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$477696120c5741dc$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $477696120c5741dc$var$Dk(a, b) {
    b &= ~$477696120c5741dc$var$sk;
    b &= ~$477696120c5741dc$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $477696120c5741dc$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $477696120c5741dc$var$Fk(a) {
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    $477696120c5741dc$var$Ik();
    var b = $477696120c5741dc$var$uc(a, 0);
    if (0 === (b & 1)) return $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), null;
    var c = $477696120c5741dc$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $477696120c5741dc$var$xc(a);
        0 !== d && (b = d, c = $477696120c5741dc$var$Ok(a, d));
    }
    if (1 === c) throw c = $477696120c5741dc$var$qk, $477696120c5741dc$var$Lk(a, 0), $477696120c5741dc$var$Dk(a, b), $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B()), c;
    if (6 === c) throw Error($477696120c5741dc$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $477696120c5741dc$var$Qk(a, $477696120c5741dc$var$uk, $477696120c5741dc$var$vk);
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    return null;
}
function $477696120c5741dc$var$Rk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    try {
        return a(b);
    } finally{
        $477696120c5741dc$var$K = c, 0 === $477696120c5741dc$var$K && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$fg && $477696120c5741dc$var$jg());
    }
}
function $477696120c5741dc$var$Sk(a) {
    null !== $477696120c5741dc$var$xk && 0 === $477696120c5741dc$var$xk.tag && 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$Ik();
    var b = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 1;
    var c = $477696120c5741dc$var$pk.transition, d = $477696120c5741dc$var$C;
    try {
        if ($477696120c5741dc$var$pk.transition = null, $477696120c5741dc$var$C = 1, a) return a();
    } finally{
        $477696120c5741dc$var$C = d, $477696120c5741dc$var$pk.transition = c, $477696120c5741dc$var$K = b, 0 === ($477696120c5741dc$var$K & 6) && $477696120c5741dc$var$jg();
    }
}
function $477696120c5741dc$var$Ij() {
    $477696120c5741dc$var$gj = $477696120c5741dc$var$fj.current;
    $477696120c5741dc$var$E($477696120c5741dc$var$fj);
}
function $477696120c5741dc$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $477696120c5741dc$var$Gf(c));
    if (null !== $477696120c5741dc$var$Y) for(c = $477696120c5741dc$var$Y.return; null !== c;){
        var d = c;
        $477696120c5741dc$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $477696120c5741dc$var$$f();
                break;
            case 3:
                $477696120c5741dc$var$Jh();
                $477696120c5741dc$var$E($477696120c5741dc$var$Wf);
                $477696120c5741dc$var$E($477696120c5741dc$var$H);
                $477696120c5741dc$var$Oh();
                break;
            case 5:
                $477696120c5741dc$var$Lh(d);
                break;
            case 4:
                $477696120c5741dc$var$Jh();
                break;
            case 13:
                $477696120c5741dc$var$E($477696120c5741dc$var$M);
                break;
            case 19:
                $477696120c5741dc$var$E($477696120c5741dc$var$M);
                break;
            case 10:
                $477696120c5741dc$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $477696120c5741dc$var$Ij();
        }
        c = c.return;
    }
    $477696120c5741dc$var$R = a;
    $477696120c5741dc$var$Y = a = $477696120c5741dc$var$wh(a.current, null);
    $477696120c5741dc$var$Z = $477696120c5741dc$var$gj = b;
    $477696120c5741dc$var$T = 0;
    $477696120c5741dc$var$qk = null;
    $477696120c5741dc$var$sk = $477696120c5741dc$var$rk = $477696120c5741dc$var$hh = 0;
    $477696120c5741dc$var$uk = $477696120c5741dc$var$tk = null;
    if (null !== $477696120c5741dc$var$Wg) {
        for(b = 0; b < $477696120c5741dc$var$Wg.length; b++)if (c = $477696120c5741dc$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $477696120c5741dc$var$Wg = null;
    }
    return a;
}
function $477696120c5741dc$var$Nk(a, b) {
    do {
        var c = $477696120c5741dc$var$Y;
        try {
            $477696120c5741dc$var$Qg();
            $477696120c5741dc$var$Ph.current = $477696120c5741dc$var$ai;
            if ($477696120c5741dc$var$Sh) {
                for(var d = $477696120c5741dc$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $477696120c5741dc$var$Sh = !1;
            }
            $477696120c5741dc$var$Rh = 0;
            $477696120c5741dc$var$P = $477696120c5741dc$var$O = $477696120c5741dc$var$N = null;
            $477696120c5741dc$var$Th = !1;
            $477696120c5741dc$var$Uh = 0;
            $477696120c5741dc$var$ok.current = null;
            if (null === c || null === c.return) {
                $477696120c5741dc$var$T = 1;
                $477696120c5741dc$var$qk = b;
                $477696120c5741dc$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $477696120c5741dc$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $477696120c5741dc$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $477696120c5741dc$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $477696120c5741dc$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $477696120c5741dc$var$Ti(f, l, b);
                            $477696120c5741dc$var$uj();
                            break a;
                        }
                        k = Error($477696120c5741dc$var$p(426));
                    }
                } else if ($477696120c5741dc$var$I && h.mode & 1) {
                    var J = $477696120c5741dc$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $477696120c5741dc$var$Wi(J, g, h, f, b);
                        $477696120c5741dc$var$Jg($477696120c5741dc$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $477696120c5741dc$var$Ki(k, h);
                4 !== $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 2);
                null === $477696120c5741dc$var$tk ? $477696120c5741dc$var$tk = [
                    f
                ] : $477696120c5741dc$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $477696120c5741dc$var$Oi(f, k, b);
                            $477696120c5741dc$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $477696120c5741dc$var$Si || !$477696120c5741dc$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $477696120c5741dc$var$Ri(f, h, b);
                                $477696120c5741dc$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $477696120c5741dc$var$Tk(c);
        } catch (na) {
            b = na;
            $477696120c5741dc$var$Y === c && null !== c && ($477696120c5741dc$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $477696120c5741dc$var$Kk() {
    var a = $477696120c5741dc$var$nk.current;
    $477696120c5741dc$var$nk.current = $477696120c5741dc$var$ai;
    return null === a ? $477696120c5741dc$var$ai : a;
}
function $477696120c5741dc$var$uj() {
    if (0 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T || 2 === $477696120c5741dc$var$T) $477696120c5741dc$var$T = 4;
    null === $477696120c5741dc$var$R || 0 === ($477696120c5741dc$var$hh & 268435455) && 0 === ($477696120c5741dc$var$rk & 268435455) || $477696120c5741dc$var$Dk($477696120c5741dc$var$R, $477696120c5741dc$var$Z);
}
function $477696120c5741dc$var$Jk(a, b) {
    var c = $477696120c5741dc$var$K;
    $477696120c5741dc$var$K |= 2;
    var d = $477696120c5741dc$var$Kk();
    if ($477696120c5741dc$var$R !== a || $477696120c5741dc$var$Z !== b) $477696120c5741dc$var$vk = null, $477696120c5741dc$var$Lk(a, b);
    for(;;)try {
        $477696120c5741dc$var$Uk();
        break;
    } catch (e) {
        $477696120c5741dc$var$Nk(a, e);
    }
    $477696120c5741dc$var$Qg();
    $477696120c5741dc$var$K = c;
    $477696120c5741dc$var$nk.current = d;
    if (null !== $477696120c5741dc$var$Y) throw Error($477696120c5741dc$var$p(261));
    $477696120c5741dc$var$R = null;
    $477696120c5741dc$var$Z = 0;
    return $477696120c5741dc$var$T;
}
function $477696120c5741dc$var$Uk() {
    for(; null !== $477696120c5741dc$var$Y;)$477696120c5741dc$var$Vk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Mk() {
    for(; null !== $477696120c5741dc$var$Y && !$477696120c5741dc$var$cc();)$477696120c5741dc$var$Vk($477696120c5741dc$var$Y);
}
function $477696120c5741dc$var$Vk(a) {
    var b = $477696120c5741dc$var$Wk(a.alternate, a, $477696120c5741dc$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $477696120c5741dc$var$Tk(a) : $477696120c5741dc$var$Y = b;
    $477696120c5741dc$var$ok.current = null;
}
function $477696120c5741dc$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $477696120c5741dc$var$Fj(c, b, $477696120c5741dc$var$gj), null !== c) {
                $477696120c5741dc$var$Y = c;
                return;
            }
        } else {
            c = $477696120c5741dc$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $477696120c5741dc$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $477696120c5741dc$var$T = 6;
                $477696120c5741dc$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $477696120c5741dc$var$Y = b;
            return;
        }
        $477696120c5741dc$var$Y = b = a;
    }while (null !== b);
    0 === $477696120c5741dc$var$T && ($477696120c5741dc$var$T = 5);
}
function $477696120c5741dc$var$Qk(a, b, c) {
    var d = $477696120c5741dc$var$C, e = $477696120c5741dc$var$pk.transition;
    try {
        $477696120c5741dc$var$pk.transition = null, $477696120c5741dc$var$C = 1, $477696120c5741dc$var$Xk(a, b, c, d);
    } finally{
        $477696120c5741dc$var$pk.transition = e, $477696120c5741dc$var$C = d;
    }
    return null;
}
function $477696120c5741dc$var$Xk(a, b, c, d) {
    do $477696120c5741dc$var$Ik();
    while (null !== $477696120c5741dc$var$xk);
    if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($477696120c5741dc$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $477696120c5741dc$var$Bc(a, f);
    a === $477696120c5741dc$var$R && ($477696120c5741dc$var$Y = $477696120c5741dc$var$R = null, $477696120c5741dc$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $477696120c5741dc$var$wk || ($477696120c5741dc$var$wk = !0, $477696120c5741dc$var$Gk($477696120c5741dc$var$hc, function() {
        $477696120c5741dc$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $477696120c5741dc$var$pk.transition;
        $477696120c5741dc$var$pk.transition = null;
        var g = $477696120c5741dc$var$C;
        $477696120c5741dc$var$C = 1;
        var h = $477696120c5741dc$var$K;
        $477696120c5741dc$var$K |= 4;
        $477696120c5741dc$var$ok.current = null;
        $477696120c5741dc$var$Pj(a, c);
        $477696120c5741dc$var$ek(c, a);
        $477696120c5741dc$var$Oe($477696120c5741dc$var$Df);
        $477696120c5741dc$var$dd = !!$477696120c5741dc$var$Cf;
        $477696120c5741dc$var$Df = $477696120c5741dc$var$Cf = null;
        a.current = c;
        $477696120c5741dc$var$ik(c, a, e);
        $477696120c5741dc$var$dc();
        $477696120c5741dc$var$K = h;
        $477696120c5741dc$var$C = g;
        $477696120c5741dc$var$pk.transition = f;
    } else a.current = c;
    $477696120c5741dc$var$wk && ($477696120c5741dc$var$wk = !1, $477696120c5741dc$var$xk = a, $477696120c5741dc$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($477696120c5741dc$var$Si = null);
    $477696120c5741dc$var$mc(c.stateNode, d);
    $477696120c5741dc$var$Ek(a, $477696120c5741dc$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($477696120c5741dc$var$Pi) throw $477696120c5741dc$var$Pi = !1, a = $477696120c5741dc$var$Qi, $477696120c5741dc$var$Qi = null, a;
    0 !== ($477696120c5741dc$var$yk & 1) && 0 !== a.tag && $477696120c5741dc$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $477696120c5741dc$var$Ak ? $477696120c5741dc$var$zk++ : ($477696120c5741dc$var$zk = 0, $477696120c5741dc$var$Ak = a) : $477696120c5741dc$var$zk = 0;
    $477696120c5741dc$var$jg();
    return null;
}
function $477696120c5741dc$var$Ik() {
    if (null !== $477696120c5741dc$var$xk) {
        var a = $477696120c5741dc$var$Dc($477696120c5741dc$var$yk), b = $477696120c5741dc$var$pk.transition, c = $477696120c5741dc$var$C;
        try {
            $477696120c5741dc$var$pk.transition = null;
            $477696120c5741dc$var$C = 16 > a ? 16 : a;
            if (null === $477696120c5741dc$var$xk) var d = !1;
            else {
                a = $477696120c5741dc$var$xk;
                $477696120c5741dc$var$xk = null;
                $477696120c5741dc$var$yk = 0;
                if (0 !== ($477696120c5741dc$var$K & 6)) throw Error($477696120c5741dc$var$p(331));
                var e = $477696120c5741dc$var$K;
                $477696120c5741dc$var$K |= 4;
                for($477696120c5741dc$var$V = a.current; null !== $477696120c5741dc$var$V;){
                    var f = $477696120c5741dc$var$V, g = f.child;
                    if (0 !== ($477696120c5741dc$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($477696120c5741dc$var$V = l; null !== $477696120c5741dc$var$V;){
                                    var m = $477696120c5741dc$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $477696120c5741dc$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $477696120c5741dc$var$V = q;
                                    else for(; null !== $477696120c5741dc$var$V;){
                                        m = $477696120c5741dc$var$V;
                                        var r = m.sibling, y = m.return;
                                        $477696120c5741dc$var$Tj(m);
                                        if (m === l) {
                                            $477696120c5741dc$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $477696120c5741dc$var$V = r;
                                            break;
                                        }
                                        $477696120c5741dc$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $477696120c5741dc$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $477696120c5741dc$var$V = g;
                    else b: for(; null !== $477696120c5741dc$var$V;){
                        f = $477696120c5741dc$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $477696120c5741dc$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $477696120c5741dc$var$V = x;
                            break b;
                        }
                        $477696120c5741dc$var$V = f.return;
                    }
                }
                var w = a.current;
                for($477696120c5741dc$var$V = w; null !== $477696120c5741dc$var$V;){
                    g = $477696120c5741dc$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $477696120c5741dc$var$V = u;
                    else b: for(g = w; null !== $477696120c5741dc$var$V;){
                        h = $477696120c5741dc$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $477696120c5741dc$var$Rj(9, h);
                            }
                        } catch (na) {
                            $477696120c5741dc$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $477696120c5741dc$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $477696120c5741dc$var$V = F;
                            break b;
                        }
                        $477696120c5741dc$var$V = h.return;
                    }
                }
                $477696120c5741dc$var$K = e;
                $477696120c5741dc$var$jg();
                if ($477696120c5741dc$var$lc && "function" === typeof $477696120c5741dc$var$lc.onPostCommitFiberRoot) try {
                    $477696120c5741dc$var$lc.onPostCommitFiberRoot($477696120c5741dc$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $477696120c5741dc$var$C = c, $477696120c5741dc$var$pk.transition = b;
        }
    }
    return !1;
}
function $477696120c5741dc$var$Yk(a, b, c) {
    b = $477696120c5741dc$var$Ki(c, b);
    b = $477696120c5741dc$var$Oi(a, b, 1);
    a = $477696120c5741dc$var$dh(a, b, 1);
    b = $477696120c5741dc$var$L();
    null !== a && ($477696120c5741dc$var$Ac(a, 1, b), $477696120c5741dc$var$Ek(a, b));
}
function $477696120c5741dc$var$W(a, b, c) {
    if (3 === a.tag) $477696120c5741dc$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $477696120c5741dc$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $477696120c5741dc$var$Si || !$477696120c5741dc$var$Si.has(d))) {
                a = $477696120c5741dc$var$Ki(c, a);
                a = $477696120c5741dc$var$Ri(b, a, 1);
                b = $477696120c5741dc$var$dh(b, a, 1);
                a = $477696120c5741dc$var$L();
                null !== b && ($477696120c5741dc$var$Ac(b, 1, a), $477696120c5741dc$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $477696120c5741dc$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $477696120c5741dc$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $477696120c5741dc$var$R === a && ($477696120c5741dc$var$Z & c) === c && (4 === $477696120c5741dc$var$T || 3 === $477696120c5741dc$var$T && ($477696120c5741dc$var$Z & 130023424) === $477696120c5741dc$var$Z && 500 > $477696120c5741dc$var$B() - $477696120c5741dc$var$gk ? $477696120c5741dc$var$Lk(a, 0) : $477696120c5741dc$var$sk |= c);
    $477696120c5741dc$var$Ek(a, b);
}
function $477696120c5741dc$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $477696120c5741dc$var$sc, $477696120c5741dc$var$sc <<= 1, 0 === ($477696120c5741dc$var$sc & 130023424) && ($477696120c5741dc$var$sc = 4194304)));
    var c = $477696120c5741dc$var$L();
    a = $477696120c5741dc$var$Zg(a, b);
    null !== a && ($477696120c5741dc$var$Ac(a, b, c), $477696120c5741dc$var$Ek(a, c));
}
function $477696120c5741dc$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $477696120c5741dc$var$Zk(a, c);
}
function $477696120c5741dc$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($477696120c5741dc$var$p(314));
    }
    null !== d && d.delete(b);
    $477696120c5741dc$var$Zk(a, c);
}
var $477696120c5741dc$var$Wk;
$477696120c5741dc$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $477696120c5741dc$var$Wf.current) $477696120c5741dc$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $477696120c5741dc$var$Ug = !1, $477696120c5741dc$var$zj(a, b, c);
            $477696120c5741dc$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $477696120c5741dc$var$Ug = !1, $477696120c5741dc$var$I && 0 !== (b.flags & 1048576) && $477696120c5741dc$var$ug(b, $477696120c5741dc$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $477696120c5741dc$var$jj(a, b);
            a = b.pendingProps;
            var e = $477696120c5741dc$var$Yf(b, $477696120c5741dc$var$H.current);
            $477696120c5741dc$var$Tg(b, c);
            e = $477696120c5741dc$var$Xh(null, b, d, a, e, c);
            var f = $477696120c5741dc$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $477696120c5741dc$var$Zf(d) ? (f = !0, $477696120c5741dc$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $477696120c5741dc$var$ah(b), e.updater = $477696120c5741dc$var$nh, b.stateNode = e, e._reactInternals = b, $477696120c5741dc$var$rh(b, d, a, c), b = $477696120c5741dc$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $477696120c5741dc$var$I && f && $477696120c5741dc$var$vg(b), $477696120c5741dc$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $477696120c5741dc$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $477696120c5741dc$var$$k(d);
                a = $477696120c5741dc$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $477696120c5741dc$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $477696120c5741dc$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $477696120c5741dc$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $477696120c5741dc$var$aj(null, b, d, $477696120c5741dc$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($477696120c5741dc$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $477696120c5741dc$var$lj(b);
                if (null === a) throw Error($477696120c5741dc$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $477696120c5741dc$var$bh(a, b);
                $477696120c5741dc$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(423)), b);
                        b = $477696120c5741dc$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $477696120c5741dc$var$Ki(Error($477696120c5741dc$var$p(424)), b);
                        b = $477696120c5741dc$var$mj(a, b, d, c, e);
                        break a;
                    } else for($477696120c5741dc$var$yg = $477696120c5741dc$var$Lf(b.stateNode.containerInfo.firstChild), $477696120c5741dc$var$xg = b, $477696120c5741dc$var$I = !0, $477696120c5741dc$var$zg = null, c = $477696120c5741dc$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $477696120c5741dc$var$Ig();
                    if (d === e) {
                        b = $477696120c5741dc$var$$i(a, b, c);
                        break a;
                    }
                    $477696120c5741dc$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $477696120c5741dc$var$Kh(b), null === a && $477696120c5741dc$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $477696120c5741dc$var$Ef(d, e) ? g = null : null !== f && $477696120c5741dc$var$Ef(d, f) && (b.flags |= 32), $477696120c5741dc$var$hj(a, b), $477696120c5741dc$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $477696120c5741dc$var$Eg(b), null;
        case 13:
            return $477696120c5741dc$var$pj(a, b, c);
        case 4:
            return $477696120c5741dc$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $477696120c5741dc$var$Bh(b, null, d, c) : $477696120c5741dc$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$Zi(a, b, d, e, c);
        case 7:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $477696120c5741dc$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $477696120c5741dc$var$G($477696120c5741dc$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($477696120c5741dc$var$He(f.value, g)) {
                        if (f.children === e.children && !$477696120c5741dc$var$Wf.current) {
                            b = $477696120c5741dc$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $477696120c5741dc$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $477696120c5741dc$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($477696120c5741dc$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $477696120c5741dc$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $477696120c5741dc$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $477696120c5741dc$var$Tg(b, c), e = $477696120c5741dc$var$Vg(e), d = d(e), b.flags |= 1, $477696120c5741dc$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $477696120c5741dc$var$Lg(d, b.pendingProps), e = $477696120c5741dc$var$Lg(d.type, e), $477696120c5741dc$var$aj(a, b, d, e, c);
        case 15:
            return $477696120c5741dc$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $477696120c5741dc$var$Lg(d, e), $477696120c5741dc$var$jj(a, b), b.tag = 1, $477696120c5741dc$var$Zf(d) ? (a = !0, $477696120c5741dc$var$cg(b)) : a = !1, $477696120c5741dc$var$Tg(b, c), $477696120c5741dc$var$ph(b, d, e), $477696120c5741dc$var$rh(b, d, e, c), $477696120c5741dc$var$kj(null, b, d, !0, a, c);
        case 19:
            return $477696120c5741dc$var$yj(a, b, c);
        case 22:
            return $477696120c5741dc$var$ej(a, b, c);
    }
    throw Error($477696120c5741dc$var$p(156, b.tag));
};
function $477696120c5741dc$var$Gk(a, b) {
    return $477696120c5741dc$var$ac(a, b);
}
function $477696120c5741dc$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $477696120c5741dc$var$Bg(a, b, c, d) {
    return new $477696120c5741dc$var$al(a, b, c, d);
}
function $477696120c5741dc$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $477696120c5741dc$var$$k(a) {
    if ("function" === typeof a) return $477696120c5741dc$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $477696120c5741dc$var$Da) return 11;
        if (a === $477696120c5741dc$var$Ga) return 14;
    }
    return 2;
}
function $477696120c5741dc$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $477696120c5741dc$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $477696120c5741dc$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $477696120c5741dc$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $477696120c5741dc$var$ya:
            return $477696120c5741dc$var$Ah(c.children, e, f, b);
        case $477696120c5741dc$var$za:
            g = 8;
            e |= 8;
            break;
        case $477696120c5741dc$var$Aa:
            return a = $477696120c5741dc$var$Bg(12, c, b, e | 2), a.elementType = $477696120c5741dc$var$Aa, a.lanes = f, a;
        case $477696120c5741dc$var$Ea:
            return a = $477696120c5741dc$var$Bg(13, c, b, e), a.elementType = $477696120c5741dc$var$Ea, a.lanes = f, a;
        case $477696120c5741dc$var$Fa:
            return a = $477696120c5741dc$var$Bg(19, c, b, e), a.elementType = $477696120c5741dc$var$Fa, a.lanes = f, a;
        case $477696120c5741dc$var$Ia:
            return $477696120c5741dc$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $477696120c5741dc$var$Ba:
                    g = 10;
                    break a;
                case $477696120c5741dc$var$Ca:
                    g = 9;
                    break a;
                case $477696120c5741dc$var$Da:
                    g = 11;
                    break a;
                case $477696120c5741dc$var$Ga:
                    g = 14;
                    break a;
                case $477696120c5741dc$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($477696120c5741dc$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $477696120c5741dc$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $477696120c5741dc$var$Ah(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$qj(a, b, c, d) {
    a = $477696120c5741dc$var$Bg(22, a, d, b);
    a.elementType = $477696120c5741dc$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $477696120c5741dc$var$xh(a, b, c) {
    a = $477696120c5741dc$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $477696120c5741dc$var$zh(a, b, c) {
    b = $477696120c5741dc$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $477696120c5741dc$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $477696120c5741dc$var$zc(0);
    this.expirationTimes = $477696120c5741dc$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $477696120c5741dc$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $477696120c5741dc$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $477696120c5741dc$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $477696120c5741dc$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $477696120c5741dc$var$ah(f);
    return a;
}
function $477696120c5741dc$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $477696120c5741dc$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $477696120c5741dc$var$el(a) {
    if (!a) return $477696120c5741dc$var$Vf;
    a = a._reactInternals;
    a: {
        if ($477696120c5741dc$var$Vb(a) !== a || 1 !== a.tag) throw Error($477696120c5741dc$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($477696120c5741dc$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($477696120c5741dc$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($477696120c5741dc$var$Zf(c)) return $477696120c5741dc$var$bg(a, c, b);
    }
    return b;
}
function $477696120c5741dc$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $477696120c5741dc$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $477696120c5741dc$var$el(null);
    c = a.current;
    d = $477696120c5741dc$var$L();
    e = $477696120c5741dc$var$lh(c);
    f = $477696120c5741dc$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $477696120c5741dc$var$dh(c, f, e);
    a.current.lanes = e;
    $477696120c5741dc$var$Ac(a, e, d);
    $477696120c5741dc$var$Ek(a, d);
    return a;
}
function $477696120c5741dc$var$gl(a, b, c, d) {
    var e = b.current, f = $477696120c5741dc$var$L(), g = $477696120c5741dc$var$lh(e);
    c = $477696120c5741dc$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $477696120c5741dc$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $477696120c5741dc$var$dh(e, b, g);
    null !== a && ($477696120c5741dc$var$mh(a, e, g, f), $477696120c5741dc$var$eh(a, e, g));
    return g;
}
function $477696120c5741dc$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $477696120c5741dc$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $477696120c5741dc$var$jl(a, b) {
    $477696120c5741dc$var$il(a, b);
    (a = a.alternate) && $477696120c5741dc$var$il(a, b);
}
function $477696120c5741dc$var$kl() {
    return null;
}
var $477696120c5741dc$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $477696120c5741dc$var$ml(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$nl.prototype.render = $477696120c5741dc$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($477696120c5741dc$var$p(409));
    $477696120c5741dc$var$gl(a, b, null, null);
};
$477696120c5741dc$var$nl.prototype.unmount = $477696120c5741dc$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $477696120c5741dc$var$Sk(function() {
            $477696120c5741dc$var$gl(null, a, null, null);
        });
        b[$477696120c5741dc$var$uf] = null;
    }
};
function $477696120c5741dc$var$nl(a) {
    this._internalRoot = a;
}
$477696120c5741dc$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $477696120c5741dc$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $477696120c5741dc$var$Qc.length && 0 !== b && b < $477696120c5741dc$var$Qc[c].priority; c++);
        $477696120c5741dc$var$Qc.splice(c, 0, a);
        0 === c && $477696120c5741dc$var$Vc(a);
    }
};
function $477696120c5741dc$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $477696120c5741dc$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $477696120c5741dc$var$ql() {}
function $477696120c5741dc$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $477696120c5741dc$var$hl(g);
                f.call(a);
            };
        }
        var g = $477696120c5741dc$var$fl(b, d, a, 0, null, !1, !1, "", $477696120c5741dc$var$ql);
        a._reactRootContainer = g;
        a[$477696120c5741dc$var$uf] = g.current;
        $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
        $477696120c5741dc$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $477696120c5741dc$var$hl(k);
            h.call(a);
        };
    }
    var k = $477696120c5741dc$var$cl(a, 0, !1, null, null, !1, !1, "", $477696120c5741dc$var$ql);
    a._reactRootContainer = k;
    a[$477696120c5741dc$var$uf] = k.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    $477696120c5741dc$var$Sk(function() {
        $477696120c5741dc$var$gl(b, k, c, d);
    });
    return k;
}
function $477696120c5741dc$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $477696120c5741dc$var$hl(g);
                h.call(a);
            };
        }
        $477696120c5741dc$var$gl(b, g, a, e);
    } else g = $477696120c5741dc$var$rl(c, b, a, e, d);
    return $477696120c5741dc$var$hl(g);
}
$477696120c5741dc$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $477696120c5741dc$var$tc(b.pendingLanes);
                0 !== c && ($477696120c5741dc$var$Cc(b, c | 1), $477696120c5741dc$var$Ek(b, $477696120c5741dc$var$B()), 0 === ($477696120c5741dc$var$K & 6) && ($477696120c5741dc$var$Hj = $477696120c5741dc$var$B() + 500, $477696120c5741dc$var$jg()));
            }
            break;
        case 13:
            $477696120c5741dc$var$Sk(function() {
                var b = $477696120c5741dc$var$Zg(a, 1);
                if (null !== b) {
                    var c = $477696120c5741dc$var$L();
                    $477696120c5741dc$var$mh(b, a, 1, c);
                }
            }), $477696120c5741dc$var$jl(a, 1);
    }
};
$477696120c5741dc$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $477696120c5741dc$var$L();
            $477696120c5741dc$var$mh(b, a, 134217728, c);
        }
        $477696120c5741dc$var$jl(a, 134217728);
    }
};
$477696120c5741dc$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $477696120c5741dc$var$lh(a), c = $477696120c5741dc$var$Zg(a, b);
        if (null !== c) {
            var d = $477696120c5741dc$var$L();
            $477696120c5741dc$var$mh(c, a, b, d);
        }
        $477696120c5741dc$var$jl(a, b);
    }
};
$477696120c5741dc$var$Hc = function() {
    return $477696120c5741dc$var$C;
};
$477696120c5741dc$var$Ic = function(a, b) {
    var c = $477696120c5741dc$var$C;
    try {
        return $477696120c5741dc$var$C = a, b();
    } finally{
        $477696120c5741dc$var$C = c;
    }
};
$477696120c5741dc$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $477696120c5741dc$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $477696120c5741dc$var$Db(d);
                        if (!e) throw Error($477696120c5741dc$var$p(90));
                        $477696120c5741dc$var$Wa(d);
                        $477696120c5741dc$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $477696120c5741dc$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $477696120c5741dc$var$fb(a, !!c.multiple, b, !1);
    }
};
$477696120c5741dc$var$Gb = $477696120c5741dc$var$Rk;
$477696120c5741dc$var$Hb = $477696120c5741dc$var$Sk;
var $477696120c5741dc$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $477696120c5741dc$var$Cb,
        $477696120c5741dc$var$ue,
        $477696120c5741dc$var$Db,
        $477696120c5741dc$var$Eb,
        $477696120c5741dc$var$Fb,
        $477696120c5741dc$var$Rk
    ]
}, $477696120c5741dc$var$ul = {
    findFiberByHostInstance: $477696120c5741dc$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $477696120c5741dc$var$vl = {
    bundleType: $477696120c5741dc$var$ul.bundleType,
    version: $477696120c5741dc$var$ul.version,
    rendererPackageName: $477696120c5741dc$var$ul.rendererPackageName,
    rendererConfig: $477696120c5741dc$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $477696120c5741dc$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $477696120c5741dc$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $477696120c5741dc$var$ul.findFiberByHostInstance || $477696120c5741dc$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $477696120c5741dc$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$477696120c5741dc$var$wl.isDisabled && $477696120c5741dc$var$wl.supportsFiber) try {
        $477696120c5741dc$var$kc = $477696120c5741dc$var$wl.inject($477696120c5741dc$var$vl), $477696120c5741dc$var$lc = $477696120c5741dc$var$wl;
    } catch (a) {}
}
$477696120c5741dc$export$ae55be85d98224ed = $477696120c5741dc$var$tl;
$477696120c5741dc$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$477696120c5741dc$var$ol(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$dl(a, b, null, c);
};
$477696120c5741dc$export$882461b6382ed46c = function(a, b) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(299));
    var c = !1, d = "", e = $477696120c5741dc$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $477696120c5741dc$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $477696120c5741dc$var$ml(b);
};
$477696120c5741dc$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($477696120c5741dc$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($477696120c5741dc$var$p(268, a));
    }
    a = $477696120c5741dc$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$477696120c5741dc$export$cd75ccfd720a3cd4 = function(a) {
    return $477696120c5741dc$var$Sk(a);
};
$477696120c5741dc$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$477696120c5741dc$var$pl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$sl(null, a, b, !0, c);
};
$477696120c5741dc$export$757ceba2d55c277e = function(a, b, c) {
    if (!$477696120c5741dc$var$ol(a)) throw Error($477696120c5741dc$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $477696120c5741dc$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $477696120c5741dc$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$477696120c5741dc$var$uf] = b.current;
    $477696120c5741dc$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $477696120c5741dc$var$nl(b);
};
$477696120c5741dc$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$477696120c5741dc$var$pl(b)) throw Error($477696120c5741dc$var$p(200));
    return $477696120c5741dc$var$sl(null, a, b, !1, c);
};
$477696120c5741dc$export$502457920280e6be = function(a) {
    if (!$477696120c5741dc$var$pl(a)) throw Error($477696120c5741dc$var$p(40));
    return a._reactRootContainer ? ($477696120c5741dc$var$Sk(function() {
        $477696120c5741dc$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$477696120c5741dc$var$uf] = null;
        });
    }), !0) : !1;
};
$477696120c5741dc$export$c78a37762a8d58e1 = $477696120c5741dc$var$Rk;
$477696120c5741dc$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$477696120c5741dc$var$pl(c)) throw Error($477696120c5741dc$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($477696120c5741dc$var$p(38));
    return $477696120c5741dc$var$sl(a, b, c, !1, d);
};
$477696120c5741dc$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1c3ne", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ecVue"));

});
parcelRequire.register("ecVue", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a57ec74d8a366a12$export$c4744153514ff05d; }, function (v) { return $a57ec74d8a366a12$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7; }, function (v) { return $a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a57ec74d8a366a12$export$e26fe2ed2fa76875; }, function (v) { return $a57ec74d8a366a12$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a57ec74d8a366a12$export$502329bbf4b505b1; }, function (v) { return $a57ec74d8a366a12$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a57ec74d8a366a12$export$6e3807111c4874c4; }, function (v) { return $a57ec74d8a366a12$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a57ec74d8a366a12$export$c27134553091fb3a; }, function (v) { return $a57ec74d8a366a12$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2; }, function (v) { return $a57ec74d8a366a12$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a57ec74d8a366a12$export$b00a404bbd5edef2; }, function (v) { return $a57ec74d8a366a12$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a57ec74d8a366a12$export$8352ce38b91d0c62; }, function (v) { return $a57ec74d8a366a12$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a57ec74d8a366a12$export$d66a1c1c77bd778b; }, function (v) { return $a57ec74d8a366a12$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a57ec74d8a366a12$export$d3dfb8e4810cb555; }, function (v) { return $a57ec74d8a366a12$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a57ec74d8a366a12$export$839f9183b0465a69; }, function (v) { return $a57ec74d8a366a12$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a57ec74d8a366a12$export$72fdf0e06517287b; }, function (v) { return $a57ec74d8a366a12$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a57ec74d8a366a12$export$4b844e58a3e414b4; }, function (v) { return $a57ec74d8a366a12$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a57ec74d8a366a12$export$816d2913ae6b83b1; }, function (v) { return $a57ec74d8a366a12$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a57ec74d8a366a12$export$61bcfe829111a1d0; }, function (v) { return $a57ec74d8a366a12$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f; }, function (v) { return $a57ec74d8a366a12$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a57ec74d8a366a12$export$b5836b71941fa3ed; }, function (v) { return $a57ec74d8a366a12$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a57ec74d8a366a12$export$cf845f2c119da08a; }, function (v) { return $a57ec74d8a366a12$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a57ec74d8a366a12$export$c4744153514ff05d;
var $a57ec74d8a366a12$export$3e506c1ccc9cc1a7;
var $a57ec74d8a366a12$export$e26fe2ed2fa76875;
var $a57ec74d8a366a12$export$502329bbf4b505b1;
var $a57ec74d8a366a12$export$6e3807111c4874c4;
var $a57ec74d8a366a12$export$c27134553091fb3a;
var $a57ec74d8a366a12$export$33ee1acdc04fd2a2;
var $a57ec74d8a366a12$export$b00a404bbd5edef2;
var $a57ec74d8a366a12$export$8352ce38b91d0c62;
var $a57ec74d8a366a12$export$d66a1c1c77bd778b;
var $a57ec74d8a366a12$export$d3dfb8e4810cb555;
var $a57ec74d8a366a12$export$839f9183b0465a69;
var $a57ec74d8a366a12$export$72fdf0e06517287b;
var $a57ec74d8a366a12$export$4b844e58a3e414b4;
var $a57ec74d8a366a12$export$816d2913ae6b83b1;
var $a57ec74d8a366a12$export$61bcfe829111a1d0;
var $a57ec74d8a366a12$export$7ee8c9beb337bc3f;
var $a57ec74d8a366a12$export$b5836b71941fa3ed;
var $a57ec74d8a366a12$export$cf845f2c119da08a;
"use strict";
function $a57ec74d8a366a12$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a57ec74d8a366a12$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a57ec74d8a366a12$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a57ec74d8a366a12$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a57ec74d8a366a12$var$g(C, c)) n < e && 0 > $a57ec74d8a366a12$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a57ec74d8a366a12$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a57ec74d8a366a12$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a57ec74d8a366a12$var$l = performance;
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$l.now();
    };
} else {
    var $a57ec74d8a366a12$var$p = Date, $a57ec74d8a366a12$var$q = $a57ec74d8a366a12$var$p.now();
    $a57ec74d8a366a12$export$c4744153514ff05d = function() {
        return $a57ec74d8a366a12$var$p.now() - $a57ec74d8a366a12$var$q;
    };
}
var $a57ec74d8a366a12$var$r = [], $a57ec74d8a366a12$var$t = [], $a57ec74d8a366a12$var$u = 1, $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = 3, $a57ec74d8a366a12$var$z = !1, $a57ec74d8a366a12$var$A = !1, $a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$D = "function" === typeof setTimeout ? setTimeout : null, $a57ec74d8a366a12$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a57ec74d8a366a12$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a57ec74d8a366a12$var$G(a) {
    for(var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t); null !== b;){
        if (null === b.callback) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t);
        else if (b.startTime <= a) $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$t), b.sortIndex = b.expirationTime, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, b);
        else break;
        b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
    }
}
function $a57ec74d8a366a12$var$H(a) {
    $a57ec74d8a366a12$var$B = !1;
    $a57ec74d8a366a12$var$G(a);
    if (!$a57ec74d8a366a12$var$A) {
        if (null !== $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r)) $a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J);
        else {
            var b = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== b && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, b.startTime - a);
        }
    }
}
function $a57ec74d8a366a12$var$J(a, b) {
    $a57ec74d8a366a12$var$A = !1;
    $a57ec74d8a366a12$var$B && ($a57ec74d8a366a12$var$B = !1, $a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1);
    $a57ec74d8a366a12$var$z = !0;
    var c = $a57ec74d8a366a12$var$y;
    try {
        $a57ec74d8a366a12$var$G(b);
        for($a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r); null !== $a57ec74d8a366a12$var$v && (!($a57ec74d8a366a12$var$v.expirationTime > b) || a && !$a57ec74d8a366a12$var$M());){
            var d = $a57ec74d8a366a12$var$v.callback;
            if ("function" === typeof d) {
                $a57ec74d8a366a12$var$v.callback = null;
                $a57ec74d8a366a12$var$y = $a57ec74d8a366a12$var$v.priorityLevel;
                var e = d($a57ec74d8a366a12$var$v.expirationTime <= b);
                b = $a57ec74d8a366a12$export$c4744153514ff05d();
                "function" === typeof e ? $a57ec74d8a366a12$var$v.callback = e : $a57ec74d8a366a12$var$v === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
                $a57ec74d8a366a12$var$G(b);
            } else $a57ec74d8a366a12$var$k($a57ec74d8a366a12$var$r);
            $a57ec74d8a366a12$var$v = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
        }
        if (null !== $a57ec74d8a366a12$var$v) var w = !0;
        else {
            var m = $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t);
            null !== m && $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a57ec74d8a366a12$var$v = null, $a57ec74d8a366a12$var$y = c, $a57ec74d8a366a12$var$z = !1;
    }
}
var $a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null, $a57ec74d8a366a12$var$L = -1, $a57ec74d8a366a12$var$P = 5, $a57ec74d8a366a12$var$Q = -1;
function $a57ec74d8a366a12$var$M() {
    return $a57ec74d8a366a12$export$c4744153514ff05d() - $a57ec74d8a366a12$var$Q < $a57ec74d8a366a12$var$P ? !1 : !0;
}
function $a57ec74d8a366a12$var$R() {
    if (null !== $a57ec74d8a366a12$var$O) {
        var a = $a57ec74d8a366a12$export$c4744153514ff05d();
        $a57ec74d8a366a12$var$Q = a;
        var b = !0;
        try {
            b = $a57ec74d8a366a12$var$O(!0, a);
        } finally{
            b ? $a57ec74d8a366a12$var$S() : ($a57ec74d8a366a12$var$N = !1, $a57ec74d8a366a12$var$O = null);
        }
    } else $a57ec74d8a366a12$var$N = !1;
}
var $a57ec74d8a366a12$var$S;
if ("function" === typeof $a57ec74d8a366a12$var$F) $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$F($a57ec74d8a366a12$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a57ec74d8a366a12$var$T = new MessageChannel, $a57ec74d8a366a12$var$U = $a57ec74d8a366a12$var$T.port2;
    $a57ec74d8a366a12$var$T.port1.onmessage = $a57ec74d8a366a12$var$R;
    $a57ec74d8a366a12$var$S = function() {
        $a57ec74d8a366a12$var$U.postMessage(null);
    };
} else $a57ec74d8a366a12$var$S = function() {
    $a57ec74d8a366a12$var$D($a57ec74d8a366a12$var$R, 0);
};
function $a57ec74d8a366a12$var$I(a) {
    $a57ec74d8a366a12$var$O = a;
    $a57ec74d8a366a12$var$N || ($a57ec74d8a366a12$var$N = !0, $a57ec74d8a366a12$var$S());
}
function $a57ec74d8a366a12$var$K(a, b) {
    $a57ec74d8a366a12$var$L = $a57ec74d8a366a12$var$D(function() {
        a($a57ec74d8a366a12$export$c4744153514ff05d());
    }, b);
}
$a57ec74d8a366a12$export$3e506c1ccc9cc1a7 = 5;
$a57ec74d8a366a12$export$e26fe2ed2fa76875 = 1;
$a57ec74d8a366a12$export$502329bbf4b505b1 = 4;
$a57ec74d8a366a12$export$6e3807111c4874c4 = 3;
$a57ec74d8a366a12$export$c27134553091fb3a = null;
$a57ec74d8a366a12$export$33ee1acdc04fd2a2 = 2;
$a57ec74d8a366a12$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a57ec74d8a366a12$export$8352ce38b91d0c62 = function() {
    $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J));
};
$a57ec74d8a366a12$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a57ec74d8a366a12$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a57ec74d8a366a12$export$d3dfb8e4810cb555 = function() {
    return $a57ec74d8a366a12$var$y;
};
$a57ec74d8a366a12$export$839f9183b0465a69 = function() {
    return $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r);
};
$a57ec74d8a366a12$export$72fdf0e06517287b = function(a) {
    switch($a57ec74d8a366a12$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a57ec74d8a366a12$var$y;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = b;
    try {
        return a();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$4b844e58a3e414b4 = function() {};
$a57ec74d8a366a12$export$816d2913ae6b83b1 = function() {};
$a57ec74d8a366a12$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a57ec74d8a366a12$var$y;
    $a57ec74d8a366a12$var$y = a;
    try {
        return b();
    } finally{
        $a57ec74d8a366a12$var$y = c;
    }
};
$a57ec74d8a366a12$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a57ec74d8a366a12$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a57ec74d8a366a12$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$t, a), null === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$r) && a === $a57ec74d8a366a12$var$h($a57ec74d8a366a12$var$t) && ($a57ec74d8a366a12$var$B ? ($a57ec74d8a366a12$var$E($a57ec74d8a366a12$var$L), $a57ec74d8a366a12$var$L = -1) : $a57ec74d8a366a12$var$B = !0, $a57ec74d8a366a12$var$K($a57ec74d8a366a12$var$H, c - d))) : (a.sortIndex = e, $a57ec74d8a366a12$var$f($a57ec74d8a366a12$var$r, a), $a57ec74d8a366a12$var$A || $a57ec74d8a366a12$var$z || ($a57ec74d8a366a12$var$A = !0, $a57ec74d8a366a12$var$I($a57ec74d8a366a12$var$J)));
    return a;
};
$a57ec74d8a366a12$export$b5836b71941fa3ed = $a57ec74d8a366a12$var$M;
$a57ec74d8a366a12$export$cf845f2c119da08a = function(a) {
    var b = $a57ec74d8a366a12$var$y;
    return function() {
        var c = $a57ec74d8a366a12$var$y;
        $a57ec74d8a366a12$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a57ec74d8a366a12$var$y = c;
        }
    };
};

});



parcelRequire.register("hWfed", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("jGuZ2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRequire.register("jGuZ2", function(module, exports) {
"use strict";

});


parcelRequire.register("aojIm", function(module, exports) {
"use strict";

var $4bbgd = parcelRequire("4bbgd");
var $790b70256ebff162$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $790b70256ebff162$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $790b70256ebff162$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $790b70256ebff162$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $4bbgd();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $790b70256ebff162$var$clipboardToIE11Formatting[options.format] || $790b70256ebff162$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $790b70256ebff162$var$format("message" in options ? options.message : $790b70256ebff162$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $790b70256ebff162$var$copy;

});
parcelRequire.register("4bbgd", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRequire.register("63wzt", function(module, exports) {

var $jlvmO = parcelRequire("jlvmO");
var $468c49d4eaefb225$var$Global = $jlvmO.Global;
module.exports = {
    name: "localStorage",
    read: $468c49d4eaefb225$var$read,
    write: $468c49d4eaefb225$var$write,
    each: $468c49d4eaefb225$var$each,
    remove: $468c49d4eaefb225$var$remove,
    clearAll: $468c49d4eaefb225$var$clearAll
};
function $468c49d4eaefb225$var$localStorage() {
    return $468c49d4eaefb225$var$Global.localStorage;
}
function $468c49d4eaefb225$var$read(key) {
    return $468c49d4eaefb225$var$localStorage().getItem(key);
}
function $468c49d4eaefb225$var$write(key, data) {
    return $468c49d4eaefb225$var$localStorage().setItem(key, data);
}
function $468c49d4eaefb225$var$each(fn) {
    for(var i = $468c49d4eaefb225$var$localStorage().length - 1; i >= 0; i--){
        var key = $468c49d4eaefb225$var$localStorage().key(i);
        fn($468c49d4eaefb225$var$read(key), key);
    }
}
function $468c49d4eaefb225$var$remove(key) {
    return $468c49d4eaefb225$var$localStorage().removeItem(key);
}
function $468c49d4eaefb225$var$clearAll() {
    return $468c49d4eaefb225$var$localStorage().clear();
}

});
parcelRequire.register("jlvmO", function(module, exports) {
var $e1584f51c65a7ed2$var$assign = $e1584f51c65a7ed2$var$make_assign();
var $e1584f51c65a7ed2$var$create = $e1584f51c65a7ed2$var$make_create();
var $e1584f51c65a7ed2$var$trim = $e1584f51c65a7ed2$var$make_trim();
var $e1584f51c65a7ed2$var$Global = typeof window !== "undefined" ? window : $parcel$global;
module.exports = {
    assign: $e1584f51c65a7ed2$var$assign,
    create: $e1584f51c65a7ed2$var$create,
    trim: $e1584f51c65a7ed2$var$trim,
    bind: $e1584f51c65a7ed2$var$bind,
    slice: $e1584f51c65a7ed2$var$slice,
    each: $e1584f51c65a7ed2$var$each,
    map: $e1584f51c65a7ed2$var$map,
    pluck: $e1584f51c65a7ed2$var$pluck,
    isList: $e1584f51c65a7ed2$var$isList,
    isFunction: $e1584f51c65a7ed2$var$isFunction,
    isObject: $e1584f51c65a7ed2$var$isObject,
    Global: $e1584f51c65a7ed2$var$Global
};
function $e1584f51c65a7ed2$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$e1584f51c65a7ed2$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $e1584f51c65a7ed2$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $e1584f51c65a7ed2$var$slice(arguments, 1);
        return $e1584f51c65a7ed2$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $e1584f51c65a7ed2$var$slice(arguments, 1);
            F.prototype = obj;
            return $e1584f51c65a7ed2$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $e1584f51c65a7ed2$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
}
function $e1584f51c65a7ed2$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $e1584f51c65a7ed2$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $e1584f51c65a7ed2$var$each(obj, fn) {
    $e1584f51c65a7ed2$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $e1584f51c65a7ed2$var$map(obj, fn) {
    var res = $e1584f51c65a7ed2$var$isList(obj) ? [] : {};
    $e1584f51c65a7ed2$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $e1584f51c65a7ed2$var$pluck(obj, fn) {
    if ($e1584f51c65a7ed2$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $e1584f51c65a7ed2$var$isList(val) {
    return val != null && typeof val != "function" && typeof val.length == "number";
}
function $e1584f51c65a7ed2$var$isFunction(val) {
    return val && ({}).toString.call(val) === "[object Function]";
}
function $e1584f51c65a7ed2$var$isObject(val) {
    return val && ({}).toString.call(val) === "[object Object]";
}

});


parcelRequire.register("d74u2", function(module, exports) {
// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var $jlvmO = parcelRequire("jlvmO");
var $98bf6825f5696d94$var$Global = $jlvmO.Global;
module.exports = {
    name: "oldFF-globalStorage",
    read: $98bf6825f5696d94$var$read,
    write: $98bf6825f5696d94$var$write,
    each: $98bf6825f5696d94$var$each,
    remove: $98bf6825f5696d94$var$remove,
    clearAll: $98bf6825f5696d94$var$clearAll
};
var $98bf6825f5696d94$var$globalStorage = $98bf6825f5696d94$var$Global.globalStorage;
function $98bf6825f5696d94$var$read(key) {
    return $98bf6825f5696d94$var$globalStorage[key];
}
function $98bf6825f5696d94$var$write(key, data) {
    $98bf6825f5696d94$var$globalStorage[key] = data;
}
function $98bf6825f5696d94$var$each(fn) {
    for(var i = $98bf6825f5696d94$var$globalStorage.length - 1; i >= 0; i--){
        var key = $98bf6825f5696d94$var$globalStorage.key(i);
        fn($98bf6825f5696d94$var$globalStorage[key], key);
    }
}
function $98bf6825f5696d94$var$remove(key) {
    return $98bf6825f5696d94$var$globalStorage.removeItem(key);
}
function $98bf6825f5696d94$var$clearAll() {
    $98bf6825f5696d94$var$each(function(key, _) {
        delete $98bf6825f5696d94$var$globalStorage[key];
    });
}

});

parcelRequire.register("053wT", function(module, exports) {
// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var $jlvmO = parcelRequire("jlvmO");
var $00f334a19fd09552$var$Global = $jlvmO.Global;
module.exports = {
    name: "oldIE-userDataStorage",
    write: $00f334a19fd09552$var$write,
    read: $00f334a19fd09552$var$read,
    each: $00f334a19fd09552$var$each,
    remove: $00f334a19fd09552$var$remove,
    clearAll: $00f334a19fd09552$var$clearAll
};
var $00f334a19fd09552$var$storageName = "storejs";
var $00f334a19fd09552$var$doc = $00f334a19fd09552$var$Global.document;
var $00f334a19fd09552$var$_withStorageEl = $00f334a19fd09552$var$_makeIEStorageElFunction();
var $00f334a19fd09552$var$disable = ($00f334a19fd09552$var$Global.navigator ? $00f334a19fd09552$var$Global.navigator.userAgent : "").match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
;
function $00f334a19fd09552$var$write(unfixedKey, data) {
    if ($00f334a19fd09552$var$disable) return;
    var fixedKey = $00f334a19fd09552$var$fixKey(unfixedKey);
    $00f334a19fd09552$var$_withStorageEl(function(storageEl) {
        storageEl.setAttribute(fixedKey, data);
        storageEl.save($00f334a19fd09552$var$storageName);
    });
}
function $00f334a19fd09552$var$read(unfixedKey) {
    if ($00f334a19fd09552$var$disable) return;
    var fixedKey = $00f334a19fd09552$var$fixKey(unfixedKey);
    var res = null;
    $00f334a19fd09552$var$_withStorageEl(function(storageEl) {
        res = storageEl.getAttribute(fixedKey);
    });
    return res;
}
function $00f334a19fd09552$var$each(callback) {
    $00f334a19fd09552$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        for(var i = attributes.length - 1; i >= 0; i--){
            var attr = attributes[i];
            callback(storageEl.getAttribute(attr.name), attr.name);
        }
    });
}
function $00f334a19fd09552$var$remove(unfixedKey) {
    var fixedKey = $00f334a19fd09552$var$fixKey(unfixedKey);
    $00f334a19fd09552$var$_withStorageEl(function(storageEl) {
        storageEl.removeAttribute(fixedKey);
        storageEl.save($00f334a19fd09552$var$storageName);
    });
}
function $00f334a19fd09552$var$clearAll() {
    $00f334a19fd09552$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        storageEl.load($00f334a19fd09552$var$storageName);
        for(var i = attributes.length - 1; i >= 0; i--)storageEl.removeAttribute(attributes[i].name);
        storageEl.save($00f334a19fd09552$var$storageName);
    });
}
// Helpers
//////////
// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var $00f334a19fd09552$var$forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
function $00f334a19fd09552$var$fixKey(key) {
    return key.replace(/^\d/, "___$&").replace($00f334a19fd09552$var$forbiddenCharsRegex, "___");
}
function $00f334a19fd09552$var$_makeIEStorageElFunction() {
    if (!$00f334a19fd09552$var$doc || !$00f334a19fd09552$var$doc.documentElement || !$00f334a19fd09552$var$doc.documentElement.addBehavior) return null;
    var scriptTag = "script", storageOwner, storageContainer, storageEl;
    // Since #userData storage applies only to specific paths, we need to
    // somehow link our data to a specific path.  We choose /favicon.ico
    // as a pretty safe option, since all browsers already make a request to
    // this URL anyway and being a 404 will not hurt us here.  We wrap an
    // iframe pointing to the favicon in an ActiveXObject(htmlfile) object
    // (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
    // since the iframe access rules appear to allow direct access and
    // manipulation of the document element, even for a 404 page.  This
    // document can be used instead of the current document (which would
    // have been limited to the current path) to perform #userData storage.
    try {
        /* global ActiveXObject */ storageContainer = new ActiveXObject("htmlfile");
        storageContainer.open();
        storageContainer.write("<" + scriptTag + ">document.w=window</" + scriptTag + '><iframe src="/favicon.ico"></iframe>');
        storageContainer.close();
        storageOwner = storageContainer.w.frames[0].document;
        storageEl = storageOwner.createElement("div");
    } catch (e) {
        // somehow ActiveXObject instantiation failed (perhaps some special
        // security settings or otherwse), fall back to per-path storage
        storageEl = $00f334a19fd09552$var$doc.createElement("div");
        storageOwner = $00f334a19fd09552$var$doc.body;
    }
    return function(storeFunction) {
        var args = [].slice.call(arguments, 0);
        args.unshift(storageEl);
        // See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
        // and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
        storageOwner.appendChild(storageEl);
        storageEl.addBehavior("#default#userData");
        storageEl.load($00f334a19fd09552$var$storageName);
        storeFunction.apply(this, args);
        storageOwner.removeChild(storageEl);
        return;
    };
}

});

parcelRequire.register("dBJPT", function(module, exports) {
// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var $jlvmO = parcelRequire("jlvmO");
var $9e8249242500ac5f$var$Global = $jlvmO.Global;
var $9e8249242500ac5f$var$trim = $jlvmO.trim;
module.exports = {
    name: "cookieStorage",
    read: $9e8249242500ac5f$var$read,
    write: $9e8249242500ac5f$var$write,
    each: $9e8249242500ac5f$var$each,
    remove: $9e8249242500ac5f$var$remove,
    clearAll: $9e8249242500ac5f$var$clearAll
};
var $9e8249242500ac5f$var$doc = $9e8249242500ac5f$var$Global.document;
function $9e8249242500ac5f$var$read(key) {
    if (!key || !$9e8249242500ac5f$var$_has(key)) return null;
    var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
    return unescape($9e8249242500ac5f$var$doc.cookie.replace(new RegExp(regexpStr), "$1"));
}
function $9e8249242500ac5f$var$each(callback) {
    var cookies = $9e8249242500ac5f$var$doc.cookie.split(/; ?/g);
    for(var i = cookies.length - 1; i >= 0; i--){
        if (!$9e8249242500ac5f$var$trim(cookies[i])) continue;
        var kvp = cookies[i].split("=");
        var key = unescape(kvp[0]);
        var val = unescape(kvp[1]);
        callback(val, key);
    }
}
function $9e8249242500ac5f$var$write(key, data) {
    if (!key) return;
    $9e8249242500ac5f$var$doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
}
function $9e8249242500ac5f$var$remove(key) {
    if (!key || !$9e8249242500ac5f$var$_has(key)) return;
    $9e8249242500ac5f$var$doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
function $9e8249242500ac5f$var$clearAll() {
    $9e8249242500ac5f$var$each(function(_, key) {
        $9e8249242500ac5f$var$remove(key);
    });
}
function $9e8249242500ac5f$var$_has(key) {
    return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test($9e8249242500ac5f$var$doc.cookie);
}

});

parcelRequire.register("8wo1l", function(module, exports) {

var $jlvmO = parcelRequire("jlvmO");
var $6343f1e7e13ce437$var$Global = $jlvmO.Global;
module.exports = {
    name: "sessionStorage",
    read: $6343f1e7e13ce437$var$read,
    write: $6343f1e7e13ce437$var$write,
    each: $6343f1e7e13ce437$var$each,
    remove: $6343f1e7e13ce437$var$remove,
    clearAll: $6343f1e7e13ce437$var$clearAll
};
function $6343f1e7e13ce437$var$sessionStorage() {
    return $6343f1e7e13ce437$var$Global.sessionStorage;
}
function $6343f1e7e13ce437$var$read(key) {
    return $6343f1e7e13ce437$var$sessionStorage().getItem(key);
}
function $6343f1e7e13ce437$var$write(key, data) {
    return $6343f1e7e13ce437$var$sessionStorage().setItem(key, data);
}
function $6343f1e7e13ce437$var$each(fn) {
    for(var i = $6343f1e7e13ce437$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $6343f1e7e13ce437$var$sessionStorage().key(i);
        fn($6343f1e7e13ce437$var$read(key), key);
    }
}
function $6343f1e7e13ce437$var$remove(key) {
    return $6343f1e7e13ce437$var$sessionStorage().removeItem(key);
}
function $6343f1e7e13ce437$var$clearAll() {
    return $6343f1e7e13ce437$var$sessionStorage().clear();
}

});

parcelRequire.register("lF78s", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: "memoryStorage",
    read: $fc52f63a9d73d111$var$read,
    write: $fc52f63a9d73d111$var$write,
    each: $fc52f63a9d73d111$var$each,
    remove: $fc52f63a9d73d111$var$remove,
    clearAll: $fc52f63a9d73d111$var$clearAll
};
var $fc52f63a9d73d111$var$memoryStorage = {};
function $fc52f63a9d73d111$var$read(key) {
    return $fc52f63a9d73d111$var$memoryStorage[key];
}
function $fc52f63a9d73d111$var$write(key, data) {
    $fc52f63a9d73d111$var$memoryStorage[key] = data;
}
function $fc52f63a9d73d111$var$each(callback) {
    for(var key in $fc52f63a9d73d111$var$memoryStorage)if ($fc52f63a9d73d111$var$memoryStorage.hasOwnProperty(key)) callback($fc52f63a9d73d111$var$memoryStorage[key], key);
}
function $fc52f63a9d73d111$var$remove(key) {
    delete $fc52f63a9d73d111$var$memoryStorage[key];
}
function $fc52f63a9d73d111$var$clearAll(key) {
    $fc52f63a9d73d111$var$memoryStorage = {};
}

});

parcelRequire.register("jx4X3", function(module, exports) {
module.exports = $e384f0a54aad9c23$var$json2Plugin;

function $e384f0a54aad9c23$var$json2Plugin() {
    (parcelRequire("5GeeX"));
    return {};
}

});
parcelRequire.register("5GeeX", function(module, exports) {
/* eslint-disable */ //  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html
//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.
//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.
//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.
//          For example, this would serialize Dates as ISO strings.
//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };
//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.
//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.
//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.
//          JSON.stringify(undefined) returns undefined.
//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.
//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.
//          Example:
//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'
//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'
//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.
//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.
//          Example:
//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.
//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });
//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });
//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.
/*jslint
    eval, for, this
*/ /*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
if (typeof JSON !== "object") JSON = {};
(function() {
    "use strict";
    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    function f(n11) {
        // Format integers to have at least two digits.
        return n11 < 10 ? "0" + n11 : n11;
    }
    function this_value() {
        return this.valueOf();
    }
    if (typeof Date.prototype.toJSON !== "function") {
        Date.prototype.toJSON = function() {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
        };
        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }
    var gap;
    var indent;
    var meta;
    var rep;
    function quote(string11) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string11) ? '"' + string11.replace(rx_escapable, function(a11) {
            var c11 = meta[a11];
            return typeof c11 === "string" ? c11 : "\\u" + ("0000" + a11.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string11 + '"';
    }
    function str(key11, holder11) {
        // Produce a string from holder[key].
        var i11; // The loop counter.
        var k11; // The member key.
        var v11; // The member value.
        var length11;
        var mind11 = gap;
        var partial11;
        var value11 = holder11[key11];
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value11 && typeof value11 === "object" && typeof value11.toJSON === "function") value11 = value11.toJSON(key11);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value11 = rep.call(holder11, key11, value11);
        // What happens next depends on the value's type.
        switch(typeof value11){
            case "string":
                return quote(value11);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value11) ? String(value11) : "null";
            case "boolean":
            case "null":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce "null". The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value11);
            // If the type is "object", we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is "object",
                // so watch out for that case.
                if (!value11) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial11 = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value11) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length11 = value11.length;
                    for(i11 = 0; i11 < length11; i11 += 1)partial11[i11] = str(i11, value11) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v11 = partial11.length === 0 ? "[]" : gap ? "[\n" + gap + partial11.join(",\n" + gap) + "\n" + mind11 + "]" : "[" + partial11.join(",") + "]";
                    gap = mind11;
                    return v11;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length11 = rep.length;
                    for(i11 = 0; i11 < length11; i11 += 1)if (typeof rep[i11] === "string") {
                        k11 = rep[i11];
                        v11 = str(k11, value11);
                        if (v11) partial11.push(quote(k11) + (gap ? ": " : ":") + v11);
                    }
                } else {
                    // Otherwise, iterate through all of the keys in the object.
                    for(k11 in value11)if (Object.prototype.hasOwnProperty.call(value11, k11)) {
                        v11 = str(k11, value11);
                        if (v11) partial11.push(quote(k11) + (gap ? ": " : ":") + v11);
                    }
                }
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v11 = partial11.length === 0 ? "{}" : gap ? "{\n" + gap + partial11.join(",\n" + gap) + "\n" + mind11 + "}" : "{" + partial11.join(",") + "}";
                gap = mind11;
                return v11;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof JSON.stringify !== "function") {
        meta = {
            "\b": "\\b",
            "	": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
        };
        JSON.stringify = function(value11, replacer11, space11) {
            // The stringify method takes a value and an optional replacer, and an optional
            // space parameter, and returns a JSON text. The replacer can be a function
            // that can replace values, or an array of strings that will select the keys.
            // A default replacer method can be provided. Use of the space parameter can
            // produce text that is more easily readable.
            var i11;
            gap = "";
            indent = "";
            // If the space parameter is a number, make an indent string containing that
            // many spaces.
            if (typeof space11 === "number") for(i11 = 0; i11 < space11; i11 += 1)indent += " ";
            else if (typeof space11 === "string") indent = space11;
            // If there is a replacer, it must be a function or an array.
            // Otherwise, throw an error.
            rep = replacer11;
            if (replacer11 && typeof replacer11 !== "function" && (typeof replacer11 !== "object" || typeof replacer11.length !== "number")) throw new Error("JSON.stringify");
            // Make a fake root object containing our value under the key of "".
            // Return the result of stringifying the value.
            return str("", {
                "": value11
            });
        };
    }
    // If the JSON object does not yet have a parse method, give it one.
    if (typeof JSON.parse !== "function") JSON.parse = function(text, reviver) {
        // The parse method takes a text and an optional reviver function, and returns
        // a JavaScript value if the text is a valid JSON text.
        var j;
        function walk(holder11, key11) {
            // The walk method is used to recursively walk the resulting structure so
            // that modifications can be made.
            var k11;
            var v11;
            var value11 = holder11[key11];
            if (value11 && typeof value11 === "object") {
                for(k11 in value11)if (Object.prototype.hasOwnProperty.call(value11, k11)) {
                    v11 = walk(value11, k11);
                    if (v11 !== undefined) value11[k11] = v11;
                    else delete value11[k11];
                }
            }
            return reviver.call(holder11, key11, value11);
        }
        // Parsing happens in four stages. In the first stage, we replace certain
        // Unicode characters with escape sequences. JavaScript handles many characters
        // incorrectly, either silently deleting them, or treating them as line endings.
        text = String(text);
        rx_dangerous.lastIndex = 0;
        if (rx_dangerous.test(text)) text = text.replace(rx_dangerous, function(a11) {
            return "\\u" + ("0000" + a11.charCodeAt(0).toString(16)).slice(-4);
        });
        // In the second stage, we run the text against regular expressions that look
        // for non-JSON patterns. We are especially concerned with "()" and "new"
        // because they can cause invocation, and "=" because it can cause mutation.
        // But just to be safe, we want to reject all unexpected forms.
        // We split the second stage into 4 regexp operations in order to work around
        // crippling inefficiencies in IE's and Safari's regexp engines. First we
        // replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
        // replace all simple value tokens with "]" characters. Third, we delete all
        // open brackets that follow a colon or comma or that begin the text. Finally,
        // we look to see that the remaining characters are only whitespace or "]" or
        // "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
        if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
            // In the third stage we use the eval function to compile the text into a
            // JavaScript structure. The "{" operator is subject to a syntactic ambiguity
            // in JavaScript: it can begin a block or an object literal. We wrap the text
            // in parens to eliminate the ambiguity.
            j = eval("(" + text + ")");
            // In the optional fourth stage, we recursively walk the new structure, passing
            // each name/value pair to a reviver function for possible transformation.
            return typeof reviver === "function" ? walk({
                "": j
            }, "") : j;
        }
        // If the text is not JSON parseable, then a SyntaxError is thrown.
        throw new SyntaxError("JSON.parse");
    };
})();

});


parcelRequire.register("d21w1", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $97cca3331f49c21d$export$2b8d127b894957b9; }, function (v) { return $97cca3331f49c21d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $97cca3331f49c21d$export$cea3a54a6425200c; }, function (v) { return $97cca3331f49c21d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $97cca3331f49c21d$export$a7c73072b1a182ae; }, function (v) { return $97cca3331f49c21d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $97cca3331f49c21d$export$9f27bc3417b4524d; }, function (v) { return $97cca3331f49c21d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $97cca3331f49c21d$export$db77ccec0bb4ccac; }, function (v) { return $97cca3331f49c21d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $97cca3331f49c21d$export$8392c0c9d3dcbd35; }, function (v) { return $97cca3331f49c21d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $97cca3331f49c21d$export$ffb0004e005737fa; }, function (v) { return $97cca3331f49c21d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $97cca3331f49c21d$export$b624eff549462981; }, function (v) { return $97cca3331f49c21d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $97cca3331f49c21d$export$7897aa7841a5380c; }, function (v) { return $97cca3331f49c21d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $97cca3331f49c21d$export$602eac185826482c; }, function (v) { return $97cca3331f49c21d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $97cca3331f49c21d$export$e2c29f18771995cb; }, function (v) { return $97cca3331f49c21d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $97cca3331f49c21d$export$5f8d39834fd61797; }, function (v) { return $97cca3331f49c21d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $97cca3331f49c21d$export$74bf444e3cd11ea5; }, function (v) { return $97cca3331f49c21d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $97cca3331f49c21d$export$92387174baf9b227; }, function (v) { return $97cca3331f49c21d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $97cca3331f49c21d$export$ec112efeb987d9c6; }, function (v) { return $97cca3331f49c21d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $97cca3331f49c21d$export$b706b080d889d2c9; }, function (v) { return $97cca3331f49c21d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $97cca3331f49c21d$export$5be5a87408f70ddc; }, function (v) { return $97cca3331f49c21d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $97cca3331f49c21d$export$45a5e7f76e0caa8d; }, function (v) { return $97cca3331f49c21d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $97cca3331f49c21d$export$455c2e768291efa6; }, function (v) { return $97cca3331f49c21d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $97cca3331f49c21d$export$9522e17588c12572; }, function (v) { return $97cca3331f49c21d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $97cca3331f49c21d$export$2110ac352bb060b9; }, function (v) { return $97cca3331f49c21d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $97cca3331f49c21d$export$56885ab8b9c456ab; }, function (v) { return $97cca3331f49c21d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $97cca3331f49c21d$export$d927fcb6adf8f9de; }, function (v) { return $97cca3331f49c21d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $97cca3331f49c21d$export$b82d16f27459e05a; }, function (v) { return $97cca3331f49c21d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $97cca3331f49c21d$export$522c17b4f5e123e8; }, function (v) { return $97cca3331f49c21d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $97cca3331f49c21d$export$1aabd8a0274ecfd6; }, function (v) { return $97cca3331f49c21d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $97cca3331f49c21d$export$9b621391a187a31a; }, function (v) { return $97cca3331f49c21d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $97cca3331f49c21d$export$f5bbd400c2f4426f; }, function (v) { return $97cca3331f49c21d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $97cca3331f49c21d$export$2b8d127b894957b9;
var $97cca3331f49c21d$export$cea3a54a6425200c;
var $97cca3331f49c21d$export$a7c73072b1a182ae;
var $97cca3331f49c21d$export$9f27bc3417b4524d;
var $97cca3331f49c21d$export$db77ccec0bb4ccac;
var $97cca3331f49c21d$export$8392c0c9d3dcbd35;
var $97cca3331f49c21d$export$ffb0004e005737fa;
var $97cca3331f49c21d$export$b624eff549462981;
var $97cca3331f49c21d$export$7897aa7841a5380c;
var $97cca3331f49c21d$export$602eac185826482c;
var $97cca3331f49c21d$export$e2c29f18771995cb;
var $97cca3331f49c21d$export$5f8d39834fd61797;
var $97cca3331f49c21d$export$74bf444e3cd11ea5;
var $97cca3331f49c21d$export$92387174baf9b227;
var $97cca3331f49c21d$export$ec112efeb987d9c6;
var $97cca3331f49c21d$export$b706b080d889d2c9;
var $97cca3331f49c21d$export$5be5a87408f70ddc;
var $97cca3331f49c21d$export$45a5e7f76e0caa8d;
var $97cca3331f49c21d$export$455c2e768291efa6;
var $97cca3331f49c21d$export$9522e17588c12572;
var $97cca3331f49c21d$export$2110ac352bb060b9;
var $97cca3331f49c21d$export$56885ab8b9c456ab;
var $97cca3331f49c21d$export$d927fcb6adf8f9de;
var $97cca3331f49c21d$export$b82d16f27459e05a;
var $97cca3331f49c21d$export$522c17b4f5e123e8;
var $97cca3331f49c21d$export$1aabd8a0274ecfd6;
var $97cca3331f49c21d$export$9b621391a187a31a;
var $97cca3331f49c21d$export$f5bbd400c2f4426f;
"use strict";
var $97cca3331f49c21d$var$b = "function" === typeof Symbol && Symbol.for, $97cca3331f49c21d$var$c = $97cca3331f49c21d$var$b ? Symbol.for("react.element") : 60103, $97cca3331f49c21d$var$d = $97cca3331f49c21d$var$b ? Symbol.for("react.portal") : 60106, $97cca3331f49c21d$var$e = $97cca3331f49c21d$var$b ? Symbol.for("react.fragment") : 60107, $97cca3331f49c21d$var$f = $97cca3331f49c21d$var$b ? Symbol.for("react.strict_mode") : 60108, $97cca3331f49c21d$var$g = $97cca3331f49c21d$var$b ? Symbol.for("react.profiler") : 60114, $97cca3331f49c21d$var$h = $97cca3331f49c21d$var$b ? Symbol.for("react.provider") : 60109, $97cca3331f49c21d$var$k = $97cca3331f49c21d$var$b ? Symbol.for("react.context") : 60110, $97cca3331f49c21d$var$l = $97cca3331f49c21d$var$b ? Symbol.for("react.async_mode") : 60111, $97cca3331f49c21d$var$m = $97cca3331f49c21d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $97cca3331f49c21d$var$n = $97cca3331f49c21d$var$b ? Symbol.for("react.forward_ref") : 60112, $97cca3331f49c21d$var$p = $97cca3331f49c21d$var$b ? Symbol.for("react.suspense") : 60113, $97cca3331f49c21d$var$q = $97cca3331f49c21d$var$b ? Symbol.for("react.suspense_list") : 60120, $97cca3331f49c21d$var$r = $97cca3331f49c21d$var$b ? Symbol.for("react.memo") : 60115, $97cca3331f49c21d$var$t = $97cca3331f49c21d$var$b ? Symbol.for("react.lazy") : 60116, $97cca3331f49c21d$var$v = $97cca3331f49c21d$var$b ? Symbol.for("react.block") : 60121, $97cca3331f49c21d$var$w = $97cca3331f49c21d$var$b ? Symbol.for("react.fundamental") : 60117, $97cca3331f49c21d$var$x = $97cca3331f49c21d$var$b ? Symbol.for("react.responder") : 60118, $97cca3331f49c21d$var$y = $97cca3331f49c21d$var$b ? Symbol.for("react.scope") : 60119;
function $97cca3331f49c21d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $97cca3331f49c21d$var$c:
                switch(a = a.type, a){
                    case $97cca3331f49c21d$var$l:
                    case $97cca3331f49c21d$var$m:
                    case $97cca3331f49c21d$var$e:
                    case $97cca3331f49c21d$var$g:
                    case $97cca3331f49c21d$var$f:
                    case $97cca3331f49c21d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $97cca3331f49c21d$var$k:
                            case $97cca3331f49c21d$var$n:
                            case $97cca3331f49c21d$var$t:
                            case $97cca3331f49c21d$var$r:
                            case $97cca3331f49c21d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $97cca3331f49c21d$var$d:
                return u;
        }
    }
}
function $97cca3331f49c21d$var$A(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$m;
}
$97cca3331f49c21d$export$2b8d127b894957b9 = $97cca3331f49c21d$var$l;
$97cca3331f49c21d$export$cea3a54a6425200c = $97cca3331f49c21d$var$m;
$97cca3331f49c21d$export$a7c73072b1a182ae = $97cca3331f49c21d$var$k;
$97cca3331f49c21d$export$9f27bc3417b4524d = $97cca3331f49c21d$var$h;
$97cca3331f49c21d$export$db77ccec0bb4ccac = $97cca3331f49c21d$var$c;
$97cca3331f49c21d$export$8392c0c9d3dcbd35 = $97cca3331f49c21d$var$n;
$97cca3331f49c21d$export$ffb0004e005737fa = $97cca3331f49c21d$var$e;
$97cca3331f49c21d$export$b624eff549462981 = $97cca3331f49c21d$var$t;
$97cca3331f49c21d$export$7897aa7841a5380c = $97cca3331f49c21d$var$r;
$97cca3331f49c21d$export$602eac185826482c = $97cca3331f49c21d$var$d;
$97cca3331f49c21d$export$e2c29f18771995cb = $97cca3331f49c21d$var$g;
$97cca3331f49c21d$export$5f8d39834fd61797 = $97cca3331f49c21d$var$f;
$97cca3331f49c21d$export$74bf444e3cd11ea5 = $97cca3331f49c21d$var$p;
$97cca3331f49c21d$export$92387174baf9b227 = function(a) {
    return $97cca3331f49c21d$var$A(a) || $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$l;
};
$97cca3331f49c21d$export$ec112efeb987d9c6 = $97cca3331f49c21d$var$A;
$97cca3331f49c21d$export$b706b080d889d2c9 = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$k;
};
$97cca3331f49c21d$export$5be5a87408f70ddc = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$h;
};
$97cca3331f49c21d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $97cca3331f49c21d$var$c;
};
$97cca3331f49c21d$export$455c2e768291efa6 = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$n;
};
$97cca3331f49c21d$export$9522e17588c12572 = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$e;
};
$97cca3331f49c21d$export$2110ac352bb060b9 = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$t;
};
$97cca3331f49c21d$export$56885ab8b9c456ab = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$r;
};
$97cca3331f49c21d$export$d927fcb6adf8f9de = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$d;
};
$97cca3331f49c21d$export$b82d16f27459e05a = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$g;
};
$97cca3331f49c21d$export$522c17b4f5e123e8 = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$f;
};
$97cca3331f49c21d$export$1aabd8a0274ecfd6 = function(a) {
    return $97cca3331f49c21d$var$z(a) === $97cca3331f49c21d$var$p;
};
$97cca3331f49c21d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $97cca3331f49c21d$var$e || a === $97cca3331f49c21d$var$m || a === $97cca3331f49c21d$var$g || a === $97cca3331f49c21d$var$f || a === $97cca3331f49c21d$var$p || a === $97cca3331f49c21d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $97cca3331f49c21d$var$t || a.$$typeof === $97cca3331f49c21d$var$r || a.$$typeof === $97cca3331f49c21d$var$h || a.$$typeof === $97cca3331f49c21d$var$k || a.$$typeof === $97cca3331f49c21d$var$n || a.$$typeof === $97cca3331f49c21d$var$w || a.$$typeof === $97cca3331f49c21d$var$x || a.$$typeof === $97cca3331f49c21d$var$y || a.$$typeof === $97cca3331f49c21d$var$v);
};
$97cca3331f49c21d$export$f5bbd400c2f4426f = $97cca3331f49c21d$var$z;

});

parcelRequire.register("34qAQ", function(module, exports) {
"use strict";

var $d2h6k = parcelRequire("d2h6k");

var $1hqbz = parcelRequire("1hqbz");
module.exports = $1hqbz;
$1hqbz.prototype.message = $23c65face8d7e3e2$var$message;
$1hqbz.prototype.info = $23c65face8d7e3e2$var$info;
$1hqbz.prototype.fail = $23c65face8d7e3e2$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $23c65face8d7e3e2$var$message(reason, position, origin) {
    var message = new $d2h6k(reason, position, origin);
    if (this.path) {
        message.name = this.path + ":" + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $23c65face8d7e3e2$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $23c65face8d7e3e2$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRequire.register("d2h6k", function(module, exports) {
"use strict";

var $l1tiQ = parcelRequire("l1tiQ");
module.exports = $97d8ba29498806e0$var$VMessage;
// Inherit from `Error#`.
function $97d8ba29498806e0$var$VMessagePrototype() {}
$97d8ba29498806e0$var$VMessagePrototype.prototype = Error.prototype;
$97d8ba29498806e0$var$VMessage.prototype = new $97d8ba29498806e0$var$VMessagePrototype();
// Message properties.
var $97d8ba29498806e0$var$proto = $97d8ba29498806e0$var$VMessage.prototype;
$97d8ba29498806e0$var$proto.file = "";
$97d8ba29498806e0$var$proto.name = "";
$97d8ba29498806e0$var$proto.reason = "";
$97d8ba29498806e0$var$proto.message = "";
$97d8ba29498806e0$var$proto.stack = "";
$97d8ba29498806e0$var$proto.fatal = null;
$97d8ba29498806e0$var$proto.column = null;
$97d8ba29498806e0$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $97d8ba29498806e0$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === "string") {
        origin = position;
        position = null;
    }
    parts = $97d8ba29498806e0$var$parseOrigin(origin);
    range = $l1tiQ(position) || "1:1";
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $97d8ba29498806e0$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === "string") {
        index = origin.indexOf(":");
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRequire.register("l1tiQ", function(module, exports) {
"use strict";
var $f4e06bf32ee57ec6$var$own = {}.hasOwnProperty;
module.exports = $f4e06bf32ee57ec6$var$stringify;
function $f4e06bf32ee57ec6$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ($f4e06bf32ee57ec6$var$own.call(value, "position") || $f4e06bf32ee57ec6$var$own.call(value, "type")) return $f4e06bf32ee57ec6$var$position(value.position);
    // Position.
    if ($f4e06bf32ee57ec6$var$own.call(value, "start") || $f4e06bf32ee57ec6$var$own.call(value, "end")) return $f4e06bf32ee57ec6$var$position(value);
    // Point.
    if ($f4e06bf32ee57ec6$var$own.call(value, "line") || $f4e06bf32ee57ec6$var$own.call(value, "column")) return $f4e06bf32ee57ec6$var$point(value);
    // ?
    return "";
}
function $f4e06bf32ee57ec6$var$point(point) {
    if (!point || typeof point !== "object") point = {};
    return $f4e06bf32ee57ec6$var$index(point.line) + ":" + $f4e06bf32ee57ec6$var$index(point.column);
}
function $f4e06bf32ee57ec6$var$position(pos) {
    if (!pos || typeof pos !== "object") pos = {};
    return $f4e06bf32ee57ec6$var$point(pos.start) + "-" + $f4e06bf32ee57ec6$var$point(pos.end);
}
function $f4e06bf32ee57ec6$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRequire.register("1hqbz", function(module, exports) {
"use strict";

var $5277G = parcelRequire("5277G");

var $h2koA = parcelRequire("h2koA");

var $1vTdF = parcelRequire("1vTdF");
module.exports = $0eebb0df966842ce$var$VFile;
var $0eebb0df966842ce$var$own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $0eebb0df966842ce$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
$0eebb0df966842ce$var$VFile.prototype.toString = $0eebb0df966842ce$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($0eebb0df966842ce$var$VFile.prototype, "path", {
    get: $0eebb0df966842ce$var$getPath,
    set: $0eebb0df966842ce$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($0eebb0df966842ce$var$VFile.prototype, "dirname", {
    get: $0eebb0df966842ce$var$getDirname,
    set: $0eebb0df966842ce$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($0eebb0df966842ce$var$VFile.prototype, "basename", {
    get: $0eebb0df966842ce$var$getBasename,
    set: $0eebb0df966842ce$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($0eebb0df966842ce$var$VFile.prototype, "extname", {
    get: $0eebb0df966842ce$var$getExtname,
    set: $0eebb0df966842ce$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($0eebb0df966842ce$var$VFile.prototype, "stem", {
    get: $0eebb0df966842ce$var$getStem,
    set: $0eebb0df966842ce$var$setStem
});
// Construct a new file.
function $0eebb0df966842ce$var$VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === "string" || $1vTdF(options)) options = {
        contents: options
    };
    else if ("message" in options && "messages" in options) return options;
    if (!(this instanceof $0eebb0df966842ce$var$VFile)) return new $0eebb0df966842ce$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $h2koA.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < $0eebb0df966842ce$var$order.length){
        prop = $0eebb0df966842ce$var$order[index];
        if ($0eebb0df966842ce$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($0eebb0df966842ce$var$order.indexOf(prop) < 0) this[prop] = options[prop];
}
function $0eebb0df966842ce$var$getPath() {
    return this.history[this.history.length - 1];
}
function $0eebb0df966842ce$var$setPath(path) {
    $0eebb0df966842ce$var$assertNonEmpty(path, "path");
    if (this.path !== path) this.history.push(path);
}
function $0eebb0df966842ce$var$getDirname() {
    return typeof this.path === "string" ? $5277G.dirname(this.path) : undefined;
}
function $0eebb0df966842ce$var$setDirname(dirname) {
    $0eebb0df966842ce$var$assertPath(this.path, "dirname");
    this.path = $5277G.join(dirname || "", this.basename);
}
function $0eebb0df966842ce$var$getBasename() {
    return typeof this.path === "string" ? $5277G.basename(this.path) : undefined;
}
function $0eebb0df966842ce$var$setBasename(basename) {
    $0eebb0df966842ce$var$assertNonEmpty(basename, "basename");
    $0eebb0df966842ce$var$assertPart(basename, "basename");
    this.path = $5277G.join(this.dirname || "", basename);
}
function $0eebb0df966842ce$var$getExtname() {
    return typeof this.path === "string" ? $5277G.extname(this.path) : undefined;
}
function $0eebb0df966842ce$var$setExtname(extname) {
    $0eebb0df966842ce$var$assertPart(extname, "extname");
    $0eebb0df966842ce$var$assertPath(this.path, "extname");
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
        if (extname.indexOf(".", 1) > -1) throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = $5277G.join(this.dirname, this.stem + (extname || ""));
}
function $0eebb0df966842ce$var$getStem() {
    return typeof this.path === "string" ? $5277G.basename(this.path, this.extname) : undefined;
}
function $0eebb0df966842ce$var$setStem(stem) {
    $0eebb0df966842ce$var$assertNonEmpty(stem, "stem");
    $0eebb0df966842ce$var$assertPart(stem, "stem");
    this.path = $5277G.join(this.dirname || "", stem + (this.extname || ""));
}
// Get the value of the file.
function $0eebb0df966842ce$var$toString(encoding) {
    return (this.contents || "").toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function $0eebb0df966842ce$var$assertPart(part, name) {
    if (part && part.indexOf($5277G.sep) > -1) throw new Error("`" + name + "` cannot be a path: did not expect `" + $5277G.sep + "`");
}
// Assert that `part` is not empty.
function $0eebb0df966842ce$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
// Assert `path` exists.
function $0eebb0df966842ce$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}

});
parcelRequire.register("5277G", function(module, exports) {

$parcel$export(module.exports, "basename", function () { return $3aa2aa1a5fa3bef3$export$9bf319d8f74f51d1; }, function (v) { return $3aa2aa1a5fa3bef3$export$9bf319d8f74f51d1 = v; });
$parcel$export(module.exports, "dirname", function () { return $3aa2aa1a5fa3bef3$export$7f7b8152cc673abe; }, function (v) { return $3aa2aa1a5fa3bef3$export$7f7b8152cc673abe = v; });
$parcel$export(module.exports, "extname", function () { return $3aa2aa1a5fa3bef3$export$d0e86f3a75393fa3; }, function (v) { return $3aa2aa1a5fa3bef3$export$d0e86f3a75393fa3 = v; });
$parcel$export(module.exports, "join", function () { return $3aa2aa1a5fa3bef3$export$f7e2c8231c57a8bd; }, function (v) { return $3aa2aa1a5fa3bef3$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "sep", function () { return $3aa2aa1a5fa3bef3$export$5aee1a5bd9743d8f; }, function (v) { return $3aa2aa1a5fa3bef3$export$5aee1a5bd9743d8f = v; });
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $3aa2aa1a5fa3bef3$export$9bf319d8f74f51d1;
var $3aa2aa1a5fa3bef3$export$7f7b8152cc673abe;
var $3aa2aa1a5fa3bef3$export$d0e86f3a75393fa3;
var $3aa2aa1a5fa3bef3$export$f7e2c8231c57a8bd;
var $3aa2aa1a5fa3bef3$export$5aee1a5bd9743d8f;
"use strict";
$3aa2aa1a5fa3bef3$export$9bf319d8f74f51d1 = $3aa2aa1a5fa3bef3$var$basename;
$3aa2aa1a5fa3bef3$export$7f7b8152cc673abe = $3aa2aa1a5fa3bef3$var$dirname;
$3aa2aa1a5fa3bef3$export$d0e86f3a75393fa3 = $3aa2aa1a5fa3bef3$var$extname;
$3aa2aa1a5fa3bef3$export$f7e2c8231c57a8bd = $3aa2aa1a5fa3bef3$var$join;
$3aa2aa1a5fa3bef3$export$5aee1a5bd9743d8f = "/";
function $3aa2aa1a5fa3bef3$var$basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $3aa2aa1a5fa3bef3$var$assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function $3aa2aa1a5fa3bef3$var$dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    $3aa2aa1a5fa3bef3$var$assertPath(path);
    if (!path.length) return ".";
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
function $3aa2aa1a5fa3bef3$var$extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    $3aa2aa1a5fa3bef3$var$assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
function $3aa2aa1a5fa3bef3$var$join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        $3aa2aa1a5fa3bef3$var$assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + "/" + arguments[index];
    }
    return joined === undefined ? "." : $3aa2aa1a5fa3bef3$var$normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $3aa2aa1a5fa3bef3$var$normalize(path) {
    var absolute;
    var value;
    $3aa2aa1a5fa3bef3$var$assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = $3aa2aa1a5fa3bef3$var$normalizeString(path, !absolute);
    if (!value.length && !absolute) value = ".";
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function $3aa2aa1a5fa3bef3$var$normalizeString(path, allowAboveRoot) {
    var result = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function $3aa2aa1a5fa3bef3$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}

});

parcelRequire.register("h2koA", function(module, exports) {

$parcel$export(module.exports, "cwd", function () { return $c67271b2c577124d$export$5f7bb87daeae59c1; }, function (v) { return $c67271b2c577124d$export$5f7bb87daeae59c1 = v; });
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $c67271b2c577124d$export$5f7bb87daeae59c1;
"use strict";
$c67271b2c577124d$export$5f7bb87daeae59c1 = $c67271b2c577124d$var$cwd;
function $c67271b2c577124d$var$cwd() {
    return "/";
}

});

parcelRequire.register("1vTdF", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});



parcelRequire.register("iGt2x", function(module, exports) {
"use strict";
module.exports = $d9a2acfc94e04a99$var$fromMarkdown;

var $5Lp4S = parcelRequire("5Lp4S");

var $3jpB0 = parcelRequire("3jpB0");

var $biIrQ = parcelRequire("biIrQ");

var $6eyVN = parcelRequire("6eyVN");

var $gdIN3 = parcelRequire("gdIN3");

var $7r73U = parcelRequire("7r73U");

var $7vWfy = parcelRequire("7vWfy");

var $04tjI = parcelRequire("04tjI");

var $69Z2v = parcelRequire("69Z2v");

var $l1tiQ = parcelRequire("l1tiQ");
function $d9a2acfc94e04a99$var$fromMarkdown(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $d9a2acfc94e04a99$var$compiler(options)($04tjI($7r73U(options).document().write($7vWfy()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function $d9a2acfc94e04a99$var$compiler(options) {
    var settings = options || {};
    var config = $d9a2acfc94e04a99$var$configure({
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: "root",
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if ($biIrQ.call(handler, events[index][1].type)) handler[events[index][1].type].call($3jpB0({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error("Cannot close document, a token (`" + tokenStack[tokenStack.length - 1].type + "`, " + $l1tiQ({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ") is still open");
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + $l1tiQ({
            start: token.start,
            end: token.end
        }) + "): it’s not open");
        else if (open.type !== token.type) throw new Error("Cannot close `" + token.type + "` (" + $l1tiQ({
            start: token.start,
            end: token.end
        }) + "): a different token (`" + open.type + "`, " + $l1tiQ({
            start: open.start,
            end: open.end
        }) + ") is open");
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return $5Lp4S(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $6eyVN(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData("atHardBreak", true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData("inReference")) {
            context.type += "Reference";
            context.referenceType = getData("referenceType") || "shortcut";
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData("referenceType");
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData("inReference")) {
            context.type += "Reference";
            context.referenceType = getData("referenceType") || "shortcut";
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData("referenceType");
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = $6eyVN(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData("inReference", true);
        if (this.stack[this.stack.length - 1].type === "link") this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData("inReference");
    }
    function onenterreference() {
        setData("referenceType", "collapsed");
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $6eyVN(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData("characterReferenceType");
        var value;
        var tail;
        if (type) {
            value = $gdIN3(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else value = $69Z2v(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    function heading() {
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: "break"
        };
    }
    function html() {
        return {
            type: "html",
            value: ""
        };
    }
    function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    function text() {
        return {
            type: "text",
            value: ""
        };
    }
    function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
function $d9a2acfc94e04a99$var$configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)$d9a2acfc94e04a99$var$extension(config, extensions[index]);
    return config;
}
function $d9a2acfc94e04a99$var$extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = $biIrQ.call(config, key) ? config[key] : config[key] = {};
        if (key === "canContainEols" || key === "transforms") config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

});
parcelRequire.register("5Lp4S", function(module, exports) {
"use strict";
module.exports = $4324cb6a41c97cf2$var$toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function $4324cb6a41c97cf2$var$toString(node) {
    return node && (node.value || node.alt || node.title || "children" in node && $4324cb6a41c97cf2$var$all(node.children) || "length" in node && $4324cb6a41c97cf2$var$all(node)) || "";
}
function $4324cb6a41c97cf2$var$all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $4324cb6a41c97cf2$var$toString(values[index]);
    return result.join("");
}

});

parcelRequire.register("3jpB0", function(module, exports) {
"use strict";
var $269700405e7556b2$var$assign = Object.assign;
module.exports = $269700405e7556b2$var$assign;

});

parcelRequire.register("biIrQ", function(module, exports) {
"use strict";
var $83a3da9a84089344$var$own = {}.hasOwnProperty;
module.exports = $83a3da9a84089344$var$own;

});

parcelRequire.register("6eyVN", function(module, exports) {
"use strict";
function $489f257ab6e73948$var$normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ") // Trim.
    .replace(/^ | $/g, "") // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = $489f257ab6e73948$var$normalizeIdentifier;

});

parcelRequire.register("gdIN3", function(module, exports) {
"use strict";

var $aSUwF = parcelRequire("aSUwF");
function $bcf09aa41e49b0d9$var$safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return "�";
    return $aSUwF(code);
}
module.exports = $bcf09aa41e49b0d9$var$safeFromInt;

});
parcelRequire.register("aSUwF", function(module, exports) {
"use strict";
var $7ecacb65af34008f$var$fromCharCode = String.fromCharCode;
module.exports = $7ecacb65af34008f$var$fromCharCode;

});


parcelRequire.register("7r73U", function(module, exports) {
"use strict";

var $jx5a3 = parcelRequire("jx5a3");

var $4sdaq = parcelRequire("4sdaq");

var $9nwWU = parcelRequire("9nwWU");

var $1alUx = parcelRequire("1alUx");

var $6vS9E = parcelRequire("6vS9E");

var $gcBYk = parcelRequire("gcBYk");

var $h8pqp = parcelRequire("h8pqp");

var $bZwLW = parcelRequire("bZwLW");
function $56a0886127cd8796$var$parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: $6vS9E([
            $bZwLW
        ].concat($h8pqp(settings.extensions))),
        content: create($jx5a3),
        document: create($4sdaq),
        flow: create($9nwWU),
        string: create($1alUx.string),
        text: create($1alUx.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return $gcBYk(parser, initializer, from);
        }
    }
}
module.exports = $56a0886127cd8796$var$parse;

});
parcelRequire.register("jx5a3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3GwUa = parcelRequire("3GwUa");

var $OF96b = parcelRequire("OF96b");
var $e3851a47f9efc614$var$tokenize = $e3851a47f9efc614$var$initializeContent;
function $e3851a47f9efc614$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $OF96b(effects, contentStart, "linePrefix");
    }
    function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ($3GwUa(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
module.exports.tokenize = $e3851a47f9efc614$var$tokenize;

});
parcelRequire.register("3GwUa", function(module, exports) {
"use strict";
function $2aeed1991e50892a$var$markdownLineEnding(code) {
    return code < -2;
}
module.exports = $2aeed1991e50892a$var$markdownLineEnding;

});

parcelRequire.register("OF96b", function(module, exports) {
"use strict";

var $9faMf = parcelRequire("9faMf");
function $09849651020046f8$var$spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if ($9faMf(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if ($9faMf(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = $09849651020046f8$var$spaceFactory;

});
parcelRequire.register("9faMf", function(module, exports) {
"use strict";
function $6baddfe170de1a3d$var$markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = $6baddfe170de1a3d$var$markdownSpace;

});



parcelRequire.register("4sdaq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3GwUa = parcelRequire("3GwUa");

var $OF96b = parcelRequire("OF96b");

var $l8l9z = parcelRequire("l8l9z");
var $33e3fdaad63a5171$var$tokenize = $33e3fdaad63a5171$var$initializeDocument;
var $33e3fdaad63a5171$var$containerConstruct = {
    tokenize: $33e3fdaad63a5171$var$tokenizeContainer
};
var $33e3fdaad63a5171$var$lazyFlowConstruct = {
    tokenize: $33e3fdaad63a5171$var$tokenizeLazyFlow
};
function $33e3fdaad63a5171$var$initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt($33e3fdaad63a5171$var$containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit("chunkFlow"));
            return flowStart(code);
        }
        if ($3GwUa(code)) {
            effects.consume(code);
            continueFlow(effects.exit("chunkFlow"));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt($33e3fdaad63a5171$var$containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt($33e3fdaad63a5171$var$containerConstruct, inspectFlowEnd, effects.attempt($33e3fdaad63a5171$var$lazyFlowConstruct, inspectFlowEnd, effects.check($l8l9z, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function $33e3fdaad63a5171$var$tokenizeContainer(effects, ok, nok) {
    return $OF96b(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
function $33e3fdaad63a5171$var$tokenizeLazyFlow(effects, ok, nok) {
    return $OF96b(effects, effects.lazy(this.parser.constructs.flow, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
module.exports.tokenize = $33e3fdaad63a5171$var$tokenize;

});
parcelRequire.register("l8l9z", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $OF96b = parcelRequire("OF96b");
var $f62ac0f2c03b056e$var$partialBlankLine = {
    tokenize: $f62ac0f2c03b056e$var$tokenizePartialBlankLine,
    partial: true
};
function $f62ac0f2c03b056e$var$tokenizePartialBlankLine(effects, ok, nok) {
    return $OF96b(effects, afterWhitespace, "linePrefix");
    function afterWhitespace(code) {
        return code === null || $3GwUa(code) ? ok(code) : nok(code);
    }
}
module.exports = $f62ac0f2c03b056e$var$partialBlankLine;

});


parcelRequire.register("9nwWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2kSpb = parcelRequire("2kSpb");

var $OF96b = parcelRequire("OF96b");

var $l8l9z = parcelRequire("l8l9z");
var $6d3fd20d5621adec$var$tokenize = $6d3fd20d5621adec$var$initializeFlow;
function $6d3fd20d5621adec$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    $l8l9z, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, $OF96b(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt($2kSpb, afterConstruct)), "linePrefix")));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}
module.exports.tokenize = $6d3fd20d5621adec$var$tokenize;

});
parcelRequire.register("2kSpb", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $9y2Pv = parcelRequire("9y2Pv");

var $gvKxh = parcelRequire("gvKxh");

var $OF96b = parcelRequire("OF96b");
// No name because it must not be turned off.
var $1b37a6bfd4b6aea3$var$content = {
    tokenize: $1b37a6bfd4b6aea3$var$tokenizeContent,
    resolve: $1b37a6bfd4b6aea3$var$resolveContent,
    interruptible: true,
    lazy: true
};
var $1b37a6bfd4b6aea3$var$continuationConstruct = {
    tokenize: $1b37a6bfd4b6aea3$var$tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function $1b37a6bfd4b6aea3$var$resolveContent(events) {
    $gvKxh(events);
    return events;
}
function $1b37a6bfd4b6aea3$var$tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if ($3GwUa(code)) return effects.check($1b37a6bfd4b6aea3$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous = previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        return data;
    }
}
function $1b37a6bfd4b6aea3$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $OF96b(effects, prefixed, "linePrefix");
    }
    function prefixed(code) {
        if (code === null || $3GwUa(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf("codeIndented") > -1 || $9y2Pv(self.events, "linePrefix") < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = $1b37a6bfd4b6aea3$var$content;

});
parcelRequire.register("9y2Pv", function(module, exports) {
"use strict";

var $k54gE = parcelRequire("k54gE");
function $6f397bf121e06749$var$prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return $k54gE(tail[2].sliceStream(tail[1]));
}
module.exports = $6f397bf121e06749$var$prefixSize;

});
parcelRequire.register("k54gE", function(module, exports) {
"use strict";
// Counts tabs based on their expanded size, and CR+LF as one character.
function $e9e795b3da4701f7$var$sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === "string" ? chunks[index].length : 1;
    return size;
}
module.exports = $e9e795b3da4701f7$var$sizeChunks;

});


parcelRequire.register("gvKxh", function(module, exports) {
"use strict";

var $3jpB0 = parcelRequire("3jpB0");

var $iMOj1 = parcelRequire("iMOj1");

var $k0SS8 = parcelRequire("k0SS8");
function $c053a3a601ae6d0e$var$subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                $3jpB0(jumps, $c053a3a601ae6d0e$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = $k0SS8(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                $iMOj1(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function $c053a3a601ae6d0e$var$subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === "enter") entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        $iMOj1(events, start, 2, slice);
    }
}
module.exports = $c053a3a601ae6d0e$var$subtokenize;

});
parcelRequire.register("iMOj1", function(module, exports) {
"use strict";

var $9RYN6 = parcelRequire("9RYN6");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function $dad3bb5f024951a0$var$chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        $9RYN6.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) $9RYN6.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            $9RYN6.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = $dad3bb5f024951a0$var$chunkedSplice;

});
parcelRequire.register("9RYN6", function(module, exports) {
"use strict";
var $72f8382349f3da85$var$splice = [].splice;
module.exports = $72f8382349f3da85$var$splice;

});


parcelRequire.register("k0SS8", function(module, exports) {
"use strict";

var $3jpB0 = parcelRequire("3jpB0");
function $e91e5f2d1ba92e70$var$shallow(object) {
    return $3jpB0({}, object);
}
module.exports = $e91e5f2d1ba92e70$var$shallow;

});




parcelRequire.register("1alUx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3jpB0 = parcelRequire("3jpB0");

var $k0SS8 = parcelRequire("k0SS8");
var $0d97b8a8987ecfb0$var$text = $0d97b8a8987ecfb0$var$initializeFactory("text");
var $0d97b8a8987ecfb0$var$string = $0d97b8a8987ecfb0$var$initializeFactory("string");
var $0d97b8a8987ecfb0$var$resolver = {
    resolveAll: $0d97b8a8987ecfb0$var$createResolver()
};
function $0d97b8a8987ecfb0$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $0d97b8a8987ecfb0$var$createResolver(field === "text" ? $0d97b8a8987ecfb0$var$resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function $0d97b8a8987ecfb0$var$createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function $0d97b8a8987ecfb0$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: $k0SS8(data.end)
            };
            data.end = $k0SS8(token.start);
            if (data.start.offset === data.end.offset) $3jpB0(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
module.exports.resolver = $0d97b8a8987ecfb0$var$resolver;
module.exports.string = $0d97b8a8987ecfb0$var$string;
module.exports.text = $0d97b8a8987ecfb0$var$text;

});

parcelRequire.register("6vS9E", function(module, exports) {
"use strict";

var $biIrQ = parcelRequire("biIrQ");

var $iMOj1 = parcelRequire("iMOj1");

var $h8pqp = parcelRequire("h8pqp");
function $4bdfa554c8643800$var$combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)$4bdfa554c8643800$var$extension(all, extensions[index]);
    return all;
}
function $4bdfa554c8643800$var$extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = $biIrQ.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = $4bdfa554c8643800$var$constructs($h8pqp(right[code]), $biIrQ.call(left, code) ? left[code] : []);
    }
}
function $4bdfa554c8643800$var$constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    $iMOj1(existing, 0, 0, before);
    return existing;
}
module.exports = $4bdfa554c8643800$var$combineExtensions;

});
parcelRequire.register("h8pqp", function(module, exports) {
"use strict";
function $c796e7e1ee410a02$var$miniflat(value) {
    return value === null || value === undefined ? [] : "length" in value ? value : [
        value
    ];
}
module.exports = $c796e7e1ee410a02$var$miniflat;

});


parcelRequire.register("gcBYk", function(module, exports) {
"use strict";

var $3jpB0 = parcelRequire("3jpB0");

var $3GwUa = parcelRequire("3GwUa");

var $zyGHS = parcelRequire("zyGHS");

var $iMOj1 = parcelRequire("iMOj1");

var $h8pqp = parcelRequire("h8pqp");

var $eNZlq = parcelRequire("eNZlq");

var $6i0T6 = parcelRequire("6i0T6");

var $k0SS8 = parcelRequire("k0SS8");

var $GoYQw = parcelRequire("GoYQw");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function $bcbb38ce97ede092$var$createTokenizer(parser, initialize, from) {
    var point = from ? $k0SS8(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = $zyGHS(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = $eNZlq(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return $6i0T6(sliceStream(token));
    }
    function sliceStream(token) {
        return $GoYQw(chunks, token);
    }
    function now() {
        return $k0SS8(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if ($3GwUa(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || "length" in constructs ? handleListOfConstructs($h8pqp(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ $h8pqp(constructs[code]).concat($h8pqp(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? $3jpB0({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) $iMOj1(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = $bcbb38ce97ede092$var$createTokenizer;

});
parcelRequire.register("zyGHS", function(module, exports) {
"use strict";

var $iMOj1 = parcelRequire("iMOj1");
function $06ae2d46fbea0a76$var$chunkedPush(list, items) {
    if (list.length) {
        $iMOj1(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = $06ae2d46fbea0a76$var$chunkedPush;

});

parcelRequire.register("eNZlq", function(module, exports) {
"use strict";
function $ac753a0cabd2d567$var$resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = $ac753a0cabd2d567$var$resolveAll;

});

parcelRequire.register("6i0T6", function(module, exports) {
"use strict";

var $aSUwF = parcelRequire("aSUwF");
function $49451cd3b4db6905$var$serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === "string") value = chunk;
        else if (chunk === -5) value = "\r";
        else if (chunk === -4) value = "\n";
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = "	";
        else if (chunk === -1) {
            if (atTab) continue;
            value = " ";
        } else // Currently only replacement character.
        value = $aSUwF(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}
module.exports = $49451cd3b4db6905$var$serializeChunks;

});

parcelRequire.register("GoYQw", function(module, exports) {
"use strict";
function $07f74cf16d02aaeb$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = $07f74cf16d02aaeb$var$sliceChunks;

});


parcelRequire.register("bZwLW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1alUx = parcelRequire("1alUx");

var $4Wfbw = parcelRequire("4Wfbw");

var $3f5vp = parcelRequire("3f5vp");

var $5WBMP = parcelRequire("5WBMP");

var $jR86j = parcelRequire("jR86j");

var $l9HkF = parcelRequire("l9HkF");

var $6cCyk = parcelRequire("6cCyk");

var $j1bqw = parcelRequire("j1bqw");

var $kji0u = parcelRequire("kji0u");

var $e4Hqf = parcelRequire("e4Hqf");

var $5yaAL = parcelRequire("5yaAL");

var $khX7c = parcelRequire("khX7c");

var $jA01T = parcelRequire("jA01T");

var $ctktm = parcelRequire("ctktm");

var $OZ435 = parcelRequire("OZ435");

var $cbaIW = parcelRequire("cbaIW");

var $e7Pqx = parcelRequire("e7Pqx");

var $hhIqw = parcelRequire("hhIqw");

var $kSHLi = parcelRequire("kSHLi");

var $6tqBN = parcelRequire("6tqBN");

var $13BuS = parcelRequire("13BuS");
var $8baed0160afa2e1d$var$document = {
    42: $kSHLi,
    // Asterisk
    43: $kSHLi,
    // Plus sign
    45: $kSHLi,
    // Dash
    48: $kSHLi,
    // 0
    49: $kSHLi,
    // 1
    50: $kSHLi,
    // 2
    51: $kSHLi,
    // 3
    52: $kSHLi,
    // 4
    53: $kSHLi,
    // 5
    54: $kSHLi,
    // 6
    55: $kSHLi,
    // 7
    56: $kSHLi,
    // 8
    57: $kSHLi,
    // 9
    62: $5WBMP // Greater than
};
var $8baed0160afa2e1d$var$contentInitial = {
    91: $e4Hqf // Left square bracket
};
var $8baed0160afa2e1d$var$flowInitial = {
    "-2": $j1bqw,
    // Horizontal tab
    "-1": $j1bqw,
    // Virtual space
    32: $j1bqw // Space
};
var $8baed0160afa2e1d$var$flow = {
    35: $khX7c,
    // Number sign
    42: $13BuS,
    // Asterisk
    45: [
        $6tqBN,
        $13BuS
    ],
    // Dash
    60: $jA01T,
    // Less than
    61: $6tqBN,
    // Equals to
    95: $13BuS,
    // Underscore
    96: $6cCyk,
    // Grave accent
    126: $6cCyk // Tilde
};
var $8baed0160afa2e1d$var$string = {
    38: $l9HkF,
    // Ampersand
    92: $jR86j // Backslash
};
var $8baed0160afa2e1d$var$text = {
    "-5": $hhIqw,
    // Carriage return
    "-4": $hhIqw,
    // Line feed
    "-3": $hhIqw,
    // Carriage return + line feed
    33: $cbaIW,
    // Exclamation mark
    38: $l9HkF,
    // Ampersand
    42: $4Wfbw,
    // Asterisk
    60: [
        $3f5vp,
        $ctktm
    ],
    // Less than
    91: $e7Pqx,
    // Left square bracket
    92: [
        $5yaAL,
        $jR86j
    ],
    // Backslash
    93: $OZ435,
    // Right square bracket
    95: $4Wfbw,
    // Underscore
    96: $kji0u // Grave accent
};
var $8baed0160afa2e1d$var$insideSpan = {
    null: [
        $4Wfbw,
        $1alUx.resolver
    ]
};
var $8baed0160afa2e1d$var$disable = {
    null: []
};
module.exports.contentInitial = $8baed0160afa2e1d$var$contentInitial;
module.exports.disable = $8baed0160afa2e1d$var$disable;
module.exports.document = $8baed0160afa2e1d$var$document;
module.exports.flow = $8baed0160afa2e1d$var$flow;
module.exports.flowInitial = $8baed0160afa2e1d$var$flowInitial;
module.exports.insideSpan = $8baed0160afa2e1d$var$insideSpan;
module.exports.string = $8baed0160afa2e1d$var$string;
module.exports.text = $8baed0160afa2e1d$var$text;

});
parcelRequire.register("4Wfbw", function(module, exports) {
"use strict";

var $zyGHS = parcelRequire("zyGHS");

var $iMOj1 = parcelRequire("iMOj1");

var $1UXLM = parcelRequire("1UXLM");

var $kdYSv = parcelRequire("kdYSv");

var $eNZlq = parcelRequire("eNZlq");

var $k0SS8 = parcelRequire("k0SS8");
var $39885b9a14a704c9$var$attention = {
    name: "attention",
    tokenize: $39885b9a14a704c9$var$tokenizeAttention,
    resolveAll: $39885b9a14a704c9$var$resolveAllAttention
};
function $39885b9a14a704c9$var$resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: $kdYSv($k0SS8(events[open][1].end), -use),
                end: $k0SS8(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: $k0SS8(events[index][1].start),
                end: $kdYSv($k0SS8(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: $k0SS8(events[open][1].end),
                end: $k0SS8(events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: $k0SS8(openingSequence.start),
                end: $k0SS8(closingSequence.end)
            };
            events[open][1].end = $k0SS8(openingSequence.start);
            events[index][1].start = $k0SS8(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = $zyGHS(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = $zyGHS(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = $zyGHS(nextEvents, $eNZlq(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = $zyGHS(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = $zyGHS(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            $iMOj1(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
function $39885b9a14a704c9$var$tokenizeAttention(effects, ok) {
    var before = $1UXLM(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter("attentionSequence");
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit("attentionSequence");
        after = $1UXLM(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = $39885b9a14a704c9$var$attention;

});
parcelRequire.register("1UXLM", function(module, exports) {
"use strict";

var $izI1r = parcelRequire("izI1r");

var $1mZmj = parcelRequire("1mZmj");

var $ahXis = parcelRequire("ahXis");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function $16596268f2aee54f$var$classifyCharacter(code) {
    if (code === null || $izI1r(code) || $ahXis(code)) return 1;
    if ($1mZmj(code)) return 2;
}
module.exports = $16596268f2aee54f$var$classifyCharacter;

});
parcelRequire.register("izI1r", function(module, exports) {
"use strict";
function $d85da4c3cef0bfb7$var$markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = $d85da4c3cef0bfb7$var$markdownLineEndingOrSpace;

});

parcelRequire.register("1mZmj", function(module, exports) {
"use strict";

var $7PMiV = parcelRequire("7PMiV");

var $jjKbU = parcelRequire("jjKbU");
// In fact adds to the bundle size.
var $0ff7712058d077f5$var$unicodePunctuation = $jjKbU($7PMiV);
module.exports = $0ff7712058d077f5$var$unicodePunctuation;

});
parcelRequire.register("7PMiV", function(module, exports) {
"use strict";
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var $5b42c40e031bee47$var$unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = $5b42c40e031bee47$var$unicodePunctuation;

});

parcelRequire.register("jjKbU", function(module, exports) {
"use strict";

var $aSUwF = parcelRequire("aSUwF");
function $e1039f3bb1b009b6$var$regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test($aSUwF(code));
    }
}
module.exports = $e1039f3bb1b009b6$var$regexCheck;

});


parcelRequire.register("ahXis", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $77d97d03517d11f7$var$unicodeWhitespace = $jjKbU(/\s/);
module.exports = $77d97d03517d11f7$var$unicodeWhitespace;

});


parcelRequire.register("kdYSv", function(module, exports) {
"use strict";
// chunks (replacement characters, tabs, or line endings).
function $eb943eaab19f1fe3$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = $eb943eaab19f1fe3$var$movePoint;

});


parcelRequire.register("3f5vp", function(module, exports) {
"use strict";

var $bk6wI = parcelRequire("bk6wI");

var $g8Xxu = parcelRequire("g8Xxu");

var $gRTPZ = parcelRequire("gRTPZ");

var $cGpei = parcelRequire("cGpei");
var $25c70b1c3b5f03cb$var$autolink = {
    name: "autolink",
    tokenize: $25c70b1c3b5f03cb$var$tokenizeAutolink
};
function $25c70b1c3b5f03cb$var$tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    function open(code) {
        if ($bk6wI(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return $gRTPZ(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || $g8Xxu(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || $g8Xxu(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            return end(code);
        }
        if (code === 32 || code === 60 || $cGpei(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ($gRTPZ(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return $g8Xxu(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || $g8Xxu(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.exit("autolink");
        return ok;
    }
}
module.exports = $25c70b1c3b5f03cb$var$autolink;

});
parcelRequire.register("bk6wI", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $83e6a00791783ee9$var$asciiAlpha = $jjKbU(/[A-Za-z]/);
module.exports = $83e6a00791783ee9$var$asciiAlpha;

});

parcelRequire.register("g8Xxu", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $bc0b93f4da1b1894$var$asciiAlphanumeric = $jjKbU(/[\dA-Za-z]/);
module.exports = $bc0b93f4da1b1894$var$asciiAlphanumeric;

});

parcelRequire.register("gRTPZ", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $c47ce8c3c9aea2b5$var$asciiAtext = $jjKbU(/[#-'*+\--9=?A-Z^-~]/);
module.exports = $c47ce8c3c9aea2b5$var$asciiAtext;

});

parcelRequire.register("cGpei", function(module, exports) {
"use strict";
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function $93bcfa574042161e$var$asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = $93bcfa574042161e$var$asciiControl;

});


parcelRequire.register("5WBMP", function(module, exports) {
"use strict";

var $9faMf = parcelRequire("9faMf");

var $OF96b = parcelRequire("OF96b");
var $453fae253f4be57f$var$blockQuote = {
    name: "blockQuote",
    tokenize: $453fae253f4be57f$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $453fae253f4be57f$var$tokenizeBlockQuoteContinuation
    },
    exit: $453fae253f4be57f$var$exit
};
function $453fae253f4be57f$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if ($9faMf(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
function $453fae253f4be57f$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return $OF96b(effects, effects.attempt($453fae253f4be57f$var$blockQuote, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
function $453fae253f4be57f$var$exit(effects) {
    effects.exit("blockQuote");
}
module.exports = $453fae253f4be57f$var$blockQuote;

});

parcelRequire.register("jR86j", function(module, exports) {
"use strict";

var $jxOac = parcelRequire("jxOac");
var $e749403382b0df08$var$characterEscape = {
    name: "characterEscape",
    tokenize: $e749403382b0df08$var$tokenizeCharacterEscape
};
function $e749403382b0df08$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return open;
    }
    function open(code) {
        if ($jxOac(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $e749403382b0df08$var$characterEscape;

});
parcelRequire.register("jxOac", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $e3a802d62b41aa8b$var$asciiPunctuation = $jjKbU(/[!-/:-@[-`{-~]/);
module.exports = $e3a802d62b41aa8b$var$asciiPunctuation;

});


parcelRequire.register("l9HkF", function(module, exports) {
"use strict";

var $69Z2v = parcelRequire("69Z2v");

var $g8Xxu = parcelRequire("g8Xxu");

var $3Bzs5 = parcelRequire("3Bzs5");

var $28LoP = parcelRequire("28LoP");
function $f66c0d240b033b8b$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        default: e
    };
}
var $f66c0d240b033b8b$var$decodeEntity__default = /*#__PURE__*/ $f66c0d240b033b8b$var$_interopDefaultLegacy($69Z2v);
var $f66c0d240b033b8b$var$characterReference = {
    name: "characterReference",
    tokenize: $f66c0d240b033b8b$var$tokenizeCharacterReference
};
function $f66c0d240b033b8b$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = $g8Xxu;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = $28LoP;
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = $3Bzs5;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit("characterReferenceValue");
            if (test === $g8Xxu && !$f66c0d240b033b8b$var$decodeEntity__default["default"](self.sliceSerialize(token))) return nok(code);
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = $f66c0d240b033b8b$var$characterReference;

});
parcelRequire.register("69Z2v", function(module, exports) {
"use strict";
/* eslint-env browser */ var $47c2ee7a3e42e9c9$var$el;
var $47c2ee7a3e42e9c9$var$semicolon = 59 //  ';'
;
module.exports = $47c2ee7a3e42e9c9$var$decodeEntity;
function $47c2ee7a3e42e9c9$var$decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    $47c2ee7a3e42e9c9$var$el = $47c2ee7a3e42e9c9$var$el || document.createElement("i");
    $47c2ee7a3e42e9c9$var$el.innerHTML = entity;
    char = $47c2ee7a3e42e9c9$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $47c2ee7a3e42e9c9$var$semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});

parcelRequire.register("3Bzs5", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $2a0053d221194060$var$asciiDigit = $jjKbU(/\d/);
module.exports = $2a0053d221194060$var$asciiDigit;

});

parcelRequire.register("28LoP", function(module, exports) {
"use strict";

var $jjKbU = parcelRequire("jjKbU");
var $18f118aaeb1db211$var$asciiHexDigit = $jjKbU(/[\dA-Fa-f]/);
module.exports = $18f118aaeb1db211$var$asciiHexDigit;

});


parcelRequire.register("6cCyk", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $izI1r = parcelRequire("izI1r");

var $9y2Pv = parcelRequire("9y2Pv");

var $OF96b = parcelRequire("OF96b");
var $4841c4d0b96e011f$var$codeFenced = {
    name: "codeFenced",
    tokenize: $4841c4d0b96e011f$var$tokenizeCodeFenced,
    concrete: true
};
function $4841c4d0b96e011f$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = $9y2Pv(this.events, "linePrefix");
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeFencedFenceSequence");
        return sizeOpen < 3 ? nok(code) : $OF96b(effects, infoOpen, "whitespace")(code);
    }
    function infoOpen(code) {
        if (code === null || $3GwUa(code)) return openAfter(code);
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    function info(code) {
        if (code === null || $izI1r(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return $OF96b(effects, infoAfter, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || $3GwUa(code)) return openAfter(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || $3GwUa(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit("codeFencedFence");
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? $OF96b(effects, content, "linePrefix", initialPrefix + 1) : content);
        }
        effects.enter("codeFlowValue");
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || $3GwUa(code)) {
            effects.exit("codeFlowValue");
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return $OF96b(effects, closingSequenceStart, "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter("codeFencedFence");
            effects.enter("codeFencedFenceSequence");
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit("codeFencedFenceSequence");
            return $OF96b(effects, closingSequenceEnd, "whitespace")(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || $3GwUa(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = $4841c4d0b96e011f$var$codeFenced;

});

parcelRequire.register("j1bqw", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $iMOj1 = parcelRequire("iMOj1");

var $9y2Pv = parcelRequire("9y2Pv");

var $OF96b = parcelRequire("OF96b");
var $dd86f972ec02a462$var$codeIndented = {
    name: "codeIndented",
    tokenize: $dd86f972ec02a462$var$tokenizeCodeIndented,
    resolve: $dd86f972ec02a462$var$resolveCodeIndented
};
var $dd86f972ec02a462$var$indentedContentConstruct = {
    tokenize: $dd86f972ec02a462$var$tokenizeIndentedContent,
    partial: true
};
function $dd86f972ec02a462$var$resolveCodeIndented(events, context) {
    var code = {
        type: "codeIndented",
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    $iMOj1(events, 0, 0, [
        [
            "enter",
            code,
            context
        ]
    ]);
    $iMOj1(events, events.length, 0, [
        [
            "exit",
            code,
            context
        ]
    ]);
    return events;
}
function $dd86f972ec02a462$var$tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt($dd86f972ec02a462$var$indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if ($3GwUa(code)) return effects.attempt($dd86f972ec02a462$var$indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter("codeFlowValue");
        return content(code);
    }
    function content(code) {
        if (code === null || $3GwUa(code)) {
            effects.exit("codeFlowValue");
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function $dd86f972ec02a462$var$tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return $OF96b(effects, afterPrefix, "linePrefix", 5);
    function afterPrefix(code) {
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return $OF96b(effects, afterPrefix, "linePrefix", 5);
        }
        return $9y2Pv(self.events, "linePrefix") < 4 ? nok(code) : ok(code);
    }
}
module.exports = $dd86f972ec02a462$var$codeIndented;

});

parcelRequire.register("kji0u", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");
var $ec938cce51f557ea$var$codeText = {
    name: "codeText",
    tokenize: $ec938cce51f557ea$var$tokenizeCodeText,
    resolve: $ec938cce51f557ea$var$resolveCodeText,
    previous: $ec938cce51f557ea$var$previous
};
function $ec938cce51f557ea$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function $ec938cce51f557ea$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function $ec938cce51f557ea$var$tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit("codeTextSequence");
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return gap;
        }
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return gap;
        } // Data.
        effects.enter("codeTextData");
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || $3GwUa(code)) {
            effects.exit("codeTextData");
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        } // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}
module.exports = $ec938cce51f557ea$var$codeText;

});

parcelRequire.register("e4Hqf", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $izI1r = parcelRequire("izI1r");

var $6eyVN = parcelRequire("6eyVN");

var $imGwn = parcelRequire("imGwn");

var $ccze7 = parcelRequire("ccze7");

var $OF96b = parcelRequire("OF96b");

var $2Wi9v = parcelRequire("2Wi9v");

var $24i5N = parcelRequire("24i5N");
var $a3f31f324dac4675$var$definition = {
    name: "definition",
    tokenize: $a3f31f324dac4675$var$tokenizeDefinition
};
var $a3f31f324dac4675$var$titleConstruct = {
    tokenize: $a3f31f324dac4675$var$tokenizeTitle,
    partial: true
};
function $a3f31f324dac4675$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter("definition");
        return $ccze7.call(self, effects, labelAfter, nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    function labelAfter(code) {
        identifier = $6eyVN(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker") // Note: blank lines can’t exist in content.
            ;
            return $2Wi9v(effects, $imGwn(effects, effects.attempt($a3f31f324dac4675$var$titleConstruct, $OF96b(effects, after, "whitespace"), $OF96b(effects, after, "whitespace")), nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString"));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || $3GwUa(code)) {
            effects.exit("definition");
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function $a3f31f324dac4675$var$tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return $izI1r(code) ? $2Wi9v(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return $24i5N(effects, $OF96b(effects, after, "whitespace"), nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
        return nok(code);
    }
    function after(code) {
        return code === null || $3GwUa(code) ? ok(code) : nok(code);
    }
}
module.exports = $a3f31f324dac4675$var$definition;

});
parcelRequire.register("imGwn", function(module, exports) {
"use strict";

var $cGpei = parcelRequire("cGpei");

var $izI1r = parcelRequire("izI1r");

var $3GwUa = parcelRequire("3GwUa");
// eslint-disable-next-line max-params
function $d5eb43ea1b4bcb32$var$destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if ($cGpei(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || $3GwUa(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit("chunkString");
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || $izI1r(code)) {
            if (balance) return nok(code);
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ($cGpei(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = $d5eb43ea1b4bcb32$var$destinationFactory;

});

parcelRequire.register("ccze7", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $9faMf = parcelRequire("9faMf");
// eslint-disable-next-line max-params
function $8e21ee509b5c9c5c$var$labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || $3GwUa(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !$9faMf(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = $8e21ee509b5c9c5c$var$labelFactory;

});

parcelRequire.register("2Wi9v", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $9faMf = parcelRequire("9faMf");

var $OF96b = parcelRequire("OF96b");
function $223f143d10617b54$var$whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ($9faMf(code)) return $OF96b(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}
module.exports = $223f143d10617b54$var$whitespaceFactory;

});

parcelRequire.register("24i5N", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $OF96b = parcelRequire("OF96b");
function $1819fd4de486b824$var$titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return $OF96b(effects, atTitleBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || $3GwUa(code)) {
            effects.exit("chunkString");
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = $1819fd4de486b824$var$titleFactory;

});


parcelRequire.register("5yaAL", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");
var $40a8580f264eb07f$var$hardBreakEscape = {
    name: "hardBreakEscape",
    tokenize: $40a8580f264eb07f$var$tokenizeHardBreakEscape
};
function $40a8580f264eb07f$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("hardBreakEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if ($3GwUa(code)) {
            effects.exit("escapeMarker");
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $40a8580f264eb07f$var$hardBreakEscape;

});

parcelRequire.register("khX7c", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $izI1r = parcelRequire("izI1r");

var $9faMf = parcelRequire("9faMf");

var $iMOj1 = parcelRequire("iMOj1");

var $OF96b = parcelRequire("OF96b");
var $ec5340361917adf9$var$headingAtx = {
    name: "headingAtx",
    tokenize: $ec5340361917adf9$var$tokenizeHeadingAtx,
    resolve: $ec5340361917adf9$var$resolveHeadingAtx
};
function $ec5340361917adf9$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        $iMOj1(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
function $ec5340361917adf9$var$tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter("atxHeading");
        effects.enter("atxHeadingSequence");
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || $izI1r(code)) {
            effects.exit("atxHeadingSequence");
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequence(code);
        }
        if (code === null || $3GwUa(code)) {
            effects.exit("atxHeading");
            return ok(code);
        }
        if ($9faMf(code)) return $OF96b(effects, headingBreak, "whitespace")(code);
        effects.enter("atxHeadingText");
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit("atxHeadingSequence");
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || $izI1r(code)) {
            effects.exit("atxHeadingText");
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = $ec5340361917adf9$var$headingAtx;

});

parcelRequire.register("jA01T", function(module, exports) {
"use strict";

var $bk6wI = parcelRequire("bk6wI");

var $g8Xxu = parcelRequire("g8Xxu");

var $3GwUa = parcelRequire("3GwUa");

var $izI1r = parcelRequire("izI1r");

var $9faMf = parcelRequire("9faMf");

var $aSUwF = parcelRequire("aSUwF");

var $e9Z35 = parcelRequire("e9Z35");

var $2YFgn = parcelRequire("2YFgn");

var $l8l9z = parcelRequire("l8l9z");
var $e41166fe8fbfd37d$var$htmlFlow = {
    name: "htmlFlow",
    tokenize: $e41166fe8fbfd37d$var$tokenizeHtmlFlow,
    resolveTo: $e41166fe8fbfd37d$var$resolveToHtmlFlow,
    concrete: true
};
var $e41166fe8fbfd37d$var$nextBlankConstruct = {
    tokenize: $e41166fe8fbfd37d$var$tokenizeNextBlank,
    partial: true
};
function $e41166fe8fbfd37d$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function $e41166fe8fbfd37d$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ($bk6wI(code)) {
            effects.consume(code);
            buffer = $aSUwF(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = "CDATA[";
            index = 0;
            return cdataOpenInside;
        }
        if ($bk6wI(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if ($bk6wI(code)) {
            effects.consume(code);
            buffer = $aSUwF(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || $izI1r(code)) {
            if (code !== 47 && startTag && $2YFgn.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ($e9Z35.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || $g8Xxu(code)) {
            effects.consume(code);
            buffer += $aSUwF(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if ($9faMf(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || $bk6wI(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $g8Xxu(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || $3GwUa(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || $izI1r(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || $9faMf(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if ($9faMf(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || $3GwUa(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ($3GwUa(code) && (kind === 6 || kind === 7)) return effects.check($e41166fe8fbfd37d$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || $3GwUa(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit("htmlFlowData");
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ($3GwUa(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return htmlContinueStart;
        }
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && $2YFgn.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if ($bk6wI(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += $aSUwF(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || $3GwUa(code)) {
            effects.exit("htmlFlowData");
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit("htmlFlow");
        return ok(code);
    }
}
function $e41166fe8fbfd37d$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit("htmlFlowData");
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        return effects.attempt($l8l9z, ok, nok);
    }
}
module.exports = $e41166fe8fbfd37d$var$htmlFlow;

});
parcelRequire.register("e9Z35", function(module, exports) {
"use strict";
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $a4f142fc3e273b17$var$basics = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
module.exports = $a4f142fc3e273b17$var$basics;

});

parcelRequire.register("2YFgn", function(module, exports) {
"use strict";
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $22b13162972add9d$var$raws = [
    "pre",
    "script",
    "style",
    "textarea"
];
module.exports = $22b13162972add9d$var$raws;

});


parcelRequire.register("ctktm", function(module, exports) {
"use strict";

var $bk6wI = parcelRequire("bk6wI");

var $g8Xxu = parcelRequire("g8Xxu");

var $3GwUa = parcelRequire("3GwUa");

var $izI1r = parcelRequire("izI1r");

var $9faMf = parcelRequire("9faMf");

var $OF96b = parcelRequire("OF96b");
var $914812ea11859eda$var$htmlText = {
    name: "htmlText",
    tokenize: $914812ea11859eda$var$tokenizeHtmlText
};
function $914812ea11859eda$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ($bk6wI(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = "CDATA[";
            index = 0;
            return cdataOpen;
        }
        if ($bk6wI(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ($3GwUa(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ($3GwUa(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ($3GwUa(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ($3GwUa(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if ($bk6wI(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || $g8Xxu(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if ($3GwUa(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || $g8Xxu(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || $izI1r(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || $bk6wI(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ($3GwUa(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $g8Xxu(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ($3GwUa(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ($3GwUa(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ($9faMf(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ($3GwUa(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || $izI1r(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || $izI1r(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $OF96b(effects, afterPrefix, "linePrefix", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $914812ea11859eda$var$htmlText;

});

parcelRequire.register("OZ435", function(module, exports) {
"use strict";

var $izI1r = parcelRequire("izI1r");

var $zyGHS = parcelRequire("zyGHS");

var $iMOj1 = parcelRequire("iMOj1");

var $6eyVN = parcelRequire("6eyVN");

var $eNZlq = parcelRequire("eNZlq");

var $k0SS8 = parcelRequire("k0SS8");

var $imGwn = parcelRequire("imGwn");

var $ccze7 = parcelRequire("ccze7");

var $24i5N = parcelRequire("24i5N");

var $2Wi9v = parcelRequire("2Wi9v");
var $099409b9b36cd74f$var$labelEnd = {
    name: "labelEnd",
    tokenize: $099409b9b36cd74f$var$tokenizeLabelEnd,
    resolveTo: $099409b9b36cd74f$var$resolveToLabelEnd,
    resolveAll: $099409b9b36cd74f$var$resolveAllLabelEnd
};
var $099409b9b36cd74f$var$resourceConstruct = {
    tokenize: $099409b9b36cd74f$var$tokenizeResource
};
var $099409b9b36cd74f$var$fullReferenceConstruct = {
    tokenize: $099409b9b36cd74f$var$tokenizeFullReference
};
var $099409b9b36cd74f$var$collapsedReferenceConstruct = {
    tokenize: $099409b9b36cd74f$var$tokenizeCollapsedReference
};
function $099409b9b36cd74f$var$resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd")) {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
function $099409b9b36cd74f$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: $k0SS8(events[open][1].start),
        end: $k0SS8(events[events.length - 1][1].end)
    };
    label = {
        type: "label",
        start: $k0SS8(events[open][1].start),
        end: $k0SS8(events[close][1].end)
    };
    text = {
        type: "labelText",
        start: $k0SS8(events[open + offset + 2][1].end),
        end: $k0SS8(events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = $zyGHS(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = $zyGHS(media, [
        [
            "enter",
            text,
            context
        ]
    ]) // Between.
    ;
    media = $zyGHS(media, $eNZlq(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = $zyGHS(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = $zyGHS(media, events.slice(close + 1)) // Media close.
    ;
    media = $zyGHS(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    $iMOj1(events, open, events.length, media);
    return events;
}
function $099409b9b36cd74f$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf($6eyVN(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($099409b9b36cd74f$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($099409b9b36cd74f$var$fullReferenceConstruct, ok, defined ? effects.attempt($099409b9b36cd74f$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function $099409b9b36cd74f$var$tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return $2Wi9v(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return $imGwn(effects, destinationAfter, nok, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 3)(code);
    }
    function destinationAfter(code) {
        return $izI1r(code) ? $2Wi9v(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return $24i5N(effects, $2Wi9v(effects, end), nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
function $099409b9b36cd74f$var$tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return $ccze7.call(self, effects, afterLabel, nok, "reference", "referenceMarker", "referenceString")(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf($6eyVN(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function $099409b9b36cd74f$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $099409b9b36cd74f$var$labelEnd;

});

parcelRequire.register("cbaIW", function(module, exports) {
"use strict";

var $OZ435 = parcelRequire("OZ435");
var $8dded4a0e82a309a$var$labelStartImage = {
    name: "labelStartImage",
    tokenize: $8dded4a0e82a309a$var$tokenizeLabelStartImage,
    resolveAll: $OZ435.resolveAll
};
function $8dded4a0e82a309a$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $8dded4a0e82a309a$var$labelStartImage;

});

parcelRequire.register("e7Pqx", function(module, exports) {
"use strict";

var $OZ435 = parcelRequire("OZ435");
var $a4899c7e4d8f6a1e$var$labelStartLink = {
    name: "labelStartLink",
    tokenize: $a4899c7e4d8f6a1e$var$tokenizeLabelStartLink,
    resolveAll: $OZ435.resolveAll
};
function $a4899c7e4d8f6a1e$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $a4899c7e4d8f6a1e$var$labelStartLink;

});

parcelRequire.register("hhIqw", function(module, exports) {
"use strict";

var $OF96b = parcelRequire("OF96b");
var $c9567c711e9c244e$var$lineEnding = {
    name: "lineEnding",
    tokenize: $c9567c711e9c244e$var$tokenizeLineEnding
};
function $c9567c711e9c244e$var$tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $OF96b(effects, ok, "linePrefix");
    }
}
module.exports = $c9567c711e9c244e$var$lineEnding;

});

parcelRequire.register("kSHLi", function(module, exports) {
"use strict";

var $3Bzs5 = parcelRequire("3Bzs5");

var $9faMf = parcelRequire("9faMf");

var $9y2Pv = parcelRequire("9y2Pv");

var $k54gE = parcelRequire("k54gE");

var $OF96b = parcelRequire("OF96b");

var $l8l9z = parcelRequire("l8l9z");

var $13BuS = parcelRequire("13BuS");
var $f33acc00bf66532f$var$list = {
    name: "list",
    tokenize: $f33acc00bf66532f$var$tokenizeListStart,
    continuation: {
        tokenize: $f33acc00bf66532f$var$tokenizeListContinuation
    },
    exit: $f33acc00bf66532f$var$tokenizeListEnd
};
var $f33acc00bf66532f$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $f33acc00bf66532f$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
var $f33acc00bf66532f$var$indentConstruct = {
    tokenize: $f33acc00bf66532f$var$tokenizeIndent,
    partial: true
};
function $f33acc00bf66532f$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = $9y2Pv(self.events, "linePrefix");
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : $3Bzs5(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check($13BuS, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if ($3Bzs5(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check($l8l9z, self.interrupt ? nok : onBlank, effects.attempt($f33acc00bf66532f$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if ($9faMf(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + $k54gE(self.sliceStream(effects.exit("listItemPrefix")));
        return ok(code);
    }
}
function $f33acc00bf66532f$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check($l8l9z, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return $OF96b(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !$9faMf(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt($f33acc00bf66532f$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return $OF96b(effects, effects.attempt($f33acc00bf66532f$var$list, ok, nok), "linePrefix", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4)(code);
    }
}
function $f33acc00bf66532f$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return $OF96b(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    function afterPrefix(code) {
        return $9y2Pv(self.events, "listItemIndent") === self.containerState.size ? ok(code) : nok(code);
    }
}
function $f33acc00bf66532f$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function $f33acc00bf66532f$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return $OF96b(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 5);
    function afterPrefix(code) {
        return $9faMf(code) || !$9y2Pv(self.events, "listItemPrefixWhitespace") ? nok(code) : ok(code);
    }
}
module.exports = $f33acc00bf66532f$var$list;

});
parcelRequire.register("13BuS", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $9faMf = parcelRequire("9faMf");

var $OF96b = parcelRequire("OF96b");
var $0c53285e6c9bd15d$var$thematicBreak = {
    name: "thematicBreak",
    tokenize: $0c53285e6c9bd15d$var$tokenizeThematicBreak
};
function $0c53285e6c9bd15d$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter("thematicBreak");
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if ($9faMf(code)) return $OF96b(effects, atBreak, "whitespace")(code);
        if (size < 3 || code !== null && !$3GwUa(code)) return nok(code);
        effects.exit("thematicBreak");
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return atBreak(code);
    }
}
module.exports = $0c53285e6c9bd15d$var$thematicBreak;

});


parcelRequire.register("6tqBN", function(module, exports) {
"use strict";

var $3GwUa = parcelRequire("3GwUa");

var $k0SS8 = parcelRequire("k0SS8");

var $OF96b = parcelRequire("OF96b");
var $4b6a1768f1426e42$var$setextUnderline = {
    name: "setextUnderline",
    tokenize: $4b6a1768f1426e42$var$tokenizeSetextUnderline,
    resolveTo: $4b6a1768f1426e42$var$resolveToSetextUnderline
};
function $4b6a1768f1426e42$var$resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    heading = {
        type: "setextHeading",
        start: $k0SS8(events[text][1].start),
        end: $k0SS8(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = "setextHeadingText" // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = $k0SS8(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
function $4b6a1768f1426e42$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
        paragraph = self.events[index][1].type === "paragraph";
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            effects.enter("setextHeadingLineSequence");
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit("setextHeadingLineSequence");
        return $OF96b(effects, closingSequenceEnd, "lineSuffix")(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || $3GwUa(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $4b6a1768f1426e42$var$setextUnderline;

});



parcelRequire.register("7vWfy", function(module, exports) {
"use strict";
var $57889ce201e03cff$var$search = /[\0\t\n\r]/g;
function $57889ce201e03cff$var$preprocess() {
    var start = true;
    var column = 1;
    var buffer = "";
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $57889ce201e03cff$var$search.lastIndex = startPosition;
            match = $57889ce201e03cff$var$search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = $57889ce201e03cff$var$preprocess;

});

parcelRequire.register("04tjI", function(module, exports) {
"use strict";

var $gvKxh = parcelRequire("gvKxh");
function $00d71d8fd1665314$var$postprocess(events) {
    while(!$gvKxh(events));
    return events;
}
module.exports = $00d71d8fd1665314$var$postprocess;

});


parcelRequire.register("6M2CY", function(module, exports) {
"use strict";
module.exports = $4ee9438bf3c5f01c$var$toHast;

var $bkaaE = parcelRequire("bkaaE");

var $2O0C6 = parcelRequire("2O0C6");

var $ikNMt = parcelRequire("ikNMt");

var $ctNAf = parcelRequire("ctNAf");

var $6lqSu = parcelRequire("6lqSu");

var $bFRmC = parcelRequire("bFRmC");

var $he7iZ = parcelRequire("he7iZ");

var $8oCnI = parcelRequire("8oCnI");
var $4ee9438bf3c5f01c$var$own = {}.hasOwnProperty;
var $4ee9438bf3c5f01c$var$deprecationWarningIssued = false;
// Factory to transform.
function $4ee9438bf3c5f01c$var$factory(tree, options) {
    var settings = options || {};
    // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
    if (settings.allowDangerousHTML !== undefined && !$4ee9438bf3c5f01c$var$deprecationWarningIssued) {
        $4ee9438bf3c5f01c$var$deprecationWarningIssued = true;
        console.warn("mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead");
    }
    var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = $6lqSu(tree);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = Object.assign({}, $8oCnI, settings.handlers);
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    $2O0C6(tree, "footnoteDefinition", onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && left.data) {
            data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = Object.assign({}, right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!$ctNAf(ctx)) right.position = {
            start: $ikNMt.start(ctx),
            end: $ikNMt.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === "object" && "length" in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$4ee9438bf3c5f01c$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function $4ee9438bf3c5f01c$var$toHast(tree, options) {
    var h = $4ee9438bf3c5f01c$var$factory(tree, options);
    var node = $bFRmC(h, tree);
    var foot = $he7iZ(h);
    if (foot) node.children = node.children.concat($bkaaE("text", "\n"), foot);
    return node;
}

});
parcelRequire.register("bkaaE", function(module, exports) {
"use strict";
module.exports = $83e973a6880ea5cf$var$u;
function $83e973a6880ea5cf$var$u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== "object" || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = Object.assign({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

});

parcelRequire.register("2O0C6", function(module, exports) {
"use strict";
module.exports = $20b0ba20e3e0d779$var$visit;

var $vsUtm = parcelRequire("vsUtm");
var $20b0ba20e3e0d779$var$CONTINUE = $vsUtm.CONTINUE;
var $20b0ba20e3e0d779$var$SKIP = $vsUtm.SKIP;
var $20b0ba20e3e0d779$var$EXIT = $vsUtm.EXIT;
$20b0ba20e3e0d779$var$visit.CONTINUE = $20b0ba20e3e0d779$var$CONTINUE;
$20b0ba20e3e0d779$var$visit.SKIP = $20b0ba20e3e0d779$var$SKIP;
$20b0ba20e3e0d779$var$visit.EXIT = $20b0ba20e3e0d779$var$EXIT;
function $20b0ba20e3e0d779$var$visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $vsUtm(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRequire.register("vsUtm", function(module, exports) {
"use strict";
module.exports = $05e952424405f82e$var$visitParents;

var $7MLLw = parcelRequire("7MLLw");

var $gHPe8 = parcelRequire("gHPe8");
var $05e952424405f82e$var$CONTINUE = true;
var $05e952424405f82e$var$SKIP = "skip";
var $05e952424405f82e$var$EXIT = false;
$05e952424405f82e$var$visitParents.CONTINUE = $05e952424405f82e$var$CONTINUE;
$05e952424405f82e$var$visitParents.SKIP = $05e952424405f82e$var$SKIP;
$05e952424405f82e$var$visitParents.EXIT = $05e952424405f82e$var$EXIT;
function $05e952424405f82e$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $7MLLw(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === "object" && node !== null ? node : {};
        var name;
        if (typeof value.type === "string") {
            name = typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            visit.displayName = "node (" + $gHPe8(value.type + (name ? "<" + name + ">" : "")) + ")";
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $05e952424405f82e$var$toResult(visitor(node, parents));
                if (result[0] === $05e952424405f82e$var$EXIT) return result;
            }
            if (node.children && result[0] !== $05e952424405f82e$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $05e952424405f82e$var$EXIT) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $05e952424405f82e$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $05e952424405f82e$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRequire.register("7MLLw", function(module, exports) {
"use strict";
module.exports = $5ab2115a6802f1ee$var$convert;
function $5ab2115a6802f1ee$var$convert(test) {
    if (test == null) return $5ab2115a6802f1ee$var$ok;
    if (typeof test === "string") return $5ab2115a6802f1ee$var$typeFactory(test);
    if (typeof test === "object") return "length" in test ? $5ab2115a6802f1ee$var$anyFactory(test) : $5ab2115a6802f1ee$var$allFactory(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $5ab2115a6802f1ee$var$allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $5ab2115a6802f1ee$var$anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $5ab2115a6802f1ee$var$convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $5ab2115a6802f1ee$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $5ab2115a6802f1ee$var$ok() {
    return true;
}

});

parcelRequire.register("gHPe8", function(module, exports) {
module.exports = $03237d84977b6b24$var$identity;
function $03237d84977b6b24$var$identity(d) {
    return d;
}

});



parcelRequire.register("ikNMt", function(module, exports) {
"use strict";
var $d590b5ac6d19be91$var$start = $d590b5ac6d19be91$var$factory("start");
var $d590b5ac6d19be91$var$end = $d590b5ac6d19be91$var$factory("end");
module.exports = $d590b5ac6d19be91$var$position;
$d590b5ac6d19be91$var$position.start = $d590b5ac6d19be91$var$start;
$d590b5ac6d19be91$var$position.end = $d590b5ac6d19be91$var$end;
function $d590b5ac6d19be91$var$position(node) {
    return {
        start: $d590b5ac6d19be91$var$start(node),
        end: $d590b5ac6d19be91$var$end(node)
    };
}
function $d590b5ac6d19be91$var$factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

});

parcelRequire.register("ctNAf", function(module, exports) {
"use strict";
module.exports = $915ea7c5ef2e043a$var$generated;
function $915ea7c5ef2e043a$var$generated(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRequire.register("6lqSu", function(module, exports) {
"use strict";

var $2O0C6 = parcelRequire("2O0C6");
module.exports = $49e98d9b46d60dc3$var$getDefinitionFactory;
var $49e98d9b46d60dc3$var$own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function $49e98d9b46d60dc3$var$getDefinitionFactory(node, options) {
    return $49e98d9b46d60dc3$var$getterFactory($49e98d9b46d60dc3$var$gather(node, options));
}
// Gather all definitions in `node`
function $49e98d9b46d60dc3$var$gather(node) {
    var cache = {};
    if (!node || !node.type) throw new Error("mdast-util-definitions expected node");
    $2O0C6(node, "definition", ondefinition);
    return cache;
    function ondefinition(definition) {
        var id = $49e98d9b46d60dc3$var$normalise(definition.identifier);
        if (!$49e98d9b46d60dc3$var$own.call(cache, id)) cache[id] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function $49e98d9b46d60dc3$var$getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && $49e98d9b46d60dc3$var$normalise(identifier);
        return id && $49e98d9b46d60dc3$var$own.call(cache, id) ? cache[id] : null;
    }
}
function $49e98d9b46d60dc3$var$normalise(identifier) {
    return identifier.toUpperCase();
}

});

parcelRequire.register("bFRmC", function(module, exports) {
"use strict";
module.exports = $87fceafe7634897d$var$one;

var $bkaaE = parcelRequire("bkaaE");

var $jjeL6 = parcelRequire("jjeL6");
var $87fceafe7634897d$var$own = {}.hasOwnProperty;
// Transform an unknown node.
function $87fceafe7634897d$var$unknown(h, node) {
    if ($87fceafe7634897d$var$text(node)) return h.augment(node, $bkaaE("text", node.value));
    return h(node, "div", $jjeL6(h, node));
}
// Visit a node.
function $87fceafe7634897d$var$one(h, node, parent) {
    var type = node && node.type;
    var fn;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($87fceafe7634897d$var$own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.indexOf(type) > -1) fn = $87fceafe7634897d$var$returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === "function" ? fn : $87fceafe7634897d$var$unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function $87fceafe7634897d$var$text(node) {
    var data = node.data || {};
    if ($87fceafe7634897d$var$own.call(data, "hName") || $87fceafe7634897d$var$own.call(data, "hProperties") || $87fceafe7634897d$var$own.call(data, "hChildren")) return false;
    return "value" in node;
}
function $87fceafe7634897d$var$returnNode(h, node) {
    var clone;
    if (node.children) {
        clone = Object.assign({}, node);
        clone.children = $jjeL6(h, node);
        return clone;
    }
    return node;
}

});
parcelRequire.register("jjeL6", function(module, exports) {
"use strict";
module.exports = $e0eb3d708897c91e$var$all;

var $bFRmC = parcelRequire("bFRmC");
function $e0eb3d708897c91e$var$all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = $bFRmC(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === "break") {
                if (result.value) result.value = result.value.replace(/^\s+/, "");
                head = result.children && result.children[0];
                if (head && head.value) head.value = head.value.replace(/^\s+/, "");
            }
            values = values.concat(result);
        }
    }
    return values;
}

});


parcelRequire.register("he7iZ", function(module, exports) {
"use strict";
module.exports = $c8a9692b5c49312d$var$generateFootnotes;

var $hs1bL = parcelRequire("hs1bL");

var $f2ILT = parcelRequire("f2ILT");

var $ePc6b = parcelRequire("ePc6b");
function $c8a9692b5c49312d$var$generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: "link",
            url: "#fnref-" + def.identifier,
            data: {
                hProperties: {
                    className: [
                        "footnote-backref"
                    ]
                }
            },
            children: [
                {
                    type: "text",
                    value: "↩"
                }
            ]
        };
        if (!tail || tail.type !== "paragraph") {
            tail = {
                type: "paragraph",
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: "listItem",
            data: {
                hProperties: {
                    id: "fn-" + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, "div", {
        className: [
            "footnotes"
        ]
    }, $ePc6b([
        $hs1bL(h),
        $f2ILT(h, {
            type: "list",
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRequire.register("hs1bL", function(module, exports) {
"use strict";
module.exports = $cb45f945ff74f667$var$thematicBreak;
function $cb45f945ff74f667$var$thematicBreak(h, node) {
    return h(node, "hr");
}

});

parcelRequire.register("f2ILT", function(module, exports) {
"use strict";
module.exports = $af39c5970da68ad4$var$list;

var $ePc6b = parcelRequire("ePc6b");

var $jjeL6 = parcelRequire("jjeL6");
function $af39c5970da68ad4$var$list(h, node) {
    var props = {};
    var name = node.ordered ? "ol" : "ul";
    var items;
    var index = -1;
    var length;
    if (typeof node.start === "number" && node.start !== 1) props.start = node.start;
    items = $jjeL6(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf("task-list-item") !== -1) {
        props.className = [
            "contains-task-list"
        ];
        break;
    }
    return h(node, name, props, $ePc6b(items, true));
}

});
parcelRequire.register("ePc6b", function(module, exports) {
"use strict";
module.exports = $acaf36a509d15121$var$wrap;

var $bkaaE = parcelRequire("bkaaE");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function $acaf36a509d15121$var$wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push($bkaaE("text", "\n"));
    while(++index < length){
        if (index) result.push($bkaaE("text", "\n"));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push($bkaaE("text", "\n"));
    return result;
}

});



parcelRequire.register("8oCnI", function(module, exports) {
"use strict";






















module.exports = {
    blockquote: (parcelRequire("3ZCm2")),
    break: (parcelRequire("7H7tq")),
    code: (parcelRequire("6T1mU")),
    delete: (parcelRequire("kSkOU")),
    emphasis: (parcelRequire("e9sOK")),
    footnoteReference: (parcelRequire("8lh9h")),
    footnote: (parcelRequire("5YnUG")),
    heading: (parcelRequire("kOI92")),
    html: (parcelRequire("ceAmz")),
    imageReference: (parcelRequire("fOgkF")),
    image: (parcelRequire("enfiC")),
    inlineCode: (parcelRequire("kwclI")),
    linkReference: (parcelRequire("bJ3Uy")),
    link: (parcelRequire("aGK2D")),
    listItem: (parcelRequire("hDX4F")),
    list: (parcelRequire("f2ILT")),
    paragraph: (parcelRequire("cgE5G")),
    root: (parcelRequire("33vRB")),
    strong: (parcelRequire("aCuYY")),
    table: (parcelRequire("hM8DQ")),
    text: (parcelRequire("3yMF9")),
    thematicBreak: (parcelRequire("hs1bL")),
    toml: $61ce5664b1d5458c$var$ignore,
    yaml: $61ce5664b1d5458c$var$ignore,
    definition: $61ce5664b1d5458c$var$ignore,
    footnoteDefinition: $61ce5664b1d5458c$var$ignore
};
// Return nothing for nodes that are ignored.
function $61ce5664b1d5458c$var$ignore() {
    return null;
}

});
parcelRequire.register("3ZCm2", function(module, exports) {
"use strict";
module.exports = $2e84d20635f77fa2$var$blockquote;

var $ePc6b = parcelRequire("ePc6b");

var $jjeL6 = parcelRequire("jjeL6");
function $2e84d20635f77fa2$var$blockquote(h, node) {
    return h(node, "blockquote", $ePc6b($jjeL6(h, node), true));
}

});

parcelRequire.register("7H7tq", function(module, exports) {
"use strict";
module.exports = $59a258adf88e9418$var$hardBreak;

var $bkaaE = parcelRequire("bkaaE");
function $59a258adf88e9418$var$hardBreak(h, node) {
    return [
        h(node, "br"),
        $bkaaE("text", "\n")
    ];
}

});

parcelRequire.register("6T1mU", function(module, exports) {
"use strict";
module.exports = $5038f0e8e894c3d4$var$code;

var $bkaaE = parcelRequire("bkaaE");
function $5038f0e8e894c3d4$var$code(h, node) {
    var value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    var code;
    if (lang) props.className = [
        "language-" + lang
    ];
    code = h(node, "code", props, [
        $bkaaE("text", value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, "pre", [
        code
    ]);
}

});

parcelRequire.register("kSkOU", function(module, exports) {
"use strict";
module.exports = $f3290035b7472495$var$strikethrough;

var $jjeL6 = parcelRequire("jjeL6");
function $f3290035b7472495$var$strikethrough(h, node) {
    return h(node, "del", $jjeL6(h, node));
}

});

parcelRequire.register("e9sOK", function(module, exports) {
"use strict";
module.exports = $a4d8427f062689c0$var$emphasis;

var $jjeL6 = parcelRequire("jjeL6");
function $a4d8427f062689c0$var$emphasis(h, node) {
    return h(node, "em", $jjeL6(h, node));
}

});

parcelRequire.register("8lh9h", function(module, exports) {
"use strict";
module.exports = $612d9647858f8c7d$var$footnoteReference;

var $bkaaE = parcelRequire("bkaaE");
function $612d9647858f8c7d$var$footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, "sup", {
        id: "fnref-" + identifier
    }, [
        h(node, "a", {
            href: "#fn-" + identifier,
            className: [
                "footnote-ref"
            ]
        }, [
            $bkaaE("text", node.label || identifier)
        ])
    ]);
}

});

parcelRequire.register("5YnUG", function(module, exports) {
"use strict";
module.exports = $45951aff81cb1128$var$footnote;

var $8lh9h = parcelRequire("8lh9h");
function $45951aff81cb1128$var$footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return $8lh9h(h, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRequire.register("kOI92", function(module, exports) {
"use strict";
module.exports = $f27ab8624a014f67$var$heading;

var $jjeL6 = parcelRequire("jjeL6");
function $f27ab8624a014f67$var$heading(h, node) {
    return h(node, "h" + node.depth, $jjeL6(h, node));
}

});

parcelRequire.register("ceAmz", function(module, exports) {
"use strict";
module.exports = $8e82ffcaf0f8bf4b$var$html;

var $bkaaE = parcelRequire("bkaaE");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function $8e82ffcaf0f8bf4b$var$html(h, node) {
    return h.dangerous ? h.augment(node, $bkaaE("raw", node.value)) : null;
}

});

parcelRequire.register("fOgkF", function(module, exports) {
"use strict";
module.exports = $b82831ce9331eb00$var$imageReference;

var $2ce7C = parcelRequire("2ce7C");

var $a4gJH = parcelRequire("a4gJH");
function $b82831ce9331eb00$var$imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $a4gJH(h, node);
    props = {
        src: $2ce7C(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "img", props);
}

});
parcelRequire.register("2ce7C", function(module, exports) {
"use strict";
var $1997a80c5bedbaa1$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $1997a80c5bedbaa1$var$getEncodeCache(exclude) {
    var i, ch, cache = $1997a80c5bedbaa1$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $1997a80c5bedbaa1$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $1997a80c5bedbaa1$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $1997a80c5bedbaa1$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $1997a80c5bedbaa1$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$1997a80c5bedbaa1$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$1997a80c5bedbaa1$var$encode.componentChars = "-_.!~*'()";
module.exports = $1997a80c5bedbaa1$var$encode;

});

parcelRequire.register("a4gJH", function(module, exports) {
"use strict";
module.exports = $7547428c48b91217$var$revert;

var $bkaaE = parcelRequire("bkaaE");

var $jjeL6 = parcelRequire("jjeL6");
// Return the content of a reference without definition as Markdown.
function $7547428c48b91217$var$revert(h, node) {
    var subtype = node.referenceType;
    var suffix = "]";
    var contents;
    var head;
    var tail;
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return $bkaaE("text", "![" + node.alt + suffix);
    contents = $jjeL6(h, node);
    head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift($bkaaE("text", "["));
    tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push($bkaaE("text", suffix));
    return contents;
}

});


parcelRequire.register("enfiC", function(module, exports) {
"use strict";

var $2ce7C = parcelRequire("2ce7C");
module.exports = $a76f14c84fdb4fba$var$image;
function $a76f14c84fdb4fba$var$image(h, node) {
    var props = {
        src: $2ce7C(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "img", props);
}

});

parcelRequire.register("kwclI", function(module, exports) {
"use strict";
module.exports = $ef00601cdffa24be$var$inlineCode;

var $bkaaE = parcelRequire("bkaaE");
function $ef00601cdffa24be$var$inlineCode(h, node) {
    var value = node.value.replace(/\r?\n|\r/g, " ");
    return h(node, "code", [
        $bkaaE("text", value)
    ]);
}

});

parcelRequire.register("bJ3Uy", function(module, exports) {
"use strict";
module.exports = $8896ee60b372f75c$var$linkReference;

var $2ce7C = parcelRequire("2ce7C");

var $a4gJH = parcelRequire("a4gJH");

var $jjeL6 = parcelRequire("jjeL6");
function $8896ee60b372f75c$var$linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $a4gJH(h, node);
    props = {
        href: $2ce7C(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "a", props, $jjeL6(h, node));
}

});

parcelRequire.register("aGK2D", function(module, exports) {
"use strict";

var $2ce7C = parcelRequire("2ce7C");

var $jjeL6 = parcelRequire("jjeL6");
module.exports = $7c818a84a83a028e$var$link;
function $7c818a84a83a028e$var$link(h, node) {
    var props = {
        href: $2ce7C(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "a", props, $jjeL6(h, node));
}

});

parcelRequire.register("hDX4F", function(module, exports) {
"use strict";
module.exports = $cd83e71a623b9e76$var$listItem;

var $bkaaE = parcelRequire("bkaaE");

var $jjeL6 = parcelRequire("jjeL6");
function $cd83e71a623b9e76$var$listItem(h, node, parent) {
    var result = $jjeL6(h, node);
    var head = result[0];
    var loose = parent ? $cd83e71a623b9e76$var$listLoose(parent) : $cd83e71a623b9e76$var$listItemLoose(node);
    var props = {};
    var wrapped = [];
    var length;
    var index;
    var child;
    if (typeof node.checked === "boolean") {
        if (!head || head.tagName !== "p") {
            head = h(null, "p", []);
            result.unshift(head);
        }
        if (head.children.length > 0) head.children.unshift($bkaaE("text", " "));
        head.children.unshift(h(null, "input", {
            type: "checkbox",
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            "task-list-item"
        ];
    }
    length = result.length;
    index = -1;
    while(++index < length){
        child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.tagName !== "p") wrapped.push($bkaaE("text", "\n"));
        if (child.tagName === "p" && !loose) wrapped = wrapped.concat(child.children);
        else wrapped.push(child);
    }
    // Add a final eol.
    if (length && (loose || child.tagName !== "p")) wrapped.push($bkaaE("text", "\n"));
    return h(node, "li", props, wrapped);
}
function $cd83e71a623b9e76$var$listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = $cd83e71a623b9e76$var$listItemLoose(children[index]);
    return loose;
}
function $cd83e71a623b9e76$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRequire.register("cgE5G", function(module, exports) {
"use strict";
module.exports = $8ee613d8700b25cb$var$paragraph;

var $jjeL6 = parcelRequire("jjeL6");
function $8ee613d8700b25cb$var$paragraph(h, node) {
    return h(node, "p", $jjeL6(h, node));
}

});

parcelRequire.register("33vRB", function(module, exports) {
"use strict";
module.exports = $239a5e5923a43101$var$root;

var $bkaaE = parcelRequire("bkaaE");

var $ePc6b = parcelRequire("ePc6b");

var $jjeL6 = parcelRequire("jjeL6");
function $239a5e5923a43101$var$root(h, node) {
    return h.augment(node, $bkaaE("root", $ePc6b($jjeL6(h, node))));
}

});

parcelRequire.register("aCuYY", function(module, exports) {
"use strict";
module.exports = $7bb57c73ceb316ea$var$strong;

var $jjeL6 = parcelRequire("jjeL6");
function $7bb57c73ceb316ea$var$strong(h, node) {
    return h(node, "strong", $jjeL6(h, node));
}

});

parcelRequire.register("hM8DQ", function(module, exports) {
"use strict";
module.exports = $cf0d9f702d16c187$var$table;

var $ikNMt = parcelRequire("ikNMt");

var $ePc6b = parcelRequire("ePc6b");

var $jjeL6 = parcelRequire("jjeL6");
function $cf0d9f702d16c187$var$table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align || [];
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? "th" : "td";
        pos = alignLength || row.length;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? $jjeL6(h, cell) : []);
        }
        result[index] = h(rows[index], "tr", $ePc6b(out, true));
    }
    return h(node, "table", $ePc6b([
        h(result[0].position, "thead", $ePc6b([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: $ikNMt.start(result[1]),
        end: $ikNMt.end(result[result.length - 1])
    }, "tbody", $ePc6b(result.slice(1), true)) : []), true));
}

});

parcelRequire.register("3yMF9", function(module, exports) {
"use strict";
module.exports = $297a4b799f570f2e$var$text;

var $bkaaE = parcelRequire("bkaaE");
function $297a4b799f570f2e$var$text(h, node) {
    return h.augment(node, $bkaaE("text", String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, "$1")));
}

});



parcelRequire.register("7aRnb", function(module, exports) {
"use strict";
var $5392de554d6f2b4e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5392de554d6f2b4e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5392de554d6f2b4e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.forceInit = module.exports.util = module.exports.math = module.exports.random = module.exports.sources = module.exports.variation = module.exports.Emitter = module.exports.Particle = module.exports.settings = module.exports.scene = void 0;

var $7u14n = parcelRequire("7u14n");


$5392de554d6f2b4e$var$__exportStar((parcelRequire("krtLn")), module.exports);

$5392de554d6f2b4e$var$__exportStar((parcelRequire("ih6Wa")), module.exports);

$5392de554d6f2b4e$var$__exportStar((parcelRequire("hi7H6")), module.exports);

$5392de554d6f2b4e$var$__exportStar((parcelRequire("7G4Sq")), module.exports);
// Create the lazy-initializing scene.
module.exports.scene = new (parcelRequire("hFcRm")).Lazy(function() {
    // The library requires the use of the DOM, hence it cannot run in non-browser environments.
    if (typeof document === "undefined" || typeof window === "undefined") throw new Error("It seems like you are trying to run party.js in a non-browser-like environment, which is not supported.");
    return new $7u14n.Scene();
});

var $fvf8u = parcelRequire("fvf8u");
Object.defineProperty(module.exports, "settings", {
    enumerable: true,
    get: function() {
        return $fvf8u.settings;
    }
});

var $ghZeo = parcelRequire("ghZeo");
Object.defineProperty(module.exports, "Particle", {
    enumerable: true,
    get: function() {
        return $ghZeo.Particle;
    }
});

var $cJl2w = parcelRequire("cJl2w");
Object.defineProperty(module.exports, "Emitter", {
    enumerable: true,
    get: function() {
        return $cJl2w.Emitter;
    }
});

module.exports.variation = (parcelRequire("8wOWU"));

module.exports.sources = (parcelRequire("lcJ00"));

module.exports.random = (parcelRequire("8YLYT"));

module.exports.math = (parcelRequire("6wW8p"));

module.exports.util = (parcelRequire("hFcRm"));
/**
 * Forces the initialization of the otherwise lazy scene.
 */ function $5392de554d6f2b4e$var$forceInit() {
    module.exports.scene.current;
}
module.exports.forceInit = $5392de554d6f2b4e$var$forceInit;

module.exports.default = module.exports;

});
parcelRequire.register("7u14n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scene = void 0;

var $e7bdg = parcelRequire("e7bdg");

var $cJl2w = parcelRequire("cJl2w");

var $jQKEj = parcelRequire("jQKEj");
/**
 * Represents a scene that contains emitters and their particles.
 *
 * Scenes are responsible for spawning and updating emitters, and
 * removing them once they are done.
 *
 * Scenes are not explicitely present in the DOM as an element, only
 * the contained particles are.
 */ var $572c2a21e95fdd5e$var$Scene = /** @class */ function() {
    /**
     * Initializes a new scene and starts the ticking job.
     */ function Scene() {
        /**
         * The emitters currently present in the scene.
         */ this.emitters = [];
        /**
         * The debug instance associated with the scene.
         */ this.debug = new $e7bdg.Debug(this);
        /**
         * The renderer associated with the scene.
         */ this.renderer = new $jQKEj.Renderer();
        /**
         * The ID of the currently scheduled tick.
         */ this.scheduledTickId = undefined;
        /**
         * The timestamp of the last tick, used to calculate deltas.
         *
         * @initialValue `performance.now()` (time origin)
         * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp
         */ this.lastTickTimestamp = performance.now();
        // Ensure the scene context is preserved on the tick.
        this.tick = this.tick.bind(this);
        this.scheduleTick();
    }
    /**
     * Creates and returns a new, default emitter object.
     */ Scene.prototype.createEmitter = function(options) {
        var emitter = new $cJl2w.Emitter(options);
        this.emitters.push(emitter);
        return emitter;
    };
    /**
     * Clears all emitters from the scene.
     *
     * @returns The number of cleared emitters.
     */ Scene.prototype.clearEmitters = function() {
        return this.emitters.splice(0).length;
    };
    /**
     * Clears the particles from all emitters in the scene.
     * Note that this does not remove the actual emitter objects though.
     *
     * @returns The number of cleared particles.
     */ Scene.prototype.clearParticles = function() {
        return this.emitters.reduce(function(sum, emitter) {
            return sum + emitter.clearParticles();
        }, 0);
    };
    /**
     * Schedules a tick in the scene.
     */ Scene.prototype.scheduleTick = function() {
        this.scheduledTickId = window.requestAnimationFrame(this.tick);
    };
    /**
     * Cancels a pending tick operation.
     */ Scene.prototype.cancelTick = function() {
        window.cancelAnimationFrame(this.scheduledTickId);
    };
    /**
     * Processes a tick cycle, updating all emitters contained in the scene.
     * This is handled as a JS animation frame event, hence the passed timestamp.
     *
     * @remarks
     * The emitter ticking and particle rendering is run using try-catch blocks,
     * to ensure that we can recover from potential errors.
     *
     * @param timestamp The current timestamp of the animation frame.
     */ Scene.prototype.tick = function(timestamp) {
        // Calculate the elapsed delta and convert it to seconds.
        var delta = (timestamp - this.lastTickTimestamp) / 1000;
        try {
            // Perform ticks for all the emitters in the scene.
            for(var i = 0; i < this.emitters.length; i++){
                var emitter = this.emitters[i];
                emitter.tick(delta);
                if (emitter.isExpired && emitter.canRemove) this.emitters.splice(i--, 1);
            }
        } catch (error) {
            console.error("An error occurred while updating the scene's emitters:\n\"" + error + '"');
        }
        try {
            // Instruct the renderer to draw the particles of all systems.
            this.renderer.begin();
            for(var _i = 0, _a = this.emitters; _i < _a.length; _i++){
                var emitter = _a[_i];
                for(var _b = 0, _c = emitter.particles; _b < _c.length; _b++){
                    var particle = _c[_b];
                    this.renderer.renderParticle(particle, emitter);
                }
            }
            this.renderer.end();
        } catch (error) {
            console.error("An error occurred while rendering the scene's particles:\n\"" + error + '"');
        }
        // Perform a tick on the debug interface
        this.debug.tick(delta);
        // Save the timestamp as the last tick timestamp and schedule a new tick.
        this.lastTickTimestamp = timestamp;
        this.scheduleTick();
    };
    return Scene;
}();
module.exports.Scene = $572c2a21e95fdd5e$var$Scene;

});
parcelRequire.register("e7bdg", function(module, exports) {
"use strict";
var $a46a6acfa7af31bf$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Debug = void 0;

var $3K9ck = parcelRequire("3K9ck");

var $fvf8u = parcelRequire("fvf8u");
/**
 * Represents a utility module to view debug information inside the DOM.
 * This is disabled by default and needs to manually be enabled by setting
 * the '.enabled' field to true.
 *
 * While disabled, the utility will not fetch stats and update itself.
 */ var $a46a6acfa7af31bf$var$Debug = /** @class */ function() {
    /**
     * Registers a new debug utility that is attached to the given scene.
     *
     * @param scene The scene to attach to.
     */ function Debug(scene) {
        this.scene = scene;
        /**
         * The rate at which the debug interface should refresh itself (per second).
         */ this.refreshRate = 8;
        /**
         * The timer counting down to refreshes.
         */ this.refreshTimer = 1 / this.refreshRate;
    }
    /**
     * Processes a tick event in the interface. This checks if enough has passed to
     * trigger a refresh, and if so, fetches the debug information and updates the DOM.
     *
     * @param delta The time that has elapsed since the last tick.
     */ Debug.prototype.tick = function(delta) {
        var container = $3K9ck.debugContainer.current;
        // If the current display style does not match the style inferred from the
        // enabled-state, update it.
        var displayStyle = $fvf8u.settings.debug ? "block" : "none";
        if (container.style.display !== displayStyle) container.style.display = displayStyle;
        if (!$fvf8u.settings.debug) // If the interface is not enabled, don't fetch or update any infos.
        return;
        this.refreshTimer += delta;
        if (this.refreshTimer > 1 / this.refreshRate) {
            this.refreshTimer = 0;
            // Update the container with the fetched information joined on line breaks.
            container.innerHTML = this.getDebugInformation(delta).join("<br>");
        }
    };
    /**
     * Fetches the debug information from the specified delta and the linked scene.
     *
     * @returns An array of debugging information, formatted as HTML.
     */ Debug.prototype.getDebugInformation = function(delta) {
        // Count emitters and particles.
        var emitters = this.scene.emitters.length;
        var particles = this.scene.emitters.reduce(function(acc, cur) {
            return acc + cur.particles.length;
        }, 0);
        var infos = [
            "<b>party.js Debug</b>",
            "--------------",
            "FPS: " + Math.round(1 / delta),
            "Emitters: " + emitters,
            "Particles: " + particles
        ];
        // Emitter informations are formatted using their index, internal timer
        // and total particle count.
        var emitterInfos = this.scene.emitters.map(function(emitter) {
            return [
                // Show the current loop and the total loops.
                "⭯: " + (emitter["currentLoop"] + 1) + "/" + (emitter.options.loops >= 0 ? emitter.options.loops : "∞"),
                // Show the amount of particle contained.
                "Σp: " + emitter.particles.length,
                // Show the internal timer.
                !emitter.isExpired ? "Σt: " + emitter["durationTimer"].toFixed(3) + "s" : "<i>expired</i>"
            ].join(", ");
        });
        infos.push.apply(infos, $a46a6acfa7af31bf$var$__spreadArray([
            "--------------"
        ], emitterInfos));
        return infos;
    };
    return Debug;
}();
module.exports.Debug = $a46a6acfa7af31bf$var$Debug;

});
parcelRequire.register("3K9ck", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.particleContainer = module.exports.debugContainer = module.exports.rootContainer = void 0;

var $fvf8u = parcelRequire("fvf8u");

var $hFcRm = parcelRequire("hFcRm");
/**
 * The prefix to apply to the containers.
 */ var $2b9ccd7b868a3997$var$containerPrefix = "party-js-";
/**
 * Checks if the specified container is 'active', meaning not undefined and attached to the DOM.
 */ function $2b9ccd7b868a3997$var$isContainerActive(container) {
    return container && container.isConnected;
}
/**
 * A generic factory method for creating a DOM container. Prefixes the specified name with the
 * container prefix, applies the styles and adds it under the parent.
 */ function $2b9ccd7b868a3997$var$makeContainer(name, styles, parent) {
    var container = document.createElement("div");
    container.id = $2b9ccd7b868a3997$var$containerPrefix + name;
    Object.assign(container.style, styles);
    return parent.appendChild(container);
}
/**
 * Represents the root container for DOM elements of the library.
 */ module.exports.rootContainer = new $hFcRm.Lazy(function() {
    return $2b9ccd7b868a3997$var$makeContainer("container", {
        position: "fixed",
        left: "0",
        top: "0",
        height: "100vh",
        width: "100vw",
        pointerEvents: "none",
        userSelect: "none",
        zIndex: $fvf8u.settings.zIndex.toString()
    }, document.body);
}, $2b9ccd7b868a3997$var$isContainerActive);
/**
 * Represents the debugging container of the library, only active if debugging is enabled.
 */ module.exports.debugContainer = new $hFcRm.Lazy(function() {
    return $2b9ccd7b868a3997$var$makeContainer("debug", {
        position: "absolute",
        top: "0",
        left: "0",
        margin: "0.5em",
        padding: "0.5em 1em",
        border: "2px solid rgb(0, 0, 0, 0.2)",
        background: "rgb(0, 0, 0, 0.1)",
        color: "#555",
        fontFamily: "monospace"
    }, module.exports.rootContainer.current);
}, $2b9ccd7b868a3997$var$isContainerActive);
/**
 * Represents the particle container of the library.
 * This is where the particle DOM elements get rendered into.
 */ module.exports.particleContainer = new $hFcRm.Lazy(function() {
    return $2b9ccd7b868a3997$var$makeContainer("particles", {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        perspective: "1200px"
    }, module.exports.rootContainer.current);
}, $2b9ccd7b868a3997$var$isContainerActive);

});
parcelRequire.register("fvf8u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.settings = void 0;
module.exports.settings = {
    debug: false,
    gravity: 800,
    zIndex: 99999,
    respectReducedMotion: true
};

});

parcelRequire.register("hFcRm", function(module, exports) {
"use strict";
var $cdc03da7723e3a2d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cdc03da7723e3a2d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cdc03da7723e3a2d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cdc03da7723e3a2d$var$__exportStar((parcelRequire("5ddM5")), module.exports);

$cdc03da7723e3a2d$var$__exportStar((parcelRequire("iSHvF")), module.exports);

$cdc03da7723e3a2d$var$__exportStar((parcelRequire("iJGfm")), module.exports);

$cdc03da7723e3a2d$var$__exportStar((parcelRequire("j6VSR")), module.exports);

});
parcelRequire.register("5ddM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overrideDefaults = void 0;
/**
 * Replaces the supplied defaults with the properties specified in the overrides.
 * This returns a new object.
 */ function $3cb8da045bb7ad75$var$overrideDefaults(defaults, overrides) {
    return Object.assign({}, defaults, overrides);
}
module.exports.overrideDefaults = $3cb8da045bb7ad75$var$overrideDefaults;

});

parcelRequire.register("iSHvF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rotationToNormal = void 0;

var $krtLn = parcelRequire("krtLn");

var $6wW8p = parcelRequire("6wW8p");
/**
 * Converts the specified euler rotation (in degrees) into the corresponding normal vector.
 *
 * @remarks
 * The normal is calculated by placing a (figurative) plane in a coordinate-system's
 * origin, and rotating it by the specified angles. Note that the z-component of the
 * rotation is irrelevant for the normal and can be ignored. Then, two vectors
 * describing the orientation of the plane are calculated. Their cross product
 * denotes the normal vector.
 *
 * @param rotation The euler rotation angles (in degrees) to calculate the normal for.
 */ function $dbef05474e86eb9c$var$rotationToNormal(rotation) {
    var alpha = rotation.x * $6wW8p.deg2rad;
    var beta = rotation.y * $6wW8p.deg2rad;
    var a = new $krtLn.Vector(Math.cos(beta), 0, Math.sin(beta));
    var b = new $krtLn.Vector(0, Math.cos(alpha), Math.sin(alpha));
    return a.cross(b);
}
module.exports.rotationToNormal = $dbef05474e86eb9c$var$rotationToNormal;

});
parcelRequire.register("krtLn", function(module, exports) {
"use strict";
var $ee1d6a987323aedc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee1d6a987323aedc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee1d6a987323aedc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ee1d6a987323aedc$var$__exportStar((parcelRequire("wbzSx")), module.exports);

$ee1d6a987323aedc$var$__exportStar((parcelRequire("eo9Sc")), module.exports);

$ee1d6a987323aedc$var$__exportStar((parcelRequire("8XEGW")), module.exports);

$ee1d6a987323aedc$var$__exportStar((parcelRequire("aCiJ1")), module.exports);

$ee1d6a987323aedc$var$__exportStar((parcelRequire("3XriL")), module.exports);

$ee1d6a987323aedc$var$__exportStar((parcelRequire("i8nnx")), module.exports);

});
parcelRequire.register("wbzSx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Circle = void 0;
/**
 * Represents a circle.
 */ var $060bf85c75c7ee23$var$Circle = /** @class */ function() {
    /**
     * Creates a new circle at the specified coordinates, with a default radius of 0.
     */ function Circle(x, y, radius) {
        if (radius === void 0) radius = 0;
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    Circle.zero = new Circle(0, 0);
    return Circle;
}();
module.exports.Circle = $060bf85c75c7ee23$var$Circle;

});

parcelRequire.register("eo9Sc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = void 0;

var $6wW8p = parcelRequire("6wW8p");
/**
 * Represents a color consisting of RGB values. The components of it are
 * represented as integers in the range 0 to 255.
 *
 * @example
 * ```ts
 * const a = new Color(12, 59, 219);
 * const b = Color.fromHex("#ffa68d");
 * const result = a.mix(b);
 * ```
 */ var $a79af7367cf748b9$var$Color = /** @class */ function() {
    /**
     * Creates a new color instance from the specified RGB components.
     */ function Color(r, g, b) {
        this.values = new Float32Array(3);
        this.rgb = [
            r,
            g,
            b
        ];
    }
    Object.defineProperty(Color.prototype, "r", {
        /**
         * Returns the r-component of the color.
         */ get: function() {
            return this.values[0];
        },
        /**
         * Modifies the r-component of the color.
         * Note that this also floors the value.
         */ set: function(value) {
            this.values[0] = Math.floor(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "g", {
        /**
         * Returns the g-component of the color.
         */ get: function() {
            return this.values[1];
        },
        /**
         * Modifies the g-component of the color.
         * Note that this also floors the value.
         */ set: function(value) {
            this.values[1] = Math.floor(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "b", {
        /**
         * Returns the b-component of the color.
         * Note that this also floors the value.
         */ get: function() {
            return this.values[2];
        },
        /**
         * Modifies the b-component of the color.
         */ set: function(value) {
            this.values[2] = Math.floor(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "rgb", {
        /**
         * Returns the rgb-components of the color, bundled as a copied array.
         */ get: function() {
            return [
                this.r,
                this.g,
                this.b
            ];
        },
        /**
         * Simultaneously updates the rgb-components of the color, by passing an array.
         */ set: function(values) {
            this.r = values[0];
            this.g = values[1];
            this.b = values[2];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Mixes the two color together with an optional mixing weight.
     * This weight is 0.5 by default, perfectly averaging the color.
     */ Color.prototype.mix = function(color, weight) {
        if (weight === void 0) weight = 0.5;
        return new Color($6wW8p.lerp(this.r, color.r, weight), $6wW8p.lerp(this.g, color.g, weight), $6wW8p.lerp(this.b, color.b, weight));
    };
    /**
     * Returns the hexadecimal representation of the color, prefixed by '#'.
     */ Color.prototype.toHex = function() {
        var hex = function(v) {
            return v.toString(16).padStart(2, "0");
        };
        return "#" + hex(this.r) + hex(this.g) + hex(this.b);
    };
    /**
     * Returns a formatted representation of the color.
     */ Color.prototype.toString = function() {
        return "rgb(" + this.values.join(", ") + ")";
    };
    /**
     * Creates a color from the specified hexadecimal string.
     * This string can optionally be prefixed by '#'.
     */ Color.fromHex = function(hex) {
        if (hex.startsWith("#")) hex = hex.substr(1);
        return new Color(parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16));
    };
    /**
     * Creates a color from the specified HSL components.
     *
     * @see https://stackoverflow.com/a/9493060/5507624
     */ Color.fromHsl = function(h, s, l) {
        h /= 360;
        s /= 100;
        l /= 100;
        if (s === 0) return new Color(l, l, l);
        else {
            var hue2rgb = function(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 0.5) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            var to255 = function(v) {
                return Math.min(255, 256 * v);
            };
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            return new Color(to255(hue2rgb(p, q, h + 1 / 3)), to255(hue2rgb(p, q, h)), to255(hue2rgb(p, q, h - 1 / 3)));
        }
    };
    /**
     * Returns (1, 1, 1).
     */ Color.white = new Color(255, 255, 255);
    /**
     * Returns (0, 0, 0).
     */ Color.black = new Color(0, 0, 0);
    return Color;
}();
module.exports.Color = $a79af7367cf748b9$var$Color;

});
parcelRequire.register("6wW8p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.approximately = module.exports.clamp = module.exports.invlerp = module.exports.slerp = module.exports.lerp = module.exports.epsilon = module.exports.rad2deg = module.exports.deg2rad = void 0;
/**
 * Constant coefficient to convert degrees to radians.
 */ module.exports.deg2rad = Math.PI / 180;
/**
 * Constant coefficient to convert radians to degrees.
 */ module.exports.rad2deg = 180 / Math.PI;
/**
 * A small value to approximately compare values.
 */ module.exports.epsilon = 0.000001;
/**
 * Linearly interpolates between a and b by t.
 */ function $4c12d39467bba91d$var$lerp(a, b, t) {
    return (1 - t) * a + t * b;
}
module.exports.lerp = $4c12d39467bba91d$var$lerp;
/**
 * Smoothly interpolates between a and b by t (using cosine interpolation).
 */ function $4c12d39467bba91d$var$slerp(a, b, t) {
    return $4c12d39467bba91d$var$lerp(a, b, (1 - Math.cos(t * Math.PI)) / 2);
}
module.exports.slerp = $4c12d39467bba91d$var$slerp;
/**
 * Inversely lerps v between a and b to find t.
 */ function $4c12d39467bba91d$var$invlerp(a, b, v) {
    return (v - a) / (b - a);
}
module.exports.invlerp = $4c12d39467bba91d$var$invlerp;
/**
 * Clamps the specified value between a minimum and a maximum.
 */ function $4c12d39467bba91d$var$clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
module.exports.clamp = $4c12d39467bba91d$var$clamp;
/**
 * Checks if a is approximately equal to b.
 */ function $4c12d39467bba91d$var$approximately(a, b) {
    return Math.abs(a - b) < module.exports.epsilon;
}
module.exports.approximately = $4c12d39467bba91d$var$approximately;

});


parcelRequire.register("8XEGW", function(module, exports) {
"use strict";
var $686365ec7c09cc8f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $686365ec7c09cc8f$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Gradient = void 0;

var $gAp6f = parcelRequire("gAp6f");
/**
 * Represents a gradient that can be used to interpolate between multiple color.
 */ var $686365ec7c09cc8f$var$Gradient = /** @class */ function(_super) {
    $686365ec7c09cc8f$var$__extends(Gradient, _super);
    function Gradient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Interpolates between two color on the gradient.
     */ Gradient.prototype.interpolate = function(a, b, t) {
        return a.mix(b, t);
    };
    /**
     * Returns a solid gradient from the given color.
     */ Gradient.solid = function(color) {
        return new Gradient({
            value: color,
            time: 0.5
        });
    };
    /**
     * Returns a gradient with evenly spaced keys from the given colors.
     */ Gradient.simple = function() {
        var colors = [];
        for(var _i = 0; _i < arguments.length; _i++)colors[_i] = arguments[_i];
        var step = 1 / (colors.length - 1);
        return new (Gradient.bind.apply(Gradient, $686365ec7c09cc8f$var$__spreadArray([
            void 0
        ], colors.map(function(color, index) {
            return {
                value: color,
                time: index * step
            };
        }))))();
    };
    return Gradient;
}($gAp6f.Spline);
module.exports.Gradient = $686365ec7c09cc8f$var$Gradient;

});
parcelRequire.register("gAp6f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spline = void 0;

var $6wW8p = parcelRequire("6wW8p");
/**
 * Represents a spline that can be used to continueously evaluate a function
 * between keys. The base implementation is kept generic, so the functionality
 * can easily be implemented for similar constructs, such as gradients.
 */ var $c1337a6b32be9811$var$Spline = /** @class */ function() {
    /**
     * Creates a new spline instance, using the specified keys.
     * Note that you have to pass at least one key.
     */ function Spline() {
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        if (keys.length === 0) throw new Error("Splines require at least one key.");
        if (Array.isArray(keys[0])) throw new Error("You are trying to pass an array to the spline constructor, which is not supported. Try to spread the array into the constructor instead.");
        this.keys = keys;
    }
    /**
     * Evaluates the spline at the given time.
     */ Spline.prototype.evaluate = function(time) {
        if (this.keys.length === 0) throw new Error("Attempt to evaluate a spline with no keys.");
        if (this.keys.length === 1) // The spline only contains one key, therefore is constant.
        return this.keys[0].value;
        // Sort the keys and figure out the first key above the passed time.
        var ascendingKeys = this.keys.sort(function(a, b) {
            return a.time - b.time;
        });
        var upperKeyIndex = ascendingKeys.findIndex(function(g) {
            return g.time > time;
        });
        // If the found index is either 0 or -1, the specified time falls out
        // of the range of the supplied keys. In that case, the value of the
        // nearest applicant key is returned.
        if (upperKeyIndex === 0) return ascendingKeys[0].value;
        if (upperKeyIndex === -1) return ascendingKeys[ascendingKeys.length - 1].value;
        // Otherwise, find the bounding keys, and extrapolate the time between
        // the two. This is then used to interpolate between the two keys,
        // using the provided implementation.
        var lowerKey = ascendingKeys[upperKeyIndex - 1];
        var upperKey = ascendingKeys[upperKeyIndex];
        var containedTime = $6wW8p.invlerp(lowerKey.time, upperKey.time, time);
        return this.interpolate(lowerKey.value, upperKey.value, containedTime);
    };
    return Spline;
}();
module.exports.Spline = $c1337a6b32be9811$var$Spline;

});


parcelRequire.register("aCiJ1", function(module, exports) {
"use strict";
var $7babfa70004196c6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericSpline = void 0;

var $6wW8p = parcelRequire("6wW8p");

var $gAp6f = parcelRequire("gAp6f");
/**
 * Represents a spline that can take numeric values.
 */ var $7babfa70004196c6$var$NumericSpline = /** @class */ function(_super) {
    $7babfa70004196c6$var$__extends(NumericSpline, _super);
    function NumericSpline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Smoothly interpolates between two keys on the spline.
     */ NumericSpline.prototype.interpolate = function(a, b, t) {
        return $6wW8p.slerp(a, b, t);
    };
    return NumericSpline;
}($gAp6f.Spline);
module.exports.NumericSpline = $7babfa70004196c6$var$NumericSpline;

});

parcelRequire.register("3XriL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rect = void 0;
/**
 * Represents a rectangle with an origin and size.
 */ var $2e1c0f50f46711fb$var$Rect = /** @class */ function() {
    function Rect(x, y, width, height) {
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
     * Returns a new document-space rectangle from the viewport's bounds.
     */ Rect.fromScreen = function() {
        return new Rect(window.scrollX, window.scrollY, window.innerWidth, window.innerHeight);
    };
    /**
     * Returns a new document-space rectangle from the specified element.
     */ Rect.fromElement = function(element) {
        var r = element.getBoundingClientRect();
        return new Rect(window.scrollX + r.x, window.scrollY + r.y, r.width, r.height);
    };
    Rect.zero = new Rect(0, 0);
    return Rect;
}();
module.exports.Rect = $2e1c0f50f46711fb$var$Rect;

});

parcelRequire.register("i8nnx", function(module, exports) {
"use strict";
var $d33b1be0bf391c99$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vector = void 0;

var $6wW8p = parcelRequire("6wW8p");
/**
 * Represents a structure used to process vectors.
 *
 * @remarks
 * Note that the operations in this class will **not** modify the original vector,
 * except for the property assignments. This is to ensure that vectors are not
 * unintentionally modified.
 *
 * @example
 * ```ts
 * const vectorA = new Vector(1, 3, 5);
 * const vectorB = new Vector(2, 3, 1);
 * const vectorC = vectorA.add(vectorB); // (3, 6, 6)
 * ```
 */ var $d33b1be0bf391c99$var$Vector = /** @class */ function() {
    /**
     * Creates a new vector with optional x-, y-, and z-components.
     * Omitted components are defaulted to 0.
     */ function Vector(x, y, z) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (z === void 0) z = 0;
        this.values = new Float32Array(3);
        this.xyz = [
            x,
            y,
            z
        ];
    }
    Object.defineProperty(Vector.prototype, "x", {
        /**
         * Returns the x-component of the vector.
         */ get: function() {
            return this.values[0];
        },
        /**
         * Modifies the x-component of the vector.
         */ set: function(value) {
            this.values[0] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "y", {
        /**
         * Returns the y-component of the vector.
         */ get: function() {
            return this.values[1];
        },
        /**
         * Modifies the y-component of the vector.
         */ set: function(value) {
            this.values[1] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "z", {
        /**
         * Returns the z-component of the vector.
         */ get: function() {
            return this.values[2];
        },
        /**
         * Modifies the z-component of the vector.
         */ set: function(value) {
            this.values[2] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "xyz", {
        /**
         * Returns the xyz-components of the vector, bundled as a copied array.
         */ get: function() {
            return [
                this.x,
                this.y,
                this.z
            ];
        },
        /**
         * Simultaneously updates the xyz-components of the vector, by passing an array.
         */ set: function(values) {
            this.values[0] = values[0];
            this.values[1] = values[1];
            this.values[2] = values[2];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the length of the vector.
     */ Vector.prototype.magnitude = function() {
        return Math.sqrt(this.sqrMagnitude());
    };
    /**
     * Returns the squared length of the vector.
     */ Vector.prototype.sqrMagnitude = function() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    };
    /**
     * Adds the two vectors together, component-wise.
     */ Vector.prototype.add = function(vector) {
        return new Vector(this.x + vector.x, this.y + vector.y, this.z + vector.z);
    };
    /**
     * Subtracts the right vector from the left one, component-wise.
     */ Vector.prototype.subtract = function(vector) {
        return new Vector(this.x - vector.x, this.y - vector.y, this.z - vector.z);
    };
    /**
     * Scales the lefthand vector by another vector or by a number.
     */ Vector.prototype.scale = function(scalar) {
        if (typeof scalar === "number") return new Vector(this.x * scalar, this.y * scalar, this.z * scalar);
        else return new Vector(this.x * scalar.x, this.y * scalar.y, this.z * scalar.z);
    };
    /**
     * Normalizes the vector to a length of 1. If the length was previously zero,
     * then a zero-length vector will be returned.
     */ Vector.prototype.normalized = function() {
        var magnitude = this.magnitude();
        if (magnitude !== 0) return this.scale(1 / magnitude);
        return new (Vector.bind.apply(Vector, $d33b1be0bf391c99$var$__spreadArray([
            void 0
        ], this.xyz)))();
    };
    /**
     * Returns the angle between two vectors, in degrees.
     */ Vector.prototype.angle = function(vector) {
        return $6wW8p.rad2deg * Math.acos((this.x * vector.x + this.y * vector.y + this.z * vector.z) / (this.magnitude() * vector.magnitude()));
    };
    /**
     * Returns the cross-product of two vectors.
     */ Vector.prototype.cross = function(vector) {
        return new Vector(this.y * vector.z - this.z * vector.y, this.z * vector.x - this.x * vector.z, this.x * vector.y - this.y * vector.x);
    };
    /**
     * returns the dot-product of two vectors.
     */ Vector.prototype.dot = function(vector) {
        return this.magnitude() * vector.magnitude() * Math.cos($6wW8p.deg2rad * this.angle(vector));
    };
    /**
     * Returns a formatted representation of the vector.
     */ Vector.prototype.toString = function() {
        return "Vector(" + this.values.join(", ") + ")";
    };
    /**
     * Creates a new vector from an angle, in degrees. Note that the z-component will be zero.
     */ Vector.from2dAngle = function(angle) {
        return new Vector(Math.cos(angle * $6wW8p.deg2rad), Math.sin(angle * $6wW8p.deg2rad));
    };
    /**
     * Returns (0, 0, 0).
     */ Vector.zero = new Vector(0, 0, 0);
    /**
     * Returns (1, 1, 1).
     */ Vector.one = new Vector(1, 1, 1);
    /**
     * Returns (1, 0, 0).
     */ Vector.right = new Vector(1, 0, 0);
    /**
     * Returns (0, 1, 0).
     */ Vector.up = new Vector(0, 1, 0);
    /**
     * Returns (0, 0, 1).
     */ Vector.forward = new Vector(0, 0, 1);
    return Vector;
}();
module.exports.Vector = $d33b1be0bf391c99$var$Vector;

});



parcelRequire.register("iJGfm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.despawningRules = void 0;
/**
 * Contains a set of pre-defined particle despawning rules.
 */ module.exports.despawningRules = {
    /**
     * A rule that despawns a particle once its lifetime is over.
     */ lifetime: function(particle) {
        return particle.lifetime <= 0;
    },
    /**
     * A rule that despawns a particle once its y-coordinate is outside of the document.
     */ bounds: function(particle) {
        // Get document height: https://stackoverflow.com/a/44077777/5507624
        var height = document.documentElement.scrollHeight;
        return particle.location.y > height;
    }
};

});

parcelRequire.register("j6VSR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lazy = void 0;
/**
 * A wrapper class to lazily initialize a value.
 * Supports custom factory and predicate methods.
 */ var $de9b7a5f06861376$var$Lazy = /** @class */ function() {
    function Lazy(factory, exists) {
        if (exists === void 0) exists = Lazy.defaultExists;
        this.factory = factory;
        this.exists = exists;
    }
    Object.defineProperty(Lazy.prototype, "current", {
        /**
         * The current value of the lazy object. Will be initialized, if the 'exists'
         * predicate doesn't match.
         */ get: function() {
            if (!this.exists(this.value)) this.value = this.factory();
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Lazy.defaultExists = function(value) {
        return typeof value !== "undefined";
    };
    return Lazy;
}();
module.exports.Lazy = $de9b7a5f06861376$var$Lazy;

});




parcelRequire.register("cJl2w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Emitter = void 0;

var $i8nnx = parcelRequire("i8nnx");

var $fvf8u = parcelRequire("fvf8u");

var $8wOWU = parcelRequire("8wOWU");

var $5ddM5 = parcelRequire("5ddM5");

var $lSlyc = parcelRequire("lSlyc");

var $ghZeo = parcelRequire("ghZeo");
/**
 * Represents an emitter that is responsible for spawning and updating particles.
 *
 * Particles themselves are just data-holders, with the system acting upon them and
 * modifying them. The modifications are done mainly via modules, that use the
 * particle's data together with some function to apply temporal transitions.
 *
 * @see Particle
 * @see ParticleModifierModule
 */ var $944a0207881ca63b$var$Emitter = /** @class */ function() {
    /**
     * Creates a new emitter, using default options.
     */ function Emitter(options) {
        /**
         * The particles currently contained within the system.
         */ this.particles = [];
        this.currentLoop = 0; // The current loop index.
        this.durationTimer = 0; // Measures the current runtime duration, to allow loops to reset.
        this.emissionTimer = 0; // Measures the current emission timer, to allow spawning particles in intervals.
        this.attemptedBurstIndices = []; // The indices of the particle bursts that were attempted this loop.
        this.options = $5ddM5.overrideDefaults($lSlyc.getDefaultEmitterOptions(), options === null || options === void 0 ? void 0 : options.emitterOptions);
        this.emission = $5ddM5.overrideDefaults($lSlyc.getDefaultEmissionOptions(), options === null || options === void 0 ? void 0 : options.emissionOptions);
        this.renderer = $5ddM5.overrideDefaults($lSlyc.getDefaultRendererOptions(), options === null || options === void 0 ? void 0 : options.rendererOptions);
    }
    Object.defineProperty(Emitter.prototype, "isExpired", {
        /**
         * Checks if the emitter is already expired and can be removed.
         * Expired emitters do not emit new particles.
         */ get: function() {
            return this.options.loops >= 0 && this.currentLoop >= this.options.loops;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Emitter.prototype, "canRemove", {
        /**
         * Checks if the emitter can safely be removed.
         * This is true if no more particles are active.
         */ get: function() {
            return this.particles.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clears all particles inside the emitter.
     *
     * @returns The number of cleared particles.
     */ Emitter.prototype.clearParticles = function() {
        return this.particles.splice(0).length;
    };
    /**
     * Processes a tick of the emitter, using the elapsed time.
     *
     * @remarks
     * This handles a few things, namely:
     * - Incrementing the duration timer and potentially incrementing the loop.
     * - Handling particle bursts & emissions.
     * - Despawning particles conditionally.
     *
     * @param delta The time, in seconds, passed since the last tick.
     */ Emitter.prototype.tick = function(delta) {
        if (!this.isExpired) {
            this.durationTimer += delta;
            if (this.durationTimer >= this.options.duration) {
                this.currentLoop++;
                // To start a new loop, the duration timer and attempted bursts are reset.
                this.durationTimer = 0;
                this.attemptedBurstIndices = [];
            }
            // We need to check the expiry again, in case the added loop or duration changed something.
            if (!this.isExpired) {
                // Iterate over the bursts, attempting to execute them if the time is ready.
                var burstIndex = 0;
                for(var _i = 0, _a = this.emission.bursts; _i < _a.length; _i++){
                    var burst = _a[_i];
                    if (burst.time <= this.durationTimer) // Has the burst already been attempted? If not ...
                    {
                        if (!this.attemptedBurstIndices.includes(burstIndex)) {
                            // Perform the burst, emitting a variable amount of particles.
                            var count = $8wOWU.evaluateVariation(burst.count);
                            for(var i = 0; i < count; i++)this.emitParticle();
                            // Mark the burst as attempted.
                            this.attemptedBurstIndices.push(burstIndex);
                        }
                    }
                    burstIndex++;
                }
                // Handle the 'emission over time'. By using a while-loop instead of a simple
                // if-condition, we take high deltas into account, and ensure that the correct
                // number of particles will consistently be emitted.
                this.emissionTimer += delta;
                var delay = 1 / this.emission.rate;
                while(this.emissionTimer > delay){
                    this.emissionTimer -= delay;
                    this.emitParticle();
                }
            }
        }
        var _loop_1 = function(i) {
            var particle = this_1.particles[i];
            this_1.tickParticle(particle, delta);
            // Particles should be despawned (i.e. removed from the collection) if any of
            // the despawning rules apply to them.
            if (this_1.options.despawningRules.some(function(rule) {
                return rule(particle);
            })) this_1.particles.splice(i, 1);
        };
        var this_1 = this;
        for(var i = this.particles.length - 1; i >= 0; i--)_loop_1(i);
    };
    /**
     * Performs an internal tick for the particle.
     *
     * @remarks
     * This method controls the particle's lifetime, location and velocity, according
     * to the elapsed delta and the configuration. Additionally, each of the emitter's
     * modules is applied to the particle.
     *
     * @param particle The particle to apply the tick for.
     * @param delta The time, in seconds, passed since the last tick.
     */ Emitter.prototype.tickParticle = function(particle, delta) {
        particle.lifetime -= delta;
        if (this.options.useGravity) // Apply gravitational acceleration to the particle.
        particle.velocity = particle.velocity.add($i8nnx.Vector.up.scale($fvf8u.settings.gravity * delta));
        // Apply the particle's velocity to its location.
        particle.location = particle.location.add(particle.velocity.scale(delta));
        // Apply the modules to the particle.
        for(var _i = 0, _a = this.options.modules; _i < _a.length; _i++){
            var moduleFunction = _a[_i];
            moduleFunction(particle);
        }
    };
    /**
     * Emits a particle using the registered settings.
     * Also may despawn a particle if the maximum number of particles is exceeded.
     */ Emitter.prototype.emitParticle = function() {
        var particle = new $ghZeo.Particle({
            location: this.emission.sourceSampler(),
            lifetime: $8wOWU.evaluateVariation(this.emission.initialLifetime),
            velocity: $i8nnx.Vector.from2dAngle($8wOWU.evaluateVariation(this.emission.angle)).scale($8wOWU.evaluateVariation(this.emission.initialSpeed)),
            size: $8wOWU.evaluateVariation(this.emission.initialSize),
            rotation: $8wOWU.evaluateVariation(this.emission.initialRotation),
            color: $8wOWU.evaluateVariation(this.emission.initialColor)
        });
        this.particles.push(particle);
        // Ensure that no more particles than 'maxParticles' can exist.
        if (this.particles.length > this.options.maxParticles) this.particles.shift();
        return particle;
    };
    return Emitter;
}();
module.exports.Emitter = $944a0207881ca63b$var$Emitter;

});
parcelRequire.register("8wOWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gradientSample = module.exports.splineSample = module.exports.skewRelative = module.exports.skew = module.exports.range = module.exports.evaluateVariation = void 0;

var $8YLYT = parcelRequire("8YLYT");
/**
 * Returns a value instance of a variation.
 */ function $6358d556d8082e1b$var$evaluateVariation(variation) {
    if (Array.isArray(variation)) return $8YLYT.pick(variation);
    if (typeof variation === "function") return variation();
    return variation;
}
module.exports.evaluateVariation = $6358d556d8082e1b$var$evaluateVariation;
/**
 * Creates a variation function that returns a random number from min to max.
 */ function $6358d556d8082e1b$var$range(min, max) {
    return function() {
        return $8YLYT.randomRange(min, max);
    };
}
module.exports.range = $6358d556d8082e1b$var$range;
/**
 * Creates a variation function that skews the specified value by a specified, absolute
 * amount. This means that instead of the value itself, a random number that deviates
 * at most by the specified amount is returned.
 *
 * @remarks
 * If you want to skew by a percentage instead, use `skewRelative`.
 */ function $6358d556d8082e1b$var$skew(value, amount) {
    return function() {
        return value + $8YLYT.randomRange(-amount, amount);
    };
}
module.exports.skew = $6358d556d8082e1b$var$skew;
/**
 * Creates a variation function that skews the specified value by a specified percentage.
 * This means that instead of the value itself, a random number that deviates by a maximum
 * of the specified percentage is returned.
 */ function $6358d556d8082e1b$var$skewRelative(value, percentage) {
    return function() {
        return value * (1 + $8YLYT.randomRange(-percentage, percentage));
    };
}
module.exports.skewRelative = $6358d556d8082e1b$var$skewRelative;
/**
 * Creates a variation function that returns a random sample from the given spline.
 *
 * @param spline The spline to sample from.
 */ function $6358d556d8082e1b$var$splineSample(spline) {
    return function() {
        return spline.evaluate(Math.random());
    };
}
module.exports.splineSample = $6358d556d8082e1b$var$splineSample;
/**
 * Creates a variation function that returns a random sample from the given gradient.
 *
 * @remarks
 * This function is an alias for the spline variation, since a gradient is just
 * a spline under the hood.
 *
 * @param gradient The gradient to sample from.
 */ function $6358d556d8082e1b$var$gradientSample(gradient) {
    return $6358d556d8082e1b$var$splineSample(gradient);
}
module.exports.gradientSample = $6358d556d8082e1b$var$gradientSample;

});
parcelRequire.register("8YLYT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomInsideCircle = module.exports.randomInsideRect = module.exports.randomUnitVector = module.exports.pick = module.exports.randomRange = void 0;

var $krtLn = parcelRequire("krtLn");

var $6wW8p = parcelRequire("6wW8p");
/**
 * Returns a random value from min to max.
 */ function $68992560cde2eab4$var$randomRange(min, max) {
    if (min === void 0) min = 0;
    if (max === void 0) max = 1;
    return $6wW8p.lerp(min, max, Math.random());
}
module.exports.randomRange = $68992560cde2eab4$var$randomRange;
/**
 * Picks a random element from the specified array. Returns undefined if the array is empty.
 */ function $68992560cde2eab4$var$pick(arr) {
    return arr.length === 0 ? undefined : arr[Math.floor(Math.random() * arr.length)];
}
module.exports.pick = $68992560cde2eab4$var$pick;
/**
 * Returns a random unit vector.
 */ function $68992560cde2eab4$var$randomUnitVector() {
    var theta = $68992560cde2eab4$var$randomRange(0, 2 * Math.PI);
    var z = $68992560cde2eab4$var$randomRange(-1, 1);
    return new $krtLn.Vector(Math.sqrt(1 - z * z) * Math.cos(theta), Math.sqrt(1 - z * z) * Math.sin(theta), z);
}
module.exports.randomUnitVector = $68992560cde2eab4$var$randomUnitVector;
/**
 * Returns a random point inside the given rect.
 */ function $68992560cde2eab4$var$randomInsideRect(rect) {
    return new $krtLn.Vector(rect.x + $68992560cde2eab4$var$randomRange(0, rect.width), rect.y + $68992560cde2eab4$var$randomRange(0, rect.height));
}
module.exports.randomInsideRect = $68992560cde2eab4$var$randomInsideRect;
function $68992560cde2eab4$var$randomInsideCircle(circle) {
    var theta = $68992560cde2eab4$var$randomRange(0, 2 * Math.PI);
    var radius = $68992560cde2eab4$var$randomRange(0, circle.radius);
    return new $krtLn.Vector(circle.x + Math.cos(theta) * radius, circle.y + Math.sin(theta) * radius);
}
module.exports.randomInsideCircle = $68992560cde2eab4$var$randomInsideCircle;

});


parcelRequire.register("lSlyc", function(module, exports) {
"use strict";
var $fecf5ba140acde92$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fecf5ba140acde92$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fecf5ba140acde92$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fecf5ba140acde92$var$__exportStar((parcelRequire("jB3km")), module.exports);

$fecf5ba140acde92$var$__exportStar((parcelRequire("hfczU")), module.exports);

$fecf5ba140acde92$var$__exportStar((parcelRequire("6n594")), module.exports);

});
parcelRequire.register("jB3km", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultEmitterOptions = void 0;

var $iJGfm = parcelRequire("iJGfm");
/**
 * Returns the default set of emitter options.
 */ function $e4440dc7a69db5bd$var$getDefaultEmitterOptions() {
    return {
        duration: 5,
        loops: 1,
        useGravity: true,
        maxParticles: 300,
        despawningRules: [
            $iJGfm.despawningRules.lifetime,
            $iJGfm.despawningRules.bounds
        ],
        modules: []
    };
}
module.exports.getDefaultEmitterOptions = $e4440dc7a69db5bd$var$getDefaultEmitterOptions;

});

parcelRequire.register("hfczU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultEmissionOptions = void 0;

var $krtLn = parcelRequire("krtLn");

var $lcJ00 = parcelRequire("lcJ00");
/**
 * Returns the default set of emission options.
 */ function $c8dd98250d871f3e$var$getDefaultEmissionOptions() {
    return {
        rate: 10,
        angle: 0,
        bursts: [],
        sourceSampler: $lcJ00.rectSource($krtLn.Rect.zero),
        initialLifetime: 5,
        initialSpeed: 5,
        initialSize: 1,
        initialRotation: $krtLn.Vector.zero,
        initialColor: $krtLn.Color.white
    };
}
module.exports.getDefaultEmissionOptions = $c8dd98250d871f3e$var$getDefaultEmissionOptions;

});
parcelRequire.register("lcJ00", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circleSource = module.exports.rectSource = module.exports.mouseSource = module.exports.elementSource = module.exports.dynamicSource = void 0;

var $krtLn = parcelRequire("krtLn");

var $8YLYT = parcelRequire("8YLYT");
/**
 * Dynamically infers a source sampler for the specified source type.
 */ function $f6fd9fdd01d07a4d$var$dynamicSource(source) {
    if (source instanceof HTMLElement) return $f6fd9fdd01d07a4d$var$elementSource(source);
    if (source instanceof $krtLn.Circle) return $f6fd9fdd01d07a4d$var$circleSource(source);
    if (source instanceof $krtLn.Rect) return $f6fd9fdd01d07a4d$var$rectSource(source);
    if (source instanceof MouseEvent) return $f6fd9fdd01d07a4d$var$mouseSource(source);
    throw new Error("Cannot infer the source type of '" + source + "'.");
}
module.exports.dynamicSource = $f6fd9fdd01d07a4d$var$dynamicSource;
/**
 * Creates a sampler to retrieve random points inside a specified HTMLElement.
 */ function $f6fd9fdd01d07a4d$var$elementSource(source) {
    return function() {
        return $8YLYT.randomInsideRect($krtLn.Rect.fromElement(source));
    };
}
module.exports.elementSource = $f6fd9fdd01d07a4d$var$elementSource;
/**
 * Creates a sampler to retrieve the position of a mouse event.
 */ function $f6fd9fdd01d07a4d$var$mouseSource(source) {
    return function() {
        return new $krtLn.Vector(window.scrollX + source.clientX, window.scrollY + source.clientY);
    };
}
module.exports.mouseSource = $f6fd9fdd01d07a4d$var$mouseSource;
/**
 * Creates a sampler to retrieve random points inside a specified rectangle.
 */ function $f6fd9fdd01d07a4d$var$rectSource(source) {
    return function() {
        return $8YLYT.randomInsideRect(source);
    };
}
module.exports.rectSource = $f6fd9fdd01d07a4d$var$rectSource;
/**
 * Creates a sampler to retrieve random points inside a specified circle.
 */ function $f6fd9fdd01d07a4d$var$circleSource(source) {
    return function() {
        return $8YLYT.randomInsideCircle(source);
    };
}
module.exports.circleSource = $f6fd9fdd01d07a4d$var$circleSource;

});


parcelRequire.register("6n594", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultRendererOptions = void 0;
/**
 * Returns the default set of renderer options.
 */ function $4a38e1cb5f49b627$var$getDefaultRendererOptions() {
    return {
        shapeFactory: "square",
        applyColor: $4a38e1cb5f49b627$var$defaultApplyColor,
        applyOpacity: $4a38e1cb5f49b627$var$defaultApplyOpacity,
        applyLighting: $4a38e1cb5f49b627$var$defaultApplyLighting,
        applyTransform: $4a38e1cb5f49b627$var$defaultApplyTransform
    };
}
module.exports.getDefaultRendererOptions = $4a38e1cb5f49b627$var$getDefaultRendererOptions;
/**
 * Applies the specified color to the element.
 *
 * @remarks
 * This function is aware of the element's node type:
 * - `div` elements have their `background` set.
 * - `svg` elements have their `fill` and `color` set.
 * - Other elements have their `color` set.
 */ function $4a38e1cb5f49b627$var$defaultApplyColor(color, element) {
    var hex = color.toHex();
    // Note that by default, HTML node names are uppercase.
    switch(element.nodeName.toLowerCase()){
        case "div":
            element.style.background = hex;
            break;
        case "svg":
            element.style.fill = element.style.color = hex;
            break;
        default:
            element.style.color = hex;
            break;
    }
}
/**
 * Applies the specified opacity to the element.
 */ function $4a38e1cb5f49b627$var$defaultApplyOpacity(opacity, element) {
    element.style.opacity = opacity.toString();
}
/**
 * Applies the specified lighting to the element as a brightness filter.
 *
 * @remarks
 * This function assumes an ambient light with intensity 0.5, and that the
 * particle should be lit from both sides. The brightness filter can exceed 1,
 * to give the particles a "glossy" feel.
 */ function $4a38e1cb5f49b627$var$defaultApplyLighting(lighting, element) {
    element.style.filter = "brightness(" + (0.5 + Math.abs(lighting)) + ")";
}
/**
 * Applies the specified transform to the element as a 3D CSS transform.
 * Also takes into account the current window scroll, to make sure that particles are
 * rendered inside of the fixed container.
 */ function $4a38e1cb5f49b627$var$defaultApplyTransform(particle, element) {
    element.style.transform = // Make sure to take window scrolling into account.
    "translateX(" + (particle.location.x - window.scrollX).toFixed(3) + "px) " + ("translateY(" + (particle.location.y - window.scrollY).toFixed(3) + "px) ") + ("translateZ(" + particle.location.z.toFixed(3) + "px) ") + ("rotateX(" + particle.rotation.x.toFixed(3) + "deg) ") + ("rotateY(" + particle.rotation.y.toFixed(3) + "deg) ") + ("rotateZ(" + particle.rotation.z.toFixed(3) + "deg) ") + ("scale(" + particle.size.toFixed(3) + ")");
}

});


parcelRequire.register("ghZeo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Particle = void 0;

var $krtLn = parcelRequire("krtLn");

var $5ddM5 = parcelRequire("5ddM5");
/**
 * Represents an emitted particle.
 */ var $bdbdbb1e2a3d9bc2$var$Particle = /** @class */ function() {
    /**
     * Creates a new particle instance through the specified options.
     */ function Particle(options) {
        var populatedOptions = $5ddM5.overrideDefaults({
            lifetime: 0,
            size: 1,
            location: $krtLn.Vector.zero,
            rotation: $krtLn.Vector.zero,
            velocity: $krtLn.Vector.zero,
            color: $krtLn.Color.white,
            opacity: 1
        }, options);
        // Generate a symbolic ID.
        this.id = Symbol();
        // Assign various properties, together with some initials for later reference.
        this.size = this.initialSize = populatedOptions.size;
        this.lifetime = this.initialLifetime = populatedOptions.lifetime;
        this.rotation = this.initialRotation = populatedOptions.rotation;
        this.location = populatedOptions.location;
        this.velocity = populatedOptions.velocity;
        this.color = populatedOptions.color;
        this.opacity = populatedOptions.opacity;
    }
    return Particle;
}();
module.exports.Particle = $bdbdbb1e2a3d9bc2$var$Particle;

});


parcelRequire.register("jQKEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Renderer = void 0;

var $7aRnb = parcelRequire("7aRnb");

var $i8nnx = parcelRequire("i8nnx");

var $3K9ck = parcelRequire("3K9ck");

var $hi7H6 = parcelRequire("hi7H6");

var $hFcRm = parcelRequire("hFcRm");
/**
 * Represents a renderer used to draw particles to the DOM via HTML
 * elements. Additionally, it is responsible for purging the elements
 * of destroyed particles from the DOM.
 */ var $e7370f38e9be7d74$var$Renderer = /** @class */ function() {
    function Renderer() {
        /**
         * The lookup of elements currently handled by the renderer, with the
         * particle ID as key and a HTMLElement as the value.
         */ this.elements = new Map();
        /**
         * The normalized direction the light comes from.
         */ this.light = new $i8nnx.Vector(0, 0, 1);
        /**
         * Whether or not the renderer should actually draw particles.
         */ this.enabled = true;
        // Respect that users might prefer reduced motion.
        // See: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
        this.enabled = !$7aRnb.settings.respectReducedMotion || !window.matchMedia("(prefers-reduced-motion)").matches;
    }
    /**
     * Begins a new render block. During the rendering phase, a list of rendered particles
     * is tracked, so that stale particles can be removed later.
     */ Renderer.prototype.begin = function() {
        this.renderedParticles = [];
    };
    /**
     * Terminates an existing render block. This checks which particles were rendered
     * during the block and purges all unused HTMLElements from the DOM.
     *
     * @returns The amount of particles that were rendered.
     */ Renderer.prototype.end = function() {
        var it = this.elements.keys();
        var result = it.next();
        while(!result.done){
            var id = result.value;
            if (!this.renderedParticles.includes(id)) {
                this.elements.get(id).remove();
                this.elements.delete(id);
            }
            result = it.next();
        }
        return this.renderedParticles.length;
    };
    /**
     * Renders an individual particle to the DOM. If the particle is rendered for the first
     * time, a HTMLElement will be created using the emitter's render settings.
     *
     * @param particle The particle to be rendered.
     * @param emitter The system containing the particle.
     */ Renderer.prototype.renderParticle = function(particle, emitter) {
        if (!this.enabled) return;
        var options = emitter.renderer;
        // Ensure that an element for the particle exists.
        var element = this.elements.has(particle.id) ? this.elements.get(particle.id) : this.createParticleElement(particle, options);
        if (options.applyColor) // If the options offer a coloring method, apply it.
        options.applyColor(particle.color, element);
        if (options.applyOpacity) // If the options offer an opacity modifying method, apply it.
        options.applyOpacity(particle.opacity, element);
        if (options.applyLighting) {
            // If the options offer a lighting method, apply it.
            // Lighting is calculated as a combination of the particle's normal
            // direction and the lighting direction.
            var normal = $hFcRm.rotationToNormal(particle.rotation);
            var lightingCoefficient = normal.dot(this.light);
            options.applyLighting(lightingCoefficient, element);
        }
        if (options.applyTransform) // If the options offer a transformation method, apply it.
        // This ensures the particle is rendered at the correct position with the correct rotation.
        options.applyTransform(particle, element);
        // Mark the particle as rendered.
        this.renderedParticles.push(particle.id);
    };
    /**
     * Creates the HTMLElement for a particle that does not have one already.
     */ Renderer.prototype.createParticleElement = function(particle, options) {
        // Resolve the element returned from the factory.
        var resolved = $hi7H6.resolveShapeFactory(options.shapeFactory);
        // Clone the node to ensure we do not break existing elements.
        var element = resolved.cloneNode(true);
        // Ensure that the elements can be "stacked" ontop of eachother.
        element.style.position = "absolute";
        // Register the new element in the map, while appending the new element to the DOM.
        this.elements.set(particle.id, $3K9ck.particleContainer.current.appendChild(element));
        return element;
    };
    return Renderer;
}();
module.exports.Renderer = $e7370f38e9be7d74$var$Renderer;

});
parcelRequire.register("hi7H6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveShapeFactory = module.exports.resolvableShapes = void 0;

var $8wOWU = parcelRequire("8wOWU");
/**
 * Represents the lookup that maps resolveable element keys to their HTML strings.
 *
 * @remarks
 * The default shapes are made to fit inside a dimension of 10x10 pixels, except
 * the 'star' shape, which exceeds it slightly.
 */ module.exports.resolvableShapes = {
    square: '<div style="height: 10px; width: 10px;"></div>',
    rectangle: '<div style="height: 6px; width: 10px;"></div>',
    circle: '<svg viewBox="0 0 2 2" width="10" height="10"><circle cx="1" cy="1" r="1" fill="currentColor"/></svg>',
    roundedSquare: '<div style="height: 10px; width: 10px; border-radius: 3px;"></div>',
    roundedRectangle: '<div style="height: 6px; width: 10px; border-radius: 3px;"></div>',
    star: '<svg viewBox="0 0 512 512" width="15" height="15"><polygon fill="currentColor" points="512,197.816 325.961,185.585 255.898,9.569 185.835,185.585 0,197.816 142.534,318.842 95.762,502.431 255.898,401.21 416.035,502.431 369.263,318.842"/></svg>'
};
/**
 * Resolves the specified element factory using the resolvable elements, if needed.
 */ function $c96a160467acc9a5$var$resolveShapeFactory(factory) {
    // Retrieve the unresolved element from the factory.
    var shape = $8wOWU.evaluateVariation(factory);
    // If a string is returned, we need to resolve the element. This means
    // looking up the string in the resolver lookup. If the key was not
    // resolvable, we throw an error.
    if (typeof shape === "string") {
        var resolved = module.exports.resolvableShapes[shape];
        if (!resolved) throw new Error("Failed to resolve shape key '" + shape + "'. Did you forget to add it to the 'resolvableShapes' lookup?");
        // We're in luck, we can resolve the element! We create a dummy <div> element
        // to set the innerHTML of, and return the first element child.
        var dummy = document.createElement("div");
        dummy.innerHTML = resolved;
        return dummy.firstElementChild;
    }
    return shape;
}
module.exports.resolveShapeFactory = $c96a160467acc9a5$var$resolveShapeFactory;

});



parcelRequire.register("ih6Wa", function(module, exports) {
"use strict";
var $d4df321a5b23e21d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d4df321a5b23e21d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d4df321a5b23e21d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d4df321a5b23e21d$var$__exportStar((parcelRequire("irAmy")), module.exports);

$d4df321a5b23e21d$var$__exportStar((parcelRequire("9zyvK")), module.exports);

});
parcelRequire.register("irAmy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.confetti = void 0;

var $7aRnb = parcelRequire("7aRnb");

var $krtLn = parcelRequire("krtLn");

var $7G4Sq = parcelRequire("7G4Sq");

var $8YLYT = parcelRequire("8YLYT");

var $lcJ00 = parcelRequire("lcJ00");

var $8wOWU = parcelRequire("8wOWU");

var $hFcRm = parcelRequire("hFcRm");
/**
 * The standard confetti template.
 *
 * @param source The source to emit the confetti from.
 * @param options The (optional) configuration overrides.
 */ function $d6d6f47b8185e636$var$confetti(source, options) {
    var populated = $hFcRm.overrideDefaults({
        count: $8wOWU.range(20, 40),
        spread: $8wOWU.range(35, 45),
        speed: $8wOWU.range(300, 600),
        size: $8wOWU.skew(1, 0.2),
        rotation: function() {
            return $8YLYT.randomUnitVector().scale(180);
        },
        color: function() {
            return $krtLn.Color.fromHsl($8YLYT.randomRange(0, 360), 100, 70);
        },
        modules: [
            new $7G4Sq.ModuleBuilder().drive("size").by(function(t) {
                return Math.min(1, t * 3);
            }).relative().build(),
            new $7G4Sq.ModuleBuilder().drive("rotation").by(function(t) {
                return new $krtLn.Vector(140, 200, 260).scale(t);
            }).relative().build()
        ],
        shapes: [
            "square",
            "circle"
        ]
    }, options);
    var emitter = $7aRnb.scene.current.createEmitter({
        emitterOptions: {
            loops: 1,
            duration: 8,
            modules: populated.modules
        },
        emissionOptions: {
            rate: 0,
            bursts: [
                {
                    time: 0,
                    count: populated.count
                }
            ],
            sourceSampler: $lcJ00.dynamicSource(source),
            angle: $8wOWU.skew(-90, $8wOWU.evaluateVariation(populated.spread)),
            initialLifetime: 8,
            initialSpeed: populated.speed,
            initialSize: populated.size,
            initialRotation: populated.rotation,
            initialColor: populated.color
        },
        rendererOptions: {
            shapeFactory: populated.shapes
        }
    });
    return emitter;
}
module.exports.confetti = $d6d6f47b8185e636$var$confetti;

});
parcelRequire.register("7G4Sq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleBuilder = void 0;

var $krtLn = parcelRequire("krtLn");
/**
 * Represents a builder for particle modules. Returns an evaluatable module
 * function, that can be consumed by emitters.
 *
 * @remarks
 * Not all properties can be driven. TypeScript will validate this at compile time,
 * but no internal validation is performed due to performance reasons. Also, note
 * that the driving factor is "lifetime" by default.
 *
 * @example
 * ```ts
 * new ModuleBuilder()
 *     .drive("size")
 *     .by((t) => t * 2)
 *     .through("lifetime")
 *     .build();
 * ```
 */ var $59703d1a75b5afb7$var$ModuleBuilder = /** @class */ function() {
    function ModuleBuilder() {
        /**
         * The factor driving the built function.
         *
         * @defaultValue "lifetime"
         */ this.factor = "lifetime";
        this.isRelative = false;
    }
    /**
     * Specifies the key in the particle that should be driven.
     *
     * @remarks
     * Note that not all of a particle's properties are drivable through modules. If you
     * need full control of a particle inside of a module, you can use a module function directly.
     *
     * @returns The chained builder instance.
     */ ModuleBuilder.prototype.drive = function(key) {
        this.driverKey = key;
        return this;
    };
    /**
     * Specifies the factor to drive the evaluated value by. Supports "lifetime" and "size".
     *
     * @returns The chained builder instance.
     */ ModuleBuilder.prototype.through = function(factor) {
        this.factor = factor;
        return this;
    };
    /**
     * Specifies the value to drive the module behaviour by. This can be a constant,
     * a spline or an evaluable function. Note that in the last case, the driving
     * factor is passed as a parameter.
     *
     * @returns The chained builder instance.
     */ ModuleBuilder.prototype.by = function(driver) {
        this.driverValue = driver;
        return this;
    };
    /**
     * Specifies that the module function is supposed to act relative to the
     * properties initial value.
     *
     * @remarks
     * Note that this is only possible if an "initial*" property exists on the
     * particle object. The operation applied to the initial and new value
     * is dependant on their type:
     * - `Vector`: Both vectors are added.
     * - `number`: Both numbers are multiplied.
     *
     * For more advanced relative customizations, consider using the particle
     * object in the driver value function instead, like:
     * ```ts
     * .by((t, p) => p.initialSize + t * 2);
     * ```
     */ ModuleBuilder.prototype.relative = function(isRelative) {
        if (isRelative === void 0) isRelative = true;
        this.isRelative = isRelative;
        return this;
    };
    /**
     * Consumes the builder and returns an evaluatable module function.
     *
     * @remarks
     * Note that you need to specify the driving key and value, otherwise an error
     * will be thrown.
     */ ModuleBuilder.prototype.build = function() {
        var _this = this;
        if (typeof this.driverKey === "undefined") throw new Error("No driving key was provided in the module builder. Did you forget a '.drive()' call?");
        if (typeof this.driverValue === "undefined") throw new Error("No driving value was provided in the module builder. Did you forget a '.through()' call?");
        return function(particle) {
            $59703d1a75b5afb7$var$updateDrivenProperty(particle, _this.driverKey, $59703d1a75b5afb7$var$evaluateModuleDriver(_this.driverValue, $59703d1a75b5afb7$var$calculateModuleFactor(_this.factor, particle), particle), _this.isRelative);
        };
    };
    return ModuleBuilder;
}();
module.exports.ModuleBuilder = $59703d1a75b5afb7$var$ModuleBuilder;
/**
 * Evaluates the module driver using a specified factor.
 */ function $59703d1a75b5afb7$var$evaluateModuleDriver(driver, factor, particle) {
    if (typeof driver === "object" && "evaluate" in driver) return driver.evaluate(factor);
    if (typeof driver === "function") return driver(factor, particle);
    return driver;
}
/**
 * Calculates a module factor using a specified particle as context.
 */ function $59703d1a75b5afb7$var$calculateModuleFactor(factor, particle) {
    switch(factor){
        case "lifetime":
            return particle.initialLifetime - particle.lifetime;
        case "relativeLifetime":
            return (particle.initialLifetime - particle.lifetime) / particle.initialLifetime;
        case "size":
            return particle.size;
        default:
            throw new Error("Invalid driving factor '" + factor + "'.");
    }
}
/**
 * Updates a driven property of a particle using the specified value.
 *
 * @remarks
 * If the operation is marked as relative, the function infers the new value
 * through the value's type. Note that relative properties must have a
 * corresponding "initial*" value in the particle's properties.
 */ function $59703d1a75b5afb7$var$updateDrivenProperty(particle, key, value, relative) {
    if (relative === void 0) relative = false;
    if (!relative) particle[key] = value;
    else {
        var initial = particle["initial" + key[0].toUpperCase() + key.substr(1)];
        if (typeof initial === "undefined") throw new Error("Unable to use relative chaining with key '" + key + "'; no initial value exists.");
        if (value instanceof $krtLn.Vector) $59703d1a75b5afb7$var$updateDrivenProperty(particle, key, initial.add(value));
        else if (typeof value === "number") $59703d1a75b5afb7$var$updateDrivenProperty(particle, key, initial * value);
        else throw new Error("Unable to use relative chaining with particle key '" + key + "'; no relative operation for '" + value + "' could be inferred.");
    }
}

});


parcelRequire.register("9zyvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sparkles = void 0;

var $7aRnb = parcelRequire("7aRnb");

var $krtLn = parcelRequire("krtLn");

var $7G4Sq = parcelRequire("7G4Sq");

var $8YLYT = parcelRequire("8YLYT");

var $lcJ00 = parcelRequire("lcJ00");

var $8wOWU = parcelRequire("8wOWU");

var $hFcRm = parcelRequire("hFcRm");
/**
 * The standard sparkles template.
 *
 * @param source The source to emit the sparkles from.
 * @param options The (optional) configuration overrides.
 */ function $6f822720a9639236$var$sparkles(source, options) {
    var populated = $hFcRm.overrideDefaults({
        lifetime: $8wOWU.range(1, 2),
        count: $8wOWU.range(10, 20),
        speed: $8wOWU.range(100, 200),
        size: $8wOWU.range(0.8, 1.8),
        rotation: function() {
            return new $krtLn.Vector(0, 0, $8YLYT.randomRange(0, 360));
        },
        color: function() {
            return $krtLn.Color.fromHsl(50, 100, $8YLYT.randomRange(55, 85));
        },
        modules: [
            new $7G4Sq.ModuleBuilder().drive("rotation").by(function(t) {
                return new $krtLn.Vector(0, 0, 200).scale(t);
            }).relative().build(),
            new $7G4Sq.ModuleBuilder().drive("size").by(new $krtLn.NumericSpline({
                time: 0,
                value: 0
            }, {
                time: 0.3,
                value: 1
            }, {
                time: 0.7,
                value: 1
            }, {
                time: 1,
                value: 0
            })).through("relativeLifetime").relative().build(),
            new $7G4Sq.ModuleBuilder().drive("opacity").by(new $krtLn.NumericSpline({
                time: 0,
                value: 1
            }, {
                time: 0.5,
                value: 1
            }, {
                time: 1,
                value: 0
            })).through("relativeLifetime").build()
        ],
        shapes: "star"
    }, options);
    var emitter = $7aRnb.scene.current.createEmitter({
        emitterOptions: {
            loops: 1,
            duration: 3,
            useGravity: false,
            modules: populated.modules
        },
        emissionOptions: {
            rate: 0,
            bursts: [
                {
                    time: 0,
                    count: populated.count
                }
            ],
            sourceSampler: $lcJ00.dynamicSource(source),
            angle: $8wOWU.range(0, 360),
            initialLifetime: populated.lifetime,
            initialSpeed: populated.speed,
            initialSize: populated.size,
            initialRotation: populated.rotation,
            initialColor: populated.color
        },
        rendererOptions: {
            applyLighting: undefined,
            shapeFactory: populated.shapes
        }
    });
    return emitter;
}
module.exports.sparkles = $6f822720a9639236$var$sparkles;

});



// Must be loaded before anything else
// See https://polkadot.js.org/docs/api/FAQ/#since-upgrading-to-the-7x-series-typescript-augmentation-is-missing
var $3c47adbabe8a32cb$exports = {};
"use strict";

$3c47adbabe8a32cb$exports = (parcelRequire("hi5z5"));






var $4Iuzv = parcelRequire("4Iuzv");
var $21fa618cfc67d6ae$export$882461b6382ed46c;
var $21fa618cfc67d6ae$export$757ceba2d55c277e;
"use strict";
var $d0525dc7624af49b$exports = {};
"use strict";
function $d0525dc7624af49b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0525dc7624af49b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0525dc7624af49b$var$checkDCE();

$d0525dc7624af49b$exports = (parcelRequire("68oCn"));


var $21fa618cfc67d6ae$var$i;
$21fa618cfc67d6ae$export$882461b6382ed46c = $d0525dc7624af49b$exports.createRoot;
$21fa618cfc67d6ae$export$757ceba2d55c277e = $d0525dc7624af49b$exports.hydrateRoot;





var $4Iuzv = parcelRequire("4Iuzv");

var $hWfed = parcelRequire("hWfed");
var $ea63bfbf68f64a41$export$1cf59a6acd43f5f;
(function(Conviction) {
    Conviction[Conviction[/// 0.1x votes, unlocked.
    "None"] = 0] = "None";
    Conviction[Conviction[/// 1x votes, locked for an enactment period following a successful vote.
    "Locked1x"] = 1] = "Locked1x";
    Conviction[Conviction[/// 2x votes, locked for 2x enactment periods following a successful vote.
    "Locked2x"] = 2] = "Locked2x";
    Conviction[Conviction[/// 3x votes, locked for 4x...
    "Locked3x"] = 3] = "Locked3x";
    Conviction[Conviction[/// 4x votes, locked for 8x...
    "Locked4x"] = 4] = "Locked4x";
    Conviction[Conviction[/// 5x votes, locked for 16x...
    "Locked5x"] = 5] = "Locked5x";
    Conviction[Conviction[/// 6x votes, locked for 32x...
    "Locked6x"] = 6] = "Locked6x";
})($ea63bfbf68f64a41$export$1cf59a6acd43f5f || ($ea63bfbf68f64a41$export$1cf59a6acd43f5f = {}));


/**
 * @name objectSpread
 * @summary Concats all sources into the destination
 */ function $0dc68258eafd8717$export$5e8a1629c9c35a19(dest, ...sources) {
    for(let i = 0, count = sources.length; i < count; i++){
        const src = sources[i];
        if (src) {
            if (typeof src.entries === "function") for (const [key, value] of src.entries())dest[key] = value;
            else Object.assign(dest, src);
        }
    }
    return dest;
}


/**
 * @name isString
 * @summary Tests for a string.
 * @description
 * Checks to see if the input value is a JavaScript string.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isString } from '@polkadot/util';
 *
 * console.log('isString', isString('test')); // => true
 * ```
 */ function $0d672af39bfe8283$export$844ec244b1367d54(value) {
    return typeof value === "string" || value instanceof String;
}

const $1e2cfad286c009ca$var$U8 = new Array(256);
const $1e2cfad286c009ca$var$U16 = new Array(65536);
for(let n = 0; n < 256; n++)$1e2cfad286c009ca$var$U8[n] = n.toString(16).padStart(2, "0");
for(let i = 0; i < 256; i++){
    const s = i << 8;
    for(let j = 0; j < 256; j++)$1e2cfad286c009ca$var$U16[s | j] = $1e2cfad286c009ca$var$U8[i] + $1e2cfad286c009ca$var$U8[j];
}
/** @internal */ function $1e2cfad286c009ca$var$hex(value, result) {
    const mod = value.length % 2 | 0;
    const length = value.length - mod | 0;
    for(let i = 0; i < length; i += 2)result += $1e2cfad286c009ca$var$U16[value[i] << 8 | value[i + 1]];
    if (mod) result += $1e2cfad286c009ca$var$U8[value[length] | 0];
    return result;
}
function $1e2cfad286c009ca$export$4429d284633899e1(value, bitLength = -1, isPrefixed = true) {
    // this is not 100% correct sinmce we support isPrefixed = false....
    const empty = isPrefixed ? "0x" : "";
    if (!value || !value.length) return empty;
    else if (bitLength > 0) {
        const length = Math.ceil(bitLength / 8);
        if (value.length > length) return `${$1e2cfad286c009ca$var$hex(value.subarray(0, length / 2), empty)}…${$1e2cfad286c009ca$var$hex(value.subarray(value.length - length / 2), "")}`;
    }
    return $1e2cfad286c009ca$var$hex(value, empty);
}

const $c70fb13b09c6b2c8$var$CHR = "0123456789abcdef";
const $c70fb13b09c6b2c8$var$U8 = new Uint8Array(256);
const $c70fb13b09c6b2c8$var$U16 = new Uint8Array(65536);
for(let i = 0, count = $c70fb13b09c6b2c8$var$CHR.length; i < count; i++){
    $c70fb13b09c6b2c8$var$U8[$c70fb13b09c6b2c8$var$CHR[i].charCodeAt(0) | 0] = i | 0;
    if (i > 9) $c70fb13b09c6b2c8$var$U8[$c70fb13b09c6b2c8$var$CHR[i].toUpperCase().charCodeAt(0) | 0] = i | 0;
}
for(let i = 0; i < 256; i++){
    const s = i << 8;
    for(let j = 0; j < 256; j++)$c70fb13b09c6b2c8$var$U16[s | j] = $c70fb13b09c6b2c8$var$U8[i] << 4 | $c70fb13b09c6b2c8$var$U8[j];
}
function $c70fb13b09c6b2c8$export$fbca403d18cdd700(value, bitLength = -1) {
    if (!value) return new Uint8Array();
    let s = value.startsWith("0x") ? 2 : 0;
    const decLength = Math.ceil((value.length - s) / 2);
    const endLength = Math.ceil(bitLength === -1 ? decLength : bitLength / 8);
    const result = new Uint8Array(endLength);
    const offset = endLength > decLength ? endLength - decLength : 0;
    for(let i = offset; i < endLength; i++, s += 2)// The big factor here is actually the string lookups. If we do
    // HEX_TO_U16[value.substring()] we get an 10x slowdown. In the
    // same vein using charCodeAt (as opposed to value[s] or value.charAt(s)) is
    // also the faster operation by at least 2x with the character map above
    result[i] = $c70fb13b09c6b2c8$var$U16[value.charCodeAt(s) << 8 | value.charCodeAt(s + 1)];
    return result;
}



/** @internal Last-resort "this", if it gets here it probably would fail anyway */ function $9ce44c51a85397c6$var$evaluateThis(fn) {
    return fn("return this");
}
const $9ce44c51a85397c6$export$51e5d554977815ce = /*#__PURE__*/ typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $9ce44c51a85397c6$var$evaluateThis(Function);
function $9ce44c51a85397c6$export$157d08edb917d81(name, fallback) {
    // Not quite sure why this is here - snuck in with TS 4.7.2 with no real idea
    // (as of now) as to why this looks like an "any" when we do cast it to a T
    //
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return typeof $9ce44c51a85397c6$export$51e5d554977815ce[name] === "undefined" ? fallback : $9ce44c51a85397c6$export$51e5d554977815ce[name];
}
function $9ce44c51a85397c6$export$89c2709f9d51d171(name, fallback) {
    if (typeof $9ce44c51a85397c6$export$51e5d554977815ce[name] === "undefined") $9ce44c51a85397c6$export$51e5d554977815ce[name] = fallback;
}




/**
 * @internal
 *
 * There are _still_ some older environments (specifically RN < 0.70), that does
 * not have proper BigInt support - a non-working fallback is provided for those.
 *
 * We detect availability of BigInt upon usage, so this is purely to allow functional
 * compilation & bundling. Since we have operators such as *+-/ top-level, a number-ish
 * result is used here.
 */ function $1a9b914c03c95c37$var$invalidFallback() {
    return Number.NaN;
}
const $1a9b914c03c95c37$export$2eb24fc24c69cb4d = /*#__PURE__*/ (0, $9ce44c51a85397c6$export$157d08edb917d81)("BigInt", $1a9b914c03c95c37$var$invalidFallback);



var $6574c8753d85e60c$var$__dirname = "node_modules/@polkadot/util";
const $6574c8753d85e60c$export$c50f41259082745b = typeof (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d) === "function" && typeof (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d).asIntN === "function";
const $6574c8753d85e60c$export$5d6811bb7f556252 = true;
const $6574c8753d85e60c$export$b30b9665a6ed8596 = typeof $6574c8753d85e60c$var$__dirname !== "undefined";
const $6574c8753d85e60c$export$f238320fe9999171 = !$6574c8753d85e60c$export$5d6811bb7f556252;
const $6574c8753d85e60c$export$f5c02881c55e08bb = typeof WebAssembly !== "undefined";
const $6574c8753d85e60c$export$a09f058e8ecd2d7b = typeof (0, $9ce44c51a85397c6$export$51e5d554977815ce).Buffer === "function" && typeof (0, $9ce44c51a85397c6$export$51e5d554977815ce).Buffer.isBuffer === "function";
const $6574c8753d85e60c$export$7af020c88c16a8f7 = typeof (0, $9ce44c51a85397c6$export$51e5d554977815ce).process === "object";


/**
 * @name isFunction
 * @summary Tests for a `function`.
 * @description
 * Checks to see if the input value is a JavaScript function.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isFunction } from '@polkadot/util';
 *
 * isFunction(() => false); // => true
 * ```
 */ function $7539b0fce3dae361$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}


function $b0b2c84d8719d979$export$a7884ebc965f8f54(value) {
    // we do check a function first, since it is slightly faster than isBuffer itself
    return (0, $6574c8753d85e60c$export$a09f058e8ecd2d7b) && !!value && (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value.readDoubleLE) && (0, $9ce44c51a85397c6$export$51e5d554977815ce).Buffer.isBuffer(value);
}


const $de053f8bd7fe9927$export$aeee3e57f1b0a4e5 = /^0x[\da-fA-F]+$/;
const $de053f8bd7fe9927$export$cfe92fa222ae2d9 = /^[\da-fA-F]+$/;
function $de053f8bd7fe9927$export$8a9b6341a7c96bc(value, bitLength = -1, ignoreLength) {
    return typeof value === "string" && (value === "0x" || $de053f8bd7fe9927$export$aeee3e57f1b0a4e5.test(value)) && (bitLength === -1 ? ignoreLength || value.length % 2 === 0 : value.length === 2 + Math.ceil(bitLength / 4));
}


/**
 * @name isU8a
 * @summary Tests for a `Uint8Array` object instance.
 * @description
 * Checks to see if the input object is an instance of `Uint8Array`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isUint8Array } from '@polkadot/util';
 *
 * console.log('isU8a', isU8a([])); // => false
 * ```
 */ function $ad964ef63ebabd4e$export$f5328759db5e050d(value) {
    // here we defer the instanceof check which is actually slightly
    // slower than just checking the constrctor (direct instances)
    return (value && value.constructor) === Uint8Array || value instanceof Uint8Array;
}



class $f11bc49a7236d4cf$export$88fb0cfd153261a7 {
    encode(value) {
        const count = value.length;
        const u8a = new Uint8Array(count);
        for(let i = 0; i < count; i++)u8a[i] = value.charCodeAt(i);
        return u8a;
    }
}


var $6c3615c9b8ab4ce1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/x-textencoder/packageInfo.js"
});
const $6c3615c9b8ab4ce1$export$ce0097da4c08ff3f = {
    name: "@polkadot/x-textencoder",
    path: $6c3615c9b8ab4ce1$import_meta && "file:///node_modules/@polkadot/x-textencoder/packageInfo.js" ? new URL("file:///node_modules/@polkadot/x-textencoder/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/x-textencoder/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "12.3.2"
};


const $0edac676705214dc$export$88fb0cfd153261a7 = /*#__PURE__*/ (0, $9ce44c51a85397c6$export$157d08edb917d81)("TextEncoder", (0, $f11bc49a7236d4cf$export$88fb0cfd153261a7));


const $1b66c29e6169cf04$var$encoder = new (0, $0edac676705214dc$export$88fb0cfd153261a7)();
function $1b66c29e6169cf04$export$e66335b9b1239eaf(value) {
    return value ? $1b66c29e6169cf04$var$encoder.encode(value.toString()) : new Uint8Array();
}


function $5cce92b1af3b58b2$export$3d1a44fbed727ee2(value) {
    return (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? (0, $b0b2c84d8719d979$export$a7884ebc965f8f54)(value) ? new Uint8Array(value) : value : (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(value) : Array.isArray(value) ? new Uint8Array(value) : (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)(value);
}


var $b57f2f892c2ac20d$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/api/packageInfo.js"
});
const $b57f2f892c2ac20d$export$ce0097da4c08ff3f = {
    name: "@polkadot/api",
    path: $b57f2f892c2ac20d$import_meta && "file:///node_modules/@polkadot/api/packageInfo.js" ? new URL("file:///node_modules/@polkadot/api/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/api/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "10.9.1"
};



function $0d2af457e7d47dce$export$db3b1dfc16b79619(registry, callIndex) {
    return registry.findMetaCall((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(callIndex));
}
function $0d2af457e7d47dce$export$6db3490d470bf39f(registry, errorIndex) {
    return registry.findMetaError((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(errorIndex));
}


function $92bc279d37b40d11$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $d050dcd13f6b1080$export$78f6d1b1dbcda304 = (0, $92bc279d37b40d11$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $efa1f973f33411e2$var$extendStatics = function(d, b) {
    $efa1f973f33411e2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $efa1f973f33411e2$var$extendStatics(d, b);
};
function $efa1f973f33411e2$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $efa1f973f33411e2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $efa1f973f33411e2$export$18ce0697a983be9b = function() {
    $efa1f973f33411e2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efa1f973f33411e2$export$18ce0697a983be9b.apply(this, arguments);
};
function $efa1f973f33411e2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $efa1f973f33411e2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $efa1f973f33411e2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $efa1f973f33411e2$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $efa1f973f33411e2$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $efa1f973f33411e2$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $efa1f973f33411e2$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $efa1f973f33411e2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $efa1f973f33411e2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $efa1f973f33411e2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $efa1f973f33411e2$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $efa1f973f33411e2$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $efa1f973f33411e2$export$45d3717a4c69092e(o, m, p);
}
function $efa1f973f33411e2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $efa1f973f33411e2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $efa1f973f33411e2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($efa1f973f33411e2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $efa1f973f33411e2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $efa1f973f33411e2$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $efa1f973f33411e2$export$10c90e4f7922046c(v) {
    return this instanceof $efa1f973f33411e2$export$10c90e4f7922046c ? (this.v = v, this) : new $efa1f973f33411e2$export$10c90e4f7922046c(v);
}
function $efa1f973f33411e2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $efa1f973f33411e2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $efa1f973f33411e2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $efa1f973f33411e2$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $efa1f973f33411e2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $efa1f973f33411e2$export$19a8beecd37a4c45 === "function" ? $efa1f973f33411e2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $efa1f973f33411e2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $efa1f973f33411e2$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $efa1f973f33411e2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $efa1f973f33411e2$export$45d3717a4c69092e(result, mod, k);
    }
    $efa1f973f33411e2$var$__setModuleDefault(result, mod);
    return result;
}
function $efa1f973f33411e2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $efa1f973f33411e2$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $efa1f973f33411e2$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $efa1f973f33411e2$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $efa1f973f33411e2$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $efa1f973f33411e2$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $efa1f973f33411e2$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $efa1f973f33411e2$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $efa1f973f33411e2$export$2e2bcd8739ae039 = {
    __extends: $efa1f973f33411e2$export$a8ba968b8961cb8a,
    __assign: $efa1f973f33411e2$export$18ce0697a983be9b,
    __rest: $efa1f973f33411e2$export$3c9a16f847548506,
    __decorate: $efa1f973f33411e2$export$29e00dfd3077644b,
    __param: $efa1f973f33411e2$export$d5ad3fd78186038f,
    __metadata: $efa1f973f33411e2$export$f1db080c865becb9,
    __awaiter: $efa1f973f33411e2$export$1050f835b63b671e,
    __generator: $efa1f973f33411e2$export$67ebef60e6f28a6,
    __createBinding: $efa1f973f33411e2$export$45d3717a4c69092e,
    __exportStar: $efa1f973f33411e2$export$f33643c0debef087,
    __values: $efa1f973f33411e2$export$19a8beecd37a4c45,
    __read: $efa1f973f33411e2$export$8d051b38c9118094,
    __spread: $efa1f973f33411e2$export$afc72e2116322959,
    __spreadArrays: $efa1f973f33411e2$export$6388937ca91ccae8,
    __spreadArray: $efa1f973f33411e2$export$1216008129fb82ed,
    __await: $efa1f973f33411e2$export$10c90e4f7922046c,
    __asyncGenerator: $efa1f973f33411e2$export$e427f37a30a4de9b,
    __asyncDelegator: $efa1f973f33411e2$export$bbd80228419bb833,
    __asyncValues: $efa1f973f33411e2$export$e3b29a3d6162315f,
    __makeTemplateObject: $efa1f973f33411e2$export$4fb47efe1390b86f,
    __importStar: $efa1f973f33411e2$export$c21735bcef00d192,
    __importDefault: $efa1f973f33411e2$export$da59b14a69baef04,
    __classPrivateFieldGet: $efa1f973f33411e2$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $efa1f973f33411e2$export$d40a35129aaff81f,
    __classPrivateFieldIn: $efa1f973f33411e2$export$81fdc39f203e4e04,
    __addDisposableResource: $efa1f973f33411e2$export$88ac25d8e944e405,
    __disposeResources: $efa1f973f33411e2$export$8f076105dc360e92
};


function $cd7378a71af165cd$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}





var $42aa9805ddda41fc$export$c9648b76fd580c34 = (0, $92bc279d37b40d11$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $09623c854bfb7a22$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $fa281c7f095e6bc0$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $efa1f973f33411e2$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $cd7378a71af165cd$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $42aa9805ddda41fc$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $efa1f973f33411e2$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $fa281c7f095e6bc0$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $42aa9805ddda41fc$export$c9648b76fd580c34)) errors = (0, $efa1f973f33411e2$export$1216008129fb82ed)((0, $efa1f973f33411e2$export$1216008129fb82ed)([], (0, $efa1f973f33411e2$export$8d051b38c9118094)(errors)), (0, $efa1f973f33411e2$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $42aa9805ddda41fc$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $fa281c7f095e6bc0$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $09623c854bfb7a22$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $09623c854bfb7a22$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $fa281c7f095e6bc0$export$610f9c3ca1a38dd8 = $fa281c7f095e6bc0$export$f55210826850c514.EMPTY;
function $fa281c7f095e6bc0$export$4f9221cbada3c4fc(value) {
    return value instanceof $fa281c7f095e6bc0$export$f55210826850c514 || value && "closed" in value && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.remove) && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.add) && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $fa281c7f095e6bc0$var$execFinalizer(finalizer) {
    if ((0, $cd7378a71af165cd$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $1c6846a8162a85ef$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $1195621bcf8b5b6e$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $1195621bcf8b5b6e$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $efa1f973f33411e2$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $efa1f973f33411e2$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $efa1f973f33411e2$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $efa1f973f33411e2$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $1195621bcf8b5b6e$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $5f4cc2ceb8eac15a$export$ebf645db02d3e99f(err) {
    (0, $1195621bcf8b5b6e$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $163d6b6e3b9e14ff$export$8793edee2d425525() {}


var $b53c82daf7fa4494$export$b7f97edb34bc1f87 = function() {
    return $b53c82daf7fa4494$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $b53c82daf7fa4494$export$dd472c3d8fe5a85a(error) {
    return $b53c82daf7fa4494$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $b53c82daf7fa4494$export$ff9346b0d1d30313(value) {
    return $b53c82daf7fa4494$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $b53c82daf7fa4494$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $f88f74c37c498b34$var$context = null;
function $f88f74c37c498b34$export$d974811edc77eafa(cb) {
    if ((0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$f88f74c37c498b34$var$context;
        if (isRoot) $f88f74c37c498b34$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $f88f74c37c498b34$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $f88f74c37c498b34$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $f88f74c37c498b34$export$3e205fbb5df021e0(err) {
    if ((0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $f88f74c37c498b34$var$context) {
        $f88f74c37c498b34$var$context.errorThrown = true;
        $f88f74c37c498b34$var$context.error = err;
    }
}


var $3563e2985023cd91$export$60959659b2c22881 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $fa281c7f095e6bc0$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $3563e2985023cd91$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $3563e2985023cd91$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $3563e2985023cd91$var$handleStoppedNotification((0, $b53c82daf7fa4494$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $3563e2985023cd91$var$handleStoppedNotification((0, $b53c82daf7fa4494$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $3563e2985023cd91$var$handleStoppedNotification((0, $b53c82daf7fa4494$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $fa281c7f095e6bc0$export$f55210826850c514));
var $3563e2985023cd91$var$_bind = Function.prototype.bind;
function $3563e2985023cd91$var$bind(fn, thisArg) {
    return $3563e2985023cd91$var$_bind.call(fn, thisArg);
}
var $3563e2985023cd91$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $3563e2985023cd91$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $3563e2985023cd91$var$handleUnhandledError(error);
        }
        else $3563e2985023cd91$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $3563e2985023cd91$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $3563e2985023cd91$export$94eeb6a328cab6c7 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $cd7378a71af165cd$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $3563e2985023cd91$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $3563e2985023cd91$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $3563e2985023cd91$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $3563e2985023cd91$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($3563e2985023cd91$export$60959659b2c22881);
function $3563e2985023cd91$var$handleUnhandledError(error) {
    if ((0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $f88f74c37c498b34$export$3e205fbb5df021e0)(error);
    else (0, $5f4cc2ceb8eac15a$export$ebf645db02d3e99f)(error);
}
function $3563e2985023cd91$var$defaultErrorHandler(err) {
    throw err;
}
function $3563e2985023cd91$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $1195621bcf8b5b6e$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $3563e2985023cd91$export$88d395d20619a0af = {
    closed: true,
    next: (0, $163d6b6e3b9e14ff$export$8793edee2d425525),
    error: $3563e2985023cd91$var$defaultErrorHandler,
    complete: (0, $163d6b6e3b9e14ff$export$8793edee2d425525)
};


function $a9828966d726d4a4$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === "object";
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $3563e2985023cd91$export$94eeb6a328cab6c7)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $d050dcd13f6b1080$export$78f6d1b1dbcda304)());
            }
        });
        source.subscribe(subscriber);
    });
}


function $2450271e40925995$export$ebec8610810318c5(source) {
    return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $2450271e40925995$export$871731df685d7753(init) {
    return function(source) {
        if ($2450271e40925995$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}




function $780013973b1bcfa8$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $780013973b1bcfa8$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $780013973b1bcfa8$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $3563e2985023cd91$export$60959659b2c22881));


function $9a63ae9794caf0c2$export$871de8747c9eaa88(project, thisArg) {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}



function $28b32e6e8d0aa2ab$export$187e35932e88c15c(value) {
    return value && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.schedule);
}


function $d7d77464a40802d3$var$last(arr) {
    return arr[arr.length - 1];
}
function $d7d77464a40802d3$export$9ae19b645239a61b(args) {
    return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)($d7d77464a40802d3$var$last(args)) ? args.pop() : undefined;
}
function $d7d77464a40802d3$export$29534b2f653ae592(args) {
    return (0, $28b32e6e8d0aa2ab$export$187e35932e88c15c)($d7d77464a40802d3$var$last(args)) ? args.pop() : undefined;
}
function $d7d77464a40802d3$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $d7d77464a40802d3$var$last(args) === "number" ? args.pop() : defaultValue;
}



var $c9d71ac5e5f2fa7b$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};



function $9edcbfa839045ba9$export$4369c812aac99591(value) {
    return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}




var $aa22e00fecc83db3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $1802c01a893130db$export$f0954fd7d5368655(x) {
    return x;
}


function $876ba9aaaf7065f9$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $876ba9aaaf7065f9$export$71f88a61afaa14d7(fns);
}
function $876ba9aaaf7065f9$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $1802c01a893130db$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $8732e18bef00f237$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $8732e18bef00f237$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $3563e2985023cd91$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $f88f74c37c498b34$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $8732e18bef00f237$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $3563e2985023cd91$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $aa22e00fecc83db3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $876ba9aaaf7065f9$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $8732e18bef00f237$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $8732e18bef00f237$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $1c6846a8162a85ef$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $8732e18bef00f237$var$isObserver(value) {
    return value && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.next) && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.error) && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(value.complete);
}
function $8732e18bef00f237$var$isSubscriber(value) {
    return value && value instanceof (0, $3563e2985023cd91$export$60959659b2c22881) || $8732e18bef00f237$var$isObserver(value) && (0, $fa281c7f095e6bc0$export$4f9221cbada3c4fc)(value);
}




function $671782c872fb0311$export$48c0cddbc99c45c2(input) {
    return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(input[0, $aa22e00fecc83db3$export$5ab46cbf6120b33a]);
}



function $aaf23d20d46be2ee$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $18af65ee9e03ea9d$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $74bfdbc1e303cac6$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $74bfdbc1e303cac6$export$6f58e2338da23f4d = $74bfdbc1e303cac6$export$aa9956be4ae4fe8();



function $94e06e4a1e527227$export$9652023d9040757(input) {
    return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $74bfdbc1e303cac6$export$6f58e2338da23f4d]);
}




function $44105734dbf597c6$export$cf4785e597badab3(readableStream) {
    return (0, $efa1f973f33411e2$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $efa1f973f33411e2$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $efa1f973f33411e2$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $efa1f973f33411e2$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $efa1f973f33411e2$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $44105734dbf597c6$export$c088ffafdba7405f(obj) {
    return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $2d91ca4f021570a0$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $8732e18bef00f237$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $671782c872fb0311$export$48c0cddbc99c45c2)(input)) return $2d91ca4f021570a0$export$aa3d41784b3267fa(input);
        if ((0, $c9d71ac5e5f2fa7b$export$1e2f57719e155213)(input)) return $2d91ca4f021570a0$export$4cb2acdbcda2c253(input);
        if ((0, $9edcbfa839045ba9$export$4369c812aac99591)(input)) return $2d91ca4f021570a0$export$60f45028237c39d1(input);
        if ((0, $aaf23d20d46be2ee$export$edb10ab8dd75a915)(input)) return $2d91ca4f021570a0$export$e073fccf36d78cc1(input);
        if ((0, $94e06e4a1e527227$export$9652023d9040757)(input)) return $2d91ca4f021570a0$export$dcccc29c315dd646(input);
        if ((0, $44105734dbf597c6$export$c088ffafdba7405f)(input)) return $2d91ca4f021570a0$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $18af65ee9e03ea9d$export$7cbe71b9fa263484)(input);
}
function $2d91ca4f021570a0$export$aa3d41784b3267fa(obj) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $aa22e00fecc83db3$export$5ab46cbf6120b33a]();
        if ((0, $cd7378a71af165cd$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $2d91ca4f021570a0$export$4cb2acdbcda2c253(array) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $2d91ca4f021570a0$export$60f45028237c39d1(promise) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $5f4cc2ceb8eac15a$export$ebf645db02d3e99f));
    });
}
function $2d91ca4f021570a0$export$dcccc29c315dd646(iterable) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $efa1f973f33411e2$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $2d91ca4f021570a0$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        $2d91ca4f021570a0$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $2d91ca4f021570a0$export$b2dcb11d46e7a4ad(readableStream) {
    return $2d91ca4f021570a0$export$e073fccf36d78cc1((0, $44105734dbf597c6$export$cf4785e597badab3)(readableStream));
}
function $2d91ca4f021570a0$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $efa1f973f33411e2$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $efa1f973f33411e2$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $efa1f973f33411e2$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $a1bc2941fd3c7e1b$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $c5ea050210e3d31f$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $594d21bd85ac60d6$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $a6679b052cba6333$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(input).pipe((0, $594d21bd85ac60d6$export$1eb44d8f5f64733b)(scheduler), (0, $c5ea050210e3d31f$export$9007f49c319d1ac7)(scheduler));
}





function $4b43817329cc6ec8$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(input).pipe((0, $594d21bd85ac60d6$export$1eb44d8f5f64733b)(scheduler), (0, $c5ea050210e3d31f$export$9007f49c319d1ac7)(scheduler));
}



function $097211b33debc52f$export$b34673931371729a(input, scheduler) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $7b86511e202b0536$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $74bfdbc1e303cac6$export$6f58e2338da23f4d]();
            (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $e976f82748638607$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $2639d14a31cd69f5$export$3385251aeecad28a(input, scheduler) {
    return (0, $e976f82748638607$export$7c7f0979b56a32f3)((0, $44105734dbf597c6$export$cf4785e597badab3)(input), scheduler);
}


function $73d957f70d2edc01$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $671782c872fb0311$export$48c0cddbc99c45c2)(input)) return (0, $a6679b052cba6333$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $c9d71ac5e5f2fa7b$export$1e2f57719e155213)(input)) return (0, $097211b33debc52f$export$b34673931371729a)(input, scheduler);
        if ((0, $9edcbfa839045ba9$export$4369c812aac99591)(input)) return (0, $4b43817329cc6ec8$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $aaf23d20d46be2ee$export$edb10ab8dd75a915)(input)) return (0, $e976f82748638607$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $94e06e4a1e527227$export$9652023d9040757)(input)) return (0, $7b86511e202b0536$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $44105734dbf597c6$export$c088ffafdba7405f)(input)) return (0, $2639d14a31cd69f5$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $18af65ee9e03ea9d$export$7cbe71b9fa263484)(input);
}



function $9451f06798fd34f2$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $73d957f70d2edc01$export$49c44dfc2bb21d70)(input, scheduler) : (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(input);
}


function $dc9a8fc77574b4ba$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $d7d77464a40802d3$export$29534b2f653ae592)(args);
    return (0, $9451f06798fd34f2$export$6788812c4e6611e6)(args, scheduler);
}




function $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}



/**
 * @name isBoolean
 * @summary Tests for a boolean value.
 * @description
 * Checks to see if the input value is a JavaScript boolean.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isBoolean } from '@polkadot/util';
 *
 * isBoolean(false); // => true
 * ```
 */ function $a88f7b3165367a92$export$f9ce7b637dfbe238(value) {
    return typeof value === "boolean";
}

/**
 * @name isObject
 * @summary Tests for an `object`.
 * @description
 * Checks to see if the input value is a JavaScript object.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isObject } from '@polkadot/util';
 *
 * isObject({}); // => true
 * isObject('something'); // => false
 * ```
 */ function $75e63b2ba0788249$export$a6cdc56e425d0d0a(value) {
    return !!value && typeof value === "object";
}

/**
 * @name isUndefined
 * @summary Tests for a `undefined` values.
 * @description
 * Checks to see if the input value is `undefined`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isUndefined } from '@polkadot/util';
 *
 * console.log('isUndefined', isUndefined(void(0))); // => true
 * ```
 */ function $09d5dc0a6a4c347b$export$fce6876652108ab(value) {
    return value === undefined;
}

/**
 * @name objectProperty
 * @summary Assign a get property on the input object
 */ function $fb51452ffd615a15$export$b1dee6b72881b450(that, key, getter, getName, index = 0) {
    const name = getName ? getName(key, index) : key;
    // There are 3 approaches here -
    //  - Object.prototype.hasOwnProperty.call(that, key) - this only checks the current class, i.e
    //    will retuirn false if the property is set in the parent class
    //  - isUndefined(...) - this may yield a false positive when the property is there, but not set.
    //    Additionally, on pre-defined getters it may make a call
    //  - key in that - Does not need to be combined with either of the above and checks the full chain
    if (!(name in that)) Object.defineProperty(that, name, {
        enumerable: true,
        // Unlike in lazy, we always call into the upper function, i.e. this method
        // does not cache old values (it is expected to be used for dynamic values)
        get: function() {
            return getter(key, index, this);
        }
    });
}
function $fb51452ffd615a15$export$4660c3861a213768(that, keys, getter, getName) {
    for(let i = 0, count = keys.length; i < count; i++)$fb51452ffd615a15$export$b1dee6b72881b450(that, keys[i], getter, getName, i);
}

const $4db46be060f888b6$export$467f382b677d7278 = new Array(256);
const $4db46be060f888b6$export$b106de9d73dfc75e = new Array(256);
for(let i = 0, count = $4db46be060f888b6$export$467f382b677d7278.length; i < count; i++){
    $4db46be060f888b6$export$b106de9d73dfc75e[i] = String.fromCharCode(i).toLowerCase();
    $4db46be060f888b6$export$467f382b677d7278[i] = String.fromCharCode(i).toUpperCase();
}
/** @internal */ function $4db46be060f888b6$var$formatAllCaps(w) {
    return w.slice(0, w.length - 1).toLowerCase() + $4db46be060f888b6$export$467f382b677d7278[w.charCodeAt(w.length - 1)];
}
/**
 * @internal
 *
 * Inspired by https://stackoverflow.com/a/2970667
 *
 * This is not as optimal as the original SO answer (we split into per-word),
 * however it does pass the tests (which the SO version doesn't) and is still
 * a major improvement over the original camelcase npm package -
 *
 *   camelcase: 20.88 μs/op
 *        this:  1.00 μs/op
 *
 * Caveat of this: only Ascii, but acceptable for the intended usecase
 */ function $4db46be060f888b6$var$converter(format) {
    return (value)=>{
        const parts = value// replace all separators (including consequtive) with spaces
        .replace(/[-_., ]+/g, " ")// we don't want leading or trailing spaces
        .trim()// split into words
        .split(" ");
        let result = "";
        for(let i = 0, count = parts.length; i < count; i++){
            const w = parts[i];
            // apply the formatting
            result += format(/^[\dA-Z]+$/.test(w) ? w.toLowerCase() : w.replace(/^[\dA-Z]{2,}[^a-z]/, $4db46be060f888b6$var$formatAllCaps), i);
        }
        return result;
    };
}
const $4db46be060f888b6$export$27f5d30aaa3dc2ea = /*#__PURE__*/ $4db46be060f888b6$var$converter((w, i)=>(i ? $4db46be060f888b6$export$467f382b677d7278[w.charCodeAt(0)] : $4db46be060f888b6$export$b106de9d73dfc75e[w.charCodeAt(0)]) + w.slice(1));
const $4db46be060f888b6$export$733fa19993fe16bc = /*#__PURE__*/ $4db46be060f888b6$var$converter((w)=>$4db46be060f888b6$export$467f382b677d7278[w.charCodeAt(0)] + w.slice(1));

/**
 * @name isBigInt
 * @summary Tests for a `BigInt` object instance.
 * @description
 * Checks to see if the input object is an instance of `BigInt`
 * @example
 * <BR>
 *
 * ```javascript
 * import { isBigInt } from '@polkadot/util';
 *
 * console.log('isBigInt', isBigInt(123_456n)); // => true
 * ```
 */ function $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7(value) {
    return typeof value === "bigint";
}


/** @internal */ function $e2c4db534325025c$var$replacer(_, v) {
    return (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(v) ? v.toString() : v;
}
function $e2c4db534325025c$export$fac44ee5b035f737(value, space) {
    return JSON.stringify(value, $e2c4db534325025c$var$replacer, space);
}


function $84207d7313fd2c40$export$7b640c40d4922c2e(...list) {
    const count = list.length;
    const u8as = new Array(count);
    let length = 0;
    for(let i = 0; i < count; i++){
        u8as[i] = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(list[i]);
        length += u8as[i].length;
    }
    return $84207d7313fd2c40$export$4dcdc48872dbeda7(u8as, length);
}
function $84207d7313fd2c40$export$4dcdc48872dbeda7(u8as, length = 0) {
    const count = u8as.length;
    let offset = 0;
    if (!length) for(let i = 0; i < count; i++)length += u8as[i].length;
    const result = new Uint8Array(length);
    for(let i = 0; i < count; i++){
        result.set(u8as[i], offset);
        offset += u8as[i].length;
    }
    return result;
}




function $da9585ca1451b938$export$9c527b6f5a12fec5(o) {
    return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(o.eq);
}


function $ac7bf2586ed6a7f5$var$hasMismatch(a, b) {
    return (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(a) || ((0, $da9585ca1451b938$export$9c527b6f5a12fec5)(a) ? !a.eq(b) : a !== b);
}
function $ac7bf2586ed6a7f5$var$notEntry(value) {
    return !Array.isArray(value) || value.length !== 2;
}
function $ac7bf2586ed6a7f5$var$compareMapArray(a, b) {
    // equal number of entries and each entry in the array should match
    return a.size === b.length && !b.some((e)=>$ac7bf2586ed6a7f5$var$notEntry(e) || $ac7bf2586ed6a7f5$var$hasMismatch(a.get(e[0]), e[1]));
}
function $ac7bf2586ed6a7f5$export$bc5ca6344d311f69(a, b) {
    if (Array.isArray(b)) return $ac7bf2586ed6a7f5$var$compareMapArray(a, b);
    else if (b instanceof Map) return $ac7bf2586ed6a7f5$var$compareMapArray(a, [
        ...b.entries()
    ]);
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(b)) return $ac7bf2586ed6a7f5$var$compareMapArray(a, Object.entries(b));
    return false;
}


/** @internal */ function $c6c7d9c63fddefa8$var$formatFailure(registry, fn, _result, { message: message }, u8a, i, count, Type, key) {
    let type = "";
    try {
        type = `: ${new Type(registry).toRawType()}`;
    } catch  {
    // ignore
    }
    // This is extra debugging info (we most-probably want this in in some way, shape or form,
    // but at this point not quite sure how to include and format it (it can be quite massive)
    // console.error(JSON.stringify(result, null, 2));
    return `${fn}: failed at ${(0, $1e2cfad286c009ca$export$4429d284633899e1)(u8a.subarray(0, 16))}…${key ? ` on ${key}` : ""} (index ${i + 1}/${count})${type}:: ${message}`;
}
function $c6c7d9c63fddefa8$export$e7a6c3d9d31d9fd6(registry, result, u8a, [Types, keys]) {
    const count = result.length;
    let offset = 0;
    let i = 0;
    try {
        while(i < count){
            const value = new Types[i](registry, u8a.subarray(offset));
            offset += value.initialU8aLength || value.encodedLength;
            result[i] = value;
            i++;
        }
    } catch (error) {
        throw new Error($c6c7d9c63fddefa8$var$formatFailure(registry, "decodeU8a", result, error, u8a.subarray(offset), i, count, Types[i], keys[i]));
    }
    return [
        result,
        offset
    ];
}
function $c6c7d9c63fddefa8$export$b95cba108c799391(registry, result, u8a, [Types, keys]) {
    const count = result.length;
    let offset = 0;
    let i = 0;
    try {
        while(i < count){
            const value = new Types[i](registry, u8a.subarray(offset));
            offset += value.initialU8aLength || value.encodedLength;
            result[i] = [
                keys[i],
                value
            ];
            i++;
        }
    } catch (error) {
        throw new Error($c6c7d9c63fddefa8$var$formatFailure(registry, "decodeU8aStruct", result, error, u8a.subarray(offset), i, count, Types[i], keys[i]));
    }
    return [
        result,
        offset
    ];
}
function $c6c7d9c63fddefa8$export$ebb8ead71f4fb09f(registry, result, u8a, startAt, Type) {
    const count = result.length;
    let offset = startAt;
    let i = 0;
    try {
        while(i < count){
            const value = new Type(registry, u8a.subarray(offset));
            offset += value.initialU8aLength || value.encodedLength;
            result[i] = value;
            i++;
        }
    } catch (error) {
        throw new Error($c6c7d9c63fddefa8$var$formatFailure(registry, "decodeU8aVec", result, error, u8a.subarray(offset), i, count, Type));
    }
    return [
        offset,
        offset - startAt
    ];
}

/**
 * @internal
 * From a type string or class, return the associated type class
 */ function $decc53b303ead3a7$export$30c7ba5c4398003d(registry, type) {
    return typeof type === "function" ? type : registry.createClassUnsafe(type);
}
function $decc53b303ead3a7$export$8a2235eb3de9eba7(registry, types) {
    const count = types.length;
    const result = new Array(count);
    for(let i = 0; i < count; i++)result[i] = $decc53b303ead3a7$export$30c7ba5c4398003d(registry, types[i]);
    return result;
}
function $decc53b303ead3a7$export$17958927a4ea0eb2(registry, input) {
    const entries = Object.entries(input);
    const count = entries.length;
    const output = [
        new Array(count),
        new Array(count)
    ];
    for(let i = 0; i < count; i++){
        output[1][i] = entries[i][0];
        output[0][i] = $decc53b303ead3a7$export$30c7ba5c4398003d(registry, entries[i][1]);
    }
    return output;
}

function $faf940201c18431a$export$97b3c2f336f5e421(registry, [Types, keys]) {
    const result = {};
    for(let i = 0, count = keys.length; i < count; i++)result[keys[i]] = registry.getClassName(Types[i]) || new Types[i](registry).toRawType();
    return result;
}


function $6552ecce3d7abdb5$var$noopSetDefinition(d) {
    return d;
}
/** @internal */ function $6552ecce3d7abdb5$var$decodeStructFromObject(registry, [Types, keys], value, jsonMap) {
    let jsonObj;
    const typeofArray = Array.isArray(value);
    const typeofMap = value instanceof Map;
    const count = keys.length;
    if (!typeofArray && !typeofMap && !(0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value)) throw new Error(`Struct: Cannot decode value ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(value)} (typeof ${typeof value}), expected an input object, map or array`);
    else if (typeofArray && value.length !== count) throw new Error(`Struct: Unable to map ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(value)} array to object with known keys ${keys.join(", ")}`);
    const raw = new Array(count);
    for(let i = 0; i < count; i++){
        const key = keys[i];
        const jsonKey = jsonMap.get(key) || key;
        const Type = Types[i];
        let assign;
        try {
            if (typeofArray) assign = value[i];
            else if (typeofMap) assign = jsonKey && value.get(jsonKey);
            else {
                assign = jsonKey && value[jsonKey];
                if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(assign)) {
                    if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(jsonObj)) {
                        const entries = Object.entries(value);
                        jsonObj = {};
                        for(let e = 0, ecount = entries.length; e < ecount; e++)jsonObj[(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(entries[e][0])] = entries[e][1];
                    }
                    assign = jsonKey && jsonObj[jsonKey];
                }
            }
            raw[i] = [
                key,
                assign instanceof Type ? assign : new Type(registry, assign)
            ];
        } catch (error) {
            let type = Type.name;
            try {
                type = new Type(registry).toRawType();
            } catch  {
            // ignore
            }
            throw new Error(`Struct: failed on ${jsonKey}: ${type}:: ${error.message}`);
        }
    }
    return [
        raw,
        0
    ];
}
class $6552ecce3d7abdb5$export$eabc71f011df675a extends Map {
    constructor(registry, Types, value, jsonMap = new Map(), { definition: definition, setDefinition: setDefinition = $6552ecce3d7abdb5$var$noopSetDefinition } = {}){
        const typeMap = definition || setDefinition((0, $decc53b303ead3a7$export$17958927a4ea0eb2)(registry, Types));
        const [decoded, decodedLength] = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? (0, $c6c7d9c63fddefa8$export$b95cba108c799391)(registry, new Array(typeMap[0].length), (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), typeMap) : value instanceof $6552ecce3d7abdb5$export$eabc71f011df675a ? [
            value,
            0
        ] : $6552ecce3d7abdb5$var$decodeStructFromObject(registry, typeMap, value || {}, jsonMap);
        super(decoded);
        this.initialU8aLength = decodedLength;
        this.registry = registry;
        this.__internal__jsonMap = jsonMap;
        this.__internal__Types = typeMap;
    }
    static with(Types, jsonMap) {
        var _a;
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d)=>definition = d;
        return _a = class extends $6552ecce3d7abdb5$export$eabc71f011df675a {
            constructor(registry, value){
                super(registry, Types, value, jsonMap, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        }, (()=>{
            const keys = Object.keys(Types);
            (0, $fb51452ffd615a15$export$4660c3861a213768)(_a.prototype, keys, (k, _, self)=>self.get(k));
        })(), _a;
    }
    /**
     * @description The available keys for this struct
     */ get defKeys() {
        return this.__internal__Types[1];
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        for (const v of this.values()){
            if (!v.isEmpty) return false;
        }
        return true;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        let total = 0;
        for (const v of this.values())total += v.encodedLength;
        return total;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Returns the Type description of the structure
     */ get Type() {
        const result = {};
        const [Types, keys] = this.__internal__Types;
        for(let i = 0, count = keys.length; i < count; i++)result[keys[i]] = new Types[i](this.registry).toRawType();
        return result;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return (0, $ac7bf2586ed6a7f5$export$bc5ca6344d311f69)(this, other);
    }
    /**
     * @description Returns a specific names entry in the structure
     * @param key The name of the entry to retrieve
     */ get(key) {
        return super.get(key);
    }
    /**
     * @description Returns the values of a member at a specific index (Rather use get(name) for performance)
     */ getAtIndex(index) {
        return this.toArray()[index];
    }
    /**
     * @description Returns the a types value by name
     */ getT(key) {
        return super.get(key);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect(isBare) {
        const inner = [];
        for (const [k, v] of this.entries())inner.push({
            ...v.inspect(!isBare || (0, $a88f7b3165367a92$export$f9ce7b637dfbe238)(isBare) ? isBare : isBare[k]),
            name: (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(k)
        });
        return {
            inner: inner
        };
    }
    /**
     * @description Converts the Object to an standard JavaScript Array
     */ toArray() {
        return [
            ...this.values()
        ];
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        const json = {};
        for (const [k, v] of this.entries())json[k] = v.toHuman(isExtended);
        return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        const json = {};
        for (const [k, v] of this.entries())// Here we pull out the entry against the JSON mapping (if supplied)
        // since this representation goes over RPC and needs to be correct
        json[this.__internal__jsonMap.get(k) || k] = v.toJSON();
        return json;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        const json = {};
        for (const [k, v] of this.entries())json[k] = v.toPrimitive();
        return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)((0, $faf940201c18431a$export$97b3c2f336f5e421)(this.registry, this.__internal__Types));
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const encoded = [];
        for (const [k, v] of this.entries())encoded.push(v.toU8a(!isBare || (0, $a88f7b3165367a92$export$f9ce7b637dfbe238)(isBare) ? isBare : isBare[k]));
        return (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(encoded);
    }
}


/** @internal */ function $c18a1aec78715c59$export$d154e161130d8280(list, result = []) {
    for(let i = 0, count = list.length; i < count; i++){
        const entry = list[i];
        if (Array.isArray(entry)) $c18a1aec78715c59$export$d154e161130d8280(entry, result);
        else result.push(entry);
    }
    return [
        ...new Set(result)
    ];
}



/** @internal */ function $5e755a3807394fd9$var$zeroPad(value) {
    return value.toString().padStart(2, "0");
}
function $5e755a3807394fd9$export$3ae94a2503e890a1(date) {
    const year = date.getFullYear().toString();
    const month = $5e755a3807394fd9$var$zeroPad(date.getMonth() + 1);
    const day = $5e755a3807394fd9$var$zeroPad(date.getDate());
    const hour = $5e755a3807394fd9$var$zeroPad(date.getHours());
    const minute = $5e755a3807394fd9$var$zeroPad(date.getMinutes());
    const second = $5e755a3807394fd9$var$zeroPad(date.getSeconds());
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}



var $hWfed = parcelRequire("hWfed");
function $6b7448b66af103e8$export$92a23ef2f5b8d147(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hWfed))).isBN(value);
}









/**
 * A sharable identity function. Returns the input as-is with no transformation applied.
 */ function $3c9cf064340c6f95$export$f0954fd7d5368655(value) {
    return value;
}
function $3c9cf064340c6f95$export$8793edee2d425525() {
// noop
}


const $d7d4f472109ad7f8$var$logTo = {
    debug: "log",
    error: "error",
    log: "log",
    warn: "warn"
};
function $d7d4f472109ad7f8$var$formatOther(value) {
    if (value && (0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value) && value.constructor === Object) {
        const result = {};
        for (const [k, v] of Object.entries(value))result[k] = $d7d4f472109ad7f8$export$3d4b3f29395c6b7d(v);
        return result;
    }
    return value;
}
function $d7d4f472109ad7f8$export$3d4b3f29395c6b7d(value) {
    if (Array.isArray(value)) return value.map($d7d4f472109ad7f8$export$3d4b3f29395c6b7d);
    else if ((0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(value)) return value.toString();
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $b0b2c84d8719d979$export$a7884ebc965f8f54)(value)) return (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
    return $d7d4f472109ad7f8$var$formatOther(value);
}
function $d7d4f472109ad7f8$var$formatWithLength(maxLength) {
    return (v)=>{
        if (maxLength <= 0) return v;
        const r = `${v}`;
        return r.length < maxLength ? v : `${r.substring(0, maxLength)} ...`;
    };
}
function $d7d4f472109ad7f8$var$apply(log, type, values, maxSize = -1) {
    if (values.length === 1 && (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(values[0])) {
        const fnResult = values[0]();
        return $d7d4f472109ad7f8$var$apply(log, type, Array.isArray(fnResult) ? fnResult : [
            fnResult
        ], maxSize);
    }
    console[$d7d4f472109ad7f8$var$logTo[log]]((0, $5e755a3807394fd9$export$3ae94a2503e890a1)(new Date()), type, ...values.map($d7d4f472109ad7f8$export$3d4b3f29395c6b7d).map($d7d4f472109ad7f8$var$formatWithLength(maxSize)));
}
function $d7d4f472109ad7f8$var$isDebugOn(e, type) {
    return !!e && (e === "*" || type === e || e.endsWith("*") && type.startsWith(e.slice(0, -1)));
}
function $d7d4f472109ad7f8$var$isDebugOff(e, type) {
    return !!e && e.startsWith("-") && (type === e.slice(1) || e.endsWith("*") && type.startsWith(e.slice(1, -1)));
}
function $d7d4f472109ad7f8$var$getDebugFlag(env, type) {
    let flag = false;
    for (const e of env){
        if ($d7d4f472109ad7f8$var$isDebugOn(e, type)) flag = true;
        else if ($d7d4f472109ad7f8$var$isDebugOff(e, type)) flag = false;
    }
    return flag;
}
function $d7d4f472109ad7f8$var$parseEnv(type) {
    const env = ((0, $6574c8753d85e60c$export$7af020c88c16a8f7) ? (0, $9ce44c51a85397c6$export$51e5d554977815ce).process : {}).env || {};
    const maxSize = parseInt(env["DEBUG_MAX"] || "-1", 10);
    return [
        $d7d4f472109ad7f8$var$getDebugFlag((env["DEBUG"] || "").toLowerCase().split(","), type),
        isNaN(maxSize) ? -1 : maxSize
    ];
}
function $d7d4f472109ad7f8$export$af88d00dbe7f521(origin) {
    const type = `${origin.toUpperCase()}:`.padStart(16);
    const [isDebug, maxSize] = $d7d4f472109ad7f8$var$parseEnv(origin.toLowerCase());
    return {
        debug: isDebug ? (...values)=>$d7d4f472109ad7f8$var$apply("debug", type, values, maxSize) : (0, $3c9cf064340c6f95$export$8793edee2d425525),
        error: (...values)=>$d7d4f472109ad7f8$var$apply("error", type, values),
        log: (...values)=>$d7d4f472109ad7f8$var$apply("log", type, values),
        noop: $3c9cf064340c6f95$export$8793edee2d425525,
        warn: (...values)=>$d7d4f472109ad7f8$var$apply("warn", type, values)
    };
}


const $8eefb6164d9f7959$var$BOUNDED = [
    "BTreeMap",
    "BTreeSet",
    "HashMap",
    "Vec"
];
const $8eefb6164d9f7959$var$ALLOWED_BOXES = $8eefb6164d9f7959$var$BOUNDED.concat([
    "Compact",
    "DoNotConstruct",
    "Int",
    "Linkage",
    "Range",
    "RangeInclusive",
    "Result",
    "Opaque",
    "Option",
    "UInt",
    "WrapperKeepOpaque",
    "WrapperOpaque"
]);
const $8eefb6164d9f7959$var$BOX_PRECEDING = [
    "<",
    "(",
    "[",
    '"',
    ",",
    " "
]; // start of vec, tuple, fixed array, part of struct def or in tuple
const $8eefb6164d9f7959$var$mappings = [
    // alias <T::InherentOfflineReport as InherentOfflineReport>::Inherent -> InherentOfflineReport
    $8eefb6164d9f7959$export$8de3e08801b34e5a("<T::InherentOfflineReport as InherentOfflineReport>::Inherent", "InherentOfflineReport", false),
    $8eefb6164d9f7959$export$8de3e08801b34e5a("VecDeque<", "Vec<", false),
    // <T::Balance as HasCompact>
    $8eefb6164d9f7959$export$21e973814aef44b9(),
    // Change BoundedVec<Type, Size> to Vec<Type>
    $8eefb6164d9f7959$export$748f956e607b675b("Bounded", true),
    // Change WeakVec<Type> to Vec<Type>
    $8eefb6164d9f7959$export$748f956e607b675b("Weak", false),
    // Remove all the trait prefixes
    $8eefb6164d9f7959$export$17cc5e2bc4594d9a(),
    // remove PairOf<T> -> (T, T)
    $8eefb6164d9f7959$export$27e4175936959c72(),
    // remove boxing, `Box<Proposal>` -> `Proposal`
    $8eefb6164d9f7959$export$3c8fd41546f23fdf("Box<"),
    // remove generics, `MisbehaviorReport<Hash, BlockNumber>` -> `MisbehaviorReport`
    $8eefb6164d9f7959$export$68c331eaf4d8a071(),
    // alias String -> Text (compat with jsonrpc methods)
    $8eefb6164d9f7959$export$8de3e08801b34e5a("String", "Text"),
    // alias Vec<u8> -> Bytes
    $8eefb6164d9f7959$export$8de3e08801b34e5a("Vec<u8>", "Bytes"),
    $8eefb6164d9f7959$export$8de3e08801b34e5a("&\\[u8\\]", "Bytes"),
    $8eefb6164d9f7959$export$8de3e08801b34e5a("&'static\\[u8\\]", "Bytes"),
    // alias RawAddress -> Address
    $8eefb6164d9f7959$export$8de3e08801b34e5a("RawAddress", "Address"),
    // lookups, mapped to Address/AccountId as appropriate in runtime
    $8eefb6164d9f7959$export$8de3e08801b34e5a("Lookup::Source", "LookupSource"),
    $8eefb6164d9f7959$export$8de3e08801b34e5a("Lookup::Target", "LookupTarget"),
    // HACK duplication between contracts & primitives, however contracts prefixed with exec
    $8eefb6164d9f7959$export$8de3e08801b34e5a("exec::StorageKey", "ContractStorageKey"),
    // flattens tuples with one value, `(AccountId)` -> `AccountId`
    $8eefb6164d9f7959$export$1353a5411e36509e(),
    // converts ::Type to Type, <T as Trait<I>>::Proposal -> Proposal
    $8eefb6164d9f7959$export$458457b261381977(),
    // remove all trailing spaces - this should always be the last
    $8eefb6164d9f7959$export$87c2784dc9fc4ab()
];
function $8eefb6164d9f7959$export$87c2784dc9fc4ab() {
    return (value)=>value.trim();
}
function $8eefb6164d9f7959$export$ec0408085409e158(value, start) {
    let depth = 0;
    for(let i = start, count = value.length; i < count; i++){
        if (value[i] === ">") {
            if (!depth) return i;
            depth--;
        } else if (value[i] === "<") depth++;
    }
    throw new Error(`Unable to find closing matching <> on '${value}' (start ${start})`);
}
function $8eefb6164d9f7959$export$8de3e08801b34e5a(src, dest, withChecks = true) {
    const from = new RegExp(`(^${src}|${$8eefb6164d9f7959$var$BOX_PRECEDING.map((box)=>`\\${box}${src}`).join("|")})`, "g");
    const to = (src)=>{
        from.lastIndex = 0;
        return withChecks && $8eefb6164d9f7959$var$BOX_PRECEDING.includes(src[0]) ? `${src[0]}${dest}` : dest;
    };
    return (value)=>value.replace(from, to);
}
function $8eefb6164d9f7959$export$21e973814aef44b9() {
    return (value)=>{
        if (value.includes(" as HasCompact")) {
            for(let i = 0, count = value.length; i < count; i++)if (value[i] === "<") {
                const end = $8eefb6164d9f7959$export$ec0408085409e158(value, i + 1) - 14;
                if (value.substring(end, end + 14) === " as HasCompact") value = `Compact<${value.substring(i + 1, end)}>`;
            }
        }
        return value;
    };
}
function $8eefb6164d9f7959$export$1353a5411e36509e() {
    const from1 = /,\)/g;
    const from2 = /\(([^,]+)\)/;
    return (value)=>{
        from1.lastIndex = 0;
        return value// tuples may have trailing commas, e.g. (u32, BlockNumber, )
        .replace(from1, ")")// change (u32) -> u32
        .replace(from2, "$1");
    };
}
function $8eefb6164d9f7959$var$replaceTagWith(value, matcher, replacer) {
    let index = -1;
    while(true){
        index = value.indexOf(matcher, index + 1);
        if (index === -1) return value;
        const start = index + matcher.length;
        const end = $8eefb6164d9f7959$export$ec0408085409e158(value, start);
        value = `${value.substring(0, index)}${replacer(value.substring(start, end))}${value.substring(end + 1)}`;
    }
}
function $8eefb6164d9f7959$export$748f956e607b675b(type, isSized) {
    return (value)=>{
        for(let i = 0, count = $8eefb6164d9f7959$var$BOUNDED.length; i < count; i++){
            const tag = $8eefb6164d9f7959$var$BOUNDED[i];
            value = $8eefb6164d9f7959$var$replaceTagWith(value, `${type}${tag}<`, (v)=>{
                const parts = v.split(",").map((s)=>s.trim()).filter((s)=>s);
                if (isSized) parts.pop();
                return `${tag}<${parts.join(",")}>`;
            });
        }
        return value;
    };
}
function $8eefb6164d9f7959$export$458457b261381977() {
    return (value)=>{
        let index = 0;
        while(index !== -1){
            index = value.indexOf("::");
            if (index === 0) value = value.substring(2);
            else if (index !== -1) {
                let start = index;
                while(start !== -1 && !$8eefb6164d9f7959$var$BOX_PRECEDING.includes(value[start]))start--;
                value = `${value.substring(0, start + 1)}${value.substring(index + 2)}`;
            }
        }
        return value;
    };
}
function $8eefb6164d9f7959$export$68c331eaf4d8a071() {
    return (value)=>{
        for(let i = 0, count = value.length; i < count; i++)if (value[i] === "<") {
            // check against the allowed wrappers, be it Vec<..>, Option<...> ...
            const box = $8eefb6164d9f7959$var$ALLOWED_BOXES.find((box)=>{
                const start = i - box.length;
                return start >= 0 && value.substring(start, i) === box && // make sure it is stand-alone, i.e. don't catch ElectionResult<...> as Result<...>
                (start === 0 || $8eefb6164d9f7959$var$BOX_PRECEDING.includes(value[start - 1]));
            });
            // we have not found anything, unwrap generic innards
            if (!box) {
                const end = $8eefb6164d9f7959$export$ec0408085409e158(value, i + 1);
                value = `${value.substring(0, i)}${value.substring(end + 1)}`;
            }
        }
        return value;
    };
}
function $8eefb6164d9f7959$export$27e4175936959c72() {
    const replacer = (v)=>`(${v},${v})`;
    return (value)=>$8eefb6164d9f7959$var$replaceTagWith(value, "PairOf<", replacer);
}
function $8eefb6164d9f7959$export$17cc5e2bc4594d9a() {
    const from1 = /\s/g;
    const from2 = /(T|Self)::/g;
    const from3 = /<(T|Self)asTrait>::/g;
    const from4 = /<Tas[a-z]+::Trait>::/g;
    const from5 = /<LookupasStaticLookup>/g;
    const from6 = /::Type/g;
    return (value)=>{
        from1.lastIndex = 0;
        from2.lastIndex = 0;
        from3.lastIndex = 0;
        from4.lastIndex = 0;
        from5.lastIndex = 0;
        from6.lastIndex = 0;
        return value// remove all whitespaces
        .replace(from1, "")// anything `T::<type>` to end up as `<type>`
        .replace(from2, "")// replace `<T as Trait>::` (whitespaces were removed above)
        .replace(from3, "")// replace `<T as something::Trait>::` (whitespaces were removed above)
        .replace(from4, "")// replace <Lookup as StaticLookup>
        .replace(from5, "Lookup")// replace `<...>::Type`
        .replace(from6, "");
    };
}
function $8eefb6164d9f7959$export$3c8fd41546f23fdf(check) {
    const replacer = (v)=>v;
    return (value)=>$8eefb6164d9f7959$var$replaceTagWith(value, check, replacer);
}
const $8eefb6164d9f7959$var$sanitizeMap = new Map();
function $8eefb6164d9f7959$export$83d2e9e3e4ee39ed(value) {
    const startValue = value.toString();
    const memoized = $8eefb6164d9f7959$var$sanitizeMap.get(startValue);
    if (memoized) return memoized;
    let result = startValue;
    for(let i = 0, count = $8eefb6164d9f7959$var$mappings.length; i < count; i++)result = $8eefb6164d9f7959$var$mappings[i](result);
    $8eefb6164d9f7959$var$sanitizeMap.set(startValue, result);
    return result;
}


/**
 * @name isNumber
 * @summary Tests for a JavaScript number.
 * @description
 * Checks to see if the input value is a valid number.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isNumber } from '@polkadot/util';
 *
 * console.log('isNumber', isNumber(1234)); // => true
 * ```
 */ function $62d4481eefa5c3a2$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}


var $557bfa9761bbf2f6$export$9d5fb39c289c5e29;
(function(TypeDefInfo) {
    TypeDefInfo[TypeDefInfo["BTreeMap"] = 0] = "BTreeMap";
    TypeDefInfo[TypeDefInfo["BTreeSet"] = 1] = "BTreeSet";
    TypeDefInfo[TypeDefInfo["Compact"] = 2] = "Compact";
    TypeDefInfo[TypeDefInfo["DoNotConstruct"] = 3] = "DoNotConstruct";
    TypeDefInfo[TypeDefInfo["Enum"] = 4] = "Enum";
    TypeDefInfo[TypeDefInfo["HashMap"] = 5] = "HashMap";
    TypeDefInfo[TypeDefInfo["Int"] = 6] = "Int";
    TypeDefInfo[TypeDefInfo["Linkage"] = 7] = "Linkage";
    TypeDefInfo[TypeDefInfo["Null"] = 8] = "Null";
    TypeDefInfo[TypeDefInfo["Option"] = 9] = "Option";
    TypeDefInfo[TypeDefInfo["Plain"] = 10] = "Plain";
    TypeDefInfo[TypeDefInfo["Range"] = 11] = "Range";
    TypeDefInfo[TypeDefInfo["RangeInclusive"] = 12] = "RangeInclusive";
    TypeDefInfo[TypeDefInfo["Result"] = 13] = "Result";
    TypeDefInfo[TypeDefInfo["Set"] = 14] = "Set";
    TypeDefInfo[TypeDefInfo["Si"] = 15] = "Si";
    TypeDefInfo[TypeDefInfo["Struct"] = 16] = "Struct";
    TypeDefInfo[TypeDefInfo["Tuple"] = 17] = "Tuple";
    TypeDefInfo[TypeDefInfo["UInt"] = 18] = "UInt";
    TypeDefInfo[TypeDefInfo["Vec"] = 19] = "Vec";
    TypeDefInfo[TypeDefInfo["VecFixed"] = 20] = "VecFixed";
    TypeDefInfo[TypeDefInfo["WrapperKeepOpaque"] = 21] = "WrapperKeepOpaque";
    TypeDefInfo[TypeDefInfo["WrapperOpaque"] = 22] = "WrapperOpaque";
})($557bfa9761bbf2f6$export$9d5fb39c289c5e29 || ($557bfa9761bbf2f6$export$9d5fb39c289c5e29 = {}));


function $977f9d4987ba46ad$export$a9c7d05614491992(type) {
    const result = [];
    // these are the depths of the various tokens: <, [, {, (
    let c = 0;
    let f = 0;
    let s = 0;
    let t = 0;
    // current start position
    let start = 0;
    for(let i = 0, count = type.length; i < count; i++)switch(type[i]){
        // if we are not nested, add the type
        case ",":
            if (!(c || f || s || t)) {
                result.push(type.substring(start, i).trim());
                start = i + 1;
            }
            break;
        // adjust compact/vec (and friends) depth
        case "<":
            c++;
            break;
        case ">":
            c--;
            break;
        // adjust fixed vec depths
        case "[":
            f++;
            break;
        case "]":
            f--;
            break;
        // adjust struct depth
        case "{":
            s++;
            break;
        case "}":
            s--;
            break;
        // adjust tuple depth
        case "(":
            t++;
            break;
        case ")":
            t--;
            break;
    }
    // ensure we have all the terminators taken care of
    if (c || f || s || t) throw new Error(`Invalid definition (missing terminators) found in ${type}`);
    // the final leg of the journey
    result.push(type.substring(start, type.length).trim());
    return result;
}


const $22807b92000b3c41$var$KNOWN_INTERNALS = [
    "_alias",
    "_fallback"
];
function $22807b92000b3c41$var$getTypeString(typeOrObj) {
    return (0, $0d672af39bfe8283$export$844ec244b1367d54)(typeOrObj) ? typeOrObj.toString() : JSON.stringify(typeOrObj);
}
function $22807b92000b3c41$var$isRustEnum(details) {
    const values = Object.values(details);
    if (values.some((v)=>(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(v))) {
        if (!values.every((v)=>(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(v) && v >= 0 && v <= 255)) throw new Error("Invalid number-indexed enum definition");
        return false;
    }
    return true;
}
function $22807b92000b3c41$var$_decodeEnum(value, details, count, fallbackType) {
    value.info = (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Enum;
    value.fallbackType = fallbackType;
    // not as pretty, but remain compatible with oo7 for both struct and Array types
    if (Array.isArray(details)) value.sub = details.map((name, index)=>({
            index: index,
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            name: name,
            type: "Null"
        }));
    else if ($22807b92000b3c41$var$isRustEnum(details)) value.sub = Object.entries(details).map(([name, typeOrObj], index)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, $22807b92000b3c41$export$9f31b1beea63f4ee($22807b92000b3c41$var$getTypeString(typeOrObj || "Null"), {
            name: name
        }, count), {
            index: index
        }));
    else value.sub = Object.entries(details).map(([name, index])=>({
            index: index,
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            name: name,
            type: "Null"
        }));
    return value;
}
function $22807b92000b3c41$var$_decodeSet(value, details, fallbackType) {
    value.info = (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Set;
    value.fallbackType = fallbackType;
    value.length = details._bitLength;
    value.sub = Object.entries(details).filter(([name])=>!name.startsWith("_")).map(([name, index])=>({
            index: index,
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            name: name,
            type: "Null"
        }));
    return value;
}
function $22807b92000b3c41$var$_decodeStruct(value, type, _, count) {
    const parsed = JSON.parse(type);
    const keys = Object.keys(parsed);
    if (parsed._enum) return $22807b92000b3c41$var$_decodeEnum(value, parsed._enum, count, parsed._fallback);
    else if (parsed._set) return $22807b92000b3c41$var$_decodeSet(value, parsed._set, parsed._fallback);
    value.alias = parsed._alias ? new Map(Object.entries(parsed._alias)) : undefined;
    value.fallbackType = parsed._fallback;
    value.sub = keys.filter((name)=>!$22807b92000b3c41$var$KNOWN_INTERNALS.includes(name)).map((name)=>$22807b92000b3c41$export$9f31b1beea63f4ee($22807b92000b3c41$var$getTypeString(parsed[name]), {
            name: name
        }, count));
    return value;
}
function $22807b92000b3c41$var$_decodeFixedVec(value, type, _, count) {
    const max = type.length - 1;
    let index = -1;
    let inner = 0;
    for(let i = 1; i < max && index === -1; i++)switch(type[i]){
        case ";":
            if (inner === 0) index = i;
            break;
        case "[":
        case "(":
        case "<":
            inner++;
            break;
        case "]":
        case ")":
        case ">":
            inner--;
            break;
    }
    if (index === -1) throw new Error(`${type}: Unable to extract location of ';'`);
    const vecType = type.substring(1, index);
    const [strLength, displayName] = type.substring(index + 1, max).split(";");
    const length = parseInt(strLength.trim(), 10);
    if (length > 2048) throw new Error(`${type}: Only support for [Type; <length>], where length <= 2048`);
    value.displayName = displayName;
    value.length = length;
    value.sub = $22807b92000b3c41$export$9f31b1beea63f4ee(vecType, {}, count);
    return value;
}
function $22807b92000b3c41$var$_decodeTuple(value, _, subType, count) {
    value.sub = subType.length === 0 ? [] : (0, $977f9d4987ba46ad$export$a9c7d05614491992)(subType).map((inner)=>$22807b92000b3c41$export$9f31b1beea63f4ee(inner, {}, count));
    return value;
}
function $22807b92000b3c41$var$_decodeAnyInt(value, type, _, clazz) {
    const [strLength, displayName] = type.substring(clazz.length + 1, type.length - 1).split(",");
    const length = parseInt(strLength.trim(), 10);
    if (length > 8192 || length % 8) throw new Error(`${type}: Only support for ${clazz}<bitLength>, where length <= 8192 and a power of 8, found ${length}`);
    value.displayName = displayName;
    value.length = length;
    return value;
}
function $22807b92000b3c41$var$_decodeInt(value, type, subType) {
    return $22807b92000b3c41$var$_decodeAnyInt(value, type, subType, "Int");
}
function $22807b92000b3c41$var$_decodeUInt(value, type, subType) {
    return $22807b92000b3c41$var$_decodeAnyInt(value, type, subType, "UInt");
}
function $22807b92000b3c41$var$_decodeDoNotConstruct(value, type, _) {
    const NAME_LENGTH = 14;
    value.displayName = type.substring(NAME_LENGTH + 1, type.length - 1);
    return value;
}
function $22807b92000b3c41$var$hasWrapper(type, [start, end]) {
    return type.substring(0, start.length) === start && type.slice(-1 * end.length) === end;
}
const $22807b92000b3c41$var$nestedExtraction = [
    [
        "[",
        "]",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).VecFixed,
        $22807b92000b3c41$var$_decodeFixedVec
    ],
    [
        "{",
        "}",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Struct,
        $22807b92000b3c41$var$_decodeStruct
    ],
    [
        "(",
        ")",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Tuple,
        $22807b92000b3c41$var$_decodeTuple
    ],
    // the inner for these are the same as tuple, multiple values
    [
        "BTreeMap<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeMap,
        $22807b92000b3c41$var$_decodeTuple
    ],
    [
        "HashMap<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).HashMap,
        $22807b92000b3c41$var$_decodeTuple
    ],
    [
        "Int<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Int,
        $22807b92000b3c41$var$_decodeInt
    ],
    [
        "Result<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Result,
        $22807b92000b3c41$var$_decodeTuple
    ],
    [
        "UInt<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).UInt,
        $22807b92000b3c41$var$_decodeUInt
    ],
    [
        "DoNotConstruct<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).DoNotConstruct,
        $22807b92000b3c41$var$_decodeDoNotConstruct
    ]
];
const $22807b92000b3c41$var$wrappedExtraction = [
    [
        "BTreeSet<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeSet
    ],
    [
        "Compact<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Compact
    ],
    [
        "Linkage<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Linkage
    ],
    [
        "Opaque<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque
    ],
    [
        "Option<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Option
    ],
    [
        "Range<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Range
    ],
    [
        "RangeInclusive<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).RangeInclusive
    ],
    [
        "Vec<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Vec
    ],
    [
        "WrapperKeepOpaque<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperKeepOpaque
    ],
    [
        "WrapperOpaque<",
        ">",
        (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque
    ]
];
function $22807b92000b3c41$var$extractSubType(type, [start, end]) {
    return type.substring(start.length, type.length - end.length);
}
function $22807b92000b3c41$export$9f31b1beea63f4ee(_type, { displayName: displayName, name: name } = {}, count = 0) {
    // create the type via Type, allowing types to be sanitized
    const type = (0, $8eefb6164d9f7959$export$83d2e9e3e4ee39ed)(_type);
    const value = {
        displayName: displayName,
        info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
        name: name,
        type: type
    };
    if (++count > 64) throw new Error("getTypeDef: Maximum nested limit reached");
    const nested = $22807b92000b3c41$var$nestedExtraction.find((nested)=>$22807b92000b3c41$var$hasWrapper(type, nested));
    if (nested) {
        value.info = nested[2];
        return nested[3](value, type, $22807b92000b3c41$var$extractSubType(type, nested), count);
    }
    const wrapped = $22807b92000b3c41$var$wrappedExtraction.find((wrapped)=>$22807b92000b3c41$var$hasWrapper(type, wrapped));
    if (wrapped) {
        value.info = wrapped[2];
        value.sub = $22807b92000b3c41$export$9f31b1beea63f4ee($22807b92000b3c41$var$extractSubType(type, wrapped), {}, count);
    }
    return value;
}


function $003ffa0ec6642d21$var$extractSubSingle(_, { sub: sub }) {
    const { lookupName: lookupName, type: type } = sub;
    return $003ffa0ec6642d21$export$de925353ab9889c5([
        lookupName || type
    ]);
}
function $003ffa0ec6642d21$var$extractSubArray(_, { sub: sub }) {
    return $003ffa0ec6642d21$export$de925353ab9889c5(sub.map(({ lookupName: lookupName, type: type })=>lookupName || type));
}
function $003ffa0ec6642d21$var$unhandled(type, { info: info }) {
    throw new Error(`Unhandled: Unable to create and validate type from ${type} (info=${(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29)[info]})`);
}
const $003ffa0ec6642d21$var$mapping = {
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeMap]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeSet]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Compact]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).DoNotConstruct]: $003ffa0ec6642d21$var$unhandled,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Enum]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).HashMap]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Int]: $003ffa0ec6642d21$var$unhandled,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Linkage]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null]: $003ffa0ec6642d21$var$unhandled,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Option]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain]: (_, typeDef)=>typeDef.lookupName || typeDef.type,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Range]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).RangeInclusive]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Result]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Set]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Si]: $003ffa0ec6642d21$var$unhandled,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Struct]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Tuple]: $003ffa0ec6642d21$var$extractSubArray,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).UInt]: $003ffa0ec6642d21$var$unhandled,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Vec]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).VecFixed]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperKeepOpaque]: $003ffa0ec6642d21$var$extractSubSingle,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque]: $003ffa0ec6642d21$var$extractSubSingle
};
function $003ffa0ec6642d21$export$de925353ab9889c5(types) {
    const count = types.length;
    const result = new Array(count);
    for(let i = 0; i < count; i++){
        const type = types[i];
        const typeDef = (0, $22807b92000b3c41$export$9f31b1beea63f4ee)(type);
        result[i] = $003ffa0ec6642d21$var$mapping[typeDef.info](type, typeDef);
    }
    return result;
}



const $6a03c71c5527d1d2$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("metadata");
function $6a03c71c5527d1d2$export$f9ec4b7ca84375d0(registry, throwError, types) {
    const missing = (0, $c18a1aec78715c59$export$d154e161130d8280)((0, $003ffa0ec6642d21$export$de925353ab9889c5)(types)).filter((type)=>!registry.hasType(type) && !registry.isLookupType(type)).sort();
    if (missing.length !== 0) {
        const message = `Unknown types found, no types for ${missing.join(", ")}`;
        if (throwError) throw new Error(message);
        else $6a03c71c5527d1d2$var$l.warn(message);
    }
    return types;
}


/** @internal */ function $3c4fcdbb181a4dd4$var$extractTypes(lookup, types) {
    return types.map(({ type: type })=>lookup.getTypeDef(type).type);
}
/** @internal */ function $3c4fcdbb181a4dd4$var$extractFieldTypes(lookup, type) {
    return lookup.getSiType(type).def.asVariant.variants.map(({ fields: fields })=>$3c4fcdbb181a4dd4$var$extractTypes(lookup, fields));
}
/** @internal */ function $3c4fcdbb181a4dd4$var$getPalletNames({ lookup: lookup, pallets: pallets }) {
    return pallets.reduce((all, { calls: calls, constants: constants, events: events, storage: storage })=>{
        all.push([
            $3c4fcdbb181a4dd4$var$extractTypes(lookup, constants)
        ]);
        if (calls.isSome) all.push($3c4fcdbb181a4dd4$var$extractFieldTypes(lookup, calls.unwrap().type));
        if (events.isSome) all.push($3c4fcdbb181a4dd4$var$extractFieldTypes(lookup, events.unwrap().type));
        if (storage.isSome) all.push(storage.unwrap().items.map(({ type: type })=>{
            if (type.isPlain) return [
                lookup.getTypeDef(type.asPlain).type
            ];
            const { hashers: hashers, key: key, value: value } = type.asMap;
            return hashers.length === 1 ? [
                lookup.getTypeDef(value).type,
                lookup.getTypeDef(key).type
            ] : [
                lookup.getTypeDef(value).type,
                ...lookup.getSiType(key).def.asTuple.map((t)=>lookup.getTypeDef(t).type)
            ];
        }));
        return all;
    }, []);
}
function $3c4fcdbb181a4dd4$export$4a083bf1828809c6(registry, meta, throwError) {
    return (0, $6a03c71c5527d1d2$export$f9ec4b7ca84375d0)(registry, throwError, (0, $c18a1aec78715c59$export$d154e161130d8280)($3c4fcdbb181a4dd4$var$getPalletNames(meta)));
}


function $65b26dc111830010$var$trimDocs(docs) {
    const strings = docs.map((d)=>d.toString().trim());
    const firstEmpty = strings.findIndex((d)=>!d.length);
    return firstEmpty === -1 ? strings : strings.slice(0, firstEmpty);
}
function $65b26dc111830010$export$c0708a653c407b9b(registry, { extrinsic: extrinsic, lookup: lookup, pallets: pallets }) {
    return registry.createTypeUnsafe("MetadataLatest", [
        {
            extrinsic: extrinsic,
            lookup: {
                types: lookup.types.map(({ id: id, type: type })=>registry.createTypeUnsafe("PortableType", [
                        {
                            id: id,
                            type: (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, type, {
                                docs: $65b26dc111830010$var$trimDocs(type.docs)
                            })
                        }
                    ]))
            },
            pallets: pallets.map(({ calls: calls, index: index, name: name })=>({
                    calls: registry.createTypeUnsafe("Option<PalletCallMetadataLatest>", [
                        calls.unwrapOr(null)
                    ]),
                    index: index,
                    name: name
                }))
        }
    ]).toJSON();
}



/** @internal */ function $1d4267e3a01a43e8$var$createStorageHasher(registry, hasher) {
    // Blake2_128_Concat has been added at index 2, so we increment all the
    // indexes greater than 2
    if (hasher.toNumber() >= 2) return registry.createTypeUnsafe("StorageHasherV10", [
        hasher.toNumber() + 1
    ]);
    return registry.createTypeUnsafe("StorageHasherV10", [
        hasher
    ]);
}
/** @internal */ function $1d4267e3a01a43e8$var$createStorageType(registry, entryType) {
    if (entryType.isMap) return [
        (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, entryType.asMap, {
            hasher: $1d4267e3a01a43e8$var$createStorageHasher(registry, entryType.asMap.hasher)
        }),
        1
    ];
    if (entryType.isDoubleMap) return [
        (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, entryType.asDoubleMap, {
            hasher: $1d4267e3a01a43e8$var$createStorageHasher(registry, entryType.asDoubleMap.hasher),
            key2Hasher: $1d4267e3a01a43e8$var$createStorageHasher(registry, entryType.asDoubleMap.key2Hasher)
        }),
        2
    ];
    return [
        entryType.asPlain,
        0
    ];
}
/** @internal */ function $1d4267e3a01a43e8$var$convertModule(registry, mod) {
    const storage = mod.storage.unwrapOr(null);
    return registry.createTypeUnsafe("ModuleMetadataV10", [
        (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, mod, {
            storage: storage ? (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, storage, {
                items: storage.items.map((item)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, item, {
                        type: registry.createTypeUnsafe("StorageEntryTypeV10", $1d4267e3a01a43e8$var$createStorageType(registry, item.type))
                    }))
            }) : null
        })
    ]);
}
function $1d4267e3a01a43e8$export$4f7d0d97510ab072(registry, { modules: modules }) {
    return registry.createTypeUnsafe("MetadataV10", [
        {
            modules: modules.map((mod)=>$1d4267e3a01a43e8$var$convertModule(registry, mod))
        }
    ]);
}


/** @internal */ function $3c5ccb606e34aa7b$export$8e1cfc6fb16a6568(registry, { modules: modules }) {
    return registry.createTypeUnsafe("MetadataV11", [
        {
            // This is new in V11, pass V0 here - something non-existing, telling the API to use
            // the fallback for this information (on-chain detection)
            extrinsic: {
                signedExtensions: [],
                version: 0
            },
            modules: modules
        }
    ]);
}



function $32bd2b0036518222$export$50a6fe69b948075e(registry, { extrinsic: extrinsic, modules: modules }) {
    return registry.createTypeUnsafe("MetadataV12", [
        {
            extrinsic: extrinsic,
            modules: modules.map((mod)=>registry.createTypeUnsafe("ModuleMetadataV12", [
                    (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, mod, {
                        index: 255
                    })
                ]))
        }
    ]);
}


/**
 * @internal
 **/ function $0a6d035a914fc3a0$export$ea069da8ae0f3e49(registry, v12) {
    return registry.createTypeUnsafe("MetadataV13", [
        v12
    ]);
}



const $70cede73c640b469$var$typesAlias = {
    assets: {
        Approval: "AssetApproval",
        ApprovalKey: "AssetApprovalKey",
        Balance: "TAssetBalance",
        DestroyWitness: "AssetDestroyWitness"
    },
    babe: {
        EquivocationProof: "BabeEquivocationProof"
    },
    balances: {
        Status: "BalanceStatus"
    },
    beefy: {
        AuthorityId: "BeefyId"
    },
    contracts: {
        StorageKey: "ContractStorageKey"
    },
    electionProviderMultiPhase: {
        Phase: "ElectionPhase"
    },
    ethereum: {
        Block: "EthBlock",
        Header: "EthHeader",
        Receipt: "EthReceipt",
        Transaction: "EthTransaction",
        TransactionStatus: "EthTransactionStatus"
    },
    evm: {
        Account: "EvmAccount",
        Log: "EvmLog",
        Vicinity: "EvmVicinity"
    },
    grandpa: {
        Equivocation: "GrandpaEquivocation",
        EquivocationProof: "GrandpaEquivocationProof"
    },
    identity: {
        Judgement: "IdentityJudgement"
    },
    inclusion: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    paraDisputes: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    paraInclusion: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    paraScheduler: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    paraShared: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    parachains: {
        Id: "ParaId"
    },
    parasDisputes: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    parasInclusion: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    parasScheduler: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    parasShared: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    proposeParachain: {
        Proposal: "ParachainProposal"
    },
    proxy: {
        Announcement: "ProxyAnnouncement"
    },
    scheduler: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    shared: {
        ValidatorIndex: "ParaValidatorIndex"
    },
    society: {
        Judgement: "SocietyJudgement",
        Vote: "SocietyVote"
    },
    staking: {
        Compact: "CompactAssignments"
    },
    treasury: {
        Proposal: "TreasuryProposal"
    },
    xcm: {
        AssetId: "XcmAssetId"
    },
    xcmPallet: {
        AssetId: "XcmAssetId"
    }
};
function $70cede73c640b469$export$c55c30dddb6baeb1({ knownTypes: knownTypes }, section) {
    return {
        ...$70cede73c640b469$var$typesAlias[section] ?? {},
        ...knownTypes.typesAlias?.[section] ?? {}
    };
}


const $73fd57d4f755fe72$var$CORE_V1_TO_V4 = {
    execute_block: {
        description: "Execute the given block.",
        params: [
            {
                name: "block",
                type: "Block"
            }
        ],
        type: "Null"
    }
};
const $73fd57d4f755fe72$var$CORE_V1_TO_V2 = {
    version: {
        description: "Returns the version of the runtime.",
        params: [],
        type: "RuntimeVersionPre3"
    }
};
const $73fd57d4f755fe72$var$CORE_V2_TO_V4 = {
    initialize_block: {
        description: "Initialize a block with the given header.",
        params: [
            {
                name: "header",
                type: "Header"
            }
        ],
        type: "Null"
    }
};
const $73fd57d4f755fe72$export$874fd8712028ad21 = {
    Core: [
        {
            methods: {
                version: {
                    description: "Returns the version of the runtime.",
                    params: [],
                    type: "RuntimeVersion"
                },
                ...$73fd57d4f755fe72$var$CORE_V1_TO_V4,
                ...$73fd57d4f755fe72$var$CORE_V2_TO_V4
            },
            version: 4
        },
        {
            methods: {
                version: {
                    description: "Returns the version of the runtime.",
                    params: [],
                    type: "RuntimeVersionPre4"
                },
                ...$73fd57d4f755fe72$var$CORE_V1_TO_V4,
                ...$73fd57d4f755fe72$var$CORE_V2_TO_V4
            },
            version: 3
        },
        {
            methods: {
                ...$73fd57d4f755fe72$var$CORE_V1_TO_V2,
                ...$73fd57d4f755fe72$var$CORE_V1_TO_V4,
                ...$73fd57d4f755fe72$var$CORE_V2_TO_V4
            },
            version: 2
        },
        {
            methods: {
                initialise_block: {
                    description: "Initialize a block with the given header.",
                    params: [
                        {
                            name: "header",
                            type: "Header"
                        }
                    ],
                    type: "Null"
                },
                ...$73fd57d4f755fe72$var$CORE_V1_TO_V2,
                ...$73fd57d4f755fe72$var$CORE_V1_TO_V4
            },
            version: 1
        }
    ]
};


const $311b815197193fad$var$numberTypes = {
    Fixed64: "Int<64, Fixed64>",
    FixedI64: "Int<64, FixedI64>",
    FixedU64: "UInt<64, FixedU64>",
    Fixed128: "Int<128, Fixed128>",
    FixedI128: "Int<128, FixedI128>",
    FixedU128: "UInt<128, FixedU128>",
    I32F32: "Int<64, I32F32>",
    U32F32: "UInt<64, U32F32>",
    PerU16: "UInt<16, PerU16>",
    Perbill: "UInt<32, Perbill>",
    Percent: "UInt<8, Percent>",
    Permill: "UInt<32, Permill>",
    Perquintill: "UInt<64, Perquintill>"
};
const $311b815197193fad$export$e0d0b92d7d223ff2 = {
    //
    // (1) Defaults from Substrate
    //
    Council: "CollectiveOrigin",
    System: "SystemOrigin",
    TechnicalCommittee: "CollectiveOrigin",
    //
    // (2) Defaults from Polkadot
    //
    Xcm: "XcmOrigin",
    XcmPallet: "XcmOrigin",
    //
    // (3) Defaults from Acala
    //
    Authority: "AuthorityOrigin",
    GeneralCouncil: "CollectiveOrigin"
};
var $311b815197193fad$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $73fd57d4f755fe72$export$874fd8712028ad21,
    types: {
        ...$311b815197193fad$var$numberTypes,
        AccountId: "AccountId32",
        AccountId20: "GenericEthereumAccountId",
        AccountId32: "GenericAccountId32",
        AccountId33: "GenericAccountId33",
        AccountIdOf: "AccountId",
        AccountIndex: "GenericAccountIndex",
        Address: "MultiAddress",
        AssetId: "u32",
        Balance: "UInt<128, Balance>",
        BalanceOf: "Balance",
        Block: "GenericBlock",
        BlockNumber: "u32",
        BlockNumberFor: "BlockNumber",
        BlockNumberOf: "BlockNumber",
        Call: "GenericCall",
        CallHash: "Hash",
        CallHashOf: "CallHash",
        ChangesTrieConfiguration: {
            digestInterval: "u32",
            digestLevels: "u32"
        },
        ChangesTrieSignal: {
            _enum: {
                NewConfiguration: "Option<ChangesTrieConfiguration>"
            }
        },
        ConsensusEngineId: "GenericConsensusEngineId",
        CodecHash: "Hash",
        CrateVersion: {
            major: "u16",
            minor: "u8",
            patch: "u8"
        },
        Digest: {
            logs: "Vec<DigestItem>"
        },
        DigestItem: {
            _enum: {
                Other: "Bytes",
                AuthoritiesChange: "Vec<AuthorityId>",
                ChangesTrieRoot: "Hash",
                SealV0: "SealV0",
                Consensus: "Consensus",
                Seal: "Seal",
                PreRuntime: "PreRuntime",
                ChangesTrieSignal: "ChangesTrieSignal",
                RuntimeEnvironmentUpdated: "Null" // 8
            }
        },
        ExtrinsicsWeight: {
            normal: "Weight",
            operational: "Weight"
        },
        H32: "[u8; 4; H32]",
        H64: "[u8; 8; H64]",
        H128: "[u8; 16; H128]",
        H160: "[u8; 20; H160]",
        H256: "[u8; 32; H256]",
        H512: "[u8; 64; H512]",
        H1024: "[u8; 128; H1024]",
        H2048: "[u8; 256; H2048]",
        Hash: "H256",
        Header: {
            parentHash: "Hash",
            number: "Compact<BlockNumber>",
            stateRoot: "Hash",
            extrinsicsRoot: "Hash",
            digest: "Digest"
        },
        HeaderPartial: {
            parentHash: "Hash",
            // since we only parse JSON with this, having non-compact works
            number: "BlockNumber"
        },
        IndicesLookupSource: "GenericLookupSource",
        Index: "u32",
        Justification: "(ConsensusEngineId, EncodedJustification)",
        EncodedJustification: "Bytes",
        Justifications: "Vec<Justification>",
        KeyValue: "(StorageKey, StorageData)",
        KeyTypeId: "u32",
        LockIdentifier: "[u8; 8]",
        LookupSource: "MultiAddress",
        LookupTarget: "AccountId",
        ModuleId: "LockIdentifier",
        MultiAddress: "GenericMultiAddress",
        MultiSigner: {
            _enum: {
                Ed25519: "[u8; 32]",
                Sr25519: "[u8; 32]",
                Ecdsa: "[u8; 33]"
            }
        },
        Moment: "UInt<64, Moment>",
        OpaqueCall: "Bytes",
        Origin: "DoNotConstruct<Origin>",
        OriginCaller: {
            _enum: {
                // this should be dynamically built from the actual modules, based on index
                System: "SystemOrigin"
            }
        },
        PalletId: "LockIdentifier",
        PalletsOrigin: "OriginCaller",
        PalletVersion: {
            major: "u16",
            minor: "u8",
            patch: "u8"
        },
        Pays: {
            _enum: [
                "Yes",
                "No"
            ]
        },
        Phantom: "Null",
        PhantomData: "Null",
        Releases: {
            _enum: [
                "V1",
                "V2",
                "V3",
                "V4",
                "V5",
                "V6",
                "V7",
                "V8",
                "V9",
                "V10"
            ]
        },
        RuntimeCall: "Call",
        RuntimeEvent: "Event",
        RuntimeDbWeight: {
            read: "Weight",
            write: "Weight"
        },
        SignedBlock: "SignedBlockWithJustifications",
        SignedBlockWithJustification: {
            block: "Block",
            justification: "Option<EncodedJustification>"
        },
        SignedBlockWithJustifications: {
            block: "Block",
            justifications: "Option<Justifications>"
        },
        Slot: "u64",
        SlotDuration: "u64",
        StorageData: "Bytes",
        StorageInfo: {
            palletName: "Bytes",
            storage_name: "Bytes",
            prefix: "Bytes",
            maxValues: "Option<u32>",
            maxSize: "Option<u32>"
        },
        StorageProof: {
            trieNodes: "Vec<Bytes>"
        },
        TransactionPriority: "u64",
        TransactionLongevity: "u64",
        TransactionTag: "Bytes",
        TransactionInfo: {
            _alias: {
                dataSize: "size"
            },
            chunkRoot: "H256",
            contentHash: "H256",
            dataSize: "u32",
            blockChunks: "u32"
        },
        TransactionStorageProof: {
            chunk: "Vec<u8>",
            proof: "Vec<Vec<u8>>"
        },
        ValidatorId: "AccountId",
        ValidatorIdOf: "ValidatorId",
        WeightV0: "u32",
        WeightV1: "u64",
        WeightV2: {
            refTime: "Compact<u64>",
            proofSize: "Compact<u64>"
        },
        Weight: "WeightV2",
        WeightMultiplier: "Fixed64",
        // digest
        PreRuntime: "(ConsensusEngineId, Bytes)",
        SealV0: "(u64, Signature)",
        Seal: "(ConsensusEngineId, Bytes)",
        Consensus: "(ConsensusEngineId, Bytes)"
    }
};


const $a1e5d752204535dc$var$BOXES = [
    [
        "<",
        ">"
    ],
    [
        "<",
        ","
    ],
    [
        ",",
        ">"
    ],
    [
        "(",
        ")"
    ],
    [
        "(",
        ","
    ],
    [
        ",",
        ","
    ],
    [
        ",",
        ")"
    ]
];
/**
 * Creates a compatible type mapping
 * @internal
 **/ function $a1e5d752204535dc$var$compatType(specs, _type) {
    const type = _type.toString();
    const index = specs.findIndex(({ def: def })=>def.HistoricMetaCompat === type);
    if (index !== -1) return index;
    return specs.push({
        def: {
            HistoricMetaCompat: type
        }
    }) - 1;
}
function $a1e5d752204535dc$var$compatTypes(specs, ...types) {
    for(let i = 0, count = types.length; i < count; i++)$a1e5d752204535dc$var$compatType(specs, types[i]);
}
function $a1e5d752204535dc$var$makeTupleType(specs, entries) {
    return specs.push({
        def: {
            Tuple: entries
        }
    }) - 1;
}
function $a1e5d752204535dc$var$makeVariantType(modName, variantType, specs, variants) {
    return specs.push({
        def: {
            Variant: {
                variants: variants
            }
        },
        path: [
            `pallet_${modName.toString()}`,
            "pallet",
            variantType
        ]
    }) - 1;
}
/**
 * @internal
 * generate & register the OriginCaller type
 **/ function $a1e5d752204535dc$var$registerOriginCaller(registry, modules, metaVersion) {
    registry.register({
        OriginCaller: {
            _enum: modules.map((mod, index)=>[
                    mod.name.toString(),
                    metaVersion >= 12 ? mod.index.toNumber() : index
                ]).sort((a, b)=>a[1] - b[1]).reduce((result, [name, index])=>{
                for(let i = Object.keys(result).length; i < index; i++)result[`Empty${i}`] = "Null";
                result[name] = (0, $311b815197193fad$export$e0d0b92d7d223ff2)[name] || "Null";
                return result;
            }, {})
        }
    });
}
/**
 * Find and apply the correct type override
 * @internal
 **/ function $a1e5d752204535dc$var$setTypeOverride(sectionTypes, types) {
    types.forEach((type)=>{
        const override = Object.keys(sectionTypes).find((aliased)=>type.eq(aliased));
        if (override) type.setOverride(sectionTypes[override]);
        else {
            // FIXME: NOT happy with this approach, but gets over the initial hump cased by (Vec<Announcement>,BalanceOf)
            const orig = type.toString();
            const alias = Object.entries(sectionTypes).reduce((result, [src, dst])=>$a1e5d752204535dc$var$BOXES.reduce((result, [a, z])=>result.replace(`${a}${src}${z}`, `${a}${dst}${z}`), result), orig);
            if (orig !== alias) type.setOverride(alias);
        }
    });
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 **/ function $a1e5d752204535dc$var$convertCalls(specs, registry, modName, calls, sectionTypes) {
    const variants = calls.map(({ args: args, docs: docs, name: name }, index)=>{
        $a1e5d752204535dc$var$setTypeOverride(sectionTypes, args.map(({ type: type })=>type));
        return registry.createTypeUnsafe("SiVariant", [
            {
                docs: docs,
                fields: args.map(({ name: name, type: type })=>registry.createTypeUnsafe("SiField", [
                        {
                            name: name,
                            type: $a1e5d752204535dc$var$compatType(specs, type)
                        }
                    ])),
                index: index,
                name: name
            }
        ]);
    });
    return registry.createTypeUnsafe("PalletCallMetadataV14", [
        {
            type: $a1e5d752204535dc$var$makeVariantType(modName, "Call", specs, variants)
        }
    ]);
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 */ function $a1e5d752204535dc$var$convertConstants(specs, registry, constants, sectionTypes) {
    return constants.map(({ docs: docs, name: name, type: type, value: value })=>{
        $a1e5d752204535dc$var$setTypeOverride(sectionTypes, [
            type
        ]);
        return registry.createTypeUnsafe("PalletConstantMetadataV14", [
            {
                docs: docs,
                name: name,
                type: $a1e5d752204535dc$var$compatType(specs, type),
                value: value
            }
        ]);
    });
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 */ function $a1e5d752204535dc$var$convertErrors(specs, registry, modName, errors, _sectionTypes) {
    const variants = errors.map(({ docs: docs, name: name }, index)=>registry.createTypeUnsafe("SiVariant", [
            {
                docs: docs,
                fields: [],
                index: index,
                name: name
            }
        ]));
    return registry.createTypeUnsafe("PalletErrorMetadataV14", [
        {
            type: $a1e5d752204535dc$var$makeVariantType(modName, "Error", specs, variants)
        }
    ]);
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 **/ function $a1e5d752204535dc$var$convertEvents(specs, registry, modName, events, sectionTypes) {
    const variants = events.map(({ args: args, docs: docs, name: name }, index)=>{
        $a1e5d752204535dc$var$setTypeOverride(sectionTypes, args);
        return registry.createTypeUnsafe("SiVariant", [
            {
                docs: docs,
                fields: args.map((t)=>registry.createTypeUnsafe("SiField", [
                        {
                            type: $a1e5d752204535dc$var$compatType(specs, t)
                        }
                    ])),
                index: index,
                name: name
            }
        ]);
    });
    return registry.createTypeUnsafe("PalletEventMetadataV14", [
        {
            type: $a1e5d752204535dc$var$makeVariantType(modName, "Event", specs, variants)
        }
    ]);
}
function $a1e5d752204535dc$var$createMapEntry(specs, registry, sectionTypes, { hashers: hashers, isLinked: isLinked, isOptional: isOptional, keys: keys, value: value }) {
    $a1e5d752204535dc$var$setTypeOverride(sectionTypes, [
        value,
        ...Array.isArray(keys) ? keys : [
            keys
        ]
    ]);
    return registry.createTypeUnsafe("StorageEntryTypeV14", [
        {
            Map: {
                hashers: hashers,
                key: hashers.length === 1 ? $a1e5d752204535dc$var$compatType(specs, keys[0]) : $a1e5d752204535dc$var$makeTupleType(specs, keys.map((t)=>$a1e5d752204535dc$var$compatType(specs, t))),
                value: isLinked ? $a1e5d752204535dc$var$compatType(specs, `(${isOptional ? `Option<${value.toString()}>` : value.toString()}, Linkage<${keys[0].toString()}>)`) : $a1e5d752204535dc$var$compatType(specs, value)
            }
        }
    ]);
}
/**
 * Apply module-specific storage type overrides (always part of toV14)
 * @internal
 **/ function $a1e5d752204535dc$var$convertStorage(specs, registry, { items: items, prefix: prefix }, sectionTypes) {
    return registry.createTypeUnsafe("PalletStorageMetadataV14", [
        {
            items: items.map(({ docs: docs, fallback: fallback, modifier: modifier, name: name, type: type })=>{
                let entryType;
                if (type.isPlain) {
                    const plain = type.asPlain;
                    $a1e5d752204535dc$var$setTypeOverride(sectionTypes, [
                        plain
                    ]);
                    entryType = registry.createTypeUnsafe("StorageEntryTypeV14", [
                        {
                            Plain: $a1e5d752204535dc$var$compatType(specs, plain)
                        }
                    ]);
                } else if (type.isMap) {
                    const map = type.asMap;
                    entryType = $a1e5d752204535dc$var$createMapEntry(specs, registry, sectionTypes, {
                        hashers: [
                            map.hasher
                        ],
                        isLinked: map.linked.isTrue,
                        isOptional: modifier.isOptional,
                        keys: [
                            map.key
                        ],
                        value: map.value
                    });
                } else if (type.isDoubleMap) {
                    const dm = type.asDoubleMap;
                    entryType = $a1e5d752204535dc$var$createMapEntry(specs, registry, sectionTypes, {
                        hashers: [
                            dm.hasher,
                            dm.key2Hasher
                        ],
                        isLinked: false,
                        isOptional: modifier.isOptional,
                        keys: [
                            dm.key1,
                            dm.key2
                        ],
                        value: dm.value
                    });
                } else {
                    const nm = type.asNMap;
                    entryType = $a1e5d752204535dc$var$createMapEntry(specs, registry, sectionTypes, {
                        hashers: nm.hashers,
                        isLinked: false,
                        isOptional: modifier.isOptional,
                        keys: nm.keyVec,
                        value: nm.value
                    });
                }
                return registry.createTypeUnsafe("StorageEntryMetadataV14", [
                    {
                        docs: docs,
                        fallback: fallback,
                        modifier: modifier,
                        name: name,
                        type: entryType
                    }
                ]);
            }),
            prefix: prefix
        }
    ]);
}
/** @internal */ function $a1e5d752204535dc$var$convertExtrinsic(registry, { signedExtensions: signedExtensions, version: version }) {
    return registry.createTypeUnsafe("ExtrinsicMetadataV14", [
        {
            signedExtensions: signedExtensions.map((identifier)=>({
                    identifier: identifier,
                    type: 0 // we don't map the fields at all
                })),
            type: 0,
            version: version
        }
    ]);
}
/** @internal */ function $a1e5d752204535dc$var$createPallet(specs, registry, mod, { calls: calls, constants: constants, errors: errors, events: events, storage: storage }) {
    const sectionTypes = (0, $70cede73c640b469$export$c55c30dddb6baeb1)(registry, (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(mod.name));
    return registry.createTypeUnsafe("PalletMetadataV14", [
        {
            calls: calls && $a1e5d752204535dc$var$convertCalls(specs, registry, mod.name, calls, sectionTypes),
            constants: $a1e5d752204535dc$var$convertConstants(specs, registry, constants, sectionTypes),
            errors: errors && $a1e5d752204535dc$var$convertErrors(specs, registry, mod.name, errors, sectionTypes),
            events: events && $a1e5d752204535dc$var$convertEvents(specs, registry, mod.name, events, sectionTypes),
            index: mod.index,
            name: mod.name,
            storage: storage && $a1e5d752204535dc$var$convertStorage(specs, registry, storage, sectionTypes)
        }
    ]);
}
function $a1e5d752204535dc$export$e7c3c862ae12a646(registry, v13, metaVersion) {
    const specs = [];
    // position 0 always has Null, additionally add internal defaults
    $a1e5d752204535dc$var$compatTypes(specs, "Null", "u8", "u16", "u32", "u64");
    $a1e5d752204535dc$var$registerOriginCaller(registry, v13.modules, metaVersion);
    const extrinsic = $a1e5d752204535dc$var$convertExtrinsic(registry, v13.extrinsic);
    const pallets = v13.modules.map((mod)=>$a1e5d752204535dc$var$createPallet(specs, registry, mod, {
            calls: mod.calls.unwrapOr(null),
            constants: mod.constants,
            errors: mod.errors.length ? mod.errors : null,
            events: mod.events.unwrapOr(null),
            storage: mod.storage.unwrapOr(null)
        }));
    return registry.createTypeUnsafe("MetadataV14", [
        {
            extrinsic: extrinsic,
            lookup: {
                types: specs.map((type, id)=>registry.createTypeUnsafe("PortableType", [
                        {
                            id: id,
                            type: type
                        }
                    ]))
            },
            pallets: pallets
        }
    ]);
}


/**
 * Convert the Metadata to v15
 * @internal
 **/ function $545c212237e39950$export$11859103ae7567e1(registry, v14, _) {
    // V15 is mostly equivalent to v14 however it does add
    //
    // 1. The top-level apis entry - it is assumed that in usage we would
    //    just check for all-empty (like this would construct)
    // 2. A docs param on the pallet itself
    //
    // A straight conversion with createTypeUndafe magic fills in details
    return registry.createTypeUnsafe("MetadataV15", [
        v14
    ]);
}


/**
 * Convert the Metadata (which is an alias) to latest
 * @internal
 **/ function $7f73d416e84000fc$export$fc3e439b04637e90(_registry, v15, _metaVersion) {
    return v15;
}



var $hWfed = parcelRequire("hWfed");
var $hWfed = parcelRequire("hWfed");
const $031d4cf4355dbeac$export$df7eb0036fdbadfa = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
const $031d4cf4355dbeac$export$8d1cfb084cec6129 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1);
const $031d4cf4355dbeac$export$e1f42f91b26e6faf = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(2);
const $031d4cf4355dbeac$export$a40b397736588c90 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(3);
const $031d4cf4355dbeac$export$668a9c19c46894c4 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(4);
const $031d4cf4355dbeac$export$cd5352a2092e224d = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(5);
const $031d4cf4355dbeac$export$6f3b9548667e47a9 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(6);
const $031d4cf4355dbeac$export$1420aea3aab22305 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(7);
const $031d4cf4355dbeac$export$69c7ce65bc6aaab = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(8);
const $031d4cf4355dbeac$export$efa31b7a637a0365 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(9);
const $031d4cf4355dbeac$export$25aad8977506641f = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(10);
const $031d4cf4355dbeac$export$6691a839db0e7399 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(100);
const $031d4cf4355dbeac$export$188157132015d48c = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1000);
const $031d4cf4355dbeac$export$29fadd8d48a94eed = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1000000);
const $031d4cf4355dbeac$export$c576b535d52501f1 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1000000000);
const $031d4cf4355dbeac$export$d7eaaf5791ee0cbe = $031d4cf4355dbeac$export$c576b535d52501f1.mul($031d4cf4355dbeac$export$c576b535d52501f1);
const $031d4cf4355dbeac$export$71316adf7b729a57 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(Number.MAX_SAFE_INTEGER);
const $031d4cf4355dbeac$export$b900f697b76aa387 = /*#__PURE__*/ new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(94906265);


var $hWfed = parcelRequire("hWfed");

function $6e990972c9403971$export$3e415f1787628d9c(value) {
    if (!value || value === "0x") return "";
    else if ((0, $de053f8bd7fe9927$export$aeee3e57f1b0a4e5).test(value)) return value.substring(2);
    else if ((0, $de053f8bd7fe9927$export$cfe92fa222ae2d9).test(value)) return value;
    throw new Error(`Expected hex value to convert, found '${value}'`);
}


function $3e8a64521966bb95$export$c11dd5c0192d997c(value, { isLe: isLe = false, isNegative: isNegative = false } = {}) {
    if (!value || value === "0x") return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
    const stripped = (0, $6e990972c9403971$export$3e415f1787628d9c)(value);
    const bn = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(stripped, 16, isLe ? "le" : "be");
    // fromTwos takes as parameter the number of bits, which is the hex length
    // multiplied by 4 (2 bytes being 8 bits)
    return isNegative ? bn.fromTwos(stripped.length * 4) : bn;
}






function $d5bd3faeeec86a19$export$1a2d97de39ecbb75(...fns) {
    return (value)=>((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value) || (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value)) && fns.every((f)=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value[f]));
}
function $d5bd3faeeec86a19$export$ca37b3e45df82a11(...fns) {
    return (value)=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value) && fns.every((f)=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value[f]));
}
function $d5bd3faeeec86a19$export$35271fb956347754(...fns) {
    return (value)=>(0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value) && fns.every((f)=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value[f]));
}


const $58ec93fb8d1ec220$export$3188127418ca7d68 = /*#__PURE__*/ (0, $d5bd3faeeec86a19$export$1a2d97de39ecbb75)("toBigInt");



const $8ed7903dfadc63bd$export$879bd0c0c0f82682 = /*#__PURE__*/ (0, $d5bd3faeeec86a19$export$1a2d97de39ecbb75)("toBn");



var $hWfed = parcelRequire("hWfed");
function $fee06eacc361490f$export$3ce10b692b02dcbb(value) {
    return value ? (0, (/*@__PURE__*/$parcel$interopDefault($hWfed))).isBN(value) ? value : (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? (0, $3e8a64521966bb95$export$c11dd5c0192d997c)(value.toString()) : (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(value) ? new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value.toString()) : (0, $8ed7903dfadc63bd$export$879bd0c0c0f82682)(value) ? value.toBn() : (0, $58ec93fb8d1ec220$export$3188127418ca7d68)(value) ? new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value.toBigInt().toString()) : new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value) : new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
}



const $71bf0c7f6110fade$var$DEFAULT_OPTS = {
    bitLength: -1,
    isLe: true,
    isNegative: false
};
function $71bf0c7f6110fade$export$9a0110536a1deb74(value, { bitLength: bitLength = -1, isLe: isLe = true, isNegative: isNegative = false } = $71bf0c7f6110fade$var$DEFAULT_OPTS) {
    const valueBn = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(value);
    const byteLength = bitLength === -1 ? Math.ceil(valueBn.bitLength() / 8) : Math.ceil((bitLength || 0) / 8);
    if (!value) return bitLength === -1 ? new Uint8Array(1) : new Uint8Array(byteLength);
    const output = new Uint8Array(byteLength);
    const bn = isNegative ? valueBn.toTwos(byteLength * 8) : valueBn;
    output.set(bn.toArray(isLe ? "le" : "be", byteLength), 0);
    return output;
}


function $76fe50cea1c69dee$export$2b04de991f078f40(value, { bitLength: bitLength = -1, isLe: isLe = false, isNegative: isNegative = false } = {}) {
    return (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $71bf0c7f6110fade$export$9a0110536a1deb74)(value, {
        bitLength: bitLength,
        isLe: isLe,
        isNegative: isNegative
    }));
}



const $8d03329e1274c7ab$var$NUMBER_REGEX = new RegExp("(\\d+?)(?=(\\d{3})+(?!\\d)|$)", "g");
function $8d03329e1274c7ab$export$845857f28dc08744(value, separator = ",") {
    // We can do this by adjusting the regx, however for the sake of clarity
    // we rather strip and re-add the negative sign in the output
    const isNegative = value[0].startsWith("-");
    const matched = isNegative ? value.substring(1).match($8d03329e1274c7ab$var$NUMBER_REGEX) : value.match($8d03329e1274c7ab$var$NUMBER_REGEX);
    return matched ? `${isNegative ? "-" : ""}${matched.join(separator)}` : value;
}


/**
 * Get the decimal and thousand separator of a locale
 * @param locale
 * @returns {decimal: string, thousand: string}
 */ function $01f605b220f27d31$export$cd567903cc935f1d(locale) {
    return {
        decimal: 0.1.toLocaleString(locale).substring(1, 2),
        thousand: 1000..toLocaleString(locale).substring(1, 2)
    };
}


/** @internal */ const $3538c255e777b02d$export$8ad8e9acc2d3795b = 8;
const $3538c255e777b02d$export$e6702cab675b095 = [
    {
        power: -24,
        text: "yocto",
        value: "y"
    },
    {
        power: -21,
        text: "zepto",
        value: "z"
    },
    {
        power: -18,
        text: "atto",
        value: "a"
    },
    {
        power: -15,
        text: "femto",
        value: "f"
    },
    {
        power: -12,
        text: "pico",
        value: "p"
    },
    {
        power: -9,
        text: "nano",
        value: "n"
    },
    {
        power: -6,
        text: "micro",
        value: "\xb5"
    },
    {
        power: -3,
        text: "milli",
        value: "m"
    },
    {
        power: 0,
        text: "Unit",
        value: "-"
    },
    {
        power: 3,
        text: "Kilo",
        value: "k"
    },
    {
        power: 6,
        text: "Mill",
        value: "M"
    },
    {
        power: 9,
        text: "Bill",
        value: "B"
    },
    {
        power: 12,
        text: "Tril",
        value: "T"
    },
    {
        power: 15,
        text: "Peta",
        value: "P"
    },
    {
        power: 18,
        text: "Exa",
        value: "E"
    },
    {
        power: 21,
        text: "Zeta",
        value: "Z"
    },
    {
        power: 24,
        text: "Yotta",
        value: "Y"
    }
];
function $3538c255e777b02d$export$236371b54fb86e2a(type) {
    // use a loop here, better RN support (which doesn't have [].find)
    for(let i = 0, count = $3538c255e777b02d$export$e6702cab675b095.length; i < count; i++){
        if ($3538c255e777b02d$export$e6702cab675b095[i].value === type) return $3538c255e777b02d$export$e6702cab675b095[i];
    }
    return $3538c255e777b02d$export$e6702cab675b095[$3538c255e777b02d$export$8ad8e9acc2d3795b];
}
function $3538c255e777b02d$export$5de1eda5a9909e28(text, decimals, forceUnit) {
    if (forceUnit) return $3538c255e777b02d$export$236371b54fb86e2a(forceUnit);
    const siDefIndex = $3538c255e777b02d$export$8ad8e9acc2d3795b - 1 + Math.ceil((text.length - decimals) / 3);
    return $3538c255e777b02d$export$e6702cab675b095[siDefIndex] || $3538c255e777b02d$export$e6702cab675b095[siDefIndex < 0 ? 0 : $3538c255e777b02d$export$e6702cab675b095.length - 1];
}


const $b3e30afb943da5cc$var$DEFAULT_DECIMALS = 0;
const $b3e30afb943da5cc$var$DEFAULT_UNIT = (0, $3538c255e777b02d$export$e6702cab675b095)[0, $3538c255e777b02d$export$8ad8e9acc2d3795b].text;
let $b3e30afb943da5cc$var$defaultDecimals = $b3e30afb943da5cc$var$DEFAULT_DECIMALS;
let $b3e30afb943da5cc$var$defaultUnit = $b3e30afb943da5cc$var$DEFAULT_UNIT;
function $b3e30afb943da5cc$var$_formatBalance(input, { decimals: decimals = $b3e30afb943da5cc$var$defaultDecimals, forceUnit: forceUnit, locale: locale = "en", withAll: withAll = false, withSi: withSi = true, withSiFull: withSiFull = false, withUnit: withUnit = true, withZero: withZero = true } = {}) {
    // we only work with string inputs here - convert anything
    // into the string-only value
    let text = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(input).toString();
    if (text.length === 0 || text === "0") return "0";
    // strip the negative sign so we can work with clean groupings, re-add this in the
    // end when we return the result (from here on we work with positive numbers)
    let sign = "";
    if (text[0].startsWith("-")) {
        sign = "-";
        text = text.substring(1);
    }
    // We start at midpoint (8) minus 1 - this means that values display as
    // 123.4567 instead of 0.1234 k (so we always have the most relevant).
    const si = (0, $3538c255e777b02d$export$5de1eda5a9909e28)(text, decimals, forceUnit);
    const mid = text.length - (decimals + si.power);
    const pre = mid <= 0 ? "0" : text.substring(0, mid);
    // get the post from the midpoint onward and then first add max decimals
    // before trimming to the correct (calculated) amount of decimals again
    let post = text.padStart(mid < 0 ? decimals : 1, "0").substring(mid < 0 ? 0 : mid).padEnd(withAll ? Math.max(decimals, 4) : 4, "0").substring(0, withAll ? Math.max(4, decimals + si.power) : 4);
    // remove all trailing 0's (if required via flag)
    if (!withZero) {
        let end = post.length - 1;
        // This looks inefficient, however it is better to do the checks and
        // only make one final slice than it is to do it in multiples
        do if (post[end] === "0") end--;
        while (post[end] === "0");
        post = post.substring(0, end + 1);
    }
    // the display unit
    const unit = (0, $a88f7b3165367a92$export$f9ce7b637dfbe238)(withUnit) ? (0, $3538c255e777b02d$export$e6702cab675b095)[0, $3538c255e777b02d$export$8ad8e9acc2d3795b].text : withUnit;
    // format the units for display based on the flags
    const units = withSi || withSiFull ? si.value === "-" ? withUnit ? ` ${unit}` : "" : ` ${withSiFull ? `${si.text}${withUnit ? " " : ""}` : si.value}${withUnit ? unit : ""}` : "";
    const { decimal: decimal, thousand: thousand } = (0, $01f605b220f27d31$export$cd567903cc935f1d)(locale);
    return `${sign}${(0, $8d03329e1274c7ab$export$845857f28dc08744)(pre, thousand)}${post && `${decimal}${post}`}${units}`;
}
const $b3e30afb943da5cc$export$cc3bc0b518c1c6b8 = $b3e30afb943da5cc$var$_formatBalance;
$b3e30afb943da5cc$export$cc3bc0b518c1c6b8.calcSi = (text, decimals = $b3e30afb943da5cc$var$defaultDecimals)=>(0, $3538c255e777b02d$export$5de1eda5a9909e28)(text, decimals);
$b3e30afb943da5cc$export$cc3bc0b518c1c6b8.findSi = (0, $3538c255e777b02d$export$236371b54fb86e2a);
$b3e30afb943da5cc$export$cc3bc0b518c1c6b8.getDefaults = ()=>{
    return {
        decimals: $b3e30afb943da5cc$var$defaultDecimals,
        unit: $b3e30afb943da5cc$var$defaultUnit
    };
};
$b3e30afb943da5cc$export$cc3bc0b518c1c6b8.getOptions = (decimals = $b3e30afb943da5cc$var$defaultDecimals)=>{
    return (0, $3538c255e777b02d$export$e6702cab675b095).filter(({ power: power })=>power < 0 ? decimals + power >= 0 : true);
};
$b3e30afb943da5cc$export$cc3bc0b518c1c6b8.setDefaults = ({ decimals: decimals, unit: unit })=>{
    $b3e30afb943da5cc$var$defaultDecimals = (Array.isArray(decimals) ? decimals[0] : decimals) ?? $b3e30afb943da5cc$var$defaultDecimals;
    $b3e30afb943da5cc$var$defaultUnit = (Array.isArray(unit) ? unit[0] : unit) ?? $b3e30afb943da5cc$var$defaultUnit;
    (0, $3538c255e777b02d$export$e6702cab675b095)[0, $3538c255e777b02d$export$8ad8e9acc2d3795b].text = $b3e30afb943da5cc$var$defaultUnit;
};




function $d7411165c894866c$export$f5dd818bff069720(value, { locale: locale = "en" } = {}) {
    const { thousand: thousand } = (0, $01f605b220f27d31$export$cd567903cc935f1d)(locale);
    return (0, $8d03329e1274c7ab$export$845857f28dc08744)((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(value).toString(), thousand);
}


var $hWfed = parcelRequire("hWfed");
function $f4a17f42fdd6b3ea$export$28994b5b8e65520b(value, { isLe: isLe = true, isNegative: isNegative = false } = {}) {
    const count = value.length;
    // shortcut for <= u48 values - in this case the manual conversion
    // here seems to be more efficient than passing the full array
    if (isNegative) {
        if (isLe) // Most common case i{8, 16, 32} default LE SCALE-encoded
        // For <= 32, we also optimize the xor to a single op
        switch(count){
            case 0:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
            case 1:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))((value[0] ^ 255) * -1 - 1);
            case 2:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))((value[0] + (value[1] << 8) ^ 65535) * -1 - 1);
            case 3:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))((value[0] + (value[1] << 8) + (value[2] << 16) ^ 16777215) * -1 - 1);
            case 4:
                // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
                // 32-bit, in the case where the top-most bit is set this yields a negative value
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))((value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216 ^ 4294967295) * -1 - 1);
            case 5:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(((value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216 ^ 4294967295) + (value[4] ^ 0xff) * 4294967296) * -1 - 1);
            case 6:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(((value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216 ^ 4294967295) + (value[4] + (value[5] << 8) ^ 65535) * 4294967296) * -1 - 1);
            default:
                return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value, "le").fromTwos(value.length * 8);
        }
        if (count === 0) return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
        else if (count > 6) return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value, "be").fromTwos(value.length * 8);
        let result = 0;
        for(let i = 0; i < count; i++)result = result * 256 + (value[i] ^ 0xff);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(result * -1 - 1);
    }
    if (isLe) // Most common case - u{8, 16, 32} default LE SCALE-encoded
    //
    // There are some slight benefits in unrolling this specific loop,
    // however it comes with diminishing returns since here the actual
    // `new BN` does seem to take up the bulk of the time
    switch(count){
        case 0:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
        case 1:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value[0]);
        case 2:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value[0] + (value[1] << 8));
        case 3:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value[0] + (value[1] << 8) + (value[2] << 16));
        case 4:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216);
        case 5:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] + (value[4] << 8)) * 16777216);
        case 6:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] + (value[4] << 8) + (value[5] << 16)) * 16777216);
        default:
            return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value, "le");
    }
    if (count === 0) return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
    else if (count > 6) return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(value, "be");
    let result = 0;
    for(let i = 0; i < count; i++)result = result * 256 + value[i];
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(result);
}

/**
 * @name u8aToNumber
 * @summary Creates a number from a Uint8Array object. This only operates on LE values as used in SCALE.
 */ function $eb9fa403af84ee9b$export$65751e444d91bc58(value, { isNegative: isNegative = false } = {}) {
    const count = value.length;
    if (isNegative) switch(count){
        case 0:
            return 0;
        case 1:
            return (value[0] ^ 255) * -1 - 1;
        case 2:
            return (value[0] + (value[1] << 8) ^ 65535) * -1 - 1;
        case 3:
            return (value[0] + (value[1] << 8) + (value[2] << 16) ^ 16777215) * -1 - 1;
        case 4:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return (value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216 ^ 4294967295) * -1 - 1;
        case 5:
            return ((value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216 ^ 4294967295) + (value[4] ^ 0xff) * 4294967296) * -1 - 1;
        case 6:
            return ((value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216 ^ 4294967295) + (value[4] + (value[5] << 8) ^ 65535) * 4294967296) * -1 - 1;
        default:
            throw new Error("Value more than 48-bits cannot be reliably converted");
    }
    switch(count){
        case 0:
            return 0;
        case 1:
            return value[0];
        case 2:
            return value[0] + (value[1] << 8);
        case 3:
            return value[0] + (value[1] << 8) + (value[2] << 16);
        case 4:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return value[0] + (value[1] << 8) + (value[2] << 16) + value[3] * 16777216;
        case 5:
            return value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] + (value[4] << 8)) * 16777216;
        case 6:
            return value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] + (value[4] << 8) + (value[5] << 16)) * 16777216;
        default:
            throw new Error("Value more than 48-bits cannot be reliably converted");
    }
}


const $2860346704b23ada$export$21d5f71115e393de = 64;
const $2860346704b23ada$var$MAX_NUMBER_BITS = 52;
const $2860346704b23ada$var$MUL_P = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(10000);
const $2860346704b23ada$var$FORMATTERS = [
    [
        "Perquintill",
        (0, $031d4cf4355dbeac$export$d7eaaf5791ee0cbe)
    ],
    [
        "Perbill",
        (0, $031d4cf4355dbeac$export$c576b535d52501f1)
    ],
    [
        "Permill",
        (0, $031d4cf4355dbeac$export$29fadd8d48a94eed)
    ],
    [
        "Percent",
        (0, $031d4cf4355dbeac$export$6691a839db0e7399)
    ]
];
function $2860346704b23ada$var$isToBn(value) {
    return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value.toBn);
}
function $2860346704b23ada$var$toPercentage(value, divisor) {
    return `${(value.mul($2860346704b23ada$var$MUL_P).div(divisor).toNumber() / 100).toFixed(2)}%`;
}
/** @internal */ function $2860346704b23ada$var$decodeAbstractInt(value, isNegative) {
    if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value)) {
        if (!Number.isInteger(value) || value > Number.MAX_SAFE_INTEGER || value < Number.MIN_SAFE_INTEGER) throw new Error("Number needs to be an integer <= Number.MAX_SAFE_INTEGER, i.e. 2 ^ 53 - 1");
        return value;
    } else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) {
        if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value, -1, true)) return (0, $3e8a64521966bb95$export$c11dd5c0192d997c)(value, {
            isLe: false,
            isNegative: isNegative
        }).toString();
        if (value.includes(".") || value.includes(",") || value.includes("e")) throw new Error("String should not contain decimal points or scientific notation");
        return value;
    } else if ((0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(value) || (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(value)) return value.toString();
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value)) {
        if ($2860346704b23ada$var$isToBn(value)) return value.toBn().toString();
        // Allow the construction from an object with a single top-level key. This means that
        // single key objects can be treated equivalently to numbers, assuming they meet the
        // specific requirements. (This is useful in Weights 1.5 where Objects are compact)
        const keys = Object.keys(value);
        if (keys.length !== 1) throw new Error("Unable to construct number from multi-key object");
        return $2860346704b23ada$var$decodeAbstractInt(value[keys[0]], isNegative);
    } else if (!value) return 0;
    throw new Error(`Unable to create BN from unknown type ${typeof value}`);
}
class $2860346704b23ada$export$48232fc27c65fab0 extends (0, (/*@__PURE__*/$parcel$interopDefault($hWfed))) {
    constructor(registry, value = 0, bitLength = $2860346704b23ada$export$21d5f71115e393de, isSigned = false){
        // Construct via a string/number, which will be passed in the BN constructor.
        // It would be ideal to actually return a BN, but there is an issue:
        // https://github.com/indutny/bn.js/issues/206
        super(// shortcut isU8a as used in SCALE decoding
        (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? bitLength <= 48 ? (0, $eb9fa403af84ee9b$export$65751e444d91bc58)(value.subarray(0, bitLength / 8), {
            isNegative: isSigned
        }) : (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(value.subarray(0, bitLength / 8), {
            isLe: true,
            isNegative: isSigned
        }).toString() : $2860346704b23ada$var$decodeAbstractInt(value, isSigned));
        this.registry = registry;
        this.__internal__bitLength = bitLength;
        this.encodedLength = this.__internal__bitLength / 8;
        this.initialU8aLength = this.__internal__bitLength / 8;
        this.isUnsigned = !isSigned;
        const isNegative = this.isNeg();
        const maxBits = bitLength - (isSigned && !isNegative ? 1 : 0);
        if (isNegative && !isSigned) throw new Error(`${this.toRawType()}: Negative number passed to unsigned type`);
        else if (super.bitLength() > maxBits) throw new Error(`${this.toRawType()}: Input too large. Found input with ${super.bitLength()} bits, expected ${maxBits}`);
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is a zero value (align elsewhere)
     */ get isEmpty() {
        return this.isZero();
    }
    /**
     * @description Returns the number of bits in the value
     */ bitLength() {
        return this.__internal__bitLength;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    eq(other) {
        // Here we are actually overriding the built-in .eq to take care of both
        // number and BN inputs (no `.eqn` needed) - numbers will be converted
        return super.eq((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(other) ? (0, $3e8a64521966bb95$export$c11dd5c0192d997c)(other.toString(), {
            isLe: false,
            isNegative: !this.isUnsigned
        }) : (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(other));
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description True if this value is the max of the type
     */ isMax() {
        const u8a = this.toU8a().filter((b)=>b === 0xff);
        return u8a.length === this.__internal__bitLength / 8;
    }
    /**
     * @description Returns a BigInt representation of the number
     */ toBigInt() {
        return BigInt(this.toString());
    }
    /**
     * @description Returns the BN representation of the number. (Compatibility)
     */ toBn() {
        return this;
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex(isLe = false) {
        // For display/JSON, this is BE, for compare, use isLe
        return (0, $76fe50cea1c69dee$export$2b04de991f078f40)(this, {
            bitLength: this.bitLength(),
            isLe: isLe,
            isNegative: !this.isUnsigned
        });
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(_isExpanded) {
        const rawType = this.toRawType();
        if (rawType === "Balance") return this.isMax() ? "everything" : (0, $b3e30afb943da5cc$export$cc3bc0b518c1c6b8)(this, {
            decimals: this.registry.chainDecimals[0],
            withSi: true,
            withUnit: this.registry.chainTokens[0]
        });
        const [, divisor] = $2860346704b23ada$var$FORMATTERS.find(([type])=>type === rawType) || [];
        return divisor ? $2860346704b23ada$var$toPercentage(this, divisor) : (0, $d7411165c894866c$export$f5dd818bff069720)(this);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON(onlyHex = false) {
        // FIXME this return type should by string | number, however BN returns string
        // Options here are
        //   - super.bitLength() - the actual used bits, use hex when close to MAX_SAFE_INTEGER
        //   - this.__internal__bitLength - the max used bits, use hex when larger than native Rust type
        return onlyHex || this.__internal__bitLength > 128 || super.bitLength() > $2860346704b23ada$var$MAX_NUMBER_BITS ? this.toHex() : this.toNumber();
    }
    /**
     * @description Returns the value in a primitive form, either number when <= 52 bits, or string otherwise
     */ toPrimitive() {
        return super.bitLength() > $2860346704b23ada$var$MAX_NUMBER_BITS ? this.toString() : this.toNumber();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        // NOTE In the case of balances, which have a special meaning on the UI
        // and can be interpreted differently, return a specific value for it so
        // underlying it always matches (no matter which length it actually is)
        return this instanceof this.registry.createClassUnsafe("Balance") ? "Balance" : `${this.isUnsigned ? "u" : "i"}${this.bitLength()}`;
    }
    /**
     * @description Returns the string representation of the value
     * @param base The base to use for the conversion
     */ toString(base) {
        // only included here since we do not inherit docs
        return super.toString(base);
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(this, {
            bitLength: this.bitLength(),
            isLe: true,
            isNegative: !this.isUnsigned
        });
    }
}


class $e12b5c9e80666c5a$export$5aaa69e6f271b98f extends (0, $2860346704b23ada$export$48232fc27c65fab0) {
    static with(bitLength, typeName) {
        return class extends $e12b5c9e80666c5a$export$5aaa69e6f271b98f {
            constructor(registry, value){
                super(registry, value, bitLength);
            }
            toRawType() {
                return typeName || super.toRawType();
            }
        };
    }
}


class $4d3a09ccc4a71677$export$8bacf4ad828c7fe7 extends (0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f).with(32) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = "u32";
    }
}


const $94bf400112bf71f2$export$e641161dc6c2e949 = 0x6174656d; // `meta`, reversed for Little Endian encoding
class $94bf400112bf71f2$export$2c5a63474602f066 extends (0, $4d3a09ccc4a71677$export$8bacf4ad828c7fe7) {
    constructor(registry, value){
        super(registry, value);
        if (!this.isEmpty && !this.eq($94bf400112bf71f2$export$e641161dc6c2e949)) throw new Error(`MagicNumber mismatch: expected ${registry.createTypeUnsafe("u32", [
            $94bf400112bf71f2$export$e641161dc6c2e949
        ]).toHex()}, found ${this.toHex()}`);
    }
}


const $9494b6ba827d15c4$export$8ff25ca791ef2bfe = [
    15,
    14,
    13,
    12,
    11,
    10,
    9
];
const $9494b6ba827d15c4$export$5bd6772f122cb888 = $9494b6ba827d15c4$export$8ff25ca791ef2bfe[0];
const $9494b6ba827d15c4$export$8b6de0d87e57304 = 14; // LATEST_VERSION;


class $47beebf461d6ecbe$export$5fbe2269f3d5d56a extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value){
        // const timeStart = performance.now()
        super(registry, {
            magicNumber: (0, $94bf400112bf71f2$export$2c5a63474602f066),
            metadata: "MetadataAll"
        }, value);
        this.__internal__converted = new Map();
        this.__internal__assertVersion = (version)=>{
            if (this.version > version) throw new Error(`Cannot convert metadata from version ${this.version} to ${version}`);
            return this.version === version;
        };
        this.__internal__getVersion = (version, fromPrev)=>{
            if (version !== "latest" && this.__internal__assertVersion(version)) {
                const asCurr = `asV${version}`;
                return this.__internal__metadata()[asCurr];
            }
            if (!this.__internal__converted.has(version)) {
                const asPrev = version === "latest" ? `asV${0, $9494b6ba827d15c4$export$5bd6772f122cb888}` : `asV${version - 1}`;
                this.__internal__converted.set(version, fromPrev(this.registry, this[asPrev], this.version));
            }
            return this.__internal__converted.get(version);
        };
        /**
         * @description the metadata wrapped
         */ this.__internal__metadata = ()=>{
            return this.getT("metadata");
        };
    // console.log('MetadataVersioned', `${(performance.now() - timeStart).toFixed(2)}ms`)
    }
    /**
     * @description Returns the wrapped metadata as a limited calls-only (latest) version
     */ get asCallsOnly() {
        return new $47beebf461d6ecbe$export$5fbe2269f3d5d56a(this.registry, {
            magicNumber: this.magicNumber,
            metadata: this.registry.createTypeUnsafe("MetadataAll", [
                (0, $65b26dc111830010$export$c0708a653c407b9b)(this.registry, this.asLatest),
                (0, $9494b6ba827d15c4$export$8b6de0d87e57304)
            ])
        });
    }
    /**
     * @description Returns the wrapped metadata as a V9 object
     */ get asV9() {
        this.__internal__assertVersion(9);
        return this.__internal__metadata().asV9;
    }
    /**
     * @description Returns the wrapped values as a V10 object
     */ get asV10() {
        return this.__internal__getVersion(10, (0, $1d4267e3a01a43e8$export$4f7d0d97510ab072));
    }
    /**
     * @description Returns the wrapped values as a V11 object
     */ get asV11() {
        return this.__internal__getVersion(11, (0, $3c5ccb606e34aa7b$export$8e1cfc6fb16a6568));
    }
    /**
     * @description Returns the wrapped values as a V12 object
     */ get asV12() {
        return this.__internal__getVersion(12, (0, $32bd2b0036518222$export$50a6fe69b948075e));
    }
    /**
     * @description Returns the wrapped values as a V13 object
     */ get asV13() {
        return this.__internal__getVersion(13, (0, $0a6d035a914fc3a0$export$ea069da8ae0f3e49));
    }
    /**
     * @description Returns the wrapped values as a V14 object
     */ get asV14() {
        return this.__internal__getVersion(14, (0, $a1e5d752204535dc$export$e7c3c862ae12a646));
    }
    /**
     * @description Returns the wrapped values as a V14 object
     */ get asV15() {
        return this.__internal__getVersion(15, (0, $545c212237e39950$export$11859103ae7567e1));
    }
    /**
     * @description Returns the wrapped values as a latest version object
     */ get asLatest() {
        return this.__internal__getVersion("latest", (0, $7f73d416e84000fc$export$fc3e439b04637e90));
    }
    /**
     * @description The magicNumber for the Metadata (known constant)
     */ get magicNumber() {
        return this.getT("magicNumber");
    }
    /**
     * @description the metadata version this structure represents
     */ get version() {
        return this.__internal__metadata().index;
    }
    getUniqTypes(throwError) {
        return (0, $3c4fcdbb181a4dd4$export$4a083bf1828809c6)(this.registry, this.asLatest, throwError);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        // HACK(y): ensure that we apply the aliases if we have not done so already, this is
        // needed to ensure we have the correct overrides (which is only applied in toLatest)
        // eslint-disable-next-line no-unused-expressions
        this.asLatest;
        return super.toJSON();
    }
}


const $918d2e4dba59a611$var$EMPTY_METADATA = new Uint8Array([
    0x6d,
    0x65,
    0x74,
    0x61,
    9
]);
const $918d2e4dba59a611$var$VERSION_IDX = $918d2e4dba59a611$var$EMPTY_METADATA.length - 1;
/** @internal */ function $918d2e4dba59a611$var$decodeU8a(registry, u8a) {
    if (u8a.length === 0) return $918d2e4dba59a611$var$EMPTY_METADATA;
    else if (u8a[$918d2e4dba59a611$var$VERSION_IDX] === 9) // This is an f-ing hack as a follow-up to another ugly hack
    // https://github.com/polkadot-js/api/commit/a9211690be6b68ad6c6dad7852f1665cadcfa5b2
    // when we fail on V9, try to re-parse it as v10...
    try {
        return new (0, $47beebf461d6ecbe$export$5fbe2269f3d5d56a)(registry, u8a);
    } catch  {
        u8a[$918d2e4dba59a611$var$VERSION_IDX] = 10;
    }
    return u8a;
}
class $918d2e4dba59a611$export$e7adebdc1ebd2fed extends (0, $47beebf461d6ecbe$export$5fbe2269f3d5d56a) {
    constructor(registry, value){
        // const timeStart = performance.now()
        super(registry, (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $0d672af39bfe8283$export$844ec244b1367d54)(value) ? $918d2e4dba59a611$var$decodeU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value)) : value);
    // console.log('Metadata', `${(performance.now() - timeStart).toFixed(2)}ms`)
    }
}

/**
 * @name DoNotConstruct
 * @description
 * An unknown type that fails on construction with the type info
 */ class $561a7ebeda2ce82e$export$61d01bf8d0c78f65 {
    constructor(registry, typeName = "DoNotConstruct"){
        this.registry = registry;
        this.__internal__neverError = new Error(`DoNotConstruct: Cannot construct unknown type ${typeName}`);
        throw this.__internal__neverError;
    }
    static with(typeName) {
        return class extends $561a7ebeda2ce82e$export$61d01bf8d0c78f65 {
            constructor(registry){
                super(registry, typeName);
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        throw this.__internal__neverError;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        throw this.__internal__neverError;
    }
    /**
     * @description Checks if the value is an empty value (always true)
     */ get isEmpty() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ eq() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ inspect() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toHex() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toHuman() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toJSON() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toPrimitive() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toRawType() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toString() {
        throw this.__internal__neverError;
    }
    /**
     * @description Unimplemented
     */ toU8a() {
        throw this.__internal__neverError;
    }
}



/** @internal */ function $d36f0e8a198e6efb$var$decodeJson(value) {
    return Object.entries(value || {});
}
class $d36f0e8a198e6efb$export$48880ac635f47186 extends Map {
    constructor(registry, value){
        const decoded = $d36f0e8a198e6efb$var$decodeJson(value);
        super(decoded);
        this.registry = registry;
        (0, $fb51452ffd615a15$export$4660c3861a213768)(this, decoded.map(([k])=>k), (k)=>this.get(k));
    }
    /**
     * @description Always 0, never encodes as a Uint8Array
     */ get encodedLength() {
        return 0;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return [
            ...this.keys()
        ].length === 0;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return (0, $ac7bf2586ed6a7f5$export$bc5ca6344d311f69)(this, other);
    }
    /**
     * @description Returns a typed value from the internal map
     */ getT(key) {
        return this.get(key);
    }
    /**
     * @description Unimplemented, will throw
     */ inspect() {
        throw new Error("Unimplemented");
    }
    /**
     * @description Unimplemented, will throw
     */ toHex() {
        throw new Error("Unimplemented");
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return [
            ...this.entries()
        ].reduce((json, [key, value])=>{
            json[key] = (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value.toHuman) ? value.toHuman() : value;
            return json;
        }, {});
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return [
            ...this.entries()
        ].reduce((json, [key, value])=>{
            json[key] = value;
            return json;
        }, {});
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return [
            ...this.entries()
        ].reduce((json, [key, value])=>{
            json[key] = (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value.toPrimitive) ? value.toPrimitive() : value;
            return json;
        }, {});
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Json";
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)(this.toJSON());
    }
    /**
     * @description Unimplemented, will throw
     */ toU8a(_isBare) {
        throw new Error("Unimplemented");
    }
}




/** @internal */ function $7883df12a1da8abb$var$isAsciiStr(str) {
    for(let i = 0, count = str.length; i < count; i++){
        const b = str.charCodeAt(i);
        // check is inlined here, it is faster than making a call
        if (b < 32 || b > 126) return false;
    }
    return true;
}
/** @internal */ function $7883df12a1da8abb$var$isAsciiBytes(u8a) {
    for(let i = 0, count = u8a.length; i < count; i++){
        const b = u8a[i] | 0;
        // check is inlined here, it is faster than making a call
        if (b < 32 || b > 126) return false;
    }
    return true;
}
function $7883df12a1da8abb$export$5687edf39827d1cd(value) {
    return (0, $0d672af39bfe8283$export$844ec244b1367d54)(value) ? (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? $7883df12a1da8abb$var$isAsciiBytes((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value)) : $7883df12a1da8abb$var$isAsciiStr(value) : value ? $7883df12a1da8abb$var$isAsciiBytes(value) : false;
}



function $ec1ac5bfd32cbef7$export$d5e10f5314e6259d(value) {
    if (!value) return (0, $0d672af39bfe8283$export$844ec244b1367d54)(value);
    const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
    const len = u8a.length;
    let i = 0;
    while(i < len){
        if (u8a[i] <= 0x7F) i += 1;
        else if (u8a[i] >= 0xC2 && u8a[i] <= 0xDF) /* C2..DF 80..BF */ {
            if (i + 1 < len) /* Expect a 2nd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) // *message = "After a first byte between C2 and DF, expecting a 2nd byte between 80 and BF";
                // *faulty_bytes = 2;
                return false;
            } else // *message = "After a first byte between C2 and DF, expecting a 2nd byte.";
            // *faulty_bytes = 1;
            return false;
            i += 2;
        } else if (u8a[i] === 0xE0) /* E0 A0..BF 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0xA0 || u8a[i + 1] > 0xBF) // *message = "After a first byte of E0, expecting a 2nd byte between A0 and BF.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte of E0, expecting a 3nd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
            } else // *message = "After a first byte of E0, expecting two following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 3;
        } else if (u8a[i] >= 0xE1 && u8a[i] <= 0xEC) /* E1..EC 80..BF 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) // *message = "After a first byte between E1 and EC, expecting the 2nd byte between 80 and BF.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte between E1 and EC, expecting the 3rd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
            } else // *message = "After a first byte between E1 and EC, expecting two following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 3;
        } else if (u8a[i] === 0xED) /* ED 80..9F 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0x9F) // *message = "After a first byte of ED, expecting 2nd byte between 80 and 9F.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte of ED, expecting 3rd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
            } else // *message = "After a first byte of ED, expecting two following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 3;
        } else if (u8a[i] >= 0xEE && u8a[i] <= 0xEF) /* EE..EF 80..BF 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) // *message = "After a first byte between EE and EF, expecting 2nd byte between 80 and BF.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte between EE and EF, expecting 3rd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
            } else // *message = "After a first byte between EE and EF, two following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 3;
        } else if (u8a[i] === 0xF0) /* F0 90..BF 80..BF 80..BF */ {
            if (i + 3 < len) /* Expect a 2nd, 3rd 3th byte */ {
                if (u8a[i + 1] < 0x90 || u8a[i + 1] > 0xBF) // *message = "After a first byte of F0, expecting 2nd byte between 90 and BF.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte of F0, expecting 3rd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
                if (u8a[i + 3] < 0x80 || u8a[i + 3] > 0xBF) // *message = "After a first byte of F0, expecting 4th byte between 80 and BF.";
                // *faulty_bytes = 4;
                return false;
            } else // *message = "After a first byte of F0, expecting three following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 4;
        } else if (u8a[i] >= 0xF1 && u8a[i] <= 0xF3) /* F1..F3 80..BF 80..BF 80..BF */ {
            if (i + 3 < len) /* Expect a 2nd, 3rd 3th byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) // *message = "After a first byte of F1, F2, or F3, expecting a 2nd byte between 80 and BF.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte of F1, F2, or F3, expecting a 3rd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
                if (u8a[i + 3] < 0x80 || u8a[i + 3] > 0xBF) // *message = "After a first byte of F1, F2, or F3, expecting a 4th byte between 80 and BF.";
                // *faulty_bytes = 4;
                return false;
            } else // *message = "After a first byte of F1, F2, or F3, expecting three following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 4;
        } else if (u8a[i] === 0xF4) /* F4 80..8F 80..BF 80..BF */ {
            if (i + 3 < len) /* Expect a 2nd, 3rd 3th byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0x8F) // *message = "After a first byte of F4, expecting 2nd byte between 80 and 8F.";
                // *faulty_bytes = 2;
                return false;
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) // *message = "After a first byte of F4, expecting 3rd byte between 80 and BF.";
                // *faulty_bytes = 3;
                return false;
                if (u8a[i + 3] < 0x80 || u8a[i + 3] > 0xBF) // *message = "After a first byte of F4, expecting 4th byte between 80 and BF.";
                // *faulty_bytes = 4;
                return false;
            } else // *message = "After a first byte of F4, expecting three following bytes.";
            // *faulty_bytes = 1;
            return false;
            i += 4;
        } else // *message = "Expecting bytes in the following ranges: 00..7F C2..F4.";
        // *faulty_bytes = 1;
        return false;
    }
    return true;
}


class $67d99249fcfbe1bb$export$9c6b53e35bc51b5c {
    constructor(encoding){
        this.__encoding = encoding;
    }
    decode(value) {
        let result = "";
        for(let i = 0, count = value.length; i < count; i++)result += String.fromCharCode(value[i]);
        return result;
    }
}


var $1633e457ae820683$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/x-textdecoder/packageInfo.js"
});
const $1633e457ae820683$export$ce0097da4c08ff3f = {
    name: "@polkadot/x-textdecoder",
    path: $1633e457ae820683$import_meta && "file:///node_modules/@polkadot/x-textdecoder/packageInfo.js" ? new URL("file:///node_modules/@polkadot/x-textdecoder/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/x-textdecoder/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "12.3.2"
};


const $3314b0772e103984$export$9c6b53e35bc51b5c = /*#__PURE__*/ (0, $9ce44c51a85397c6$export$157d08edb917d81)("TextDecoder", (0, $67d99249fcfbe1bb$export$9c6b53e35bc51b5c));


const $20f3a615a221edb7$var$decoder = new (0, $3314b0772e103984$export$9c6b53e35bc51b5c)("utf-8");
function $20f3a615a221edb7$export$792464756f58046b(value) {
    return value ? $20f3a615a221edb7$var$decoder.decode(value) : "";
}


class $d0fc201459fab5e6$export$6f88fe47d32c9c94 extends Uint8Array {
    /**
     * @description This ensures that operators such as clice, filter, map, etc. return
     * new Array instances (without this we need to apply overrides)
     */ static get [Symbol.species]() {
        return Uint8Array;
    }
    constructor(registry, value, initialU8aLength){
        super((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
        this.registry = registry;
        this.initialU8aLength = initialU8aLength;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.length;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Returns true if the wrapped value contains only ASCII printable characters
     */ get isAscii() {
        return (0, $7883df12a1da8abb$export$5687edf39827d1cd)(this);
    }
    /**
     * @description Returns true if the type wraps an empty/default all-0 value
     */ get isEmpty() {
        return !this.length || (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(this.find((b)=>!!b));
    }
    /**
     * @description Returns true if the wrapped value contains only utf8 characters
     */ get isUtf8() {
        return (0, $ec1ac5bfd32cbef7$export$d5e10f5314e6259d)(this);
    }
    /**
     * @description Returns the number of bits in the value
     */ bitLength() {
        return this.length * 8;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        if (other instanceof Uint8Array) return this.length === other.length && !this.some((b, index)=>b !== other[index]);
        return this.eq((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(other));
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toPrimitive();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toHex();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        if (this.isAscii) {
            const text = this.toUtf8();
            // ensure we didn't end up with multibyte codepoints
            if ((0, $7883df12a1da8abb$export$5687edf39827d1cd)(text)) return text;
        }
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Raw";
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.toHex();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return Uint8Array.from(this);
    }
    /**
     * @description Returns the wrapped data as a UTF-8 string
     */ toUtf8() {
        if (!this.isUtf8) throw new Error("The character sequence is not a valid Utf8 string");
        return (0, $20f3a615a221edb7$export$792464756f58046b)(this);
    }
}



var $hWfed = parcelRequire("hWfed");

function $f98b10db0f2cd20b$export$78a7c3b36a13df0f(input) {
    const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(input);
    // The u8a is manually converted here for 1, 2 & 4 lengths, it is 2x faster
    // than doing an additional call to u8aToBn (as with variable length)
    switch(u8a[0] & 3){
        case 0:
            return [
                1,
                new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(u8a[0] >>> 2)
            ];
        case 1:
            return [
                2,
                new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(u8a[0] + (u8a[1] << 8) >>> 2)
            ];
        case 2:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return [
                4,
                new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(u8a[0] + (u8a[1] << 8) + (u8a[2] << 16) + u8a[3] * 16777216 >>> 2)
            ];
        // 0b11
        default:
            {
                // add 5 to shifted (4 for base length, 1 for this byte)
                const offset = (u8a[0] >>> 2) + 5;
                // we unroll the loop
                switch(offset){
                    // there still could be 4 bytes data, similar to 0b10 above (with offsets)
                    case 5:
                        // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
                        // 32-bit, in the case where the top-most bit is set this yields a negative value
                        return [
                            5,
                            new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + u8a[4] * 16777216)
                        ];
                    case 6:
                        return [
                            6,
                            new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + (u8a[4] + (u8a[5] << 8)) * 16777216)
                        ];
                    // 6 bytes data is the maximum, 48 bits (56 would overflow)
                    case 7:
                        return [
                            7,
                            new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + (u8a[4] + (u8a[5] << 8) + (u8a[6] << 16)) * 16777216)
                        ];
                    // for anything else, use the non-unrolled version
                    default:
                        return [
                            offset,
                            (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(u8a.subarray(1, offset))
                        ];
                }
            }
    }
}
function $f98b10db0f2cd20b$export$9549eda7cd84f536(u8a) {
    // The u8a is manually converted here for 1, 2 & 4 lengths, it is 2x faster
    // than doing an additional call to u8aToBn (as with variable length)
    switch(u8a[0] & 3){
        case 0:
            return [
                1,
                u8a[0] >>> 2
            ];
        case 1:
            return [
                2,
                u8a[0] + (u8a[1] << 8) >>> 2
            ];
        case 2:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return [
                4,
                u8a[0] + (u8a[1] << 8) + (u8a[2] << 16) + u8a[3] * 16777216 >>> 2
            ];
        // 0b11
        default:
            // add 5 to shifted (4 for base length, 1 for this byte)
            // we unroll the loop
            switch((u8a[0] >>> 2) + 5){
                // there still could be 4 bytes data, similar to 0b10 above (with offsets)
                case 5:
                    return [
                        5,
                        u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + u8a[4] * 16777216
                    ];
                case 6:
                    return [
                        6,
                        u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + (u8a[4] + (u8a[5] << 8)) * 16777216
                    ];
                // 6 bytes data is the maximum, 48 bits (56 would overflow)
                case 7:
                    return [
                        7,
                        u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + (u8a[4] + (u8a[5] << 8) + (u8a[6] << 16)) * 16777216
                    ];
                // for anything else, we are above the actual MAX_SAFE_INTEGER - bail out
                default:
                    throw new Error("Compact input is > Number.MAX_SAFE_INTEGER");
            }
    }
}


var $hWfed = parcelRequire("hWfed");

const $bdb4803c1e6b1c9a$var$MAX_U8 = (0, $031d4cf4355dbeac$export$e1f42f91b26e6faf).pow(new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(6)).isub((0, $031d4cf4355dbeac$export$8d1cfb084cec6129));
const $bdb4803c1e6b1c9a$var$MAX_U16 = (0, $031d4cf4355dbeac$export$e1f42f91b26e6faf).pow(new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(14)).isub((0, $031d4cf4355dbeac$export$8d1cfb084cec6129));
const $bdb4803c1e6b1c9a$var$MAX_U32 = (0, $031d4cf4355dbeac$export$e1f42f91b26e6faf).pow(new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(30)).isub((0, $031d4cf4355dbeac$export$8d1cfb084cec6129));
const $bdb4803c1e6b1c9a$var$BL_16 = {
    bitLength: 16
};
const $bdb4803c1e6b1c9a$var$BL_32 = {
    bitLength: 32
};
function $bdb4803c1e6b1c9a$export$37f42c2b1352e4b(value) {
    const bn = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(value);
    if (bn.lte($bdb4803c1e6b1c9a$var$MAX_U8)) return new Uint8Array([
        bn.toNumber() << 2
    ]);
    else if (bn.lte($bdb4803c1e6b1c9a$var$MAX_U16)) return (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(bn.shln(2).iadd((0, $031d4cf4355dbeac$export$8d1cfb084cec6129)), $bdb4803c1e6b1c9a$var$BL_16);
    else if (bn.lte($bdb4803c1e6b1c9a$var$MAX_U32)) return (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(bn.shln(2).iadd((0, $031d4cf4355dbeac$export$e1f42f91b26e6faf)), $bdb4803c1e6b1c9a$var$BL_32);
    const u8a = (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(bn);
    let length = u8a.length;
    // adjust to the minimum number of bytes
    while(u8a[length - 1] === 0)length--;
    if (length < 4) throw new Error("Invalid length, previous checks match anything less than 2^30");
    return (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)([
        // subtract 4 as minimum (also catered for in decoding)
        new Uint8Array([
            (length - 4 << 2) + 3
        ]),
        u8a.subarray(0, length)
    ]);
}





function $39431919ab8b009c$export$cb07857b027678fa(a, b) {
    if (Array.isArray(b)) return a.length === b.length && (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(a.find((v, index)=>(0, $da9585ca1451b938$export$9c527b6f5a12fec5)(v) ? !v.eq(b[index]) : v !== b[index]));
    return false;
}


class $a0caa1f2a8043284$export$8d1ecab2e896dc35 extends Array {
    /**
     * @description This ensures that operators such as clice, filter, map, etc. return
     * new Array instances (without this we need to apply overrides)
     */ static get [Symbol.species]() {
        return Array;
    }
    constructor(registry, length){
        super(length);
        this.registry = registry;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        // We need to loop through all entries since they may have a variable length themselves,
        // e.g. when a Vec or Compact is contained withing, it has a variable length based on data
        const count = this.length;
        let total = (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(count).length;
        for(let i = 0; i < count; i++)total += this[i].encodedLength;
        return total;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.length === 0;
    }
    /**
     * @description The length of the value
     */ get length() {
        // only included here since we ignore inherited docs
        return super.length;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return (0, $39431919ab8b009c$export$cb07857b027678fa)(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            inner: this.inspectInner(),
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.length)
            ]
        };
    }
    /**
     * @internal
     * @description Internal per-item inspection of internal values
     */ inspectInner() {
        const count = this.length;
        const inner = new Array(count);
        for(let i = 0; i < count; i++)inner[i] = this[i].inspect();
        return inner;
    }
    /**
     * @description Converts the Object to an standard JavaScript Array
     */ toArray() {
        return Array.from(this);
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        const count = this.length;
        const result = new Array(count);
        for(let i = 0; i < count; i++)result[i] = this[i] && this[i].toHuman(isExtended);
        return result;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        const count = this.length;
        const result = new Array(count);
        for(let i = 0; i < count; i++)// We actually log inside the U8a decoding and use JSON.stringify(...), which
        // means that the Vec may be partially populated (same applies to toHuman, same check)
        result[i] = this[i] && this[i].toJSON();
        return result;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        const count = this.length;
        const result = new Array(count);
        for(let i = 0; i < count; i++)result[i] = this[i] && this[i].toPrimitive();
        return result;
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        const count = this.length;
        const result = new Array(count);
        for(let i = 0; i < count; i++)result[i] = this[i].toString();
        return `[${result.join(", ")}]`;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const encoded = this.toU8aInner();
        return isBare ? (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(encoded) : (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)([
            (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.length),
            ...encoded
        ]);
    }
    /**
     * @internal
     * @description Internal per-item SCALE encoding of contained values
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8aInner(isBare) {
        const count = this.length;
        const encoded = new Array(count);
        for(let i = 0; i < count; i++)encoded[i] = this[i].toU8a(isBare);
        return encoded;
    }
}




/**
 * @name isNull
 * @summary Tests for a `null` values.
 * @description
 * Checks to see if the input value is `null`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isNull } from '@polkadot/util';
 *
 * console.log('isNull', isNull(null)); // => true
 * ```
 */ function $ca1b2dd85c8d2b2d$export$630801d484da15df(value) {
    return value === null;
}


class $cde2b5a819d50097$export$26c9c3a80cd996ae {
    constructor(registry){
        this.encodedLength = 0;
        this.isEmpty = true;
        this.initialU8aLength = 0;
        this.registry = registry;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        throw new Error(".hash is not implemented on Null");
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return other instanceof $cde2b5a819d50097$export$26c9c3a80cd996ae || (0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {};
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return "0x";
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return null;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return null;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Null";
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return "";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return new Uint8Array();
    }
}


function $533387422670f8b2$var$isRustEnum(def) {
    const defValues = Object.values(def);
    if (defValues.some((v)=>(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(v))) {
        if (!defValues.every((v)=>(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(v) && v >= 0 && v <= 255)) throw new Error("Invalid number-indexed enum definition");
        return false;
    }
    return true;
}
function $533387422670f8b2$var$extractDef(registry, _def) {
    const def = {};
    let isBasic;
    let isIndexed;
    if (Array.isArray(_def)) {
        for(let i = 0, count = _def.length; i < count; i++)def[_def[i]] = {
            Type: (0, $cde2b5a819d50097$export$26c9c3a80cd996ae),
            index: i
        };
        isBasic = true;
        isIndexed = false;
    } else if ($533387422670f8b2$var$isRustEnum(_def)) {
        const [Types, keys] = (0, $decc53b303ead3a7$export$17958927a4ea0eb2)(registry, _def);
        for(let i = 0, count = keys.length; i < count; i++)def[keys[i]] = {
            Type: Types[i],
            index: i
        };
        isBasic = !Object.values(def).some(({ Type: Type })=>Type !== (0, $cde2b5a819d50097$export$26c9c3a80cd996ae));
        isIndexed = false;
    } else {
        const entries = Object.entries(_def);
        for(let i = 0, count = entries.length; i < count; i++){
            const [key, index] = entries[i];
            def[key] = {
                Type: (0, $cde2b5a819d50097$export$26c9c3a80cd996ae),
                index: index
            };
        }
        isBasic = true;
        isIndexed = true;
    }
    return {
        def: def,
        isBasic: isBasic,
        isIndexed: isIndexed
    };
}
function $533387422670f8b2$var$getEntryType(def, checkIdx) {
    const values = Object.values(def);
    for(let i = 0; i < values.length; i++){
        const { Type: Type, index: index } = values[i];
        if (index === checkIdx) return Type;
    }
    throw new Error(`Unable to create Enum via index ${checkIdx}, in ${Object.keys(def).join(", ")}`);
}
function $533387422670f8b2$var$createFromU8a(registry, def, index, value) {
    const Type = $533387422670f8b2$var$getEntryType(def, index);
    return {
        index: index,
        value: new Type(registry, value)
    };
}
function $533387422670f8b2$var$createFromValue(registry, def, index = 0, value) {
    const Type = $533387422670f8b2$var$getEntryType(def, index);
    return {
        index: index,
        value: value instanceof Type ? value : new Type(registry, value)
    };
}
function $533387422670f8b2$var$decodeFromJSON(registry, def, key, value) {
    // JSON comes in the form of { "<type (camelCase)>": "<value for type>" }, here we
    // additionally force to lower to ensure forward compat
    const keys = Object.keys(def).map((k)=>k.toLowerCase());
    const keyLower = key.toLowerCase();
    const index = keys.indexOf(keyLower);
    if (index === -1) throw new Error(`Cannot map Enum JSON, unable to find '${key}' in ${keys.join(", ")}`);
    try {
        return $533387422670f8b2$var$createFromValue(registry, def, Object.values(def)[index].index, value);
    } catch (error) {
        throw new Error(`Enum(${key}):: ${error.message}`);
    }
}
function $533387422670f8b2$var$decodeEnum(registry, def, value, index) {
    // NOTE We check the index path first, before looking at values - this allows treating
    // the optional indexes before anything else, more-specific > less-specific
    if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(index)) return $533387422670f8b2$var$createFromValue(registry, def, index, value);
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) {
        const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
        // nested, we don't want to match isObject below
        if (u8a.length) return $533387422670f8b2$var$createFromU8a(registry, def, u8a[0], u8a.subarray(1));
    } else if (value instanceof $533387422670f8b2$export$deb82508dd66d288) return $533387422670f8b2$var$createFromValue(registry, def, value.index, value.value);
    else if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value)) return $533387422670f8b2$var$createFromValue(registry, def, value);
    else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) return $533387422670f8b2$var$decodeFromJSON(registry, def, value.toString());
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value)) {
        const key = Object.keys(value)[0];
        return $533387422670f8b2$var$decodeFromJSON(registry, def, key, value[key]);
    }
    // Worst-case scenario, return the first with default
    return $533387422670f8b2$var$createFromValue(registry, def, Object.values(def)[0].index);
}
class $533387422670f8b2$export$deb82508dd66d288 {
    constructor(registry, Types, value, index, { definition: definition, setDefinition: setDefinition = (0, $3c9cf064340c6f95$export$f0954fd7d5368655) } = {}){
        const { def: def, isBasic: isBasic, isIndexed: isIndexed } = definition || setDefinition($533387422670f8b2$var$extractDef(registry, Types));
        // shortcut isU8a as used in SCALE decoding
        const decoded = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) && value.length && !(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(index) ? $533387422670f8b2$var$createFromU8a(registry, def, value[0], value.subarray(1)) : $533387422670f8b2$var$decodeEnum(registry, def, value, index);
        this.registry = registry;
        this.__internal__def = def;
        this.__internal__isBasic = isBasic;
        this.__internal__isIndexed = isIndexed;
        this.__internal__indexes = Object.values(def).map(({ index: index })=>index);
        this.__internal__entryIndex = this.__internal__indexes.indexOf(decoded.index);
        this.__internal__raw = decoded.value;
        if (this.__internal__raw.initialU8aLength) this.initialU8aLength = 1 + this.__internal__raw.initialU8aLength;
    }
    static with(Types) {
        var _a;
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d)=>definition = d;
        return _a = class extends $533387422670f8b2$export$deb82508dd66d288 {
            constructor(registry, value, index){
                super(registry, Types, value, index, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        }, (()=>{
            const keys = Array.isArray(Types) ? Types : Object.keys(Types);
            const count = keys.length;
            const asKeys = new Array(count);
            const isKeys = new Array(count);
            for(let i = 0; i < count; i++){
                const name = (0, $4db46be060f888b6$export$733fa19993fe16bc)(keys[i]);
                asKeys[i] = `as${name}`;
                isKeys[i] = `is${name}`;
            }
            (0, $fb51452ffd615a15$export$4660c3861a213768)(_a.prototype, isKeys, (_, i, self)=>self.type === keys[i]);
            (0, $fb51452ffd615a15$export$4660c3861a213768)(_a.prototype, asKeys, (k, i, self)=>{
                if (self.type !== keys[i]) throw new Error(`Cannot convert '${self.type}' via ${k}`);
                return self.value;
            });
        })(), _a;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return 1 + this.__internal__raw.encodedLength;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description The index of the enum value
     */ get index() {
        return this.__internal__indexes[this.__internal__entryIndex];
    }
    /**
     * @description The value of the enum
     */ get inner() {
        return this.__internal__raw;
    }
    /**
     * @description true if this is a basic enum (no values)
     */ get isBasic() {
        return this.__internal__isBasic;
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.__internal__raw.isEmpty;
    }
    /**
     * @description Checks if the Enum points to a [[Null]] type
     */ get isNone() {
        return this.__internal__raw instanceof (0, $cde2b5a819d50097$export$26c9c3a80cd996ae);
    }
    /**
     * @description The available keys for this enum
     */ get defIndexes() {
        return this.__internal__indexes;
    }
    /**
     * @description The available keys for this enum
     */ get defKeys() {
        return Object.keys(this.__internal__def);
    }
    /**
     * @description The name of the type this enum value represents
     */ get type() {
        return this.defKeys[this.__internal__entryIndex];
    }
    /**
     * @description The value of the enum
     */ get value() {
        return this.__internal__raw;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        // cater for the case where we only pass the enum index
        if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(other)) return !this.toU8a().some((entry, index)=>entry !== other[index]);
        else if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(other)) return this.toNumber() === other;
        else if (this.__internal__isBasic && (0, $0d672af39bfe8283$export$844ec244b1367d54)(other)) return this.type === other;
        else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(other)) return this.toHex() === other;
        else if (other instanceof $533387422670f8b2$export$deb82508dd66d288) return this.index === other.index && this.value.eq(other.value);
        else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(other)) return this.value.eq(other[this.type]);
        // compare the actual wrapper value
        return this.value.eq(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        if (this.__internal__isBasic) return {
            outer: [
                new Uint8Array([
                    this.index
                ])
            ]
        };
        const { inner: inner, outer: outer = [] } = this.__internal__raw.inspect();
        return {
            inner: inner,
            outer: [
                new Uint8Array([
                    this.index
                ]),
                ...outer
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        return this.__internal__isBasic || this.isNone ? this.type : {
            [this.type]: this.__internal__raw.toHuman(isExtended)
        };
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.__internal__isBasic ? this.type : {
            [(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(this.type)]: this.__internal__raw.toJSON()
        };
    }
    /**
     * @description Returns the number representation for the value
     */ toNumber() {
        return this.index;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.__internal__isBasic ? this.type : {
            [(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(this.type)]: this.__internal__raw.toPrimitive()
        };
    }
    /**
     * @description Returns a raw struct representation of the enum types
     */ _toRawStruct() {
        if (this.__internal__isBasic) return this.__internal__isIndexed ? this.defKeys.reduce((out, key, index)=>{
            out[key] = this.__internal__indexes[index];
            return out;
        }, {}) : this.defKeys;
        const entries = Object.entries(this.__internal__def);
        return (0, $faf940201c18431a$export$97b3c2f336f5e421)(this.registry, entries.reduce((out, [key, { Type: Type }], i)=>{
            out[0][i] = Type;
            out[1][i] = key;
            return out;
        }, [
            new Array(entries.length),
            new Array(entries.length)
        ]));
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)({
            _enum: this._toRawStruct()
        });
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.isNone ? this.type : (0, $e2c4db534325025c$export$fac44ee5b035f737)(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        return isBare ? this.__internal__raw.toU8a(isBare) : (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)([
            new Uint8Array([
                this.index
            ]),
            this.__internal__raw.toU8a(isBare)
        ]);
    }
}





const $28ae0347fa173539$var$checkCodec = /*#__PURE__*/ (0, $d5bd3faeeec86a19$export$35271fb956347754)("toHex", "toHuman", "toU8a");
const $28ae0347fa173539$var$checkRegistry = /*#__PURE__*/ (0, $d5bd3faeeec86a19$export$35271fb956347754)("get");
function $28ae0347fa173539$export$8914f96432c883a3(value) {
    return $28ae0347fa173539$var$checkCodec(value) && $28ae0347fa173539$var$checkRegistry(value.registry);
}


/** @internal **/ function $83375bd430423ee4$var$isArrayLike(arg) {
    return arg instanceof Uint8Array || Array.isArray(arg);
}
/** @internal **/ function $83375bd430423ee4$var$isEnum(arg) {
    return (0, $28ae0347fa173539$export$8914f96432c883a3)(arg) && (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(arg.index) && (0, $28ae0347fa173539$export$8914f96432c883a3)(arg.value);
}
/** @internal */ function $83375bd430423ee4$var$isNumberLike(arg) {
    return (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(arg) || (0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(arg) || (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(arg);
}
/** @internal */ function $83375bd430423ee4$var$sortArray(a, b) {
    // Vec, Tuple, Bytes etc.
    let sortRes = 0;
    const minLen = Math.min(a.length, b.length);
    for(let i = 0; i < minLen; ++i){
        sortRes = $83375bd430423ee4$export$9e819a29c0efa48c(a[i], b[i]);
        if (sortRes !== 0) return sortRes;
    }
    return a.length - b.length;
}
function $83375bd430423ee4$export$9e819a29c0efa48c(a, b) {
    if ($83375bd430423ee4$var$isNumberLike(a) && $83375bd430423ee4$var$isNumberLike(b)) return (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(a).cmp((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(b));
    else if (a instanceof Map && b instanceof Map) return $83375bd430423ee4$export$9e819a29c0efa48c(Array.from(a.values()), Array.from(b.values()));
    else if ($83375bd430423ee4$var$isEnum(a) && $83375bd430423ee4$var$isEnum(b)) return $83375bd430423ee4$export$9e819a29c0efa48c(a.index, b.index) || $83375bd430423ee4$export$9e819a29c0efa48c(a.value, b.value);
    else if ($83375bd430423ee4$var$isArrayLike(a) && $83375bd430423ee4$var$isArrayLike(b)) return $83375bd430423ee4$var$sortArray(a, b);
    else if ((0, $28ae0347fa173539$export$8914f96432c883a3)(a) && (0, $28ae0347fa173539$export$8914f96432c883a3)(b)) // Text, Bool etc.
    return $83375bd430423ee4$export$9e819a29c0efa48c(a.toU8a(true), b.toU8a(true));
    throw new Error(`Attempting to sort unrecognized values: ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(a)} (typeof ${typeof a}) <-> ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(b)} (typeof ${typeof b})`);
}
function $83375bd430423ee4$export$5e29d11194990010(set) {
    return new Set(Array.from(set).sort($83375bd430423ee4$export$9e819a29c0efa48c));
}
function $83375bd430423ee4$export$b1d2f6c4a6d5367c(map) {
    return new Map(Array.from(map.entries()).sort(([keyA], [keyB])=>$83375bd430423ee4$export$9e819a29c0efa48c(keyA, keyB)));
}


const $63a17a756d0821f7$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("Map");
/** @internal */ function $63a17a756d0821f7$var$decodeMapFromU8a(registry, KeyClass, ValClass, u8a) {
    const output = new Map();
    const [offset, count] = (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(u8a);
    const types = [];
    for(let i = 0; i < count; i++)types.push(KeyClass, ValClass);
    const [values, decodedLength] = (0, $c6c7d9c63fddefa8$export$e7a6c3d9d31d9fd6)(registry, new Array(types.length), u8a.subarray(offset), [
        types,
        []
    ]);
    for(let i = 0, count = values.length; i < count; i += 2)output.set(values[i], values[i + 1]);
    return [
        KeyClass,
        ValClass,
        output,
        offset + decodedLength
    ];
}
/** @internal */ function $63a17a756d0821f7$var$decodeMapFromMap(registry, KeyClass, ValClass, value) {
    const output = new Map();
    for (const [key, val] of value.entries()){
        const isComplex = KeyClass.prototype instanceof (0, $a0caa1f2a8043284$export$8d1ecab2e896dc35) || KeyClass.prototype instanceof (0, $6552ecce3d7abdb5$export$eabc71f011df675a) || KeyClass.prototype instanceof (0, $533387422670f8b2$export$deb82508dd66d288);
        try {
            output.set(key instanceof KeyClass ? key : new KeyClass(registry, isComplex && typeof key === "string" ? JSON.parse(key) : key), val instanceof ValClass ? val : new ValClass(registry, val));
        } catch (error) {
            $63a17a756d0821f7$var$l.error("Failed to decode key or value:", error.message);
            throw error;
        }
    }
    return [
        KeyClass,
        ValClass,
        output,
        0
    ];
}
/**
 * Decode input to pass into constructor.
 *
 * @param KeyClass - Type of the map key
 * @param ValClass - Type of the map value
 * @param value - Value to decode, one of:
 * - null
 * - undefined
 * - hex
 * - Uint8Array
 * - Map<any, any>, where both key and value types are either
 *   constructors or decodeable values for their types.
 * @param jsonMap
 * @internal
 */ function $63a17a756d0821f7$var$decodeMap(registry, keyType, valType, value) {
    const KeyClass = (0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, keyType);
    const ValClass = (0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, valType);
    if (!value) return [
        KeyClass,
        ValClass,
        new Map(),
        0
    ];
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return $63a17a756d0821f7$var$decodeMapFromU8a(registry, KeyClass, ValClass, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
    else if (value instanceof Map) return $63a17a756d0821f7$var$decodeMapFromMap(registry, KeyClass, ValClass, value);
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value)) return $63a17a756d0821f7$var$decodeMapFromMap(registry, KeyClass, ValClass, new Map(Object.entries(value)));
    throw new Error("Map: cannot decode type");
}
class $63a17a756d0821f7$export$9525505fae60804d extends Map {
    constructor(registry, keyType, valType, rawValue, type = "HashMap"){
        const [KeyClass, ValClass, decoded, decodedLength] = $63a17a756d0821f7$var$decodeMap(registry, keyType, valType, rawValue);
        super(type === "BTreeMap" ? (0, $83375bd430423ee4$export$b1d2f6c4a6d5367c)(decoded) : decoded);
        this.registry = registry;
        this.initialU8aLength = decodedLength;
        this.__internal__KeyClass = KeyClass;
        this.__internal__ValClass = ValClass;
        this.__internal__type = type;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        let len = (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.size).length;
        for (const [k, v] of this.entries())len += k.encodedLength + v.encodedLength;
        return len;
    }
    /**
     * @description Returns a hash of the value
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.size === 0;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return (0, $ac7bf2586ed6a7f5$export$bc5ca6344d311f69)(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        const inner = [];
        for (const [k, v] of this.entries()){
            inner.push(k.inspect());
            inner.push(v.inspect());
        }
        return {
            inner: inner,
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.size)
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        const json = {};
        for (const [k, v] of this.entries())json[k instanceof (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) && k.isAscii ? k.toUtf8() : k.toString()] = v.toHuman(isExtended);
        return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        const json = {};
        for (const [k, v] of this.entries())json[k.toString()] = v.toJSON();
        return json;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        const json = {};
        for (const [k, v] of this.entries())json[k instanceof (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) && k.isAscii ? k.toUtf8() : k.toString()] = v.toPrimitive();
        return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `${this.__internal__type}<${this.registry.getClassName(this.__internal__KeyClass) || new this.__internal__KeyClass(this.registry).toRawType()},${this.registry.getClassName(this.__internal__ValClass) || new this.__internal__ValClass(this.registry).toRawType()}>`;
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const encoded = [];
        if (!isBare) encoded.push((0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.size));
        for (const [k, v] of this.entries())encoded.push(k.toU8a(isBare), v.toU8a(isBare));
        return (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(encoded);
    }
}


class $bcf1df2fef1fa41d$export$55167a68eb392190 extends (0, $63a17a756d0821f7$export$9525505fae60804d) {
    static with(keyType, valType) {
        return class extends $bcf1df2fef1fa41d$export$55167a68eb392190 {
            constructor(registry, value){
                super(registry, keyType, valType, value, "BTreeMap");
            }
        };
    }
}



function $03d2f83aa3297ab2$var$compareSetArray(a, b) {
    // equal number of entries and each entry in the array should match
    return a.size === b.length && !b.some((e)=>!a.has(e));
}
function $03d2f83aa3297ab2$export$1650eced3c420770(a, b) {
    if (Array.isArray(b)) return $03d2f83aa3297ab2$var$compareSetArray(a, b);
    else if (b instanceof Set) return $03d2f83aa3297ab2$var$compareSetArray(a, [
        ...b.values()
    ]);
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(b)) return $03d2f83aa3297ab2$var$compareSetArray(a, Object.values(b));
    return false;
}


const $a4bf2bc576e78b16$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("BTreeSet");
/** @internal */ function $a4bf2bc576e78b16$var$decodeSetFromU8a(registry, ValClass, u8a) {
    const output = new Set();
    const [offset, count] = (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(u8a);
    const result = new Array(count);
    const [decodedLength] = (0, $c6c7d9c63fddefa8$export$ebb8ead71f4fb09f)(registry, result, u8a, offset, ValClass);
    for(let i = 0; i < count; i++)output.add(result[i]);
    return [
        ValClass,
        output,
        decodedLength
    ];
}
/** @internal */ function $a4bf2bc576e78b16$var$decodeSetFromSet(registry, ValClass, value) {
    const output = new Set();
    value.forEach((val)=>{
        try {
            output.add(val instanceof ValClass ? val : new ValClass(registry, val));
        } catch (error) {
            $a4bf2bc576e78b16$var$l.error("Failed to decode key or value:", error.message);
            throw error;
        }
    });
    return [
        ValClass,
        output,
        0
    ];
}
/**
 * Decode input to pass into constructor.
 *
 * @param ValClass - Type of the map value
 * @param value - Value to decode, one of:
 * - null
 * - undefined
 * - hex
 * - Uint8Array
 * - Set<any>, where both key and value types are either
 *   constructors or decodeable values for their types.
 * @param jsonSet
 * @internal
 */ function $a4bf2bc576e78b16$var$decodeSet(registry, valType, value) {
    const ValClass = (0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, valType);
    if (!value) return [
        ValClass,
        new Set(),
        0
    ];
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return $a4bf2bc576e78b16$var$decodeSetFromU8a(registry, ValClass, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
    else if (Array.isArray(value) || value instanceof Set) return $a4bf2bc576e78b16$var$decodeSetFromSet(registry, ValClass, value);
    throw new Error("BTreeSet: cannot decode type");
}
class $a4bf2bc576e78b16$export$7167d47bc66aa5cc extends Set {
    constructor(registry, valType, rawValue){
        const [ValClass, values, decodedLength] = $a4bf2bc576e78b16$var$decodeSet(registry, valType, rawValue);
        super((0, $83375bd430423ee4$export$5e29d11194990010)(values));
        this.registry = registry;
        this.initialU8aLength = decodedLength;
        this.__internal__ValClass = ValClass;
    }
    static with(valType) {
        return class extends $a4bf2bc576e78b16$export$7167d47bc66aa5cc {
            constructor(registry, value){
                super(registry, valType, value);
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        let len = (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.size).length;
        for (const v of this.values())len += v.encodedLength;
        return len;
    }
    /**
     * @description Returns a hash of the value
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.size === 0;
    }
    /**
     * @description The actual set values as a string[]
     */ get strings() {
        return [
            ...super.values()
        ].map((v)=>v.toString());
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return (0, $03d2f83aa3297ab2$export$1650eced3c420770)(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        const inner = [];
        for (const v of this.values())inner.push(v.inspect());
        return {
            inner: inner,
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.size)
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        const json = [];
        for (const v of this.values())json.push(v.toHuman(isExtended));
        return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        const json = [];
        for (const v of this.values())json.push(v.toJSON());
        return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `BTreeSet<${this.registry.getClassName(this.__internal__ValClass) || new this.__internal__ValClass(this.registry).toRawType()}>`;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        const json = [];
        for (const v of this.values())json.push(v.toPrimitive());
        return json;
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const encoded = [];
        if (!isBare) encoded.push((0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.size));
        for (const v of this.values())encoded.push(v.toU8a(isBare));
        return (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(encoded);
    }
}



function $7c076f10c5650efd$export$54cb8b08f590bc42(input) {
    return (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)([
        (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(input.length),
        input
    ]);
}



const $6af5ed30500c41f2$var$MAX_LENGTH = 10485760;
/** @internal */ function $6af5ed30500c41f2$var$decodeBytesU8a(value) {
    if (!value.length) return [
        new Uint8Array(),
        0
    ];
    // handle all other Uint8Array inputs, these do have a length prefix
    const [offset, length] = (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(value);
    const total = offset + length;
    if (length > $6af5ed30500c41f2$var$MAX_LENGTH) throw new Error(`Bytes length ${length.toString()} exceeds ${$6af5ed30500c41f2$var$MAX_LENGTH}`);
    else if (total > value.length) throw new Error(`Bytes: required length less than remainder, expected at least ${total}, found ${value.length}`);
    return [
        value.subarray(offset, total),
        total
    ];
}
class $6af5ed30500c41f2$export$9f55f2e2bf8c2fc1 extends (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) {
    constructor(registry, value){
        const [u8a, decodedLength] = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) && !(value instanceof (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94)) ? $6af5ed30500c41f2$var$decodeBytesU8a(value) : Array.isArray(value) || (0, $0d672af39bfe8283$export$844ec244b1367d54)(value) ? [
            (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value),
            0
        ] : [
            value,
            0
        ];
        super(registry, u8a, decodedLength);
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.length + (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.length).length;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect(isBare) {
        const clength = (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.length);
        return {
            outer: isBare ? [
                super.toU8a()
            ] : this.length ? [
                clength,
                super.toU8a()
            ] : [
                clength
            ]
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Bytes";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        return isBare ? super.toU8a(isBare) : (0, $7c076f10c5650efd$export$54cb8b08f590bc42)(this);
    }
}


var $hWfed = parcelRequire("hWfed");

function $ddaad9cfdda516eb$var$encodeSet(setValues, values) {
    const encoded = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
    for(let i = 0, count = values.length; i < count; i++)encoded.ior((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(setValues[values[i]] || 0));
    return encoded;
}
/** @internal */ function $ddaad9cfdda516eb$var$decodeSetArray(setValues, values) {
    const count = values.length;
    const result = new Array(count);
    for(let i = 0; i < count; i++){
        const key = values[i];
        if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(setValues[key])) throw new Error(`Set: Invalid key '${key}' passed to Set, allowed ${Object.keys(setValues).join(", ")}`);
        result[i] = key;
    }
    return result;
}
/** @internal */ function $ddaad9cfdda516eb$var$decodeSetNumber(setValues, _value) {
    const bn = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(_value);
    const keys = Object.keys(setValues);
    const result = [];
    for(let i = 0, count = keys.length; i < count; i++){
        const key = keys[i];
        if (bn.and((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(setValues[key])).eq((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(setValues[key]))) result.push(key);
    }
    const computed = $ddaad9cfdda516eb$var$encodeSet(setValues, result);
    if (!bn.eq(computed)) throw new Error(`Set: Mismatch decoding '${bn.toString()}', computed as '${computed.toString()}' with ${result.join(", ")}`);
    return result;
}
/** @internal */ function $ddaad9cfdda516eb$var$decodeSet(setValues, value = 0, bitLength) {
    if (bitLength % 8 !== 0) throw new Error(`Expected valid bitLength, power of 8, found ${bitLength}`);
    const byteLength = bitLength / 8;
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) return value.length === 0 ? [] : $ddaad9cfdda516eb$var$decodeSetNumber(setValues, (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(value.subarray(0, byteLength), {
        isLe: true
    }));
    else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) return $ddaad9cfdda516eb$var$decodeSet(setValues, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), byteLength);
    else if (value instanceof Set || Array.isArray(value)) {
        const input = Array.isArray(value) ? value : [
            ...value.values()
        ];
        return $ddaad9cfdda516eb$var$decodeSetArray(setValues, input);
    }
    return $ddaad9cfdda516eb$var$decodeSetNumber(setValues, value);
}
class $ddaad9cfdda516eb$export$d6ee8f3a9f0a4893 extends Set {
    constructor(registry, setValues, value, bitLength = 8){
        super($ddaad9cfdda516eb$var$decodeSet(setValues, value, bitLength));
        /**
         * @description adds a value to the Set (extended to allow for validity checking)
         */ this.add = (key)=>{
            // ^^^ add = () property done to assign this instance's this, otherwise Set.add creates "some" chaos
            // we have the isUndefined(this._setValues) in here as well, add is used internally
            // in the Set constructor (so it is undefined at this point, and should allow)
            if (this.__internal__allowed && (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(this.__internal__allowed[key])) throw new Error(`Set: Invalid key '${key}' on add`);
            super.add(key);
            return this;
        };
        this.registry = registry;
        this.__internal__allowed = setValues;
        this.__internal__byteLength = bitLength / 8;
    }
    static with(values, bitLength) {
        var _a;
        return _a = class extends $ddaad9cfdda516eb$export$d6ee8f3a9f0a4893 {
            constructor(registry, value){
                super(registry, values, value, bitLength);
            }
        }, (()=>{
            const keys = Object.keys(values);
            const count = keys.length;
            const isKeys = new Array(count);
            for(let i = 0; i < count; i++)isKeys[i] = `is${(0, $4db46be060f888b6$export$733fa19993fe16bc)(keys[i])}`;
            (0, $fb51452ffd615a15$export$4660c3861a213768)(_a.prototype, isKeys, (_, i, self)=>self.strings.includes(keys[i]));
        })(), _a;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.__internal__byteLength;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description true is the Set contains no values
     */ get isEmpty() {
        return this.size === 0;
    }
    /**
     * @description The actual set values as a string[]
     */ get strings() {
        return [
            ...super.values()
        ];
    }
    /**
     * @description The encoded value for the set members
     */ get valueEncoded() {
        return $ddaad9cfdda516eb$var$encodeSet(this.__internal__allowed, this.strings);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        if (Array.isArray(other)) // we don't actually care about the order, sort the values
        return (0, $39431919ab8b009c$export$cb07857b027678fa)(this.strings.sort(), other.sort());
        else if (other instanceof Set) return this.eq([
            ...other.values()
        ]);
        else if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(other) || (0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(other)) return this.valueEncoded.eq((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(other));
        return false;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.strings;
    }
    /**
     * @description The encoded value for the set members
     */ toNumber() {
        return this.valueEncoded.toNumber();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)({
            _set: this.__internal__allowed
        });
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return `[${this.strings.join(", ")}]`;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(this.valueEncoded, {
            bitLength: this.__internal__byteLength * 8,
            isLe: true
        });
    }
}



function $bb002fe631d1d8b3$var$decodeCompact(registry, Type, value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) {
        const [decodedLength, bn] = (value[0] & 3) < 3 ? (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(value) : (0, $f98b10db0f2cd20b$export$78a7c3b36a13df0f)(value);
        return [
            new Type(registry, bn),
            decodedLength
        ];
    } else if (value instanceof $bb002fe631d1d8b3$export$6479582a9c9e50ce) {
        const raw = value.unwrap();
        return raw instanceof Type ? [
            raw,
            0
        ] : [
            new Type(registry, raw),
            0
        ];
    } else if (value instanceof Type) return [
        value,
        0
    ];
    return [
        new Type(registry, value),
        0
    ];
}
class $bb002fe631d1d8b3$export$6479582a9c9e50ce {
    constructor(registry, Type, value = 0, { definition: definition, setDefinition: setDefinition = (0, $3c9cf064340c6f95$export$f0954fd7d5368655) } = {}){
        this.registry = registry;
        this.__internal__Type = definition || setDefinition((0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, Type));
        const [raw, decodedLength] = $bb002fe631d1d8b3$var$decodeCompact(registry, this.__internal__Type, value);
        this.initialU8aLength = decodedLength;
        this.__internal__raw = raw;
    }
    static with(Type) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d)=>definition = d;
        return class extends $bb002fe631d1d8b3$export$6479582a9c9e50ce {
            constructor(registry, value){
                super(registry, Type, value, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.__internal__raw.isEmpty;
    }
    /**
     * @description Returns the number of bits in the value
     */ bitLength() {
        return this.__internal__raw.bitLength();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return this.__internal__raw.eq(other instanceof $bb002fe631d1d8b3$export$6479582a9c9e50ce ? other.__internal__raw : other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description Returns a BigInt representation of the number
     */ toBigInt() {
        return this.__internal__raw.toBigInt();
    }
    /**
     * @description Returns the BN representation of the number
     */ toBn() {
        return this.__internal__raw.toBn();
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */ toHex(isLe) {
        return this.__internal__raw.toHex(isLe);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        return this.__internal__raw.toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.__internal__raw.toJSON();
    }
    /**
     * @description Returns the number representation for the value
     */ toNumber() {
        return this.__internal__raw.toNumber();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.__internal__raw.toPrimitive();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `Compact<${this.registry.getClassName(this.__internal__Type) || this.__internal__raw.toRawType()}>`;
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.__internal__raw.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.__internal__raw.toBn());
    }
    /**
     * @description Returns the embedded [[UInt]] or [[Moment]] value
     */ unwrap() {
        return this.__internal__raw;
    }
}


class $b4be2714ca0b9963$export$60ef0b43d585640a extends (0, $63a17a756d0821f7$export$9525505fae60804d) {
    static with(keyType, valType) {
        return class extends $b4be2714ca0b9963$export$60ef0b43d585640a {
            constructor(registry, value){
                super(registry, keyType, valType, value);
            }
        };
    }
}


class $089e69a18315198b$export$fdd676b64b72b00 extends (0, $2860346704b23ada$export$48232fc27c65fab0) {
    constructor(registry, value = 0, bitLength){
        super(registry, value, bitLength, true);
    }
    static with(bitLength, typeName) {
        return class extends $089e69a18315198b$export$fdd676b64b72b00 {
            constructor(registry, value){
                super(registry, value, bitLength);
            }
            toRawType() {
                return typeName || super.toRawType();
            }
        };
    }
}




class $c77f4fb10fc66369$var$None extends (0, $cde2b5a819d50097$export$26c9c3a80cd996ae) {
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "None";
    }
}
/** @internal */ function $c77f4fb10fc66369$var$decodeOption(registry, Type, value) {
    if (value instanceof Type) // don't re-create, use as it (which also caters for derived types)
    return value;
    else if (value instanceof $c77f4fb10fc66369$export$36d18380658d5d20) {
        if (value.value instanceof Type) // same instance, return it
        return value.value;
        else if (value.isNone) // internal is None, we are also none
        return new $c77f4fb10fc66369$var$None(registry);
        // convert the actual value into known
        return new Type(registry, value.value);
    } else if ((0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(value) || (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(value) || value === "0x" || value instanceof $c77f4fb10fc66369$var$None) // anyhting empty we pass as-is
    return new $c77f4fb10fc66369$var$None(registry);
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) // the isU8a check happens last in the if-tree - since the wrapped value
    // may be an instance of it, so Type and Option checks go in first
    return !value.length || value[0] === 0 ? new $c77f4fb10fc66369$var$None(registry) : new Type(registry, value.subarray(1));
    return new Type(registry, value);
}
class $c77f4fb10fc66369$export$36d18380658d5d20 {
    constructor(registry, typeName, value, { definition: definition, setDefinition: setDefinition = (0, $3c9cf064340c6f95$export$f0954fd7d5368655) } = {}){
        const Type = definition || setDefinition((0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, typeName));
        const decoded = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) && value.length && !(0, $28ae0347fa173539$export$8914f96432c883a3)(value) ? value[0] === 0 ? new $c77f4fb10fc66369$var$None(registry) : new Type(registry, value.subarray(1)) : $c77f4fb10fc66369$var$decodeOption(registry, Type, value);
        this.registry = registry;
        this.__internal__Type = Type;
        this.__internal__raw = decoded;
        if (decoded?.initialU8aLength) this.initialU8aLength = 1 + decoded.initialU8aLength;
    }
    static with(Type) {
        let definition;
        const setDefinition = (d)=>{
            definition = d;
            return d;
        };
        return class extends $c77f4fb10fc66369$export$36d18380658d5d20 {
            constructor(registry, value){
                super(registry, Type, value, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        // boolean byte (has value, doesn't have) along with wrapped length
        return 1 + this.__internal__raw.encodedLength;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the Option has no value
     */ get isEmpty() {
        return this.isNone;
    }
    /**
     * @description Checks if the Option has no value
     */ get isNone() {
        return this.__internal__raw instanceof $c77f4fb10fc66369$var$None;
    }
    /**
     * @description Checks if the Option has a value
     */ get isSome() {
        return !this.isNone;
    }
    /**
     * @description The actual value for the Option
     */ get value() {
        return this.__internal__raw;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        if (other instanceof $c77f4fb10fc66369$export$36d18380658d5d20) return this.isSome === other.isSome && this.value.eq(other.value);
        return this.value.eq(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        if (this.isNone) return {
            outer: [
                new Uint8Array([
                    0
                ])
            ]
        };
        const { inner: inner, outer: outer = [] } = this.__internal__raw.inspect();
        return {
            inner: inner,
            outer: [
                new Uint8Array([
                    1
                ]),
                ...outer
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        // This attempts to align with the JSON encoding - actually in this case
        // the isSome value is correct, however the `isNone` may be problematic
        return this.isNone ? "0x" : (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a().subarray(1));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        return this.__internal__raw.toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.isNone ? null : this.__internal__raw.toJSON();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.isNone ? null : this.__internal__raw.toPrimitive();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType(isBare) {
        const wrapped = this.registry.getClassName(this.__internal__Type) || new this.__internal__Type(this.registry).toRawType();
        return isBare ? wrapped : `Option<${wrapped}>`;
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.__internal__raw.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        if (isBare) return this.__internal__raw.toU8a(true);
        const u8a = new Uint8Array(this.encodedLength);
        if (this.isSome) {
            u8a.set([
                1
            ]);
            u8a.set(this.__internal__raw.toU8a(), 1);
        }
        return u8a;
    }
    /**
     * @description Returns the value that the Option represents (if available), throws if null
     */ unwrap() {
        if (this.isNone) throw new Error("Option: unwrapping a None value");
        return this.__internal__raw;
    }
    /**
     * @description Returns the value that the Option represents (if available) or defaultValue if none
     * @param defaultValue The value to return if the option isNone
     */ unwrapOr(defaultValue) {
        return this.isSome ? this.unwrap() : defaultValue;
    }
    /**
     * @description Returns the value that the Option represents (if available) or defaultValue if none
     * @param defaultValue The value to return if the option isNone
     */ unwrapOrDefault() {
        return this.isSome ? this.unwrap() : new this.__internal__Type(this.registry);
    }
}




/** @internal */ function $3f7ea4d5b3798bbe$var$decodeTuple(registry, result, value, Classes) {
    if (Array.isArray(value)) {
        const Types = Classes[0];
        for(let i = 0, count = Types.length; i < count; i++)try {
            const entry = value?.[i];
            result[i] = entry instanceof Types[i] ? entry : new Types[i](registry, entry);
        } catch (error) {
            throw new Error(`Tuple: failed on ${i}:: ${error.message}`);
        }
        return [
            result,
            0
        ];
    } else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return (0, $c6c7d9c63fddefa8$export$e7a6c3d9d31d9fd6)(registry, result, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), Classes);
    else if (!value || !result.length) {
        const Types = Classes[0];
        for(let i = 0, count = Types.length; i < count; i++)result[i] = new Types[i](registry);
        return [
            result,
            0
        ];
    }
    throw new Error(`Expected array input to Tuple decoding, found ${typeof value}: ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(value)}`);
}
class $3f7ea4d5b3798bbe$export$1908877435b1d5e9 extends (0, $a0caa1f2a8043284$export$8d1ecab2e896dc35) {
    constructor(registry, Types, value, { definition: definition, setDefinition: setDefinition = (0, $3c9cf064340c6f95$export$f0954fd7d5368655) } = {}){
        const Classes = definition || setDefinition(Array.isArray(Types) ? [
            (0, $decc53b303ead3a7$export$8a2235eb3de9eba7)(registry, Types),
            []
        ] : (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(Types) || (0, $0d672af39bfe8283$export$844ec244b1367d54)(Types) ? [
            [
                (0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, Types)
            ],
            []
        ] : (0, $decc53b303ead3a7$export$17958927a4ea0eb2)(registry, Types));
        super(registry, Classes[0].length);
        this.initialU8aLength = ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? (0, $c6c7d9c63fddefa8$export$e7a6c3d9d31d9fd6)(registry, this, value, Classes) : $3f7ea4d5b3798bbe$var$decodeTuple(registry, this, value, Classes))[1];
        this.__internal__Types = Classes;
    }
    static with(Types) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d)=>definition = d;
        return class extends $3f7ea4d5b3798bbe$export$1908877435b1d5e9 {
            constructor(registry, value){
                super(registry, Types, value, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        let total = 0;
        for(let i = 0, count = this.length; i < count; i++)total += this[i].encodedLength;
        return total;
    }
    /**
     * @description The types definition of the tuple
     */ get Types() {
        return this.__internal__Types[1].length ? this.__internal__Types[1] : this.__internal__Types[0].map((T)=>new T(this.registry).toRawType());
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            inner: this.inspectInner()
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        const types = this.__internal__Types[0].map((T)=>this.registry.getClassName(T) || new T(this.registry).toRawType());
        return `(${types.join(",")})`;
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        // Overwrite the default toString representation of Array.
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        return (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(this.toU8aInner(isBare));
    }
}


class $431316c802e00787$export$9a58ef0d7ad3278c extends (0, $3f7ea4d5b3798bbe$export$1908877435b1d5e9) {
    constructor(registry, Type, value, { rangeName: rangeName = "Range" } = {}){
        super(registry, [
            Type,
            Type
        ], value);
        this.__internal__rangeName = rangeName;
    }
    static with(Type) {
        return class extends $431316c802e00787$export$9a58ef0d7ad3278c {
            constructor(registry, value){
                super(registry, Type, value);
            }
        };
    }
    /**
     * @description Returns the starting range value
     */ get start() {
        return this[0];
    }
    /**
     * @description Returns the ending range value
     */ get end() {
        return this[1];
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `${this.__internal__rangeName}<${this.start.toRawType()}>`;
    }
}


class $e9cc80ae52e3f65e$export$407ce530a5412615 extends (0, $431316c802e00787$export$9a58ef0d7ad3278c) {
    constructor(registry, Type, value){
        super(registry, Type, value, {
            rangeName: "RangeInclusive"
        });
    }
    static with(Type) {
        return class extends $e9cc80ae52e3f65e$export$407ce530a5412615 {
            constructor(registry, value){
                super(registry, Type, value);
            }
        };
    }
}


class $9118a58e4b3db64c$export$8fdcabde73f49165 extends (0, $533387422670f8b2$export$deb82508dd66d288) {
    constructor(registry, Ok, Err, value){
        // NOTE This is order-dependent, Ok (with index 0) needs to be first
        // eslint-disable-next-line sort-keys
        super(registry, {
            Ok: Ok,
            Err: Err
        }, value);
    }
    static with(Types) {
        return class extends $9118a58e4b3db64c$export$8fdcabde73f49165 {
            constructor(registry, value){
                super(registry, Types.Ok, Types.Err, value);
            }
        };
    }
    /**
     * @description Returns the wrapper Err value (if isErr)
     */ get asErr() {
        if (!this.isErr) throw new Error("Cannot extract Err value from Ok result, check isErr first");
        return this.value;
    }
    /**
     * @description Returns the wrapper Ok value (if isOk)
     */ get asOk() {
        if (!this.isOk) throw new Error("Cannot extract Ok value from Err result, check isOk first");
        return this.value;
    }
    /**
     * @description Checks if the Result has no value
     */ get isEmpty() {
        return this.isOk && this.value.isEmpty;
    }
    /**
     * @description Checks if the Result wraps an Err value
     */ get isErr() {
        return !this.isOk;
    }
    /**
     * @description Checks if the Result wraps an Ok value
     */ get isOk() {
        return this.index === 0;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        const Types = this._toRawStruct();
        return `Result<${Types.Ok},${Types.Err}>`;
    }
}



/** @internal */ function $76cc74693eb215d2$var$decodeU8aFixed(value, bitLength) {
    const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
    const byteLength = bitLength / 8;
    if (!u8a.length) return [
        new Uint8Array(byteLength),
        0
    ];
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? u8a.length < byteLength : u8a.length !== byteLength) throw new Error(`Expected input with ${byteLength} bytes (${bitLength} bits), found ${u8a.length} bytes`);
    return [
        u8a.subarray(0, byteLength),
        byteLength
    ];
}
class $76cc74693eb215d2$export$e34e28991bc25e78 extends (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) {
    constructor(registry, value = new Uint8Array(), bitLength = 256){
        const [u8a, decodedLength] = $76cc74693eb215d2$var$decodeU8aFixed(value, bitLength);
        super(registry, u8a, decodedLength);
    }
    static with(bitLength, typeName) {
        return class extends $76cc74693eb215d2$export$e34e28991bc25e78 {
            constructor(registry, value){
                super(registry, value, bitLength);
            }
            toRawType() {
                return typeName || super.toRawType();
            }
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `[u8;${this.length}]`;
    }
}




const $8b04145c78f25f1c$var$MAX_LENGTH = 65536;
const $8b04145c78f25f1c$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("Vec");
function $8b04145c78f25f1c$var$decodeVecLength(value) {
    if (Array.isArray(value)) return [
        value,
        value.length,
        0
    ];
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) {
        const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
        const [startAt, length] = (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(u8a);
        if (length > $8b04145c78f25f1c$var$MAX_LENGTH) throw new Error(`Vec length ${length.toString()} exceeds ${$8b04145c78f25f1c$var$MAX_LENGTH}`);
        return [
            u8a,
            length,
            startAt
        ];
    } else if (!value) return [
        null,
        0,
        0
    ];
    throw new Error(`Expected array/hex input to Vec<*> decoding, found ${typeof value}: ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(value)}`);
}
function $8b04145c78f25f1c$export$bbcebef8a40dc14e(registry, result, value, startAt, Type) {
    if (Array.isArray(value)) {
        const count = result.length;
        for(let i = 0; i < count; i++){
            // 26/08/2022 this is actually a false positive - after recent eslint upgdates
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const entry = value[i];
            try {
                result[i] = entry instanceof Type ? entry : new Type(registry, entry);
            } catch (error) {
                $8b04145c78f25f1c$var$l.error(`Unable to decode on index ${i}`, error.message);
                throw error;
            }
        }
        return [
            0,
            0
        ];
    } else if (!value) return [
        0,
        0
    ];
    // we don't need more checks, we already limited it via the length decoding
    return (0, $c6c7d9c63fddefa8$export$ebb8ead71f4fb09f)(registry, result, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), startAt, Type);
}
class $8b04145c78f25f1c$export$e947a0f742cf021e extends (0, $a0caa1f2a8043284$export$8d1ecab2e896dc35) {
    constructor(registry, Type, value = [], { definition: definition, setDefinition: setDefinition = (0, $3c9cf064340c6f95$export$f0954fd7d5368655) } = {}){
        const [decodeFrom, length, startAt] = $8b04145c78f25f1c$var$decodeVecLength(value);
        super(registry, length);
        this.__internal__Type = definition || setDefinition((0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, Type));
        this.initialU8aLength = ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(decodeFrom) ? (0, $c6c7d9c63fddefa8$export$ebb8ead71f4fb09f)(registry, this, decodeFrom, startAt, this.__internal__Type) : $8b04145c78f25f1c$export$bbcebef8a40dc14e(registry, this, decodeFrom, startAt, this.__internal__Type))[0];
    }
    static with(Type) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d)=>definition = d;
        return class extends $8b04145c78f25f1c$export$e947a0f742cf021e {
            constructor(registry, value){
                super(registry, Type, value, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        };
    }
    /**
     * @description The type for the items
     */ get Type() {
        return this.__internal__Type.name;
    }
    /**
     * @description Finds the index of the value in the array
     */ indexOf(other) {
        // convert type first, this removes overhead from the eq
        const check = other instanceof this.__internal__Type ? other : new this.__internal__Type(this.registry, other);
        for(let i = 0, count = this.length; i < count; i++){
            if (check.eq(this[i])) return i;
        }
        return -1;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `Vec<${this.registry.getClassName(this.__internal__Type) || new this.__internal__Type(this.registry).toRawType()}>`;
    }
}





class $a7b5164282fc26ef$export$817c7826c172179e extends (0, $a0caa1f2a8043284$export$8d1ecab2e896dc35) {
    constructor(registry, Type, length, value = [], { definition: definition, setDefinition: setDefinition = (0, $3c9cf064340c6f95$export$f0954fd7d5368655) } = {}){
        super(registry, length);
        this.__internal__Type = definition || setDefinition((0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, Type));
        this.initialU8aLength = ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? (0, $c6c7d9c63fddefa8$export$ebb8ead71f4fb09f)(registry, this, value, 0, this.__internal__Type) : (0, $8b04145c78f25f1c$export$bbcebef8a40dc14e)(registry, this, value, 0, this.__internal__Type))[1];
    }
    static with(Type, length) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d)=>definition = d;
        return class extends $a7b5164282fc26ef$export$817c7826c172179e {
            constructor(registry, value){
                super(registry, Type, length, value, {
                    definition: definition,
                    setDefinition: setDefinition
                });
            }
        };
    }
    /**
     * @description The type for the items
     */ get Type() {
        return new this.__internal__Type(this.registry).toRawType();
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        let total = 0;
        for(let i = 0, count = this.length; i < count; i++)total += this[i].encodedLength;
        return total;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            inner: this.inspectInner()
        };
    }
    toU8a() {
        // we override, we don't add the length prefix for ourselves, and at the same time we
        // ignore isBare on entries, since they should be properly encoded at all times
        const encoded = this.toU8aInner();
        return encoded.length ? (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(encoded) : new Uint8Array([]);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `[${this.Type};${this.length}]`;
    }
}


function $871e028f2f4a4d6f$export$cec2d66edc517cdd(input) {
    const [offset, length] = (0, $f98b10db0f2cd20b$export$78a7c3b36a13df0f)(input);
    const total = offset + length.toNumber();
    return [
        total,
        input.subarray(offset, total)
    ];
}





function $39b505ee5f682401$var$decodeRaw(registry, typeName, value) {
    const Type = (0, $decc53b303ead3a7$export$30c7ba5c4398003d)(registry, typeName);
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) try {
        const [, u8a] = (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? [
            0,
            (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value)
        ] : value instanceof (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) ? [
            0,
            value.subarray()
        ] : (0, $871e028f2f4a4d6f$export$cec2d66edc517cdd)(value);
        return [
            Type,
            new Type(registry, u8a),
            value
        ];
    } catch  {
        return [
            Type,
            null,
            value
        ];
    }
    const instance = new Type(registry, value);
    return [
        Type,
        instance,
        (0, $7c076f10c5650efd$export$54cb8b08f590bc42)(instance.toU8a())
    ];
}
class $39b505ee5f682401$export$a5d6a2ad932ecf51 extends (0, $6af5ed30500c41f2$export$9f55f2e2bf8c2fc1) {
    constructor(registry, typeName, value, { opaqueName: opaqueName = "WrapperKeepOpaque" } = {}){
        const [Type, decoded, u8a] = $39b505ee5f682401$var$decodeRaw(registry, typeName, value);
        super(registry, u8a);
        this.__internal__Type = Type;
        this.__internal__decoded = decoded;
        this.__internal__opaqueName = opaqueName;
    }
    static with(Type) {
        return class extends $39b505ee5f682401$export$a5d6a2ad932ecf51 {
            constructor(registry, value){
                super(registry, Type, value);
            }
        };
    }
    /**
     * @description Checks if the wrapper is decodable
     */ get isDecoded() {
        return !!this.__internal__decoded;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return this.__internal__decoded ? {
            inner: [
                this.__internal__decoded.inspect()
            ],
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.length)
            ]
        } : {
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.length),
                this.toU8a(true)
            ]
        };
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        return this.__internal__decoded ? this.__internal__decoded.toHuman(isExtended) : super.toHuman();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.__internal__decoded ? this.__internal__decoded.toPrimitive() : super.toPrimitive();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `${this.__internal__opaqueName}<${this.registry.getClassName(this.__internal__Type) || (this.__internal__decoded ? this.__internal__decoded.toRawType() : new this.__internal__Type(this.registry).toRawType())}>`;
    }
    /**
     * @description Converts the Object to to a string (either decoded or bytes)
     */ toString() {
        return this.__internal__decoded ? this.__internal__decoded.toString() : super.toString();
    }
    /**
     * @description Returns the decoded that the WrapperKeepOpaque represents (if available), throws if non-decodable
     */ unwrap() {
        if (!this.__internal__decoded) throw new Error(`${this.__internal__opaqueName}: unwrapping an undecodable value`);
        return this.__internal__decoded;
    }
}


class $6b70ddacaba35270$export$6112ef2a46ff874 extends (0, $39b505ee5f682401$export$a5d6a2ad932ecf51) {
    constructor(registry, typeName, value){
        super(registry, typeName, value, {
            opaqueName: "WrapperOpaque"
        });
    }
    static with(Type) {
        return class extends $6b70ddacaba35270$export$6112ef2a46ff874 {
            constructor(registry, value){
                super(registry, Type, value);
            }
        };
    }
    /**
     * @description The inner value for this wrapper, in all cases it _should_ be decodable (unlike KeepOpaque)
     */ get inner() {
        return this.unwrap();
    }
}





function $f05158b9012fbaae$var$getTypeDefType({ lookupName: lookupName, type: type }) {
    return lookupName || type;
}
function $f05158b9012fbaae$var$getSubDefArray(value) {
    if (!Array.isArray(value.sub)) throw new Error(`Expected subtype as TypeDef[] in ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(value)}`);
    return value.sub;
}
function $f05158b9012fbaae$var$getSubDef(value) {
    if (!value.sub || Array.isArray(value.sub)) throw new Error(`Expected subtype as TypeDef in ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(value)}`);
    return value.sub;
}
function $f05158b9012fbaae$var$getSubType(value) {
    return $f05158b9012fbaae$var$getTypeDefType($f05158b9012fbaae$var$getSubDef(value));
}
function $f05158b9012fbaae$var$getTypeClassMap(value) {
    const subs = $f05158b9012fbaae$var$getSubDefArray(value);
    const map = {};
    for(let i = 0, count = subs.length; i < count; i++)map[subs[i].name] = $f05158b9012fbaae$var$getTypeDefType(subs[i]);
    return map;
}
function $f05158b9012fbaae$var$getTypeClassArray(value) {
    return $f05158b9012fbaae$var$getSubDefArray(value).map($f05158b9012fbaae$var$getTypeDefType);
}
function $f05158b9012fbaae$var$createInt(Clazz, { displayName: displayName, length: length }) {
    if (!(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(length)) throw new Error(`Expected bitLength information for ${displayName || Clazz.constructor.name}<bitLength>`);
    return Clazz.with(length, displayName);
}
function $f05158b9012fbaae$var$createHashMap(Clazz, value) {
    const [keyType, valueType] = $f05158b9012fbaae$var$getTypeClassArray(value);
    return Clazz.with(keyType, valueType);
}
function $f05158b9012fbaae$var$createWithSub(Clazz, value) {
    return Clazz.with($f05158b9012fbaae$var$getSubType(value));
}
const $f05158b9012fbaae$var$infoMapping = {
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeMap]: (_registry, value)=>$f05158b9012fbaae$var$createHashMap((0, $bcf1df2fef1fa41d$export$55167a68eb392190), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeSet]: (_registry, value)=>$f05158b9012fbaae$var$createWithSub((0, $a4bf2bc576e78b16$export$7167d47bc66aa5cc), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Compact]: (_registry, value)=>$f05158b9012fbaae$var$createWithSub((0, $bb002fe631d1d8b3$export$6479582a9c9e50ce), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).DoNotConstruct]: (_registry, value)=>(0, $561a7ebeda2ce82e$export$61d01bf8d0c78f65).with(value.displayName || value.type),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Enum]: (_registry, value)=>{
        const subs = $f05158b9012fbaae$var$getSubDefArray(value);
        return (0, $533387422670f8b2$export$deb82508dd66d288).with(subs.every(({ type: type })=>type === "Null") ? subs.reduce((out, { index: index, name: name }, count)=>{
            out[name] = index || count;
            return out;
        }, {}) : $f05158b9012fbaae$var$getTypeClassMap(value));
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).HashMap]: (_registry, value)=>$f05158b9012fbaae$var$createHashMap((0, $b4be2714ca0b9963$export$60ef0b43d585640a), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Int]: (_registry, value)=>$f05158b9012fbaae$var$createInt((0, $089e69a18315198b$export$fdd676b64b72b00), value),
    // We have circular deps between Linkage & Struct
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Linkage]: (_registry, value)=>{
        const type = `Option<${$f05158b9012fbaae$var$getSubType(value)}>`;
        // eslint-disable-next-line sort-keys
        const Clazz = (0, $6552ecce3d7abdb5$export$eabc71f011df675a).with({
            previous: type,
            next: type
        });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        Clazz.prototype.toRawType = function() {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
            return `Linkage<${this.next.toRawType(true)}>`;
        };
        return Clazz;
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null]: (_registry, _value)=>(0, $cde2b5a819d50097$export$26c9c3a80cd996ae),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Option]: (_registry, value)=>{
        if (!value.sub || Array.isArray(value.sub)) throw new Error("Expected type information for Option");
        // NOTE This is opt-in (unhandled), not by default
        // if (value.sub.type === 'bool') {
        //   return OptionBool;
        // }
        return $f05158b9012fbaae$var$createWithSub((0, $c77f4fb10fc66369$export$36d18380658d5d20), value);
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain]: (registry, value)=>registry.getOrUnknown(value.type),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Range]: (_registry, value)=>$f05158b9012fbaae$var$createWithSub((0, $431316c802e00787$export$9a58ef0d7ad3278c), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).RangeInclusive]: (_registry, value)=>$f05158b9012fbaae$var$createWithSub((0, $e9cc80ae52e3f65e$export$407ce530a5412615), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Result]: (_registry, value)=>{
        const [Ok, Err] = $f05158b9012fbaae$var$getTypeClassArray(value);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return (0, $9118a58e4b3db64c$export$8fdcabde73f49165).with({
            Err: Err,
            Ok: Ok
        });
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Set]: (_registry, value)=>(0, $ddaad9cfdda516eb$export$d6ee8f3a9f0a4893).with($f05158b9012fbaae$var$getSubDefArray(value).reduce((result, { index: index, name: name })=>{
            result[name] = index;
            return result;
        }, {}), value.length),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Si]: (registry, value)=>$f05158b9012fbaae$export$79352ba150b6311e(registry, registry.lookup.getTypeDef(value.type)),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Struct]: (_registry, value)=>(0, $6552ecce3d7abdb5$export$eabc71f011df675a).with($f05158b9012fbaae$var$getTypeClassMap(value), value.alias),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Tuple]: (_registry, value)=>(0, $3f7ea4d5b3798bbe$export$1908877435b1d5e9).with($f05158b9012fbaae$var$getTypeClassArray(value)),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).UInt]: (_registry, value)=>$f05158b9012fbaae$var$createInt((0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Vec]: (_registry, { sub: sub })=>{
        if (!sub || Array.isArray(sub)) throw new Error("Expected type information for vector");
        return sub.type === "u8" ? (0, $6af5ed30500c41f2$export$9f55f2e2bf8c2fc1) : (0, $8b04145c78f25f1c$export$e947a0f742cf021e).with($f05158b9012fbaae$var$getTypeDefType(sub));
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).VecFixed]: (_registry, { displayName: displayName, length: length, sub: sub })=>{
        if (!(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(length) || !sub || Array.isArray(sub)) throw new Error("Expected length & type information for fixed vector");
        return sub.type === "u8" ? (0, $76cc74693eb215d2$export$e34e28991bc25e78).with(length * 8, displayName) : (0, $a7b5164282fc26ef$export$817c7826c172179e).with($f05158b9012fbaae$var$getTypeDefType(sub), length);
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperKeepOpaque]: (_registry, value)=>$f05158b9012fbaae$var$createWithSub((0, $39b505ee5f682401$export$a5d6a2ad932ecf51), value),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque]: (_registry, value)=>$f05158b9012fbaae$var$createWithSub((0, $6b70ddacaba35270$export$6112ef2a46ff874), value)
};
function $f05158b9012fbaae$export$fdf8750a4cbca64(registry, typeDef) {
    try {
        const Type = $f05158b9012fbaae$var$infoMapping[typeDef.info](registry, typeDef);
        if (!Type) throw new Error("No class created");
        // don't clobber any existing
        if (!Type.__fallbackType && typeDef.fallbackType) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore ...this is the only place we we actually assign this...
        Type.__fallbackType = typeDef.fallbackType;
        return Type;
    } catch (error) {
        throw new Error(`Unable to construct class from ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(typeDef)}: ${error.message}`);
    }
}
function $f05158b9012fbaae$export$79352ba150b6311e(registry, typeDef) {
    return registry.getUnsafe(typeDef.type, false, typeDef);
}
function $f05158b9012fbaae$export$8c6c7dc0f6f149ab(registry, type) {
    return(// just retrieve via name, no creation via typeDef
    registry.getUnsafe(type) || // we don't have an existing type, create the class via typeDef
    $f05158b9012fbaae$export$79352ba150b6311e(registry, registry.isLookupType(type) ? registry.lookup.getTypeDef(type) : (0, $22807b92000b3c41$export$9f31b1beea63f4ee)(type)));
}



function $06bddcb0a8413ca0$export$17581a7c6e2ec978(a, b) {
    const u8aa = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(a);
    const u8ab = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(b);
    if (u8aa.length === u8ab.length) {
        const dvA = new DataView(u8aa.buffer, u8aa.byteOffset);
        const dvB = new DataView(u8ab.buffer, u8ab.byteOffset);
        const mod = u8aa.length % 4 | 0;
        const length = u8aa.length - mod | 0;
        for(let i = 0; i < length; i += 4){
            if (dvA.getUint32(i) !== dvB.getUint32(i)) return false;
        }
        for(let i = length, count = u8aa.length; i < count; i++){
            if (u8aa[i] !== u8ab[i]) return false;
        }
        return true;
    }
    return false;
}



function $796aad855692ccf7$var$checkInstance(created, matcher) {
    const u8a = created.toU8a();
    const rawType = created.toRawType();
    const isOk = // full match, all ok
    (0, $06bddcb0a8413ca0$export$17581a7c6e2ec978)(u8a, matcher) || // on a length-prefixed type, just check the actual length
    [
        "Bytes",
        "Text",
        "Type"
    ].includes(rawType) && matcher.length === created.length || // when the created is empty and matcher is also empty, let it slide...
    created.isEmpty && matcher.every((v)=>!v);
    if (!isOk) throw new Error(`${rawType}:: Decoded input doesn't match input, received ${(0, $1e2cfad286c009ca$export$4429d284633899e1)(matcher, 512)} (${matcher.length} bytes), created ${(0, $1e2cfad286c009ca$export$4429d284633899e1)(u8a, 512)} (${u8a.length} bytes)`);
}
function $796aad855692ccf7$var$checkPedantic(created, [value]) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) $796aad855692ccf7$var$checkInstance(created, value);
    else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) $796aad855692ccf7$var$checkInstance(created, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
}
function $796aad855692ccf7$var$initType(registry, Type, params = [], { blockHash: blockHash, isFallback: isFallback, isOptional: isOptional, isPedantic: isPedantic } = {}) {
    const created = new (isOptional ? (0, $c77f4fb10fc66369$export$36d18380658d5d20).with(Type) : Type)(registry, ...params);
    isPedantic && $796aad855692ccf7$var$checkPedantic(created, params);
    if (blockHash) created.createdAtHash = $796aad855692ccf7$export$a0a5da2d2fe31216(registry, "BlockHash", [
        blockHash
    ]);
    if (isFallback) created.isStorageFallback = true;
    return created;
}
function $796aad855692ccf7$export$a0a5da2d2fe31216(registry, type, params = [], options = {}) {
    let Clazz = null;
    let firstError = null;
    try {
        Clazz = (0, $f05158b9012fbaae$export$8c6c7dc0f6f149ab)(registry, type);
        return $796aad855692ccf7$var$initType(registry, Clazz, params, options);
    } catch (error) {
        firstError = new Error(`createType(${type}):: ${error.message}`);
    }
    if (Clazz && Clazz.__fallbackType) try {
        Clazz = (0, $f05158b9012fbaae$export$8c6c7dc0f6f149ab)(registry, Clazz.__fallbackType);
        return $796aad855692ccf7$var$initType(registry, Clazz, params, options);
    } catch  {
    // swallow, we will throw the first error again
    }
    throw firstError;
}



function $7f962568317a1d97$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(message) ? message() : message);
}
function $7f962568317a1d97$export$5529f1223fff4d4a(value, message) {
    $7f962568317a1d97$export$a7a9523472993e97(value !== undefined && value !== null, message);
    return value;
}
function $7f962568317a1d97$export$f2525c1d596f8d46(x) {
    throw new Error(`This codepath should be unreachable. Unhandled input: ${x}`);
}

/**
 * @name lazyMethod
 * @description
 * Creates a lazy, on-demand getter for the specific value. Upon get the value will be evaluated.
 */ function $bad025b936daa7ef$export$54b978cbb0dbaeb0(result, item, creator, getName, index = 0) {
    const name = getName ? getName(item, index) : item.toString();
    let value;
    Object.defineProperty(result, name, {
        // This allows for re-configuration with the embedded defineProperty below
        // and ensures that on tested browsers and Node, it _will_ be redefined
        // and thus short-circuited for future access
        configurable: true,
        enumerable: true,
        // Use a function here, we don't want to capture the outer this, i.e.
        // don't use arrow functions in this context since we have a this inside
        get: function() {
            // This check should _always_ be false and unneeded, since we override
            // with a value below ... however we ensure we are quire vigilant against
            // all environment failures, so we are rather be safe than sorry
            if (value === undefined) {
                value = creator(item, index, this);
                try {
                    // re-define the property as a value, next time around this
                    // getter will only return the computed value
                    Object.defineProperty(this, name, {
                        value: value
                    });
                } catch  {
                // ignore any errors, since this _should_ not happen due to
                // the "configurable" property above. But if it ever does
                // from here-on we will be the cached value the next time
                // around (with a very slight dip in performance)
                }
            }
            return value;
        }
    });
}
function $bad025b936daa7ef$export$d3fc7341b317ef1a(result, items, creator, getName) {
    for(let i = 0, count = items.length; i < count; i++)$bad025b936daa7ef$export$54b978cbb0dbaeb0(result, items[i], creator, getName, i);
    return result;
}


var $0ce572e7e13c1201$exports = {};
"use strict";
Object.defineProperty($0ce572e7e13c1201$exports, "__esModule", {
    value: true
});
$0ce572e7e13c1201$exports.blake2b = void 0;
var $86027254dff81a9e$exports = {};
"use strict";
Object.defineProperty($86027254dff81a9e$exports, "__esModule", {
    value: true
});
$86027254dff81a9e$exports.BLAKE2 = $86027254dff81a9e$exports.SIGMA = void 0;
var $4b5a31cf14334437$exports = {};
"use strict";
Object.defineProperty($4b5a31cf14334437$exports, "__esModule", {
    value: true
});
$4b5a31cf14334437$exports.output = $4b5a31cf14334437$exports.exists = $4b5a31cf14334437$exports.hash = $4b5a31cf14334437$exports.bytes = $4b5a31cf14334437$exports.bool = $4b5a31cf14334437$exports.number = void 0;
function $4b5a31cf14334437$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$4b5a31cf14334437$exports.number = $4b5a31cf14334437$var$number;
function $4b5a31cf14334437$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$4b5a31cf14334437$exports.bool = $4b5a31cf14334437$var$bool;
function $4b5a31cf14334437$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$4b5a31cf14334437$exports.bytes = $4b5a31cf14334437$var$bytes;
function $4b5a31cf14334437$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $4b5a31cf14334437$var$number(hash.outputLen);
    $4b5a31cf14334437$var$number(hash.blockLen);
}
$4b5a31cf14334437$exports.hash = $4b5a31cf14334437$var$hash;
function $4b5a31cf14334437$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$4b5a31cf14334437$exports.exists = $4b5a31cf14334437$var$exists;
function $4b5a31cf14334437$var$output(out, instance) {
    $4b5a31cf14334437$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$4b5a31cf14334437$exports.output = $4b5a31cf14334437$var$output;
const $4b5a31cf14334437$var$assert = {
    number: $4b5a31cf14334437$var$number,
    bool: $4b5a31cf14334437$var$bool,
    bytes: $4b5a31cf14334437$var$bytes,
    hash: $4b5a31cf14334437$var$hash,
    exists: $4b5a31cf14334437$var$exists,
    output: $4b5a31cf14334437$var$output
};
$4b5a31cf14334437$exports.default = $4b5a31cf14334437$var$assert;


var $6d0c3b6cb2431a8d$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($6d0c3b6cb2431a8d$exports, "__esModule", {
    value: true
});
$6d0c3b6cb2431a8d$exports.randomBytes = $6d0c3b6cb2431a8d$exports.wrapXOFConstructorWithOpts = $6d0c3b6cb2431a8d$exports.wrapConstructorWithOpts = $6d0c3b6cb2431a8d$exports.wrapConstructor = $6d0c3b6cb2431a8d$exports.checkOpts = $6d0c3b6cb2431a8d$exports.Hash = $6d0c3b6cb2431a8d$exports.concatBytes = $6d0c3b6cb2431a8d$exports.toBytes = $6d0c3b6cb2431a8d$exports.utf8ToBytes = $6d0c3b6cb2431a8d$exports.asyncLoop = $6d0c3b6cb2431a8d$exports.nextTick = $6d0c3b6cb2431a8d$exports.hexToBytes = $6d0c3b6cb2431a8d$exports.bytesToHex = $6d0c3b6cb2431a8d$exports.isLE = $6d0c3b6cb2431a8d$exports.rotr = $6d0c3b6cb2431a8d$exports.createView = $6d0c3b6cb2431a8d$exports.u32 = $6d0c3b6cb2431a8d$exports.u8 = void 0;
var $856931fe4a6372fc$exports = {};
"use strict";
Object.defineProperty($856931fe4a6372fc$exports, "__esModule", {
    value: true
});
$856931fe4a6372fc$exports.crypto = void 0;
$856931fe4a6372fc$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $6d0c3b6cb2431a8d$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $6d0c3b6cb2431a8d$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$6d0c3b6cb2431a8d$exports.u8 = $6d0c3b6cb2431a8d$var$u8;
const $6d0c3b6cb2431a8d$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$6d0c3b6cb2431a8d$exports.u32 = $6d0c3b6cb2431a8d$var$u32;
// Cast array to view
const $6d0c3b6cb2431a8d$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$6d0c3b6cb2431a8d$exports.createView = $6d0c3b6cb2431a8d$var$createView;
// The rotate right (circular right shift) operation for uint32
const $6d0c3b6cb2431a8d$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$6d0c3b6cb2431a8d$exports.rotr = $6d0c3b6cb2431a8d$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$6d0c3b6cb2431a8d$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$6d0c3b6cb2431a8d$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $6d0c3b6cb2431a8d$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $6d0c3b6cb2431a8d$var$bytesToHex(bytes) {
    if (!$6d0c3b6cb2431a8d$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6d0c3b6cb2431a8d$var$hexes[bytes[i]];
    return hex;
}
$6d0c3b6cb2431a8d$exports.bytesToHex = $6d0c3b6cb2431a8d$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $6d0c3b6cb2431a8d$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$6d0c3b6cb2431a8d$exports.hexToBytes = $6d0c3b6cb2431a8d$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $6d0c3b6cb2431a8d$var$nextTick = async ()=>{};
$6d0c3b6cb2431a8d$exports.nextTick = $6d0c3b6cb2431a8d$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $6d0c3b6cb2431a8d$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $6d0c3b6cb2431a8d$exports.nextTick)();
        ts += diff;
    }
}
$6d0c3b6cb2431a8d$exports.asyncLoop = $6d0c3b6cb2431a8d$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $6d0c3b6cb2431a8d$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$6d0c3b6cb2431a8d$exports.utf8ToBytes = $6d0c3b6cb2431a8d$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $6d0c3b6cb2431a8d$var$toBytes(data) {
    if (typeof data === "string") data = $6d0c3b6cb2431a8d$var$utf8ToBytes(data);
    if (!$6d0c3b6cb2431a8d$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
$6d0c3b6cb2431a8d$exports.toBytes = $6d0c3b6cb2431a8d$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $6d0c3b6cb2431a8d$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$6d0c3b6cb2431a8d$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$6d0c3b6cb2431a8d$exports.concatBytes = $6d0c3b6cb2431a8d$var$concatBytes;
// For runtime check if class implements interface
class $6d0c3b6cb2431a8d$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$6d0c3b6cb2431a8d$exports.Hash = $6d0c3b6cb2431a8d$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
const $6d0c3b6cb2431a8d$var$isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function $6d0c3b6cb2431a8d$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$6d0c3b6cb2431a8d$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$6d0c3b6cb2431a8d$exports.checkOpts = $6d0c3b6cb2431a8d$var$checkOpts;
function $6d0c3b6cb2431a8d$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($6d0c3b6cb2431a8d$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
$6d0c3b6cb2431a8d$exports.wrapConstructor = $6d0c3b6cb2431a8d$var$wrapConstructor;
function $6d0c3b6cb2431a8d$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0c3b6cb2431a8d$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$6d0c3b6cb2431a8d$exports.wrapConstructorWithOpts = $6d0c3b6cb2431a8d$var$wrapConstructorWithOpts;
function $6d0c3b6cb2431a8d$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0c3b6cb2431a8d$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$6d0c3b6cb2431a8d$exports.wrapXOFConstructorWithOpts = $6d0c3b6cb2431a8d$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $6d0c3b6cb2431a8d$var$randomBytes(bytesLength = 32) {
    if ($856931fe4a6372fc$exports.crypto && typeof $856931fe4a6372fc$exports.crypto.getRandomValues === "function") return $856931fe4a6372fc$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$6d0c3b6cb2431a8d$exports.randomBytes = $6d0c3b6cb2431a8d$var$randomBytes;


// For BLAKE2b, the two extra permutations for rounds 10 and 11 are SIGMA[10..11] = SIGMA[0..1].
// prettier-ignore
$86027254dff81a9e$exports.SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
]);
class $86027254dff81a9e$var$BLAKE2 extends $6d0c3b6cb2431a8d$exports.Hash {
    constructor(blockLen, outputLen, opts = {}, keyLen, saltLen, persLen){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.length = 0;
        this.pos = 0;
        this.finished = false;
        this.destroyed = false;
        $4b5a31cf14334437$exports.default.number(blockLen);
        $4b5a31cf14334437$exports.default.number(outputLen);
        $4b5a31cf14334437$exports.default.number(keyLen);
        if (outputLen < 0 || outputLen > keyLen) throw new Error("outputLen bigger than keyLen");
        if (opts.key !== undefined && (opts.key.length < 1 || opts.key.length > keyLen)) throw new Error(`key must be up 1..${keyLen} byte long or undefined`);
        if (opts.salt !== undefined && opts.salt.length !== saltLen) throw new Error(`salt must be ${saltLen} byte long or undefined`);
        if (opts.personalization !== undefined && opts.personalization.length !== persLen) throw new Error(`personalization must be ${persLen} byte long or undefined`);
        this.buffer32 = (0, $6d0c3b6cb2431a8d$exports.u32)(this.buffer = new Uint8Array(blockLen));
    }
    update(data) {
        $4b5a31cf14334437$exports.default.exists(this);
        // Main difference with other hashes: there is flag for last block,
        // so we cannot process current block before we know that there
        // is the next one. This significantly complicates logic and reduces ability
        // to do zero-copy processing
        const { blockLen: blockLen, buffer: buffer, buffer32: buffer32 } = this;
        data = (0, $6d0c3b6cb2431a8d$exports.toBytes)(data);
        const len = data.length;
        const offset = data.byteOffset;
        const buf = data.buffer;
        for(let pos = 0; pos < len;){
            // If buffer is full and we still have input (don't process last block, same as blake2s)
            if (this.pos === blockLen) {
                this.compress(buffer32, 0, false);
                this.pos = 0;
            }
            const take = Math.min(blockLen - this.pos, len - pos);
            const dataOffset = offset + pos;
            // full block && aligned to 4 bytes && not last in input
            if (take === blockLen && !(dataOffset % 4) && pos + take < len) {
                const data32 = new Uint32Array(buf, dataOffset, Math.floor((len - pos) / 4));
                for(let pos32 = 0; pos + blockLen < len; pos32 += buffer32.length, pos += blockLen){
                    this.length += blockLen;
                    this.compress(data32, pos32, false);
                }
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            this.length += take;
            pos += take;
        }
        return this;
    }
    digestInto(out) {
        $4b5a31cf14334437$exports.default.exists(this);
        $4b5a31cf14334437$exports.default.output(out, this);
        const { pos: pos, buffer32: buffer32 } = this;
        this.finished = true;
        // Padding
        this.buffer.subarray(pos).fill(0);
        this.compress(buffer32, 0, true);
        const out32 = (0, $6d0c3b6cb2431a8d$exports.u32)(out);
        this.get().forEach((v, i)=>out32[i] = v);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        const { buffer: buffer, length: length, finished: finished, destroyed: destroyed, outputLen: outputLen, pos: pos } = this;
        to || (to = new this.constructor({
            dkLen: outputLen
        }));
        to.set(...this.get());
        to.length = length;
        to.finished = finished;
        to.destroyed = destroyed;
        to.outputLen = outputLen;
        to.buffer.set(buffer);
        to.pos = pos;
        return to;
    }
}
$86027254dff81a9e$exports.BLAKE2 = $86027254dff81a9e$var$BLAKE2;


var $669e2d936b3f5daf$exports = {};
"use strict";
Object.defineProperty($669e2d936b3f5daf$exports, "__esModule", {
    value: true
});
$669e2d936b3f5daf$exports.add = $669e2d936b3f5daf$exports.toBig = $669e2d936b3f5daf$exports.split = $669e2d936b3f5daf$exports.fromBig = void 0;
const $669e2d936b3f5daf$var$U32_MASK64 = BigInt(2 ** 32 - 1);
const $669e2d936b3f5daf$var$_32n = BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $669e2d936b3f5daf$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $669e2d936b3f5daf$var$U32_MASK64),
        l: Number(n >> $669e2d936b3f5daf$var$_32n & $669e2d936b3f5daf$var$U32_MASK64)
    };
    return {
        h: Number(n >> $669e2d936b3f5daf$var$_32n & $669e2d936b3f5daf$var$U32_MASK64) | 0,
        l: Number(n & $669e2d936b3f5daf$var$U32_MASK64) | 0
    };
}
$669e2d936b3f5daf$exports.fromBig = $669e2d936b3f5daf$var$fromBig;
function $669e2d936b3f5daf$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $669e2d936b3f5daf$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
$669e2d936b3f5daf$exports.split = $669e2d936b3f5daf$var$split;
const $669e2d936b3f5daf$var$toBig = (h, l)=>BigInt(h >>> 0) << $669e2d936b3f5daf$var$_32n | BigInt(l >>> 0);
$669e2d936b3f5daf$exports.toBig = $669e2d936b3f5daf$var$toBig;
// for Shift in [0, 32)
const $669e2d936b3f5daf$var$shrSH = (h, l, s)=>h >>> s;
const $669e2d936b3f5daf$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $669e2d936b3f5daf$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
const $669e2d936b3f5daf$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $669e2d936b3f5daf$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $669e2d936b3f5daf$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $669e2d936b3f5daf$var$rotr32H = (h, l)=>l;
const $669e2d936b3f5daf$var$rotr32L = (h, l)=>h;
// Left rotate for Shift in [1, 32)
const $669e2d936b3f5daf$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
const $669e2d936b3f5daf$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $669e2d936b3f5daf$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $669e2d936b3f5daf$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-
function $669e2d936b3f5daf$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
$669e2d936b3f5daf$exports.add = $669e2d936b3f5daf$var$add;
// Addition with more than 2 elements
const $669e2d936b3f5daf$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $669e2d936b3f5daf$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $669e2d936b3f5daf$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $669e2d936b3f5daf$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $669e2d936b3f5daf$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $669e2d936b3f5daf$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $669e2d936b3f5daf$var$u64 = {
    fromBig: $669e2d936b3f5daf$var$fromBig,
    split: $669e2d936b3f5daf$var$split,
    toBig: $669e2d936b3f5daf$exports.toBig,
    shrSH: $669e2d936b3f5daf$var$shrSH,
    shrSL: $669e2d936b3f5daf$var$shrSL,
    rotrSH: $669e2d936b3f5daf$var$rotrSH,
    rotrSL: $669e2d936b3f5daf$var$rotrSL,
    rotrBH: $669e2d936b3f5daf$var$rotrBH,
    rotrBL: $669e2d936b3f5daf$var$rotrBL,
    rotr32H: $669e2d936b3f5daf$var$rotr32H,
    rotr32L: $669e2d936b3f5daf$var$rotr32L,
    rotlSH: $669e2d936b3f5daf$var$rotlSH,
    rotlSL: $669e2d936b3f5daf$var$rotlSL,
    rotlBH: $669e2d936b3f5daf$var$rotlBH,
    rotlBL: $669e2d936b3f5daf$var$rotlBL,
    add: $669e2d936b3f5daf$var$add,
    add3L: $669e2d936b3f5daf$var$add3L,
    add3H: $669e2d936b3f5daf$var$add3H,
    add4L: $669e2d936b3f5daf$var$add4L,
    add4H: $669e2d936b3f5daf$var$add4H,
    add5H: $669e2d936b3f5daf$var$add5H,
    add5L: $669e2d936b3f5daf$var$add5L
};
$669e2d936b3f5daf$exports.default = $669e2d936b3f5daf$var$u64;



// Same as SHA-512 but LE
// prettier-ignore
const $0ce572e7e13c1201$var$IV = new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Temporary buffer
const $0ce572e7e13c1201$var$BUF = new Uint32Array(32);
// Mixing function G splitted in two halfs
function $0ce572e7e13c1201$var$G1(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    const Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    let Al = $0ce572e7e13c1201$var$BUF[2 * a], Ah = $0ce572e7e13c1201$var$BUF[2 * a + 1]; // prettier-ignore
    let Bl = $0ce572e7e13c1201$var$BUF[2 * b], Bh = $0ce572e7e13c1201$var$BUF[2 * b + 1]; // prettier-ignore
    let Cl = $0ce572e7e13c1201$var$BUF[2 * c], Ch = $0ce572e7e13c1201$var$BUF[2 * c + 1]; // prettier-ignore
    let Dl = $0ce572e7e13c1201$var$BUF[2 * d], Dh = $0ce572e7e13c1201$var$BUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    let ll = $669e2d936b3f5daf$exports.default.add3L(Al, Bl, Xl);
    Ah = $669e2d936b3f5daf$exports.default.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    // v[d] = rotr(v[d] ^ v[a], 32)
    ({ Dh: Dh, Dl: Dl } = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    });
    ({ Dh: Dh, Dl: Dl } = {
        Dh: $669e2d936b3f5daf$exports.default.rotr32H(Dh, Dl),
        Dl: $669e2d936b3f5daf$exports.default.rotr32L(Dh, Dl)
    });
    // v[c] = (v[c] + v[d]) | 0;
    ({ h: Ch, l: Cl } = $669e2d936b3f5daf$exports.default.add(Ch, Cl, Dh, Dl));
    // v[b] = rotr(v[b] ^ v[c], 24)
    ({ Bh: Bh, Bl: Bl } = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    });
    ({ Bh: Bh, Bl: Bl } = {
        Bh: $669e2d936b3f5daf$exports.default.rotrSH(Bh, Bl, 24),
        Bl: $669e2d936b3f5daf$exports.default.rotrSL(Bh, Bl, 24)
    });
    $0ce572e7e13c1201$var$BUF[2 * a] = Al, $0ce572e7e13c1201$var$BUF[2 * a + 1] = Ah;
    $0ce572e7e13c1201$var$BUF[2 * b] = Bl, $0ce572e7e13c1201$var$BUF[2 * b + 1] = Bh;
    $0ce572e7e13c1201$var$BUF[2 * c] = Cl, $0ce572e7e13c1201$var$BUF[2 * c + 1] = Ch;
    $0ce572e7e13c1201$var$BUF[2 * d] = Dl, $0ce572e7e13c1201$var$BUF[2 * d + 1] = Dh;
}
function $0ce572e7e13c1201$var$G2(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    const Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    let Al = $0ce572e7e13c1201$var$BUF[2 * a], Ah = $0ce572e7e13c1201$var$BUF[2 * a + 1]; // prettier-ignore
    let Bl = $0ce572e7e13c1201$var$BUF[2 * b], Bh = $0ce572e7e13c1201$var$BUF[2 * b + 1]; // prettier-ignore
    let Cl = $0ce572e7e13c1201$var$BUF[2 * c], Ch = $0ce572e7e13c1201$var$BUF[2 * c + 1]; // prettier-ignore
    let Dl = $0ce572e7e13c1201$var$BUF[2 * d], Dh = $0ce572e7e13c1201$var$BUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    let ll = $669e2d936b3f5daf$exports.default.add3L(Al, Bl, Xl);
    Ah = $669e2d936b3f5daf$exports.default.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    // v[d] = rotr(v[d] ^ v[a], 16)
    ({ Dh: Dh, Dl: Dl } = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    });
    ({ Dh: Dh, Dl: Dl } = {
        Dh: $669e2d936b3f5daf$exports.default.rotrSH(Dh, Dl, 16),
        Dl: $669e2d936b3f5daf$exports.default.rotrSL(Dh, Dl, 16)
    });
    // v[c] = (v[c] + v[d]) | 0;
    ({ h: Ch, l: Cl } = $669e2d936b3f5daf$exports.default.add(Ch, Cl, Dh, Dl));
    // v[b] = rotr(v[b] ^ v[c], 63)
    ({ Bh: Bh, Bl: Bl } = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    });
    ({ Bh: Bh, Bl: Bl } = {
        Bh: $669e2d936b3f5daf$exports.default.rotrBH(Bh, Bl, 63),
        Bl: $669e2d936b3f5daf$exports.default.rotrBL(Bh, Bl, 63)
    });
    $0ce572e7e13c1201$var$BUF[2 * a] = Al, $0ce572e7e13c1201$var$BUF[2 * a + 1] = Ah;
    $0ce572e7e13c1201$var$BUF[2 * b] = Bl, $0ce572e7e13c1201$var$BUF[2 * b + 1] = Bh;
    $0ce572e7e13c1201$var$BUF[2 * c] = Cl, $0ce572e7e13c1201$var$BUF[2 * c + 1] = Ch;
    $0ce572e7e13c1201$var$BUF[2 * d] = Dl, $0ce572e7e13c1201$var$BUF[2 * d + 1] = Dh;
}
class $0ce572e7e13c1201$var$BLAKE2b extends $86027254dff81a9e$exports.BLAKE2 {
    constructor(opts = {}){
        super(128, opts.dkLen === undefined ? 64 : opts.dkLen, opts, 64, 16, 16);
        // Same as SHA-512, but LE
        this.v0l = $0ce572e7e13c1201$var$IV[0] | 0;
        this.v0h = $0ce572e7e13c1201$var$IV[1] | 0;
        this.v1l = $0ce572e7e13c1201$var$IV[2] | 0;
        this.v1h = $0ce572e7e13c1201$var$IV[3] | 0;
        this.v2l = $0ce572e7e13c1201$var$IV[4] | 0;
        this.v2h = $0ce572e7e13c1201$var$IV[5] | 0;
        this.v3l = $0ce572e7e13c1201$var$IV[6] | 0;
        this.v3h = $0ce572e7e13c1201$var$IV[7] | 0;
        this.v4l = $0ce572e7e13c1201$var$IV[8] | 0;
        this.v4h = $0ce572e7e13c1201$var$IV[9] | 0;
        this.v5l = $0ce572e7e13c1201$var$IV[10] | 0;
        this.v5h = $0ce572e7e13c1201$var$IV[11] | 0;
        this.v6l = $0ce572e7e13c1201$var$IV[12] | 0;
        this.v6h = $0ce572e7e13c1201$var$IV[13] | 0;
        this.v7l = $0ce572e7e13c1201$var$IV[14] | 0;
        this.v7h = $0ce572e7e13c1201$var$IV[15] | 0;
        const keyLength = opts.key ? opts.key.length : 0;
        this.v0l ^= this.outputLen | keyLength << 8 | 16842752;
        if (opts.salt) {
            const salt = (0, $6d0c3b6cb2431a8d$exports.u32)((0, $6d0c3b6cb2431a8d$exports.toBytes)(opts.salt));
            this.v4l ^= salt[0];
            this.v4h ^= salt[1];
            this.v5l ^= salt[2];
            this.v5h ^= salt[3];
        }
        if (opts.personalization) {
            const pers = (0, $6d0c3b6cb2431a8d$exports.u32)((0, $6d0c3b6cb2431a8d$exports.toBytes)(opts.personalization));
            this.v6l ^= pers[0];
            this.v6h ^= pers[1];
            this.v7l ^= pers[2];
            this.v7h ^= pers[3];
        }
        if (opts.key) {
            // Pad to blockLen and update
            const tmp = new Uint8Array(this.blockLen);
            tmp.set((0, $6d0c3b6cb2431a8d$exports.toBytes)(opts.key));
            this.update(tmp);
        }
    }
    // prettier-ignore
    get() {
        let { v0l: v0l, v0h: v0h, v1l: v1l, v1h: v1h, v2l: v2l, v2h: v2h, v3l: v3l, v3h: v3h, v4l: v4l, v4h: v4h, v5l: v5l, v5h: v5h, v6l: v6l, v6h: v6h, v7l: v7l, v7h: v7h } = this;
        return [
            v0l,
            v0h,
            v1l,
            v1h,
            v2l,
            v2h,
            v3l,
            v3h,
            v4l,
            v4h,
            v5l,
            v5h,
            v6l,
            v6h,
            v7l,
            v7h
        ];
    }
    // prettier-ignore
    set(v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h) {
        this.v0l = v0l | 0;
        this.v0h = v0h | 0;
        this.v1l = v1l | 0;
        this.v1h = v1h | 0;
        this.v2l = v2l | 0;
        this.v2h = v2h | 0;
        this.v3l = v3l | 0;
        this.v3h = v3h | 0;
        this.v4l = v4l | 0;
        this.v4h = v4h | 0;
        this.v5l = v5l | 0;
        this.v5h = v5h | 0;
        this.v6l = v6l | 0;
        this.v6h = v6h | 0;
        this.v7l = v7l | 0;
        this.v7h = v7h | 0;
    }
    compress(msg, offset, isLast) {
        this.get().forEach((v, i)=>$0ce572e7e13c1201$var$BUF[i] = v); // First half from state.
        $0ce572e7e13c1201$var$BUF.set($0ce572e7e13c1201$var$IV, 16); // Second half from IV.
        let { h: h, l: l } = $669e2d936b3f5daf$exports.default.fromBig(BigInt(this.length));
        $0ce572e7e13c1201$var$BUF[24] = $0ce572e7e13c1201$var$IV[8] ^ l; // Low word of the offset.
        $0ce572e7e13c1201$var$BUF[25] = $0ce572e7e13c1201$var$IV[9] ^ h; // High word.
        // Invert all bits for last block
        if (isLast) {
            $0ce572e7e13c1201$var$BUF[28] = ~$0ce572e7e13c1201$var$BUF[28];
            $0ce572e7e13c1201$var$BUF[29] = ~$0ce572e7e13c1201$var$BUF[29];
        }
        let j = 0;
        const s = $86027254dff81a9e$exports.SIGMA;
        for(let i = 0; i < 12; i++){
            $0ce572e7e13c1201$var$G1(0, 4, 8, 12, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(0, 4, 8, 12, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(1, 5, 9, 13, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(1, 5, 9, 13, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(2, 6, 10, 14, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(2, 6, 10, 14, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(3, 7, 11, 15, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(3, 7, 11, 15, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(0, 5, 10, 15, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(0, 5, 10, 15, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(1, 6, 11, 12, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(1, 6, 11, 12, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(2, 7, 8, 13, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(2, 7, 8, 13, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G1(3, 4, 9, 14, msg, offset + 2 * s[j++]);
            $0ce572e7e13c1201$var$G2(3, 4, 9, 14, msg, offset + 2 * s[j++]);
        }
        this.v0l ^= $0ce572e7e13c1201$var$BUF[0] ^ $0ce572e7e13c1201$var$BUF[16];
        this.v0h ^= $0ce572e7e13c1201$var$BUF[1] ^ $0ce572e7e13c1201$var$BUF[17];
        this.v1l ^= $0ce572e7e13c1201$var$BUF[2] ^ $0ce572e7e13c1201$var$BUF[18];
        this.v1h ^= $0ce572e7e13c1201$var$BUF[3] ^ $0ce572e7e13c1201$var$BUF[19];
        this.v2l ^= $0ce572e7e13c1201$var$BUF[4] ^ $0ce572e7e13c1201$var$BUF[20];
        this.v2h ^= $0ce572e7e13c1201$var$BUF[5] ^ $0ce572e7e13c1201$var$BUF[21];
        this.v3l ^= $0ce572e7e13c1201$var$BUF[6] ^ $0ce572e7e13c1201$var$BUF[22];
        this.v3h ^= $0ce572e7e13c1201$var$BUF[7] ^ $0ce572e7e13c1201$var$BUF[23];
        this.v4l ^= $0ce572e7e13c1201$var$BUF[8] ^ $0ce572e7e13c1201$var$BUF[24];
        this.v4h ^= $0ce572e7e13c1201$var$BUF[9] ^ $0ce572e7e13c1201$var$BUF[25];
        this.v5l ^= $0ce572e7e13c1201$var$BUF[10] ^ $0ce572e7e13c1201$var$BUF[26];
        this.v5h ^= $0ce572e7e13c1201$var$BUF[11] ^ $0ce572e7e13c1201$var$BUF[27];
        this.v6l ^= $0ce572e7e13c1201$var$BUF[12] ^ $0ce572e7e13c1201$var$BUF[28];
        this.v6h ^= $0ce572e7e13c1201$var$BUF[13] ^ $0ce572e7e13c1201$var$BUF[29];
        this.v7l ^= $0ce572e7e13c1201$var$BUF[14] ^ $0ce572e7e13c1201$var$BUF[30];
        this.v7h ^= $0ce572e7e13c1201$var$BUF[15] ^ $0ce572e7e13c1201$var$BUF[31];
        $0ce572e7e13c1201$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer32.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
/**
 * BLAKE2b - optimized for 64-bit platforms. JS doesn't have uint64, so it's slower than BLAKE2s.
 * @param msg - message that would be hashed
 * @param opts - dkLen, key, salt, personalization
 */ $0ce572e7e13c1201$exports.blake2b = (0, $6d0c3b6cb2431a8d$exports.wrapConstructorWithOpts)((opts)=>new $0ce572e7e13c1201$var$BLAKE2b(opts));




var $0e2427ea2996a6ef$exports = {};
"use strict";
Object.defineProperty($0e2427ea2996a6ef$exports, "__esModule", {
    value: true
});
$0e2427ea2996a6ef$exports.getRandomValues = $0e2427ea2996a6ef$exports.crypto = $0e2427ea2996a6ef$exports.packageInfo = void 0;

var $6f2964376833548c$exports = {};
var $6f2964376833548c$var$__dirname = "node_modules/@polkadot/x-randomvalues/cjs";
"use strict";
Object.defineProperty($6f2964376833548c$exports, "__esModule", {
    value: true
});
$6f2964376833548c$exports.packageInfo = void 0;
$6f2964376833548c$exports.packageInfo = {
    name: "@polkadot/x-randomvalues",
    path: typeof $6f2964376833548c$var$__dirname === "string" ? $6f2964376833548c$var$__dirname : "auto",
    type: "cjs",
    version: "12.3.2"
};


Object.defineProperty($0e2427ea2996a6ef$exports, "packageInfo", {
    enumerable: true,
    get: function() {
        return $6f2964376833548c$exports.packageInfo;
    }
});
$0e2427ea2996a6ef$exports.crypto = $9ce44c51a85397c6$export$51e5d554977815ce.crypto;
function $0e2427ea2996a6ef$var$getRandomValues(arr) {
    return $0e2427ea2996a6ef$exports.crypto.getRandomValues(arr);
}
$0e2427ea2996a6ef$exports.getRandomValues = $0e2427ea2996a6ef$var$getRandomValues;


const $ddf6bbfadfd357b1$var$DEFAULT_CRYPTO = {
    getRandomValues: $0e2427ea2996a6ef$exports.getRandomValues
};
const $ddf6bbfadfd357b1$var$DEFAULT_SELF = {
    crypto: $ddf6bbfadfd357b1$var$DEFAULT_CRYPTO
};
class $ddf6bbfadfd357b1$export$693f291ec5550032 {
    constructor(bridge){
        /** @internal */ this.abort = ()=>{
            throw new Error("abort");
        };
        /** @internal */ this.__wbindgen_is_undefined = (idx)=>{
            return this.__internal__bridge.getObject(idx) === undefined;
        };
        /** @internal */ this.__wbindgen_throw = (ptr, len)=>{
            throw new Error(this.__internal__bridge.getString(ptr, len));
        };
        /** @internal */ this.__wbg_self_1b7a39e3a92c949c = ()=>{
            return this.__internal__bridge.addObject($ddf6bbfadfd357b1$var$DEFAULT_SELF);
        };
        /** @internal */ this.__wbg_require_604837428532a733 = (ptr, len)=>{
            throw new Error(`Unable to require ${this.__internal__bridge.getString(ptr, len)}`);
        };
        /** @internal */ this.__wbg_crypto_968f1772287e2df0 = (_idx)=>{
            return this.__internal__bridge.addObject($ddf6bbfadfd357b1$var$DEFAULT_CRYPTO);
        };
        /** @internal */ this.__wbg_getRandomValues_a3d34b4fee3c2869 = (_idx)=>{
            return this.__internal__bridge.addObject($ddf6bbfadfd357b1$var$DEFAULT_CRYPTO.getRandomValues);
        };
        /** @internal */ this.__wbg_getRandomValues_f5e14ab7ac8e995d = (_arg0, ptr, len)=>{
            $ddf6bbfadfd357b1$var$DEFAULT_CRYPTO.getRandomValues(this.__internal__bridge.getU8a(ptr, len));
        };
        /** @internal */ this.__wbg_randomFillSync_d5bd2d655fdf256a = (_idx, _ptr, _len)=>{
            throw new Error("randomFillsync is not available");
        // getObject(idx).randomFillSync(getU8a(ptr, len));
        };
        /** @internal */ this.__wbindgen_object_drop_ref = (idx)=>{
            this.__internal__bridge.takeObject(idx);
        };
        this.__internal__bridge = bridge;
    }
}


class $e2bd9cca8d80362c$export$68a44d00957434e6 {
    constructor(createWasm){
        this.__internal__createWasm = createWasm;
        this.__internal__cachegetInt32 = null;
        this.__internal__cachegetUint8 = null;
        this.__internal__heap = new Array(32).fill(undefined).concat(undefined, null, true, false);
        this.__internal__heapNext = this.__internal__heap.length;
        this.__internal__type = "none";
        this.__internal__wasm = null;
        this.__internal__wasmError = null;
        this.__internal__wasmPromise = null;
        this.__internal__wbg = {
            ...new (0, $ddf6bbfadfd357b1$export$693f291ec5550032)(this)
        };
    }
    /** @description Returns the init error */ get error() {
        return this.__internal__wasmError;
    }
    /** @description Returns the init type */ get type() {
        return this.__internal__type;
    }
    /** @description Returns the created wasm interface */ get wasm() {
        return this.__internal__wasm;
    }
    /** @description Performs the wasm initialization */ async init(createWasm) {
        if (!this.__internal__wasmPromise || createWasm) this.__internal__wasmPromise = (createWasm || this.__internal__createWasm)(this.__internal__wbg);
        const { error: error, type: type, wasm: wasm } = await this.__internal__wasmPromise;
        this.__internal__type = type;
        this.__internal__wasm = wasm;
        this.__internal__wasmError = error;
        return this.__internal__wasm;
    }
    /**
     * @internal
     * @description Gets an object from the heap
     */ getObject(idx) {
        return this.__internal__heap[idx];
    }
    /**
     * @internal
     * @description Removes an object from the heap
     */ dropObject(idx) {
        if (idx < 36) return;
        this.__internal__heap[idx] = this.__internal__heapNext;
        this.__internal__heapNext = idx;
    }
    /**
     * @internal
     * @description Retrieves and removes an object to the heap
     */ takeObject(idx) {
        const ret = this.getObject(idx);
        this.dropObject(idx);
        return ret;
    }
    /**
     * @internal
     * @description Adds an object to the heap
     */ addObject(obj) {
        if (this.__internal__heapNext === this.__internal__heap.length) this.__internal__heap.push(this.__internal__heap.length + 1);
        const idx = this.__internal__heapNext;
        this.__internal__heapNext = this.__internal__heap[idx];
        this.__internal__heap[idx] = obj;
        return idx;
    }
    /**
     * @internal
     * @description Retrieve an Int32 in the WASM interface
     */ getInt32() {
        if (this.__internal__cachegetInt32 === null || this.__internal__cachegetInt32.buffer !== this.__internal__wasm.memory.buffer) this.__internal__cachegetInt32 = new Int32Array(this.__internal__wasm.memory.buffer);
        return this.__internal__cachegetInt32;
    }
    /**
     * @internal
     * @description Retrieve an Uint8Array in the WASM interface
     */ getUint8() {
        if (this.__internal__cachegetUint8 === null || this.__internal__cachegetUint8.buffer !== this.__internal__wasm.memory.buffer) this.__internal__cachegetUint8 = new Uint8Array(this.__internal__wasm.memory.buffer);
        return this.__internal__cachegetUint8;
    }
    /**
     * @internal
     * @description Retrieves an Uint8Array in the WASM interface
     */ getU8a(ptr, len) {
        return this.getUint8().subarray(ptr / 1, ptr / 1 + len);
    }
    /**
     * @internal
     * @description Retrieves a string in the WASM interface
     */ getString(ptr, len) {
        return (0, $20f3a615a221edb7$export$792464756f58046b)(this.getU8a(ptr, len));
    }
    /**
     * @internal
     * @description Allocates an Uint8Array in the WASM interface
     */ allocU8a(arg) {
        const ptr = this.__internal__wasm.__wbindgen_malloc(arg.length * 1);
        this.getUint8().set(arg, ptr / 1);
        return [
            ptr,
            arg.length
        ];
    }
    /**
     * @internal
     * @description Allocates a string in the WASM interface
     */ allocString(arg) {
        return this.allocU8a((0, $1b66c29e6169cf04$export$e66335b9b1239eaf)(arg));
    }
    /**
     * @internal
     * @description Retrieves an Uint8Array from the WASM interface
     */ resultU8a() {
        const r0 = this.getInt32()[2];
        const r1 = this.getInt32()[3];
        const ret = this.getU8a(r0, r1).slice();
        this.__internal__wasm.__wbindgen_free(r0, r1 * 1);
        return ret;
    }
    /**
     * @internal
     * @description Retrieve a string from the WASM interface
     */ resultString() {
        return (0, $20f3a615a221edb7$export$792464756f58046b)(this.resultU8a());
    }
}


var $30ed248d5de1d50b$exports = {};
"use strict";
Object.defineProperty($30ed248d5de1d50b$exports, "__esModule", {
    value: true
});
$30ed248d5de1d50b$exports.createWasm = $30ed248d5de1d50b$exports.packageInfo = void 0;
/**
 * @name createWasmFn
 * @description
 * Create a WASM (or ASM.js) creator interface based on the supplied information.
 *
 * It will attempt to create a WASM interface first and if this fails or is not available in
 * the environment, will fallback to attempting to create an ASM.js interface.
 */ function $f804476bd8e94d0c$export$ab75dab3a3328cb0(root, wasmBytes, asmFn) {
    return async (wbg)=>{
        const result = {
            error: null,
            type: "none",
            wasm: null
        };
        try {
            if (!wasmBytes || !wasmBytes.length) throw new Error("No WebAssembly provided for initialization");
            else if (typeof WebAssembly !== "object" || typeof WebAssembly.instantiate !== "function") throw new Error("WebAssembly is not available in your environment");
            const source = await WebAssembly.instantiate(wasmBytes, {
                wbg: wbg
            });
            result.wasm = source.instance.exports;
            result.type = "wasm";
        } catch (error) {
            // if we have a valid supplied asm.js, return that
            if (typeof asmFn === "function") {
                result.wasm = asmFn(wbg);
                result.type = "asm";
            } else {
                result.error = `FATAL: Unable to initialize @polkadot/wasm-${root}:: ${error.message}`;
                console.error(result.error);
            }
        }
        return result;
    };
}


const $e748fe3aeddcb310$var$chr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $e748fe3aeddcb310$var$map = new Array(256);
for(let i = 0, count = $e748fe3aeddcb310$var$chr.length; i < count; i++)$e748fe3aeddcb310$var$map[$e748fe3aeddcb310$var$chr.charCodeAt(i)] = i;
function $e748fe3aeddcb310$export$c62426fdd000a97e(data, out) {
    let byte = 0;
    let bits = 0;
    let pos = -1;
    for(let i = 0, count = out.length; pos < count; i++){
        // each character represents 6 bits
        byte = byte << 6 | $e748fe3aeddcb310$var$map[data.charCodeAt(i)];
        // each byte needs to contain 8 bits
        if ((bits += 6) >= 8) out[++pos] = byte >>> (bits -= 8) & 0xff;
    }
    return out;
}

const $c8bac1be8e624e04$var$u8 = Uint8Array, $c8bac1be8e624e04$var$u16 = Uint16Array, $c8bac1be8e624e04$var$u32 = Uint32Array;
const $c8bac1be8e624e04$var$clim = new $c8bac1be8e624e04$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
const $c8bac1be8e624e04$var$fleb = new $c8bac1be8e624e04$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
const $c8bac1be8e624e04$var$fdeb = new $c8bac1be8e624e04$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
const $c8bac1be8e624e04$var$freb = (eb, start)=>{
    const b = new $c8bac1be8e624e04$var$u16(31);
    for(let i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    const r = new $c8bac1be8e624e04$var$u32(b[30]);
    for(let i = 1; i < 30; ++i)for(let j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
const [$c8bac1be8e624e04$var$fl, $c8bac1be8e624e04$var$revfl] = $c8bac1be8e624e04$var$freb($c8bac1be8e624e04$var$fleb, 2);
$c8bac1be8e624e04$var$fl[28] = 258, $c8bac1be8e624e04$var$revfl[258] = 28;
const [$c8bac1be8e624e04$var$fd] = $c8bac1be8e624e04$var$freb($c8bac1be8e624e04$var$fdeb, 0);
const $c8bac1be8e624e04$var$rev = new $c8bac1be8e624e04$var$u16(32768);
for(let i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    let x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    $c8bac1be8e624e04$var$rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
const $c8bac1be8e624e04$var$hMap = (cd, mb, r)=>{
    const s = cd.length;
    // index
    let i = 0;
    // u16 "map": index -> # of codes with bit length = index
    const l = new $c8bac1be8e624e04$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    const le = new $c8bac1be8e624e04$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    let co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $c8bac1be8e624e04$var$u16(1 << mb);
        // bits to remove for reverser
        const rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            const sv = i << 4 | cd[i];
            // free bits
            const r = mb - cd[i];
            // start value
            let v = le[cd[i] - 1]++ << r;
            // m is end value
            for(const m = v | (1 << r) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$c8bac1be8e624e04$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $c8bac1be8e624e04$var$u16(s);
        for(i = 0; i < s; ++i)co[i] = $c8bac1be8e624e04$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
const $c8bac1be8e624e04$var$flt = new $c8bac1be8e624e04$var$u8(288);
for(let i = 0; i < 144; ++i)$c8bac1be8e624e04$var$flt[i] = 8;
for(let i = 144; i < 256; ++i)$c8bac1be8e624e04$var$flt[i] = 9;
for(let i = 256; i < 280; ++i)$c8bac1be8e624e04$var$flt[i] = 7;
for(let i = 280; i < 288; ++i)$c8bac1be8e624e04$var$flt[i] = 8;
const $c8bac1be8e624e04$var$fdt = new $c8bac1be8e624e04$var$u8(32);
for(let i = 0; i < 32; ++i)$c8bac1be8e624e04$var$fdt[i] = 5;
const $c8bac1be8e624e04$var$flrm = $c8bac1be8e624e04$var$hMap($c8bac1be8e624e04$var$flt, 9, 1);
const $c8bac1be8e624e04$var$fdrm = $c8bac1be8e624e04$var$hMap($c8bac1be8e624e04$var$fdt, 5, 1);
const $c8bac1be8e624e04$var$bits = (d, p, m)=>{
    const o = p >>> 3;
    return (d[o] | d[o + 1] << 8) >>> (p & 7) & m;
};
const $c8bac1be8e624e04$var$bits16 = (d, p)=>{
    const o = p >>> 3;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >>> (p & 7);
};
const $c8bac1be8e624e04$var$shft = (p)=>(p >>> 3) + (p & 7 && 1);
const $c8bac1be8e624e04$var$slc = (v, s, e)=>{
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    const n = new (v instanceof $c8bac1be8e624e04$var$u16 ? $c8bac1be8e624e04$var$u16 : v instanceof $c8bac1be8e624e04$var$u32 ? $c8bac1be8e624e04$var$u32 : $c8bac1be8e624e04$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
const $c8bac1be8e624e04$var$max = (a)=>{
    let m = a[0];
    for(let i = 1, count = a.length; i < count; ++i)if (a[i] > m) m = a[i];
    return m;
};
const $c8bac1be8e624e04$var$inflt = (dat, buf, st)=>{
    const noSt = !st || st.i;
    if (!st) st = {};
    // source length
    const sl = dat.length;
    // have to estimate size
    const noBuf = !buf || !noSt;
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $c8bac1be8e624e04$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    const cbuf = (l)=>{
        let bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            const nbuf = new $c8bac1be8e624e04$var$u8(Math.max(bl << 1, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    let final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    if (final && !lm) return buf;
    // total bits
    const tbts = sl << 3;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $c8bac1be8e624e04$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            const type = $c8bac1be8e624e04$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                const s = $c8bac1be8e624e04$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw "unexpected EOF";
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t << 3;
                continue;
            } else if (type == 1) lm = $c8bac1be8e624e04$var$flrm, dm = $c8bac1be8e624e04$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                const hLit = $c8bac1be8e624e04$var$bits(dat, pos, 31) + 257, hcLen = $c8bac1be8e624e04$var$bits(dat, pos + 10, 15) + 4;
                const tl = hLit + $c8bac1be8e624e04$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                const ldt = new $c8bac1be8e624e04$var$u8(tl);
                // code length tree
                const clt = new $c8bac1be8e624e04$var$u8(19);
                for(let i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$c8bac1be8e624e04$var$clim[i]] = $c8bac1be8e624e04$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                const clb = $c8bac1be8e624e04$var$max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break;
                // code lengths map
                const clm = $c8bac1be8e624e04$var$hMap(clt, clb, 1);
                for(let i = 0; i < tl;){
                    const r = clm[$c8bac1be8e624e04$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    const s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        let c = 0, n = 0;
                        if (s == 16) n = 3 + $c8bac1be8e624e04$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $c8bac1be8e624e04$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $c8bac1be8e624e04$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                const lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $c8bac1be8e624e04$var$max(lt);
                // max dist bits
                dbt = $c8bac1be8e624e04$var$max(dt);
                lm = $c8bac1be8e624e04$var$hMap(lt, lbt, 1);
                dm = $c8bac1be8e624e04$var$hMap(dt, dbt, 1);
            } else throw "invalid block type";
            if (pos > tbts) throw "unexpected EOF";
        }
        // Make sure the buffer can hold this + the largest possible addition
        // maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        const lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        const mxa = lbt + dbt + 18;
        while(noSt || pos + mxa < tbts){
            // bits read, code
            const c = lm[$c8bac1be8e624e04$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) throw "unexpected EOF";
            if (!c) throw "invalid length/literal";
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = undefined;
                break;
            } else {
                let add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    const i = sym - 257, b = $c8bac1be8e624e04$var$fleb[i];
                    add = $c8bac1be8e624e04$var$bits(dat, pos, (1 << b) - 1) + $c8bac1be8e624e04$var$fl[i];
                    pos += b;
                }
                // dist
                const d = dm[$c8bac1be8e624e04$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw "invalid distance";
                pos += d & 15;
                let dt = $c8bac1be8e624e04$var$fd[dsym];
                if (dsym > 3) {
                    const b = $c8bac1be8e624e04$var$fdeb[dsym];
                    dt += $c8bac1be8e624e04$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) throw "unexpected EOF";
                if (noBuf) cbuf(bt + 131072);
                const end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $c8bac1be8e624e04$var$slc(buf, 0, bt);
};
const $c8bac1be8e624e04$var$zlv = (d)=>{
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw "invalid zlib data";
    if (d[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
function $c8bac1be8e624e04$export$9ec8134f0f1b9fc6(data, out) {
    return $c8bac1be8e624e04$var$inflt(($c8bac1be8e624e04$var$zlv(data), data.subarray(2, -4)), out);
}


// Copyright 2019-2023 @polkadot/wasm-crypto-wasm authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Generated as part of the build, do not edit
var $59ac4fce9c37c82d$export$29f14cd5cba2ed09;
var $59ac4fce9c37c82d$export$43f6a8d59c1659dd;
var $59ac4fce9c37c82d$export$b3317979f9250576;
$59ac4fce9c37c82d$export$29f14cd5cba2ed09 = 171005;
$59ac4fce9c37c82d$export$43f6a8d59c1659dd = 339466;
$59ac4fce9c37c82d$export$b3317979f9250576 = "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";



const $b16a8b874515833e$export$871a6229fd6ab771 = /*#__PURE__*/ (0, $c8bac1be8e624e04$export$9ec8134f0f1b9fc6)((0, $e748fe3aeddcb310$export$c62426fdd000a97e)((0, $59ac4fce9c37c82d$export$b3317979f9250576), new Uint8Array((0, $59ac4fce9c37c82d$export$29f14cd5cba2ed09))), new Uint8Array((0, $59ac4fce9c37c82d$export$43f6a8d59c1659dd)));


var $9a4fa0d25dc9bfbb$exports = {};
var $9a4fa0d25dc9bfbb$var$__dirname = "node_modules/@polkadot/wasm-crypto-init/cjs";
"use strict";
Object.defineProperty($9a4fa0d25dc9bfbb$exports, "__esModule", {
    value: true
});
$9a4fa0d25dc9bfbb$exports.packageInfo = void 0;
$9a4fa0d25dc9bfbb$exports.packageInfo = {
    name: "@polkadot/wasm-crypto-init",
    path: typeof $9a4fa0d25dc9bfbb$var$__dirname === "string" ? $9a4fa0d25dc9bfbb$var$__dirname : "auto",
    type: "cjs",
    version: "7.2.1"
};


Object.defineProperty($30ed248d5de1d50b$exports, "packageInfo", {
    enumerable: true,
    get: function() {
        return $9a4fa0d25dc9bfbb$exports.packageInfo;
    }
});
/**
 * @name createWasm
 * @description
 * Creates an interface using only WASM
 */ $30ed248d5de1d50b$exports.createWasm = (0, $f804476bd8e94d0c$export$ab75dab3a3328cb0)("crypto", $b16a8b874515833e$export$871a6229fd6ab771, null);


const $4d086eef88592e84$export$c92f22d3e2ef5f60 = new (0, $e2bd9cca8d80362c$export$68a44d00957434e6)((0, $30ed248d5de1d50b$exports.createWasm));
async function $4d086eef88592e84$export$7c01844c99427400(createWasm) {
    return $4d086eef88592e84$export$c92f22d3e2ef5f60.init(createWasm);
}



/**
 * @internal
 * @description
 * This create an extenal interface function from the signature, all the while checking
 * the actual bridge wasm interface to ensure it has been initialized.
 *
 * This means that we can call it
 *
 *   withWasm(wasm: WasmCryptoInstance, a: number, b: string) => Uint8Array
 *
 * and in this case it will create an interface function with the signarure
 *
 *   (a: number, b: string) => Uint8Array
 */ function $796b0ff58a262a5f$var$withWasm(fn) {
    return (...params)=>{
        if (!(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).wasm) throw new Error("The WASM interface has not been initialized. Ensure that you wait for the initialization Promise with waitReady() from @polkadot/wasm-crypto (or cryptoWaitReady() from @polkadot/util-crypto) before attempting to use WASM-only interfaces.");
        return fn((0, $4d086eef88592e84$export$c92f22d3e2ef5f60).wasm, ...params);
    };
}
const $796b0ff58a262a5f$export$35df27fe5ef13c6a = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, words)=>{
    wasm.ext_bip39_generate(8, words);
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultString();
});
const $796b0ff58a262a5f$export$783f901bc6c03ef8 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, phrase)=>{
    wasm.ext_bip39_to_entropy(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocString(phrase));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$26b92a276f4ce11a = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, phrase, password)=>{
    wasm.ext_bip39_to_mini_secret(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocString(phrase), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocString(password));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$cba58e913ea1e4dd = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, phrase, password)=>{
    wasm.ext_bip39_to_seed(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocString(phrase), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocString(password));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$bc906819c94874c7 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, phrase)=>{
    const ret = wasm.ext_bip39_validate(...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocString(phrase));
    return ret !== 0;
});
const $796b0ff58a262a5f$export$e2c6920639612ea9 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, seed)=>{
    wasm.ext_ed_from_seed(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(seed));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$efeeb32bd0b99991 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey, seckey, message)=>{
    wasm.ext_ed_sign(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(seckey), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(message));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$6318e82db5ba9c5b = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, signature, message, pubkey)=>{
    const ret = wasm.ext_ed_verify(...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(signature), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(message), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey));
    return ret !== 0;
});
const $796b0ff58a262a5f$export$761623c44fdf790 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, seckey)=>{
    wasm.ext_secp_from_seed(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(seckey));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$77e7b9749fd538d7 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey)=>{
    wasm.ext_secp_pub_compress(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$aeb350b8636aeb32 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey)=>{
    wasm.ext_secp_pub_expand(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$b3a14b2e44f710df = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, msgHash, sig, recovery)=>{
    wasm.ext_secp_recover(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(msgHash), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(sig), recovery);
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$ccc409d84129e38e = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, msgHash, seckey)=>{
    wasm.ext_secp_sign(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(msgHash), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(seckey));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$9de1259e4f2cc265 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pair, cc)=>{
    wasm.ext_sr_derive_keypair_hard(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pair), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(cc));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$f7969b889341848e = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pair, cc)=>{
    wasm.ext_sr_derive_keypair_soft(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pair), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(cc));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$c258d6ece124c84d = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey, cc)=>{
    wasm.ext_sr_derive_public_soft(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(cc));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$9cb94d9e1f85177c = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, seed)=>{
    wasm.ext_sr_from_seed(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(seed));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$a0daa256430739d5 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey, secret, message)=>{
    wasm.ext_sr_sign(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(secret), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(message));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$66054820ad7c0da7 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, signature, message, pubkey)=>{
    const ret = wasm.ext_sr_verify(...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(signature), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(message), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey));
    return ret !== 0;
});
const $796b0ff58a262a5f$export$ff5b3d47a1e4fb35 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey, secret)=>{
    wasm.ext_sr_agree(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(secret));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$abd7916afb7ee599 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, secret, context, message, extra)=>{
    wasm.ext_vrf_sign(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(secret), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(context), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(message), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(extra));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$994b32edcaf9ff72 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, pubkey, context, message, extra, outAndProof)=>{
    const ret = wasm.ext_vrf_verify(...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(pubkey), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(context), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(message), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(extra), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(outAndProof));
    return ret !== 0;
});
const $796b0ff58a262a5f$export$31406b37573ddf7 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data, key, size)=>{
    wasm.ext_blake2b(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(key), size);
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$8cb906c207500861 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, key, data)=>{
    wasm.ext_hmac_sha256(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(key), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$2fa9719a63596dff = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, key, data)=>{
    wasm.ext_hmac_sha512(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(key), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$f8151fce47ad1c35 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data)=>{
    wasm.ext_keccak256(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$e432dfb0f2f2942f = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data)=>{
    wasm.ext_keccak512(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$448fa22aedc9dbca = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data, salt, rounds)=>{
    wasm.ext_pbkdf2(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(salt), rounds);
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$7cf7c2f1ec457bf3 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, password, salt, log2n, r, p)=>{
    wasm.ext_scrypt(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(password), ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(salt), log2n, r, p);
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$bced8d2aada2d1c9 = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data)=>{
    wasm.ext_sha256(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$a888d2532e6dc7bb = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data)=>{
    wasm.ext_sha512(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data));
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
const $796b0ff58a262a5f$export$efade200b728510d = /*#__PURE__*/ $796b0ff58a262a5f$var$withWasm((wasm, data, rounds)=>{
    wasm.ext_twox(8, ...(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).allocU8a(data), rounds);
    return (0, $4d086eef88592e84$export$c92f22d3e2ef5f60).resultU8a();
});
function $796b0ff58a262a5f$export$af3c031fde264cc6() {
    return !!(0, $4d086eef88592e84$export$c92f22d3e2ef5f60).wasm;
}
async function $796b0ff58a262a5f$export$6975dd8173b81e43() {
    try {
        const wasm = await (0, $4d086eef88592e84$export$7c01844c99427400)();
        return !!wasm;
    } catch  {
        return false;
    }
}




function $84be3e8f12e6d11c$export$6e489b4cfdd62721(fn) {
    return (...args)=>(0, $1e2cfad286c009ca$export$4429d284633899e1)(fn(...args));
}
function $84be3e8f12e6d11c$export$6d7551883ed6dc0f(bitLength, fn) {
    return (data, onlyJs)=>fn(data, bitLength, onlyJs);
}
function $84be3e8f12e6d11c$export$1b8e7c173b6f2602(wa, js) {
    return (value, bitLength = 256, onlyJs)=>{
        const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
        return !(0, $6574c8753d85e60c$export$c50f41259082745b) || !onlyJs && (0, $796b0ff58a262a5f$export$af3c031fde264cc6)() ? wa[bitLength](u8a) : js[bitLength](u8a);
    };
}


function $dcbcf4e1d1853689$export$5faebd53a9e0f952(data, bitLength = 256, key, onlyJs) {
    const byteLength = Math.ceil(bitLength / 8);
    const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(data);
    return !(0, $6574c8753d85e60c$export$c50f41259082745b) || !onlyJs && (0, $796b0ff58a262a5f$export$af3c031fde264cc6)() ? (0, $796b0ff58a262a5f$export$31406b37573ddf7)(u8a, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(key), byteLength) : key ? (0, $0ce572e7e13c1201$exports.blake2b)(u8a, {
        dkLen: byteLength,
        key: key
    }) : (0, $0ce572e7e13c1201$exports.blake2b)(u8a, {
        dkLen: byteLength
    });
}
const $dcbcf4e1d1853689$export$808fb830d95da849 = /*#__PURE__*/ (0, $84be3e8f12e6d11c$export$6e489b4cfdd62721)($dcbcf4e1d1853689$export$5faebd53a9e0f952);



const $f41cf2e52d4d9a11$export$adc3ae7f2f41c864 = {
    extrinsic: {},
    payload: {}
};


const $06940dafd5828ccf$export$61524193c9526769 = {
    LimitParathreadCommits: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    OnlyStakingAndClaims: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    PrevalidateAttests: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    RestrictFunctionality: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    TransactionCallFilter: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    ValidateDoubleVoteReports: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864)
};



const $5583e0d8623bb042$export$44fee94982b0184 = {
    DisallowSigned: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864)
};


const $794571414d824a77$export$90af24bfca50c24c = {
    ChargeAssetTxPayment: {
        extrinsic: {
            tip: "Compact<Balance>",
            // eslint-disable-next-line sort-keys
            assetId: "Option<AssetId>"
        },
        payload: {}
    }
};



const $f06cc4bf99d5f92b$var$CheckMortality = {
    extrinsic: {
        era: "ExtrinsicEra"
    },
    payload: {
        blockHash: "Hash"
    }
};
const $f06cc4bf99d5f92b$export$a289ad6c54e4c830 = {
    ChargeTransactionPayment: {
        extrinsic: {
            tip: "Compact<Balance>"
        },
        payload: {}
    },
    CheckBlockGasLimit: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    CheckEra: $f06cc4bf99d5f92b$var$CheckMortality,
    CheckGenesis: {
        extrinsic: {},
        payload: {
            genesisHash: "Hash"
        }
    },
    CheckMortality: $f06cc4bf99d5f92b$var$CheckMortality,
    CheckNonZeroSender: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    CheckNonce: {
        extrinsic: {
            nonce: "Compact<Index>"
        },
        payload: {}
    },
    CheckSpecVersion: {
        extrinsic: {},
        payload: {
            specVersion: "u32"
        }
    },
    CheckTxVersion: {
        extrinsic: {},
        payload: {
            transactionVersion: "u32"
        }
    },
    CheckVersion: {
        extrinsic: {},
        payload: {
            specVersion: "u32"
        }
    },
    CheckWeight: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    LockStakingStatus: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864),
    ValidateEquivocationReport: (0, $f41cf2e52d4d9a11$export$adc3ae7f2f41c864)
};


const $e9af2f5d0b405445$export$da416d2475c4aa03 = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, (0, $f06cc4bf99d5f92b$export$a289ad6c54e4c830), (0, $06940dafd5828ccf$export$61524193c9526769), (0, $5583e0d8623bb042$export$44fee94982b0184), (0, $794571414d824a77$export$90af24bfca50c24c));
const $e9af2f5d0b405445$export$a73f9a83a616a915 = [
    "CheckVersion",
    "CheckGenesis",
    "CheckEra",
    "CheckNonce",
    "CheckWeight",
    "ChargeTransactionPayment",
    "CheckBlockGasLimit"
];
function $e9af2f5d0b405445$export$17157f56eba35ba1(extensions, userExtensions = {}) {
    const names = [
        ...Object.keys($e9af2f5d0b405445$export$da416d2475c4aa03),
        ...Object.keys(userExtensions)
    ];
    return extensions.filter((k)=>!names.includes(k));
}
function $e9af2f5d0b405445$export$c19e5b60d3c5089e(extensions, type, userExtensions = {}) {
    return extensions// Always allow user extensions first - these should provide overrides
    .map((k)=>userExtensions[k] || $e9af2f5d0b405445$export$da416d2475c4aa03[k]).filter((info)=>!!info).reduce((result, info)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(result, info[type]), {});
}




/** @internal */ function $b713657d03724297$var$decodeEvent(registry, value) {
    if (!value || !value.length) return {
        DataType: (0, $cde2b5a819d50097$export$26c9c3a80cd996ae)
    };
    const index = value.subarray(0, 2);
    return {
        DataType: registry.findMetaEvent(index),
        value: {
            data: value.subarray(2),
            index: index
        }
    };
}
class $b713657d03724297$export$1b4b861caf7ac12b extends (0, $3f7ea4d5b3798bbe$export$1908877435b1d5e9) {
    constructor(registry, value, meta, section = "<unknown>", method = "<unknown>"){
        const fields = meta?.fields || [];
        super(registry, fields.map(({ type: type })=>registry.createLookupType(type)), value);
        this.__internal__names = null;
        this.__internal__meta = meta;
        this.__internal__method = method;
        this.__internal__section = section;
        this.__internal__typeDef = fields.map(({ type: type })=>registry.lookup.getTypeDef(type));
        const names = fields.map(({ name: name })=>registry.lookup.sanitizeField(name)[0]).filter((n)=>!!n);
        if (names.length === fields.length) {
            this.__internal__names = names;
            (0, $fb51452ffd615a15$export$4660c3861a213768)(this, names, (_, i)=>this[i]);
        }
    }
    /**
     * @description The wrapped [[EventMetadata]]
     */ get meta() {
        return this.__internal__meta;
    }
    /**
     * @description The method as a string
     */ get method() {
        return this.__internal__method;
    }
    /**
     * @description The field names (as available)
     */ get names() {
        return this.__internal__names;
    }
    /**
     * @description The section as a string
     */ get section() {
        return this.__internal__section;
    }
    /**
     * @description The [[TypeDef]] for this event
     */ get typeDef() {
        return this.__internal__typeDef;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        if (this.__internal__names !== null) {
            const json = {};
            for(let i = 0, count = this.__internal__names.length; i < count; i++)json[this.__internal__names[i]] = this[i].toHuman(isExtended);
            return json;
        }
        return super.toHuman(isExtended);
    }
}
class $b713657d03724297$export$dffc327d80bea855 extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    // Currently we _only_ decode from Uint8Array, since we expect it to
    // be used via EventRecord
    constructor(registry, _value){
        const { DataType: DataType, value: value } = $b713657d03724297$var$decodeEvent(registry, _value);
        super(registry, {
            index: "EventId",
            // eslint-disable-next-line sort-keys
            data: DataType
        }, value);
    }
    /**
     * @description The wrapped [[EventData]]
     */ get data() {
        return this.getT("data");
    }
    /**
     * @description The [[EventId]], identifying the raw event
     */ get index() {
        return this.getT("index");
    }
    /**
     * @description The [[EventMetadata]] with the documentation
     */ get meta() {
        return this.data.meta;
    }
    /**
     * @description The method string identifying the event
     */ get method() {
        return this.data.method;
    }
    /**
     * @description The section string identifying the event
     */ get section() {
        return this.data.section;
    }
    /**
     * @description The [[TypeDef]] for the event
     */ get typeDef() {
        return this.data.typeDef;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExpanded) {
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            method: this.method,
            section: this.section
        }, isExpanded ? {
            docs: this.meta.docs.map((d)=>d.toString())
        } : null, super.toHuman(isExpanded));
    }
}


var $7df5b58966439861$exports = {};
var $406aeba327260154$exports = {};

$parcel$export($406aeba327260154$exports, "GenericExtrinsic", function () { return $b0e4a8b59034fae4$export$84cf34f56e9b2fd5; });
$parcel$export($406aeba327260154$exports, "GenericExtrinsicEra", function () { return $3023dc8aefc86c64$export$5d5cd89b8b0581bb; });
$parcel$export($406aeba327260154$exports, "GenericImmortalEra", function () { return $3023dc8aefc86c64$export$a341e270b1e33716; });
$parcel$export($406aeba327260154$exports, "GenericMortalEra", function () { return $3023dc8aefc86c64$export$d3ded7cc5c8ef901; });
$parcel$export($406aeba327260154$exports, "GenericExtrinsicPayload", function () { return $b207b6a97fc979fb$export$16fcba9f79c8d2cd; });
$parcel$export($406aeba327260154$exports, "GenericExtrinsicPayloadUnknown", function () { return $4f59639b4128bc69$export$16de08536e20f6e; });
$parcel$export($406aeba327260154$exports, "GenericExtrinsicUnknown", function () { return $820d13c385425a18$export$8dfdb1d7f756968d; });
$parcel$export($406aeba327260154$exports, "GenericSignerPayload", function () { return $eee25df9023bcec9$export$7496e86a1dd2214a; });
/**
 * @name Base
 * @description A type extends the Base class, when it holds a value
 */ class $5bac603f88334ac0$export$6d8c589c31247384 {
    constructor(registry, value, initialU8aLength){
        this.initialU8aLength = initialU8aLength;
        this.__internal__raw = value;
        this.registry = registry;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description returns the inner (wrapped value)
     */ get inner() {
        return this.__internal__raw;
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.__internal__raw.isEmpty;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return this.__internal__raw.eq(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return this.__internal__raw.inspect();
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */ toHex(isLe) {
        return this.__internal__raw.toHex(isLe);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        return this.__internal__raw.toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.__internal__raw.toJSON();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.__internal__raw.toPrimitive();
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.__internal__raw.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        return this.__internal__raw.toU8a(isBare);
    }
    /**
     * @description Returns the inner wrapped value (equivalent to valueOf)
     */ unwrap() {
        return this.__internal__raw;
    }
    /**
     * @description Returns the inner wrapped value
     */ valueOf() {
        return this.__internal__raw;
    }
}





const $bb489c6fc97da74a$export$daa69b8b70533cd6 = 4;
class $bb489c6fc97da74a$export$de52b1432b0f98e7 extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value, { isSigned: isSigned } = {}){
        super(registry, {
            signature: "ExtrinsicSignatureV4",
            // eslint-disable-next-line sort-keys
            method: "Call"
        }, $bb489c6fc97da74a$export$de52b1432b0f98e7.decodeExtrinsic(registry, value, isSigned));
    }
    /** @internal */ static decodeExtrinsic(registry, value, isSigned = false) {
        if (value instanceof $bb489c6fc97da74a$export$de52b1432b0f98e7) return value;
        else if (value instanceof registry.createClassUnsafe("Call")) return {
            method: value
        };
        else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) {
            // here we decode manually since we need to pull through the version information
            const signature = registry.createTypeUnsafe("ExtrinsicSignatureV4", [
                value,
                {
                    isSigned: isSigned
                }
            ]);
            const method = registry.createTypeUnsafe("Call", [
                value.subarray(signature.encodedLength)
            ]);
            return {
                method: method,
                signature: signature
            };
        }
        return value || {};
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */ get method() {
        return this.getT("method");
    }
    /**
     * @description The [[ExtrinsicSignatureV4]]
     */ get signature() {
        return this.getT("signature");
    }
    /**
     * @description The version for the signature
     */ get version() {
        return $bb489c6fc97da74a$export$daa69b8b70533cd6;
    }
    /**
     * @description Add an [[ExtrinsicSignatureV4]] to the extrinsic (already generated)
     */ addSignature(signer, signature, payload) {
        this.signature.addSignature(signer, signature, payload);
        return this;
    }
    /**
     * @description Sign the extrinsic with a specific keypair
     */ sign(account, options) {
        this.signature.sign(this.method, account, options);
        return this;
    }
    /**
     * @describe Adds a fake signature to the extrinsic
     */ signFake(signer, options) {
        this.signature.signFake(this.method, signer, options);
        return this;
    }
}


const $3b4cdc47f94d6d49$export$f3c5488c1bb824a9 = 128;
const $3b4cdc47f94d6d49$export$fc0b177a1dd8dd6f = 0;
const $3b4cdc47f94d6d49$export$e36b6dd925dc1ec4 = new Uint8Array();
const $3b4cdc47f94d6d49$export$363ebe89e6e7aeef = 4;
const $3b4cdc47f94d6d49$export$4f5ad2dc5b1538c7 = new Uint8Array([
    0
]);
const $3b4cdc47f94d6d49$export$85ad1b550ea69f4a = 127;


const $b0e4a8b59034fae4$var$VERSIONS = [
    "ExtrinsicUnknown",
    "ExtrinsicUnknown",
    "ExtrinsicUnknown",
    "ExtrinsicUnknown",
    "ExtrinsicV4"
];
/** @internal */ function $b0e4a8b59034fae4$var$newFromValue(registry, value, version) {
    if (value instanceof $b0e4a8b59034fae4$export$84cf34f56e9b2fd5) return value.unwrap();
    const isSigned = (version & (0, $3b4cdc47f94d6d49$export$f3c5488c1bb824a9)) === (0, $3b4cdc47f94d6d49$export$f3c5488c1bb824a9);
    const type = $b0e4a8b59034fae4$var$VERSIONS[version & (0, $3b4cdc47f94d6d49$export$85ad1b550ea69f4a)] || $b0e4a8b59034fae4$var$VERSIONS[0];
    // we cast here since the VERSION definition is incredibly broad - we don't have a
    // slice for "only add extrinsic types", and more string definitions become unwieldy
    return registry.createTypeUnsafe(type, [
        value,
        {
            isSigned: isSigned,
            version: version
        }
    ]);
}
/** @internal */ function $b0e4a8b59034fae4$var$decodeExtrinsic(registry, value, version = (0, $3b4cdc47f94d6d49$export$363ebe89e6e7aeef)) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || Array.isArray(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return $b0e4a8b59034fae4$var$decodeU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), version);
    else if (value instanceof registry.createClassUnsafe("Call")) return $b0e4a8b59034fae4$var$newFromValue(registry, {
        method: value
    }, version);
    return $b0e4a8b59034fae4$var$newFromValue(registry, value, version);
}
/** @internal */ function $b0e4a8b59034fae4$var$decodeU8a(registry, value, version) {
    if (!value.length) return $b0e4a8b59034fae4$var$newFromValue(registry, new Uint8Array(), version);
    const [offset, length] = (0, $f98b10db0f2cd20b$export$78a7c3b36a13df0f)(value);
    const total = offset + length.toNumber();
    if (total > value.length) throw new Error(`Extrinsic: length less than remainder, expected at least ${total}, found ${value.length}`);
    const data = value.subarray(offset, total);
    return $b0e4a8b59034fae4$var$newFromValue(registry, data.subarray(1), data[0]);
}
class $b0e4a8b59034fae4$var$ExtrinsicBase extends (0, $5bac603f88334ac0$export$6d8c589c31247384) {
    constructor(registry, value, initialU8aLength){
        super(registry, value, initialU8aLength);
        const signKeys = Object.keys(registry.getSignedExtensionTypes());
        const getter = (key)=>this.inner.signature[key];
        // This is on the abstract class, ensuring that hasOwnProperty operates
        // correctly, i.e. it needs to be on the base class exposing it
        for(let i = 0, count = signKeys.length; i < count; i++)(0, $fb51452ffd615a15$export$b1dee6b72881b450)(this, signKeys[i], getter);
    }
    /**
     * @description The arguments passed to for the call, exposes args so it is compatible with [[Call]]
     */ get args() {
        return this.method.args;
    }
    /**
     * @description The argument definitions, compatible with [[Call]]
     */ get argsDef() {
        return this.method.argsDef;
    }
    /**
     * @description The actual `[sectionIndex, methodIndex]` as used in the Call
     */ get callIndex() {
        return this.method.callIndex;
    }
    /**
     * @description The actual data for the Call
     */ get data() {
        return this.method.data;
    }
    /**
     * @description The era for this extrinsic
     */ get era() {
        return this.inner.signature.era;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description `true` id the extrinsic is signed
     */ get isSigned() {
        return this.inner.signature.isSigned;
    }
    /**
     * @description The length of the actual data, excluding prefix
     */ get length() {
        return this.toU8a(true).length;
    }
    /**
     * @description The [[FunctionMetadataLatest]] that describes the extrinsic
     */ get meta() {
        return this.method.meta;
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */ get method() {
        return this.inner.method;
    }
    /**
     * @description The nonce for this extrinsic
     */ get nonce() {
        return this.inner.signature.nonce;
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */ get signature() {
        return this.inner.signature.signature;
    }
    /**
     * @description The [[Address]] that signed
     */ get signer() {
        return this.inner.signature.signer;
    }
    /**
     * @description Forwards compat
     */ get tip() {
        return this.inner.signature.tip;
    }
    /**
     * @description Returns the raw transaction version (not flagged with signing information)
    */ get type() {
        return this.inner.version;
    }
    get inner() {
        return this.unwrap();
    }
    /**
     * @description Returns the encoded version flag
    */ get version() {
        return this.type | (this.isSigned ? (0, $3b4cdc47f94d6d49$export$f3c5488c1bb824a9) : (0, $3b4cdc47f94d6d49$export$fc0b177a1dd8dd6f));
    }
    /**
     * @description Checks if the source matches this in type
     */ is(other) {
        return this.method.is(other);
    }
    unwrap() {
        return super.unwrap();
    }
}
/**
 * @name GenericExtrinsic
 * @description
 * Representation of an Extrinsic in the system. It contains the actual call,
 * (optional) signature and encodes with an actual length prefix
 *
 * {@link https://github.com/paritytech/wiki/blob/master/Extrinsic.md#the-extrinsic-format-for-node}.
 *
 * Can be:
 * - signed, to create a transaction
 * - left as is, to create an inherent
 */ class $b0e4a8b59034fae4$export$84cf34f56e9b2fd5 extends $b0e4a8b59034fae4$var$ExtrinsicBase {
    constructor(registry, value, { version: version } = {}){
        super(registry, $b0e4a8b59034fae4$var$decodeExtrinsic(registry, value, version));
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        if (!this.__internal__hashCache) this.__internal__hashCache = super.hash;
        return this.__internal__hashCache;
    }
    /**
     * @description Injects an already-generated signature into the extrinsic
     */ addSignature(signer, signature, payload) {
        this.inner.addSignature(signer, signature, payload);
        this.__internal__hashCache = undefined;
        return this;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        const encoded = (0, $84207d7313fd2c40$export$7b640c40d4922c2e)(...this.toU8aInner());
        return {
            inner: this.isSigned ? this.inner.inspect().inner : this.inner.method.inspect().inner,
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(encoded.length),
                new Uint8Array([
                    this.version
                ])
            ]
        };
    }
    /**
     * @description Sign the extrinsic with a specific keypair
     */ sign(account, options) {
        this.inner.sign(account, options);
        this.__internal__hashCache = undefined;
        return this;
    }
    /**
     * @describe Adds a fake signature to the extrinsic
     */ signFake(signer, options) {
        this.inner.signFake(signer, options);
        this.__internal__hashCache = undefined;
        return this;
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex(isBare) {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a(isBare));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExpanded) {
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, {
            isSigned: this.isSigned,
            method: this.method.toHuman(isExpanded)
        }, this.isSigned ? {
            era: this.era.toHuman(isExpanded),
            nonce: this.nonce.toHuman(isExpanded),
            signature: this.signature.toHex(),
            signer: this.signer.toHuman(isExpanded),
            tip: this.tip.toHuman(isExpanded)
        } : null);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toHex();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Extrinsic";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value is not length-prefixed
     */ toU8a(isBare) {
        const encoded = (0, $84207d7313fd2c40$export$7b640c40d4922c2e)(...this.toU8aInner());
        return isBare ? encoded : (0, $7c076f10c5650efd$export$54cb8b08f590bc42)(encoded);
    }
    toU8aInner() {
        // we do not apply bare to the internal values, rather this only determines out length addition,
        // where we strip all lengths this creates an extrinsic that cannot be decoded
        return [
            new Uint8Array([
                this.version
            ]),
            this.inner.toU8a()
        ];
    }
}
$b0e4a8b59034fae4$export$84cf34f56e9b2fd5.LATEST_EXTRINSIC_VERSION = (0, $bb489c6fc97da74a$export$daa69b8b70533cd6);



class $b1c43899fad14151$export$cd1442401e54cffa extends (0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f).with(64) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = "u64";
    }
}




function $3023dc8aefc86c64$var$getTrailingZeros(period) {
    const binary = period.toString(2);
    let index = 0;
    while(binary[binary.length - 1 - index] === "0")index++;
    return index;
}
/** @internal */ function $3023dc8aefc86c64$var$decodeMortalEra(registry, value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) || Array.isArray(value)) return $3023dc8aefc86c64$var$decodeMortalU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
    else if (!value) return [
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry),
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry)
    ];
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value)) return $3023dc8aefc86c64$var$decodeMortalObject(registry, value);
    throw new Error("Invalid data passed to Mortal era");
}
/** @internal */ function $3023dc8aefc86c64$var$decodeMortalObject(registry, value) {
    const { current: current, period: period } = value;
    let calPeriod = Math.pow(2, Math.ceil(Math.log2(period)));
    calPeriod = Math.min(Math.max(calPeriod, 4), 65536);
    const phase = current % calPeriod;
    const quantizeFactor = Math.max(calPeriod >> 12, 1);
    const quantizedPhase = phase / quantizeFactor * quantizeFactor;
    return [
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry, calPeriod),
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry, quantizedPhase)
    ];
}
/** @internal */ function $3023dc8aefc86c64$var$decodeMortalU8a(registry, value) {
    if (value.length === 0) return [
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry),
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry)
    ];
    const first = (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(value.subarray(0, 1)).toNumber();
    const second = (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(value.subarray(1, 2)).toNumber();
    const encoded = first + (second << 8);
    const period = 2 << encoded % 16;
    const quantizeFactor = Math.max(period >> 12, 1);
    const phase = (encoded >> 4) * quantizeFactor;
    if (period < 4 || phase >= period) throw new Error("Invalid data passed to Mortal era");
    return [
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry, period),
        new (0, $b1c43899fad14151$export$cd1442401e54cffa)(registry, phase)
    ];
}
/** @internal */ function $3023dc8aefc86c64$var$decodeExtrinsicEra(value = new Uint8Array()) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) return !value.length || value[0] === 0 ? new Uint8Array([
        0
    ]) : new Uint8Array([
        1,
        value[0],
        value[1]
    ]);
    else if (!value) return new Uint8Array([
        0
    ]);
    else if (value instanceof $3023dc8aefc86c64$export$5d5cd89b8b0581bb) return $3023dc8aefc86c64$var$decodeExtrinsicEra(value.toU8a());
    else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return $3023dc8aefc86c64$var$decodeExtrinsicEra((0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(value));
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value)) {
        const entries = Object.entries(value).map(([k, v])=>[
                k.toLowerCase(),
                v
            ]);
        const mortal = entries.find(([k])=>k.toLowerCase() === "mortalera");
        const immortal = entries.find(([k])=>k.toLowerCase() === "immortalera");
        // this is to de-serialize from JSON
        return mortal ? {
            MortalEra: mortal[1]
        } : immortal ? {
            ImmortalEra: immortal[1]
        } : {
            MortalEra: value
        };
    }
    throw new Error("Invalid data passed to Era");
}
class $3023dc8aefc86c64$export$a341e270b1e33716 extends (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) {
    constructor(registry, _value){
        // For immortals, we always provide the known value (i.e. treated as a
        // constant no matter how it is constructed - it is a fixed structure)
        super(registry, (0, $3b4cdc47f94d6d49$export$4f5ad2dc5b1538c7));
    }
}
class $3023dc8aefc86c64$export$d3ded7cc5c8ef901 extends (0, $3f7ea4d5b3798bbe$export$1908877435b1d5e9) {
    constructor(registry, value){
        super(registry, {
            period: (0, $b1c43899fad14151$export$cd1442401e54cffa),
            phase: (0, $b1c43899fad14151$export$cd1442401e54cffa)
        }, $3023dc8aefc86c64$var$decodeMortalEra(registry, value));
    }
    /**
     * @description Encoded length for mortals occupy 2 bytes, different from the actual Tuple since it is encoded. This is a shortcut fro `toU8a().length`
     */ get encodedLength() {
        return 2;
    }
    /**
     * @description The period of this Mortal wraps as a [[U64]]
     */ get period() {
        return this[0];
    }
    /**
     * @description The phase of this Mortal wraps as a [[U64]]
     */ get phase() {
        return this[1];
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return {
            period: (0, $d7411165c894866c$export$f5dd818bff069720)(this.period),
            phase: (0, $d7411165c894866c$export$f5dd818bff069720)(this.phase)
        };
    }
    /**
     * @description Returns a JSON representation of the actual value
     */ toJSON() {
        return this.toHex();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the parity-codec specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     * Period and phase are encoded:
     *   - The period of validity from the block hash found in the signing material.
     *   - The phase in the period that this transaction's lifetime begins (and, importantly,
     *     implies which block hash is included in the signature material). If the `period` is
     *     greater than 1 << 12, then it will be a factor of the times greater than 1<<12 that
     *     `period` is.
     */ toU8a(_isBare) {
        const period = this.period.toNumber();
        const encoded = Math.min(15, Math.max(1, $3023dc8aefc86c64$var$getTrailingZeros(period) - 1)) + (this.phase.toNumber() / Math.max(period >> 12, 1) << 4);
        return new Uint8Array([
            encoded & 0xff,
            encoded >> 8
        ]);
    }
    /**
     * @description Get the block number of the start of the era whose properties this object describes that `current` belongs to.
     */ birth(current) {
        const phase = this.phase.toNumber();
        const period = this.period.toNumber();
        // FIXME No toNumber() here
        return ~~((Math.max((0, $fee06eacc361490f$export$3ce10b692b02dcbb)(current).toNumber(), phase) - phase) / period) * period + phase;
    }
    /**
     * @description Get the block number of the first block at which the era has ended.
     */ death(current) {
        // FIXME No toNumber() here
        return this.birth(current) + this.period.toNumber();
    }
}
class $3023dc8aefc86c64$export$5d5cd89b8b0581bb extends (0, $533387422670f8b2$export$deb82508dd66d288) {
    constructor(registry, value){
        super(registry, {
            ImmortalEra: $3023dc8aefc86c64$export$a341e270b1e33716,
            MortalEra: $3023dc8aefc86c64$export$d3ded7cc5c8ef901
        }, $3023dc8aefc86c64$var$decodeExtrinsicEra(value));
    }
    /**
     * @description Override the encoded length method
     */ get encodedLength() {
        return this.isImmortalEra ? this.asImmortalEra.encodedLength : this.asMortalEra.encodedLength;
    }
    /**
     * @description Returns the item as a [[ImmortalEra]]
     */ get asImmortalEra() {
        if (!this.isImmortalEra) throw new Error(`Cannot convert '${this.type}' via asImmortalEra`);
        return this.inner;
    }
    /**
     * @description Returns the item as a [[MortalEra]]
     */ get asMortalEra() {
        if (!this.isMortalEra) throw new Error(`Cannot convert '${this.type}' via asMortalEra`);
        return this.inner;
    }
    /**
     * @description `true` if Immortal
     */ get isImmortalEra() {
        return this.index === 0;
    }
    /**
     * @description `true` if Mortal
     */ get isMortalEra() {
        return this.index > 0;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the parity-codec specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        return this.isMortalEra ? this.asMortalEra.toU8a(isBare) : this.asImmortalEra.toU8a(isBare);
    }
}





const $b207b6a97fc979fb$var$VERSIONS = [
    "ExtrinsicPayloadUnknown",
    "ExtrinsicPayloadUnknown",
    "ExtrinsicPayloadUnknown",
    "ExtrinsicPayloadUnknown",
    "ExtrinsicPayloadV4"
];
/** @internal */ function $b207b6a97fc979fb$var$decodeExtrinsicPayload(registry, value, version = (0, $3b4cdc47f94d6d49$export$363ebe89e6e7aeef)) {
    if (value instanceof $b207b6a97fc979fb$export$16fcba9f79c8d2cd) return value.unwrap();
    return registry.createTypeUnsafe($b207b6a97fc979fb$var$VERSIONS[version] || $b207b6a97fc979fb$var$VERSIONS[0], [
        value,
        {
            version: version
        }
    ]);
}
class $b207b6a97fc979fb$export$16fcba9f79c8d2cd extends (0, $5bac603f88334ac0$export$6d8c589c31247384) {
    constructor(registry, value, { version: version } = {}){
        super(registry, $b207b6a97fc979fb$var$decodeExtrinsicPayload(registry, value, version));
    }
    /**
     * @description The block [[BlockHash]] the signature applies to (mortal/immortal)
     */ get blockHash() {
        return this.inner.blockHash;
    }
    /**
     * @description The [[ExtrinsicEra]]
     */ get era() {
        return this.inner.era;
    }
    /**
     * @description The genesis block [[BlockHash]] the signature applies to
     */ get genesisHash() {
        // NOTE only v3+
        return this.inner.genesisHash || this.registry.createTypeUnsafe("Hash", []);
    }
    /**
     * @description The [[Bytes]] contained in the payload
     */ get method() {
        return this.inner.method;
    }
    /**
     * @description The [[Index]]
     */ get nonce() {
        return this.inner.nonce;
    }
    /**
     * @description The specVersion as a [[u32]] for this payload
     */ get specVersion() {
        // NOTE only v3+
        return this.inner.specVersion || this.registry.createTypeUnsafe("u32", []);
    }
    /**
     * @description The [[Balance]]
     */ get tip() {
        // NOTE from v2+
        return this.inner.tip || this.registry.createTypeUnsafe("Compact<Balance>", []);
    }
    /**
     * @description The transaction version as a [[u32]] for this payload
     */ get transactionVersion() {
        // NOTE only v4+
        return this.inner.transactionVersion || this.registry.createTypeUnsafe("u32", []);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return this.inner.eq(other);
    }
    /**
     * @description Sign the payload with the keypair
     */ sign(signerPair) {
        const signature = this.inner.sign(signerPair);
        // This is extensible, so we could quite readily extend to send back extra
        // information, such as for instance the payload, i.e. `payload: this.toHex()`
        // For the case here we sign via the extrinsic, we ignore the return, so generally
        // this is applicable for external signing
        return {
            signature: (0, $1e2cfad286c009ca$export$4429d284633899e1)(signature)
        };
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExtended) {
        return this.inner.toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toHex();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "ExtrinsicPayload";
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.toHex();
    }
    /**
     * @description Returns a serialized u8a form
     */ toU8a(isBare) {
        // call our parent, with only the method stripped
        return super.toU8a(isBare ? {
            method: true
        } : false);
    }
}



class $4f59639b4128bc69$export$16de08536e20f6e extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, _value, { version: version = 0 } = {}){
        super(registry, {});
        throw new Error(`Unsupported extrinsic payload version ${version}`);
    }
}




class $820d13c385425a18$export$8dfdb1d7f756968d extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, _value, { isSigned: isSigned = false, version: version = 0 } = {}){
        super(registry, {});
        throw new Error(`Unsupported ${isSigned ? "" : "un"}signed extrinsic version ${version & (0, $3b4cdc47f94d6d49$export$85ad1b550ea69f4a)}`);
    }
}




const $eee25df9023bcec9$var$knownTypes = {
    address: "Address",
    blockHash: "Hash",
    blockNumber: "BlockNumber",
    era: "ExtrinsicEra",
    genesisHash: "Hash",
    method: "Call",
    nonce: "Compact<Index>",
    runtimeVersion: "RuntimeVersion",
    signedExtensions: "Vec<Text>",
    tip: "Compact<Balance>",
    version: "u8"
};
class $eee25df9023bcec9$export$7496e86a1dd2214a extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value){
        const extensionTypes = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra());
        super(registry, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, extensionTypes, $eee25df9023bcec9$var$knownTypes), value);
        this.__internal__extraTypes = {};
        const getter = (key)=>this.get(key);
        // add all extras that are not in the base types
        for (const [key, type] of Object.entries(extensionTypes)){
            if (!$eee25df9023bcec9$var$knownTypes[key]) this.__internal__extraTypes[key] = type;
            (0, $fb51452ffd615a15$export$b1dee6b72881b450)(this, key, getter);
        }
    }
    get address() {
        return this.getT("address");
    }
    get blockHash() {
        return this.getT("blockHash");
    }
    get blockNumber() {
        return this.getT("blockNumber");
    }
    get era() {
        return this.getT("era");
    }
    get genesisHash() {
        return this.getT("genesisHash");
    }
    get method() {
        return this.getT("method");
    }
    get nonce() {
        return this.getT("nonce");
    }
    get runtimeVersion() {
        return this.getT("runtimeVersion");
    }
    get signedExtensions() {
        return this.getT("signedExtensions");
    }
    get tip() {
        return this.getT("tip");
    }
    get version() {
        return this.getT("version");
    }
    /**
     * @description Creates an representation of the structure as an ISignerPayload JSON
     */ toPayload() {
        const result = {};
        const keys = Object.keys(this.__internal__extraTypes);
        // add any explicit overrides we may have
        for(let i = 0, count = keys.length; i < count; i++){
            const key = keys[i];
            const value = this.get(key);
            const isOption = value instanceof (0, $c77f4fb10fc66369$export$36d18380658d5d20);
            // Don't include Option.isNone
            if (!isOption || value.isSome) result[key] = value.toHex();
        }
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(result, {
            // the known defaults as managed explicitly and has different
            // formatting in cases, e.g. we mostly expose a hex format here
            address: this.address.toString(),
            blockHash: this.blockHash.toHex(),
            blockNumber: this.blockNumber.toHex(),
            era: this.era.toHex(),
            genesisHash: this.genesisHash.toHex(),
            method: this.method.toHex(),
            nonce: this.nonce.toHex(),
            signedExtensions: this.signedExtensions.map((e)=>e.toString()),
            specVersion: this.runtimeVersion.specVersion.toHex(),
            tip: this.tip.toHex(),
            transactionVersion: this.runtimeVersion.transactionVersion.toHex(),
            version: this.version.toNumber()
        });
    }
    /**
     * @description Creates a representation of the payload in raw Exrinsic form
     */ toRaw() {
        const payload = this.toPayload();
        const data = (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.registry.createTypeUnsafe("ExtrinsicPayload", [
            payload,
            {
                version: payload.version
            }
        ])// NOTE Explicitly pass the bare flag so the method is encoded un-prefixed (non-decodable, for signing only)
        .toU8a({
            method: true
        }));
        return {
            address: payload.address,
            data: data,
            type: "payload"
        };
    }
}


var $5878c064a76fac75$exports = {};

$parcel$export($5878c064a76fac75$exports, "GenericExtrinsicV4", function () { return $bb489c6fc97da74a$export$de52b1432b0f98e7; });
$parcel$export($5878c064a76fac75$exports, "GenericExtrinsicPayloadV4", function () { return $9b703a520fcdc539$export$44b482ea82361d08; });
$parcel$export($5878c064a76fac75$exports, "GenericExtrinsicSignatureV4", function () { return $c0c511dbb380d2f0$export$9afb5905a66840f9; });



function $25bde545029c7e1c$export$c5552dfdbc7cec71(registry, signerPair, u8a, options) {
    const encoded = u8a.length > 256 ? registry.hash(u8a) : u8a;
    return signerPair.sign(encoded, options);
}


class $9b703a520fcdc539$export$44b482ea82361d08 extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value){
        super(registry, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            method: "Bytes"
        }, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra()), value);
        // Do detection for the type of extrinsic, in the case of MultiSignature
        // this is an enum, in the case of AnySignature, this is a Hash only
        // (which may be 64 or 65 bytes)
        this.__internal__signOptions = {
            withType: registry.createTypeUnsafe("ExtrinsicSignature", []) instanceof (0, $533387422670f8b2$export$deb82508dd66d288)
        };
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return super.inspect({
            method: true
        });
    }
    /**
     * @description The block [[BlockHash]] the signature applies to (mortal/immortal)
     */ get blockHash() {
        return this.getT("blockHash");
    }
    /**
     * @description The [[ExtrinsicEra]]
     */ get era() {
        return this.getT("era");
    }
    /**
     * @description The genesis [[BlockHash]] the signature applies to (mortal/immortal)
     */ get genesisHash() {
        return this.getT("genesisHash");
    }
    /**
     * @description The [[Bytes]] contained in the payload
     */ get method() {
        return this.getT("method");
    }
    /**
     * @description The [[Index]]
     */ get nonce() {
        return this.getT("nonce");
    }
    /**
     * @description The specVersion for this signature
     */ get specVersion() {
        return this.getT("specVersion");
    }
    /**
     * @description The tip [[Balance]]
     */ get tip() {
        return this.getT("tip");
    }
    /**
     * @description The transactionVersion for this signature
     */ get transactionVersion() {
        return this.getT("transactionVersion");
    }
    /**
     * @description The (optional) asset id for this signature for chains that support transaction fees in assets
     */ get assetId() {
        return this.getT("assetId");
    }
    /**
     * @description Sign the payload with the keypair
     */ sign(signerPair) {
        // NOTE The `toU8a({ method: true })` argument is absolutely critical, we
        // don't want the method (Bytes) to have the length prefix included. This
        // means that the data-as-signed is un-decodable, but is also doesn't need
        // the extra information, only the pure data (and is not decoded) ...
        // The same applies to V1..V3, if we have a V5, carry this comment
        return (0, $25bde545029c7e1c$export$c5552dfdbc7cec71)(this.registry, signerPair, this.toU8a({
            method: true
        }), this.__internal__signOptions);
    }
}






const $c0c511dbb380d2f0$var$FAKE_SIGNATURE = new Uint8Array(256).fill(1);
function $c0c511dbb380d2f0$var$toAddress(registry, address) {
    return registry.createTypeUnsafe("Address", [
        (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(address) ? (0, $1e2cfad286c009ca$export$4429d284633899e1)(address) : address
    ]);
}
class $c0c511dbb380d2f0$export$9afb5905a66840f9 extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value, { isSigned: isSigned } = {}){
        const signTypes = registry.getSignedExtensionTypes();
        super(registry, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(// eslint-disable-next-line sort-keys
        {
            signer: "Address",
            signature: "ExtrinsicSignature"
        }, signTypes), $c0c511dbb380d2f0$export$9afb5905a66840f9.decodeExtrinsicSignature(value, isSigned));
        this.__internal__signKeys = Object.keys(signTypes);
        (0, $fb51452ffd615a15$export$4660c3861a213768)(this, this.__internal__signKeys, (k)=>this.get(k));
    }
    /** @internal */ static decodeExtrinsicSignature(value, isSigned = false) {
        if (!value) return 0, $3b4cdc47f94d6d49$export$e36b6dd925dc1ec4;
        else if (value instanceof $c0c511dbb380d2f0$export$9afb5905a66840f9) return value;
        return isSigned ? value : (0, $3b4cdc47f94d6d49$export$e36b6dd925dc1ec4);
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.isSigned ? super.encodedLength : 0;
    }
    /**
     * @description `true` if the signature is valid
     */ get isSigned() {
        return !this.signature.isEmpty;
    }
    /**
     * @description The [[ExtrinsicEra]] (mortal or immortal) this signature applies to
     */ get era() {
        return this.getT("era");
    }
    /**
     * @description The [[Index]] for the signature
     */ get nonce() {
        return this.getT("nonce");
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */ get signature() {
        // the second case here is when we don't have an enum signature, treat as raw
        return this.multiSignature.value || this.multiSignature;
    }
    /**
     * @description The raw [[ExtrinsicSignature]]
     */ get multiSignature() {
        return this.getT("signature");
    }
    /**
     * @description The [[Address]] that signed
     */ get signer() {
        return this.getT("signer");
    }
    /**
     * @description The [[Balance]] tip
     */ get tip() {
        return this.getT("tip");
    }
    _injectSignature(signer, signature, payload) {
        // use the fields exposed to guide the getters
        for(let i = 0, count = this.__internal__signKeys.length; i < count; i++){
            const k = this.__internal__signKeys[i];
            const v = payload.get(k);
            if (!(0, $09d5dc0a6a4c347b$export$fce6876652108ab)(v)) this.set(k, v);
        }
        // additional fields (exposed in struct itself)
        this.set("signer", signer);
        this.set("signature", signature);
        return this;
    }
    /**
     * @description Adds a raw signature
     */ addSignature(signer, signature, payload) {
        return this._injectSignature($c0c511dbb380d2f0$var$toAddress(this.registry, signer), this.registry.createTypeUnsafe("ExtrinsicSignature", [
            signature
        ]), new (0, $9b703a520fcdc539$export$44b482ea82361d08)(this.registry, payload));
    }
    /**
     * @description Creates a payload from the supplied options
     */ createPayload(method, options) {
        const { era: era, runtimeVersion: { specVersion: specVersion, transactionVersion: transactionVersion } } = options;
        return new (0, $9b703a520fcdc539$export$44b482ea82361d08)(this.registry, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, options, {
            era: era || (0, $3b4cdc47f94d6d49$export$4f5ad2dc5b1538c7),
            method: method.toHex(),
            specVersion: specVersion,
            transactionVersion: transactionVersion
        }));
    }
    /**
     * @description Generate a payload and applies the signature from a keypair
     */ sign(method, account, options) {
        if (!account || !account.addressRaw) throw new Error(`Expected a valid keypair for signing, found ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(account)}`);
        const payload = this.createPayload(method, options);
        return this._injectSignature($c0c511dbb380d2f0$var$toAddress(this.registry, account.addressRaw), this.registry.createTypeUnsafe("ExtrinsicSignature", [
            payload.sign(account)
        ]), payload);
    }
    /**
     * @description Generate a payload and applies a fake signature
     */ signFake(method, address, options) {
        if (!address) throw new Error(`Expected a valid address for signing, found ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(address)}`);
        const payload = this.createPayload(method, options);
        return this._injectSignature($c0c511dbb380d2f0$var$toAddress(this.registry, address), this.registry.createTypeUnsafe("ExtrinsicSignature", [
            $c0c511dbb380d2f0$var$FAKE_SIGNATURE
        ]), payload);
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        return this.isSigned ? super.toU8a(isBare) : (0, $3b4cdc47f94d6d49$export$e36b6dd925dc1ec4);
    }
}




$parcel$exportWildcard($406aeba327260154$exports, $5878c064a76fac75$exports);


var $5ea38cbe6563a36b$exports = {};

$parcel$export($5ea38cbe6563a36b$exports, "GenericAccountId", function () { return $7033f80e9fd32a40$export$e406ba10ba55d465; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericAccountId32", function () { return $7033f80e9fd32a40$export$e406ba10ba55d465; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericAccountId33", function () { return $7033f80e9fd32a40$export$3ed682307d9a4c17; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericAccountIndex", function () { return $ee4318a517c11a72$export$32a6cf2b486c273e; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericBlock", function () { return $72dcb295eed46340$export$ab64a881ee541178; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericCall", function () { return $b64d2846ef18c29b$export$8d29ed11b287d7e; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericChainProperties", function () { return $411f91694ccf9d16$export$dd6d127d010710fc; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericConsensusEngineId", function () { return $57ed4489763a1ec1$export$f8b18c3565f4d616; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericEvent", function () { return $b713657d03724297$export$dffc327d80bea855; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericEventData", function () { return $b713657d03724297$export$1b4b861caf7ac12b; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericLookupSource", function () { return $d92d162775d1d441$export$544474b0017508b9; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericAddress", function () { return $bdad1893038fd77b$export$d6fe318e4151e13b; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericMultiAddress", function () { return $bdad1893038fd77b$export$d6fe318e4151e13b; });
$parcel$export($5ea38cbe6563a36b$exports, "GenericVote", function () { return $5590538c09827e86$export$7a7552f4af8d9505; });



/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $c3b3189ede475f4e$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`Wrong integer: ${n}`);
}
function $c3b3189ede475f4e$var$chain(...args) {
    const wrap = (a, b)=>(c)=>a(b(c));
    const encode = Array.from(args).reverse().reduce((acc, i)=>acc ? wrap(acc, i.encode) : i.encode, undefined);
    const decode = args.reduce((acc, i)=>acc ? wrap(acc, i.decode) : i.decode, undefined);
    return {
        encode: encode,
        decode: decode
    };
}
function $c3b3189ede475f4e$var$alphabet(alphabet) {
    return {
        encode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map((i)=>{
                $c3b3189ede475f4e$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet.length})`);
                return alphabet[i];
            });
        },
        decode: (input)=>{
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map((letter)=>{
                if (typeof letter !== "string") throw new Error(`alphabet.decode: not string element=${letter}`);
                const index = alphabet.indexOf(letter);
                if (index === -1) throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet}`);
                return index;
            });
        }
    };
}
function $c3b3189ede475f4e$var$join(separator = "") {
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: (from)=>{
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            for (let i of from)if (typeof i !== "string") throw new Error(`join.encode: non-string input=${i}`);
            return from.join(separator);
        },
        decode: (to)=>{
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
function $c3b3189ede475f4e$var$padding(bits, chr = "=") {
    $c3b3189ede475f4e$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode (data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of data)if (typeof i !== "string") throw new Error(`padding.encode: non-string input=${i}`);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of input)if (typeof i !== "string") throw new Error(`padding.decode: non-string input=${i}`);
            let end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
function $c3b3189ede475f4e$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
function $c3b3189ede475f4e$var$convertRadix(data, from, to) {
    if (from < 2) throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d)=>{
        $c3b3189ede475f4e$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error(`Wrong integer: ${d}`);
    });
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < digits.length; i++){
            const digit = digits[i];
            const digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            digits[i] = Math.floor(digitBase / to);
            if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!digits[i]) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $c3b3189ede475f4e$var$gcd = (a, b)=>!b ? a : $c3b3189ede475f4e$var$gcd(b, a % b);
const $c3b3189ede475f4e$var$radix2carry = (from, to)=>from + (to - $c3b3189ede475f4e$var$gcd(from, to));
function $c3b3189ede475f4e$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($c3b3189ede475f4e$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$c3b3189ede475f4e$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0;
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data){
        $c3b3189ede475f4e$export$dfbcecb440255e4a(n);
        if (n >= 2 ** from) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        carry &= 2 ** pos - 1;
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
function $c3b3189ede475f4e$var$radix(num) {
    $c3b3189ede475f4e$export$dfbcecb440255e4a(num);
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix.encode input should be Uint8Array");
            return $c3b3189ede475f4e$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of strings");
            return Uint8Array.from($c3b3189ede475f4e$var$convertRadix(digits, num, 256));
        }
    };
}
function $c3b3189ede475f4e$var$radix2(bits, revPadding = false) {
    $c3b3189ede475f4e$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($c3b3189ede475f4e$var$radix2carry(8, bits) > 32 || $c3b3189ede475f4e$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix2.encode input should be Uint8Array");
            return $c3b3189ede475f4e$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of strings");
            return Uint8Array.from($c3b3189ede475f4e$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $c3b3189ede475f4e$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $c3b3189ede475f4e$var$checksum(len, fn) {
    $c3b3189ede475f4e$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.encode: input should be Uint8Array");
            const checksum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(checksum, data.length);
            return res;
        },
        decode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const newChecksum = fn(payload).slice(0, len);
            const oldChecksum = data.slice(-len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $c3b3189ede475f4e$export$eab97d15b1788b8d = {
    alphabet: $c3b3189ede475f4e$var$alphabet,
    chain: $c3b3189ede475f4e$var$chain,
    checksum: $c3b3189ede475f4e$var$checksum,
    radix: $c3b3189ede475f4e$var$radix,
    radix2: $c3b3189ede475f4e$var$radix2,
    join: $c3b3189ede475f4e$var$join,
    padding: $c3b3189ede475f4e$var$padding
};
const $c3b3189ede475f4e$export$586f61c71cb02fe4 = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(4), $c3b3189ede475f4e$var$alphabet("0123456789ABCDEF"), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$export$4a4d5965e2738b2a = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(5), $c3b3189ede475f4e$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $c3b3189ede475f4e$var$padding(5), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$export$c57d6760d519c8ac = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(5), $c3b3189ede475f4e$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $c3b3189ede475f4e$var$padding(5), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$export$5fbcb08925249358 = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(5), $c3b3189ede475f4e$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $c3b3189ede475f4e$var$join(""), $c3b3189ede475f4e$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $c3b3189ede475f4e$export$b3b2de96497acc47 = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(6), $c3b3189ede475f4e$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $c3b3189ede475f4e$var$padding(6), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$export$7d21597c7bc64465 = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(6), $c3b3189ede475f4e$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $c3b3189ede475f4e$var$padding(6), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$var$genBase58 = (abc)=>$c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix(58), $c3b3189ede475f4e$var$alphabet(abc), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$export$61f53211c069eefb = $c3b3189ede475f4e$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $c3b3189ede475f4e$export$c6a7baed2941aad2 = $c3b3189ede475f4e$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $c3b3189ede475f4e$export$cbd4c72942a9201d = $c3b3189ede475f4e$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
const $c3b3189ede475f4e$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $c3b3189ede475f4e$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $c3b3189ede475f4e$export$61f53211c069eefb.encode(block).padStart($c3b3189ede475f4e$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $c3b3189ede475f4e$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $c3b3189ede475f4e$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $c3b3189ede475f4e$export$fff625c574161df6 = (sha256)=>$c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$checksum(4, (data)=>sha256(sha256(data))), $c3b3189ede475f4e$export$61f53211c069eefb);
const $c3b3189ede475f4e$var$BECH_ALPHABET = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $c3b3189ede475f4e$var$join(""));
const $c3b3189ede475f4e$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $c3b3189ede475f4e$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $c3b3189ede475f4e$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $c3b3189ede475f4e$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $c3b3189ede475f4e$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $c3b3189ede475f4e$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $c3b3189ede475f4e$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $c3b3189ede475f4e$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $c3b3189ede475f4e$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $c3b3189ede475f4e$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $c3b3189ede475f4e$var$BECH_ALPHABET.encode($c3b3189ede475f4e$var$convertRadix2([
        chk % 2 ** 30
    ], 30, 5, false));
}
function $c3b3189ede475f4e$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $c3b3189ede475f4e$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $c3b3189ede475f4e$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        if (typeof prefix !== "string") throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
        const actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        prefix = prefix.toLowerCase();
        return `${prefix}1${$c3b3189ede475f4e$var$BECH_ALPHABET.encode(words)}${$c3b3189ede475f4e$var$bechChecksum(prefix, words, ENCODING_CONST)}`;
    }
    function decode(str, limit = 90) {
        if (typeof str !== "string") throw new Error(`bech32.decode input should be string, not ${typeof str}`);
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        str = lowered;
        const sepIndex = str.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = str.slice(0, sepIndex);
        const _words = str.slice(sepIndex + 1);
        if (_words.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $c3b3189ede475f4e$var$BECH_ALPHABET.decode(_words).slice(0, -6);
        const sum = $c3b3189ede475f4e$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!_words.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $c3b3189ede475f4e$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $c3b3189ede475f4e$export$27c42482533637da = $c3b3189ede475f4e$var$genBech32("bech32");
const $c3b3189ede475f4e$export$4963f7e473ccf819 = $c3b3189ede475f4e$var$genBech32("bech32m");
const $c3b3189ede475f4e$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $c3b3189ede475f4e$export$834dfc94dde4b3d8 = $c3b3189ede475f4e$var$chain($c3b3189ede475f4e$var$radix2(4), $c3b3189ede475f4e$var$alphabet("0123456789abcdef"), $c3b3189ede475f4e$var$join(""), $c3b3189ede475f4e$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
const $c3b3189ede475f4e$var$CODERS = {
    utf8: $c3b3189ede475f4e$export$74329b762b589566,
    hex: $c3b3189ede475f4e$export$834dfc94dde4b3d8,
    base16: $c3b3189ede475f4e$export$586f61c71cb02fe4,
    base32: $c3b3189ede475f4e$export$4a4d5965e2738b2a,
    base64: $c3b3189ede475f4e$export$b3b2de96497acc47,
    base64url: $c3b3189ede475f4e$export$7d21597c7bc64465,
    base58: $c3b3189ede475f4e$export$61f53211c069eefb,
    base58xmr: $c3b3189ede475f4e$export$e86cd8e7f8cff4a6
};
const $c3b3189ede475f4e$var$coderTypeError = `Invalid encoding type. Available types: ${Object.keys($c3b3189ede475f4e$var$CODERS).join(", ")}`;
const $c3b3189ede475f4e$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$c3b3189ede475f4e$var$CODERS.hasOwnProperty(type)) throw new TypeError($c3b3189ede475f4e$var$coderTypeError);
    if (!(bytes instanceof Uint8Array)) throw new TypeError("bytesToString() expects Uint8Array");
    return $c3b3189ede475f4e$var$CODERS[type].encode(bytes);
};
const $c3b3189ede475f4e$export$42d51816ce590c93 = $c3b3189ede475f4e$export$7c746b75f47c9c7d;
const $c3b3189ede475f4e$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$c3b3189ede475f4e$var$CODERS.hasOwnProperty(type)) throw new TypeError($c3b3189ede475f4e$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $c3b3189ede475f4e$var$CODERS[type].decode(str);
};
const $c3b3189ede475f4e$export$b3317979f9250576 = $c3b3189ede475f4e$export$c8dd6bc66a63753c;



function $0580f346b115e3e3$export$731f08e8f7451db({ coder: coder, ipfs: ipfs }, validate) {
    return (value, ipfsCompat)=>{
        validate(value, ipfsCompat);
        return coder.decode(ipfs && ipfsCompat ? value.substring(1) : value);
    };
}
function $0580f346b115e3e3$export$9e30af3a800385aa({ coder: coder, ipfs: ipfs }) {
    return (value, ipfsCompat)=>{
        const out = coder.encode((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
        return ipfs && ipfsCompat ? `${ipfs}${out}` : out;
    };
}
function $0580f346b115e3e3$export$9836a0dc385be8f1(validate) {
    return (value, ipfsCompat)=>{
        try {
            return validate(value, ipfsCompat);
        } catch  {
            return false;
        }
    };
}
function $0580f346b115e3e3$export$2859a83e4d6da57d({ chars: chars, ipfs: ipfs, type: type, withPadding: withPadding }) {
    return (value, ipfsCompat)=>{
        if (typeof value !== "string") throw new Error(`Expected ${type} string input`);
        else if (ipfs && ipfsCompat && value[0] !== ipfs) throw new Error(`Expected ipfs-compatible ${type} to start with '${ipfs}'`);
        for(let i = ipfsCompat ? 1 : 0, count = value.length; i < count; i++){
            if (chars.includes(value[i])) ;
            else if (withPadding && value[i] === "=") {
                if (i === count - 1) ;
                else if (value[i + 1] === "=") ;
                else throw new Error(`Invalid ${type} padding sequence "${value[i]}${value[i + 1]}" at index ${i}`);
            } else throw new Error(`Invalid ${type} character "${value[i]}" (0x${value.charCodeAt(i).toString(16)}) at index ${i}`);
        }
        return true;
    };
}


const $3467763799979175$var$config = {
    chars: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",
    coder: (0, $c3b3189ede475f4e$export$61f53211c069eefb),
    ipfs: "z",
    type: "base58"
};
const $3467763799979175$export$1bb67fe68adb5db2 = /*#__PURE__*/ (0, $0580f346b115e3e3$export$2859a83e4d6da57d)($3467763799979175$var$config);
const $3467763799979175$export$e42db48932fc32fe = /*#__PURE__*/ (0, $0580f346b115e3e3$export$731f08e8f7451db)($3467763799979175$var$config, $3467763799979175$export$1bb67fe68adb5db2);
const $3467763799979175$export$a025eb30fde2c140 = /*#__PURE__*/ (0, $0580f346b115e3e3$export$9e30af3a800385aa)($3467763799979175$var$config);
const $3467763799979175$export$fe9a3fa02c7cb60d = /*#__PURE__*/ (0, $0580f346b115e3e3$export$9836a0dc385be8f1)($3467763799979175$export$1bb67fe68adb5db2);




const $abda4dab45d63660$var$SS58_PREFIX = (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)("SS58PRE");
function $abda4dab45d63660$export$532a1e05ac7e36e6(key) {
    return (0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)((0, $84207d7313fd2c40$export$7b640c40d4922c2e)($abda4dab45d63660$var$SS58_PREFIX, key), 512);
}


function $f4e722017630116e$export$3a8dea5969197010(decoded) {
    const ss58Length = decoded[0] & 64 ? 2 : 1;
    const ss58Decoded = ss58Length === 1 ? decoded[0] : (decoded[0] & 63) << 2 | decoded[1] >> 6 | (decoded[1] & 63) << 8;
    // 32/33 bytes public + 2 bytes checksum + prefix
    const isPublicKey = [
        34 + ss58Length,
        35 + ss58Length
    ].includes(decoded.length);
    const length = decoded.length - (isPublicKey ? 2 : 1);
    // calculate the hash and do the checksum byte checks
    const hash = (0, $abda4dab45d63660$export$532a1e05ac7e36e6)(decoded.subarray(0, length));
    const isValid = (decoded[0] & 128) === 0 && ![
        46,
        47
    ].includes(decoded[0]) && (isPublicKey ? decoded[decoded.length - 2] === hash[0] && decoded[decoded.length - 1] === hash[1] : decoded[decoded.length - 1] === hash[0]);
    return [
        isValid,
        length,
        ss58Length,
        ss58Decoded
    ];
}


// Copyright (C) 2021-2023 Parity Technologies (UK) Ltd.
// SPDX-License-Identifier: Apache-2.0
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// 	http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var $307c277086596e53$export$2e2bcd8739ae039 = [
    {
        "prefix": 0,
        "network": "polkadot",
        "displayName": "Polkadot Relay Chain",
        "symbols": [
            "DOT"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://polkadot.network"
    },
    {
        "prefix": 1,
        "network": "BareSr25519",
        "displayName": "Bare 32-bit Schnorr/Ristretto (S/R 25519) public key.",
        "symbols": [],
        "decimals": [],
        "standardAccount": "Sr25519",
        "website": null
    },
    {
        "prefix": 2,
        "network": "kusama",
        "displayName": "Kusama Relay Chain",
        "symbols": [
            "KSM"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://kusama.network"
    },
    {
        "prefix": 3,
        "network": "BareEd25519",
        "displayName": "Bare 32-bit Ed25519 public key.",
        "symbols": [],
        "decimals": [],
        "standardAccount": "Ed25519",
        "website": null
    },
    {
        "prefix": 4,
        "network": "katalchain",
        "displayName": "Katal Chain",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": null
    },
    {
        "prefix": 5,
        "network": "astar",
        "displayName": "Astar Network",
        "symbols": [
            "ASTR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://astar.network"
    },
    {
        "prefix": 6,
        "network": "bifrost",
        "displayName": "Bifrost",
        "symbols": [
            "BNC"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://bifrost.finance/"
    },
    {
        "prefix": 7,
        "network": "edgeware",
        "displayName": "Edgeware",
        "symbols": [
            "EDG"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://edgewa.re"
    },
    {
        "prefix": 8,
        "network": "karura",
        "displayName": "Karura",
        "symbols": [
            "KAR"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://karura.network/"
    },
    {
        "prefix": 9,
        "network": "reynolds",
        "displayName": "Laminar Reynolds Canary",
        "symbols": [
            "REY"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "http://laminar.network/"
    },
    {
        "prefix": 10,
        "network": "acala",
        "displayName": "Acala",
        "symbols": [
            "ACA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://acala.network/"
    },
    {
        "prefix": 11,
        "network": "laminar",
        "displayName": "Laminar",
        "symbols": [
            "LAMI"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "http://laminar.network/"
    },
    {
        "prefix": 12,
        "network": "polymesh",
        "displayName": "Polymesh",
        "symbols": [
            "POLYX"
        ],
        "decimals": [
            6
        ],
        "standardAccount": "*25519",
        "website": "https://polymath.network/"
    },
    {
        "prefix": 13,
        "network": "integritee",
        "displayName": "Integritee",
        "symbols": [
            "TEER"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://integritee.network"
    },
    {
        "prefix": 14,
        "network": "totem",
        "displayName": "Totem",
        "symbols": [
            "TOTEM"
        ],
        "decimals": [
            0
        ],
        "standardAccount": "*25519",
        "website": "https://totemaccounting.com"
    },
    {
        "prefix": 15,
        "network": "synesthesia",
        "displayName": "Synesthesia",
        "symbols": [
            "SYN"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://synesthesia.network/"
    },
    {
        "prefix": 16,
        "network": "kulupu",
        "displayName": "Kulupu",
        "symbols": [
            "KLP"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://kulupu.network/"
    },
    {
        "prefix": 17,
        "network": "dark",
        "displayName": "Dark Mainnet",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": null
    },
    {
        "prefix": 18,
        "network": "darwinia",
        "displayName": "Darwinia Network",
        "symbols": [
            "RING",
            "KTON"
        ],
        "decimals": [
            9,
            9
        ],
        "standardAccount": "*25519",
        "website": "https://darwinia.network/"
    },
    {
        "prefix": 19,
        "network": "watr",
        "displayName": "Watr Protocol",
        "symbols": [
            "WATR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://www.watr.org"
    },
    {
        "prefix": 20,
        "network": "stafi",
        "displayName": "Stafi",
        "symbols": [
            "FIS"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://stafi.io"
    },
    {
        "prefix": 22,
        "network": "dock-pos-mainnet",
        "displayName": "Dock Mainnet",
        "symbols": [
            "DCK"
        ],
        "decimals": [
            6
        ],
        "standardAccount": "*25519",
        "website": "https://dock.io"
    },
    {
        "prefix": 23,
        "network": "shift",
        "displayName": "ShiftNrg",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": null
    },
    {
        "prefix": 24,
        "network": "zero",
        "displayName": "ZERO",
        "symbols": [
            "ZERO"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://zero.io"
    },
    {
        "prefix": 25,
        "network": "zero-alphaville",
        "displayName": "ZERO Alphaville",
        "symbols": [
            "ZERO"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://zero.io"
    },
    {
        "prefix": 26,
        "network": "jupiter",
        "displayName": "Jupiter",
        "symbols": [
            "jDOT"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://jupiter.patract.io"
    },
    {
        "prefix": 27,
        "network": "kabocha",
        "displayName": "Kabocha",
        "symbols": [
            "KAB"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://kabocha.network"
    },
    {
        "prefix": 28,
        "network": "subsocial",
        "displayName": "Subsocial",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": null
    },
    {
        "prefix": 29,
        "network": "cord",
        "displayName": "CORD Network",
        "symbols": [
            "DHI",
            "WAY"
        ],
        "decimals": [
            12,
            12
        ],
        "standardAccount": "*25519",
        "website": "https://cord.network/"
    },
    {
        "prefix": 30,
        "network": "phala",
        "displayName": "Phala Network",
        "symbols": [
            "PHA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://phala.network"
    },
    {
        "prefix": 31,
        "network": "litentry",
        "displayName": "Litentry Network",
        "symbols": [
            "LIT"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://litentry.com/"
    },
    {
        "prefix": 32,
        "network": "robonomics",
        "displayName": "Robonomics",
        "symbols": [
            "XRT"
        ],
        "decimals": [
            9
        ],
        "standardAccount": "*25519",
        "website": "https://robonomics.network"
    },
    {
        "prefix": 33,
        "network": "datahighway",
        "displayName": "DataHighway",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": null
    },
    {
        "prefix": 34,
        "network": "ares",
        "displayName": "Ares Protocol",
        "symbols": [
            "ARES"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://www.aresprotocol.com/"
    },
    {
        "prefix": 35,
        "network": "vln",
        "displayName": "Valiu Liquidity Network",
        "symbols": [
            "USDv"
        ],
        "decimals": [
            15
        ],
        "standardAccount": "*25519",
        "website": "https://valiu.com/"
    },
    {
        "prefix": 36,
        "network": "centrifuge",
        "displayName": "Centrifuge Chain",
        "symbols": [
            "CFG"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://centrifuge.io/"
    },
    {
        "prefix": 37,
        "network": "nodle",
        "displayName": "Nodle Chain",
        "symbols": [
            "NODL"
        ],
        "decimals": [
            11
        ],
        "standardAccount": "*25519",
        "website": "https://nodle.io/"
    },
    {
        "prefix": 38,
        "network": "kilt",
        "displayName": "KILT Spiritnet",
        "symbols": [
            "KILT"
        ],
        "decimals": [
            15
        ],
        "standardAccount": "*25519",
        "website": "https://kilt.io/"
    },
    {
        "prefix": 39,
        "network": "mathchain",
        "displayName": "MathChain mainnet",
        "symbols": [
            "MATH"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://mathwallet.org"
    },
    {
        "prefix": 40,
        "network": "mathchain-testnet",
        "displayName": "MathChain testnet",
        "symbols": [
            "MATH"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://mathwallet.org"
    },
    {
        "prefix": 41,
        "network": "poli",
        "displayName": "Polimec Chain",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": "https://polimec.io/"
    },
    {
        "prefix": 42,
        "network": "substrate",
        "displayName": "Substrate",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": "https://substrate.io/"
    },
    {
        "prefix": 43,
        "network": "BareSecp256k1",
        "displayName": "Bare 32-bit ECDSA SECP-256k1 public key.",
        "symbols": [],
        "decimals": [],
        "standardAccount": "secp256k1",
        "website": null
    },
    {
        "prefix": 44,
        "network": "chainx",
        "displayName": "ChainX",
        "symbols": [
            "PCX"
        ],
        "decimals": [
            8
        ],
        "standardAccount": "*25519",
        "website": "https://chainx.org/"
    },
    {
        "prefix": 45,
        "network": "uniarts",
        "displayName": "UniArts Network",
        "symbols": [
            "UART",
            "UINK"
        ],
        "decimals": [
            12,
            12
        ],
        "standardAccount": "*25519",
        "website": "https://uniarts.me"
    },
    {
        "prefix": 46,
        "network": "reserved46",
        "displayName": "This prefix is reserved.",
        "symbols": [],
        "decimals": [],
        "standardAccount": null,
        "website": null
    },
    {
        "prefix": 47,
        "network": "reserved47",
        "displayName": "This prefix is reserved.",
        "symbols": [],
        "decimals": [],
        "standardAccount": null,
        "website": null
    },
    {
        "prefix": 48,
        "network": "neatcoin",
        "displayName": "Neatcoin Mainnet",
        "symbols": [
            "NEAT"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://neatcoin.org"
    },
    {
        "prefix": 49,
        "network": "picasso",
        "displayName": "Picasso",
        "symbols": [
            "PICA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://picasso.composable.finance"
    },
    {
        "prefix": 50,
        "network": "composable",
        "displayName": "Composable Finance",
        "symbols": [
            "LAYR"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://composable.finance"
    },
    {
        "prefix": 51,
        "network": "oak",
        "displayName": "OAK Network",
        "symbols": [
            "OAK",
            "TUR"
        ],
        "decimals": [
            10,
            10
        ],
        "standardAccount": "*25519",
        "website": "https://oak.tech"
    },
    {
        "prefix": 52,
        "network": "KICO",
        "displayName": "KICO",
        "symbols": [
            "KICO"
        ],
        "decimals": [
            14
        ],
        "standardAccount": "*25519",
        "website": "https://dico.io"
    },
    {
        "prefix": 53,
        "network": "DICO",
        "displayName": "DICO",
        "symbols": [
            "DICO"
        ],
        "decimals": [
            14
        ],
        "standardAccount": "*25519",
        "website": "https://dico.io"
    },
    {
        "prefix": 54,
        "network": "cere",
        "displayName": "Cere Network",
        "symbols": [
            "CERE"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://cere.network"
    },
    {
        "prefix": 55,
        "network": "xxnetwork",
        "displayName": "xx network",
        "symbols": [
            "XX"
        ],
        "decimals": [
            9
        ],
        "standardAccount": "*25519",
        "website": "https://xx.network"
    },
    {
        "prefix": 56,
        "network": "pendulum",
        "displayName": "Pendulum chain",
        "symbols": [
            "PEN"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://pendulumchain.org/"
    },
    {
        "prefix": 57,
        "network": "amplitude",
        "displayName": "Amplitude chain",
        "symbols": [
            "AMPE"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://pendulumchain.org/"
    },
    {
        "prefix": 63,
        "network": "hydradx",
        "displayName": "HydraDX",
        "symbols": [
            "HDX"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://hydradx.io"
    },
    {
        "prefix": 65,
        "network": "aventus",
        "displayName": "Aventus Mainnet",
        "symbols": [
            "AVT"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://aventus.io"
    },
    {
        "prefix": 66,
        "network": "crust",
        "displayName": "Crust Network",
        "symbols": [
            "CRU"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://crust.network"
    },
    {
        "prefix": 67,
        "network": "genshiro",
        "displayName": "Genshiro Network",
        "symbols": [
            "GENS",
            "EQD",
            "LPT0"
        ],
        "decimals": [
            9,
            9,
            9
        ],
        "standardAccount": "*25519",
        "website": "https://genshiro.equilibrium.io"
    },
    {
        "prefix": 68,
        "network": "equilibrium",
        "displayName": "Equilibrium Network",
        "symbols": [
            "EQ"
        ],
        "decimals": [
            9
        ],
        "standardAccount": "*25519",
        "website": "https://equilibrium.io"
    },
    {
        "prefix": 69,
        "network": "sora",
        "displayName": "SORA Network",
        "symbols": [
            "XOR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://sora.org"
    },
    {
        "prefix": 71,
        "network": "p3d",
        "displayName": "3DP network",
        "symbols": [
            "P3D"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://3dpass.org"
    },
    {
        "prefix": 72,
        "network": "p3dt",
        "displayName": "3DP test network",
        "symbols": [
            "P3Dt"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://3dpass.org"
    },
    {
        "prefix": 73,
        "network": "zeitgeist",
        "displayName": "Zeitgeist",
        "symbols": [
            "ZTG"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://zeitgeist.pm"
    },
    {
        "prefix": 77,
        "network": "manta",
        "displayName": "Manta network",
        "symbols": [
            "MANTA"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://manta.network"
    },
    {
        "prefix": 78,
        "network": "calamari",
        "displayName": "Calamari: Manta Canary Network",
        "symbols": [
            "KMA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://manta.network"
    },
    {
        "prefix": 81,
        "network": "sora_dot_para",
        "displayName": "SORA Polkadot Parachain",
        "symbols": [
            "XOR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://sora.org"
    },
    {
        "prefix": 88,
        "network": "polkadex",
        "displayName": "Polkadex Mainnet",
        "symbols": [
            "PDEX"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://polkadex.trade"
    },
    {
        "prefix": 89,
        "network": "polkadexparachain",
        "displayName": "Polkadex Parachain",
        "symbols": [
            "PDEX"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://polkadex.trade"
    },
    {
        "prefix": 90,
        "network": "frequency",
        "displayName": "Frequency",
        "symbols": [
            "FRQCY"
        ],
        "decimals": [
            8
        ],
        "standardAccount": "*25519",
        "website": "https://www.frequency.xyz"
    },
    {
        "prefix": 92,
        "network": "anmol",
        "displayName": "Anmol Network",
        "symbols": [
            "ANML"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://anmol.network/"
    },
    {
        "prefix": 93,
        "network": "fragnova",
        "displayName": "Fragnova Network",
        "symbols": [
            "NOVA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://fragnova.com"
    },
    {
        "prefix": 98,
        "network": "polkasmith",
        "displayName": "PolkaSmith Canary Network",
        "symbols": [
            "PKS"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://polkafoundry.com"
    },
    {
        "prefix": 99,
        "network": "polkafoundry",
        "displayName": "PolkaFoundry Network",
        "symbols": [
            "PKF"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://polkafoundry.com"
    },
    {
        "prefix": 100,
        "network": "ibtida",
        "displayName": "Anmol Network Ibtida Canary network",
        "symbols": [
            "IANML"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://anmol.network/"
    },
    {
        "prefix": 101,
        "network": "origintrail-parachain",
        "displayName": "OriginTrail Parachain",
        "symbols": [
            "OTP"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://parachain.origintrail.io/"
    },
    {
        "prefix": 105,
        "network": "pontem-network",
        "displayName": "Pontem Network",
        "symbols": [
            "PONT"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://pontem.network"
    },
    {
        "prefix": 110,
        "network": "heiko",
        "displayName": "Heiko",
        "symbols": [
            "HKO"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://parallel.fi/"
    },
    {
        "prefix": 113,
        "network": "integritee-incognito",
        "displayName": "Integritee Incognito",
        "symbols": [],
        "decimals": [],
        "standardAccount": "*25519",
        "website": "https://integritee.network"
    },
    {
        "prefix": 117,
        "network": "tinker",
        "displayName": "Tinker",
        "symbols": [
            "TNKR"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://invarch.network"
    },
    {
        "prefix": 126,
        "network": "joystream",
        "displayName": "Joystream",
        "symbols": [
            "JOY"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://www.joystream.org"
    },
    {
        "prefix": 128,
        "network": "clover",
        "displayName": "Clover Finance",
        "symbols": [
            "CLV"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://clover.finance"
    },
    {
        "prefix": 129,
        "network": "dorafactory-polkadot",
        "displayName": "Dorafactory Polkadot Network",
        "symbols": [
            "DORA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://dorafactory.org"
    },
    {
        "prefix": 131,
        "network": "litmus",
        "displayName": "Litmus Network",
        "symbols": [
            "LIT"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://litentry.com/"
    },
    {
        "prefix": 136,
        "network": "altair",
        "displayName": "Altair",
        "symbols": [
            "AIR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://centrifuge.io/"
    },
    {
        "prefix": 137,
        "network": "vara",
        "displayName": "Vara Network",
        "symbols": [
            "VARA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://vara-network.io/"
    },
    {
        "prefix": 172,
        "network": "parallel",
        "displayName": "Parallel",
        "symbols": [
            "PARA"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://parallel.fi/"
    },
    {
        "prefix": 252,
        "network": "social-network",
        "displayName": "Social Network",
        "symbols": [
            "NET"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://social.network"
    },
    {
        "prefix": 255,
        "network": "quartz_mainnet",
        "displayName": "QUARTZ by UNIQUE",
        "symbols": [
            "QTZ"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://unique.network"
    },
    {
        "prefix": 268,
        "network": "pioneer_network",
        "displayName": "Pioneer Network by Bit.Country",
        "symbols": [
            "NEER"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://bit.country"
    },
    {
        "prefix": 420,
        "network": "sora_kusama_para",
        "displayName": "SORA Kusama Parachain",
        "symbols": [
            "XOR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://sora.org"
    },
    {
        "prefix": 440,
        "network": "allfeat_network",
        "displayName": "Allfeat Network",
        "symbols": [
            "AFT"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://allfeat.network"
    },
    {
        "prefix": 789,
        "network": "geek",
        "displayName": "GEEK Network",
        "symbols": [
            "GEEK"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://geek.gl"
    },
    {
        "prefix": 995,
        "network": "ternoa",
        "displayName": "Ternoa",
        "symbols": [
            "CAPS"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://www.ternoa.network"
    },
    {
        "prefix": 1110,
        "network": "efinity",
        "displayName": "Efinity",
        "symbols": [
            "EFI"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://efinity.io/"
    },
    {
        "prefix": 1221,
        "network": "peaq",
        "displayName": "Peaq Network",
        "symbols": [
            "PEAQ"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "Sr25519",
        "website": "https://www.peaq.network/"
    },
    {
        "prefix": 1222,
        "network": "krest",
        "displayName": "Krest Network",
        "symbols": [
            "KREST"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "Sr25519",
        "website": "https://www.peaq.network/"
    },
    {
        "prefix": 1284,
        "network": "moonbeam",
        "displayName": "Moonbeam",
        "symbols": [
            "GLMR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "secp256k1",
        "website": "https://moonbeam.network"
    },
    {
        "prefix": 1285,
        "network": "moonriver",
        "displayName": "Moonriver",
        "symbols": [
            "MOVR"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "secp256k1",
        "website": "https://moonbeam.network"
    },
    {
        "prefix": 1328,
        "network": "ajuna",
        "displayName": "Ajuna Network",
        "symbols": [
            "AJUN"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://ajuna.io"
    },
    {
        "prefix": 1337,
        "network": "bajun",
        "displayName": "Bajun Network",
        "symbols": [
            "BAJU"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://ajuna.io"
    },
    {
        "prefix": 1516,
        "network": "societal",
        "displayName": "Societal",
        "symbols": [
            "SCTL"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://www.sctl.xyz"
    },
    {
        "prefix": 1985,
        "network": "seals",
        "displayName": "Seals Network",
        "symbols": [
            "SEAL"
        ],
        "decimals": [
            9
        ],
        "standardAccount": "*25519",
        "website": "https://seals.app"
    },
    {
        "prefix": 2007,
        "network": "kapex",
        "displayName": "Kapex",
        "symbols": [
            "KAPEX"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://totemaccounting.com"
    },
    {
        "prefix": 2009,
        "network": "cloudwalk_mainnet",
        "displayName": "CloudWalk Network Mainnet",
        "symbols": [
            "CWN"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://explorer.mainnet.cloudwalk.io"
    },
    {
        "prefix": 2021,
        "network": "logion",
        "displayName": "logion network",
        "symbols": [
            "LGNT"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://logion.network"
    },
    {
        "prefix": 2032,
        "network": "interlay",
        "displayName": "Interlay",
        "symbols": [
            "INTR"
        ],
        "decimals": [
            10
        ],
        "standardAccount": "*25519",
        "website": "https://interlay.io/"
    },
    {
        "prefix": 2092,
        "network": "kintsugi",
        "displayName": "Kintsugi",
        "symbols": [
            "KINT"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://interlay.io/"
    },
    {
        "prefix": 2106,
        "network": "bitgreen",
        "displayName": "Bitgreen",
        "symbols": [
            "BBB"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://bitgreen.org/"
    },
    {
        "prefix": 2112,
        "network": "chainflip",
        "displayName": "Chainflip",
        "symbols": [
            "FLIP"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://chainflip.io/"
    },
    {
        "prefix": 2199,
        "network": "moonsama",
        "displayName": "Moonsama",
        "symbols": [
            "SAMA"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "secp256k1",
        "website": "https://moonsama.com"
    },
    {
        "prefix": 2206,
        "network": "ICE",
        "displayName": "ICE Network",
        "symbols": [
            "ICY"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://icenetwork.io"
    },
    {
        "prefix": 2207,
        "network": "SNOW",
        "displayName": "SNOW: ICE Canary Network",
        "symbols": [
            "ICZ"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://icenetwork.io"
    },
    {
        "prefix": 2254,
        "network": "subspace_testnet",
        "displayName": "Subspace testnet",
        "symbols": [
            "tSSC"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://subspace.network"
    },
    {
        "prefix": 4006,
        "network": "tangle",
        "displayName": "Tangle Network",
        "symbols": [
            "TNT"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://www.webb.tools/"
    },
    {
        "prefix": 4450,
        "network": "g1",
        "displayName": "Ğ1",
        "symbols": [
            "G1"
        ],
        "decimals": [
            2
        ],
        "standardAccount": "*25519",
        "website": "https://duniter.org"
    },
    {
        "prefix": 5234,
        "network": "humanode",
        "displayName": "Humanode Network",
        "symbols": [
            "HMND"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://humanode.io"
    },
    {
        "prefix": 6094,
        "network": "subspace",
        "displayName": "Subspace",
        "symbols": [
            "SSC"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://subspace.network"
    },
    {
        "prefix": 7007,
        "network": "tidefi",
        "displayName": "Tidefi",
        "symbols": [
            "TDFY"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://tidefi.com"
    },
    {
        "prefix": 7013,
        "network": "gm",
        "displayName": "GM",
        "symbols": [
            "FREN",
            "GM",
            "GN"
        ],
        "decimals": [
            12,
            0,
            0
        ],
        "standardAccount": "*25519",
        "website": "https://gmordie.com"
    },
    {
        "prefix": 7391,
        "network": "unique_mainnet",
        "displayName": "Unique Network",
        "symbols": [
            "UNQ"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://unique.network"
    },
    {
        "prefix": 8866,
        "network": "golden_gate",
        "displayName": "Golden Gate",
        "symbols": [
            "GGX"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://ggxchain.io/"
    },
    {
        "prefix": 8883,
        "network": "sapphire_mainnet",
        "displayName": "Sapphire by Unique",
        "symbols": [
            "QTZ"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://unique.network"
    },
    {
        "prefix": 9072,
        "network": "hashed",
        "displayName": "Hashed Network",
        "symbols": [
            "HASH"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://hashed.network"
    },
    {
        "prefix": 9807,
        "network": "dentnet",
        "displayName": "DENTNet",
        "symbols": [
            "DENTX"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://www.dentnet.io"
    },
    {
        "prefix": 9935,
        "network": "t3rn",
        "displayName": "t3rn",
        "symbols": [
            "TRN"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://t3rn.io/"
    },
    {
        "prefix": 10041,
        "network": "basilisk",
        "displayName": "Basilisk",
        "symbols": [
            "BSX"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://bsx.fi"
    },
    {
        "prefix": 11330,
        "network": "cess-testnet",
        "displayName": "CESS Testnet",
        "symbols": [
            "TCESS"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://cess.cloud"
    },
    {
        "prefix": 11331,
        "network": "cess",
        "displayName": "CESS",
        "symbols": [
            "CESS"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://cess.cloud"
    },
    {
        "prefix": 11486,
        "network": "luhn",
        "displayName": "Luhn Network",
        "symbols": [
            "LUHN"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://luhn.network"
    },
    {
        "prefix": 11820,
        "network": "contextfree",
        "displayName": "Automata ContextFree",
        "symbols": [
            "CTX"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://ata.network"
    },
    {
        "prefix": 12155,
        "network": "impact",
        "displayName": "Impact Protocol Network",
        "symbols": [
            "BSTY"
        ],
        "decimals": [
            18
        ],
        "standardAccount": "*25519",
        "website": "https://impactprotocol.network/"
    },
    {
        "prefix": 12191,
        "network": "nftmart",
        "displayName": "NFTMart",
        "symbols": [
            "NMT"
        ],
        "decimals": [
            12
        ],
        "standardAccount": "*25519",
        "website": "https://nftmart.io"
    },
    {
        "prefix": 13116,
        "network": "bittensor",
        "displayName": "Bittensor",
        "symbols": [
            "TAO"
        ],
        "decimals": [
            9
        ],
        "standardAccount": "*25519",
        "website": "https://bittensor.com"
    }
];


const $221d520d3624fceb$export$5a4d9c086e2d7883 = {
    acala: [
        "0xfc41b9bd8ef8fe53d58c7ea67c794c7ec9a73daf05e6d54b14ff6342c99ba64c"
    ],
    ajuna: [
        "0xe358eb1d11b31255a286c12e44fe6780b7edb171d657905a97e39f71d9c6c3ee"
    ],
    "aleph-node": [
        "0x70255b4d28de0fc4e1a193d7e175ad1ccef431598211c55538f1018651a0344e"
    ],
    astar: [
        "0x9eb76c5184c4ab8679d2d5d819fdf90b9c001403e9e17da2e14b6d8aec4029c6"
    ],
    basilisk: [
        "0xa85cfb9b9fd4d622a5b28289a02347af987d8f73fa3108450e2b4a11c1ce5755"
    ],
    bifrost: [
        "0x262e1b2ad728475fd6fe88e62d34c200abe6fd693931ddad144059b1eb884e5b"
    ],
    "bifrost-kusama": [
        "0x9f28c6a68e0fc9646eff64935684f6eeeece527e37bbe1f213d22caa1d9d6bed"
    ],
    bittensor: [
        "0x2f0555cc76fc2840a25a6ea3b9637146806f1f44b090c175ffde2a7e5ab36c03"
    ],
    centrifuge: [
        "0xb3db41421702df9a7fcac62b53ffeac85f7853cc4e689e0b93aeb3db18c09d82",
        "0x67dddf2673b69e5f875f6f25277495834398eafd67f492e09f3f3345e003d1b5"
    ],
    cere: [
        "0x81443836a9a24caaa23f1241897d1235717535711d1d3fe24eae4fdc942c092c"
    ],
    composable: [
        "0xdaab8df776eb52ec604a5df5d388bb62a050a0aaec4556a64265b9d42755552d"
    ],
    darwinia: [
        "0xe71578b37a7c799b0ab4ee87ffa6f059a6b98f71f06fb8c84a8d88013a548ad6"
    ],
    "dock-mainnet": [
        "0x6bfe24dca2a3be10f22212678ac13a6446ec764103c0f3471c71609eac384aae",
        "0xf73467c6544aa68df2ee546b135f955c46b90fa627e9b5d7935f41061bb8a5a9"
    ],
    edgeware: [
        "0x742a2ca70c2fda6cee4f8df98d64c4c670a052d9568058982dad9d5a7a135c5b"
    ],
    equilibrium: [
        "0x6f1a800de3daff7f5e037ddf66ab22ce03ab91874debeddb1086f5f7dbd48925"
    ],
    genshiro: [
        "0x9b8cefc0eb5c568b527998bdd76c184e2b76ae561be76e4667072230217ea243"
    ],
    hydradx: [
        "0xafdc188f45c71dacbaa0b62e16a91f726c7b8699a9748cdf715459de6b7f366d",
        "0xd2a620c27ec5cbc5621ff9a522689895074f7cca0d08e7134a7804e1a3ba86fc",
        "0x10af6e84234477d84dc572bac0789813b254aa490767ed06fb9591191d1073f9",
        "0x3d75507dd46301767e601265791da1d9cb47b6ebc94e87347b635e5bf58bd047",
        "0x0ed32bfcab4a83517fac88f2aa7cbc2f88d3ab93be9a12b6188a036bf8a943c2" // Snakenet Gen1
    ],
    "interlay-parachain": [
        "0xbf88efe70e9e0e916416e8bed61f2b45717f517d7f3523e33c7b001e5ffcbc72"
    ],
    karura: [
        "0xbaf5aabe40646d11f0ee8abbdc64f4a4b7674925cba08e4a05ff9ebed6e2126b"
    ],
    khala: [
        "0xd43540ba6d3eb4897c28a77d48cb5b729fea37603cbbfc7a86a73b72adb3be8d"
    ],
    kulupu: [
        "0xf7a99d3cb92853d00d5275c971c132c074636256583fee53b3bbe60d7b8769ba"
    ],
    kusama: [
        "0xb0a8d493285c2df73290dfb7e61f870f17b41801197a149ca93654499ea3dafe",
        "0xe3777fa922cafbff200cadeaea1a76bd7898ad5b89f7848999058b50e715f636",
        "0x3fd7b9eb6a00376e5be61f01abb429ffb0b104be05eaff4d458da48fcd425baf" // Kusama CC1
    ],
    nodle: [
        "0x97da7ede98d7bad4e36b4d734b6055425a3be036da2a332ea5a7037656427a21"
    ],
    origintrail: [
        "0xe7e0962324a3b86c83404dbea483f25fb5dab4c224791c81b756cfc948006174"
    ],
    p3d: [
        "0x6c5894837ad89b6d92b114a2fb3eafa8fe3d26a54848e3447015442cd6ef4e66"
    ],
    parallel: [
        "0xe61a41c53f5dcd0beb09df93b34402aada44cb05117b71059cce40a2723a4e97"
    ],
    pendulum: [
        "0x5d3c298622d5634ed019bf61ea4b71655030015bde9beb0d6a24743714462c86"
    ],
    phala: [
        "0x1bb969d85965e4bb5a651abbedf21a54b6b31a21f66b5401cc3f1e286268d736"
    ],
    picasso: [
        "0x6811a339673c9daa897944dcdac99c6e2939cc88245ed21951a0a3c9a2be75bc",
        "0xe8e7f0f4c4f5a00720b4821dbfddefea7490bcf0b19009961cc46957984e2c1c"
    ],
    polkadex: [
        "0x3920bcb4960a1eef5580cd5367ff3f430eef052774f78468852f7b9cb39f8a3c"
    ],
    polkadot: [
        "0x91b171bb158e2d3848fa23a9f1c25182fb8e20313b2c1eb49219da7a70ce90c3"
    ],
    polymesh: [
        "0x6fbd74e5e1d0a61d52ccfe9d4adaed16dd3a7caa37c6bc4d0c2fa12e8b2f4063"
    ],
    rococo: [
        "0x6408de7737c59c238890533af25896a2c20608d8b380bb01029acb392781063e",
        "0xaaf2cd1b74b5f726895921259421b534124726263982522174147046b8827897",
        "0x037f5f3c8e67b314062025fc886fcd6238ea25a4a9b45dce8d246815c9ebe770",
        "0xc196f81260cf1686172b47a79cf002120735d7cb0eb1474e8adce56618456fff",
        "0xf6e9983c37baf68846fedafe21e56718790e39fb1c582abc408b81bc7b208f9a",
        "0x5fce687da39305dfe682b117f0820b319348e8bb37eb16cf34acbf6a202de9d9",
        "0xe7c3d5edde7db964317cd9b51a3a059d7cd99f81bdbce14990047354334c9779",
        "0x1611e1dbf0405379b861e2e27daa90f480b2e6d3682414a80835a52e8cb8a215",
        "0x343442f12fa715489a8714e79a7b264ea88c0d5b8c66b684a7788a516032f6b9",
        "0x78bcd530c6b3a068bc17473cf5d2aff9c287102bed9af3ae3c41c33b9d6c6147",
        "0x47381ee0697153d64404fc578392c8fd5cba9073391908f46c888498415647bd",
        "0x19c0e4fa8ab75f5ac7865e0b8f74ff91eb9a100d336f423cd013a8befba40299"
    ],
    sora: [
        "0x7e4e32d0feafd4f9c9414b0be86373f9a1efa904809b683453a9af6856d38ad5"
    ],
    stafi: [
        "0x290a4149f09ea0e402c74c1c7e96ae4239588577fe78932f94f5404c68243d80"
    ],
    statemine: [
        "0x48239ef607d7928874027a43a67689209727dfb3d3dc5e5b03a39bdc2eda771a"
    ],
    statemint: [
        "0x68d56f15f85d3136970ec16946040bc1752654e906147f7e43e9d539d7c3de2f"
    ],
    subsocial: [
        "0x0bd72c1c305172e1275278aaeb3f161e02eccb7a819e63f62d47bd53a28189f8"
    ],
    ternoa: [
        "0x6859c81ca95ef624c9dfe4dc6e3381c33e5d6509e35e147092bfbc780f777c4e"
    ],
    unique: [
        "0x84322d9cddbf35088f1e54e9a85c967a41a56a4f43445768125e61af166c7d31"
    ],
    vtb: [
        "0x286bc8414c7000ce1d6ee6a834e29a54c1784814b76243eb77ed0b2c5573c60f",
        "0x7483b89572fb2bd687c7b9a93b242d0b237f9aba463aba07ec24503931038aaa"
    ],
    westend: [
        "0xe143f23803ac50e8f6f8e62695d1ce9e4e1d68aa36c1cd2cfd15340213f3423e"
    ],
    xxnetwork: [
        "0x50dd5d206917bf10502c68fb4d18a59fc8aa31586f4e8856b493e43544aa82aa"
    ],
    zeitgeist: [
        "0x1bf2a2ecb4a868de66ea8610f2ce7c8c43706561b6476031315f6640fe38e060"
    ]
};

const $5084e93f38518313$export$1b2dd6e34fcff367 = {
    centrifuge: "polkadot",
    kusama: "polkadot",
    polkadot: "polkadot",
    sora: "polkadot",
    statemine: "polkadot",
    statemint: "polkadot",
    westmint: "polkadot"
};

const $5aa68976166db721$export$4454dde8b324e76f = {
    acala: 0x00000313,
    ajuna: 0x00000162,
    "aleph-node": 0x00000283,
    astar: 0x0000032a,
    bifrost: 0x00000314,
    "bifrost-kusama": 0x00000314,
    centrifuge: 0x000002eb,
    composable: 0x00000162,
    darwinia: 0x00000162,
    "dock-mainnet": 0x00000252,
    edgeware: 0x0000020b,
    equilibrium: 0x05f5e0fd,
    genshiro: 0x05f5e0fc,
    hydradx: 0x00000162,
    "interlay-parachain": 0x00000162,
    karura: 0x000002ae,
    khala: 0x000001b2,
    kusama: 0x000001b2,
    nodle: 0x000003eb,
    origintrail: 0x00000162,
    parallel: 0x00000162,
    pendulum: 0x00000162,
    phala: 0x00000162,
    picasso: 0x000001b2,
    polkadex: 0x0000031f,
    polkadot: 0x00000162,
    polymesh: 0x00000253,
    sora: 0x00000269,
    stafi: 0x0000038b,
    statemine: 0x000001b2,
    statemint: 0x00000162,
    ternoa: 0x00003e3,
    unique: 0x00000162,
    vtb: 0x000002b6,
    xxnetwork: 0x000007a3,
    zeitgeist: 0x00000162
};

const $7fb9ed9cf01b2f25$export$6cc4c2f1b56ab49e = {
    "": true,
    "cess-testnet": true,
    "dock-testnet": true,
    jupiter: true,
    "mathchain-testnet": true,
    p3dt: true,
    subspace_testnet: true,
    "zero-alphaville": true
};


const $ed4185bd04ce3f3f$var$UNSORTED = [
    0,
    2,
    42
];
const $ed4185bd04ce3f3f$var$TESTNETS = [
    "testnet"
];
function $ed4185bd04ce3f3f$var$toExpanded(o) {
    const network = o.network || "";
    const nameParts = network.replace(/_/g, "-").split("-");
    const n = o;
    // ledger additions
    n.slip44 = (0, $5aa68976166db721$export$4454dde8b324e76f)[network];
    n.hasLedgerSupport = !!n.slip44;
    // general items
    n.genesisHash = (0, $221d520d3624fceb$export$5a4d9c086e2d7883)[network] || [];
    n.icon = (0, $5084e93f38518313$export$1b2dd6e34fcff367)[network] || "substrate";
    // filtering
    n.isTestnet = !!(0, $7fb9ed9cf01b2f25$export$6cc4c2f1b56ab49e)[network] || $ed4185bd04ce3f3f$var$TESTNETS.includes(nameParts[nameParts.length - 1]);
    n.isIgnored = n.isTestnet || !(o.standardAccount && o.decimals && o.decimals.length && o.symbols && o.symbols.length) && o.prefix !== 42;
    return n;
}
function $ed4185bd04ce3f3f$var$filterSelectable({ genesisHash: genesisHash, prefix: prefix }) {
    return !!genesisHash.length || prefix === 42;
}
function $ed4185bd04ce3f3f$var$filterAvailable(n) {
    return !n.isIgnored && !!n.network;
}
function $ed4185bd04ce3f3f$var$sortNetworks(a, b) {
    const isUnSortedA = $ed4185bd04ce3f3f$var$UNSORTED.includes(a.prefix);
    const isUnSortedB = $ed4185bd04ce3f3f$var$UNSORTED.includes(b.prefix);
    return isUnSortedA === isUnSortedB ? isUnSortedA ? 0 : a.displayName.localeCompare(b.displayName) : isUnSortedA ? -1 : 1;
}
const $ed4185bd04ce3f3f$export$603455b6116637a6 = (0, $307c277086596e53$export$2e2bcd8739ae039).map($ed4185bd04ce3f3f$var$toExpanded);
const $ed4185bd04ce3f3f$export$337a7c3584aeadf8 = $ed4185bd04ce3f3f$export$603455b6116637a6.filter($ed4185bd04ce3f3f$var$filterAvailable).sort($ed4185bd04ce3f3f$var$sortNetworks);
const $ed4185bd04ce3f3f$export$e19aa740f1b5be6c = $ed4185bd04ce3f3f$export$337a7c3584aeadf8.filter($ed4185bd04ce3f3f$var$filterSelectable);


const $66c9f64587724316$export$ebe90cb607ad99e = {
    allowedDecodedLengths: [
        1,
        2,
        4,
        8,
        32,
        33
    ],
    // publicKey has prefix + 2 checksum bytes, short only prefix + 1 checksum byte
    allowedEncodedLengths: [
        3,
        4,
        6,
        10,
        35,
        36,
        37,
        38
    ],
    allowedPrefix: (0, $ed4185bd04ce3f3f$export$337a7c3584aeadf8).map(({ prefix: prefix })=>prefix),
    prefix: 42
};


function $75dfbb1cb93569bf$export$63e61a72b498228b(encoded, ignoreChecksum, ss58Format = -1) {
    if (!encoded) throw new Error("Invalid empty address passed");
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(encoded) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(encoded)) return (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(encoded);
    try {
        const decoded = (0, $3467763799979175$export$e42db48932fc32fe)(encoded);
        if (!(0, $66c9f64587724316$export$ebe90cb607ad99e).allowedEncodedLengths.includes(decoded.length)) throw new Error("Invalid decoded address length");
        const [isValid, endPos, ss58Length, ss58Decoded] = (0, $f4e722017630116e$export$3a8dea5969197010)(decoded);
        if (!isValid && !ignoreChecksum) throw new Error("Invalid decoded address checksum");
        else if (ss58Format !== -1 && ss58Format !== ss58Decoded) throw new Error(`Expected ss58Format ${ss58Format}, received ${ss58Decoded}`);
        return decoded.slice(ss58Length, endPos);
    } catch (error) {
        throw new Error(`Decoding ${encoded}: ${error.message}`);
    }
}






function $c22d2e6736a2594b$export$b149ba8ff44e4e70(key, ss58Format = (0, $66c9f64587724316$export$ebe90cb607ad99e).prefix) {
    // decode it, this means we can re-encode an address
    const u8a = (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(key);
    if (ss58Format < 0 || ss58Format > 16383 || [
        46,
        47
    ].includes(ss58Format)) throw new Error("Out of range ss58Format specified");
    else if (!(0, $66c9f64587724316$export$ebe90cb607ad99e).allowedDecodedLengths.includes(u8a.length)) throw new Error(`Expected a valid key to convert, with length ${(0, $66c9f64587724316$export$ebe90cb607ad99e).allowedDecodedLengths.join(", ")}`);
    const input = (0, $84207d7313fd2c40$export$7b640c40d4922c2e)(ss58Format < 64 ? [
        ss58Format
    ] : [
        (ss58Format & 252) >> 2 | 64,
        ss58Format >> 8 | (ss58Format & 3) << 6
    ], u8a);
    return (0, $3467763799979175$export$a025eb30fde2c140)((0, $84207d7313fd2c40$export$7b640c40d4922c2e)(input, (0, $abda4dab45d63660$export$532a1e05ac7e36e6)(input).subarray(0, [
        32,
        33
    ].includes(u8a.length) ? 2 : 1)));
}


/** @internal */ function $7033f80e9fd32a40$var$decodeAccountId(value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || Array.isArray(value)) return (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
    else if (!value) return new Uint8Array();
    else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(value);
    else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) return (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(value.toString());
    throw new Error(`Unknown type passed to AccountId constructor, found typeof ${typeof value}`);
}
class $7033f80e9fd32a40$var$BaseAccountId extends (0, $76cc74693eb215d2$export$e34e28991bc25e78) {
    constructor(registry, allowedBits = 264, value){
        const decoded = $7033f80e9fd32a40$var$decodeAccountId(value);
        const decodedBits = decoded.length * 8;
        // Part of stream containing >= 32 bytes or a all empty (defaults)
        if (decodedBits < allowedBits && decoded.some((b)=>b)) throw new Error(`Invalid AccountId provided, expected ${allowedBits >> 3} bytes, found ${decoded.length}`);
        super(registry, decoded, allowedBits);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return super.eq($7033f80e9fd32a40$var$decodeAccountId(other));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return (0, $c22d2e6736a2594b$export$b149ba8ff44e4e70)(this, this.registry.chainSS58);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "AccountId";
    }
}
class $7033f80e9fd32a40$export$e406ba10ba55d465 extends $7033f80e9fd32a40$var$BaseAccountId {
    constructor(registry, value){
        super(registry, 256, value);
    }
}
class $7033f80e9fd32a40$export$3ed682307d9a4c17 extends $7033f80e9fd32a40$var$BaseAccountId {
    constructor(registry, value){
        super(registry, 264, value);
    }
}




var $hWfed = parcelRequire("hWfed");

const $ee4318a517c11a72$var$PREFIX_1BYTE = 0xef;
const $ee4318a517c11a72$var$PREFIX_2BYTE = 0xfc;
const $ee4318a517c11a72$var$PREFIX_4BYTE = 0xfd;
const $ee4318a517c11a72$var$PREFIX_8BYTE = 0xfe;
const $ee4318a517c11a72$var$MAX_1BYTE = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))($ee4318a517c11a72$var$PREFIX_1BYTE);
const $ee4318a517c11a72$var$MAX_2BYTE = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1).shln(16);
const $ee4318a517c11a72$var$MAX_4BYTE = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1).shln(32);
/** @internal */ function $ee4318a517c11a72$var$decodeAccountIndex(value) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if (value instanceof $ee4318a517c11a72$export$32a6cf2b486c273e) // `value.toBn()` on AccountIndex returns a pure BN (i.e. not an
    // AccountIndex), which has the initial `toString()` implementation.
    return value.toBn();
    else if ((0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(value) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) || (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(value)) return value;
    return $ee4318a517c11a72$var$decodeAccountIndex((0, $75dfbb1cb93569bf$export$63e61a72b498228b)(value));
}
class $ee4318a517c11a72$export$32a6cf2b486c273e extends (0, $4d3a09ccc4a71677$export$8bacf4ad828c7fe7) {
    constructor(registry, value = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0)){
        super(registry, $ee4318a517c11a72$var$decodeAccountIndex(value));
    }
    static calcLength(_value) {
        const value = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(_value);
        if (value.lte($ee4318a517c11a72$var$MAX_1BYTE)) return 1;
        else if (value.lt($ee4318a517c11a72$var$MAX_2BYTE)) return 2;
        else if (value.lt($ee4318a517c11a72$var$MAX_4BYTE)) return 4;
        return 8;
    }
    static readLength(input) {
        const first = input[0];
        if (first === $ee4318a517c11a72$var$PREFIX_2BYTE) return [
            1,
            2
        ];
        else if (first === $ee4318a517c11a72$var$PREFIX_4BYTE) return [
            1,
            4
        ];
        else if (first === $ee4318a517c11a72$var$PREFIX_8BYTE) return [
            1,
            8
        ];
        return [
            0,
            1
        ];
    }
    static writeLength(input) {
        switch(input.length){
            case 2:
                return new Uint8Array([
                    $ee4318a517c11a72$var$PREFIX_2BYTE
                ]);
            case 4:
                return new Uint8Array([
                    $ee4318a517c11a72$var$PREFIX_4BYTE
                ]);
            case 8:
                return new Uint8Array([
                    $ee4318a517c11a72$var$PREFIX_8BYTE
                ]);
            default:
                return new Uint8Array([]);
        }
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        // shortcut for BN or Number, don't create an object
        if ((0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(other) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(other)) return super.eq(other);
        // convert and compare
        return super.eq(this.registry.createTypeUnsafe("AccountIndex", [
            other
        ]));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        const length = $ee4318a517c11a72$export$32a6cf2b486c273e.calcLength(this);
        return (0, $c22d2e6736a2594b$export$b149ba8ff44e4e70)(this.toU8a().subarray(0, length), this.registry.chainSS58);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "AccountIndex";
    }
}



class $72dcb295eed46340$export$ab64a881ee541178 extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value){
        super(registry, {
            header: "Header",
            // eslint-disable-next-line sort-keys
            extrinsics: "Vec<Extrinsic>"
        }, value);
    }
    /**
     * @description Encodes a content [[Hash]] for the block
     */ get contentHash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description The [[Extrinsic]] contained in the block
     */ get extrinsics() {
        return this.getT("extrinsics");
    }
    /**
     * @description Block/header [[Hash]]
     */ get hash() {
        return this.header.hash;
    }
    /**
     * @description The [[Header]] of the block
     */ get header() {
        return this.getT("header");
    }
}




/**
 * Get a mapping of `argument name -> argument type` for the function, from
 * its metadata.
 *
 * @param meta - The function metadata used to get the definition.
 * @internal
 */ function $b64d2846ef18c29b$var$getArgsDef(registry, meta) {
    return meta.fields.reduce((result, { name: name, type: type }, index)=>{
        result[name.unwrapOr(`param${index}`).toString()] = registry.createLookupType(type);
        return result;
    }, {});
}
/** @internal */ function $b64d2846ef18c29b$var$decodeCallViaObject(registry, value, _meta) {
    // we only pass args/methodsIndex out
    const { args: args, callIndex: callIndex } = value;
    // Get the correct lookupIndex
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const lookupIndex = callIndex instanceof $b64d2846ef18c29b$export$4b8c6b1e0a3636b5 ? callIndex.toU8a() : callIndex;
    // Find metadata with callIndex
    const meta = _meta || registry.findMetaCall(lookupIndex).meta;
    return {
        args: args,
        argsDef: $b64d2846ef18c29b$var$getArgsDef(registry, meta),
        callIndex: callIndex,
        meta: meta
    };
}
/** @internal */ function $b64d2846ef18c29b$var$decodeCallViaU8a(registry, value, _meta) {
    // We need 2 bytes for the callIndex
    const callIndex = registry.firstCallIndex.slice();
    callIndex.set(value.subarray(0, 2), 0);
    // Find metadata with callIndex
    const meta = _meta || registry.findMetaCall(callIndex).meta;
    return {
        args: value.subarray(2),
        argsDef: $b64d2846ef18c29b$var$getArgsDef(registry, meta),
        callIndex: callIndex,
        meta: meta
    };
}
/**
 * Decode input to pass into constructor.
 *
 * @param value - Value to decode, one of:
 * - hex
 * - Uint8Array
 * - {@see DecodeMethodInput}
 * @param _meta - Metadata to use, so that `injectMethods` lookup is not
 * necessary.
 * @internal
 */ function $b64d2846ef18c29b$var$decodeCall(registry, value = new Uint8Array(), _meta) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return $b64d2846ef18c29b$var$decodeCallViaU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), _meta);
    else if ((0, $75e63b2ba0788249$export$a6cdc56e425d0d0a)(value) && value.callIndex && value.args) return $b64d2846ef18c29b$var$decodeCallViaObject(registry, value, _meta);
    throw new Error(`Call: Cannot decode value '${value}' of type ${typeof value}`);
}
class $b64d2846ef18c29b$export$4b8c6b1e0a3636b5 extends (0, $76cc74693eb215d2$export$e34e28991bc25e78) {
    constructor(registry, value){
        super(registry, value, 16);
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toHex();
    }
}
class $b64d2846ef18c29b$export$8d29ed11b287d7e extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value, meta){
        const decoded = $b64d2846ef18c29b$var$decodeCall(registry, value, meta);
        try {
            super(registry, {
                callIndex: $b64d2846ef18c29b$export$4b8c6b1e0a3636b5,
                // eslint-disable-next-line sort-keys
                args: (0, $6552ecce3d7abdb5$export$eabc71f011df675a).with(decoded.argsDef)
            }, decoded);
        } catch (error) {
            let method = "unknown.unknown";
            try {
                const c = registry.findMetaCall(decoded.callIndex);
                method = `${c.section}.${c.method}`;
            } catch  {
            // ignore
            }
            throw new Error(`Call: failed decoding ${method}:: ${error.message}`);
        }
        this._meta = decoded.meta;
    }
    /**
     * @description The arguments for the function call
     */ get args() {
        return [
            ...this.getT("args").values()
        ];
    }
    /**
     * @description The argument definitions
     */ get argsDef() {
        return $b64d2846ef18c29b$var$getArgsDef(this.registry, this.meta);
    }
    /**
     * @description The argument entries
     */ get argsEntries() {
        return [
            ...this.getT("args").entries()
        ];
    }
    /**
     * @description The encoded `[sectionIndex, methodIndex]` identifier
     */ get callIndex() {
        return this.getT("callIndex").toU8a();
    }
    /**
     * @description The encoded data
     */ get data() {
        return this.getT("args").toU8a();
    }
    /**
     * @description The [[FunctionMetadata]]
     */ get meta() {
        return this._meta;
    }
    /**
     * @description Returns the name of the method
     */ get method() {
        return this.registry.findMetaCall(this.callIndex).method;
    }
    /**
     * @description Returns the module containing the method
     */ get section() {
        return this.registry.findMetaCall(this.callIndex).section;
    }
    /**
     * @description Checks if the source matches this in type
     */ is(other) {
        return other.callIndex[0] === this.callIndex[0] && other.callIndex[1] === this.callIndex[1];
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExpanded) {
        let call;
        try {
            call = this.registry.findMetaCall(this.callIndex);
        } catch  {
        // swallow
        }
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            args: this.argsEntries.reduce((args, [n, a])=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(args, {
                    [n]: a.toHuman(isExpanded)
                }), {}),
            method: call?.method,
            section: call?.section
        }, isExpanded && call ? {
            docs: call.meta.docs.map((d)=>d.toString())
        } : null);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Call";
    }
}




function $411f91694ccf9d16$var$createValue(registry, type, value, asArray = true) {
    // We detect codec here as well - when found, generally this is constructed from itself
    if (value && (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value.unwrapOrDefault)) return value;
    return registry.createTypeUnsafe(type, [
        asArray ? (0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(value) || (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(value) ? null : Array.isArray(value) ? value : [
            value
        ] : value
    ]);
}
function $411f91694ccf9d16$var$decodeValue(registry, key, value) {
    return key === "ss58Format" ? $411f91694ccf9d16$var$createValue(registry, "Option<u32>", value, false) : key === "tokenDecimals" ? $411f91694ccf9d16$var$createValue(registry, "Option<Vec<u32>>", value) : key === "tokenSymbol" ? $411f91694ccf9d16$var$createValue(registry, "Option<Vec<Text>>", value) : value;
}
function $411f91694ccf9d16$var$decode(registry, value) {
    return(// allow decoding from a map as well (ourselves)
    (value && (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value.entries) ? [
        ...value.entries()
    ] : Object.entries(value || {})).reduce((all, [key, value])=>{
        all[key] = $411f91694ccf9d16$var$decodeValue(registry, key, value);
        return all;
    }, {
        ss58Format: registry.createTypeUnsafe("Option<u32>", []),
        tokenDecimals: registry.createTypeUnsafe("Option<Vec<u32>>", []),
        tokenSymbol: registry.createTypeUnsafe("Option<Vec<Text>>", [])
    }));
}
class $411f91694ccf9d16$export$dd6d127d010710fc extends (0, $d36f0e8a198e6efb$export$48880ac635f47186) {
    constructor(registry, value){
        super(registry, $411f91694ccf9d16$var$decode(registry, value));
    }
    /**
     * @description The chain ss58Format
     */ get ss58Format() {
        return this.getT("ss58Format");
    }
    /**
     * @description The decimals for each of the tokens
     */ get tokenDecimals() {
        return this.getT("tokenDecimals");
    }
    /**
     * @description The symbols for the tokens
     */ get tokenSymbol() {
        return this.getT("tokenSymbol");
    }
}




var $hWfed = parcelRequire("hWfed");
const $57ed4489763a1ec1$export$b2c583cf6a0627f2 = /*#__PURE__*/ (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)("aura");
const $57ed4489763a1ec1$export$b47b0650ddd264b8 = /*#__PURE__*/ (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)("BABE");
const $57ed4489763a1ec1$export$28ee0e29ba930509 = /*#__PURE__*/ (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)("FRNK");
const $57ed4489763a1ec1$export$68009d6eeb193a3f = /*#__PURE__*/ (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)("pow_");
const $57ed4489763a1ec1$export$a6f7f7b84de6c9a6 = /*#__PURE__*/ (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)("nmbs");
function $57ed4489763a1ec1$var$getAuraAuthor(registry, bytes, sessionValidators) {
    return sessionValidators[registry.createTypeUnsafe("RawAuraPreDigest", [
        bytes.toU8a(true)
    ]).slotNumber.mod(new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(sessionValidators.length)).toNumber()];
}
function $57ed4489763a1ec1$var$getBabeAuthor(registry, bytes, sessionValidators) {
    const digest = registry.createTypeUnsafe("RawBabePreDigestCompat", [
        bytes.toU8a(true)
    ]);
    return sessionValidators[digest.value.toNumber()];
}
function $57ed4489763a1ec1$var$getBytesAsAuthor(registry, bytes) {
    return registry.createTypeUnsafe("AccountId", [
        bytes
    ]);
}
class $57ed4489763a1ec1$export$f8b18c3565f4d616 extends (0, $76cc74693eb215d2$export$e34e28991bc25e78) {
    constructor(registry, value){
        super(registry, (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value) ? (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(value, {
            isLe: false
        }) : value, 32);
    }
    /**
     * @description `true` if the engine matches aura
     */ get isAura() {
        return this.eq($57ed4489763a1ec1$export$b2c583cf6a0627f2);
    }
    /**
     * @description `true` is the engine matches babe
     */ get isBabe() {
        return this.eq($57ed4489763a1ec1$export$b47b0650ddd264b8);
    }
    /**
     * @description `true` is the engine matches grandpa
     */ get isGrandpa() {
        return this.eq($57ed4489763a1ec1$export$28ee0e29ba930509);
    }
    /**
     * @description `true` is the engine matches pow
     */ get isPow() {
        return this.eq($57ed4489763a1ec1$export$68009d6eeb193a3f);
    }
    /**
     * @description `true` is the engine matches nimbus
     */ get isNimbus() {
        return this.eq($57ed4489763a1ec1$export$a6f7f7b84de6c9a6);
    }
    /**
     * @description From the input bytes, decode into an author
     */ extractAuthor(bytes, sessionValidators) {
        if (sessionValidators?.length) {
            if (this.isAura) return $57ed4489763a1ec1$var$getAuraAuthor(this.registry, bytes, sessionValidators);
            else if (this.isBabe) return $57ed4489763a1ec1$var$getBabeAuthor(this.registry, bytes, sessionValidators);
        }
        // For pow & Nimbus, the bytes are the actual author
        if (this.isPow || this.isNimbus) return $57ed4489763a1ec1$var$getBytesAsAuthor(this.registry, bytes);
        return undefined;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toString();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "ConsensusEngineId";
    }
    /**
     * @description Override the default toString to return a 4-byte string
     */ toString() {
        return this.isAscii ? (0, $20f3a615a221edb7$export$792464756f58046b)(this) : (0, $1e2cfad286c009ca$export$4429d284633899e1)(this);
    }
}








const $d92d162775d1d441$export$b5b12d188966b9bb = new Uint8Array([
    0xff
]);
/** @internal */ function $d92d162775d1d441$var$decodeString(registry, value) {
    const decoded = (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(value);
    return decoded.length === 32 ? registry.createTypeUnsafe("AccountId", [
        decoded
    ]) : registry.createTypeUnsafe("AccountIndex", [
        (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(decoded)
    ]);
}
/** @internal */ function $d92d162775d1d441$var$decodeU8a(registry, value) {
    // This allows us to instantiate an address with a raw publicKey. Do this first before
    // we checking the first byte, otherwise we may split an already-existent valid address
    if (value.length === 32) return registry.createTypeUnsafe("AccountId", [
        value
    ]);
    else if (value[0] === 0xff) return registry.createTypeUnsafe("AccountId", [
        value.subarray(1)
    ]);
    const [offset, length] = (0, $ee4318a517c11a72$export$32a6cf2b486c273e).readLength(value);
    return registry.createTypeUnsafe("AccountIndex", [
        (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(value.subarray(offset, offset + length))
    ]);
}
/** @internal */ function $d92d162775d1d441$var$decodeAddressOrIndex(registry, value) {
    return value instanceof $d92d162775d1d441$export$544474b0017508b9 ? value.inner : value instanceof (0, $7033f80e9fd32a40$export$e406ba10ba55d465) || value instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? value : (0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(value) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value) || (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(value) ? registry.createTypeUnsafe("AccountIndex", [
        value
    ]) : Array.isArray(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) || (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? $d92d162775d1d441$var$decodeU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value)) : $d92d162775d1d441$var$decodeString(registry, value);
}
class $d92d162775d1d441$export$544474b0017508b9 extends (0, $5bac603f88334ac0$export$6d8c589c31247384) {
    constructor(registry, value = new Uint8Array()){
        super(registry, $d92d162775d1d441$var$decodeAddressOrIndex(registry, value));
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        const rawLength = this._rawLength;
        return rawLength + // for 1 byte AccountIndexes, we are not adding a specific prefix
        (rawLength > 1 ? 1 : 0);
    }
    /**
     * @description The length of the raw value, either AccountIndex or AccountId
     */ get _rawLength() {
        return this.inner instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? (0, $ee4318a517c11a72$export$32a6cf2b486c273e).calcLength(this.inner) : this.inner.encodedLength;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        const value = this.inner.toU8a().subarray(0, this._rawLength);
        return {
            outer: [
                new Uint8Array(this.inner instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? (0, $ee4318a517c11a72$export$32a6cf2b486c273e).writeLength(value) : $d92d162775d1d441$export$b5b12d188966b9bb),
                value
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Address";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const encoded = this.inner.toU8a().subarray(0, this._rawLength);
        return isBare ? encoded : (0, $84207d7313fd2c40$export$7b640c40d4922c2e)(this.inner instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? (0, $ee4318a517c11a72$export$32a6cf2b486c273e).writeLength(encoded) : $d92d162775d1d441$export$b5b12d188966b9bb, encoded);
    }
}







function $bdad1893038fd77b$var$decodeU8a(registry, u8a) {
    if ([
        0,
        32
    ].includes(u8a.length)) return {
        Id: u8a
    };
    else if (u8a.length === 20) return {
        Address20: u8a
    };
    else if (u8a.length <= 8) return {
        Index: registry.createTypeUnsafe("AccountIndex", [
            u8a
        ]).toNumber()
    };
    return u8a;
}
function $bdad1893038fd77b$var$decodeMultiAny(registry, value) {
    if (value instanceof (0, $7033f80e9fd32a40$export$e406ba10ba55d465)) return {
        Id: value
    };
    else if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) // NOTE This is after the AccountId check (which is U8a)
    return $bdad1893038fd77b$var$decodeU8a(registry, value);
    else if (value instanceof $bdad1893038fd77b$export$d6fe318e4151e13b) return value;
    else if (value instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) || (0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(value) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value)) return {
        Index: (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value) ? value : value.toNumber()
    };
    else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) return $bdad1893038fd77b$var$decodeU8a(registry, (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(value.toString()));
    return value;
}
class $bdad1893038fd77b$export$d6fe318e4151e13b extends (0, $533387422670f8b2$export$deb82508dd66d288) {
    constructor(registry, value){
        super(registry, {
            Id: "AccountId",
            Index: "Compact<AccountIndex>",
            Raw: "Bytes",
            // eslint-disable-next-line sort-keys
            Address32: "H256",
            // eslint-disable-next-line sort-keys
            Address20: "H160"
        }, $bdad1893038fd77b$var$decodeMultiAny(registry, value));
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        const { inner: inner, outer: outer = [] } = this.inner.inspect();
        return {
            inner: inner,
            outer: [
                new Uint8Array([
                    this.index
                ]),
                ...outer
            ]
        };
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.value.toString();
    }
}



class $933d8a6c938b665f$export$87b259aa03e3d267 extends Boolean {
    constructor(registry, value = false){
        super((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? value[0] === 1 : value instanceof Boolean ? value.valueOf() : !!value);
        this.initialU8aLength = 1;
        this.registry = registry;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return 1;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value (true when it wraps false/default)
     */ get isEmpty() {
        return this.isFalse;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */ get isFalse() {
        return !this.isTrue;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */ get isTrue() {
        return this.valueOf();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return this.valueOf() === (other instanceof Boolean ? other.valueOf() : other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.valueOf();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "bool";
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.toJSON().toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return new Uint8Array([
            this.valueOf() ? 1 : 0
        ]);
    }
}



const $5590538c09827e86$var$AYE_BITS = 128;
const $5590538c09827e86$var$NAY_BITS = 0;
const $5590538c09827e86$var$CON_MASK = 127;
const $5590538c09827e86$var$DEF_CONV = 0; // the default conviction, None
/** @internal */ function $5590538c09827e86$var$decodeVoteBool(value) {
    return value ? new Uint8Array([
        $5590538c09827e86$var$AYE_BITS | $5590538c09827e86$var$DEF_CONV
    ]) : new Uint8Array([
        $5590538c09827e86$var$NAY_BITS
    ]);
}
/** @internal */ function $5590538c09827e86$var$decodeVoteU8a(value) {
    return value.length ? value.subarray(0, 1) : new Uint8Array([
        $5590538c09827e86$var$NAY_BITS
    ]);
}
/** @internal */ function $5590538c09827e86$var$decodeVoteType(registry, value) {
    return new Uint8Array([
        (new (0, $933d8a6c938b665f$export$87b259aa03e3d267)(registry, value.aye).isTrue ? $5590538c09827e86$var$AYE_BITS : $5590538c09827e86$var$NAY_BITS) | registry.createTypeUnsafe("Conviction", [
            value.conviction || $5590538c09827e86$var$DEF_CONV
        ]).index
    ]);
}
/** @internal */ function $5590538c09827e86$var$decodeVote(registry, value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) return $5590538c09827e86$var$decodeVoteU8a(value);
    else if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(value) || value instanceof Boolean || (0, $a88f7b3165367a92$export$f9ce7b637dfbe238)(value)) return $5590538c09827e86$var$decodeVoteBool(new (0, $933d8a6c938b665f$export$87b259aa03e3d267)(registry, value).isTrue);
    else if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value)) return $5590538c09827e86$var$decodeVoteBool(value < 0);
    return $5590538c09827e86$var$decodeVoteType(registry, value);
}
class $5590538c09827e86$export$7a7552f4af8d9505 extends (0, $76cc74693eb215d2$export$e34e28991bc25e78) {
    constructor(registry, value){
        // decoded is just 1 byte
        // Aye: Most Significant Bit
        // Conviction: 0000 - 0101
        const decoded = $5590538c09827e86$var$decodeVote(registry, value);
        super(registry, decoded, 8);
        this.__internal__aye = (decoded[0] & $5590538c09827e86$var$AYE_BITS) === $5590538c09827e86$var$AYE_BITS;
        this.__internal__conviction = this.registry.createTypeUnsafe("Conviction", [
            decoded[0] & $5590538c09827e86$var$CON_MASK
        ]);
    }
    /**
     * @description returns a V2 conviction
     */ get conviction() {
        return this.__internal__conviction;
    }
    /**
     * @description true if the wrapped value is a positive vote
     */ get isAye() {
        return this.__internal__aye;
    }
    /**
     * @description true if the wrapped value is a negative vote
     */ get isNay() {
        return !this.isAye;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman(isExpanded) {
        return {
            conviction: this.conviction.toHuman(isExpanded),
            vote: this.isAye ? "Aye" : "Nay"
        };
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return {
            aye: this.isAye,
            conviction: this.conviction.toPrimitive()
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Vote";
    }
}


var $cf5660bf02148279$exports = {};

$parcel$export($cf5660bf02148279$exports, "GenericEthereumAccountId", function () { return $7870547f74ea7e67$export$5026960ee7b6c269; });
$parcel$export($cf5660bf02148279$exports, "GenericEthereumLookupSource", function () { return $cefc4eb3637607f4$export$de024aeb20ca9482; });



var $12f12dea11ea1f55$exports = {};
"use strict";
Object.defineProperty($12f12dea11ea1f55$exports, "__esModule", {
    value: true
});
$12f12dea11ea1f55$exports.shake256 = $12f12dea11ea1f55$exports.shake128 = $12f12dea11ea1f55$exports.keccak_512 = $12f12dea11ea1f55$exports.keccak_384 = $12f12dea11ea1f55$exports.keccak_256 = $12f12dea11ea1f55$exports.keccak_224 = $12f12dea11ea1f55$exports.sha3_512 = $12f12dea11ea1f55$exports.sha3_384 = $12f12dea11ea1f55$exports.sha3_256 = $12f12dea11ea1f55$exports.sha3_224 = $12f12dea11ea1f55$exports.Keccak = $12f12dea11ea1f55$exports.keccakP = void 0;



// Various per round constants calculations
const [$12f12dea11ea1f55$var$SHA3_PI, $12f12dea11ea1f55$var$SHA3_ROTL, $12f12dea11ea1f55$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $12f12dea11ea1f55$var$_0n = BigInt(0);
const $12f12dea11ea1f55$var$_1n = BigInt(1);
const $12f12dea11ea1f55$var$_2n = BigInt(2);
const $12f12dea11ea1f55$var$_7n = BigInt(7);
const $12f12dea11ea1f55$var$_256n = BigInt(256);
const $12f12dea11ea1f55$var$_0x71n = BigInt(0x71);
for(let round = 0, R = $12f12dea11ea1f55$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $12f12dea11ea1f55$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $12f12dea11ea1f55$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $12f12dea11ea1f55$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $12f12dea11ea1f55$var$_1n ^ (R >> $12f12dea11ea1f55$var$_7n) * $12f12dea11ea1f55$var$_0x71n) % $12f12dea11ea1f55$var$_256n;
        if (R & $12f12dea11ea1f55$var$_2n) t ^= $12f12dea11ea1f55$var$_1n << ($12f12dea11ea1f55$var$_1n << BigInt(j)) - $12f12dea11ea1f55$var$_1n;
    }
    $12f12dea11ea1f55$var$_SHA3_IOTA.push(t);
}
const [$12f12dea11ea1f55$var$SHA3_IOTA_H, $12f12dea11ea1f55$var$SHA3_IOTA_L] = $669e2d936b3f5daf$exports.default.split($12f12dea11ea1f55$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $12f12dea11ea1f55$var$rotlH = (h, l, s)=>s > 32 ? $669e2d936b3f5daf$exports.default.rotlBH(h, l, s) : $669e2d936b3f5daf$exports.default.rotlSH(h, l, s);
const $12f12dea11ea1f55$var$rotlL = (h, l, s)=>s > 32 ? $669e2d936b3f5daf$exports.default.rotlBL(h, l, s) : $669e2d936b3f5daf$exports.default.rotlSL(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $12f12dea11ea1f55$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $12f12dea11ea1f55$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $12f12dea11ea1f55$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $12f12dea11ea1f55$var$SHA3_ROTL[t];
            const Th = $12f12dea11ea1f55$var$rotlH(curH, curL, shift);
            const Tl = $12f12dea11ea1f55$var$rotlL(curH, curL, shift);
            const PI = $12f12dea11ea1f55$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $12f12dea11ea1f55$var$SHA3_IOTA_H[round];
        s[1] ^= $12f12dea11ea1f55$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$12f12dea11ea1f55$exports.keccakP = $12f12dea11ea1f55$var$keccakP;
class $12f12dea11ea1f55$var$Keccak extends $6d0c3b6cb2431a8d$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        $4b5a31cf14334437$exports.default.number(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $6d0c3b6cb2431a8d$exports.u32)(this.state);
    }
    keccak() {
        $12f12dea11ea1f55$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        $4b5a31cf14334437$exports.default.exists(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $6d0c3b6cb2431a8d$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        $4b5a31cf14334437$exports.default.exists(this, false);
        $4b5a31cf14334437$exports.default.bytes(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        $4b5a31cf14334437$exports.default.number(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        $4b5a31cf14334437$exports.default.output(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $12f12dea11ea1f55$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$12f12dea11ea1f55$exports.Keccak = $12f12dea11ea1f55$var$Keccak;
const $12f12dea11ea1f55$var$gen = (suffix, blockLen, outputLen)=>(0, $6d0c3b6cb2431a8d$exports.wrapConstructor)(()=>new $12f12dea11ea1f55$var$Keccak(blockLen, suffix, outputLen));
$12f12dea11ea1f55$exports.sha3_224 = $12f12dea11ea1f55$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $12f12dea11ea1f55$exports.sha3_256 = $12f12dea11ea1f55$var$gen(0x06, 136, 32);
$12f12dea11ea1f55$exports.sha3_384 = $12f12dea11ea1f55$var$gen(0x06, 104, 48);
$12f12dea11ea1f55$exports.sha3_512 = $12f12dea11ea1f55$var$gen(0x06, 72, 64);
$12f12dea11ea1f55$exports.keccak_224 = $12f12dea11ea1f55$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $12f12dea11ea1f55$exports.keccak_256 = $12f12dea11ea1f55$var$gen(0x01, 136, 32);
$12f12dea11ea1f55$exports.keccak_384 = $12f12dea11ea1f55$var$gen(0x01, 104, 48);
$12f12dea11ea1f55$exports.keccak_512 = $12f12dea11ea1f55$var$gen(0x01, 72, 64);
const $12f12dea11ea1f55$var$genShake = (suffix, blockLen, outputLen)=>(0, $6d0c3b6cb2431a8d$exports.wrapXOFConstructorWithOpts)((opts = {})=>new $12f12dea11ea1f55$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
$12f12dea11ea1f55$exports.shake128 = $12f12dea11ea1f55$var$genShake(0x1f, 168, 16);
$12f12dea11ea1f55$exports.shake256 = $12f12dea11ea1f55$var$genShake(0x1f, 136, 32);




const $304a3945ae31cb03$export$4486c3122e8167c8 = /*#__PURE__*/ (0, $84be3e8f12e6d11c$export$1b8e7c173b6f2602)({
    256: (0, $796b0ff58a262a5f$export$f8151fce47ad1c35),
    512: (0, $796b0ff58a262a5f$export$e432dfb0f2f2942f)
}, {
    256: (0, $12f12dea11ea1f55$exports.keccak_256),
    512: (0, $12f12dea11ea1f55$exports.keccak_512)
});
const $304a3945ae31cb03$export$3e8b501bea61b7c9 = /*#__PURE__*/ (0, $84be3e8f12e6d11c$export$6d7551883ed6dc0f)(256, $304a3945ae31cb03$export$4486c3122e8167c8);
const $304a3945ae31cb03$export$cfb15ed7a49804e0 = /*#__PURE__*/ (0, $84be3e8f12e6d11c$export$6d7551883ed6dc0f)(512, $304a3945ae31cb03$export$4486c3122e8167c8);
const $304a3945ae31cb03$export$832d141e05770bf5 = /*#__PURE__*/ (0, $84be3e8f12e6d11c$export$6e489b4cfdd62721)($304a3945ae31cb03$export$4486c3122e8167c8);


var $a72f742b76167dfe$exports = {};
"use strict";
Object.defineProperty($a72f742b76167dfe$exports, "__esModule", {
    value: true
});
$a72f742b76167dfe$exports.encodeToCurve = $a72f742b76167dfe$exports.hashToCurve = $a72f742b76167dfe$exports.schnorr = $a72f742b76167dfe$exports.secp256k1 = void 0;
var $98dce586acc9845a$exports = {};
"use strict";
Object.defineProperty($98dce586acc9845a$exports, "__esModule", {
    value: true
});
$98dce586acc9845a$exports.sha224 = $98dce586acc9845a$exports.sha256 = void 0;
var $2f59d9c969bd31e5$exports = {};
"use strict";
Object.defineProperty($2f59d9c969bd31e5$exports, "__esModule", {
    value: true
});
$2f59d9c969bd31e5$exports.SHA2 = void 0;


// Polyfill for Safari 14
function $2f59d9c969bd31e5$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $2f59d9c969bd31e5$var$SHA2 extends $6d0c3b6cb2431a8d$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $6d0c3b6cb2431a8d$exports.createView)(this.buffer);
    }
    update(data) {
        $4b5a31cf14334437$exports.default.exists(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $6d0c3b6cb2431a8d$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $6d0c3b6cb2431a8d$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        $4b5a31cf14334437$exports.default.exists(this);
        $4b5a31cf14334437$exports.default.output(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $2f59d9c969bd31e5$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $6d0c3b6cb2431a8d$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$2f59d9c969bd31e5$exports.SHA2 = $2f59d9c969bd31e5$var$SHA2;



// Choice: a ? b : c
const $98dce586acc9845a$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $98dce586acc9845a$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $98dce586acc9845a$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $98dce586acc9845a$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $98dce586acc9845a$var$SHA256_W = new Uint32Array(64);
class $98dce586acc9845a$var$SHA256 extends $2f59d9c969bd31e5$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $98dce586acc9845a$var$IV[0] | 0;
        this.B = $98dce586acc9845a$var$IV[1] | 0;
        this.C = $98dce586acc9845a$var$IV[2] | 0;
        this.D = $98dce586acc9845a$var$IV[3] | 0;
        this.E = $98dce586acc9845a$var$IV[4] | 0;
        this.F = $98dce586acc9845a$var$IV[5] | 0;
        this.G = $98dce586acc9845a$var$IV[6] | 0;
        this.H = $98dce586acc9845a$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$98dce586acc9845a$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $98dce586acc9845a$var$SHA256_W[i - 15];
            const W2 = $98dce586acc9845a$var$SHA256_W[i - 2];
            const s0 = (0, $6d0c3b6cb2431a8d$exports.rotr)(W15, 7) ^ (0, $6d0c3b6cb2431a8d$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $6d0c3b6cb2431a8d$exports.rotr)(W2, 17) ^ (0, $6d0c3b6cb2431a8d$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $98dce586acc9845a$var$SHA256_W[i] = s1 + $98dce586acc9845a$var$SHA256_W[i - 7] + s0 + $98dce586acc9845a$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $6d0c3b6cb2431a8d$exports.rotr)(E, 6) ^ (0, $6d0c3b6cb2431a8d$exports.rotr)(E, 11) ^ (0, $6d0c3b6cb2431a8d$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $98dce586acc9845a$var$Chi(E, F, G) + $98dce586acc9845a$var$SHA256_K[i] + $98dce586acc9845a$var$SHA256_W[i] | 0;
            const sigma0 = (0, $6d0c3b6cb2431a8d$exports.rotr)(A, 2) ^ (0, $6d0c3b6cb2431a8d$exports.rotr)(A, 13) ^ (0, $6d0c3b6cb2431a8d$exports.rotr)(A, 22);
            const T2 = sigma0 + $98dce586acc9845a$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $98dce586acc9845a$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $98dce586acc9845a$var$SHA224 extends $98dce586acc9845a$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $98dce586acc9845a$exports.sha256 = (0, $6d0c3b6cb2431a8d$exports.wrapConstructor)(()=>new $98dce586acc9845a$var$SHA256());
$98dce586acc9845a$exports.sha224 = (0, $6d0c3b6cb2431a8d$exports.wrapConstructor)(()=>new $98dce586acc9845a$var$SHA224());



var $943f3e3c0b3a111c$exports = {};
"use strict";
Object.defineProperty($943f3e3c0b3a111c$exports, "__esModule", {
    value: true
});
$943f3e3c0b3a111c$exports.hashToPrivateScalar = $943f3e3c0b3a111c$exports.FpSqrtEven = $943f3e3c0b3a111c$exports.FpSqrtOdd = $943f3e3c0b3a111c$exports.Field = $943f3e3c0b3a111c$exports.nLength = $943f3e3c0b3a111c$exports.FpIsSquare = $943f3e3c0b3a111c$exports.FpDiv = $943f3e3c0b3a111c$exports.FpInvertBatch = $943f3e3c0b3a111c$exports.FpPow = $943f3e3c0b3a111c$exports.validateField = $943f3e3c0b3a111c$exports.isNegativeLE = $943f3e3c0b3a111c$exports.FpSqrt = $943f3e3c0b3a111c$exports.tonelliShanks = $943f3e3c0b3a111c$exports.invert = $943f3e3c0b3a111c$exports.pow2 = $943f3e3c0b3a111c$exports.pow = $943f3e3c0b3a111c$exports.mod = void 0;
var $0aac66d9b71b3d5f$exports = {};
"use strict";
Object.defineProperty($0aac66d9b71b3d5f$exports, "__esModule", {
    value: true
});
$0aac66d9b71b3d5f$exports.validateObject = $0aac66d9b71b3d5f$exports.createHmacDrbg = $0aac66d9b71b3d5f$exports.bitMask = $0aac66d9b71b3d5f$exports.bitSet = $0aac66d9b71b3d5f$exports.bitGet = $0aac66d9b71b3d5f$exports.bitLen = $0aac66d9b71b3d5f$exports.utf8ToBytes = $0aac66d9b71b3d5f$exports.equalBytes = $0aac66d9b71b3d5f$exports.concatBytes = $0aac66d9b71b3d5f$exports.ensureBytes = $0aac66d9b71b3d5f$exports.numberToVarBytesBE = $0aac66d9b71b3d5f$exports.numberToBytesLE = $0aac66d9b71b3d5f$exports.numberToBytesBE = $0aac66d9b71b3d5f$exports.bytesToNumberLE = $0aac66d9b71b3d5f$exports.bytesToNumberBE = $0aac66d9b71b3d5f$exports.hexToBytes = $0aac66d9b71b3d5f$exports.hexToNumber = $0aac66d9b71b3d5f$exports.numberToHexUnpadded = $0aac66d9b71b3d5f$exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $0aac66d9b71b3d5f$var$_0n = BigInt(0);
const $0aac66d9b71b3d5f$var$_1n = BigInt(1);
const $0aac66d9b71b3d5f$var$_2n = BigInt(2);
const $0aac66d9b71b3d5f$var$u8a = (a)=>a instanceof Uint8Array;
const $0aac66d9b71b3d5f$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $0aac66d9b71b3d5f$var$bytesToHex(bytes) {
    if (!$0aac66d9b71b3d5f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $0aac66d9b71b3d5f$var$hexes[bytes[i]];
    return hex;
}
$0aac66d9b71b3d5f$exports.bytesToHex = $0aac66d9b71b3d5f$var$bytesToHex;
function $0aac66d9b71b3d5f$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
$0aac66d9b71b3d5f$exports.numberToHexUnpadded = $0aac66d9b71b3d5f$var$numberToHexUnpadded;
function $0aac66d9b71b3d5f$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
$0aac66d9b71b3d5f$exports.hexToNumber = $0aac66d9b71b3d5f$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $0aac66d9b71b3d5f$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$0aac66d9b71b3d5f$exports.hexToBytes = $0aac66d9b71b3d5f$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $0aac66d9b71b3d5f$var$bytesToNumberBE(bytes) {
    return $0aac66d9b71b3d5f$var$hexToNumber($0aac66d9b71b3d5f$var$bytesToHex(bytes));
}
$0aac66d9b71b3d5f$exports.bytesToNumberBE = $0aac66d9b71b3d5f$var$bytesToNumberBE;
function $0aac66d9b71b3d5f$var$bytesToNumberLE(bytes) {
    if (!$0aac66d9b71b3d5f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $0aac66d9b71b3d5f$var$hexToNumber($0aac66d9b71b3d5f$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
$0aac66d9b71b3d5f$exports.bytesToNumberLE = $0aac66d9b71b3d5f$var$bytesToNumberLE;
function $0aac66d9b71b3d5f$var$numberToBytesBE(n, len) {
    return $0aac66d9b71b3d5f$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
$0aac66d9b71b3d5f$exports.numberToBytesBE = $0aac66d9b71b3d5f$var$numberToBytesBE;
function $0aac66d9b71b3d5f$var$numberToBytesLE(n, len) {
    return $0aac66d9b71b3d5f$var$numberToBytesBE(n, len).reverse();
}
$0aac66d9b71b3d5f$exports.numberToBytesLE = $0aac66d9b71b3d5f$var$numberToBytesLE;
// Unpadded, rarely used
function $0aac66d9b71b3d5f$var$numberToVarBytesBE(n) {
    return $0aac66d9b71b3d5f$var$hexToBytes($0aac66d9b71b3d5f$var$numberToHexUnpadded(n));
}
$0aac66d9b71b3d5f$exports.numberToVarBytesBE = $0aac66d9b71b3d5f$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $0aac66d9b71b3d5f$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $0aac66d9b71b3d5f$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($0aac66d9b71b3d5f$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
$0aac66d9b71b3d5f$exports.ensureBytes = $0aac66d9b71b3d5f$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $0aac66d9b71b3d5f$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$0aac66d9b71b3d5f$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$0aac66d9b71b3d5f$exports.concatBytes = $0aac66d9b71b3d5f$var$concatBytes;
function $0aac66d9b71b3d5f$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
$0aac66d9b71b3d5f$exports.equalBytes = $0aac66d9b71b3d5f$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $0aac66d9b71b3d5f$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$0aac66d9b71b3d5f$exports.utf8ToBytes = $0aac66d9b71b3d5f$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $0aac66d9b71b3d5f$var$bitLen(n) {
    let len;
    for(len = 0; n > $0aac66d9b71b3d5f$var$_0n; n >>= $0aac66d9b71b3d5f$var$_1n, len += 1);
    return len;
}
$0aac66d9b71b3d5f$exports.bitLen = $0aac66d9b71b3d5f$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $0aac66d9b71b3d5f$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $0aac66d9b71b3d5f$var$_1n;
}
$0aac66d9b71b3d5f$exports.bitGet = $0aac66d9b71b3d5f$var$bitGet;
/**
 * Sets single bit at position.
 */ const $0aac66d9b71b3d5f$var$bitSet = (n, pos, value)=>{
    return n | (value ? $0aac66d9b71b3d5f$var$_1n : $0aac66d9b71b3d5f$var$_0n) << BigInt(pos);
};
$0aac66d9b71b3d5f$exports.bitSet = $0aac66d9b71b3d5f$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $0aac66d9b71b3d5f$var$bitMask = (n)=>($0aac66d9b71b3d5f$var$_2n << BigInt(n - 1)) - $0aac66d9b71b3d5f$var$_1n;
$0aac66d9b71b3d5f$exports.bitMask = $0aac66d9b71b3d5f$var$bitMask;
// DRBG
const $0aac66d9b71b3d5f$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $0aac66d9b71b3d5f$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $0aac66d9b71b3d5f$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $0aac66d9b71b3d5f$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $0aac66d9b71b3d5f$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $0aac66d9b71b3d5f$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($0aac66d9b71b3d5f$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($0aac66d9b71b3d5f$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $0aac66d9b71b3d5f$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
$0aac66d9b71b3d5f$exports.createHmacDrbg = $0aac66d9b71b3d5f$var$createHmacDrbg;
// Validating curves and fields
const $0aac66d9b71b3d5f$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $0aac66d9b71b3d5f$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $0aac66d9b71b3d5f$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
$0aac66d9b71b3d5f$exports.validateObject = $0aac66d9b71b3d5f$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });


// prettier-ignore
const $943f3e3c0b3a111c$var$_0n = BigInt(0), $943f3e3c0b3a111c$var$_1n = BigInt(1), $943f3e3c0b3a111c$var$_2n = BigInt(2), $943f3e3c0b3a111c$var$_3n = BigInt(3);
// prettier-ignore
const $943f3e3c0b3a111c$var$_4n = BigInt(4), $943f3e3c0b3a111c$var$_5n = BigInt(5), $943f3e3c0b3a111c$var$_8n = BigInt(8);
// prettier-ignore
const $943f3e3c0b3a111c$var$_9n = BigInt(9), $943f3e3c0b3a111c$var$_16n = BigInt(16);
// Calculates a modulo b
function $943f3e3c0b3a111c$var$mod(a, b) {
    const result = a % b;
    return result >= $943f3e3c0b3a111c$var$_0n ? result : b + result;
}
$943f3e3c0b3a111c$exports.mod = $943f3e3c0b3a111c$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $943f3e3c0b3a111c$var$pow(num, power, modulo) {
    if (modulo <= $943f3e3c0b3a111c$var$_0n || power < $943f3e3c0b3a111c$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $943f3e3c0b3a111c$var$_1n) return $943f3e3c0b3a111c$var$_0n;
    let res = $943f3e3c0b3a111c$var$_1n;
    while(power > $943f3e3c0b3a111c$var$_0n){
        if (power & $943f3e3c0b3a111c$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $943f3e3c0b3a111c$var$_1n;
    }
    return res;
}
$943f3e3c0b3a111c$exports.pow = $943f3e3c0b3a111c$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $943f3e3c0b3a111c$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $943f3e3c0b3a111c$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
$943f3e3c0b3a111c$exports.pow2 = $943f3e3c0b3a111c$var$pow2;
// Inverses number over modulo
function $943f3e3c0b3a111c$var$invert(number, modulo) {
    if (number === $943f3e3c0b3a111c$var$_0n || modulo <= $943f3e3c0b3a111c$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $943f3e3c0b3a111c$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $943f3e3c0b3a111c$var$_0n, y = $943f3e3c0b3a111c$var$_1n, u = $943f3e3c0b3a111c$var$_1n, v = $943f3e3c0b3a111c$var$_0n;
    while(a !== $943f3e3c0b3a111c$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $943f3e3c0b3a111c$var$_1n) throw new Error("invert: does not exist");
    return $943f3e3c0b3a111c$var$mod(x, modulo);
}
$943f3e3c0b3a111c$exports.invert = $943f3e3c0b3a111c$var$invert;
// Tonelli-Shanks algorithm
// Paper 1: https://eprint.iacr.org/2012/685.pdf (page 12)
// Paper 2: Square Roots from 1; 24, 51, 10 to Dan Shanks
function $943f3e3c0b3a111c$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $943f3e3c0b3a111c$var$_1n) / $943f3e3c0b3a111c$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $943f3e3c0b3a111c$var$_1n, S = 0; Q % $943f3e3c0b3a111c$var$_2n === $943f3e3c0b3a111c$var$_0n; Q /= $943f3e3c0b3a111c$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $943f3e3c0b3a111c$var$_2n; Z < P && $943f3e3c0b3a111c$var$pow(Z, legendreC, P) !== P - $943f3e3c0b3a111c$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $943f3e3c0b3a111c$var$_1n) / $943f3e3c0b3a111c$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $943f3e3c0b3a111c$var$_1n) / $943f3e3c0b3a111c$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $943f3e3c0b3a111c$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
$943f3e3c0b3a111c$exports.tonelliShanks = $943f3e3c0b3a111c$var$tonelliShanks;
function $943f3e3c0b3a111c$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $943f3e3c0b3a111c$var$_4n === $943f3e3c0b3a111c$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $943f3e3c0b3a111c$var$_1n) / $943f3e3c0b3a111c$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $943f3e3c0b3a111c$var$_8n === $943f3e3c0b3a111c$var$_5n) {
        const c1 = (P - $943f3e3c0b3a111c$var$_5n) / $943f3e3c0b3a111c$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $943f3e3c0b3a111c$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $943f3e3c0b3a111c$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    $943f3e3c0b3a111c$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $943f3e3c0b3a111c$var$tonelliShanks(P);
}
$943f3e3c0b3a111c$exports.FpSqrt = $943f3e3c0b3a111c$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $943f3e3c0b3a111c$var$isNegativeLE = (num, modulo)=>($943f3e3c0b3a111c$var$mod(num, modulo) & $943f3e3c0b3a111c$var$_1n) === $943f3e3c0b3a111c$var$_1n;
$943f3e3c0b3a111c$exports.isNegativeLE = $943f3e3c0b3a111c$var$isNegativeLE;
// prettier-ignore
const $943f3e3c0b3a111c$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $943f3e3c0b3a111c$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $943f3e3c0b3a111c$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $0aac66d9b71b3d5f$exports.validateObject)(field, opts);
}
$943f3e3c0b3a111c$exports.validateField = $943f3e3c0b3a111c$var$validateField;
// Generic field functions
function $943f3e3c0b3a111c$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $943f3e3c0b3a111c$var$_0n) throw new Error("Expected power > 0");
    if (power === $943f3e3c0b3a111c$var$_0n) return f.ONE;
    if (power === $943f3e3c0b3a111c$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $943f3e3c0b3a111c$var$_0n){
        if (power & $943f3e3c0b3a111c$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $943f3e3c0b3a111c$var$_1n;
    }
    return p;
}
$943f3e3c0b3a111c$exports.FpPow = $943f3e3c0b3a111c$var$FpPow;
// 0 is non-invertible: non-batched version will throw on 0
function $943f3e3c0b3a111c$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
$943f3e3c0b3a111c$exports.FpInvertBatch = $943f3e3c0b3a111c$var$FpInvertBatch;
function $943f3e3c0b3a111c$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $943f3e3c0b3a111c$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
$943f3e3c0b3a111c$exports.FpDiv = $943f3e3c0b3a111c$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $943f3e3c0b3a111c$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $943f3e3c0b3a111c$var$_1n) / $943f3e3c0b3a111c$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
$943f3e3c0b3a111c$exports.FpIsSquare = $943f3e3c0b3a111c$var$FpIsSquare;
// CURVE.n lengths
function $943f3e3c0b3a111c$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
$943f3e3c0b3a111c$exports.nLength = $943f3e3c0b3a111c$var$nLength;
/**
 * Initializes a galois field over prime. Non-primes are not supported for now.
 * Do not init in loop: slow. Very fragile: always run a benchmark on change.
 * Major performance gains:
 * a) non-normalized operations like mulN instead of mul
 * b) `Object.freeze`
 * c) Same object shape: never add or remove keys
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $943f3e3c0b3a111c$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $943f3e3c0b3a111c$var$_0n) throw new Error(`Expected Fp ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $943f3e3c0b3a111c$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $943f3e3c0b3a111c$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $0aac66d9b71b3d5f$exports.bitMask)(BITS),
        ZERO: $943f3e3c0b3a111c$var$_0n,
        ONE: $943f3e3c0b3a111c$var$_1n,
        create: (num)=>$943f3e3c0b3a111c$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $943f3e3c0b3a111c$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $943f3e3c0b3a111c$var$_0n,
        isOdd: (num)=>(num & $943f3e3c0b3a111c$var$_1n) === $943f3e3c0b3a111c$var$_1n,
        neg: (num)=>$943f3e3c0b3a111c$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$943f3e3c0b3a111c$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$943f3e3c0b3a111c$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$943f3e3c0b3a111c$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$943f3e3c0b3a111c$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$943f3e3c0b3a111c$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$943f3e3c0b3a111c$var$mod(lhs * $943f3e3c0b3a111c$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$943f3e3c0b3a111c$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$943f3e3c0b3a111c$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $0aac66d9b71b3d5f$exports.numberToBytesLE)(num, BYTES) : (0, $0aac66d9b71b3d5f$exports.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $0aac66d9b71b3d5f$exports.bytesToNumberLE)(bytes) : (0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
$943f3e3c0b3a111c$exports.Field = $943f3e3c0b3a111c$var$Field;
function $943f3e3c0b3a111c$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
$943f3e3c0b3a111c$exports.FpSqrtOdd = $943f3e3c0b3a111c$var$FpSqrtOdd;
function $943f3e3c0b3a111c$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
$943f3e3c0b3a111c$exports.FpSqrtEven = $943f3e3c0b3a111c$var$FpSqrtEven;
/**
 * FIPS 186 B.4.1-compliant "constant-time" private key generation utility.
 * Can take (n+8) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 40 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. curveFn.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $943f3e3c0b3a111c$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $943f3e3c0b3a111c$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $0aac66d9b71b3d5f$exports.bytesToNumberLE)(hash) : (0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)(hash);
    return $943f3e3c0b3a111c$var$mod(num, groupOrder - $943f3e3c0b3a111c$var$_1n) + $943f3e3c0b3a111c$var$_1n;
}
$943f3e3c0b3a111c$exports.hashToPrivateScalar = $943f3e3c0b3a111c$var$hashToPrivateScalar;


var $0cfe434b5ea903a9$exports = {};
"use strict";
Object.defineProperty($0cfe434b5ea903a9$exports, "__esModule", {
    value: true
});
$0cfe434b5ea903a9$exports.mapToCurveSimpleSWU = $0cfe434b5ea903a9$exports.SWUFpSqrtRatio = $0cfe434b5ea903a9$exports.weierstrass = $0cfe434b5ea903a9$exports.weierstrassPoints = $0cfe434b5ea903a9$exports.DER = void 0;



var $99142b785df184bb$exports = {};
"use strict";
Object.defineProperty($99142b785df184bb$exports, "__esModule", {
    value: true
});
$99142b785df184bb$exports.validateBasic = $99142b785df184bb$exports.wNAF = void 0;


const $99142b785df184bb$var$_0n = BigInt(0);
const $99142b785df184bb$var$_1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function $99142b785df184bb$var$wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > $99142b785df184bb$var$_0n){
                if (n & $99142b785df184bb$var$_1n) p = p.add(d);
                d = d.double();
                n >>= $99142b785df184bb$var$_1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows: windows, windowSize: windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows: windows, windowSize: windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += $99142b785df184bb$var$_1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
$99142b785df184bb$exports.wNAF = $99142b785df184bb$var$wNAF;
function $99142b785df184bb$var$validateBasic(curve) {
    (0, $943f3e3c0b3a111c$exports.validateField)(curve.Fp);
    (0, $0aac66d9b71b3d5f$exports.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $943f3e3c0b3a111c$exports.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
$99142b785df184bb$exports.validateBasic = $99142b785df184bb$var$validateBasic;


function $0cfe434b5ea903a9$var$validatePointOpts(curve) {
    const opts = (0, $99142b785df184bb$exports.validateBasic)(curve);
    $0aac66d9b71b3d5f$exports.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $0cfe434b5ea903a9$var$b2n, hexToBytes: $0cfe434b5ea903a9$var$h2b } = $0aac66d9b71b3d5f$exports;
$0cfe434b5ea903a9$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $0cfe434b5ea903a9$exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $0cfe434b5ea903a9$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $0cfe434b5ea903a9$exports.DER;
        const data = typeof hex === "string" ? $0cfe434b5ea903a9$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $0cfe434b5ea903a9$exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $0cfe434b5ea903a9$exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $0cfe434b5ea903a9$var$_0n = BigInt(0), $0cfe434b5ea903a9$var$_1n = BigInt(1), $0cfe434b5ea903a9$var$_2n = BigInt(2), $0cfe434b5ea903a9$var$_3n = BigInt(3), $0cfe434b5ea903a9$var$_4n = BigInt(4);
function $0cfe434b5ea903a9$var$weierstrassPoints(opts) {
    const CURVE = $0cfe434b5ea903a9$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((c, point, isCompressed)=>{
        const a = point.toAffine();
        return $0aac66d9b71b3d5f$exports.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $0cfe434b5ea903a9$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $0aac66d9b71b3d5f$exports.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $0aac66d9b71b3d5f$exports.bytesToNumberBE((0, $0aac66d9b71b3d5f$exports.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $943f3e3c0b3a111c$exports.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $0aac66d9b71b3d5f$exports.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            // Zero is valid point too!
            if (this.is0()) {
                if (CURVE.allowInfinityPoint) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $0cfe434b5ea903a9$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $0cfe434b5ea903a9$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $0cfe434b5ea903a9$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $0cfe434b5ea903a9$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $0cfe434b5ea903a9$var$_0n || k2 > $0cfe434b5ea903a9$var$_0n){
                if (k1 & $0cfe434b5ea903a9$var$_1n) k1p = k1p.add(d);
                if (k2 & $0cfe434b5ea903a9$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $0cfe434b5ea903a9$var$_1n;
                k2 >>= $0cfe434b5ea903a9$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $0cfe434b5ea903a9$var$_0n || a === $0cfe434b5ea903a9$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $0cfe434b5ea903a9$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $0cfe434b5ea903a9$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $0aac66d9b71b3d5f$exports.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $99142b785df184bb$exports.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
$0cfe434b5ea903a9$exports.weierstrassPoints = $0cfe434b5ea903a9$var$weierstrassPoints;
function $0cfe434b5ea903a9$var$validateOpts(curve) {
    const opts = (0, $99142b785df184bb$exports.validateBasic)(curve);
    $0aac66d9b71b3d5f$exports.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $0cfe434b5ea903a9$var$weierstrass(curveDef) {
    const CURVE = $0cfe434b5ea903a9$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $0cfe434b5ea903a9$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $943f3e3c0b3a111c$exports.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $943f3e3c0b3a111c$exports.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $0cfe434b5ea903a9$var$weierstrassPoints({
        ...CURVE,
        toBytes (c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $0aac66d9b71b3d5f$exports.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $0aac66d9b71b3d5f$exports.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $0cfe434b5ea903a9$var$_1n) === $0cfe434b5ea903a9$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$0aac66d9b71b3d5f$exports.bytesToHex($0aac66d9b71b3d5f$exports.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $0cfe434b5ea903a9$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$0aac66d9b71b3d5f$exports.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $0cfe434b5ea903a9$exports.DER.toSig((0, $0aac66d9b71b3d5f$exports.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $0aac66d9b71b3d5f$exports.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $0aac66d9b71b3d5f$exports.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $0cfe434b5ea903a9$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $0aac66d9b71b3d5f$exports.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size (nBitLength+64)
         * as per FIPS 186 B.4.1 with modulo bias being neglible.
         */ randomPrivateKey: ()=>{
            const rand = CURVE.randomBytes(Fp.BYTES + 8);
            const num = $943f3e3c0b3a111c$exports.hashToPrivateScalar(rand, CURVE_ORDER);
            return $0aac66d9b71b3d5f$exports.numberToBytesBE(num, CURVE.nByteLength);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $0aac66d9b71b3d5f$exports.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $0aac66d9b71b3d5f$exports.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($0cfe434b5ea903a9$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $0aac66d9b71b3d5f$exports.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $0aac66d9b71b3d5f$exports.ensureBytes)("extraEntropy", e, Fp.BYTES)); // check for being of size BYTES
        }
        const seed = $0aac66d9b71b3d5f$exports.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $0cfe434b5ea903a9$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $0cfe434b5ea903a9$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $0cfe434b5ea903a9$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $0aac66d9b71b3d5f$exports.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $0cfe434b5ea903a9$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
$0cfe434b5ea903a9$exports.weierstrass = $0cfe434b5ea903a9$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $0cfe434b5ea903a9$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $0cfe434b5ea903a9$var$_0n;
    for(let o = q - $0cfe434b5ea903a9$var$_1n; o % $0cfe434b5ea903a9$var$_2n === $0cfe434b5ea903a9$var$_0n; o /= $0cfe434b5ea903a9$var$_2n)l += $0cfe434b5ea903a9$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $0cfe434b5ea903a9$var$_2n << c1 - $0cfe434b5ea903a9$var$_1n - $0cfe434b5ea903a9$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $0cfe434b5ea903a9$var$_2n;
    const c2 = (q - $0cfe434b5ea903a9$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $0cfe434b5ea903a9$var$_1n) / $0cfe434b5ea903a9$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $0cfe434b5ea903a9$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $0cfe434b5ea903a9$var$_1n) / $0cfe434b5ea903a9$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $0cfe434b5ea903a9$var$_1n; i--){
            let tv5 = i - $0cfe434b5ea903a9$var$_2n; // 18.    tv5 = i - 2
            tv5 = $0cfe434b5ea903a9$var$_2n << tv5 - $0cfe434b5ea903a9$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $0cfe434b5ea903a9$var$_4n === $0cfe434b5ea903a9$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $0cfe434b5ea903a9$var$_3n) / $0cfe434b5ea903a9$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
$0cfe434b5ea903a9$exports.SWUFpSqrtRatio = $0cfe434b5ea903a9$var$SWUFpSqrtRatio;
/**
 * From draft-irtf-cfrg-hash-to-curve-16
 */ function $0cfe434b5ea903a9$var$mapToCurveSimpleSWU(Fp, opts) {
    $943f3e3c0b3a111c$exports.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $0cfe434b5ea903a9$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
$0cfe434b5ea903a9$exports.mapToCurveSimpleSWU = $0cfe434b5ea903a9$var$mapToCurveSimpleSWU;



var $ae23f9749457f14b$exports = {};
"use strict";
Object.defineProperty($ae23f9749457f14b$exports, "__esModule", {
    value: true
});
$ae23f9749457f14b$exports.createHasher = $ae23f9749457f14b$exports.isogenyMap = $ae23f9749457f14b$exports.hash_to_field = $ae23f9749457f14b$exports.expand_message_xof = $ae23f9749457f14b$exports.expand_message_xmd = void 0;


function $ae23f9749457f14b$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $0aac66d9b71b3d5f$exports.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $ae23f9749457f14b$var$os2ip = $0aac66d9b71b3d5f$exports.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $ae23f9749457f14b$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $ae23f9749457f14b$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $ae23f9749457f14b$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $ae23f9749457f14b$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-11#section-5.4.1
function $ae23f9749457f14b$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $ae23f9749457f14b$var$isBytes(msg);
    $ae23f9749457f14b$var$isBytes(DST);
    $ae23f9749457f14b$var$isNum(lenInBytes);
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-5.3.3
    if (DST.length > 255) DST = H((0, $0aac66d9b71b3d5f$exports.concatBytes)((0, $0aac66d9b71b3d5f$exports.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $0aac66d9b71b3d5f$exports.concatBytes)(DST, $ae23f9749457f14b$var$i2osp(DST.length, 1));
    const Z_pad = $ae23f9749457f14b$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $ae23f9749457f14b$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $0aac66d9b71b3d5f$exports.concatBytes)(Z_pad, msg, l_i_b_str, $ae23f9749457f14b$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $0aac66d9b71b3d5f$exports.concatBytes)(b_0, $ae23f9749457f14b$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $ae23f9749457f14b$var$strxor(b_0, b[i - 1]),
            $ae23f9749457f14b$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $0aac66d9b71b3d5f$exports.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $0aac66d9b71b3d5f$exports.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
$ae23f9749457f14b$exports.expand_message_xmd = $ae23f9749457f14b$var$expand_message_xmd;
function $ae23f9749457f14b$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $ae23f9749457f14b$var$isBytes(msg);
    $ae23f9749457f14b$var$isBytes(DST);
    $ae23f9749457f14b$var$isNum(lenInBytes);
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $0aac66d9b71b3d5f$exports.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($ae23f9749457f14b$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($ae23f9749457f14b$var$i2osp(DST.length, 1)).digest();
}
$ae23f9749457f14b$exports.expand_message_xof = $ae23f9749457f14b$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-11#section-5.3
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $ae23f9749457f14b$var$hash_to_field(msg, count, options) {
    (0, $0aac66d9b71b3d5f$exports.validateObject)(options, {
        DST: "string",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $ae23f9749457f14b$var$isBytes(msg);
    $ae23f9749457f14b$var$isNum(count);
    const DST = $ae23f9749457f14b$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $ae23f9749457f14b$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $ae23f9749457f14b$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $943f3e3c0b3a111c$exports.mod)($ae23f9749457f14b$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
$ae23f9749457f14b$exports.hash_to_field = $ae23f9749457f14b$var$hash_to_field;
function $ae23f9749457f14b$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
$ae23f9749457f14b$exports.isogenyMap = $ae23f9749457f14b$var$isogenyMap;
function $ae23f9749457f14b$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve
        // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
        hashToCurve (msg, options) {
            const u = $ae23f9749457f14b$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
        encodeToCurve (msg, options) {
            const u = $ae23f9749457f14b$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
$ae23f9749457f14b$exports.createHasher = $ae23f9749457f14b$var$createHasher;


var $a07694dc8ede188c$exports = {};
"use strict";
Object.defineProperty($a07694dc8ede188c$exports, "__esModule", {
    value: true
});
$a07694dc8ede188c$exports.createCurve = $a07694dc8ede188c$exports.getHash = void 0;
var $92381c290b36cdbc$exports = {};
"use strict";
Object.defineProperty($92381c290b36cdbc$exports, "__esModule", {
    value: true
});
$92381c290b36cdbc$exports.hmac = $92381c290b36cdbc$exports.HMAC = void 0;


// HMAC (RFC 2104)
class $92381c290b36cdbc$var$HMAC extends $6d0c3b6cb2431a8d$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        $4b5a31cf14334437$exports.default.hash(hash);
        const key = (0, $6d0c3b6cb2431a8d$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        $4b5a31cf14334437$exports.default.exists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        $4b5a31cf14334437$exports.default.exists(this);
        $4b5a31cf14334437$exports.default.bytes(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$92381c290b36cdbc$exports.HMAC = $92381c290b36cdbc$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $92381c290b36cdbc$var$hmac = (hash, key, message)=>new $92381c290b36cdbc$var$HMAC(hash, key).update(message).digest();
$92381c290b36cdbc$exports.hmac = $92381c290b36cdbc$var$hmac;
$92381c290b36cdbc$exports.hmac.create = (hash, key)=>new $92381c290b36cdbc$var$HMAC(hash, key);




// connects noble-curves to noble-hashes
function $a07694dc8ede188c$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $92381c290b36cdbc$exports.hmac)(hash, key, (0, $6d0c3b6cb2431a8d$exports.concatBytes)(...msgs)),
        randomBytes: $6d0c3b6cb2431a8d$exports.randomBytes
    };
}
$a07694dc8ede188c$exports.getHash = $a07694dc8ede188c$var$getHash;
function $a07694dc8ede188c$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $0cfe434b5ea903a9$exports.weierstrass)({
            ...curveDef,
            ...$a07694dc8ede188c$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
$a07694dc8ede188c$exports.createCurve = $a07694dc8ede188c$var$createCurve;


const $a72f742b76167dfe$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $a72f742b76167dfe$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $a72f742b76167dfe$var$_1n = BigInt(1);
const $a72f742b76167dfe$var$_2n = BigInt(2);
const $a72f742b76167dfe$var$divNearest = (a, b)=>(a + b / $a72f742b76167dfe$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $a72f742b76167dfe$var$sqrtMod(y) {
    const P = $a72f742b76167dfe$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $943f3e3c0b3a111c$exports.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $943f3e3c0b3a111c$exports.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $943f3e3c0b3a111c$exports.pow2)(b9, $a72f742b76167dfe$var$_2n, P) * b2 % P;
    const b22 = (0, $943f3e3c0b3a111c$exports.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $943f3e3c0b3a111c$exports.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $943f3e3c0b3a111c$exports.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $943f3e3c0b3a111c$exports.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $943f3e3c0b3a111c$exports.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $943f3e3c0b3a111c$exports.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $943f3e3c0b3a111c$exports.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $943f3e3c0b3a111c$exports.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $943f3e3c0b3a111c$exports.pow2)(t2, $a72f742b76167dfe$var$_2n, P);
    if (!$a72f742b76167dfe$var$Fp.eql($a72f742b76167dfe$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $a72f742b76167dfe$var$Fp = (0, $943f3e3c0b3a111c$exports.Field)($a72f742b76167dfe$var$secp256k1P, undefined, undefined, {
    sqrt: $a72f742b76167dfe$var$sqrtMod
});
$a72f742b76167dfe$exports.secp256k1 = (0, $a07694dc8ede188c$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $a72f742b76167dfe$var$Fp,
    n: $a72f742b76167dfe$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $a72f742b76167dfe$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$a72f742b76167dfe$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $a72f742b76167dfe$var$divNearest(b2 * k, n);
            const c2 = $a72f742b76167dfe$var$divNearest(-b1 * k, n);
            let k1 = (0, $943f3e3c0b3a111c$exports.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $943f3e3c0b3a111c$exports.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $98dce586acc9845a$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $a72f742b76167dfe$var$_0n = BigInt(0);
const $a72f742b76167dfe$var$fe = (x)=>typeof x === "bigint" && $a72f742b76167dfe$var$_0n < x && x < $a72f742b76167dfe$var$secp256k1P;
const $a72f742b76167dfe$var$ge = (x)=>typeof x === "bigint" && $a72f742b76167dfe$var$_0n < x && x < $a72f742b76167dfe$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $a72f742b76167dfe$var$TAGGED_HASH_PREFIXES = {};
function $a72f742b76167dfe$var$taggedHash(tag, ...messages) {
    let tagP = $a72f742b76167dfe$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $98dce586acc9845a$exports.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $0aac66d9b71b3d5f$exports.concatBytes)(tagH, tagH);
        $a72f742b76167dfe$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $98dce586acc9845a$exports.sha256)((0, $0aac66d9b71b3d5f$exports.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $a72f742b76167dfe$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $a72f742b76167dfe$var$numTo32b = (n)=>(0, $0aac66d9b71b3d5f$exports.numberToBytesBE)(n, 32);
const $a72f742b76167dfe$var$modP = (x)=>(0, $943f3e3c0b3a111c$exports.mod)(x, $a72f742b76167dfe$var$secp256k1P);
const $a72f742b76167dfe$var$modN = (x)=>(0, $943f3e3c0b3a111c$exports.mod)(x, $a72f742b76167dfe$var$secp256k1N);
const $a72f742b76167dfe$var$Point = $a72f742b76167dfe$exports.secp256k1.ProjectivePoint;
const $a72f742b76167dfe$var$GmulAdd = (Q, a, b)=>$a72f742b76167dfe$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $a72f742b76167dfe$var$schnorrGetExtPubKey(priv) {
    let d_ = $a72f742b76167dfe$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $a72f742b76167dfe$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $a72f742b76167dfe$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $a72f742b76167dfe$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $a72f742b76167dfe$var$lift_x(x) {
    if (!$a72f742b76167dfe$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $a72f742b76167dfe$var$modP(x * x);
    const c = $a72f742b76167dfe$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $a72f742b76167dfe$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $a72f742b76167dfe$var$_2n !== $a72f742b76167dfe$var$_0n) y = $a72f742b76167dfe$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $a72f742b76167dfe$var$Point(x, y, $a72f742b76167dfe$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $a72f742b76167dfe$var$challenge(...args) {
    return $a72f742b76167dfe$var$modN((0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)($a72f742b76167dfe$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $a72f742b76167dfe$var$schnorrGetPublicKey(privateKey) {
    return $a72f742b76167dfe$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $a72f742b76167dfe$var$schnorrSign(message, privateKey, auxRand = (0, $6d0c3b6cb2431a8d$exports.randomBytes)(32)) {
    const m = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $a72f742b76167dfe$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $a72f742b76167dfe$var$numTo32b(d ^ (0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)($a72f742b76167dfe$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $a72f742b76167dfe$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $a72f742b76167dfe$var$modN((0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $a72f742b76167dfe$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $a72f742b76167dfe$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $a72f742b76167dfe$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($a72f742b76167dfe$var$numTo32b($a72f742b76167dfe$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$a72f742b76167dfe$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $a72f742b76167dfe$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("signature", signature, 64);
    const m = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("message", message);
    const pub = (0, $0aac66d9b71b3d5f$exports.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $a72f742b76167dfe$var$lift_x((0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$a72f742b76167dfe$var$fe(r)) return false;
        const s = (0, $0aac66d9b71b3d5f$exports.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$a72f742b76167dfe$var$ge(s)) return false;
        const e = $a72f742b76167dfe$var$challenge($a72f742b76167dfe$var$numTo32b(r), $a72f742b76167dfe$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $a72f742b76167dfe$var$GmulAdd(P, s, $a72f742b76167dfe$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$a72f742b76167dfe$exports.schnorr = (()=>({
        getPublicKey: $a72f742b76167dfe$var$schnorrGetPublicKey,
        sign: $a72f742b76167dfe$var$schnorrSign,
        verify: $a72f742b76167dfe$var$schnorrVerify,
        utils: {
            randomPrivateKey: $a72f742b76167dfe$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $a72f742b76167dfe$var$lift_x,
            pointToBytes: $a72f742b76167dfe$var$pointToBytes,
            numberToBytesBE: $0aac66d9b71b3d5f$exports.numberToBytesBE,
            bytesToNumberBE: $0aac66d9b71b3d5f$exports.bytesToNumberBE,
            taggedHash: $a72f742b76167dfe$var$taggedHash,
            mod: $943f3e3c0b3a111c$exports.mod
        }
    }))();
const $a72f742b76167dfe$var$isoMap = /* @__PURE__ */ (()=>(0, $ae23f9749457f14b$exports.isogenyMap)($a72f742b76167dfe$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $a72f742b76167dfe$var$mapSWU = /* @__PURE__ */ (()=>(0, $0cfe434b5ea903a9$exports.mapToCurveSimpleSWU)($a72f742b76167dfe$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $a72f742b76167dfe$var$Fp.create(BigInt("-11"))
    }))();
const $a72f742b76167dfe$var$htf = /* @__PURE__ */ (()=>(0, $ae23f9749457f14b$exports.createHasher)($a72f742b76167dfe$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $a72f742b76167dfe$var$mapSWU($a72f742b76167dfe$var$Fp.create(scalars[0]));
        return $a72f742b76167dfe$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $a72f742b76167dfe$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $98dce586acc9845a$exports.sha256
    }))();
$a72f742b76167dfe$exports.hashToCurve = (()=>$a72f742b76167dfe$var$htf.hashToCurve)();
$a72f742b76167dfe$exports.encodeToCurve = (()=>$a72f742b76167dfe$var$htf.encodeToCurve)();




const $5a154fa197cf8b23$export$724e27015b517b85 = {
    isLe: false
};
const $5a154fa197cf8b23$export$b0a7224376870f92 = {
    isLe: true
};
const $5a154fa197cf8b23$export$b57e37712f64522c = {
    bitLength: 16,
    isLe: true
};
const $5a154fa197cf8b23$export$97356aaaff20accf = {
    bitLength: 32,
    isLe: false
};
const $5a154fa197cf8b23$export$c94d7cbf9ebd5cdc = {
    bitLength: 32,
    isLe: true
};
const $5a154fa197cf8b23$export$2f812cffe0ad0ae3 = {
    bitLength: 256,
    isLe: false
};
const $5a154fa197cf8b23$export$b57283eb2772eead = {
    bitLength: 256,
    isLe: true
};
const $5a154fa197cf8b23$export$76758233a2953f7a = {
    bitLength: 512,
    isLe: true
};


function $551a556d7a8def35$export$aeb350b8636aeb32(publicKey, onlyJs) {
    if (![
        33,
        65
    ].includes(publicKey.length)) throw new Error(`Invalid publicKey provided, received ${publicKey.length} bytes input`);
    if (publicKey.length === 65) return publicKey.subarray(1);
    if (!(0, $6574c8753d85e60c$export$c50f41259082745b) || !onlyJs && (0, $796b0ff58a262a5f$export$af3c031fde264cc6)()) return (0, $796b0ff58a262a5f$export$aeb350b8636aeb32)(publicKey).subarray(1);
    const { px: px, py: py } = (0, $a72f742b76167dfe$exports.secp256k1).ProjectivePoint.fromHex(publicKey);
    return (0, $84207d7313fd2c40$export$7b640c40d4922c2e)((0, $71bf0c7f6110fade$export$9a0110536a1deb74)(px, (0, $5a154fa197cf8b23$export$2f812cffe0ad0ae3)), (0, $71bf0c7f6110fade$export$9a0110536a1deb74)(py, (0, $5a154fa197cf8b23$export$2f812cffe0ad0ae3)));
}


function $f91b87c3e225bdcf$var$getH160(u8a) {
    if ([
        33,
        65
    ].includes(u8a.length)) u8a = (0, $304a3945ae31cb03$export$4486c3122e8167c8)((0, $551a556d7a8def35$export$aeb350b8636aeb32)(u8a));
    return u8a.slice(-20);
}
function $f91b87c3e225bdcf$export$2d4f4037b7611bc7(addressOrPublic) {
    if (!addressOrPublic) return "0x";
    const u8aAddress = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(addressOrPublic);
    if (![
        20,
        32,
        33,
        65
    ].includes(u8aAddress.length)) throw new Error(`Invalid address or publicKey provided, received ${u8aAddress.length} bytes input`);
    const address = (0, $1e2cfad286c009ca$export$4429d284633899e1)($f91b87c3e225bdcf$var$getH160(u8aAddress), -1, false);
    const hash = (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $304a3945ae31cb03$export$4486c3122e8167c8)(address), -1, false);
    let result = "";
    for(let i = 0; i < 40; i++)result = `${result}${parseInt(hash[i], 16) > 7 ? address[i].toUpperCase() : address[i]}`;
    return `0x${result}`;
}




function $1fca92c2d265aff7$var$isInvalidChar(char, byte) {
    return char !== (byte > 7 ? char.toUpperCase() : char.toLowerCase());
}
function $1fca92c2d265aff7$export$c9d7ba5ff8134798(_address) {
    const address = _address.replace("0x", "");
    const hash = (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $304a3945ae31cb03$export$4486c3122e8167c8)(address.toLowerCase()), -1, false);
    for(let i = 0; i < 40; i++){
        if ($1fca92c2d265aff7$var$isInvalidChar(address[i], parseInt(hash[i], 16))) return false;
    }
    return true;
}


function $449dc664b8ac3cbd$export$fc2df6336ba07c5f(address) {
    if (!address || address.length !== 42 || !(0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(address)) return false;
    else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) return true;
    return (0, $1fca92c2d265aff7$export$c9d7ba5ff8134798)(address);
}


/** @internal */ function $7870547f74ea7e67$var$decodeAccountId(value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || Array.isArray(value)) return (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
    else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) || (0, $449dc664b8ac3cbd$export$fc2df6336ba07c5f)(value.toString())) return (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(value.toString());
    else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) return (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
    return value;
}
class $7870547f74ea7e67$export$5026960ee7b6c269 extends (0, $76cc74693eb215d2$export$e34e28991bc25e78) {
    constructor(registry, value = new Uint8Array()){
        super(registry, $7870547f74ea7e67$var$decodeAccountId(value), 160);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return !!other && super.eq($7870547f74ea7e67$var$decodeAccountId(other));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return (0, $f91b87c3e225bdcf$export$2d4f4037b7611bc7)(this);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "AccountId";
    }
}







const $cefc4eb3637607f4$export$b5b12d188966b9bb = new Uint8Array([
    0xff
]);
/** @internal */ function $cefc4eb3637607f4$var$decodeString(registry, value) {
    const decoded = (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(value);
    return decoded.length === 20 ? registry.createTypeUnsafe("EthereumAccountId", [
        decoded
    ]) : registry.createTypeUnsafe("AccountIndex", [
        (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(decoded)
    ]);
}
/** @internal */ function $cefc4eb3637607f4$var$decodeU8a(registry, value) {
    // This allows us to instantiate an address with a raw publicKey. Do this first before
    // we checking the first byte, otherwise we may split an already-existent valid address
    if (value.length === 20) return registry.createTypeUnsafe("EthereumAccountId", [
        value
    ]);
    else if (value[0] === 0xff) return registry.createTypeUnsafe("EthereumAccountId", [
        value.subarray(1)
    ]);
    const [offset, length] = (0, $ee4318a517c11a72$export$32a6cf2b486c273e).readLength(value);
    return registry.createTypeUnsafe("AccountIndex", [
        (0, $f4a17f42fdd6b3ea$export$28994b5b8e65520b)(value.subarray(offset, offset + length))
    ]);
}
function $cefc4eb3637607f4$var$decodeAddressOrIndex(registry, value) {
    return value instanceof $cefc4eb3637607f4$export$de024aeb20ca9482 ? value.inner : value instanceof (0, $7870547f74ea7e67$export$5026960ee7b6c269) || value instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? value : (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || Array.isArray(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? $cefc4eb3637607f4$var$decodeU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value)) : (0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(value) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(value) || (0, $cf647a5c8604c19c$export$c4c1bdb0d1c7cfc7)(value) ? registry.createTypeUnsafe("AccountIndex", [
        value
    ]) : $cefc4eb3637607f4$var$decodeString(registry, value);
}
class $cefc4eb3637607f4$export$de024aeb20ca9482 extends (0, $5bac603f88334ac0$export$6d8c589c31247384) {
    constructor(registry, value = new Uint8Array()){
        super(registry, $cefc4eb3637607f4$var$decodeAddressOrIndex(registry, value));
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        const rawLength = this._rawLength;
        return rawLength + // for 1 byte AccountIndexes, we are not adding a specific prefix
        (rawLength > 1 ? 1 : 0);
    }
    /**
     * @description The length of the raw value, either AccountIndex or AccountId
     */ get _rawLength() {
        return this.inner instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? (0, $ee4318a517c11a72$export$32a6cf2b486c273e).calcLength(this.inner) : this.inner.encodedLength;
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Address";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const encoded = this.inner.toU8a().subarray(0, this._rawLength);
        return isBare ? encoded : (0, $84207d7313fd2c40$export$7b640c40d4922c2e)(this.inner instanceof (0, $ee4318a517c11a72$export$32a6cf2b486c273e) ? (0, $ee4318a517c11a72$export$32a6cf2b486c273e).writeLength(encoded) : $cefc4eb3637607f4$export$b5b12d188966b9bb, encoded);
    }
}




$parcel$exportWildcard($5ea38cbe6563a36b$exports, $cf5660bf02148279$exports);


var $382efb02151ee08c$exports = {};

$parcel$export($382efb02151ee08c$exports, "BitVec", function () { return $6c7728456d398541$export$2954f430c28ec0f0; });
$parcel$export($382efb02151ee08c$exports, "Bool", function () { return $933d8a6c938b665f$export$87b259aa03e3d267; });
$parcel$export($382efb02151ee08c$exports, "bool", function () { return $933d8a6c938b665f$export$87b259aa03e3d267; });
$parcel$export($382efb02151ee08c$exports, "Bytes", function () { return $6af5ed30500c41f2$export$9f55f2e2bf8c2fc1; });
$parcel$export($382efb02151ee08c$exports, "F32", function () { return $2276e7165fe04d30$export$e33361ff41014190; });
$parcel$export($382efb02151ee08c$exports, "f32", function () { return $2276e7165fe04d30$export$e33361ff41014190; });
$parcel$export($382efb02151ee08c$exports, "F64", function () { return $a59cf4249a20b332$export$eda3f5d9b9872690; });
$parcel$export($382efb02151ee08c$exports, "f64", function () { return $a59cf4249a20b332$export$eda3f5d9b9872690; });
$parcel$export($382efb02151ee08c$exports, "I8", function () { return $bbf149afbc431034$export$9ad68ccef5e52093; });
$parcel$export($382efb02151ee08c$exports, "i8", function () { return $bbf149afbc431034$export$9ad68ccef5e52093; });
$parcel$export($382efb02151ee08c$exports, "I16", function () { return $a378fa3a01c74898$export$941bd9d09c20518; });
$parcel$export($382efb02151ee08c$exports, "i16", function () { return $a378fa3a01c74898$export$941bd9d09c20518; });
$parcel$export($382efb02151ee08c$exports, "I32", function () { return $55d022a480b453e7$export$b71748db06371c77; });
$parcel$export($382efb02151ee08c$exports, "i32", function () { return $55d022a480b453e7$export$b71748db06371c77; });
$parcel$export($382efb02151ee08c$exports, "I64", function () { return $8c2db57457d40132$export$350f5a4edd618094; });
$parcel$export($382efb02151ee08c$exports, "i64", function () { return $8c2db57457d40132$export$350f5a4edd618094; });
$parcel$export($382efb02151ee08c$exports, "I128", function () { return $6e51b375de4e6673$export$77f6394270c638a1; });
$parcel$export($382efb02151ee08c$exports, "i128", function () { return $6e51b375de4e6673$export$77f6394270c638a1; });
$parcel$export($382efb02151ee08c$exports, "I256", function () { return $abc7c0c77285aa50$export$c4e13e6ea93f4e65; });
$parcel$export($382efb02151ee08c$exports, "i256", function () { return $abc7c0c77285aa50$export$c4e13e6ea93f4e65; });
$parcel$export($382efb02151ee08c$exports, "ISize", function () { return $a916b4688d7563ce$export$d3939c12e00078c4; });
$parcel$export($382efb02151ee08c$exports, "isize", function () { return $a916b4688d7563ce$export$d3939c12e00078c4; });
$parcel$export($382efb02151ee08c$exports, "Null", function () { return $cde2b5a819d50097$export$26c9c3a80cd996ae; });
$parcel$export($382efb02151ee08c$exports, "OptionBool", function () { return $2a7126889d57ba46$export$295f85560db305d8; });
$parcel$export($382efb02151ee08c$exports, "Text", function () { return $98748f65a0bee8c6$export$5f1af8db9871e1d6; });
$parcel$export($382efb02151ee08c$exports, "Type", function () { return $27cf92db83428355$export$92738401e1603719; });
$parcel$export($382efb02151ee08c$exports, "U8", function () { return $7e4d62c5e0322d78$export$9813fca58c0b9f71; });
$parcel$export($382efb02151ee08c$exports, "u8", function () { return $7e4d62c5e0322d78$export$9813fca58c0b9f71; });
$parcel$export($382efb02151ee08c$exports, "U16", function () { return $3c17e40605809ab7$export$73c443a9dbe0d04a; });
$parcel$export($382efb02151ee08c$exports, "u16", function () { return $3c17e40605809ab7$export$73c443a9dbe0d04a; });
$parcel$export($382efb02151ee08c$exports, "U32", function () { return $4d3a09ccc4a71677$export$8bacf4ad828c7fe7; });
$parcel$export($382efb02151ee08c$exports, "u32", function () { return $4d3a09ccc4a71677$export$8bacf4ad828c7fe7; });
$parcel$export($382efb02151ee08c$exports, "U64", function () { return $b1c43899fad14151$export$cd1442401e54cffa; });
$parcel$export($382efb02151ee08c$exports, "u64", function () { return $b1c43899fad14151$export$cd1442401e54cffa; });
$parcel$export($382efb02151ee08c$exports, "U128", function () { return $18835dab7e6ed9d4$export$6cebf8c93d35ecb4; });
$parcel$export($382efb02151ee08c$exports, "u128", function () { return $18835dab7e6ed9d4$export$6cebf8c93d35ecb4; });
$parcel$export($382efb02151ee08c$exports, "U256", function () { return $1fe90e4dfbf11c50$export$c6d3c723c6dee16b; });
$parcel$export($382efb02151ee08c$exports, "u256", function () { return $1fe90e4dfbf11c50$export$c6d3c723c6dee16b; });
$parcel$export($382efb02151ee08c$exports, "USize", function () { return $df43d6a4235bfd6e$export$a026a6fc9b813720; });
$parcel$export($382efb02151ee08c$exports, "usize", function () { return $df43d6a4235bfd6e$export$a026a6fc9b813720; });
$parcel$export($382efb02151ee08c$exports, "Data", function () { return $d25991c13eb0985f$export$2d0294657ab35f1b; });
$parcel$export($382efb02151ee08c$exports, "StorageKey", function () { return $30bb43f19cf9e7de$export$2fdc5139b636713c; });
/**
 * @summary Type definitions that are used in the system
 */ 

const $c55b73f8dda76a9d$var$DEDUPE = "Either remove and explicitly install matching versions or dedupe using your package manager.\nThe following conflicting packages were found:";
/** @internal */ function $c55b73f8dda76a9d$var$getEntry(name) {
    const _global = (0, $9ce44c51a85397c6$export$51e5d554977815ce);
    if (!_global.__polkadotjs) _global.__polkadotjs = {};
    if (!_global.__polkadotjs[name]) _global.__polkadotjs[name] = [];
    return _global.__polkadotjs[name];
}
/** @internal */ function $c55b73f8dda76a9d$var$formatDisplay(all, fmt) {
    let max = 0;
    for(let i = 0, count = all.length; i < count; i++)max = Math.max(max, all[i].version.length);
    return all.map((d)=>`\t${fmt(d.version.padEnd(max), d).join("	")}`).join("\n");
}
/** @internal */ function $c55b73f8dda76a9d$var$formatInfo(version, { name: name }) {
    return [
        version,
        name
    ];
}
/** @internal */ function $c55b73f8dda76a9d$var$formatVersion(version, { path: path, type: type }) {
    let extracted;
    if (path && path.length >= 5) {
        const nmIndex = path.indexOf("node_modules");
        extracted = nmIndex === -1 ? path : path.substring(nmIndex);
    } else extracted = "<unknown>";
    return [
        `${`${type || ""}`.padStart(3)} ${version}`,
        extracted
    ];
}
/** @internal */ function $c55b73f8dda76a9d$var$getPath(infoPath, pathOrFn) {
    if (infoPath) return infoPath;
    else if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(pathOrFn)) try {
        return pathOrFn() || "";
    } catch  {
        return "";
    }
    return pathOrFn || "";
}
/** @internal */ function $c55b73f8dda76a9d$var$warn(pre, all, fmt) {
    console.warn(`${pre}\n${$c55b73f8dda76a9d$var$DEDUPE}\n${$c55b73f8dda76a9d$var$formatDisplay(all, fmt)}`);
}
function $c55b73f8dda76a9d$export$3d90b6f1c729d3cf({ name: name, path: path, type: type, version: version }, pathOrFn, deps = []) {
    if (!name.startsWith("@polkadot")) throw new Error(`Invalid package descriptor ${name}`);
    const entry = $c55b73f8dda76a9d$var$getEntry(name);
    entry.push({
        path: $c55b73f8dda76a9d$var$getPath(path, pathOrFn),
        type: type,
        version: version
    });
    if (entry.length !== 1) $c55b73f8dda76a9d$var$warn(`${name} has multiple versions, ensure that there is only one installed.`, entry, $c55b73f8dda76a9d$var$formatVersion);
    else {
        const mismatches = deps.filter((d)=>d && d.version !== version);
        if (mismatches.length) $c55b73f8dda76a9d$var$warn(`${name} requires direct dependencies exactly matching version ${version}.`, mismatches, $c55b73f8dda76a9d$var$formatInfo);
    }
}


var $60aa2e36c8518ab8$export$2e2bcd8739ae039 = [];


var $81cded6fcd482ca5$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/types-codec/packageInfo.js"
});
const $81cded6fcd482ca5$export$ce0097da4c08ff3f = {
    name: "@polkadot/types-codec",
    path: $81cded6fcd482ca5$import_meta && "file:///node_modules/@polkadot/types-codec/packageInfo.js" ? new URL("file:///node_modules/@polkadot/types-codec/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/types-codec/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "10.9.1"
};


(0, $c55b73f8dda76a9d$export$3d90b6f1c729d3cf)((0, $81cded6fcd482ca5$export$ce0097da4c08ff3f), null, (0, $60aa2e36c8518ab8$export$2e2bcd8739ae039));



/** @internal */ function $6c7728456d398541$var$decodeBitVecU8a(value) {
    if (!value || !value.length) return [
        0,
        new Uint8Array()
    ];
    // handle all other Uint8Array inputs, these do have a length prefix which is the number of bits encoded
    const [offset, length] = (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(value);
    const total = offset + Math.ceil(length / 8);
    if (total > value.length) throw new Error(`BitVec: required length less than remainder, expected at least ${total}, found ${value.length}`);
    return [
        length,
        value.subarray(offset, total)
    ];
}
/** @internal */ function $6c7728456d398541$var$decodeBitVec(value) {
    if (Array.isArray(value) || (0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) {
        const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
        return [
            u8a.length / 8,
            u8a
        ];
    }
    return $6c7728456d398541$var$decodeBitVecU8a(value);
}
class $6c7728456d398541$export$2954f430c28ec0f0 extends (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94) {
    // In lieu of having the Msb/Lsb identifiers passed through, we default to assuming
    // we are dealing with Lsb, which is the default (as of writing) BitVec format used
    // in the Polkadot code (this only affects the toHuman displays)
    constructor(registry, value, isMsb = false){
        const [decodedLength, u8a] = $6c7728456d398541$var$decodeBitVec(value);
        super(registry, u8a);
        this.__internal__decodedLength = decodedLength;
        this.__internal__isMsb = isMsb;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.length + (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.__internal__decodedLength).length;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.__internal__decodedLength),
                super.toU8a()
            ]
        };
    }
    /**
     * @description Creates a boolean array of the bit values
     */ toBoolArray() {
        const map = [
            ...this.toU8a(true)
        ].map((v)=>[
                !!(v & 128),
                !!(v & 64),
                !!(v & 32),
                !!(v & 16),
                !!(v & 8),
                !!(v & 4),
                !!(v & 2),
                !!(v & 1)
            ]);
        const count = map.length;
        const result = new Array(8 * count);
        for(let i = 0; i < count; i++){
            const off = i * 8;
            const v = map[i];
            for(let j = 0; j < 8; j++)result[off + j] = this.__internal__isMsb ? v[j] : v[7 - j];
        }
        return result;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return `0b${[
            ...this.toU8a(true)
        ].map((d)=>`00000000${d.toString(2)}`.slice(-8)).map((s)=>this.__internal__isMsb ? s : s.split("").reverse().join("")).join("_")}`;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "BitVec";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        const bitVec = super.toU8a(isBare);
        return isBare ? bitVec : (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)([
            (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(this.__internal__decodedLength),
            bitVec
        ]);
    }
}




function $2a7126889d57ba46$var$decodeU8a(registry, value) {
    // Encoded as -
    //  - 0 = None
    //  - 1 = True
    //  - 2 = False
    return value[0] === 0 ? null : new (0, $933d8a6c938b665f$export$87b259aa03e3d267)(registry, value[0] === 1);
}
class $2a7126889d57ba46$export$295f85560db305d8 extends (0, $c77f4fb10fc66369$export$36d18380658d5d20) {
    constructor(registry, value){
        super(registry, (0, $933d8a6c938b665f$export$87b259aa03e3d267), (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? $2a7126889d57ba46$var$decodeU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value)) : value);
        this.initialU8aLength = 1;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return 1;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */ get isFalse() {
        return this.isSome ? !this.value.valueOf() : false;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */ get isTrue() {
        return this.isSome ? this.value.valueOf() : false;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType(isBare) {
        return isBare ? "bool" : "Option<bool>";
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        if (isBare) return super.toU8a(true);
        return this.isSome ? new Uint8Array([
            this.isTrue ? 1 : 2
        ]) : new Uint8Array([
            0
        ]);
    }
}



const $98748f65a0bee8c6$var$MAX_LENGTH = 131072;
/** @internal */ function $98748f65a0bee8c6$var$decodeText(value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value)) {
        if (!value.length) return [
            "",
            0
        ];
        // for Raw, the internal buffer does not have an internal length
        // (the same applies in e.g. Bytes, where length is added at encoding-time)
        if (value instanceof (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94)) return [
            (0, $20f3a615a221edb7$export$792464756f58046b)(value),
            0
        ];
        const [offset, length] = (0, $f98b10db0f2cd20b$export$9549eda7cd84f536)(value);
        const total = offset + length;
        if (length > $98748f65a0bee8c6$var$MAX_LENGTH) throw new Error(`Text: length ${length.toString()} exceeds ${$98748f65a0bee8c6$var$MAX_LENGTH}`);
        else if (total > value.length) throw new Error(`Text: required length less than remainder, expected at least ${total}, found ${value.length}`);
        return [
            (0, $20f3a615a221edb7$export$792464756f58046b)(value.subarray(offset, total)),
            total
        ];
    } else if ((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) return [
        (0, $20f3a615a221edb7$export$792464756f58046b)((0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(value)),
        0
    ];
    return [
        value ? value.toString() : "",
        0
    ];
}
class $98748f65a0bee8c6$export$5f1af8db9871e1d6 extends String {
    constructor(registry, value){
        const [str, decodedLength] = $98748f65a0bee8c6$var$decodeText(value);
        super(str);
        this.__internal__override = null;
        this.registry = registry;
        this.initialU8aLength = decodedLength;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */ get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */ get isEmpty() {
        return this.length === 0;
    }
    /**
     * @description The length of the value
     */ get length() {
        // only included here since we ignore inherited docs
        return super.length;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return (0, $0d672af39bfe8283$export$844ec244b1367d54)(other) ? this.toString() === other.toString() : false;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        const value = (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)(super.toString());
        return {
            outer: value.length ? [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(value.length),
                value
            ] : [
                (0, $bdb4803c1e6b1c9a$export$37f42c2b1352e4b)(value.length)
            ]
        };
    }
    /**
     * @description Set an override value for this
     */ setOverride(override) {
        this.__internal__override = override;
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        // like with Vec<u8>, when we are encoding to hex, we don't actually add
        // the length prefix (it is already implied by the actual string length)
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a(true));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Text";
    }
    /**
     * @description Returns the string representation of the value
     */ toString() {
        return this.__internal__override || super.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */ toU8a(isBare) {
        // NOTE Here we use the super toString (we are not taking overrides into account,
        // rather encoding the original value the string was constructed with)
        const encoded = (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)(super.toString());
        return isBare ? encoded : (0, $7c076f10c5650efd$export$54cb8b08f590bc42)(encoded);
    }
}



class $27cf92db83428355$export$92738401e1603719 extends (0, $98748f65a0bee8c6$export$5f1af8db9871e1d6) {
    constructor(registry, value = ""){
        super(registry, value);
        this.setOverride((0, $8eefb6164d9f7959$export$83d2e9e3e4ee39ed)(this.toString()));
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return "Type";
    }
}


/**
 * @name floatToU8a
 * @description Converts a float into a U8a representation (While we don't use BE in SCALE
 * we still allow for either representation, although, as elsewhere, isLe is default)
 */ function $636a7905730f2608$export$cbc3b9c0634e3e01(value = 0.0, { bitLength: bitLength = 32, isLe: isLe = true } = {}) {
    if (bitLength !== 32 && bitLength !== 64) throw new Error("Invalid bitLength provided, expected 32 or 64");
    const result = new Uint8Array(bitLength / 8);
    const dv = new DataView(result.buffer, result.byteOffset);
    if (bitLength === 32) dv.setFloat32(0, Number(value), isLe);
    else dv.setFloat64(0, Number(value), isLe);
    return result;
}

/**
 * @name u8aToFloat
 * @description Converts a Uint8Array value into the float (either 32 or 64-bit)
 * representation.
 */ function $c9f1db358354296d$export$e3d95d6306165342(value, { bitLength: bitLength = 32, isLe: isLe = true } = {}) {
    if (bitLength !== 32 && bitLength !== 64) throw new Error("Invalid bitLength provided, expected 32 or 64");
    else if (value.length < bitLength / 8) throw new Error(`Invalid input buffer provided, expected at least ${bitLength / 8} bytes, found ${value.length}`);
    const dv = new DataView(value.buffer, value.byteOffset);
    return bitLength === 32 ? dv.getFloat32(0, isLe) : dv.getFloat64(0, isLe);
}


class $af83d2ae2687883b$export$bb89b76e902dbdb5 extends Number {
    constructor(registry, value, { bitLength: bitLength = 32 } = {}){
        super((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? value.length === 0 ? 0 : (0, $c9f1db358354296d$export$e3d95d6306165342)((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value), {
            bitLength: bitLength
        }) : value || 0);
        this.__internal__bitLength = bitLength;
        this.encodedLength = bitLength / 8;
        this.initialU8aLength = this.encodedLength;
        this.registry = registry;
    }
    static with(bitLength) {
        return class extends $af83d2ae2687883b$export$bb89b76e902dbdb5 {
            constructor(registry, value){
                super(registry, value, {
                    bitLength: bitLength
                });
            }
        };
    }
    /**
     * @description returns a hash of the contents
     */ get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Returns true if the type wraps an empty/default all-0 value
     */ get isEmpty() {
        return this.valueOf() === 0;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */ eq(other) {
        return this.valueOf() === Number(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */ inspect() {
        return {
            outer: [
                this.toU8a()
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */ toHex() {
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */ toHuman() {
        return this.toString();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */ toJSON() {
        // Not sure if this is actually a hex or a string value
        // (would need to check against RPCs to see the result here)
        return this.toHex();
    }
    /**
     * @description Returns the number representation (Same as valueOf)
     */ toNumber() {
        return this.valueOf();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */ toPrimitive() {
        return this.toNumber();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */ toRawType() {
        return `f${this.__internal__bitLength}`;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a(_isBare) {
        return (0, $636a7905730f2608$export$cbc3b9c0634e3e01)(this, {
            bitLength: this.__internal__bitLength
        });
    }
}


class $2276e7165fe04d30$export$e33361ff41014190 extends (0, $af83d2ae2687883b$export$bb89b76e902dbdb5).with(32) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__FloatType = "f32";
    }
}


class $a59cf4249a20b332$export$eda3f5d9b9872690 extends (0, $af83d2ae2687883b$export$bb89b76e902dbdb5).with(64) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__FloatType = "f64";
    }
}


class $bbf149afbc431034$export$9ad68ccef5e52093 extends (0, $089e69a18315198b$export$fdd676b64b72b00).with(8) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__IntType = "i8";
    }
}


class $a378fa3a01c74898$export$941bd9d09c20518 extends (0, $089e69a18315198b$export$fdd676b64b72b00).with(16) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__IntType = "i16";
    }
}


class $55d022a480b453e7$export$b71748db06371c77 extends (0, $089e69a18315198b$export$fdd676b64b72b00).with(32) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__IntType = "i32";
    }
}


class $8c2db57457d40132$export$350f5a4edd618094 extends (0, $089e69a18315198b$export$fdd676b64b72b00).with(64) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__IntType = "i64";
    }
}


class $6e51b375de4e6673$export$77f6394270c638a1 extends (0, $089e69a18315198b$export$fdd676b64b72b00).with(128) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__IntType = "i128";
    }
}


class $abc7c0c77285aa50$export$c4e13e6ea93f4e65 extends (0, $089e69a18315198b$export$fdd676b64b72b00).with(256) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__IntType = "i256";
    }
}


class $a916b4688d7563ce$export$d3939c12e00078c4 extends (0, $55d022a480b453e7$export$b71748db06371c77) {
    constructor(registry, value){
        super(registry, value);
        throw new Error("The `isize` type should not be used. Since it is platform-specific, it creates incompatibilities between native (generally i64) and WASM (always i32) code. Use one of the `i32` or `i64` types explicitly.");
    }
}


class $7e4d62c5e0322d78$export$9813fca58c0b9f71 extends (0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f).with(8) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = "u8";
    }
}


class $3c17e40605809ab7$export$73c443a9dbe0d04a extends (0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f).with(16) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = "u16";
    }
}


class $18835dab7e6ed9d4$export$6cebf8c93d35ecb4 extends (0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f).with(128) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = "u128";
    }
}


class $1fe90e4dfbf11c50$export$c6d3c723c6dee16b extends (0, $e12b5c9e80666c5a$export$5aaa69e6f271b98f).with(256) {
    constructor(){
        super(...arguments);
        // NOTE without this, we cannot properly determine extensions
        this.__UIntType = "u256";
    }
}


class $df43d6a4235bfd6e$export$a026a6fc9b813720 extends (0, $4d3a09ccc4a71677$export$8bacf4ad828c7fe7) {
    constructor(registry, value){
        super(registry, value);
        throw new Error("The `usize` type should not be used. Since it is platform-specific, it creates incompatibilities between native (generally u64) and WASM (always u32) code. Use one of the `u32` or `u64` types explicitly.");
    }
}







/** @internal */ function $d25991c13eb0985f$var$decodeDataU8a(registry, value) {
    const indicator = value[0];
    if (!indicator) return [
        undefined,
        undefined
    ];
    else if (indicator >= 1 && indicator <= 33) {
        const length = indicator - 1;
        const data = value.subarray(1, length + 1);
        // in this case, we are passing a Raw back (since we have no length)
        return [
            registry.createTypeUnsafe("Raw", [
                data
            ]),
            1
        ];
    } else if (indicator >= 34 && indicator <= 37) return [
        value.subarray(1, 33),
        indicator - 32
    ]; // 34 becomes 2
    throw new Error(`Unable to decode Data, invalid indicator byte ${indicator}`);
}
/** @internal */ function $d25991c13eb0985f$var$decodeData(registry, value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) return $d25991c13eb0985f$var$decodeDataU8a(registry, (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value));
    else if (!value) return [
        undefined,
        undefined
    ];
    // assume we have an Enum or an  object input, handle this via the normal Enum decoding
    return [
        value,
        undefined
    ];
}
class $d25991c13eb0985f$export$2d0294657ab35f1b extends (0, $533387422670f8b2$export$deb82508dd66d288) {
    constructor(registry, value){
        super(registry, {
            None: "Null",
            Raw: "Bytes",
            // eslint-disable-next-line sort-keys
            BlakeTwo256: "H256",
            Sha256: "H256",
            // eslint-disable-next-line sort-keys
            Keccak256: "H256",
            ShaThree256: "H256" // 5
        }, ...$d25991c13eb0985f$var$decodeData(registry, value));
        if (this.isRaw && this.asRaw.length > 32) throw new Error("Data.Raw values are limited to a maximum length of 32 bytes");
    }
    get asBlakeTwo256() {
        return this.value;
    }
    get asKeccak256() {
        return this.value;
    }
    get asRaw() {
        return this.value;
    }
    get asSha256() {
        return this.value;
    }
    get asShaThree256() {
        return this.value;
    }
    get isBlakeTwo256() {
        return this.index === 2;
    }
    get isKeccak256() {
        return this.index === 4;
    }
    get isNone() {
        return this.index === 0;
    }
    get isRaw() {
        return this.index === 1;
    }
    get isSha256() {
        return this.index === 3;
    }
    get isShaThree256() {
        return this.index === 5;
    }
    /**
     * @description The encoded length
     */ get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */ toU8a() {
        if (this.index === 0) return new Uint8Array(1);
        else if (this.index === 1) {
            // don't add the length, just the data
            const data = this.value.toU8a(true);
            const length = Math.min(data.length, 32);
            const u8a = new Uint8Array(length + 1);
            u8a.set([
                length + 1
            ], 0);
            u8a.set(data.subarray(0, length), 1);
            return u8a;
        }
        // otherwise we simply have a hash
        const u8a = new Uint8Array(33);
        u8a.set([
            this.index + 32
        ], 0);
        u8a.set(this.value.toU8a(), 1);
        return u8a;
    }
}




function $2a5439f14937909c$export$73d7a99faf161633(lookup, type) {
    const typeDef = lookup.getTypeDef(type);
    return typeDef.lookupName || typeDef.type;
}



function $5e2f058d5ec7affb$export$f4ee7d406626f648(type) {
    return type.isPlain ? type.asPlain : type.asMap.value;
}
function $5e2f058d5ec7affb$export$9d07eff9efb562f3(registry, type, isOptional) {
    const outputType = (0, $2a5439f14937909c$export$73d7a99faf161633)(registry.lookup, $5e2f058d5ec7affb$export$f4ee7d406626f648(type));
    return isOptional ? `Option<${outputType}>` : outputType;
}


const $30bb43f19cf9e7de$var$HASHER_MAP = {
    // opaque
    Blake2_128: [
        16,
        false
    ],
    Blake2_128Concat: [
        16,
        true
    ],
    Blake2_256: [
        32,
        false
    ],
    Identity: [
        0,
        true
    ],
    Twox128: [
        16,
        false
    ],
    Twox256: [
        32,
        false
    ],
    Twox64Concat: [
        8,
        true
    ]
};
/** @internal */ function $30bb43f19cf9e7de$var$decodeStorageKey(value) {
    if ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || !value || (0, $0d672af39bfe8283$export$844ec244b1367d54)(value)) // let Bytes handle these inputs
    return {
        key: value
    };
    else if (value instanceof $30bb43f19cf9e7de$export$2fdc5139b636713c) return {
        key: value,
        method: value.method,
        section: value.section
    };
    else if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value)) return {
        key: value(),
        method: value.method,
        section: value.section
    };
    else if (Array.isArray(value)) {
        const [fn, args = []] = value;
        if (!(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(fn)) throw new Error("Expected function input for key construction");
        if (fn.meta && fn.meta.type.isMap) {
            const map = fn.meta.type.asMap;
            if (!Array.isArray(args) || args.length !== map.hashers.length) throw new Error(`Expected an array of ${map.hashers.length} values as params to a Map query`);
        }
        return {
            key: fn(...args),
            method: fn.method,
            section: fn.section
        };
    }
    throw new Error(`Unable to convert input ${value} to StorageKey`);
}
/** @internal */ function $30bb43f19cf9e7de$var$decodeHashers(registry, value, hashers) {
    // the storage entry is xxhashAsU8a(prefix, 128) + xxhashAsU8a(method, 128), 256 bits total
    let offset = 32;
    const count = hashers.length;
    const result = new Array(count);
    for(let i = 0; i < count; i++){
        const [hasher, type] = hashers[i];
        const [hashLen, canDecode] = $30bb43f19cf9e7de$var$HASHER_MAP[hasher.type];
        const decoded = canDecode ? registry.createTypeUnsafe((0, $2a5439f14937909c$export$73d7a99faf161633)(registry.lookup, type), [
            value.subarray(offset + hashLen)
        ]) : registry.createTypeUnsafe("Raw", [
            value.subarray(offset, offset + hashLen)
        ]);
        offset += hashLen + (canDecode ? decoded.encodedLength : 0);
        result[i] = decoded;
    }
    return result;
}
/** @internal */ function $30bb43f19cf9e7de$var$decodeArgsFromMeta(registry, value, meta) {
    if (!meta || !meta.type.isMap) return [];
    const { hashers: hashers, key: key } = meta.type.asMap;
    const keys = hashers.length === 1 ? [
        key
    ] : registry.lookup.getSiType(key).def.asTuple;
    return $30bb43f19cf9e7de$var$decodeHashers(registry, value, hashers.map((h, i)=>[
            h,
            keys[i]
        ]));
}
/** @internal */ function $30bb43f19cf9e7de$var$getMeta(value) {
    if (value instanceof $30bb43f19cf9e7de$export$2fdc5139b636713c) return value.meta;
    else if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value)) return value.meta;
    else if (Array.isArray(value)) {
        const [fn] = value;
        return fn.meta;
    }
    return undefined;
}
/** @internal */ function $30bb43f19cf9e7de$var$getType(registry, value) {
    if (value instanceof $30bb43f19cf9e7de$export$2fdc5139b636713c) return value.outputType;
    else if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(value)) return (0, $5e2f058d5ec7affb$export$9d07eff9efb562f3)(registry, value.meta.type);
    else if (Array.isArray(value)) {
        const [fn] = value;
        if (fn.meta) return (0, $5e2f058d5ec7affb$export$9d07eff9efb562f3)(registry, fn.meta.type);
    }
    // If we have no type set, default to Raw
    return "Raw";
}
class $30bb43f19cf9e7de$export$2fdc5139b636713c extends (0, $6af5ed30500c41f2$export$9f55f2e2bf8c2fc1) {
    constructor(registry, value, override = {}){
        const { key: key, method: method, section: section } = $30bb43f19cf9e7de$var$decodeStorageKey(value);
        super(registry, key);
        this.__internal__outputType = $30bb43f19cf9e7de$var$getType(registry, value);
        // decode the args (as applicable based on the key and the hashers, after all init)
        this.setMeta($30bb43f19cf9e7de$var$getMeta(value), override.section || section, override.method || method);
    }
    /**
     * @description Return the decoded arguments (applicable to map with decodable values)
     */ get args() {
        return this.__internal__args;
    }
    /**
     * @description The metadata or `undefined` when not available
     */ get meta() {
        return this.__internal__meta;
    }
    /**
     * @description The key method or `undefined` when not specified
     */ get method() {
        return this.__internal__method;
    }
    /**
     * @description The output type
     */ get outputType() {
        return this.__internal__outputType;
    }
    /**
     * @description The key section or `undefined` when not specified
     */ get section() {
        return this.__internal__section;
    }
    is(key) {
        return key.section === this.section && key.method === this.method;
    }
    /**
     * @description Sets the meta for this key
     */ setMeta(meta, section, method) {
        this.__internal__meta = meta;
        this.__internal__method = method || this.__internal__method;
        this.__internal__section = section || this.__internal__section;
        if (meta) this.__internal__outputType = (0, $5e2f058d5ec7affb$export$9d07eff9efb562f3)(this.registry, meta.type);
        try {
            this.__internal__args = $30bb43f19cf9e7de$var$decodeArgsFromMeta(this.registry, this.toU8a(true), meta);
        } catch  {
        // ignore...
        }
        return this;
    }
    /**
     * @description Returns the Human representation for this type
     */ toHuman() {
        return this.__internal__args.length ? this.__internal__args.map((a)=>a.toHuman()) : super.toHuman();
    }
    /**
     * @description Returns the raw type for this
     */ toRawType() {
        return "StorageKey";
    }
}




$parcel$exportWildcard($7df5b58966439861$exports, $406aeba327260154$exports);
$parcel$exportWildcard($7df5b58966439861$exports, $5ea38cbe6563a36b$exports);
$parcel$exportWildcard($7df5b58966439861$exports, $382efb02151ee08c$exports);


var $f07063bab9185798$exports = {};

$parcel$export($f07063bab9185798$exports, "assets", function () { return $a8765ae608f8a973$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "aura", function () { return $8ead97cd32c947da$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "authorship", function () { return $cbd1ea63265d7ec7$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "babe", function () { return $66215ef502cf5853$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "balances", function () { return $785796059bbd5f01$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "beefy", function () { return $41198d8a0297eb4b$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "benchmark", function () { return $3b58becf0fd0ff9c$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "blockbuilder", function () { return $7a062c39b04b2ef1$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "collective", function () { return $cacc21be21aabce2$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "consensus", function () { return $921d65424359fd1a$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "contracts", function () { return $901173f692165aab$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "democracy", function () { return $09b20fc847164ad5$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "dev", function () { return $9ca601cb967a8c79$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "discovery", function () { return $ca9ab72eabe5d4a5$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "elections", function () { return $813540352a02bcef$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "engine", function () { return $034e762b479a231b$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "evm", function () { return $9bfdb1322427f123$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "extrinsics", function () { return $e86e6bc082f8db29$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "fungibles", function () { return $6d13662795b82a01$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "genericAsset", function () { return $f51debcac6ddd468$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "gilt", function () { return $79bc2be1200af744$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "grandpa", function () { return $765e70e545eb56ef$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "identity", function () { return $226242da1b568d5e$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "imOnline", function () { return $f837b12048a3efb3$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "lottery", function () { return $a079b073c9c94481$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "mmr", function () { return $134cc75a22ce97c1$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "nfts", function () { return $50c97f5c3074e977$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "nompools", function () { return $4d8051ee07149069$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "offences", function () { return $ee8c09f11a23ca7c$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "pow", function () { return $abeec8bd00c21a34$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "proxy", function () { return $8456c80ed089df95$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "recovery", function () { return $5c5649b6430ec504$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "scheduler", function () { return $e83cc75ef04b1ad8$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "session", function () { return $33ff446850d77e68$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "society", function () { return $76142cf3d2a6ccc6$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "staking", function () { return $b0fecc43aa958b30$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "support", function () { return $aabe5c0ecaa6583c$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "syncstate", function () { return $036afd3af5d243ce$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "system", function () { return $99055c2b847983d8$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "treasury", function () { return $432154c7d2640652$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "txpayment", function () { return $704e401c2bbea300$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "txqueue", function () { return $f982ec5ac285f2a2$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "uniques", function () { return $946998023fc35ba9$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "utility", function () { return $dc3a75dbae1f51c7$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "vesting", function () { return $4ad8d9be365c6205$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "attestations", function () { return $c83bf69e715361bd$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "bridges", function () { return $975e2dcbe970662b$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "claims", function () { return $a1021bc139f16c6e$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "crowdloan", function () { return $928d19c325bb34c9$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "cumulus", function () { return $db552d52aa8ece51$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "finality", function () { return $02e8569593272f6d$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "parachains", function () { return $cde4cbd8ede43fe9$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "poll", function () { return $f828505377cc7713$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "purchase", function () { return $15c859f0169b9f04$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "xcm", function () { return $0ec6c8d06534b1e7$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "contractsAbi", function () { return $b600921f9cc8dc58$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "eth", function () { return $de1da58605fc6318$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "nimbus", function () { return $b91f8b94885f9d6e$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "ormlOracle", function () { return $b934746ebb4defa3$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "ormlTokens", function () { return $da2431dfc4d3cdc2$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "rpc", function () { return $9a5e7073e4f79c00$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "author", function () { return $92577db7422b1b10$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "chain", function () { return $2d37c78b35c8cc17$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "childstate", function () { return $89ff5665dde79b63$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "offchain", function () { return $22b38005f29a2a9d$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "payment", function () { return $bbbeee776479a655$export$2e2bcd8739ae039; });
$parcel$export($f07063bab9185798$exports, "state", function () { return $60e971efe0d37e89$export$2e2bcd8739ae039; });
var $04d24b70f7af5675$exports = {};

$parcel$export($04d24b70f7af5675$exports, "metadata", function () { return $333d8ba20865e855$export$2e2bcd8739ae039; });
$parcel$export($04d24b70f7af5675$exports, "runtime", function () { return $311b815197193fad$export$2e2bcd8739ae039; });
$parcel$export($04d24b70f7af5675$exports, "scaleInfo", function () { return $b58a76a351eed649$export$2e2bcd8739ae039; });

const $2d5d09324b4dadbf$var$META_V1_TO_V2 = {
    metadata: {
        description: "Returns the metadata of a runtime",
        params: [],
        type: "OpaqueMetadata"
    }
};
const $2d5d09324b4dadbf$export$874fd8712028ad21 = {
    Metadata: [
        {
            methods: {
                metadata_at_version: {
                    description: "Returns the metadata at a given version.",
                    params: [
                        {
                            name: "version",
                            type: "u32"
                        }
                    ],
                    type: "Option<OpaqueMetadata>"
                },
                metadata_versions: {
                    description: "Returns the supported metadata versions.",
                    params: [],
                    type: "Vec<u32>"
                },
                ...$2d5d09324b4dadbf$var$META_V1_TO_V2
            },
            version: 2
        },
        {
            methods: {
                ...$2d5d09324b4dadbf$var$META_V1_TO_V2
            },
            version: 1
        }
    ]
};


const $6a09bce5c5941859$export$bf544b3bd0c7d316 = {
    // v9
    ErrorMetadataV9: {
        name: "Text",
        docs: "Vec<Text>"
    },
    EventMetadataV9: {
        name: "Text",
        args: "Vec<Type>",
        docs: "Vec<Text>"
    },
    FunctionArgumentMetadataV9: {
        name: "Text",
        type: "Type"
    },
    FunctionMetadataV9: {
        name: "Text",
        args: "Vec<FunctionArgumentMetadataV9>",
        docs: "Vec<Text>"
    },
    MetadataV9: {
        modules: "Vec<ModuleMetadataV9>"
    },
    ModuleConstantMetadataV9: {
        name: "Text",
        type: "Type",
        value: "Bytes",
        docs: "Vec<Text>"
    },
    ModuleMetadataV9: {
        name: "Text",
        storage: "Option<StorageMetadataV9>",
        calls: "Option<Vec<FunctionMetadataV9>>",
        events: "Option<Vec<EventMetadataV9>>",
        constants: "Vec<ModuleConstantMetadataV9>",
        errors: "Vec<ErrorMetadataV9>"
    },
    StorageEntryMetadataV9: {
        name: "Text",
        modifier: "StorageEntryModifierV9",
        type: "StorageEntryTypeV9",
        fallback: "Bytes",
        docs: "Vec<Text>"
    },
    StorageEntryModifierV9: {
        _enum: [
            "Optional",
            "Default",
            "Required"
        ]
    },
    StorageEntryTypeV9: {
        _enum: {
            Plain: "Type",
            Map: {
                hasher: "StorageHasherV9",
                key: "Type",
                value: "Type",
                linked: "bool"
            },
            DoubleMap: {
                hasher: "StorageHasherV9",
                key1: "Type",
                key2: "Type",
                value: "Type",
                key2Hasher: "StorageHasherV9"
            }
        }
    },
    StorageHasherV9: {
        _enum: {
            Blake2_128: null,
            Blake2_256: null,
            Twox128: null,
            Twox256: null,
            Twox64Concat: null
        }
    },
    StorageMetadataV9: {
        prefix: "Text",
        items: "Vec<StorageEntryMetadataV9>"
    }
};


const $8ea19b791535a99e$export$6b7c6e87793e1508 = {
    // v10
    ErrorMetadataV10: "ErrorMetadataV9",
    EventMetadataV10: "EventMetadataV9",
    FunctionArgumentMetadataV10: "FunctionArgumentMetadataV9",
    FunctionMetadataV10: "FunctionMetadataV9",
    MetadataV10: {
        modules: "Vec<ModuleMetadataV10>"
    },
    ModuleConstantMetadataV10: "ModuleConstantMetadataV9",
    ModuleMetadataV10: {
        name: "Text",
        storage: "Option<StorageMetadataV10>",
        calls: "Option<Vec<FunctionMetadataV10>>",
        events: "Option<Vec<EventMetadataV10>>",
        constants: "Vec<ModuleConstantMetadataV10>",
        errors: "Vec<ErrorMetadataV10>"
    },
    StorageEntryModifierV10: "StorageEntryModifierV9",
    StorageEntryMetadataV10: {
        name: "Text",
        modifier: "StorageEntryModifierV10",
        type: "StorageEntryTypeV10",
        fallback: "Bytes",
        docs: "Vec<Text>"
    },
    StorageEntryTypeV10: {
        _enum: {
            Plain: "Type",
            Map: {
                hasher: "StorageHasherV10",
                key: "Type",
                value: "Type",
                linked: "bool"
            },
            DoubleMap: {
                hasher: "StorageHasherV10",
                key1: "Type",
                key2: "Type",
                value: "Type",
                key2Hasher: "StorageHasherV10"
            }
        }
    },
    StorageMetadataV10: {
        prefix: "Text",
        items: "Vec<StorageEntryMetadataV10>"
    },
    StorageHasherV10: {
        _enum: {
            Blake2_128: null,
            Blake2_256: null,
            Blake2_128Concat: null,
            Twox128: null,
            Twox256: null,
            Twox64Concat: null
        }
    }
};


/* eslint-disable sort-keys */ const $9234c6e38d0f8a38$export$51de55ce928a93f6 = {
    Blake2_128: null,
    Blake2_256: null,
    Blake2_128Concat: null,
    Twox128: null,
    Twox256: null,
    Twox64Concat: null,
    // new in v11
    Identity: null
};


const $634a7c29a60dbddb$export$bfe8132a528d0a6b = {
    // v11
    ErrorMetadataV11: "ErrorMetadataV10",
    EventMetadataV11: "EventMetadataV10",
    ExtrinsicMetadataV11: {
        version: "u8",
        signedExtensions: "Vec<Text>"
    },
    FunctionArgumentMetadataV11: "FunctionArgumentMetadataV10",
    FunctionMetadataV11: "FunctionMetadataV10",
    MetadataV11: {
        modules: "Vec<ModuleMetadataV11>",
        extrinsic: "ExtrinsicMetadataV11"
    },
    ModuleConstantMetadataV11: "ModuleConstantMetadataV10",
    ModuleMetadataV11: {
        name: "Text",
        storage: "Option<StorageMetadataV11>",
        calls: "Option<Vec<FunctionMetadataV11>>",
        events: "Option<Vec<EventMetadataV11>>",
        constants: "Vec<ModuleConstantMetadataV11>",
        errors: "Vec<ErrorMetadataV11>"
    },
    StorageEntryModifierV11: "StorageEntryModifierV10",
    StorageEntryMetadataV11: {
        name: "Text",
        modifier: "StorageEntryModifierV11",
        type: "StorageEntryTypeV11",
        fallback: "Bytes",
        docs: "Vec<Text>"
    },
    StorageEntryTypeV11: {
        _enum: {
            Plain: "Type",
            Map: {
                hasher: "StorageHasherV11",
                key: "Type",
                value: "Type",
                linked: "bool"
            },
            DoubleMap: {
                hasher: "StorageHasherV11",
                key1: "Type",
                key2: "Type",
                value: "Type",
                key2Hasher: "StorageHasherV11"
            }
        }
    },
    StorageMetadataV11: {
        prefix: "Text",
        items: "Vec<StorageEntryMetadataV11>"
    },
    StorageHasherV11: {
        _enum: (0, $9234c6e38d0f8a38$export$51de55ce928a93f6)
    }
};


const $fe5561bbac297262$export$d370897d61cd478f = {
    // v12
    ErrorMetadataV12: "ErrorMetadataV11",
    EventMetadataV12: "EventMetadataV11",
    ExtrinsicMetadataV12: "ExtrinsicMetadataV11",
    FunctionArgumentMetadataV12: "FunctionArgumentMetadataV11",
    FunctionMetadataV12: "FunctionMetadataV11",
    MetadataV12: {
        modules: "Vec<ModuleMetadataV12>",
        extrinsic: "ExtrinsicMetadataV12"
    },
    ModuleConstantMetadataV12: "ModuleConstantMetadataV11",
    ModuleMetadataV12: {
        name: "Text",
        storage: "Option<StorageMetadataV12>",
        calls: "Option<Vec<FunctionMetadataV12>>",
        events: "Option<Vec<EventMetadataV12>>",
        constants: "Vec<ModuleConstantMetadataV12>",
        errors: "Vec<ErrorMetadataV12>",
        index: "u8"
    },
    StorageEntryModifierV12: "StorageEntryModifierV11",
    StorageEntryMetadataV12: "StorageEntryMetadataV11",
    StorageEntryTypeV12: "StorageEntryTypeV11",
    StorageMetadataV12: "StorageMetadataV11",
    StorageHasherV12: "StorageHasherV11"
};


const $7852ed4d19fed3dc$export$b656a7253311f206 = {
    // v13
    ErrorMetadataV13: "ErrorMetadataV12",
    EventMetadataV13: "EventMetadataV12",
    ExtrinsicMetadataV13: "ExtrinsicMetadataV12",
    FunctionArgumentMetadataV13: "FunctionArgumentMetadataV12",
    FunctionMetadataV13: "FunctionMetadataV12",
    MetadataV13: {
        modules: "Vec<ModuleMetadataV13>",
        extrinsic: "ExtrinsicMetadataV13"
    },
    ModuleConstantMetadataV13: "ModuleConstantMetadataV12",
    ModuleMetadataV13: {
        name: "Text",
        storage: "Option<StorageMetadataV13>",
        calls: "Option<Vec<FunctionMetadataV13>>",
        events: "Option<Vec<EventMetadataV13>>",
        constants: "Vec<ModuleConstantMetadataV13>",
        errors: "Vec<ErrorMetadataV13>",
        index: "u8"
    },
    StorageEntryModifierV13: "StorageEntryModifierV12",
    StorageEntryMetadataV13: {
        name: "Text",
        modifier: "StorageEntryModifierV13",
        type: "StorageEntryTypeV13",
        fallback: "Bytes",
        docs: "Vec<Text>"
    },
    StorageEntryTypeV13: {
        _enum: {
            Plain: "Type",
            Map: {
                hasher: "StorageHasherV13",
                key: "Type",
                value: "Type",
                linked: "bool"
            },
            DoubleMap: {
                hasher: "StorageHasherV13",
                key1: "Type",
                key2: "Type",
                value: "Type",
                key2Hasher: "StorageHasherV13"
            },
            NMap: {
                keyVec: "Vec<Type>",
                hashers: "Vec<StorageHasherV13>",
                value: "Type"
            }
        }
    },
    StorageMetadataV13: {
        prefix: "Text",
        items: "Vec<StorageEntryMetadataV13>"
    },
    StorageHasherV13: "StorageHasherV12"
};


/* eslint-disable sort-keys */ const $e213ba836e7d8880$export$dd5e54ddf3b05c07 = {
    name: "Text",
    fields: "Vec<Si1Field>",
    index: "u8",
    docs: "Vec<Text>"
};
const $e213ba836e7d8880$export$11cb33cb3c138832 = {
    Si1Field: {
        name: "Option<Text>",
        type: "Si1LookupTypeId",
        typeName: "Option<Text>",
        docs: "Vec<Text>"
    },
    Si1LookupTypeId: "Compact<u32>",
    Si1Path: "Si0Path",
    Si1Type: {
        path: "Si1Path",
        params: "Vec<Si1TypeParameter>",
        def: "Si1TypeDef",
        docs: "Vec<Text>"
    },
    Si1TypeDef: {
        _enum: {
            Composite: "Si1TypeDefComposite",
            Variant: "Si1TypeDefVariant",
            Sequence: "Si1TypeDefSequence",
            Array: "Si1TypeDefArray",
            Tuple: "Si1TypeDefTuple",
            Primitive: "Si1TypeDefPrimitive",
            Compact: "Si1TypeDefCompact",
            BitSequence: "Si1TypeDefBitSequence",
            // NOTE: This is specific to the implementation for pre-v14 metadata
            // compatibility (always keep this as the last entry in the enum)
            HistoricMetaCompat: "Type"
        }
    },
    Si1TypeDefArray: {
        len: "u32",
        type: "Si1LookupTypeId"
    },
    Si1TypeDefBitSequence: {
        bitStoreType: "Si1LookupTypeId",
        bitOrderType: "Si1LookupTypeId"
    },
    Si1TypeDefCompact: {
        type: "Si1LookupTypeId"
    },
    Si1TypeDefComposite: {
        fields: "Vec<Si1Field>"
    },
    Si1TypeDefPrimitive: "Si0TypeDefPrimitive",
    Si1TypeDefSequence: {
        type: "Si1LookupTypeId"
    },
    Si1TypeDefTuple: "Vec<Si1LookupTypeId>",
    Si1TypeParameter: {
        name: "Text",
        type: "Option<Si1LookupTypeId>"
    },
    Si1TypeDefVariant: {
        variants: "Vec<Si1Variant>"
    },
    Si1Variant: $e213ba836e7d8880$export$dd5e54ddf3b05c07
};


const $45c7d32910382e24$export$1fed2888ddd2fd61 = {
    // registry
    PortableTypeV14: {
        id: "Si1LookupTypeId",
        type: "Si1Type"
    },
    // compatibility with earlier layouts, i.e. don't break previous users
    ErrorMetadataV14: {
        ...(0, $e213ba836e7d8880$export$dd5e54ddf3b05c07),
        args: "Vec<Type>"
    },
    EventMetadataV14: {
        ...(0, $e213ba836e7d8880$export$dd5e54ddf3b05c07),
        args: "Vec<Type>"
    },
    FunctionArgumentMetadataV14: {
        name: "Text",
        type: "Type",
        typeName: "Option<Type>"
    },
    FunctionMetadataV14: {
        ...(0, $e213ba836e7d8880$export$dd5e54ddf3b05c07),
        args: "Vec<FunctionArgumentMetadataV14>"
    },
    // V14
    ExtrinsicMetadataV14: {
        type: "SiLookupTypeId",
        version: "u8",
        signedExtensions: "Vec<SignedExtensionMetadataV14>"
    },
    MetadataV14: {
        lookup: "PortableRegistry",
        pallets: "Vec<PalletMetadataV14>",
        extrinsic: "ExtrinsicMetadataV14",
        type: "SiLookupTypeId"
    },
    PalletCallMetadataV14: {
        type: "SiLookupTypeId"
    },
    PalletConstantMetadataV14: {
        name: "Text",
        type: "SiLookupTypeId",
        value: "Bytes",
        docs: "Vec<Text>"
    },
    PalletErrorMetadataV14: {
        type: "SiLookupTypeId"
    },
    PalletEventMetadataV14: {
        type: "SiLookupTypeId"
    },
    PalletMetadataV14: {
        name: "Text",
        storage: "Option<PalletStorageMetadataV14>",
        calls: "Option<PalletCallMetadataV14>",
        events: "Option<PalletEventMetadataV14>",
        constants: "Vec<PalletConstantMetadataV14>",
        errors: "Option<PalletErrorMetadataV14>",
        index: "u8"
    },
    PalletStorageMetadataV14: {
        prefix: "Text",
        // NOTE: Renamed from entries
        items: "Vec<StorageEntryMetadataV14>"
    },
    SignedExtensionMetadataV14: {
        identifier: "Text",
        type: "SiLookupTypeId",
        additionalSigned: "SiLookupTypeId"
    },
    StorageEntryMetadataV14: {
        name: "Text",
        modifier: "StorageEntryModifierV14",
        type: "StorageEntryTypeV14",
        fallback: "Bytes",
        docs: "Vec<Text>"
    },
    StorageEntryModifierV14: "StorageEntryModifierV13",
    StorageEntryTypeV14: {
        _enum: {
            Plain: "SiLookupTypeId",
            Map: {
                hashers: "Vec<StorageHasherV14>",
                key: "SiLookupTypeId",
                value: "SiLookupTypeId"
            }
        }
    },
    StorageHasherV14: "StorageHasherV13"
};


const $b50fd2595231bf89$export$4029ae12047a7817 = {
    // new/adjusted in v15
    PalletMetadataV15: {
        name: "Text",
        storage: "Option<PalletStorageMetadataV14>",
        calls: "Option<PalletCallMetadataV14>",
        events: "Option<PalletEventMetadataV14>",
        constants: "Vec<PalletConstantMetadataV14>",
        errors: "Option<PalletErrorMetadataV14>",
        index: "u8",
        docs: "Vec<Text>"
    },
    RuntimeApiMetadataV15: {
        name: "Text",
        methods: "Vec<RuntimeApiMethodMetadataV15>",
        docs: "Vec<Text>"
    },
    RuntimeApiMethodMetadataV15: {
        name: "Text",
        inputs: "Vec<RuntimeApiMethodParamMetadataV15>",
        output: "SiLookupTypeId",
        docs: "Vec<Text>"
    },
    RuntimeApiMethodParamMetadataV15: {
        name: "Text",
        type: "SiLookupTypeId"
    },
    // actual v15 definition
    MetadataV15: {
        lookup: "PortableRegistry",
        pallets: "Vec<PalletMetadataV15>",
        extrinsic: "ExtrinsicMetadataV14",
        type: "SiLookupTypeId",
        apis: "Vec<RuntimeApiMetadataV15>"
    }
};


var $333d8ba20865e855$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $2d5d09324b4dadbf$export$874fd8712028ad21,
    types: {
        // all known
        ...(0, $6a09bce5c5941859$export$bf544b3bd0c7d316),
        ...(0, $8ea19b791535a99e$export$6b7c6e87793e1508),
        ...(0, $634a7c29a60dbddb$export$bfe8132a528d0a6b),
        ...(0, $fe5561bbac297262$export$d370897d61cd478f),
        ...(0, $7852ed4d19fed3dc$export$b656a7253311f206),
        ...(0, $45c7d32910382e24$export$1fed2888ddd2fd61),
        ...(0, $b50fd2595231bf89$export$4029ae12047a7817),
        // latest mappings
        // NOTE: For v15, we only added the runtime defintions,
        // hence latest for most pointing to the previous V14
        ErrorMetadataLatest: "ErrorMetadataV14",
        EventMetadataLatest: "EventMetadataV14",
        ExtrinsicMetadataLatest: "ExtrinsicMetadataV14",
        FunctionArgumentMetadataLatest: "FunctionArgumentMetadataV14",
        FunctionMetadataLatest: "FunctionMetadataV14",
        MetadataLatest: "MetadataV15",
        PalletCallMetadataLatest: "PalletCallMetadataV14",
        PalletConstantMetadataLatest: "PalletConstantMetadataV14",
        PalletErrorMetadataLatest: "PalletErrorMetadataV14",
        PalletEventMetadataLatest: "PalletEventMetadataV14",
        PalletMetadataLatest: "PalletMetadataV15",
        PalletStorageMetadataLatest: "PalletStorageMetadataV14",
        PortableType: "PortableTypeV14",
        RuntimeApiMetadataLatest: "RuntimeApiMetadataV15",
        SignedExtensionMetadataLatest: "SignedExtensionMetadataV14",
        StorageEntryMetadataLatest: "StorageEntryMetadataV14",
        StorageEntryModifierLatest: "StorageEntryModifierV14",
        StorageEntryTypeLatest: "StorageEntryTypeV14",
        StorageHasher: "StorageHasherV14",
        // additional types
        OpaqueMetadata: "Opaque<Bytes>",
        // the enum containing all the mappings
        MetadataAll: {
            _enum: {
                V0: "DoNotConstruct<MetadataV0>",
                V1: "DoNotConstruct<MetadataV1>",
                V2: "DoNotConstruct<MetadataV2>",
                V3: "DoNotConstruct<MetadataV3>",
                V4: "DoNotConstruct<MetadataV4>",
                V5: "DoNotConstruct<MetadataV5>",
                V6: "DoNotConstruct<MetadataV6>",
                V7: "DoNotConstruct<MetadataV7>",
                V8: "DoNotConstruct<MetadataV8>",
                // First version on Kusama in V9, dropping will be problematic
                V9: "MetadataV9",
                V10: "MetadataV10",
                V11: "MetadataV11",
                V12: "MetadataV12",
                V13: "MetadataV13",
                V14: "MetadataV14",
                V15: "MetadataV15"
            }
        }
    }
};



/* eslint-disable sort-keys */ const $1c22466bc27d422b$export$16613c9dcf124475 = {
    Si0Field: {
        name: "Option<Text>",
        type: "Si0LookupTypeId",
        typeName: "Option<Text>",
        docs: "Vec<Text>"
    },
    Si0LookupTypeId: "u32",
    Si0Path: "Vec<Text>",
    Si0Type: {
        path: "Si0Path",
        params: "Vec<Si0LookupTypeId>",
        def: "Si0TypeDef"
    },
    Si0TypeDef: {
        _enum: {
            Composite: "Si0TypeDefComposite",
            Variant: "Si0TypeDefVariant",
            Sequence: "Si0TypeDefSequence",
            Array: "Si0TypeDefArray",
            Tuple: "Si0TypeDefTuple",
            Primitive: "Si0TypeDefPrimitive",
            Compact: "Si0TypeDefCompact",
            Phantom: "Si0TypeDefPhantom",
            BitSequence: "Si0TypeDefBitSequence"
        }
    },
    Si0TypeDefArray: {
        len: "u32",
        type: "Si0LookupTypeId"
    },
    Si0TypeDefBitSequence: {
        bitStoreType: "Si0LookupTypeId",
        bitOrderType: "Si0LookupTypeId"
    },
    Si0TypeDefCompact: {
        type: "Si0LookupTypeId"
    },
    Si0TypeDefComposite: {
        fields: "Vec<Si0Field>"
    },
    Si0TypeDefPhantom: "Null",
    Si0TypeDefVariant: {
        variants: "Vec<Si0Variant>"
    },
    Si0TypeDefPrimitive: {
        _enum: [
            "Bool",
            "Char",
            "Str",
            "U8",
            "U16",
            "U32",
            "U64",
            "U128",
            "U256",
            "I8",
            "I16",
            "I32",
            "I64",
            "I128",
            "I256"
        ]
    },
    Si0TypeDefSequence: {
        type: "Si0LookupTypeId"
    },
    Si0TypeDefTuple: "Vec<Si0LookupTypeId>",
    Si0TypeParameter: {
        name: "Text",
        type: "Option<Si0LookupTypeId>"
    },
    Si0Variant: {
        name: "Text",
        fields: "Vec<Si0Field>",
        index: "Option<u8>",
        discriminant: "Option<u64>",
        docs: "Vec<Text>"
    }
};



var /* eslint-disable sort-keys */ $b58a76a351eed649$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ...(0, $1c22466bc27d422b$export$16613c9dcf124475),
        ...(0, $e213ba836e7d8880$export$11cb33cb3c138832),
        // latest mappings
        SiField: "Si1Field",
        SiLookupTypeId: "Si1LookupTypeId",
        SiPath: "Si1Path",
        SiType: "Si1Type",
        SiTypeDef: "Si1TypeDef",
        SiTypeDefArray: "Si1TypeDefArray",
        SiTypeDefBitSequence: "Si1TypeDefBitSequence",
        SiTypeDefCompact: "Si1TypeDefCompact",
        SiTypeDefComposite: "Si1TypeDefComposite",
        SiTypeDefPrimitive: "Si1TypeDefPrimitive",
        SiTypeDefSequence: "Si1TypeDefSequence",
        SiTypeDefTuple: "Si1TypeDefTuple",
        SiTypeParameter: "Si1TypeParameter",
        SiTypeDefVariant: "Si1TypeDefVariant",
        SiVariant: "Si1Variant"
    }
};




const $67632954cd0ed324$export$874fd8712028ad21 = {
    AssetsApi: [
        {
            methods: {
                account_balances: {
                    description: "Return the current set of authorities.",
                    params: [
                        {
                            name: "account",
                            type: "AccountId"
                        }
                    ],
                    type: "Vec<(u32, TAssetBalance)>"
                }
            },
            version: 1
        }
    ]
};


var $a8765ae608f8a973$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $67632954cd0ed324$export$874fd8712028ad21,
    types: {
        AssetApprovalKey: {
            owner: "AccountId",
            delegate: "AccountId"
        },
        AssetApproval: {
            amount: "TAssetBalance",
            deposit: "TAssetDepositBalance"
        },
        AssetBalance: {
            balance: "TAssetBalance",
            isFrozen: "bool",
            isSufficient: "bool"
        },
        AssetDestroyWitness: {
            accounts: "Compact<u32>",
            sufficients: "Compact<u32>",
            approvals: "Compact<u32>"
        },
        AssetDetails: {
            owner: "AccountId",
            issuer: "AccountId",
            admin: "AccountId",
            freezer: "AccountId",
            supply: "TAssetBalance",
            deposit: "TAssetDepositBalance",
            minBalance: "TAssetBalance",
            isSufficient: "bool",
            accounts: "u32",
            sufficients: "u32",
            approvals: "u32",
            isFrozen: "bool"
        },
        AssetMetadata: {
            deposit: "TAssetDepositBalance",
            name: "Vec<u8>",
            symbol: "Vec<u8>",
            decimals: "u8",
            isFrozen: "bool"
        },
        TAssetBalance: "u64",
        TAssetDepositBalance: "BalanceOf"
    }
};


const $1d8523a3b659cac6$export$874fd8712028ad21 = {
    AuraApi: [
        {
            methods: {
                authorities: {
                    description: "Return the current set of authorities.",
                    params: [],
                    type: "Vec<AuthorityId>"
                },
                slot_duration: {
                    description: "Returns the slot duration for Aura.",
                    params: [],
                    type: "SlotDuration"
                }
            },
            version: 1
        }
    ]
};


var $8ead97cd32c947da$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $1d8523a3b659cac6$export$874fd8712028ad21,
    types: {
        RawAuraPreDigest: {
            slotNumber: "u64"
        }
    }
};


var $cbd1ea63265d7ec7$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        UncleEntryItem: {
            _enum: {
                InclusionHeight: "BlockNumber",
                Uncle: "(Hash, Option<AccountId>)"
            }
        }
    }
};


const $12078cd108d82792$export$82f5954781486db2 = {
    epochAuthorship: {
        description: "Returns data about which slots (primary or secondary) can be claimed in the current epoch with the keys in the keystore",
        isUnsafe: true,
        params: [],
        type: "HashMap<AuthorityId, EpochAuthorship>"
    }
};


const $c51cb6044f067367$var$V1_V2_SHARED = {
    current_epoch: {
        description: "Returns information regarding the current epoch.",
        params: [],
        type: "Epoch"
    },
    current_epoch_start: {
        description: "Returns the slot that started the current epoch.",
        params: [],
        type: "Slot"
    },
    generate_key_ownership_proof: {
        description: "Generates a proof of key ownership for the given authority in the current epoch.",
        params: [
            {
                name: "slot",
                type: "Slot"
            },
            {
                name: "authorityId",
                type: "AuthorityId"
            }
        ],
        type: "Option<OpaqueKeyOwnershipProof>"
    },
    next_epoch: {
        description: "Returns information regarding the next epoch (which was already previously announced).",
        params: [],
        type: "Epoch"
    },
    submit_report_equivocation_unsigned_extrinsic: {
        description: "Submits an unsigned extrinsic to report an equivocation.",
        params: [
            {
                name: "equivocationProof",
                type: "BabeEquivocationProof"
            },
            {
                name: "keyOwnerProof",
                type: "OpaqueKeyOwnershipProof"
            }
        ],
        type: "Option<Null>"
    }
};
const $c51cb6044f067367$export$874fd8712028ad21 = {
    BabeApi: [
        {
            methods: {
                configuration: {
                    description: "Return the genesis configuration for BABE. The configuration is only read on genesis.",
                    params: [],
                    type: "BabeGenesisConfiguration"
                },
                ...$c51cb6044f067367$var$V1_V2_SHARED
            },
            version: 2
        },
        {
            methods: {
                configuration: {
                    description: "Return the configuration for BABE. Version 1.",
                    params: [],
                    type: "BabeGenesisConfigurationV1"
                },
                ...$c51cb6044f067367$var$V1_V2_SHARED
            },
            version: 1
        }
    ]
};


var $66215ef502cf5853$export$2e2bcd8739ae039 = {
    rpc: $12078cd108d82792$export$82f5954781486db2,
    runtime: $c51cb6044f067367$export$874fd8712028ad21,
    types: {
        AllowedSlots: {
            _enum: [
                "PrimarySlots",
                "PrimaryAndSecondaryPlainSlots",
                "PrimaryAndSecondaryVRFSlots"
            ]
        },
        BabeAuthorityWeight: "u64",
        BabeEpochConfiguration: {
            c: "(u64, u64)",
            allowedSlots: "AllowedSlots"
        },
        BabeBlockWeight: "u32",
        BabeEquivocationProof: {
            offender: "AuthorityId",
            slotNumber: "SlotNumber",
            firstHeader: "Header",
            secondHeader: "Header"
        },
        BabeGenesisConfiguration: {
            slotDuration: "u64",
            epochLength: "u64",
            c: "(u64, u64)",
            genesisAuthorities: "Vec<(AuthorityId, BabeAuthorityWeight)>",
            randomness: "Randomness",
            allowedSlots: "AllowedSlots"
        },
        BabeGenesisConfigurationV1: {
            slotDuration: "u64",
            epochLength: "u64",
            c: "(u64, u64)",
            genesisAuthorities: "Vec<(AuthorityId, BabeAuthorityWeight)>",
            randomness: "Randomness",
            secondarySlots: "bool"
        },
        BabeWeight: "u64",
        MaybeRandomness: "Option<Randomness>",
        MaybeVrf: "Option<VrfData>",
        Epoch: {
            epochIndex: "u64",
            startSlot: "Slot",
            duration: "u64",
            authorities: "Vec<(AuthorityId, BabeAuthorityWeight)>",
            randomness: "Hash",
            config: "BabeEpochConfiguration"
        },
        EpochAuthorship: {
            primary: "Vec<u64>",
            secondary: "Vec<u64>",
            secondary_vrf: "Vec<u64>"
        },
        NextConfigDescriptor: {
            _enum: {
                V0: "Null",
                V1: "NextConfigDescriptorV1"
            }
        },
        NextConfigDescriptorV1: {
            c: "(u64, u64)",
            allowedSlots: "AllowedSlots"
        },
        OpaqueKeyOwnershipProof: "Bytes",
        Randomness: "Hash",
        RawBabePreDigest: {
            _enum: {
                Phantom: "Null",
                Primary: "RawBabePreDigestPrimary",
                SecondaryPlain: "RawBabePreDigestSecondaryPlain",
                SecondaryVRF: "RawBabePreDigestSecondaryVRF"
            }
        },
        RawBabePreDigestPrimary: {
            authorityIndex: "u32",
            slotNumber: "SlotNumber",
            vrfOutput: "VrfOutput",
            vrfProof: "VrfProof"
        },
        RawBabePreDigestSecondaryPlain: {
            authorityIndex: "u32",
            slotNumber: "SlotNumber"
        },
        RawBabePreDigestSecondaryVRF: {
            authorityIndex: "u32",
            slotNumber: "SlotNumber",
            vrfOutput: "VrfOutput",
            vrfProof: "VrfProof"
        },
        RawBabePreDigestTo159: {
            _enum: {
                Primary: "RawBabePreDigestPrimaryTo159",
                Secondary: "RawBabePreDigestSecondaryTo159"
            }
        },
        RawBabePreDigestPrimaryTo159: {
            authorityIndex: "u32",
            slotNumber: "SlotNumber",
            weight: "BabeBlockWeight",
            vrfOutput: "VrfOutput",
            vrfProof: "VrfProof"
        },
        RawBabePreDigestSecondaryTo159: {
            authorityIndex: "u32",
            slotNumber: "SlotNumber",
            weight: "BabeBlockWeight"
        },
        // a cross old/new compatible version of the digest, that is _only_ useful
        // for partial parsing and extraction of the author. This assumes that all
        // entries has the authorityIndex in the first position - and that it is all
        // we are interested in
        RawBabePreDigestCompat: {
            _enum: {
                Zero: "u32",
                One: "u32",
                Two: "u32",
                Three: "u32"
            }
        },
        SlotNumber: "u64",
        VrfData: "[u8; 32]",
        VrfOutput: "[u8; 32]",
        VrfProof: "[u8; 64]"
    }
};


var $785796059bbd5f01$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        AccountData: {
            free: "Balance",
            reserved: "Balance",
            miscFrozen: "Balance",
            feeFrozen: "Balance"
        },
        BalanceLockTo212: {
            id: "LockIdentifier",
            amount: "Balance",
            until: "BlockNumber",
            reasons: "WithdrawReasons"
        },
        BalanceLock: {
            id: "LockIdentifier",
            amount: "Balance",
            reasons: "Reasons"
        },
        BalanceStatus: {
            _enum: [
                "Free",
                "Reserved"
            ]
        },
        Reasons: {
            _enum: [
                "Fee",
                "Misc",
                "All"
            ]
        },
        ReserveData: {
            id: "ReserveIdentifier",
            amount: "Balance"
        },
        ReserveIdentifier: "[u8; 8]",
        VestingSchedule: {
            offset: "Balance",
            perBlock: "Balance",
            startingBlock: "BlockNumber"
        },
        WithdrawReasons: {
            _set: {
                TransactionPayment: 1,
                Transfer: 2,
                Reserve: 4,
                Fee: 8,
                Tip: 16
            }
        }
    }
};


const $034fd03efb5269f8$export$82f5954781486db2 = {
    getFinalizedHead: {
        description: "Returns hash of the latest BEEFY finalized block as seen by this client.",
        params: [],
        type: "H256"
    },
    subscribeJustifications: {
        description: "Returns the block most recently finalized by BEEFY, alongside side its justification.",
        params: [],
        pubsub: [
            "justifications",
            "subscribeJustifications",
            "unsubscribeJustifications"
        ],
        type: "BeefySignedCommitment"
    }
};


const $c260a36e23d21bc8$var$BEEFY_V1_V2 = {
    beefy_genesis: {
        description: "Return the block number where BEEFY consensus is enabled/started",
        params: [],
        type: "Option<BlockNumber>"
    },
    generate_key_ownership_proof: {
        description: "Generates a proof of key ownership for the given authority in the given set.",
        params: [
            {
                name: "setId",
                type: "ValidatorSetId"
            },
            {
                name: "authorityId",
                type: "AuthorityId"
            }
        ],
        type: "Option<OpaqueKeyOwnershipProof>"
    },
    submit_report_equivocation_unsigned_extrinsic: {
        description: "Submits an unsigned extrinsic to report an equivocation.",
        params: [
            {
                name: "equivocationProof",
                type: "BeefyEquivocationProof"
            },
            {
                name: "keyOwnerProof",
                type: "OpaqueKeyOwnershipProof"
            }
        ],
        type: "Option<Null>"
    },
    validator_set: {
        description: "Return the current active BEEFY validator set",
        params: [],
        type: "Option<ValidatorSet>"
    }
};
const $c260a36e23d21bc8$var$BEEFY_MMR_V1 = {
    authority_set_proof: {
        description: "Return the currently active BEEFY authority set proof.",
        params: [],
        type: "BeefyAuthoritySet"
    },
    next_authority_set_proof: {
        description: "Return the next/queued BEEFY authority set proof.",
        params: [],
        type: "BeefyNextAuthoritySet"
    }
};
const $c260a36e23d21bc8$export$874fd8712028ad21 = {
    BeefyApi: [
        {
            methods: $c260a36e23d21bc8$var$BEEFY_V1_V2,
            version: 2
        },
        {
            methods: $c260a36e23d21bc8$var$BEEFY_V1_V2,
            version: 1
        }
    ],
    BeefyMmrApi: [
        {
            methods: $c260a36e23d21bc8$var$BEEFY_MMR_V1,
            version: 1
        }
    ]
};


var $41198d8a0297eb4b$export$2e2bcd8739ae039 = {
    rpc: $034fd03efb5269f8$export$82f5954781486db2,
    runtime: $c260a36e23d21bc8$export$874fd8712028ad21,
    types: {
        BeefyAuthoritySet: {
            id: "u64",
            len: "u32",
            root: "H256"
        },
        BeefyCommitment: {
            payload: "BeefyPayload",
            blockNumber: "BlockNumber",
            validatorSetId: "ValidatorSetId"
        },
        BeefyId: "[u8; 33]",
        BeefyEquivocationProof: {
            first: "BeefyVoteMessage",
            second: "BeefyVoteMessage"
        },
        BeefySignedCommitment: {
            commitment: "BeefyCommitment",
            signatures: "Vec<Option<EcdsaSignature>>"
        },
        BeefyNextAuthoritySet: {
            id: "u64",
            len: "u32",
            root: "H256"
        },
        BeefyPayload: "Vec<(BeefyPayloadId, Bytes)>",
        BeefyPayloadId: "[u8;2]",
        BeefyVoteMessage: {
            commitment: "BeefyCommitment",
            id: "AuthorityId",
            signature: "Signature"
        },
        MmrRootHash: "H256",
        ValidatorSetId: "u64",
        ValidatorSet: {
            validators: "Vec<AuthorityId>",
            id: "ValidatorSetId"
        }
    }
};


const $bf3fe2a184264402$export$874fd8712028ad21 = {
    Benchmark: [
        {
            methods: {
                benchmark_metadata: {
                    description: "Get the benchmark metadata available for this runtime.",
                    params: [
                        {
                            name: "extra",
                            type: "bool"
                        }
                    ],
                    type: "(Vec<BenchmarkList>, Vec<StorageInfo>)"
                },
                dispatch_benchmark: {
                    description: "Dispatch the given benchmark.",
                    params: [
                        {
                            name: "config",
                            type: "BenchmarkConfig"
                        }
                    ],
                    type: "Result<Vec<BenchmarkBatch>, Text>"
                }
            },
            version: 1
        }
    ]
};


var $3b58becf0fd0ff9c$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $bf3fe2a184264402$export$874fd8712028ad21,
    types: {
        BenchmarkBatch: {
            pallet: "Text",
            instance: "Text",
            benchmark: "Text",
            results: "Vec<BenchmarkResult>"
        },
        BenchmarkConfig: {
            pallet: "Bytes",
            benchmark: "Bytes",
            selectedComponents: "Vec<(BenchmarkParameter, u32)>",
            verify: "bool",
            internalRepeats: "u32"
        },
        BenchmarkList: {
            pallet: "Bytes",
            instance: "Bytes",
            benchmarks: "Vec<BenchmarkMetadata>"
        },
        BenchmarkMetadata: {
            name: "Bytes",
            components: "Vec<(BenchmarkParameter, u32, u32)>"
        },
        BenchmarkParameter: {
            _enum: [
                "a",
                "b",
                "c",
                "d",
                "e",
                "f",
                "g",
                "h",
                "i",
                "j",
                "k",
                "l",
                "m",
                "n",
                "o",
                "p",
                "q",
                "r",
                "s",
                "t",
                "u",
                "v",
                "w",
                "x",
                "y",
                "z"
            ]
        },
        BenchmarkResult: {
            components: "Vec<(BenchmarkParameter, u32)>",
            extrinsicTime: "u128",
            storageRootTime: "u128",
            reads: "u32",
            repeatReads: "u32",
            writes: "u32",
            repeatWrites: "u32",
            proofSize: "u32",
            benchKeys: "Vec<(Vec<u8>, u32, u32, bool)>"
        }
    }
};


const $859eaf6a3db57d39$var$BB_V2_TO_V4 = {
    // this was removed after V4
    random_seed: {
        description: "Generate a random seed.",
        params: [],
        type: "Hash"
    }
};
const $859eaf6a3db57d39$var$BB_V2_TO_V5 = {
    apply_extrinsic: {
        description: "Apply the given extrinsic.",
        params: [
            {
                name: "extrinsic",
                type: "Extrinsic"
            }
        ],
        type: "ApplyExtrinsicResultPre6"
    }
};
const $859eaf6a3db57d39$var$BB_V2_TO_V6 = {
    check_inherents: {
        description: "Check that the inherents are valid.",
        params: [
            {
                name: "block",
                type: "Block"
            },
            {
                name: "data",
                type: "InherentData"
            }
        ],
        type: "CheckInherentsResult"
    },
    inherent_extrinsics: {
        description: "Generate inherent extrinsics.",
        params: [
            {
                name: "inherent",
                type: "InherentData"
            }
        ],
        type: "Vec<Extrinsic>"
    }
};
const $859eaf6a3db57d39$var$BB_V3_TO_V6 = {
    // renamed in v3 from finalize_block
    finalize_block: {
        description: "Finish the current block.",
        params: [],
        type: "Header"
    }
};
const $859eaf6a3db57d39$export$874fd8712028ad21 = {
    BlockBuilder: [
        {
            methods: {
                apply_extrinsic: {
                    description: "Apply the given extrinsic.",
                    params: [
                        {
                            name: "extrinsic",
                            type: "Extrinsic"
                        }
                    ],
                    type: "ApplyExtrinsicResult"
                },
                ...$859eaf6a3db57d39$var$BB_V2_TO_V6,
                ...$859eaf6a3db57d39$var$BB_V3_TO_V6
            },
            version: 6
        },
        {
            methods: {
                // apply_extrinsic result changed in 6
                ...$859eaf6a3db57d39$var$BB_V2_TO_V5,
                ...$859eaf6a3db57d39$var$BB_V2_TO_V6,
                ...$859eaf6a3db57d39$var$BB_V3_TO_V6
            },
            version: 5
        },
        {
            methods: {
                // random_seed removed
                ...$859eaf6a3db57d39$var$BB_V2_TO_V4,
                ...$859eaf6a3db57d39$var$BB_V2_TO_V5,
                ...$859eaf6a3db57d39$var$BB_V2_TO_V6,
                ...$859eaf6a3db57d39$var$BB_V3_TO_V6
            },
            version: 4
        },
        {
            methods: {
                // finalize_block renamed
                ...$859eaf6a3db57d39$var$BB_V2_TO_V4,
                ...$859eaf6a3db57d39$var$BB_V2_TO_V6,
                ...$859eaf6a3db57d39$var$BB_V3_TO_V6
            },
            version: 3
        },
        {
            methods: {
                finalise_block: {
                    description: "Finish the current block.",
                    params: [],
                    type: "Header"
                },
                ...$859eaf6a3db57d39$var$BB_V2_TO_V4,
                ...$859eaf6a3db57d39$var$BB_V2_TO_V6
            },
            version: 2
        }
    ]
};


var $7a062c39b04b2ef1$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $859eaf6a3db57d39$export$874fd8712028ad21,
    types: {
        CheckInherentsResult: {
            okay: "bool",
            fatalError: "bool",
            errors: "InherentData"
        },
        InherentData: {
            data: "BTreeMap<InherentIdentifier, Bytes>"
        },
        InherentIdentifier: "[u8; 8]"
    }
};


var $cacc21be21aabce2$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        CollectiveOrigin: {
            _enum: {
                Members: "(MemberCount, MemberCount)",
                Member: "AccountId"
            }
        },
        MemberCount: "u32",
        ProposalIndex: "u32",
        VotesTo230: {
            index: "ProposalIndex",
            threshold: "MemberCount",
            ayes: "Vec<AccountId>",
            nays: "Vec<AccountId>"
        },
        Votes: {
            index: "ProposalIndex",
            threshold: "MemberCount",
            ayes: "Vec<AccountId>",
            nays: "Vec<AccountId>",
            end: "BlockNumber"
        }
    }
};


var $921d65424359fd1a$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        AuthorityId: "AccountId",
        RawVRFOutput: "[u8; 32]"
    }
};


const $33bf72494ff23a9f$export$82f5954781486db2 = {
    call: {
        deprecated: "Use the runtime interface `api.call.contractsApi.call` instead",
        description: "Executes a call to a contract",
        params: [
            {
                name: "callRequest",
                type: "ContractCallRequest"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "ContractExecResult"
    },
    getStorage: {
        deprecated: "Use the runtime interface `api.call.contractsApi.getStorage` instead",
        description: "Returns the value under a specified storage key in a contract",
        params: [
            {
                name: "address",
                type: "AccountId"
            },
            {
                name: "key",
                type: "H256"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Option<Bytes>"
    },
    instantiate: {
        deprecated: "Use the runtime interface `api.call.contractsApi.instantiate` instead",
        description: "Instantiate a new contract",
        params: [
            {
                name: "request",
                type: "InstantiateRequestV1"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "ContractInstantiateResult"
    },
    rentProjection: {
        deprecated: "Not available in newer versions of the contracts interfaces",
        description: "Returns the projected time a given contract will be able to sustain paying its rent",
        params: [
            {
                name: "address",
                type: "AccountId"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Option<BlockNumber>"
    },
    uploadCode: {
        deprecated: "Use the runtime interface `api.call.contractsApi.uploadCode` instead",
        description: "Upload new code without instantiating a contract from it",
        // The RPC here is terribly misnamed - somebody forgot how the RPCs
        // are actually done, ie. <module>_<camelCasedMethod>
        endpoint: "contracts_upload_code",
        params: [
            {
                name: "uploadRequest",
                type: "CodeUploadRequest"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "CodeUploadResult"
    }
};


const $c124654b7c5960cd$var$SHARED_V1_V2 = {
    get_storage: {
        description: "Query a given storage key in a given contract.",
        params: [
            {
                name: "address",
                type: "AccountId"
            },
            {
                name: "key",
                type: "Bytes"
            }
        ],
        type: "Option<Bytes>"
    },
    upload_code: {
        description: "Upload new code without instantiating a contract from it.",
        params: [
            {
                name: "origin",
                type: "AccountId"
            },
            {
                name: "code",
                type: "Bytes"
            },
            {
                name: "storageDepositLimit",
                type: "Option<Balance>"
            }
        ],
        type: "CodeUploadResult"
    }
};
const $c124654b7c5960cd$export$874fd8712028ad21 = {
    ContractsApi: [
        {
            methods: {
                call: {
                    description: "Perform a call from a specified account to a given contract.",
                    params: [
                        {
                            name: "origin",
                            type: "AccountId"
                        },
                        {
                            name: "dest",
                            type: "AccountId"
                        },
                        {
                            name: "value",
                            type: "Balance"
                        },
                        {
                            name: "gasLimit",
                            type: "Option<WeightV2>"
                        },
                        {
                            name: "storageDepositLimit",
                            type: "Option<Balance>"
                        },
                        {
                            name: "inputData",
                            type: "Vec<u8>"
                        }
                    ],
                    type: "ContractExecResult"
                },
                instantiate: {
                    description: "Instantiate a new contract.",
                    params: [
                        {
                            name: "origin",
                            type: "AccountId"
                        },
                        {
                            name: "value",
                            type: "Balance"
                        },
                        {
                            name: "gasLimit",
                            type: "Option<WeightV2>"
                        },
                        {
                            name: "storageDepositLimit",
                            type: "Option<Balance>"
                        },
                        {
                            name: "code",
                            type: "CodeSource"
                        },
                        {
                            name: "data",
                            type: "Bytes"
                        },
                        {
                            name: "salt",
                            type: "Bytes"
                        }
                    ],
                    type: "ContractInstantiateResult"
                },
                ...$c124654b7c5960cd$var$SHARED_V1_V2
            },
            version: 2
        },
        {
            methods: {
                call: {
                    description: "Perform a call from a specified account to a given contract.",
                    params: [
                        {
                            name: "origin",
                            type: "AccountId"
                        },
                        {
                            name: "dest",
                            type: "AccountId"
                        },
                        {
                            name: "value",
                            type: "Balance"
                        },
                        {
                            name: "gasLimit",
                            type: "u64"
                        },
                        {
                            name: "storageDepositLimit",
                            type: "Option<Balance>"
                        },
                        {
                            name: "inputData",
                            type: "Vec<u8>"
                        }
                    ],
                    type: "ContractExecResultU64"
                },
                instantiate: {
                    description: "Instantiate a new contract.",
                    params: [
                        {
                            name: "origin",
                            type: "AccountId"
                        },
                        {
                            name: "value",
                            type: "Balance"
                        },
                        {
                            name: "gasLimit",
                            type: "u64"
                        },
                        {
                            name: "storageDepositLimit",
                            type: "Option<Balance>"
                        },
                        {
                            name: "code",
                            type: "CodeSource"
                        },
                        {
                            name: "data",
                            type: "Bytes"
                        },
                        {
                            name: "salt",
                            type: "Bytes"
                        }
                    ],
                    type: "ContractInstantiateResultU64"
                },
                ...$c124654b7c5960cd$var$SHARED_V1_V2
            },
            version: 1
        }
    ]
};


var $901173f692165aab$export$2e2bcd8739ae039 = {
    rpc: $33bf72494ff23a9f$export$82f5954781486db2,
    runtime: $c124654b7c5960cd$export$874fd8712028ad21,
    types: {
        AliveContractInfo: {
            trieId: "TrieId",
            storageSize: "u32",
            pairCount: "u32",
            codeHash: "CodeHash",
            rentAllowance: "Balance",
            rentPaid: "Balance",
            deductBlock: "BlockNumber",
            lastWrite: "Option<BlockNumber>",
            _reserved: "Option<Null>"
        },
        CodeHash: "Hash",
        CodeSource: {
            _enum: {
                Upload: "Bytes",
                Existing: "Hash"
            }
        },
        CodeUploadRequest: {
            origin: "AccountId",
            code: "Bytes",
            storageDepositLimit: "Option<Balance>"
        },
        CodeUploadResult: "Result<CodeUploadResultValue, DispatchError>",
        CodeUploadResultValue: {
            codeHash: "CodeHash",
            deposit: "Balance"
        },
        ContractCallRequest: {
            origin: "AccountId",
            dest: "AccountId",
            value: "Balance",
            gasLimit: "u64",
            storageDepositLimit: "Option<Balance>",
            inputData: "Bytes"
        },
        ContractExecResultSuccessTo255: {
            status: "u8",
            data: "Raw"
        },
        ContractExecResultTo255: {
            _enum: {
                Success: "ContractExecResultSuccessTo255",
                Error: "Null"
            }
        },
        ContractExecResultSuccessTo260: {
            flags: "ContractReturnFlags",
            data: "Bytes",
            gasConsumed: "u64"
        },
        ContractExecResultTo260: {
            _enum: {
                Success: "ContractExecResultSuccessTo260",
                Error: "Null"
            }
        },
        ContractExecResultOk: {
            flags: "ContractReturnFlags",
            data: "Bytes"
        },
        ContractExecResultResult: "Result<ContractExecResultOk, DispatchError>",
        ContractExecResultTo267: {
            gasConsumed: "u64",
            debugMessage: "Text",
            result: "ContractExecResultResult"
        },
        ContractExecResult: {
            gasConsumed: "Weight",
            gasRequired: "Weight",
            storageDeposit: "StorageDeposit",
            debugMessage: "Text",
            result: "ContractExecResultResult"
        },
        ContractExecResultU64: {
            gasConsumed: "u64",
            gasRequired: "u64",
            storageDeposit: "StorageDeposit",
            debugMessage: "Text",
            result: "ContractExecResultResult"
        },
        ContractInfo: {
            _enum: {
                Alive: "AliveContractInfo",
                Tombstone: "TombstoneContractInfo"
            }
        },
        ContractCallFlags: {
            _set: {
                _bitLength: 32,
                ForwardInput: 1,
                CloneInput: 2,
                TailCall: 4,
                AllowReentry: 8
            }
        },
        ContractReturnFlags: {
            _set: {
                _bitLength: 32,
                Revert: 1
            }
        },
        ContractStorageKey: "[u8; 32]",
        DeletedContract: {
            pairCount: "u32",
            trieId: "TrieId"
        },
        ExecReturnValue: {
            flags: "ContractReturnFlags",
            data: "Bytes"
        },
        Gas: "u64",
        HostFnWeightsTo264: {
            caller: "Weight",
            address: "Weight",
            gasLeft: "Weight",
            balance: "Weight",
            valueTransferred: "Weight",
            minimumBalance: "Weight",
            tombstoneDeposit: "Weight",
            rentAllowance: "Weight",
            blockNumber: "Weight",
            now: "Weight",
            weightToFee: "Weight",
            gas: "Weight",
            input: "Weight",
            inputPerByte: "Weight",
            return: "Weight",
            returnPerByte: "Weight",
            terminate: "Weight",
            restoreTo: "Weight",
            restoreToPerDelta: "Weight",
            random: "Weight",
            depositEvent: "Weight",
            depositEventPerTopic: "Weight",
            depositEventPerByte: "Weight",
            setRentAllowance: "Weight",
            setStorage: "Weight",
            setStoragePerByte: "Weight",
            clearStorage: "Weight",
            getStorage: "Weight",
            getStoragePerByte: "Weight",
            transfer: "Weight",
            call: "Weight",
            callTransferSurcharge: "Weight",
            callPerInputByte: "Weight",
            callPerOutputByte: "Weight",
            instantiate: "Weight",
            instantiatePerInputByte: "Weight",
            instantiatePerOutputByte: "Weight",
            hashSha2256: "Weight",
            hashSha2256PerByte: "Weight",
            hashKeccak256: "Weight",
            hashKeccak256PerByte: "Weight",
            hashBlake2256: "Weight",
            hashBlake2256PerByte: "Weight",
            hashBlake2128: "Weight",
            hashBlake2128PerByte: "Weight"
        },
        HostFnWeights: {
            caller: "Weight",
            address: "Weight",
            gasLeft: "Weight",
            balance: "Weight",
            valueTransferred: "Weight",
            minimumBalance: "Weight",
            tombstoneDeposit: "Weight",
            rentAllowance: "Weight",
            blockNumber: "Weight",
            now: "Weight",
            weightToFee: "Weight",
            gas: "Weight",
            input: "Weight",
            inputPerByte: "Weight",
            return: "Weight",
            returnPerByte: "Weight",
            terminate: "Weight",
            terminatePerCodeByte: "Weight",
            restoreTo: "Weight",
            restoreToPerCallerCodeByte: "Weight",
            restoreToPerTombstoneCodeByte: "Weight",
            restoreToPerDelta: "Weight",
            random: "Weight",
            depositEvent: "Weight",
            depositEventPerTopic: "Weight",
            depositEventPerByte: "Weight",
            setRentAllowance: "Weight",
            setStorage: "Weight",
            setStoragePerByte: "Weight",
            clearStorage: "Weight",
            getStorage: "Weight",
            getStoragePerByte: "Weight",
            transfer: "Weight",
            call: "Weight",
            callPerCodeByte: "Weight",
            callTransferSurcharge: "Weight",
            callPerInputByte: "Weight",
            callPerOutputByte: "Weight",
            instantiate: "Weight",
            instantiatePerCodeByte: "Weight",
            instantiatePerInputByte: "Weight",
            instantiatePerOutputByte: "Weight",
            instantiatePerSaltByte: "Weight",
            hashSha2256: "Weight",
            hashSha2256PerByte: "Weight",
            hashKeccak256: "Weight",
            hashKeccak256PerByte: "Weight",
            hashBlake2256: "Weight",
            hashBlake2256PerByte: "Weight",
            hashBlake2128: "Weight",
            hashBlake2128PerByte: "Weight",
            rentParams: "Weight"
        },
        InstantiateRequestV1: {
            origin: "AccountId",
            value: "Balance",
            gasLimit: "Gas",
            code: "Bytes",
            data: "Bytes",
            salt: "Bytes"
        },
        InstantiateRequestV2: {
            _fallback: "InstantiateRequestV1",
            origin: "AccountId",
            value: "Balance",
            gasLimit: "Gas",
            storageDepositLimit: "Option<Balance>",
            code: "Bytes",
            data: "Bytes",
            salt: "Bytes"
        },
        InstantiateRequest: {
            _fallback: "InstantiateRequestV2",
            origin: "AccountId",
            value: "Balance",
            gasLimit: "Gas",
            storageDepositLimit: "Option<Balance>",
            code: "CodeSource",
            data: "Bytes",
            salt: "Bytes"
        },
        ContractInstantiateResultTo267: "Result<InstantiateReturnValueTo267, Null>",
        ContractInstantiateResultTo299: "Result<InstantiateReturnValueOk, Null>",
        ContractInstantiateResult: {
            gasConsumed: "WeightV2",
            gasRequired: "WeightV2",
            storageDeposit: "StorageDeposit",
            debugMessage: "Text",
            result: "InstantiateReturnValue"
        },
        ContractInstantiateResultU64: {
            // only this one can fail, the current version (above) _should_ be correctly
            // versioned now, aka no more deprecated RPCs involved, only runtime calls
            _fallback: "ContractInstantiateResultTo299",
            gasConsumed: "u64",
            gasRequired: "u64",
            storageDeposit: "StorageDeposit",
            debugMessage: "Text",
            result: "InstantiateReturnValue"
        },
        InstantiateReturnValueTo267: {
            result: "ExecReturnValue",
            accountId: "AccountId",
            rentProjection: "Option<RentProjection>"
        },
        InstantiateReturnValueOk: {
            result: "ExecReturnValue",
            accountId: "AccountId"
        },
        InstantiateReturnValue: "Result<InstantiateReturnValueOk, DispatchError>",
        InstructionWeights: {
            i64const: "u32",
            i64load: "u32",
            i64store: "u32",
            select: "u32",
            rIf: "u32",
            br: "u32",
            brIf: "u32",
            brIable: "u32",
            brIablePerEntry: "u32",
            call: "u32",
            callIndirect: "u32",
            callIndirectPerParam: "u32",
            localGet: "u32",
            localSet: "u32",
            local_tee: "u32",
            globalGet: "u32",
            globalSet: "u32",
            memoryCurrent: "u32",
            memoryGrow: "u32",
            i64clz: "u32",
            i64ctz: "u32",
            i64popcnt: "u32",
            i64eqz: "u32",
            i64extendsi32: "u32",
            i64extendui32: "u32",
            i32wrapi64: "u32",
            i64eq: "u32",
            i64ne: "u32",
            i64lts: "u32",
            i64ltu: "u32",
            i64gts: "u32",
            i64gtu: "u32",
            i64les: "u32",
            i64leu: "u32",
            i64ges: "u32",
            i64geu: "u32",
            i64add: "u32",
            i64sub: "u32",
            i64mul: "u32",
            i64divs: "u32",
            i64divu: "u32",
            i64rems: "u32",
            i64remu: "u32",
            i64and: "u32",
            i64or: "u32",
            i64xor: "u32",
            i64shl: "u32",
            i64shrs: "u32",
            i64shru: "u32",
            i64rotl: "u32",
            i64rotr: "u32"
        },
        LimitsTo264: {
            eventTopics: "u32",
            stackHeight: "u32",
            globals: "u32",
            parameters: "u32",
            memoryPages: "u32",
            tableSize: "u32",
            brTableSize: "u32",
            subjectLen: "u32",
            codeSize: "u32"
        },
        Limits: {
            eventTopics: "u32",
            stackHeight: "u32",
            globals: "u32",
            parameters: "u32",
            memoryPages: "u32",
            tableSize: "u32",
            brTableSize: "u32",
            subjectLen: "u32"
        },
        PrefabWasmModule: {
            scheduleVersion: "Compact<u32>",
            initial: "Compact<u32>",
            maximum: "Compact<u32>",
            refcount: "Compact<u64>",
            _reserved: "Option<Null>",
            code: "Bytes",
            originalCodeLen: "u32"
        },
        RentProjection: {
            _enum: {
                EvictionAt: "BlockNumber",
                NoEviction: "Null"
            }
        },
        ScheduleTo212: {
            version: "u32",
            putCodePerByteCost: "Gas",
            growMemCost: "Gas",
            regularOpCost: "Gas",
            returnDataPerByteCost: "Gas",
            eventDataPerByteCost: "Gas",
            eventPerTopicCost: "Gas",
            eventBaseCost: "Gas",
            sandboxDataReadCost: "Gas",
            sandboxDataWriteCost: "Gas",
            maxEventTopics: "u32",
            maxStackHeight: "u32",
            maxMemoryPages: "u32",
            enablePrintln: "bool",
            maxSubjectLen: "u32"
        },
        ScheduleTo258: {
            version: "u32",
            putCodePerByteCost: "Gas",
            growMemCost: "Gas",
            regularOpCost: "Gas",
            returnDataPerByteCost: "Gas",
            eventDataPerByteCost: "Gas",
            eventPerTopicCost: "Gas",
            eventBaseCost: "Gas",
            sandboxDataReadCost: "Gas",
            sandboxDataWriteCost: "Gas",
            transferCost: "Gas",
            maxEventTopics: "u32",
            maxStackHeight: "u32",
            maxMemoryPages: "u32",
            enablePrintln: "bool",
            maxSubjectLen: "u32"
        },
        ScheduleTo264: {
            version: "u32",
            enablePrintln: "bool",
            limits: "LimitsTo264",
            instructionWeights: "InstructionWeights",
            hostFnWeights: "HostFnWeightsTo264"
        },
        Schedule: {
            version: "u32",
            enablePrintln: "bool",
            limits: "Limits",
            instructionWeights: "InstructionWeights",
            hostFnWeights: "HostFnWeights"
        },
        SeedOf: "Hash",
        StorageDeposit: {
            _enum: {
                Refund: "Balance",
                Charge: "Balance"
            }
        },
        TombstoneContractInfo: "Hash",
        TrieId: "Bytes"
    }
};


const $09b20fc847164ad5$export$b831416a98542821 = [
    // 0.1x votes, unlocked.
    "None",
    // 1x votes, locked for an enactment period following a successful vote.
    "Locked1x",
    // 2x votes, locked for 2x enactment periods following a successful vote.
    "Locked2x",
    // 3x votes, locked for 4x...
    "Locked3x",
    // 4x votes, locked for 8x...
    "Locked4x",
    // 5x votes, locked for 16x...
    "Locked5x",
    // 6x votes, locked for 32x...
    "Locked6x"
];
var $09b20fc847164ad5$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        AccountVote: {
            _enum: {
                Standard: "AccountVoteStandard",
                Split: "AccountVoteSplit"
            }
        },
        AccountVoteSplit: {
            aye: "Balance",
            nay: "Balance"
        },
        AccountVoteStandard: {
            vote: "Vote",
            balance: "Balance"
        },
        Conviction: {
            _enum: $09b20fc847164ad5$export$b831416a98542821
        },
        Delegations: {
            votes: "Balance",
            capital: "Balance"
        },
        PreimageStatus: {
            _enum: {
                Missing: "BlockNumber",
                Available: "PreimageStatusAvailable"
            }
        },
        PreimageStatusAvailable: {
            data: "Bytes",
            provider: "AccountId",
            deposit: "Balance",
            since: "BlockNumber",
            expiry: "Option<BlockNumber>"
        },
        PriorLock: "(BlockNumber, Balance)",
        PropIndex: "u32",
        Proposal: "Call",
        ProxyState: {
            _enum: {
                Open: "AccountId",
                Active: "AccountId"
            }
        },
        ReferendumIndex: "u32",
        ReferendumInfoTo239: {
            end: "BlockNumber",
            proposalHash: "Hash",
            threshold: "VoteThreshold",
            delay: "BlockNumber"
        },
        ReferendumInfo: {
            _enum: {
                Ongoing: "ReferendumStatus",
                Finished: "ReferendumInfoFinished"
            }
        },
        ReferendumInfoFinished: {
            approved: "bool",
            end: "BlockNumber"
        },
        ReferendumStatus: {
            end: "BlockNumber",
            proposalHash: "Hash",
            threshold: "VoteThreshold",
            delay: "BlockNumber",
            tally: "Tally"
        },
        Tally: {
            ayes: "Balance",
            nays: "Balance",
            turnout: "Balance"
        },
        Voting: {
            _enum: {
                Direct: "VotingDirect",
                Delegating: "VotingDelegating"
            }
        },
        VotingDirect: {
            votes: "Vec<VotingDirectVote>",
            delegations: "Delegations",
            prior: "PriorLock"
        },
        VotingDirectVote: "(ReferendumIndex, AccountVote)",
        VotingDelegating: {
            balance: "Balance",
            target: "AccountId",
            conviction: "Conviction",
            delegations: "Delegations",
            prior: "PriorLock"
        }
    }
};


const $7dae97ae8bf65888$export$82f5954781486db2 = {
    getBlockStats: {
        description: "Reexecute the specified `block_hash` and gather statistics while doing so",
        isUnsafe: true,
        params: [
            {
                isHistoric: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Option<BlockStats>"
    }
};


var $9ca601cb967a8c79$export$2e2bcd8739ae039 = {
    rpc: $7dae97ae8bf65888$export$82f5954781486db2,
    types: {
        BlockStats: {
            witnessLen: "u64",
            witnessCompactLen: "u64",
            blockLen: "u64",
            blockNumExtrinsics: "u64"
        }
    }
};


const $a29859d00b537ed6$export$874fd8712028ad21 = {
    AuthorityDiscoveryApi: [
        {
            methods: {
                authorities: {
                    description: "Retrieve authority identifiers of the current and next authority set.",
                    params: [],
                    type: "Vec<AuthorityId>"
                }
            },
            version: 1
        }
    ]
};


var $ca9ab72eabe5d4a5$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $a29859d00b537ed6$export$874fd8712028ad21,
    types: {}
};


var $813540352a02bcef$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ApprovalFlag: "u32",
        DefunctVoter: {
            who: "AccountId",
            voteCount: "Compact<u32>",
            candidateCount: "Compact<u32>"
        },
        Renouncing: {
            _enum: {
                Member: "Null",
                RunnerUp: "Null",
                Candidate: "Compact<u32>"
            }
        },
        SetIndex: "u32",
        Vote: "GenericVote",
        VoteIndex: "u32",
        VoterInfo: {
            lastActive: "VoteIndex",
            lastWin: "VoteIndex",
            pot: "Balance",
            stake: "Balance"
        },
        VoteThreshold: {
            _enum: [
                "Super Majority Approve",
                "Super Majority Against",
                "Simple Majority"
            ]
        }
    }
};


const $e4a8713d02838c0d$export$82f5954781486db2 = {
    createBlock: {
        description: "Instructs the manual-seal authorship task to create a new block",
        params: [
            {
                name: "createEmpty",
                type: "bool"
            },
            {
                name: "finalize",
                type: "bool"
            },
            {
                isOptional: true,
                name: "parentHash",
                type: "BlockHash"
            }
        ],
        type: "CreatedBlock"
    },
    finalizeBlock: {
        description: "Instructs the manual-seal authorship task to finalize a block",
        params: [
            {
                name: "hash",
                type: "BlockHash"
            },
            {
                isOptional: true,
                name: "justification",
                type: "Justification"
            }
        ],
        type: "bool"
    }
};


var $034e762b479a231b$export$2e2bcd8739ae039 = {
    rpc: $e4a8713d02838c0d$export$82f5954781486db2,
    types: {
        CreatedBlock: {
            _alias: {
                blockHash: "hash"
            },
            blockHash: "BlockHash",
            aux: "ImportedAux"
        },
        ImportedAux: {
            headerOnly: "bool",
            clearJustificationRequests: "bool",
            needsJustification: "bool",
            badJustification: "bool",
            needsFinalityProof: "bool",
            isNewBest: "bool"
        }
    }
};


var $9bfdb1322427f123$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        EvmAccount: {
            nonce: "u256",
            balance: "u256"
        },
        EvmCallInfo: {
            exitReason: "ExitReason",
            value: "Bytes",
            usedGas: "U256",
            logs: "Vec<EvmLog>"
        },
        EvmCreateInfo: {
            exitReason: "ExitReason",
            value: "H160",
            usedGas: "U256",
            logs: "Vec<EvmLog>"
        },
        EvmLog: {
            address: "H160",
            topics: "Vec<H256>",
            data: "Bytes"
        },
        EvmVicinity: {
            gasPrice: "u256",
            origin: "H160"
        },
        ExitError: {
            _enum: {
                StackUnderflow: "Null",
                StackOverflow: "Null",
                InvalidJump: "Null",
                InvalidRange: "Null",
                DesignatedInvalid: "Null",
                CallTooDeep: "Null",
                CreateCollision: "Null",
                CreateContractLimit: "Null",
                OutOfOffset: "Null",
                OutOfGas: "Null",
                OutOfFund: "Null",
                PCUnderflow: "Null",
                CreateEmpty: "Null",
                Other: "Text"
            }
        },
        ExitFatal: {
            _enum: {
                NotSupported: "Null",
                UnhandledInterrupt: "Null",
                CallErrorAsFatal: "ExitError",
                Other: "Text"
            }
        },
        ExitReason: {
            _enum: {
                Succeed: "ExitSucceed",
                Error: "ExitError",
                Revert: "ExitRevert",
                Fatal: "ExitFatal"
            }
        },
        ExitRevert: {
            _enum: [
                "Reverted"
            ]
        },
        ExitSucceed: {
            _enum: [
                "Stopped",
                "Returned",
                "Suicided"
            ]
        }
    }
};


var $e86e6bc082f8db29$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Extrinsic: "GenericExtrinsic",
        ExtrinsicEra: "GenericExtrinsicEra",
        ExtrinsicPayload: "GenericExtrinsicPayload",
        ExtrinsicSignature: "MultiSignature",
        ExtrinsicV4: "GenericExtrinsicV4",
        ExtrinsicPayloadV4: "GenericExtrinsicPayloadV4",
        ExtrinsicSignatureV4: "GenericExtrinsicSignatureV4",
        ExtrinsicUnknown: "GenericExtrinsicUnknown",
        ExtrinsicPayloadUnknown: "GenericExtrinsicPayloadUnknown",
        // eras
        Era: "ExtrinsicEra",
        ImmortalEra: "GenericImmortalEra",
        MortalEra: "GenericMortalEra",
        // signatures & signer
        AnySignature: "H512",
        MultiSignature: {
            _enum: {
                Ed25519: "Ed25519Signature",
                Sr25519: "Sr25519Signature",
                Ecdsa: "EcdsaSignature"
            }
        },
        Signature: "H512",
        SignerPayload: "GenericSignerPayload",
        EcdsaSignature: "[u8; 65]",
        Ed25519Signature: "H512",
        Sr25519Signature: "H512"
    }
};


const $2cf2b0bddae04654$export$874fd8712028ad21 = {
    FungiblesApi: [
        {
            methods: {
                query_account_balances: {
                    description: "Returns the list of all `MultiAsset` that an `AccountId` has",
                    params: [
                        {
                            name: "account",
                            type: "AccountId"
                        }
                    ],
                    type: "Result<Vec<XcmV3MultiAsset>, FungiblesAccessError>"
                }
            },
            version: 1
        }
    ]
};


var $6d13662795b82a01$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $2cf2b0bddae04654$export$874fd8712028ad21,
    types: {
        FungiblesAccessError: {
            _enum: [
                "AssetIdConversionFailed",
                "AmountToBalanceConversionFailed"
            ]
        }
    }
};


var $f51debcac6ddd468$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        AssetOptions: {
            initalIssuance: "Compact<Balance>",
            permissions: "PermissionLatest"
        },
        Owner: {
            _enum: {
                None: "Null",
                Address: "AccountId"
            }
        },
        PermissionsV1: {
            update: "Owner",
            mint: "Owner",
            burn: "Owner"
        },
        PermissionVersions: {
            _enum: {
                V1: "PermissionsV1"
            }
        },
        PermissionLatest: "PermissionsV1"
    }
};


var $79bc2be1200af744$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ActiveGilt: {
            proportion: "Perquintill",
            amount: "Balance",
            who: "AccountId",
            expiry: "BlockNumber"
        },
        ActiveGiltsTotal: {
            frozen: "Balance",
            proportion: "Perquintill",
            index: "ActiveIndex",
            target: "Perquintill"
        },
        ActiveIndex: "u32",
        GiltBid: {
            amount: "Balance",
            who: "AccountId"
        }
    }
};


const $33e9ded155c87fb4$export$82f5954781486db2 = {
    proveFinality: {
        description: "Prove finality for the given block number, returning the Justification for the last block in the set.",
        params: [
            {
                name: "blockNumber",
                type: "BlockNumber"
            }
        ],
        type: "Option<EncodedFinalityProofs>"
    },
    roundState: {
        description: "Returns the state of the current best round state as well as the ongoing background rounds",
        params: [],
        type: "ReportedRoundStates"
    },
    subscribeJustifications: {
        description: "Subscribes to grandpa justifications",
        params: [],
        pubsub: [
            "justifications",
            "subscribeJustifications",
            "unsubscribeJustifications"
        ],
        type: "JustificationNotification"
    }
};


const $f479070699311381$var$GRANDPA_V2_V3 = {
    generate_key_ownership_proof: {
        description: "Generates a proof of key ownership for the given authority in the given set.",
        params: [
            {
                name: "setId",
                type: "SetId"
            },
            {
                name: "authorityId",
                type: "AuthorityId"
            }
        ],
        type: "Option<OpaqueKeyOwnershipProof>"
    },
    grandpa_authorities: {
        description: "Get the current GRANDPA authorities and weights. This should not change except for when changes are scheduled and the corresponding delay has passed.",
        params: [],
        type: "AuthorityList"
    },
    submit_report_equivocation_unsigned_extrinsic: {
        description: "Submits an unsigned extrinsic to report an equivocation.",
        params: [
            {
                name: "equivocationProof",
                type: "GrandpaEquivocationProof"
            },
            {
                name: "keyOwnerProof",
                type: "OpaqueKeyOwnershipProof"
            }
        ],
        type: "Option<Null>"
    }
};
const $f479070699311381$export$874fd8712028ad21 = {
    GrandpaApi: [
        {
            methods: {
                current_set_id: {
                    description: "Get current GRANDPA authority set id.",
                    params: [],
                    type: "SetId"
                },
                ...$f479070699311381$var$GRANDPA_V2_V3
            },
            version: 3
        },
        {
            methods: $f479070699311381$var$GRANDPA_V2_V3,
            version: 2
        }
    ]
};


var $765e70e545eb56ef$export$2e2bcd8739ae039 = {
    rpc: $33e9ded155c87fb4$export$82f5954781486db2,
    runtime: $f479070699311381$export$874fd8712028ad21,
    types: {
        AuthorityIndex: "u64",
        AuthorityList: "Vec<NextAuthority>",
        AuthoritySet: {
            currentAuthorities: "AuthorityList",
            setId: "u64",
            pendingStandardChanges: "ForkTreePendingChange",
            pendingForcedChanges: "Vec<PendingChange>",
            authoritySetChanges: "AuthoritySetChanges"
        },
        ForkTreePendingChange: {
            roots: "Vec<ForkTreePendingChangeNode>",
            bestFinalizedNumber: "Option<BlockNumber>"
        },
        ForkTreePendingChangeNode: {
            hash: "BlockHash",
            number: "BlockNumber",
            data: "PendingChange",
            children: "Vec<ForkTreePendingChangeNode>"
        },
        AuthoritySetChange: "(U64, BlockNumber)",
        AuthoritySetChanges: "Vec<AuthoritySetChange>",
        AuthorityWeight: "u64",
        DelayKind: {
            _enum: {
                Finalized: "Null",
                Best: "DelayKindBest"
            }
        },
        DelayKindBest: {
            medianLastFinalized: "BlockNumber"
        },
        EncodedFinalityProofs: "Bytes",
        GrandpaEquivocation: {
            _enum: {
                Prevote: "GrandpaEquivocationValue",
                Precommit: "GrandpaEquivocationValue"
            }
        },
        GrandpaEquivocationProof: {
            setId: "SetId",
            equivocation: "GrandpaEquivocation"
        },
        GrandpaEquivocationValue: {
            roundNumber: "u64",
            identity: "AuthorityId",
            first: "(GrandpaPrevote, AuthoritySignature)",
            second: "(GrandpaPrevote, AuthoritySignature)"
        },
        GrandpaPrevote: {
            targetHash: "Hash",
            targetNumber: "BlockNumber"
        },
        GrandpaCommit: {
            targetHash: "BlockHash",
            targetNumber: "BlockNumber",
            precommits: "Vec<GrandpaSignedPrecommit>"
        },
        GrandpaPrecommit: {
            targetHash: "BlockHash",
            targetNumber: "BlockNumber"
        },
        GrandpaSignedPrecommit: {
            precommit: "GrandpaPrecommit",
            signature: "AuthoritySignature",
            id: "AuthorityId"
        },
        GrandpaJustification: {
            round: "u64",
            commit: "GrandpaCommit",
            votesAncestries: "Vec<Header>"
        },
        JustificationNotification: "Bytes",
        KeyOwnerProof: "MembershipProof",
        NextAuthority: "(AuthorityId, AuthorityWeight)",
        PendingChange: {
            nextAuthorities: "AuthorityList",
            delay: "BlockNumber",
            canonHeight: "BlockNumber",
            canonHash: "BlockHash",
            delayKind: "DelayKind"
        },
        PendingPause: {
            scheduledAt: "BlockNumber",
            delay: "BlockNumber"
        },
        PendingResume: {
            scheduledAt: "BlockNumber",
            delay: "BlockNumber"
        },
        Precommits: {
            currentWeight: "u32",
            missing: "BTreeSet<AuthorityId>"
        },
        Prevotes: {
            currentWeight: "u32",
            missing: "BTreeSet<AuthorityId>"
        },
        ReportedRoundStates: {
            setId: "u32",
            best: "RoundState",
            background: "Vec<RoundState>"
        },
        RoundState: {
            round: "u32",
            totalWeight: "u32",
            thresholdWeight: "u32",
            prevotes: "Prevotes",
            precommits: "Precommits"
        },
        SetId: "u64",
        StoredPendingChange: {
            scheduledAt: "BlockNumber",
            delay: "BlockNumber",
            nextAuthorities: "AuthorityList"
        },
        StoredState: {
            _enum: {
                Live: "Null",
                PendingPause: "PendingPause",
                Paused: "Null",
                PendingResume: "PendingResume"
            }
        }
    }
};


var $226242da1b568d5e$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        IdentityFields: {
            _set: {
                _bitLength: 64,
                // Mapped here to 32 bits, in Rust these are 64-bit values
                Display: 1,
                Legal: 2,
                Web: 4,
                Riot: 8,
                Email: 16,
                PgpFingerprint: 32,
                Image: 64,
                Twitter: 128
            }
        },
        IdentityInfoAdditional: "(Data, Data)",
        IdentityInfoTo198: {
            additional: "Vec<IdentityInfoAdditional>",
            display: "Data",
            legal: "Data",
            web: "Data",
            riot: "Data",
            email: "Data",
            pgpFingerprint: "Option<H160>",
            image: "Data"
        },
        IdentityInfo: {
            _fallback: "IdentityInfoTo198",
            additional: "Vec<IdentityInfoAdditional>",
            display: "Data",
            legal: "Data",
            web: "Data",
            riot: "Data",
            email: "Data",
            pgpFingerprint: "Option<H160>",
            image: "Data",
            twitter: "Data"
        },
        IdentityJudgement: {
            _enum: {
                Unknown: "Null",
                FeePaid: "Balance",
                Reasonable: "Null",
                KnownGood: "Null",
                OutOfDate: "Null",
                LowQuality: "Null",
                Erroneous: "Null"
            }
        },
        RegistrationJudgement: "(RegistrarIndex, IdentityJudgement)",
        RegistrationTo198: {
            judgements: "Vec<RegistrationJudgement>",
            deposit: "Balance",
            info: "IdentityInfoTo198"
        },
        Registration: {
            _fallback: "RegistrationTo198",
            judgements: "Vec<RegistrationJudgement>",
            deposit: "Balance",
            info: "IdentityInfo"
        },
        RegistrarIndex: "u32",
        RegistrarInfo: {
            account: "AccountId",
            fee: "Balance",
            fields: "IdentityFields"
        }
    }
};


var $f837b12048a3efb3$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        AuthIndex: "u32",
        AuthoritySignature: "Signature",
        Heartbeat: {
            blockNumber: "BlockNumber",
            networkState: "OpaqueNetworkState",
            sessionIndex: "SessionIndex",
            authorityIndex: "AuthIndex",
            validatorsLen: "u32"
        },
        HeartbeatTo244: {
            blockNumber: "BlockNumber",
            networkState: "OpaqueNetworkState",
            sessionIndex: "SessionIndex",
            authorityIndex: "AuthIndex"
        },
        OpaqueMultiaddr: "Opaque<Bytes>",
        OpaquePeerId: "Opaque<Bytes>",
        OpaqueNetworkState: {
            peerId: "OpaquePeerId",
            externalAddresses: "Vec<OpaqueMultiaddr>"
        }
    }
};


var $a079b073c9c94481$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        CallIndex: "(u8, u8)",
        LotteryConfig: {
            price: "Balance",
            start: "BlockNumber",
            length: "BlockNumber",
            delay: "BlockNumber",
            repeat: "bool"
        }
    }
};


const $e7ec5528dcb0c4da$export$82f5954781486db2 = {
    generateProof: {
        description: "Generate MMR proof for the given block numbers.",
        params: [
            {
                name: "blockNumbers",
                type: "Vec<u64>"
            },
            {
                isOptional: true,
                name: "bestKnownBlockNumber",
                type: "u64"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "MmrLeafBatchProof"
    },
    root: {
        description: "Get the MMR root hash for the current best block.",
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "MmrHash"
    },
    verifyProof: {
        description: "Verify an MMR proof",
        params: [
            {
                name: "proof",
                type: "MmrLeafBatchProof"
            }
        ],
        type: "bool"
    },
    verifyProofStateless: {
        description: "Verify an MMR proof statelessly given an mmr_root",
        params: [
            {
                name: "root",
                type: "MmrHash"
            },
            {
                name: "proof",
                type: "MmrLeafBatchProof"
            }
        ],
        type: "bool"
    }
};


const $c0a8e5bc024a189b$var$MMR_V2 = {
    generate_proof: {
        description: "Generate MMR proof for the given block numbers.",
        params: [
            {
                name: "blockNumbers",
                type: "Vec<BlockNumber>"
            },
            {
                name: "bestKnownBlockNumber",
                type: "Option<BlockNumber>"
            }
        ],
        type: "Result<(Vec<MmrEncodableOpaqueLeaf>, MmrBatchProof), MmrError>"
    },
    root: {
        description: "Return the on-chain MMR root hash.",
        params: [],
        type: "Result<Hash, MmrError>"
    },
    verify_proof: {
        description: "Verify MMR proof against on-chain MMR.",
        params: [
            {
                name: "leaves",
                type: "Vec<MmrEncodableOpaqueLeaf>"
            },
            {
                name: "proof",
                type: "MmrBatchProof"
            }
        ],
        type: "Result<(), MmrError>"
    },
    verify_proof_stateless: {
        description: "Verify MMR proof against given root hash.",
        params: [
            {
                name: "root",
                type: "Hash"
            },
            {
                name: "leaves",
                type: "Vec<MmrEncodableOpaqueLeaf>"
            },
            {
                name: "proof",
                type: "MmrBatchProof"
            }
        ],
        type: "Result<(), MmrError>"
    }
};
const $c0a8e5bc024a189b$var$MMR_V1 = {
    generate_batch_proof: {
        description: "Generate MMR proof for a series of leaves under given indices.",
        params: [
            {
                name: "leafIndices",
                type: "Vec<MmrLeafIndex>"
            }
        ],
        type: "Result<(Vec<MmrEncodableOpaqueLeaf>, MmrBatchProof), MmrError>"
    },
    generate_proof: {
        description: "Generate MMR proof for a leaf under given index.",
        params: [
            {
                name: "leafIndex",
                type: "MmrLeafIndex"
            }
        ],
        type: "Result<(MmrEncodableOpaqueLeaf, MmrProof), MmrError>"
    },
    mmr_root: {
        description: "Return the on-chain MMR root hash.",
        params: [],
        type: "Result<Hash, MmrError>"
    },
    verify_batch_proof: {
        description: "Verify MMR proof against on-chain MMR for a batch of leaves.",
        params: [
            {
                name: "leaves",
                type: "Vec<MmrEncodableOpaqueLeaf>"
            },
            {
                name: "proof",
                type: "MmrBatchProof"
            }
        ],
        type: "Result<(), MmrError>"
    },
    verify_batch_proof_stateless: {
        description: "Verify MMR proof against given root hash or a batch of leaves.",
        params: [
            {
                name: "root",
                type: "Hash"
            },
            {
                name: "leaves",
                type: "Vec<MmrEncodableOpaqueLeaf>"
            },
            {
                name: "proof",
                type: "MmrBatchProof"
            }
        ],
        type: "Result<(), MmrError>"
    },
    verify_proof: {
        description: "Verify MMR proof against on-chain MMR.",
        params: [
            {
                name: "leaf",
                type: "MmrEncodableOpaqueLeaf"
            },
            {
                name: "proof",
                type: "MmrProof"
            }
        ],
        type: "Result<(), MmrError>"
    },
    verify_proof_stateless: {
        description: "Verify MMR proof against given root hash.",
        params: [
            {
                name: "root",
                type: "Hash"
            },
            {
                name: "leaf",
                type: "MmrEncodableOpaqueLeaf"
            },
            {
                name: "proof",
                type: "MmrProof"
            }
        ],
        type: "Result<(), MmrError>"
    }
};
const $c0a8e5bc024a189b$export$874fd8712028ad21 = {
    MmrApi: [
        {
            methods: $c0a8e5bc024a189b$var$MMR_V2,
            version: 2
        },
        {
            methods: $c0a8e5bc024a189b$var$MMR_V1,
            version: 1
        }
    ]
};


var $134cc75a22ce97c1$export$2e2bcd8739ae039 = {
    rpc: $e7ec5528dcb0c4da$export$82f5954781486db2,
    runtime: $c0a8e5bc024a189b$export$874fd8712028ad21,
    types: {
        MmrBatchProof: {
            leafIndices: "Vec<MmrLeafIndex>",
            leafCount: "MmrNodeIndex",
            items: "Vec<Hash>"
        },
        MmrEncodableOpaqueLeaf: "Bytes",
        MmrError: {
            _enum: [
                "Push",
                "GetRoot",
                "Commit",
                "GenerateProof",
                "Verify",
                "LeafNotFound",
                " PalletNotIncluded",
                "InvalidLeafIndex"
            ]
        },
        MmrHash: "Hash",
        MmrLeafBatchProof: {
            blockHash: "BlockHash",
            leaves: "Bytes",
            proof: "Bytes"
        },
        MmrLeafIndex: "u64",
        MmrLeafProof: {
            blockHash: "BlockHash",
            leaf: "Bytes",
            proof: "Bytes"
        },
        MmrNodeIndex: "u64",
        MmrProof: {
            leafIndex: "MmrLeafIndex",
            leafCount: "MmrNodeIndex",
            items: "Vec<Hash>"
        }
    }
};


const $dfd01991e77b4c5c$export$874fd8712028ad21 = {
    NftsApi: [
        {
            methods: {
                attribute: {
                    description: "An attribute",
                    params: [
                        {
                            name: "collection",
                            type: "NftCollectionId"
                        },
                        {
                            name: "item",
                            type: "NftItemId"
                        },
                        {
                            name: "key",
                            type: "Bytes"
                        }
                    ],
                    type: "Option<Bytes>"
                },
                collection_attribute: {
                    description: "A collection attribute",
                    params: [
                        {
                            name: "collection",
                            type: "NftCollectionId"
                        },
                        {
                            name: "key",
                            type: "Bytes"
                        }
                    ],
                    type: "Option<Bytes>"
                },
                collection_owner: {
                    description: "A collection owner",
                    params: [
                        {
                            name: "collection",
                            type: "NftCollectionId"
                        }
                    ],
                    type: "Option<AccountId>"
                },
                custom_attribute: {
                    description: "A custom attribute",
                    params: [
                        {
                            name: "account",
                            type: "AccountId"
                        },
                        {
                            name: "collection",
                            type: "NftCollectionId"
                        },
                        {
                            name: "item",
                            type: "NftItemId"
                        },
                        {
                            name: "key",
                            type: "Bytes"
                        }
                    ],
                    type: "Option<Bytes>"
                },
                owner: {
                    description: "Collection owner",
                    params: [
                        {
                            name: "collection",
                            type: "NftCollectionId"
                        },
                        {
                            name: "item",
                            type: "NftItemId"
                        }
                    ],
                    type: "Option<AccountId>"
                },
                system_attribute: {
                    description: "System attribute",
                    params: [
                        {
                            name: "collection",
                            type: "NftCollectionId"
                        },
                        {
                            name: "item",
                            type: "NftItemId"
                        },
                        {
                            name: "key",
                            type: "Bytes"
                        }
                    ],
                    type: "Option<Bytes>"
                }
            },
            version: 1
        }
    ]
};


var $50c97f5c3074e977$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $dfd01991e77b4c5c$export$874fd8712028ad21,
    types: {
        NftCollectionId: "u32",
        NftItemId: "u32"
    }
};


const $61dec564004e7e0d$export$874fd8712028ad21 = {
    NominationPoolsApi: [
        {
            methods: {
                balance_to_points: {
                    description: "Returns the equivalent points of `new_funds` for a given pool.",
                    params: [
                        {
                            name: "poolId",
                            type: "NpPoolId"
                        },
                        {
                            name: "newFunds",
                            type: "Balance"
                        }
                    ],
                    type: "Balance"
                },
                pending_rewards: {
                    description: "Returns the pending rewards for the given member.",
                    params: [
                        {
                            name: "member",
                            type: "AccountId"
                        }
                    ],
                    type: "Balance"
                },
                points_to_balance: {
                    description: "Returns the equivalent balance of `points` for a given pool.",
                    params: [
                        {
                            name: "poolId",
                            type: "NpPoolId"
                        },
                        {
                            name: "points",
                            type: "Balance"
                        }
                    ],
                    type: "Balance"
                }
            },
            version: 1
        }
    ]
};


var $4d8051ee07149069$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $61dec564004e7e0d$export$874fd8712028ad21,
    types: {
        NpApiError: {
            _enum: [
                "MemberNotFound",
                "OverflowInPendingRewards"
            ]
        },
        NpPoolId: "u32"
    }
};


var $ee8c09f11a23ca7c$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        DeferredOffenceOf: "(Vec<OffenceDetails>, Vec<Perbill>, SessionIndex)",
        Kind: "[u8; 16]",
        OffenceDetails: {
            offender: "Offender",
            reporters: "Vec<Reporter>"
        },
        Offender: "IdentificationTuple",
        OpaqueTimeSlot: "Bytes",
        ReportIdOf: "Hash",
        Reporter: "AccountId"
    }
};


const $236bceddb815640e$export$874fd8712028ad21 = {
    DifficultyApi: [
        {
            methods: {
                difficulty: {
                    description: "Return the target difficulty of the next block.",
                    params: [],
                    // This is Difficulty in the original, however this is chain-specific
                    type: "Raw"
                }
            },
            version: 1
        }
    ],
    TimestampApi: [
        {
            methods: {
                timestamp: {
                    description: "API necessary for timestamp-based difficulty adjustment algorithms.",
                    params: [],
                    type: "Moment"
                }
            },
            version: 1
        }
    ]
};


var $abeec8bd00c21a34$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $236bceddb815640e$export$874fd8712028ad21,
    types: {}
};


var $8456c80ed089df95$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ProxyDefinition: {
            delegate: "AccountId",
            proxyType: "ProxyType",
            delay: "BlockNumber"
        },
        ProxyType: {
            _enum: [
                "Any",
                "NonTransfer",
                "Governance",
                "Staking"
            ]
        },
        ProxyAnnouncement: {
            real: "AccountId",
            callHash: "Hash",
            height: "BlockNumber"
        }
    }
};


var $5c5649b6430ec504$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ActiveRecovery: {
            created: "BlockNumber",
            deposit: "Balance",
            friends: "Vec<AccountId>"
        },
        RecoveryConfig: {
            delayPeriod: "BlockNumber",
            deposit: "Balance",
            friends: "Vec<AccountId>",
            threshold: "u16"
        }
    }
};


var $e83cc75ef04b1ad8$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Period: "(BlockNumber, u32)",
        Priority: "u8",
        SchedulePeriod: "Period",
        SchedulePriority: "Priority",
        Scheduled: {
            maybeId: "Option<Bytes>",
            priority: "SchedulePriority",
            call: "Call",
            maybePeriodic: "Option<SchedulePeriod>",
            origin: "PalletsOrigin"
        },
        ScheduledTo254: {
            maybeId: "Option<Bytes>",
            priority: "SchedulePriority",
            call: "Call",
            maybePeriodic: "Option<SchedulePeriod>"
        },
        TaskAddress: "(BlockNumber, u32)"
    }
};


const $185c87286fcacb67$export$874fd8712028ad21 = {
    SessionKeys: [
        {
            methods: {
                decode_session_keys: {
                    description: "Decode the given public session keys.",
                    params: [
                        {
                            name: "encoded",
                            type: "Bytes"
                        }
                    ],
                    type: "Option<Vec<(Bytes, KeyTypeId)>>"
                },
                generate_session_keys: {
                    description: "Generate a set of session keys with optionally using the given seed.",
                    params: [
                        {
                            name: "seed",
                            type: "Option<Bytes>"
                        }
                    ],
                    type: "Bytes"
                }
            },
            version: 1
        }
    ]
};


const $33ff446850d77e68$var$keyTypes = {
    // key for beefy
    BeefyKey: "[u8; 33]",
    // default to Substrate master defaults, 4 keys (polkadot master, 5 keys)
    Keys: "SessionKeys4",
    SessionKeys1: "(AccountId)",
    SessionKeys2: "(AccountId, AccountId)",
    SessionKeys3: "(AccountId, AccountId, AccountId)",
    SessionKeys4: "(AccountId, AccountId, AccountId, AccountId)",
    SessionKeys5: "(AccountId, AccountId, AccountId, AccountId, AccountId)",
    SessionKeys6: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)",
    SessionKeys6B: "(AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)",
    SessionKeys7: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)",
    SessionKeys7B: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)",
    SessionKeys8: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)",
    SessionKeys8B: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)",
    SessionKeys9: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)",
    SessionKeys9B: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)",
    SessionKeys10: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)",
    SessionKeys10B: "(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)"
};
var $33ff446850d77e68$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $185c87286fcacb67$export$874fd8712028ad21,
    types: {
        ...$33ff446850d77e68$var$keyTypes,
        FullIdentification: "Exposure",
        IdentificationTuple: "(ValidatorId, FullIdentification)",
        MembershipProof: {
            session: "SessionIndex",
            trieNodes: "Vec<Bytes>",
            validatorCount: "ValidatorCount"
        },
        SessionIndex: "u32",
        ValidatorCount: "u32"
    }
};


var $76142cf3d2a6ccc6$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Bid: {
            who: "AccountId",
            kind: "BidKind",
            value: "Balance"
        },
        BidKind: {
            _enum: {
                Deposit: "Balance",
                Vouch: "(AccountId, Balance)"
            }
        },
        // a society-specific Judgement (not the same as identity Judgement)
        SocietyJudgement: {
            _enum: [
                "Rebid",
                "Reject",
                "Approve"
            ]
        },
        // a society-specific Vote
        SocietyVote: {
            _enum: [
                "Skeptic",
                "Reject",
                "Approve"
            ]
        },
        StrikeCount: "u32",
        VouchingStatus: {
            _enum: [
                "Vouching",
                "Banned"
            ]
        }
    }
};


const $368752d3defa023d$export$874fd8712028ad21 = {
    StakingApi: [
        {
            methods: {
                nominations_quota: {
                    description: "Returns the nominations quota for a nominator with a given balance.",
                    params: [
                        {
                            name: "balance",
                            type: "Balance"
                        }
                    ],
                    type: "u32"
                }
            },
            version: 1
        }
    ]
};


const $b0fecc43aa958b30$var$deprecated = {
    Points: "u32",
    EraPoints: {
        total: "Points",
        individual: "Vec<Points>"
    }
};
const $b0fecc43aa958b30$var$phragmen = {
    CompactAssignments: "CompactAssignmentsWith16",
    CompactAssignmentsWith16: {
        votes1: "Vec<(NominatorIndexCompact, ValidatorIndexCompact)>",
        votes2: "Vec<(NominatorIndexCompact, CompactScoreCompact, ValidatorIndexCompact)>",
        votes3: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 2], ValidatorIndexCompact)>",
        votes4: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 3], ValidatorIndexCompact)>",
        votes5: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 4], ValidatorIndexCompact)>",
        votes6: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 5], ValidatorIndexCompact)>",
        votes7: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 6], ValidatorIndexCompact)>",
        votes8: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 7], ValidatorIndexCompact)>",
        votes9: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 8], ValidatorIndexCompact)>",
        votes10: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 9], ValidatorIndexCompact)>",
        votes11: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 10], ValidatorIndexCompact)>",
        votes12: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 11], ValidatorIndexCompact)>",
        votes13: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 12], ValidatorIndexCompact)>",
        votes14: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 13], ValidatorIndexCompact)>",
        votes15: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 14], ValidatorIndexCompact)>",
        votes16: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 15], ValidatorIndexCompact)>"
    },
    CompactAssignmentsWith24: {
        votes1: "Vec<(NominatorIndexCompact, ValidatorIndexCompact)>",
        votes2: "Vec<(NominatorIndexCompact, CompactScoreCompact, ValidatorIndexCompact)>",
        votes3: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 2], ValidatorIndexCompact)>",
        votes4: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 3], ValidatorIndexCompact)>",
        votes5: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 4], ValidatorIndexCompact)>",
        votes6: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 5], ValidatorIndexCompact)>",
        votes7: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 6], ValidatorIndexCompact)>",
        votes8: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 7], ValidatorIndexCompact)>",
        votes9: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 8], ValidatorIndexCompact)>",
        votes10: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 9], ValidatorIndexCompact)>",
        votes11: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 10], ValidatorIndexCompact)>",
        votes12: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 11], ValidatorIndexCompact)>",
        votes13: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 12], ValidatorIndexCompact)>",
        votes14: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 13], ValidatorIndexCompact)>",
        votes15: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 14], ValidatorIndexCompact)>",
        votes16: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 15], ValidatorIndexCompact)>",
        votes17: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 16], ValidatorIndexCompact)>",
        votes18: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 17], ValidatorIndexCompact)>",
        votes19: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 18], ValidatorIndexCompact)>",
        votes20: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 19], ValidatorIndexCompact)>",
        votes21: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 20], ValidatorIndexCompact)>",
        votes22: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 21], ValidatorIndexCompact)>",
        votes23: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 22], ValidatorIndexCompact)>",
        votes24: "Vec<(NominatorIndexCompact, [CompactScoreCompact; 23], ValidatorIndexCompact)>"
    },
    CompactAssignmentsTo265: "CompactAssignmentsWith16",
    CompactAssignmentsTo257: {
        votes1: "Vec<(NominatorIndex, [CompactScore; 0], ValidatorIndex)>",
        votes2: "Vec<(NominatorIndex, [CompactScore; 1], ValidatorIndex)>",
        votes3: "Vec<(NominatorIndex, [CompactScore; 2], ValidatorIndex)>",
        votes4: "Vec<(NominatorIndex, [CompactScore; 3], ValidatorIndex)>",
        votes5: "Vec<(NominatorIndex, [CompactScore; 4], ValidatorIndex)>",
        votes6: "Vec<(NominatorIndex, [CompactScore; 5], ValidatorIndex)>",
        votes7: "Vec<(NominatorIndex, [CompactScore; 6], ValidatorIndex)>",
        votes8: "Vec<(NominatorIndex, [CompactScore; 7], ValidatorIndex)>",
        votes9: "Vec<(NominatorIndex, [CompactScore; 8], ValidatorIndex)>",
        votes10: "Vec<(NominatorIndex, [CompactScore; 9], ValidatorIndex)>",
        votes11: "Vec<(NominatorIndex, [CompactScore; 10], ValidatorIndex)>",
        votes12: "Vec<(NominatorIndex, [CompactScore; 11], ValidatorIndex)>",
        votes13: "Vec<(NominatorIndex, [CompactScore; 12], ValidatorIndex)>",
        votes14: "Vec<(NominatorIndex, [CompactScore; 13], ValidatorIndex)>",
        votes15: "Vec<(NominatorIndex, [CompactScore; 14], ValidatorIndex)>",
        votes16: "Vec<(NominatorIndex, [CompactScore; 15], ValidatorIndex)>"
    },
    CompactScore: "(ValidatorIndex, OffchainAccuracy)",
    CompactScoreCompact: "(ValidatorIndexCompact, OffchainAccuracyCompact)",
    ElectionCompute: {
        // in previous versions the last entry was "AuthorityId"
        // (since no data attached, and it is via SCALE can rename)
        _enum: [
            "OnChain",
            "Signed",
            "Unsigned"
        ]
    },
    ElectionPhase: {
        _enum: {
            Off: null,
            Signed: null,
            Unsigned: "(bool, BlockNumber)",
            Emergency: null
        }
    },
    ElectionResult: {
        compute: "ElectionCompute",
        slotStake: "Balance",
        electedStashes: "Vec<AccountId>",
        exposures: "Vec<(AccountId, Exposure)>"
    },
    ElectionScore: "[u128; 3]",
    ElectionSize: {
        validators: "Compact<ValidatorIndex>",
        nominators: "Compact<NominatorIndex>"
    },
    ElectionStatus: {
        _enum: {
            Close: "Null",
            Open: "BlockNumber"
        }
    },
    ExtendedBalance: "u128",
    RawSolution: "RawSolutionWith16",
    RawSolutionWith16: {
        compact: "CompactAssignmentsWith16",
        score: "ElectionScore",
        round: "u32"
    },
    RawSolutionWith24: {
        compact: "CompactAssignmentsWith24",
        score: "ElectionScore",
        round: "u32"
    },
    RawSolutionTo265: "RawSolutionWith16",
    ReadySolution: {
        supports: "SolutionSupports",
        score: "ElectionScore",
        compute: "ElectionCompute"
    },
    RoundSnapshot: {
        voters: "Vec<(AccountId, VoteWeight, Vec<AccountId>)>",
        targets: "Vec<AccountId>"
    },
    SeatHolder: {
        who: "AccountId",
        stake: "Balance",
        deposit: "Balance"
    },
    SignedSubmission: {
        _fallback: "SignedSubmissionTo276",
        who: "AccountId",
        deposit: "Balance",
        solution: "RawSolution",
        reward: "Balance"
    },
    SignedSubmissionTo276: {
        who: "AccountId",
        deposit: "Balance",
        solution: "RawSolution"
    },
    SignedSubmissionOf: "SignedSubmission",
    SolutionOrSnapshotSize: {
        voters: "Compact<u32>",
        targets: "Compact<u32>"
    },
    SolutionSupport: {
        total: "ExtendedBalance",
        voters: "Vec<(AccountId, ExtendedBalance)>"
    },
    SolutionSupports: "Vec<(AccountId, SolutionSupport)>",
    Supports: "SolutionSupports",
    SubmissionIndicesOf: "BTreeMap<ElectionScore, u32>",
    Voter: {
        votes: "Vec<AccountId>",
        stake: "Balance",
        deposit: "Balance"
    },
    VoteWeight: "u64"
};
var $b0fecc43aa958b30$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $368752d3defa023d$export$874fd8712028ad21,
    types: {
        ...$b0fecc43aa958b30$var$deprecated,
        ...$b0fecc43aa958b30$var$phragmen,
        ActiveEraInfo: {
            index: "EraIndex",
            start: "Option<Moment>"
        },
        EraIndex: "u32",
        EraRewardPoints: {
            total: "RewardPoint",
            individual: "BTreeMap<AccountId, RewardPoint>"
        },
        EraRewards: {
            total: "u32",
            rewards: "Vec<u32>"
        },
        Exposure: {
            total: "Compact<Balance>",
            own: "Compact<Balance>",
            others: "Vec<IndividualExposure>"
        },
        Forcing: {
            _enum: [
                "NotForcing",
                "ForceNew",
                "ForceNone",
                "ForceAlways"
            ]
        },
        IndividualExposure: {
            who: "AccountId",
            value: "Compact<Balance>"
        },
        KeyType: "AccountId",
        MomentOf: "Moment",
        Nominations: {
            targets: "Vec<AccountId>",
            submittedIn: "EraIndex",
            suppressed: "bool"
        },
        NominatorIndex: "u32",
        NominatorIndexCompact: "Compact<NominatorIndex>",
        OffchainAccuracy: "PerU16",
        OffchainAccuracyCompact: "Compact<OffchainAccuracy>",
        PhragmenScore: "[u128; 3]",
        Points: "u32",
        RewardDestination: {
            _enum: {
                Staked: "Null",
                Stash: "Null",
                Controller: "Null",
                Account: "AccountId",
                None: "Null"
            }
        },
        RewardPoint: "u32",
        SlashJournalEntry: {
            who: "AccountId",
            amount: "Balance",
            ownSlash: "Balance"
        },
        SlashingSpansTo204: {
            spanIndex: "SpanIndex",
            lastStart: "EraIndex",
            prior: "Vec<EraIndex>"
        },
        SlashingSpans: {
            spanIndex: "SpanIndex",
            lastStart: "EraIndex",
            lastNonzeroSlash: "EraIndex",
            prior: "Vec<EraIndex>"
        },
        SpanIndex: "u32",
        SpanRecord: {
            slashed: "Balance",
            paidOut: "Balance"
        },
        StakingLedgerTo223: {
            stash: "AccountId",
            total: "Compact<Balance>",
            active: "Compact<Balance>",
            unlocking: "Vec<UnlockChunk>"
        },
        StakingLedgerTo240: {
            _fallback: "StakingLedgerTo223",
            stash: "AccountId",
            total: "Compact<Balance>",
            active: "Compact<Balance>",
            unlocking: "Vec<UnlockChunk>",
            lastReward: "Option<EraIndex>"
        },
        StakingLedger: {
            stash: "AccountId",
            total: "Compact<Balance>",
            active: "Compact<Balance>",
            unlocking: "Vec<UnlockChunk>",
            claimedRewards: "Vec<EraIndex>"
        },
        UnappliedSlashOther: "(AccountId, Balance)",
        UnappliedSlash: {
            validator: "AccountId",
            own: "Balance",
            others: "Vec<UnappliedSlashOther>",
            reporters: "Vec<AccountId>",
            payout: "Balance"
        },
        UnlockChunk: {
            value: "Compact<Balance>",
            era: "Compact<BlockNumber>"
        },
        ValidatorIndex: "u16",
        ValidatorIndexCompact: "Compact<ValidatorIndex>",
        ValidatorPrefs: "ValidatorPrefsWithBlocked",
        ValidatorPrefsWithCommission: {
            commission: "Compact<Perbill>"
        },
        ValidatorPrefsWithBlocked: {
            commission: "Compact<Perbill>",
            blocked: "bool"
        },
        ValidatorPrefsTo196: {
            validatorPayment: "Compact<Balance>"
        },
        ValidatorPrefsTo145: {
            unstakeThreshold: "Compact<u32>",
            validatorPayment: "Compact<Balance>"
        }
    }
};


var $aabe5c0ecaa6583c$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        WeightToFeeCoefficient: {
            coeffInteger: "Balance",
            coeffFrac: "Perbill",
            negative: "bool",
            degree: "u8"
        }
    }
};


const $0c8ffd252ceb7573$export$82f5954781486db2 = {
    genSyncSpec: {
        description: "Returns the json-serialized chainspec running the node, with a sync state.",
        endpoint: "sync_state_genSyncSpec",
        params: [
            {
                name: "raw",
                type: "bool"
            }
        ],
        type: "Json"
    }
};


var $036afd3af5d243ce$export$2e2bcd8739ae039 = {
    rpc: $0c8ffd252ceb7573$export$82f5954781486db2,
    types: {}
};


const $cb5c997dfaad0b67$export$82f5954781486db2 = {
    accountNextIndex: {
        alias: [
            "account_nextIndex"
        ],
        description: "Retrieves the next accountIndex as available on the node",
        params: [
            {
                name: "accountId",
                type: "AccountId"
            }
        ],
        type: "Index"
    },
    addLogFilter: {
        description: "Adds the supplied directives to the current log filter",
        isUnsafe: true,
        params: [
            {
                name: "directives",
                type: "Text"
            }
        ],
        type: "Null"
    },
    addReservedPeer: {
        description: "Adds a reserved peer",
        isUnsafe: true,
        params: [
            {
                name: "peer",
                type: "Text"
            }
        ],
        type: "Text"
    },
    chain: {
        description: "Retrieves the chain",
        params: [],
        type: "Text"
    },
    chainType: {
        description: "Retrieves the chain type",
        params: [],
        type: "ChainType"
    },
    dryRun: {
        alias: [
            "system_dryRunAt"
        ],
        description: "Dry run an extrinsic at a given block",
        isUnsafe: true,
        params: [
            {
                name: "extrinsic",
                type: "Bytes"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "ApplyExtrinsicResult"
    },
    health: {
        description: "Return health status of the node",
        noErrorLog: true,
        params: [],
        type: "Health"
    },
    localListenAddresses: {
        description: "The addresses include a trailing /p2p/ with the local PeerId, and are thus suitable to be passed to addReservedPeer or as a bootnode address for example",
        params: [],
        type: "Vec<Text>"
    },
    localPeerId: {
        description: "Returns the base58-encoded PeerId of the node",
        params: [],
        type: "Text"
    },
    name: {
        description: "Retrieves the node name",
        params: [],
        type: "Text"
    },
    networkState: {
        alias: [
            "system_unstable_networkState"
        ],
        description: "Returns current state of the network",
        isUnsafe: true,
        params: [],
        type: "NetworkState"
    },
    nodeRoles: {
        description: "Returns the roles the node is running as",
        params: [],
        type: "Vec<NodeRole>"
    },
    peers: {
        description: "Returns the currently connected peers",
        isUnsafe: true,
        params: [],
        type: "Vec<PeerInfo>"
    },
    properties: {
        description: "Get a custom set of properties as a JSON object, defined in the chain spec",
        params: [],
        type: "ChainProperties"
    },
    removeReservedPeer: {
        description: "Remove a reserved peer",
        isUnsafe: true,
        params: [
            {
                name: "peerId",
                type: "Text"
            }
        ],
        type: "Text"
    },
    reservedPeers: {
        description: "Returns the list of reserved peers",
        params: [],
        type: "Vec<Text>"
    },
    resetLogFilter: {
        description: "Resets the log filter to Substrate defaults",
        isUnsafe: true,
        params: [],
        type: "Null"
    },
    syncState: {
        description: "Returns the state of the syncing of the node",
        params: [],
        type: "SyncState"
    },
    version: {
        description: "Retrieves the version of the node",
        params: [],
        type: "Text"
    }
};


const $cc8c72cdaebdb10c$export$874fd8712028ad21 = {
    AccountNonceApi: [
        {
            methods: {
                account_nonce: {
                    description: "The API to query account nonce (aka transaction index)",
                    params: [
                        {
                            name: "accountId",
                            type: "AccountId"
                        }
                    ],
                    type: "Index"
                }
            },
            version: 1
        }
    ]
};


var $99055c2b847983d8$export$2e2bcd8739ae039 = {
    rpc: $cb5c997dfaad0b67$export$82f5954781486db2,
    runtime: $cc8c72cdaebdb10c$export$874fd8712028ad21,
    types: {
        AccountInfo: "AccountInfoWithTripleRefCount",
        AccountInfoWithRefCountU8: {
            nonce: "Index",
            refcount: "u8",
            data: "AccountData"
        },
        AccountInfoWithRefCount: {
            _fallback: "AccountInfoWithRefCountU8",
            nonce: "Index",
            refcount: "RefCount",
            data: "AccountData"
        },
        AccountInfoWithDualRefCount: {
            _fallback: "AccountInfoWithRefCount",
            nonce: "Index",
            consumers: "RefCount",
            providers: "RefCount",
            data: "AccountData"
        },
        // original naming
        AccountInfoWithProviders: "AccountInfoWithDualRefCount",
        AccountInfoWithTripleRefCount: {
            _fallback: "AccountInfoWithDualRefCount",
            nonce: "Index",
            consumers: "RefCount",
            providers: "RefCount",
            sufficients: "RefCount",
            data: "AccountData"
        },
        ApplyExtrinsicResult: "Result<DispatchOutcome, TransactionValidityError>",
        ApplyExtrinsicResultPre6: "Result<DispatchOutcomePre6, TransactionValidityError>",
        ArithmeticError: {
            _enum: [
                "Underflow",
                "Overflow",
                "DivisionByZero"
            ]
        },
        BlockLength: {
            max: "PerDispatchClassU32"
        },
        BlockWeights: {
            baseBlock: "Weight",
            maxBlock: "Weight",
            perClass: "PerDispatchClassWeightsPerClass"
        },
        ChainProperties: "GenericChainProperties",
        ChainType: {
            _enum: {
                Development: "Null",
                Local: "Null",
                Live: "Null",
                Custom: "Text"
            }
        },
        ConsumedWeight: "PerDispatchClassWeight",
        DigestOf: "Digest",
        DispatchClass: {
            _enum: [
                "Normal",
                "Operational",
                "Mandatory"
            ]
        },
        DispatchError: {
            _enum: {
                Other: "Null",
                CannotLookup: "Null",
                BadOrigin: "Null",
                Module: "DispatchErrorModule",
                ConsumerRemaining: "Null",
                NoProviders: "Null",
                TooManyConsumers: "Null",
                Token: "TokenError",
                Arithmetic: "ArithmeticError",
                Transactional: "TransactionalError",
                Exhausted: "Null",
                Corruption: "Null",
                Unavailable: "Null"
            }
        },
        DispatchErrorPre6: {
            _enum: {
                Other: "Null",
                CannotLookup: "Null",
                BadOrigin: "Null",
                Module: "DispatchErrorModulePre6",
                ConsumerRemaining: "Null",
                NoProviders: "Null",
                TooManyConsumers: "Null",
                Token: "TokenError",
                Arithmetic: "ArithmeticError",
                Transactional: "TransactionalError"
            }
        },
        DispatchErrorPre6First: {
            // The enum was modified mid-flight, affecting asset chains -
            // https://github.com/paritytech/substrate/pull/10382/files#diff-e4e016b33a82268b6208dc974eea841bad47597865a749fee2f937eb6fdf67b4R498
            _enum: {
                Other: "Null",
                CannotLookup: "Null",
                BadOrigin: "Null",
                Module: "DispatchErrorModulePre6",
                ConsumerRemaining: "Null",
                NoProviders: "Null",
                Token: "TokenError",
                Arithmetic: "ArithmeticError",
                Transactional: "TransactionalError"
            }
        },
        DispatchErrorModuleU8: {
            index: "u8",
            error: "u8"
        },
        DispatchErrorModuleU8a: {
            index: "u8",
            error: "[u8; 4]"
        },
        DispatchErrorModule: "DispatchErrorModuleU8a",
        DispatchErrorModulePre6: "DispatchErrorModuleU8",
        DispatchErrorTo198: {
            module: "Option<u8>",
            error: "u8"
        },
        DispatchInfo: {
            weight: "Weight",
            class: "DispatchClass",
            paysFee: "Pays"
        },
        DispatchInfoTo190: {
            weight: "Weight",
            class: "DispatchClass"
        },
        DispatchInfoTo244: {
            weight: "Weight",
            class: "DispatchClass",
            paysFee: "bool"
        },
        DispatchOutcome: "Result<(), DispatchError>",
        DispatchOutcomePre6: "Result<(), DispatchErrorPre6>",
        DispatchResult: "Result<(), DispatchError>",
        DispatchResultOf: "DispatchResult",
        DispatchResultTo198: "Result<(), Text>",
        Event: "GenericEvent",
        EventId: "[u8; 2]",
        EventIndex: "u32",
        EventRecord: {
            phase: "Phase",
            event: "Event",
            topics: "Vec<Hash>"
        },
        Health: {
            peers: "u64",
            isSyncing: "bool",
            shouldHavePeers: "bool"
        },
        InvalidTransaction: {
            _enum: {
                Call: "Null",
                Payment: "Null",
                Future: "Null",
                Stale: "Null",
                BadProof: "Null",
                AncientBirthBlock: "Null",
                ExhaustsResources: "Null",
                Custom: "u8",
                BadMandatory: "Null",
                MandatoryDispatch: "Null",
                BadSigner: "Null"
            }
        },
        Key: "Bytes",
        LastRuntimeUpgradeInfo: {
            specVersion: "Compact<u32>",
            specName: "Text"
        },
        NetworkState: {
            peerId: "Text",
            listenedAddresses: "Vec<Text>",
            externalAddresses: "Vec<Text>",
            connectedPeers: "HashMap<Text, Peer>",
            notConnectedPeers: "HashMap<Text, NotConnectedPeer>",
            averageDownloadPerSec: "u64",
            averageUploadPerSec: "u64",
            peerset: "NetworkStatePeerset"
        },
        NetworkStatePeerset: {
            messageQueue: "u64",
            nodes: "HashMap<Text, NetworkStatePeersetInfo>"
        },
        NetworkStatePeersetInfo: {
            connected: "bool",
            reputation: "i32"
        },
        NodeRole: {
            _enum: {
                Full: "Null",
                LightClient: "Null",
                Authority: "Null",
                UnknownRole: "u8"
            }
        },
        NotConnectedPeer: {
            knownAddresses: "Vec<Text>",
            latestPingTime: "Option<PeerPing>",
            versionString: "Option<Text>"
        },
        Peer: {
            enabled: "bool",
            endpoint: "PeerEndpoint",
            knownAddresses: "Vec<Text>",
            latestPingTime: "PeerPing",
            open: "bool",
            versionString: "Text"
        },
        PeerEndpoint: {
            listening: "PeerEndpointAddr"
        },
        PeerEndpointAddr: {
            _alias: {
                localAddr: "local_addr",
                sendBackAddr: "send_back_addr"
            },
            localAddr: "Text",
            sendBackAddr: "Text"
        },
        PeerPing: {
            nanos: "u64",
            secs: "u64"
        },
        PeerInfo: {
            peerId: "Text",
            roles: "Text",
            protocolVersion: "u32",
            bestHash: "Hash",
            bestNumber: "BlockNumber"
        },
        PerDispatchClassU32: {
            normal: "u32",
            operational: "u32",
            mandatory: "u32"
        },
        PerDispatchClassWeight: {
            normal: "Weight",
            operational: "Weight",
            mandatory: "Weight"
        },
        PerDispatchClassWeightsPerClass: {
            normal: "WeightPerClass",
            operational: "WeightPerClass",
            mandatory: "WeightPerClass"
        },
        Phase: {
            _enum: {
                ApplyExtrinsic: "u32",
                Finalization: "Null",
                Initialization: "Null"
            }
        },
        RawOrigin: {
            _enum: {
                Root: "Null",
                Signed: "AccountId",
                None: "Null"
            }
        },
        RefCount: "u32",
        RefCountTo259: "u8",
        SyncState: {
            startingBlock: "BlockNumber",
            currentBlock: "BlockNumber",
            highestBlock: "Option<BlockNumber>"
        },
        SystemOrigin: "RawOrigin",
        TokenError: {
            _enum: [
                "NoFunds",
                "WouldDie",
                "BelowMinimum",
                "CannotCreate",
                "UnknownAsset",
                "Frozen",
                "Unsupported",
                // these are dropped, but still in older versions
                // (if this adjusts, will need to take a re-look)
                "Underflow",
                "Overflow"
            ]
        },
        TransactionValidityError: {
            _enum: {
                Invalid: "InvalidTransaction",
                Unknown: "UnknownTransaction"
            }
        },
        TransactionalError: {
            _enum: [
                "LimitReached",
                "NoLayer"
            ]
        },
        UnknownTransaction: {
            _enum: {
                CannotLookup: "Null",
                NoUnsignedValidator: "Null",
                Custom: "u8"
            }
        },
        WeightPerClass: {
            baseExtrinsic: "Weight",
            maxExtrinsic: "Option<Weight>",
            maxTotal: "Option<Weight>",
            reserved: "Option<Weight>"
        }
    }
};


var $432154c7d2640652$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Bounty: {
            proposer: "AccountId",
            value: "Balance",
            fee: "Balance",
            curatorDeposit: "Balance",
            bond: "Balance",
            status: "BountyStatus"
        },
        BountyIndex: "u32",
        BountyStatus: {
            _enum: {
                Proposed: "Null",
                Approved: "Null",
                Funded: "Null",
                CuratorProposed: "BountyStatusCuratorProposed",
                Active: "BountyStatusActive",
                PendingPayout: "BountyStatusPendingPayout"
            }
        },
        BountyStatusActive: {
            curator: "AccountId",
            updateDue: "BlockNumber"
        },
        BountyStatusCuratorProposed: {
            curator: "AccountId"
        },
        BountyStatusPendingPayout: {
            curator: "AccountId",
            beneficiary: "AccountId",
            unlockAt: "BlockNumber"
        },
        OpenTip: {
            reason: "Hash",
            who: "AccountId",
            finder: "AccountId",
            deposit: "Balance",
            closes: "Option<BlockNumber>",
            tips: "Vec<OpenTipTip>",
            findersFee: "bool"
        },
        OpenTipTo225: {
            reason: "Hash",
            who: "AccountId",
            finder: "Option<OpenTipFinderTo225>",
            closes: "Option<BlockNumber>",
            tips: "Vec<OpenTipTip>"
        },
        OpenTipFinderTo225: "(AccountId, Balance)",
        OpenTipTip: "(AccountId, Balance)",
        TreasuryProposal: {
            proposer: "AccountId",
            value: "Balance",
            beneficiary: "AccountId",
            bond: "Balance"
        }
    }
};


var $704e401c2bbea300$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Multiplier: "Fixed128"
    }
};


const $86e2fa066096caa8$export$874fd8712028ad21 = {
    TaggedTransactionQueue: [
        {
            methods: {
                validate_transaction: {
                    description: "Validate the transaction.",
                    params: [
                        {
                            name: "source",
                            type: "TransactionSource"
                        },
                        {
                            name: "tx",
                            type: "Extrinsic"
                        },
                        {
                            name: "blockHash",
                            type: "BlockHash"
                        }
                    ],
                    type: "TransactionValidity"
                }
            },
            version: 3
        },
        {
            methods: {
                validate_transaction: {
                    description: "Validate the transaction.",
                    params: [
                        {
                            name: "source",
                            type: "TransactionSource"
                        },
                        {
                            name: "tx",
                            type: "Extrinsic"
                        }
                    ],
                    type: "TransactionValidity"
                }
            },
            version: 2
        },
        {
            methods: {
                validate_transaction: {
                    description: "Validate the transaction.",
                    params: [
                        {
                            name: "tx",
                            type: "Extrinsic"
                        }
                    ],
                    type: "TransactionValidity"
                }
            },
            version: 1
        }
    ]
};


var $f982ec5ac285f2a2$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $86e2fa066096caa8$export$874fd8712028ad21,
    types: {
        TransactionSource: {
            _enum: [
                "InBlock",
                "Local",
                "External"
            ]
        },
        TransactionValidity: "Result<ValidTransaction, TransactionValidityError>",
        ValidTransaction: {
            priority: "TransactionPriority",
            requires: "Vec<TransactionTag>",
            provides: "Vec<TransactionTag>",
            longevity: "TransactionLongevity",
            propagate: "bool"
        }
    }
};


var $946998023fc35ba9$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ClassId: "u32",
        InstanceId: "u32",
        DepositBalance: "Balance",
        DepositBalanceOf: "Balance",
        ClassDetails: {
            owner: "AccountId",
            issuer: "AccountId",
            admin: "AccountId",
            freezer: "AccountId",
            totalDeposit: "DepositBalance",
            freeHolding: "bool",
            instances: "u32",
            instanceMetadatas: "u32",
            attributes: "u32",
            isFrozen: "bool"
        },
        DestroyWitness: {
            instances: "Compact<u32>",
            instanceMetadatas: "Compact<u32>",
            attributes: "Compact<u32>"
        },
        InstanceDetails: {
            owner: "AccountId",
            approved: "Option<AccountId>",
            isFrozen: "bool",
            deposit: "DepositBalance"
        },
        ClassMetadata: {
            deposit: "DepositBalance",
            data: "Vec<u8>",
            isFrozen: "bool"
        },
        InstanceMetadata: {
            deposit: "DepositBalance",
            data: "Vec<u8>",
            isFrozen: "bool"
        }
    }
};


var $dc3a75dbae1f51c7$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Multisig: {
            when: "Timepoint",
            deposit: "Balance",
            depositor: "AccountId",
            approvals: "Vec<AccountId>"
        },
        Timepoint: {
            height: "BlockNumber",
            index: "u32"
        }
    }
};


var $4ad8d9be365c6205$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        VestingInfo: {
            locked: "Balance",
            perBlock: "Balance",
            startingBlock: "BlockNumber"
        }
    }
};


var $c83bf69e715361bd$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        BlockAttestations: {
            receipt: "CandidateReceipt",
            valid: "Vec<AccountId>",
            invalid: "Vec<AccountId>"
        },
        IncludedBlocks: {
            actualNumber: "BlockNumber",
            session: "SessionIndex",
            randomSeed: "H256",
            activeParachains: "Vec<ParaId>",
            paraBlocks: "Vec<Hash>"
        },
        MoreAttestations: {}
    }
};


var $975e2dcbe970662b$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        BridgedBlockHash: "H256",
        BridgedBlockNumber: "BlockNumber",
        BridgedHeader: "Header",
        BridgeMessageId: "(LaneId, MessageNonce)",
        CallOrigin: {
            _enum: {
                SourceRoot: "Null",
                TargetAccount: "(AccountId, MultiSigner, MultiSignature)",
                SourceAccount: "AccountId"
            }
        },
        ChainId: "[u8; 4]",
        DeliveredMessages: {
            begin: "MessageNonce",
            end: "MessageNonce",
            // pub type DispatchResultsBitVec = BitVec<Msb0, u8>;
            dispatchResults: "BitVec"
        },
        DispatchFeePayment: {
            _enum: [
                "AtSourceChain",
                "AtTargetChain"
            ]
        },
        InboundLaneData: {
            relayers: "Vec<UnrewardedRelayer>",
            lastConfirmedNonce: "MessageNonce"
        },
        InboundRelayer: "AccountId",
        InitializationData: {
            header: "Header",
            authorityList: "AuthorityList",
            setId: "SetId",
            isHalted: "bool"
        },
        LaneId: "[u8; 4]",
        MessageData: {
            payload: "Bytes",
            fee: "Balance"
        },
        MessagesDeliveryProofOf: {
            bridgedHeaderHash: "BlockHash",
            storageProof: "Vec<Bytes>",
            lane: "LaneId"
        },
        MessageKey: {
            laneId: "LaneId",
            nonce: "MessageNonce"
        },
        MessageNonce: "u64",
        MessagesProofOf: {
            bridgedHeaderHash: "BridgedBlockHash",
            storageProof: "Vec<Bytes>",
            lane: "LaneId",
            noncesStart: "MessageNonce",
            noncesEnd: "MessageNonce"
        },
        OperatingMode: {
            _enum: [
                "Normal",
                "RejectingOutboundMessages",
                "Halted"
            ]
        },
        OutboundLaneData: {
            oldestUnprunedNonce: "MessageNonce",
            latestReceivedNonce: "MessageNonce",
            latestGeneratedNonce: "MessageNonce"
        },
        OutboundMessageFee: "Balance",
        OutboundPayload: {
            specVersion: "u32",
            weight: "Weight",
            origin: "CallOrigin",
            dispatchFeePayment: "DispatchFeePayment",
            call: "Bytes"
        },
        Parameter: "Null",
        RelayerId: "AccountId",
        UnrewardedRelayer: {
            relayer: "RelayerId",
            messages: "DeliveredMessages"
        },
        UnrewardedRelayersState: {
            unrewardedRelayer_Entries: "MessageNonce",
            messagesInOldestEntry: "MessageNonce",
            totalMessages: "MessageNonce"
        }
    }
};


var $a1021bc139f16c6e$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        StatementKind: {
            _enum: [
                "Regular",
                "Saft"
            ]
        }
    }
};


var $928d19c325bb34c9$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        FundIndex: "u32",
        LastContribution: {
            _enum: {
                Never: "Null",
                PreEnding: "u32",
                Ending: "BlockNumber"
            }
        },
        FundInfo: {
            depositor: "AccountId",
            verifier: "Option<MultiSigner>",
            deposit: "Balance",
            raised: "Balance",
            end: "BlockNumber",
            cap: "Balance",
            lastContribution: "LastContribution",
            firstPeriod: "LeasePeriod",
            lastPeriod: "LeasePeriod",
            trieIndex: "TrieIndex"
        },
        TrieIndex: "u32"
    }
};


const $974d77ae93c284c9$export$874fd8712028ad21 = {
    CollectCollationInfo: [
        {
            methods: {
                collect_collation_info: {
                    description: "Collect information about a collation.",
                    params: [
                        {
                            name: "header",
                            type: "Header"
                        }
                    ],
                    type: "CollationInfo"
                }
            },
            version: 2
        },
        {
            methods: {
                collect_collation_info: {
                    description: "Collect information about a collation.",
                    params: [],
                    type: "CollationInfoV1"
                }
            },
            version: 1
        }
    ]
};


const $db552d52aa8ece51$var$dmpQueue = {
    CollationInfo: {
        upwardMessages: "Vec<UpwardMessage>",
        horizontalMessages: "Vec<OutboundHrmpMessage>",
        newValidationCode: "Option<ValidationCode>",
        processedDownwardMessages: "u32",
        hrmpWatermark: "RelayBlockNumber",
        headData: "HeadData"
    },
    CollationInfoV1: {
        upwardMessages: "Vec<UpwardMessage>",
        horizontalMessages: "Vec<OutboundHrmpMessage>",
        newValidationCode: "Option<ValidationCode>",
        processedDownwardMessages: "u32",
        hrmpWatermark: "RelayBlockNumber"
    },
    ConfigData: {
        maxIndividual: "Weight"
    },
    MessageId: "[u8; 32]",
    OverweightIndex: "u64",
    PageCounter: "u32",
    PageIndexData: {
        beginUsed: "PageCounter",
        endUsed: "PageCounter",
        overweightCount: "OverweightIndex"
    }
};
var $db552d52aa8ece51$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $974d77ae93c284c9$export$874fd8712028ad21,
    types: $db552d52aa8ece51$var$dmpQueue
};


const $396739d38a28f5d2$var$finalityV1 = {
    methods: {
        best_finalized: {
            description: "Returns number and hash of the best finalized header known to the bridge module.",
            params: [],
            type: "(BlockNumber, Hash)"
        }
    },
    version: 1
};
const $396739d38a28f5d2$export$874fd8712028ad21 = {
    KusamaFinalityApi: [
        $396739d38a28f5d2$var$finalityV1
    ],
    PolkadotFinalityApi: [
        $396739d38a28f5d2$var$finalityV1
    ],
    RococoFinalityApi: [
        $396739d38a28f5d2$var$finalityV1
    ],
    WestendFinalityApi: [
        $396739d38a28f5d2$var$finalityV1
    ]
};


var $02e8569593272f6d$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $396739d38a28f5d2$export$874fd8712028ad21,
    types: {}
};


/* eslint-disable sort-keys */ var $21e175793096c61f$export$2e2bcd8739ae039 = {
    HrmpChannel: {
        maxCapacity: "u32",
        maxTotalSize: "u32",
        maxMessageSize: "u32",
        msgCount: "u32",
        totalSize: "u32",
        mqcHead: "Option<Hash>",
        senderDeposit: "Balance",
        recipientDeposit: "Balance"
    },
    HrmpChannelId: {
        sender: "u32",
        receiver: "u32"
    },
    HrmpOpenChannelRequest: {
        confirmed: "bool",
        age: "SessionIndex",
        senderDeposit: "Balance",
        maxMessageSize: "u32",
        maxCapacity: "u32",
        maxTotalSize: "u32"
    }
};


const $a328ffd1e04bd21d$var$PH_V1_TO_V2 = {
    assumed_validation_data: {
        description: "Returns the persisted validation data for the given `ParaId` along with the corresponding validation code hash.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            },
            {
                name: "hash",
                type: "Hash"
            }
        ],
        type: "Option<(PersistedValidationData, ValidationCodeHash)>"
    },
    availability_cores: {
        description: "Yields information on all availability cores as relevant to the child block.",
        params: [],
        type: "Vec<CoreState>"
    },
    candidate_events: {
        description: "Get a vector of events concerning candidates that occurred within a block.",
        params: [],
        type: "Vec<CandidateEvent>"
    },
    candidate_pending_availability: {
        description: "Get the receipt of a candidate pending availability.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            }
        ],
        type: "Option<CommittedCandidateReceipt>"
    },
    check_validation_outputs: {
        description: "Checks if the given validation outputs pass the acceptance criteria.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            },
            {
                name: "outputs",
                type: "CandidateCommitments"
            }
        ],
        type: "bool"
    },
    dmq_contents: {
        description: "Get all the pending inbound messages in the downward message queue for a para.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            }
        ],
        type: "Vec<InboundDownwardMessage>"
    },
    inbound_hrmp_channels_contents: {
        description: "Get the contents of all channels addressed to the given recipient.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            }
        ],
        type: "Vec<InboundHrmpMessage>"
    },
    on_chain_votes: {
        description: "Scrape dispute relevant from on-chain, backing votes and resolved disputes.",
        params: [],
        type: "Option<ScrapedOnChainVotes>"
    },
    persisted_validation_data: {
        description: "Yields the persisted validation data for the given `ParaId` along with an assumption that should be used if the para currently occupies a core.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            },
            {
                name: "assumption",
                type: "OccupiedCoreAssumption"
            }
        ],
        type: "Option<PersistedValidationData>"
    },
    session_index_for_child: {
        description: "Returns the session index expected at a child of the block.",
        params: [],
        type: "SessionIndex"
    },
    validation_code: {
        description: "Fetch the validation code used by a para, making the given `OccupiedCoreAssumption`.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            },
            {
                name: "assumption",
                type: "OccupiedCoreAssumption"
            }
        ],
        type: "ValidationCode"
    },
    validation_code_by_hash: {
        description: "Get the validation code from its hash.",
        params: [
            {
                name: "hash",
                type: "ValidationCodeHash"
            }
        ],
        type: "Option<ValidationCode>"
    },
    validator_groups: {
        description: "Returns the validator groups and rotation info localized based on the hypothetical child of a block whose state  this is invoked on",
        params: [],
        type: "(Vec<Vec<ParaValidatorIndex>>, GroupRotationInfo)"
    },
    validators: {
        description: "Get the current validators.",
        params: [],
        type: "Vec<ValidatorId>"
    }
};
const $a328ffd1e04bd21d$var$PH_V2_TO_V3 = {
    pvfs_require_precheck: {
        description: "Returns code hashes of PVFs that require pre-checking by validators in the active set.",
        params: [],
        type: "Vec<ValidationCodeHash>"
    },
    session_info: {
        description: "Get the session info for the given session, if stored.",
        params: [
            {
                name: "index",
                type: "SessionIndex"
            }
        ],
        type: "Option<SessionInfo>"
    },
    submit_pvf_check_statement: {
        description: "Submits a PVF pre-checking statement into the transaction pool.",
        params: [
            {
                name: "stmt",
                type: "PvfCheckStatement"
            },
            {
                name: "signature",
                type: "ValidatorSignature"
            }
        ],
        type: "Null"
    },
    validation_code_hash: {
        description: "Fetch the hash of the validation code used by a para, making the given `OccupiedCoreAssumption`.",
        params: [
            {
                name: "paraId",
                type: "ParaId"
            },
            {
                name: "assumption",
                type: "OccupiedCoreAssumption"
            }
        ],
        type: "Option<ValidationCodeHash>"
    }
};
const $a328ffd1e04bd21d$var$PH_V3 = {
    disputes: {
        description: "Returns all onchain disputes.",
        params: [],
        type: "Vec<(SessionIndex, CandidateHash, DisputeState)>"
    }
};
const $a328ffd1e04bd21d$var$PH_V4 = {
    session_executor_params: {
        description: "Returns execution parameters for the session.",
        params: [
            {
                name: "sessionIndex",
                type: "SessionIndex"
            }
        ],
        type: "Option<ExecutorParams>"
    }
};
const $a328ffd1e04bd21d$export$874fd8712028ad21 = {
    ParachainHost: [
        {
            methods: {
                ...$a328ffd1e04bd21d$var$PH_V1_TO_V2,
                ...$a328ffd1e04bd21d$var$PH_V2_TO_V3,
                ...$a328ffd1e04bd21d$var$PH_V3,
                ...$a328ffd1e04bd21d$var$PH_V4
            },
            version: 4
        },
        {
            methods: {
                ...$a328ffd1e04bd21d$var$PH_V1_TO_V2,
                ...$a328ffd1e04bd21d$var$PH_V2_TO_V3,
                ...$a328ffd1e04bd21d$var$PH_V3
            },
            version: 3
        },
        {
            methods: {
                ...$a328ffd1e04bd21d$var$PH_V1_TO_V2,
                ...$a328ffd1e04bd21d$var$PH_V2_TO_V3
            },
            version: 2
        },
        {
            methods: {
                session_info: {
                    description: "Get the session info for the given session, if stored.",
                    params: [
                        {
                            name: "index",
                            type: "SessionIndex"
                        }
                    ],
                    type: "Option<OldV1SessionInfo>"
                },
                ...$a328ffd1e04bd21d$var$PH_V1_TO_V2
            },
            version: 1
        }
    ]
};


/* eslint-disable sort-keys */ const $946c65c6202f7dc7$var$SlotRange10 = {
    _enum: [
        "ZeroZero",
        "ZeroOne",
        "ZeroTwo",
        "ZeroThree",
        "OneOne",
        "OneTwo",
        "OneThree",
        "TwoTwo",
        "TwoThree",
        "ThreeThree"
    ]
};
const $946c65c6202f7dc7$var$SlotRange = {
    _enum: [
        "ZeroZero",
        "ZeroOne",
        "ZeroTwo",
        "ZeroThree",
        "ZeroFour",
        "ZeroFive",
        "ZeroSix",
        "ZeroSeven",
        "OneOne",
        "OneTwo",
        "OneThree",
        "OneFour",
        "OneFive",
        "OneSix",
        "OneSeven",
        "TwoTwo",
        "TwoThree",
        "TwoFour",
        "TwoFive",
        "TwoSix",
        "TwoSeven",
        "ThreeThree",
        "ThreeFour",
        "ThreeFive",
        "ThreeSix",
        "ThreeSeven",
        "FourFour",
        "FourFive",
        "FourSix",
        "FourSeven",
        "FiveFive",
        "FiveSix",
        "FiveSeven",
        "SixSix",
        "SixSeven",
        "SevenSeven"
    ]
};
const $946c65c6202f7dc7$var$oldTypes = {
    Bidder: {
        _enum: {
            New: "NewBidder",
            Existing: "ParaId"
        }
    },
    IncomingParachain: {
        _enum: {
            Unset: "NewBidder",
            Fixed: "IncomingParachainFixed",
            Deploy: "IncomingParachainDeploy"
        }
    },
    IncomingParachainDeploy: {
        code: "ValidationCode",
        initialHeadData: "HeadData"
    },
    IncomingParachainFixed: {
        codeHash: "Hash",
        codeSize: "u32",
        initialHeadData: "HeadData"
    },
    NewBidder: {
        who: "AccountId",
        sub: "SubId"
    },
    SubId: "u32"
};
var $946c65c6202f7dc7$export$2e2bcd8739ae039 = {
    ...$946c65c6202f7dc7$var$oldTypes,
    AuctionIndex: "u32",
    LeasePeriod: "BlockNumber",
    LeasePeriodOf: "BlockNumber",
    SlotRange10: $946c65c6202f7dc7$var$SlotRange10,
    SlotRange: $946c65c6202f7dc7$var$SlotRange,
    WinningData10: `[WinningDataEntry; ${$946c65c6202f7dc7$var$SlotRange10._enum.length}]`,
    WinningData: `[WinningDataEntry; ${$946c65c6202f7dc7$var$SlotRange._enum.length}]`,
    WinningDataEntry: "Option<(AccountId, ParaId, BalanceOf)>",
    WinnersData10: "Vec<WinnersDataTuple10>",
    WinnersData: "Vec<WinnersDataTuple>",
    WinnersDataTuple10: "(AccountId, ParaId, BalanceOf, SlotRange10)",
    WinnersDataTuple: "(AccountId, ParaId, BalanceOf, SlotRange)"
};


const $cde4cbd8ede43fe9$var$proposeTypes = {
    ParachainProposal: {
        proposer: "AccountId",
        genesisHead: "HeadData",
        validators: "Vec<ValidatorId>",
        name: "Bytes",
        balance: "Balance"
    },
    RegisteredParachainInfo: {
        validators: "Vec<ValidatorId>",
        proposer: "AccountId"
    }
};
const $cde4cbd8ede43fe9$var$cumulusTypes = {
    ServiceQuality: {
        _enum: [
            "Ordered",
            "Fast"
        ]
    }
};
const $cde4cbd8ede43fe9$var$disputeTypes = {
    DisputeLocation: {
        _enum: [
            "Local",
            "Remote"
        ]
    },
    DisputeResult: {
        _enum: [
            "Valid",
            "Invalid"
        ]
    },
    DisputeState: {
        validatorsFor: "BitVec",
        validatorsAgainst: "BitVec",
        start: "BlockNumber",
        concludedAt: "Option<BlockNumber>"
    },
    DisputeStatement: {
        _enum: {
            Valid: "ValidDisputeStatementKind",
            Invalid: "InvalidDisputeStatementKind"
        }
    },
    DisputeStatementSet: {
        candidateHash: "CandidateHash",
        session: "SessionIndex",
        statements: "Vec<(DisputeStatement, ParaValidatorIndex, ValidatorSignature)>"
    },
    ExecutorParam: {
        _enum: {
            Phantom: "Null",
            MaxMemoryPages: "u32",
            StackLogicalMax: "u32",
            StackNativeMax: "u32",
            PrecheckingMaxMemory: "u64",
            PvfPrepTimeout: "(PvfPrepTimeoutKind, u64)",
            PvfExecTimeout: "(PvfExecTimeoutKind, u64)"
        }
    },
    ExecutorParamsHash: "Hash",
    ExecutorParams: "Vec<ExecutorParam>",
    ExplicitDisputeStatement: {
        valid: "bool",
        candidateHash: "CandidateHash",
        session: "SessionIndex"
    },
    InvalidDisputeStatementKind: {
        _enum: [
            "Explicit"
        ]
    },
    MultiDisputeStatementSet: "Vec<DisputeStatementSet>",
    PvfExecTimeoutKind: {
        _enum: [
            "Backing",
            "Approval"
        ]
    },
    PvfPrepTimeoutKind: {
        _enum: [
            "Precheck",
            "Lenient"
        ]
    },
    ValidDisputeStatementKind: {
        _enum: {
            Explicit: "Null",
            BackingSeconded: "Hash",
            BackingValid: "Hash",
            ApprovalChecking: "Null"
        }
    }
};
var $cde4cbd8ede43fe9$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $a328ffd1e04bd21d$export$874fd8712028ad21,
    types: {
        ...$cde4cbd8ede43fe9$var$cumulusTypes,
        ...$cde4cbd8ede43fe9$var$disputeTypes,
        ...(0, $21e175793096c61f$export$2e2bcd8739ae039),
        ...$cde4cbd8ede43fe9$var$proposeTypes,
        ...(0, $946c65c6202f7dc7$export$2e2bcd8739ae039),
        AbridgedCandidateReceipt: {
            parachainIndex: "ParaId",
            relayParent: "Hash",
            headData: "HeadData",
            collator: "CollatorId",
            signature: "CollatorSignature",
            povBlockHash: "Hash",
            commitments: "CandidateCommitments"
        },
        AbridgedHostConfiguration: {
            maxCodeSize: "u32",
            maxHeadDataSize: "u32",
            maxUpwardQueueCount: "u32",
            maxUpwardQueueSize: "u32",
            maxUpwardMessageSize: "u32",
            maxUpwardMessageNumPerCandidate: "u32",
            hrmpMaxMessageNumPerCandidate: "u32",
            validationUpgradeFrequency: "BlockNumber",
            validationUpgradeDelay: "BlockNumber"
        },
        AbridgedHrmpChannel: {
            maxCapacity: "u32",
            maxTotalSize: "u32",
            maxMessageSize: "u32",
            msgCount: "u32",
            totalSize: "u32",
            mqcHead: "Option<Hash>"
        },
        AssignmentId: "AccountId",
        AssignmentKind: {
            _enum: {
                Parachain: "Null",
                Parathread: "(CollatorId, u32)"
            }
        },
        AttestedCandidate: {
            candidate: "AbridgedCandidateReceipt",
            validityVotes: "Vec<ValidityAttestation>",
            validatorIndices: "BitVec"
        },
        AuthorityDiscoveryId: "AccountId",
        AvailabilityBitfield: "BitVec",
        AvailabilityBitfieldRecord: {
            bitfield: "AvailabilityBitfield",
            submittedTt: "BlockNumber"
        },
        BackedCandidate: {
            candidate: "CommittedCandidateReceipt",
            validityVotes: "Vec<ValidityAttestation>",
            validatorIndices: "BitVec"
        },
        BufferedSessionChange: {
            applyAt: "BlockNumber",
            validators: "Vec<ValidatorId>",
            queued: "Vec<ValidatorId>",
            sessionIndex: "SessionIndex"
        },
        CandidateCommitments: {
            upwardMessages: "Vec<UpwardMessage>",
            horizontalMessages: "Vec<OutboundHrmpMessage>",
            newValidationCode: "Option<ValidationCode>",
            headData: "HeadData",
            processedDownwardMessages: "u32",
            hrmpWatermark: "BlockNumber"
        },
        CandidateDescriptor: {
            paraId: "ParaId",
            relayParent: "RelayChainHash",
            collatorId: "CollatorId",
            persistedValidationDataHash: "Hash",
            povHash: "Hash",
            erasureRoot: "Hash",
            signature: "CollatorSignature",
            paraHead: "Hash",
            validationCodeHash: "ValidationCodeHash"
        },
        CandidateEvent: {
            _enum: {
                CandidateBacked: "(CandidateReceipt, HeadData, CoreIndex, GroupIndex)",
                CandidateIncluded: "(CandidateReceipt, HeadData, CoreIndex, GroupIndex)",
                CandidateTimedOut: "(CandidateReceipt, HeadData, CoreIndex)"
            }
        },
        CandidateHash: "Hash",
        CandidateInfo: {
            who: "AccountId",
            deposit: "Balance"
        },
        CandidatePendingAvailability: {
            core: "CoreIndex",
            hash: "CandidateHash",
            descriptor: "CandidateDescriptor",
            availabilityVotes: "BitVec",
            backers: "BitVec",
            relayParentNumber: "BlockNumber",
            backedInNumber: "BlockNumber",
            backingGroup: "GroupIndex"
        },
        CandidateReceipt: {
            descriptor: "CandidateDescriptor",
            commitmentsHash: "Hash"
        },
        GlobalValidationData: {
            maxCodeSize: "u32",
            maxHeadDataSize: "u32",
            blockNumber: "BlockNumber"
        },
        CollatorId: "H256",
        CollatorSignature: "Signature",
        CommittedCandidateReceipt: {
            descriptor: "CandidateDescriptor",
            commitments: "CandidateCommitments"
        },
        CoreAssignment: {
            core: "CoreIndex",
            paraId: "ParaId",
            kind: "AssignmentKind",
            groupIdx: "GroupIndex"
        },
        CoreIndex: "u32",
        CoreOccupied: {
            _enum: {
                Parathread: "ParathreadEntry",
                Parachain: "Null"
            }
        },
        CoreState: {
            _enum: {
                Occupied: "OccupiedCore",
                Scheduled: "ScheduledCore",
                Free: "Null"
            }
        },
        DoubleVoteReport: {
            identity: "ValidatorId",
            first: "(Statement, ValidatorSignature)",
            second: "(Statement, ValidatorSignature)",
            proof: "MembershipProof",
            signingContext: "SigningContext"
        },
        DownwardMessage: "Bytes",
        GroupIndex: "u32",
        GroupRotationInfo: {
            sessionStartBlock: "BlockNumber",
            groupRotationFrequency: "BlockNumber",
            now: "BlockNumber"
        },
        GlobalValidationSchedule: {
            maxCodeSize: "u32",
            maxHeadDataSize: "u32",
            blockNumber: "BlockNumber"
        },
        HeadData: "Bytes",
        HostConfiguration: {
            maxCodeSize: "u32",
            maxHeadDataSize: "u32",
            maxUpwardQueueCount: "u32",
            maxUpwardQueueSize: "u32",
            maxUpwardMessageSize: "u32",
            maxUpwardMessageNumPerCandidate: "u32",
            hrmpMaxMessageNumPerCandidate: "u32",
            validationUpgradeFrequency: "BlockNumber",
            validationUpgradeDelay: "BlockNumber",
            maxPovSize: "u32",
            maxDownwardMessageSize: "u32",
            preferredDispatchableUpwardMessagesStepWeight: "Weight",
            hrmpMaxParachainOutboundChannels: "u32",
            hrmpMaxParathreadOutboundChannels: "u32",
            hrmpOpenRequestTtl: "u32",
            hrmpSenderDeposit: "Balance",
            hrmpRecipientDeposit: "Balance",
            hrmpChannelMaxCapacity: "u32",
            hrmpChannelMaxTotalSize: "u32",
            hrmpMaxParachainInboundChannels: "u32",
            hrmpMaxParathreadInboundChannels: "u32",
            hrmpChannelMaxMessageSize: "u32",
            codeRetentionPeriod: "BlockNumber",
            parathreadCores: "u32",
            parathreadRetries: "u32",
            groupRotationFrequency: "BlockNumber",
            chainAvailabilityPeriod: "BlockNumber",
            threadAvailabilityPeriod: "BlockNumber",
            schedulingLookahead: "u32",
            maxValidatorsPerCore: "Option<u32>",
            maxValidators: "Option<u32>",
            disputePeriod: "SessionIndex",
            disputePostConclusionAcceptancePeriod: "BlockNumber",
            disputeMaxSpamSlots: "u32",
            disputeConclusionByTimeOutPeriod: "BlockNumber",
            noShowSlots: "u32",
            nDelayTranches: "u32",
            zerothDelayTrancheWidth: "u32",
            neededApprovals: "u32",
            relayVrfModuloSamples: "u32"
        },
        InboundDownwardMessage: {
            pubSentAt: "BlockNumber",
            pubMsg: "DownwardMessage"
        },
        InboundHrmpMessage: {
            sentAt: "BlockNumber",
            data: "Bytes"
        },
        InboundHrmpMessages: "Vec<InboundHrmpMessage>",
        LocalValidationData: {
            parentHead: "HeadData",
            balance: "Balance",
            codeUpgradeAllowed: "Option<BlockNumber>"
        },
        MessageIngestionType: {
            downwardMessages: "Vec<InboundDownwardMessage>",
            horizontalMessages: "BTreeMap<ParaId, InboundHrmpMessages>"
        },
        MessageQueueChain: "RelayChainHash",
        OccupiedCore: {
            nextUpOnAvailable: "Option<ScheduledCore>",
            occupiedSince: "BlockNumber",
            timeOutAt: "BlockNumber",
            nextUpOnTimeOut: "Option<ScheduledCore>",
            availability: "BitVec",
            groupResponsible: "GroupIndex",
            candidateHash: "CandidateHash",
            candidateDescriptor: "CandidateDescriptor"
        },
        OccupiedCoreAssumption: {
            _enum: [
                "Included,",
                "TimedOut",
                "Free"
            ]
        },
        OutboundHrmpMessage: {
            recipient: "u32",
            data: "Bytes"
        },
        ParachainDispatchOrigin: {
            _enum: [
                "Signed",
                "Parachain",
                "Root"
            ]
        },
        ParachainInherentData: {
            validationData: "PersistedValidationData",
            relayChainState: "StorageProof",
            downwardMessages: "Vec<InboundDownwardMessage>",
            horizontalMessages: "BTreeMap<ParaId, VecInboundHrmpMessage>"
        },
        ParachainsInherentData: {
            bitfields: "SignedAvailabilityBitfields",
            backedCandidates: "Vec<BackedCandidate>",
            disputes: "MultiDisputeStatementSet",
            parentHeader: "Header"
        },
        ParaGenesisArgs: {
            genesisHead: "Bytes",
            validationCode: "Bytes",
            parachain: "bool"
        },
        ParaId: "u32",
        ParaInfo: {
            manager: "AccountId",
            deposit: "Balance",
            locked: "bool"
        },
        ParaLifecycle: {
            _enum: [
                "Onboarding",
                "Parathread",
                "Parachain",
                "UpgradingToParachain",
                "DowngradingToParathread",
                "OutgoingParathread",
                "OutgoingParachain"
            ]
        },
        ParaPastCodeMeta: {
            upgradeTimes: "Vec<ReplacementTimes>",
            lastPruned: "Option<BlockNumber>"
        },
        ParaScheduling: {
            _enum: [
                "Always",
                "Dynamic"
            ]
        },
        ParathreadClaim: "(ParaId, CollatorId)",
        ParathreadClaimQueue: {
            queue: "Vec<QueuedParathread>",
            nextCoreOffset: "u32"
        },
        ParathreadEntry: {
            claim: "ParathreadClaim",
            retries: "u32"
        },
        ParaValidatorIndex: "u32",
        PersistedValidationData: {
            parentHead: "HeadData",
            relayParentNumber: "RelayChainBlockNumber",
            relayParentStorageRoot: "Hash",
            maxPovSize: "u32"
        },
        PvfCheckStatement: {
            accept: "bool",
            subject: "ValidationCodeHash",
            sessionIndex: "SessionIndex",
            validatorIndex: "ParaValidatorIndex"
        },
        QueuedParathread: {
            claim: "ParathreadEntry",
            coreOffset: "u32"
        },
        RelayBlockNumber: "u32",
        RelayChainBlockNumber: "RelayBlockNumber",
        RelayHash: "Hash",
        RelayChainHash: "RelayHash",
        Remark: "[u8; 32]",
        ReplacementTimes: {
            expectedAt: "BlockNumber",
            activatedAt: "BlockNumber"
        },
        Retriable: {
            _enum: {
                Never: "Null",
                WithRetries: "u32"
            }
        },
        ScheduledCore: {
            paraId: "ParaId",
            collator: "Option<CollatorId>"
        },
        Scheduling: {
            _enum: [
                "Always",
                "Dynamic"
            ]
        },
        ScrapedOnChainVotes: {
            session: "SessionIndex",
            backingValidatorsPerCandidate: "Vec<(CandidateReceipt, Vec<(ParaValidatorIndex, ValidityAttestation)>)>",
            disputes: "MultiDisputeStatementSet"
        },
        SessionInfo: {
            activeValidatorIndices: "Vec<ParaValidatorIndex>",
            randomSeed: "[u8; 32]",
            disputePeriod: "SessionIndex",
            validators: "Vec<ValidatorId>",
            discoveryKeys: "Vec<AuthorityDiscoveryId>",
            assignmentKeys: "Vec<AssignmentId>",
            validatorGroups: "Vec<Vec<ValidatorIndex>>",
            nCores: "u32",
            zerothDelayTrancheWidth: "u32",
            relayVrfModuloSamples: "u32",
            nDelayTranches: "u32",
            noShowSlots: "u32",
            neededApprovals: "u32"
        },
        OldV1SessionInfo: {
            validators: "Vec<ValidatorId>",
            discoveryKeys: "Vec<AuthorityDiscoveryId>",
            assignmentKeys: "Vec<AssignmentId>",
            validatorGroups: "Vec<Vec<ParaValidatorIndex>>",
            nCores: "u32",
            zerothDelayTrancheWidth: "u32",
            relayVrfModuloSamples: "u32",
            nDelayTranches: "u32",
            noShowSlots: "u32",
            neededApprovals: "u32"
        },
        SessionInfoValidatorGroup: "Vec<ParaValidatorIndex>",
        SignedAvailabilityBitfield: {
            payload: "BitVec",
            validatorIndex: "ParaValidatorIndex",
            signature: "ValidatorSignature"
        },
        SignedAvailabilityBitfields: "Vec<SignedAvailabilityBitfield>",
        SigningContext: {
            sessionIndex: "SessionIndex",
            parentHash: "Hash"
        },
        Statement: {
            _enum: {
                Never: "Null",
                Candidate: "Hash",
                Valid: "Hash",
                Invalid: "Hash"
            }
        },
        TransientValidationData: {
            maxCodeSize: "u32",
            maxHeadDataSize: "u32",
            balance: "Balance",
            codeUpgradeAllowed: "Option<BlockNumber>",
            dmqLength: "u32"
        },
        UpgradeGoAhead: {
            _enum: [
                "Abort",
                "GoAhead"
            ]
        },
        UpgradeRestriction: {
            _enum: [
                "Present"
            ]
        },
        UpwardMessage: "Bytes",
        ValidationFunctionParams: {
            maxCodeSize: "u32",
            relayChainHeight: "RelayChainBlockNumber",
            codeUpgradeAllowed: "Option<RelayChainBlockNumber>"
        },
        ValidationCode: "Bytes",
        ValidationCodeHash: "Hash",
        ValidationData: {
            persisted: "PersistedValidationData",
            transient: "TransientValidationData"
        },
        ValidationDataType: {
            validationData: "ValidationData",
            relayChainState: "Vec<Bytes>"
        },
        ValidatorSignature: "Signature",
        ValidityAttestation: {
            _enum: {
                Never: "Null",
                Implicit: "ValidatorSignature",
                Explicit: "ValidatorSignature"
            }
        },
        MessagingStateSnapshot: {
            relayDispatchQueueSize: "(u32, u32)",
            egressChannels: "Vec<MessagingStateSnapshotEgressEntry>"
        },
        MessagingStateSnapshotEgressEntry: "(ParaId, AbridgedHrmpChannel)",
        SystemInherentData: "ParachainInherentData",
        VecInboundHrmpMessage: "Vec<InboundHrmpMessage>"
    }
};


var $f828505377cc7713$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        Approvals: "[bool; 4]"
    }
};


var $15c859f0169b9f04$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        AccountStatus: {
            validity: "AccountValidity",
            freeBalance: "Balance",
            lockedBalance: "Balance",
            signature: "Vec<u8>",
            vat: "Permill"
        },
        AccountValidity: {
            _enum: [
                "Invalid",
                "Initiated",
                "Pending",
                "ValidLow",
                "ValidHigh",
                "Completed"
            ]
        }
    }
};



const $0c648c48d03456b7$export$fc25d3e0aca949b4 = [
    "AssetInstance",
    "Fungibility",
    "Junction",
    "Junctions",
    "MultiAsset",
    "MultiAssetFilter",
    "MultiLocation",
    "Response",
    "WildFungibility",
    "WildMultiAsset",
    "Xcm",
    "XcmError",
    "XcmOrder"
];
function $0c648c48d03456b7$export$5c047182797f4bb8(version) {
    return $0c648c48d03456b7$export$fc25d3e0aca949b4.reduce((all, key)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(all, {
            [key]: `${key}${version}`
        }), {});
}


const $f1188d4f36f38793$export$16613c9dcf124475 = {
    FungibilityV0: "FungibilityV1",
    WildFungibilityV0: "WildFungibilityV1",
    AssetInstanceV0: {
        _enum: {
            Undefined: "Null",
            Index8: "u8",
            Index16: "Compact<u16>",
            Index32: "Compact<u32>",
            Index64: "Compact<u64>",
            Index128: "Compact<u128>",
            Array4: "[u8; 4]",
            Array8: "[u8; 8]",
            Array16: "[u8; 16]",
            Array32: "[u8; 32]",
            Blob: "Vec<u8>"
        }
    },
    JunctionV0: {
        _enum: {
            Parent: "Null",
            Parachain: "Compact<u32>",
            AccountId32: {
                network: "NetworkId",
                id: "AccountId"
            },
            AccountIndex64: {
                network: "NetworkId",
                index: "Compact<u64>"
            },
            AccountKey20: {
                network: "NetworkId",
                key: "[u8; 20]"
            },
            PalletInstance: "u8",
            GeneralIndex: "Compact<u128>",
            GeneralKey: "Vec<u8>",
            OnlyChild: "Null",
            Plurality: {
                id: "BodyId",
                part: "BodyPart"
            }
        }
    },
    MultiAssetV0: {
        _enum: {
            None: "Null",
            All: "Null",
            AllFungible: "Null",
            AllNonFungible: "Null",
            AllAbstractFungible: "Vec<u8>",
            AllAbstractNonFungible: "Vec<u8>",
            AllConcreteFungible: "MultiLocationV0",
            AllConcreteNonFungible: "MultiLocationV0",
            AbstractFungible: {
                id: "Vec<u8>",
                instance: "Compact<u128>"
            },
            AbstractNonFungible: {
                class: "Vec<u8>",
                instance: "AssetInstanceV0"
            },
            ConcreteFungible: {
                id: "MultiLocationV0",
                amount: "Compact<u128>"
            },
            ConcreteNonFungible: {
                class: "MultiLocationV0",
                instance: "AssetInstanceV0"
            }
        }
    },
    MultiLocationV0: {
        _enum: {
            Here: "Null",
            X1: "JunctionV0",
            X2: "(JunctionV0, JunctionV0)",
            X3: "(JunctionV0, JunctionV0, JunctionV0)",
            X4: "(JunctionV0, JunctionV0, JunctionV0, JunctionV0)",
            X5: "(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)",
            X6: "(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)",
            X7: "(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)",
            X8: "(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)"
        }
    },
    OriginKindV0: {
        _enum: [
            "Native",
            "SovereignAccount",
            "Superuser",
            "Xcm"
        ]
    },
    ResponseV0: {
        _enum: {
            Assets: "Vec<MultiAssetV0>"
        }
    },
    XcmV0: {
        _enum: {
            WithdrawAsset: {
                assets: "Vec<MultiAssetV0>",
                effects: "Vec<XcmOrderV0>"
            },
            ReserveAssetDeposit: {
                assets: "Vec<MultiAssetV0>",
                effects: "Vec<XcmOrderV0>"
            },
            ReceiveTeleportedAsset: {
                assets: "Vec<MultiAssetV0>",
                effects: "Vec<XcmOrderV0>"
            },
            QueryResponse: {
                queryId: "Compact<u64>",
                response: "ResponseV0"
            },
            TransferAsset: {
                assets: "Vec<MultiAssetV0>",
                dest: "MultiLocationV0"
            },
            TransferReserveAsset: {
                assets: "Vec<MultiAssetV0>",
                dest: "MultiLocationV0",
                effects: "Vec<XcmOrderV0>"
            },
            Transact: {
                originType: "XcmOriginKind",
                requireWeightAtMost: "u64",
                call: "DoubleEncodedCall"
            },
            HrmpNewChannelOpenRequest: {
                sender: "Compact<u32>",
                maxMessageSize: "Compact<u32>",
                maxCapacity: "Compact<u32>"
            },
            HrmpChannelAccepted: {
                recipient: "Compact<u32>"
            },
            HrmpChannelClosing: {
                initiator: "Compact<u32>",
                sender: "Compact<u32>",
                recipient: "Compact<u32>"
            },
            RelayedFrom: {
                who: "MultiLocationV0",
                message: "XcmV0"
            }
        }
    },
    XcmErrorV0: {
        _enum: {
            Undefined: "Null",
            Overflow: "Null",
            Unimplemented: "Null",
            UnhandledXcmVersion: "Null",
            UnhandledXcmMessage: "Null",
            UnhandledEffect: "Null",
            EscalationOfPrivilege: "Null",
            UntrustedReserveLocation: "Null",
            UntrustedTeleportLocation: "Null",
            DestinationBufferOverflow: "Null",
            SendFailed: "Null",
            CannotReachDestination: "(MultiLocation, Xcm)",
            MultiLocationFull: "Null",
            FailedToDecode: "Null",
            BadOrigin: "Null",
            ExceedsMaxMessageSize: "Null",
            FailedToTransactAsset: "Null",
            WeightLimitReached: "Weight",
            Wildcard: "Null",
            TooMuchWeightRequired: "Null",
            NotHoldingFees: "Null",
            WeightNotComputable: "Null",
            Barrier: "Null",
            NotWithdrawable: "Null",
            LocationCannotHold: "Null",
            TooExpensive: "Null",
            AssetNotFound: "Null",
            RecursionLimitReached: "Null"
        }
    },
    XcmOrderV0: {
        _enum: {
            Null: "Null",
            DepositAsset: {
                assets: "Vec<MultiAssetV0>",
                dest: "MultiLocationV0"
            },
            DepositReserveAsset: {
                assets: "Vec<MultiAssetV0>",
                dest: "MultiLocationV0",
                effects: "Vec<XcmOrderV0>"
            },
            ExchangeAsset: {
                give: "Vec<MultiAssetV0>",
                receive: "Vec<MultiAssetV0>"
            },
            InitiateReserveWithdraw: {
                assets: "Vec<MultiAssetV0>",
                reserve: "MultiLocationV0",
                effects: "Vec<XcmOrderV0>"
            },
            InitiateTeleport: {
                assets: "Vec<MultiAssetV0>",
                dest: "MultiLocationV0",
                effects: "Vec<XcmOrderV0>"
            },
            QueryHolding: {
                queryId: "Compact<u64>",
                dest: "MultiLocationV0",
                assets: "Vec<MultiAssetV0>"
            },
            BuyExecution: {
                fees: "MultiAssetV0",
                weight: "u64",
                debt: "u64",
                haltOnError: "bool",
                xcm: "Vec<XcmV0>"
            }
        }
    }
};


const $82a96bead8803b4f$export$11cb33cb3c138832 = {
    AssetInstanceV1: {
        _enum: {
            Undefined: "Null",
            Index: "Compact<u128>",
            Array4: "[u8; 4]",
            Array8: "[u8; 8]",
            Array16: "[u8; 16]",
            Array32: "[u8; 32]",
            Blob: "Bytes"
        }
    },
    FungibilityV1: {
        _enum: {
            Fungible: "Compact<u128>",
            NonFungible: "AssetInstanceV1"
        }
    },
    JunctionV1: {
        _enum: {
            Parachain: "Compact<u32>",
            AccountId32: {
                network: "NetworkId",
                id: "AccountId"
            },
            AccountIndex64: {
                network: "NetworkId",
                index: "Compact<u64>"
            },
            AccountKey20: {
                network: "NetworkId",
                key: "[u8; 20]"
            },
            PalletInstance: "u8",
            GeneralIndex: "Compact<u128>",
            GeneralKey: "Vec<u8>",
            OnlyChild: "Null",
            Plurality: {
                id: "BodyId",
                part: "BodyPart"
            }
        }
    },
    JunctionsV1: {
        _enum: {
            Here: "Null",
            X1: "JunctionV1",
            X2: "(JunctionV1, JunctionV1)",
            X3: "(JunctionV1, JunctionV1, JunctionV1)",
            X4: "(JunctionV1, JunctionV1, JunctionV1, JunctionV1)",
            X5: "(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)",
            X6: "(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)",
            X7: "(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)",
            X8: "(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)"
        }
    },
    MultiAssetsV1: "Vec<MultiAssetV1>",
    MultiAssetV1: {
        id: "XcmAssetId",
        fungibility: "FungibilityV1"
    },
    MultiAssetFilterV1: {
        _enum: {
            Definite: "MultiAssetsV1",
            Wild: "WildMultiAssetV1"
        }
    },
    MultiLocationV1: {
        parents: "u8",
        interior: "JunctionsV1"
    },
    OriginKindV1: "OriginKindV0",
    ResponseV1: {
        _enum: {
            Assets: "MultiAssetsV1"
        }
    },
    WildFungibilityV1: {
        _enum: [
            "Fungible",
            "NonFungible"
        ]
    },
    WildMultiAssetV1: {
        _enum: {
            All: "Null",
            AllOf: {
                id: "XcmAssetId",
                fungibility: "WildFungibilityV1"
            }
        }
    },
    XcmV1: {
        _enum: {
            WithdrawAsset: {
                assets: "MultiAssetsV1",
                effects: "Vec<XcmOrderV1>"
            },
            ReserveAssetDeposit: {
                assets: "MultiAssetsV1",
                effects: "Vec<XcmOrderV1>"
            },
            ReceiveTeleportedAsset: {
                assets: "MultiAssetsV1",
                effects: "Vec<XcmOrderV1>"
            },
            QueryResponse: {
                queryId: "Compact<u64>",
                response: "ResponseV1"
            },
            TransferAsset: {
                assets: "MultiAssetsV1",
                dest: "MultiLocationV1"
            },
            TransferReserveAsset: {
                assets: "MultiAssetsV1",
                dest: "MultiLocationV1",
                effects: "Vec<XcmOrderV1>"
            },
            Transact: {
                originType: "XcmOriginKind",
                requireWeightAtMost: "u64",
                call: "DoubleEncodedCall"
            },
            HrmpNewChannelOpenRequest: {
                sender: "Compact<u32>",
                maxMessageSize: "Compact<u32>",
                maxCapacity: "Compact<u32>"
            },
            HrmpChannelAccepted: {
                recipient: "Compact<u32>"
            },
            HrmpChannelClosing: {
                initiator: "Compact<u32>",
                sender: "Compact<u32>",
                recipient: "Compact<u32>"
            },
            RelayedFrom: {
                who: "MultiLocationV1",
                message: "XcmV1"
            }
        }
    },
    XcmErrorV1: {
        _enum: {
            Undefined: "Null",
            Overflow: "Null",
            Unimplemented: "Null",
            UnhandledXcmVersion: "Null",
            UnhandledXcmMessage: "Null",
            UnhandledEffect: "Null",
            EscalationOfPrivilege: "Null",
            UntrustedReserveLocation: "Null",
            UntrustedTeleportLocation: "Null",
            DestinationBufferOverflow: "Null",
            SendFailed: "Null",
            CannotReachDestination: "(MultiLocationV1, XcmV1)",
            MultiLocationFull: "Null",
            FailedToDecode: "Null",
            BadOrigin: "Null",
            ExceedsMaxMessageSize: "Null",
            FailedToTransactAsset: "Null",
            WeightLimitReached: "Weight",
            Wildcard: "Null",
            TooMuchWeightRequired: "Null",
            NotHoldingFees: "Null",
            WeightNotComputable: "Null",
            Barrier: "Null",
            NotWithdrawable: "Null",
            LocationCannotHold: "Null",
            TooExpensive: "Null",
            AssetNotFound: "Null",
            DestinationUnsupported: "Null",
            RecursionLimitReached: "Null"
        }
    },
    XcmOrderV1: {
        _enum: {
            Noop: "Null",
            DepositAsset: {
                assets: "MultiAssetFilterV1",
                maxAssets: "u32",
                beneficiary: "MultiLocationV1"
            },
            DepositReserveAsset: {
                assets: "MultiAssetFilterV1",
                maxAssets: "u32",
                dest: "MultiLocationV1",
                effects: "Vec<XcmOrderV1>"
            },
            ExchangeAsset: {
                give: "MultiAssetFilterV1",
                receive: "MultiAssetsV1"
            },
            InitiateReserveWithdraw: {
                assets: "MultiAssetFilterV1",
                reserve: "MultiLocationV1",
                effects: "Vec<XcmOrderV1>"
            },
            InitiateTeleport: {
                assets: "MultiAssetFilterV1",
                dest: "MultiLocationV1",
                effects: "Vec<XcmOrderV1>"
            },
            QueryHolding: {
                queryId: "Compact<u64>",
                dest: "MultiLocationV1",
                assets: "MultiAssetFilterV1"
            },
            BuyExecution: {
                fees: "MultiAssetV1",
                weight: "u64",
                debt: "u64",
                haltOnError: "bool",
                instructions: "Vec<XcmV1>"
            }
        }
    }
};


const $62c6b36b7be54e04$export$8815aa1d021a7d50 = {
    AssetInstanceV2: "AssetInstanceV1",
    FungibilityV2: "FungibilityV1",
    JunctionV2: "JunctionV1",
    JunctionsV2: "JunctionsV1",
    MultiAssetsV2: "MultiAssetsV1",
    MultiAssetV2: "MultiAssetV1",
    MultiAssetFilterV2: "MultiAssetFilterV1",
    MultiLocationV2: "MultiLocationV1",
    OriginKindV2: "OriginKindV1",
    WildFungibilityV2: "WildFungibilityV1",
    ResponseV2: {
        _enum: {
            Null: "Null",
            Assets: "MultiAssetsV2",
            ExecutionResult: "ResponseV2Result"
        }
    },
    ResponseV2Error: "(u32, XcmErrorV2)",
    ResponseV2Result: "Result<Null, ResponseV2Error>",
    WeightLimitV2: {
        _enum: {
            Unlimited: "Null",
            Limited: "Compact<u64>"
        }
    },
    InstructionV2: {
        _enum: {
            WithdrawAsset: "MultiAssetsV2",
            ReserveAssetDeposited: "MultiAssetsV2",
            ReceiveTeleportedAsset: "MultiAssetsV2",
            QueryResponse: {
                queryId: "Compact<u64>",
                response: "ResponseV2",
                maxWeight: "Compact<u64>"
            },
            TransferAsset: {
                assets: "MultiAssetsV2",
                beneficiary: "MultiLocationV2"
            },
            TransferReserveAsset: {
                assets: "MultiAssetsV2",
                dest: "MultiLocationV2",
                xcm: "XcmV2"
            },
            Transact: {
                originType: "OriginKindV2",
                requireWeightAtMost: "u64",
                call: "DoubleEncodedCall"
            },
            HrmpNewChannelOpenRequest: {
                sender: "Compact<u32>",
                maxMessageSize: "Compact<u32>",
                maxCapacity: "Compact<u32>"
            },
            HrmpChannelAccepted: {
                recipient: "Compact<u32>"
            },
            HrmpChannelClosing: {
                initiator: "Compact<u32>",
                sender: "Compact<u32>",
                recipient: "Compact<u32>"
            },
            ClearOrigin: "Null",
            DescendOrigin: "InteriorMultiLocation",
            ReportError: {
                queryId: "Compact<u64>",
                dest: "MultiLocationV2",
                maxResponseWeight: "Compact<u64>"
            },
            DepositAsset: {
                assets: "MultiAssetFilterV2",
                maxAssets: "u32",
                beneficiary: "MultiLocationV2"
            },
            DepositReserveAsset: {
                assets: "MultiAssetFilterV2",
                maxAssets: "u32",
                dest: "MultiLocationV2",
                xcm: "XcmV2"
            },
            ExchangeAsset: {
                give: "MultiAssetFilterV2",
                receive: "MultiAssetsV2"
            },
            InitiateReserveWithdraw: {
                assets: "MultiAssetFilterV2",
                reserve: "MultiLocationV2",
                xcm: "XcmV2"
            },
            InitiateTeleport: {
                assets: "MultiAssetFilterV2",
                dest: "MultiLocationV2",
                xcm: "XcmV2"
            },
            QueryHolding: {
                query_id: "Compact<u64>",
                dest: "MultiLocationV2",
                assets: "MultiAssetFilterV2",
                maxResponse_Weight: "Compact<u64>"
            },
            BuyExecution: {
                fees: "MultiAssetV2",
                weightLimit: "WeightLimitV2"
            },
            RefundSurplus: "Null",
            SetErrorHandler: "XcmV2",
            SetAppendix: "XcmV2",
            ClearError: "Null",
            ClaimAsset: {
                assets: "MultiAssetsV2",
                ticket: "MultiLocationV2"
            },
            Trap: "u64"
        }
    },
    WildMultiAssetV2: "WildMultiAssetV1",
    XcmV2: "Vec<InstructionV2>",
    XcmErrorV2: {
        _enum: {
            Undefined: "Null",
            Overflow: "Null",
            Unimplemented: "Null",
            UnhandledXcmVersion: "Null",
            UnhandledXcmMessage: "Null",
            UnhandledEffect: "Null",
            EscalationOfPrivilege: "Null",
            UntrustedReserveLocation: "Null",
            UntrustedTeleportLocation: "Null",
            DestinationBufferOverflow: "Null",
            MultiLocationFull: "Null",
            MultiLocationNotInvertible: "Null",
            FailedToDecode: "Null",
            BadOrigin: "Null",
            ExceedsMaxMessageSize: "Null",
            FailedToTransactAsset: "Null",
            WeightLimitReached: "Weight",
            Wildcard: "Null",
            TooMuchWeightRequired: "Null",
            NotHoldingFees: "Null",
            WeightNotComputable: "Null",
            Barrier: "Null",
            NotWithdrawable: "Null",
            LocationCannotHold: "Null",
            TooExpensive: "Null",
            AssetNotFound: "Null",
            DestinationUnsupported: "Null",
            RecursionLimitReached: "Null",
            Transport: "Null",
            Unroutable: "Null",
            UnknownWeightRequired: "Null",
            Trap: "u64",
            UnknownClaim: "Null",
            InvalidLocation: "Null"
        }
    },
    XcmOrderV2: "XcmOrderV1"
};


const $0ec6c8d06534b1e7$var$XCM_LATEST = "V2";
const $0ec6c8d06534b1e7$var$xcm = {
    XcmOrigin: {
        _enum: {
            Xcm: "MultiLocation"
        }
    },
    XcmpMessageFormat: {
        _enum: [
            "ConcatenatedVersionedXcm",
            "ConcatenatedEncodedBlob",
            "Signals"
        ]
    },
    XcmAssetId: {
        _enum: {
            Concrete: "MultiLocation",
            Abstract: "Bytes"
        }
    },
    InboundStatus: {
        _enum: [
            "Ok",
            "Suspended"
        ]
    },
    OutboundStatus: {
        _enum: [
            "Ok",
            "Suspended"
        ]
    },
    MultiAssets: "Vec<MultiAsset>"
};
const $0ec6c8d06534b1e7$var$location = {
    BodyId: {
        _enum: {
            Unit: "Null",
            Named: "Vec<u8>",
            Index: "Compact<u32>",
            Executive: "Null",
            Technical: "Null",
            Legislative: "Null",
            Judicial: "Null"
        }
    },
    BodyPart: {
        _enum: {
            Voice: "Null",
            Members: "Compact<u32>",
            Fraction: {
                nom: "Compact<u32>",
                denom: "Compact<u32>"
            },
            AtLeastProportion: {
                nom: "Compact<u32>",
                denom: "Compact<u32>"
            },
            MoreThanProportion: {
                nom: "Compact<u32>",
                denom: "Compact<u32>"
            }
        }
    },
    InteriorMultiLocation: "Junctions",
    NetworkId: {
        _enum: {
            Any: "Null",
            Named: "Vec<u8>",
            Polkadot: "Null",
            Kusama: "Null"
        }
    }
};
var $0ec6c8d06534b1e7$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ...$0ec6c8d06534b1e7$var$location,
        ...$0ec6c8d06534b1e7$var$xcm,
        ...(0, $f1188d4f36f38793$export$16613c9dcf124475),
        ...(0, $82a96bead8803b4f$export$11cb33cb3c138832),
        ...(0, $62c6b36b7be54e04$export$8815aa1d021a7d50),
        ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)($0ec6c8d06534b1e7$var$XCM_LATEST),
        DoubleEncodedCall: {
            encoded: "Vec<u8>"
        },
        XcmOriginKind: {
            _enum: [
                "Native",
                "SovereignAccount",
                "Superuser",
                "Xcm"
            ]
        },
        Outcome: {
            _enum: {
                Complete: "Weight",
                Incomplete: "(Weight, XcmErrorV0)",
                Error: "XcmErrorV0"
            }
        },
        QueryId: "u64",
        QueryStatus: {
            _enum: {
                Pending: {
                    responder: "VersionedMultiLocation",
                    maybeNotify: "Option<(u8, u8)>",
                    timeout: "BlockNumber"
                },
                Ready: {
                    response: "VersionedResponse",
                    at: "BlockNumber"
                }
            }
        },
        QueueConfigData: {
            suspendThreshold: "u32",
            dropThreshold: "u32",
            resumeThreshold: "u32",
            thresholdWeight: "Weight",
            weightRestrictDecay: "Weight"
        },
        VersionMigrationStage: {
            _enum: {
                MigrateSupportedVersion: "Null",
                MigrateVersionNotifiers: "Null",
                NotifyCurrentTargets: "Option<Bytes>",
                MigrateAndNotifyOldTargets: "Null"
            }
        },
        VersionedMultiAsset: {
            _enum: {
                V0: "MultiAssetV0",
                V1: "MultiAssetV1",
                V2: "MultiAssetV2"
            }
        },
        VersionedMultiAssets: {
            _enum: {
                V0: "Vec<MultiAssetV0>",
                V1: "MultiAssetsV1",
                V2: "MultiAssetsV2"
            }
        },
        VersionedMultiLocation: {
            _enum: {
                V0: "MultiLocationV0",
                V1: "MultiLocationV1",
                V2: "MultiLocationV2"
            }
        },
        VersionedResponse: {
            V0: "ResponseV0",
            V1: "ResponseV1",
            V2: "ResponseV2"
        },
        VersionedXcm: {
            _enum: {
                V0: "XcmV0",
                V1: "XcmV1",
                V2: "XcmV2"
            }
        },
        XcmVersion: "u32"
    }
};


/* eslint-disable sort-keys */ const $b600921f9cc8dc58$var$layout = {
    ContractCryptoHasher: {
        _enum: [
            "Blake2x256",
            "Sha2x256",
            "Keccak256"
        ]
    },
    ContractDiscriminant: "u32",
    ContractLayoutArray: {
        offset: "ContractLayoutKey",
        len: "u32",
        cellsPerElem: "u64",
        layout: "ContractStorageLayout"
    },
    ContractLayoutCell: {
        key: "ContractLayoutKey",
        ty: "SiLookupTypeId"
    },
    ContractLayoutEnum: {
        dispatchKey: "ContractLayoutKey",
        variants: "BTreeMap<ContractDiscriminant, ContractLayoutStruct>"
    },
    ContractLayoutHash: {
        offset: "ContractLayoutKey",
        strategy: "ContractLayoutHashingStrategy",
        layout: "ContractStorageLayout"
    },
    ContractLayoutHashingStrategy: {
        hasher: "ContractCryptoHasher",
        postfix: "Vec<u8>",
        prefix: "Vec<u8>"
    },
    ContractLayoutKey: "[u8; 32]",
    ContractLayoutStruct: {
        fields: "Vec<ContractLayoutStructField>"
    },
    ContractLayoutStructField: {
        layout: "ContractStorageLayout",
        name: "Text"
    },
    ContractStorageLayout: {
        _enum: {
            Cell: "ContractLayoutCell",
            Hash: "ContractLayoutHash",
            Array: "ContractLayoutArray",
            Struct: "ContractLayoutStruct",
            Enum: "ContractLayoutEnum"
        }
    }
};
const $b600921f9cc8dc58$var$spec = {
    ContractConstructorSpecV0: {
        name: "Text",
        selector: "ContractSelector",
        args: "Vec<ContractMessageParamSpecV0>",
        docs: "Vec<Text>"
    },
    ContractConstructorSpecV1: {
        name: "Vec<Text>",
        selector: "ContractSelector",
        args: "Vec<ContractMessageParamSpecV0>",
        docs: "Vec<Text>"
    },
    ContractConstructorSpecV2: {
        label: "Text",
        selector: "ContractSelector",
        args: "Vec<ContractMessageParamSpecV2>",
        docs: "Vec<Text>"
    },
    ContractConstructorSpecV3: {
        label: "Text",
        selector: "ContractSelector",
        payable: "bool",
        args: "Vec<ContractMessageParamSpecV2>",
        docs: "Vec<Text>"
    },
    ContractConstructorSpecV4: {
        label: "Text",
        selector: "ContractSelector",
        payable: "bool",
        args: "Vec<ContractMessageParamSpecV2>",
        docs: "Vec<Text>",
        default: "bool",
        returnType: "Option<ContractTypeSpec>"
    },
    ContractContractSpecV0: {
        constructors: "Vec<ContractConstructorSpecV0>",
        messages: "Vec<ContractMessageSpecV0>",
        events: "Vec<ContractEventSpecV0>",
        docs: "Vec<Text>"
    },
    ContractContractSpecV1: {
        constructors: "Vec<ContractConstructorSpecV1>",
        messages: "Vec<ContractMessageSpecV1>",
        events: "Vec<ContractEventSpecV1>",
        docs: "Vec<Text>"
    },
    ContractContractSpecV2: {
        constructors: "Vec<ContractConstructorSpecV2>",
        messages: "Vec<ContractMessageSpecV2>",
        events: "Vec<ContractEventSpecV2>",
        docs: "Vec<Text>"
    },
    ContractContractSpecV3: {
        constructors: "Vec<ContractConstructorSpecV3>",
        messages: "Vec<ContractMessageSpecV2>",
        events: "Vec<ContractEventSpecV2>",
        docs: "Vec<Text>"
    },
    ContractContractSpecV4: {
        constructors: "Vec<ContractConstructorSpecV4>",
        messages: "Vec<ContractMessageSpecV3>",
        events: "Vec<ContractEventSpecV2>",
        docs: "Vec<Text>",
        environment: "ContractEnvironmentV4"
    },
    ContractDisplayName: "SiPath",
    ContractEventParamSpecV0: {
        name: "Text",
        indexed: "bool",
        type: "ContractTypeSpec",
        docs: "Vec<Text>"
    },
    ContractEventParamSpecV2: {
        label: "Text",
        indexed: "bool",
        type: "ContractTypeSpec",
        docs: "Vec<Text>"
    },
    ContractEventSpecV0: {
        name: "Text",
        args: "Vec<ContractEventParamSpecV0>",
        docs: "Vec<Text>"
    },
    ContractEventSpecV1: {
        name: "Text",
        args: "Vec<ContractEventParamSpecV0>",
        docs: "Vec<Text>"
    },
    ContractEventSpecV2: {
        label: "Text",
        args: "Vec<ContractEventParamSpecV2>",
        docs: "Vec<Text>"
    },
    ContractMessageParamSpecV0: {
        name: "Text",
        type: "ContractTypeSpec"
    },
    ContractMessageParamSpecV2: {
        label: "Text",
        type: "ContractTypeSpec"
    },
    ContractMessageSpecV0: {
        name: "Text",
        selector: "ContractSelector",
        mutates: "bool",
        payable: "bool",
        args: "Vec<ContractMessageParamSpecV0>",
        returnType: "Option<ContractTypeSpec>",
        docs: "Vec<Text>"
    },
    ContractMessageSpecV1: {
        name: "Vec<Text>",
        selector: "ContractSelector",
        mutates: "bool",
        payable: "bool",
        args: "Vec<ContractMessageParamSpecV0>",
        returnType: "Option<ContractTypeSpec>",
        docs: "Vec<Text>"
    },
    ContractMessageSpecV2: {
        label: "Text",
        selector: "ContractSelector",
        mutates: "bool",
        payable: "bool",
        args: "Vec<ContractMessageParamSpecV2>",
        returnType: "Option<ContractTypeSpec>",
        docs: "Vec<Text>"
    },
    ContractMessageSpecV3: {
        label: "Text",
        selector: "ContractSelector",
        mutates: "bool",
        payable: "bool",
        args: "Vec<ContractMessageParamSpecV2>",
        returnType: "Option<ContractTypeSpec>",
        docs: "Vec<Text>",
        default: "bool"
    },
    ContractSelector: "[u8; 4]",
    ContractTypeSpec: {
        type: "SiLookupTypeId",
        displayName: "ContractDisplayName"
    }
};
const $b600921f9cc8dc58$var$latest = {
    ContractConstructorSpecLatest: "ContractConstructorSpecV4",
    ContractEventSpecLatest: "ContractEventSpecV2",
    ContractEventParamSpecLatest: "ContractEventParamSpecV2",
    ContractMessageParamSpecLatest: "ContractMessageParamSpecV2",
    ContractMessageSpecLatest: "ContractMessageSpecV3",
    ContractMetadataLatest: "ContractMetadataV4"
};
var $b600921f9cc8dc58$export$2e2bcd8739ae039 = {
    rpc: {},
    types: {
        ...$b600921f9cc8dc58$var$layout,
        ...$b600921f9cc8dc58$var$spec,
        ...$b600921f9cc8dc58$var$latest,
        ContractProjectInfo: {
            source: "ContractProjectSource",
            contract: "ContractProjectContract"
        },
        ContractMetadataV0: {
            metadataVersion: "Text",
            types: "Vec<Si0Type>",
            spec: "ContractContractSpecV0"
        },
        ContractMetadataV1: {
            types: "Vec<PortableType>",
            spec: "ContractContractSpecV1"
        },
        ContractMetadataV2: {
            types: "Vec<PortableType>",
            spec: "ContractContractSpecV2"
        },
        ContractMetadataV3: {
            types: "Vec<PortableType>",
            spec: "ContractContractSpecV3"
        },
        ContractMetadataV4: {
            types: "Vec<PortableType>",
            spec: "ContractContractSpecV4"
        },
        ContractMetadata: {
            _enum: {
                V0: "ContractMetadataV0",
                V1: "ContractMetadataV1",
                V2: "ContractMetadataV2",
                V3: "ContractMetadataV3",
                V4: "ContractMetadataV4"
            }
        },
        ContractProjectV0: {
            metadataVersion: "Text",
            source: "ContractProjectSource",
            contract: "ContractProjectContract",
            types: "Vec<Si0Type>",
            spec: "ContractContractSpecV0"
        },
        ContractProject: "(ContractProjectInfo, ContractMetadata)",
        ContractProjectContract: {
            _alias: {
                docs: "documentation"
            },
            name: "Text",
            version: "Text",
            authors: "Vec<Text>",
            description: "Option<Text>",
            docs: "Option<Text>",
            repository: "Option<Text>",
            homepage: "Option<Text>",
            license: "Option<Text>"
        },
        ContractProjectSource: {
            _alias: {
                wasmHash: "hash"
            },
            wasmHash: "[u8; 32]",
            language: "Text",
            compiler: "Text",
            wasm: "Raw"
        },
        ContractEnvironmentV4: {
            _alias: {
                hashType: "hash"
            },
            // NOTE These are not marked optional in the Rust code, however since we
            // convert from older versions to newer, we may not have these fields.
            // The Option<...> works since our inputs are always JSON, so it will
            // be None when not specified.
            //
            // Additionally we don't mark the full structure as Option, rather we
            // do it on a per-field basis since fields may be added as the versions
            // progress.
            accountId: "Option<ContractTypeSpec>",
            balance: "Option<ContractTypeSpec>",
            blockNumber: "Option<ContractTypeSpec>",
            hashType: "Option<ContractTypeSpec>",
            timestamp: "Option<ContractTypeSpec>",
            maxEventTopics: "Option<u32>"
        }
    }
};


const $71a2477081700fdd$var$netRpc = {
    listening: {
        aliasSection: "net",
        description: "Returns true if client is actively listening for network connections. Otherwise false.",
        params: [],
        type: "bool"
    },
    peerCount: {
        aliasSection: "net",
        description: "Returns number of peers connected to node.",
        params: [],
        type: "Text"
    },
    version: {
        aliasSection: "net",
        description: "Returns protocol version.",
        params: [],
        type: "Text"
    }
};
const $71a2477081700fdd$var$web3Rpc = {
    clientVersion: {
        aliasSection: "web3",
        description: "Returns current client version.",
        params: [],
        type: "Text"
    },
    sha3: {
        aliasSection: "web3",
        description: "Returns sha3 of the given data",
        params: [
            {
                name: "data",
                type: "Bytes"
            }
        ],
        type: "H256"
    }
};
const $71a2477081700fdd$export$82f5954781486db2 = {
    ...$71a2477081700fdd$var$netRpc,
    ...$71a2477081700fdd$var$web3Rpc,
    accounts: {
        description: "Returns accounts list.",
        params: [],
        type: "Vec<H160>"
    },
    blockNumber: {
        description: "Returns the blockNumber",
        params: [],
        type: "U256"
    },
    call: {
        description: "Call contract, returning the output data.",
        params: [
            {
                name: "request",
                type: "EthCallRequest"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "Bytes"
    },
    chainId: {
        description: "Returns the chain ID used for transaction signing at the current best block. None is returned if not available.",
        params: [],
        type: "U64"
    },
    coinbase: {
        description: "Returns block author.",
        params: [],
        type: "H160"
    },
    estimateGas: {
        description: "Estimate gas needed for execution of given contract.",
        params: [
            {
                name: "request",
                type: "EthCallRequest"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "U256"
    },
    feeHistory: {
        description: "Returns fee history for given block count & reward percentiles",
        params: [
            {
                name: "blockCount",
                type: "U256"
            },
            {
                name: "newestBlock",
                type: "BlockNumber"
            },
            {
                name: "rewardPercentiles",
                type: "Option<Vec<f64>>"
            }
        ],
        type: "EthFeeHistory"
    },
    gasPrice: {
        description: "Returns current gas price.",
        params: [],
        type: "U256"
    },
    getBalance: {
        description: "Returns balance of the given account.",
        params: [
            {
                name: "address",
                type: "H160"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "U256"
    },
    getBlockByHash: {
        description: "Returns block with given hash.",
        params: [
            {
                name: "hash",
                type: "H256"
            },
            {
                name: "full",
                type: "bool"
            }
        ],
        type: "Option<EthRichBlock>"
    },
    getBlockByNumber: {
        description: "Returns block with given number.",
        params: [
            {
                name: "block",
                type: "BlockNumber"
            },
            {
                name: "full",
                type: "bool"
            }
        ],
        type: "Option<EthRichBlock>"
    },
    getBlockTransactionCountByHash: {
        description: "Returns the number of transactions in a block with given hash.",
        params: [
            {
                name: "hash",
                type: "H256"
            }
        ],
        type: "U256"
    },
    getBlockTransactionCountByNumber: {
        description: "Returns the number of transactions in a block with given block number.",
        params: [
            {
                name: "block",
                type: "BlockNumber"
            }
        ],
        type: "U256"
    },
    getCode: {
        description: "Returns the code at given address at given time (block number).",
        params: [
            {
                name: "address",
                type: "H160"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "Bytes"
    },
    getFilterChanges: {
        description: "Returns filter changes since last poll.",
        params: [
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "EthFilterChanges"
    },
    getFilterLogs: {
        description: "Returns all logs matching given filter (in a range 'from' - 'to').",
        params: [
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "Vec<EthLog>"
    },
    getLogs: {
        description: "Returns logs matching given filter object.",
        params: [
            {
                name: "filter",
                type: "EthFilter"
            }
        ],
        type: "Vec<EthLog>"
    },
    getProof: {
        description: "Returns proof for account and storage.",
        params: [
            {
                name: "address",
                type: "H160"
            },
            {
                name: "storageKeys",
                type: "Vec<H256>"
            },
            {
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "EthAccount"
    },
    getStorageAt: {
        description: "Returns content of the storage at given address.",
        params: [
            {
                name: "address",
                type: "H160"
            },
            {
                name: "index",
                type: "U256"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "H256"
    },
    getTransactionByBlockHashAndIndex: {
        description: "Returns transaction at given block hash and index.",
        params: [
            {
                name: "hash",
                type: "H256"
            },
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "EthTransaction"
    },
    getTransactionByBlockNumberAndIndex: {
        description: "Returns transaction by given block number and index.",
        params: [
            {
                name: "number",
                type: "BlockNumber"
            },
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "EthTransaction"
    },
    getTransactionByHash: {
        description: "Get transaction by its hash.",
        params: [
            {
                name: "hash",
                type: "H256"
            }
        ],
        type: "EthTransaction"
    },
    getTransactionCount: {
        description: "Returns the number of transactions sent from given address at given time (block number).",
        params: [
            {
                name: "address",
                type: "H160"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "U256"
    },
    getTransactionReceipt: {
        description: "Returns transaction receipt by transaction hash.",
        params: [
            {
                name: "hash",
                type: "H256"
            }
        ],
        type: "EthReceipt"
    },
    getUncleByBlockHashAndIndex: {
        description: "Returns an uncles at given block and index.",
        params: [
            {
                name: "hash",
                type: "H256"
            },
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "EthRichBlock"
    },
    getUncleByBlockNumberAndIndex: {
        description: "Returns an uncles at given block and index.",
        params: [
            {
                name: "number",
                type: "BlockNumber"
            },
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "EthRichBlock"
    },
    getUncleCountByBlockHash: {
        description: "Returns the number of uncles in a block with given hash.",
        params: [
            {
                name: "hash",
                type: "H256"
            }
        ],
        type: "U256"
    },
    getUncleCountByBlockNumber: {
        description: "Returns the number of uncles in a block with given block number.",
        params: [
            {
                name: "number",
                type: "BlockNumber"
            }
        ],
        type: "U256"
    },
    getWork: {
        description: "Returns the hash of the current block, the seedHash, and the boundary condition to be met.",
        params: [],
        type: "EthWork"
    },
    hashrate: {
        description: "Returns the number of hashes per second that the node is mining with.",
        params: [],
        type: "U256"
    },
    maxPriorityFeePerGas: {
        description: "Returns max priority fee per gas",
        params: [],
        type: "U256"
    },
    mining: {
        description: "Returns true if client is actively mining new blocks.",
        params: [],
        type: "bool"
    },
    newBlockFilter: {
        description: "Returns id of new block filter.",
        params: [],
        type: "U256"
    },
    newFilter: {
        description: "Returns id of new filter.",
        params: [
            {
                name: "filter",
                type: "EthFilter"
            }
        ],
        type: "U256"
    },
    newPendingTransactionFilter: {
        description: "Returns id of new block filter.",
        params: [],
        type: "U256"
    },
    protocolVersion: {
        description: "Returns protocol version encoded as a string (quotes are necessary).",
        params: [],
        type: "u64"
    },
    sendRawTransaction: {
        description: "Sends signed transaction, returning its hash.",
        params: [
            {
                name: "bytes",
                type: "Bytes"
            }
        ],
        type: "H256"
    },
    sendTransaction: {
        description: "Sends transaction; will block waiting for signer to return the transaction hash",
        params: [
            {
                name: "tx",
                type: "EthTransactionRequest"
            }
        ],
        type: "H256"
    },
    submitHashrate: {
        description: "Used for submitting mining hashrate.",
        params: [
            {
                name: "index",
                type: "U256"
            },
            {
                name: "hash",
                type: "H256"
            }
        ],
        type: "bool"
    },
    submitWork: {
        description: "Used for submitting a proof-of-work solution.",
        params: [
            {
                name: "nonce",
                type: "H64"
            },
            {
                name: "headerHash",
                type: "H256"
            },
            {
                name: "mixDigest",
                type: "H256"
            }
        ],
        type: "bool"
    },
    subscribe: {
        description: "Subscribe to Eth subscription.",
        params: [
            {
                name: "kind",
                type: "EthSubKind"
            },
            {
                isOptional: true,
                name: "params",
                type: "EthSubParams"
            }
        ],
        pubsub: [
            "subscription",
            "subscribe",
            "unsubscribe"
        ],
        type: "Null"
    },
    syncing: {
        description: "Returns an object with data about the sync status or false.",
        params: [],
        type: "EthSyncStatus"
    },
    uninstallFilter: {
        description: "Uninstalls filter.",
        params: [
            {
                name: "index",
                type: "U256"
            }
        ],
        type: "bool"
    }
};


const $c279fe6b77def5c1$export$874fd8712028ad21 = {
    ConvertTransactionRuntimeApi: [
        {
            methods: {
                convert_transaction: {
                    description: "Converts an Ethereum-style transaction to Extrinsic",
                    params: [
                        {
                            name: "transaction",
                            type: "TransactionV2"
                        }
                    ],
                    type: "Extrinsic"
                }
            },
            version: 2
        }
    ],
    DebugRuntimeApi: [
        {
            methods: {
                trace_block: {
                    description: "Trace all block extrinsics",
                    params: [
                        {
                            name: "extrinsics",
                            type: "Vec<Extrinsic>"
                        },
                        {
                            name: "knownTransactions",
                            type: "Vec<H256>"
                        }
                    ],
                    type: "Result<(), DispatchError>"
                },
                trace_transaction: {
                    description: "Trace transaction extrinsics",
                    params: [
                        {
                            name: "extrinsics",
                            type: "Vec<Extrinsic>"
                        },
                        {
                            name: "transaction",
                            type: "EthTransaction"
                        }
                    ],
                    type: "Result<(), DispatchError>"
                }
            },
            version: 4
        }
    ],
    EthereumRuntimeRPCApi: [
        {
            methods: {
                account_basic: {
                    description: "Returns pallet_evm::Accounts by address.",
                    params: [
                        {
                            name: "address",
                            type: "H160"
                        }
                    ],
                    type: "EvmAccount"
                },
                account_code_at: {
                    description: "For a given account address, returns pallet_evm::AccountCodes.",
                    params: [
                        {
                            name: "address",
                            type: "H160"
                        }
                    ],
                    type: "Bytes"
                },
                author: {
                    description: "Returns the converted FindAuthor::find_author authority id.",
                    params: [],
                    type: "H160"
                },
                call: {
                    description: "Returns a frame_ethereum::call response. If `estimate` is true,",
                    params: [
                        {
                            name: "from",
                            type: "H160"
                        },
                        {
                            name: "to",
                            type: "H160"
                        },
                        {
                            name: "data",
                            type: "Vec<u8>"
                        },
                        {
                            name: "value",
                            type: "U256"
                        },
                        {
                            name: "gasLimit",
                            type: "U256"
                        },
                        {
                            name: "maxFeePerGas",
                            type: "Option<U256>"
                        },
                        {
                            name: "maxPriorityFeePerGas",
                            type: "Option<U256>"
                        },
                        {
                            name: "nonce",
                            type: "Option<U256>"
                        },
                        {
                            name: "estimate",
                            type: "bool"
                        },
                        {
                            name: "accessList",
                            type: "Option<Vec<(H160, Vec<H256>)>>"
                        }
                    ],
                    type: "Result<EvmCallInfo, DispatchError>"
                },
                chain_id: {
                    description: "Returns runtime defined pallet_evm::ChainId.",
                    params: [],
                    type: "u64"
                },
                create: {
                    description: "Returns a frame_ethereum::call response. If `estimate` is true,",
                    params: [
                        {
                            name: "from",
                            type: "H160"
                        },
                        {
                            name: "data",
                            type: "Vec<u8>"
                        },
                        {
                            name: "value",
                            type: "U256"
                        },
                        {
                            name: "gasLimit",
                            type: "U256"
                        },
                        {
                            name: "maxFeePerGas",
                            type: "Option<U256>"
                        },
                        {
                            name: "maxPriorityFeePerGas",
                            type: "Option<U256>"
                        },
                        {
                            name: "nonce",
                            type: "Option<U256>"
                        },
                        {
                            name: "estimate",
                            type: "bool"
                        },
                        {
                            name: "accessList",
                            type: "Option<Vec<(H160, Vec<H256>)>>"
                        }
                    ],
                    type: "Result<EvmCreateInfo, DispatchError>"
                },
                current_all: {
                    description: "Return all the current data for a block in a single runtime call.",
                    params: [],
                    type: "(Option<BlockV2>, Option<Vec<EthReceiptV3>>, Option<Vec<EthTransactionStatus>>)"
                },
                current_block: {
                    description: "Return the current block.",
                    params: [],
                    type: "BlockV2"
                },
                current_receipts: {
                    description: "Return the current receipt.",
                    params: [],
                    type: "Option<Vec<EthReceiptV3>>"
                },
                current_transaction_statuses: {
                    description: "Return the current transaction status.",
                    params: [],
                    type: "Option<Vec<EthTransactionStatus>>"
                },
                elasticity: {
                    description: "Return the elasticity multiplier.",
                    params: [],
                    type: "Option<Permill>"
                },
                extrinsic_filter: {
                    description: "Receives a `Vec<OpaqueExtrinsic>` and filters all the ethereum transactions.",
                    params: [
                        {
                            name: "xts",
                            type: "Vec<Extrinsic>"
                        }
                    ],
                    type: "Vec<TransactionV2>"
                },
                gas_price: {
                    description: "Returns FixedGasPrice::min_gas_price",
                    params: [],
                    type: "u256"
                },
                storage_at: {
                    description: "For a given account address and index, returns pallet_evm::AccountStorages.",
                    params: [
                        {
                            name: "address",
                            type: "H160"
                        },
                        {
                            name: "index",
                            type: "u256"
                        }
                    ],
                    type: "H256"
                }
            },
            version: 4
        }
    ]
};


const $de1da58605fc6318$var$V0 = {
    BlockV0: {
        header: "EthHeader",
        transactions: "Vec<TransactionV0>",
        ommers: "Vec<EthHeader>"
    },
    LegacyTransaction: {
        nonce: "U256",
        gasPrice: "U256",
        gasLimit: "U256",
        action: "EthTransactionAction",
        value: "U256",
        input: "Bytes",
        signature: "EthTransactionSignature"
    },
    TransactionV0: "LegacyTransaction"
};
const $de1da58605fc6318$var$V1 = {
    BlockV1: {
        header: "EthHeader",
        transactions: "Vec<TransactionV1>",
        ommers: "Vec<EthHeader>"
    },
    EIP2930Transaction: {
        chainId: "u64",
        nonce: "U256",
        gasPrice: "U256",
        gasLimit: "U256",
        action: "EthTransactionAction",
        value: "U256",
        input: "Bytes",
        accessList: "EthAccessList",
        oddYParity: "bool",
        r: "H256",
        s: "H256"
    },
    TransactionV1: {
        _enum: {
            Legacy: "LegacyTransaction",
            EIP2930: "EIP2930Transaction"
        }
    }
};
const $de1da58605fc6318$var$V2 = {
    BlockV2: {
        header: "EthHeader",
        transactions: "Vec<TransactionV2>",
        ommers: "Vec<EthHeader>"
    },
    EIP1559Transaction: {
        chainId: "u64",
        nonce: "U256",
        maxPriorityFeePerGas: "U256",
        maxFeePerGas: "U256",
        gasLimit: "U256",
        action: "EthTransactionAction",
        value: "U256",
        input: "Bytes",
        accessList: "EthAccessList",
        oddYParity: "bool",
        r: "H256",
        s: "H256"
    },
    TransactionV2: {
        _enum: {
            Legacy: "LegacyTransaction",
            EIP2930: "EIP2930Transaction",
            EIP1559: "EIP1559Transaction"
        }
    }
};
const $de1da58605fc6318$var$types = {
    ...$de1da58605fc6318$var$V0,
    ...$de1da58605fc6318$var$V1,
    ...$de1da58605fc6318$var$V2,
    EthereumAccountId: "GenericEthereumAccountId",
    EthereumAddress: "GenericEthereumAccountId",
    EthereumLookupSource: "GenericEthereumLookupSource",
    EthereumSignature: "[u8; 65]",
    EthAccessListItem: {
        address: "EthAddress",
        slots: "Vec<H256>"
    },
    EthAccessList: "Vec<EthAccessListItem>",
    EthAccount: {
        address: "EthAddress",
        balance: "U256",
        nonce: "U256",
        codeHash: "H256",
        storageHash: "H256",
        accountProof: "Vec<Bytes>",
        storageProof: "Vec<EthStorageProof>"
    },
    EthAddress: "H160",
    EthBlock: {
        header: "EthHeader",
        transactions: "Vec<EthTransaction>",
        ommers: "Vec<EthHeader>"
    },
    EthHeader: {
        parentHash: "H256",
        ommersHash: "H256",
        beneficiary: "EthAddress",
        stateRoot: "H256",
        transactionsRoot: "H256",
        receiptsRoot: "H256",
        logsBloom: "EthBloom",
        difficulty: "U256",
        number: "U256",
        gasLimit: "U256",
        gasUsed: "U256",
        timestamp: "u64",
        extraData: "Bytes",
        mixMash: "H256",
        nonce: "H64"
    },
    EthRichBlock: {
        _alias: {
            blockHash: "hash",
            blockSize: "size"
        },
        blockHash: "Option<H256>",
        parentHash: "H256",
        sha3Uncles: "H256",
        author: "EthAddress",
        miner: "EthAddress",
        stateRoot: "H256",
        transactionsRoot: "H256",
        receiptsRoot: "H256",
        number: "Option<U256>",
        gasUsed: "U256",
        gasLimit: "U256",
        extraData: "Bytes",
        logsBloom: "EthBloom",
        timestamp: "U256",
        difficulty: "U256",
        totalDifficulty: "Option<U256>",
        sealFields: "Vec<Bytes>",
        uncles: "Vec<H256>",
        transactions: "Vec<EthTransaction>",
        blockSize: "Option<U256>"
    },
    EthBloom: "H2048",
    EthCallRequest: {
        from: "Option<EthAddress>",
        to: "Option<EthAddress>",
        gasPrice: "Option<U256>",
        gas: "Option<U256>",
        value: "Option<U256>",
        data: "Option<Bytes>",
        nonce: "Option<U256>"
    },
    EthFeeHistory: {
        oldestBlock: "U256",
        baseFeePerGas: "Vec<U256>",
        gasUsedRatio: "Vec<f64>",
        reward: "Option<Vec<Vec<U256>>>"
    },
    EthFilter: {
        fromBlock: "Option<BlockNumber>",
        toBlock: "Option<BlockNumber>",
        blockHash: "Option<H256>",
        address: "Option<EthFilterAddress>",
        topics: "Option<EthFilterTopic>"
    },
    EthFilterAddress: {
        _enum: {
            Single: "EthAddress",
            Multiple: "Vec<EthAddress>",
            Null: "Null"
        }
    },
    EthFilterChanges: {
        _enum: {
            Logs: "Vec<EthLog>",
            Hashes: "Vec<H256>",
            Empty: "Null"
        }
    },
    EthFilterTopic: {
        _enum: {
            Single: "EthFilterTopicInner",
            Multiple: "Vec<EthFilterTopicInner>",
            Null: "Null"
        }
    },
    EthFilterTopicEntry: "Option<H256>",
    EthFilterTopicInner: {
        _enum: {
            Single: "EthFilterTopicEntry",
            Multiple: "Vec<EthFilterTopicEntry>",
            Null: "Null"
        }
    },
    EthRichHeader: {
        _alias: {
            blockHash: "hash",
            blockSize: "size"
        },
        blockHash: "Option<H256>",
        parentHash: "H256",
        sha3Uncles: "H256",
        author: "EthAddress",
        miner: "EthAddress",
        stateRoot: "H256",
        transactionsRoot: "H256",
        receiptsRoot: "H256",
        number: "Option<U256>",
        gasUsed: "U256",
        gasLimit: "U256",
        extraData: "Bytes",
        logsBloom: "EthBloom",
        timestamp: "U256",
        difficulty: "U256",
        sealFields: "Vec<Bytes>",
        blockSize: "Option<U256>"
    },
    EthLog: {
        address: "EthAddress",
        topics: "Vec<H256>",
        data: "Bytes",
        blockHash: "Option<H256>",
        blockNumber: "Option<U256>",
        transactionHash: "Option<H256>",
        transactionIndex: "Option<U256>",
        logIndex: "Option<U256>",
        transactionLogIndex: "Option<U256>",
        removed: "bool"
    },
    EthReceipt: {
        transactionHash: "Option<H256>",
        transactionIndex: "Option<U256>",
        blockHash: "Option<H256>",
        from: "Option<EthAddress>",
        to: "Option<EthAddress>",
        blockNumber: "Option<U256>",
        cumulativeGasUsed: "U256",
        gasUsed: "Option<U256>",
        contractAddress: "Option<EthAddress>",
        logs: "Vec<EthLog>",
        root: "Option<H256>",
        logsBloom: "EthBloom",
        statusCode: "Option<U64>"
    },
    // not convinced, however the original commit matches, so... (maybe V3 is incorrect?)
    EthReceiptV0: "EthReceipt",
    EthReceiptV3: "EthReceipt",
    EthStorageProof: {
        key: "U256",
        value: "U256",
        proof: "Vec<Bytes>"
    },
    EthSubKind: {
        _enum: [
            "newHeads",
            "logs",
            "newPendingTransactions",
            "syncing"
        ]
    },
    EthSubParams: {
        _enum: {
            None: "Null",
            Logs: "EthFilter"
        }
    },
    EthSubResult: {
        _enum: {
            Header: "EthRichHeader",
            Log: "EthLog",
            TransactionHash: "H256",
            SyncState: "EthSyncStatus"
        }
    },
    EthSyncInfo: {
        startingBlock: "U256",
        currentBlock: "U256",
        highestBlock: "U256",
        warpChunksAmount: "Option<U256>",
        warpChunksProcessed: "Option<U256>"
    },
    EthSyncStatus: {
        _enum: {
            Info: "EthSyncInfo",
            None: "Null"
        }
    },
    EthTransaction: {
        hash: "H256",
        nonce: "U256",
        blockHash: "Option<H256>",
        blockNumber: "Option<U256>",
        transactionIndex: "Option<U256>",
        from: "H160",
        to: "Option<H160>",
        value: "U256",
        gasPrice: "Option<U256>",
        maxFeePerGas: "Option<U256>",
        maxPriorityFeePerGas: "Option<U256>",
        gas: "U256",
        input: "Bytes",
        creates: "Option<H160>",
        raw: "Bytes",
        publicKey: "Option<H512>",
        chainId: "Option<U64>",
        standardV: "U256",
        v: "U256",
        r: "U256",
        s: "U256",
        accessList: "Option<Vec<EthAccessListItem>>",
        transactionType: "Option<U256>"
    },
    EthTransactionSignature: {
        v: "u64",
        r: "H256",
        s: "H256"
    },
    EthTransactionAction: {
        _enum: {
            Call: "H160",
            Create: "Null"
        }
    },
    EthTransactionCondition: {
        _enum: {
            block: "u64",
            time: "u64"
        }
    },
    EthTransactionRequest: {
        from: "Option<EthAddress>",
        to: "Option<EthAddress>",
        gasPrice: "Option<U256>",
        gas: "Option<U256>",
        value: "Option<U256>",
        data: "Option<Bytes>",
        nonce: "Option<U256>"
    },
    EthTransactionStatus: {
        transactionHash: "H256",
        transactionIndex: "u32",
        from: "EthAddress",
        to: "Option<EthAddress>",
        contractAddress: "Option<EthAddress>",
        logs: "Vec<EthLog>",
        logsBloom: "EthBloom"
    },
    EthWork: {
        powHash: "H256",
        seedHash: "H256",
        target: "H256",
        number: "Option<u64>"
    }
};
var $de1da58605fc6318$export$2e2bcd8739ae039 = {
    rpc: $71a2477081700fdd$export$82f5954781486db2,
    runtime: $c279fe6b77def5c1$export$874fd8712028ad21,
    types: $de1da58605fc6318$var$types
};


const $1ec3a08570155f0c$export$874fd8712028ad21 = {
    // deprecated, the NimbusApi is current - this is for backwards compat
    AuthorFilterAPI: [
        {
            methods: {
                can_author: {
                    description: "The runtime api used to predict whether an author will be eligible in the given slot",
                    params: [
                        {
                            name: "author",
                            type: "AccountId"
                        },
                        {
                            name: "relayParent",
                            type: "u32"
                        },
                        {
                            name: "parentHeader",
                            type: "Header"
                        }
                    ],
                    type: "bool"
                }
            },
            version: 2
        },
        {
            methods: {
                can_author: {
                    description: "The runtime api used to predict whether an author will be eligible in the given slot",
                    params: [
                        {
                            name: "author",
                            type: "AccountId"
                        },
                        {
                            name: "relayParent",
                            type: "u32"
                        }
                    ],
                    type: "bool"
                }
            },
            version: 1
        }
    ],
    NimbusApi: [
        {
            methods: {
                can_author: {
                    description: "The runtime api used to predict whether a Nimbus author will be eligible in the given slot",
                    params: [
                        {
                            name: "author",
                            type: "AccountId"
                        },
                        {
                            name: "relayParent",
                            type: "u32"
                        },
                        {
                            name: "parentHeader",
                            type: "Header"
                        }
                    ],
                    type: "bool"
                }
            },
            version: 1
        }
    ]
};


var $b91f8b94885f9d6e$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $1ec3a08570155f0c$export$874fd8712028ad21,
    types: {}
};


const $0d955e842f440c4e$export$874fd8712028ad21 = {
    // https://github.com/open-web3-stack/open-runtime-module-library/blob/b57f88b39cd547e2fb51727d8bb9bcc64fddf8b5/oracle/rpc/runtime-api/src/lib.rs#L12-L21
    OracleApi: [
        {
            methods: {
                get_all_values: {
                    description: "Retrieves all values",
                    params: [
                        {
                            name: "providerId",
                            // This is a Codec type
                            type: "Raw"
                        }
                    ],
                    // This won't actually work as expected - since we have
                    // no information about the actual Raw sizes, we cannot
                    // handle it in this format (it would need an override
                    // for the specific Codec). So return the Raw value.
                    // type: 'Vec<(Raw, Option<Raw>)>'
                    type: "Raw"
                },
                get_value: {
                    description: "Retrieves a single value",
                    params: [
                        {
                            name: "providerId",
                            // This is a Codec type
                            type: "Raw"
                        },
                        {
                            name: "key",
                            // This is a Codec type
                            type: "Raw"
                        }
                    ],
                    // This is an Option<Codec> type
                    type: "Option<Raw>"
                }
            },
            version: 1
        }
    ]
};


var $b934746ebb4defa3$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $0d955e842f440c4e$export$874fd8712028ad21,
    types: {}
};


const $cc1e57d88c68c170$export$874fd8712028ad21 = {
    // https://github.com/open-web3-stack/open-runtime-module-library/blob/b57f88b39cd547e2fb51727d8bb9bcc64fddf8b5/tokens/rpc/runtime-api/src/lib.rs#L11-L18
    TokensApi: [
        {
            methods: {
                query_existential_deposit: {
                    description: "Query the existential amount for a specific currency",
                    params: [
                        {
                            name: "currencyId",
                            // This is CurrencyId, as per the return value, we are unsure
                            // if this is specialized and/or global to the chain or not
                            type: "Raw"
                        }
                    ],
                    // This is Balance - since we don't understand enough about the way
                    // in which this is used, we default to u128 here (it certainly could
                    // be a specialized type that doesn't map to the on-chain Balance)
                    type: "u128"
                }
            },
            version: 1
        }
    ]
};


var $da2431dfc4d3cdc2$export$2e2bcd8739ae039 = {
    rpc: {},
    runtime: $cc1e57d88c68c170$export$874fd8712028ad21,
    types: {}
};


const $d537d58098e23a55$export$82f5954781486db2 = {
    methods: {
        description: "Retrieves the list of RPC methods that are exposed by the node",
        params: [],
        type: "RpcMethods"
    }
};


var $9a5e7073e4f79c00$export$2e2bcd8739ae039 = {
    rpc: $d537d58098e23a55$export$82f5954781486db2,
    types: {
        RpcMethods: {
            version: "u32",
            methods: "Vec<Text>"
        }
    }
};


const $88271ed8b3c00fba$export$82f5954781486db2 = {
    hasKey: {
        description: "Returns true if the keystore has private keys for the given public key and key type.",
        isUnsafe: true,
        params: [
            {
                name: "publicKey",
                type: "Bytes"
            },
            {
                name: "keyType",
                type: "Text"
            }
        ],
        type: "bool"
    },
    hasSessionKeys: {
        description: "Returns true if the keystore has private keys for the given session public keys.",
        isUnsafe: true,
        params: [
            {
                name: "sessionKeys",
                type: "Bytes"
            }
        ],
        type: "bool"
    },
    insertKey: {
        description: "Insert a key into the keystore.",
        isUnsafe: true,
        params: [
            {
                name: "keyType",
                type: "Text"
            },
            {
                name: "suri",
                type: "Text"
            },
            {
                name: "publicKey",
                type: "Bytes"
            }
        ],
        type: "Bytes"
    },
    pendingExtrinsics: {
        description: "Returns all pending extrinsics, potentially grouped by sender",
        params: [],
        type: "Vec<Extrinsic>"
    },
    removeExtrinsic: {
        description: "Remove given extrinsic from the pool and temporarily ban it to prevent reimporting",
        isUnsafe: true,
        params: [
            {
                name: "bytesOrHash",
                type: "Vec<ExtrinsicOrHash>"
            }
        ],
        type: "Vec<Hash>"
    },
    rotateKeys: {
        description: "Generate new session keys and returns the corresponding public keys",
        isUnsafe: true,
        params: [],
        type: "Bytes"
    },
    submitAndWatchExtrinsic: {
        description: "Submit and subscribe to watch an extrinsic until unsubscribed",
        isSigned: true,
        params: [
            {
                name: "extrinsic",
                type: "Extrinsic"
            }
        ],
        pubsub: [
            "extrinsicUpdate",
            "submitAndWatchExtrinsic",
            "unwatchExtrinsic"
        ],
        type: "ExtrinsicStatus"
    },
    submitExtrinsic: {
        description: "Submit a fully formatted extrinsic for block inclusion",
        isSigned: true,
        params: [
            {
                name: "extrinsic",
                type: "Extrinsic"
            }
        ],
        type: "Hash"
    }
};


var $92577db7422b1b10$export$2e2bcd8739ae039 = {
    rpc: $88271ed8b3c00fba$export$82f5954781486db2,
    types: {
        ExtrinsicOrHash: {
            _enum: {
                Hash: "Hash",
                Extrinsic: "Bytes"
            }
        },
        ExtrinsicStatus: {
            _enum: {
                Future: "Null",
                Ready: "Null",
                Broadcast: "Vec<Text>",
                InBlock: "Hash",
                Retracted: "Hash",
                FinalityTimeout: "Hash",
                Finalized: "Hash",
                Usurped: "Hash",
                Dropped: "Null",
                Invalid: "Null"
            }
        }
    }
};


const $bc122ce86f59b5f2$export$82f5954781486db2 = {
    getBlock: {
        description: "Get header and body of a relay chain block",
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: "hash",
                type: "BlockHash"
            }
        ],
        type: "SignedBlock"
    },
    getBlockHash: {
        description: "Get the block hash for a specific block",
        params: [
            {
                isOptional: true,
                name: "blockNumber",
                type: "BlockNumber"
            }
        ],
        type: "BlockHash"
    },
    getFinalizedHead: {
        alias: [
            "chain_getFinalisedHead"
        ],
        description: "Get hash of the last finalized block in the canon chain",
        params: [],
        type: "BlockHash"
    },
    getHeader: {
        alias: [
            "chain_getHead"
        ],
        description: "Retrieves the header for a specific block",
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: "hash",
                type: "BlockHash"
            }
        ],
        type: "Header"
    },
    subscribeAllHeads: {
        description: "Retrieves the newest header via subscription",
        params: [],
        pubsub: [
            "allHead",
            "subscribeAllHeads",
            "unsubscribeAllHeads"
        ],
        type: "Header"
    },
    subscribeFinalizedHeads: {
        alias: [
            "chain_subscribeFinalisedHeads",
            "chain_unsubscribeFinalisedHeads"
        ],
        description: "Retrieves the best finalized header via subscription",
        params: [],
        pubsub: [
            "finalizedHead",
            "subscribeFinalizedHeads",
            "unsubscribeFinalizedHeads"
        ],
        type: "Header"
    },
    subscribeNewHeads: {
        alias: [
            "chain_unsubscribeNewHeads",
            "subscribe_newHead",
            "unsubscribe_newHead"
        ],
        description: "Retrieves the best header via subscription",
        params: [],
        // NOTE These still has the aliassed version, compatible with 1.x
        pubsub: [
            "newHead",
            "subscribeNewHead",
            "unsubscribeNewHead"
        ],
        type: "Header"
    }
};


var $2d37c78b35c8cc17$export$2e2bcd8739ae039 = {
    rpc: $bc122ce86f59b5f2$export$82f5954781486db2,
    types: {
        BlockHash: "Hash"
    }
};


const $6ee25251cefe4417$export$82f5954781486db2 = {
    getKeys: {
        description: "Returns the keys with prefix from a child storage, leave empty to get all the keys",
        params: [
            {
                name: "childKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "prefix",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Vec<StorageKey>"
    },
    getKeysPaged: {
        alias: [
            "childstate_getKeysPagedAt"
        ],
        description: "Returns the keys with prefix from a child storage with pagination support",
        params: [
            {
                name: "childKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "prefix",
                type: "StorageKey"
            },
            {
                name: "count",
                type: "u32"
            },
            {
                isOptional: true,
                name: "startKey",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Vec<StorageKey>"
    },
    getStorage: {
        description: "Returns a child storage entry at a specific block state",
        params: [
            {
                name: "childKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Option<StorageData>"
    },
    getStorageEntries: {
        description: "Returns child storage entries for multiple keys at a specific block state",
        params: [
            {
                name: "childKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "keys",
                type: "Vec<StorageKey>"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Vec<Option<StorageData>>"
    },
    getStorageHash: {
        description: "Returns the hash of a child storage entry at a block state",
        params: [
            {
                name: "childKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Option<Hash>"
    },
    getStorageSize: {
        description: "Returns the size of a child storage entry at a block state",
        params: [
            {
                name: "childKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "Hash"
            }
        ],
        type: "Option<u64>"
    }
};


var $89ff5665dde79b63$export$2e2bcd8739ae039 = {
    rpc: $6ee25251cefe4417$export$82f5954781486db2,
    types: {
        // StorageKey extends Bytes
        PrefixedStorageKey: "StorageKey"
    }
};


const $be248fc0ac7c70be$export$82f5954781486db2 = {
    localStorageGet: {
        description: "Get offchain local storage under given key and prefix",
        isUnsafe: true,
        params: [
            {
                name: "kind",
                type: "StorageKind"
            },
            {
                name: "key",
                type: "Bytes"
            }
        ],
        type: "Option<Bytes>"
    },
    localStorageSet: {
        description: "Set offchain local storage under given key and prefix",
        isUnsafe: true,
        params: [
            {
                name: "kind",
                type: "StorageKind"
            },
            {
                name: "key",
                type: "Bytes"
            },
            {
                name: "value",
                type: "Bytes"
            }
        ],
        type: "Null"
    }
};


const $6babff665e8d5fc5$export$874fd8712028ad21 = {
    OffchainWorkerApi: [
        {
            methods: {
                offchain_worker: {
                    description: "Starts the off-chain task for given block header.",
                    params: [
                        {
                            name: "header",
                            type: "Header"
                        }
                    ],
                    type: "Null"
                }
            },
            version: 2
        },
        {
            methods: {
                offchain_worker: {
                    description: "Starts the off-chain task for given block header.",
                    params: [
                        {
                            name: "number",
                            type: "BlockNumber"
                        }
                    ],
                    type: "Null"
                }
            },
            version: 1
        }
    ]
};


var $22b38005f29a2a9d$export$2e2bcd8739ae039 = {
    rpc: $be248fc0ac7c70be$export$82f5954781486db2,
    runtime: $6babff665e8d5fc5$export$874fd8712028ad21,
    types: {
        StorageKind: {
            _enum: {
                PERSISTENT: 1,
                LOCAL: 2
            }
        }
    }
};


const $01b41fe3827f07cd$export$82f5954781486db2 = {
    queryFeeDetails: {
        // NOTE: Not deprecated (yet) in Substrate, but it is the intent to do so
        deprecated: "Use `api.call.transactionPaymentApi.queryFeeDetails` instead",
        description: "Query the detailed fee of a given encoded extrinsic",
        params: [
            {
                name: "extrinsic",
                type: "Bytes"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "FeeDetails"
    },
    queryInfo: {
        // NOTE: Not deprecated (yet) in Substrate, but it is the intent to do so
        deprecated: "Use `api.call.transactionPaymentApi.queryInfo` instead",
        description: "Retrieves the fee information for an encoded extrinsic",
        params: [
            {
                name: "extrinsic",
                type: "Bytes"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        // NOTE: Stuck on V1 forever (at least for the time being)
        type: "RuntimeDispatchInfoV1"
    }
};


const $48a5f18ee3261da5$var$V1_TO_V4_SHARED_PAY = {
    query_fee_details: {
        description: "The transaction fee details",
        params: [
            {
                name: "uxt",
                type: "Extrinsic"
            },
            {
                name: "len",
                type: "u32"
            }
        ],
        type: "FeeDetails"
    }
};
const $48a5f18ee3261da5$var$V1_TO_V3_SHARED_CALL = {
    query_call_fee_details: {
        description: "The call fee details",
        params: [
            {
                name: "call",
                type: "Call"
            },
            {
                name: "len",
                type: "u32"
            }
        ],
        type: "FeeDetails"
    }
};
const $48a5f18ee3261da5$var$V2_TO_V4_SHARED_PAY = {
    query_info: {
        description: "The transaction info",
        params: [
            {
                name: "uxt",
                type: "Extrinsic"
            },
            {
                name: "len",
                type: "u32"
            }
        ],
        type: "RuntimeDispatchInfo"
    }
};
const $48a5f18ee3261da5$var$V2_V3_SHARED_CALL = {
    query_call_info: {
        description: "The call info",
        params: [
            {
                name: "call",
                type: "Call"
            },
            {
                name: "len",
                type: "u32"
            }
        ],
        type: "RuntimeDispatchInfo"
    }
};
const $48a5f18ee3261da5$var$V3_SHARED_PAY_CALL = {
    query_length_to_fee: {
        description: "Query the output of the current LengthToFee given some input",
        params: [
            {
                name: "length",
                type: "u32"
            }
        ],
        type: "Balance"
    },
    query_weight_to_fee: {
        description: "Query the output of the current WeightToFee given some input",
        params: [
            {
                name: "weight",
                type: "Weight"
            }
        ],
        type: "Balance"
    }
};
const $48a5f18ee3261da5$export$874fd8712028ad21 = {
    TransactionPaymentApi: [
        {
            // V4 is equivalent to V3 (V4 just dropped all V1 references)
            methods: {
                ...$48a5f18ee3261da5$var$V3_SHARED_PAY_CALL,
                ...$48a5f18ee3261da5$var$V2_TO_V4_SHARED_PAY,
                ...$48a5f18ee3261da5$var$V1_TO_V4_SHARED_PAY
            },
            version: 4
        },
        {
            methods: {
                ...$48a5f18ee3261da5$var$V3_SHARED_PAY_CALL,
                ...$48a5f18ee3261da5$var$V2_TO_V4_SHARED_PAY,
                ...$48a5f18ee3261da5$var$V1_TO_V4_SHARED_PAY
            },
            version: 3
        },
        {
            methods: {
                ...$48a5f18ee3261da5$var$V2_TO_V4_SHARED_PAY,
                ...$48a5f18ee3261da5$var$V1_TO_V4_SHARED_PAY
            },
            version: 2
        },
        {
            methods: {
                query_info: {
                    description: "The transaction info",
                    params: [
                        {
                            name: "uxt",
                            type: "Extrinsic"
                        },
                        {
                            name: "len",
                            type: "u32"
                        }
                    ],
                    // NOTE: _Should_ be V1 (as per current Substrate), however the interface was
                    // changed mid-flight between versions. So we have some of each depending on
                    // runtime. (We do detect the weight type, so correct)
                    type: "RuntimeDispatchInfo"
                },
                ...$48a5f18ee3261da5$var$V1_TO_V4_SHARED_PAY
            },
            version: 1
        }
    ],
    TransactionPaymentCallApi: [
        {
            methods: {
                ...$48a5f18ee3261da5$var$V3_SHARED_PAY_CALL,
                ...$48a5f18ee3261da5$var$V2_V3_SHARED_CALL,
                ...$48a5f18ee3261da5$var$V1_TO_V3_SHARED_CALL
            },
            version: 3
        },
        {
            methods: {
                ...$48a5f18ee3261da5$var$V2_V3_SHARED_CALL,
                ...$48a5f18ee3261da5$var$V1_TO_V3_SHARED_CALL
            },
            version: 2
        },
        {
            methods: {
                CALL: {
                    description: "The call info",
                    params: [
                        {
                            name: "call",
                            type: "Call"
                        },
                        {
                            name: "len",
                            type: "u32"
                        }
                    ],
                    // NOTE: As per the above comment, the below is correct according to Substrate, but
                    // _may_ yield fallback decoding on some versions of the runtime
                    type: "RuntimeDispatchInfo"
                },
                ...$48a5f18ee3261da5$var$V1_TO_V3_SHARED_CALL
            },
            version: 1
        }
    ]
};


var $bbbeee776479a655$export$2e2bcd8739ae039 = {
    rpc: $01b41fe3827f07cd$export$82f5954781486db2,
    runtime: $48a5f18ee3261da5$export$874fd8712028ad21,
    types: {
        FeeDetails: {
            inclusionFee: "Option<InclusionFee>"
        },
        InclusionFee: {
            baseFee: "Balance",
            lenFee: "Balance",
            adjustedWeightFee: "Balance"
        },
        RuntimeDispatchInfo: {
            weight: "Weight",
            class: "DispatchClass",
            partialFee: "Balance"
        },
        RuntimeDispatchInfoV1: {
            weight: "WeightV1",
            class: "DispatchClass",
            partialFee: "Balance"
        },
        RuntimeDispatchInfoV2: {
            weight: "WeightV2",
            class: "DispatchClass",
            partialFee: "Balance"
        }
    }
};


const $2cc0ec4f7fb8be6d$export$82f5954781486db2 = {
    call: {
        alias: [
            "state_callAt"
        ],
        description: "Perform a call to a builtin on the chain",
        params: [
            {
                name: "method",
                type: "Text"
            },
            {
                name: "data",
                type: "Bytes"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Bytes"
    },
    getChildKeys: {
        description: "Retrieves the keys with prefix of a specific child storage",
        params: [
            {
                name: "childStorageKey",
                type: "StorageKey"
            },
            {
                name: "childDefinition",
                type: "StorageKey"
            },
            {
                name: "childType",
                type: "u32"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Vec<StorageKey>"
    },
    getChildReadProof: {
        description: "Returns proof of storage for child key entries at a specific block state.",
        params: [
            {
                name: "childStorageKey",
                type: "PrefixedStorageKey"
            },
            {
                name: "keys",
                type: "Vec<StorageKey>"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "ReadProof"
    },
    getChildStorage: {
        description: "Retrieves the child storage for a key",
        params: [
            {
                name: "childStorageKey",
                type: "StorageKey"
            },
            {
                name: "childDefinition",
                type: "StorageKey"
            },
            {
                name: "childType",
                type: "u32"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "StorageData"
    },
    getChildStorageHash: {
        description: "Retrieves the child storage hash",
        params: [
            {
                name: "childStorageKey",
                type: "StorageKey"
            },
            {
                name: "childDefinition",
                type: "StorageKey"
            },
            {
                name: "childType",
                type: "u32"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Hash"
    },
    getChildStorageSize: {
        description: "Retrieves the child storage size",
        params: [
            {
                name: "childStorageKey",
                type: "StorageKey"
            },
            {
                name: "childDefinition",
                type: "StorageKey"
            },
            {
                name: "childType",
                type: "u32"
            },
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "u64"
    },
    getKeys: {
        deprecated: "Use `api.rpc.state.getKeysPaged` to retrieve keys",
        description: "Retrieves the keys with a certain prefix",
        params: [
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Vec<StorageKey>"
    },
    getKeysPaged: {
        alias: [
            "state_getKeysPagedAt"
        ],
        description: "Returns the keys with prefix with pagination support.",
        params: [
            {
                name: "key",
                type: "StorageKey"
            },
            {
                name: "count",
                type: "u32"
            },
            {
                isOptional: true,
                name: "startKey",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Vec<StorageKey>"
    },
    getMetadata: {
        description: "Returns the runtime metadata",
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Metadata"
    },
    getPairs: {
        deprecated: "Use `api.rpc.state.getKeysPaged` to retrieve keys",
        description: "Returns the keys with prefix, leave empty to get all the keys (deprecated: Use getKeysPaged)",
        isUnsafe: true,
        params: [
            {
                name: "prefix",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Vec<KeyValue>"
    },
    getReadProof: {
        description: "Returns proof of storage entries at a specific block state",
        params: [
            {
                name: "keys",
                type: "Vec<StorageKey>"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "ReadProof"
    },
    getRuntimeVersion: {
        alias: [
            "chain_getRuntimeVersion"
        ],
        description: "Get the runtime version",
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "RuntimeVersion"
    },
    getStorage: {
        alias: [
            "state_getStorageAt"
        ],
        description: "Retrieves the storage for a key",
        params: [
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "StorageData"
    },
    getStorageHash: {
        alias: [
            "state_getStorageHashAt"
        ],
        description: "Retrieves the storage hash",
        params: [
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Hash"
    },
    getStorageSize: {
        alias: [
            "state_getStorageSizeAt"
        ],
        description: "Retrieves the storage size",
        params: [
            {
                name: "key",
                type: "StorageKey"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "u64"
    },
    queryStorage: {
        description: "Query historical storage entries (by key) starting from a start block",
        isUnsafe: true,
        params: [
            {
                name: "keys",
                type: "Vec<StorageKey>"
            },
            {
                name: "fromBlock",
                type: "Hash"
            },
            {
                isOptional: true,
                name: "toBlock",
                type: "BlockHash"
            }
        ],
        type: "Vec<StorageChangeSet>"
    },
    queryStorageAt: {
        description: "Query storage entries (by key) starting at block hash given as the second parameter",
        params: [
            {
                name: "keys",
                type: "Vec<StorageKey>"
            },
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "Vec<StorageChangeSet>"
    },
    subscribeRuntimeVersion: {
        alias: [
            "chain_subscribeRuntimeVersion",
            "chain_unsubscribeRuntimeVersion"
        ],
        description: "Retrieves the runtime version via subscription",
        params: [],
        pubsub: [
            "runtimeVersion",
            "subscribeRuntimeVersion",
            "unsubscribeRuntimeVersion"
        ],
        type: "RuntimeVersion"
    },
    subscribeStorage: {
        description: "Subscribes to storage changes for the provided keys",
        // NOTE Just marking it here to follow the logic - this is unsafe when no
        // keys are provided (i.e. subscribing to all), generally this is used
        // extensively with normal subscriptions
        // isUnsafe: true,
        params: [
            {
                isOptional: true,
                name: "keys",
                type: "Vec<StorageKey>"
            }
        ],
        pubsub: [
            "storage",
            "subscribeStorage",
            "unsubscribeStorage"
        ],
        type: "StorageChangeSet"
    },
    traceBlock: {
        description: "Provides a way to trace the re-execution of a single block",
        isUnsafe: true,
        params: [
            {
                name: "block",
                type: "Hash"
            },
            {
                name: "targets",
                type: "Option<Text>"
            },
            {
                name: "storageKeys",
                type: "Option<Text>"
            },
            {
                name: "methods",
                type: "Option<Text>"
            }
        ],
        type: "TraceBlockResponse"
    },
    trieMigrationStatus: {
        description: "Check current migration state",
        isUnsafe: true,
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: "at",
                type: "BlockHash"
            }
        ],
        type: "MigrationStatusResult"
    }
};


var $60e971efe0d37e89$export$2e2bcd8739ae039 = {
    rpc: $2cc0ec4f7fb8be6d$export$82f5954781486db2,
    types: {
        ApiId: "[u8; 8]",
        BlockTrace: {
            blockHash: "Text",
            parentHash: "Text",
            tracingTargets: "Text",
            storageKeys: "Text",
            spans: "Vec<BlockTraceSpan>",
            events: "Vec<BlockTraceEvent>"
        },
        BlockTraceEvent: {
            target: "Text",
            data: "BlockTraceEventData",
            parentId: "Option<u64>"
        },
        BlockTraceEventData: {
            stringValues: "HashMap<Text, Text>"
        },
        BlockTraceSpan: {
            id: "u64",
            parentId: "Option<u64>",
            name: "Text",
            target: "Text",
            wasm: "bool"
        },
        KeyValueOption: "(StorageKey, Option<StorageData>)",
        MigrationStatusResult: {
            topRemainingToMigrate: "u64",
            childRemainingToMigrate: "u64"
        },
        ReadProof: {
            at: "Hash",
            proof: "Vec<Bytes>"
        },
        RuntimeVersionApi: "(ApiId, u32)",
        RuntimeVersion: {
            specName: "Text",
            implName: "Text",
            authoringVersion: "u32",
            specVersion: "u32",
            implVersion: "u32",
            apis: "Vec<RuntimeVersionApi>",
            transactionVersion: "u32",
            stateVersion: "u8"
        },
        RuntimeVersionPre4: {
            specName: "Text",
            implName: "Text",
            authoringVersion: "u32",
            specVersion: "u32",
            implVersion: "u32",
            apis: "Vec<RuntimeVersionApi>",
            transactionVersion: "u32"
        },
        RuntimeVersionPre3: {
            specName: "Text",
            implName: "Text",
            authoringVersion: "u32",
            specVersion: "u32",
            implVersion: "u32",
            apis: "Vec<RuntimeVersionApi>"
        },
        RuntimeVersionPartial: {
            specName: "Text",
            specVersion: "u32",
            apis: "Vec<RuntimeVersionApi>"
        },
        SpecVersion: "u32",
        StorageChangeSet: {
            block: "Hash",
            changes: "Vec<KeyValueOption>"
        },
        TraceBlockResponse: {
            _enum: {
                TraceError: "TraceError",
                BlockTrace: "BlockTrace"
            }
        },
        TraceError: {
            error: "Text"
        }
    }
};


$parcel$exportWildcard($f07063bab9185798$exports, $04d24b70f7af5675$exports);




function $e18d98b64df51de2$export$46c30c6def42ba7d(lookup, { type: type }, getName, creator) {
    const result = {};
    const variants = lookup.getSiType(type).def.asVariant.variants;
    for(let i = 0, count = variants.length; i < count; i++)(0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, variants[i], creator, getName, i);
    return result;
}




function $ed675231db5fe830$var$convert(fn) {
    return ({ name: name })=>fn(name);
}
const $ed675231db5fe830$export$a4f9bcfa07da06f6 = /*#__PURE__*/ $ed675231db5fe830$var$convert((0, $4db46be060f888b6$export$27f5d30aaa3dc2ea));
const $ed675231db5fe830$export$e6769dcf7d071547 = /*#__PURE__*/ $ed675231db5fe830$var$convert((n)=>n.toString());



function $595d93d3e40198f1$var$isTx(tx, callIndex) {
    return tx.callIndex[0] === callIndex[0] && tx.callIndex[1] === callIndex[1];
}
function $595d93d3e40198f1$export$4e345a51504bc82a(registry, section, callIndex, callMetadata) {
    const expectedArgs = callMetadata.fields;
    const funcName = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(callMetadata.name);
    const extrinsicFn = (...args)=>{
        if (expectedArgs.length !== args.length) throw new Error(`Extrinsic ${section}.${funcName} expects ${expectedArgs.length} arguments, got ${args.length}.`);
        return registry.createTypeUnsafe("Call", [
            {
                args: args,
                callIndex: callIndex
            },
            callMetadata
        ]);
    };
    extrinsicFn.is = (tx)=>$595d93d3e40198f1$var$isTx(tx, callIndex);
    extrinsicFn.callIndex = callIndex;
    extrinsicFn.meta = callMetadata;
    extrinsicFn.method = funcName;
    extrinsicFn.section = section;
    extrinsicFn.toJSON = ()=>callMetadata.toJSON();
    return extrinsicFn;
}


function $bff1a500fdc7f076$export$f54d62d58c333dbb({ calls: calls }) {
    return calls.isSome;
}
function $bff1a500fdc7f076$export$6cde56eec82c0c6a(registry, lookup, variant, sectionName, sectionIndex) {
    const { fields: fields, index: index } = variant;
    const count = fields.length;
    const args = new Array(count);
    for(let i = 0; i < count; i++){
        const { name: name, type: type, typeName: typeName } = fields[i];
        args[i] = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            name: (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name.unwrapOr(`param${i}`)),
            type: (0, $2a5439f14937909c$export$73d7a99faf161633)(lookup, type)
        }, typeName.isSome ? {
            typeName: typeName.unwrap()
        } : null);
    }
    return (0, $595d93d3e40198f1$export$4e345a51504bc82a)(registry, sectionName, new Uint8Array([
        sectionIndex,
        index.toNumber()
    ]), registry.createTypeUnsafe("FunctionMetadataLatest", [
        (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            args: args
        }, variant)
    ]));
}
function $bff1a500fdc7f076$export$5d63c876c2db8f77(registry, { lookup: lookup, pallets: pallets }, version) {
    const result = {};
    const filtered = pallets.filter($bff1a500fdc7f076$export$f54d62d58c333dbb);
    for(let i = 0, count = filtered.length; i < count; i++){
        const { calls: calls, index: index, name: name } = filtered[i];
        const sectionName = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name);
        const sectionIndex = version >= 12 ? index.toNumber() : i;
        (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, sectionName, ()=>(0, $e18d98b64df51de2$export$46c30c6def42ba7d)(lookup, calls.unwrap(), (0, $ed675231db5fe830$export$a4f9bcfa07da06f6), (variant)=>$bff1a500fdc7f076$export$6cde56eec82c0c6a(registry, lookup, variant, sectionName, sectionIndex)));
    }
    return result;
}





function $6fd24ae59e9f7c74$export$bce56c4ffddeedc8(registry, { pallets: pallets }, _version) {
    const result = {};
    for(let i = 0, count = pallets.length; i < count; i++){
        const { constants: constants, name: name } = pallets[i];
        if (!constants.isEmpty) (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name), ()=>(0, $bad025b936daa7ef$export$d3fc7341b317ef1a)({}, constants, (constant)=>{
                const codec = registry.createTypeUnsafe(registry.createLookupType(constant.type), [
                    (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(constant.value.toHex())
                ]);
                // We are casting here since we are assigning to a read-only property
                codec.meta = constant;
                return codec;
            }, (0, $ed675231db5fe830$export$a4f9bcfa07da06f6)));
    }
    return result;
}





function $0ea9d26610fb372d$export$839ce679090a24a1(lookup, variant) {
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
        args: variant.fields.map(({ type: type })=>lookup.getTypeDef(type).type)
    }, variant);
}
function $0ea9d26610fb372d$export$90951a2c9c83170(registry, { lookup: lookup, pallets: pallets }, version) {
    const result = {};
    for(let i = 0, count = pallets.length; i < count; i++){
        const { errors: errors, index: index, name: name } = pallets[i];
        if (errors.isSome) {
            const sectionIndex = version >= 12 ? index.toNumber() : i;
            (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name), ()=>(0, $e18d98b64df51de2$export$46c30c6def42ba7d)(lookup, errors.unwrap(), (0, $ed675231db5fe830$export$e6769dcf7d071547), (variant)=>({
                        // We sprinkle in isCodec & isU8a to ensure we are dealing with the correct objects
                        is: (errorMod)=>(0, $28ae0347fa173539$export$8914f96432c883a3)(errorMod) && (0, $28ae0347fa173539$export$8914f96432c883a3)(errorMod.index) && errorMod.index.eq(sectionIndex) && ((0, $ad964ef63ebabd4e$export$f5328759db5e050d)(errorMod.error) ? errorMod.error[0] === variant.index.toNumber() : (0, $28ae0347fa173539$export$8914f96432c883a3)(errorMod.error) && errorMod.error.eq(variant.index)),
                        meta: registry.createTypeUnsafe("ErrorMetadataLatest", [
                            $0ea9d26610fb372d$export$839ce679090a24a1(lookup, variant)
                        ])
                    })));
        }
    }
    return result;
}






function $2afce0de1332c32b$export$d0fc5d59dcf00a97({ events: events }) {
    return events.isSome;
}
function $2afce0de1332c32b$export$f8376c3696189eda(registry, { lookup: lookup, pallets: pallets }, version) {
    const result = {};
    const filtered = pallets.filter($2afce0de1332c32b$export$d0fc5d59dcf00a97);
    for(let i = 0, count = filtered.length; i < count; i++){
        const { events: events, index: index, name: name } = filtered[i];
        const sectionIndex = version >= 12 ? index.toNumber() : i;
        (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name), ()=>(0, $e18d98b64df51de2$export$46c30c6def42ba7d)(lookup, events.unwrap(), (0, $ed675231db5fe830$export$e6769dcf7d071547), (variant)=>({
                    // We sprinkle in isCodec & isU8a to ensure we are dealing with the correct objects
                    is: (eventRecord)=>(0, $28ae0347fa173539$export$8914f96432c883a3)(eventRecord) && (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(eventRecord.index) && sectionIndex === eventRecord.index[0] && variant.index.eq(eventRecord.index[1]),
                    meta: registry.createTypeUnsafe("EventMetadataLatest", [
                        (0, $0ea9d26610fb372d$export$839ce679090a24a1)(lookup, variant)
                    ])
                })));
    }
    return result;
}











const $f18874b655d5f201$export$88dd0bc7d94c666 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(0);
const $f18874b655d5f201$export$83f3236b956b9786 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(1);
const $f18874b655d5f201$export$5375de44cf36eab8 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(2);
const $f18874b655d5f201$export$d3ecfa2c7ce90527 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(3);
const $f18874b655d5f201$export$ba41c85b07c3212d = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(4);
const $f18874b655d5f201$export$468ca929120ff547 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(5);
const $f18874b655d5f201$export$5e3d0510d365b822 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(6);
const $f18874b655d5f201$export$f135eb39372aba8b = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(7);
const $f18874b655d5f201$export$ee7c3df004a2ef0e = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(8);
const $f18874b655d5f201$export$b2ba18c290798b97 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(9);
const $f18874b655d5f201$export$78cd2b495eb42513 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(10);
const $f18874b655d5f201$export$4aeacebe450f2d14 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(100);
const $f18874b655d5f201$export$e9e4500a7e6ed064 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(1000);
const $f18874b655d5f201$export$399a5d2e1ce4201e = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(1000000);
const $f18874b655d5f201$export$bf19928dc47b3d55 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(1000000000);
const $f18874b655d5f201$export$3c32dc449b8ecc76 = $f18874b655d5f201$export$bf19928dc47b3d55 * $f18874b655d5f201$export$bf19928dc47b3d55;
const $f18874b655d5f201$export$5d327452b32fabe3 = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(Number.MAX_SAFE_INTEGER);
const $f18874b655d5f201$export$3db1d7f7daf9cc0e = /*#__PURE__*/ (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(94906265);



const $95bf3ff157aabe2b$var$P64_1 = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)("11400714785074694791");
const $95bf3ff157aabe2b$var$P64_2 = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)("14029467366897019727");
const $95bf3ff157aabe2b$var$P64_3 = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)("1609587929392839161");
const $95bf3ff157aabe2b$var$P64_4 = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)("9650029242287828579");
const $95bf3ff157aabe2b$var$P64_5 = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)("2870177450012600261");
const $95bf3ff157aabe2b$var$U64 = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)("0xffffffffffffffff");
const $95bf3ff157aabe2b$var$_7n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(7);
const $95bf3ff157aabe2b$var$_11n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(11);
const $95bf3ff157aabe2b$var$_12n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(12);
const $95bf3ff157aabe2b$var$_16n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(16);
const $95bf3ff157aabe2b$var$_18n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(18);
const $95bf3ff157aabe2b$var$_23n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(23);
const $95bf3ff157aabe2b$var$_27n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(27);
const $95bf3ff157aabe2b$var$_29n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(29);
const $95bf3ff157aabe2b$var$_31n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(31);
const $95bf3ff157aabe2b$var$_32n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(32);
const $95bf3ff157aabe2b$var$_33n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(33);
const $95bf3ff157aabe2b$var$_64n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(64);
const $95bf3ff157aabe2b$var$_256n = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(256);
function $95bf3ff157aabe2b$var$rotl(a, b) {
    const c = a & $95bf3ff157aabe2b$var$U64;
    return (c << b | c >> $95bf3ff157aabe2b$var$_64n - b) & $95bf3ff157aabe2b$var$U64;
}
function $95bf3ff157aabe2b$var$fromU8a(u8a, p, count) {
    const bigints = new Array(count);
    let offset = 0;
    for(let i = 0; i < count; i++, offset += 2)bigints[i] = (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(u8a[p + offset] | u8a[p + 1 + offset] << 8);
    let result = (0, $f18874b655d5f201$export$88dd0bc7d94c666);
    for(let i = count - 1; i >= 0; i--)result = (result << $95bf3ff157aabe2b$var$_16n) + bigints[i];
    return result;
}
function $95bf3ff157aabe2b$var$init(seed, input) {
    const state = {
        seed: seed,
        u8a: new Uint8Array(32),
        u8asize: 0,
        v1: seed + $95bf3ff157aabe2b$var$P64_1 + $95bf3ff157aabe2b$var$P64_2,
        v2: seed + $95bf3ff157aabe2b$var$P64_2,
        v3: seed,
        v4: seed - $95bf3ff157aabe2b$var$P64_1
    };
    if (input.length < 32) {
        state.u8a.set(input);
        state.u8asize = input.length;
        return state;
    }
    const limit = input.length - 32;
    let p = 0;
    if (limit >= 0) {
        const adjustV = (v)=>$95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(v + $95bf3ff157aabe2b$var$P64_2 * $95bf3ff157aabe2b$var$fromU8a(input, p, 4), $95bf3ff157aabe2b$var$_31n);
        do {
            state.v1 = adjustV(state.v1);
            p += 8;
            state.v2 = adjustV(state.v2);
            p += 8;
            state.v3 = adjustV(state.v3);
            p += 8;
            state.v4 = adjustV(state.v4);
            p += 8;
        }while (p <= limit);
    }
    if (p < input.length) {
        state.u8a.set(input.subarray(p, input.length));
        state.u8asize = input.length - p;
    }
    return state;
}
function $95bf3ff157aabe2b$export$6f9f586567871a11(input, initSeed) {
    const { seed: seed, u8a: u8a, u8asize: u8asize, v1: v1, v2: v2, v3: v3, v4: v4 } = $95bf3ff157aabe2b$var$init((0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(initSeed), input);
    let p = 0;
    let h64 = $95bf3ff157aabe2b$var$U64 & (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(input.length) + (input.length >= 32 ? (((($95bf3ff157aabe2b$var$rotl(v1, (0, $f18874b655d5f201$export$83f3236b956b9786)) + $95bf3ff157aabe2b$var$rotl(v2, $95bf3ff157aabe2b$var$_7n) + $95bf3ff157aabe2b$var$rotl(v3, $95bf3ff157aabe2b$var$_12n) + $95bf3ff157aabe2b$var$rotl(v4, $95bf3ff157aabe2b$var$_18n) ^ $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(v1 * $95bf3ff157aabe2b$var$P64_2, $95bf3ff157aabe2b$var$_31n)) * $95bf3ff157aabe2b$var$P64_1 + $95bf3ff157aabe2b$var$P64_4 ^ $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(v2 * $95bf3ff157aabe2b$var$P64_2, $95bf3ff157aabe2b$var$_31n)) * $95bf3ff157aabe2b$var$P64_1 + $95bf3ff157aabe2b$var$P64_4 ^ $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(v3 * $95bf3ff157aabe2b$var$P64_2, $95bf3ff157aabe2b$var$_31n)) * $95bf3ff157aabe2b$var$P64_1 + $95bf3ff157aabe2b$var$P64_4 ^ $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(v4 * $95bf3ff157aabe2b$var$P64_2, $95bf3ff157aabe2b$var$_31n)) * $95bf3ff157aabe2b$var$P64_1 + $95bf3ff157aabe2b$var$P64_4 : seed + $95bf3ff157aabe2b$var$P64_5);
    while(p <= u8asize - 8){
        h64 = $95bf3ff157aabe2b$var$U64 & $95bf3ff157aabe2b$var$P64_4 + $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(h64 ^ $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl($95bf3ff157aabe2b$var$P64_2 * $95bf3ff157aabe2b$var$fromU8a(u8a, p, 4), $95bf3ff157aabe2b$var$_31n), $95bf3ff157aabe2b$var$_27n);
        p += 8;
    }
    if (p + 4 <= u8asize) {
        h64 = $95bf3ff157aabe2b$var$U64 & $95bf3ff157aabe2b$var$P64_3 + $95bf3ff157aabe2b$var$P64_2 * $95bf3ff157aabe2b$var$rotl(h64 ^ $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$fromU8a(u8a, p, 2), $95bf3ff157aabe2b$var$_23n);
        p += 4;
    }
    while(p < u8asize)h64 = $95bf3ff157aabe2b$var$U64 & $95bf3ff157aabe2b$var$P64_1 * $95bf3ff157aabe2b$var$rotl(h64 ^ $95bf3ff157aabe2b$var$P64_5 * (0, $1a9b914c03c95c37$export$2eb24fc24c69cb4d)(u8a[p++]), $95bf3ff157aabe2b$var$_11n);
    h64 = $95bf3ff157aabe2b$var$U64 & $95bf3ff157aabe2b$var$P64_2 * (h64 ^ h64 >> $95bf3ff157aabe2b$var$_33n);
    h64 = $95bf3ff157aabe2b$var$U64 & $95bf3ff157aabe2b$var$P64_3 * (h64 ^ h64 >> $95bf3ff157aabe2b$var$_29n);
    h64 = $95bf3ff157aabe2b$var$U64 & (h64 ^ h64 >> $95bf3ff157aabe2b$var$_32n);
    const result = new Uint8Array(8);
    for(let i = 7; i >= 0; i--){
        result[i] = Number(h64 % $95bf3ff157aabe2b$var$_256n);
        h64 = h64 / $95bf3ff157aabe2b$var$_256n;
    }
    return result;
}


function $b82038eb13c2852a$export$1d328d249374c3bb(data, bitLength = 64, onlyJs) {
    const rounds = Math.ceil(bitLength / 64);
    const u8a = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(data);
    if (!(0, $6574c8753d85e60c$export$c50f41259082745b) || !onlyJs && (0, $796b0ff58a262a5f$export$af3c031fde264cc6)()) return (0, $796b0ff58a262a5f$export$efade200b728510d)(u8a, rounds);
    const result = new Uint8Array(rounds * 8);
    for(let seed = 0; seed < rounds; seed++)result.set((0, $95bf3ff157aabe2b$export$6f9f586567871a11)(u8a, seed).reverse(), seed * 8);
    return result;
}
const $b82038eb13c2852a$export$3afdca9a37e22e2 = /*#__PURE__*/ (0, $84be3e8f12e6d11c$export$6e489b4cfdd62721)($b82038eb13c2852a$export$1d328d249374c3bb);





const $49e519773807d596$var$DEFAULT_FN = (data)=>(0, $b82038eb13c2852a$export$1d328d249374c3bb)(data, 128);
const $49e519773807d596$var$HASHERS = {
    Blake2_128: (data)=>(0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)(data, 128),
    Blake2_128Concat: (data)=>(0, $84207d7313fd2c40$export$7b640c40d4922c2e)((0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)(data, 128), (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(data)),
    Blake2_256: (data)=>(0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)(data, 256),
    Identity: (data)=>(0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(data),
    Twox128: (data)=>(0, $b82038eb13c2852a$export$1d328d249374c3bb)(data, 128),
    Twox256: (data)=>(0, $b82038eb13c2852a$export$1d328d249374c3bb)(data, 256),
    Twox64Concat: (data)=>(0, $84207d7313fd2c40$export$7b640c40d4922c2e)((0, $b82038eb13c2852a$export$1d328d249374c3bb)(data, 64), (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(data))
};
function $49e519773807d596$export$a086b98481a8dc90(hasher) {
    return $49e519773807d596$var$HASHERS[hasher.type] || $49e519773807d596$var$DEFAULT_FN;
}


const $bc0d9169152f10f4$export$4c0055667bf39121 = {
    args: [],
    hashers: [],
    keys: []
};
/** @internal */ function $bc0d9169152f10f4$var$filterDefined(a) {
    return !(0, $09d5dc0a6a4c347b$export$fce6876652108ab)(a);
}
/** @internal */ function $bc0d9169152f10f4$var$assertArgs({ method: method, section: section }, { args: args, keys: keys }) {
    if (!Array.isArray(args)) throw new Error(`Call to ${(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(section || "unknown")}.${(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(method || "unknown")} needs ${keys.length} arguments`);
    else if (args.filter($bc0d9169152f10f4$var$filterDefined).length !== keys.length) throw new Error(`Call to ${(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(section || "unknown")}.${(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(method || "unknown")} needs ${keys.length} arguments, found [${args.join(", ")}]`);
}
function $bc0d9169152f10f4$export$e12e6d5852051360(registry, itemFn, { args: args, hashers: hashers, keys: keys }) {
    const count = keys.length;
    const extra = new Array(count);
    for(let i = 0; i < count; i++)extra[i] = (0, $49e519773807d596$export$a086b98481a8dc90)(hashers[i])(registry.createTypeUnsafe(registry.createLookupType(keys[i]), [
        args[i]
    ]).toU8a());
    return [
        [
            (0, $b82038eb13c2852a$export$1d328d249374c3bb)(itemFn.prefix, 128),
            (0, $b82038eb13c2852a$export$1d328d249374c3bb)(itemFn.method, 128)
        ],
        extra
    ];
}
function $bc0d9169152f10f4$export$1ae71e4c89f08f68(registry, itemFn, args) {
    $bc0d9169152f10f4$var$assertArgs(itemFn, args);
    const { meta: meta } = itemFn;
    const [prefix, extra] = $bc0d9169152f10f4$export$e12e6d5852051360(registry, itemFn, args);
    let types = [];
    if (meta.type.isMap) {
        const { hashers: hashers, key: key } = meta.type.asMap;
        types = hashers.length === 1 ? [
            `${hashers[0].type}(${(0, $2a5439f14937909c$export$73d7a99faf161633)(registry.lookup, key)})`
        ] : registry.lookup.getSiType(key).def.asTuple.map((k, i)=>`${hashers[i].type}(${(0, $2a5439f14937909c$export$73d7a99faf161633)(registry.lookup, k)})`);
    }
    const names = [
        "module",
        "method"
    ].concat(...args.args.map((_, i)=>types[i]));
    return {
        inner: prefix.concat(...extra).map((v, i)=>({
                name: names[i],
                outer: [
                    v
                ]
            }))
    };
}
function $bc0d9169152f10f4$export$e7281d3ffa2d5267(registry, itemFn, args) {
    const [prefix, extra] = $bc0d9169152f10f4$export$e12e6d5852051360(registry, itemFn, args);
    return (0, $84207d7313fd2c40$export$7b640c40d4922c2e)(...prefix, ...extra);
}
/** @internal */ function $bc0d9169152f10f4$var$createKey(registry, itemFn, args) {
    $bc0d9169152f10f4$var$assertArgs(itemFn, args);
    // always add the length prefix (underlying it is Bytes)
    return (0, $7c076f10c5650efd$export$54cb8b08f590bc42)($bc0d9169152f10f4$export$e7281d3ffa2d5267(registry, itemFn, args));
}
/** @internal */ function $bc0d9169152f10f4$var$createStorageInspect(registry, itemFn, options) {
    const { meta: { type: type } } = itemFn;
    return (...args)=>{
        if (type.isPlain) return options.skipHashing ? {
            inner: [],
            name: "wellKnown",
            outer: [
                (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(options.key)
            ]
        } : $bc0d9169152f10f4$export$1ae71e4c89f08f68(registry, itemFn, $bc0d9169152f10f4$export$4c0055667bf39121);
        const { hashers: hashers, key: key } = type.asMap;
        return hashers.length === 1 ? $bc0d9169152f10f4$export$1ae71e4c89f08f68(registry, itemFn, {
            args: args,
            hashers: hashers,
            keys: [
                key
            ]
        }) : $bc0d9169152f10f4$export$1ae71e4c89f08f68(registry, itemFn, {
            args: args,
            hashers: hashers,
            keys: registry.lookup.getSiType(key).def.asTuple
        });
    };
}
/** @internal */ function $bc0d9169152f10f4$var$createStorageFn(registry, itemFn, options) {
    const { meta: { type: type } } = itemFn;
    let cacheKey = null;
    // Can only have zero or one argument:
    //   - storage.system.account(address)
    //   - storage.timestamp.blockPeriod()
    // For higher-map queries the params are passed in as an tuple, [key1, key2]
    return (...args)=>{
        if (type.isPlain) {
            if (!cacheKey) cacheKey = options.skipHashing ? (0, $7c076f10c5650efd$export$54cb8b08f590bc42)((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(options.key)) : $bc0d9169152f10f4$var$createKey(registry, itemFn, $bc0d9169152f10f4$export$4c0055667bf39121);
            return cacheKey;
        }
        const { hashers: hashers, key: key } = type.asMap;
        return hashers.length === 1 ? $bc0d9169152f10f4$var$createKey(registry, itemFn, {
            args: args,
            hashers: hashers,
            keys: [
                key
            ]
        }) : $bc0d9169152f10f4$var$createKey(registry, itemFn, {
            args: args,
            hashers: hashers,
            keys: registry.lookup.getSiType(key).def.asTuple
        });
    };
}
/** @internal */ function $bc0d9169152f10f4$var$createWithMeta(registry, itemFn, options) {
    const { meta: meta, method: method, prefix: prefix, section: section } = itemFn;
    const storageFn = $bc0d9169152f10f4$var$createStorageFn(registry, itemFn, options);
    storageFn.inspect = $bc0d9169152f10f4$var$createStorageInspect(registry, itemFn, options);
    storageFn.meta = meta;
    storageFn.method = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(method);
    storageFn.prefix = prefix;
    storageFn.section = section;
    // explicitly add the actual method in the toJSON, this gets used to determine caching and without it
    // instances (e.g. collective) will not work since it is only matched on param meta
    storageFn.toJSON = ()=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            storage: {
                method: method,
                prefix: prefix,
                section: section
            }
        }, meta.toJSON());
    return storageFn;
}
/** @internal */ function $bc0d9169152f10f4$var$extendHeadMeta(registry, { meta: { docs: docs, name: name, type: type }, section: section }, { method: method }, iterFn) {
    // metadata with a fallback value using the type of the key, the normal
    // meta fallback only applies to actual entry values, create one for head
    const meta = registry.createTypeUnsafe("StorageEntryMetadataLatest", [
        {
            docs: docs,
            fallback: registry.createTypeUnsafe("Bytes", []),
            modifier: registry.createTypeUnsafe("StorageEntryModifierLatest", [
                1
            ]),
            name: name,
            type: registry.createTypeUnsafe("StorageEntryTypeLatest", [
                type.asMap.key,
                0
            ])
        }
    ]);
    iterFn.meta = meta;
    const fn = (...args)=>registry.createTypeUnsafe("StorageKey", [
            iterFn(...args),
            {
                method: method,
                section: section
            }
        ]);
    fn.meta = meta;
    return fn;
}
/** @internal */ function $bc0d9169152f10f4$var$extendPrefixedMap(registry, itemFn, storageFn) {
    const { meta: { type: type }, method: method, section: section } = itemFn;
    storageFn.iterKey = $bc0d9169152f10f4$var$extendHeadMeta(registry, itemFn, storageFn, (...args)=>{
        if (args.length && (type.isPlain || args.length >= type.asMap.hashers.length)) throw new Error(`Iteration of ${(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(section || "unknown")}.${(0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(method || "unknown")} needs arguments to be at least one less than the full arguments, found [${args.join(", ")}]`);
        if (args.length) {
            if (type.isMap) {
                const { hashers: hashers, key: key } = type.asMap;
                const keysVec = hashers.length === 1 ? [
                    key
                ] : registry.lookup.getSiType(key).def.asTuple;
                return new (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94)(registry, $bc0d9169152f10f4$export$e7281d3ffa2d5267(registry, itemFn, {
                    args: args,
                    hashers: hashers.slice(0, args.length),
                    keys: keysVec.slice(0, args.length)
                }));
            }
        }
        return new (0, $d0fc201459fab5e6$export$6f88fe47d32c9c94)(registry, $bc0d9169152f10f4$export$e7281d3ffa2d5267(registry, itemFn, $bc0d9169152f10f4$export$4c0055667bf39121));
    });
    return storageFn;
}
function $bc0d9169152f10f4$export$74ab6113d805deb(registry, itemFn, options) {
    const { meta: { type: type } } = itemFn;
    const storageFn = $bc0d9169152f10f4$var$createWithMeta(registry, itemFn, options);
    if (type.isMap) $bc0d9169152f10f4$var$extendPrefixedMap(registry, itemFn, storageFn);
    storageFn.keyPrefix = (...args)=>storageFn.iterKey && storageFn.iterKey(...args) || (0, $871e028f2f4a4d6f$export$cec2d66edc517cdd)(storageFn())[1];
    return storageFn;
}



function $dd289e2e4854980d$var$findSiPrimitive(registry, _prim) {
    const prim = _prim.toLowerCase();
    return registry.lookup.types.find((t)=>t.type.def.isPrimitive && t.type.def.asPrimitive.toString().toLowerCase() === prim || t.type.def.isHistoricMetaCompat && t.type.def.asHistoricMetaCompat.toString().toLowerCase() === prim);
}
function $dd289e2e4854980d$var$findSiType(registry, orig) {
    let portable = $dd289e2e4854980d$var$findSiPrimitive(registry, orig);
    if (!portable && orig === "Bytes") {
        const u8 = $dd289e2e4854980d$var$findSiPrimitive(registry, "u8");
        if (u8) portable = registry.lookup.types.find((t)=>t.type.def.isSequence && t.type.def.asSequence.type.eq(u8.id) || t.type.def.isHistoricMetaCompat && t.type.def.asHistoricMetaCompat.eq(orig));
    }
    if (!portable) console.warn(`Unable to map ${orig} to a lookup index`);
    return portable;
}
function $dd289e2e4854980d$export$7988a07c244a738({ method: method, prefix: prefix, section: section }, key, { docs: docs, type: type }) {
    return (registry)=>(0, $bc0d9169152f10f4$export$74ab6113d805deb)(registry, {
            meta: registry.createTypeUnsafe("StorageEntryMetadataLatest", [
                {
                    docs: registry.createTypeUnsafe("Vec<Text>", [
                        [
                            docs
                        ]
                    ]),
                    modifier: registry.createTypeUnsafe("StorageEntryModifierLatest", [
                        "Required"
                    ]),
                    name: registry.createTypeUnsafe("Text", [
                        method
                    ]),
                    toJSON: ()=>key,
                    type: registry.createTypeUnsafe("StorageEntryTypeLatest", [
                        {
                            Plain: $dd289e2e4854980d$var$findSiType(registry, type)?.id || 0
                        }
                    ])
                }
            ]),
            method: method,
            prefix: prefix,
            section: section
        }, {
            key: key,
            skipHashing: true
        });
}


const $f21d76ec4c35d046$var$prefix = "Substrate";
const $f21d76ec4c35d046$var$section = "substrate";
function $f21d76ec4c35d046$var$createSubstrateFn(method, key, meta) {
    return (0, $dd289e2e4854980d$export$7988a07c244a738)({
        method: method,
        prefix: $f21d76ec4c35d046$var$prefix,
        section: $f21d76ec4c35d046$var$section
    }, key, meta);
}
const $f21d76ec4c35d046$export$a289ad6c54e4c830 = {
    changesTrieConfig: $f21d76ec4c35d046$var$createSubstrateFn("changesTrieConfig", ":changes_trie", {
        docs: "Changes trie configuration is stored under this key.",
        type: "u32"
    }),
    childStorageKeyPrefix: $f21d76ec4c35d046$var$createSubstrateFn("childStorageKeyPrefix", ":child_storage:", {
        docs: "Prefix of child storage keys.",
        type: "u32"
    }),
    code: $f21d76ec4c35d046$var$createSubstrateFn("code", ":code", {
        docs: "Wasm code of the runtime.",
        type: "Bytes"
    }),
    extrinsicIndex: $f21d76ec4c35d046$var$createSubstrateFn("extrinsicIndex", ":extrinsic_index", {
        docs: "Current extrinsic index (u32) is stored under this key.",
        type: "u32"
    }),
    heapPages: $f21d76ec4c35d046$var$createSubstrateFn("heapPages", ":heappages", {
        docs: "Number of wasm linear memory pages required for execution of the runtime.",
        type: "u64"
    })
};


function $455a1debbaf59966$export$fbd9b57a66480737(registry) {
    const storage = {};
    const entries = Object.entries((0, $f21d76ec4c35d046$export$a289ad6c54e4c830));
    for(let e = 0, count = entries.length; e < count; e++)storage[entries[e][0]] = entries[e][1](registry);
    return {
        substrate: storage
    };
}



const $cbbec3e158834a4e$var$VERSION_NAME = "palletVersion";
const $cbbec3e158834a4e$var$VERSION_KEY = ":__STORAGE_VERSION__:";
const $cbbec3e158834a4e$var$VERSION_DOCS = {
    docs: "Returns the current pallet version from storage",
    type: "u16"
};
function $cbbec3e158834a4e$export$79f9bdc360a1a21(registry, { pallets: pallets }, _metaVersion) {
    const result = (0, $455a1debbaf59966$export$fbd9b57a66480737)(registry);
    for(let i = 0, count = pallets.length; i < count; i++){
        const { name: name, storage: storage } = pallets[i];
        if (storage.isSome) {
            const section = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name);
            const { items: items, prefix: _prefix } = storage.unwrap();
            const prefix = _prefix.toString();
            (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, section, ()=>(0, $bad025b936daa7ef$export$d3fc7341b317ef1a)({
                    palletVersion: (0, $dd289e2e4854980d$export$7988a07c244a738)({
                        method: $cbbec3e158834a4e$var$VERSION_NAME,
                        prefix: prefix,
                        section: section
                    }, (0, $bc0d9169152f10f4$export$e7281d3ffa2d5267)(registry, {
                        method: $cbbec3e158834a4e$var$VERSION_KEY,
                        prefix: name.toString()
                    }, (0, $bc0d9169152f10f4$export$4c0055667bf39121)), $cbbec3e158834a4e$var$VERSION_DOCS)(registry)
                }, items, (meta)=>(0, $bc0d9169152f10f4$export$74ab6113d805deb)(registry, {
                        meta: meta,
                        method: meta.name.toString(),
                        prefix: prefix,
                        section: section
                    }, {}), (0, $ed675231db5fe830$export$a4f9bcfa07da06f6)));
        }
    }
    return result;
}


function $43a9183d9a542fa6$export$fcc096e8dd32d10e(registry, metadata) {
    if (!(metadata instanceof (0, $918d2e4dba59a611$export$e7adebdc1ebd2fed))) throw new Error("You need to pass a valid Metadata instance to Decorated");
    const latest = metadata.asLatest;
    const version = metadata.version;
    return {
        consts: (0, $6fd24ae59e9f7c74$export$bce56c4ffddeedc8)(registry, latest, version),
        errors: (0, $0ea9d26610fb372d$export$90951a2c9c83170)(registry, latest, version),
        events: (0, $2afce0de1332c32b$export$f8376c3696189eda)(registry, latest, version),
        query: (0, $cbbec3e158834a4e$export$79f9bdc360a1a21)(registry, latest, version),
        registry: registry,
        tx: (0, $bff1a500fdc7f076$export$5d63c876c2db8f77)(registry, latest, version)
    };
}






const $93449a5ef27edd4d$var$stringIdentity = (value)=>value.toString();
const $93449a5ef27edd4d$var$INFO_WRAP = [
    "BTreeMap",
    "BTreeSet",
    "Compact",
    "HashMap",
    "Option",
    "Result",
    "Vec"
];
function $93449a5ef27edd4d$export$ce04017ff5df6221(outer, inner, transform = $93449a5ef27edd4d$var$stringIdentity) {
    return `${outer}${inner ? `<${(Array.isArray(inner) ? inner : [
        inner
    ]).map(transform).join(", ")}>` : ""}`;
}
function $93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, outer) {
    const { info: info, sub: sub } = typeDef;
    switch(info){
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeMap:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeSet:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Compact:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).HashMap:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Linkage:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Option:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Range:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).RangeInclusive:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Result:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Vec:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperKeepOpaque:
        case (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque:
            return $93449a5ef27edd4d$export$ce04017ff5df6221(outer, sub, (p)=>$93449a5ef27edd4d$export$c949ea293f1d6bc5(registry, p));
    }
    throw new Error(`Unable to encode ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(typeDef)} with params`);
}
function $93449a5ef27edd4d$var$encodeSubTypes(registry, sub, asEnum, extra) {
    const names = sub.map(({ name: name })=>name);
    if (!names.every((n)=>!!n)) throw new Error(`Subtypes does not have consistent names, ${names.join(", ")}`);
    const inner = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, extra);
    for(let i = 0, count = sub.length; i < count; i++){
        const def = sub[i];
        inner[def.name] = $93449a5ef27edd4d$export$c949ea293f1d6bc5(registry, def);
    }
    return (0, $e2c4db534325025c$export$fac44ee5b035f737)(asEnum ? {
        _enum: inner
    } : inner);
}
const $93449a5ef27edd4d$var$encoders = {
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeMap]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "BTreeMap"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeSet]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "BTreeSet"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Compact]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "Compact"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).DoNotConstruct]: (registry, { displayName: displayName, lookupIndex: lookupIndex, lookupName: lookupName })=>`DoNotConstruct<${lookupName || displayName || ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(lookupIndex) ? "Unknown" : registry.createLookupType(lookupIndex))}>`,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Enum]: (registry, { sub: sub })=>{
        if (!Array.isArray(sub)) throw new Error("Unable to encode Enum type");
        // c-like enums have all Null entries
        // TODO We need to take the disciminant into account and auto-add empty entries
        return sub.every(({ type: type })=>type === "Null") ? (0, $e2c4db534325025c$export$fac44ee5b035f737)({
            _enum: sub.map(({ name: name }, index)=>`${name || `Empty${index}`}`)
        }) : $93449a5ef27edd4d$var$encodeSubTypes(registry, sub, true);
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).HashMap]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "HashMap"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Int]: (_registry, { length: length = 32 })=>`Int<${length}>`,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Linkage]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "Linkage"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null]: (_registry, _typeDef)=>"Null",
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Option]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "Option"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain]: (_registry, { displayName: displayName, type: type })=>displayName || type,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Range]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "Range"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).RangeInclusive]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "RangeInclusive"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Result]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "Result"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Set]: (_registry, { length: length = 8, sub: sub })=>{
        if (!Array.isArray(sub)) throw new Error("Unable to encode Set type");
        return (0, $e2c4db534325025c$export$fac44ee5b035f737)({
            _set: sub.reduce((all, { index: index, name: name }, count)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(all, {
                    [`${name || `Unknown${index || count}`}`]: index || count
                }), {
                _bitLength: length || 8
            })
        });
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Si]: (_registry, { lookupName: lookupName, type: type })=>lookupName || type,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Struct]: (registry, { alias: alias, sub: sub })=>{
        if (!Array.isArray(sub)) throw new Error("Unable to encode Struct type");
        return $93449a5ef27edd4d$var$encodeSubTypes(registry, sub, false, alias ? {
            _alias: [
                ...alias.entries()
            ].reduce((all, [k, v])=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(all, {
                    [k]: v
                }), {})
        } : {});
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Tuple]: (registry, { sub: sub })=>{
        if (!Array.isArray(sub)) throw new Error("Unable to encode Tuple type");
        return `(${sub.map((type)=>$93449a5ef27edd4d$export$c949ea293f1d6bc5(registry, type)).join(",")})`;
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).UInt]: (_registry, { length: length = 32 })=>`UInt<${length}>`,
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Vec]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "Vec"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).VecFixed]: (_registry, { length: length, sub: sub })=>{
        if (!(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(length) || !sub || Array.isArray(sub)) throw new Error("Unable to encode VecFixed type");
        return `[${sub.type};${length}]`;
    },
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperKeepOpaque]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "WrapperKeepOpaque"),
    [(0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque]: (registry, typeDef)=>$93449a5ef27edd4d$var$encodeWithParams(registry, typeDef, "WrapperOpaque")
};
function $93449a5ef27edd4d$var$encodeType(registry, typeDef, withLookup = true) {
    return withLookup && typeDef.lookupName ? typeDef.lookupName : $93449a5ef27edd4d$var$encoders[typeDef.info](registry, typeDef);
}
function $93449a5ef27edd4d$export$c949ea293f1d6bc5(registry, typeDef) {
    // In the case of contracts we do have the unfortunate situation where the displayName would
    // refer to "Option" when it is an option. For these, string it out, only using when actually
    // not a top-level element to be used
    return typeDef.displayName && !$93449a5ef27edd4d$var$INFO_WRAP.some((i)=>typeDef.displayName === i) ? typeDef.displayName : $93449a5ef27edd4d$var$encodeType(registry, typeDef);
}
function $93449a5ef27edd4d$export$93c3022a8a191f9e(registry, typeDef) {
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, typeDef, {
        type: $93449a5ef27edd4d$var$encodeType(registry, typeDef, false)
    });
}



const $1d65e77a7fae75e9$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("PortableRegistry");
const $1d65e77a7fae75e9$var$TYPE_UNWRAP = {
    toNumber: ()=>-1
};
const $1d65e77a7fae75e9$var$PRIMITIVE_ALIAS = {
    Char: "u32",
    Str: "Text"
};
const $1d65e77a7fae75e9$var$PATHS_ALIAS = $1d65e77a7fae75e9$var$splitNamespace([
    // full matching on exact names...
    // these are well-known types with additional encoding
    "sp_core::crypto::AccountId32",
    "sp_runtime::generic::era::Era",
    "sp_runtime::multiaddress::MultiAddress",
    // ethereum overrides (Frontier, Moonbeam, Polkadot claims)
    "fp_account::AccountId20",
    "account::AccountId20",
    "polkadot_runtime_common::claims::EthereumAddress",
    // weights 2 is a structure, however for 1.5. with a single field it
    // should be flatenned (can appear in Compact<Weight> extrinsics)
    "frame_support::weights::weight_v2::Weight",
    "sp_weights::weight_v2::Weight",
    // wildcard matching in place...
    // these have a specific encoding or logic, use a wildcard for {pallet, darwinia}_democracy
    "*_democracy::vote::Vote",
    "*_conviction_voting::vote::Vote",
    "*_identity::types::Data",
    // these are opaque Vec<u8> wrappers
    "sp_core::OpaqueMetadata",
    "sp_core::OpaquePeerId",
    "sp_core::offchain::OpaqueMultiaddr",
    // shorten some well-known types
    "primitive_types::*",
    "sp_arithmetic::per_things::*",
    // runtime
    "*_runtime::RuntimeCall",
    "*_runtime::RuntimeEvent",
    // ink!
    "ink::env::types::*",
    "ink::primitives::types::*",
    "ink_env::types::*",
    "ink_primitives::types::*"
]);
const $1d65e77a7fae75e9$var$PATHS_SET = $1d65e77a7fae75e9$var$splitNamespace([
    "pallet_identity::types::BitFlags"
]);
const $1d65e77a7fae75e9$var$BITVEC_NS_LSB = [
    "bitvec::order::Lsb0",
    "BitOrderLsb0"
];
const $1d65e77a7fae75e9$var$BITVEC_NS_MSB = [
    "bitvec::order::Msb0",
    "BitOrderMsb0"
];
const $1d65e77a7fae75e9$var$BITVEC_NS = [
    ...$1d65e77a7fae75e9$var$BITVEC_NS_LSB,
    ...$1d65e77a7fae75e9$var$BITVEC_NS_MSB
];
const $1d65e77a7fae75e9$var$WRAPPERS = [
    "BoundedBTreeMap",
    "BoundedBTreeSet",
    "BoundedVec",
    "Box",
    "BTreeMap",
    "BTreeSet",
    "Cow",
    "Option",
    "Range",
    "RangeInclusive",
    "Result",
    "WeakBoundedVec",
    "WrapperKeepOpaque",
    "WrapperOpaque"
];
const $1d65e77a7fae75e9$var$RESERVED = [
    // JS reserved words
    "entries",
    "keys",
    "new",
    "size",
    // exposed by all Codec objects
    "hash",
    "registry"
];
const $1d65e77a7fae75e9$var$PATH_RM_INDEX_1 = [
    "generic",
    "misc",
    "pallet",
    "traits",
    "types"
];
/** @internal Converts a Text[] into string[] (used as part of definitions) */ function $1d65e77a7fae75e9$var$sanitizeDocs(docs) {
    const count = docs.length;
    const result = new Array(count);
    for(let i = 0; i < count; i++)result[i] = docs[i].toString();
    return result;
}
/** @internal Split a namespace with :: into individual parts */ function $1d65e77a7fae75e9$var$splitNamespace(values) {
    const count = values.length;
    const result = new Array(count);
    for(let i = 0; i < count; i++)result[i] = values[i].split("::");
    return result;
}
/** @internal Match a namespace based on parts (alongside wildcards) */ function $1d65e77a7fae75e9$var$matchParts(first, second) {
    return first.length === second.length && first.every((a, index)=>{
        const b = second[index].toString();
        if (a === "*" || a === b) return true;
        if (a.includes("*") && a.includes("_") && b.includes("_")) {
            let suba = a.split("_");
            let subb = b.split("_");
            // match initial *'s to multiples if we have a match for the other
            if (suba[0] === "*") {
                const indexOf = subb.indexOf(suba[1]);
                if (indexOf !== -1) {
                    suba = suba.slice(1);
                    subb = subb.slice(indexOf);
                }
            }
            // check for * matches at the end, adjust accordingly
            if (suba.length === 2 && suba[1] === "*" && suba[0] === subb[0]) return true;
            return $1d65e77a7fae75e9$var$matchParts(suba, subb);
        }
        return false;
    });
}
/** @internal check if the path matches the PATHS_ALIAS (with wildcards) */ function $1d65e77a7fae75e9$var$getAliasPath({ def: def, path: path }) {
    // specific logic for weights - we override when non-complex struct
    // (as applied in Weight 1.5 where we also have `Compact<{ refTime: u64 }>)
    if ([
        "frame_support::weights::weight_v2::Weight",
        "sp_weights::weight_v2::Weight"
    ].includes(path.join("::"))) return !def.isComposite || def.asComposite.fields.length === 1 ? "WeightV1" : null;
    // TODO We need to handle ink! Balance in some way
    return path.length && $1d65e77a7fae75e9$var$PATHS_ALIAS.some((a)=>$1d65e77a7fae75e9$var$matchParts(a, path)) ? path[path.length - 1].toString() : null;
}
/** @internal Converts a type name into a JS-API compatible name */ function $1d65e77a7fae75e9$var$extractNameFlat(portable, lookupIndex, params, path, isInternal = false) {
    const count = path.length;
    // if we have no path or determined as a wrapper, we just skip it
    if (count === 0 || $1d65e77a7fae75e9$var$WRAPPERS.includes(path[count - 1].toString())) return null;
    const camels = new Array(count);
    const lowers = new Array(count);
    // initially just create arrays of the camelCase and lowercase path
    // parts - we will check these to extract the final values. While
    // we have 2 loops here, we also don't do the same operation twice
    for(let i = 0; i < count; i++){
        const c = (0, $4db46be060f888b6$export$733fa19993fe16bc)(isInternal ? path[i].replace("pallet_", "") : path[i]);
        const l = c.toLowerCase();
        camels[i] = c;
        lowers[i] = l;
    }
    let name = "";
    for(let i = 0; i < count; i++){
        const l = lowers[i];
        // Remove ::{generic, misc, pallet, traits, types}::
        if (i !== 1 || !$1d65e77a7fae75e9$var$PATH_RM_INDEX_1.includes(l)) // sp_runtime::generic::digest::Digest -> sp_runtime::generic::Digest
        // sp_runtime::multiaddress::MultiAddress -> sp_runtime::MultiAddress
        {
            if (l !== lowers[i + 1]) name += camels[i];
        }
    }
    // do magic for RawOrigin lookup, e.g. pallet_collective::RawOrigin
    if (camels[1] === "RawOrigin" && count === 2 && params.length === 2 && params[1].type.isSome) {
        const instanceType = portable[params[1].type.unwrap().toNumber()];
        if (instanceType.type.path.length === 2) name = `${name}${instanceType.type.path[1].toString()}`;
    }
    return {
        lookupIndex: lookupIndex,
        name: name,
        params: params
    };
}
/** @internal Alias for extractNameFlat with PortableType as a last parameter */ function $1d65e77a7fae75e9$var$extractName(portable, lookupIndex, { type: { params: params, path: path } }) {
    return $1d65e77a7fae75e9$var$extractNameFlat(portable, lookupIndex, params, path);
}
/** @internal Check for dupes from a specific index onwards */ function $1d65e77a7fae75e9$var$nextDupeMatches(name, startAt, names) {
    const result = [
        names[startAt]
    ];
    for(let i = startAt + 1, count = names.length; i < count; i++){
        const v = names[i];
        if (v.name === name) result.push(v);
    }
    return result;
}
/** @internal Checks to see if a type is a full duplicate (with all params matching) */ function $1d65e77a7fae75e9$var$rewriteDupes(input, rewrite) {
    const count = input.length;
    for(let i = 0; i < count; i++){
        const a = input[i];
        for(let j = i + 1; j < count; j++){
            const b = input[j];
            // if the indexes are not the same and the names match, we have a dupe
            if (a.lookupIndex !== b.lookupIndex && a.name === b.name) return false;
        }
    }
    // add all the adjusted values to the rewite map
    for(let i = 0; i < count; i++){
        const p = input[i];
        rewrite[p.lookupIndex] = p.name;
    }
    return true;
}
/** @internal Find duplicates and adjust the names based on parameters */ function $1d65e77a7fae75e9$var$removeDupeNames(lookup, portable, names) {
    const rewrite = {};
    return names.map((original, startAt)=>{
        const { lookupIndex: lookupIndex, name: name, params: params } = original;
        if (!name) // the name is empty (this is not expected, but have a failsafe)
        return null;
        else if (rewrite[lookupIndex]) // we have already rewritten this one, we can skip it
        return original;
        // those where the name is matching starting from this index
        const allSame = $1d65e77a7fae75e9$var$nextDupeMatches(name, startAt, names);
        // we only have one, so all ok
        if (allSame.length === 1) return original;
        // are there param differences between matching names
        const anyDiff = allSame.some((o)=>params.length !== o.params.length || params.some((p, index)=>!p.name.eq(o.params[index].name) || p.type.unwrapOr($1d65e77a7fae75e9$var$TYPE_UNWRAP).toNumber() !== o.params[index].type.unwrapOr($1d65e77a7fae75e9$var$TYPE_UNWRAP).toNumber()));
        // everything matches, we can combine these
        if (!anyDiff) return original;
        // TODO We probably want to attach all the indexes with differences,
        // not just the first
        // find the first parameter that yields differences
        const paramIdx = params.findIndex(({ type: type }, index)=>allSame.every(({ params: params }, aIndex)=>params[index].type.isSome && (aIndex === 0 || !params[index].type.eq(type))));
        // No param found that is different
        if (paramIdx === -1) return original;
        // see if using the param type helps
        const sameCount = allSame.length;
        const adjusted = new Array(sameCount);
        // loop through all, specifically checking that index where the
        // first param yields differences
        for(let i = 0; i < sameCount; i++){
            const { lookupIndex: lookupIndex, name: name, params: params } = allSame[i];
            const { def: def, path: path } = lookup.getSiType(params[paramIdx].type.unwrap());
            // if it is not a primitive and it doesn't have a path, we really cannot
            // do anything at this point
            if (!def.isPrimitive && !path.length) return null;
            adjusted[i] = {
                lookupIndex: lookupIndex,
                name: def.isPrimitive ? `${name}${def.asPrimitive.toString()}` : `${name}${path[path.length - 1].toString()}`
            };
        }
        // check to see if the adjusted names have no issues
        if ($1d65e77a7fae75e9$var$rewriteDupes(adjusted, rewrite)) return original;
        // TODO This is duplicated from the section just above...
        // ... we certainly need a better solution here
        //
        // Last-ditch effort to use the full type path - ugly
        // loop through all, specifically checking that index where the
        // first param yields differences
        for(let i = 0; i < sameCount; i++){
            const { lookupIndex: lookupIndex, name: name, params: params } = allSame[i];
            const { def: def, path: path } = lookup.getSiType(params[paramIdx].type.unwrap());
            const flat = $1d65e77a7fae75e9$var$extractNameFlat(portable, lookupIndex, params, path, true);
            if (def.isPrimitive || !flat) return null;
            adjusted[i] = {
                lookupIndex: lookupIndex,
                name: `${name}${flat.name}`
            };
        }
        // check to see if the adjusted names have no issues
        if ($1d65e77a7fae75e9$var$rewriteDupes(adjusted, rewrite)) return original;
        return null;
    }).filter((n)=>!!n).map(({ lookupIndex: lookupIndex, name: name, params: params })=>({
            lookupIndex: lookupIndex,
            name: rewrite[lookupIndex] || name,
            params: params
        }));
}
/** @internal Detect on-chain types (AccountId/Signature) as set as the default */ function $1d65e77a7fae75e9$var$registerTypes(lookup, lookups, names, params) {
    // Register the types we extracted
    lookup.registry.register(lookups);
    // Try and extract the AccountId/Address/Signature type from UncheckedExtrinsic
    if (params.SpRuntimeUncheckedExtrinsic) {
        // Address, Call, Signature, Extra
        const [addrParam, , sigParam] = params.SpRuntimeUncheckedExtrinsic;
        const siAddress = lookup.getSiType(addrParam.type.unwrap());
        const siSignature = lookup.getSiType(sigParam.type.unwrap());
        const nsSignature = siSignature.path.join("::");
        let nsAccountId = siAddress.path.join("::");
        const isMultiAddress = nsAccountId === "sp_runtime::multiaddress::MultiAddress";
        // With multiaddress, we check the first type param again
        if (isMultiAddress) {
            // AccountId, AccountIndex
            const [idParam] = siAddress.params;
            nsAccountId = lookup.getSiType(idParam.type.unwrap()).path.join("::");
        }
        lookup.registry.register({
            // known: account::AccountId20, fp_account::AccountId20, primitive_types::H160
            AccountId: nsAccountId.endsWith("::AccountId20") || nsAccountId.endsWith("::H160") ? "AccountId20" : "AccountId32",
            Address: isMultiAddress ? "MultiAddress" : "AccountId",
            ExtrinsicSignature: [
                "sp_runtime::MultiSignature"
            ].includes(nsSignature) ? "MultiSignature" : names[sigParam.type.unwrap().toNumber()] || "MultiSignature"
        });
    }
}
/**
 * @internal Extracts aliases based on what we know the runtime config looks like in a
 * Substrate chain. Specifically we want to have access to the Call and Event params
 **/ function $1d65e77a7fae75e9$var$extractAliases(params, isContract) {
    const hasParams = Object.keys(params).some((k)=>!k.startsWith("Pallet"));
    const alias = {};
    if (params.SpRuntimeUncheckedExtrinsic) {
        // Address, Call, Signature, Extra
        const [, { type: type }] = params.SpRuntimeUncheckedExtrinsic;
        alias[type.unwrap().toNumber()] = "Call";
    } else if (hasParams && !isContract) $1d65e77a7fae75e9$var$l.warn("Unable to determine runtime Call type, cannot inspect sp_runtime::generic::unchecked_extrinsic::UncheckedExtrinsic");
    if (params.FrameSystemEventRecord) {
        // Event, Topic
        const [{ type: type }] = params.FrameSystemEventRecord;
        alias[type.unwrap().toNumber()] = "Event";
    } else if (hasParams && !isContract) $1d65e77a7fae75e9$var$l.warn("Unable to determine runtime Event type, cannot inspect frame_system::EventRecord");
    return alias;
}
/** @internal Extracts all the intreresting type information for this registry */ function $1d65e77a7fae75e9$var$extractTypeInfo(lookup, portable) {
    const nameInfo = [];
    const types = {};
    for(let i = 0, count = portable.length; i < count; i++){
        const type = portable[i];
        const lookupIndex = type.id.toNumber();
        const extracted = $1d65e77a7fae75e9$var$extractName(portable, lookupIndex, portable[i]);
        if (extracted) nameInfo.push(extracted);
        types[lookupIndex] = type;
    }
    const lookups = {};
    const names = {};
    const params = {};
    const dedup = $1d65e77a7fae75e9$var$removeDupeNames(lookup, portable, nameInfo);
    for(let i = 0, count = dedup.length; i < count; i++){
        const { lookupIndex: lookupIndex, name: name, params: p } = dedup[i];
        names[lookupIndex] = name;
        lookups[name] = lookup.registry.createLookupType(lookupIndex);
        params[name] = p;
    }
    return {
        lookups: lookups,
        names: names,
        params: params,
        types: types
    };
}
class $1d65e77a7fae75e9$export$a991cc4a835cd8d8 extends (0, $6552ecce3d7abdb5$export$eabc71f011df675a) {
    constructor(registry, value, isContract){
        // const timeStart = performance.now()
        super(registry, {
            types: "Vec<PortableType>"
        }, value);
        this.__internal__typeDefs = {};
        const { lookups: lookups, names: names, params: params, types: types } = $1d65e77a7fae75e9$var$extractTypeInfo(this, this.types);
        this.__internal__alias = $1d65e77a7fae75e9$var$extractAliases(params, isContract);
        this.__internal__lookups = lookups;
        this.__internal__names = names;
        this.__internal__params = params;
        this.__internal__types = types;
    // console.log('PortableRegistry', `${(performance.now() - timeStart).toFixed(2)}ms`)
    }
    /**
     * @description Returns all the available type names for this chain
     **/ get names() {
        return Object.values(this.__internal__names).sort();
    }
    /**
     * @description The types of the registry
     */ get types() {
        return this.getT("types");
    }
    /**
     * @description Register all available types into the registry (generally for internal usage)
     */ register() {
        $1d65e77a7fae75e9$var$registerTypes(this, this.__internal__lookups, this.__internal__names, this.__internal__params);
    }
    /**
     * @description Returns the name for a specific lookup
     */ getName(lookupId) {
        return this.__internal__names[this.__internal__getLookupId(lookupId)];
    }
    /**
     * @description Finds a specific type in the registry
     */ getSiType(lookupId) {
        // NOTE catch-22 - this may already be used as part of the constructor, so
        // ensure that we have actually initialized it correctly
        const found = (this.__internal__types || this.types)[this.__internal__getLookupId(lookupId)];
        if (!found) throw new Error(`PortableRegistry: Unable to find type with lookupId ${lookupId.toString()}`);
        return found.type;
    }
    /**
     * @description Lookup the type definition for the index
     */ getTypeDef(lookupId) {
        const lookupIndex = this.__internal__getLookupId(lookupId);
        if (!this.__internal__typeDefs[lookupIndex]) {
            const lookupName = this.__internal__names[lookupIndex];
            const empty = {
                info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).DoNotConstruct,
                lookupIndex: lookupIndex,
                lookupName: lookupName,
                type: this.registry.createLookupType(lookupIndex)
            };
            // Set named items since we will get into circular lookups along the way
            if (lookupName) this.__internal__typeDefs[lookupIndex] = empty;
            const extracted = this.__internal__extract(this.getSiType(lookupId), lookupIndex);
            // For non-named items, we only set this right at the end
            if (!lookupName) this.__internal__typeDefs[lookupIndex] = empty;
            Object.keys(extracted).forEach((k)=>{
                if (k !== "lookupName" || extracted[k]) // these are safe since we are looking through the keys as set
                this.__internal__typeDefs[lookupIndex][k] = extracted[k];
            });
            // don't set lookupName on lower-level, we want to always direct to the type
            if (extracted.info === (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain) {
                this.__internal__typeDefs[lookupIndex].lookupNameRoot = this.__internal__typeDefs[lookupIndex].lookupName;
                delete this.__internal__typeDefs[lookupIndex].lookupName;
            }
        }
        return this.__internal__typeDefs[lookupIndex];
    }
    /**
     * @description For a specific field, perform adjustments to not have built-in conflicts
     */ sanitizeField(name) {
        let nameField = null;
        let nameOrig = null;
        if (name.isSome) {
            nameField = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name.unwrap());
            if (nameField.includes("#")) {
                nameOrig = nameField;
                nameField = nameOrig.replace(/#/g, "_");
            } else if ($1d65e77a7fae75e9$var$RESERVED.includes(nameField)) {
                nameOrig = nameField;
                nameField = `${nameField}_`;
            }
        }
        return [
            nameField,
            nameOrig
        ];
    }
    /** @internal Creates a TypeDef based on an internal lookupId */ __internal__createSiDef(lookupId) {
        const typeDef = this.getTypeDef(lookupId);
        const lookupIndex = lookupId.toNumber();
        // Setup for a lookup on complex types
        return [
            (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).DoNotConstruct,
            (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Enum,
            (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Struct
        ].includes(typeDef.info) && typeDef.lookupName ? {
            docs: typeDef.docs,
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Si,
            lookupIndex: lookupIndex,
            lookupName: this.__internal__names[lookupIndex],
            type: this.registry.createLookupType(lookupId)
        } : typeDef;
    }
    /** @internal Converts a lookupId input to the actual lookup index */ __internal__getLookupId(lookupId) {
        if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(lookupId)) {
            if (!this.registry.isLookupType(lookupId)) throw new Error(`PortableRegistry: Expected a lookup string type, found ${lookupId}`);
            return parseInt(lookupId.replace("Lookup", ""), 10);
        } else if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(lookupId)) return lookupId;
        return lookupId.toNumber();
    }
    /** @internal Converts a type into a TypeDef for Codec usage */ __internal__extract(type, lookupIndex) {
        const namespace = type.path.join("::");
        let typeDef;
        const aliasType = this.__internal__alias[lookupIndex] || $1d65e77a7fae75e9$var$getAliasPath(type);
        try {
            if (aliasType) typeDef = this.__internal__extractAliasPath(lookupIndex, aliasType);
            else switch(type.def.type){
                case "Array":
                    typeDef = this.__internal__extractArray(lookupIndex, type.def.asArray);
                    break;
                case "BitSequence":
                    typeDef = this.__internal__extractBitSequence(lookupIndex, type.def.asBitSequence);
                    break;
                case "Compact":
                    typeDef = this.__internal__extractCompact(lookupIndex, type.def.asCompact);
                    break;
                case "Composite":
                    typeDef = this.__internal__extractComposite(lookupIndex, type, type.def.asComposite);
                    break;
                case "HistoricMetaCompat":
                    typeDef = this.__internal__extractHistoric(lookupIndex, type.def.asHistoricMetaCompat);
                    break;
                case "Primitive":
                    typeDef = this.__internal__extractPrimitive(lookupIndex, type);
                    break;
                case "Sequence":
                    typeDef = this.__internal__extractSequence(lookupIndex, type.def.asSequence);
                    break;
                case "Tuple":
                    typeDef = this.__internal__extractTuple(lookupIndex, type.def.asTuple);
                    break;
                case "Variant":
                    typeDef = this.__internal__extractVariant(lookupIndex, type, type.def.asVariant);
                    break;
                default:
                    (0, $7f962568317a1d97$export$f2525c1d596f8d46)(type.def.type);
            }
        } catch (error) {
            throw new Error(`PortableRegistry: ${lookupIndex}${namespace ? ` (${namespace})` : ""}: Error extracting ${(0, $e2c4db534325025c$export$fac44ee5b035f737)(type)}: ${error.message}`);
        }
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            docs: $1d65e77a7fae75e9$var$sanitizeDocs(type.docs),
            namespace: namespace
        }, typeDef);
    }
    /** @internal Extracts a ScaleInfo Array into TypeDef.VecFixed */ __internal__extractArray(_, { len: len, type: type }) {
        const length = len.toNumber();
        if (length > 2048) throw new Error("Only support for [Type; <length>], where length <= 2048");
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).VecFixed,
            length: length,
            sub: this.__internal__createSiDef(type)
        });
    }
    /** @internal Extracts a ScaleInfo BitSequence into TypeDef.Plain */ __internal__extractBitSequence(_, { bitOrderType: bitOrderType, bitStoreType: bitStoreType }) {
        // With the v3 of scale-info this swapped around, but obviously the decoder cannot determine
        // the order. With that in-mind, we apply a detection for LSb0/Msb and set accordingly
        const a = this.__internal__createSiDef(bitOrderType);
        const b = this.__internal__createSiDef(bitStoreType);
        const [bitOrder, bitStore] = $1d65e77a7fae75e9$var$BITVEC_NS.includes(a.namespace || "") ? [
            a,
            b
        ] : [
            b,
            a
        ];
        if (!bitOrder.namespace || !$1d65e77a7fae75e9$var$BITVEC_NS.includes(bitOrder.namespace)) throw new Error(`Unexpected bitOrder found as ${bitOrder.namespace || "<unknown>"}`);
        else if (bitStore.info !== (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain || bitStore.type !== "u8") throw new Error(`Only u8 bitStore is currently supported, found ${bitStore.type}`);
        const isLsb = $1d65e77a7fae75e9$var$BITVEC_NS_LSB.includes(bitOrder.namespace);
        isLsb;
        return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            type: "BitVec"
        };
    }
    /** @internal Extracts a ScaleInfo Compact into TypeDef.Compact */ __internal__extractCompact(_, { type: type }) {
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Compact,
            sub: this.__internal__createSiDef(type)
        });
    }
    /** @internal Extracts a ScaleInfo Composite into TypeDef.{BTree*, Range*, Wrapper*} */ __internal__extractComposite(lookupIndex, { params: params, path: path }, { fields: fields }) {
        if (path.length) {
            const pathFirst = path[0].toString();
            const pathLast = path[path.length - 1].toString();
            if (path.length === 1 && pathFirst === "BTreeMap") {
                if (params.length !== 2) throw new Error(`BTreeMap requires 2 parameters, found ${params.length}`);
                return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
                    info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeMap,
                    sub: params.map(({ type: type })=>this.__internal__createSiDef(type.unwrap()))
                });
            } else if (path.length === 1 && pathFirst === "BTreeSet") {
                if (params.length !== 1) throw new Error(`BTreeSet requires 1 parameter, found ${params.length}`);
                return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
                    info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).BTreeSet,
                    sub: this.__internal__createSiDef(params[0].type.unwrap())
                });
            } else if ([
                "Range",
                "RangeInclusive"
            ].includes(pathFirst)) {
                if (params.length !== 1) throw new Error(`Range requires 1 parameter, found ${params.length}`);
                return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
                    info: pathFirst === "Range" ? (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Range : (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).RangeInclusive,
                    sub: this.__internal__createSiDef(params[0].type.unwrap()),
                    type: pathFirst
                });
            } else if ([
                "WrapperKeepOpaque",
                "WrapperOpaque"
            ].includes(pathLast)) {
                if (params.length !== 1) throw new Error(`WrapperOpaque requires 1 parameter, found ${params.length}`);
                return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
                    info: pathLast === "WrapperKeepOpaque" ? (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperKeepOpaque : (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).WrapperOpaque,
                    sub: this.__internal__createSiDef(params[0].type.unwrap()),
                    type: pathLast
                });
            }
        }
        return $1d65e77a7fae75e9$var$PATHS_SET.some((p)=>$1d65e77a7fae75e9$var$matchParts(p, path)) ? this.__internal__extractCompositeSet(lookupIndex, params, fields) : this.__internal__extractFields(lookupIndex, fields);
    }
    /** @internal Extracts a ScaleInfo CompositeSet into TypeDef.Set */ __internal__extractCompositeSet(_, params, fields) {
        if (params.length !== 1 || fields.length !== 1) throw new Error("Set handling expects param/field as single entries");
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Set,
            length: this.registry.createTypeUnsafe(this.registry.createLookupType(fields[0].type), []).bitLength(),
            sub: this.getSiType(params[0].type.unwrap()).def.asVariant.variants.map(({ index: index, name: name })=>({
                    // This will be an issue > 2^53 - 1 ... don't have those (yet)
                    index: index.toNumber(),
                    info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
                    name: name.toString(),
                    type: "Null"
                }))
        });
    }
    /** @internal Extracts ScaleInfo enum/struct fields into TypeDef.{Struct, Tuple} */ __internal__extractFields(lookupIndex, fields) {
        let isStruct = true;
        let isTuple = true;
        const count = fields.length;
        for(let f = 0; f < count; f++){
            const { name: name } = fields[f];
            isStruct = isStruct && name.isSome;
            isTuple = isTuple && name.isNone;
        }
        if (!isTuple && !isStruct) throw new Error("Invalid fields type detected, expected either Tuple (all unnamed) or Struct (all named)");
        if (count === 0) return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null,
            type: "Null"
        };
        else if (isTuple && count === 1) {
            const typeDef = this.__internal__createSiDef(fields[0].type);
            return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, typeDef, lookupIndex === -1 ? null : {
                lookupIndex: lookupIndex,
                lookupName: this.__internal__names[lookupIndex],
                lookupNameRoot: typeDef.lookupName
            }, fields[0].typeName.isSome ? {
                typeName: (0, $8eefb6164d9f7959$export$83d2e9e3e4ee39ed)(fields[0].typeName.unwrap())
            } : null);
        }
        const [sub, alias] = this.__internal__extractFieldsAlias(fields);
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            info: isTuple // Tuple check first
             ? (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Tuple : (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Struct,
            sub: sub
        }, alias.size ? {
            alias: alias
        } : null, lookupIndex === -1 ? null : {
            lookupIndex: lookupIndex,
            lookupName: this.__internal__names[lookupIndex]
        }));
    }
    /** @internal Apply field aliassed (with no JS conflicts) */ __internal__extractFieldsAlias(fields) {
        const alias = new Map();
        const count = fields.length;
        const sub = new Array(count);
        for(let i = 0; i < count; i++){
            const { docs: docs, name: name, type: type, typeName: typeName } = fields[i];
            const typeDef = this.__internal__createSiDef(type);
            if (name.isNone) sub[i] = typeDef;
            else {
                const [nameField, nameOrig] = this.sanitizeField(name);
                if (nameField && nameOrig) alias.set(nameField, nameOrig);
                sub[i] = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                    docs: $1d65e77a7fae75e9$var$sanitizeDocs(docs),
                    name: nameField
                }, typeDef, typeName.isSome ? {
                    typeName: (0, $8eefb6164d9f7959$export$83d2e9e3e4ee39ed)(typeName.unwrap())
                } : null);
            }
        }
        return [
            sub,
            alias
        ];
    }
    /** @internal Extracts an internal Historic (pre V14) type  */ __internal__extractHistoric(_, type) {
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            displayName: type.toString(),
            isFromSi: true
        }, (0, $22807b92000b3c41$export$9f31b1beea63f4ee)(type));
    }
    /** @internal Extracts a ScaleInfo Primitive into TypeDef.Plain */ __internal__extractPrimitive(_, type) {
        const typeStr = type.def.asPrimitive.type.toString();
        return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            type: $1d65e77a7fae75e9$var$PRIMITIVE_ALIAS[typeStr] || typeStr.toLowerCase()
        };
    }
    /** @internal Applies an alias path onto the TypeDef */ __internal__extractAliasPath(_, type) {
        return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            type: type
        };
    }
    /** @internal Extracts a ScaleInfo Sequence into TypeDef.Vec (with Bytes shortcut) */ __internal__extractSequence(lookupIndex, { type: type }) {
        const sub = this.__internal__createSiDef(type);
        if (sub.type === "u8") return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Plain,
            type: "Bytes"
        };
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Vec,
            lookupIndex: lookupIndex,
            lookupName: this.__internal__names[lookupIndex],
            sub: sub
        });
    }
    /** @internal Extracts a ScaleInfo Tuple into TypeDef.Tuple */ __internal__extractTuple(lookupIndex, ids) {
        if (ids.length === 0) return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null,
            type: "Null"
        };
        else if (ids.length === 1) return this.getTypeDef(ids[0]);
        const sub = ids.map((t)=>this.__internal__createSiDef(t));
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Tuple,
            lookupIndex: lookupIndex,
            lookupName: this.__internal__names[lookupIndex],
            sub: sub
        });
    }
    /** @internal Extracts a ScaleInfo Variant into TypeDef.{Option, Result, Enum} */ __internal__extractVariant(lookupIndex, { params: params, path: path }, { variants: variants }) {
        if (path.length) {
            const specialVariant = path[0].toString();
            if (specialVariant === "Option") {
                if (params.length !== 1) throw new Error(`Option requires 1 parameter, found ${params.length}`);
                // NOTE This is opt-in (unhandled), not by default
                // if (sub.type === 'bool') {
                //   return withTypeString(this.registry, {
                //     info: TypeDefInfo.Plain,
                //     type: 'OptionBool'
                //   });
                // }
                return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
                    info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Option,
                    sub: this.__internal__createSiDef(params[0].type.unwrap())
                });
            } else if (specialVariant === "Result") {
                if (params.length !== 2) throw new Error(`Result requires 2 parameters, found ${params.length}`);
                return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
                    info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Result,
                    sub: params.map(({ type: type }, index)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                            name: [
                                "Ok",
                                "Error"
                            ][index]
                        }, this.__internal__createSiDef(type.unwrap())))
                });
            }
        }
        if (variants.length === 0) return {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null,
            type: "Null"
        };
        return this.__internal__extractVariantEnum(lookupIndex, variants);
    }
    /** @internal Extracts a ScaleInfo Variant into TypeDef.Enum */ __internal__extractVariantEnum(lookupIndex, variants) {
        const sub = [];
        // we may get entries out of order, arrange them first before creating with gaps filled
        // NOTE: Since we mutate, use a copy of the array as an input
        variants.slice().sort((a, b)=>a.index.cmp(b.index)).forEach(({ fields: fields, index: bnIndex, name: name })=>{
            const index = bnIndex.toNumber();
            while(sub.length !== index)sub.push({
                index: sub.length,
                info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Null,
                name: `__Unused${sub.length}`,
                type: "Null"
            });
            sub.push((0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(this.__internal__extractFields(-1, fields), {
                index: index,
                name: name.toString()
            }));
        });
        return (0, $93449a5ef27edd4d$export$93c3022a8a191f9e)(this.registry, {
            info: (0, $557bfa9761bbf2f6$export$9d5fb39c289c5e29).Enum,
            lookupIndex: lookupIndex,
            lookupName: this.__internal__names[lookupIndex],
            sub: sub
        });
    }
}



const $e21dedd888b26621$var$DEFAULT_FIRST_CALL_IDX = new Uint8Array(2);
const $e21dedd888b26621$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("registry");
function $e21dedd888b26621$var$sortDecimalStrings(a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
}
function $e21dedd888b26621$var$valueToString(v) {
    return v.toString();
}
function $e21dedd888b26621$var$getFieldArgs(lookup, fields) {
    const count = fields.length;
    const args = new Array(count);
    for(let i = 0; i < count; i++)args[i] = lookup.getTypeDef(fields[i].type).type;
    return args;
}
function $e21dedd888b26621$var$clearRecord(record) {
    const keys = Object.keys(record);
    for(let i = 0, count = keys.length; i < count; i++)delete record[keys[i]];
}
function $e21dedd888b26621$var$getVariantStringIdx({ index: index }) {
    return index.toString();
}
function $e21dedd888b26621$var$injectErrors(_, { lookup: lookup, pallets: pallets }, version, result) {
    $e21dedd888b26621$var$clearRecord(result);
    for(let i = 0, count = pallets.length; i < count; i++){
        const { errors: errors, index: index, name: name } = pallets[i];
        if (errors.isSome) {
            const sectionName = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name);
            (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, version >= 12 ? index.toNumber() : i, ()=>(0, $e18d98b64df51de2$export$46c30c6def42ba7d)(lookup, errors.unwrap(), $e21dedd888b26621$var$getVariantStringIdx, ({ docs: docs, fields: fields, index: index, name: name })=>({
                        args: $e21dedd888b26621$var$getFieldArgs(lookup, fields),
                        docs: docs.map($e21dedd888b26621$var$valueToString),
                        fields: fields,
                        index: index.toNumber(),
                        method: name.toString(),
                        name: name.toString(),
                        section: sectionName
                    })));
        }
    }
}
function $e21dedd888b26621$var$injectEvents(registry, { lookup: lookup, pallets: pallets }, version, result) {
    const filtered = pallets.filter((0, $2afce0de1332c32b$export$d0fc5d59dcf00a97));
    $e21dedd888b26621$var$clearRecord(result);
    for(let i = 0, count = filtered.length; i < count; i++){
        const { events: events, index: index, name: name } = filtered[i];
        (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, version >= 12 ? index.toNumber() : i, ()=>(0, $e18d98b64df51de2$export$46c30c6def42ba7d)(lookup, events.unwrap(), $e21dedd888b26621$var$getVariantStringIdx, (variant)=>{
                const meta = registry.createType("EventMetadataLatest", (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, variant, {
                    args: $e21dedd888b26621$var$getFieldArgs(lookup, variant.fields)
                }));
                return class extends (0, $b713657d03724297$export$1b4b861caf7ac12b) {
                    constructor(registry, value){
                        super(registry, value, meta, (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name), variant.name.toString());
                    }
                };
            }));
    }
}
function $e21dedd888b26621$var$injectExtrinsics(registry, { lookup: lookup, pallets: pallets }, version, result, mapping) {
    const filtered = pallets.filter((0, $bff1a500fdc7f076$export$f54d62d58c333dbb));
    $e21dedd888b26621$var$clearRecord(result);
    $e21dedd888b26621$var$clearRecord(mapping);
    for(let i = 0, count = filtered.length; i < count; i++){
        const { calls: calls, index: index, name: name } = filtered[i];
        const sectionIndex = version >= 12 ? index.toNumber() : i;
        const sectionName = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(name);
        const allCalls = calls.unwrap();
        (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, sectionIndex, ()=>(0, $e18d98b64df51de2$export$46c30c6def42ba7d)(lookup, allCalls, $e21dedd888b26621$var$getVariantStringIdx, (variant)=>(0, $bff1a500fdc7f076$export$6cde56eec82c0c6a)(registry, lookup, variant, sectionName, sectionIndex)));
        const { path: path } = registry.lookup.getSiType(allCalls.type);
        // frame_system::pallet::Call / pallet_balances::pallet::Call / polkadot_runtime_parachains::configuration::pallet::Call /
        const palletIdx = path.findIndex((v)=>v.eq("pallet"));
        if (palletIdx !== -1) {
            const name = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(path.slice(0, palletIdx).map((p, i)=>i === 0 ? p.replace(/^(frame|pallet)_/, "") : p).join(" "));
            if (!mapping[name]) mapping[name] = [
                sectionName
            ];
            else mapping[name].push(sectionName);
        }
    }
}
function $e21dedd888b26621$var$extractProperties(registry, metadata) {
    const original = registry.getChainProperties();
    const constants = (0, $6fd24ae59e9f7c74$export$bce56c4ffddeedc8)(registry, metadata.asLatest, metadata.version);
    const ss58Format = constants["system"] && (constants["system"]["sS58Prefix"] || constants["system"]["ss58Prefix"]);
    if (!ss58Format) return original;
    const { tokenDecimals: tokenDecimals, tokenSymbol: tokenSymbol } = original || {};
    return registry.createTypeUnsafe("ChainProperties", [
        {
            ss58Format: ss58Format,
            tokenDecimals: tokenDecimals,
            tokenSymbol: tokenSymbol
        }
    ]);
}
class $e21dedd888b26621$export$ea4312c9b0ebd908 {
    constructor(createdAtHash){
        this.__internal__classes = new Map();
        this.__internal__definitions = new Map();
        this.__internal__firstCallIndex = null;
        this.__internal__hasher = (0, $dcbcf4e1d1853689$export$5faebd53a9e0f952);
        this.__internal__knownTypes = {};
        this.__internal__metadataVersion = 0;
        this.__internal__signedExtensions = (0, $e9af2f5d0b405445$export$a73f9a83a616a915);
        this.__internal__unknownTypes = new Map();
        this.__internal__metadataCalls = {};
        this.__internal__metadataErrors = {};
        this.__internal__metadataEvents = {};
        this.__internal__moduleMap = {};
        this.__internal__registerObject = (obj)=>{
            const entries = Object.entries(obj);
            for(let e = 0, count = entries.length; e < count; e++){
                const [name, type] = entries[e];
                if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(type)) // This _looks_ a bit funny, but `typeof Clazz === 'function'
                this.__internal__classes.set(name, type);
                else {
                    const def = (0, $0d672af39bfe8283$export$844ec244b1367d54)(type) ? type : (0, $e2c4db534325025c$export$fac44ee5b035f737)(type);
                    if (name === def) throw new Error(`Unable to register circular ${name} === ${def}`);
                    // we already have this type, remove the classes registered for it
                    if (this.__internal__classes.has(name)) this.__internal__classes.delete(name);
                    this.__internal__definitions.set(name, def);
                }
            }
        };
        // register alias types alongside the portable/lookup setup
        // (we don't combine this into setLookup since that would/could
        // affect stand-along lookups, such as ABIs which don't have
        // actual on-chain metadata)
        this.__internal__registerLookup = (lookup)=>{
            // attach the lookup before we register any types
            this.setLookup(lookup);
            // we detect based on runtime configuration
            let Weight = null;
            if (this.hasType("SpWeightsWeightV2Weight")) {
                // detection for WeightV2 type based on latest naming
                const weightv2 = this.createType("SpWeightsWeightV2Weight");
                Weight = weightv2.refTime && weightv2.proofSize ? "SpWeightsWeightV2Weight" : "WeightV1";
            } else if (!(0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(this.createType("Weight"))) // where we have an already-supplied BN override, we don't clobber
            // it with our detected value (This protects against pre-defines
            // where Weight may be aliassed to WeightV0, e.g. in early Kusama chains)
            Weight = "WeightV1";
            if (Weight) // we have detected a version, adjust the definition
            this.register({
                Weight: Weight
            });
        };
        this.__internal__knownDefaults = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            Json: $d36f0e8a198e6efb$export$48880ac635f47186,
            Metadata: $918d2e4dba59a611$export$e7adebdc1ebd2fed,
            PortableRegistry: $1d65e77a7fae75e9$export$a991cc4a835cd8d8,
            Raw: $d0fc201459fab5e6$export$6f88fe47d32c9c94
        }, $7df5b58966439861$exports);
        this.__internal__knownDefaultsEntries = Object.entries(this.__internal__knownDefaults);
        this.__internal__knownDefinitions = $f07063bab9185798$exports;
        const allKnown = Object.values(this.__internal__knownDefinitions);
        for(let i = 0, count = allKnown.length; i < count; i++)this.register(allKnown[i].types);
        if (createdAtHash) this.createdAtHash = this.createType("BlockHash", createdAtHash);
    }
    get chainDecimals() {
        if (this.__internal__chainProperties?.tokenDecimals.isSome) {
            const allDecimals = this.__internal__chainProperties.tokenDecimals.unwrap();
            if (allDecimals.length) return allDecimals.map((b)=>b.toNumber());
        }
        return [
            12
        ];
    }
    get chainSS58() {
        return this.__internal__chainProperties?.ss58Format.isSome ? this.__internal__chainProperties.ss58Format.unwrap().toNumber() : undefined;
    }
    get chainTokens() {
        if (this.__internal__chainProperties?.tokenSymbol.isSome) {
            const allTokens = this.__internal__chainProperties.tokenSymbol.unwrap();
            if (allTokens.length) return allTokens.map($e21dedd888b26621$var$valueToString);
        }
        return [
            (0, $b3e30afb943da5cc$export$cc3bc0b518c1c6b8).getDefaults().unit
        ];
    }
    get firstCallIndex() {
        return this.__internal__firstCallIndex || $e21dedd888b26621$var$DEFAULT_FIRST_CALL_IDX;
    }
    /**
     * @description Returns true if the type is in a Compat format
     */ isLookupType(value) {
        return /Lookup\d+$/.test(value);
    }
    /**
     * @description Creates a lookup string from the supplied id
     */ createLookupType(lookupId) {
        return `Lookup${typeof lookupId === "number" ? lookupId : lookupId.toNumber()}`;
    }
    get knownTypes() {
        return this.__internal__knownTypes;
    }
    get lookup() {
        return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(this.__internal__lookup, "PortableRegistry has not been set on this registry");
    }
    get metadata() {
        return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(this.__internal__metadata, "Metadata has not been set on this registry");
    }
    get unknownTypes() {
        return [
            ...this.__internal__unknownTypes.keys()
        ];
    }
    get signedExtensions() {
        return this.__internal__signedExtensions;
    }
    clearCache() {
        this.__internal__classes = new Map();
    }
    /**
     * @describe Creates an instance of the class
     */ createClass(type) {
        return (0, $f05158b9012fbaae$export$8c6c7dc0f6f149ab)(this, type);
    }
    /**
     * @describe Creates an instance of the class
     */ createClassUnsafe(type) {
        return (0, $f05158b9012fbaae$export$8c6c7dc0f6f149ab)(this, type);
    }
    /**
     * @description Creates an instance of a type as registered
     */ createType(type, ...params) {
        return (0, $796aad855692ccf7$export$a0a5da2d2fe31216)(this, type, params);
    }
    /**
     * @description Creates an instance of a type as registered
     */ createTypeUnsafe(type, params, options) {
        return (0, $796aad855692ccf7$export$a0a5da2d2fe31216)(this, type, params, options);
    }
    // find a specific call
    findMetaCall(callIndex) {
        const [section, method] = [
            callIndex[0],
            callIndex[1]
        ];
        return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(this.__internal__metadataCalls[`${section}`] && this.__internal__metadataCalls[`${section}`][`${method}`], ()=>`findMetaCall: Unable to find Call with index [${section}, ${method}]/[${callIndex.toString()}]`);
    }
    // finds an error
    findMetaError(errorIndex) {
        const [section, method] = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(errorIndex) ? [
            errorIndex[0],
            errorIndex[1]
        ] : [
            errorIndex.index.toNumber(),
            (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(errorIndex.error) ? errorIndex.error[0] : errorIndex.error.toNumber()
        ];
        return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(this.__internal__metadataErrors[`${section}`] && this.__internal__metadataErrors[`${section}`][`${method}`], ()=>`findMetaError: Unable to find Error with index [${section}, ${method}]/[${errorIndex.toString()}]`);
    }
    findMetaEvent(eventIndex) {
        const [section, method] = [
            eventIndex[0],
            eventIndex[1]
        ];
        return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(this.__internal__metadataEvents[`${section}`] && this.__internal__metadataEvents[`${section}`][`${method}`], ()=>`findMetaEvent: Unable to find Event with index [${section}, ${method}]/[${eventIndex.toString()}]`);
    }
    get(name, withUnknown, knownTypeDef) {
        return this.getUnsafe(name, withUnknown, knownTypeDef);
    }
    getUnsafe(name, withUnknown, knownTypeDef) {
        let Type = this.__internal__classes.get(name) || this.__internal__knownDefaults[name];
        // we have not already created the type, attempt it
        if (!Type) {
            const definition = this.__internal__definitions.get(name);
            let BaseType;
            // we have a definition, so create the class now (lazily)
            if (definition) BaseType = (0, $f05158b9012fbaae$export$8c6c7dc0f6f149ab)(this, definition);
            else if (knownTypeDef) BaseType = (0, $f05158b9012fbaae$export$fdf8750a4cbca64)(this, knownTypeDef);
            else if (withUnknown) {
                $e21dedd888b26621$var$l.warn(`Unable to resolve type ${name}, it will fail on construction`);
                this.__internal__unknownTypes.set(name, true);
                BaseType = (0, $561a7ebeda2ce82e$export$61d01bf8d0c78f65).with(name);
            }
            if (BaseType) {
                // NOTE If we didn't extend here, we would have strange artifacts. An example is
                // Balance, with this, new Balance() instanceof u128 is true, but Balance !== u128
                // Additionally, we now pass through the registry, which is a link to ourselves
                Type = class extends BaseType {
                };
                this.__internal__classes.set(name, Type);
                // In the case of lookups, we also want to store the actual class against
                // the lookup name, instad of having to traverse again
                if (knownTypeDef && (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(knownTypeDef.lookupIndex)) this.__internal__classes.set(this.createLookupType(knownTypeDef.lookupIndex), Type);
            }
        }
        return Type;
    }
    getChainProperties() {
        return this.__internal__chainProperties;
    }
    getClassName(Type) {
        // we cannot rely on export order (anymore, since babel/core 7.15.8), so in the case of
        // items such as u32 & U32, we get the lowercase versions here... not quite as optimal
        // (previously this used to be a simple find & return)
        const names = [];
        for (const [name, Clazz] of this.__internal__knownDefaultsEntries)if (Type === Clazz) names.push(name);
        for (const [name, Clazz] of this.__internal__classes.entries())if (Type === Clazz) names.push(name);
        return names.length ? names.sort().reverse()[0] : undefined;
    }
    getDefinition(typeName) {
        return this.__internal__definitions.get(typeName);
    }
    getModuleInstances(specName, moduleName) {
        return this.__internal__knownTypes?.typesBundle?.spec?.[specName.toString()]?.instances?.[moduleName] || this.__internal__moduleMap[moduleName];
    }
    getOrThrow(name) {
        const Clazz = this.get(name);
        if (!Clazz) throw new Error(`type ${name} not found`);
        return Clazz;
    }
    getOrUnknown(name) {
        return this.get(name, true);
    }
    getSignedExtensionExtra() {
        return (0, $e9af2f5d0b405445$export$c19e5b60d3c5089e)(this.__internal__signedExtensions, "payload", this.__internal__userExtensions);
    }
    getSignedExtensionTypes() {
        return (0, $e9af2f5d0b405445$export$c19e5b60d3c5089e)(this.__internal__signedExtensions, "extrinsic", this.__internal__userExtensions);
    }
    hasClass(name) {
        return this.__internal__classes.has(name) || !!this.__internal__knownDefaults[name];
    }
    hasDef(name) {
        return this.__internal__definitions.has(name);
    }
    hasType(name) {
        return !this.__internal__unknownTypes.get(name) && (this.hasClass(name) || this.hasDef(name));
    }
    hash(data) {
        return this.createType("CodecHash", this.__internal__hasher(data));
    }
    // eslint-disable-next-line no-dupe-class-members
    register(arg1, arg2) {
        // NOTE Constructors appear as functions here
        if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(arg1)) this.__internal__classes.set(arg1.name, arg1);
        else if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(arg1)) {
            if (!(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(arg2)) throw new Error(`Expected class definition passed to '${arg1}' registration`);
            else if (arg1 === arg2.toString()) throw new Error(`Unable to register circular ${arg1} === ${arg1}`);
            this.__internal__classes.set(arg1, arg2);
        } else this.__internal__registerObject(arg1);
    }
    // sets the chain properties
    setChainProperties(properties) {
        if (properties) this.__internal__chainProperties = properties;
    }
    setHasher(hasher) {
        this.__internal__hasher = hasher || (0, $dcbcf4e1d1853689$export$5faebd53a9e0f952);
    }
    setKnownTypes(knownTypes) {
        this.__internal__knownTypes = knownTypes;
    }
    setLookup(lookup) {
        this.__internal__lookup = lookup;
        // register all applicable types found
        lookup.register();
    }
    // sets the metadata
    setMetadata(metadata, signedExtensions, userExtensions, noInitWarn) {
        this.__internal__metadata = metadata.asLatest;
        this.__internal__metadataVersion = metadata.version;
        this.__internal__firstCallIndex = null;
        // attach the lookup at this point and register relevant types (before injecting)
        this.__internal__registerLookup(this.__internal__metadata.lookup);
        $e21dedd888b26621$var$injectExtrinsics(this, this.__internal__metadata, this.__internal__metadataVersion, this.__internal__metadataCalls, this.__internal__moduleMap);
        $e21dedd888b26621$var$injectErrors(this, this.__internal__metadata, this.__internal__metadataVersion, this.__internal__metadataErrors);
        $e21dedd888b26621$var$injectEvents(this, this.__internal__metadata, this.__internal__metadataVersion, this.__internal__metadataEvents);
        // set the default call index (the lowest section, the lowest method)
        // in most chains this should be 0,0
        const [defSection] = Object.keys(this.__internal__metadataCalls).sort($e21dedd888b26621$var$sortDecimalStrings);
        if (defSection) {
            const [defMethod] = Object.keys(this.__internal__metadataCalls[defSection]).sort($e21dedd888b26621$var$sortDecimalStrings);
            if (defMethod) this.__internal__firstCallIndex = new Uint8Array([
                parseInt(defSection, 10),
                parseInt(defMethod, 10)
            ]);
        }
        // setup the available extensions
        this.setSignedExtensions(signedExtensions || (this.__internal__metadata.extrinsic.version.gt((0, $031d4cf4355dbeac$export$df7eb0036fdbadfa)) ? this.__internal__metadata.extrinsic.signedExtensions.map(({ identifier: identifier })=>identifier.toString()) : (0, $e9af2f5d0b405445$export$a73f9a83a616a915)), userExtensions, noInitWarn);
        // setup the chain properties with format overrides
        this.setChainProperties($e21dedd888b26621$var$extractProperties(this, metadata));
    }
    // sets the available signed extensions
    setSignedExtensions(signedExtensions = (0, $e9af2f5d0b405445$export$a73f9a83a616a915), userExtensions, noInitWarn) {
        this.__internal__signedExtensions = signedExtensions;
        this.__internal__userExtensions = userExtensions;
        if (!noInitWarn) {
            const unknown = (0, $e9af2f5d0b405445$export$17157f56eba35ba1)(this.__internal__signedExtensions, this.__internal__userExtensions);
            if (unknown.length) $e21dedd888b26621$var$l.warn(`Unknown signed extensions ${unknown.join(", ")} found, treating them as no-effect`);
        }
    }
}



const $8d34cd00dd8948d7$export$238768e5caeba982 = {};


const $d47a7eda8d5633b1$var$sharedTypes = {
    // Anchor
    AnchorData: {
        anchoredBlock: "u64",
        docRoot: "H256",
        id: "H256"
    },
    DispatchErrorModule: "DispatchErrorModuleU8",
    PreCommitData: {
        expirationBlock: "u64",
        identity: "H256",
        signingRoot: "H256"
    },
    // Fees
    Fee: {
        key: "Hash",
        price: "Balance"
    },
    // MultiAccount
    MultiAccountData: {
        deposit: "Balance",
        depositor: "AccountId",
        signatories: "Vec<AccountId>",
        threshold: "u16"
    },
    // Bridge
    ChainId: "u8",
    DepositNonce: "u64",
    ResourceId: "[u8; 32]",
    "chainbridge::ChainId": "u8",
    // NFT
    RegistryId: "H160",
    TokenId: "U256",
    AssetId: {
        registryId: "RegistryId",
        tokenId: "TokenId"
    },
    AssetInfo: {
        metadata: "Bytes"
    },
    MintInfo: {
        anchorId: "Hash",
        proofs: "Vec<ProofMint>",
        staticHashes: "[Hash; 3]"
    },
    Proof: {
        leafHash: "H256",
        sortedHashes: "H256"
    },
    ProofMint: {
        hashes: "Vec<Hash>",
        property: "Bytes",
        salt: "[u8; 32]",
        value: "Bytes"
    },
    RegistryInfo: {
        fields: "Vec<Bytes>",
        ownerCanBurn: "bool"
    },
    ProxyType: {
        _enum: [
            "Any",
            "NonTransfer",
            "Governance",
            "Staking",
            "NonProxy"
        ]
    }
};
const $d47a7eda8d5633b1$var$standaloneTypes = {
    ...$d47a7eda8d5633b1$var$sharedTypes,
    AccountInfo: "AccountInfoWithRefCount",
    Address: "LookupSource",
    LookupSource: "IndicesLookupSource",
    Multiplier: "Fixed64",
    RefCount: "RefCountTo259"
};
const $d47a7eda8d5633b1$export$77209763ab277934 = [
    {
        minmax: [
            240,
            243
        ],
        types: {
            ...$d47a7eda8d5633b1$var$standaloneTypes,
            ProxyType: {
                _enum: [
                    "Any",
                    "NonTransfer",
                    "Governance",
                    "Staking",
                    "Vesting"
                ]
            }
        }
    },
    {
        minmax: [
            244,
            999
        ],
        types: {
            ...$d47a7eda8d5633b1$var$standaloneTypes
        }
    },
    {
        minmax: [
            1000,
            undefined
        ],
        types: {
            ...$d47a7eda8d5633b1$var$sharedTypes
        }
    }
];



const $6c18be5822fc76e6$var$sharedTypes = {
    CompactAssignments: "CompactAssignmentsWith24",
    DispatchErrorModule: "DispatchErrorModuleU8",
    RawSolution: "RawSolutionWith24",
    Keys: "SessionKeys6",
    ProxyType: {
        _enum: [
            "Any",
            "NonTransfer",
            "Governance",
            "Staking",
            "IdentityJudgement",
            "CancelProxy",
            "Auction"
        ]
    },
    Weight: "WeightV1"
};
const $6c18be5822fc76e6$var$addrIndicesTypes = {
    AccountInfo: "AccountInfoWithRefCount",
    Address: "LookupSource",
    CompactAssignments: "CompactAssignmentsWith16",
    DispatchErrorModule: "DispatchErrorModuleU8",
    RawSolution: "RawSolutionWith16",
    Keys: "SessionKeys5",
    LookupSource: "IndicesLookupSource",
    ValidatorPrefs: "ValidatorPrefsWithCommission"
};
const $6c18be5822fc76e6$var$addrAccountIdTypes = {
    AccountInfo: "AccountInfoWithRefCount",
    Address: "AccountId",
    CompactAssignments: "CompactAssignmentsWith16",
    DispatchErrorModule: "DispatchErrorModuleU8",
    RawSolution: "RawSolutionWith16",
    Keys: "SessionKeys5",
    LookupSource: "AccountId",
    ValidatorPrefs: "ValidatorPrefsWithCommission"
};
const $6c18be5822fc76e6$export$77209763ab277934 = [
    {
        // 1020 is first CC3
        minmax: [
            1019,
            1031
        ],
        types: {
            ...$6c18be5822fc76e6$var$addrIndicesTypes,
            BalanceLock: "BalanceLockTo212",
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchError: "DispatchErrorTo198",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            IdentityInfo: "IdentityInfoTo198",
            Keys: "SessionKeys5",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            ReferendumInfo: "ReferendumInfoTo239",
            Scheduled: "ScheduledTo254",
            SlashingSpans: "SlashingSpansTo204",
            StakingLedger: "StakingLedgerTo223",
            Votes: "VotesTo230",
            Weight: "u32"
        }
    },
    {
        minmax: [
            1032,
            1042
        ],
        types: {
            ...$6c18be5822fc76e6$var$addrIndicesTypes,
            BalanceLock: "BalanceLockTo212",
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            Keys: "SessionKeys5",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            ReferendumInfo: "ReferendumInfoTo239",
            Scheduled: "ScheduledTo254",
            SlashingSpans: "SlashingSpansTo204",
            StakingLedger: "StakingLedgerTo223",
            Votes: "VotesTo230",
            Weight: "u32"
        }
    },
    {
        // actual at 1045 (1043-1044 is dev)
        minmax: [
            1043,
            1045
        ],
        types: {
            ...$6c18be5822fc76e6$var$addrIndicesTypes,
            BalanceLock: "BalanceLockTo212",
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            Keys: "SessionKeys5",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            ReferendumInfo: "ReferendumInfoTo239",
            Scheduled: "ScheduledTo254",
            StakingLedger: "StakingLedgerTo223",
            Votes: "VotesTo230",
            Weight: "u32"
        }
    },
    {
        minmax: [
            1046,
            1049
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            ReferendumInfo: "ReferendumInfoTo239",
            Scheduled: "ScheduledTo254",
            StakingLedger: "StakingLedgerTo223",
            Weight: "u32"
        }
    },
    {
        minmax: [
            1050,
            1054
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            ReferendumInfo: "ReferendumInfoTo239",
            Scheduled: "ScheduledTo254",
            StakingLedger: "StakingLedgerTo240",
            Weight: "u32"
        }
    },
    {
        minmax: [
            1055,
            1056
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            Scheduled: "ScheduledTo254",
            StakingLedger: "StakingLedgerTo240",
            Weight: "u32"
        }
    },
    {
        minmax: [
            1057,
            1061
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            // Last 100% known problematic runtime range - this quite possibly need to
            // apply to more runtime ranges that follow, we just don't know how far this
            // should be applied to
            //
            // TL;DR whack-a-mole since this was not histrically checked
            //
            // See https://github.com/polkadot-js/api/issues/5618#issuecomment-1530970316
            Scheduled: "ScheduledTo254"
        }
    },
    {
        minmax: [
            1062,
            2012
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            2013,
            2022
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            2023,
            2024
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes,
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            2025,
            2027
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...$6c18be5822fc76e6$var$addrAccountIdTypes
        }
    },
    {
        minmax: [
            2028,
            2029
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            AccountInfo: "AccountInfoWithDualRefCount",
            CompactAssignments: "CompactAssignmentsWith16",
            RawSolution: "RawSolutionWith16"
        }
    },
    {
        minmax: [
            2030,
            9000
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            CompactAssignments: "CompactAssignmentsWith16",
            RawSolution: "RawSolutionWith16"
        }
    },
    {
        minmax: [
            9010,
            9099
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V0")
        }
    },
    {
        // jump from 9100 to 9110, however align with Rococo
        minmax: [
            9100,
            9105
        ],
        types: {
            ...$6c18be5822fc76e6$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V1")
        }
    },
    {
        // metadata v14
        minmax: [
            9106,
            undefined
        ],
        types: {
            Weight: "WeightV1"
        }
    }
];


const $ef59be20a26f3f2f$export$77209763ab277934 = [
    {
        minmax: [
            0,
            undefined
        ],
        types: {
            // nothing, API tracks master
            // (v2 weights are not yet the default)
            Weight: "WeightV2"
        }
    }
];


const $b786bd4f851608c2$export$77209763ab277934 = [
    {
        minmax: [
            0,
            undefined
        ],
        types: {
            // nothing, API tracks master
            // (v2 weights are not yet the default)
            Weight: "WeightV2"
        }
    }
];


const $e18b3040573aea24$var$sharedTypes = {
    CompactAssignments: "CompactAssignmentsWith16",
    DispatchErrorModule: "DispatchErrorModuleU8",
    RawSolution: "RawSolutionWith16",
    Keys: "SessionKeys6",
    ProxyType: {
        _enum: {
            Any: 0,
            NonTransfer: 1,
            Governance: 2,
            Staking: 3,
            UnusedSudoBalances: 4,
            IdentityJudgement: 5,
            CancelProxy: 6,
            Auction: 7
        }
    },
    Weight: "WeightV1"
};
const $e18b3040573aea24$var$addrAccountIdTypes = {
    AccountInfo: "AccountInfoWithRefCount",
    Address: "AccountId",
    DispatchErrorModule: "DispatchErrorModuleU8",
    Keys: "SessionKeys5",
    LookupSource: "AccountId",
    ValidatorPrefs: "ValidatorPrefsWithCommission"
};
const $e18b3040573aea24$export$77209763ab277934 = [
    {
        minmax: [
            0,
            12
        ],
        types: {
            ...$e18b3040573aea24$var$sharedTypes,
            ...$e18b3040573aea24$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            13,
            22
        ],
        types: {
            ...$e18b3040573aea24$var$sharedTypes,
            ...$e18b3040573aea24$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            23,
            24
        ],
        types: {
            ...$e18b3040573aea24$var$sharedTypes,
            ...$e18b3040573aea24$var$addrAccountIdTypes,
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            25,
            27
        ],
        types: {
            ...$e18b3040573aea24$var$sharedTypes,
            ...$e18b3040573aea24$var$addrAccountIdTypes
        }
    },
    {
        minmax: [
            28,
            29
        ],
        types: {
            ...$e18b3040573aea24$var$sharedTypes,
            AccountInfo: "AccountInfoWithDualRefCount"
        }
    },
    {
        minmax: [
            30,
            9109
        ],
        types: {
            ...$e18b3040573aea24$var$sharedTypes
        }
    },
    {
        // metadata v14
        minmax: [
            9110,
            undefined
        ],
        types: {
            Weight: "WeightV1"
        }
    }
];



/* eslint-disable sort-keys */ const $40f5e713f66ba96a$var$sharedTypes = {
    DispatchErrorModule: "DispatchErrorModuleU8",
    FullIdentification: "()",
    Keys: "SessionKeys7B",
    Weight: "WeightV1"
};
const $40f5e713f66ba96a$export$77209763ab277934 = [
    {
        minmax: [
            0,
            200
        ],
        types: {
            ...$40f5e713f66ba96a$var$sharedTypes,
            AccountInfo: "AccountInfoWithDualRefCount",
            Address: "AccountId",
            LookupSource: "AccountId"
        }
    },
    {
        minmax: [
            201,
            214
        ],
        types: {
            ...$40f5e713f66ba96a$var$sharedTypes,
            AccountInfo: "AccountInfoWithDualRefCount"
        }
    },
    {
        minmax: [
            215,
            228
        ],
        types: {
            ...$40f5e713f66ba96a$var$sharedTypes,
            Keys: "SessionKeys6"
        }
    },
    {
        minmax: [
            229,
            9099
        ],
        types: {
            ...$40f5e713f66ba96a$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V0")
        }
    },
    {
        minmax: [
            9100,
            9105
        ],
        types: {
            ...$40f5e713f66ba96a$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V1")
        }
    },
    {
        // metadata v14
        minmax: [
            9106,
            undefined
        ],
        types: {
            Weight: "WeightV1"
        }
    }
];


const $8636654257b9d3d2$export$77209763ab277934 = [
    {
        minmax: [
            0,
            undefined
        ],
        types: {
        }
    }
];



const $9e78b16017511728$var$sharedTypes = {
    DispatchErrorModule: "DispatchErrorModuleU8",
    TAssetBalance: "u128",
    ProxyType: {
        _enum: [
            "Any",
            "NonTransfer",
            "CancelProxy",
            "Assets",
            "AssetOwner",
            "AssetManager",
            "Staking"
        ]
    },
    Weight: "WeightV1"
};
const $9e78b16017511728$export$77209763ab277934 = [
    {
        minmax: [
            0,
            3
        ],
        types: {
            // Enum was modified mid-flight -
            // https://github.com/paritytech/substrate/pull/10382/files#diff-e4e016b33a82268b6208dc974eea841bad47597865a749fee2f937eb6fdf67b4R498
            DispatchError: "DispatchErrorPre6First",
            ...$9e78b16017511728$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V0")
        }
    },
    {
        minmax: [
            4,
            5
        ],
        types: {
            // As above, see https://github.com/polkadot-js/api/issues/5301
            DispatchError: "DispatchErrorPre6First",
            ...$9e78b16017511728$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V1")
        }
    },
    {
        // metadata V14
        minmax: [
            500,
            undefined
        ],
        types: {
            Weight: "WeightV1"
        }
    }
];



const $1f9cdad791ab92f5$var$sharedTypes = {
    // 16 validators
    CompactAssignments: "CompactAssignmentsWith16",
    DispatchErrorModule: "DispatchErrorModuleU8",
    RawSolution: "RawSolutionWith16",
    // general
    Keys: "SessionKeys6",
    ProxyType: {
        _enum: [
            "Any",
            "NonTransfer",
            "Staking",
            "SudoBalances",
            "IdentityJudgement",
            "CancelProxy"
        ]
    },
    Weight: "WeightV1"
};
const $1f9cdad791ab92f5$var$addrAccountIdTypes = {
    AccountInfo: "AccountInfoWithRefCount",
    Address: "AccountId",
    CompactAssignments: "CompactAssignmentsWith16",
    DispatchErrorModule: "DispatchErrorModuleU8",
    LookupSource: "AccountId",
    Keys: "SessionKeys5",
    RawSolution: "RawSolutionWith16",
    ValidatorPrefs: "ValidatorPrefsWithCommission"
};
const $1f9cdad791ab92f5$export$77209763ab277934 = [
    {
        minmax: [
            1,
            2
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...$1f9cdad791ab92f5$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            Multiplier: "Fixed64",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259",
            Weight: "u32"
        }
    },
    {
        minmax: [
            3,
            22
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...$1f9cdad791ab92f5$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            OpenTip: "OpenTipTo225",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            23,
            42
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...$1f9cdad791ab92f5$var$addrAccountIdTypes,
            CompactAssignments: "CompactAssignmentsTo257",
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            43,
            44
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...$1f9cdad791ab92f5$var$addrAccountIdTypes,
            DispatchInfo: "DispatchInfoTo244",
            Heartbeat: "HeartbeatTo244",
            RefCount: "RefCountTo259"
        }
    },
    {
        minmax: [
            45,
            47
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...$1f9cdad791ab92f5$var$addrAccountIdTypes
        }
    },
    {
        minmax: [
            48,
            49
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            AccountInfo: "AccountInfoWithDualRefCount"
        }
    },
    {
        minmax: [
            50,
            9099
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V0")
        }
    },
    {
        minmax: [
            9100,
            9105
        ],
        types: {
            ...$1f9cdad791ab92f5$var$sharedTypes,
            ...(0, $0c648c48d03456b7$export$5c047182797f4bb8)("V1")
        }
    },
    {
        // metadata v14
        minmax: [
            9106,
            undefined
        ],
        types: {
            Weight: "WeightV1"
        }
    }
];


const $4345e1f83d70cfce$export$29b2ac8da719c288 = {
    "centrifuge-chain": (0, $d47a7eda8d5633b1$export$77209763ab277934),
    kusama: $6c18be5822fc76e6$export$77209763ab277934,
    node: $ef59be20a26f3f2f$export$77209763ab277934,
    "node-template": (0, $b786bd4f851608c2$export$77209763ab277934),
    polkadot: $e18b3040573aea24$export$77209763ab277934,
    rococo: $40f5e713f66ba96a$export$77209763ab277934,
    shell: $8636654257b9d3d2$export$77209763ab277934,
    statemine: (0, $9e78b16017511728$export$77209763ab277934),
    statemint: $9e78b16017511728$export$77209763ab277934,
    westend: $1f9cdad791ab92f5$export$77209763ab277934,
    westmint: (0, $9e78b16017511728$export$77209763ab277934)
};




var $hWfed = parcelRequire("hWfed");
var $36281b561d260678$exports = {};

$parcel$export($36281b561d260678$exports, "kusama", function () { return $8c42a585311050cf$export$4188226d4014f4f; });
$parcel$export($36281b561d260678$exports, "polkadot", function () { return $e3870c296db043b4$export$4188226d4014f4f; });
$parcel$export($36281b561d260678$exports, "westend", function () { return $5db890a7b1f78b6e$export$4188226d4014f4f; });
const $8c42a585311050cf$export$4188226d4014f4f = [
    [
        0,
        1020,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        26669,
        1021,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        38245,
        1022,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        54248,
        1023,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        59659,
        1024,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        67651,
        1025,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        82191,
        1027,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        83238,
        1028,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        101503,
        1029,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        203466,
        1030,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        295787,
        1031,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        461692,
        1032,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        504329,
        1033,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        569327,
        1038,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        587687,
        1039,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        653183,
        1040,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        693488,
        1042,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        901442,
        1045,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1375086,
        1050,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1445458,
        1051,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1472960,
        1052,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1475648,
        1053,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1491596,
        1054,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1574408,
        1055,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2064961,
        1058,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2201991,
        1062,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2671528,
        2005,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2704202,
        2007,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2728002,
        2008,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2832534,
        2011,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2962294,
        2012,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3240000,
        2013,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3274408,
        2015,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3323565,
        2019,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3534175,
        2022,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3860281,
        2023,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4143129,
        2024,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4401242,
        2025,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4841367,
        2026,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5961600,
        2027,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6137912,
        2028,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6561855,
        2029,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7100891,
        2030,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7468792,
        9010,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7668600,
        9030,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7812476,
        9040,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8010981,
        9050,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8073833,
        9070,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8555825,
        9080,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8945245,
        9090,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9611377,
        9100,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9625129,
        9111,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9866422,
        9122,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10403784,
        9130,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10960765,
        9150,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11006614,
        9151,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11404482,
        9160,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11601803,
        9170,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12008022,
        9180,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12405451,
        9190,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12665416,
        9200,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12909508,
        9220,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        13109752,
        9230,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        13555777,
        9250,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        13727747,
        9260,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        14248044,
        9271,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14433840,
        9280,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14645900,
        9291,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15048375,
        9300,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15426015,
        9320,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15680713,
        9340,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15756296,
        9350,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ]
];


const $e3870c296db043b4$export$4188226d4014f4f = [
    [
        0,
        0,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        29231,
        1,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        188836,
        5,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        199405,
        6,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        214264,
        7,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        244358,
        8,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        303079,
        9,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        314201,
        10,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        342400,
        11,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        443963,
        12,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        528470,
        13,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        687751,
        14,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        746085,
        15,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        787923,
        16,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        799302,
        17,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1205128,
        18,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1603423,
        23,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1733218,
        24,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2005673,
        25,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2436698,
        26,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3613564,
        27,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3899547,
        28,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4345767,
        29,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4876134,
        30,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5661442,
        9050,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6321619,
        9080,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6713249,
        9090,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7217907,
        9100,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7229126,
        9110,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7560558,
        9122,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8115869,
        9140,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8638103,
        9151,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9280179,
        9170,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9738717,
        9180,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10156856,
        9190,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10458576,
        9200,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10655116,
        9220,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10879371,
        9230,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11328884,
        9250,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11532856,
        9260,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11933818,
        9270,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12217535,
        9280,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        12245277,
        9281,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        12532644,
        9291,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        12876189,
        9300,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ]
];


const $5db890a7b1f78b6e$export$4188226d4014f4f = [
    [
        214356,
        4,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        392764,
        7,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        409740,
        8,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        809976,
        20,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        877581,
        24,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        879238,
        25,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        889472,
        26,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        902937,
        27,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        932751,
        28,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        991142,
        29,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1030162,
        31,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1119657,
        32,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1199282,
        33,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1342534,
        34,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1392263,
        35,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1431703,
        36,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1433369,
        37,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1490972,
        41,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2087397,
        43,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2316688,
        44,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2549864,
        45,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3925782,
        46,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3925843,
        47,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4207800,
        48,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4627944,
        49,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5124076,
        50,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5478664,
        900,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5482450,
        9000,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5584305,
        9010,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5784566,
        9030,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5879822,
        9031,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5896856,
        9032,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5897316,
        9033,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6117927,
        9050,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6210274,
        9070,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6379314,
        9080,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6979141,
        9090,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7568453,
        9100,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7766394,
        9111,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7911691,
        9120,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7968866,
        9121,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7982889,
        9122,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8514322,
        9130,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9091726,
        9140,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9091774,
        9150,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9406726,
        9160,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9921066,
        9170,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10007115,
        9180,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10480973,
        9190,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10578091,
        9200,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10678509,
        9210,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10811001,
        9220,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11096116,
        9230,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11409279,
        9250,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11584820,
        9251,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11716837,
        9260,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11876919,
        9261,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11987927,
        9270,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12077324,
        9271,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12301871,
        9280,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12604343,
        9290,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12841034,
        9300,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13128237,
        9310,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13272363,
        9320,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13483497,
        9330,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13649433,
        9340,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13761100,
        9350,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ]
];




const $01f10807b74a711e$var$NET_EXTRA = {
    westend: {
        genesisHash: [
            "0xe143f23803ac50e8f6f8e62695d1ce9e4e1d68aa36c1cd2cfd15340213f3423e"
        ]
    }
};
/** @internal */ function $01f10807b74a711e$var$mapRaw([network, versions]) {
    const chain = (0, $ed4185bd04ce3f3f$export$e19aa740f1b5be6c).find((n)=>n.network === network) || $01f10807b74a711e$var$NET_EXTRA[network];
    if (!chain) throw new Error(`Unable to find info for chain ${network}`);
    return {
        genesisHash: (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(chain.genesisHash[0]),
        network: network,
        versions: versions.map(([blockNumber, specVersion, apis])=>({
                apis: apis,
                blockNumber: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(blockNumber),
                specVersion: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(specVersion)
            }))
    };
}
const $01f10807b74a711e$export$4188226d4014f4f = Object.entries($36281b561d260678$exports).map($01f10807b74a711e$var$mapRaw);


/**
 * @description Perform the callback function using the stringified spec/chain
 * @internal
 * */ function $676c6ee87070430c$var$withNames(chainName, specName, fn) {
    return fn(chainName.toString(), specName.toString());
}
/**
 * @descriptionFflatten a VersionedType[] into a Record<string, string>
 * @internal
 * */ function $676c6ee87070430c$var$filterVersions(versions = [], specVersion) {
    return versions.filter(({ minmax: [min, max] })=>(min === undefined || min === null || specVersion >= min) && (max === undefined || max === null || specVersion <= max)).reduce((result, { types: types })=>({
            ...result,
            ...types
        }), {});
}
function $676c6ee87070430c$export$9941a79b48f71da2({ knownTypes: knownTypes }, chainName, specName) {
    return $676c6ee87070430c$var$withNames(chainName, specName, (c, s)=>({
            ...knownTypes.typesBundle?.spec?.[s]?.signedExtensions ?? {},
            ...knownTypes.typesBundle?.chain?.[c]?.signedExtensions ?? {}
        }));
}
function $676c6ee87070430c$export$c099f8c8aa80b480({ knownTypes: knownTypes }, chainName, specName, specVersion) {
    const _specVersion = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(specVersion).toNumber();
    return $676c6ee87070430c$var$withNames(chainName, specName, (c, s)=>({
            // The order here is always, based on -
            //   - spec then chain
            //   - typesBundle takes higher precedence
            //   - types is the final catch-all override
            ...$676c6ee87070430c$var$filterVersions((0, $4345e1f83d70cfce$export$29b2ac8da719c288)[s], _specVersion),
            ...$676c6ee87070430c$var$filterVersions((0, $8d34cd00dd8948d7$export$238768e5caeba982)[c], _specVersion),
            ...$676c6ee87070430c$var$filterVersions(knownTypes.typesBundle?.spec?.[s]?.types, _specVersion),
            ...$676c6ee87070430c$var$filterVersions(knownTypes.typesBundle?.chain?.[c]?.types, _specVersion),
            ...knownTypes.typesSpec?.[s] ?? {},
            ...knownTypes.typesChain?.[c] ?? {},
            ...knownTypes.types ?? {}
        }));
}
function $676c6ee87070430c$export$e4a7bf67e5bfb658({ knownTypes: knownTypes }, chainName, specName) {
    return $676c6ee87070430c$var$withNames(chainName, specName, (c, s)=>knownTypes.hasher || knownTypes.typesBundle?.chain?.[c]?.hasher || knownTypes.typesBundle?.spec?.[s]?.hasher || null);
}
function $676c6ee87070430c$export$d850d27bae1846f4({ knownTypes: knownTypes }, chainName, specName) {
    return $676c6ee87070430c$var$withNames(chainName, specName, (c, s)=>({
            ...knownTypes.typesBundle?.spec?.[s]?.rpc ?? {},
            ...knownTypes.typesBundle?.chain?.[c]?.rpc ?? {}
        }));
}
function $676c6ee87070430c$export$3ca5901d943d5d8({ knownTypes: knownTypes }, chainName, specName) {
    return $676c6ee87070430c$var$withNames(chainName, specName, (c, s)=>({
            ...knownTypes.typesBundle?.spec?.[s]?.runtime ?? {},
            ...knownTypes.typesBundle?.chain?.[c]?.runtime ?? {}
        }));
}
function $676c6ee87070430c$export$c977ced5e7aa3a56({ knownTypes: knownTypes }, chainName, specName) {
    return $676c6ee87070430c$var$withNames(chainName, specName, (c, s)=>({
            // as per versions, first spec, then chain then finally non-versioned
            ...knownTypes.typesBundle?.spec?.[s]?.alias ?? {},
            ...knownTypes.typesBundle?.chain?.[c]?.alias ?? {},
            ...knownTypes.typesAlias ?? {}
        }));
}
function $676c6ee87070430c$export$d9a776a58fa8f61b(genesisHash, blockNumber) {
    const known = (0, $01f10807b74a711e$export$4188226d4014f4f).find((u)=>genesisHash.eq(u.genesisHash));
    return known ? [
        known.versions.reduce((last, version)=>{
            return blockNumber.gt(version.blockNumber) ? version : last;
        }, undefined),
        known.versions.find((version)=>blockNumber.lte(version.blockNumber))
    ] : [
        undefined,
        undefined
    ];
}




const $89f083bc1f278e17$export$686ae79e41448444 = (0, $796b0ff58a262a5f$export$af3c031fde264cc6);
function $89f083bc1f278e17$export$2adefdc7d729f62e() {
    return (0, $796b0ff58a262a5f$export$6975dd8173b81e43)().then(()=>{
        if (!(0, $796b0ff58a262a5f$export$af3c031fde264cc6)()) throw new Error("Unable to initialize @polkadot/util-crypto");
        return true;
    }).catch(()=>false);
}







var $48816f1bc71c2145$export$f708eee25634bc80 = (0, $92bc279d37b40d11$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $d3cb2bedec36d971$export$b6bbab5a9b109038 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $d3cb2bedec36d971$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $48816f1bc71c2145$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $f88f74c37c498b34$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $efa1f973f33411e2$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $f88f74c37c498b34$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $f88f74c37c498b34$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $fa281c7f095e6bc0$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $fa281c7f095e6bc0$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $09623c854bfb7a22$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $8732e18bef00f237$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $d3cb2bedec36d971$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $8732e18bef00f237$export$77cea355fa80b5f4));
var $d3cb2bedec36d971$export$155189cde295587d = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $fa281c7f095e6bc0$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($d3cb2bedec36d971$export$b6bbab5a9b109038);


var $c083768a9df36bef$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $d3cb2bedec36d971$export$b6bbab5a9b109038));


var $3a104e7f6a5de5a7$var$isArray = Array.isArray;
var $3a104e7f6a5de5a7$var$getPrototypeOf = Object.getPrototypeOf, $3a104e7f6a5de5a7$var$objectProto = Object.prototype, $3a104e7f6a5de5a7$var$getKeys = Object.keys;
function $3a104e7f6a5de5a7$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($3a104e7f6a5de5a7$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($3a104e7f6a5de5a7$var$isPOJO(first_1)) {
            var keys = $3a104e7f6a5de5a7$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $3a104e7f6a5de5a7$var$isPOJO(obj) {
    return obj && typeof obj === "object" && $3a104e7f6a5de5a7$var$getPrototypeOf(obj) === $3a104e7f6a5de5a7$var$objectProto;
}






var $0ed9d95814b05ba5$var$isArray = Array.isArray;
function $0ed9d95814b05ba5$var$callOrApply(fn, args) {
    return $0ed9d95814b05ba5$var$isArray(args) ? fn.apply(void 0, (0, $efa1f973f33411e2$export$1216008129fb82ed)([], (0, $efa1f973f33411e2$export$8d051b38c9118094)(args))) : fn(args);
}
function $0ed9d95814b05ba5$export$559affaa48f4288d(fn) {
    return (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(function(args) {
        return $0ed9d95814b05ba5$var$callOrApply(fn, args);
    });
}



function $957deb2b2dd15d98$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $092e9fc3c37f8594$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $d7d77464a40802d3$export$29534b2f653ae592)(args);
    var resultSelector = (0, $d7d77464a40802d3$export$9ae19b645239a61b)(args);
    var _a = (0, $3a104e7f6a5de5a7$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $9451f06798fd34f2$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $8732e18bef00f237$export$77cea355fa80b5f4)($092e9fc3c37f8594$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $957deb2b2dd15d98$export$79c7e160a7743efd)(keys, values);
    } : (0, $1802c01a893130db$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $0ed9d95814b05ba5$export$559affaa48f4288d)(resultSelector)) : result;
}
function $092e9fc3c37f8594$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $1802c01a893130db$export$f0954fd7d5368655);
    return function(subscriber) {
        $092e9fc3c37f8594$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $092e9fc3c37f8594$var$maybeSchedule(scheduler, function() {
                    var source = (0, $9451f06798fd34f2$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $092e9fc3c37f8594$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}





function $9d19ec2059422f48$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $1802c01a893130db$export$f0954fd7d5368655);
}


function $2c4dcad0453ae0cb$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}



function $2fd505af5ef7bf0b$export$533b26079ad0b4b(accumulator, seed) {
    return (0, $2450271e40925995$export$871731df685d7753)((0, $2c4dcad0453ae0cb$export$30fc204bc7867c02)(accumulator, seed, arguments.length >= 2, false, true));
}



var $8f965355e5b83cb3$var$arrReducer = function(arr, value) {
    return arr.push(value), arr;
};
function $8f965355e5b83cb3$export$45b10814cc054894() {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        (0, $2fd505af5ef7bf0b$export$533b26079ad0b4b)($8f965355e5b83cb3$var$arrReducer, [])(source).subscribe(subscriber);
    });
}



function $1404998085556672$export$58416e29444cc64(result, section, getKeys, creator) {
    (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, section, ()=>(0, $bad025b936daa7ef$export$d3fc7341b317ef1a)({}, getKeys(section), (method)=>creator(section, method)));
}


var $c6e5f69bdad9c21b$exports = {};
var $ef8d552014a03090$exports = {};

$parcel$export($ef8d552014a03090$exports, "accountId", function () { return $ef8d552014a03090$export$60273ff775106be9; });





function $963d14c700537c88$var$defaultGetId() {
    return "none";
}
function $963d14c700537c88$export$fc10aeed3a532e2a(fn, { getInstanceId: getInstanceId = $963d14c700537c88$var$defaultGetId } = {}) {
    const cache = {};
    const memoized = (...args)=>{
        const stringParams = (0, $e2c4db534325025c$export$fac44ee5b035f737)(args);
        const instanceId = getInstanceId();
        if (!cache[instanceId]) cache[instanceId] = {};
        if (cache[instanceId][stringParams] === undefined) cache[instanceId][stringParams] = fn(...args);
        return cache[instanceId][stringParams];
    };
    memoized.unmemoize = (...args)=>{
        const stringParams = (0, $e2c4db534325025c$export$fac44ee5b035f737)(args);
        const instanceId = getInstanceId();
        if (cache[instanceId] && cache[instanceId][stringParams] !== undefined) delete cache[instanceId][stringParams];
    };
    return memoized;
}





function $985f81c342020fc8$export$3dede90624df3ba9(selector) {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(selector(err, $985f81c342020fc8$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}




function $1396ecb96d663d17$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $1802c01a893130db$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $1396ecb96d663d17$var$defaultCompare;
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $1396ecb96d663d17$var$defaultCompare(a, b) {
    return a === b;
}



var $06cdea910d1c4afc$export$c1895ea2d519a677 = {
    now: function() {
        return ($06cdea910d1c4afc$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $dba9b2a30b894aaf$export$915d2682b0aa0991 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $06cdea910d1c4afc$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $d3cb2bedec36d971$export$b6bbab5a9b109038));







function $b779a8a892b6cef5$export$18d0766d894cba0c() {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = (0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, undefined, undefined, undefined, function() {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) sharedConnection.unsubscribe();
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) connection = source.connect();
    });
}




var $c1f657467901e8c1$export$9038dea0172d3ba9 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if ((0, $2450271e40925995$export$ebec8610810318c5)(source)) _this.lift = source.lift;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 || _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new (0, $fa281c7f095e6bc0$export$f55210826850c514)();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subject_1, undefined, function() {
                _this._teardown();
                subject_1.complete();
            }, function(err) {
                _this._teardown();
                subject_1.error(err);
            }, function() {
                return _this._teardown();
            })));
            if (connection.closed) {
                this._connection = null;
                connection = (0, $fa281c7f095e6bc0$export$f55210826850c514).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, $b779a8a892b6cef5$export$18d0766d894cba0c)()(this);
    };
    return ConnectableObservable;
}((0, $8732e18bef00f237$export$77cea355fa80b5f4));







function $d513946ecfa4de2d$export$86a55c2f04dd8842(subscribable) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        return subscribable.subscribe(subscriber);
    });
}


var $5c9dd3a7b268ccfc$var$DEFAULT_CONFIG = {
    connector: function() {
        return new (0, $d3cb2bedec36d971$export$b6bbab5a9b109038)();
    }
};
function $5c9dd3a7b268ccfc$export$64605811ab45167f(selector, config) {
    if (config === void 0) config = $5c9dd3a7b268ccfc$var$DEFAULT_CONFIG;
    var connector = config.connector;
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var subject = connector();
        (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(selector((0, $d513946ecfa4de2d$export$86a55c2f04dd8842)(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}


function $1a77612b51043f33$export$1364843af8d5a963(subjectOrSubjectFactory, selector) {
    var subjectFactory = (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
    };
    if ((0, $cd7378a71af165cd$export$f6e2535fb5126e54)(selector)) return (0, $5c9dd3a7b268ccfc$export$64605811ab45167f)(selector, {
        connector: subjectFactory
    });
    return function(source) {
        return new (0, $c1f657467901e8c1$export$9038dea0172d3ba9)(source, subjectFactory);
    };
}



function $6b94d8a3a42e897d$export$1f3342bf81d92d52(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !(0, $cd7378a71af165cd$export$f6e2535fb5126e54)(selectorOrScheduler)) timestampProvider = selectorOrScheduler;
    var selector = (0, $cd7378a71af165cd$export$f6e2535fb5126e54)(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function(source) {
        return (0, $1a77612b51043f33$export$1364843af8d5a963)(new (0, $dba9b2a30b894aaf$export$915d2682b0aa0991)(bufferSize, windowTime, timestampProvider), selector)(source);
    };
}







var $15bbd76d6e32c0aa$export$e19cd5f9376f8cee = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $fa281c7f095e6bc0$export$f55210826850c514));



var $38bf98820721650a$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $38bf98820721650a$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $efa1f973f33411e2$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $efa1f973f33411e2$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $efa1f973f33411e2$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $efa1f973f33411e2$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $38bf98820721650a$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $02f85fb79f68a871$export$b5369ffd7cb2211b = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $38bf98820721650a$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $38bf98820721650a$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $09623c854bfb7a22$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $15bbd76d6e32c0aa$export$e19cd5f9376f8cee));



var $eb5c25b546a38562$var$nextHandle = 1;
var $eb5c25b546a38562$var$resolved;
var $eb5c25b546a38562$var$activeHandles = {};
function $eb5c25b546a38562$var$findAndClearHandle(handle) {
    if (handle in $eb5c25b546a38562$var$activeHandles) {
        delete $eb5c25b546a38562$var$activeHandles[handle];
        return true;
    }
    return false;
}
var $eb5c25b546a38562$export$9bf7f22d83f7b5af = {
    setImmediate: function(cb) {
        var handle = $eb5c25b546a38562$var$nextHandle++;
        $eb5c25b546a38562$var$activeHandles[handle] = true;
        if (!$eb5c25b546a38562$var$resolved) $eb5c25b546a38562$var$resolved = Promise.resolve();
        $eb5c25b546a38562$var$resolved.then(function() {
            return $eb5c25b546a38562$var$findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        $eb5c25b546a38562$var$findAndClearHandle(handle);
    }
};
var $eb5c25b546a38562$export$3967e9a9db29c776 = {
    pending: function() {
        return Object.keys($eb5c25b546a38562$var$activeHandles).length;
    }
};


var $32e2c3594facb728$var$setImmediate = (0, $eb5c25b546a38562$export$9bf7f22d83f7b5af).setImmediate, $32e2c3594facb728$var$clearImmediate = (0, $eb5c25b546a38562$export$9bf7f22d83f7b5af).clearImmediate;
var $32e2c3594facb728$export$24f2eaeae9bdcb7c = {
    setImmediate: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $32e2c3594facb728$export$24f2eaeae9bdcb7c.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || $32e2c3594facb728$var$setImmediate).apply(void 0, (0, $efa1f973f33411e2$export$1216008129fb82ed)([], (0, $efa1f973f33411e2$export$8d051b38c9118094)(args)));
    },
    clearImmediate: function(handle) {
        var delegate = $32e2c3594facb728$export$24f2eaeae9bdcb7c.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || $32e2c3594facb728$var$clearImmediate)(handle);
    },
    delegate: undefined
};


var $ad3eb95df9a38e1c$export$6a72523e12463e75 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, $32e2c3594facb728$export$24f2eaeae9bdcb7c).setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, $32e2c3594facb728$export$24f2eaeae9bdcb7c).clearImmediate(id);
            if (scheduler._scheduled === id) scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, $02f85fb79f68a871$export$b5369ffd7cb2211b));





var $dd554ba3f7c448dd$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $06cdea910d1c4afc$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $25dab5cae55160f8$export$4114a3ec92faa3c6 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $dd554ba3f7c448dd$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $dd554ba3f7c448dd$export$d3e54bb8584cda7c));


var $769294a7d7cece43$export$e27ac4cacb0fee33 = function(_super) {
    (0, $efa1f973f33411e2$export$a8ba968b8961cb8a)(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, $25dab5cae55160f8$export$4114a3ec92faa3c6));


var $d930030b4f73c3c6$export$25915e3b9bb42559 = new (0, $769294a7d7cece43$export$e27ac4cacb0fee33)((0, $ad3eb95df9a38e1c$export$6a72523e12463e75));
var $d930030b4f73c3c6$export$dc4d482300a341e1 = $d930030b4f73c3c6$export$25915e3b9bb42559;


function $af07b3a8f3032eab$export$80e0d6d4a808a79(delay = 1750) {
    return (source)=>{
        // state: 0 = disconnected, 1 = disconnecting, 2 = connecting, 3 = connected
        let [state, refCount, connection, scheduler] = [
            0,
            0,
            (0, $fa281c7f095e6bc0$export$f55210826850c514).EMPTY,
            (0, $fa281c7f095e6bc0$export$f55210826850c514).EMPTY
        ];
        return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)((ob)=>{
            source.subscribe(ob);
            if (refCount++ === 0) {
                if (state === 1) scheduler.unsubscribe();
                else // eslint-disable-next-line deprecation/deprecation
                connection = source.connect();
                state = 3;
            }
            return ()=>{
                if (--refCount === 0) {
                    if (state === 2) {
                        state = 0;
                        scheduler.unsubscribe();
                    } else {
                        // state === 3
                        state = 1;
                        scheduler = (0, $d930030b4f73c3c6$export$25915e3b9bb42559).schedule(()=>{
                            state = 0;
                            connection.unsubscribe();
                        }, delay);
                    }
                }
            };
        });
    };
}


function $d53961cc3e3471c7$var$CMP(a, b) {
    return (0, $e2c4db534325025c$export$fac44ee5b035f737)({
        t: a
    }) === (0, $e2c4db534325025c$export$fac44ee5b035f737)({
        t: b
    });
}
function $d53961cc3e3471c7$var$ERR(error) {
    throw error;
}
function $d53961cc3e3471c7$var$NOOP() {
// empty
}
function $d53961cc3e3471c7$export$5d0437caf0b8f08f({ delay: delay, skipChange: skipChange = false, skipTimeout: skipTimeout = false } = {}) {
    return (source$)=>source$.pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)($d53961cc3e3471c7$var$ERR), skipChange ? (0, $9d19ec2059422f48$export$3f23594af5f37336)($d53961cc3e3471c7$var$NOOP) : (0, $1396ecb96d663d17$export$779c5fb865a0172e)($d53961cc3e3471c7$var$CMP), // eslint-disable-next-line deprecation/deprecation
        (0, $6b94d8a3a42e897d$export$1f3342bf81d92d52)(1), skipTimeout ? (0, $b779a8a892b6cef5$export$18d0766d894cba0c)() : (0, $af07b3a8f3032eab$export$80e0d6d4a808a79)(delay));
}


function $ab24732a7fa90447$export$7c73462e0d25e514(instanceId, inner) {
    const options = {
        getInstanceId: ()=>instanceId
    };
    const cached = (0, $963d14c700537c88$export$fc10aeed3a532e2a)((...params)=>new (0, $8732e18bef00f237$export$77cea355fa80b5f4)((observer)=>{
            const subscription = inner(...params).subscribe(observer);
            return ()=>{
                cached.unmemoize(...params);
                subscription.unsubscribe();
            };
        }).pipe((0, $d53961cc3e3471c7$export$5d0437caf0b8f08f)()), options);
    return cached;
}


function $ef8d552014a03090$export$60273ff775106be9(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (address)=>{
        const decoded = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(address) ? address : (0, $75dfbb1cb93569bf$export$63e61a72b498228b)((address || "").toString());
        if (decoded.length > 8) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(api.registry.createType("AccountId", decoded));
        const accountIndex = api.registry.createType("AccountIndex", decoded);
        return api.derive.accounts.indexToId(accountIndex.toString()).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((a)=>(0, $7f962568317a1d97$export$5529f1223fff4d4a)(a, "Unable to retrieve accountId")));
    });
}


var $2e700eb2b3f29613$exports = {};

$parcel$export($2e700eb2b3f29613$exports, "_flags", function () { return $2e700eb2b3f29613$export$68b7a949ef236d1e; });
$parcel$export($2e700eb2b3f29613$exports, "flags", function () { return $2e700eb2b3f29613$export$ceac1d294cf61000; });



function $2e700eb2b3f29613$var$parseFlags(address, [electionsMembers, councilMembers, technicalCommitteeMembers, societyMembers, sudoKey]) {
    const addrStr = address && address.toString();
    const isIncluded = (id)=>id.toString() === addrStr;
    return {
        isCouncil: (electionsMembers?.map((r)=>Array.isArray(r) ? r[0] : r.who) || councilMembers || []).some(isIncluded),
        isSociety: (societyMembers || []).some(isIncluded),
        isSudo: sudoKey?.toString() === addrStr,
        isTechCommittee: (technicalCommitteeMembers || []).some(isIncluded)
    };
}
function $2e700eb2b3f29613$export$68b7a949ef236d1e(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>{
        const results = [
            undefined,
            [],
            [],
            [],
            undefined
        ];
        const calls = [
            (api.query.elections || api.query["phragmenElection"] || api.query["electionsPhragmen"])?.members,
            api.query.council?.members,
            api.query.technicalCommittee?.members,
            api.query.society?.members,
            api.query.sudo?.key
        ];
        const filtered = calls.filter((c)=>c);
        if (!filtered.length) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(results);
        return api.queryMulti(filtered).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((values)=>{
            let resultIndex = -1;
            for(let i = 0, count = calls.length; i < count; i++)if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(calls[i])) results[i] = values[++resultIndex];
            return results;
        }));
    });
}
function $2e700eb2b3f29613$export$ceac1d294cf61000(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (address)=>api.derive.accounts._flags().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((r)=>$2e700eb2b3f29613$var$parseFlags(address, r))));
}


var $b0577f67e1a8a25e$exports = {};

$parcel$export($b0577f67e1a8a25e$exports, "idAndIndex", function () { return $b0577f67e1a8a25e$export$58019c2d77b2aaa2; });




function $b0577f67e1a8a25e$export$58019c2d77b2aaa2(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (address)=>{
        try {
            // yes, this can fail, don't care too much, catch will catch it
            const decoded = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(address) ? address : (0, $75dfbb1cb93569bf$export$63e61a72b498228b)((address || "").toString());
            if (decoded.length > 8) {
                const accountId = api.registry.createType("AccountId", decoded);
                return api.derive.accounts.idToIndex(accountId).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((accountIndex)=>[
                        accountId,
                        accountIndex
                    ]));
            }
            const accountIndex = api.registry.createType("AccountIndex", decoded);
            return api.derive.accounts.indexToId(accountIndex.toString()).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((accountId)=>[
                    accountId,
                    accountIndex
                ]));
        } catch  {
            return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
                undefined,
                undefined
            ]);
        }
    });
}


var $57084c9a4af7d207$exports = {};

$parcel$export($57084c9a4af7d207$exports, "_identity", function () { return $57084c9a4af7d207$export$81db620afe0b16c1; });
$parcel$export($57084c9a4af7d207$exports, "identity", function () { return $57084c9a4af7d207$export$f0954fd7d5368655; });
$parcel$export($57084c9a4af7d207$exports, "hasIdentity", function () { return $57084c9a4af7d207$export$4db8ec76a216de02; });
$parcel$export($57084c9a4af7d207$exports, "hasIdentityMulti", function () { return $57084c9a4af7d207$export$85bfa4dd89a1387d; });




function $4cbfbf6045db21e5$export$ee780b122c05d452(obs) {
    return obs.pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([a])=>a));
}
function $4cbfbf6045db21e5$export$6937bf188da273fb(fn) {
    return (instanceId, api)=>(0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (...args)=>$4cbfbf6045db21e5$export$ee780b122c05d452(fn(api, ...args)));
}


const $57084c9a4af7d207$var$UNDEF_HEX = {
    toHex: ()=>undefined
};
function $57084c9a4af7d207$var$dataAsString(data) {
    return data.isRaw ? (0, $20f3a615a221edb7$export$792464756f58046b)(data.asRaw.toU8a(true)) : data.isNone ? undefined : data.toHex();
}
function $57084c9a4af7d207$var$extractOther(additional) {
    return additional.reduce((other, [_key, _value])=>{
        const key = $57084c9a4af7d207$var$dataAsString(_key);
        const value = $57084c9a4af7d207$var$dataAsString(_value);
        if (key && value) other[key] = value;
        return other;
    }, {});
}
function $57084c9a4af7d207$var$extractIdentity(identityOfOpt, superOf) {
    if (!identityOfOpt?.isSome) return {
        judgements: []
    };
    const { info: info, judgements: judgements } = identityOfOpt.unwrap();
    const topDisplay = $57084c9a4af7d207$var$dataAsString(info.display);
    return {
        display: superOf && $57084c9a4af7d207$var$dataAsString(superOf[1]) || topDisplay,
        displayParent: superOf && topDisplay,
        email: $57084c9a4af7d207$var$dataAsString(info.email),
        image: $57084c9a4af7d207$var$dataAsString(info.image),
        judgements: judgements,
        legal: $57084c9a4af7d207$var$dataAsString(info.legal),
        other: $57084c9a4af7d207$var$extractOther(info.additional),
        parent: superOf && superOf[0],
        pgp: info.pgpFingerprint.unwrapOr($57084c9a4af7d207$var$UNDEF_HEX).toHex(),
        riot: $57084c9a4af7d207$var$dataAsString(info.riot),
        twitter: $57084c9a4af7d207$var$dataAsString(info.twitter),
        web: $57084c9a4af7d207$var$dataAsString(info.web)
    };
}
function $57084c9a4af7d207$var$getParent(api, identityOfOpt, superOfOpt) {
    if (identityOfOpt?.isSome) // this identity has something set
    return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
        identityOfOpt,
        undefined
    ]);
    else if (superOfOpt?.isSome) {
        const superOf = superOfOpt.unwrap();
        return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.accounts._identity(superOf[0]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([info])=>info)),
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(superOf)
        ]);
    }
    // nothing of value returned
    return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
        undefined,
        undefined
    ]);
}
function $57084c9a4af7d207$export$81db620afe0b16c1(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId)=>accountId && api.query.identity?.identityOf ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.query.identity.identityOf(accountId),
            api.query.identity.superOf(accountId)
        ]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
            undefined,
            undefined
        ]));
}
function $57084c9a4af7d207$export$f0954fd7d5368655(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId)=>api.derive.accounts._identity(accountId).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([identityOfOpt, superOfOpt])=>$57084c9a4af7d207$var$getParent(api, identityOfOpt, superOfOpt)), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([identityOfOpt, superOf])=>$57084c9a4af7d207$var$extractIdentity(identityOfOpt, superOf))));
}
const $57084c9a4af7d207$export$4db8ec76a216de02 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId)=>api.derive.accounts.hasIdentityMulti([
        accountId
    ]));
function $57084c9a4af7d207$export$85bfa4dd89a1387d(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds)=>api.query.identity?.identityOf ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.query.identity.identityOf.multi(accountIds),
            api.query.identity.superOf.multi(accountIds)
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([identities, supers])=>identities.map((identityOfOpt, index)=>{
                const superOfOpt = supers[index];
                const parentId = superOfOpt && superOfOpt.isSome ? superOfOpt.unwrap()[0].toString() : undefined;
                let display;
                if (identityOfOpt && identityOfOpt.isSome) {
                    const value = $57084c9a4af7d207$var$dataAsString(identityOfOpt.unwrap().info.display);
                    if (value && !(0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value)) display = value;
                }
                return {
                    display: display,
                    hasIdentity: !!(display || parentId),
                    parentId: parentId
                };
            }))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(accountIds.map(()=>({
                hasIdentity: false
            }))));
}


var $07545929d12dff06$exports = {};

$parcel$export($07545929d12dff06$exports, "idToIndex", function () { return $07545929d12dff06$export$7a72108a26533ef9; });


function $07545929d12dff06$export$7a72108a26533ef9(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId)=>api.derive.accounts.indexes().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((indexes)=>(indexes || {})[accountId.toString()])));
}


var $9bcf9c76a367bee6$exports = {};

$parcel$export($9bcf9c76a367bee6$exports, "indexes", function () { return $9bcf9c76a367bee6$export$8b04ba635e5803cd; });






function $b6c26c25f3cfcdda$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $a1bc2941fd3c7e1b$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $e118cd4880428984$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $cd7378a71af165cd$export$f6e2535fb5126e54)(resultSelector)) return $e118cd4880428984$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $2d91ca4f021570a0$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        return (0, $b6c26c25f3cfcdda$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $b662db4e1b31e1d7$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $e118cd4880428984$export$6b9f6c0d32c093f9)((0, $1802c01a893130db$export$f0954fd7d5368655), concurrent);
}


function $217c1a6a12233999$export$b314777ae20abca9() {
    return (0, $b662db4e1b31e1d7$export$18aef43295bbe906)(1);
}




function $4b8649f788835ea5$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $217c1a6a12233999$export$b314777ae20abca9)()((0, $9451f06798fd34f2$export$6788812c4e6611e6)(args, (0, $d7d77464a40802d3$export$29534b2f653ae592)(args)));
}




function $fa2edaed0b135380$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $d7d77464a40802d3$export$29534b2f653ae592)(values);
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $4b8649f788835ea5$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $4b8649f788835ea5$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}



let $9bcf9c76a367bee6$var$indicesCache = null;
function $9bcf9c76a367bee6$var$queryAccounts(api) {
    return api.query.indices.accounts.entries().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((entries)=>entries.reduce((indexes, [key, idOpt])=>{
            if (idOpt.isSome) indexes[idOpt.unwrap()[0].toString()] = api.registry.createType("AccountIndex", key.args[0]);
            return indexes;
        }, {})));
}
function $9bcf9c76a367bee6$export$8b04ba635e5803cd(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>$9bcf9c76a367bee6$var$indicesCache ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)($9bcf9c76a367bee6$var$indicesCache) : (api.query.indices ? $9bcf9c76a367bee6$var$queryAccounts(api).pipe((0, $fa2edaed0b135380$export$a4fe86229b0e9bdd)({})) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({})).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((indices)=>{
            $9bcf9c76a367bee6$var$indicesCache = indices;
            return indices;
        })));
}


var $c428e43af02e9e42$exports = {};

$parcel$export($c428e43af02e9e42$exports, "indexToId", function () { return $c428e43af02e9e42$export$d6fa1e70f56d6cf2; });


function $c428e43af02e9e42$export$d6fa1e70f56d6cf2(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIndex)=>api.query.indices ? api.query.indices.accounts(accountIndex).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((optResult)=>optResult.unwrapOr([])[0])) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(undefined));
}


var $ed80e6e6a3f720b0$exports = {};

$parcel$export($ed80e6e6a3f720b0$exports, "info", function () { return $ed80e6e6a3f720b0$export$a80b3bd66acc52ff; });



function $ed80e6e6a3f720b0$var$retrieveNick(api, accountId) {
    return (accountId && api.query["nicks"]?.["nameOf"] ? api.query["nicks"]["nameOf"](accountId) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(undefined)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((nameOf)=>nameOf?.isSome ? (0, $20f3a615a221edb7$export$792464756f58046b)(nameOf.unwrap()[0]).substring(0, api.consts["nicks"]["maxLength"].toNumber()) : undefined));
}
function $ed80e6e6a3f720b0$export$a80b3bd66acc52ff(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (address)=>api.derive.accounts.idAndIndex(address).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([accountId, accountIndex])=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({
                    accountId: accountId,
                    accountIndex: accountIndex
                }),
                api.derive.accounts.identity(accountId),
                $ed80e6e6a3f720b0$var$retrieveNick(api, accountId)
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([{ accountId: accountId, accountIndex: accountIndex }, identity, nickname])=>({
                accountId: accountId,
                accountIndex: accountIndex,
                identity: identity,
                nickname: nickname
            }))));
}


$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $ef8d552014a03090$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $2e700eb2b3f29613$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $b0577f67e1a8a25e$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $57084c9a4af7d207$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $07545929d12dff06$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $9bcf9c76a367bee6$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $c428e43af02e9e42$exports);
$parcel$exportWildcard($c6e5f69bdad9c21b$exports, $ed80e6e6a3f720b0$exports);


var $cb487c4777b5c118$exports = {};

$parcel$export($cb487c4777b5c118$exports, "members", function () { return $cb487c4777b5c118$export$100ad4af8c8d544f; });
$parcel$export($cb487c4777b5c118$exports, "hasProposals", function () { return $cb487c4777b5c118$export$bb89e61a247f7297; });
$parcel$export($cb487c4777b5c118$exports, "proposal", function () { return $cb487c4777b5c118$export$2ce2edfe63bacbbd; });
$parcel$export($cb487c4777b5c118$exports, "proposalCount", function () { return $cb487c4777b5c118$export$376b9c225e2427fa; });
$parcel$export($cb487c4777b5c118$exports, "proposalHashes", function () { return $cb487c4777b5c118$export$eaa0407513beb83b; });
$parcel$export($cb487c4777b5c118$exports, "proposals", function () { return $cb487c4777b5c118$export$803aac3a222d8bb8; });
$parcel$export($cb487c4777b5c118$exports, "prime", function () { return $cb487c4777b5c118$export$1cac00b2a622912a; });






function $20cc9c5dca62b955$export$8bedcca5bbd73999(api, section) {
    const instances = api.registry.getModuleInstances(api.runtimeVersion.specName, section);
    const name = instances && instances.length ? instances[0] : section;
    return api.query[name];
}
function $20cc9c5dca62b955$export$bb25039cd4f6c691(section, fn) {
    return (instanceId, api)=>(0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, fn($20cc9c5dca62b955$export$8bedcca5bbd73999(api, section), api, instanceId));
}
function $20cc9c5dca62b955$export$5f8b9ade8eca3144(method, empty) {
    return (section)=>$20cc9c5dca62b955$export$bb25039cd4f6c691(section, (query)=>()=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(query?.[method]) ? query[method]() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(empty));
}


function $70904c3fcdd7e3b2$var$parse(api, [hashes, proposals, votes]) {
    return proposals.map((o, index)=>({
            hash: api.registry.createType("Hash", hashes[index]),
            proposal: o && o.isSome ? o.unwrap() : null,
            votes: votes[index].unwrapOr(null)
        }));
}
function $70904c3fcdd7e3b2$var$_proposalsFrom(api, query, hashes) {
    return ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(query?.proposals) && hashes.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(hashes),
        // this should simply be api.query[section].proposalOf.multi<Option<Proposal>>(hashes),
        // however we have had cases on Edgeware where the indices have moved around after an
        // upgrade, which results in invalid on-chain data
        query.proposalOf.multi(hashes).pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)(()=>(0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(hashes.map(()=>null)))),
        query.voting.multi(hashes)
    ]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
        [],
        [],
        []
    ])).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((r)=>$70904c3fcdd7e3b2$var$parse(api, r)));
}
function $70904c3fcdd7e3b2$export$bb89e61a247f7297(section) {
    return (0, $20cc9c5dca62b955$export$bb25039cd4f6c691)(section, (query)=>()=>(0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(query?.proposals)));
}
function $70904c3fcdd7e3b2$export$803aac3a222d8bb8(section) {
    return (0, $20cc9c5dca62b955$export$bb25039cd4f6c691)(section, (query, api)=>()=>api.derive[section].proposalHashes().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((all)=>$70904c3fcdd7e3b2$var$_proposalsFrom(api, query, all))));
}
function $70904c3fcdd7e3b2$export$2ce2edfe63bacbbd(section) {
    return (0, $20cc9c5dca62b955$export$bb25039cd4f6c691)(section, (query, api)=>(hash)=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(query?.proposals) ? (0, $4cbfbf6045db21e5$export$ee780b122c05d452)($70904c3fcdd7e3b2$var$_proposalsFrom(api, query, [
                hash
            ])) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null));
}
const $70904c3fcdd7e3b2$export$376b9c225e2427fa = /*#__PURE__*/ (0, $20cc9c5dca62b955$export$5f8b9ade8eca3144)("proposalCount", null);
const $70904c3fcdd7e3b2$export$eaa0407513beb83b = /*#__PURE__*/ (0, $20cc9c5dca62b955$export$5f8b9ade8eca3144)("proposals", []);


const $f072415ace5e2936$export$100ad4af8c8d544f = /*#__PURE__*/ (0, $20cc9c5dca62b955$export$5f8b9ade8eca3144)("members", []);




function $0a21f0df368cf435$export$1cac00b2a622912a(section) {
    return (0, $20cc9c5dca62b955$export$bb25039cd4f6c691)(section, (query)=>()=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(query?.prime) ? query.prime().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((o)=>o.unwrapOr(null))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null));
}


const $cb487c4777b5c118$export$100ad4af8c8d544f = /*#__PURE__*/ (0, $f072415ace5e2936$export$100ad4af8c8d544f)("allianceMotion");
const $cb487c4777b5c118$export$bb89e61a247f7297 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$bb89e61a247f7297)("allianceMotion");
const $cb487c4777b5c118$export$2ce2edfe63bacbbd = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$2ce2edfe63bacbbd)("allianceMotion");
const $cb487c4777b5c118$export$376b9c225e2427fa = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$376b9c225e2427fa)("allianceMotion");
const $cb487c4777b5c118$export$eaa0407513beb83b = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$eaa0407513beb83b)("allianceMotion");
const $cb487c4777b5c118$export$803aac3a222d8bb8 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$803aac3a222d8bb8)("allianceMotion");
const $cb487c4777b5c118$export$1cac00b2a622912a = /*#__PURE__*/ (0, $0a21f0df368cf435$export$1cac00b2a622912a)("allianceMotion");


var $e70acc60895c8c2a$exports = {};
var $474c80684cdd87f4$exports = {};

$parcel$export($474c80684cdd87f4$exports, "_getIds", function () { return $474c80684cdd87f4$export$fdac0b2613d7815c; });
$parcel$export($474c80684cdd87f4$exports, "all", function () { return $474c80684cdd87f4$export$84bf76cd7afc7469; });
$parcel$export($474c80684cdd87f4$exports, "get", function () { return $474c80684cdd87f4$export$3988ae62b71be9a3; });



function $9c647a33dee19ccb$export$e2a40d0283d5e9ff(api) {
    return(// latest substrate & polkadot
    api.query.voterList || // previous substrate
    api.query["voterBagsList"] || api.query["bagsList"]);
}


function $474c80684cdd87f4$var$orderBags(ids, bags) {
    const sorted = ids.map((id, index)=>({
            bag: bags[index].unwrapOr(null),
            id: id,
            key: id.toString()
        })).sort((a, b)=>b.id.cmp(a.id));
    const max = sorted.length - 1;
    return sorted.map((entry, index)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(entry, {
            bagLower: index === max ? (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa) : sorted[index + 1].id,
            bagUpper: entry.id,
            index: index
        }));
}
function $474c80684cdd87f4$export$fdac0b2613d7815c(instanceId, api) {
    const query = (0, $9c647a33dee19ccb$export$e2a40d0283d5e9ff)(api);
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (_ids)=>{
        const ids = _ids.map((id)=>(0, $fee06eacc361490f$export$3ce10b692b02dcbb)(id));
        return ids.length ? query.listBags.multi(ids).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((bags)=>$474c80684cdd87f4$var$orderBags(ids, bags))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]);
    });
}
function $474c80684cdd87f4$export$84bf76cd7afc7469(instanceId, api) {
    const query = (0, $9c647a33dee19ccb$export$e2a40d0283d5e9ff)(api);
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>query.listBags.keys().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((keys)=>api.derive.bagsList._getIds(keys.map(({ args: [id] })=>id))), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((list)=>list.filter(({ bag: bag })=>bag))));
}
function $474c80684cdd87f4$export$3988ae62b71be9a3(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (id)=>api.derive.bagsList._getIds([
            (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(id)
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((bags)=>bags[0])));
}


var $637cdfe08c6d601d$exports = {};

$parcel$export($637cdfe08c6d601d$exports, "expand", function () { return $637cdfe08c6d601d$export$9f77e0932fb78f72; });
$parcel$export($637cdfe08c6d601d$exports, "getExpanded", function () { return $637cdfe08c6d601d$export$536dc91e674be53; });



function $637cdfe08c6d601d$export$9f77e0932fb78f72(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (bag)=>api.derive.bagsList.listNodes(bag.bag).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((nodes)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                nodes: nodes
            }, bag))));
}
function $637cdfe08c6d601d$export$536dc91e674be53(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (id)=>api.derive.bagsList.get(id).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((bag)=>api.derive.bagsList.expand(bag))));
}


var $cf44c17f9ae0b736$exports = {};

$parcel$export($cf44c17f9ae0b736$exports, "listNodes", function () { return $cf44c17f9ae0b736$export$d63fdde0fce6fec5; });

/**
 * @name nextTick
 * @description Defer the operation to the queue for evaluation on the next tick
 */ function $1d2b78a8676f560d$export$bdd553fddd433dcb(onExec, onError) {
    // While Promise.resolve().then(...) would defer to the nextTick, this
    // actually does not play as nicely in browsers like the setTimeout(...)
    // approach. So the safer, though less optimal approach is the one taken here
    setTimeout(()=>{
        Promise.resolve().then(()=>{
            onExec();
        }).catch((error)=>{
            if (onError) onError(error);
            else console.error(error);
        });
    }, 0);
}




function $cf44c17f9ae0b736$var$traverseLinks(api, head) {
    const subject = new (0, $c083768a9df36bef$export$cc3d42e6b2b9cf8b)(head);
    const query = (0, $9c647a33dee19ccb$export$e2a40d0283d5e9ff)(api);
    return subject.pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((account)=>query.listNodes(account)), (0, $9d19ec2059422f48$export$3f23594af5f37336)((node)=>{
        (0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>{
            node.isSome && node.value.next.isSome ? subject.next(node.unwrap().next.unwrap()) : subject.complete();
        });
    }), (0, $8f965355e5b83cb3$export$45b10814cc054894)(), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((all)=>all.map((o)=>o.unwrap())));
}
function $cf44c17f9ae0b736$export$d63fdde0fce6fec5(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (bag)=>bag && bag.head.isSome ? $cf44c17f9ae0b736$var$traverseLinks(api, bag.head.unwrap()) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


$parcel$exportWildcard($e70acc60895c8c2a$exports, $474c80684cdd87f4$exports);
$parcel$exportWildcard($e70acc60895c8c2a$exports, $637cdfe08c6d601d$exports);
$parcel$exportWildcard($e70acc60895c8c2a$exports, $cf44c17f9ae0b736$exports);


var $39d3a389d3c41bff$exports = {};

$parcel$export($39d3a389d3c41bff$exports, "votingBalance", function () { return $39d3a389d3c41bff$export$c2e44b11f9043ae2; });
$parcel$export($39d3a389d3c41bff$exports, "all", function () { return $ac080532faffca7a$export$84bf76cd7afc7469; });


var $hWfed = parcelRequire("hWfed");/** @internal */ function $1480a958cef004a8$export$7be79edbadaba65a(cmp) {
    return (...items)=>{
        const count = items.length;
        if (count === 0) throw new Error("Must provide one or more arguments");
        let result = items[0];
        for(let i = 1; i < count; i++)if (cmp(items[i], result)) result = items[i];
        return result;
    };
}


const $5bd17043f25a0c5f$export$2f088284d5380a8f = /*#__PURE__*/ (0, $1480a958cef004a8$export$7be79edbadaba65a)((a, b)=>a.gt(b));
const $5bd17043f25a0c5f$export$4d1b627addcbf3a5 = /*#__PURE__*/ (0, $1480a958cef004a8$export$7be79edbadaba65a)((a, b)=>a.lt(b));



const $ac080532faffca7a$var$VESTING_ID = "0x76657374696e6720";
function $ac080532faffca7a$var$calcLocked(api, bestNumber, locks) {
    let lockedBalance = api.registry.createType("Balance");
    let lockedBreakdown = [];
    let vestingLocked = api.registry.createType("Balance");
    let allLocked = false;
    if (Array.isArray(locks)) {
        // only get the locks that are valid until passed the current block
        lockedBreakdown = locks.filter(({ until: until })=>!until || bestNumber && until.gt(bestNumber));
        allLocked = lockedBreakdown.some(({ amount: amount })=>amount && amount.isMax());
        vestingLocked = api.registry.createType("Balance", lockedBreakdown.filter(({ id: id })=>id.eq($ac080532faffca7a$var$VESTING_ID)).reduce((result, { amount: amount })=>result.iadd(amount), new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0)));
        // get the maximum of the locks according to https://github.com/paritytech/substrate/blob/master/srml/balances/src/lib.rs#L699
        const notAll = lockedBreakdown.filter(({ amount: amount })=>amount && !amount.isMax());
        if (notAll.length) lockedBalance = api.registry.createType("Balance", (0, $5bd17043f25a0c5f$export$2f088284d5380a8f)(...notAll.map(({ amount: amount })=>amount)));
    }
    return {
        allLocked: allLocked,
        lockedBalance: lockedBalance,
        lockedBreakdown: lockedBreakdown,
        vestingLocked: vestingLocked
    };
}
function $ac080532faffca7a$var$calcShared(api, bestNumber, data, locks) {
    const { allLocked: allLocked, lockedBalance: lockedBalance, lockedBreakdown: lockedBreakdown, vestingLocked: vestingLocked } = $ac080532faffca7a$var$calcLocked(api, bestNumber, locks);
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, data, {
        availableBalance: api.registry.createType("Balance", allLocked ? 0 : (0, $5bd17043f25a0c5f$export$2f088284d5380a8f)(new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0), data?.freeBalance ? data.freeBalance.sub(lockedBalance) : new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0))),
        lockedBalance: lockedBalance,
        lockedBreakdown: lockedBreakdown,
        vestingLocked: vestingLocked
    });
}
function $ac080532faffca7a$var$calcVesting(bestNumber, shared, _vesting) {
    // Calculate the vesting balances,
    //  - offset = balance locked at startingBlock
    //  - perBlock is the unlock amount
    const vesting = _vesting || [];
    const isVesting = !shared.vestingLocked.isZero();
    const vestedBalances = vesting.map(({ locked: locked, perBlock: perBlock, startingBlock: startingBlock })=>bestNumber.gt(startingBlock) ? (0, $5bd17043f25a0c5f$export$4d1b627addcbf3a5)(locked, perBlock.mul(bestNumber.sub(startingBlock))) : (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa));
    const vestedBalance = vestedBalances.reduce((all, value)=>all.iadd(value), new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0));
    const vestingTotal = vesting.reduce((all, { locked: locked })=>all.iadd(locked), new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0));
    return {
        isVesting: isVesting,
        vestedBalance: vestedBalance,
        vestedClaimable: isVesting ? shared.vestingLocked.sub(vestingTotal.sub(vestedBalance)) : (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa),
        vesting: vesting.map(({ locked: locked, perBlock: perBlock, startingBlock: startingBlock }, index)=>({
                endBlock: locked.div(perBlock).iadd(startingBlock),
                locked: locked,
                perBlock: perBlock,
                startingBlock: startingBlock,
                vested: vestedBalances[index]
            })).filter(({ locked: locked })=>!locked.isZero()),
        vestingTotal: vestingTotal
    };
}
function $ac080532faffca7a$var$calcBalances(api, result) {
    const [data, [vesting, allLocks, namedReserves], bestNumber] = result;
    const shared = $ac080532faffca7a$var$calcShared(api, bestNumber, data, allLocks[0]);
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(shared, $ac080532faffca7a$var$calcVesting(bestNumber, shared, vesting), {
        accountId: data.accountId,
        accountNonce: data.accountNonce,
        additional: allLocks.slice(1).map((l, index)=>$ac080532faffca7a$var$calcShared(api, bestNumber, data.additional[index], l)),
        namedReserves: namedReserves
    });
}
function $ac080532faffca7a$var$queryOld(api, accountId) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query.balances.locks(accountId),
        api.query.balances["vesting"](accountId)
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([locks, optVesting])=>{
        let vestingNew = null;
        if (optVesting.isSome) {
            const { offset: locked, perBlock: perBlock, startingBlock: startingBlock } = optVesting.unwrap();
            vestingNew = api.registry.createType("VestingInfo", {
                locked: locked,
                perBlock: perBlock,
                startingBlock: startingBlock
            });
        }
        return [
            vestingNew ? [
                vestingNew
            ] : null,
            [
                locks
            ],
            []
        ];
    }));
}
const $ac080532faffca7a$var$isNonNullable = (nullable)=>!!nullable;
function $ac080532faffca7a$var$createCalls(calls) {
    return [
        calls.map((c)=>!c),
        calls.filter($ac080532faffca7a$var$isNonNullable)
    ];
}
function $ac080532faffca7a$var$queryCurrent(api, accountId, balanceInstances = [
    "balances"
]) {
    const [lockEmpty, lockQueries] = $ac080532faffca7a$var$createCalls(balanceInstances.map((m)=>api.derive[m]?.customLocks || api.query[m]?.locks));
    const [reserveEmpty, reserveQueries] = $ac080532faffca7a$var$createCalls(balanceInstances.map((m)=>api.query[m]?.reserves));
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query.vesting?.vesting ? api.query.vesting.vesting(accountId) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(api.registry.createType("Option<VestingInfo>")),
        lockQueries.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(lockQueries.map((c)=>c(accountId))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]),
        reserveQueries.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(reserveQueries.map((c)=>c(accountId))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([opt, locks, reserves])=>{
        let offsetLock = -1;
        let offsetReserve = -1;
        const vesting = opt.unwrapOr(null);
        return [
            vesting ? Array.isArray(vesting) ? vesting : [
                vesting
            ] : null,
            lockEmpty.map((e)=>e ? api.registry.createType("Vec<BalanceLock>") : locks[++offsetLock]),
            reserveEmpty.map((e)=>e ? api.registry.createType("Vec<PalletBalancesReserveData>") : reserves[++offsetReserve])
        ];
    }));
}
function $ac080532faffca7a$export$84bf76cd7afc7469(instanceId, api) {
    const balanceInstances = api.registry.getModuleInstances(api.runtimeVersion.specName, "balances");
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (address)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.balances.account(address),
            (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.system?.account) || (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.balances?.account) ? $ac080532faffca7a$var$queryCurrent(api, address, balanceInstances) : $ac080532faffca7a$var$queryOld(api, address)
        ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([account, locks])=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(account),
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(locks),
                api.derive.chain.bestNumber()
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((result)=>$ac080532faffca7a$var$calcBalances(api, result))));
}


var $163207baede4c64e$exports = {};

$parcel$export($163207baede4c64e$exports, "account", function () { return $163207baede4c64e$export$6b501c78a3684162; });



function $163207baede4c64e$var$zeroBalance(api) {
    return api.registry.createType("Balance");
}
function $163207baede4c64e$var$getBalance(api, [freeBalance, reservedBalance, frozenFee, frozenMisc]) {
    const votingBalance = api.registry.createType("Balance", freeBalance.toBn());
    return {
        freeBalance: freeBalance,
        frozenFee: frozenFee,
        frozenMisc: frozenMisc,
        reservedBalance: reservedBalance,
        votingBalance: votingBalance
    };
}
function $163207baede4c64e$var$calcBalances(api, [accountId, [accountNonce, [primary, ...additional]]]) {
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
        accountId: accountId,
        accountNonce: accountNonce,
        additional: additional.map((b)=>$163207baede4c64e$var$getBalance(api, b))
    }, $163207baede4c64e$var$getBalance(api, primary));
}
function $163207baede4c64e$var$queryBalancesFree(api, accountId) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query.balances["freeBalance"](accountId),
        api.query.balances["reservedBalance"](accountId),
        api.query.system["accountNonce"](accountId)
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([freeBalance, reservedBalance, accountNonce])=>[
            accountNonce,
            [
                [
                    freeBalance,
                    reservedBalance,
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api)
                ]
            ]
        ]));
}
function $163207baede4c64e$var$queryNonceOnly(api, accountId) {
    const fill = (nonce)=>[
            nonce,
            [
                [
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api)
                ]
            ]
        ];
    return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.system.account) ? api.query.system.account(accountId).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(({ nonce: nonce })=>fill(nonce))) : (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.system["accountNonce"]) ? api.query.system["accountNonce"](accountId).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((nonce)=>fill(nonce))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(fill(api.registry.createType("Index")));
}
function $163207baede4c64e$var$queryBalancesAccount(api, accountId, modules = [
    "balances"
]) {
    const balances = modules.map((m)=>api.derive[m]?.customAccount || api.query[m]?.account).filter((q)=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(q));
    const extract = (nonce, data)=>[
            nonce,
            data.map(({ feeFrozen: feeFrozen, free: free, miscFrozen: miscFrozen, reserved: reserved })=>[
                    free,
                    reserved,
                    feeFrozen,
                    miscFrozen
                ])
        ];
    // NOTE this is for the first case where we do have instances specified
    return balances.length ? (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.system.account) ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query.system.account(accountId),
        ...balances.map((c)=>c(accountId))
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([{ nonce: nonce }, ...balances])=>extract(nonce, balances))) : (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query.system["accountNonce"](accountId),
        ...balances.map((c)=>c(accountId))
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([nonce, ...balances])=>extract(nonce, balances))) : $163207baede4c64e$var$queryNonceOnly(api, accountId);
}
function $163207baede4c64e$var$querySystemAccount(api, accountId) {
    // AccountInfo is current, support old, eg. Edgeware
    return api.query.system.account(accountId).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((infoOrTuple)=>{
        const data = infoOrTuple.nonce ? infoOrTuple.data : infoOrTuple[1];
        const nonce = infoOrTuple.nonce || infoOrTuple[0];
        if (!data || data.isEmpty) return [
            nonce,
            [
                [
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api),
                    $163207baede4c64e$var$zeroBalance(api)
                ]
            ]
        ];
        const { feeFrozen: feeFrozen, free: free, miscFrozen: miscFrozen, reserved: reserved } = data;
        return [
            nonce,
            [
                [
                    free,
                    reserved,
                    feeFrozen,
                    miscFrozen
                ]
            ]
        ];
    }));
}
function $163207baede4c64e$export$6b501c78a3684162(instanceId, api) {
    const balanceInstances = api.registry.getModuleInstances(api.runtimeVersion.specName, "balances");
    const nonDefaultBalances = balanceInstances && balanceInstances[0] !== "balances";
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (address)=>api.derive.accounts.accountId(address).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((accountId)=>accountId ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(accountId),
                nonDefaultBalances ? $163207baede4c64e$var$queryBalancesAccount(api, accountId, balanceInstances) : (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.system?.account) ? $163207baede4c64e$var$querySystemAccount(api, accountId) : (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.balances?.account) ? $163207baede4c64e$var$queryBalancesAccount(api, accountId) : (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.balances?.["freeBalance"]) ? $163207baede4c64e$var$queryBalancesFree(api, accountId) : $163207baede4c64e$var$queryNonceOnly(api, accountId)
            ]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
                api.registry.createType("AccountId"),
                [
                    api.registry.createType("Index"),
                    [
                        [
                            $163207baede4c64e$var$zeroBalance(api),
                            $163207baede4c64e$var$zeroBalance(api),
                            $163207baede4c64e$var$zeroBalance(api),
                            $163207baede4c64e$var$zeroBalance(api)
                        ]
                    ]
                ]
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((result)=>$163207baede4c64e$var$calcBalances(api, result))));
}


var $54a9d3d304c1ed92$exports = {};

$parcel$export($54a9d3d304c1ed92$exports, "votingBalances", function () { return $54a9d3d304c1ed92$export$e102350b65cdb8fd; });


function $54a9d3d304c1ed92$export$e102350b65cdb8fd(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (addresses)=>!addresses || !addresses.length ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]) : (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(addresses.map((accountId)=>api.derive.balances.account(accountId))));
}


const $39d3a389d3c41bff$export$c2e44b11f9043ae2 = (0, $ac080532faffca7a$export$84bf76cd7afc7469);
$parcel$exportWildcard($39d3a389d3c41bff$exports, $163207baede4c64e$exports);
$parcel$exportWildcard($39d3a389d3c41bff$exports, $54a9d3d304c1ed92$exports);


var $bad1e7a0a8a9dfd5$exports = {};
var $bf7ab9cd64050e58$exports = {};

$parcel$export($bf7ab9cd64050e58$exports, "bounties", function () { return $bf7ab9cd64050e58$export$35ae93ba99dcf22b; });


function $9d9bb1897197dfd9$export$cb5697c3c60337f3(api, allProposals) {
    const bountyTxBase = api.tx.bounties ? api.tx.bounties : api.tx.treasury;
    const bountyProposalCalls = [
        bountyTxBase.approveBounty,
        bountyTxBase.closeBounty,
        bountyTxBase.proposeCurator,
        bountyTxBase.unassignCurator
    ];
    return allProposals.filter((proposal)=>bountyProposalCalls.find((bountyCall)=>proposal.proposal && bountyCall.is(proposal.proposal)));
}


function $bf7ab9cd64050e58$var$parseResult([maybeBounties, maybeDescriptions, ids, bountyProposals]) {
    const bounties = [];
    maybeBounties.forEach((bounty, index)=>{
        if (bounty.isSome) bounties.push({
            bounty: bounty.unwrap(),
            description: maybeDescriptions[index].unwrapOrDefault().toUtf8(),
            index: ids[index],
            proposals: bountyProposals.filter((bountyProposal)=>bountyProposal.proposal && ids[index].eq(bountyProposal.proposal.args[0]))
        });
    });
    return bounties;
}
function $bf7ab9cd64050e58$export$35ae93ba99dcf22b(instanceId, api) {
    const bountyBase = api.query.bounties || api.query.treasury;
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>bountyBase.bounties ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            bountyBase.bountyCount(),
            api.query.council ? api.query.council.proposalCount() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(0)
        ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(()=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                bountyBase.bounties.keys(),
                api.derive.council ? api.derive.council.proposals() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])
            ])), (0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([keys, proposals])=>{
            const ids = keys.map(({ args: [id] })=>id);
            return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                bountyBase.bounties.multi(ids),
                bountyBase.bountyDescriptions.multi(ids),
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(ids),
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)((0, $9d9bb1897197dfd9$export$cb5697c3c60337f3)(api, proposals))
            ]);
        }), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)($bf7ab9cd64050e58$var$parseResult)) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)($bf7ab9cd64050e58$var$parseResult([
            [],
            [],
            [],
            []
        ])));
}


$parcel$exportWildcard($bad1e7a0a8a9dfd5$exports, $bf7ab9cd64050e58$exports);


var $45578ab7fb7fa864$exports = {};
var $2df84f4628adaaba$exports = {};

$parcel$export($2df84f4628adaaba$exports, "bestNumber", function () { return $2df84f4628adaaba$export$8d49ab1ce26d1629; });


const $b0a891e6e2805aca$export$817485789353cfbb = /*#__PURE__*/ (0, $d5bd3faeeec86a19$export$35271fb956347754)("toBigInt", "toBn", "toNumber", "unwrap");


function $f06ae579a041ba37$export$b7834c09351198be(hdr) {
    return (0, $b0a891e6e2805aca$export$817485789353cfbb)(hdr.number) ? hdr.number.unwrap() : hdr.number;
}


function $d8e779ecb3fc7da9$export$d4ac0a284a30d4c2(fn) {
    return (instanceId, api)=>(0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>fn(api).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((0, $f06ae579a041ba37$export$b7834c09351198be))));
}
/** @internal */ function $d8e779ecb3fc7da9$var$getAuthorDetailsWithAt(header, queryAt) {
    const validators = queryAt.session?.validators ? queryAt.session.validators() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null);
    // nimbus consensus stores the session key of the block author in header logs
    const { logs: [log] } = header.digest;
    const loggedAuthor = log && (log.isConsensus && log.asConsensus[0].isNimbus && log.asConsensus[1] || log.isPreRuntime && log.asPreRuntime[0].isNimbus && log.asPreRuntime[1]);
    if (loggedAuthor) {
        // use the author mapping pallet, if available (ie: moonbeam, moonriver), to map session (nimbus) key to author (collator/validator) key
        if (queryAt["authorMapping"]?.["mappingWithDeposit"]) return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(header),
            validators,
            queryAt["authorMapping"]["mappingWithDeposit"](loggedAuthor).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((o)=>o.unwrapOr({
                    account: null
                }).account))
        ]);
        // fall back to session and parachain staking pallets, if available (ie: manta, calamari), to map session (nimbus) key to author (collator) key
        if (queryAt["parachainStaking"]?.["selectedCandidates"] && queryAt.session?.nextKeys) {
            const loggedHex = loggedAuthor.toHex();
            return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(header),
                validators,
                queryAt["parachainStaking"]["selectedCandidates"]().pipe((0, $e118cd4880428984$export$6b9f6c0d32c093f9)((selectedCandidates)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(selectedCandidates),
                        queryAt.session.nextKeys.multi(selectedCandidates).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((nextKeys)=>nextKeys.findIndex((o)=>o.unwrapOrDefault().nimbus.toHex() === loggedHex)))
                    ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([selectedCandidates, index])=>index === -1 ? null : selectedCandidates[index]))
            ]);
        }
    }
    // normal operation, non-mapping
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(header),
        validators,
        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null)
    ]);
}
function $d8e779ecb3fc7da9$export$465c188dcb131886(api, header, blockHash) {
    // For on-chain state, we need to retrieve it as per the start
    // of the block being constructed, i.e. session validators would
    // be at the point of the block construction, not when all operations
    // has been supplied.
    //
    // However for the first block (no parentHash available), we would
    // just use the as-is
    return api.queryAt(header.parentHash.isEmpty ? blockHash || header.hash : header.parentHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((queryAt)=>$d8e779ecb3fc7da9$var$getAuthorDetailsWithAt(header, queryAt)));
}


const $2df84f4628adaaba$export$8d49ab1ce26d1629 = /*#__PURE__*/ (0, $d8e779ecb3fc7da9$export$d4ac0a284a30d4c2)((api)=>api.rpc.chain.subscribeNewHeads());


var $971399dee8b96c95$exports = {};

$parcel$export($971399dee8b96c95$exports, "bestNumberFinalized", function () { return $971399dee8b96c95$export$45940689d4a7ad8d; });

const $971399dee8b96c95$export$45940689d4a7ad8d = /*#__PURE__*/ (0, $d8e779ecb3fc7da9$export$d4ac0a284a30d4c2)((api)=>api.rpc.chain.subscribeFinalizedHeads());


var $45f6f46d75b670a5$exports = {};

$parcel$export($45f6f46d75b670a5$exports, "bestNumberLag", function () { return $45f6f46d75b670a5$export$2acd653a23d3b460; });


function $45f6f46d75b670a5$export$2acd653a23d3b460(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.chain.bestNumber(),
            api.derive.chain.bestNumberFinalized()
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([bestNumber, bestNumberFinalized])=>api.registry.createType("BlockNumber", bestNumber.sub(bestNumberFinalized)))));
}


var $67cfff5d20420621$exports = {};

$parcel$export($67cfff5d20420621$exports, "getBlock", function () { return $67cfff5d20420621$export$ea0af84ed2e77902; });

function $73c3c20a4b373a80$export$e07e4fe6aeaf04b2(digest, sessionValidators) {
    const [citem] = digest.logs.filter((e)=>e.isConsensus);
    const [pitem] = digest.logs.filter((e)=>e.isPreRuntime);
    const [sitem] = digest.logs.filter((e)=>e.isSeal);
    let accountId;
    try {
        // This is critical to be first for BABE (before Consensus)
        // If not first, we end up dropping the author at session-end
        if (pitem) {
            const [engine, data] = pitem.asPreRuntime;
            accountId = engine.extractAuthor(data, sessionValidators);
        }
        if (!accountId && citem) {
            const [engine, data] = citem.asConsensus;
            accountId = engine.extractAuthor(data, sessionValidators);
        }
        // SEAL, still used in e.g. Kulupu for pow
        if (!accountId && sitem) {
            const [engine, data] = sitem.asSeal;
            accountId = engine.extractAuthor(data, sessionValidators);
        }
    } catch  {
    // ignore
    }
    return accountId;
}


function $a5068c3399eba3eb$var$mapExtrinsics(extrinsics, records) {
    return extrinsics.map((extrinsic, index)=>{
        let dispatchError;
        let dispatchInfo;
        const events = records.filter(({ phase: phase })=>phase.isApplyExtrinsic && phase.asApplyExtrinsic.eq(index)).map(({ event: event })=>{
            if (event.section === "system") {
                if (event.method === "ExtrinsicSuccess") dispatchInfo = event.data[0];
                else if (event.method === "ExtrinsicFailed") {
                    dispatchError = event.data[0];
                    dispatchInfo = event.data[1];
                }
            }
            return event;
        });
        return {
            dispatchError: dispatchError,
            dispatchInfo: dispatchInfo,
            events: events,
            extrinsic: extrinsic
        };
    });
}
function $a5068c3399eba3eb$export$868bdb73076908cb(registry, block, events, validators, author) {
    // an instance of the base extrinsic for us to extend
    const SignedBlockBase = registry.createClass("SignedBlock");
    class Implementation extends SignedBlockBase {
        constructor(registry, block, events, validators, author){
            super(registry, block);
            this.__internal__author = author || (0, $73c3c20a4b373a80$export$e07e4fe6aeaf04b2)(this.block.header.digest, validators || []);
            this.__internal__events = events || [];
            this.__internal__extrinsics = $a5068c3399eba3eb$var$mapExtrinsics(this.block.extrinsics, this.__internal__events);
            this.createdAtHash = block?.createdAtHash;
        }
        /**
         * @description Convenience method, returns the author for the block
         */ get author() {
            return this.__internal__author;
        }
        /**
         * @description Convenience method, returns the events associated with the block
         */ get events() {
            return this.__internal__events;
        }
        /**
         * @description Returns the extrinsics and their events, mapped
         */ get extrinsics() {
            return this.__internal__extrinsics;
        }
    }
    return new Implementation(registry, block, events, validators, author);
}




function $67cfff5d20420621$export$ea0af84ed2e77902(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (blockHash)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.rpc.chain.getBlock(blockHash),
            api.queryAt(blockHash)
        ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([signedBlock, queryAt])=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(signedBlock),
                queryAt.system.events(),
                (0, $d8e779ecb3fc7da9$export$465c188dcb131886)(api, signedBlock.block.header, blockHash)
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([signedBlock, events, [, validators, author]])=>(0, $a5068c3399eba3eb$export$868bdb73076908cb)(events.registry, signedBlock, events, validators, author))));
}


var $41e3ab87758a6396$exports = {};

$parcel$export($41e3ab87758a6396$exports, "getBlockByNumber", function () { return $41e3ab87758a6396$export$d0e57961846d3fbf; });


function $41e3ab87758a6396$export$d0e57961846d3fbf(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (blockNumber)=>api.rpc.chain.getBlockHash(blockNumber).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((h)=>api.derive.chain.getBlock(h))));
}


var $bfe34cbe8cf10d13$exports = {};

$parcel$export($bfe34cbe8cf10d13$exports, "getHeader", function () { return $bfe34cbe8cf10d13$export$47ed31abc613cf55; });


function $c200eee892d2c5d4$export$388442af5e4ba812(registry, header, validators, author) {
    // an instance of the base extrinsic for us to extend
    const HeaderBase = registry.createClass("Header");
    class Implementation extends HeaderBase {
        constructor(registry, header, validators, author){
            super(registry, header);
            this.__internal__author = author || (0, $73c3c20a4b373a80$export$e07e4fe6aeaf04b2)(this.digest, validators || []);
            this.createdAtHash = header?.createdAtHash;
        }
        /**
         * @description Convenience method, returns the author for the block
         */ get author() {
            return this.__internal__author;
        }
    }
    return new Implementation(registry, header, validators, author);
}




function $bfe34cbe8cf10d13$export$47ed31abc613cf55(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (blockHash)=>api.rpc.chain.getHeader(blockHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((header)=>(0, $d8e779ecb3fc7da9$export$465c188dcb131886)(api, header, blockHash)), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([header, validators, author])=>(0, $c200eee892d2c5d4$export$388442af5e4ba812)((validators || header).registry, header, validators, author))));
}


var $8d818702b48ab430$exports = {};

$parcel$export($8d818702b48ab430$exports, "_getHeaderRange", function () { return $8d818702b48ab430$export$fad40bfd4e239737; });
$parcel$export($8d818702b48ab430$exports, "subscribeFinalizedHeads", function () { return $8d818702b48ab430$export$cd08d24d3ea99052; });


function $8d818702b48ab430$export$fad40bfd4e239737(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (startHash, endHash, prev = [])=>api.rpc.chain.getHeader(startHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((header)=>header.parentHash.eq(endHash) ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
                header,
                ...prev
            ]) : api.derive.chain._getHeaderRange(header.parentHash, endHash, [
                header,
                ...prev
            ]))));
}
function $8d818702b48ab430$export$cd08d24d3ea99052(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>{
        let prevHash = null;
        return api.rpc.chain.subscribeFinalizedHeads().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((header)=>{
            const endHash = prevHash;
            const startHash = header.parentHash;
            prevHash = header.createdAtHash = header.hash;
            return endHash === null || startHash.eq(endHash) ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(header) : api.derive.chain._getHeaderRange(startHash, endHash, [
                header
            ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((headers)=>(0, $9451f06798fd34f2$export$6788812c4e6611e6)(headers)));
        }));
    });
}


var $a0941fb36da634b2$exports = {};

$parcel$export($a0941fb36da634b2$exports, "subscribeNewBlocks", function () { return $a0941fb36da634b2$export$4f1498a9877e7cc6; });


function $a0941fb36da634b2$export$4f1498a9877e7cc6(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.chain.subscribeNewHeads().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((header)=>api.derive.chain.getBlock(header.createdAtHash || header.hash))));
}


var $212d1046b2b37b74$exports = {};

$parcel$export($212d1046b2b37b74$exports, "subscribeNewHeads", function () { return $212d1046b2b37b74$export$a0498f744a5d05db; });




function $212d1046b2b37b74$export$a0498f744a5d05db(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.rpc.chain.subscribeNewHeads().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((header)=>(0, $d8e779ecb3fc7da9$export$465c188dcb131886)(api, header)), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([header, validators, author])=>{
            header.createdAtHash = header.hash;
            return (0, $c200eee892d2c5d4$export$388442af5e4ba812)(header.registry, header, validators, author);
        })));
}


$parcel$exportWildcard($45578ab7fb7fa864$exports, $2df84f4628adaaba$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $971399dee8b96c95$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $45f6f46d75b670a5$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $67cfff5d20420621$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $41e3ab87758a6396$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $bfe34cbe8cf10d13$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $8d818702b48ab430$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $a0941fb36da634b2$exports);
$parcel$exportWildcard($45578ab7fb7fa864$exports, $212d1046b2b37b74$exports);


var $e97ac1da89361e01$exports = {};
var $5b6ff14bf762f1a1$exports = {};

$parcel$export($5b6ff14bf762f1a1$exports, "fees", function () { return $5b6ff14bf762f1a1$export$2e01ef62b4f17329; });


function $5b6ff14bf762f1a1$var$queryConstants(api) {
    return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
        // deprecated
        api.consts.contracts["callBaseFee"] || api.registry.createType("Balance"),
        api.consts.contracts["contractFee"] || api.registry.createType("Balance"),
        api.consts.contracts["creationFee"] || api.registry.createType("Balance"),
        api.consts.contracts["transactionBaseFee"] || api.registry.createType("Balance"),
        api.consts.contracts["transactionByteFee"] || api.registry.createType("Balance"),
        api.consts.contracts["transferFee"] || api.registry.createType("Balance"),
        // current
        api.consts.contracts["rentByteFee"] || api.registry.createType("Balance"),
        api.consts.contracts["rentDepositOffset"] || api.registry.createType("Balance"),
        api.consts.contracts["surchargeReward"] || api.registry.createType("Balance"),
        api.consts.contracts["tombstoneDeposit"] || api.registry.createType("Balance")
    ]);
}
function $5b6ff14bf762f1a1$export$2e01ef62b4f17329(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>{
        return $5b6ff14bf762f1a1$var$queryConstants(api).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([callBaseFee, contractFee, creationFee, transactionBaseFee, transactionByteFee, transferFee, rentByteFee, rentDepositOffset, surchargeReward, tombstoneDeposit])=>({
                callBaseFee: callBaseFee,
                contractFee: contractFee,
                creationFee: creationFee,
                rentByteFee: rentByteFee,
                rentDepositOffset: rentDepositOffset,
                surchargeReward: surchargeReward,
                tombstoneDeposit: tombstoneDeposit,
                transactionBaseFee: transactionBaseFee,
                transactionByteFee: transactionByteFee,
                transferFee: transferFee
            })));
    });
}


$parcel$exportWildcard($e97ac1da89361e01$exports, $5b6ff14bf762f1a1$exports);


var $b3cdd8c415ff6b16$exports = {};

$parcel$export($b3cdd8c415ff6b16$exports, "members", function () { return $b3cdd8c415ff6b16$export$100ad4af8c8d544f; });
$parcel$export($b3cdd8c415ff6b16$exports, "hasProposals", function () { return $b3cdd8c415ff6b16$export$bb89e61a247f7297; });
$parcel$export($b3cdd8c415ff6b16$exports, "proposal", function () { return $b3cdd8c415ff6b16$export$2ce2edfe63bacbbd; });
$parcel$export($b3cdd8c415ff6b16$exports, "proposalCount", function () { return $b3cdd8c415ff6b16$export$376b9c225e2427fa; });
$parcel$export($b3cdd8c415ff6b16$exports, "proposalHashes", function () { return $b3cdd8c415ff6b16$export$eaa0407513beb83b; });
$parcel$export($b3cdd8c415ff6b16$exports, "proposals", function () { return $b3cdd8c415ff6b16$export$803aac3a222d8bb8; });
$parcel$export($b3cdd8c415ff6b16$exports, "prime", function () { return $b3cdd8c415ff6b16$export$1cac00b2a622912a; });

var $d4f334d8d456f4e6$exports = {};

$parcel$export($d4f334d8d456f4e6$exports, "votes", function () { return $d4f334d8d456f4e6$export$12fad99ef49a648f; });


function $d4f334d8d456f4e6$var$isVoter(value) {
    return !Array.isArray(value);
}
function $d4f334d8d456f4e6$var$retrieveStakeOf(elections) {
    return elections["stakeOf"].entries().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((entries)=>entries.map(([{ args: [accountId] }, stake])=>[
                accountId,
                stake
            ])));
}
function $d4f334d8d456f4e6$var$retrieveVoteOf(elections) {
    return elections["votesOf"].entries().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((entries)=>entries.map(([{ args: [accountId] }, votes])=>[
                accountId,
                votes
            ])));
}
function $d4f334d8d456f4e6$var$retrievePrev(api, elections) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        $d4f334d8d456f4e6$var$retrieveStakeOf(elections),
        $d4f334d8d456f4e6$var$retrieveVoteOf(elections)
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([stakes, votes])=>{
        const result = [];
        votes.forEach(([voter, votes])=>{
            result.push([
                voter,
                {
                    stake: api.registry.createType("Balance"),
                    votes: votes
                }
            ]);
        });
        stakes.forEach(([staker, stake])=>{
            const entry = result.find(([voter])=>voter.eq(staker));
            if (entry) entry[1].stake = stake;
            else result.push([
                staker,
                {
                    stake: stake,
                    votes: []
                }
            ]);
        });
        return result;
    }));
}
function $d4f334d8d456f4e6$var$retrieveCurrent(elections) {
    return elections.voting.entries().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((entries)=>entries.map(([{ args: [accountId] }, value])=>[
                accountId,
                $d4f334d8d456f4e6$var$isVoter(value) ? {
                    stake: value.stake,
                    votes: value.votes
                } : {
                    stake: value[0],
                    votes: value[1]
                }
            ])));
}
function $d4f334d8d456f4e6$export$12fad99ef49a648f(instanceId, api) {
    const elections = api.query.elections || api.query["phragmenElection"] || api.query["electionsPhragmen"];
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>elections ? elections["stakeOf"] ? $d4f334d8d456f4e6$var$retrievePrev(api, elections) : $d4f334d8d456f4e6$var$retrieveCurrent(elections) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $64b59444d4105da1$exports = {};

$parcel$export($64b59444d4105da1$exports, "votesOf", function () { return $64b59444d4105da1$export$29c6cd40cec5cf4e; });


function $64b59444d4105da1$export$29c6cd40cec5cf4e(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId)=>api.derive.council.votes().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((votes)=>(votes.find(([from])=>from.eq(accountId)) || [
                null,
                {
                    stake: api.registry.createType("Balance"),
                    votes: []
                }
            ])[1])));
}


const $b3cdd8c415ff6b16$export$100ad4af8c8d544f = /*#__PURE__*/ (0, $f072415ace5e2936$export$100ad4af8c8d544f)("council");
const $b3cdd8c415ff6b16$export$bb89e61a247f7297 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$bb89e61a247f7297)("council");
const $b3cdd8c415ff6b16$export$2ce2edfe63bacbbd = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$2ce2edfe63bacbbd)("council");
const $b3cdd8c415ff6b16$export$376b9c225e2427fa = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$376b9c225e2427fa)("council");
const $b3cdd8c415ff6b16$export$eaa0407513beb83b = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$eaa0407513beb83b)("council");
const $b3cdd8c415ff6b16$export$803aac3a222d8bb8 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$803aac3a222d8bb8)("council");
const $b3cdd8c415ff6b16$export$1cac00b2a622912a = /*#__PURE__*/ (0, $0a21f0df368cf435$export$1cac00b2a622912a)("council");
$parcel$exportWildcard($b3cdd8c415ff6b16$exports, $d4f334d8d456f4e6$exports);
$parcel$exportWildcard($b3cdd8c415ff6b16$exports, $64b59444d4105da1$exports);


var $d76328f7febb0bdc$exports = {};
var $68f026e8201c7160$exports = {};

$parcel$export($68f026e8201c7160$exports, "childKey", function () { return $68f026e8201c7160$export$5f3511bcbab73763; });




function $68f026e8201c7160$var$createChildKey(info) {
    return (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $84207d7313fd2c40$export$7b640c40d4922c2e)(":child_storage:default:", (0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)((0, $84207d7313fd2c40$export$7b640c40d4922c2e)("crowdloan", (info.fundIndex || info.trieIndex).toU8a()))));
}
function $68f026e8201c7160$export$5f3511bcbab73763(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (paraId)=>api.query["crowdloan"]["funds"](paraId).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((optInfo)=>optInfo.isSome ? $68f026e8201c7160$var$createChildKey(optInfo.unwrap()) : null)));
}


var $89d88ec8ba136dd5$exports = {};

$parcel$export($89d88ec8ba136dd5$exports, "contributions", function () { return $89d88ec8ba136dd5$export$e14f9107f508f846; });

var $59e1a09a7b50cea7$export$ccb33e29d92c9a58 = new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $59e1a09a7b50cea7$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $59e1a09a7b50cea7$var$emptyScheduled(scheduler) : $59e1a09a7b50cea7$export$ccb33e29d92c9a58;
}
function $59e1a09a7b50cea7$var$emptyScheduled(scheduler) {
    return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}


/**
 * @name arrayFlatten
 * @summary Merge T[][] into T[]
 * @description
 * Returns a new array with all arrays merged into one
 * @example
 * <BR>
 *
 * ```javascript
 * import { arrayFlatten } from '@polkadot/util';
 *
 * arrayFlatten([[1, 2], [3, 4], [5]]); // [1, 2, 3, 4, 5]
 * ```
 */ function $f9c42f4bb009b291$export$71d4d087ef817bcf(arrays) {
    const num = arrays.length;
    // shortcuts for the empty & single-entry case
    if (num === 0) return [];
    else if (num === 1) return arrays[0];
    // pre-allocate based on the combined size
    let size = 0;
    for(let i = 0; i < num; i++)size += arrays[i].length;
    const output = new Array(size);
    let i = -1;
    for(let j = 0; j < num; j++){
        const a = arrays[j];
        // instead of pushing, we just set the entries
        for(let e = 0, count = a.length; e < count; e++)output[++i] = a[e];
    }
    return output;
}



function $951fd93ade5a1da1$export$cbf2746c8da162f7(paraId, events) {
    const added = [];
    const removed = [];
    return events.filter(({ event: { data: [, eventParaId], method: method, section: section } })=>section === "crowdloan" && [
            "Contributed",
            "Withdrew"
        ].includes(method) && eventParaId.eq(paraId)).reduce((result, { event: { data: [accountId], method: method } })=>{
        if (method === "Contributed") result.added.push(accountId.toHex());
        else result.removed.push(accountId.toHex());
        return result;
    }, {
        added: added,
        blockHash: events.createdAtHash?.toHex() || "-",
        removed: removed
    });
}


const $89d88ec8ba136dd5$var$PAGE_SIZE_K = 1000; // limit aligned with the 1k on the node (trie lookups are heavy)
function $89d88ec8ba136dd5$var$_getUpdates(api, paraId) {
    let added = [];
    let removed = [];
    return api.query.system.events().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((events)=>{
        const changes = (0, $951fd93ade5a1da1$export$cbf2746c8da162f7)(paraId, events);
        if (changes.added.length || changes.removed.length) {
            added = added.concat(...changes.added);
            removed = removed.concat(...changes.removed);
            return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({
                added: added,
                addedDelta: changes.added,
                blockHash: events.createdAtHash?.toHex() || "-",
                removed: removed,
                removedDelta: changes.removed
            });
        }
        return 0, $59e1a09a7b50cea7$export$ccb33e29d92c9a58;
    }), (0, $fa2edaed0b135380$export$a4fe86229b0e9bdd)({
        added: added,
        addedDelta: [],
        blockHash: "-",
        removed: removed,
        removedDelta: []
    }));
}
function $89d88ec8ba136dd5$var$_eventTriggerAll(api, paraId) {
    return api.query.system.events().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((events)=>{
        const items = events.filter(({ event: { data: [eventParaId], method: method, section: section } })=>section === "crowdloan" && [
                "AllRefunded",
                "Dissolved",
                "PartiallyRefunded"
            ].includes(method) && eventParaId.eq(paraId));
        return items.length ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(events.createdAtHash?.toHex() || "-") : (0, $59e1a09a7b50cea7$export$ccb33e29d92c9a58);
    }), (0, $fa2edaed0b135380$export$a4fe86229b0e9bdd)("-"));
}
function $89d88ec8ba136dd5$var$_getKeysPaged(api, childKey) {
    const subject = new (0, $c083768a9df36bef$export$cc3d42e6b2b9cf8b)(undefined);
    return subject.pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((startKey)=>api.rpc.childstate.getKeysPaged(childKey, "0x", $89d88ec8ba136dd5$var$PAGE_SIZE_K, startKey)), (0, $9d19ec2059422f48$export$3f23594af5f37336)((keys)=>{
        (0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>{
            keys.length === $89d88ec8ba136dd5$var$PAGE_SIZE_K ? subject.next(keys[$89d88ec8ba136dd5$var$PAGE_SIZE_K - 1].toHex()) : subject.complete();
        });
    }), (0, $8f965355e5b83cb3$export$45b10814cc054894)(), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((keyArr)=>(0, $f9c42f4bb009b291$export$71d4d087ef817bcf)(keyArr)));
}
function $89d88ec8ba136dd5$var$_getAll(api, paraId, childKey) {
    return $89d88ec8ba136dd5$var$_eventTriggerAll(api, paraId).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(()=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.rpc.childstate.getKeysPaged) ? $89d88ec8ba136dd5$var$_getKeysPaged(api, childKey) : api.rpc.childstate.getKeys(childKey, "0x")), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((keys)=>keys.map((k)=>k.toHex())));
}
function $89d88ec8ba136dd5$var$_contributions(api, paraId, childKey) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        $89d88ec8ba136dd5$var$_getAll(api, paraId, childKey),
        $89d88ec8ba136dd5$var$_getUpdates(api, paraId)
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([keys, { added: added, blockHash: blockHash, removed: removed }])=>{
        const contributorsMap = {};
        keys.forEach((k)=>{
            contributorsMap[k] = true;
        });
        added.forEach((k)=>{
            contributorsMap[k] = true;
        });
        removed.forEach((k)=>{
            delete contributorsMap[k];
        });
        return {
            blockHash: blockHash,
            contributorsHex: Object.keys(contributorsMap)
        };
    }));
}
function $89d88ec8ba136dd5$export$e14f9107f508f846(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (paraId)=>api.derive.crowdloan.childKey(paraId).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((childKey)=>childKey ? $89d88ec8ba136dd5$var$_contributions(api, paraId, childKey) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({
                blockHash: "-",
                contributorsHex: []
            }))));
}


var $9e7a973614399059$exports = {};

$parcel$export($9e7a973614399059$exports, "ownContributions", function () { return $9e7a973614399059$export$6f55c6bbe87cc691; });




function $9e7a973614399059$var$_getValues(api, childKey, keys) {
    // We actually would love to use multi-keys https://github.com/paritytech/substrate/issues/9203
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(keys.map((k)=>api.rpc.childstate.getStorage(childKey, k))).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((values)=>values.map((v)=>api.registry.createType("Option<StorageData>", v)).map((o)=>o.isSome ? api.registry.createType("Balance", o.unwrap()) : api.registry.createType("Balance")).reduce((all, b, index)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(all, {
                [keys[index]]: b
            }), {})));
}
function $9e7a973614399059$var$_watchOwnChanges(api, paraId, childkey, keys) {
    return api.query.system.events().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((events)=>{
        const changes = (0, $951fd93ade5a1da1$export$cbf2746c8da162f7)(paraId, events);
        const filtered = keys.filter((k)=>changes.added.includes(k) || changes.removed.includes(k));
        return filtered.length ? $9e7a973614399059$var$_getValues(api, childkey, filtered) : (0, $59e1a09a7b50cea7$export$ccb33e29d92c9a58);
    }), (0, $fa2edaed0b135380$export$a4fe86229b0e9bdd)({}));
}
function $9e7a973614399059$var$_contributions(api, paraId, childKey, keys) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        $9e7a973614399059$var$_getValues(api, childKey, keys),
        $9e7a973614399059$var$_watchOwnChanges(api, paraId, childKey, keys)
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([all, latest])=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, all, latest)));
}
function $9e7a973614399059$export$6f55c6bbe87cc691(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (paraId, keys)=>api.derive.crowdloan.childKey(paraId).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((childKey)=>childKey && keys.length ? $9e7a973614399059$var$_contributions(api, paraId, childKey, keys) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({}))));
}


$parcel$exportWildcard($d76328f7febb0bdc$exports, $68f026e8201c7160$exports);
$parcel$exportWildcard($d76328f7febb0bdc$exports, $89d88ec8ba136dd5$exports);
$parcel$exportWildcard($d76328f7febb0bdc$exports, $9e7a973614399059$exports);


var $bbe1b83af9805521$exports = {};
var $16c35c0d5bdba262$exports = {};

$parcel$export($16c35c0d5bdba262$exports, "dispatchQueue", function () { return $16c35c0d5bdba262$export$251be8be64d516ae; });




function $d1be03dbfdd357e9$export$551c48dea6f88e6d(value) {
    return (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $1b66c29e6169cf04$export$e66335b9b1239eaf)(value));
}




var $hWfed = parcelRequire("hWfed");
var $hWfed = parcelRequire("hWfed");


function $0d5adc72a53daf1f$export$b1236a9357c90608(value) {
    const n = (0, $fee06eacc361490f$export$3ce10b692b02dcbb)(value);
    if (n.isNeg()) throw new Error("square root of negative numbers is not supported");
    // https://stackoverflow.com/questions/53683995/javascript-big-integer-square-root/
    // shortcut <= 2^53 - 1 to use the JS utils
    if (n.lte((0, $031d4cf4355dbeac$export$71316adf7b729a57))) // ~~ More performant version of Math.floor
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(~~Math.sqrt(n.toNumber()));
    // Use sqrt(MAX_SAFE_INTEGER) as starting point. since we already know the
    // output will be larger than this, we expect this to be a safe start
    let x0 = (0, $031d4cf4355dbeac$export$b900f697b76aa387).clone();
    while(true){
        const x1 = n.div(x0).iadd(x0).ishrn(1);
        if (x0.eq(x1) || x0.eq(x1.sub((0, $031d4cf4355dbeac$export$8d1cfb084cec6129)))) return x0;
        x0 = x1;
    }
}


function $6cb8286efa335018$var$isOldInfo(info) {
    return !!info.proposalHash;
}
function $6cb8286efa335018$var$isCurrentStatus(status) {
    return !!status.tally;
}
function $6cb8286efa335018$export$6420a67786abfec6(n1, d1, n2, d2) {
    while(true){
        const q1 = n1.div(d1);
        const q2 = n2.div(d2);
        if (q1.lt(q2)) return true;
        else if (q2.lt(q1)) return false;
        const r1 = n1.mod(d1);
        const r2 = n2.mod(d2);
        if (r2.isZero()) return false;
        else if (r1.isZero()) return true;
        n1 = d2;
        n2 = d1;
        d1 = r2;
        d2 = r1;
    }
}
function $6cb8286efa335018$var$calcPassingOther(threshold, sqrtElectorate, { votedAye: votedAye, votedNay: votedNay, votedTotal: votedTotal }) {
    const sqrtVoters = (0, $0d5adc72a53daf1f$export$b1236a9357c90608)(votedTotal);
    return sqrtVoters.isZero() ? false : threshold.isSuperMajorityApprove ? $6cb8286efa335018$export$6420a67786abfec6(votedNay, sqrtVoters, votedAye, sqrtElectorate) : $6cb8286efa335018$export$6420a67786abfec6(votedNay, sqrtElectorate, votedAye, sqrtVoters);
}
function $6cb8286efa335018$export$afc023e980aac5fd(threshold, sqrtElectorate, state) {
    return threshold.isSimpleMajority ? state.votedAye.gt(state.votedNay) : $6cb8286efa335018$var$calcPassingOther(threshold, sqrtElectorate, state);
}
function $6cb8286efa335018$var$calcVotesPrev(votesFor) {
    return votesFor.reduce((state, derived)=>{
        const { balance: balance, vote: vote } = derived;
        const isDefault = vote.conviction.index === 0;
        const counted = balance.muln(isDefault ? 1 : vote.conviction.index).divn(isDefault ? 10 : 1);
        if (vote.isAye) {
            state.allAye.push(derived);
            state.voteCountAye++;
            state.votedAye.iadd(counted);
        } else {
            state.allNay.push(derived);
            state.voteCountNay++;
            state.votedNay.iadd(counted);
        }
        state.voteCount++;
        state.votedTotal.iadd(counted);
        return state;
    }, {
        allAye: [],
        allNay: [],
        voteCount: 0,
        voteCountAye: 0,
        voteCountNay: 0,
        votedAye: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0),
        votedNay: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0),
        votedTotal: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0)
    });
}
function $6cb8286efa335018$var$calcVotesCurrent(tally, votes) {
    const allAye = [];
    const allNay = [];
    votes.forEach((derived)=>{
        if (derived.vote.isAye) allAye.push(derived);
        else allNay.push(derived);
    });
    return {
        allAye: allAye,
        allNay: allNay,
        voteCount: allAye.length + allNay.length,
        voteCountAye: allAye.length,
        voteCountNay: allNay.length,
        votedAye: tally.ayes,
        votedNay: tally.nays,
        votedTotal: tally.turnout
    };
}
function $6cb8286efa335018$export$7ca142caf573b85(sqrtElectorate, referendum, votes) {
    const state = $6cb8286efa335018$var$isCurrentStatus(referendum.status) ? $6cb8286efa335018$var$calcVotesCurrent(referendum.status.tally, votes) : $6cb8286efa335018$var$calcVotesPrev(votes);
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, state, {
        isPassing: $6cb8286efa335018$export$afc023e980aac5fd(referendum.status.threshold, sqrtElectorate, state),
        votes: votes
    });
}
function $6cb8286efa335018$export$b70265791d2079d4(info) {
    if (info.isNone) return null;
    const unwrapped = info.unwrap();
    return $6cb8286efa335018$var$isOldInfo(unwrapped) ? unwrapped : unwrapped.isOngoing ? unwrapped.asOngoing : null;
}
function $6cb8286efa335018$export$10ea95fda3af1124(hash) {
    return hash.isLegacy ? hash.asLegacy.hash_.toHex() : hash.isLookup ? hash.asLookup.hash_.toHex() : hash.isInline ? hash.asInline.hash.toHex() : (0, $0d672af39bfe8283$export$844ec244b1367d54)(hash) ? (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(hash) ? hash : (0, $d1be03dbfdd357e9$export$551c48dea6f88e6d)(hash) : (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(hash) ? (0, $1e2cfad286c009ca$export$4429d284633899e1)(hash) : hash.toHex();
}
function $6cb8286efa335018$export$834930396608d553(status) {
    return $6cb8286efa335018$export$10ea95fda3af1124(status.proposal || status.proposalHash);
}


const $16c35c0d5bdba262$var$DEMOCRACY_ID = (0, $d1be03dbfdd357e9$export$551c48dea6f88e6d)("democrac");
function $16c35c0d5bdba262$var$isMaybeHashedOrBounded(call) {
    // check for enum
    return call instanceof (0, $533387422670f8b2$export$deb82508dd66d288);
}
function $16c35c0d5bdba262$var$isBounded(call) {
    // check for type
    return call.isInline || call.isLegacy || call.isLookup;
}
function $16c35c0d5bdba262$var$queryQueue(api) {
    return api.query.democracy["dispatchQueue"]().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((dispatches)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(dispatches),
            api.derive.democracy.preimages(dispatches.map(([, hash])=>hash))
        ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([dispatches, images])=>dispatches.map(([at, imageHash, index], dispatchIndex)=>({
                at: at,
                image: images[dispatchIndex],
                imageHash: (0, $6cb8286efa335018$export$10ea95fda3af1124)(imageHash),
                index: index
            }))));
}
function $16c35c0d5bdba262$var$schedulerEntries(api) {
    // We don't get entries, but rather we get the keys (triggered via finished referendums) and
    // the subscribe to those keys - this means we pickup when the schedulers actually executes
    // at a block, the entry for that block will become empty
    return api.derive.democracy.referendumsFinished().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(()=>api.query.scheduler.agenda.keys()), (0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((keys)=>{
        const blockNumbers = keys.map(({ args: [blockNumber] })=>blockNumber);
        return blockNumbers.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(blockNumbers),
            // this should simply be api.query.scheduler.agenda.multi,
            // however we have had cases on Darwinia where the indices have moved around after an
            // upgrade, which results in invalid on-chain data
            api.query.scheduler.agenda.multi(blockNumbers).pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)(()=>(0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(blockNumbers.map(()=>[]))))
        ]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
            [],
            []
        ]);
    }));
}
function $16c35c0d5bdba262$var$queryScheduler(api) {
    return $16c35c0d5bdba262$var$schedulerEntries(api).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([blockNumbers, agendas])=>{
        const result = [];
        blockNumbers.forEach((at, index)=>{
            (agendas[index] || []).filter((o)=>o.isSome).forEach((o)=>{
                const scheduled = o.unwrap();
                if (scheduled.maybeId.isSome) {
                    const id = scheduled.maybeId.unwrap().toHex();
                    if (id.startsWith($16c35c0d5bdba262$var$DEMOCRACY_ID)) {
                        const imageHash = $16c35c0d5bdba262$var$isMaybeHashedOrBounded(scheduled.call) ? $16c35c0d5bdba262$var$isBounded(scheduled.call) ? (0, $6cb8286efa335018$export$10ea95fda3af1124)(scheduled.call) : scheduled.call.isHash ? scheduled.call.asHash.toHex() : scheduled.call.asValue.args[0].toHex() : scheduled.call.args[0].toHex();
                        result.push({
                            at: at,
                            imageHash: imageHash,
                            index: api.registry.createType("(u64, ReferendumIndex)", id)[1]
                        });
                    }
                }
            });
        });
        return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(result),
            result.length ? api.derive.democracy.preimages(result.map(({ imageHash: imageHash })=>imageHash)) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])
        ]);
    }), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([infos, images])=>infos.map((info, index)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                image: images[index]
            }, info))));
}
function $16c35c0d5bdba262$export$251be8be64d516ae(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.scheduler?.agenda) ? $16c35c0d5bdba262$var$queryScheduler(api) : api.query.democracy["dispatchQueue"] ? $16c35c0d5bdba262$var$queryQueue(api) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $83f57e152244ce77$exports = {};

$parcel$export($83f57e152244ce77$exports, "locks", function () { return $83f57e152244ce77$export$95facc3a2772ab34; });



const $83f57e152244ce77$var$LOCKUPS = [
    0,
    1,
    2,
    4,
    8,
    16,
    32
];
function $83f57e152244ce77$var$parseEnd(api, vote, { approved: approved, end: end }) {
    return [
        end,
        approved.isTrue && vote.isAye || approved.isFalse && vote.isNay ? end.add((api.consts.democracy.voteLockingPeriod || api.consts.democracy.enactmentPeriod).muln($83f57e152244ce77$var$LOCKUPS[vote.conviction.index])) : (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa)
    ];
}
function $83f57e152244ce77$var$parseLock(api, [referendumId, accountVote], referendum) {
    const { balance: balance, vote: vote } = accountVote.asStandard;
    const [referendumEnd, unlockAt] = referendum.isFinished ? $83f57e152244ce77$var$parseEnd(api, vote, referendum.asFinished) : [
        (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa),
        (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa)
    ];
    return {
        balance: balance,
        isDelegated: false,
        isFinished: referendum.isFinished,
        referendumEnd: referendumEnd,
        referendumId: referendumId,
        unlockAt: unlockAt,
        vote: vote
    };
}
function $83f57e152244ce77$var$delegateLocks(api, { balance: balance, conviction: conviction, target: target }) {
    return api.derive.democracy.locks(target).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((available)=>available.map(({ isFinished: isFinished, referendumEnd: referendumEnd, referendumId: referendumId, unlockAt: unlockAt, vote: vote })=>({
                balance: balance,
                isDelegated: true,
                isFinished: isFinished,
                referendumEnd: referendumEnd,
                referendumId: referendumId,
                unlockAt: unlockAt.isZero() ? unlockAt : referendumEnd.add((api.consts.democracy.voteLockingPeriod || api.consts.democracy.enactmentPeriod).muln($83f57e152244ce77$var$LOCKUPS[conviction.index])),
                vote: api.registry.createType("Vote", {
                    aye: vote.isAye,
                    conviction: conviction
                })
            }))));
}
function $83f57e152244ce77$var$directLocks(api, { votes: votes }) {
    if (!votes.length) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]);
    return api.query.democracy.referendumInfoOf.multi(votes.map(([referendumId])=>referendumId)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((referendums)=>votes.map((vote, index)=>[
                vote,
                referendums[index].unwrapOr(null)
            ]).filter((item)=>!!item[1] && (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(item[1].end) && item[0][1].isStandard).map(([directVote, referendum])=>$83f57e152244ce77$var$parseLock(api, directVote, referendum))));
}
function $83f57e152244ce77$export$95facc3a2772ab34(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId)=>api.query.democracy.votingOf ? api.query.democracy.votingOf(accountId).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((voting)=>voting.isDirect ? $83f57e152244ce77$var$directLocks(api, voting.asDirect) : voting.isDelegating ? $83f57e152244ce77$var$delegateLocks(api, voting.asDelegating) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $e257f89994c6a172$exports = {};

$parcel$export($e257f89994c6a172$exports, "nextExternal", function () { return $e257f89994c6a172$export$c7800eeba136c6fe; });



function $e257f89994c6a172$var$withImage(api, nextOpt) {
    if (nextOpt.isNone) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null);
    const [hash, threshold] = nextOpt.unwrap();
    return api.derive.democracy.preimage(hash).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((image)=>({
            image: image,
            imageHash: (0, $6cb8286efa335018$export$10ea95fda3af1124)(hash),
            threshold: threshold
        })));
}
function $e257f89994c6a172$export$c7800eeba136c6fe(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.democracy?.nextExternal ? api.query.democracy.nextExternal().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((nextOpt)=>$e257f89994c6a172$var$withImage(api, nextOpt))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null));
}


var $328af82479007bb0$exports = {};

$parcel$export($328af82479007bb0$exports, "preimages", function () { return $328af82479007bb0$export$37b94d2db8c3fc2e; });
$parcel$export($328af82479007bb0$exports, "preimage", function () { return $328af82479007bb0$export$8825af6b21948212; });




function $328af82479007bb0$var$isDemocracyPreimage(api, imageOpt) {
    return !!imageOpt && !api.query.democracy["dispatchQueue"];
}
function $328af82479007bb0$var$constructProposal(api, [bytes, proposer, balance, at]) {
    let proposal;
    try {
        proposal = api.registry.createType("Call", bytes.toU8a(true));
    } catch (error) {
        console.error(error);
    }
    return {
        at: at,
        balance: balance,
        proposal: proposal,
        proposer: proposer
    };
}
function $328af82479007bb0$var$parseDemocracy(api, imageOpt) {
    if (imageOpt.isNone) return;
    if ($328af82479007bb0$var$isDemocracyPreimage(api, imageOpt)) {
        const status = imageOpt.unwrap();
        if (status.isMissing) return;
        const { data: data, deposit: deposit, provider: provider, since: since } = status.asAvailable;
        return $328af82479007bb0$var$constructProposal(api, [
            data,
            provider,
            deposit,
            since
        ]);
    }
    return $328af82479007bb0$var$constructProposal(api, imageOpt.unwrap());
}
function $328af82479007bb0$var$parseImage(api, [proposalHash, status, bytes]) {
    if (!status) return undefined;
    const [proposer, balance] = status.isUnrequested ? status.asUnrequested.deposit : status.asRequested.deposit.unwrapOrDefault();
    let proposal;
    if (bytes) try {
        proposal = api.registry.createType("Call", bytes.toU8a(true));
    } catch (error) {
        console.error(error);
    }
    return {
        at: (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa),
        balance: balance,
        proposal: proposal,
        proposalHash: proposalHash,
        proposer: proposer
    };
}
function $328af82479007bb0$var$getDemocracyImages(api, bounded) {
    const hashes = bounded.map((b)=>(0, $6cb8286efa335018$export$10ea95fda3af1124)(b));
    return api.query.democracy["preimages"].multi(hashes).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((images)=>images.map((imageOpt)=>$328af82479007bb0$var$parseDemocracy(api, imageOpt))));
}
function $328af82479007bb0$var$getImages(api, bounded) {
    const hashes = bounded.map((b)=>(0, $6cb8286efa335018$export$10ea95fda3af1124)(b));
    const bytesType = api.registry.lookup.getTypeDef(api.query.preimage.preimageFor.creator.meta.type.asMap.key).type;
    return api.query.preimage.statusFor.multi(hashes).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((optStatus)=>{
        const statuses = optStatus.map((o)=>o.unwrapOr(null));
        const keys = statuses.map((s, i)=>s ? bytesType === "H256" ? hashes[i] : s.isRequested ? [
                hashes[i],
                s.asRequested.len.unwrapOr(0)
            ] : [
                hashes[i],
                s.asUnrequested.len
            ] : null).filter((p)=>!!p);
        return api.query.preimage.preimageFor.multi(keys).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((optBytes)=>{
            let ptr = -1;
            return statuses.map((s, i)=>s ? [
                    hashes[i],
                    s,
                    optBytes[++ptr].unwrapOr(null)
                ] : [
                    hashes[i],
                    null,
                    null
                ]).map((v)=>$328af82479007bb0$var$parseImage(api, v));
        }));
    }));
}
function $328af82479007bb0$export$37b94d2db8c3fc2e(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (hashes)=>hashes.length ? (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.democracy["preimages"]) ? $328af82479007bb0$var$getDemocracyImages(api, hashes) : (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.preimage.preimageFor) ? $328af82479007bb0$var$getImages(api, hashes) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}
const $328af82479007bb0$export$8825af6b21948212 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, hash)=>api.derive.democracy.preimages([
        hash
    ]));


var $c89f6c3455284f3e$exports = {};

$parcel$export($c89f6c3455284f3e$exports, "proposals", function () { return $c89f6c3455284f3e$export$803aac3a222d8bb8; });




function $c89f6c3455284f3e$var$isNewDepositors(depositors) {
    // Detect balance...
    return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(depositors[1].mul);
}
function $c89f6c3455284f3e$var$parse([proposals, images, optDepositors]) {
    return proposals.filter(([, , proposer], index)=>!!optDepositors[index]?.isSome && !proposer.isEmpty).map(([index, hash, proposer], proposalIndex)=>{
        const depositors = optDepositors[proposalIndex].unwrap();
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            image: images[proposalIndex],
            imageHash: (0, $6cb8286efa335018$export$10ea95fda3af1124)(hash),
            index: index,
            proposer: proposer
        }, $c89f6c3455284f3e$var$isNewDepositors(depositors) ? {
            balance: depositors[1],
            seconds: depositors[0]
        } : {
            balance: depositors[0],
            seconds: depositors[1]
        });
    });
}
function $c89f6c3455284f3e$export$803aac3a222d8bb8(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.democracy?.publicProps) ? api.query.democracy.publicProps().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((proposals)=>proposals.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(proposals),
                api.derive.democracy.preimages(proposals.map(([, hash])=>hash)),
                api.query.democracy.depositOf.multi(proposals.map(([index])=>index))
            ]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
                [],
                [],
                []
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)($c89f6c3455284f3e$var$parse)) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $6b0ab0f889fe17bc$exports = {};

$parcel$export($6b0ab0f889fe17bc$exports, "referendumIds", function () { return $6b0ab0f889fe17bc$export$5e0fd94c71ff91f2; });


function $6b0ab0f889fe17bc$export$5e0fd94c71ff91f2(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.democracy?.lowestUnbaked ? api.queryMulti([
            api.query.democracy.lowestUnbaked,
            api.query.democracy.referendumCount
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([first, total])=>total.gt(first) ? [
                ...Array(total.sub(first).toNumber())
            ].map((_, i)=>first.addn(i)) : [])) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $c67ac68f20af65ee$exports = {};

$parcel$export($c67ac68f20af65ee$exports, "referendums", function () { return $c67ac68f20af65ee$export$cde2836ef0df6298; });



function $c67ac68f20af65ee$export$cde2836ef0df6298(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.democracy.referendumsActive().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((referendums)=>referendums.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(referendums),
                api.derive.democracy._referendumsVotes(referendums)
            ]) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([
                [],
                []
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([referendums, votes])=>referendums.map((referendum, index)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, referendum, votes[index])))));
}


var $2cfe7c52ab36c463$exports = {};

$parcel$export($2cfe7c52ab36c463$exports, "referendumsActive", function () { return $2cfe7c52ab36c463$export$fa7e988fd507180b; });


function $2cfe7c52ab36c463$export$fa7e988fd507180b(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.democracy.referendumIds().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((ids)=>ids.length ? api.derive.democracy.referendumsInfo(ids) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]))));
}


var $dbc3ba57fd6248d2$exports = {};

$parcel$export($dbc3ba57fd6248d2$exports, "referendumsFinished", function () { return $dbc3ba57fd6248d2$export$bb9867584f61d326; });


function $dbc3ba57fd6248d2$export$bb9867584f61d326(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.democracy.referendumIds().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((ids)=>api.query.democracy.referendumInfoOf.multi(ids)), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((infos)=>infos.map((o)=>o.unwrapOr(null)).filter((info)=>!!info && info.isFinished).map((info)=>info.asFinished))));
}


var $8f16ca85a309da97$exports = {};

$parcel$export($8f16ca85a309da97$exports, "_referendumVotes", function () { return $8f16ca85a309da97$export$bcce86e26d15d51f; });
$parcel$export($8f16ca85a309da97$exports, "_referendumsVotes", function () { return $8f16ca85a309da97$export$cf4baa76e7199fbe; });
$parcel$export($8f16ca85a309da97$exports, "_referendumInfo", function () { return $8f16ca85a309da97$export$cf501b097fa730fd; });
$parcel$export($8f16ca85a309da97$exports, "referendumsInfo", function () { return $8f16ca85a309da97$export$779c7873047d147d; });




function $8f16ca85a309da97$var$votesPrev(api, referendumId) {
    return api.query.democracy["votersFor"](referendumId).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((votersFor)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(votersFor),
            votersFor.length ? api.query.democracy["voteOf"].multi(votersFor.map((accountId)=>[
                    referendumId,
                    accountId
                ])) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]),
            api.derive.balances.votingBalances(votersFor)
        ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([votersFor, votes, balances])=>votersFor.map((accountId, index)=>({
                accountId: accountId,
                balance: balances[index].votingBalance || api.registry.createType("Balance"),
                isDelegating: false,
                vote: votes[index] || api.registry.createType("Vote")
            }))));
}
function $8f16ca85a309da97$var$extractVotes(mapped, referendumId) {
    return mapped.filter(([, voting])=>voting.isDirect).map(([accountId, voting])=>[
            accountId,
            voting.asDirect.votes.filter(([idx])=>idx.eq(referendumId))
        ]).filter(([, directVotes])=>!!directVotes.length).reduce((result, [accountId, votes])=>// FIXME We are ignoring split votes
        votes.reduce((result, [, vote])=>{
            if (vote.isStandard) result.push((0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                accountId: accountId,
                isDelegating: false
            }, vote.asStandard));
            return result;
        }, result), []);
}
function $8f16ca85a309da97$var$votesCurr(api, referendumId) {
    return api.query.democracy.votingOf.entries().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((allVoting)=>{
        const mapped = allVoting.map(([{ args: [accountId] }, voting])=>[
                accountId,
                voting
            ]);
        const votes = $8f16ca85a309da97$var$extractVotes(mapped, referendumId);
        const delegations = mapped.filter(([, voting])=>voting.isDelegating).map(([accountId, voting])=>[
                accountId,
                voting.asDelegating
            ]);
        // add delegations
        delegations.forEach(([accountId, { balance: balance, conviction: conviction, target: target }])=>{
            // Are we delegating to a delegator
            const toDelegator = delegations.find(([accountId])=>accountId.eq(target));
            const to = votes.find(({ accountId: accountId })=>accountId.eq(toDelegator ? toDelegator[0] : target));
            // this delegation has a target
            if (to) votes.push({
                accountId: accountId,
                balance: balance,
                isDelegating: true,
                vote: api.registry.createType("Vote", {
                    aye: to.vote.isAye,
                    conviction: conviction
                })
            });
        });
        return votes;
    }));
}
function $8f16ca85a309da97$export$bcce86e26d15d51f(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (referendum)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.democracy.sqrtElectorate(),
            (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.query.democracy.votingOf) ? $8f16ca85a309da97$var$votesCurr(api, referendum.index) : $8f16ca85a309da97$var$votesPrev(api, referendum.index)
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([sqrtElectorate, votes])=>(0, $6cb8286efa335018$export$7ca142caf573b85)(sqrtElectorate, referendum, votes))));
}
function $8f16ca85a309da97$export$cf4baa76e7199fbe(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (referendums)=>referendums.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(referendums.map((referendum)=>api.derive.democracy._referendumVotes(referendum))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}
function $8f16ca85a309da97$export$cf501b097fa730fd(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (index, info)=>{
        const status = (0, $6cb8286efa335018$export$b70265791d2079d4)(info);
        return status ? api.derive.democracy.preimage(status.proposal || status.proposalHash).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((image)=>({
                image: image,
                imageHash: (0, $6cb8286efa335018$export$834930396608d553)(status),
                index: api.registry.createType("ReferendumIndex", index),
                status: status
            }))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null);
    });
}
function $8f16ca85a309da97$export$779c7873047d147d(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (ids)=>ids.length ? api.query.democracy.referendumInfoOf.multi(ids).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((infos)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(ids.map((id, index)=>api.derive.democracy._referendumInfo(id, infos[index])))), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((infos)=>infos.filter((r)=>!!r))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $e759dca3c3268fa7$exports = {};

$parcel$export($e759dca3c3268fa7$exports, "sqrtElectorate", function () { return $e759dca3c3268fa7$export$58541d7036f9b473; });



function $e759dca3c3268fa7$export$58541d7036f9b473(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.balances.totalIssuance().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((0, $0d5adc72a53daf1f$export$b1236a9357c90608))));
}


$parcel$exportWildcard($bbe1b83af9805521$exports, $16c35c0d5bdba262$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $83f57e152244ce77$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $e257f89994c6a172$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $328af82479007bb0$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $c89f6c3455284f3e$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $6b0ab0f889fe17bc$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $c67ac68f20af65ee$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $2cfe7c52ab36c463$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $dbc3ba57fd6248d2$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $8f16ca85a309da97$exports);
$parcel$exportWildcard($bbe1b83af9805521$exports, $e759dca3c3268fa7$exports);


var $a028bc59a4c0810e$exports = {};
var $b018c7406b235384$exports = {};

$parcel$export($b018c7406b235384$exports, "info", function () { return $b018c7406b235384$export$a80b3bd66acc52ff; });



function $b018c7406b235384$var$isSeatHolder(value) {
    return !Array.isArray(value);
}
function $b018c7406b235384$var$isCandidateTuple(value) {
    return Array.isArray(value);
}
function $b018c7406b235384$var$getAccountTuple(value) {
    return $b018c7406b235384$var$isSeatHolder(value) ? [
        value.who,
        value.stake
    ] : value;
}
function $b018c7406b235384$var$getCandidate(value) {
    return $b018c7406b235384$var$isCandidateTuple(value) ? value[0] : value;
}
function $b018c7406b235384$var$sortAccounts([, balanceA], [, balanceB]) {
    return balanceB.cmp(balanceA);
}
function $b018c7406b235384$var$getConstants(api, elections) {
    return elections ? {
        candidacyBond: api.consts[elections].candidacyBond,
        desiredRunnersUp: api.consts[elections].desiredRunnersUp,
        desiredSeats: api.consts[elections].desiredMembers,
        termDuration: api.consts[elections].termDuration,
        votingBond: api.consts[elections]["votingBond"],
        votingBondBase: api.consts[elections].votingBondBase,
        votingBondFactor: api.consts[elections].votingBondFactor
    } : {};
}
function $b018c7406b235384$var$getModules(api) {
    const [council] = api.registry.getModuleInstances(api.runtimeVersion.specName, "council") || [
        "council"
    ];
    const elections = api.query["phragmenElection"] ? "phragmenElection" : api.query["electionsPhragmen"] ? "electionsPhragmen" : api.query.elections ? "elections" : null;
    return [
        council,
        elections
    ];
}
function $b018c7406b235384$var$queryAll(api, council, elections) {
    return api.queryMulti([
        api.query[council].members,
        api.query[elections].candidates,
        api.query[elections].members,
        api.query[elections].runnersUp
    ]);
}
function $b018c7406b235384$var$queryCouncil(api, council) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query[council].members(),
        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]),
        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]),
        (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])
    ]);
}
function $b018c7406b235384$export$a80b3bd66acc52ff(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>{
        const [council, elections] = $b018c7406b235384$var$getModules(api);
        return (elections ? $b018c7406b235384$var$queryAll(api, council, elections) : $b018c7406b235384$var$queryCouncil(api, council)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([councilMembers, candidates, members, runnersUp])=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, $b018c7406b235384$var$getConstants(api, elections), {
                candidateCount: api.registry.createType("u32", candidates.length),
                candidates: candidates.map($b018c7406b235384$var$getCandidate),
                members: members.length ? members.map($b018c7406b235384$var$getAccountTuple).sort($b018c7406b235384$var$sortAccounts) : councilMembers.map((a)=>[
                        a,
                        api.registry.createType("Balance")
                    ]),
                runnersUp: runnersUp.map($b018c7406b235384$var$getAccountTuple).sort($b018c7406b235384$var$sortAccounts)
            })));
    });
}


$parcel$exportWildcard($a028bc59a4c0810e$exports, $b018c7406b235384$exports);


var $c12abb0d0f1a759e$exports = {};
var $21fa3aa9f5896bbf$exports = {};

$parcel$export($21fa3aa9f5896bbf$exports, "receivedHeartbeats", function () { return $21fa3aa9f5896bbf$export$816b878dd7a9348a; });



function $21fa3aa9f5896bbf$var$mapResult([result, validators, heartbeats, numBlocks]) {
    validators.forEach((validator, index)=>{
        const validatorId = validator.toString();
        const blockCount = numBlocks[index];
        const hasMessage = !heartbeats[index].isEmpty;
        const prev = result[validatorId];
        if (!prev || prev.hasMessage !== hasMessage || !prev.blockCount.eq(blockCount)) result[validatorId] = {
            blockCount: blockCount,
            hasMessage: hasMessage,
            isOnline: hasMessage || blockCount.gt((0, $031d4cf4355dbeac$export$df7eb0036fdbadfa))
        };
    });
    return result;
}
function $21fa3aa9f5896bbf$export$816b878dd7a9348a(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.imOnline?.receivedHeartbeats ? api.derive.staking.overview().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(({ currentIndex: currentIndex, validators: validators })=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({}),
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(validators),
                api.query.imOnline.receivedHeartbeats.multi(validators.map((_address, index)=>[
                        currentIndex,
                        index
                    ])),
                api.query.imOnline.authoredBlocks.multi(validators.map((address)=>[
                        currentIndex,
                        address
                    ]))
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)($21fa3aa9f5896bbf$var$mapResult)) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({}));
}


$parcel$exportWildcard($c12abb0d0f1a759e$exports, $21fa3aa9f5896bbf$exports);


var $34d402b2904f95ff$exports = {};

$parcel$export($34d402b2904f95ff$exports, "members", function () { return $34d402b2904f95ff$export$100ad4af8c8d544f; });
$parcel$export($34d402b2904f95ff$exports, "hasProposals", function () { return $34d402b2904f95ff$export$bb89e61a247f7297; });
$parcel$export($34d402b2904f95ff$exports, "proposal", function () { return $34d402b2904f95ff$export$2ce2edfe63bacbbd; });
$parcel$export($34d402b2904f95ff$exports, "proposalCount", function () { return $34d402b2904f95ff$export$376b9c225e2427fa; });
$parcel$export($34d402b2904f95ff$exports, "proposalHashes", function () { return $34d402b2904f95ff$export$eaa0407513beb83b; });
$parcel$export($34d402b2904f95ff$exports, "proposals", function () { return $34d402b2904f95ff$export$803aac3a222d8bb8; });
$parcel$export($34d402b2904f95ff$exports, "prime", function () { return $34d402b2904f95ff$export$1cac00b2a622912a; });

const $34d402b2904f95ff$export$100ad4af8c8d544f = /*#__PURE__*/ (0, $f072415ace5e2936$export$100ad4af8c8d544f)("membership");
const $34d402b2904f95ff$export$bb89e61a247f7297 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$bb89e61a247f7297)("membership");
const $34d402b2904f95ff$export$2ce2edfe63bacbbd = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$2ce2edfe63bacbbd)("membership");
const $34d402b2904f95ff$export$376b9c225e2427fa = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$376b9c225e2427fa)("membership");
const $34d402b2904f95ff$export$eaa0407513beb83b = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$eaa0407513beb83b)("membership");
const $34d402b2904f95ff$export$803aac3a222d8bb8 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$803aac3a222d8bb8)("membership");
const $34d402b2904f95ff$export$1cac00b2a622912a = /*#__PURE__*/ (0, $0a21f0df368cf435$export$1cac00b2a622912a)("membership");


var $fd0fd080304433d4$exports = {};
var $8196bee54cb9309f$exports = {};

$parcel$export($8196bee54cb9309f$exports, "info", function () { return $8196bee54cb9309f$export$a80b3bd66acc52ff; });



function $8552ccb6322ef80f$export$4996bced4e23d893(didUpdate, id) {
    return didUpdate.isSome ? didUpdate.unwrap().some((paraId)=>paraId.eq(id)) : false;
}


function $8196bee54cb9309f$var$parseActive(id, active) {
    const found = active.find(([paraId])=>paraId === id);
    if (found && found[1].isSome) {
        const [collatorId, retriable] = found[1].unwrap();
        return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            collatorId: collatorId
        }, retriable.isWithRetries ? {
            isRetriable: true,
            retries: retriable.asWithRetries.toNumber()
        } : {
            isRetriable: false,
            retries: 0
        });
    }
    return null;
}
function $8196bee54cb9309f$var$parseCollators(id, collatorQueue) {
    return collatorQueue.map((queue)=>{
        const found = queue.find(([paraId])=>paraId === id);
        return found ? found[1] : null;
    });
}
function $8196bee54cb9309f$var$parse(id, [active, retryQueue, selectedThreads, didUpdate, info, pendingSwap, heads, relayDispatchQueue]) {
    if (info.isNone) return null;
    return {
        active: $8196bee54cb9309f$var$parseActive(id, active),
        didUpdate: (0, $8552ccb6322ef80f$export$4996bced4e23d893)(didUpdate, id),
        heads: heads,
        id: id,
        info: (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            id: id
        }, info.unwrap()),
        pendingSwapId: pendingSwap.unwrapOr(null),
        relayDispatchQueue: relayDispatchQueue,
        retryCollators: $8196bee54cb9309f$var$parseCollators(id, retryQueue),
        selectedCollators: $8196bee54cb9309f$var$parseCollators(id, selectedThreads)
    };
}
function $8196bee54cb9309f$export$a80b3bd66acc52ff(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (id)=>api.query["registrar"] && api.query["parachains"] ? api.queryMulti([
            api.query["registrar"]["active"],
            api.query["registrar"]["retryQueue"],
            api.query["registrar"]["selectedThreads"],
            api.query["parachains"]["didUpdate"],
            [
                api.query["registrar"]["paras"],
                id
            ],
            [
                api.query["registrar"]["pendingSwap"],
                id
            ],
            [
                api.query["parachains"]["heads"],
                id
            ],
            [
                api.query["parachains"]["relayDispatchQueue"],
                id
            ]
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((result)=>$8196bee54cb9309f$var$parse(api.registry.createType("ParaId", id), result))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null));
}


var $edcc68e285d9bce1$exports = {};

$parcel$export($edcc68e285d9bce1$exports, "overview", function () { return $edcc68e285d9bce1$export$f3cbcc6ad82435d7; });




function $edcc68e285d9bce1$var$parse([ids, didUpdate, relayDispatchQueueSizes, infos, pendingSwaps]) {
    return ids.map((id, index)=>({
            didUpdate: (0, $8552ccb6322ef80f$export$4996bced4e23d893)(didUpdate, id),
            id: id,
            info: (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                id: id
            }, infos[index].unwrapOr(null)),
            pendingSwapId: pendingSwaps[index].unwrapOr(null),
            relayDispatchQueueSize: relayDispatchQueueSizes[index][0].toNumber()
        }));
}
function $edcc68e285d9bce1$export$f3cbcc6ad82435d7(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query["registrar"]?.["parachains"] && api.query["parachains"] ? api.query["registrar"]["parachains"]().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((paraIds)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(paraIds),
                api.query["parachains"]["didUpdate"](),
                api.query["parachains"]["relayDispatchQueueSize"].multi(paraIds),
                api.query["registrar"]["paras"].multi(paraIds),
                api.query["registrar"]["pendingSwap"].multi(paraIds)
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)($edcc68e285d9bce1$var$parse)) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


$parcel$exportWildcard($fd0fd080304433d4$exports, $8196bee54cb9309f$exports);
$parcel$exportWildcard($fd0fd080304433d4$exports, $edcc68e285d9bce1$exports);


var $9e4cb37e05bd272b$exports = {};
var $4fcb07a9ec59d13a$exports = {};

$parcel$export($4fcb07a9ec59d13a$exports, "indexes", function () { return $4fcb07a9ec59d13a$export$8b04ba635e5803cd; });


function $4fcb07a9ec59d13a$var$parse([currentIndex, activeEra, activeEraStart, currentEra, validatorCount]) {
    return {
        activeEra: activeEra,
        activeEraStart: activeEraStart,
        currentEra: currentEra,
        currentIndex: currentIndex,
        validatorCount: validatorCount
    };
}
function $4fcb07a9ec59d13a$var$queryStaking(api) {
    return api.queryMulti([
        api.query.session.currentIndex,
        api.query.staking.activeEra,
        api.query.staking.currentEra,
        api.query.staking.validatorCount
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([currentIndex, activeOpt, currentEra, validatorCount])=>{
        const { index: index, start: start } = activeOpt.unwrapOrDefault();
        return $4fcb07a9ec59d13a$var$parse([
            currentIndex,
            index,
            start,
            currentEra.unwrapOrDefault(),
            validatorCount
        ]);
    }));
}
function $4fcb07a9ec59d13a$var$querySession(api) {
    return api.query.session.currentIndex().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((currentIndex)=>$4fcb07a9ec59d13a$var$parse([
            currentIndex,
            api.registry.createType("EraIndex"),
            api.registry.createType("Option<Moment>"),
            api.registry.createType("EraIndex"),
            api.registry.createType("u32")
        ])));
}
function $4fcb07a9ec59d13a$var$empty(api) {
    return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)($4fcb07a9ec59d13a$var$parse([
        api.registry.createType("SessionIndex", 1),
        api.registry.createType("EraIndex"),
        api.registry.createType("Option<Moment>"),
        api.registry.createType("EraIndex"),
        api.registry.createType("u32")
    ]));
}
function $4fcb07a9ec59d13a$export$8b04ba635e5803cd(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.session ? api.query.staking ? $4fcb07a9ec59d13a$var$queryStaking(api) : $4fcb07a9ec59d13a$var$querySession(api) : $4fcb07a9ec59d13a$var$empty(api));
}


var $5d66284fc2f7a5e2$exports = {};

$parcel$export($5d66284fc2f7a5e2$exports, "info", function () { return $5d66284fc2f7a5e2$export$a80b3bd66acc52ff; });



function $5d66284fc2f7a5e2$export$a80b3bd66acc52ff(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.session.indexes().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((indexes)=>{
            const sessionLength = api.consts?.babe?.epochDuration || api.registry.createType("u64", 1);
            const sessionsPerEra = api.consts?.staking?.sessionsPerEra || api.registry.createType("SessionIndex", 1);
            return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                eraLength: api.registry.createType("BlockNumber", sessionsPerEra.mul(sessionLength)),
                isEpoch: !!api.query.babe,
                sessionLength: sessionLength,
                sessionsPerEra: sessionsPerEra
            }, indexes);
        })));
}


var $478ff8bb1ad24e77$exports = {};

$parcel$export($478ff8bb1ad24e77$exports, "progress", function () { return $478ff8bb1ad24e77$export$504d7abb21fa8c9; });
$parcel$export($478ff8bb1ad24e77$exports, "eraLength", function () { return $478ff8bb1ad24e77$export$d39a530d74a4e5c2; });
$parcel$export($478ff8bb1ad24e77$exports, "eraProgress", function () { return $478ff8bb1ad24e77$export$e4ef4627b8940b10; });
$parcel$export($478ff8bb1ad24e77$exports, "sessionProgress", function () { return $478ff8bb1ad24e77$export$fd5d342109765870; });



function $478ff8bb1ad24e77$var$withProgressField(field) {
    return (instanceId, api)=>(0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.session.progress().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((info)=>info[field])));
}
function $478ff8bb1ad24e77$var$createDerive(api, info, [currentSlot, epochIndex, epochOrGenesisStartSlot, activeEraStartSessionIndex]) {
    const epochStartSlot = epochIndex.mul(info.sessionLength).iadd(epochOrGenesisStartSlot);
    const sessionProgress = currentSlot.sub(epochStartSlot);
    const eraProgress = info.currentIndex.sub(activeEraStartSessionIndex).imul(info.sessionLength).iadd(sessionProgress);
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
        eraProgress: api.registry.createType("BlockNumber", eraProgress),
        sessionProgress: api.registry.createType("BlockNumber", sessionProgress)
    }, info);
}
function $478ff8bb1ad24e77$var$queryAura(api) {
    return api.derive.session.info().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((info)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
            eraProgress: api.registry.createType("BlockNumber"),
            sessionProgress: api.registry.createType("BlockNumber")
        }, info)));
}
function $478ff8bb1ad24e77$var$queryBabe(api) {
    return api.derive.session.info().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((info)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(info),
            // we may have no staking, but have babe (permissioned)
            api.query.staking?.erasStartSessionIndex ? api.queryMulti([
                api.query.babe.currentSlot,
                api.query.babe.epochIndex,
                api.query.babe.genesisSlot,
                [
                    api.query.staking.erasStartSessionIndex,
                    info.activeEra
                ]
            ]) : api.queryMulti([
                api.query.babe.currentSlot,
                api.query.babe.epochIndex,
                api.query.babe.genesisSlot
            ])
        ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([info, [currentSlot, epochIndex, genesisSlot, optStartIndex]])=>[
            info,
            [
                currentSlot,
                epochIndex,
                genesisSlot,
                optStartIndex && optStartIndex.isSome ? optStartIndex.unwrap() : api.registry.createType("SessionIndex", 1)
            ]
        ]));
}
function $478ff8bb1ad24e77$export$504d7abb21fa8c9(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.babe ? $478ff8bb1ad24e77$var$queryBabe(api).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([info, slots])=>$478ff8bb1ad24e77$var$createDerive(api, info, slots))) : $478ff8bb1ad24e77$var$queryAura(api));
}
const $478ff8bb1ad24e77$export$d39a530d74a4e5c2 = /*#__PURE__*/ $478ff8bb1ad24e77$var$withProgressField("eraLength");
const $478ff8bb1ad24e77$export$e4ef4627b8940b10 = /*#__PURE__*/ $478ff8bb1ad24e77$var$withProgressField("eraProgress");
const $478ff8bb1ad24e77$export$fd5d342109765870 = /*#__PURE__*/ $478ff8bb1ad24e77$var$withProgressField("sessionProgress");


$parcel$exportWildcard($9e4cb37e05bd272b$exports, $4fcb07a9ec59d13a$exports);
$parcel$exportWildcard($9e4cb37e05bd272b$exports, $5d66284fc2f7a5e2$exports);
$parcel$exportWildcard($9e4cb37e05bd272b$exports, $478ff8bb1ad24e77$exports);


var $a0c050f26933fdbf$exports = {};
var $d0d17aca2530bde5$exports = {};

$parcel$export($d0d17aca2530bde5$exports, "candidates", function () { return $d0d17aca2530bde5$export$2a1dc148d556e4a4; });


function $d0d17aca2530bde5$export$2a1dc148d556e4a4(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.society.candidates().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((candidates)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(candidates),
                api.query.society.suspendedCandidates.multi(candidates.map(({ who: who })=>who))
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([candidates, suspended])=>candidates.map(({ kind: kind, value: value, who: who }, index)=>({
                    accountId: who,
                    isSuspended: suspended[index].isSome,
                    kind: kind,
                    value: value
                })))));
}


var $fe994e418f46bf2e$exports = {};

$parcel$export($fe994e418f46bf2e$exports, "info", function () { return $fe994e418f46bf2e$export$a80b3bd66acc52ff; });


function $fe994e418f46bf2e$export$a80b3bd66acc52ff(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.queryMulti([
            api.query.society.bids,
            api.query.society.defender,
            api.query.society.founder,
            api.query.society.head,
            api.query.society.maxMembers,
            api.query.society.pot
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([bids, defender, founder, head, maxMembers, pot])=>({
                bids: bids,
                defender: defender.unwrapOr(undefined),
                founder: founder.unwrapOr(undefined),
                hasDefender: defender.isSome && head.isSome && !head.eq(defender) || false,
                head: head.unwrapOr(undefined),
                maxMembers: maxMembers,
                pot: pot
            }))));
}


var $9c58a0c86ecf5c8a$exports = {};

$parcel$export($9c58a0c86ecf5c8a$exports, "member", function () { return $9c58a0c86ecf5c8a$export$6a0d13241802fe80; });


function $9c58a0c86ecf5c8a$export$6a0d13241802fe80(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId)=>api.derive.society._members([
            accountId
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([result])=>result)));
}


var $e2283a9451c8e5ad$exports = {};

$parcel$export($e2283a9451c8e5ad$exports, "_members", function () { return $e2283a9451c8e5ad$export$dcdc11ca4a0957d4; });
$parcel$export($e2283a9451c8e5ad$exports, "members", function () { return $e2283a9451c8e5ad$export$100ad4af8c8d544f; });


function $e2283a9451c8e5ad$export$dcdc11ca4a0957d4(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(accountIds),
            api.query.society.payouts.multi(accountIds),
            api.query.society.strikes.multi(accountIds),
            api.query.society.defenderVotes.multi(accountIds),
            api.query.society.suspendedMembers.multi(accountIds),
            api.query.society.vouching.multi(accountIds)
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([accountIds, payouts, strikes, defenderVotes, suspended, vouching])=>accountIds.map((accountId, index)=>({
                    accountId: accountId,
                    isDefenderVoter: defenderVotes[index].isSome,
                    isSuspended: suspended[index].isTrue,
                    payouts: payouts[index],
                    strikes: strikes[index],
                    vote: defenderVotes[index].unwrapOr(undefined),
                    vouching: vouching[index].unwrapOr(undefined)
                })))));
}
function $e2283a9451c8e5ad$export$100ad4af8c8d544f(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.society.members().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((members)=>api.derive.society._members(members))));
}


$parcel$exportWildcard($a0c050f26933fdbf$exports, $d0d17aca2530bde5$exports);
$parcel$exportWildcard($a0c050f26933fdbf$exports, $fe994e418f46bf2e$exports);
$parcel$exportWildcard($a0c050f26933fdbf$exports, $9c58a0c86ecf5c8a$exports);
$parcel$exportWildcard($a0c050f26933fdbf$exports, $e2283a9451c8e5ad$exports);


var $5ff67c6a184312d5$exports = {};
var $b0c8592c02196f49$exports = {};

$parcel$export($b0c8592c02196f49$exports, "accounts", function () { return $b0c8592c02196f49$export$c5541db89994d14; });
$parcel$export($b0c8592c02196f49$exports, "account", function () { return $b0c8592c02196f49$export$6b501c78a3684162; });


var $hWfed = parcelRequire("hWfed");

const $b0c8592c02196f49$var$QUERY_OPTS = {
    withDestination: true,
    withLedger: true,
    withNominations: true,
    withPrefs: true
};
function $b0c8592c02196f49$var$groupByEra(list) {
    return list.reduce((map, { era: era, value: value })=>{
        const key = era.toString();
        map[key] = (map[key] || (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa)).add(value.unwrap());
        return map;
    }, {});
}
function $b0c8592c02196f49$var$calculateUnlocking(api, stakingLedger, sessionInfo) {
    const results = Object.entries($b0c8592c02196f49$var$groupByEra((stakingLedger?.unlocking || []).filter(({ era: era })=>era.unwrap().gt(sessionInfo.activeEra)))).map(([eraString, value])=>({
            remainingEras: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(eraString).isub(sessionInfo.activeEra),
            value: api.registry.createType("Balance", value)
        }));
    return results.length ? results : undefined;
}
function $b0c8592c02196f49$var$redeemableSum(api, stakingLedger, sessionInfo) {
    return api.registry.createType("Balance", (stakingLedger?.unlocking || []).reduce((total, { era: era, value: value })=>{
        // aligns with https://github.com/paritytech/substrate/blob/fdfdc73f9e64dc47934b72eb9af3e1989e4ba699/frame/staking/src/pallet/mod.rs#L973-L975
        // (ensure currentEra >= era passed, as per https://github.com/paritytech/substrate/blob/fdfdc73f9e64dc47934b72eb9af3e1989e4ba699/frame/staking/src/lib.rs#L477-L494)
        // NOTE: Previously we used activeEra >= era, which is incorrect for the last session
        return era.unwrap().gt(sessionInfo.currentEra) ? total : total.iadd(value.unwrap());
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0)));
}
function $b0c8592c02196f49$var$parseResult(api, sessionInfo, keys, query) {
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, keys, query, {
        redeemable: $b0c8592c02196f49$var$redeemableSum(api, query.stakingLedger, sessionInfo),
        unlocking: $b0c8592c02196f49$var$calculateUnlocking(api, query.stakingLedger, sessionInfo)
    });
}
function $b0c8592c02196f49$export$c5541db89994d14(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, opts = $b0c8592c02196f49$var$QUERY_OPTS)=>api.derive.session.info().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((sessionInfo)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                api.derive.staking.keysMulti(accountIds),
                api.derive.staking.queryMulti(accountIds, opts)
            ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([keys, queries])=>queries.map((q, index)=>$b0c8592c02196f49$var$parseResult(api, sessionInfo, keys[index], q)))))));
}
const $b0c8592c02196f49$export$6b501c78a3684162 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId, opts)=>api.derive.staking.accounts([
        accountId
    ], opts));


var $74c0f541a92b4973$exports = {};

$parcel$export($74c0f541a92b4973$exports, "currentPoints", function () { return $74c0f541a92b4973$export$5cc549ba4a8d2163; });


function $74c0f541a92b4973$export$5cc549ba4a8d2163(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.derive.session.indexes().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(({ activeEra: activeEra })=>api.query.staking.erasRewardPoints(activeEra))));
}


var $8b90090d7946c730$exports = {};

$parcel$export($8b90090d7946c730$exports, "electedInfo", function () { return $8b90090d7946c730$export$e6233ccb79872c99; });



const $8b90090d7946c730$var$DEFAULT_FLAGS = {
    withController: true,
    withExposure: true,
    withPrefs: true
};
function $8b90090d7946c730$var$combineAccounts(nextElected, validators) {
    return (0, $f9c42f4bb009b291$export$71d4d087ef817bcf)([
        nextElected,
        validators.filter((v)=>!nextElected.find((n)=>n.eq(v)))
    ]);
}
function $8b90090d7946c730$export$e6233ccb79872c99(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (flags = $8b90090d7946c730$var$DEFAULT_FLAGS)=>api.derive.staking.validators().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(({ nextElected: nextElected, validators: validators })=>api.derive.staking.queryMulti($8b90090d7946c730$var$combineAccounts(nextElected, validators), flags).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((info)=>({
                    info: info,
                    nextElected: nextElected,
                    validators: validators
                }))))));
}


var $e45f49a7601ebca0$exports = {};

$parcel$export($e45f49a7601ebca0$exports, "_eraExposure", function () { return $e45f49a7601ebca0$export$e7c2ebc77c51a227; });
$parcel$export($e45f49a7601ebca0$exports, "eraExposure", function () { return $e45f49a7601ebca0$export$4e0bb5220555bf11; });
$parcel$export($e45f49a7601ebca0$exports, "_erasExposure", function () { return $e45f49a7601ebca0$export$2357db0a11cf6cb3; });
$parcel$export($e45f49a7601ebca0$exports, "erasExposure", function () { return $e45f49a7601ebca0$export$eb19ec10b68e393a; });


const $c2c0dd5fefddf15c$var$mapCache = new Map();
const $c2c0dd5fefddf15c$export$df3c7e346a652b0 = {
    del: (key)=>{
        $c2c0dd5fefddf15c$var$mapCache.delete(key);
    },
    forEach: (cb)=>{
        for (const [k, v] of $c2c0dd5fefddf15c$var$mapCache.entries())cb(k, v);
    },
    get: (key)=>{
        return $c2c0dd5fefddf15c$var$mapCache.get(key);
    },
    set: (key, value)=>{
        $c2c0dd5fefddf15c$var$mapCache.set(key, value);
    }
};
const $c2c0dd5fefddf15c$export$a8159a96a2c00d7f = {
    del: ()=>undefined,
    forEach: ()=>undefined,
    get: ()=>undefined,
    set: (_, value)=>value
};


const $6db9bca0ed4b26f6$var$CHACHE_EXPIRY = 604800000;
let $6db9bca0ed4b26f6$export$59750993711d780c;
function $6db9bca0ed4b26f6$var$wrapCache(keyStart, cache) {
    return {
        del: (partial)=>cache.del(`${keyStart}${partial}`),
        forEach: cache.forEach,
        get: (partial)=>{
            const key = `${keyStart}${partial}`;
            const cached = cache.get(key);
            if (cached) {
                cached.x = Date.now();
                cache.set(key, cached);
                return cached.v;
            }
            return undefined;
        },
        set: (partial, v)=>{
            cache.set(`${keyStart}${partial}`, {
                v: v,
                x: Date.now()
            });
        }
    };
}
function $6db9bca0ed4b26f6$var$clearCache(cache) {
    // clear all expired values
    const now = Date.now();
    const all = [];
    cache.forEach((key, { x: x })=>{
        now - x > $6db9bca0ed4b26f6$var$CHACHE_EXPIRY && all.push(key);
    });
    // don't do delete inside loop, just in-case
    all.forEach((key)=>cache.del(key));
}
function $6db9bca0ed4b26f6$export$2b0c27d864a9e233(prefix = "", cache) {
    $6db9bca0ed4b26f6$export$59750993711d780c = cache ? $6db9bca0ed4b26f6$var$wrapCache(`derive:${prefix}:`, cache) : (0, $c2c0dd5fefddf15c$export$a8159a96a2c00d7f);
    if (cache) $6db9bca0ed4b26f6$var$clearCache(cache);
}
$6db9bca0ed4b26f6$export$2b0c27d864a9e233();


function $748e205e32d5616b$export$1181ede251dca1f8(CACHE_KEY, era, withActive) {
    const cacheKey = `${CACHE_KEY}-${era.toString()}`;
    return [
        cacheKey,
        withActive ? undefined : (0, $6db9bca0ed4b26f6$export$59750993711d780c).get(cacheKey)
    ];
}
function $748e205e32d5616b$export$a6e561d7c6d9a702(CACHE_KEY, eras, withActive) {
    const cached = withActive ? [] : eras.map((e)=>(0, $6db9bca0ed4b26f6$export$59750993711d780c).get(`${CACHE_KEY}-${e.toString()}`)).filter((v)=>!!v);
    return cached;
}
function $748e205e32d5616b$export$104e0ab71ba00e2(cacheKey, withActive, value) {
    !withActive && (0, $6db9bca0ed4b26f6$export$59750993711d780c).set(cacheKey, value);
    return value;
}
function $748e205e32d5616b$export$b7e10bfbf00b5dd(CACHE_KEY, withActive, values) {
    !withActive && values.forEach((v)=>(0, $6db9bca0ed4b26f6$export$59750993711d780c).set(`${CACHE_KEY}-${v.era.toString()}`, v));
    return values;
}
function $748e205e32d5616b$export$2fc597ece4a3ae51(eras, cached, query) {
    return eras.map((e)=>cached.find(({ era: era })=>e.eq(era)) || query.find(({ era: era })=>e.eq(era)));
}



/**
 * @name arrayChunk
 * @summary Split T[] into T[][] based on the defind size
 * @description
 * Returns a set ao arrays based on the chunksize
 * @example
 * <BR>
 *
 * ```javascript
 * import { arrayChunk } from '@polkadot/util';
 *
 * arrayChunk([1, 2, 3, 4, 5]); // [[1, 2], [3, 4], [5]]
 * ```
 */ function $e204297b30b8ef47$export$b320c6157b39692a(array, chunkSize) {
    const outputSize = Math.ceil(array.length / chunkSize);
    // shortcut for the single-split case
    if (outputSize === 1) return [
        array
    ];
    const output = Array(outputSize);
    for(let i = 0; i < outputSize; i++){
        const offset = i * chunkSize;
        output[i] = array.slice(offset, offset + chunkSize);
    }
    return output;
}



const $74a1e6f8326c9c2f$var$ERA_CHUNK_SIZE = 14;
function $74a1e6f8326c9c2f$var$chunkEras(eras, fn) {
    const chunked = (0, $e204297b30b8ef47$export$b320c6157b39692a)(eras, $74a1e6f8326c9c2f$var$ERA_CHUNK_SIZE);
    let index = 0;
    const subject = new (0, $c083768a9df36bef$export$cc3d42e6b2b9cf8b)(chunked[index]);
    return subject.pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(fn), (0, $9d19ec2059422f48$export$3f23594af5f37336)(()=>{
        (0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>{
            index++;
            index === chunked.length ? subject.complete() : subject.next(chunked[index]);
        });
    }), (0, $8f965355e5b83cb3$export$45b10814cc054894)(), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((0, $f9c42f4bb009b291$export$71d4d087ef817bcf)));
}
function $74a1e6f8326c9c2f$export$ec2de520529fd54b(eras, list) {
    return eras.filter((e)=>!list.some(({ era: era })=>e.eq(era)));
}
function $74a1e6f8326c9c2f$export$2e15fb89e64d6900(fn) {
    return (instanceId, api)=>// Cannot quite get the typing right, but it is right in the code
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (withActive = false)=>api.derive.staking.erasHistoric(withActive).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((e)=>api.derive.staking[fn](e, withActive))));
}
function $74a1e6f8326c9c2f$export$dc48acbfe12786d7(fn) {
    return (instanceId, api)=>// Cannot quite get the typing right, but it is right in the code
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId, withActive = false)=>api.derive.staking.erasHistoric(withActive).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((e)=>api.derive.staking[fn](accountId, e, withActive))));
}
function $74a1e6f8326c9c2f$export$1ef128ec85ca65c7(fn) {
    return (instanceId, api)=>// Cannot quite get the typing right, but it is right in the code
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (era)=>api.derive.staking[fn](era, true));
}
function $74a1e6f8326c9c2f$export$3ada48edc4b57469(fn) {
    return (instanceId, api)=>// Cannot quite get the typing right, but it is right in the code
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (eras, withActive)=>!eras.length ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]) : $74a1e6f8326c9c2f$var$chunkEras(eras, (eras)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(eras.map((e)=>api.derive.staking[fn](e, withActive)))));
}


const $e45f49a7601ebca0$var$CACHE_KEY = "eraExposure";
function $e45f49a7601ebca0$var$mapStakers(era, stakers) {
    const nominators = {};
    const validators = {};
    stakers.forEach(([key, exposure])=>{
        const validatorId = key.args[1].toString();
        validators[validatorId] = exposure;
        exposure.others.forEach(({ who: who }, validatorIndex)=>{
            const nominatorId = who.toString();
            nominators[nominatorId] = nominators[nominatorId] || [];
            nominators[nominatorId].push({
                validatorId: validatorId,
                validatorIndex: validatorIndex
            });
        });
    });
    return {
        era: era,
        nominators: nominators,
        validators: validators
    };
}
function $e45f49a7601ebca0$export$e7c2ebc77c51a227(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (era, withActive = false)=>{
        const [cacheKey, cached] = (0, $748e205e32d5616b$export$1181ede251dca1f8)($e45f49a7601ebca0$var$CACHE_KEY, era, withActive);
        return cached ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(cached) : api.query.staking.erasStakersClipped.entries(era).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((r)=>(0, $748e205e32d5616b$export$104e0ab71ba00e2)(cacheKey, withActive, $e45f49a7601ebca0$var$mapStakers(era, r))));
    });
}
const $e45f49a7601ebca0$export$4e0bb5220555bf11 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$1ef128ec85ca65c7)("_eraExposure");
const $e45f49a7601ebca0$export$2357db0a11cf6cb3 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$3ada48edc4b57469)("_eraExposure");
const $e45f49a7601ebca0$export$eb19ec10b68e393a = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$2e15fb89e64d6900)("_erasExposure");


var $cce99ab362452a70$exports = {};

$parcel$export($cce99ab362452a70$exports, "erasHistoric", function () { return $cce99ab362452a70$export$71af63bcfbe8b10c; });



function $cce99ab362452a70$export$71af63bcfbe8b10c(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (withActive)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.query.staking.activeEra(),
            api.consts.staking.historyDepth ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(api.consts.staking.historyDepth) : api.query.staking["historyDepth"]()
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([activeEraOpt, historyDepth])=>{
            const result = [];
            const max = historyDepth.toNumber();
            const activeEra = activeEraOpt.unwrapOrDefault().index;
            let lastEra = activeEra;
            while(lastEra.gte((0, $031d4cf4355dbeac$export$df7eb0036fdbadfa)) && result.length < max){
                if (lastEra !== activeEra || withActive === true) result.push(api.registry.createType("EraIndex", lastEra));
                lastEra = lastEra.sub((0, $031d4cf4355dbeac$export$8d1cfb084cec6129));
            }
            // go from oldest to newest
            return result.reverse();
        })));
}


var $37007be96dbf6bf3$exports = {};

$parcel$export($37007be96dbf6bf3$exports, "_erasPoints", function () { return $37007be96dbf6bf3$export$3fa1cda31c60f64; });
$parcel$export($37007be96dbf6bf3$exports, "erasPoints", function () { return $37007be96dbf6bf3$export$a014680183e52fa5; });





const $37007be96dbf6bf3$var$CACHE_KEY = "eraPoints";
function $37007be96dbf6bf3$var$mapValidators({ individual: individual }) {
    return [
        ...individual.entries()
    ].filter(([, points])=>points.gt((0, $031d4cf4355dbeac$export$df7eb0036fdbadfa))).reduce((result, [validatorId, points])=>{
        result[validatorId.toString()] = points;
        return result;
    }, {});
}
function $37007be96dbf6bf3$var$mapPoints(eras, points) {
    return eras.map((era, index)=>({
            era: era,
            eraPoints: points[index].total,
            validators: $37007be96dbf6bf3$var$mapValidators(points[index])
        }));
}
function $37007be96dbf6bf3$export$3fa1cda31c60f64(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (eras, withActive)=>{
        if (!eras.length) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]);
        const cached = (0, $748e205e32d5616b$export$a6e561d7c6d9a702)($37007be96dbf6bf3$var$CACHE_KEY, eras, withActive);
        const remaining = (0, $74a1e6f8326c9c2f$export$ec2de520529fd54b)(eras, cached);
        return !remaining.length ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(cached) : api.query.staking.erasRewardPoints.multi(remaining).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((p)=>(0, $748e205e32d5616b$export$2fc597ece4a3ae51)(eras, cached, (0, $748e205e32d5616b$export$b7e10bfbf00b5dd)($37007be96dbf6bf3$var$CACHE_KEY, withActive, $37007be96dbf6bf3$var$mapPoints(remaining, p)))));
    });
}
const $37007be96dbf6bf3$export$a014680183e52fa5 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$2e15fb89e64d6900)("_erasPoints");


var $dce473b8d44b3121$exports = {};

$parcel$export($dce473b8d44b3121$exports, "_eraPrefs", function () { return $dce473b8d44b3121$export$2b3796c390543939; });
$parcel$export($dce473b8d44b3121$exports, "eraPrefs", function () { return $dce473b8d44b3121$export$3ae7ca603be8c601; });
$parcel$export($dce473b8d44b3121$exports, "_erasPrefs", function () { return $dce473b8d44b3121$export$7ded4121f198e580; });
$parcel$export($dce473b8d44b3121$exports, "erasPrefs", function () { return $dce473b8d44b3121$export$95d9794031a56931; });




const $dce473b8d44b3121$var$CACHE_KEY = "eraPrefs";
function $dce473b8d44b3121$var$mapPrefs(era, all) {
    const validators = {};
    all.forEach(([key, prefs])=>{
        validators[key.args[1].toString()] = prefs;
    });
    return {
        era: era,
        validators: validators
    };
}
function $dce473b8d44b3121$export$2b3796c390543939(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (era, withActive)=>{
        const [cacheKey, cached] = (0, $748e205e32d5616b$export$1181ede251dca1f8)($dce473b8d44b3121$var$CACHE_KEY, era, withActive);
        return cached ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(cached) : api.query.staking.erasValidatorPrefs.entries(era).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((r)=>(0, $748e205e32d5616b$export$104e0ab71ba00e2)(cacheKey, withActive, $dce473b8d44b3121$var$mapPrefs(era, r))));
    });
}
const $dce473b8d44b3121$export$3ae7ca603be8c601 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$1ef128ec85ca65c7)("_eraPrefs");
const $dce473b8d44b3121$export$7ded4121f198e580 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$3ada48edc4b57469)("_eraPrefs");
const $dce473b8d44b3121$export$95d9794031a56931 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$2e15fb89e64d6900)("_erasPrefs");


var $2f10f4a93b91bf2d$exports = {};

$parcel$export($2f10f4a93b91bf2d$exports, "_erasRewards", function () { return $2f10f4a93b91bf2d$export$69d69714815c6992; });
$parcel$export($2f10f4a93b91bf2d$exports, "erasRewards", function () { return $2f10f4a93b91bf2d$export$2bd1bec829f62842; });




const $2f10f4a93b91bf2d$var$CACHE_KEY = "eraRewards";
function $2f10f4a93b91bf2d$var$mapRewards(eras, optRewards) {
    return eras.map((era, index)=>({
            era: era,
            eraReward: optRewards[index].unwrapOrDefault()
        }));
}
function $2f10f4a93b91bf2d$export$69d69714815c6992(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (eras, withActive)=>{
        if (!eras.length) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]);
        const cached = (0, $748e205e32d5616b$export$a6e561d7c6d9a702)($2f10f4a93b91bf2d$var$CACHE_KEY, eras, withActive);
        const remaining = (0, $74a1e6f8326c9c2f$export$ec2de520529fd54b)(eras, cached);
        if (!remaining.length) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(cached);
        return api.query.staking.erasValidatorReward.multi(remaining).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((r)=>(0, $748e205e32d5616b$export$2fc597ece4a3ae51)(eras, cached, (0, $748e205e32d5616b$export$b7e10bfbf00b5dd)($2f10f4a93b91bf2d$var$CACHE_KEY, withActive, $2f10f4a93b91bf2d$var$mapRewards(remaining, r)))));
    });
}
const $2f10f4a93b91bf2d$export$2bd1bec829f62842 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$2e15fb89e64d6900)("_erasRewards");


var $72d9d3506469e06e$exports = {};

$parcel$export($72d9d3506469e06e$exports, "_eraSlashes", function () { return $72d9d3506469e06e$export$3827dfb2eced4aad; });
$parcel$export($72d9d3506469e06e$exports, "eraSlashes", function () { return $72d9d3506469e06e$export$1ee86bdd1630f4b2; });
$parcel$export($72d9d3506469e06e$exports, "_erasSlashes", function () { return $72d9d3506469e06e$export$c36a2f570ccd1d2d; });
$parcel$export($72d9d3506469e06e$exports, "erasSlashes", function () { return $72d9d3506469e06e$export$17a189e74c20bc72; });




const $72d9d3506469e06e$var$CACHE_KEY = "eraSlashes";
function $72d9d3506469e06e$var$mapSlashes(era, noms, vals) {
    const nominators = {};
    const validators = {};
    noms.forEach(([key, optBalance])=>{
        nominators[key.args[1].toString()] = optBalance.unwrap();
    });
    vals.forEach(([key, optRes])=>{
        validators[key.args[1].toString()] = optRes.unwrapOrDefault()[1];
    });
    return {
        era: era,
        nominators: nominators,
        validators: validators
    };
}
function $72d9d3506469e06e$export$3827dfb2eced4aad(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (era, withActive)=>{
        const [cacheKey, cached] = (0, $748e205e32d5616b$export$1181ede251dca1f8)($72d9d3506469e06e$var$CACHE_KEY, era, withActive);
        return cached ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(cached) : (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.query.staking.nominatorSlashInEra.entries(era),
            api.query.staking.validatorSlashInEra.entries(era)
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([n, v])=>(0, $748e205e32d5616b$export$104e0ab71ba00e2)(cacheKey, withActive, $72d9d3506469e06e$var$mapSlashes(era, n, v))));
    });
}
const $72d9d3506469e06e$export$1ee86bdd1630f4b2 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$1ef128ec85ca65c7)("_eraSlashes");
const $72d9d3506469e06e$export$c36a2f570ccd1d2d = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$3ada48edc4b57469)("_eraSlashes");
const $72d9d3506469e06e$export$17a189e74c20bc72 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$2e15fb89e64d6900)("_erasSlashes");


var $4d898ebced36411c$exports = {};

$parcel$export($4d898ebced36411c$exports, "keys", function () { return $4d898ebced36411c$export$ed97f33186d4b816; });
$parcel$export($4d898ebced36411c$exports, "keysMulti", function () { return $4d898ebced36411c$export$1bfebf5bde94c47; });


function $4d898ebced36411c$var$extractsIds(stashId, queuedKeys, nextKeys) {
    const sessionIds = (queuedKeys.find(([currentId])=>currentId.eq(stashId)) || [
        undefined,
        []
    ])[1];
    const nextSessionIds = nextKeys.unwrapOr([]);
    return {
        nextSessionIds: Array.isArray(nextSessionIds) ? nextSessionIds : [
            ...nextSessionIds.values()
        ],
        sessionIds: Array.isArray(sessionIds) ? sessionIds : [
            ...sessionIds.values()
        ]
    };
}
const $4d898ebced36411c$export$ed97f33186d4b816 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, stashId)=>api.derive.staking.keysMulti([
        stashId
    ]));
function $4d898ebced36411c$export$1bfebf5bde94c47(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (stashIds)=>stashIds.length ? api.query.session.queuedKeys().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((queuedKeys)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
                (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(queuedKeys),
                api.consts["session"]?.["dedupKeyPrefix"] ? api.query.session.nextKeys.multi(stashIds.map((s)=>[
                        api.consts["session"]["dedupKeyPrefix"],
                        s
                    ])) : (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(stashIds.map((s)=>api.query.session.nextKeys(s)))
            ])), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([queuedKeys, nextKeys])=>stashIds.map((stashId, index)=>$4d898ebced36411c$var$extractsIds(stashId, queuedKeys, nextKeys[index])))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}


var $8a9619a237040e4d$exports = {};

$parcel$export($8a9619a237040e4d$exports, "overview", function () { return $8a9619a237040e4d$export$f3cbcc6ad82435d7; });



function $8a9619a237040e4d$export$f3cbcc6ad82435d7(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.session.indexes(),
            api.derive.staking.validators()
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([indexes, { nextElected: nextElected, validators: validators }])=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, indexes, {
                nextElected: nextElected,
                validators: validators
            }))));
}


var $ec5edaf0d8dff4e8$exports = {};

$parcel$export($ec5edaf0d8dff4e8$exports, "_ownExposures", function () { return $ec5edaf0d8dff4e8$export$fdb7833511c1cd24; });
$parcel$export($ec5edaf0d8dff4e8$exports, "ownExposure", function () { return $ec5edaf0d8dff4e8$export$bbdafe2153a0c1eb; });
$parcel$export($ec5edaf0d8dff4e8$exports, "ownExposures", function () { return $ec5edaf0d8dff4e8$export$6f8e2c5919202de3; });



function $ec5edaf0d8dff4e8$export$fdb7833511c1cd24(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId, eras, _withActive)=>eras.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(eras.map((e)=>api.query.staking.erasStakersClipped(e, accountId))),
            (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(eras.map((e)=>api.query.staking.erasStakers(e, accountId)))
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([clp, exp])=>eras.map((era, index)=>({
                    clipped: clp[index],
                    era: era,
                    exposure: exp[index]
                })))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}
const $ec5edaf0d8dff4e8$export$bbdafe2153a0c1eb = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId, era)=>api.derive.staking._ownExposures(accountId, [
        era
    ], true));
const $ec5edaf0d8dff4e8$export$6f8e2c5919202de3 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$dc48acbfe12786d7)("_ownExposures");


var $6fa05aeb687e3881$exports = {};

$parcel$export($6fa05aeb687e3881$exports, "_ownSlashes", function () { return $6fa05aeb687e3881$export$7df40f65e7dda2f4; });
$parcel$export($6fa05aeb687e3881$exports, "ownSlash", function () { return $6fa05aeb687e3881$export$2ac2974f11d6039f; });
$parcel$export($6fa05aeb687e3881$exports, "ownSlashes", function () { return $6fa05aeb687e3881$export$97d087335c0a168d; });



function $6fa05aeb687e3881$export$7df40f65e7dda2f4(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId, eras, _withActive)=>eras.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(eras.map((e)=>api.query.staking.validatorSlashInEra(e, accountId))),
            (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(eras.map((e)=>api.query.staking.nominatorSlashInEra(e, accountId)))
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([vals, noms])=>eras.map((era, index)=>({
                    era: era,
                    total: vals[index].isSome ? vals[index].unwrap()[1] : noms[index].unwrapOrDefault()
                })))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}
const $6fa05aeb687e3881$export$2ac2974f11d6039f = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId, era)=>api.derive.staking._ownSlashes(accountId, [
        era
    ], true));
const $6fa05aeb687e3881$export$97d087335c0a168d = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$dc48acbfe12786d7)("_ownSlashes");


var $27794d81db79af07$exports = {};

$parcel$export($27794d81db79af07$exports, "query", function () { return $27794d81db79af07$export$2fa187e846a241c4; });
$parcel$export($27794d81db79af07$exports, "queryMulti", function () { return $27794d81db79af07$export$2527d0dce817108f; });


function $27794d81db79af07$var$parseDetails(stashId, controllerIdOpt, nominatorsOpt, rewardDestination, validatorPrefs, exposure, stakingLedgerOpt) {
    return {
        accountId: stashId,
        controllerId: controllerIdOpt && controllerIdOpt.unwrapOr(null),
        exposure: exposure,
        nominators: nominatorsOpt.isSome ? nominatorsOpt.unwrap().targets : [],
        rewardDestination: rewardDestination,
        stakingLedger: stakingLedgerOpt.unwrapOrDefault(),
        stashId: stashId,
        validatorPrefs: validatorPrefs
    };
}
function $27794d81db79af07$var$getLedgers(api, optIds, { withLedger: withLedger = false }) {
    const ids = optIds.filter((o)=>withLedger && !!o && o.isSome).map((o)=>o.unwrap());
    const emptyLed = api.registry.createType("Option<StakingLedger>");
    return (ids.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(ids.map((s)=>api.query.staking.ledger(s))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((optLedgers)=>{
        let offset = -1;
        return optIds.map((o)=>o && o.isSome ? optLedgers[++offset] || emptyLed : emptyLed);
    }));
}
function $27794d81db79af07$var$getStashInfo(api, stashIds, activeEra, { withController: withController, withDestination: withDestination, withExposure: withExposure, withLedger: withLedger, withNominations: withNominations, withPrefs: withPrefs }) {
    const emptyNoms = api.registry.createType("Option<Nominations>");
    const emptyRewa = api.registry.createType("RewardDestination");
    const emptyExpo = api.registry.createType("Exposure");
    const emptyPrefs = api.registry.createType("ValidatorPrefs");
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        withController || withLedger ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(stashIds.map((s)=>api.query.staking.bonded(s))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(stashIds.map(()=>null)),
        withNominations ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(stashIds.map((s)=>api.query.staking.nominators(s))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(stashIds.map(()=>emptyNoms)),
        withDestination ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(stashIds.map((s)=>api.query.staking.payee(s))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(stashIds.map(()=>emptyRewa)),
        withPrefs ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(stashIds.map((s)=>api.query.staking.validators(s))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(stashIds.map(()=>emptyPrefs)),
        withExposure ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)(stashIds.map((s)=>api.query.staking.erasStakers(activeEra, s))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(stashIds.map(()=>emptyExpo))
    ]);
}
function $27794d81db79af07$var$getBatch(api, activeEra, stashIds, flags) {
    return $27794d81db79af07$var$getStashInfo(api, stashIds, activeEra, flags).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([controllerIdOpt, nominatorsOpt, rewardDestination, validatorPrefs, exposure])=>$27794d81db79af07$var$getLedgers(api, controllerIdOpt, flags).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((stakingLedgerOpts)=>stashIds.map((stashId, index)=>$27794d81db79af07$var$parseDetails(stashId, controllerIdOpt[index], nominatorsOpt[index], rewardDestination[index], validatorPrefs[index], exposure[index], stakingLedgerOpts[index]))))));
}
const $27794d81db79af07$export$2fa187e846a241c4 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId, flags)=>api.derive.staking.queryMulti([
        accountId
    ], flags));
function $27794d81db79af07$export$2527d0dce817108f(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, flags)=>api.derive.session.indexes().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(({ activeEra: activeEra })=>{
            const stashIds = accountIds.map((a)=>api.registry.createType("AccountId", a));
            return stashIds.length ? $27794d81db79af07$var$getBatch(api, activeEra, stashIds, flags) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]);
        })));
}


var $333b8b93e24efe48$exports = {};

$parcel$export($333b8b93e24efe48$exports, "_stakerExposures", function () { return $333b8b93e24efe48$export$293d05a8d6401fbb; });
$parcel$export($333b8b93e24efe48$exports, "stakerExposures", function () { return $333b8b93e24efe48$export$4404fb686c7cf58f; });
$parcel$export($333b8b93e24efe48$exports, "stakerExposure", function () { return $333b8b93e24efe48$export$6a157b11d526b965; });


function $333b8b93e24efe48$export$293d05a8d6401fbb(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, eras, withActive = false)=>{
        const stakerIds = accountIds.map((a)=>api.registry.createType("AccountId", a).toString());
        return api.derive.staking._erasExposure(eras, withActive).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((exposures)=>stakerIds.map((stakerId)=>exposures.map(({ era: era, nominators: allNominators, validators: allValidators })=>{
                    const isValidator = !!allValidators[stakerId];
                    const validators = {};
                    const nominating = allNominators[stakerId] || [];
                    if (isValidator) validators[stakerId] = allValidators[stakerId];
                    else if (nominating) nominating.forEach(({ validatorId: validatorId })=>{
                        validators[validatorId] = allValidators[validatorId];
                    });
                    return {
                        era: era,
                        isEmpty: !Object.keys(validators).length,
                        isValidator: isValidator,
                        nominating: nominating,
                        validators: validators
                    };
                }))));
    });
}
function $333b8b93e24efe48$export$4404fb686c7cf58f(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, withActive = false)=>api.derive.staking.erasHistoric(withActive).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((eras)=>api.derive.staking._stakerExposures(accountIds, eras, withActive))));
}
const $333b8b93e24efe48$export$6a157b11d526b965 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId, withActive)=>api.derive.staking.stakerExposures([
        accountId
    ], withActive));


var $b3eec2e8bd18c071$exports = {};

$parcel$export($b3eec2e8bd18c071$exports, "_stakerPoints", function () { return $b3eec2e8bd18c071$export$8f3a5dd12e064c25; });
$parcel$export($b3eec2e8bd18c071$exports, "stakerPoints", function () { return $b3eec2e8bd18c071$export$e7b46a25b1da9de9; });



function $b3eec2e8bd18c071$export$8f3a5dd12e064c25(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId, eras, withActive)=>{
        const stakerId = api.registry.createType("AccountId", accountId).toString();
        return api.derive.staking._erasPoints(eras, withActive).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((points)=>points.map(({ era: era, eraPoints: eraPoints, validators: validators })=>({
                    era: era,
                    eraPoints: eraPoints,
                    points: validators[stakerId] || api.registry.createType("RewardPoint")
                }))));
    });
}
const $b3eec2e8bd18c071$export$e7b46a25b1da9de9 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$dc48acbfe12786d7)("_stakerPoints");


var $471de4e99d212120$exports = {};

$parcel$export($471de4e99d212120$exports, "_stakerPrefs", function () { return $471de4e99d212120$export$e8fb4a56f5e5b573; });
$parcel$export($471de4e99d212120$exports, "stakerPrefs", function () { return $471de4e99d212120$export$1bc9c64e154063e0; });



function $471de4e99d212120$export$e8fb4a56f5e5b573(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId, eras, _withActive)=>api.query.staking.erasValidatorPrefs.multi(eras.map((e)=>[
                e,
                accountId
            ])).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((all)=>all.map((validatorPrefs, index)=>({
                    era: eras[index],
                    validatorPrefs: validatorPrefs
                })))));
}
const $471de4e99d212120$export$1bc9c64e154063e0 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$dc48acbfe12786d7)("_stakerPrefs");


var $c1521ffdec0748b5$exports = {};

$parcel$export($c1521ffdec0748b5$exports, "_stakerRewardsEras", function () { return $c1521ffdec0748b5$export$5809d38367dbab37; });
$parcel$export($c1521ffdec0748b5$exports, "_stakerRewards", function () { return $c1521ffdec0748b5$export$266eb248314e6781; });
$parcel$export($c1521ffdec0748b5$exports, "stakerRewards", function () { return $c1521ffdec0748b5$export$572010ad5c41ec2; });
$parcel$export($c1521ffdec0748b5$exports, "stakerRewardsMultiEras", function () { return $c1521ffdec0748b5$export$bb7efc4a13388614; });
$parcel$export($c1521ffdec0748b5$exports, "stakerRewardsMulti", function () { return $c1521ffdec0748b5$export$9e63feb26d776cc6; });



function $c1521ffdec0748b5$var$parseRewards(api, stashId, [erasPoints, erasPrefs, erasRewards], exposures) {
    return exposures.map(({ era: era, isEmpty: isEmpty, isValidator: isValidator, nominating: nominating, validators: eraValidators })=>{
        const { eraPoints: eraPoints, validators: allValPoints } = erasPoints.find((p)=>p.era.eq(era)) || {
            eraPoints: (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa),
            validators: {}
        };
        const { eraReward: eraReward } = erasRewards.find((r)=>r.era.eq(era)) || {
            eraReward: api.registry.createType("Balance")
        };
        const { validators: allValPrefs } = erasPrefs.find((p)=>p.era.eq(era)) || {
            validators: {}
        };
        const validators = {};
        const stakerId = stashId.toString();
        Object.entries(eraValidators).forEach(([validatorId, exposure])=>{
            const valPoints = allValPoints[validatorId] || (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa);
            const valComm = allValPrefs[validatorId]?.commission.unwrap() || (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa);
            const expTotal = exposure.total?.unwrap() || (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa);
            let avail = (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa);
            let value;
            if (!(expTotal.isZero() || valPoints.isZero() || eraPoints.isZero())) {
                avail = eraReward.mul(valPoints).div(eraPoints);
                const valCut = valComm.mul(avail).div((0, $031d4cf4355dbeac$export$c576b535d52501f1));
                let staked;
                if (validatorId === stakerId) staked = exposure.own.unwrap();
                else {
                    const stakerExp = exposure.others.find(({ who: who })=>who.eq(stakerId));
                    staked = stakerExp ? stakerExp.value.unwrap() : (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa);
                }
                value = avail.sub(valCut).imul(staked).div(expTotal).iadd(validatorId === stakerId ? valCut : (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa));
            }
            validators[validatorId] = {
                total: api.registry.createType("Balance", avail),
                value: api.registry.createType("Balance", value)
            };
        });
        return {
            era: era,
            eraReward: eraReward,
            isEmpty: isEmpty,
            isValidator: isValidator,
            nominating: nominating,
            validators: validators
        };
    });
}
function $c1521ffdec0748b5$var$allUniqValidators(rewards) {
    return rewards.reduce(([all, perStash], rewards)=>{
        const uniq = [];
        perStash.push(uniq);
        rewards.forEach(({ validators: validators })=>Object.keys(validators).forEach((validatorId)=>{
                if (!uniq.includes(validatorId)) {
                    uniq.push(validatorId);
                    if (!all.includes(validatorId)) all.push(validatorId);
                }
            }));
        return [
            all,
            perStash
        ];
    }, [
        [],
        []
    ]);
}
function $c1521ffdec0748b5$var$removeClaimed(validators, queryValidators, reward) {
    const rm = [];
    Object.keys(reward.validators).forEach((validatorId)=>{
        const index = validators.indexOf(validatorId);
        if (index !== -1) {
            const valLedger = queryValidators[index].stakingLedger;
            if (valLedger?.claimedRewards.some((e)=>reward.era.eq(e))) rm.push(validatorId);
        }
    });
    rm.forEach((validatorId)=>{
        delete reward.validators[validatorId];
    });
}
function $c1521ffdec0748b5$var$filterRewards(eras, valInfo, { rewards: rewards, stakingLedger: stakingLedger }) {
    const filter = eras.filter((e)=>!stakingLedger.claimedRewards.some((s)=>s.eq(e)));
    const validators = valInfo.map(([v])=>v);
    const queryValidators = valInfo.map(([, q])=>q);
    return rewards.filter(({ isEmpty: isEmpty })=>!isEmpty).filter((reward)=>{
        if (!filter.some((e)=>reward.era.eq(e))) return false;
        $c1521ffdec0748b5$var$removeClaimed(validators, queryValidators, reward);
        return true;
    }).filter(({ validators: validators })=>Object.keys(validators).length !== 0).map((reward)=>(0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, reward, {
            nominators: reward.nominating.filter((n)=>reward.validators[n.validatorId])
        }));
}
function $c1521ffdec0748b5$export$5809d38367dbab37(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (eras, withActive = false)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.staking._erasPoints(eras, withActive),
            api.derive.staking._erasPrefs(eras, withActive),
            api.derive.staking._erasRewards(eras, withActive)
        ]));
}
function $c1521ffdec0748b5$export$266eb248314e6781(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, eras, withActive = false)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.staking.queryMulti(accountIds, {
                withLedger: true
            }),
            api.derive.staking._stakerExposures(accountIds, eras, withActive),
            api.derive.staking._stakerRewardsEras(eras, withActive)
        ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([queries, exposures, erasResult])=>{
            const allRewards = queries.map(({ stakingLedger: stakingLedger, stashId: stashId }, index)=>!stashId || !stakingLedger ? [] : $c1521ffdec0748b5$var$parseRewards(api, stashId, erasResult, exposures[index]));
            if (withActive) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(allRewards);
            const [allValidators, stashValidators] = $c1521ffdec0748b5$var$allUniqValidators(allRewards);
            return api.derive.staking.queryMulti(allValidators, {
                withLedger: true
            }).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((queriedVals)=>queries.map(({ stakingLedger: stakingLedger }, index)=>$c1521ffdec0748b5$var$filterRewards(eras, stashValidators[index].map((validatorId)=>[
                            validatorId,
                            queriedVals.find((q)=>q.accountId.eq(validatorId))
                        ]), {
                        rewards: allRewards[index],
                        stakingLedger: stakingLedger
                    }))));
        })));
}
const $c1521ffdec0748b5$export$572010ad5c41ec2 = /*#__PURE__*/ (0, $4cbfbf6045db21e5$export$6937bf188da273fb)((api, accountId, withActive)=>api.derive.staking.erasHistoric(withActive).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((eras)=>api.derive.staking._stakerRewards([
            accountId
        ], eras, withActive))));
function $c1521ffdec0748b5$export$bb7efc4a13388614(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, eras)=>accountIds.length && eras.length ? api.derive.staking._stakerRewards(accountIds, eras, false) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
}
function $c1521ffdec0748b5$export$9e63feb26d776cc6(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountIds, withActive = false)=>api.derive.staking.erasHistoric(withActive).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((eras)=>api.derive.staking.stakerRewardsMultiEras(accountIds, eras))));
}


var $5eb895b5f6490721$exports = {};

$parcel$export($5eb895b5f6490721$exports, "_stakerSlashes", function () { return $5eb895b5f6490721$export$9a1822f6ceb4ebca; });
$parcel$export($5eb895b5f6490721$exports, "stakerSlashes", function () { return $5eb895b5f6490721$export$496a4023e9d98915; });



function $5eb895b5f6490721$export$9a1822f6ceb4ebca(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (accountId, eras, withActive)=>{
        const stakerId = api.registry.createType("AccountId", accountId).toString();
        return api.derive.staking._erasSlashes(eras, withActive).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((slashes)=>slashes.map(({ era: era, nominators: nominators, validators: validators })=>({
                    era: era,
                    total: nominators[stakerId] || validators[stakerId] || api.registry.createType("Balance")
                }))));
    });
}
const $5eb895b5f6490721$export$496a4023e9d98915 = /*#__PURE__*/ (0, $74a1e6f8326c9c2f$export$dc48acbfe12786d7)("_stakerSlashes");


var $1b12e889ccf080d6$exports = {};

$parcel$export($1b12e889ccf080d6$exports, "stashes", function () { return $1b12e889ccf080d6$export$8b2f87d03f6d8367; });


function $1b12e889ccf080d6$var$onBondedEvent(api) {
    let current = Date.now();
    return api.query.system.events().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((events)=>{
        current = events.filter(({ event: event, phase: phase })=>{
            try {
                return phase.isApplyExtrinsic && event.section === "staking" && event.method === "Bonded";
            } catch  {
                return false;
            }
        }) ? Date.now() : current;
        return current;
    }), (0, $fa2edaed0b135380$export$a4fe86229b0e9bdd)(current), (0, $d53961cc3e3471c7$export$5d0437caf0b8f08f)({
        skipTimeout: true
    }));
}
function $1b12e889ccf080d6$export$8b2f87d03f6d8367(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>$1b12e889ccf080d6$var$onBondedEvent(api).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(()=>api.query.staking.validators.keys()), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((keys)=>keys.map(({ args: [v] })=>v).filter((a)=>a))));
}


var $90f219fe9f23ae8b$exports = {};

$parcel$export($90f219fe9f23ae8b$exports, "nextElected", function () { return $90f219fe9f23ae8b$export$e3422018f5bf4110; });
$parcel$export($90f219fe9f23ae8b$exports, "validators", function () { return $90f219fe9f23ae8b$export$6f98703d2f5d4276; });


function $90f219fe9f23ae8b$export$e3422018f5bf4110(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.staking.erasStakers ? api.derive.session.indexes().pipe(// only populate for next era in the last session, so track both here - entries are not
        // subscriptions, so we need a trigger - currentIndex acts as that trigger to refresh
        (0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(({ currentEra: currentEra })=>api.query.staking.erasStakers.keys(currentEra)), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((keys)=>keys.map(({ args: [, accountId] })=>accountId))) : api.query.staking["currentElected"]());
}
function $90f219fe9f23ae8b$export$6f98703d2f5d4276(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>// Sadly the node-template is (for some obscure reason) not comprehensive, so while the derive works
        // in all actual real-world deployed chains, it does create some confusion for limited template chains
        (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.query.session ? api.query.session.validators() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]),
            api.query.staking ? api.derive.staking.nextElected() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([validators, nextElected])=>({
                nextElected: nextElected.length ? nextElected : validators,
                validators: validators
            }))));
}


var $cf92e5a953972a8a$exports = {};

$parcel$export($cf92e5a953972a8a$exports, "waitingInfo", function () { return $cf92e5a953972a8a$export$41b3412aa99f4b35; });


const $cf92e5a953972a8a$var$DEFAULT_FLAGS = {
    withController: true,
    withPrefs: true
};
function $cf92e5a953972a8a$export$41b3412aa99f4b35(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (flags = $cf92e5a953972a8a$var$DEFAULT_FLAGS)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.derive.staking.validators(),
            api.derive.staking.stashes()
        ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([{ nextElected: nextElected }, stashes])=>{
            const elected = nextElected.map((a)=>a.toString());
            const waiting = stashes.filter((v)=>!elected.includes(v.toString()));
            return api.derive.staking.queryMulti(waiting, flags).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((info)=>({
                    info: info,
                    waiting: waiting
                })));
        })));
}


$parcel$exportWildcard($5ff67c6a184312d5$exports, $b0c8592c02196f49$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $74c0f541a92b4973$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $8b90090d7946c730$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $e45f49a7601ebca0$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $cce99ab362452a70$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $37007be96dbf6bf3$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $dce473b8d44b3121$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $2f10f4a93b91bf2d$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $72d9d3506469e06e$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $4d898ebced36411c$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $8a9619a237040e4d$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $ec5edaf0d8dff4e8$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $6fa05aeb687e3881$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $27794d81db79af07$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $333b8b93e24efe48$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $b3eec2e8bd18c071$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $471de4e99d212120$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $c1521ffdec0748b5$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $5eb895b5f6490721$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $1b12e889ccf080d6$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $90f219fe9f23ae8b$exports);
$parcel$exportWildcard($5ff67c6a184312d5$exports, $cf92e5a953972a8a$exports);


var $2d5dfaf6e8c2217b$exports = {};

$parcel$export($2d5dfaf6e8c2217b$exports, "members", function () { return $2d5dfaf6e8c2217b$export$100ad4af8c8d544f; });
$parcel$export($2d5dfaf6e8c2217b$exports, "hasProposals", function () { return $2d5dfaf6e8c2217b$export$bb89e61a247f7297; });
$parcel$export($2d5dfaf6e8c2217b$exports, "proposal", function () { return $2d5dfaf6e8c2217b$export$2ce2edfe63bacbbd; });
$parcel$export($2d5dfaf6e8c2217b$exports, "proposalCount", function () { return $2d5dfaf6e8c2217b$export$376b9c225e2427fa; });
$parcel$export($2d5dfaf6e8c2217b$exports, "proposalHashes", function () { return $2d5dfaf6e8c2217b$export$eaa0407513beb83b; });
$parcel$export($2d5dfaf6e8c2217b$exports, "proposals", function () { return $2d5dfaf6e8c2217b$export$803aac3a222d8bb8; });
$parcel$export($2d5dfaf6e8c2217b$exports, "prime", function () { return $2d5dfaf6e8c2217b$export$1cac00b2a622912a; });

const $2d5dfaf6e8c2217b$export$100ad4af8c8d544f = /*#__PURE__*/ (0, $f072415ace5e2936$export$100ad4af8c8d544f)("technicalCommittee");
const $2d5dfaf6e8c2217b$export$bb89e61a247f7297 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$bb89e61a247f7297)("technicalCommittee");
const $2d5dfaf6e8c2217b$export$2ce2edfe63bacbbd = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$2ce2edfe63bacbbd)("technicalCommittee");
const $2d5dfaf6e8c2217b$export$376b9c225e2427fa = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$376b9c225e2427fa)("technicalCommittee");
const $2d5dfaf6e8c2217b$export$eaa0407513beb83b = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$eaa0407513beb83b)("technicalCommittee");
const $2d5dfaf6e8c2217b$export$803aac3a222d8bb8 = /*#__PURE__*/ (0, $70904c3fcdd7e3b2$export$803aac3a222d8bb8)("technicalCommittee");
const $2d5dfaf6e8c2217b$export$1cac00b2a622912a = /*#__PURE__*/ (0, $0a21f0df368cf435$export$1cac00b2a622912a)("technicalCommittee");


var $612dcdb0d257f4a2$exports = {};
var $0a2dbebaab0c0514$exports = {};

$parcel$export($0a2dbebaab0c0514$exports, "proposals", function () { return $0a2dbebaab0c0514$export$803aac3a222d8bb8; });


function $0a2dbebaab0c0514$var$parseResult(api, { allIds: allIds, allProposals: allProposals, approvalIds: approvalIds, councilProposals: councilProposals, proposalCount: proposalCount }) {
    const approvals = [];
    const proposals = [];
    const councilTreasury = councilProposals.filter(({ proposal: proposal })=>proposal && (api.tx.treasury.approveProposal.is(proposal) || api.tx.treasury.rejectProposal.is(proposal)));
    allIds.forEach((id, index)=>{
        if (allProposals[index].isSome) {
            const council = councilTreasury.filter(({ proposal: proposal })=>proposal && id.eq(proposal.args[0])).sort((a, b)=>a.proposal && b.proposal ? a.proposal.method.localeCompare(b.proposal.method) : a.proposal ? -1 : 1);
            const isApproval = approvalIds.some((approvalId)=>approvalId.eq(id));
            const derived = {
                council: council,
                id: id,
                proposal: allProposals[index].unwrap()
            };
            if (isApproval) approvals.push(derived);
            else proposals.push(derived);
        }
    });
    return {
        approvals: approvals,
        proposalCount: proposalCount,
        proposals: proposals
    };
}
function $0a2dbebaab0c0514$var$retrieveProposals(api, proposalCount, approvalIds) {
    const proposalIds = [];
    const count = proposalCount.toNumber();
    for(let index = 0; index < count; index++)if (!approvalIds.some((id)=>id.eqn(index))) proposalIds.push(api.registry.createType("ProposalIndex", index));
    const allIds = [
        ...proposalIds,
        ...approvalIds
    ];
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.query.treasury.proposals.multi(allIds),
        api.derive.council ? api.derive.council.proposals() : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([allProposals, councilProposals])=>$0a2dbebaab0c0514$var$parseResult(api, {
            allIds: allIds,
            allProposals: allProposals,
            approvalIds: approvalIds,
            councilProposals: councilProposals,
            proposalCount: proposalCount
        })));
}
function $0a2dbebaab0c0514$export$803aac3a222d8bb8(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, ()=>api.query.treasury ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.query.treasury.proposalCount(),
            api.query.treasury.approvals()
        ]).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(([proposalCount, approvalIds])=>$0a2dbebaab0c0514$var$retrieveProposals(api, proposalCount, approvalIds))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)({
            approvals: [],
            proposalCount: api.registry.createType("ProposalIndex"),
            proposals: []
        }));
}


$parcel$exportWildcard($612dcdb0d257f4a2$exports, $0a2dbebaab0c0514$exports);


var $f121ea8d3f44c270$exports = {};
var $e2fb885d8bf0587c$exports = {};

$parcel$export($e2fb885d8bf0587c$exports, "events", function () { return $e2fb885d8bf0587c$export$4bf9923669ad6c63; });


function $e2fb885d8bf0587c$export$4bf9923669ad6c63(instanceId, api) {
    return (0, $ab24732a7fa90447$export$7c73462e0d25e514)(instanceId, (blockHash)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            api.rpc.chain.getBlock(blockHash),
            api.queryAt(blockHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((queryAt)=>queryAt.system.events()))
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([block, events])=>({
                block: block,
                events: events
            }))));
}


var $dc0fce059a10263c$exports = {};

$parcel$export($dc0fce059a10263c$exports, "signingInfo", function () { return $dc0fce059a10263c$export$b196f5f6e91a35a7; });




var $hWfed = parcelRequire("hWfed");
const $60c351b90afece21$export$684fded775e96ca0 = 250;
const $60c351b90afece21$export$e7a943a129e20aad = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(6000);
const $60c351b90afece21$export$55e9067362d6f4c7 = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(5);
const $60c351b90afece21$export$29de014bafecffd1 = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(300000);


function $dc0fce059a10263c$var$latestNonce(api, address) {
    return api.derive.balances.account(address).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(({ accountNonce: accountNonce })=>accountNonce));
}
function $dc0fce059a10263c$var$nextNonce(api, address) {
    return api.rpc.system?.accountNextIndex ? api.rpc.system.accountNextIndex(address) : $dc0fce059a10263c$var$latestNonce(api, address);
}
function $dc0fce059a10263c$var$signingHeader(api) {
    return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
        api.rpc.chain.getHeader().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((header)=>// check for chains at genesis (until block 1 is produced, e.g. 6s), since
            // we do need to allow transactions at chain start (also dev/seal chains)
            header.parentHash.isEmpty ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(header) : api.rpc.chain.getHeader(header.parentHash).pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)(()=>(0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(header))))),
        api.rpc.chain.getFinalizedHead().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((hash)=>api.rpc.chain.getHeader(hash).pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)(()=>(0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null)))))
    ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([current, finalized])=>// determine the hash to use, current when lag > max, else finalized
        !finalized || (0, $f06ae579a041ba37$export$b7834c09351198be)(current).sub((0, $f06ae579a041ba37$export$b7834c09351198be)(finalized)).gt((0, $60c351b90afece21$export$55e9067362d6f4c7)) ? current : finalized));
}
function $dc0fce059a10263c$export$b196f5f6e91a35a7(_instanceId, api) {
    // no memo, we want to do this fresh on each run
    return (address, nonce, era)=>(0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)([
            // retrieve nonce if none was specified
            (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(nonce) ? $dc0fce059a10263c$var$latestNonce(api, address) : nonce === -1 ? $dc0fce059a10263c$var$nextNonce(api, address) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(api.registry.createType("Index", nonce)),
            // if no era (create) or era > 0 (mortal), do block retrieval
            (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(era) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(era) && era > 0 ? $dc0fce059a10263c$var$signingHeader(api) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(null)
        ]).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(([nonce, header])=>({
                header: header,
                mortalLength: Math.min(api.consts.system?.blockHashCount?.toNumber() || (0, $60c351b90afece21$export$684fded775e96ca0), (0, $60c351b90afece21$export$29de014bafecffd1).div(api.consts.babe?.expectedBlockTime || api.consts.timestamp?.minimumPeriod.muln(2) || (0, $60c351b90afece21$export$e7a943a129e20aad)).iadd((0, $60c351b90afece21$export$55e9067362d6f4c7)).toNumber()),
                nonce: nonce
            })));
}


$parcel$exportWildcard($f121ea8d3f44c270$exports, $e2fb885d8bf0587c$exports);
$parcel$exportWildcard($f121ea8d3f44c270$exports, $dc0fce059a10263c$exports);


const $c77afe4b0318357e$export$78ed5b3305815fc7 = {
    accounts: $c6e5f69bdad9c21b$exports,
    alliance: $cb487c4777b5c118$exports,
    bagsList: $e70acc60895c8c2a$exports,
    balances: $39d3a389d3c41bff$exports,
    bounties: $bad1e7a0a8a9dfd5$exports,
    chain: $45578ab7fb7fa864$exports,
    contracts: $e97ac1da89361e01$exports,
    council: $b3cdd8c415ff6b16$exports,
    crowdloan: $d76328f7febb0bdc$exports,
    democracy: $bbe1b83af9805521$exports,
    elections: $a028bc59a4c0810e$exports,
    imOnline: $c12abb0d0f1a759e$exports,
    membership: $34d402b2904f95ff$exports,
    parachains: $fd0fd080304433d4$exports,
    session: $9e4cb37e05bd272b$exports,
    society: $a0c050f26933fdbf$exports,
    staking: $5ff67c6a184312d5$exports,
    technicalCommittee: $2d5dfaf6e8c2217b$exports,
    treasury: $612dcdb0d257f4a2$exports,
    tx: $f121ea8d3f44c270$exports
};



const $9e08e8d0869f5d5d$var$checks = {
    allianceMotion: {
        instances: [
            "allianceMotion"
        ],
        methods: []
    },
    bagsList: {
        instances: [
            "voterBagsList",
            "voterList",
            "bagsList"
        ],
        methods: [],
        withDetect: true
    },
    contracts: {
        instances: [
            "contracts"
        ],
        methods: []
    },
    council: {
        instances: [
            "council"
        ],
        methods: [],
        withDetect: true
    },
    crowdloan: {
        instances: [
            "crowdloan"
        ],
        methods: []
    },
    democracy: {
        instances: [
            "democracy"
        ],
        methods: []
    },
    elections: {
        instances: [
            "phragmenElection",
            "electionsPhragmen",
            "elections",
            "council"
        ],
        methods: [],
        withDetect: true
    },
    imOnline: {
        instances: [
            "imOnline"
        ],
        methods: []
    },
    membership: {
        instances: [
            "membership"
        ],
        methods: []
    },
    parachains: {
        instances: [
            "parachains",
            "registrar"
        ],
        methods: []
    },
    session: {
        instances: [
            "session"
        ],
        methods: []
    },
    society: {
        instances: [
            "society"
        ],
        methods: []
    },
    staking: {
        instances: [
            "staking"
        ],
        methods: [
            "erasRewardPoints"
        ]
    },
    technicalCommittee: {
        instances: [
            "technicalCommittee"
        ],
        methods: [],
        withDetect: true
    },
    treasury: {
        instances: [
            "treasury"
        ],
        methods: []
    }
};
function $9e08e8d0869f5d5d$var$getModuleInstances(api, specName, moduleName) {
    return api.registry.getModuleInstances(specName, moduleName) || [];
}
/**
 * Returns an object that will inject `api` into all the functions inside
 * `allSections`, and keep the object architecture of `allSections`.
 */ /** @internal */ function $9e08e8d0869f5d5d$var$injectFunctions(instanceId, api, derives) {
    const result = {};
    const names = Object.keys(derives);
    const keys = Object.keys(api.query);
    const specName = api.runtimeVersion.specName;
    const filterKeys = (q)=>keys.includes(q);
    const filterInstances = (q)=>$9e08e8d0869f5d5d$var$getModuleInstances(api, specName, q).some(filterKeys);
    const filterMethods = (all)=>(m)=>all.some((q)=>keys.includes(q) && api.query[q][m]);
    const getKeys = (s)=>Object.keys(derives[s]);
    const creator = (s, m)=>derives[s][m](instanceId, api);
    const isIncluded = (c)=>!$9e08e8d0869f5d5d$var$checks[c] || $9e08e8d0869f5d5d$var$checks[c].instances.some(filterKeys) && (!$9e08e8d0869f5d5d$var$checks[c].methods.length || $9e08e8d0869f5d5d$var$checks[c].methods.every(filterMethods($9e08e8d0869f5d5d$var$checks[c].instances))) || $9e08e8d0869f5d5d$var$checks[c].withDetect && $9e08e8d0869f5d5d$var$checks[c].instances.some(filterInstances);
    for(let i = 0, count = names.length; i < count; i++){
        const name = names[i];
        isIncluded(name) && (0, $1404998085556672$export$58416e29444cc64)(result, name, getKeys, creator);
    }
    return result;
}
function $9e08e8d0869f5d5d$export$57f6da4ee225b75e(instanceId, api, custom = {}) {
    return {
        ...$9e08e8d0869f5d5d$var$injectFunctions(instanceId, api, (0, $c77afe4b0318357e$export$78ed5b3305815fc7)),
        ...$9e08e8d0869f5d5d$var$injectFunctions(instanceId, api, custom)
    };
}





const $b17f41ec49e7dcdd$var$jsonrpc = {};
Object.keys($f07063bab9185798$exports).forEach((s)=>Object.entries($f07063bab9185798$exports[s].rpc || {}).forEach(([method, def])=>{
        // allow for section overrides
        const section = def.aliasSection || s;
        if (!$b17f41ec49e7dcdd$var$jsonrpc[section]) $b17f41ec49e7dcdd$var$jsonrpc[section] = {};
        $b17f41ec49e7dcdd$var$jsonrpc[section][method] = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, def, {
            isSubscription: !!def.pubsub,
            jsonrpc: `${section}_${method}`,
            method: method,
            section: section
        });
    }));
var $b17f41ec49e7dcdd$export$2e2bcd8739ae039 = $b17f41ec49e7dcdd$var$jsonrpc;





const $ee7223588c9ee45e$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("rpc-core");
const $ee7223588c9ee45e$var$EMPTY_META = {
    fallback: undefined,
    modifier: {
        isOptional: true
    },
    type: {
        asMap: {
            linked: {
                isTrue: false
            }
        },
        isMap: false
    }
};
/** @internal */ function $ee7223588c9ee45e$var$logErrorMessage(method, { noErrorLog: noErrorLog, params: params, type: type }, error) {
    if (noErrorLog) return;
    $ee7223588c9ee45e$var$l.error(`${method}(${params.map(({ isOptional: isOptional, name: name, type: type })=>`${name}${isOptional ? "?" : ""}: ${type}`).join(", ")}): ${type}:: ${error.message}`);
}
function $ee7223588c9ee45e$var$isTreatAsHex(key) {
    // :code is problematic - it does not have the length attached, which is
    // unlike all other storage entries where it is indeed properly encoded
    return [
        "0x3a636f6465"
    ].includes(key.toHex());
}
class $ee7223588c9ee45e$export$a87e1cf60dfc73a7 {
    /**
     * @constructor
     * Default constructor for the core RPC handler
     * @param  {ProviderInterface} provider An API provider using any of the supported providers (HTTP, SC or WebSocket)
     */ constructor(instanceId, registry, { isPedantic: isPedantic = true, provider: provider, userRpc: userRpc = {} }){
        this.__internal__storageCache = new Map();
        this.mapping = new Map();
        this.sections = [];
        // eslint-disable-next-line @typescript-eslint/unbound-method
        if (!provider || !(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(provider.send)) throw new Error("Expected Provider to API create");
        this.__internal__instanceId = instanceId;
        this.__internal__isPedantic = isPedantic;
        this.__internal__registryDefault = registry;
        this.provider = provider;
        const sectionNames = Object.keys((0, $b17f41ec49e7dcdd$export$2e2bcd8739ae039));
        // these are the base keys (i.e. part of jsonrpc)
        this.sections.push(...sectionNames);
        // decorate all interfaces, defined and user on this instance
        this.addUserInterfaces(userRpc);
    }
    /**
     * @description Returns the connected status of a provider
     */ get isConnected() {
        return this.provider.isConnected;
    }
    /**
     * @description Manually connect from the attached provider
     */ connect() {
        return this.provider.connect();
    }
    /**
     * @description Manually disconnect from the attached provider
     */ disconnect() {
        return this.provider.disconnect();
    }
    /**
     * @description Sets a registry swap (typically from Api)
     */ setRegistrySwap(registrySwap) {
        this.__internal__getBlockRegistry = (0, $963d14c700537c88$export$fc10aeed3a532e2a)(registrySwap, {
            getInstanceId: ()=>this.__internal__instanceId
        });
    }
    /**
     * @description Sets a function to resolve block hash from block number
     */ setResolveBlockHash(resolveBlockHash) {
        this.__internal__getBlockHash = (0, $963d14c700537c88$export$fc10aeed3a532e2a)(resolveBlockHash, {
            getInstanceId: ()=>this.__internal__instanceId
        });
    }
    addUserInterfaces(userRpc) {
        // add any extra user-defined sections
        this.sections.push(...Object.keys(userRpc).filter((k)=>!this.sections.includes(k)));
        for(let s = 0, scount = this.sections.length; s < scount; s++){
            const section = this.sections[s];
            const defs = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, (0, $b17f41ec49e7dcdd$export$2e2bcd8739ae039)[section], userRpc[section]);
            const methods = Object.keys(defs);
            for(let m = 0, mcount = methods.length; m < mcount; m++){
                const method = methods[m];
                const def = defs[method];
                const jsonrpc = def.endpoint || `${section}_${method}`;
                if (!this.mapping.has(jsonrpc)) {
                    const isSubscription = !!def.pubsub;
                    if (!this[section]) this[section] = {};
                    this.mapping.set(jsonrpc, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, def, {
                        isSubscription: isSubscription,
                        jsonrpc: jsonrpc,
                        method: method,
                        section: section
                    }));
                    (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(this[section], method, ()=>isSubscription ? this._createMethodSubscribe(section, method, def) : this._createMethodSend(section, method, def));
                }
            }
        }
    }
    _memomize(creator, def) {
        const memoOpts = {
            getInstanceId: ()=>this.__internal__instanceId
        };
        const memoized = (0, $963d14c700537c88$export$fc10aeed3a532e2a)(creator(true), memoOpts);
        memoized.raw = (0, $963d14c700537c88$export$fc10aeed3a532e2a)(creator(false), memoOpts);
        memoized.meta = def;
        return memoized;
    }
    _formatResult(isScale, registry, blockHash, method, def, params, result) {
        return isScale ? this._formatOutput(registry, blockHash, method, def, params, result) : result;
    }
    _createMethodSend(section, method, def) {
        const rpcName = def.endpoint || `${section}_${method}`;
        const hashIndex = def.params.findIndex(({ isHistoric: isHistoric })=>isHistoric);
        let memoized = null;
        // execute the RPC call, doing a registry swap for historic as applicable
        const callWithRegistry = async (isScale, values)=>{
            const blockId = hashIndex === -1 ? null : values[hashIndex];
            const blockHash = blockId && def.params[hashIndex].type === "BlockNumber" ? await this.__internal__getBlockHash?.(blockId) : blockId;
            const { registry: registry } = isScale && blockHash && this.__internal__getBlockRegistry ? await this.__internal__getBlockRegistry((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(blockHash)) : {
                registry: this.__internal__registryDefault
            };
            const params = this._formatParams(registry, null, def, values);
            // only cache .at(<blockHash>) queries, e.g. where valid blockHash was supplied
            const result = await this.provider.send(rpcName, params.map((p)=>p.toJSON()), !!blockHash);
            return this._formatResult(isScale, registry, blockHash, method, def, params, result);
        };
        const creator = (isScale)=>(...values)=>{
                const isDelayed = isScale && hashIndex !== -1 && !!values[hashIndex];
                return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)((observer)=>{
                    callWithRegistry(isScale, values).then((value)=>{
                        observer.next(value);
                        observer.complete();
                    }).catch((error)=>{
                        $ee7223588c9ee45e$var$logErrorMessage(method, def, error);
                        observer.error(error);
                        observer.complete();
                    });
                    return ()=>{
                        // delete old results from cache
                        if (isScale) memoized?.unmemoize(...values);
                        else memoized?.raw.unmemoize(...values);
                    };
                }).pipe(// eslint-disable-next-line deprecation/deprecation
                (0, $6b94d8a3a42e897d$export$1f3342bf81d92d52)(1), isDelayed ? (0, $af07b3a8f3032eab$export$80e0d6d4a808a79)() // Unsubscribe after delay
                 : (0, $b779a8a892b6cef5$export$18d0766d894cba0c)());
            };
        memoized = this._memomize(creator, def);
        return memoized;
    }
    // create a subscriptor, it subscribes once and resolves with the id as subscribe
    _createSubscriber({ paramsJson: paramsJson, subName: subName, subType: subType, update: update }, errorHandler) {
        return new Promise((resolve, reject)=>{
            this.provider.subscribe(subType, subName, paramsJson, update).then(resolve).catch((error)=>{
                errorHandler(error);
                reject(error);
            });
        });
    }
    _createMethodSubscribe(section, method, def) {
        const [updateType, subMethod, unsubMethod] = def.pubsub;
        const subName = `${section}_${subMethod}`;
        const unsubName = `${section}_${unsubMethod}`;
        const subType = `${section}_${updateType}`;
        let memoized = null;
        const creator = (isScale)=>(...values)=>{
                return new (0, $8732e18bef00f237$export$77cea355fa80b5f4)((observer)=>{
                    // Have at least an empty promise, as used in the unsubscribe
                    let subscriptionPromise = Promise.resolve(null);
                    const registry = this.__internal__registryDefault;
                    const errorHandler = (error)=>{
                        $ee7223588c9ee45e$var$logErrorMessage(method, def, error);
                        observer.error(error);
                    };
                    try {
                        const params = this._formatParams(registry, null, def, values);
                        const update = (error, result)=>{
                            if (error) {
                                $ee7223588c9ee45e$var$logErrorMessage(method, def, error);
                                return;
                            }
                            try {
                                observer.next(this._formatResult(isScale, registry, null, method, def, params, result));
                            } catch (error) {
                                observer.error(error);
                            }
                        };
                        subscriptionPromise = this._createSubscriber({
                            paramsJson: params.map((p)=>p.toJSON()),
                            subName: subName,
                            subType: subType,
                            update: update
                        }, errorHandler);
                    } catch (error) {
                        errorHandler(error);
                    }
                    // Teardown logic
                    return ()=>{
                        // Delete from cache, so old results don't hang around
                        if (isScale) memoized?.unmemoize(...values);
                        else memoized?.raw.unmemoize(...values);
                        // Unsubscribe from provider
                        subscriptionPromise.then((subscriptionId)=>(0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(subscriptionId) ? Promise.resolve(false) : this.provider.unsubscribe(subType, unsubName, subscriptionId)).catch((error)=>$ee7223588c9ee45e$var$logErrorMessage(method, def, error));
                    };
                }).pipe((0, $d53961cc3e3471c7$export$5d0437caf0b8f08f)());
            };
        memoized = this._memomize(creator, def);
        return memoized;
    }
    _formatParams(registry, blockHash, def, inputs) {
        const count = inputs.length;
        const reqCount = def.params.filter(({ isOptional: isOptional })=>!isOptional).length;
        if (count < reqCount || count > def.params.length) throw new Error(`Expected ${def.params.length} parameters${reqCount === def.params.length ? "" : ` (${def.params.length - reqCount} optional)`}, ${count} found instead`);
        const params = new Array(count);
        for(let i = 0; i < count; i++)params[i] = registry.createTypeUnsafe(def.params[i].type, [
            inputs[i]
        ], {
            blockHash: blockHash
        });
        return params;
    }
    _formatOutput(registry, blockHash, method, rpc, params, result) {
        if (rpc.type === "StorageData") {
            const key = params[0];
            return this._formatStorageData(registry, blockHash, key, result);
        } else if (rpc.type === "StorageChangeSet") {
            const keys = params[0];
            return keys ? this._formatStorageSet(registry, result.block, keys, result.changes) : registry.createType("StorageChangeSet", result);
        } else if (rpc.type === "Vec<StorageChangeSet>") {
            const jsonSet = result;
            const count = jsonSet.length;
            const mapped = new Array(count);
            for(let i = 0; i < count; i++){
                const { block: block, changes: changes } = jsonSet[i];
                mapped[i] = [
                    registry.createType("BlockHash", block),
                    this._formatStorageSet(registry, block, params[0], changes)
                ];
            }
            // we only query at a specific block, not a range - flatten
            return method === "queryStorageAt" ? mapped[0][1] : mapped;
        }
        return registry.createTypeUnsafe(rpc.type, [
            result
        ], {
            blockHash: blockHash
        });
    }
    _formatStorageData(registry, blockHash, key, value) {
        const isEmpty = (0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(value);
        // we convert to Uint8Array since it maps to the raw encoding, all
        // data will be correctly encoded (incl. numbers, excl. :code)
        const input = isEmpty ? null : $ee7223588c9ee45e$var$isTreatAsHex(key) ? value : (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
        return this._newType(registry, blockHash, key, input, isEmpty);
    }
    _formatStorageSet(registry, blockHash, keys, changes) {
        // For StorageChangeSet, the changes has the [key, value] mappings
        const count = keys.length;
        const withCache = count !== 1;
        const values = new Array(count);
        // multiple return values (via state.storage subscription), decode the
        // values one at a time, all based on the supplied query types
        for(let i = 0; i < count; i++)values[i] = this._formatStorageSetEntry(registry, blockHash, keys[i], changes, withCache, i);
        return values;
    }
    _formatStorageSetEntry(registry, blockHash, key, changes, withCache, entryIndex) {
        const hexKey = key.toHex();
        const found = changes.find(([key])=>key === hexKey);
        const isNotFound = (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(found);
        // if we don't find the value, this is our fallback
        //   - in the case of an array of values, fill the hole from the cache
        //   - if a single result value, don't fill - it is not an update hole
        //   - fallback to an empty option in all cases
        if (isNotFound && withCache) {
            const cached = this.__internal__storageCache.get(hexKey);
            if (cached) return cached;
        }
        const value = isNotFound ? null : found[1];
        const isEmpty = (0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(value);
        const input = isEmpty || $ee7223588c9ee45e$var$isTreatAsHex(key) ? value : (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(value);
        const codec = this._newType(registry, blockHash, key, input, isEmpty, entryIndex);
        // store the retrieved result - the only issue with this cache is that there is no
        // clearing of it, so very long running processes (not just a couple of hours, longer)
        // will increase memory beyond what is allowed.
        this.__internal__storageCache.set(hexKey, codec);
        return codec;
    }
    _newType(registry, blockHash, key, input, isEmpty, entryIndex = -1) {
        // single return value (via state.getStorage), decode the value based on the
        // outputType that we have specified. Fallback to Raw on nothing
        const type = key.outputType || "Raw";
        const meta = key.meta || $ee7223588c9ee45e$var$EMPTY_META;
        const entryNum = entryIndex === -1 ? "" : ` entry ${entryIndex}:`;
        try {
            return registry.createTypeUnsafe(type, [
                isEmpty ? meta.fallback ? type.includes("Linkage<") ? (0, $84207d7313fd2c40$export$7b640c40d4922c2e)((0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(meta.fallback.toHex()), new Uint8Array(2)) : (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(meta.fallback.toHex()) : undefined : meta.modifier.isOptional ? registry.createTypeUnsafe(type, [
                    input
                ], {
                    blockHash: blockHash,
                    isPedantic: this.__internal__isPedantic
                }) : input
            ], {
                blockHash: blockHash,
                isFallback: isEmpty && !!meta.fallback,
                isOptional: meta.modifier.isOptional,
                isPedantic: this.__internal__isPedantic && !meta.modifier.isOptional
            });
        } catch (error) {
            throw new Error(`Unable to decode storage ${key.section || "unknown"}.${key.method || "unknown"}:${entryNum}: ${error.message}`);
        }
    }
}


var $891aadac6ba73256$exports = {};
"use strict";
var $891aadac6ba73256$var$has = Object.prototype.hasOwnProperty, $891aadac6ba73256$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $891aadac6ba73256$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $891aadac6ba73256$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $891aadac6ba73256$var$Events().__proto__) $891aadac6ba73256$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $891aadac6ba73256$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $891aadac6ba73256$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $891aadac6ba73256$var$EE(fn, context || emitter, once), evt = $891aadac6ba73256$var$prefix ? $891aadac6ba73256$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $891aadac6ba73256$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $891aadac6ba73256$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $891aadac6ba73256$var$EventEmitter() {
    this._events = new $891aadac6ba73256$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($891aadac6ba73256$var$has.call(events, name)) names.push($891aadac6ba73256$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $891aadac6ba73256$var$prefix ? $891aadac6ba73256$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $891aadac6ba73256$var$prefix ? $891aadac6ba73256$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $891aadac6ba73256$var$prefix ? $891aadac6ba73256$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $891aadac6ba73256$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $891aadac6ba73256$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $891aadac6ba73256$var$prefix ? $891aadac6ba73256$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $891aadac6ba73256$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $891aadac6ba73256$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $891aadac6ba73256$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $891aadac6ba73256$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $891aadac6ba73256$var$prefix ? $891aadac6ba73256$var$prefix + event : event;
        if (this._events[evt]) $891aadac6ba73256$var$clearEvent(this, evt);
    } else {
        this._events = new $891aadac6ba73256$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$891aadac6ba73256$var$EventEmitter.prototype.off = $891aadac6ba73256$var$EventEmitter.prototype.removeListener;
$891aadac6ba73256$var$EventEmitter.prototype.addListener = $891aadac6ba73256$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$891aadac6ba73256$var$EventEmitter.prefixed = $891aadac6ba73256$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$891aadac6ba73256$var$EventEmitter.EventEmitter = $891aadac6ba73256$var$EventEmitter;
$891aadac6ba73256$exports = $891aadac6ba73256$var$EventEmitter;



const $a687c72efdf05eed$export$5578ef75f4140928 = /*#__PURE__*/ (0, $d5bd3faeeec86a19$export$ca37b3e45df82a11)("isPrototypeOf", "hasOwnProperty");


function $192eddd343d0487a$export$ff0a60c492425f45(Parent, Child) {
    // https://stackoverflow.com/questions/30993434/check-if-a-constructor-inherits-another-in-es6/30993664
    return (0, $a687c72efdf05eed$export$5578ef75f4140928)(Child) && (0, $a687c72efdf05eed$export$5578ef75f4140928)(Parent) ? Parent === Child || Parent.isPrototypeOf(Child) : false;
}





const $c45dfcd0117fdc7f$export$3909fb301d3dc8c9 = (0, $9ce44c51a85397c6$export$51e5d554977815ce).WebSocket;




const $a38d646e0efb7718$var$UNKNOWN = -99999;
function $a38d646e0efb7718$var$extend(that, name, value) {
    Object.defineProperty(that, name, {
        configurable: true,
        enumerable: false,
        value: value
    });
}
/**
 * @name RpcError
 * @summary Extension to the basic JS Error.
 * @description
 * The built-in JavaScript Error class is extended by adding a code to allow for Error categorization. In addition to the normal `stack`, `message`, the numeric `code` and `data` (any types) parameters are available on the object.
 * @example
 * <BR>
 *
 * ```javascript
 * const { RpcError } from '@polkadot/util');
 *
 * throw new RpcError('some message', RpcError.CODES.METHOD_NOT_FOUND); // => error.code = -32601
 * ```
 */ class $a38d646e0efb7718$var$RpcError extends Error {
    constructor(message = "", code = $a38d646e0efb7718$var$UNKNOWN, data){
        super();
        $a38d646e0efb7718$var$extend(this, "message", String(message));
        $a38d646e0efb7718$var$extend(this, "name", this.constructor.name);
        $a38d646e0efb7718$var$extend(this, "data", data);
        $a38d646e0efb7718$var$extend(this, "code", code);
        if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(Error.captureStackTrace)) Error.captureStackTrace(this, this.constructor);
        else {
            const { stack: stack } = new Error(message);
            stack && $a38d646e0efb7718$var$extend(this, "stack", stack);
        }
    }
}
$a38d646e0efb7718$var$RpcError.CODES = {
    ASSERT: -90009,
    INVALID_JSONRPC: -99998,
    METHOD_NOT_FOUND: -32601,
    UNKNOWN: $a38d646e0efb7718$var$UNKNOWN
};
var $a38d646e0efb7718$export$2e2bcd8739ae039 = $a38d646e0efb7718$var$RpcError;


function $6cf3a605ab84bc3b$var$formatErrorData(data) {
    if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(data)) return "";
    const formatted = `: ${(0, $0d672af39bfe8283$export$844ec244b1367d54)(data) ? data.replace(/Error\("/g, "").replace(/\("/g, "(").replace(/"\)/g, ")").replace(/\(/g, ", ").replace(/\)/g, "") : (0, $e2c4db534325025c$export$fac44ee5b035f737)(data)}`;
    // We need some sort of cut-off here since these can be very large and
    // very nested, pick a number and trim the result display to it
    return formatted.length <= 256 ? formatted : `${formatted.substring(0, 255)}…`;
}
function $6cf3a605ab84bc3b$var$checkError(error) {
    if (error) {
        const { code: code, data: data, message: message } = error;
        throw new (0, $a38d646e0efb7718$export$2e2bcd8739ae039)(`${code}: ${message}${$6cf3a605ab84bc3b$var$formatErrorData(data)}`, code, data);
    }
}
class $6cf3a605ab84bc3b$export$9a5fa01753cc630b {
    constructor(){
        this.__internal__id = 0;
    }
    decodeResponse(response) {
        if (!response || response.jsonrpc !== "2.0") throw new Error("Invalid jsonrpc field in decoded object");
        const isSubscription = !(0, $09d5dc0a6a4c347b$export$fce6876652108ab)(response.params) && !(0, $09d5dc0a6a4c347b$export$fce6876652108ab)(response.method);
        if (!(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(response.id) && (!isSubscription || !(0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(response.params.subscription) && !(0, $0d672af39bfe8283$export$844ec244b1367d54)(response.params.subscription))) throw new Error("Invalid id field in decoded object");
        $6cf3a605ab84bc3b$var$checkError(response.error);
        if (response.result === undefined && !isSubscription) throw new Error("No result found in jsonrpc response");
        if (isSubscription) {
            $6cf3a605ab84bc3b$var$checkError(response.params.error);
            return response.params.result;
        }
        return response.result;
    }
    encodeJson(method, params) {
        const [id, data] = this.encodeObject(method, params);
        return [
            id,
            (0, $e2c4db534325025c$export$fac44ee5b035f737)(data)
        ];
    }
    encodeObject(method, params) {
        const id = ++this.__internal__id;
        return [
            id,
            {
                id: id,
                jsonrpc: "2.0",
                method: method,
                params: params
            }
        ];
    }
}


const $f997c21acf1859b2$var$HTTP_URL = "http://127.0.0.1:9933";
const $f997c21acf1859b2$var$WS_URL = "ws://127.0.0.1:9944";
var $f997c21acf1859b2$export$2e2bcd8739ae039 = {
    HTTP_URL: $f997c21acf1859b2$var$HTTP_URL,
    WS_URL: $f997c21acf1859b2$var$WS_URL
};


const $c7cf042314dfb8ed$var$DEFAULT_CAPACITY = 128;
class $c7cf042314dfb8ed$var$LRUNode {
    constructor(key){
        this.key = key;
        this.next = this.prev = this;
    }
}
class $c7cf042314dfb8ed$export$182500e6725aad9a {
    constructor(capacity = $c7cf042314dfb8ed$var$DEFAULT_CAPACITY){
        this.__internal__data = new Map();
        this.__internal__refs = new Map();
        this.__internal__length = 0;
        this.capacity = capacity;
        this.__internal__head = this.__internal__tail = new $c7cf042314dfb8ed$var$LRUNode("<empty>");
    }
    get length() {
        return this.__internal__length;
    }
    get lengthData() {
        return this.__internal__data.size;
    }
    get lengthRefs() {
        return this.__internal__refs.size;
    }
    entries() {
        const keys = this.keys();
        const count = keys.length;
        const entries = new Array(count);
        for(let i = 0; i < count; i++){
            const key = keys[i];
            entries[i] = [
                key,
                this.__internal__data.get(key)
            ];
        }
        return entries;
    }
    keys() {
        const keys = [];
        if (this.__internal__length) {
            let curr = this.__internal__head;
            while(curr !== this.__internal__tail){
                keys.push(curr.key);
                curr = curr.next;
            }
            keys.push(curr.key);
        }
        return keys;
    }
    get(key) {
        const data = this.__internal__data.get(key);
        if (data) {
            this.__internal__toHead(key);
            return data;
        }
        return null;
    }
    set(key, value) {
        if (this.__internal__data.has(key)) this.__internal__toHead(key);
        else {
            const node = new $c7cf042314dfb8ed$var$LRUNode(key);
            this.__internal__refs.set(node.key, node);
            if (this.length === 0) this.__internal__head = this.__internal__tail = node;
            else {
                this.__internal__head.prev = node;
                node.next = this.__internal__head;
                this.__internal__head = node;
            }
            if (this.__internal__length === this.capacity) {
                this.__internal__data.delete(this.__internal__tail.key);
                this.__internal__refs.delete(this.__internal__tail.key);
                this.__internal__tail = this.__internal__tail.prev;
                this.__internal__tail.next = this.__internal__head;
            } else this.__internal__length += 1;
        }
        this.__internal__data.set(key, value);
    }
    __internal__toHead(key) {
        const ref = this.__internal__refs.get(key);
        if (ref && ref !== this.__internal__head) {
            ref.prev.next = ref.next;
            ref.next.prev = ref.prev;
            ref.next = this.__internal__head;
            this.__internal__head.prev = ref;
            this.__internal__head = ref;
        }
    }
}


const $4138ddf81440efff$var$known = {
    1000: "Normal Closure",
    1001: "Going Away",
    1002: "Protocol Error",
    1003: "Unsupported Data",
    1004: "(For future)",
    1005: "No Status Received",
    1006: "Abnormal Closure",
    1007: "Invalid frame payload data",
    1008: "Policy Violation",
    1009: "Message too big",
    1010: "Missing Extension",
    1011: "Internal Error",
    1012: "Service Restart",
    1013: "Try Again Later",
    1014: "Bad Gateway",
    1015: "TLS Handshake"
};
function $4138ddf81440efff$export$2bcb1c93091aadc8(code) {
    if (code >= 0 && code <= 999) return "(Unused)";
    else if (code >= 1016) {
        if (code <= 1999) return "(For WebSocket standard)";
        else if (code <= 2999) return "(For WebSocket extensions)";
        else if (code <= 3999) return "(For libraries and frameworks)";
        else if (code <= 4999) return "(For applications)";
    }
    return $4138ddf81440efff$var$known[code] || "(Unknown)";
}


const $e549b920579303d9$var$ALIASES = {
    chain_finalisedHead: "chain_finalizedHead",
    chain_subscribeFinalisedHeads: "chain_subscribeFinalizedHeads",
    chain_unsubscribeFinalisedHeads: "chain_unsubscribeFinalizedHeads"
};
const $e549b920579303d9$var$RETRY_DELAY = 2500;
const $e549b920579303d9$var$DEFAULT_TIMEOUT_MS = 60000;
const $e549b920579303d9$var$TIMEOUT_INTERVAL = 5000;
const $e549b920579303d9$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("api-ws");
/** @internal Clears a Record<*> of all keys, optionally with all callback on clear */ function $e549b920579303d9$var$eraseRecord(record, cb) {
    Object.keys(record).forEach((key)=>{
        if (cb) cb(record[key]);
        delete record[key];
    });
}
/** @internal Creates a default/empty stats object */ function $e549b920579303d9$var$defaultEndpointStats() {
    return {
        bytesRecv: 0,
        bytesSent: 0,
        cached: 0,
        errors: 0,
        requests: 0,
        subscriptions: 0,
        timeout: 0
    };
}
class $e549b920579303d9$export$676472937f48f64 {
    /**
     * @param {string | string[]}  endpoint    The endpoint url. Usually `ws://ip:9944` or `wss://ip:9944`, may provide an array of endpoint strings.
     * @param {number | false} autoConnectMs Whether to connect automatically or not (default). Provided value is used as a delay between retries.
     * @param {Record<string, string>} headers The headers provided to the underlying WebSocket
     * @param {number} [timeout] Custom timeout value used per request . Defaults to `DEFAULT_TIMEOUT_MS`
     */ constructor(endpoint = (0, $f997c21acf1859b2$export$2e2bcd8739ae039).WS_URL, autoConnectMs = $e549b920579303d9$var$RETRY_DELAY, headers = {}, timeout){
        this.__internal__callCache = new (0, $c7cf042314dfb8ed$export$182500e6725aad9a)();
        this.__internal__handlers = {};
        this.__internal__waitingForId = {};
        this.__internal__isConnected = false;
        this.__internal__subscriptions = {};
        this.__internal__timeoutId = null;
        this.__internal__emit = (type, ...args)=>{
            this.__internal__eventemitter.emit(type, ...args);
        };
        this.__internal__onSocketClose = (event)=>{
            const error = new Error(`disconnected from ${this.endpoint}: ${event.code}:: ${event.reason || (0, $4138ddf81440efff$export$2bcb1c93091aadc8)(event.code)}`);
            if (this.__internal__autoConnectMs > 0) $e549b920579303d9$var$l.error(error.message);
            this.__internal__isConnected = false;
            if (this.__internal__websocket) {
                this.__internal__websocket.onclose = null;
                this.__internal__websocket.onerror = null;
                this.__internal__websocket.onmessage = null;
                this.__internal__websocket.onopen = null;
                this.__internal__websocket = null;
            }
            if (this.__internal__timeoutId) {
                clearInterval(this.__internal__timeoutId);
                this.__internal__timeoutId = null;
            }
            // reject all hanging requests
            $e549b920579303d9$var$eraseRecord(this.__internal__handlers, (h)=>{
                try {
                    h.callback(error, undefined);
                } catch (err) {
                    // does not throw
                    $e549b920579303d9$var$l.error(err);
                }
            });
            $e549b920579303d9$var$eraseRecord(this.__internal__waitingForId);
            // Reset stats for active endpoint
            this.__internal__endpointStats = $e549b920579303d9$var$defaultEndpointStats();
            this.__internal__emit("disconnected");
            if (this.__internal__autoConnectMs > 0) setTimeout(()=>{
                this.connectWithRetry().catch(()=>{
                // does not throw
                });
            }, this.__internal__autoConnectMs);
        };
        this.__internal__onSocketError = (error)=>{
            $e549b920579303d9$var$l.debug(()=>[
                    "socket error",
                    error
                ]);
            this.__internal__emit("error", error);
        };
        this.__internal__onSocketMessage = (message)=>{
            $e549b920579303d9$var$l.debug(()=>[
                    "received",
                    message.data
                ]);
            const bytesRecv = message.data.length;
            this.__internal__endpointStats.bytesRecv += bytesRecv;
            this.__internal__stats.total.bytesRecv += bytesRecv;
            const response = JSON.parse(message.data);
            return (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(response.method) ? this.__internal__onSocketMessageResult(response) : this.__internal__onSocketMessageSubscribe(response);
        };
        this.__internal__onSocketMessageResult = (response)=>{
            const handler = this.__internal__handlers[response.id];
            if (!handler) {
                $e549b920579303d9$var$l.debug(()=>`Unable to find handler for id=${response.id}`);
                return;
            }
            try {
                const { method: method, params: params, subscription: subscription } = handler;
                const result = this.__internal__coder.decodeResponse(response);
                // first send the result - in case of subs, we may have an update
                // immediately if we have some queued results already
                handler.callback(null, result);
                if (subscription) {
                    const subId = `${subscription.type}::${result}`;
                    this.__internal__subscriptions[subId] = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, subscription, {
                        method: method,
                        params: params
                    });
                    // if we have a result waiting for this subscription already
                    if (this.__internal__waitingForId[subId]) this.__internal__onSocketMessageSubscribe(this.__internal__waitingForId[subId]);
                }
            } catch (error) {
                this.__internal__endpointStats.errors++;
                this.__internal__stats.total.errors++;
                handler.callback(error, undefined);
            }
            delete this.__internal__handlers[response.id];
        };
        this.__internal__onSocketMessageSubscribe = (response)=>{
            const method = $e549b920579303d9$var$ALIASES[response.method] || response.method || "invalid";
            const subId = `${method}::${response.params.subscription}`;
            const handler = this.__internal__subscriptions[subId];
            if (!handler) {
                // store the JSON, we could have out-of-order subid coming in
                this.__internal__waitingForId[subId] = response;
                $e549b920579303d9$var$l.debug(()=>`Unable to find handler for subscription=${subId}`);
                return;
            }
            // housekeeping
            delete this.__internal__waitingForId[subId];
            try {
                const result = this.__internal__coder.decodeResponse(response);
                handler.callback(null, result);
            } catch (error) {
                this.__internal__endpointStats.errors++;
                this.__internal__stats.total.errors++;
                handler.callback(error, undefined);
            }
        };
        this.__internal__onSocketOpen = ()=>{
            if (this.__internal__websocket === null) throw new Error("WebSocket cannot be null in onOpen");
            $e549b920579303d9$var$l.debug(()=>[
                    "connected to",
                    this.endpoint
                ]);
            this.__internal__isConnected = true;
            this.__internal__resubscribe();
            this.__internal__emit("connected");
            return true;
        };
        this.__internal__resubscribe = ()=>{
            const subscriptions = this.__internal__subscriptions;
            this.__internal__subscriptions = {};
            Promise.all(Object.keys(subscriptions).map(async (id)=>{
                const { callback: callback, method: method, params: params, type: type } = subscriptions[id];
                // only re-create subscriptions which are not in author (only area where
                // transactions are created, i.e. submissions such as 'author_submitAndWatchExtrinsic'
                // are not included (and will not be re-broadcast)
                if (type.startsWith("author_")) return;
                try {
                    await this.subscribe(type, method, params, callback);
                } catch (error) {
                    $e549b920579303d9$var$l.error(error);
                }
            })).catch($e549b920579303d9$var$l.error);
        };
        this.__internal__timeoutHandlers = ()=>{
            const now = Date.now();
            const ids = Object.keys(this.__internal__handlers);
            for(let i = 0, count = ids.length; i < count; i++){
                const handler = this.__internal__handlers[ids[i]];
                if (now - handler.start > this.__internal__timeout) {
                    try {
                        handler.callback(new Error(`No response received from RPC endpoint in ${this.__internal__timeout / 1000}s`), undefined);
                    } catch  {
                    // ignore
                    }
                    this.__internal__endpointStats.timeout++;
                    this.__internal__stats.total.timeout++;
                    delete this.__internal__handlers[ids[i]];
                }
            }
        };
        const endpoints = Array.isArray(endpoint) ? endpoint : [
            endpoint
        ];
        if (endpoints.length === 0) throw new Error("WsProvider requires at least one Endpoint");
        endpoints.forEach((endpoint)=>{
            if (!/^(wss|ws):\/\//.test(endpoint)) throw new Error(`Endpoint should start with 'ws://', received '${endpoint}'`);
        });
        this.__internal__eventemitter = new (0, $891aadac6ba73256$exports.EventEmitter)();
        this.__internal__autoConnectMs = autoConnectMs || 0;
        this.__internal__coder = new (0, $6cf3a605ab84bc3b$export$9a5fa01753cc630b)();
        this.__internal__endpointIndex = -1;
        this.__internal__endpoints = endpoints;
        this.__internal__headers = headers;
        this.__internal__websocket = null;
        this.__internal__stats = {
            active: {
                requests: 0,
                subscriptions: 0
            },
            total: $e549b920579303d9$var$defaultEndpointStats()
        };
        this.__internal__endpointStats = $e549b920579303d9$var$defaultEndpointStats();
        this.__internal__timeout = timeout || $e549b920579303d9$var$DEFAULT_TIMEOUT_MS;
        if (autoConnectMs && autoConnectMs > 0) this.connectWithRetry().catch(()=>{
        // does not throw
        });
        this.__internal__isReadyPromise = new Promise((resolve)=>{
            this.__internal__eventemitter.once("connected", ()=>{
                resolve(this);
            });
        });
    }
    /**
     * @summary `true` when this provider supports subscriptions
     */ get hasSubscriptions() {
        return true;
    }
    /**
     * @summary `true` when this provider supports clone()
     */ get isClonable() {
        return true;
    }
    /**
     * @summary Whether the node is connected or not.
     * @return {boolean} true if connected
     */ get isConnected() {
        return this.__internal__isConnected;
    }
    /**
     * @description Promise that resolves the first time we are connected and loaded
     */ get isReady() {
        return this.__internal__isReadyPromise;
    }
    get endpoint() {
        return this.__internal__endpoints[this.__internal__endpointIndex];
    }
    /**
     * @description Returns a clone of the object
     */ clone() {
        return new $e549b920579303d9$export$676472937f48f64(this.__internal__endpoints);
    }
    selectEndpointIndex(endpoints) {
        return (this.__internal__endpointIndex + 1) % endpoints.length;
    }
    /**
     * @summary Manually connect
     * @description The [[WsProvider]] connects automatically by default, however if you decided otherwise, you may
     * connect manually using this method.
     */ // eslint-disable-next-line @typescript-eslint/require-await
    async connect() {
        if (this.__internal__websocket) throw new Error("WebSocket is already connected");
        try {
            this.__internal__endpointIndex = this.selectEndpointIndex(this.__internal__endpoints);
            // the as here is Deno-specific - not available on the globalThis
            this.__internal__websocket = typeof (0, $9ce44c51a85397c6$export$51e5d554977815ce).WebSocket !== "undefined" && (0, $192eddd343d0487a$export$ff0a60c492425f45)((0, $9ce44c51a85397c6$export$51e5d554977815ce).WebSocket, (0, $c45dfcd0117fdc7f$export$3909fb301d3dc8c9)) ? new (0, $c45dfcd0117fdc7f$export$3909fb301d3dc8c9)(this.endpoint) : new (0, $c45dfcd0117fdc7f$export$3909fb301d3dc8c9)(this.endpoint, undefined, {
                headers: this.__internal__headers
            });
            if (this.__internal__websocket) {
                this.__internal__websocket.onclose = this.__internal__onSocketClose;
                this.__internal__websocket.onerror = this.__internal__onSocketError;
                this.__internal__websocket.onmessage = this.__internal__onSocketMessage;
                this.__internal__websocket.onopen = this.__internal__onSocketOpen;
            }
            // timeout any handlers that have not had a response
            this.__internal__timeoutId = setInterval(()=>this.__internal__timeoutHandlers(), $e549b920579303d9$var$TIMEOUT_INTERVAL);
        } catch (error) {
            $e549b920579303d9$var$l.error(error);
            this.__internal__emit("error", error);
            throw error;
        }
    }
    /**
     * @description Connect, never throwing an error, but rather forcing a retry
     */ async connectWithRetry() {
        if (this.__internal__autoConnectMs > 0) try {
            await this.connect();
        } catch  {
            setTimeout(()=>{
                this.connectWithRetry().catch(()=>{
                // does not throw
                });
            }, this.__internal__autoConnectMs);
        }
    }
    /**
     * @description Manually disconnect from the connection, clearing auto-connect logic
     */ // eslint-disable-next-line @typescript-eslint/require-await
    async disconnect() {
        // switch off autoConnect, we are in manual mode now
        this.__internal__autoConnectMs = 0;
        try {
            if (this.__internal__websocket) // 1000 - Normal closure; the connection successfully completed
            this.__internal__websocket.close(1000);
        } catch (error) {
            $e549b920579303d9$var$l.error(error);
            this.__internal__emit("error", error);
            throw error;
        }
    }
    /**
     * @description Returns the connection stats
     */ get stats() {
        return {
            active: {
                requests: Object.keys(this.__internal__handlers).length,
                subscriptions: Object.keys(this.__internal__subscriptions).length
            },
            total: this.__internal__stats.total
        };
    }
    get endpointStats() {
        return this.__internal__endpointStats;
    }
    /**
     * @summary Listens on events after having subscribed using the [[subscribe]] function.
     * @param  {ProviderInterfaceEmitted} type Event
     * @param  {ProviderInterfaceEmitCb}  sub  Callback
     * @return unsubscribe function
     */ on(type, sub) {
        this.__internal__eventemitter.on(type, sub);
        return ()=>{
            this.__internal__eventemitter.removeListener(type, sub);
        };
    }
    /**
     * @summary Send JSON data using WebSockets to configured HTTP Endpoint or queue.
     * @param method The RPC methods to execute
     * @param params Encoded parameters as applicable for the method
     * @param subscription Subscription details (internally used)
     */ send(method, params, isCacheable, subscription) {
        this.__internal__endpointStats.requests++;
        this.__internal__stats.total.requests++;
        const [id, body] = this.__internal__coder.encodeJson(method, params);
        let resultPromise = isCacheable ? this.__internal__callCache.get(body) : null;
        if (!resultPromise) {
            resultPromise = this.__internal__send(id, body, method, params, subscription);
            if (isCacheable) this.__internal__callCache.set(body, resultPromise);
        } else {
            this.__internal__endpointStats.cached++;
            this.__internal__stats.total.cached++;
        }
        return resultPromise;
    }
    async __internal__send(id, body, method, params, subscription) {
        return new Promise((resolve, reject)=>{
            try {
                if (!this.isConnected || this.__internal__websocket === null) throw new Error("WebSocket is not connected");
                const callback = (error, result)=>{
                    error ? reject(error) : resolve(result);
                };
                $e549b920579303d9$var$l.debug(()=>[
                        "calling",
                        method,
                        body
                    ]);
                this.__internal__handlers[id] = {
                    callback: callback,
                    method: method,
                    params: params,
                    start: Date.now(),
                    subscription: subscription
                };
                const bytesSent = body.length;
                this.__internal__endpointStats.bytesSent += bytesSent;
                this.__internal__stats.total.bytesSent += bytesSent;
                this.__internal__websocket.send(body);
            } catch (error) {
                this.__internal__endpointStats.errors++;
                this.__internal__stats.total.errors++;
                reject(error);
            }
        });
    }
    /**
     * @name subscribe
     * @summary Allows subscribing to a specific event.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * const provider = new WsProvider('ws://127.0.0.1:9944');
     * const rpc = new Rpc(provider);
     *
     * rpc.state.subscribeStorage([[storage.system.account, <Address>]], (_, values) => {
     *   console.log(values)
     * }).then((subscriptionId) => {
     *   console.log('balance changes subscription id: ', subscriptionId)
     * })
     * ```
     */ subscribe(type, method, params, callback) {
        this.__internal__endpointStats.subscriptions++;
        this.__internal__stats.total.subscriptions++;
        // subscriptions are not cached, LRU applies to .at(<blockHash>) only
        return this.send(method, params, false, {
            callback: callback,
            type: type
        });
    }
    /**
     * @summary Allows unsubscribing to subscriptions made with [[subscribe]].
     */ async unsubscribe(type, method, id) {
        const subscription = `${type}::${id}`;
        // FIXME This now could happen with re-subscriptions. The issue is that with a re-sub
        // the assigned id now does not match what the API user originally received. It has
        // a slight complication in solving - since we cannot rely on the send id, but rather
        // need to find the actual subscription id to map it
        if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(this.__internal__subscriptions[subscription])) {
            $e549b920579303d9$var$l.debug(()=>`Unable to find active subscription=${subscription}`);
            return false;
        }
        delete this.__internal__subscriptions[subscription];
        try {
            return this.isConnected && !(0, $ca1b2dd85c8d2b2d$export$630801d484da15df)(this.__internal__websocket) ? this.send(method, [
                id
            ]) : true;
        } catch  {
            return false;
        }
    }
}





var $hWfed = parcelRequire("hWfed");
/** @internal */ function $74edb1a24086f8de$var$converter(map) {
    return (value)=>value ? map[value.charCodeAt(0)] + value.slice(1) : "";
}
const $74edb1a24086f8de$export$6fb60ada418062e5 = /*#__PURE__*/ $74edb1a24086f8de$var$converter((0, $4db46be060f888b6$export$b106de9d73dfc75e));
const $74edb1a24086f8de$export$4bfee90023fbfd41 = /*#__PURE__*/ $74edb1a24086f8de$var$converter((0, $4db46be060f888b6$export$467f382b677d7278));






function $f94a3e72ee156ad1$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}





function $5f6d248ba049fd16$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $59e1a09a7b50cea7$export$ccb33e29d92c9a58;
    } : (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $8f5ae89c29c8e260$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $1d438d715f5ca64a$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $1d438d715f5ca64a$var$defaultErrorFactory;
    return (0, $2450271e40925995$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $780013973b1bcfa8$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $1d438d715f5ca64a$var$defaultErrorFactory() {
    return new (0, $d050dcd13f6b1080$export$78f6d1b1dbcda304)();
}



function $e965237653bd011c$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $f94a3e72ee156ad1$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $1802c01a893130db$export$f0954fd7d5368655), (0, $5f6d248ba049fd16$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $8f5ae89c29c8e260$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $1d438d715f5ca64a$export$c8ea5e9f84346833)(function() {
            return new (0, $d050dcd13f6b1080$export$78f6d1b1dbcda304)();
        }));
    };
}





const $6e69e130a0ad2c98$export$882b5998b3b9117c = /*#__PURE__*/ (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("api/util");


function $892b9df0885c7671$export$abcd98354d9fb0f7(txHash, { block: { extrinsics: extrinsics, header: header } }, allEvents, status) {
    // extrinsics to hashes
    for (const [txIndex, x] of extrinsics.entries()){
        if (x.hash.eq(txHash)) return {
            blockNumber: (0, $b0a891e6e2805aca$export$817485789353cfbb)(header.number) ? header.number.unwrap() : header.number,
            events: allEvents.filter(({ phase: phase })=>phase.isApplyExtrinsic && phase.asApplyExtrinsic.eqn(txIndex)),
            txIndex: txIndex
        };
    }
    // if we do get the block after finalized, it _should_ be there
    // only warn on filtering with isInBlock (finalization finalizes after)
    if (status.isInBlock) {
        const allHashes = extrinsics.map((x)=>x.hash.toHex());
        (0, $6e69e130a0ad2c98$export$882b5998b3b9117c).warn(`block ${header.hash.toHex()}: Unable to find extrinsic ${txHash.toHex()} inside ${allHashes.join(", ")}`);
    }
    return {};
}


function $8fe2ec2d2e685538$export$2524a6f9273c8882(account) {
    return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(account.sign);
}


const $eb93ea8f8dc60f82$var$recordIdentity = (record)=>record;
function $eb93ea8f8dc60f82$var$filterAndApply(events, section, methods, onFound) {
    return events.filter(({ event: event })=>section === event.section && methods.includes(event.method)).map((record)=>onFound(record));
}
function $eb93ea8f8dc60f82$var$getDispatchError({ event: { data: [dispatchError] } }) {
    return dispatchError;
}
function $eb93ea8f8dc60f82$var$getDispatchInfo({ event: { data: data, method: method } }) {
    return method === "ExtrinsicSuccess" ? data[0] : data[1];
}
function $eb93ea8f8dc60f82$var$extractError(events = []) {
    return $eb93ea8f8dc60f82$var$filterAndApply(events, "system", [
        "ExtrinsicFailed"
    ], $eb93ea8f8dc60f82$var$getDispatchError)[0];
}
function $eb93ea8f8dc60f82$var$extractInfo(events = []) {
    return $eb93ea8f8dc60f82$var$filterAndApply(events, "system", [
        "ExtrinsicFailed",
        "ExtrinsicSuccess"
    ], $eb93ea8f8dc60f82$var$getDispatchInfo)[0];
}
class $eb93ea8f8dc60f82$export$1ad24d34ab80f7f1 {
    constructor({ blockNumber: blockNumber, dispatchError: dispatchError, dispatchInfo: dispatchInfo, events: events, internalError: internalError, status: status, txHash: txHash, txIndex: txIndex }){
        this.dispatchError = dispatchError || $eb93ea8f8dc60f82$var$extractError(events);
        this.dispatchInfo = dispatchInfo || $eb93ea8f8dc60f82$var$extractInfo(events);
        this.events = events || [];
        this.internalError = internalError;
        this.status = status;
        this.txHash = txHash;
        this.txIndex = txIndex;
        this.blockNumber = blockNumber;
    }
    get isCompleted() {
        return this.isError || this.status.isInBlock || this.status.isFinalized;
    }
    get isError() {
        return this.status.isDropped || this.status.isFinalityTimeout || this.status.isInvalid || this.status.isUsurped;
    }
    get isFinalized() {
        return this.status.isFinalized;
    }
    get isInBlock() {
        return this.status.isInBlock;
    }
    get isWarning() {
        return this.status.isRetracted;
    }
    /**
     * @description Filters EventRecords for the specified method & section (there could be multiple)
     */ filterRecords(section, method) {
        return $eb93ea8f8dc60f82$var$filterAndApply(this.events, section, Array.isArray(method) ? method : [
            method
        ], $eb93ea8f8dc60f82$var$recordIdentity);
    }
    /**
     * @description Finds an EventRecord for the specified method & section
     */ findRecord(section, method) {
        return this.filterRecords(section, method)[0];
    }
    /**
     * @description Creates a human representation of the output
     */ toHuman(isExtended) {
        return {
            dispatchError: this.dispatchError?.toHuman(),
            dispatchInfo: this.dispatchInfo?.toHuman(),
            events: this.events.map((e)=>e.toHuman(isExtended)),
            internalError: this.internalError?.message.toString(),
            status: this.status.toHuman(isExtended)
        };
    }
}


function $31590c5835c2826e$var$makeEraOptions(api, registry, partialOptions, { header: header, mortalLength: mortalLength, nonce: nonce }) {
    if (!header) {
        if (partialOptions.era && !partialOptions.blockHash) throw new Error("Expected blockHash to be passed alongside non-immortal era options");
        if ((0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(partialOptions.era)) {
            // since we have no header, it is immortal, remove any option overrides
            // so we only supply the genesisHash and no era to the construction
            delete partialOptions.era;
            delete partialOptions.blockHash;
        }
        return $31590c5835c2826e$var$makeSignOptions(api, partialOptions, {
            nonce: nonce
        });
    }
    return $31590c5835c2826e$var$makeSignOptions(api, partialOptions, {
        blockHash: header.hash,
        era: registry.createTypeUnsafe("ExtrinsicEra", [
            {
                current: header.number,
                period: partialOptions.era || mortalLength
            }
        ]),
        nonce: nonce
    });
}
function $31590c5835c2826e$var$makeSignAndSendOptions(partialOptions, statusCb) {
    let options = {};
    if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(partialOptions)) statusCb = partialOptions;
    else options = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, partialOptions);
    return [
        options,
        statusCb
    ];
}
function $31590c5835c2826e$var$makeSignOptions(api, partialOptions, extras) {
    return (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
        blockHash: api.genesisHash,
        genesisHash: api.genesisHash
    }, partialOptions, extras, {
        runtimeVersion: api.runtimeVersion,
        signedExtensions: api.registry.signedExtensions,
        version: api.extrinsicType
    });
}
function $31590c5835c2826e$var$optionsOrNonce(partialOptions = {}) {
    return (0, $6b7448b66af103e8$export$92a23ef2f5b8d147)(partialOptions) || (0, $62d4481eefa5c3a2$export$7e4aa119212bc614)(partialOptions) ? {
        nonce: partialOptions
    } : partialOptions;
}
function $31590c5835c2826e$export$19af00d264950ba1({ api: api, apiType: apiType, blockHash: blockHash, decorateMethod: decorateMethod }) {
    // an instance of the base extrinsic for us to extend
    const ExtrinsicBase = api.registry.createClass("Extrinsic");
    class Submittable extends ExtrinsicBase {
        constructor(registry, extrinsic){
            super(registry, extrinsic, {
                version: api.extrinsicType
            });
            this.__internal__transformResult = (0, $3c9cf064340c6f95$export$f0954fd7d5368655);
            this.__internal__observeSign = (account, partialOptions)=>{
                const address = (0, $8fe2ec2d2e685538$export$2524a6f9273c8882)(account) ? account.address : account.toString();
                const options = $31590c5835c2826e$var$optionsOrNonce(partialOptions);
                return api.derive.tx.signingInfo(address, options.nonce, options.era).pipe((0, $e965237653bd011c$export$43128fadae87b74a)(), (0, $e118cd4880428984$export$6b9f6c0d32c093f9)(async (signingInfo)=>{
                    const eraOptions = $31590c5835c2826e$var$makeEraOptions(api, this.registry, options, signingInfo);
                    let updateId = -1;
                    if ((0, $8fe2ec2d2e685538$export$2524a6f9273c8882)(account)) this.sign(account, eraOptions);
                    else updateId = await this.__internal__signViaSigner(address, eraOptions, signingInfo.header);
                    return {
                        options: eraOptions,
                        updateId: updateId
                    };
                }));
            };
            this.__internal__observeStatus = (txHash, status)=>{
                if (!status.isFinalized && !status.isInBlock) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(this.__internal__transformResult(new (0, $eb93ea8f8dc60f82$export$1ad24d34ab80f7f1)({
                    status: status,
                    txHash: txHash
                })));
                const blockHash = status.isInBlock ? status.asInBlock : status.asFinalized;
                return api.derive.tx.events(blockHash).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(({ block: block, events: events })=>this.__internal__transformResult(new (0, $eb93ea8f8dc60f82$export$1ad24d34ab80f7f1)({
                        ...(0, $892b9df0885c7671$export$abcd98354d9fb0f7)(txHash, block, events, status),
                        status: status,
                        txHash: txHash
                    }))), (0, $985f81c342020fc8$export$3dede90624df3ba9)((internalError)=>(0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(this.__internal__transformResult(new (0, $eb93ea8f8dc60f82$export$1ad24d34ab80f7f1)({
                        internalError: internalError,
                        status: status,
                        txHash: txHash
                    })))));
            };
            this.__internal__observeSend = (info)=>{
                return api.rpc.author.submitExtrinsic(this).pipe((0, $9d19ec2059422f48$export$3f23594af5f37336)((hash)=>{
                    this.__internal__updateSigner(hash, info);
                }));
            };
            this.__internal__observeSubscribe = (info)=>{
                const txHash = this.hash;
                return api.rpc.author.submitAndWatchExtrinsic(this).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((status)=>this.__internal__observeStatus(txHash, status)), (0, $9d19ec2059422f48$export$3f23594af5f37336)((status)=>{
                    this.__internal__updateSigner(status, info);
                }));
            };
            this.__internal__signViaSigner = async (address, options, header)=>{
                const signer = options.signer || api.signer;
                if (!signer) throw new Error("No signer specified, either via api.setSigner or via sign options. You possibly need to pass through an explicit keypair for the origin so it can be used for signing.");
                const payload = this.registry.createTypeUnsafe("SignerPayload", [
                    (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, options, {
                        address: address,
                        blockNumber: header ? header.number : 0,
                        method: this.method
                    })
                ]);
                let result;
                if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(signer.signPayload)) result = await signer.signPayload(payload.toPayload());
                else if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(signer.signRaw)) result = await signer.signRaw(payload.toRaw());
                else throw new Error("Invalid signer interface, it should implement either signPayload or signRaw (or both)");
                // Here we explicitly call `toPayload()` again instead of working with an object
                // (reference) as passed to the signer. This means that we are sure that the
                // payload data is not modified from our inputs, but the signer
                super.addSignature(address, result.signature, payload.toPayload());
                return result.id;
            };
            this.__internal__updateSigner = (status, info)=>{
                if (info && info.updateId !== -1) {
                    const { options: options, updateId: updateId } = info;
                    const signer = options.signer || api.signer;
                    if (signer && (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(signer.update)) signer.update(updateId, status);
                }
            };
            this.__internal__ignoreStatusCb = apiType === "rxjs";
        }
        get hasDryRun() {
            return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.rpc.system?.dryRun);
        }
        get hasPaymentInfo() {
            return (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(api.call.transactionPaymentApi?.queryInfo);
        }
        // dry run an extrinsic
        dryRun(account, optionsOrHash) {
            if (!this.hasDryRun) throw new Error("The system.dryRun RPC call is not available in your environment");
            if (blockHash || (0, $0d672af39bfe8283$export$844ec244b1367d54)(optionsOrHash) || (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(optionsOrHash)) // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return decorateMethod(()=>api.rpc.system.dryRun(this.toHex(), blockHash || optionsOrHash));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(()=>this.__internal__observeSign(account, optionsOrHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(()=>api.rpc.system.dryRun(this.toHex()))))();
        }
        // calculate the payment info for this transaction (if signed and submitted)
        paymentInfo(account, optionsOrHash) {
            if (!this.hasPaymentInfo) throw new Error("The transactionPaymentApi.queryInfo runtime call is not available in your environment");
            if (blockHash || (0, $0d672af39bfe8283$export$844ec244b1367d54)(optionsOrHash) || (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(optionsOrHash)) // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return decorateMethod(()=>api.callAt(blockHash || optionsOrHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((callAt)=>{
                    const u8a = this.toU8a();
                    return callAt.transactionPaymentApi.queryInfo(u8a, u8a.length);
                })));
            const [allOptions] = $31590c5835c2826e$var$makeSignAndSendOptions(optionsOrHash);
            const address = (0, $8fe2ec2d2e685538$export$2524a6f9273c8882)(account) ? account.address : account.toString();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(()=>api.derive.tx.signingInfo(address, allOptions.nonce, allOptions.era).pipe((0, $e965237653bd011c$export$43128fadae87b74a)(), (0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((signingInfo)=>{
                    // setup our options (same way as in signAndSend)
                    const eraOptions = $31590c5835c2826e$var$makeEraOptions(api, this.registry, allOptions, signingInfo);
                    const signOptions = $31590c5835c2826e$var$makeSignOptions(api, eraOptions, {});
                    // 1. Don't use the internal objects inside the new tx (hence toU8a)
                    // 2. Don't override the data from existing signed extrinsics
                    // 3. Ensure that this object stays intact, with no new sign after operation
                    const u8a = api.tx(this.toU8a()).signFake(address, signOptions).toU8a();
                    return api.call.transactionPaymentApi.queryInfo(u8a, u8a.length);
                })))();
        }
        // send implementation for both immediate Hash and statusCb variants
        send(statusCb) {
            const isSubscription = api.hasSubscriptions && (this.__internal__ignoreStatusCb || !!statusCb);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(isSubscription ? this.__internal__observeSubscribe : this.__internal__observeSend)(statusCb);
        }
        /**
         * @description Signs a transaction, returning `this` to allow chaining. E.g.: `signAsync(...).send()`. Like `.signAndSend` this will retrieve the nonce and blockHash to send the tx with.
         */ signAsync(account, partialOptions) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(()=>this.__internal__observeSign(account, partialOptions).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)(()=>this)))();
        }
        // signAndSend implementation for all 3 cases above
        signAndSend(account, partialOptions, optionalStatusCb) {
            const [options, statusCb] = $31590c5835c2826e$var$makeSignAndSendOptions(partialOptions, optionalStatusCb);
            const isSubscription = api.hasSubscriptions && (this.__internal__ignoreStatusCb || !!statusCb);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(()=>this.__internal__observeSign(account, options).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((info)=>isSubscription ? this.__internal__observeSubscribe(info) : this.__internal__observeSend(info))) // FIXME This is wrong, SubmittableResult is _not_ a codec
            )(statusCb);
        }
        // adds a transform to the result, applied before result is returned
        withResultTransform(transform) {
            this.__internal__transformResult = transform;
            return this;
        }
    }
    return Submittable;
}


function $1708cf704191c947$export$cd4f5aa0ba018bd4(apiType, api, decorateMethod, registry, blockHash) {
    const Submittable = (0, $31590c5835c2826e$export$19af00d264950ba1)({
        api: api,
        apiType: apiType,
        blockHash: blockHash,
        decorateMethod: decorateMethod
    });
    return (extrinsic)=>new Submittable(registry || api.registry, extrinsic);
}


/**
 * @name objectClear
 * @summary Removes all the keys from the input object
 */ function $2a9dad1a926668c9$export$4210ab0230333e0f(value) {
    const keys = Object.keys(value);
    for(let i = 0, count = keys.length; i < count; i++)delete value[keys[i]];
    return value;
}


const $0c33d03adc258e6b$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("api/augment");
function $0c33d03adc258e6b$var$logLength(type, values, and = []) {
    return values.length ? ` ${values.length} ${type}${and.length ? " and" : ""}` : "";
}
function $0c33d03adc258e6b$var$logValues(type, values) {
    return values.length ? `\n\t${type.padStart(7)}: ${values.sort().join(", ")}` : "";
}
function $0c33d03adc258e6b$var$warn(prefix, type, [added, removed]) {
    if (added.length || removed.length) $0c33d03adc258e6b$var$l.warn(`api.${prefix}: Found${$0c33d03adc258e6b$var$logLength("added", added, removed)}${$0c33d03adc258e6b$var$logLength("removed", removed)} ${type}:${$0c33d03adc258e6b$var$logValues("added", added)}${$0c33d03adc258e6b$var$logValues("removed", removed)}`);
}
function $0c33d03adc258e6b$var$findSectionExcludes(a, b) {
    return a.filter((s)=>!b.includes(s));
}
function $0c33d03adc258e6b$var$findSectionIncludes(a, b) {
    return a.filter((s)=>b.includes(s));
}
function $0c33d03adc258e6b$var$extractSections(src, dst) {
    const srcSections = Object.keys(src);
    const dstSections = Object.keys(dst);
    return [
        $0c33d03adc258e6b$var$findSectionExcludes(srcSections, dstSections),
        $0c33d03adc258e6b$var$findSectionExcludes(dstSections, srcSections)
    ];
}
function $0c33d03adc258e6b$var$findMethodExcludes(src, dst) {
    const srcSections = Object.keys(src);
    const dstSections = $0c33d03adc258e6b$var$findSectionIncludes(Object.keys(dst), srcSections);
    const excludes = [];
    for(let s = 0, scount = dstSections.length; s < scount; s++){
        const section = dstSections[s];
        const srcMethods = Object.keys(src[section]);
        const dstMethods = Object.keys(dst[section]);
        for(let d = 0, mcount = dstMethods.length; d < mcount; d++){
            const method = dstMethods[d];
            if (!srcMethods.includes(method)) excludes.push(`${section}.${method}`);
        }
    }
    return excludes;
}
function $0c33d03adc258e6b$var$extractMethods(src, dst) {
    return [
        $0c33d03adc258e6b$var$findMethodExcludes(dst, src),
        $0c33d03adc258e6b$var$findMethodExcludes(src, dst)
    ];
}
function $0c33d03adc258e6b$export$c1440ea1083fe2b(prefix, src, dst, fromEmpty = false) {
    fromEmpty && (0, $2a9dad1a926668c9$export$4210ab0230333e0f)(dst);
    // NOTE: This part is slightly problematic since it will get the
    // values for at least all the sections and the names of the methods
    // (Since methods won't be decorated before lazy, this _may_ be ok)
    if (prefix && Object.keys(dst).length) {
        $0c33d03adc258e6b$var$warn(prefix, "modules", $0c33d03adc258e6b$var$extractSections(src, dst));
        $0c33d03adc258e6b$var$warn(prefix, "calls", $0c33d03adc258e6b$var$extractMethods(src, dst));
    }
    const sections = Object.keys(src);
    for(let i = 0, count = sections.length; i < count; i++){
        const section = sections[i];
        const methods = src[section];
        // We don't set here with a lazy interface, we decorate based
        // on the top-level structure (this bypasses adding lazy onto lazy)
        if (!dst[section]) dst[section] = {};
        (0, $bad025b936daa7ef$export$d3fc7341b317ef1a)(dst[section], Object.keys(methods), (m)=>methods[m]);
    }
    return dst;
}



function $233a72847b310a1f$export$b3c01e03f8df8386(decorateMethod, derives) {
    const getKeys = (s)=>Object.keys(derives[s]);
    const creator = (s, m)=>decorateMethod(derives[s][m]);
    const result = {};
    const names = Object.keys(derives);
    for(let i = 0, count = names.length; i < count; i++)(0, $1404998085556672$export$58416e29444cc64)(result, names[i], getKeys, creator);
    return result;
}



function $ccda0a529c1c1831$var$sig({ lookup: lookup }, { method: method, section: section }, args) {
    return `${section}.${method}(${args.map((a)=>lookup.getTypeDef(a).type).join(", ")})`;
}
function $ccda0a529c1c1831$export$ac03cd6be97f218a(registry, creator, _args) {
    const args = _args.filter((a)=>!(0, $09d5dc0a6a4c347b$export$fce6876652108ab)(a));
    if (creator.meta.type.isPlain) {
        if (args.length !== 0) throw new Error(`${$ccda0a529c1c1831$var$sig(registry, creator, [])} does not take any arguments, ${args.length} found`);
    } else {
        const { hashers: hashers, key: key } = creator.meta.type.asMap;
        const keys = hashers.length === 1 ? [
            key
        ] : registry.lookup.getSiType(key).def.asTuple.map((t)=>t);
        if (args.length !== keys.length) throw new Error(`${$ccda0a529c1c1831$var$sig(registry, creator, keys)} is a map, requiring ${keys.length} arguments, ${args.length} found`);
    }
    // pass as tuple
    return [
        creator,
        args
    ];
}



class $46ec52193531f3d9$export$ada873a34909da65 {
    constructor(){
        this.__internal__eventemitter = new (0, $891aadac6ba73256$exports.EventEmitter)();
    }
    emit(type, ...args) {
        return this.__internal__eventemitter.emit(type, ...args);
    }
    /**
     * @description Attach an eventemitter handler to listen to a specific event
     *
     * @param type The type of event to listen to. Available events are `connected`, `disconnected`, `ready` and `error`
     * @param handler The callback to be called when the event fires. Depending on the event type, it could fire with additional arguments.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.on('connected', (): void => {
     *   console.log('API has been connected to the endpoint');
     * });
     *
     * api.on('disconnected', (): void => {
     *   console.log('API has been disconnected from the endpoint');
     * });
     * ```
     */ on(type, handler) {
        this.__internal__eventemitter.on(type, handler);
        return this;
    }
    /**
     * @description Remove the given eventemitter handler
     *
     * @param type The type of event the callback was attached to. Available events are `connected`, `disconnected`, `ready` and `error`
     * @param handler The callback to unregister.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * const handler = (): void => {
     *  console.log('Connected !);
     * };
     *
     * // Start listening
     * api.on('connected', handler);
     *
     * // Stop listening
     * api.off('connected', handler);
     * ```
     */ off(type, handler) {
        this.__internal__eventemitter.removeListener(type, handler);
        return this;
    }
    /**
     * @description Attach an one-time eventemitter handler to listen to a specific event
     *
     * @param type The type of event to listen to. Available events are `connected`, `disconnected`, `ready` and `error`
     * @param handler The callback to be called when the event fires. Depending on the event type, it could fire with additional arguments.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.once('connected', (): void => {
     *   console.log('API has been connected to the endpoint');
     * });
     *
     * api.once('disconnected', (): void => {
     *   console.log('API has been disconnected from the endpoint');
     * });
     * ```
     */ once(type, handler) {
        this.__internal__eventemitter.once(type, handler);
        return this;
    }
}



const $f2b9425f228b751d$var$PAGE_SIZE_K = 1000; // limit aligned with the 1k on the node (trie lookups are heavy)
const $f2b9425f228b751d$var$PAGE_SIZE_V = 250; // limited since the data may be > 16MB (e.g. misfiring elections)
const $f2b9425f228b751d$var$PAGE_SIZE_Q = 50; // queue of pending storage queries (mapped together, next tick)
const $f2b9425f228b751d$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("api/init");
let $f2b9425f228b751d$var$instanceCounter = 0;
function $f2b9425f228b751d$var$getAtQueryFn(api, { method: method, section: section }) {
    return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(api.rx.query[section] && api.rx.query[section][method], ()=>`query.${section}.${method} is not available in this version of the metadata`);
}
class $f2b9425f228b751d$export$f4822cf0c28e14c7 extends (0, $46ec52193531f3d9$export$ada873a34909da65) {
    /**
     * @description Create an instance of the class
     *
     * @param options Options object to create API instance or a Provider instance
     *
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * const api = new Api().isReady();
     *
     * api.rpc.subscribeNewHeads((header) => {
     *   console.log(`new block #${header.number.toNumber()}`);
     * });
     * ```
     */ constructor(options, type, decorateMethod){
        super();
        this.__internal__runtimeLog = {};
        this.__internal__storageGetQ = [];
        this.__internal__storageSubQ = [];
        // HACK Use BN import so decorateDerive works... yes, wtf.
        this.__phantom = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0);
        this._call = {};
        this._consts = {};
        this._errors = {};
        this._events = {};
        this._extrinsicType = (0, $b0e4a8b59034fae4$export$84cf34f56e9b2fd5).LATEST_EXTRINSIC_VERSION;
        this._isReady = false;
        this._query = {};
        this._runtimeMap = {};
        this._rx = {
            call: {},
            consts: {},
            query: {},
            tx: {}
        };
        /**
         * Put the `this.onCall` function of ApiRx here, because it is needed by
         * `api._rx`.
         */ this._rxDecorateMethod = (method)=>{
            return method;
        };
        this.__internal__instanceId = `${++$f2b9425f228b751d$var$instanceCounter}`;
        this.__internal__registry = options.source?.registry || options.registry || new (0, $e21dedd888b26621$export$ea4312c9b0ebd908)();
        this._rx.callAt = (blockHash, knownVersion)=>(0, $9451f06798fd34f2$export$6788812c4e6611e6)(this.at(blockHash, knownVersion)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((a)=>a.rx.call));
        this._rx.queryAt = (blockHash, knownVersion)=>(0, $9451f06798fd34f2$export$6788812c4e6611e6)(this.at(blockHash, knownVersion)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((a)=>a.rx.query));
        this._rx.registry = this.__internal__registry;
        this._decorateMethod = decorateMethod;
        this._options = options;
        this._type = type;
        const provider = options.source ? options.source._rpcCore.provider.isClonable ? options.source._rpcCore.provider.clone() : options.source._rpcCore.provider : options.provider || new (0, $e549b920579303d9$export$676472937f48f64)();
        // The RPC interface decorates the known interfaces on init
        this._rpcCore = new (0, $ee7223588c9ee45e$export$a87e1cf60dfc73a7)(this.__internal__instanceId, this.__internal__registry, {
            isPedantic: this._options.isPedantic,
            provider: provider,
            userRpc: this._options.rpc
        });
        this._isConnected = new (0, $c083768a9df36bef$export$cc3d42e6b2b9cf8b)(this._rpcCore.provider.isConnected);
        this._rx.hasSubscriptions = this._rpcCore.provider.hasSubscriptions;
    }
    /**
     * @description Return the current used registry
     */ get registry() {
        return this.__internal__registry;
    }
    /**
     * @description Creates an instance of a type as registered
     */ createType(type, ...params) {
        return this.__internal__registry.createType(type, ...params);
    }
    /**
     * @description Register additional user-defined of chain-specific types in the type registry
     */ registerTypes(types) {
        types && this.__internal__registry.register(types);
    }
    /**
     * @returns `true` if the API operates with subscriptions
     */ get hasSubscriptions() {
        return this._rpcCore.provider.hasSubscriptions;
    }
    /**
     * @returns `true` if the API decorate multi-key queries
     */ get supportMulti() {
        return this._rpcCore.provider.hasSubscriptions || !!this._rpcCore.state.queryStorageAt;
    }
    _emptyDecorated(registry, blockHash) {
        return {
            call: {},
            consts: {},
            errors: {},
            events: {},
            query: {},
            registry: registry,
            rx: {
                call: {},
                query: {}
            },
            tx: (0, $1708cf704191c947$export$cd4f5aa0ba018bd4)(this._type, this._rx, this._decorateMethod, registry, blockHash)
        };
    }
    _createDecorated(registry, fromEmpty, decoratedApi, blockHash) {
        if (!decoratedApi) decoratedApi = this._emptyDecorated(registry.registry, blockHash);
        if (fromEmpty || !registry.decoratedMeta) registry.decoratedMeta = (0, $43a9183d9a542fa6$export$fcc096e8dd32d10e)(registry.registry, registry.metadata);
        const runtime = this._decorateCalls(registry, this._decorateMethod, blockHash);
        const runtimeRx = this._decorateCalls(registry, this._rxDecorateMethod, blockHash);
        const storage = this._decorateStorage(registry.decoratedMeta, this._decorateMethod, blockHash);
        const storageRx = this._decorateStorage(registry.decoratedMeta, this._rxDecorateMethod, blockHash);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("consts", registry.decoratedMeta.consts, decoratedApi.consts, fromEmpty);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("errors", registry.decoratedMeta.errors, decoratedApi.errors, fromEmpty);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("events", registry.decoratedMeta.events, decoratedApi.events, fromEmpty);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("query", storage, decoratedApi.query, fromEmpty);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("query", storageRx, decoratedApi.rx.query, fromEmpty);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("call", runtime, decoratedApi.call, fromEmpty);
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("call", runtimeRx, decoratedApi.rx.call, fromEmpty);
        decoratedApi.findCall = (callIndex)=>(0, $0d2af457e7d47dce$export$db3b1dfc16b79619)(registry.registry, callIndex);
        decoratedApi.findError = (errorIndex)=>(0, $0d2af457e7d47dce$export$6db3490d470bf39f)(registry.registry, errorIndex);
        decoratedApi.queryMulti = blockHash ? this._decorateMultiAt(decoratedApi, this._decorateMethod, blockHash) : this._decorateMulti(this._decorateMethod);
        decoratedApi.runtimeVersion = registry.runtimeVersion;
        return {
            createdAt: blockHash,
            decoratedApi: decoratedApi,
            decoratedMeta: registry.decoratedMeta
        };
    }
    _injectMetadata(registry, fromEmpty = false) {
        // clear the decoration, we are redoing it here
        if (fromEmpty || !registry.decoratedApi) registry.decoratedApi = this._emptyDecorated(registry.registry);
        const { decoratedApi: decoratedApi, decoratedMeta: decoratedMeta } = this._createDecorated(registry, fromEmpty, registry.decoratedApi);
        this._call = decoratedApi.call;
        this._consts = decoratedApi.consts;
        this._errors = decoratedApi.errors;
        this._events = decoratedApi.events;
        this._query = decoratedApi.query;
        this._rx.call = decoratedApi.rx.call;
        this._rx.query = decoratedApi.rx.query;
        const tx = this._decorateExtrinsics(decoratedMeta, this._decorateMethod);
        const rxtx = this._decorateExtrinsics(decoratedMeta, this._rxDecorateMethod);
        if (fromEmpty || !this._extrinsics) {
            this._extrinsics = tx;
            this._rx.tx = rxtx;
        } else {
            (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)("tx", tx, this._extrinsics, false);
            (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)(null, rxtx, this._rx.tx, false);
        }
        (0, $0c33d03adc258e6b$export$c1440ea1083fe2b)(null, decoratedMeta.consts, this._rx.consts, fromEmpty);
        this.emit("decorated");
    }
    /**
     * @deprecated
     * backwards compatible endpoint for metadata injection, may be removed in the future (However, it is still useful for testing injection)
     */ injectMetadata(metadata, fromEmpty, registry) {
        this._injectMetadata({
            counter: 0,
            metadata: metadata,
            registry: registry || this.__internal__registry,
            runtimeVersion: this.__internal__registry.createType("RuntimeVersionPartial")
        }, fromEmpty);
    }
    _decorateFunctionMeta(input, output) {
        output.meta = input.meta;
        output.method = input.method;
        output.section = input.section;
        output.toJSON = input.toJSON;
        if (input.callIndex) output.callIndex = input.callIndex;
        return output;
    }
    // Filter all RPC methods based on the results of the rpc_methods call. We do this in the following
    // manner to cater for both old and new:
    //   - when the number of entries are 0, only remove the ones with isOptional (account & contracts)
    //   - when non-zero, remove anything that is not in the array (we don't do this)
    _filterRpc(methods, additional) {
        // add any specific user-base RPCs
        if (Object.keys(additional).length !== 0) {
            this._rpcCore.addUserInterfaces(additional);
            // re-decorate, only adding any new additional interfaces
            this._decorateRpc(this._rpcCore, this._decorateMethod, this._rpc);
            this._decorateRpc(this._rpcCore, this._rxDecorateMethod, this._rx.rpc);
        }
        // extract the actual sections from the methods (this is useful when
        // we try and create mappings to runtime names via a hash mapping)
        const sectionMap = {};
        for(let i = 0, count = methods.length; i < count; i++){
            const [section] = methods[i].split("_");
            sectionMap[section] = true;
        }
        // convert the actual section names into an easy name lookup
        const sections = Object.keys(sectionMap);
        for(let i = 0, count = sections.length; i < count; i++){
            const nameA = (0, $74edb1a24086f8de$export$4bfee90023fbfd41)(sections[i]);
            const nameB = `${nameA}Api`;
            this._runtimeMap[(0, $dcbcf4e1d1853689$export$808fb830d95da849)(nameA, 64)] = nameA;
            this._runtimeMap[(0, $dcbcf4e1d1853689$export$808fb830d95da849)(nameB, 64)] = nameB;
        }
        // finally we filter the actual methods to expose
        this._filterRpcMethods(methods);
    }
    _filterRpcMethods(exposed) {
        const hasResults = exposed.length !== 0;
        const allKnown = [
            ...this._rpcCore.mapping.entries()
        ];
        const allKeys = [];
        const count = allKnown.length;
        for(let i = 0; i < count; i++){
            const [, { alias: alias, endpoint: endpoint, method: method, pubsub: pubsub, section: section }] = allKnown[i];
            allKeys.push(`${section}_${method}`);
            if (pubsub) {
                allKeys.push(`${section}_${pubsub[1]}`);
                allKeys.push(`${section}_${pubsub[2]}`);
            }
            if (alias) allKeys.push(...alias);
            if (endpoint) allKeys.push(endpoint);
        }
        const unknown = exposed.filter((k)=>!allKeys.includes(k) && !k.includes("_unstable_"));
        if (unknown.length && !this._options.noInitWarn) $f2b9425f228b751d$var$l.warn(`RPC methods not decorated: ${unknown.join(", ")}`);
        // loop through all entries we have (populated in decorate) and filter as required
        // only remove when we have results and method missing, or with no results if optional
        for(let i = 0; i < count; i++){
            const [k, { method: method, section: section }] = allKnown[i];
            if (hasResults && !exposed.includes(k) && k !== "rpc_methods") {
                if (this._rpc[section]) {
                    delete this._rpc[section][method];
                    delete this._rx.rpc[section][method];
                }
            }
        }
    }
    _rpcSubmitter(decorateMethod) {
        const method = (method, ...params)=>{
            return (0, $9451f06798fd34f2$export$6788812c4e6611e6)(this._rpcCore.provider.send(method, params));
        };
        return decorateMethod(method);
    }
    _decorateRpc(rpc, decorateMethod, input = this._rpcSubmitter(decorateMethod)) {
        const out = input;
        const decorateFn = (section, method)=>{
            const source = rpc[section][method];
            const fn = decorateMethod(source, {
                methodName: method
            });
            fn.meta = source.meta;
            fn.raw = decorateMethod(source.raw, {
                methodName: method
            });
            return fn;
        };
        for(let s = 0, scount = rpc.sections.length; s < scount; s++){
            const section = rpc.sections[s];
            if (!Object.prototype.hasOwnProperty.call(out, section)) {
                const methods = Object.keys(rpc[section]);
                const decorateInternal = (method)=>decorateFn(section, method);
                for(let m = 0, mcount = methods.length; m < mcount; m++){
                    const method = methods[m];
                    //  skip subscriptions where we have a non-subscribe interface
                    if (this.hasSubscriptions || !(method.startsWith("subscribe") || method.startsWith("unsubscribe"))) {
                        if (!Object.prototype.hasOwnProperty.call(out, section)) out[section] = {};
                        (0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(out[section], method, decorateInternal);
                    }
                }
            }
        }
        return out;
    }
    // add all definition entries
    _addRuntimeDef(result, additional) {
        if (!additional) return;
        const entries = Object.entries(additional);
        for(let j = 0, ecount = entries.length; j < ecount; j++){
            const [key, defs] = entries[j];
            if (result[key]) // we have this one already, step through for new versions or
            // new methods and add those as applicable
            for(let k = 0, dcount = defs.length; k < dcount; k++){
                const def = defs[k];
                const prev = result[key].find(({ version: version })=>def.version === version);
                if (prev) // interleave the new methods with the old - last definition wins
                (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)(prev.methods, def.methods);
                else // we don't have this specific version, add it
                result[key].push(def);
            }
            else // we don't have this runtime definition, add it as-is
            result[key] = defs;
        }
    }
    // extract all runtime definitions
    _getRuntimeDefs(registry, specName, chain = "") {
        const result = {};
        const defValues = Object.values((0, $f07063bab9185798$exports));
        // options > chain/spec > built-in, apply in reverse order with
        // methods overriding previous definitions (or interleave missing)
        for(let i = 0, count = defValues.length; i < count; i++)this._addRuntimeDef(result, defValues[i].runtime);
        this._addRuntimeDef(result, (0, $676c6ee87070430c$export$3ca5901d943d5d8)(registry, chain, specName));
        this._addRuntimeDef(result, this._options.runtime);
        return Object.entries(result);
    }
    // pre-metadata decoration
    _decorateCalls({ registry: registry, runtimeVersion: { apis: apis, specName: specName, specVersion: specVersion } }, decorateMethod, blockHash) {
        const result = {};
        const named = {};
        const hashes = {};
        const sections = this._getRuntimeDefs(registry, specName, this._runtimeChain);
        const older = [];
        const implName = `${specName.toString()}/${specVersion.toString()}`;
        const hasLogged = this.__internal__runtimeLog[implName] || false;
        this.__internal__runtimeLog[implName] = true;
        for(let i = 0, scount = sections.length; i < scount; i++){
            const [_section, secs] = sections[i];
            const sectionHash = (0, $dcbcf4e1d1853689$export$808fb830d95da849)(_section, 64);
            const rtApi = apis.find(([a])=>a.eq(sectionHash));
            hashes[sectionHash] = true;
            if (rtApi) {
                const all = secs.map(({ version: version })=>version).sort();
                const sec = secs.find(({ version: version })=>rtApi[1].eq(version));
                if (sec) {
                    const section = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(_section);
                    const methods = Object.entries(sec.methods);
                    if (methods.length) {
                        if (!named[section]) named[section] = {};
                        for(let m = 0, mcount = methods.length; m < mcount; m++){
                            const [_method, def] = methods[m];
                            const method = (0, $4db46be060f888b6$export$27f5d30aaa3dc2ea)(_method);
                            named[section][method] = (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                                method: method,
                                name: `${_section}_${_method}`,
                                section: section,
                                sectionHash: sectionHash
                            }, def);
                        }
                    }
                } else older.push(`${_section}/${rtApi[1].toString()} (${all.join("/")} known)`);
            }
        }
        // find the runtimes that we don't have hashes for
        const notFound = apis.map(([a, v])=>[
                a.toHex(),
                v.toString()
            ]).filter(([a])=>!hashes[a]).map(([a, v])=>`${this._runtimeMap[a] || a}/${v}`);
        if (!this._options.noInitWarn && !hasLogged) {
            if (older.length) $f2b9425f228b751d$var$l.warn(`${implName}: Not decorating runtime apis without matching versions: ${older.join(", ")}`);
            if (notFound.length) $f2b9425f228b751d$var$l.warn(`${implName}: Not decorating unknown runtime apis: ${notFound.join(", ")}`);
        }
        const stateCall = blockHash ? (name, bytes)=>this._rpcCore.state.call(name, bytes, blockHash) : (name, bytes)=>this._rpcCore.state.call(name, bytes);
        const lazySection = (section)=>(0, $bad025b936daa7ef$export$d3fc7341b317ef1a)({}, Object.keys(named[section]), (method)=>this._decorateCall(registry, named[section][method], stateCall, decorateMethod));
        const modules = Object.keys(named);
        for(let i = 0, count = modules.length; i < count; i++)(0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, modules[i], lazySection);
        return result;
    }
    _decorateCall(registry, def, stateCall, decorateMethod) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const decorated = decorateMethod((...args)=>{
            if (args.length !== def.params.length) throw new Error(`${def.name}:: Expected ${def.params.length} arguments, found ${args.length}`);
            const bytes = registry.createType("Raw", (0, $84207d7313fd2c40$export$4dcdc48872dbeda7)(args.map((a, i)=>registry.createTypeUnsafe(def.params[i].type, [
                    a
                ]).toU8a())));
            return stateCall(def.name, bytes).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((r)=>registry.createTypeUnsafe(def.type, [
                    r
                ])));
        });
        decorated.meta = def;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return decorated;
    }
    // only be called if supportMulti is true
    _decorateMulti(decorateMethod) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return decorateMethod((keys)=>keys.length ? (this.hasSubscriptions ? this._rpcCore.state.subscribeStorage : this._rpcCore.state.queryStorageAt)(keys.map((args)=>Array.isArray(args) ? args[0].creator.meta.type.isPlain ? [
                    args[0].creator
                ] : args[0].creator.meta.type.asMap.hashers.length === 1 ? [
                    args[0].creator,
                    args.slice(1)
                ] : [
                    args[0].creator,
                    ...args.slice(1)
                ] : [
                    args.creator
                ])) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
    }
    _decorateMultiAt(atApi, decorateMethod, blockHash) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return decorateMethod((calls)=>calls.length ? this._rpcCore.state.queryStorageAt(calls.map((args)=>{
                if (Array.isArray(args)) {
                    const { creator: creator } = $f2b9425f228b751d$var$getAtQueryFn(atApi, args[0].creator);
                    return creator.meta.type.isPlain ? [
                        creator
                    ] : creator.meta.type.asMap.hashers.length === 1 ? [
                        creator,
                        args.slice(1)
                    ] : [
                        creator,
                        ...args.slice(1)
                    ];
                }
                return [
                    $f2b9425f228b751d$var$getAtQueryFn(atApi, args.creator).creator
                ];
            }), blockHash) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]));
    }
    _decorateExtrinsics({ tx: tx }, decorateMethod) {
        const result = (0, $1708cf704191c947$export$cd4f5aa0ba018bd4)(this._type, this._rx, decorateMethod);
        const lazySection = (section)=>(0, $bad025b936daa7ef$export$d3fc7341b317ef1a)({}, Object.keys(tx[section]), (method)=>method.startsWith("$") ? tx[section][method] : this._decorateExtrinsicEntry(tx[section][method], result));
        const sections = Object.keys(tx);
        for(let i = 0, count = sections.length; i < count; i++)(0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, sections[i], lazySection);
        return result;
    }
    _decorateExtrinsicEntry(method, creator) {
        const decorated = (...params)=>creator(method(...params));
        // pass through the `.is`
        decorated.is = (other)=>method.is(other);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this._decorateFunctionMeta(method, decorated);
    }
    _decorateStorage({ query: query, registry: registry }, decorateMethod, blockHash) {
        const result = {};
        const lazySection = (section)=>(0, $bad025b936daa7ef$export$d3fc7341b317ef1a)({}, Object.keys(query[section]), (method)=>blockHash ? this._decorateStorageEntryAt(registry, query[section][method], decorateMethod, blockHash) : this._decorateStorageEntry(query[section][method], decorateMethod));
        const sections = Object.keys(query);
        for(let i = 0, count = sections.length; i < count; i++)(0, $bad025b936daa7ef$export$54b978cbb0dbaeb0)(result, sections[i], lazySection);
        return result;
    }
    _decorateStorageEntry(creator, decorateMethod) {
        const getArgs = (args, registry)=>(0, $ccda0a529c1c1831$export$ac03cd6be97f218a)(registry || this.__internal__registry, creator, args);
        const getQueryAt = (blockHash)=>(0, $9451f06798fd34f2$export$6788812c4e6611e6)(this.at(blockHash)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((api)=>$f2b9425f228b751d$var$getAtQueryFn(api, creator)));
        // Disable this where it occurs for each field we are decorating
        /* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */ const decorated = this._decorateStorageCall(creator, decorateMethod);
        decorated.creator = creator;
        // eslint-disable-next-line deprecation/deprecation
        decorated.at = decorateMethod((blockHash, ...args)=>getQueryAt(blockHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((q)=>q(...args))));
        decorated.hash = decorateMethod((...args)=>this._rpcCore.state.getStorageHash(getArgs(args)));
        decorated.is = (key)=>key.section === creator.section && key.method === creator.method;
        decorated.key = (...args)=>(0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $871e028f2f4a4d6f$export$cec2d66edc517cdd)(creator(...args))[1]);
        decorated.keyPrefix = (...args)=>(0, $1e2cfad286c009ca$export$4429d284633899e1)(creator.keyPrefix(...args));
        decorated.size = decorateMethod((...args)=>this._rpcCore.state.getStorageSize(getArgs(args)));
        // eslint-disable-next-line deprecation/deprecation
        decorated.sizeAt = decorateMethod((blockHash, ...args)=>getQueryAt(blockHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((q)=>this._rpcCore.state.getStorageSize(getArgs(args, q.creator.meta.registry), blockHash))));
        // .keys() & .entries() only available on map types
        if (creator.iterKey && creator.meta.type.isMap) {
            decorated.entries = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (...args)=>this._retrieveMapEntries(creator, null, args)));
            // eslint-disable-next-line deprecation/deprecation
            decorated.entriesAt = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (blockHash, ...args)=>getQueryAt(blockHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((q)=>this._retrieveMapEntries(q.creator, blockHash, args)))));
            decorated.entriesPaged = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (opts)=>this._retrieveMapEntriesPaged(creator, undefined, opts)));
            decorated.keys = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (...args)=>this._retrieveMapKeys(creator, null, args)));
            // eslint-disable-next-line deprecation/deprecation
            decorated.keysAt = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (blockHash, ...args)=>getQueryAt(blockHash).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((q)=>this._retrieveMapKeys(q.creator, blockHash, args)))));
            decorated.keysPaged = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (opts)=>this._retrieveMapKeysPaged(creator, undefined, opts)));
        }
        if (this.supportMulti && creator.meta.type.isMap) // When using double map storage function, user need to pass double map key as an array
        decorated.multi = decorateMethod((args)=>creator.meta.type.asMap.hashers.length === 1 ? this._retrieveMulti(args.map((a)=>[
                    creator,
                    [
                        a
                    ]
                ])) : this._retrieveMulti(args.map((a)=>[
                    creator,
                    a
                ])));
        /* eslint-enable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */ return this._decorateFunctionMeta(creator, decorated);
    }
    _decorateStorageEntryAt(registry, creator, decorateMethod, blockHash) {
        const getArgs = (args)=>(0, $ccda0a529c1c1831$export$ac03cd6be97f218a)(registry, creator, args);
        // Disable this where it occurs for each field we are decorating
        /* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */ const decorated = decorateMethod((...args)=>this._rpcCore.state.getStorage(getArgs(args), blockHash));
        decorated.creator = creator;
        decorated.hash = decorateMethod((...args)=>this._rpcCore.state.getStorageHash(getArgs(args), blockHash));
        decorated.is = (key)=>key.section === creator.section && key.method === creator.method;
        decorated.key = (...args)=>(0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $871e028f2f4a4d6f$export$cec2d66edc517cdd)(creator(...args))[1]);
        decorated.keyPrefix = (...keys)=>(0, $1e2cfad286c009ca$export$4429d284633899e1)(creator.keyPrefix(...keys));
        decorated.size = decorateMethod((...args)=>this._rpcCore.state.getStorageSize(getArgs(args), blockHash));
        // .keys() & .entries() only available on map types
        if (creator.iterKey && creator.meta.type.isMap) {
            decorated.entries = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (...args)=>this._retrieveMapEntries(creator, blockHash, args)));
            decorated.entriesPaged = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (opts)=>this._retrieveMapEntriesPaged(creator, blockHash, opts)));
            decorated.keys = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (...args)=>this._retrieveMapKeys(creator, blockHash, args)));
            decorated.keysPaged = decorateMethod((0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (opts)=>this._retrieveMapKeysPaged(creator, blockHash, opts)));
        }
        if (this.supportMulti && creator.meta.type.isMap) // When using double map storage function, user need to pass double map key as an array
        decorated.multi = decorateMethod((args)=>creator.meta.type.asMap.hashers.length === 1 ? this._retrieveMulti(args.map((a)=>[
                    creator,
                    [
                        a
                    ]
                ]), blockHash) : this._retrieveMulti(args.map((a)=>[
                    creator,
                    a
                ]), blockHash));
        /* eslint-enable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */ return this._decorateFunctionMeta(creator, decorated);
    }
    _queueStorage(call, queue) {
        const query = queue === this.__internal__storageSubQ ? this._rpcCore.state.subscribeStorage : this._rpcCore.state.queryStorageAt;
        let queueIdx = queue.length - 1;
        let valueIdx = 0;
        let valueObs;
        // if we don't have queue entries yet,
        // or the current queue has fired (see from below),
        // or the current queue has the max entries,
        // then we create a new queue
        if (queueIdx === -1 || !queue[queueIdx] || queue[queueIdx][1].length === $f2b9425f228b751d$var$PAGE_SIZE_Q) {
            queueIdx++;
            valueObs = (0, $9451f06798fd34f2$export$6788812c4e6611e6)(// we delay the execution until the next tick, this allows
            // any queries made in this timeframe to be added to the same
            // queue for a single query
            new Promise((resolve)=>{
                (0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>{
                    // get all the calls in this instance, resolve with it
                    // and then clear the queue so we don't add more
                    // (anything after this will be added to a new queue)
                    const calls = queue[queueIdx][1];
                    delete queue[queueIdx];
                    resolve(calls);
                });
            })).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((calls)=>query(calls)));
            queue.push([
                valueObs,
                [
                    call
                ]
            ]);
        } else {
            valueObs = queue[queueIdx][0];
            valueIdx = queue[queueIdx][1].length;
            queue[queueIdx][1].push(call);
        }
        return valueObs.pipe(// return the single value at this index
        (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((values)=>values[valueIdx]));
    }
    // Decorate the base storage call. In the case or rxjs or promise-without-callback (await)
    // we make a subscription, alternatively we push this through a single-shot query
    _decorateStorageCall(creator, decorateMethod) {
        const memoed = (0, $ab24732a7fa90447$export$7c73462e0d25e514)(this.__internal__instanceId, (...args)=>{
            const call = (0, $ccda0a529c1c1831$export$ac03cd6be97f218a)(this.__internal__registry, creator, args);
            if (!this.hasSubscriptions) return this._rpcCore.state.getStorage(call);
            return this._queueStorage(call, this.__internal__storageSubQ);
        });
        return decorateMethod(memoed, {
            methodName: creator.method,
            overrideNoSub: (...args)=>this._queueStorage((0, $ccda0a529c1c1831$export$ac03cd6be97f218a)(this.__internal__registry, creator, args), this.__internal__storageGetQ)
        });
    }
    // retrieve a set of values for a specific set of keys - here we chunk the keys into PAGE_SIZE sizes
    _retrieveMulti(keys, blockHash) {
        if (!keys.length) return (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([]);
        const query = this.hasSubscriptions && !blockHash ? this._rpcCore.state.subscribeStorage : this._rpcCore.state.queryStorageAt;
        if (keys.length <= $f2b9425f228b751d$var$PAGE_SIZE_V) return blockHash ? query(keys, blockHash) : query(keys);
        return (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)((0, $e204297b30b8ef47$export$b320c6157b39692a)(keys, $f2b9425f228b751d$var$PAGE_SIZE_V).map((k)=>blockHash ? query(k, blockHash) : query(k))).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((0, $f9c42f4bb009b291$export$71d4d087ef817bcf)));
    }
    _retrieveMapKeys({ iterKey: iterKey, meta: meta, method: method, section: section }, at, args) {
        if (!iterKey || !meta.type.isMap) throw new Error("keys can only be retrieved on maps");
        const headKey = iterKey(...args).toHex();
        const startSubject = new (0, $c083768a9df36bef$export$cc3d42e6b2b9cf8b)(headKey);
        const query = at ? (startKey)=>this._rpcCore.state.getKeysPaged(headKey, $f2b9425f228b751d$var$PAGE_SIZE_K, startKey, at) : (startKey)=>this._rpcCore.state.getKeysPaged(headKey, $f2b9425f228b751d$var$PAGE_SIZE_K, startKey);
        const setMeta = (key)=>key.setMeta(meta, section, method);
        return startSubject.pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)(query), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((keys)=>keys.map(setMeta)), (0, $9d19ec2059422f48$export$3f23594af5f37336)((keys)=>(0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>{
                keys.length === $f2b9425f228b751d$var$PAGE_SIZE_K ? startSubject.next(keys[$f2b9425f228b751d$var$PAGE_SIZE_K - 1].toHex()) : startSubject.complete();
            })), (0, $8f965355e5b83cb3$export$45b10814cc054894)(), (0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((0, $f9c42f4bb009b291$export$71d4d087ef817bcf)));
    }
    _retrieveMapKeysPaged({ iterKey: iterKey, meta: meta, method: method, section: section }, at, opts) {
        if (!iterKey || !meta.type.isMap) throw new Error("keys can only be retrieved on maps");
        const setMeta = (key)=>key.setMeta(meta, section, method);
        const query = at ? (headKey)=>this._rpcCore.state.getKeysPaged(headKey, opts.pageSize, opts.startKey || headKey, at) : (headKey)=>this._rpcCore.state.getKeysPaged(headKey, opts.pageSize, opts.startKey || headKey);
        return query(iterKey(...opts.args).toHex()).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((keys)=>keys.map(setMeta)));
    }
    _retrieveMapEntries(entry, at, args) {
        const query = at ? (keys)=>this._rpcCore.state.queryStorageAt(keys, at) : (keys)=>this._rpcCore.state.queryStorageAt(keys);
        return this._retrieveMapKeys(entry, at, args).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((keys)=>keys.length ? (0, $092e9fc3c37f8594$export$77fa7d86f5204e8a)((0, $e204297b30b8ef47$export$b320c6157b39692a)(keys, $f2b9425f228b751d$var$PAGE_SIZE_V).map(query)).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((valsArr)=>(0, $f9c42f4bb009b291$export$71d4d087ef817bcf)(valsArr).map((value, index)=>[
                        keys[index],
                        value
                    ]))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])));
    }
    _retrieveMapEntriesPaged(entry, at, opts) {
        const query = at ? (keys)=>this._rpcCore.state.queryStorageAt(keys, at) : (keys)=>this._rpcCore.state.queryStorageAt(keys);
        return this._retrieveMapKeysPaged(entry, at, opts).pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((keys)=>keys.length ? query(keys).pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((valsArr)=>valsArr.map((value, index)=>[
                        keys[index],
                        value
                    ]))) : (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)([])));
    }
    _decorateDeriveRx(decorateMethod) {
        const specName = this._runtimeVersion?.specName.toString();
        // Pull in derive from api-derive
        const available = (0, $9e08e8d0869f5d5d$export$57f6da4ee225b75e)(this.__internal__instanceId, this._rx, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, this._options.derives, this._options.typesBundle?.spec?.[specName || ""]?.derives));
        return (0, $233a72847b310a1f$export$b3c01e03f8df8386)(decorateMethod, available);
    }
    _decorateDerive(decorateMethod) {
        return (0, $233a72847b310a1f$export$b3c01e03f8df8386)(decorateMethod, this._rx.derive);
    }
}


const $7ba966f8ff293ac2$var$KEEPALIVE_INTERVAL = 10000;
const $7ba966f8ff293ac2$var$WITH_VERSION_SHORTCUT = false;
const $7ba966f8ff293ac2$var$l = (0, $d7d4f472109ad7f8$export$af88d00dbe7f521)("api/init");
function $7ba966f8ff293ac2$var$textToString(t) {
    return t.toString();
}
class $7ba966f8ff293ac2$export$d050db8f6426404e extends (0, $f2b9425f228b751d$export$f4822cf0c28e14c7) {
    constructor(options, type, decorateMethod){
        super(options, type, decorateMethod);
        this.__internal__atLast = null;
        this.__internal__healthTimer = null;
        this.__internal__registries = [];
        this.__internal__updateSub = null;
        this.__internal__waitingRegistries = {};
        // all injected types added to the registry for overrides
        this.registry.setKnownTypes(options);
        // We only register the types (global) if this is not a cloned instance.
        // Do right up-front, so we get in the user types before we are actually
        // doing anything on-chain, this ensures we have the overrides in-place
        if (!options.source) this.registerTypes(options.types);
        else this.__internal__registries = options.source.__internal__registries;
        this._rpc = this._decorateRpc(this._rpcCore, this._decorateMethod);
        this._rx.rpc = this._decorateRpc(this._rpcCore, this._rxDecorateMethod);
        if (this.supportMulti) {
            this._queryMulti = this._decorateMulti(this._decorateMethod);
            this._rx.queryMulti = this._decorateMulti(this._rxDecorateMethod);
        }
        this._rx.signer = options.signer;
        this._rpcCore.setRegistrySwap((blockHash)=>this.getBlockRegistry(blockHash));
        this._rpcCore.setResolveBlockHash((blockNumber)=>(0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.chain.getBlockHash(blockNumber)));
        if (this.hasSubscriptions) {
            this._rpcCore.provider.on("disconnected", ()=>this.__internal__onProviderDisconnect());
            this._rpcCore.provider.on("error", (e)=>this.__internal__onProviderError(e));
            this._rpcCore.provider.on("connected", ()=>this.__internal__onProviderConnect());
        } else if (!this._options.noInitWarn) $7ba966f8ff293ac2$var$l.warn("Api will be available in a limited mode since the provider does not support subscriptions");
        // If the provider was instantiated earlier, and has already emitted a
        // 'connected' event, then the `on('connected')` won't fire anymore. To
        // cater for this case, we call manually `this._onProviderConnect`.
        if (this._rpcCore.provider.isConnected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.__internal__onProviderConnect();
    }
    /**
     * @description Decorates a registry based on the runtime version
     */ _initRegistry(registry, chain, version, metadata, chainProps) {
        registry.clearCache();
        registry.setChainProperties(chainProps || this.registry.getChainProperties());
        registry.setKnownTypes(this._options);
        registry.register((0, $676c6ee87070430c$export$c099f8c8aa80b480)(registry, chain, version.specName, version.specVersion));
        registry.setHasher((0, $676c6ee87070430c$export$e4a7bf67e5bfb658)(registry, chain, version.specName));
        // for bundled types, pull through the aliases defined
        if (registry.knownTypes.typesBundle) registry.knownTypes.typesAlias = (0, $676c6ee87070430c$export$c977ced5e7aa3a56)(registry, chain, version.specName);
        registry.setMetadata(metadata, undefined, (0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, (0, $676c6ee87070430c$export$9941a79b48f71da2)(registry, chain, version.specName), this._options.signedExtensions), this._options.noInitWarn);
    }
    /**
     * @description Returns the default versioned registry
     */ _getDefaultRegistry() {
        return (0, $7f962568317a1d97$export$5529f1223fff4d4a)(this.__internal__registries.find(({ isDefault: isDefault })=>isDefault), "Initialization error, cannot find the default registry");
    }
    /**
     * @description Returns a decorated API instance at a specific point in time
     */ async at(blockHash, knownVersion) {
        const u8aHash = (0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(blockHash);
        const u8aHex = (0, $1e2cfad286c009ca$export$4429d284633899e1)(u8aHash);
        const registry = await this.getBlockRegistry(u8aHash, knownVersion);
        if (!this.__internal__atLast || this.__internal__atLast[0] !== u8aHex) // always create a new decoration - since we are pointing to a specific hash, this
        // means that all queries needs to use that hash (not a previous one already existing)
        this.__internal__atLast = [
            u8aHex,
            this._createDecorated(registry, true, null, u8aHash).decoratedApi
        ];
        return this.__internal__atLast[1];
    }
    async _createBlockRegistry(blockHash, header, version) {
        const registry = new (0, $e21dedd888b26621$export$ea4312c9b0ebd908)(blockHash);
        const metadata = new (0, $918d2e4dba59a611$export$e7adebdc1ebd2fed)(registry, await (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.state.getMetadata.raw(header.parentHash)));
        this._initRegistry(registry, this._runtimeChain, version, metadata);
        // add our new registry
        const result = {
            counter: 0,
            lastBlockHash: blockHash,
            metadata: metadata,
            registry: registry,
            runtimeVersion: version
        };
        this.__internal__registries.push(result);
        return result;
    }
    _cacheBlockRegistryProgress(key, creator) {
        // look for waiting resolves
        let waiting = this.__internal__waitingRegistries[key];
        if ((0, $09d5dc0a6a4c347b$export$fce6876652108ab)(waiting)) // nothing waiting, construct new
        waiting = this.__internal__waitingRegistries[key] = new Promise((resolve, reject)=>{
            creator().then((registry)=>{
                delete this.__internal__waitingRegistries[key];
                resolve(registry);
            }).catch((error)=>{
                delete this.__internal__waitingRegistries[key];
                reject(error);
            });
        });
        return waiting;
    }
    _getBlockRegistryViaVersion(blockHash, version) {
        if (version) {
            // check for pre-existing registries. We also check specName, e.g. it
            // could be changed like in Westmint with upgrade from shell -> westmint
            const existingViaVersion = this.__internal__registries.find(({ runtimeVersion: { specName: specName, specVersion: specVersion } })=>specName.eq(version.specName) && specVersion.eq(version.specVersion));
            if (existingViaVersion) {
                existingViaVersion.counter++;
                existingViaVersion.lastBlockHash = blockHash;
                return existingViaVersion;
            }
        }
        return null;
    }
    async _getBlockRegistryViaHash(blockHash) {
        // ensure we have everything required
        if (!this._genesisHash || !this._runtimeVersion) throw new Error("Cannot retrieve data on an uninitialized chain");
        // We have to assume that on the RPC layer the calls used here does not call back into
        // the registry swap, so getHeader & getRuntimeVersion should not be historic
        const header = this.registry.createType("HeaderPartial", this._genesisHash.eq(blockHash) ? {
            number: (0, $031d4cf4355dbeac$export$df7eb0036fdbadfa),
            parentHash: this._genesisHash
        } : await (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.chain.getHeader.raw(blockHash)));
        if (header.parentHash.isEmpty) throw new Error("Unable to retrieve header and parent from supplied hash");
        // get the runtime version, either on-chain or via an known upgrade history
        const [firstVersion, lastVersion] = (0, $676c6ee87070430c$export$d9a776a58fa8f61b)(this._genesisHash, header.number);
        const version = this.registry.createType("RuntimeVersionPartial", $7ba966f8ff293ac2$var$WITH_VERSION_SHORTCUT && firstVersion && (lastVersion || firstVersion.specVersion.eq(this._runtimeVersion.specVersion)) ? {
            apis: firstVersion.apis,
            specName: this._runtimeVersion.specName,
            specVersion: firstVersion.specVersion
        } : await (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.state.getRuntimeVersion.raw(header.parentHash)));
        return(// try to find via version
        this._getBlockRegistryViaVersion(blockHash, version) || // return new or in-flight result
        await this._cacheBlockRegistryProgress(version.toHex(), ()=>this._createBlockRegistry(blockHash, header, version)));
    }
    /**
     * @description Sets up a registry based on the block hash defined
     */ async getBlockRegistry(blockHash, knownVersion) {
        return(// try to find via blockHash
        this.__internal__registries.find(({ lastBlockHash: lastBlockHash })=>lastBlockHash && (0, $06bddcb0a8413ca0$export$17581a7c6e2ec978)(lastBlockHash, blockHash)) || // try to find via version
        this._getBlockRegistryViaVersion(blockHash, knownVersion) || // return new or in-flight result
        await this._cacheBlockRegistryProgress((0, $1e2cfad286c009ca$export$4429d284633899e1)(blockHash), ()=>this._getBlockRegistryViaHash(blockHash)));
    }
    async _loadMeta() {
        // on re-connection to the same chain, we don't want to re-do everything from chain again
        if (this._isReady) return true;
        this._unsubscribeUpdates();
        // only load from on-chain if we are not a clone (default path), alternatively
        // just use the values from the source instance provided
        [this._genesisHash, this._runtimeMetadata] = this._options.source?._isReady ? await this._metaFromSource(this._options.source) : await this._metaFromChain(this._options.metadata);
        return this._initFromMeta(this._runtimeMetadata);
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async _metaFromSource(source) {
        this._extrinsicType = source.extrinsicVersion;
        this._runtimeChain = source.runtimeChain;
        this._runtimeVersion = source.runtimeVersion;
        // manually build a list of all available methods in this RPC, we are
        // going to filter on it to align the cloned RPC without making a call
        const sections = Object.keys(source.rpc);
        const rpcs = [];
        for(let s = 0, scount = sections.length; s < scount; s++){
            const section = sections[s];
            const methods = Object.keys(source.rpc[section]);
            for(let m = 0, mcount = methods.length; m < mcount; m++)rpcs.push(`${section}_${methods[m]}`);
        }
        this._filterRpc(rpcs, (0, $676c6ee87070430c$export$d850d27bae1846f4)(this.registry, source.runtimeChain, source.runtimeVersion.specName));
        return [
            source.genesisHash,
            source.runtimeMetadata
        ];
    }
    // subscribe to metadata updates, inject the types on changes
    _subscribeUpdates() {
        if (this.__internal__updateSub || !this.hasSubscriptions) return;
        this.__internal__updateSub = this._rpcCore.state.subscribeRuntimeVersion().pipe((0, $bb062d4ebeac9c0f$export$9f6ea8e48bc26eab)((version)=>// only retrieve the metadata when the on-chain version has been changed
            this._runtimeVersion?.specVersion.eq(version.specVersion) ? (0, $dc9a8fc77574b4ba$export$ba255e9e49e00608)(false) : this._rpcCore.state.getMetadata().pipe((0, $9a63ae9794caf0c2$export$871de8747c9eaa88)((metadata)=>{
                $7ba966f8ff293ac2$var$l.log(`Runtime version updated to spec=${version.specVersion.toString()}, tx=${version.transactionVersion.toString()}`);
                this._runtimeMetadata = metadata;
                this._runtimeVersion = version;
                this._rx.runtimeVersion = version;
                // update the default registry version
                const thisRegistry = this._getDefaultRegistry();
                // setup the data as per the current versions
                thisRegistry.metadata = metadata;
                thisRegistry.runtimeVersion = version;
                this._initRegistry(this.registry, this._runtimeChain, version, metadata);
                this._injectMetadata(thisRegistry, true);
                return true;
            })))).subscribe();
    }
    async _metaFromChain(optMetadata) {
        const [genesisHash, runtimeVersion, chain, chainProps, rpcMethods, chainMetadata] = await Promise.all([
            (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.chain.getBlockHash(0)),
            (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.state.getRuntimeVersion()),
            (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.system.chain()),
            (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.system.properties()),
            (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.rpc.methods()),
            optMetadata ? Promise.resolve(null) : (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.state.getMetadata())
        ]);
        // set our chain version & genesisHash as returned
        this._runtimeChain = chain;
        this._runtimeVersion = runtimeVersion;
        this._rx.runtimeVersion = runtimeVersion;
        // retrieve metadata, either from chain  or as pass-in via options
        const metadataKey = `${genesisHash.toHex() || "0x"}-${runtimeVersion.specVersion.toString()}`;
        const metadata = chainMetadata || (optMetadata && optMetadata[metadataKey] ? new (0, $918d2e4dba59a611$export$e7adebdc1ebd2fed)(this.registry, optMetadata[metadataKey]) : await (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.state.getMetadata()));
        // initializes the registry & RPC
        this._initRegistry(this.registry, chain, runtimeVersion, metadata, chainProps);
        this._filterRpc(rpcMethods.methods.map($7ba966f8ff293ac2$var$textToString), (0, $676c6ee87070430c$export$d850d27bae1846f4)(this.registry, chain, runtimeVersion.specName));
        this._subscribeUpdates();
        // setup the initial registry, when we have none
        if (!this.__internal__registries.length) this.__internal__registries.push({
            counter: 0,
            isDefault: true,
            metadata: metadata,
            registry: this.registry,
            runtimeVersion: runtimeVersion
        });
        // get unique types & validate
        metadata.getUniqTypes(this._options.throwOnUnknown || false);
        return [
            genesisHash,
            metadata
        ];
    }
    _initFromMeta(metadata) {
        this._extrinsicType = metadata.asLatest.extrinsic.version.toNumber();
        this._rx.extrinsicType = this._extrinsicType;
        this._rx.genesisHash = this._genesisHash;
        this._rx.runtimeVersion = this._runtimeVersion; // must be set here
        // inject metadata and adjust the types as detected
        this._injectMetadata(this._getDefaultRegistry(), true);
        // derive is last, since it uses the decorated rx
        this._rx.derive = this._decorateDeriveRx(this._rxDecorateMethod);
        this._derive = this._decorateDerive(this._decorateMethod);
        return true;
    }
    _subscribeHealth() {
        this._unsubscribeHealth();
        // Only enable the health keepalive on WS, not needed on HTTP
        this.__internal__healthTimer = this.hasSubscriptions ? setInterval(()=>{
            (0, $a9828966d726d4a4$export$400f9f949cef996c)(this._rpcCore.system.health.raw()).catch(()=>undefined);
        }, $7ba966f8ff293ac2$var$KEEPALIVE_INTERVAL) : null;
    }
    _unsubscribeHealth() {
        if (this.__internal__healthTimer) {
            clearInterval(this.__internal__healthTimer);
            this.__internal__healthTimer = null;
        }
    }
    _unsubscribeUpdates() {
        if (this.__internal__updateSub) {
            this.__internal__updateSub.unsubscribe();
            this.__internal__updateSub = null;
        }
    }
    _unsubscribe() {
        this._unsubscribeHealth();
        this._unsubscribeUpdates();
    }
    async __internal__onProviderConnect() {
        this._isConnected.next(true);
        this.emit("connected");
        try {
            const cryptoReady = this._options.initWasm === false ? true : await (0, $89f083bc1f278e17$export$2adefdc7d729f62e)();
            const hasMeta = await this._loadMeta();
            this._subscribeHealth();
            if (hasMeta && !this._isReady && cryptoReady) {
                this._isReady = true;
                this.emit("ready", this);
            }
        } catch (_error) {
            const error = new Error(`FATAL: Unable to initialize the API: ${_error.message}`);
            $7ba966f8ff293ac2$var$l.error(error);
            this.emit("error", error);
        }
    }
    __internal__onProviderDisconnect() {
        this._isConnected.next(false);
        this._unsubscribe();
        this.emit("disconnected");
    }
    __internal__onProviderError(error) {
        this.emit("error", error);
    }
}


function $410a4fe85d94efab$var$assertResult(value) {
    if (value === undefined) throw new Error("Api interfaces needs to be initialized before using, wait for 'isReady'");
    return value;
}
class $410a4fe85d94efab$export$98f149b9af65c508 extends (0, $7ba966f8ff293ac2$export$d050db8f6426404e) {
    /**
     * @description Runtime call interfaces (currently untyped, only decorated via API options)
     */ get call() {
        return $410a4fe85d94efab$var$assertResult(this._call);
    }
    /**
     * @description Contains the parameter types (constants) of all modules.
     *
     * The values are instances of the appropriate type and are accessible using `section`.`constantName`,
     *
     * @example
     * <BR>
     *
     * ```javascript
     * console.log(api.consts.democracy.enactmentPeriod.toString())
     * ```
     */ get consts() {
        return $410a4fe85d94efab$var$assertResult(this._consts);
    }
    /**
     * @description Derived results that are injected into the API, allowing for combinations of various query results.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.derive.chain.bestNumber((number) => {
     *   console.log('best number', number);
     * });
     * ```
     */ get derive() {
        return $410a4fe85d94efab$var$assertResult(this._derive);
    }
    /**
     * @description Errors from metadata
     */ get errors() {
        return $410a4fe85d94efab$var$assertResult(this._errors);
    }
    /**
     * @description Events from metadata
     */ get events() {
        return $410a4fe85d94efab$var$assertResult(this._events);
    }
    /**
     * @description  Returns the version of extrinsics in-use on this chain
     */ get extrinsicVersion() {
        return this._extrinsicType;
    }
    /**
     * @description Contains the genesis Hash of the attached chain. Apart from being useful to determine the actual chain, it can also be used to sign immortal transactions.
     */ get genesisHash() {
        return $410a4fe85d94efab$var$assertResult(this._genesisHash);
    }
    /**
     * @description true is the underlying provider is connected
     */ get isConnected() {
        return this._isConnected.getValue();
    }
    /**
     * @description The library information name & version (from package.json)
     */ get libraryInfo() {
        return `${(0, $b57f2f892c2ac20d$export$ce0097da4c08ff3f).name} v${(0, $b57f2f892c2ac20d$export$ce0097da4c08ff3f).version}`;
    }
    /**
     * @description Contains all the chain state modules and their subsequent methods in the API. These are attached dynamically from the runtime metadata.
     *
     * All calls inside the namespace, is denoted by `section`.`method` and may take an optional query parameter. As an example, `api.query.timestamp.now()` (current block timestamp) does not take parameters, while `api.query.system.account(<accountId>)` (retrieving the associated nonce & balances for an account), takes the `AccountId` as a parameter.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.query.system.account(<accountId>, ([nonce, balance]) => {
     *   console.log('new free balance', balance.free, 'new nonce', nonce);
     * });
     * ```
     */ get query() {
        return $410a4fe85d94efab$var$assertResult(this._query);
    }
    /**
     * @description Allows for the querying of multiple storage entries and the combination thereof into a single result. This is a very optimal way to make multiple queries since it only makes a single connection to the node and retrieves the data over one subscription.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * const unsub = await api.queryMulti(
     *   [
     *     // you can include the storage without any parameters
     *     api.query.balances.totalIssuance,
     *     // or you can pass parameters to the storage query
     *     [api.query.system.account, '5GrwvaEF5zXb26Fz9rcQpDWS57CtERHpNehXCPcNoHGKutQY']
     *   ],
     *   ([existential, [, { free }]]) => {
     *     console.log(`You have ${free.sub(existential)} more than the existential deposit`);
     *
     *     unsub();
     *   }
     * );
     * ```
     */ get queryMulti() {
        return $410a4fe85d94efab$var$assertResult(this._queryMulti);
    }
    /**
     * @description Contains all the raw rpc sections and their subsequent methods in the API as defined by the jsonrpc interface definitions. Unlike the dynamic `api.query` and `api.tx` sections, these methods are fixed (although extensible with node upgrades) and not determined by the runtime.
     *
     * RPC endpoints available here allow for the query of chain, node and system information, in addition to providing interfaces for the raw queries of state (using known keys) and the submission of transactions.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.rpc.chain.subscribeNewHeads((header) => {
     *   console.log('new header', header);
     * });
     * ```
     */ get rpc() {
        return $410a4fe85d94efab$var$assertResult(this._rpc);
    }
    /**
     * @description Contains the chain information for the current node.
     */ get runtimeChain() {
        return $410a4fe85d94efab$var$assertResult(this._runtimeChain);
    }
    /**
     * @description Yields the current attached runtime metadata. Generally this is only used to construct extrinsics & storage, but is useful for current runtime inspection.
     */ get runtimeMetadata() {
        return $410a4fe85d94efab$var$assertResult(this._runtimeMetadata);
    }
    /**
     * @description Contains the version information for the current runtime.
     */ get runtimeVersion() {
        return $410a4fe85d94efab$var$assertResult(this._runtimeVersion);
    }
    /**
     * @description The underlying Rx API interface
     */ get rx() {
        return $410a4fe85d94efab$var$assertResult(this._rx);
    }
    /**
     * @description Returns the underlying provider stats
     */ get stats() {
        return this._rpcCore.provider.stats;
    }
    /**
     * @description The type of this API instance, either 'rxjs' or 'promise'
     */ get type() {
        return this._type;
    }
    /**
     * @description Contains all the extrinsic modules and their subsequent methods in the API. It allows for the construction of transactions and the submission thereof. These are attached dynamically from the runtime metadata.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.tx.balances
     *   .transfer(<recipientId>, <balance>)
     *   .signAndSend(<keyPair>, ({status}) => {
     *     console.log('tx status', status.asFinalized.toHex());
     *   });
     * ```
     */ get tx() {
        return $410a4fe85d94efab$var$assertResult(this._extrinsics);
    }
    /**
     * @description Finds the definition for a specific [[CallFunction]] based on the index supplied
     */ findCall(callIndex) {
        return (0, $0d2af457e7d47dce$export$db3b1dfc16b79619)(this.registry, callIndex);
    }
    /**
     * @description Finds the definition for a specific [[RegistryError]] based on the index supplied
     */ findError(errorIndex) {
        return (0, $0d2af457e7d47dce$export$6db3490d470bf39f)(this.registry, errorIndex);
    }
}


class $de37a27a8ad7262e$export$4e7c329e089d8cc5 extends (0, $410a4fe85d94efab$export$98f149b9af65c508) {
    /**
     * @description Create an instance of the class
     *
     * @param options Options object to create API instance or a Provider instance
     *
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * const api = new Api().isReady();
     *
     * api.rpc.subscribeNewHeads((header) => {
     *   console.log(`new block #${header.number.toNumber()}`);
     * });
     * ```
     */ constructor(options = {}, type, decorateMethod){
        super(options, type, decorateMethod);
    }
    /**
     * @description Connect from the underlying provider, halting all network traffic
     */ connect() {
        return this._rpcCore.connect();
    }
    /**
     * @description Disconnect from the underlying provider, halting all network traffic
     */ disconnect() {
        this._unsubscribe();
        return this._rpcCore.disconnect();
    }
    /**
     * @description Set an external signer which will be used to sign extrinsic when account passed in is not KeyringPair
     */ setSigner(signer) {
        this._rx.signer = signer;
    }
    /**
     * @description Signs a raw signer payload, string or Uint8Array
     */ async sign(address, data, { signer: signer } = {}) {
        if ((0, $0d672af39bfe8283$export$844ec244b1367d54)(address)) {
            const _signer = signer || this._rx.signer;
            if (!_signer || !_signer.signRaw) throw new Error("No signer exists with a signRaw interface. You possibly need to pass through an explicit keypair for the origin so it can be used for signing.");
            return (await _signer.signRaw((0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({
                type: "bytes"
            }, data, {
                address: address
            }))).signature;
        }
        return (0, $1e2cfad286c009ca$export$4429d284633899e1)(address.sign((0, $5cce92b1af3b58b2$export$3d1a44fbed727ee2)(data.data)));
    }
}



class $4a78dda700e04001$export$3cbfd7ee92c4e2ca {
    constructor(fns, callback){
        this.__internal__allHasFired = false;
        this.__internal__fired = [];
        this.__internal__fns = [];
        this.__internal__isActive = true;
        this.__internal__results = [];
        this.__internal__subscriptions = [];
        this.__internal__callback = callback;
        // eslint-disable-next-line @typescript-eslint/require-await
        this.__internal__subscriptions = fns.map(async (input, index)=>{
            const [fn, ...args] = Array.isArray(input) ? input : [
                input
            ];
            this.__internal__fired.push(false);
            this.__internal__fns.push(fn);
            // Not quite 100% how to have a variable number at the front here
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/ban-types
            return fn(...args, this._createCallback(index));
        });
    }
    _allHasFired() {
        this.__internal__allHasFired ||= this.__internal__fired.filter((hasFired)=>!hasFired).length === 0;
        return this.__internal__allHasFired;
    }
    _createCallback(index) {
        return (value)=>{
            this.__internal__fired[index] = true;
            this.__internal__results[index] = value;
            this._triggerUpdate();
        };
    }
    _triggerUpdate() {
        if (!this.__internal__isActive || !(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(this.__internal__callback) || !this._allHasFired()) return;
        try {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.__internal__callback(this.__internal__results);
        } catch  {
        // swallow, we don't want the handler to trip us up
        }
    }
    unsubscribe() {
        if (!this.__internal__isActive) return;
        this.__internal__isActive = false;
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        this.__internal__subscriptions.forEach(async (subscription)=>{
            try {
                const unsubscribe = await subscription;
                if ((0, $7539b0fce3dae361$export$f6e2535fb5126e54)(unsubscribe)) unsubscribe();
            } catch  {
            // ignore
            }
        });
    }
}




function $f2e8ea2596d62a80$export$670d5117ed9f70b3(resolve, reject) {
    let isCompleted = false;
    return {
        reject: (error)=>{
            if (!isCompleted) {
                isCompleted = true;
                reject(error);
            }
            return 0, $59e1a09a7b50cea7$export$ccb33e29d92c9a58;
        },
        resolve: (value)=>{
            if (!isCompleted) {
                isCompleted = true;
                resolve(value);
            }
        }
    };
}
function $f2e8ea2596d62a80$var$extractArgs(args, needsCallback) {
    const actualArgs = args.slice();
    // If the last arg is a function, we pop it, put it into callback.
    // actualArgs will then hold the actual arguments to be passed to `method`
    const callback = args.length && (0, $7539b0fce3dae361$export$f6e2535fb5126e54)(args[args.length - 1]) ? actualArgs.pop() : undefined;
    // When we need a subscription, ensure that a valid callback is actually passed
    if (needsCallback && !(0, $7539b0fce3dae361$export$f6e2535fb5126e54)(callback)) throw new Error("Expected a callback to be passed with subscriptions");
    return [
        actualArgs,
        callback
    ];
}
function $f2e8ea2596d62a80$var$decorateCall(method, args) {
    return new Promise((resolve, reject)=>{
        // single result tracker - either reject with Error or resolve with Codec result
        const tracker = $f2e8ea2596d62a80$export$670d5117ed9f70b3(resolve, reject);
        // encoding errors reject immediately, any result unsubscribes and resolves
        const subscription = method(...args).pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)((error)=>tracker.reject(error))).subscribe((result)=>{
            tracker.resolve(result);
            (0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>subscription.unsubscribe());
        });
    });
}
function $f2e8ea2596d62a80$var$decorateSubscribe(method, args, resultCb) {
    return new Promise((resolve, reject)=>{
        // either reject with error or resolve with unsubscribe callback
        const tracker = $f2e8ea2596d62a80$export$670d5117ed9f70b3(resolve, reject);
        // errors reject immediately, the first result resolves with an unsubscribe promise, all results via callback
        const subscription = method(...args).pipe((0, $985f81c342020fc8$export$3dede90624df3ba9)((error)=>tracker.reject(error)), (0, $9d19ec2059422f48$export$3f23594af5f37336)(()=>tracker.resolve(()=>subscription.unsubscribe()))).subscribe((result)=>{
            // queue result (back of queue to clear current)
            (0, $1d2b78a8676f560d$export$bdd553fddd433dcb)(()=>resultCb(result));
        });
    });
}
function $f2e8ea2596d62a80$export$8f7aa4d6db73a0e9(method, options) {
    const needsCallback = !!(options && options.methodName && options.methodName.includes("subscribe"));
    return function(...args) {
        const [actualArgs, resultCb] = $f2e8ea2596d62a80$var$extractArgs(args, needsCallback);
        return resultCb ? $f2e8ea2596d62a80$var$decorateSubscribe(method, actualArgs, resultCb) : $f2e8ea2596d62a80$var$decorateCall(options?.overrideNoSub || method, actualArgs);
    };
}


class $cb287a4c0605e587$export$70ade524e4d1d39d extends (0, $de37a27a8ad7262e$export$4e7c329e089d8cc5) {
    /**
     * @description Creates an instance of the ApiPromise class
     * @param options Options to create an instance. This can be either [[ApiOptions]] or
     * an [[WsProvider]].
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * new Api().isReady.then((api) => {
     *   api.rpc.subscribeNewHeads((header) => {
     *     console.log(`new block #${header.number.toNumber()}`);
     *   });
     * });
     * ```
     */ constructor(options){
        super(options, "promise", (0, $f2e8ea2596d62a80$export$8f7aa4d6db73a0e9));
        this.__internal__isReadyPromise = new Promise((resolve)=>{
            super.once("ready", ()=>resolve(this));
        });
        this.__internal__isReadyOrErrorPromise = new Promise((resolve, reject)=>{
            const tracker = (0, $f2e8ea2596d62a80$export$670d5117ed9f70b3)(resolve, reject);
            super.once("ready", ()=>tracker.resolve(this));
            super.once("error", (error)=>tracker.reject(error));
        });
    }
    /**
     * @description Creates an ApiPromise instance using the supplied provider. Returns an Promise containing the actual Api instance.
     * @param options options that is passed to the class contructor. Can be either [[ApiOptions]] or a
     * provider (see the constructor arguments)
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * Api.create().then(async (api) => {
     *   const timestamp = await api.query.timestamp.now();
     *
     *   console.log(`lastest block timestamp ${timestamp}`);
     * });
     * ```
     */ static create(options) {
        const instance = new $cb287a4c0605e587$export$70ade524e4d1d39d(options);
        if (options && options.throwOnConnect) return instance.isReadyOrError;
        // Swallow any rejections on isReadyOrError
        // (in Node 15.x this creates issues, when not being looked at)
        instance.isReadyOrError.catch(()=>{
        // ignore
        });
        return instance.isReady;
    }
    /**
     * @description Promise that resolves the first time we are connected and loaded
     */ get isReady() {
        return this.__internal__isReadyPromise;
    }
    /**
     * @description Promise that resolves if we can connect, or reject if there is an error
     */ get isReadyOrError() {
        return this.__internal__isReadyOrErrorPromise;
    }
    /**
     * @description Returns a clone of this ApiPromise instance (new underlying provider connection)
     */ clone() {
        return new $cb287a4c0605e587$export$70ade524e4d1d39d((0, $0dc68258eafd8717$export$5e8a1629c9c35a19)({}, this._options, {
            source: this
        }));
    }
    /**
     * @description Creates a combinator that can be used to combine the latest results from multiple subscriptions
     * @param fns An array of function to combine, each in the form of `(cb: (value: void)) => void`
     * @param callback A callback that will return an Array of all the values this combinator has been applied to
     * @example
     * <BR>
     *
     * ```javascript
     * const address = '5DTestUPts3kjeXSTMyerHihn1uwMfLj8vU8sqF7qYrFacT7';
     *
     * // combines values from balance & nonce as it updates
     * api.combineLatest([
     *   api.rpc.chain.subscribeNewHeads,
     *   (cb) => api.query.system.account(address, cb)
     * ], ([head, [balance, nonce]]) => {
     *   console.log(`#${head.number}: You have ${balance.free} units, with ${nonce} transactions sent`);
     * });
     * ```
     */ // eslint-disable-next-line @typescript-eslint/require-await
    async combineLatest(fns, callback) {
        const combinator = new (0, $4a78dda700e04001$export$3cbfd7ee92c4e2ca)(fns, callback);
        return ()=>{
            combinator.unsubscribe();
        };
    }
}






function $fc10b12b1b3c0f3a$export$5b2dafa06c83924(a, b) {
    return (0, $06bddcb0a8413ca0$export$17581a7c6e2ec978)((0, $75dfbb1cb93569bf$export$63e61a72b498228b)(a), (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(b));
}



var $hWfed = parcelRequire("hWfed");

const $526c1cdc475b977f$var$DEFAULT_OPTIONS = {
    noInitWarn: true,
    throwOnConnect: false
};
function $526c1cdc475b977f$export$5658a6aad1bab68e(options) {
    return (0, $cb287a4c0605e587$export$70ade524e4d1d39d).create({
        ...$526c1cdc475b977f$var$DEFAULT_OPTIONS,
        ...options
    });
}
function $526c1cdc475b977f$export$63bcd1f4e5acb361(api, calls) {
    return api.tx.utility.batchAll([
        ...calls
    ]);
}
async function $526c1cdc475b977f$export$c52e4b551c4ab930(address, options, extrinsic, callback) {
    const unsub = await extrinsic.signAndSend(address, options, (callResult)=>{
        callback(callResult, unsub);
    });
}
function $526c1cdc475b977f$export$8cc545829c7461b0(api, dispatchError) {
    if (dispatchError.isModule) {
        // for module errors, we have the section indexed, lookup
        const decoded = api.registry.findMetaError(dispatchError.asModule);
        const { docs: docs, name: name, section: section } = decoded;
        return `${section}.${name}: ${docs.join(" ")}`;
    } else // Other, CannotLookup, BadOrigin, no extra info
    return dispatchError.toString();
}
async function $526c1cdc475b977f$export$f9a8254a7f017ec(tx, sender) {
    const { partialFee: partialFee } = await tx.paymentInfo(sender);
    // 'partialFee' is the total fee minus eventual tip
    // Use some margin to be extra safe (strategy copied from https://github.com/polkadot-js/apps/blob/master/packages/page-accounts/src/modals/Transfer.tsx#L65)
    // Also see https://polkadot.js.org/docs/api/start/api.tx.subs/#payment-information
    // and https://wiki.polkadot.network/docs/build-node-interaction#fetching-a-block
    return partialFee.muln(110).div((0, $031d4cf4355dbeac$export$6691a839db0e7399));
}
function $526c1cdc475b977f$export$4c62941f84ce88(balance, delegateSelectedFee, undelegateAllFee) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hWfed))).max(balance.sub(delegateSelectedFee.add(undelegateAllFee.muln(200).divn(100))), new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0));
}
function $526c1cdc475b977f$export$cc3bc0b518c1c6b8(input, decimals, unit) {
    return `${(0, $b3e30afb943da5cc$export$cc3bc0b518c1c6b8)(input, {
        decimals: decimals,
        withUnit: unit,
        forceUnit: "Unit",
        withSi: false
    })} ${unit}`;
}
function $526c1cdc475b977f$export$121bfd3c744d638e(conviction) {
    switch(conviction){
        case (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).None:
            return "No conviction";
        default:
            return conviction.toString();
    }
}
function $526c1cdc475b977f$export$4c8c026bbd58385(account) {
    return !!account?.type && [
        "ed25519",
        "sr25519"
    ].includes(account.type);
}
function $526c1cdc475b977f$export$fa91a32fb7d0a473(account, chainGenesisHash) {
    return !account.genesisHash || !chainGenesisHash || account.genesisHash === chainGenesisHash;
}
function $526c1cdc475b977f$export$1987372119294ebb(address) {
    try {
        (0, $c22d2e6736a2594b$export$b149ba8ff44e4e70)((0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(address) ? (0, $c70fb13b09c6b2c8$export$fbca403d18cdd700)(address) : (0, $75dfbb1cb93569bf$export$63e61a72b498228b)(address));
        return true;
    } catch (error) {
        return false;
    }
}
function $526c1cdc475b977f$export$1a5871317500f667(addr1, addr2) {
    return $526c1cdc475b977f$export$1987372119294ebb(addr1) && $526c1cdc475b977f$export$1987372119294ebb(addr2) && (0, $fc10b12b1b3c0f3a$export$5b2dafa06c83924)(addr1, addr2);
}


function $86de7a8a6ebe9447$export$37eefdad5758e42(aye, conviction = (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).None, balance = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0)) {
    return {
        type: "standard",
        vote: {
            aye: aye,
            conviction: conviction
        },
        balance: balance
    };
}
function $86de7a8a6ebe9447$export$390edb77df1bcd07(balance, target, conviction, delegations = {
    votes: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0),
    capital: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0)
}, prior = {
    balance: new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(0),
    block: 0
}) {
    return {
        type: "delegating",
        balance: balance,
        target: target,
        conviction: conviction,
        delegations: delegations,
        prior: prior
    };
}
function $86de7a8a6ebe9447$var$toConviction(o) {
    if (o.isNone) return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).None;
    else if (o.isLocked1x) return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).Locked1x;
    else if (o.isLocked2x) return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).Locked2x;
    else if (o.isLocked3x) return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).Locked3x;
    else if (o.isLocked4x) return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).Locked4x;
    else if (o.isLocked5x) return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).Locked5x;
    else return (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).Locked6x;
}
function $86de7a8a6ebe9447$export$4651a17750e10a5d(o) {
    if (o.isStandard) {
        const standard = o.asStandard;
        return {
            type: "standard",
            vote: {
                aye: standard.vote.isAye,
                conviction: $86de7a8a6ebe9447$var$toConviction(standard.vote.conviction)
            },
            balance: standard.balance
        };
    } else if (o.isSplit) {
        const split = o.asSplit;
        return {
            type: "split",
            aye: split.aye,
            nay: split.nay
        };
    } else {
        const splitAbstain = o.asSplitAbstain;
        return {
            type: "splitAbstain",
            aye: splitAbstain.aye,
            nay: splitAbstain.nay,
            abstain: splitAbstain.abstain
        };
    }
}
function $86de7a8a6ebe9447$var$toVoting(o) {
    if (o.isCasting) {
        const casting = o.asCasting;
        return {
            type: "casting",
            votes: new Map(casting.votes.map((o)=>[
                    o[0].toNumber(),
                    $86de7a8a6ebe9447$export$4651a17750e10a5d(o[1])
                ])),
            delegations: casting.delegations,
            prior: {
                block: casting.prior[0].toNumber(),
                balance: casting.prior[1].toBn()
            }
        };
    } else if (o.isDelegating) {
        const delegating = o.asDelegating;
        return {
            type: "delegating",
            delegations: delegating.delegations,
            balance: delegating.balance,
            target: delegating.target.toString(),
            conviction: $86de7a8a6ebe9447$var$toConviction(delegating.conviction),
            prior: {
                block: delegating.prior[0].toNumber(),
                balance: delegating.prior[1].toBn()
            }
        };
    } else return {
        type: "unknown"
    };
}
function $86de7a8a6ebe9447$var$toVotings(votings) {
    return new Map(votings.map((o)=>[
            o[0].args[1].toNumber(),
            $86de7a8a6ebe9447$var$toVoting(o[1])
        ]));
}
async function $86de7a8a6ebe9447$export$7ae783ef9d681616(api, address) {
    return $86de7a8a6ebe9447$var$toVotings(await api.query.convictionVoting.votingFor.entries(address));
}
function $86de7a8a6ebe9447$var$toAllVotings(votings) {
    return new Map(votings.map((o)=>[
            [
                o[0].args[0].toString(),
                o[0].args[1].toNumber()
            ],
            $86de7a8a6ebe9447$var$toVoting(o[1])
        ]));
}
async function $86de7a8a6ebe9447$export$a26249ac3c486966(api) {
    return $86de7a8a6ebe9447$var$toAllVotings(await api.query.convictionVoting.votingFor.entries());
}
function $86de7a8a6ebe9447$var$fromAccountVote(accountVote) {
    if (accountVote.type === "standard") {
        const vote = accountVote.vote;
        return {
            Standard: {
                vote: {
                    conviction: vote.conviction,
                    aye: vote.aye
                },
                balance: accountVote.balance
            }
        };
    } else if (accountVote.type === "split") return {
        Split: {
            aye: accountVote.aye,
            nay: accountVote.nay
        }
    };
    else return {
        SplitAbstain: {
            aye: accountVote.aye,
            nay: accountVote.nay,
            abstain: accountVote.abstain
        }
    };
}
function $86de7a8a6ebe9447$export$eef0a990000408da(api, index, accountVote) {
    return api.tx.convictionVoting.vote(index, $86de7a8a6ebe9447$var$fromAccountVote(accountVote));
}
function $86de7a8a6ebe9447$export$6b7aa4382abc88e8(api, trackIndex, index) {
    return api.tx.convictionVoting.removeVote(trackIndex, index);
}
function $86de7a8a6ebe9447$export$c2a057552da9428d(api, accountVotes) {
    const txs = [
        ...accountVotes
    ].map(([index, accountVote])=>$86de7a8a6ebe9447$export$eef0a990000408da(api, index, accountVote));
    return (0, $526c1cdc475b977f$export$63bcd1f4e5acb361)(api, txs);
}
function $86de7a8a6ebe9447$export$10b1921597150314(api, track, to, conviction, balance) {
    return api.tx.convictionVoting.delegate(track, to, conviction, balance);
}
function $86de7a8a6ebe9447$export$faa99c1921d524fd(api, track) {
    return api.tx.convictionVoting.undelegate(track);
}
function $86de7a8a6ebe9447$export$eccddd504975e05d(api, track, target) {
    return api.tx.convictionVoting.unlock(track, target);
}


function $76d8c760bbd55ec9$var$toReferendumSubmitted(referendum) {
    return {
        submitted: referendum[0],
        submissionDeposit: referendum[1],
        decisionDeposit: referendum[2].unwrapOr(null)
    };
}
function $76d8c760bbd55ec9$var$toCall(o) {
    try {
        const lookup = o.asLookup;
        return {
            hash: lookup.hash.toString(),
            len: lookup.len.toNumber()
        };
    } catch  {
        return {
            hash: "",
            len: 0
        };
    }
}
function $76d8c760bbd55ec9$var$toScheduledWakeUp(o) {
    return {
        when: o[0].toNumber()
    };
}
function $76d8c760bbd55ec9$var$toDeposit(o) {
    return {
        who: o.who.toString(),
        amount: o.amount.toBn()
    };
}
function $76d8c760bbd55ec9$var$toDispatchTime(o) {
    if (o.isAfter) {
        const after = o.asAfter;
        return {
            after: after.toNumber()
        };
    } else {
        const at = o.asAt;
        return {
            at: at.toNumber()
        };
    }
}
function $76d8c760bbd55ec9$var$toReferendum(o) {
    if (o.isOngoing) {
        const ongoing = o.asOngoing;
        const deciding = ongoing.deciding.unwrapOr(undefined);
        const decisionDeposit = ongoing.decisionDeposit.unwrapOr(undefined);
        const alarm = ongoing.alarm.unwrapOr(undefined);
        return {
            type: "ongoing",
            trackIndex: ongoing.track.toNumber(),
            proposal: $76d8c760bbd55ec9$var$toCall(ongoing.proposal),
            enactment: $76d8c760bbd55ec9$var$toDispatchTime(ongoing.enactment),
            inQueue: ongoing.inQueue.toPrimitive(),
            deciding: deciding ? {
                since: deciding.since.toNumber(),
                confirming: deciding.confirming.unwrapOr(undefined)?.toNumber()
            } : undefined,
            tally: ongoing.tally,
            submitted: ongoing.submitted.toNumber(),
            submissionDeposit: $76d8c760bbd55ec9$var$toDeposit(ongoing.submissionDeposit),
            decisionDeposit: decisionDeposit ? $76d8c760bbd55ec9$var$toDeposit(decisionDeposit) : undefined,
            alarm: alarm ? $76d8c760bbd55ec9$var$toScheduledWakeUp(alarm) : undefined
        };
    } else if (o.isApproved) {
        const approved = o.asApproved;
        return {
            type: "approved",
            ...$76d8c760bbd55ec9$var$toReferendumSubmitted(approved)
        };
    } else if (o.isRejected) {
        const rejected = o.asRejected;
        return {
            type: "rejected",
            ...$76d8c760bbd55ec9$var$toReferendumSubmitted(rejected)
        };
    } else if (o.isCancelled) {
        const cancelled = o.asCancelled;
        return {
            type: "cancelled",
            ...$76d8c760bbd55ec9$var$toReferendumSubmitted(cancelled)
        };
    } else if (o.isTimedOut) {
        const timedout = o.asTimedOut;
        return {
            type: "timedout",
            ...$76d8c760bbd55ec9$var$toReferendumSubmitted(timedout)
        };
    } else if (o.isKilled) {
        const killed = o.asKilled;
        return {
            type: "killed",
            submitted: killed.toNumber()
        };
    } else return {
        type: "unknown"
    };
}
function $76d8c760bbd55ec9$var$toReferenda(referenda) {
    return new Map(referenda.map((o)=>{
        const key = o[0].args[0].toNumber();
        return [
            key,
            $76d8c760bbd55ec9$var$toReferendum(o[1].unwrapOrDefault())
        ];
    }));
}
async function $76d8c760bbd55ec9$export$78d8ecacf64ccf30(api) {
    return $76d8c760bbd55ec9$var$toReferenda(await api.query.referenda.referendumInfoFor.entries());
}
function $76d8c760bbd55ec9$var$toCurve(codec) {
    if (codec.isLinearDecreasing) {
        const linearDecreasing = codec.asLinearDecreasing;
        return {
            type: "LinearDecreasing",
            length: linearDecreasing.length,
            floor: linearDecreasing.floor,
            ceil: linearDecreasing.ceil
        };
    } else if (codec.isSteppedDecreasing) {
        const steppedDecreasing = codec.asSteppedDecreasing;
        return {
            type: "SteppedDecreasing",
            begin: steppedDecreasing.begin,
            end: steppedDecreasing.end,
            step: steppedDecreasing.step,
            period: steppedDecreasing.period
        };
    } else {
        const reciprocal = codec.asReciprocal;
        return {
            type: "Reciprocal",
            factor: reciprocal.factor,
            xOffset: reciprocal.xOffset,
            yOffset: reciprocal.yOffset
        };
    }
}
function $76d8c760bbd55ec9$var$toTrack(trackInfo) {
    return {
        name: trackInfo.name.toString(),
        maxDeciding: trackInfo.maxDeciding.toNumber(),
        decisionDeposit: trackInfo.decisionDeposit.toBn(),
        preparePeriod: trackInfo.preparePeriod.toNumber(),
        decisionPeriod: trackInfo.decisionPeriod.toNumber(),
        confirmPeriod: trackInfo.confirmPeriod.toNumber(),
        minEnactmentPeriod: trackInfo.minEnactmentPeriod.toNumber(),
        minApproval: $76d8c760bbd55ec9$var$toCurve(trackInfo.minApproval),
        minSupport: $76d8c760bbd55ec9$var$toCurve(trackInfo.minSupport)
    };
}
function $76d8c760bbd55ec9$var$toTracks(tracks) {
    return new Map(tracks?.map((o)=>[
            o[0].toNumber(),
            $76d8c760bbd55ec9$var$toTrack(o[1])
        ]));
}
function $76d8c760bbd55ec9$export$71538f1fdeb2b290(api) {
    return $76d8c760bbd55ec9$var$toTracks(api.consts.referenda.tracks);
}



var $hWfed = parcelRequire("hWfed");
function $5bf901c388a26365$export$a200d878f7ec02ec(options) {
    return (mul, value)=>{
        // We lose the decimals here... depending on chain config, this could be non-optimal
        // (A simple formatBalance(value.muln(mul), FMT_OPTS) formats to 4 decimals)
        return `${(0, $b3e30afb943da5cc$export$cc3bc0b518c1c6b8)(value.muln(mul), options).split(".")[0]} ${options.withUnit}`;
    };
}
// hardcoded here since this is static (hopefully no re-denomination anytime...)
const $5bf901c388a26365$var$formatSpend = $5bf901c388a26365$export$a200d878f7ec02ec({
    decimals: 12,
    forceUnit: "-",
    withSi: true,
    withUnit: "KSM"
});
// https://github.com/paritytech/polkadot/blob/6e3f2c5b4b6e6927915de2f784e1d831717760fa/runtime/kusama/constants/src/lib.rs#L28-L32
const $5bf901c388a26365$var$UNITS = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(1000000000000);
const $5bf901c388a26365$var$QUID = $5bf901c388a26365$var$UNITS.divn(30);
const $5bf901c388a26365$var$GRAND = $5bf901c388a26365$var$QUID.muln(1000);
// https://github.com/paritytech/polkadot/blob/6e3f2c5b4b6e6927915de2f784e1d831717760fa/runtime/kusama/src/governance/origins.rs#L170-L179
const $5bf901c388a26365$var$SPEND_LIMITS = {
    BigSpender: $5bf901c388a26365$var$formatSpend(1000, $5bf901c388a26365$var$GRAND),
    BigTipper: $5bf901c388a26365$var$formatSpend(1, $5bf901c388a26365$var$GRAND),
    MediumSpender: $5bf901c388a26365$var$formatSpend(100, $5bf901c388a26365$var$GRAND),
    SmallSpender: $5bf901c388a26365$var$formatSpend(10, $5bf901c388a26365$var$GRAND),
    SmallTipper: $5bf901c388a26365$var$formatSpend(250, $5bf901c388a26365$var$QUID),
    Treasurer: $5bf901c388a26365$var$formatSpend(10000, $5bf901c388a26365$var$GRAND)
};
const $5bf901c388a26365$export$c42c4b43e6ce031e = [
    {
        title: "Admin",
        tracks: [
            {
                id: 0,
                title: "Root",
                description: "Origin for upgrades, fixes, and network rescues"
            },
            {
                id: 15,
                title: "Auction Admin",
                description: "Origin for starting auctions"
            }
        ]
    },
    {
        title: "Governance",
        tracks: [
            {
                id: 12,
                title: "Lease Admin",
                description: "Origin able to force slot leases"
            },
            {
                id: 14,
                title: "General Admin",
                description: "Origin for managing the registrar"
            },
            {
                id: 20,
                title: "Referendum Canceler",
                description: "Origin able to cancel referenda"
            },
            {
                id: 21,
                title: "Referendum Killer",
                description: "Origin able to kill referenda"
            },
            {
                id: 10,
                title: "Staking Admin",
                description: "Origin for canceling slashes"
            }
        ]
    },
    {
        title: "Treasury",
        tracks: [
            {
                id: 30,
                title: "Small Tipper",
                description: `Origin able to spend up to ${$5bf901c388a26365$var$SPEND_LIMITS.SmallTipper} from the treasury at once`
            },
            {
                id: 31,
                title: "Big Tipper",
                description: `Origin able to spend up to ${$5bf901c388a26365$var$SPEND_LIMITS.BigTipper} from the treasury at once`
            },
            {
                id: 32,
                title: "Small Spender",
                description: `Origin able to spend up to ${$5bf901c388a26365$var$SPEND_LIMITS.SmallSpender} from the treasury at once`
            },
            {
                id: 33,
                title: "Medium Spender",
                description: `Origin able to spend up to ${$5bf901c388a26365$var$SPEND_LIMITS.MediumSpender} from the treasury at once`
            },
            {
                id: 34,
                title: "Big Spender",
                description: `Origin able to spend up to ${$5bf901c388a26365$var$SPEND_LIMITS.BigSpender} from the treasury at once`
            },
            {
                id: 11,
                title: "Treasurer",
                description: `Origin for spending (any amount of) funds until the upper limit of ${$5bf901c388a26365$var$SPEND_LIMITS.Treasurer}`
            }
        ]
    },
    {
        title: "Fellowship",
        tracks: [
            {
                id: 1,
                title: "Whitelisted Caller",
                description: "Origin commanded by members of the Kusama Fellowship"
            },
            {
                id: 13,
                title: "Fellowship Admin",
                description: "Origin for managing the composition of the fellowship"
            }
        ]
    }
];



var $hWfed = parcelRequire("hWfed");
function $1639d8731450fd05$export$a200d878f7ec02ec(options) {
    return (mul, value)=>{
        // We lose the decimals here... depending on chain config, this could be non-optimal
        // (A simple formatBalance(value.muln(mul), FMT_OPTS) formats to 4 decimals)
        return `${(0, $b3e30afb943da5cc$export$cc3bc0b518c1c6b8)(value.muln(mul), options).split(".")[0]} ${options.withUnit}`;
    };
}
// hardcoded here since this is static (hopefully no re-denomination anytime...)
const $1639d8731450fd05$var$formatSpend = $1639d8731450fd05$export$a200d878f7ec02ec({
    decimals: 10,
    forceUnit: "-",
    withSi: true,
    withUnit: "DOT"
});
// https://github.com/paritytech/polkadot/blob/6e3f2c5b4b6e6927915de2f784e1d831717760fa/runtime/kusama/constants/src/lib.rs#L28-L32
const $1639d8731450fd05$var$UNITS = new (0, (/*@__PURE__*/$parcel$interopDefault($hWfed)))(10000000000);
const $1639d8731450fd05$var$DOLLARS = $1639d8731450fd05$var$UNITS;
const $1639d8731450fd05$var$GRAND = $1639d8731450fd05$var$DOLLARS.muln(1000);
// https://github.com/paritytech/polkadot/blob/6e3f2c5b4b6e6927915de2f784e1d831717760fa/runtime/kusama/src/governance/origins.rs#L170-L179
const $1639d8731450fd05$var$SPEND_LIMITS = {
    BigSpender: $1639d8731450fd05$var$formatSpend(1000, $1639d8731450fd05$var$GRAND),
    BigTipper: $1639d8731450fd05$var$formatSpend(1, $1639d8731450fd05$var$GRAND),
    MediumSpender: $1639d8731450fd05$var$formatSpend(100, $1639d8731450fd05$var$GRAND),
    SmallSpender: $1639d8731450fd05$var$formatSpend(10, $1639d8731450fd05$var$GRAND),
    SmallTipper: $1639d8731450fd05$var$formatSpend(250, $1639d8731450fd05$var$DOLLARS),
    Treasurer: $1639d8731450fd05$var$formatSpend(10000, $1639d8731450fd05$var$GRAND)
};
const $1639d8731450fd05$export$c42c4b43e6ce031e = [
    {
        title: "Admin",
        tracks: [
            {
                id: 0,
                title: "Root",
                description: "Origin for upgrades, fixes, and network rescues"
            },
            {
                id: 15,
                title: "Auction Admin",
                description: "Origin for starting auctions"
            }
        ]
    },
    {
        title: "Governance",
        tracks: [
            {
                id: 12,
                title: "Lease Admin",
                description: "Origin able to force slot leases"
            },
            {
                id: 14,
                title: "General Admin",
                description: "Origin for managing the registrar"
            },
            {
                id: 20,
                title: "Referendum Canceler",
                description: "Origin able to cancel referenda"
            },
            {
                id: 21,
                title: "Referendum Killer",
                description: "Origin able to kill referenda"
            },
            {
                id: 10,
                title: "Staking Admin",
                description: "Origin for canceling slashes"
            }
        ]
    },
    {
        title: "Treasury",
        tracks: [
            {
                id: 30,
                title: "Small Tipper",
                description: `Origin able to spend up to ${$1639d8731450fd05$var$SPEND_LIMITS.SmallTipper} from the treasury at once`
            },
            {
                id: 31,
                title: "Big Tipper",
                description: `Origin able to spend up to ${$1639d8731450fd05$var$SPEND_LIMITS.BigTipper} from the treasury at once`
            },
            {
                id: 32,
                title: "Small Spender",
                description: `Origin able to spend up to ${$1639d8731450fd05$var$SPEND_LIMITS.SmallSpender} from the treasury at once`
            },
            {
                id: 33,
                title: "Medium Spender",
                description: `Origin able to spend up to ${$1639d8731450fd05$var$SPEND_LIMITS.MediumSpender} from the treasury at once`
            },
            {
                id: 34,
                title: "Big Spender",
                description: `Origin able to spend up to ${$1639d8731450fd05$var$SPEND_LIMITS.BigSpender} from the treasury at once`
            },
            {
                id: 11,
                title: "Treasurer",
                description: `Origin for spending (any amount of) funds until the upper limit of ${$1639d8731450fd05$var$SPEND_LIMITS.Treasurer}`
            }
        ]
    },
    {
        title: "Fellowship",
        tracks: [
            {
                id: 1,
                title: "Whitelisted Caller",
                description: "Origin commanded by members of the Polkadot Fellowship"
            },
            {
                id: 13,
                title: "Fellowship Admin",
                description: "Origin for managing the composition of the fellowship"
            }
        ]
    }
];


function $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49(value) {
    return {
        type: "ok",
        value: value
    };
}
function $4453e73b8fa7c4de$export$8048b892d651b310(error) {
    return {
        type: "err",
        error: error
    };
}


function $aa0d921ca162e481$export$d07f57595c356899(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}


var $d1a50225a354c5e4$export$95be4ae94445245a;
(function(Network) {
    Network["Kusama"] = "Kusama";
    Network["Polkadot"] = "Polkadot";
})($d1a50225a354c5e4$export$95be4ae94445245a || ($d1a50225a354c5e4$export$95be4ae94445245a = {}));
function $d1a50225a354c5e4$export$e5a12ad88a46d660() {
    const env = undefined;
    if (env) return (0, $aa0d921ca162e481$export$d07f57595c356899)(env);
    return $d1a50225a354c5e4$export$95be4ae94445245a.Polkadot;
}
function $d1a50225a354c5e4$export$98e6a39c04603d36(s) {
    const network = (0, $aa0d921ca162e481$export$d07f57595c356899)(s);
    return network ? (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(network) : (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(`Unrecognized network ${s}`));
}
function $d1a50225a354c5e4$export$4c880d918d249638(api) {
    return api.runtimeChain.toHuman();
}
function $d1a50225a354c5e4$export$6a3d7965cc7ead4c(network) {
    switch(network){
        case $d1a50225a354c5e4$export$95be4ae94445245a.Kusama:
            return [
                //'wss://1rpc.io/ksm'
                //'wss://kusama-public-rpc.blockops.network/ws'
                //'wss://kusama-rpc.dwellir.com'
                //'wss://rpc-kusama.luckyfriday.io'
                //'wss://kusama-rpc.polkadot.io',
                "wss://apps-kusama-rpc.polkadot.io"
            ];
        case $d1a50225a354c5e4$export$95be4ae94445245a.Polkadot:
            return [
                "wss://apps-rpc.polkadot.io"
            ];
    }
}



function $8b449846a5d6a52a$var$isDestroyable(o) {
    return o.destroy !== undefined;
}
function $8b449846a5d6a52a$var$isEvictable(o) {
    return o.onEvict !== undefined;
}
class $8b449846a5d6a52a$export$94affb487e701bf2 {
    ctor;
    #instances;
    #ctor;
    constructor(ctor){
        this.ctor = ctor;
        this.#instances = new Map();
        this.#ctor = ctor;
    }
    /**
   * An `Array<U>` of all currently cached keys.
   */ get keys() {
        return Array.from(this.#instances.keys());
    }
    /**
   * @param args
   * @returns a cached T if exists, a newly create one otherwise
   */ async getOrCreate(args) {
        const existingInstance = this.#instances.get(args);
        if (existingInstance) return existingInstance;
        else {
            const instance = new this.#ctor(args);
            const ready = await instance.ready;
            if ($8b449846a5d6a52a$var$isEvictable(ready)) ready.onEvict(()=>this.evict(args));
            this.#instances.set(args, ready);
            return ready;
        }
    }
    /**
   * Evict an instance keyed bi `args`. Handles `Destroyable`.
   * @param args
   * @returns
   */ async evict(args) {
        const instance = this.#instances.get(args);
        if (instance) {
            this.#instances.delete(args);
            if ($8b449846a5d6a52a$var$isDestroyable(instance)) await instance.destroy();
            return instance;
        }
        return null;
    }
    /**
   * Evict all instances.  Handles `Destroyable`.
   * @returns
   */ async evictAll() {
        return Promise.all(this.keys.map(this.evict.bind(this)));
    }
}



const $98868944f5761e7c$export$2e9c3ba0607097b8 = "chain";
const $98868944f5761e7c$export$1f80f7f9f3a665bb = "customDelegates";
const $98868944f5761e7c$export$6a9022b4c5fcea02 = 3;
const $98868944f5761e7c$export$b8de75f2fd4fbd02 = [
    {
        name: $98868944f5761e7c$export$2e9c3ba0607097b8
    },
    {
        name: $98868944f5761e7c$export$1f80f7f9f3a665bb
    }
];
const $98868944f5761e7c$var$BASE_DB_NAME = "polkadot/governance";
function $98868944f5761e7c$export$61b0b2f27286444c(network) {
    return `${$98868944f5761e7c$var$BASE_DB_NAME}/${network.toString()}`;
}
async function $98868944f5761e7c$export$c762badf122ac9fd() {
    const databases = await indexedDB.databases();
    const names = databases.filter((database)=>database.name?.startsWith($98868944f5761e7c$var$BASE_DB_NAME)).map((database)=>database.name);
    return names.map((s)=>(0, $d1a50225a354c5e4$export$98e6a39c04603d36)(s)).filter((network)=>network.type == "ok").map((network)=>network.value);
}



function $8c286b8fd86085ed$var$extractObjectStoreIndex(name, store) {
    const index = store.index(name);
    return {
        name: name,
        keyPath: index.keyPath
    };
}
function $8c286b8fd86085ed$var$extractIndexes(store) {
    if (store.indexNames.length > 0) return new Array(...store.indexNames).map((name)=>$8c286b8fd86085ed$var$extractObjectStoreIndex(name, store));
}
function $8c286b8fd86085ed$var$extractOptions(store) {
    const defaultAutoIncrement = store.autoIncrement ? {
        autoIncrement: store.autoIncrement
    } : null;
    const defaultKeyPath = store.keyPath ? {
        keyPath: store.keyPath
    } : null;
    if (defaultAutoIncrement || defaultKeyPath) return {
        ...defaultAutoIncrement,
        ...defaultKeyPath
    };
}
function $8c286b8fd86085ed$var$extractObjectStore(store) {
    const indexes = $8c286b8fd86085ed$var$extractIndexes(store);
    const defaultIndexes = indexes ? {
        indexes: indexes
    } : null;
    const options = $8c286b8fd86085ed$var$extractOptions(store);
    const defaultOptions = options ? {
        options: options
    } : null;
    return {
        name: store.name,
        ...defaultIndexes,
        ...defaultOptions
    };
}
function $8c286b8fd86085ed$var$extractObjectStoresFromDB(dataBase) {
    const storeNames = new Array(...dataBase.objectStoreNames);
    if (storeNames.length > 0) {
        const transaction = dataBase.transaction(storeNames, "readonly");
        return $8c286b8fd86085ed$var$extractObjectStores(storeNames, transaction);
    }
    return [];
}
function $8c286b8fd86085ed$var$extractObjectStores(storeNames, transaction) {
    return storeNames.map((storeName)=>$8c286b8fd86085ed$var$extractObjectStore(transaction.objectStore(storeName)));
}
function $8c286b8fd86085ed$var$createStore(database, { name: name, indexes: indexes, options: options }) {
    const store = database.createObjectStore(name, options);
    if (indexes) indexes.forEach(({ name: name, keyPath: keyPath, options: options })=>{
        store.createIndex(name, keyPath, options);
    });
}
function $8c286b8fd86085ed$var$updateStore(transaction, { name: name, options: options }) {
    const objectStore = transaction.objectStore(name);
    // TODO add support for indexes reconciliation
    if (options) {
        const { autoIncrement: autoIncrement, keyPath: keyPath } = options;
        if (keyPath != objectStore.keyPath) return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(`Unsupported keyPath modification: ${keyPath}`));
        if (autoIncrement != objectStore.autoIncrement) return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(`Unsupported autoIncrement modification: ${autoIncrement}`));
    }
    return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(true);
}
function $8c286b8fd86085ed$var$deleteStore(database, name) {
    database.deleteObjectStore(name);
}
function $8c286b8fd86085ed$var$isSameIndex(index1, index2) {
    return index1.name == index2.name && index1.keyPath == index2.keyPath && index1.options?.multiEntry == index2.options?.multiEntry && index1.options?.unique == index2.options?.unique;
}
function $8c286b8fd86085ed$var$areSameIndexes(indexes1, indexes2) {
    if (indexes1 == null || indexes2 == null) return indexes1 == indexes2;
    if (indexes1.length != indexes2.length) return false;
    const sort = (a, b)=>a.name > b.name ? 1 : a.name == b.name ? 0 : -1;
    const sortedIndexes1 = indexes1.sort(sort);
    const sortedIndexes2 = indexes2.sort(sort);
    return sortedIndexes1.every((o, index)=>$8c286b8fd86085ed$var$isSameIndex(o, sortedIndexes2[index]));
}
function $8c286b8fd86085ed$var$isSameStore(store1, store2) {
    return store1.name == store2.name && $8c286b8fd86085ed$var$areSameIndexes(store1.indexes, store2.indexes) && store1.options?.autoIncrement == store2.options?.autoIncrement && store1.options?.keyPath == store2.options?.keyPath;
}
function $8c286b8fd86085ed$var$areSameStores(stores1, stores2) {
    if (stores1.length != stores2.length) return false;
    const sort = (a, b)=>a.name > b.name ? 1 : a.name == b.name ? 0 : -1;
    const sortedStores1 = stores1.sort(sort);
    const sortedStores2 = stores2.sort(sort);
    return sortedStores1.every((o, index)=>$8c286b8fd86085ed$var$isSameStore(o, sortedStores2[index]));
}
async function $8c286b8fd86085ed$export$3ce6949f20cea765(name, stores, version, options = {}) {
    const request = indexedDB.open(name, version);
    // Fail if no matching stores
    return new Promise((resolve, reject)=>{
        const { onBlocked: onBlocked, onUpgradeNeeded: onUpgradeNeeded } = options;
        if (onBlocked) // DB needs to be updated but is locked, eventually in another tab
        request.onblocked = onBlocked;
        if (stores.length > 0 || onUpgradeNeeded) request.onupgradeneeded = (event)=>{
            const transaction = request.transaction;
            if (!transaction) // Can't happen as we are in an upgrade transaction
            return;
            // Will be called before onsuccess, if the transaction version is incremented
            const database = request.result;
            const existingStores = new Map($8c286b8fd86085ed$var$extractObjectStores(new Array(...database.objectStoreNames), transaction).map((store)=>[
                    store.name,
                    store
                ]));
            // 1. Create new stores
            const newStores = stores.filter((store)=>!existingStores.has(store.name));
            newStores.forEach((store)=>{
                $8c286b8fd86085ed$var$createStore(database, store);
            });
            // 2. Updated existing stores with updated definitions
            stores.forEach((store)=>{
                const existingStore = existingStores.get(store.name);
                if (existingStore && store != existingStore) $8c286b8fd86085ed$var$updateStore(transaction, store);
            });
            // 3. Removed now undefined stores
            const removedStores = new Array(...existingStores.values()).filter((existingStore)=>!stores.find((store)=>store.name == existingStore.name));
            removedStores.forEach((store)=>{
                $8c286b8fd86085ed$var$deleteStore(database, store.name);
            });
            if (onUpgradeNeeded) onUpgradeNeeded(event);
        };
        request.onerror = ()=>{
            reject(request.error);
        };
        request.onsuccess = ()=>{
            const database = request.result;
            if (version == database.version && !$8c286b8fd86085ed$var$areSameStores(stores, $8c286b8fd86085ed$var$extractObjectStoresFromDB(database))) reject(new Error(`New store definitions but unchanged version (${version})`));
            resolve(request.result);
        };
    });
}
async function $8c286b8fd86085ed$export$b8064d1c42a6b8(db, storeName) {
    return new Promise(function(resolve, reject) {
        const request = db.transaction(storeName, "readonly").objectStore(storeName).openCursor(null, "prev");
        request.onsuccess = ()=>{
            if (request.result) {
                const { key: key, value: value } = request.result;
                resolve({
                    key: key,
                    value: value
                });
            } else resolve(null);
        };
        request.onerror = reject;
    });
}
async function $8c286b8fd86085ed$export$3988ae62b71be9a3(db, storeName, key) {
    return new Promise(function(resolve, reject) {
        const request = db.transaction(storeName, "readonly").objectStore(storeName).get(key);
        request.onsuccess = ()=>{
            resolve(request.result);
        };
        request.onerror = reject;
    });
}
async function $8c286b8fd86085ed$export$84bf76cd7afc7469(db, storeName) {
    return new Promise((resolve, reject)=>{
        const result = new Map();
        const request = db.transaction(storeName, "readonly").objectStore(storeName).openCursor();
        request.onsuccess = ()=>{
            const cursor = request.result;
            if (cursor) {
                result.set(cursor.primaryKey, cursor.value);
                cursor.continue();
            } else resolve(result);
        };
        request.onerror = reject;
    });
}
async function $8c286b8fd86085ed$export$ade7a30951d0bc54(db, storeName) {
    return new Promise((resolve, reject)=>{
        const result = new Set();
        const request = db.transaction(storeName, "readonly").objectStore(storeName).openKeyCursor();
        request.onsuccess = ()=>{
            const cursor = request.result;
            if (cursor) {
                result.add(cursor.primaryKey);
                cursor.continue();
            } else resolve(result);
        };
        request.onerror = reject;
    });
}
async function $8c286b8fd86085ed$export$a1544dad697b423d(db, storeName, key, value) {
    return new Promise(function(resolve, reject) {
        const request = db.transaction(storeName, "readwrite").objectStore(storeName).put(value, key);
        request.onsuccess = ()=>resolve();
        request.onerror = reject;
    });
}
async function $8c286b8fd86085ed$export$cd7f480d6b8286c3(db, storeName, key) {
    return new Promise(function(resolve, reject) {
        const request = db.transaction(storeName, "readwrite").objectStore(storeName).delete(key);
        request.onsuccess = ()=>resolve();
        request.onerror = reject;
    });
}
async function $8c286b8fd86085ed$export$722a3828c3d5dbae(db, storeName, map) {
    return new Promise(function(resolve, reject) {
        const tx = db.transaction(storeName, "readwrite");
        tx.oncomplete = ()=>resolve();
        tx.onerror = reject;
        const store = tx.objectStore(storeName);
        map.forEach((value, key)=>{
            store.put(value, key);
        });
        tx.commit();
    });
}
async function $8c286b8fd86085ed$export$42ffd38884aecdac(db, storeName) {
    return new Promise(function(resolve, reject) {
        const request = db.transaction(storeName, "readwrite").objectStore(storeName).clear();
        request.onsuccess = ()=>resolve();
        request.onerror = reject;
    });
}


async function $6edf692333e130ac$export$8c1798a4c725d9af(name, callback) {
    $6edf692333e130ac$export$b62aa2130c86b59b(name);
    try {
        return await callback();
    } finally{
        $6edf692333e130ac$export$97a67d1a5c124236(name);
    }
}
function $6edf692333e130ac$export$b62aa2130c86b59b(name) {
    performance.mark(`start:${name}`);
}
function $6edf692333e130ac$export$97a67d1a5c124236(name) {
    const endMark = `end:${name}`;
    performance.mark(endMark);
    performance.measure(name, `start:${name}`, endMark);
}



function $d09b2bd67ed552e2$export$f3db5e8fd0cb70b3(search, params) {
    const searchParams = new URLSearchParams(search);
    return params.map((param)=>searchParams.get(param));
}


const $7b9c103ea16b33ae$export$2a95c2268ac2504b = (connectivity)=>{
    const { type: type } = connectivity;
    return type == "Connected" || type == "Following";
};



async function $a3c71b764e6b1579$export$81bec6e38e8b706b(input, init) {
    return fetch(input, init).then(async (resp)=>{
        if (resp.ok) return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(await resp.json());
        else return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(""));
    }).catch((e)=>{
        if (e instanceof Error) return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(e);
        else return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(`${e}`));
    });
}


async function $fb4f49e738864135$export$1ad9d52463c4976(network, id) {
    const url = `https://api.polkassembly.io/api/v1/posts/on-chain-post?postId=${id}&proposalType=referendums_v2`;
    return await (0, $a3c71b764e6b1579$export$81bec6e38e8b706b)(url, {
        headers: {
            "x-network": network.toString().toLowerCase()
        }
    });
}



class $196f69ae0c61f20e$export$cb960adff68d0013 extends (0, $e549b920579303d9$export$676472937f48f64) {
    static RETRY_DELAY = 2500;
    static CHECKER_INTERVAL_MS = 5000;
    static PER_REQUEST_TIMEOUT_MS = 15000;
    static MAX_STALL_COUNT = 5;
    statsHistory = new Map();
    #checkerId;
    constructor(endpoints){
        super(endpoints, $196f69ae0c61f20e$export$cb960adff68d0013.RETRY_DELAY, undefined, $196f69ae0c61f20e$export$cb960adff68d0013.PER_REQUEST_TIMEOUT_MS);
        this.#checkerId = setInterval(this.#checker.bind(this), $196f69ae0c61f20e$export$cb960adff68d0013.CHECKER_INTERVAL_MS);
        // Triggered by connect, disconnect or onSocketError
        super.on("error", (e)=>{
            console.debug(`Received error; disonnect from ${this.endpoint}`, e);
            super.disconnect.apply(this);
        });
        super.on("connected", ()=>{
            console.debug(`Connected to ${this.endpoint}`);
        });
        super.on("disconnected", ()=>{
            console.debug(`Disonnected from  ${this.endpoint}`);
        });
    }
    #checker() {
        try {
            if (!super.isConnected) {
                console.debug(`Not connected, connect to ${this.endpoint}`);
                super.connect();
            }
        } catch (e) {
            console.debug("Failed to connect", e);
        }
        const { bytesRecv: bytesRecv, errors: errors, timeout: timeout } = super.stats.total;
        const previousStats = this.statsHistory.get(super.endpoint);
        const stalled = previousStats?.bytesRecv == bytesRecv;
        const newStallCount = stalled ? (previousStats?.stallCount || 0) + 1 : 0;
        this.statsHistory.set(super.endpoint, {
            bytesRecv: bytesRecv,
            errors: errors,
            timeout: timeout,
            stallCount: newStallCount
        });
        if (newStallCount > $196f69ae0c61f20e$export$cb960adff68d0013.MAX_STALL_COUNT) {
            console.debug("No progress, connection is stalled. Disconnect");
            this.statsHistory.delete(super.endpoint); // Clear existing stats
            super.disconnect();
        }
    }
    #clearCheckId() {
        if (this.#checkerId) {
            clearInterval(this.#checkerId);
            this.#checkerId = undefined;
        }
    }
    close() {
        this.#clearCheckId();
    }
}



// Auto follow chain updates? Only if user settings? Show notif? Only if impacting change?
// Revisit if/when ChainState is persisted
// Actions
// TODO
// Heartbeat (to detect no new finalized blocks are reeived, keep track of delta between last received and now)
// Startup
// settings, overriden by Env variable, overriden by query params, overriden by user settings? offer user confirmation
// network, allow to restore chain db
// endpoints, allow to connect to chain
// if no endpoints provided, default to network endpoints
// endpoints and network: must match network
// only endpoints: sets network
function $ff275152c44ce822$var$filterEmptyValues(value) {
    return value[1].length != 0;
}
/**
 * @param votes
 * @param referenda
 * @returns filter away `votes` that do not map to `referenda`
 */ function $ff275152c44ce822$var$filterOldVotes(votes, referenda) {
    const values = Array.from(votes).map(([trackId, votes])=>[
            trackId,
            votes.filter((vote)=>referenda.has(vote))
        ]);
    return new Map(values.filter($ff275152c44ce822$var$filterEmptyValues));
}
function $ff275152c44ce822$var$extractCastingVotes(votings) {
    const castingVotings = Array.from(votings.entries()).filter(([, voting])=>{
        return voting.type === "casting";
    });
    return castingVotings.reduce((acc, [trackId, votings])=>{
        const votes = acc.get(trackId) || [];
        const allVotes = votes.concat(...votings.votes.keys());
        acc.set(trackId, allVotes);
        return acc;
    }, new Map());
}
function $ff275152c44ce822$export$ab19f40c6bc62d4d(allVotings) {
    const delegates = new Map();
    allVotings.forEach((voting, trackId)=>{
        // filter the delegatings.
        if (voting.type === "delegating") delegates.set(trackId, voting);
    });
    return delegates;
}
function $ff275152c44ce822$export$8c9f51735fe4c232(referenda) {
    return new Map([
        ...referenda
    ].filter(([, v])=>v.type == "ongoing"));
}
function $ff275152c44ce822$export$2c79ccda3c7b0ffe(referenda, votes) {
    return new Map([
        ...referenda
    ].filter(([index])=>!votes.has(index)));
}
function $ff275152c44ce822$export$9c0e4d1c0409ad69(state) {
    if (state.type == "ConnectedState") return state.account?.balance;
}
function $ff275152c44ce822$export$d3f593c73a07d922(state) {
    const allVotings = state.type === "ConnectedState" ? state.account?.allVotings : undefined;
    if (allVotings) return $ff275152c44ce822$export$ab19f40c6bc62d4d(allVotings);
    return new Map();
}
function $ff275152c44ce822$export$bf095c2cbab9a226(state) {
    const delegations = $ff275152c44ce822$export$d3f593c73a07d922(state);
    const targetDelegations = new Map();
    const tracks = $ff275152c44ce822$export$60cb0fea1fbc7c9f(state.tracks);
    for (const [trackId, delegation] of delegations.entries()){
        const track = tracks.get(trackId);
        const target = delegation.target;
        targetDelegations.set(target, [
            ...targetDelegations.get(target) || [],
            track
        ]);
    }
    return new Map([
        ...targetDelegations
    ].map(([address, tracks])=>{
        const delegate = state.delegates.find((delegate)=>delegate.address == address) || {
            address: address
        };
        return [
            delegate,
            tracks
        ];
    }));
}
function $ff275152c44ce822$export$338e8628bf39a38a(delegates, address) {
    const delegate = delegates.filter((delegate)=>(0, $526c1cdc475b977f$export$1a5871317500f667)(delegate.address, address))[0];
    return delegate;
}
function $ff275152c44ce822$export$4a6dbf642db5266c(state) {
    if (state.type == "ConnectedState") return {
        decimals: state.chain.properties.tokenDecimals[0],
        unit: state.chain.properties.tokenSymbols[0],
        ss58: state.chain.properties.ss58Format,
        genesisHash: state.chain.properties.genesisHash
    };
}
function $ff275152c44ce822$export$f21bf6b1fa1004ea(state) {
    return !!state?.processingReport;
}
function $ff275152c44ce822$var$error(message) {
    return {
        type: "Error",
        message: message
    };
}
function $ff275152c44ce822$var$incorrectTransitionError(previousState, action) {
    return $ff275152c44ce822$var$error(`Incorrect transition, can't apply ${action.type} to ${previousState.type}`);
}
function $ff275152c44ce822$var$withNewReport(previousState, report) {
    const previousReports = previousState.reports || [];
    return {
        ...previousState,
        reports: [
            report,
            ...previousReports
        ]
    };
}
function $ff275152c44ce822$var$reducer(previousState, action) {
    // Note that unlucky timing might lead to overstepping changes (triggered via listeners registered just above)
    // So applying changes must be indempotent
    switch(action.type){
        case "SetConnectedAddress":
            {
                const { connectedAddress: connectedAddress } = action;
                if (previousState.type == "ConnectedState") return {
                    ...previousState,
                    connectedAddress: connectedAddress,
                    // Clear previous account data
                    account: undefined
                };
                else return {
                    ...previousState,
                    connectedAddress: connectedAddress
                };
            }
        case "SetRestored":
            {
                const { network: network, tracks: tracks, customDelegates: customDelegates } = action;
                return {
                    ...previousState,
                    type: "RestoredState",
                    network: network,
                    tracks: tracks,
                    customDelegates: customDelegates
                };
            }
        case "UpdateConnectivity":
            {
                const { connectivity: connectivity } = action;
                if ("connectivity" in previousState) return {
                    ...previousState,
                    connectivity: connectivity
                };
                else return $ff275152c44ce822$var$withNewReport(previousState, $ff275152c44ce822$var$incorrectTransitionError(previousState, action));
            }
        case "AddVotings":
            if (previousState.type == "ConnectedState") {
                const { balance: balance, allVotings: allVotings } = previousState.account;
                return {
                    ...previousState,
                    account: {
                        balance: balance,
                        allVotings: new Map([
                            ...allVotings,
                            ...action.votings
                        ])
                    }
                };
            } else return $ff275152c44ce822$var$withNewReport(previousState, $ff275152c44ce822$var$incorrectTransitionError(previousState, action));
        case "RemoveVotings":
            if (previousState.type == "ConnectedState") {
                const { balance: balance, allVotings: allVotings } = previousState.account;
                action.trackIds.forEach((trackId)=>allVotings.delete(trackId));
                return {
                    ...previousState,
                    account: {
                        balance: balance,
                        allVotings: allVotings
                    }
                };
            } else return $ff275152c44ce822$var$withNewReport(previousState, $ff275152c44ce822$var$incorrectTransitionError(previousState, action));
        case "AddReport":
            return $ff275152c44ce822$var$withNewReport(previousState, action.report);
        case "RemoveReport":
            {
                const previousReports = previousState.reports || [];
                previousReports.splice(action.index, 1);
                return {
                    ...previousState,
                    reports: [
                        ...previousReports
                    ]
                };
            }
        case "ClearProcessing":
            return {
                ...previousState,
                processingReport: undefined
            };
        case "SetProcessing":
            return {
                ...previousState,
                processingReport: action.report
            };
        case "UpdateChainDetails":
            {
                const { details: details } = action;
                if (previousState.type == "ConnectedState") // Already connected, update connectivity
                // But do not update chain details
                return {
                    ...previousState,
                    chain: previousState.chain
                };
                else if (previousState.type == "RestoredState") // First block received
                return {
                    ...previousState,
                    type: "ConnectedState",
                    chain: details,
                    details: new Map()
                };
                else return $ff275152c44ce822$var$withNewReport(previousState, $ff275152c44ce822$var$incorrectTransitionError(previousState, action));
            }
        case "UpdateChainAccountDetails":
            {
                const { details: details } = action;
                if (previousState.type == "ConnectedState") return {
                    ...previousState,
                    account: details
                };
                else return $ff275152c44ce822$var$withNewReport(previousState, $ff275152c44ce822$var$incorrectTransitionError(previousState, action));
            }
        case "StoreReferendumDetails":
            {
                const { details: details } = action;
                const previousDetails = previousState.details;
                return {
                    ...previousState,
                    details: new Map([
                        ...previousDetails,
                        ...details
                    ])
                };
            }
        case "SetIndexes":
            return {
                ...previousState,
                indexes: action.data
            };
        case "SetDelegates":
            return {
                ...previousState,
                delegates: action.data || []
            };
        case "AddCustomDelegate":
            {
                const customDelegates = previousState.customDelegates;
                customDelegates.push(action.delegate);
                return {
                    ...previousState,
                    ...customDelegates
                };
            }
        case "RemoveCustomDelegate":
            {
                const customDelegates = previousState.customDelegates;
                customDelegates.splice(action.index, 1);
                return {
                    ...previousState,
                    ...customDelegates
                };
            }
    }
}
// Persisted data
async function $ff275152c44ce822$var$restorePersisted(db) {
    const customDelegates = await (0, $8c286b8fd86085ed$export$84bf76cd7afc7469)(db, (0, $98868944f5761e7c$export$1f80f7f9f3a665bb));
    return {
        customDelegates: new Array(...customDelegates.values())
    };
}
function $ff275152c44ce822$var$getProperties(registry) {
    const properties = registry.getChainProperties();
    if (properties) return {
        ss58Format: properties.ss58Format.unwrapOr(undefined)?.toNumber(),
        tokenDecimals: properties.tokenDecimals.unwrapOrDefault().map((s)=>s.toNumber()),
        tokenSymbols: properties.tokenSymbol.unwrapOrDefault().map((s)=>s.toString())
    };
    return {
        tokenDecimals: [],
        tokenSymbols: []
    };
}
async function $ff275152c44ce822$export$f5334432830428cc(api, registry, genesisHash) {
    const tracks = (0, $76d8c760bbd55ec9$export$71538f1fdeb2b290)(api);
    const referenda = await (0, $76d8c760bbd55ec9$export$78d8ecacf64ccf30)(api);
    const properties = {
        genesisHash: genesisHash,
        ...$ff275152c44ce822$var$getProperties(registry)
    };
    return {
        properties: properties,
        tracks: tracks,
        referenda: referenda
    };
}
async function $ff275152c44ce822$export$a48b9da41076292b(api, connectedAddress) {
    const allVotings = await (0, $86de7a8a6ebe9447$export$7ae783ef9d681616)(api, connectedAddress);
    const account = await api.query.system.account(connectedAddress);
    const balance = account.data.free.toBn();
    return {
        allVotings: allVotings,
        balance: balance
    };
}
class $ff275152c44ce822$var$DBReady {
    ready;
    constructor(name){
        this.ready = (0, $8c286b8fd86085ed$export$3ce6949f20cea765)(name, (0, $98868944f5761e7c$export$b8de75f2fd4fbd02), (0, $98868944f5761e7c$export$6a9022b4c5fcea02));
    }
    async destroy() {
        const db = await this.ready;
        db.close();
    }
}
class $ff275152c44ce822$var$ApiReady {
    ready;
    constructor(endpoints){
        this.ready = (0, $6edf692333e130ac$export$8c1798a4c725d9af)("api", async ()=>{
            const api = await (0, $526c1cdc475b977f$export$5658a6aad1bab68e)({
                provider: new (0, $196f69ae0c61f20e$export$cb960adff68d0013)(endpoints)
            });
            return api.isReadyOrError;
        });
    }
    async destroy() {
        const api = await this.ready;
        await api.disconnect();
    }
}
const $ff275152c44ce822$export$7fb7d1ec29bca401 = new (0, $8b449846a5d6a52a$export$94affb487e701bf2)($ff275152c44ce822$var$DBReady);
const $ff275152c44ce822$export$c69bf045a678b870 = new (0, $8b449846a5d6a52a$export$94affb487e701bf2)($ff275152c44ce822$var$ApiReady);
class $ff275152c44ce822$export$3386beb5bc3bfa {
    #stateAccessor;
    #dispatch;
    unsub;
    constructor(stateAccessor, dispatch){
        this.#stateAccessor = stateAccessor;
        this.#dispatch = dispatch;
    }
    async start() {
        try {
            this.unsub = await $ff275152c44ce822$var$updateChainState(this.#stateAccessor, this.#dispatch);
        } catch (e) {
            await this.addReport($ff275152c44ce822$var$error(e.toString()));
        }
    }
    stop() {
        this.unsub?.();
    }
    async getApi(state) {
        const { type: type, connectivity: connectivity } = state;
        if (type == "ConnectedState" && (0, $7b9c103ea16b33ae$export$2a95c2268ac2504b)(connectivity)) return await $ff275152c44ce822$export$c69bf045a678b870.getOrCreate(connectivity.endpoints);
        return null;
    }
    async delegate(address, tracks, balance, conviction) {
        const state = this.#stateAccessor();
        const api = await this.getApi(state);
        const { type: type, connectivity: connectivity } = state;
        if (api) {
            if (type == "ConnectedState" && (0, $7b9c103ea16b33ae$export$2a95c2268ac2504b)(connectivity)) {
                const votings = await (0, $86de7a8a6ebe9447$export$7ae783ef9d681616)(api, state.connectedAddress);
                const { referenda: referenda } = state.chain;
                const ongoingReferenda = $ff275152c44ce822$export$8c9f51735fe4c232(referenda);
                const votes = $ff275152c44ce822$var$extractCastingVotes(votings);
                const existingVotes = $ff275152c44ce822$var$filterOldVotes(votes, ongoingReferenda);
                const removeTxs = [
                    ...existingVotes.entries()
                ].map(([trackId, votes])=>votes.map((vote)=>(0, $86de7a8a6ebe9447$export$6b7aa4382abc88e8)(api, trackId, vote))).flat();
                const txs = removeTxs.concat(tracks.map((track)=>(0, $86de7a8a6ebe9447$export$10b1921597150314)(api, track, address, conviction, balance)));
                return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)((0, $526c1cdc475b977f$export$63bcd1f4e5acb361)(api, txs));
            } else {
                const report = $ff275152c44ce822$var$error("Must be connected to delegate");
                await this.addReport(report);
                return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(report.message));
            }
        } else {
            const report = $ff275152c44ce822$var$error("Failed to retrieve Api");
            await this.addReport(report);
            return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(report.message));
        }
    }
    async delegateFee(connectedAddress, delegateAddress, tracks, balance, conviction) {
        const tx = await this.delegate(delegateAddress, tracks, balance, conviction);
        if (tx.type === "ok") return await (0, $526c1cdc475b977f$export$f9a8254a7f017ec)(tx.value, connectedAddress);
    }
    async undelegate(tracks, unlockTarget) {
        const state = this.#stateAccessor();
        const api = await this.getApi(state);
        if (api) {
            let txs = tracks.map((track)=>(0, $86de7a8a6ebe9447$export$faa99c1921d524fd)(api, track));
            if (unlockTarget) {
                // delegation locks are put on balance per each delegated track.
                // here all tracks that are being undelegated are bateched with an unlock call to lift their locks.
                const unlockTxs = tracks.map((track)=>(0, $86de7a8a6ebe9447$export$eccddd504975e05d)(api, track, unlockTarget));
                txs = [
                    ...txs,
                    ...unlockTxs
                ];
            }
            return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)((0, $526c1cdc475b977f$export$63bcd1f4e5acb361)(api, txs));
        } else {
            const report = $ff275152c44ce822$var$error("Failed to retrieve Api");
            await this.addReport(report);
            return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(report.message));
        }
    }
    async undelegateFee(connectedAddress, tracks) {
        const tx = await this.undelegate(tracks, connectedAddress);
        if (tx.type == "ok") return await (0, $526c1cdc475b977f$export$f9a8254a7f017ec)(tx.value, connectedAddress);
    }
    async handleCallResult(unsub, status, dispatchError) {
        if (dispatchError) {
            const state = this.#stateAccessor();
            const api = await this.getApi(state);
            const message = api ? (0, $526c1cdc475b977f$export$8cc545829c7461b0)(api, dispatchError) : dispatchError.toString();
            this.clearProcessingReport();
            this.addReport({
                type: "Error",
                message: `Failed to send the transaction: ${message}`
            });
            unsub();
        } else if (status.isReady) this.setProcessingReport({
            isTransient: false,
            message: "The transaction is ready"
        });
        else if (status.isBroadcast) // Can happen multiple times
        this.setProcessingReport({
            isTransient: false,
            message: "The transaction is broadcasted"
        });
        else if (status.isInBlock) this.setProcessingReport({
            isTransient: true,
            message: "The transaction is included in a block"
        });
        else if (status.isInvalid) {
            this.clearProcessingReport();
            this.addReport({
                type: "Error",
                message: "The transaction failed"
            });
            unsub();
        } else {
            this.clearProcessingReport();
            // `retracted` is harmless, ignoring
            if (!(status.isFinalized || status.isRetracted)) console.debug("Unhandled status", status);
            unsub();
        }
    }
    async setConnectedAddress(connectedAddress) {
        this.#dispatch({
            type: "SetConnectedAddress",
            connectedAddress: connectedAddress
        });
        // connectedAddress exists, fetch associated chain info
        if (connectedAddress) {
            const state = this.#stateAccessor();
            const api = await this.getApi(state);
            if (api) await $ff275152c44ce822$var$updateChainAccountDetails(api, this.#dispatch, connectedAddress);
        // When restoring address during startup API won't be available; ignoring.
        // Will become irrelevant once this is persisted via the state.
        }
    }
    async addVotings(votings) {
        this.#dispatch({
            type: "AddVotings",
            votings: votings
        });
    }
    async removeVotings(trackIds) {
        this.#dispatch({
            type: "RemoveVotings",
            trackIds: trackIds
        });
    }
    async addReport(report) {
        this.#dispatch({
            type: "AddReport",
            report: report
        });
    }
    async removeReport(index) {
        this.#dispatch({
            type: "RemoveReport",
            index: index
        });
    }
    async addCustomDelegate(delegate) {
        this.#dispatch({
            type: "AddCustomDelegate",
            delegate: delegate
        });
        const state = this.#stateAccessor();
        if (state.type == "ConnectedState") {
            const db = await $ff275152c44ce822$export$7fb7d1ec29bca401.getOrCreate((0, $98868944f5761e7c$export$61b0b2f27286444c)(state.network));
            await (0, $8c286b8fd86085ed$export$a1544dad697b423d)(db, (0, $98868944f5761e7c$export$1f80f7f9f3a665bb), state.customDelegates.length + 1, delegate);
        } else await this.addReport($ff275152c44ce822$var$error("Must be connected to add custom delegate"));
    }
    async removeCustomDelegate(index) {
        this.#dispatch({
            type: "RemoveCustomDelegate",
            index: index
        });
    }
    async clearProcessingReport() {
        this.#dispatch({
            type: "ClearProcessing"
        });
    }
    async setProcessingReport(processing) {
        this.#dispatch({
            type: "SetProcessing",
            report: processing
        });
    }
}
const $ff275152c44ce822$var$DEFAULT_INITIAL_STATE = {
    type: "InitialState",
    connectivity: {
        type: navigator.onLine ? "Online" : "Offline"
    },
    connectedAddress: null,
    details: new Map(),
    indexes: {},
    tracks: [],
    delegates: [],
    customDelegates: []
};
const $ff275152c44ce822$var$history = new Array();
function $ff275152c44ce822$var$useReducerWithHistory(reducer, history) {
    return (0, $4Iuzv.useCallback)((previousState, action)=>{
        const newState = reducer(previousState, action);
        history.push({
            when: new Date(),
            action: action,
            previousState: previousState,
            newState: newState
        });
        return newState;
    }, [
        reducer
    ]);
}
async function $ff275152c44ce822$var$fetchDelegates(network) {
    const url = `https://paritytech.github.io/governance-ui/data/${network.toLowerCase()}/delegates.json`;
    const delegates = await fetch(url);
    if (delegates.ok) {
        const data = await delegates.json();
        return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(data);
    } else return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(`Can't access ${url}`));
}
function $ff275152c44ce822$export$60cb0fea1fbc7c9f(tracks) {
    return Array.from(tracks.entries()).reduce((acc, [, category])=>{
        category.tracks.forEach((track)=>acc.set(track.id, track));
        return acc;
    }, new Map());
}
function $ff275152c44ce822$export$950bf1eaf02906d4(state, allTracks) {
    const delegations = $ff275152c44ce822$export$d3f593c73a07d922(state);
    return [
        ...allTracks.entries()
    ].filter(([trackIndex])=>!delegations.has(trackIndex)).map(([, track])=>track);
}
function $ff275152c44ce822$var$tracksFor(network) {
    switch(network){
        case (0, $d1a50225a354c5e4$export$95be4ae94445245a).Kusama:
            return 0, $5bf901c388a26365$export$c42c4b43e6ce031e;
        default:
            return 0, $1639d8731450fd05$export$c42c4b43e6ce031e;
    }
}
/**
 * Called when the connected network has changed.
 * Underlying `indexeddb`, `api` and associated resources will refreshed.
 * Also calls `dispatchEndpointsChange`.
 *
 * @param network
 * @param dispatch
 */ async function $ff275152c44ce822$var$dispatchNetworkChange(stateAccessor, dispatch, network, rpcParam) {
    try {
        const db = await (0, $8c286b8fd86085ed$export$3ce6949f20cea765)((0, $98868944f5761e7c$export$61b0b2f27286444c)(network), (0, $98868944f5761e7c$export$b8de75f2fd4fbd02), (0, $98868944f5761e7c$export$6a9022b4c5fcea02));
        const restoredState = await (0, $6edf692333e130ac$export$8c1798a4c725d9af)("fetch-restored-state", ()=>$ff275152c44ce822$var$restorePersisted(db));
        dispatch({
            type: "SetRestored",
            network: network,
            tracks: $ff275152c44ce822$var$tracksFor(network),
            ...restoredState
        });
    } catch (e) {
        console.warn(`${e.message}`);
        dispatch({
            type: "SetRestored",
            network: network,
            tracks: $ff275152c44ce822$var$tracksFor(network),
            customDelegates: []
        });
    }
    // Fetch delegates
    const delegates = await $ff275152c44ce822$var$fetchDelegates(network);
    if (delegates.type == "ok") dispatch({
        type: "SetDelegates",
        data: delegates.value
    });
    else $ff275152c44ce822$var$dispatchAddReport(dispatch, {
        type: "Warning",
        message: delegates.error.message
    });
    return $ff275152c44ce822$var$dispatchEndpointsParamChange(stateAccessor, dispatch, network, rpcParam);
}
function $ff275152c44ce822$var$dispatchAddReport(dispatch, report) {
    dispatch({
        type: "AddReport",
        report: report
    });
}
async function $ff275152c44ce822$var$dispatchEndpointsParamChange(stateAccessor, dispatch, network, rpcParam) {
    if (rpcParam) {
        const endpoints = $ff275152c44ce822$var$extractEndpointsFromParam(rpcParam);
        if (endpoints.type == "ok") return await $ff275152c44ce822$var$dispatchEndpointsChange(stateAccessor, dispatch, network, endpoints.value);
        else $ff275152c44ce822$var$dispatchAddReport(dispatch, $ff275152c44ce822$var$error(`Invalid 'rpc' param ${rpcParam}: ${endpoints.error}`));
    } else return await $ff275152c44ce822$var$dispatchEndpointsChange(stateAccessor, dispatch, network, (0, $d1a50225a354c5e4$export$6a3d7965cc7ead4c)(network));
}
async function $ff275152c44ce822$var$loadAndDispatchReferendaMetaData(dispatch, referendaIndexes, network) {
    const indexes = Array.from(referendaIndexes);
    indexes.forEach(async (index)=>{
        const details = await (0, $6edf692333e130ac$export$8c1798a4c725d9af)("fetch-referenda", ()=>(0, $fb4f49e738864135$export$1ad9d52463c4976)(network, index));
        if (details.type == "ok") dispatch({
            type: "StoreReferendumDetails",
            details: new Map([
                [
                    index,
                    details.value
                ]
            ])
        });
        else {
            // Ignore error as it's not blocking
            console.error(`Error while accessing referenda details: ${details.error.message}`);
            // Store dummy data so that fetch is not retried in a loop
            dispatch({
                type: "StoreReferendumDetails",
                details: new Map([
                    [
                        index,
                        {
                            title: "",
                            content: ""
                        }
                    ]
                ])
            });
        }
    });
}
async function $ff275152c44ce822$var$updateChainAccountDetails(api, dispatch, connectedAccount) {
    const details = await (0, $6edf692333e130ac$export$8c1798a4c725d9af)("fetch-account-chain-details", ()=>$ff275152c44ce822$export$a48b9da41076292b(api, connectedAccount));
    dispatch({
        type: "UpdateChainAccountDetails",
        details: details
    });
}
async function $ff275152c44ce822$var$dispatchEndpointsChange(stateAccessor, dispatch, network, endpoints) {
    const api = await $ff275152c44ce822$export$c69bf045a678b870.getOrCreate(endpoints);
    // TODO listen for deconnection/stales and update accordingly
    // Connection has been established
    const lastHeader = await api.rpc.chain.getHeader();
    dispatch({
        type: "UpdateConnectivity",
        connectivity: {
            type: "Connected",
            endpoints: endpoints,
            block: lastHeader.number.toNumber()
        }
    });
    return await api.rpc.chain.subscribeFinalizedHeads(async (header)=>{
        // New block has been received, we are up-to-date with the chain
        // Refetch everything to ensure data freshness
        dispatch({
            type: "UpdateConnectivity",
            connectivity: {
                type: "Following",
                endpoints: endpoints,
                block: header.number.toNumber()
            }
        });
        const state = stateAccessor();
        const apiAt = await api.at(header.hash);
        try {
            // TODO rely on subs, do not re-fetch whole state each block
            const details = await (0, $6edf692333e130ac$export$8c1798a4c725d9af)("fetch-chain-details", ()=>$ff275152c44ce822$export$f5334432830428cc(apiAt, api.registry, api.genesisHash.toHex()));
            dispatch({
                type: "UpdateChainDetails",
                details: details
            });
            const connectedAddress = state.connectedAddress;
            if (connectedAddress) await $ff275152c44ce822$var$updateChainAccountDetails(apiAt, dispatch, connectedAddress);
            // Trigger fetch of missing referenda metadata
            const previousReferendaIndexes = Array.from(state.details.keys());
            const newReferendaIndexes = Array.from($ff275152c44ce822$export$8c9f51735fe4c232(details.referenda).keys());
            const missingReferendaIndexes = newReferendaIndexes.filter((index)=>!previousReferendaIndexes.includes(index));
            await $ff275152c44ce822$var$loadAndDispatchReferendaMetaData(dispatch, missingReferendaIndexes, network);
        } catch (e) {
            dispatch({
                type: "AddReport",
                report: {
                    type: "Warning",
                    message: e.toString()
                }
            });
        }
    });
}
function $ff275152c44ce822$var$isValidEnpoint(endpoint) {
    try {
        const url = new URL(endpoint);
        return url.protocol === "ws:" || url.protocol === "wss:";
    } catch (err) {
        return false;
    }
}
function $ff275152c44ce822$export$981dc6940c9a33bd(endpoints) {
    const invalidEndpoints = endpoints.filter((endpoint)=>!$ff275152c44ce822$var$isValidEnpoint(endpoint));
    if (invalidEndpoints.length !== 0) return (0, $4453e73b8fa7c4de$export$8048b892d651b310)(new Error(`Some of provided rpcs are not valid endpoints: ${invalidEndpoints}`));
    return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(endpoints);
}
function $ff275152c44ce822$export$d048c2f6cd7b97eb() {
    const [networkParam, rpcParam] = (0, $d09b2bd67ed552e2$export$f3db5e8fd0cb70b3)(window.location.search, [
        "network",
        "rpc"
    ]);
    return {
        networkParam: networkParam,
        rpcParam: rpcParam
    };
}
function $ff275152c44ce822$export$2f38a1811b8d6e74(onChange) {
    window.addEventListener("popstate", onChange);
    window.addEventListener("pushstate", onChange);
    window.addEventListener("replacestate", onChange);
}
function $ff275152c44ce822$export$398cd8a20027c153(onChange) {
    window.removeEventListener("popstate", onChange);
    window.removeEventListener("pushstate", onChange);
    window.removeEventListener("replacestate", onChange);
}
function $ff275152c44ce822$var$extractEndpointsFromParam(s) {
    return $ff275152c44ce822$export$981dc6940c9a33bd(s.split("|"));
}
/**
 * It's assumed that provided state and dependencies are fully initialized.
 * e.g. a 'ConnectedState' should provide a connected `api`
 *
 * @param state
 * @param dispatch
 */ async function $ff275152c44ce822$var$updateChainState(stateAccessor, dispatch) {
    // First setup listeners
    let currentUnsub;
    function updateUnsub(unsub) {
        if (currentUnsub) currentUnsub();
        currentUnsub = unsub;
    }
    /*addAccountListener((accounts) => {
    // TODO
    // Updated votings whenever selected accounts are updated
  });*/ $ff275152c44ce822$export$2f38a1811b8d6e74(async ()=>{
        // Track changes to network related query parameters
        // Only consider values set, absent values are not consider (keep unchanged)
        // If `network` is set, `endpoints` if unset will default to Network default
        const state = stateAccessor();
        if (state.type == "ConnectedState") {
            // Only consider ConnectedState
            const { networkParam: networkParam, rpcParam: rpcParam } = $ff275152c44ce822$export$d048c2f6cd7b97eb();
            if (networkParam && rpcParam) $ff275152c44ce822$var$dispatchAddReport(dispatch, $ff275152c44ce822$var$error(`Both rpc and network params can't be set at the same time`));
            else {
                if (networkParam) {
                    // `network` param is set and takes precedence, `endpoints` might
                    const network = (0, $d1a50225a354c5e4$export$98e6a39c04603d36)(networkParam);
                    if (network.type == "ok") {
                        if (state.network != network.value) // Only react to network changes
                        updateUnsub(await $ff275152c44ce822$var$dispatchNetworkChange(stateAccessor, dispatch, network.value, rpcParam));
                    } else $ff275152c44ce822$var$dispatchAddReport(dispatch, $ff275152c44ce822$var$error(`Invalid 'network' param ${networkParam}: ${network.error}`));
                } else if (rpcParam) // Only `rpc` param is set, reconnect using those
                updateUnsub(await $ff275152c44ce822$var$dispatchEndpointsParamChange(stateAccessor, dispatch, state.network, rpcParam));
            }
        }
    });
    window.addEventListener("online", async ()=>{
        dispatch({
            type: "UpdateConnectivity",
            connectivity: {
                type: "Online"
            }
        });
    });
    window.addEventListener("offline", ()=>dispatch({
            type: "UpdateConnectivity",
            connectivity: {
                type: "Offline"
            }
        }));
    window.addEventListener("unhandledrejection", (event)=>$ff275152c44ce822$var$dispatchAddReport(dispatch, $ff275152c44ce822$var$error(`Unhandled promise rejection: ${event.reason}`)));
    async function getNetwork(networkParam) {
        if (networkParam) {
            const network = (0, $d1a50225a354c5e4$export$98e6a39c04603d36)(networkParam);
            if (network.type == "ok") return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(network.value);
            else return network;
        } else return (0, $4453e73b8fa7c4de$export$dcb8b3f0e2de7e49)(await (0, $d1a50225a354c5e4$export$e5a12ad88a46d660)());
    }
    const { networkParam: networkParam, rpcParam: rpcParam } = $ff275152c44ce822$export$d048c2f6cd7b97eb();
    const network = await getNetwork(networkParam);
    if (network.type == "ok") {
        console.log(`Using network ${network.value}`);
        updateUnsub(await $ff275152c44ce822$var$dispatchNetworkChange(stateAccessor, dispatch, network.value, rpcParam));
    } else $ff275152c44ce822$var$dispatchAddReport(dispatch, $ff275152c44ce822$var$error(network.error.message));
    return ()=>{
        currentUnsub?.();
    };
}
const $ff275152c44ce822$var$appLifeCycleContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({});
const $ff275152c44ce822$export$f941bf1beb8c8ec2 = ()=>(0, $4Iuzv.useContext)($ff275152c44ce822$var$appLifeCycleContext);
const $ff275152c44ce822$export$e78b73c32cb1e19f = ({ initialState: initialState = $ff275152c44ce822$var$DEFAULT_INITIAL_STATE, children: children })=>{
    const [state, dispatch] = (0, $4Iuzv.useReducer)($ff275152c44ce822$var$useReducerWithHistory($ff275152c44ce822$var$reducer, $ff275152c44ce822$var$history), initialState);
    const lastState = (0, $4Iuzv.useRef)(state);
    // Allows to access current State
    const stateAccessor = (0, $4Iuzv.useCallback)(()=>lastState.current, []);
    const updater = new $ff275152c44ce822$export$3386beb5bc3bfa(stateAccessor, dispatch);
    (0, $4Iuzv.useEffect)(()=>{
        lastState.current = state;
    }, [
        state
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        async function start() {
            await updater.start();
        }
        start();
        return ()=>{
            updater.stop();
        };
    }, []);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($ff275152c44ce822$var$appLifeCycleContext.Provider, {
        value: {
            state: state,
            updater: updater
        },
        children: children
    });
};




var $4Iuzv = parcelRequire("4Iuzv");

var $e8d9766c67c3a920$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/ui-settings/packageInfo.js"
});
const $e8d9766c67c3a920$export$ce0097da4c08ff3f = {
    name: "@polkadot/ui-settings",
    path: $e8d9766c67c3a920$import_meta && "file:///node_modules/@polkadot/ui-settings/packageInfo.js" ? new URL("file:///node_modules/@polkadot/ui-settings/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/ui-settings/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "3.5.1"
};


var $94a8f2ae2506c3da$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/ui-shared/packageInfo.js"
});
const $94a8f2ae2506c3da$export$ce0097da4c08ff3f = {
    name: "@polkadot/ui-shared",
    path: $94a8f2ae2506c3da$import_meta && "file:///node_modules/@polkadot/ui-shared/packageInfo.js" ? new URL("file:///node_modules/@polkadot/ui-shared/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/ui-shared/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "3.5.1"
};


var $b301ab02661e875d$export$2e2bcd8739ae039 = [
    (0, $e8d9766c67c3a920$export$ce0097da4c08ff3f),
    (0, $94a8f2ae2506c3da$export$ce0097da4c08ff3f)
];


var $446326327312a6cb$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/@polkadot/react-identicon/packageInfo.js"
});
const $446326327312a6cb$export$ce0097da4c08ff3f = {
    name: "@polkadot/react-identicon",
    path: $446326327312a6cb$import_meta && "file:///node_modules/@polkadot/react-identicon/packageInfo.js" ? new URL("file:///node_modules/@polkadot/react-identicon/packageInfo.js").pathname.substring(0, new URL("file:///node_modules/@polkadot/react-identicon/packageInfo.js").pathname.lastIndexOf("/") + 1) : "auto",
    type: "esm",
    version: "3.5.1"
};


(0, $c55b73f8dda76a9d$export$3d90b6f1c729d3cf)((0, $446326327312a6cb$export$ce0097da4c08ff3f), null, (0, $b301ab02661e875d$export$2e2bcd8739ae039));




var $4Iuzv = parcelRequire("4Iuzv");
var $542cb45932491e02$exports = {};
"use strict";
var $8cc9150aa94bb405$exports = {};
"use strict";
function $8cc9150aa94bb405$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8cc9150aa94bb405$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8cc9150aa94bb405$var$_typeof(obj);
}
Object.defineProperty($8cc9150aa94bb405$exports, "__esModule", {
    value: true
});
$8cc9150aa94bb405$exports.CopyToClipboard = void 0;

var $8cc9150aa94bb405$var$_react = $8cc9150aa94bb405$var$_interopRequireDefault((parcelRequire("4Iuzv")));

var $8cc9150aa94bb405$var$_copyToClipboard = $8cc9150aa94bb405$var$_interopRequireDefault((parcelRequire("aojIm")));
var $8cc9150aa94bb405$var$_excluded = [
    "text",
    "onCopy",
    "options",
    "children"
];
function $8cc9150aa94bb405$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8cc9150aa94bb405$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8cc9150aa94bb405$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8cc9150aa94bb405$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8cc9150aa94bb405$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8cc9150aa94bb405$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8cc9150aa94bb405$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8cc9150aa94bb405$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8cc9150aa94bb405$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8cc9150aa94bb405$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8cc9150aa94bb405$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8cc9150aa94bb405$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8cc9150aa94bb405$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8cc9150aa94bb405$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8cc9150aa94bb405$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8cc9150aa94bb405$var$_setPrototypeOf(subClass, superClass);
}
function $8cc9150aa94bb405$var$_setPrototypeOf(o, p) {
    $8cc9150aa94bb405$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8cc9150aa94bb405$var$_setPrototypeOf(o, p);
}
function $8cc9150aa94bb405$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8cc9150aa94bb405$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8cc9150aa94bb405$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8cc9150aa94bb405$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8cc9150aa94bb405$var$_possibleConstructorReturn(this, result);
    };
}
function $8cc9150aa94bb405$var$_possibleConstructorReturn(self, call) {
    if (call && ($8cc9150aa94bb405$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8cc9150aa94bb405$var$_assertThisInitialized(self);
}
function $8cc9150aa94bb405$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8cc9150aa94bb405$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8cc9150aa94bb405$var$_getPrototypeOf(o) {
    $8cc9150aa94bb405$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8cc9150aa94bb405$var$_getPrototypeOf(o);
}
function $8cc9150aa94bb405$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8cc9150aa94bb405$var$CopyToClipboard = /*#__PURE__*/ function(_React$PureComponent) {
    $8cc9150aa94bb405$var$_inherits(CopyToClipboard, _React$PureComponent);
    var _super = $8cc9150aa94bb405$var$_createSuper(CopyToClipboard);
    function CopyToClipboard() {
        var _this;
        $8cc9150aa94bb405$var$_classCallCheck(this, CopyToClipboard);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $8cc9150aa94bb405$var$_defineProperty($8cc9150aa94bb405$var$_assertThisInitialized(_this), "onClick", function(event) {
            var _this$props = _this.props, text = _this$props.text, onCopy = _this$props.onCopy, children = _this$props.children, options = _this$props.options;
            var elem = $8cc9150aa94bb405$var$_react["default"].Children.only(children);
            var result = (0, $8cc9150aa94bb405$var$_copyToClipboard["default"])(text, options);
            if (onCopy) onCopy(text, result);
             // Bypass onClick if it was present
            if (elem && elem.props && typeof elem.props.onClick === "function") elem.props.onClick(event);
        });
        return _this;
    }
    $8cc9150aa94bb405$var$_createClass(CopyToClipboard, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, _text = _this$props2.text, _onCopy = _this$props2.onCopy, _options = _this$props2.options, children = _this$props2.children, props = $8cc9150aa94bb405$var$_objectWithoutProperties(_this$props2, $8cc9150aa94bb405$var$_excluded);
                var elem = $8cc9150aa94bb405$var$_react["default"].Children.only(children);
                return /*#__PURE__*/ $8cc9150aa94bb405$var$_react["default"].cloneElement(elem, $8cc9150aa94bb405$var$_objectSpread($8cc9150aa94bb405$var$_objectSpread({}, props), {}, {
                    onClick: this.onClick
                }));
            }
        }
    ]);
    return CopyToClipboard;
}($8cc9150aa94bb405$var$_react["default"].PureComponent);
$8cc9150aa94bb405$exports.CopyToClipboard = $8cc9150aa94bb405$var$CopyToClipboard;
$8cc9150aa94bb405$var$_defineProperty($8cc9150aa94bb405$var$CopyToClipboard, "defaultProps", {
    onCopy: undefined,
    options: undefined
});


var $542cb45932491e02$var$CopyToClipboard = $8cc9150aa94bb405$exports.CopyToClipboard;
$542cb45932491e02$var$CopyToClipboard.CopyToClipboard = $542cb45932491e02$var$CopyToClipboard;
$542cb45932491e02$exports = $542cb45932491e02$var$CopyToClipboard;


const $5ebef6e34c9183bd$export$5a6301b0956b783a = typeof window !== "undefined" && window.location.host.includes("polkadot");


const $ad93b1a428581336$export$965070396d8ca009 = "default";
const $ad93b1a428581336$export$c30c22aa13bcf6cf = !(0, $5ebef6e34c9183bd$export$5a6301b0956b783a) && typeof window !== "undefined" && window.location.host.includes("ui-light") ? "light" : "full";
const $ad93b1a428581336$export$6c80e1dae84bc9d1 = [
    {
        info: "full",
        text: "Fully featured",
        value: "full"
    },
    {
        info: "light",
        text: "Basic features only",
        value: "light"
    }
];
const $ad93b1a428581336$export$2aef31f58c86776a = (0, $5ebef6e34c9183bd$export$5a6301b0956b783a) ? "polkadot" : "substrate";
const $ad93b1a428581336$export$ef37ea0ea5d70dd9 = [
    {
        info: "polkadot",
        text: "Polkadot",
        value: "polkadot"
    },
    {
        info: "substrate",
        text: "Substrate",
        value: "substrate"
    }
];
const $ad93b1a428581336$export$16c77a5f675cb3cf = "default";
const $ad93b1a428581336$export$1e716925a55d2873 = (0, $5ebef6e34c9183bd$export$5a6301b0956b783a) ? "polkadot" : "substrate";
const $ad93b1a428581336$export$fde44257752a9f60 = [
    {
        info: "default",
        text: "Default for the connected node",
        value: "default"
    },
    {
        info: "polkadot",
        text: "Polkadot",
        value: "polkadot"
    },
    {
        info: "substrate",
        text: "Substrate",
        value: "substrate"
    },
    {
        info: "beachball",
        text: "Beachball",
        value: "beachball"
    }
];
const $ad93b1a428581336$export$f04dbaae500ebb28 = "popup";


var $e5c3feb2b186ac86$exports = {};
var $97800522d831b174$exports = {};

var $jlvmO = parcelRequire("jlvmO");
var $97800522d831b174$var$slice = $jlvmO.slice;
var $97800522d831b174$var$pluck = $jlvmO.pluck;
var $97800522d831b174$var$each = $jlvmO.each;
var $97800522d831b174$var$bind = $jlvmO.bind;
var $97800522d831b174$var$create = $jlvmO.create;
var $97800522d831b174$var$isList = $jlvmO.isList;
var $97800522d831b174$var$isFunction = $jlvmO.isFunction;
var $97800522d831b174$var$isObject = $jlvmO.isObject;
$97800522d831b174$exports = {
    createStore: $97800522d831b174$var$createStore
};
var $97800522d831b174$var$storeAPI = {
    version: "2.0.12",
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || "").replace(self._namespaceRegexp, ""));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == "__storejs_" + namespace + "_";
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $97800522d831b174$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $97800522d831b174$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $97800522d831b174$var$_warn() {
    var _console = typeof console == "undefined" ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $97800522d831b174$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = "";
    if (storages && !$97800522d831b174$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$97800522d831b174$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? "__storejs_" + namespace + "_" : "";
    var namespaceRegexp = namespace ? new RegExp("^" + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = "__storejs__test__";
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $97800522d831b174$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $97800522d831b174$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = "";
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($97800522d831b174$var$isList(plugin)) {
                $97800522d831b174$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $97800522d831b174$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$97800522d831b174$var$isFunction(plugin)) throw new Error("Plugins must be function values that return objects");
            var pluginProperties = plugin.call(this);
            if (!$97800522d831b174$var$isObject(pluginProperties)) throw new Error("Plugins must return an object of function properties");
            // Add the plugin function properties to this store instance.
            $97800522d831b174$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$97800522d831b174$var$isFunction(pluginFnProp)) throw new Error("Bad plugin property: " + propName + " from plugin " + plugin.name + ". Plugins should only return functions.");
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $97800522d831b174$var$_warn("store.addStorage(storage) is deprecated. Use createStore([storages])");
            this._addStorage(storage);
        }
    };
    var store = $97800522d831b174$var$create(_privateStoreProps, $97800522d831b174$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $97800522d831b174$var$each(store, function(prop, propName) {
        if ($97800522d831b174$var$isFunction(prop)) store.raw[propName] = $97800522d831b174$var$bind(store, prop);
    });
    $97800522d831b174$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $97800522d831b174$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}


var $110b8d300973b7ee$exports = {};






$110b8d300973b7ee$exports = [
    // Listed in order of usage preference
    (parcelRequire("63wzt")),
    (parcelRequire("d74u2")),
    (parcelRequire("053wT")),
    (parcelRequire("dBJPT")),
    (parcelRequire("8wo1l")),
    (parcelRequire("lF78s"))
];



var $e5c3feb2b186ac86$var$plugins = [
    (parcelRequire("jx4X3"))
];
$e5c3feb2b186ac86$exports = $97800522d831b174$exports.createStore($110b8d300973b7ee$exports, $e5c3feb2b186ac86$var$plugins);



const $81dfa3a948b52901$export$f1d5567a18b78bb4 = [
    {
        info: "sr25519",
        text: "Schnorrkel (sr25519, recommended)",
        value: "sr25519"
    },
    {
        info: "ed25519",
        text: "Edwards (ed25519, alternative)",
        value: "ed25519"
    },
    {
        info: "ecdsa",
        text: "ECDSA (Non BTC/ETH compatible)",
        value: "ecdsa"
    }
];
const $81dfa3a948b52901$export$320dd32ad8137d23 = [
    {
        info: "ethereum",
        text: "ECDSA (ETH compatible)",
        value: "ethereum"
    }
];
const $81dfa3a948b52901$export$717473b6809b2b9 = [
    ...$81dfa3a948b52901$export$f1d5567a18b78bb4,
    {
        info: "ed25519-ledger",
        text: "Ledger (ed25519, BIP32 derivation)",
        value: "ed25519-ledger"
    }
];


const $b9bbe3da03bb24c2$export$4a3a00e07ffce8bd = [
    {
        info: "local",
        text: "Local Node (Own, 127.0.0.1:9944)",
        value: "ws://127.0.0.1:9944/"
    }
];
const $b9bbe3da03bb24c2$export$42d4395c73f1770 = $b9bbe3da03bb24c2$export$4a3a00e07ffce8bd[0];


const $366d79641d98cfb2$export$5b77e10dfb0e8f2d = "none";
const $366d79641d98cfb2$export$7793ee2144d7b333 = [
    {
        info: "none",
        text: "Do not attach Ledger devices",
        value: "none"
    },
    // Deprecated
    // {
    //   info: 'u2f',
    //   text: 'Attach Ledger via U2F',
    //   value: 'u2f'
    // },
    {
        info: "webusb",
        text: "Attach Ledger via WebUSB (Chrome, recommended)",
        value: "webusb"
    },
    {
        info: "hid",
        text: "Attach Ledger via WebHID (Chrome, experimental)",
        value: "hid"
    }
];



const $449687444fbfa8a6$export$aa130917991ba133 = -1;
const $449687444fbfa8a6$var$defaultNetwork = {
    info: "default",
    text: "Default for the connected node",
    value: -1
};
const $449687444fbfa8a6$var$networks = (0, $ed4185bd04ce3f3f$export$337a7c3584aeadf8).map(({ displayName: displayName, network: network, prefix: prefix })=>({
        info: network,
        text: displayName,
        value: prefix
    }));
const $449687444fbfa8a6$export$edfefab06886d8a7 = [
    $449687444fbfa8a6$var$defaultNetwork,
    ...$449687444fbfa8a6$var$networks
];



const $31ab27166ddc8e87$export$3e39b2d0a1ad56a8 = "off";
const $31ab27166ddc8e87$export$86703463cbdc13c0 = [
    {
        info: "on",
        text: "Allow camera access",
        value: "on"
    },
    {
        info: "off",
        text: "Do not allow camera access",
        value: "off"
    }
];
const $31ab27166ddc8e87$export$965070396d8ca009 = "default";
const $31ab27166ddc8e87$export$4d48727e41ac4030 = "session";
const $31ab27166ddc8e87$export$9a74e9ad927dd158 = [
    {
        info: "session",
        text: "Once per session",
        value: "session"
    },
    {
        info: "tx",
        text: "On each transaction",
        value: "tx"
    }
];
const $31ab27166ddc8e87$export$5b1eccaf0e74e95d = "off";
const $31ab27166ddc8e87$export$17ef3d8461c48b57 = [
    {
        info: "off",
        text: "Do not auto-update extension metadata",
        value: "off"
    },
    {
        info: "on",
        text: "Auto-update extension metadata",
        value: "on"
    }
];
const $31ab27166ddc8e87$export$2f574605a51cbd80 = "off";
const $31ab27166ddc8e87$export$e52920da3d8ae458 = [
    {
        info: "on",
        text: "Allow local in-browser account storage",
        value: "on"
    },
    {
        info: "off",
        text: "Do not allow local in-browser account storage",
        value: "off"
    }
];


var $5671edd534fa79c4$exports = {};
// shim for using process in browser
var $5671edd534fa79c4$var$process = $5671edd534fa79c4$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5671edd534fa79c4$var$cachedSetTimeout;
var $5671edd534fa79c4$var$cachedClearTimeout;
function $5671edd534fa79c4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $5671edd534fa79c4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        else $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedSetTimeout = $5671edd534fa79c4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        else $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    } catch (e) {
        $5671edd534fa79c4$var$cachedClearTimeout = $5671edd534fa79c4$var$defaultClearTimeout;
    }
})();
function $5671edd534fa79c4$var$runTimeout(fun) {
    if ($5671edd534fa79c4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedSetTimeout === $5671edd534fa79c4$var$defaultSetTimout || !$5671edd534fa79c4$var$cachedSetTimeout) && setTimeout) {
        $5671edd534fa79c4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5671edd534fa79c4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5671edd534fa79c4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5671edd534fa79c4$var$runClearTimeout(marker) {
    if ($5671edd534fa79c4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5671edd534fa79c4$var$cachedClearTimeout === $5671edd534fa79c4$var$defaultClearTimeout || !$5671edd534fa79c4$var$cachedClearTimeout) && clearTimeout) {
        $5671edd534fa79c4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5671edd534fa79c4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5671edd534fa79c4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5671edd534fa79c4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5671edd534fa79c4$var$queue = [];
var $5671edd534fa79c4$var$draining = false;
var $5671edd534fa79c4$var$currentQueue;
var $5671edd534fa79c4$var$queueIndex = -1;
function $5671edd534fa79c4$var$cleanUpNextTick() {
    if (!$5671edd534fa79c4$var$draining || !$5671edd534fa79c4$var$currentQueue) return;
    $5671edd534fa79c4$var$draining = false;
    if ($5671edd534fa79c4$var$currentQueue.length) $5671edd534fa79c4$var$queue = $5671edd534fa79c4$var$currentQueue.concat($5671edd534fa79c4$var$queue);
    else $5671edd534fa79c4$var$queueIndex = -1;
    if ($5671edd534fa79c4$var$queue.length) $5671edd534fa79c4$var$drainQueue();
}
function $5671edd534fa79c4$var$drainQueue() {
    if ($5671edd534fa79c4$var$draining) return;
    var timeout = $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$cleanUpNextTick);
    $5671edd534fa79c4$var$draining = true;
    var len = $5671edd534fa79c4$var$queue.length;
    while(len){
        $5671edd534fa79c4$var$currentQueue = $5671edd534fa79c4$var$queue;
        $5671edd534fa79c4$var$queue = [];
        while(++$5671edd534fa79c4$var$queueIndex < len)if ($5671edd534fa79c4$var$currentQueue) $5671edd534fa79c4$var$currentQueue[$5671edd534fa79c4$var$queueIndex].run();
        $5671edd534fa79c4$var$queueIndex = -1;
        len = $5671edd534fa79c4$var$queue.length;
    }
    $5671edd534fa79c4$var$currentQueue = null;
    $5671edd534fa79c4$var$draining = false;
    $5671edd534fa79c4$var$runClearTimeout(timeout);
}
$5671edd534fa79c4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5671edd534fa79c4$var$queue.push(new $5671edd534fa79c4$var$Item(fun, args));
    if ($5671edd534fa79c4$var$queue.length === 1 && !$5671edd534fa79c4$var$draining) $5671edd534fa79c4$var$runTimeout($5671edd534fa79c4$var$drainQueue);
};
// v8 likes predictible objects
function $5671edd534fa79c4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5671edd534fa79c4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5671edd534fa79c4$var$process.title = "browser";
$5671edd534fa79c4$var$process.browser = true;
$5671edd534fa79c4$var$process.env = {};
$5671edd534fa79c4$var$process.argv = [];
$5671edd534fa79c4$var$process.version = ""; // empty string to avoid regexp issues
$5671edd534fa79c4$var$process.versions = {};
function $5671edd534fa79c4$var$noop() {}
$5671edd534fa79c4$var$process.on = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.addListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.once = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.off = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.removeAllListeners = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.emit = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.prependOnceListener = $5671edd534fa79c4$var$noop;
$5671edd534fa79c4$var$process.listeners = function(name) {
    return [];
};
$5671edd534fa79c4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$5671edd534fa79c4$var$process.cwd = function() {
    return "/";
};
$5671edd534fa79c4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$5671edd534fa79c4$var$process.umask = function() {
    return 0;
};


function $2228a38573058660$var$withDefault(options, option, fallback) {
    const _option = option || fallback;
    return options.some(({ value: value })=>value === _option) ? _option : fallback;
}
class $2228a38573058660$export$c72f6eaae7b9adff {
    constructor(){
        const settings = (0, (/*@__PURE__*/$parcel$interopDefault($e5c3feb2b186ac86$exports))).get("settings") || {};
        this.__internal__emitter = new (0, $891aadac6ba73256$exports.EventEmitter)();
        // will become deprecated for supporting substrate connect light clients. apiType structure should be used instead
        this.__internal__apiUrl = typeof settings.apiUrl === "string" && settings.apiUrl || (0, $6574c8753d85e60c$export$7af020c88c16a8f7) && $5671edd534fa79c4$exports.env && undefined || (0, $b9bbe3da03bb24c2$export$42d4395c73f1770).value;
        this.__internal__apiType = {
            param: this.__internal__apiUrl,
            type: "json-rpc"
        };
        this.__internal__camera = $2228a38573058660$var$withDefault((0, $31ab27166ddc8e87$export$86703463cbdc13c0), settings.camera, (0, $31ab27166ddc8e87$export$3e39b2d0a1ad56a8));
        this.__internal__ledgerConn = $2228a38573058660$var$withDefault((0, $366d79641d98cfb2$export$7793ee2144d7b333), settings.ledgerConn, (0, $366d79641d98cfb2$export$5b77e10dfb0e8f2d));
        this.__internal__i18nLang = settings.i18nLang || (0, $31ab27166ddc8e87$export$965070396d8ca009);
        this.__internal__icon = settings.icon || (0, $ad93b1a428581336$export$16c77a5f675cb3cf);
        this.__internal__locking = settings.locking || (0, $31ab27166ddc8e87$export$4d48727e41ac4030);
        this.__internal__metadataUp = $2228a38573058660$var$withDefault((0, $31ab27166ddc8e87$export$17ef3d8461c48b57), settings.storage, (0, $31ab27166ddc8e87$export$5b1eccaf0e74e95d));
        this.__internal__notification = settings.notification || (0, $ad93b1a428581336$export$f04dbaae500ebb28);
        this.__internal__prefix = (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(settings.prefix) ? (0, $449687444fbfa8a6$export$aa130917991ba133) : settings.prefix;
        this.__internal__storage = $2228a38573058660$var$withDefault((0, $31ab27166ddc8e87$export$e52920da3d8ae458), settings.storage, (0, $31ab27166ddc8e87$export$2f574605a51cbd80));
        this.__internal__uiMode = settings.uiMode || (0, $ad93b1a428581336$export$c30c22aa13bcf6cf);
        this.__internal__uiTheme = settings.uiTheme || (0, $ad93b1a428581336$export$2aef31f58c86776a);
    }
    get camera() {
        return this.__internal__camera;
    }
    get apiType() {
        return this.__internal__apiType;
    }
    get apiUrl() {
        return this.__internal__apiUrl;
    }
    get i18nLang() {
        return this.__internal__i18nLang;
    }
    get icon() {
        return this.__internal__icon;
    }
    get notification() {
        return this.__internal__notification;
    }
    get ledgerConn() {
        return this.__internal__ledgerConn;
    }
    get locking() {
        return this.__internal__locking;
    }
    get metadataUp() {
        return this.__internal__metadataUp;
    }
    get prefix() {
        return this.__internal__prefix;
    }
    get storage() {
        return this.__internal__storage;
    }
    get uiMode() {
        return this.__internal__uiMode;
    }
    get uiTheme() {
        return this.__internal__uiTheme;
    }
    get availableCamera() {
        return 0, $31ab27166ddc8e87$export$86703463cbdc13c0;
    }
    get availableCryptos() {
        return 0, $81dfa3a948b52901$export$f1d5567a18b78bb4;
    }
    get availableCryptosEth() {
        return 0, $81dfa3a948b52901$export$320dd32ad8137d23;
    }
    get availableCryptosLedger() {
        return 0, $81dfa3a948b52901$export$717473b6809b2b9;
    }
    get availableIcons() {
        return 0, $ad93b1a428581336$export$fde44257752a9f60;
    }
    get availableLedgerConn() {
        return 0, $366d79641d98cfb2$export$7793ee2144d7b333;
    }
    get availableLocking() {
        return 0, $31ab27166ddc8e87$export$9a74e9ad927dd158;
    }
    get availableMetadataUp() {
        return 0, $31ab27166ddc8e87$export$17ef3d8461c48b57;
    }
    get availableNodes() {
        return 0, $b9bbe3da03bb24c2$export$4a3a00e07ffce8bd;
    }
    get availablePrefixes() {
        return 0, $449687444fbfa8a6$export$edfefab06886d8a7;
    }
    get availableStorage() {
        return 0, $31ab27166ddc8e87$export$e52920da3d8ae458;
    }
    get availableUIModes() {
        return 0, $ad93b1a428581336$export$6c80e1dae84bc9d1;
    }
    get availableUIThemes() {
        return 0, $ad93b1a428581336$export$ef37ea0ea5d70dd9;
    }
    get() {
        return {
            apiType: this.__internal__apiType,
            apiUrl: this.__internal__apiUrl,
            camera: this.__internal__camera,
            i18nLang: this.__internal__i18nLang,
            icon: this.__internal__icon,
            ledgerConn: this.__internal__ledgerConn,
            locking: this.__internal__locking,
            metadataUp: this.__internal__metadataUp,
            notification: this.__internal__notification,
            prefix: this.__internal__prefix,
            storage: this.__internal__storage,
            uiMode: this.__internal__uiMode,
            uiTheme: this.__internal__uiTheme
        };
    }
    set(settings) {
        this.__internal__apiType = settings.apiType || this.__internal__apiType;
        this.__internal__apiUrl = settings.apiUrl || this.__internal__apiUrl;
        this.__internal__camera = settings.camera || this.__internal__camera;
        this.__internal__ledgerConn = settings.ledgerConn || this.__internal__ledgerConn;
        this.__internal__i18nLang = settings.i18nLang || this.__internal__i18nLang;
        this.__internal__icon = settings.icon || this.__internal__icon;
        this.__internal__locking = settings.locking || this.__internal__locking;
        this.__internal__metadataUp = settings.metadataUp || this.__internal__metadataUp;
        this.__internal__notification = settings.notification || this.__internal__notification;
        this.__internal__prefix = (0, $09d5dc0a6a4c347b$export$fce6876652108ab)(settings.prefix) ? this.__internal__prefix : settings.prefix;
        this.__internal__storage = settings.storage || this.__internal__storage;
        this.__internal__uiMode = settings.uiMode || this.__internal__uiMode;
        this.__internal__uiTheme = settings.uiTheme || this.__internal__uiTheme;
        const newValues = this.get();
        (0, (/*@__PURE__*/$parcel$interopDefault($e5c3feb2b186ac86$exports))).set("settings", newValues);
        this.__internal__emitter.emit("change", newValues);
    }
    on(type, cb) {
        this.__internal__emitter.on(type, cb);
    }
}
const $2228a38573058660$export$a5a6e0b888b2c992 = new $2228a38573058660$export$c72f6eaae7b9adff();






var $4Iuzv = parcelRequire("4Iuzv");
const $81dcd2a4da154661$export$56d196d2844d1ca1 = [
    // https://sashat.me/2017/01/11/list-of-20-simple-distinct-colors/
    "#ffe119",
    "#4363d8",
    "#f58231",
    "#fabebe",
    "#e6beff",
    "#800000",
    "#000075",
    "#a9a9a9",
    "#ffffff",
    "#000000"
];
const $81dcd2a4da154661$export$8b5db91aebc0c140 = 5;


const $2aa9ccc057eb7167$var$SVG_NS = "http://www.w3.org/2000/svg";
function $2aa9ccc057eb7167$export$7ed1367e7fa1ad68(type) {
    return document.createElementNS($2aa9ccc057eb7167$var$SVG_NS, type);
}


function $3433d1f8b79e2be9$export$e1d786d2f707b414(r, cx, cy) {
    const elem = (0, $2aa9ccc057eb7167$export$7ed1367e7fa1ad68)("circle");
    elem.setAttributeNS("", "cx", `${cx}`);
    elem.setAttributeNS("", "cy", `${cy}`);
    elem.setAttributeNS("", "r", `${r}`);
    return elem;
}


function $c4c7ac6649519ade$export$e1d786d2f707b414(seeder, fill, diameter, count) {
    const center = diameter / 2;
    const angle = seeder() * 360;
    const radius = ((0, $81dcd2a4da154661$export$8b5db91aebc0c140) - count) / (0, $81dcd2a4da154661$export$8b5db91aebc0c140) * (diameter / 2) + diameter / 8 * seeder();
    const offset = diameter / 4 * (seeder() + (count + 1) / (0, $81dcd2a4da154661$export$8b5db91aebc0c140));
    const cx = offset * Math.sin(angle) + center;
    const cy = offset * Math.cos(angle) + center;
    const svg = (0, $3433d1f8b79e2be9$export$e1d786d2f707b414)(radius, cx, cy);
    svg.setAttributeNS("", "fill", fill);
    return svg;
}



function $893310e78ef5da0e$export$8454457683f90105(size, type = "svg", x = 0, y = 0) {
    const elem = (0, $2aa9ccc057eb7167$export$7ed1367e7fa1ad68)(type);
    elem.setAttributeNS("", "x", `${x}`);
    elem.setAttributeNS("", "y", `${y}`);
    elem.setAttributeNS("", "width", `${size}`);
    elem.setAttributeNS("", "height", `${size}`);
    return elem;
}


var $a4d3ff2979ca24dc$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $a4d3ff2979ca24dc$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $a4d3ff2979ca24dc$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $a4d3ff2979ca24dc$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $a4d3ff2979ca24dc$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $a4d3ff2979ca24dc$var$a = function(r) {
    return {
        r: $a4d3ff2979ca24dc$var$e(r.r, 0, 255),
        g: $a4d3ff2979ca24dc$var$e(r.g, 0, 255),
        b: $a4d3ff2979ca24dc$var$e(r.b, 0, 255),
        a: $a4d3ff2979ca24dc$var$e(r.a)
    };
}, $a4d3ff2979ca24dc$var$o = function(r) {
    return {
        r: $a4d3ff2979ca24dc$var$n(r.r),
        g: $a4d3ff2979ca24dc$var$n(r.g),
        b: $a4d3ff2979ca24dc$var$n(r.b),
        a: $a4d3ff2979ca24dc$var$n(r.a, 3)
    };
}, $a4d3ff2979ca24dc$var$i = /^#([0-9a-f]{3,8})$/i, $a4d3ff2979ca24dc$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $a4d3ff2979ca24dc$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $a4d3ff2979ca24dc$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $a4d3ff2979ca24dc$var$g = function(r) {
    return {
        h: $a4d3ff2979ca24dc$var$u(r.h),
        s: $a4d3ff2979ca24dc$var$e(r.s, 0, 100),
        l: $a4d3ff2979ca24dc$var$e(r.l, 0, 100),
        a: $a4d3ff2979ca24dc$var$e(r.a)
    };
}, $a4d3ff2979ca24dc$var$d = function(r) {
    return {
        h: $a4d3ff2979ca24dc$var$n(r.h),
        s: $a4d3ff2979ca24dc$var$n(r.s),
        l: $a4d3ff2979ca24dc$var$n(r.l),
        a: $a4d3ff2979ca24dc$var$n(r.a, 3)
    };
}, $a4d3ff2979ca24dc$var$f = function(r) {
    var t, n, e;
    return $a4d3ff2979ca24dc$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $a4d3ff2979ca24dc$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $a4d3ff2979ca24dc$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $a4d3ff2979ca24dc$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $a4d3ff2979ca24dc$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $a4d3ff2979ca24dc$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $a4d3ff2979ca24dc$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $a4d3ff2979ca24dc$var$y = {
    string: [
        [
            function(r) {
                var t = $a4d3ff2979ca24dc$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $a4d3ff2979ca24dc$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $a4d3ff2979ca24dc$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $a4d3ff2979ca24dc$var$v.exec(r) || $a4d3ff2979ca24dc$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $a4d3ff2979ca24dc$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $a4d3ff2979ca24dc$var$l.exec(t) || $a4d3ff2979ca24dc$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $a4d3ff2979ca24dc$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($a4d3ff2979ca24dc$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $a4d3ff2979ca24dc$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $a4d3ff2979ca24dc$var$t(n) && $a4d3ff2979ca24dc$var$t(e) && $a4d3ff2979ca24dc$var$t(u) ? $a4d3ff2979ca24dc$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$a4d3ff2979ca24dc$var$t(n) || !$a4d3ff2979ca24dc$var$t(e) || !$a4d3ff2979ca24dc$var$t(u)) return null;
                var i = $a4d3ff2979ca24dc$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $a4d3ff2979ca24dc$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$a4d3ff2979ca24dc$var$t(n) || !$a4d3ff2979ca24dc$var$t(a) || !$a4d3ff2979ca24dc$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $a4d3ff2979ca24dc$var$u(r.h),
                        s: $a4d3ff2979ca24dc$var$e(r.s, 0, 100),
                        v: $a4d3ff2979ca24dc$var$e(r.v, 0, 100),
                        a: $a4d3ff2979ca24dc$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $a4d3ff2979ca24dc$var$b(h);
            },
            "hsv"
        ]
    ]
}, $a4d3ff2979ca24dc$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $a4d3ff2979ca24dc$var$x = function(r) {
    return "string" == typeof r ? $a4d3ff2979ca24dc$var$N(r.trim(), $a4d3ff2979ca24dc$var$y.string) : "object" == typeof r && null !== r ? $a4d3ff2979ca24dc$var$N(r, $a4d3ff2979ca24dc$var$y.object) : [
        null,
        void 0
    ];
}, $a4d3ff2979ca24dc$export$f61ac8b6f1f46202 = function(r) {
    return $a4d3ff2979ca24dc$var$x(r)[1];
}, $a4d3ff2979ca24dc$var$M = function(r, t) {
    var n = $a4d3ff2979ca24dc$var$c(r);
    return {
        h: n.h,
        s: $a4d3ff2979ca24dc$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $a4d3ff2979ca24dc$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $a4d3ff2979ca24dc$var$$ = function(r, t) {
    var n = $a4d3ff2979ca24dc$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $a4d3ff2979ca24dc$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $a4d3ff2979ca24dc$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $a4d3ff2979ca24dc$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $a4d3ff2979ca24dc$var$n($a4d3ff2979ca24dc$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $a4d3ff2979ca24dc$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $a4d3ff2979ca24dc$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $a4d3ff2979ca24dc$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $a4d3ff2979ca24dc$var$s($a4d3ff2979ca24dc$var$n(255 * a)) : "", "#" + $a4d3ff2979ca24dc$var$s(t) + $a4d3ff2979ca24dc$var$s(e) + $a4d3ff2979ca24dc$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $a4d3ff2979ca24dc$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $a4d3ff2979ca24dc$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $a4d3ff2979ca24dc$var$d($a4d3ff2979ca24dc$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $a4d3ff2979ca24dc$var$d($a4d3ff2979ca24dc$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $a4d3ff2979ca24dc$var$h(this.rgba), {
            h: $a4d3ff2979ca24dc$var$n(r.h),
            s: $a4d3ff2979ca24dc$var$n(r.s),
            v: $a4d3ff2979ca24dc$var$n(r.v),
            a: $a4d3ff2979ca24dc$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $a4d3ff2979ca24dc$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $a4d3ff2979ca24dc$export$c8efe09109f9cb9e($a4d3ff2979ca24dc$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $a4d3ff2979ca24dc$export$c8efe09109f9cb9e($a4d3ff2979ca24dc$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $a4d3ff2979ca24dc$export$c8efe09109f9cb9e($a4d3ff2979ca24dc$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $a4d3ff2979ca24dc$export$c8efe09109f9cb9e($a4d3ff2979ca24dc$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $a4d3ff2979ca24dc$export$c8efe09109f9cb9e($a4d3ff2979ca24dc$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $a4d3ff2979ca24dc$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $a4d3ff2979ca24dc$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $a4d3ff2979ca24dc$var$c(this.rgba);
        return "number" == typeof r ? $a4d3ff2979ca24dc$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $a4d3ff2979ca24dc$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $a4d3ff2979ca24dc$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $a4d3ff2979ca24dc$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $a4d3ff2979ca24dc$export$4d30ed660ff08d0 ? r : new $a4d3ff2979ca24dc$export$4d30ed660ff08d0(r);
}, $a4d3ff2979ca24dc$var$S = [], $a4d3ff2979ca24dc$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $a4d3ff2979ca24dc$var$S.indexOf(r) < 0 && (r($a4d3ff2979ca24dc$export$4d30ed660ff08d0, $a4d3ff2979ca24dc$var$y), $a4d3ff2979ca24dc$var$S.push(r));
    });
}, $a4d3ff2979ca24dc$export$4385e60b38654f68 = function() {
    return new $a4d3ff2979ca24dc$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};



const $82ad6261094eeb6d$var$WOBBLE = 30;
function $82ad6261094eeb6d$export$8f45430ccf837300(seeder) {
    const amount = seeder() * $82ad6261094eeb6d$var$WOBBLE - $82ad6261094eeb6d$var$WOBBLE / 2;
    const all = (0, $81dcd2a4da154661$export$56d196d2844d1ca1).map((hex)=>(0, $a4d3ff2979ca24dc$export$c8efe09109f9cb9e)(hex).rotate(amount));
    return (alpha = 1)=>{
        const index = Math.floor(all.length * seeder());
        return all.splice(index, 1)[0].alpha(alpha).toHslString();
    };
}


function $5ccb5d7d2d10e666$export$34e0f9847d4c02dd(diameter, background = "white", className = "", _style = {}) {
    const element = document.createElement("div");
    const style = Object.assign({
        background: background,
        borderRadius: `${diameter / 2}px`,
        display: "inline-block",
        height: `${diameter}px`,
        margin: "0px",
        overflow: "hidden",
        padding: "0px",
        width: `${diameter}px`
    }, _style);
    element.className = className;
    element.style.background = background;
    Object.keys(style).forEach((key)=>{
        element.style[key] = style[key];
    });
    return element;
}




const $9151f5ade204161e$var$DIVISOR = 65536;
function $9151f5ade204161e$export$e8563c1a19a6a73a(_seed = new Uint8Array(32)) {
    const seed = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(_seed) ? _seed : (0, $1b66c29e6169cf04$export$e66335b9b1239eaf)(_seed);
    let index = seed[Math.floor(seed.length / 2)] % seed.length - 1;
    const next = ()=>{
        index += 1;
        if (index === seed.length) index = 0;
        return seed[index];
    };
    return ()=>{
        return (next() * 256 + next()) / $9151f5ade204161e$var$DIVISOR;
    };
}


function $af40e68ee5457773$export$4a111e565dd94bc5(seed, { size: size = 256 }, className = "", style) {
    const seeder = (0, $9151f5ade204161e$export$e8563c1a19a6a73a)(seed);
    const colorGen = (0, $82ad6261094eeb6d$export$8f45430ccf837300)(seeder);
    const outer = (0, $5ccb5d7d2d10e666$export$34e0f9847d4c02dd)(size, "white", className, style);
    const container = (0, $5ccb5d7d2d10e666$export$34e0f9847d4c02dd)(size, colorGen());
    const svg = (0, $893310e78ef5da0e$export$8454457683f90105)(size);
    outer.appendChild(container);
    container.appendChild(svg);
    for(let count = 0; count < (0, $81dcd2a4da154661$export$8b5db91aebc0c140); count++){
        const fill = colorGen();
        const shape = (0, $c4c7ac6649519ade$export$e1d786d2f707b414)(seeder, fill, size, count);
        svg.appendChild(shape);
    }
    return outer;
}


function $76fca3c684e0769f$var$Identicon({ address: address, className: className = "", size: size, style: style = {} }) {
    const updateElem = (0, $4Iuzv.useCallback)((node)=>{
        node && node.appendChild((0, $af40e68ee5457773$export$4a111e565dd94bc5)(address, {
            isAlternative: false,
            size: size
        }));
    }, [
        address,
        size
    ]);
    return (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: className,
        ref: updateElem,
        style: style
    });
}
const $76fca3c684e0769f$export$cdad1aec2bf7dbc3 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo($76fca3c684e0769f$var$Identicon);



var $4Iuzv = parcelRequire("4Iuzv");
function $c2d773e70b8269a4$var$Identicon({ className: className = "", size: size, style: style = {} }) {
    return (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        height: size,
        style: style,
        viewBox: "0 0 64 64",
        width: size
    });
}
const $c2d773e70b8269a4$export$1f74963c34e8bfec = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo($c2d773e70b8269a4$var$Identicon);


var $bf089e35853ea7b7$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $bf089e35853ea7b7$exports = factory();
})($bf089e35853ea7b7$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ exports: {},
                /******/ id: moduleId,
                /******/ loaded: false
            };
            /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            const pnglib = __webpack_require__(1);
            const hsl2rgb = __webpack_require__(2);
            // The random number is a js implementation of the Xorshift PRNG
            const randseed = new Array(4); // Xorshift: [x, y, z, w] 32 bit values
            function seedrand(seed) {
                for(let i = 0; i < randseed.length; i++)randseed[i] = 0;
                for(let i = 0; i < seed.length; i++)randseed[i % 4] = (randseed[i % 4] << 5) - randseed[i % 4] + seed.charCodeAt(i);
            }
            function rand() {
                // based on Java's String.hashCode(), expanded to 4 32bit values
                const t = randseed[0] ^ randseed[0] << 11;
                randseed[0] = randseed[1];
                randseed[1] = randseed[2];
                randseed[2] = randseed[3];
                randseed[3] = randseed[3] ^ randseed[3] >> 19 ^ t ^ t >> 8;
                return (randseed[3] >>> 0) / 2147483648;
            }
            function createColor() {
                //saturation is the whole color spectrum
                const h = Math.floor(rand() * 360);
                //saturation goes from 40 to 100, it avoids greyish colors
                const s = rand() * 60 + 40;
                //lightness can be anything from 0 to 100, but probabilities are a bell curve around 50%
                const l = (rand() + rand() + rand() + rand()) * 25;
                return [
                    h / 360,
                    s / 100,
                    l / 100
                ];
            }
            function createImageData(size) {
                const width = size; // Only support square icons for now
                const height = size;
                const dataWidth = Math.ceil(width / 2);
                const mirrorWidth = width - dataWidth;
                const data = [];
                for(let y = 0; y < height; y++){
                    let row = [];
                    for(let x = 0; x < dataWidth; x++)// this makes foreground and background color to have a 43% (1/2.3) probability
                    // spot color has 13% chance
                    row[x] = Math.floor(rand() * 2.3);
                    const r = row.slice(0, mirrorWidth).reverse();
                    row = row.concat(r);
                    for(let i = 0; i < row.length; i++)data.push(row[i]);
                }
                return data;
            }
            // Modifies the passed PNG to fill in a specified rectangle
            function fillRect(png, x, y, w, h, color) {
                for(let i = 0; i < w; i++)for(let j = 0; j < h; j++)png.buffer[png.index(x + i, y + j)] = color;
            }
            function buildOpts(opts) {
                if (!opts.seed) throw new Error("No seed provided");
                seedrand(opts.seed);
                return Object.assign({
                    size: 8,
                    scale: 16,
                    color: createColor(),
                    bgcolor: createColor(),
                    spotcolor: createColor()
                }, opts);
            }
            function makeBlockie(address) {
                const opts = buildOpts({
                    seed: address.toLowerCase()
                });
                const imageData = createImageData(opts.size);
                const width = Math.sqrt(imageData.length);
                const p = new pnglib(opts.size * opts.scale, opts.size * opts.scale, 3);
                const bgcolor = p.color(...hsl2rgb(...opts.bgcolor));
                const color = p.color(...hsl2rgb(...opts.color));
                const spotcolor = p.color(...hsl2rgb(...opts.spotcolor));
                for(let i = 0; i < imageData.length; i++){
                    const row = Math.floor(i / width);
                    const col = i % width;
                    // if data is 0, leave the background
                    if (imageData[i]) {
                        // if data is 2, choose spot color, if 1 choose foreground
                        const pngColor = imageData[i] == 1 ? color : spotcolor;
                        fillRect(p, col * opts.scale, row * opts.scale, opts.scale, opts.scale, pngColor);
                    }
                }
                return `data:image/png;base64,${p.getBase64()}`;
            }
            module1.exports = makeBlockie;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
	 * A handy class to calculate color values.
	 *
	 * @version 1.0
	 * @author Robert Eisele <robert@xarg.org>
	 * @copyright Copyright (c) 2010, Robert Eisele
	 * @link http://www.xarg.org/2010/03/generate-client-side-png-files-using-javascript/
	 * @license http://www.opensource.org/licenses/bsd-license.php BSD License
	 *
	 */ // Modified by George Chan <gchan@21cn.com>
            // Further modified by Will O'B <@wbobeirne> to make it
            // UglifyJS and "use strict"; friendly
            module1.exports = function(width, height, depth) {
                // helper functions for that ctx
                function write(buffer, offs) {
                    for(var i = 2; i < arguments.length; i++)for(var j = 0; j < arguments[i].length; j++)buffer[offs++] = arguments[i].charAt(j);
                }
                function byte2(w) {
                    return String.fromCharCode(w >> 8 & 255, w & 255);
                }
                function byte4(w) {
                    return String.fromCharCode(w >> 24 & 255, w >> 16 & 255, w >> 8 & 255, w & 255);
                }
                function byte2lsb(w) {
                    return String.fromCharCode(w & 255, w >> 8 & 255);
                }
                this.width = width;
                this.height = height;
                this.depth = depth;
                // pixel data and row filter identifier size
                this.pix_size = height * (width + 1);
                // deflate header, pix_size, block headers, adler32 checksum
                this.data_size = 2 + this.pix_size + 5 * Math.floor((0xfffe + this.pix_size) / 0xffff) + 4;
                // offsets and sizes of Png chunks
                this.ihdr_offs = 0; // IHDR offset and size
                this.ihdr_size = 25;
                this.plte_offs = this.ihdr_offs + this.ihdr_size; // PLTE offset and size
                this.plte_size = 8 + 3 * depth + 4;
                this.trns_offs = this.plte_offs + this.plte_size; // tRNS offset and size
                this.trns_size = 8 + depth + 4;
                this.idat_offs = this.trns_offs + this.trns_size; // IDAT offset and size
                this.idat_size = 8 + this.data_size + 4;
                this.iend_offs = this.idat_offs + this.idat_size; // IEND offset and size
                this.iend_size = 12;
                this.buffer_size = this.iend_offs + this.iend_size; // total PNG size
                this.buffer = new Array();
                this.palette = new Object();
                this.pindex = 0;
                var _crc32 = new Array();
                // initialize buffer with zero bytes
                for(var i = 0; i < this.buffer_size; i++)this.buffer[i] = "\x00";
                // initialize non-zero elements
                write(this.buffer, this.ihdr_offs, byte4(this.ihdr_size - 12), "IHDR", byte4(width), byte4(height), "\b\x03");
                write(this.buffer, this.plte_offs, byte4(this.plte_size - 12), "PLTE");
                write(this.buffer, this.trns_offs, byte4(this.trns_size - 12), "tRNS");
                write(this.buffer, this.idat_offs, byte4(this.idat_size - 12), "IDAT");
                write(this.buffer, this.iend_offs, byte4(this.iend_size - 12), "IEND");
                // initialize deflate header
                var header = 30912;
                header += 31 - header % 31;
                write(this.buffer, this.idat_offs + 8, byte2(header));
                // initialize deflate block headers
                for(var i = 0; (i << 16) - 1 < this.pix_size; i++){
                    var size, bits;
                    if (i + 0xffff < this.pix_size) {
                        size = 0xffff;
                        bits = "\x00";
                    } else {
                        size = this.pix_size - (i << 16) - i;
                        bits = "\x01";
                    }
                    write(this.buffer, this.idat_offs + 8 + 2 + (i << 16) + (i << 2), bits, byte2lsb(size), byte2lsb(~size));
                }
                /* Create crc32 lookup table */ for(var i = 0; i < 256; i++){
                    var c = i;
                    for(var j = 0; j < 8; j++)if (c & 1) c = -306674912 ^ c >> 1 & 0x7fffffff;
                    else c = c >> 1 & 0x7fffffff;
                    _crc32[i] = c;
                }
                // compute the index into a png for a given pixel
                this.index = function(x, y) {
                    var i = y * (this.width + 1) + x + 1;
                    var j = this.idat_offs + 8 + 2 + 5 * Math.floor(i / 0xffff + 1) + i;
                    return j;
                };
                // convert a color and build up the palette
                this.color = function(red, green, blue, alpha) {
                    alpha = alpha >= 0 ? alpha : 255;
                    var color = ((alpha << 8 | red) << 8 | green) << 8 | blue;
                    if (typeof this.palette[color] == "undefined") {
                        if (this.pindex == this.depth) return "\x00";
                        var ndx = this.plte_offs + 8 + 3 * this.pindex;
                        this.buffer[ndx + 0] = String.fromCharCode(red);
                        this.buffer[ndx + 1] = String.fromCharCode(green);
                        this.buffer[ndx + 2] = String.fromCharCode(blue);
                        this.buffer[this.trns_offs + 8 + this.pindex] = String.fromCharCode(alpha);
                        this.palette[color] = String.fromCharCode(this.pindex++);
                    }
                    return this.palette[color];
                };
                // output a PNG string, Base64 encoded
                this.getBase64 = function() {
                    var s = this.getDump();
                    var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var c1, c2, c3, e1, e2, e3, e4;
                    var l = s.length;
                    var i = 0;
                    var r = "";
                    do {
                        c1 = s.charCodeAt(i);
                        e1 = c1 >> 2;
                        c2 = s.charCodeAt(i + 1);
                        e2 = (c1 & 3) << 4 | c2 >> 4;
                        c3 = s.charCodeAt(i + 2);
                        if (l < i + 2) e3 = 64;
                        else e3 = (c2 & 0xf) << 2 | c3 >> 6;
                        if (l < i + 3) e4 = 64;
                        else e4 = c3 & 0x3f;
                        r += ch.charAt(e1) + ch.charAt(e2) + ch.charAt(e3) + ch.charAt(e4);
                    }while ((i += 3) < l);
                    return r;
                };
                // output a PNG string
                this.getDump = function() {
                    // compute adler32 of output pixels + row filter bytes
                    var BASE = 65521; /* largest prime smaller than 65536 */ 
                    var NMAX = 5552; /* NMAX is the largest n such that 255n(n+1)/2 + (n+1)(BASE-1) <= 2^32-1 */ 
                    var s1 = 1;
                    var s2 = 0;
                    var n = NMAX;
                    for(var y = 0; y < this.height; y++)for(var x = -1; x < this.width; x++){
                        s1 += this.buffer[this.index(x, y)].charCodeAt(0);
                        s2 += s1;
                        if ((n -= 1) == 0) {
                            s1 %= BASE;
                            s2 %= BASE;
                            n = NMAX;
                        }
                    }
                    s1 %= BASE;
                    s2 %= BASE;
                    write(this.buffer, this.idat_offs + this.idat_size - 8, byte4(s2 << 16 | s1));
                    // compute crc32 of the PNG chunks
                    function crc32(png, offs, size) {
                        var crc = -1;
                        for(var i = 4; i < size - 4; i += 1)crc = _crc32[(crc ^ png[offs + i].charCodeAt(0)) & 0xff] ^ crc >> 8 & 0x00ffffff;
                        write(png, offs + size - 4, byte4(crc ^ -1));
                    }
                    crc32(this.buffer, this.ihdr_offs, this.ihdr_size);
                    crc32(this.buffer, this.plte_offs, this.plte_size);
                    crc32(this.buffer, this.trns_offs, this.trns_size);
                    crc32(this.buffer, this.idat_offs, this.idat_size);
                    crc32(this.buffer, this.iend_offs, this.iend_size);
                    // convert PNG to string
                    return "\x89PNG\r\n\x1a\n" + this.buffer.join("");
                };
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            // https://stackoverflow.com/questions/2353211/hsl-to-rgb-color-conversion
            /**
	 * Converts an HSL color value to RGB. Conversion formula
	 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
	 * Assumes h, s, and l are contained in the set [0, 1] and
	 * returns r, g, and b in the set [0, 255].
	 *
	 * @param   {number}  h       The hue
	 * @param   {number}  s       The saturation
	 * @param   {number}  l       The lightness
	 * @return  {Array}           The RGB representation
	 */ function hue2rgb(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 0.5) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            }
            function hsl2rgb(h, s, l) {
                let r, g, b;
                if (s == 0) r = g = b = l; // achromatic
                else {
                    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    const p = 2 * l - q;
                    r = hue2rgb(p, q, h + 1 / 3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1 / 3);
                }
                return [
                    Math.round(r * 255),
                    Math.round(g * 255),
                    Math.round(b * 255),
                    255
                ];
            }
            module1.exports = hsl2rgb;
        /***/ }
    ]);
});



var $4Iuzv = parcelRequire("4Iuzv");
var $c009d25364177c1b$exports = {};
"use strict";

$c009d25364177c1b$exports = (parcelRequire("d21w1"));



var $4Iuzv = parcelRequire("4Iuzv");
var $28ad59042aff93bc$exports = {};
//
$28ad59042aff93bc$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $5b570e5a0b530090$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $5b570e5a0b530090$export$2e2bcd8739ae039 = $5b570e5a0b530090$var$stylis_min;


var $e4d961ca08e2a518$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $e4d961ca08e2a518$export$2e2bcd8739ae039 = $e4d961ca08e2a518$var$unitlessKeys;


function $aa177298e59cad41$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $aee56ff00fae488f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $aee56ff00fae488f$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $aa177298e59cad41$export$2e2bcd8739ae039)(function(prop) {
    return $aee56ff00fae488f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $73bbc0bea28e4f9a$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $73bbc0bea28e4f9a$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $73bbc0bea28e4f9a$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $73bbc0bea28e4f9a$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $73bbc0bea28e4f9a$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $73bbc0bea28e4f9a$var$TYPE_STATICS = {};
$73bbc0bea28e4f9a$var$TYPE_STATICS[$c009d25364177c1b$exports.ForwardRef] = $73bbc0bea28e4f9a$var$FORWARD_REF_STATICS;
$73bbc0bea28e4f9a$var$TYPE_STATICS[$c009d25364177c1b$exports.Memo] = $73bbc0bea28e4f9a$var$MEMO_STATICS;
function $73bbc0bea28e4f9a$var$getStatics(component) {
    // React v16.11 and below
    if ($c009d25364177c1b$exports.isMemo(component)) return $73bbc0bea28e4f9a$var$MEMO_STATICS;
     // React v16.12 and above
    return $73bbc0bea28e4f9a$var$TYPE_STATICS[component["$$typeof"]] || $73bbc0bea28e4f9a$var$REACT_STATICS;
}
var $73bbc0bea28e4f9a$var$defineProperty = Object.defineProperty;
var $73bbc0bea28e4f9a$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $73bbc0bea28e4f9a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $73bbc0bea28e4f9a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $73bbc0bea28e4f9a$var$getPrototypeOf = Object.getPrototypeOf;
var $73bbc0bea28e4f9a$var$objectPrototype = Object.prototype;
function $73bbc0bea28e4f9a$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($73bbc0bea28e4f9a$var$objectPrototype) {
            var inheritedComponent = $73bbc0bea28e4f9a$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $73bbc0bea28e4f9a$var$objectPrototype) $73bbc0bea28e4f9a$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $73bbc0bea28e4f9a$var$getOwnPropertyNames(sourceComponent);
        if ($73bbc0bea28e4f9a$var$getOwnPropertySymbols) keys = keys.concat($73bbc0bea28e4f9a$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $73bbc0bea28e4f9a$var$getStatics(targetComponent);
        var sourceStatics = $73bbc0bea28e4f9a$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$73bbc0bea28e4f9a$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $73bbc0bea28e4f9a$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $73bbc0bea28e4f9a$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$73bbc0bea28e4f9a$exports = $73bbc0bea28e4f9a$var$hoistNonReactStatics;



function $88daf2a39afbf88c$var$y() {
    return ($88daf2a39afbf88c$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $88daf2a39afbf88c$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $88daf2a39afbf88c$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $c009d25364177c1b$exports.typeOf)(t);
}, $88daf2a39afbf88c$var$S = Object.freeze([]), $88daf2a39afbf88c$var$w = Object.freeze({});
function $88daf2a39afbf88c$var$E(e) {
    return "function" == typeof e;
}
function $88daf2a39afbf88c$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $88daf2a39afbf88c$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $88daf2a39afbf88c$var$N = ("undefined" != typeof $5671edd534fa79c4$exports && void 0 !== $5671edd534fa79c4$exports.env && undefined, "data-styled"), $88daf2a39afbf88c$export$83d89fbfd8236492 = "5.3.11", $88daf2a39afbf88c$var$C = "undefined" != typeof window && "HTMLElement" in window, $88daf2a39afbf88c$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $5671edd534fa79c4$exports && void 0 !== $5671edd534fa79c4$exports.env && false), $88daf2a39afbf88c$var$P = {}, $88daf2a39afbf88c$var$O = {};
function $88daf2a39afbf88c$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $88daf2a39afbf88c$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $88daf2a39afbf88c$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $88daf2a39afbf88c$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $88daf2a39afbf88c$var$T = new Map, $88daf2a39afbf88c$var$x = new Map, $88daf2a39afbf88c$var$k = 1, $88daf2a39afbf88c$var$V = function(e) {
    if ($88daf2a39afbf88c$var$T.has(e)) return $88daf2a39afbf88c$var$T.get(e);
    for(; $88daf2a39afbf88c$var$x.has($88daf2a39afbf88c$var$k);)$88daf2a39afbf88c$var$k++;
    var t = $88daf2a39afbf88c$var$k++;
    return $88daf2a39afbf88c$var$T.set(e, t), $88daf2a39afbf88c$var$x.set(t, e), t;
}, $88daf2a39afbf88c$var$B = function(e) {
    return $88daf2a39afbf88c$var$x.get(e);
}, $88daf2a39afbf88c$var$z = function(e, t) {
    t >= $88daf2a39afbf88c$var$k && ($88daf2a39afbf88c$var$k = t + 1), $88daf2a39afbf88c$var$T.set(e, t), $88daf2a39afbf88c$var$x.set(t, e);
}, $88daf2a39afbf88c$var$M = "style[" + $88daf2a39afbf88c$var$N + '][data-styled-version="5.3.11"]', $88daf2a39afbf88c$var$G = new RegExp("^" + $88daf2a39afbf88c$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $88daf2a39afbf88c$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $88daf2a39afbf88c$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($88daf2a39afbf88c$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($88daf2a39afbf88c$var$z(u, c), $88daf2a39afbf88c$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $88daf2a39afbf88c$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $88daf2a39afbf88c$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($88daf2a39afbf88c$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($88daf2a39afbf88c$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $88daf2a39afbf88c$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $88daf2a39afbf88c$var$H = function() {
    function e(e) {
        var t = this.element = $88daf2a39afbf88c$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $88daf2a39afbf88c$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $88daf2a39afbf88c$var$$ = function() {
    function e(e) {
        var t = this.element = $88daf2a39afbf88c$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $88daf2a39afbf88c$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $88daf2a39afbf88c$var$U = $88daf2a39afbf88c$var$C, $88daf2a39afbf88c$var$J = {
    isServer: !$88daf2a39afbf88c$var$C,
    useCSSOMInjection: !$88daf2a39afbf88c$var$I
}, $88daf2a39afbf88c$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $88daf2a39afbf88c$var$w), void 0 === t && (t = {}), this.options = $88daf2a39afbf88c$var$y({}, $88daf2a39afbf88c$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $88daf2a39afbf88c$var$C && $88daf2a39afbf88c$var$U && ($88daf2a39afbf88c$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($88daf2a39afbf88c$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($88daf2a39afbf88c$var$N) && ($88daf2a39afbf88c$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $88daf2a39afbf88c$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($88daf2a39afbf88c$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $88daf2a39afbf88c$var$W(o) : r ? new $88daf2a39afbf88c$var$H(o) : new $88daf2a39afbf88c$var$$(o), new $88daf2a39afbf88c$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($88daf2a39afbf88c$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($88daf2a39afbf88c$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($88daf2a39afbf88c$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $88daf2a39afbf88c$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $88daf2a39afbf88c$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $88daf2a39afbf88c$var$Z = /(a)(d)/gi, $88daf2a39afbf88c$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $88daf2a39afbf88c$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $88daf2a39afbf88c$var$K(t % 52) + n;
    return ($88daf2a39afbf88c$var$K(t % 52) + n).replace($88daf2a39afbf88c$var$Z, "$1-$2");
}
var $88daf2a39afbf88c$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $88daf2a39afbf88c$var$te = function(e) {
    return $88daf2a39afbf88c$var$ee(5381, e);
};
function $88daf2a39afbf88c$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($88daf2a39afbf88c$var$E(n) && !$88daf2a39afbf88c$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $88daf2a39afbf88c$var$re = $88daf2a39afbf88c$var$te("5.3.11"), $88daf2a39afbf88c$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $88daf2a39afbf88c$var$ne(e), this.componentId = t, this.baseHash = $88daf2a39afbf88c$var$ee($88daf2a39afbf88c$var$re, t), this.baseStyle = n, $88daf2a39afbf88c$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $88daf2a39afbf88c$var$_e(this.rules, e, t, n).join(""), i = $88daf2a39afbf88c$var$Q($88daf2a39afbf88c$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $88daf2a39afbf88c$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $88daf2a39afbf88c$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $88daf2a39afbf88c$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $88daf2a39afbf88c$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $88daf2a39afbf88c$var$se = /^\s*\/\/.*$/gm, $88daf2a39afbf88c$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $88daf2a39afbf88c$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $88daf2a39afbf88c$var$w : e, i = s.options, a = void 0 === i ? $88daf2a39afbf88c$var$w : i, c = s.plugins, u = void 0 === c ? $88daf2a39afbf88c$var$S : c, l = new (0, $5b570e5a0b530090$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $88daf2a39afbf88c$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($88daf2a39afbf88c$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $88daf2a39afbf88c$var$D(15), $88daf2a39afbf88c$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $88daf2a39afbf88c$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext(), $88daf2a39afbf88c$export$91317688fc694efa = $88daf2a39afbf88c$export$8c190ef828af4c86.Consumer, $88daf2a39afbf88c$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext(), $88daf2a39afbf88c$var$de = ($88daf2a39afbf88c$var$le.Consumer, new $88daf2a39afbf88c$var$X), $88daf2a39afbf88c$var$he = $88daf2a39afbf88c$var$ae();
function $88daf2a39afbf88c$var$pe() {
    return (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$8c190ef828af4c86) || $88daf2a39afbf88c$var$de;
}
function $88daf2a39afbf88c$var$fe() {
    return (0, $4Iuzv.useContext)($88daf2a39afbf88c$var$le) || $88daf2a39afbf88c$var$he;
}
function $88daf2a39afbf88c$export$a473771da2f0ff7c(e) {
    var t = (0, $4Iuzv.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $88daf2a39afbf88c$var$pe(), u = (0, $4Iuzv.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $4Iuzv.useMemo)(function() {
        return $88daf2a39afbf88c$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $4Iuzv.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($28ad59042aff93bc$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $88daf2a39afbf88c$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $88daf2a39afbf88c$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $88daf2a39afbf88c$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $88daf2a39afbf88c$var$he), this.name + e.hash;
    }, e;
}(), $88daf2a39afbf88c$var$ve = /([A-Z])/, $88daf2a39afbf88c$var$ge = /([A-Z])/g, $88daf2a39afbf88c$var$Se = /^ms-/, $88daf2a39afbf88c$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $88daf2a39afbf88c$var$Ee(e) {
    return $88daf2a39afbf88c$var$ve.test(e) ? e.replace($88daf2a39afbf88c$var$ge, $88daf2a39afbf88c$var$we).replace($88daf2a39afbf88c$var$Se, "-ms-") : e;
}
var $88daf2a39afbf88c$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $88daf2a39afbf88c$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $88daf2a39afbf88c$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($88daf2a39afbf88c$var$be(e)) return "";
    if ($88daf2a39afbf88c$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($88daf2a39afbf88c$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $88daf2a39afbf88c$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $88daf2a39afbf88c$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $88daf2a39afbf88c$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$88daf2a39afbf88c$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $88daf2a39afbf88c$var$E(t[i]) ? s.push($88daf2a39afbf88c$var$Ee(i) + ":", t[i], ";") : $88daf2a39afbf88c$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($88daf2a39afbf88c$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $e4d961ca08e2a518$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $88daf2a39afbf88c$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $88daf2a39afbf88c$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $88daf2a39afbf88c$var$E(e) || $88daf2a39afbf88c$var$g(e) ? $88daf2a39afbf88c$var$Ne($88daf2a39afbf88c$var$_e($88daf2a39afbf88c$var$v($88daf2a39afbf88c$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $88daf2a39afbf88c$var$Ne($88daf2a39afbf88c$var$_e($88daf2a39afbf88c$var$v(e, n)));
}
var $88daf2a39afbf88c$var$Ce = /invalid hook call/i, $88daf2a39afbf88c$var$Ie = new Set, $88daf2a39afbf88c$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $88daf2a39afbf88c$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $88daf2a39afbf88c$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $88daf2a39afbf88c$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $88daf2a39afbf88c$var$De = /(^-|-$)/g;
function $88daf2a39afbf88c$var$je(e) {
    return e.replace($88daf2a39afbf88c$var$Re, "-").replace($88daf2a39afbf88c$var$De, "");
}
var $88daf2a39afbf88c$var$Te = function(e) {
    return $88daf2a39afbf88c$var$Q($88daf2a39afbf88c$var$te(e) >>> 0);
};
function $88daf2a39afbf88c$var$xe(e) {
    return "string" == typeof e && true;
}
var $88daf2a39afbf88c$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $88daf2a39afbf88c$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $88daf2a39afbf88c$var$Be(e, t, n) {
    var r = e[n];
    $88daf2a39afbf88c$var$ke(t) && $88daf2a39afbf88c$var$ke(r) ? $88daf2a39afbf88c$var$ze(r, t) : e[n] = t;
}
function $88daf2a39afbf88c$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($88daf2a39afbf88c$var$ke(i)) for(var a in i)$88daf2a39afbf88c$var$Ve(a) && $88daf2a39afbf88c$var$Be(e, i[a], a);
    }
    return e;
}
var $88daf2a39afbf88c$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext(), $88daf2a39afbf88c$export$b631efc24e9d5e2f = $88daf2a39afbf88c$export$2c657da244d00bd6.Consumer;
function $88daf2a39afbf88c$export$d8964aec282183a3(e) {
    var t = (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$2c657da244d00bd6), n = (0, $4Iuzv.useMemo)(function() {
        return function(e, t) {
            if (!e) return $88daf2a39afbf88c$var$D(14);
            if ($88daf2a39afbf88c$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $88daf2a39afbf88c$var$D(8) : t ? $88daf2a39afbf88c$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $88daf2a39afbf88c$var$Fe = {};
function $88daf2a39afbf88c$var$Ye(e, t, n) {
    var o = $88daf2a39afbf88c$export$7ba318d8d2f06c76(e), i = !$88daf2a39afbf88c$var$xe(e), a = t.attrs, c = void 0 === a ? $88daf2a39afbf88c$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $88daf2a39afbf88c$var$je(e);
        $88daf2a39afbf88c$var$Fe[n] = ($88daf2a39afbf88c$var$Fe[n] || 0) + 1;
        var r = n + "-" + $88daf2a39afbf88c$var$Te("5.3.11" + n + $88daf2a39afbf88c$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $88daf2a39afbf88c$var$xe(e) ? "styled." + e : "Styled(" + $88daf2a39afbf88c$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $88daf2a39afbf88c$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $88daf2a39afbf88c$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $88daf2a39afbf88c$var$w);
                var r = $88daf2a39afbf88c$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $88daf2a39afbf88c$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($88daf2a39afbf88c$var$Oe(t, (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$2c657da244d00bd6), a) || $88daf2a39afbf88c$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $88daf2a39afbf88c$var$pe(), s = $88daf2a39afbf88c$var$fe(), i = t ? e.generateAndInjectStyles($88daf2a39afbf88c$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $88daf2a39afbf88c$var$xe(b), N = v !== t ? $88daf2a39afbf88c$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $aee56ff00fae488f$export$2e2bcd8739ae039), b) : !_ || (0, $aee56ff00fae488f$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $88daf2a39afbf88c$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $4Iuzv.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $88daf2a39afbf88c$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($88daf2a39afbf88c$var$xe(e) ? e : $88daf2a39afbf88c$var$je($88daf2a39afbf88c$var$b(e)));
        return $88daf2a39afbf88c$var$Ye(e, $88daf2a39afbf88c$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $88daf2a39afbf88c$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($73bbc0bea28e4f9a$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $88daf2a39afbf88c$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $88daf2a39afbf88c$var$w), !(0, $c009d25364177c1b$exports.isValidElementType)(r)) return $88daf2a39afbf88c$var$D(1, String(r));
        var s = function() {
            return t(r, o, $88daf2a39afbf88c$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $88daf2a39afbf88c$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $88daf2a39afbf88c$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($88daf2a39afbf88c$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $88daf2a39afbf88c$var$qe[e] = $88daf2a39afbf88c$var$qe(e);
});
var $88daf2a39afbf88c$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $88daf2a39afbf88c$var$ne(e), $88daf2a39afbf88c$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($88daf2a39afbf88c$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $88daf2a39afbf88c$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $88daf2a39afbf88c$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $88daf2a39afbf88c$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $88daf2a39afbf88c$var$Te(JSON.stringify(i)), u = new $88daf2a39afbf88c$var$He(i, a);
    function d(e) {
        var t = $88daf2a39afbf88c$var$pe(), n = $88daf2a39afbf88c$var$fe(), o = (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$2c657da244d00bd6), d = (0, $4Iuzv.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $4Iuzv.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $88daf2a39afbf88c$var$P, n, o);
        else {
            var s = $88daf2a39afbf88c$var$y({}, t, {
                theme: $88daf2a39afbf88c$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo(d);
}
function $88daf2a39afbf88c$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $88daf2a39afbf88c$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $88daf2a39afbf88c$var$Te(o);
    return new $88daf2a39afbf88c$var$ye(s, o);
}
var $88daf2a39afbf88c$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $88daf2a39afbf88c$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $88daf2a39afbf88c$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $88daf2a39afbf88c$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $88daf2a39afbf88c$var$D(2);
            var n = ((t = {})[$88daf2a39afbf88c$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $88daf2a39afbf88c$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("style", $88daf2a39afbf88c$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $88daf2a39afbf88c$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $88daf2a39afbf88c$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($88daf2a39afbf88c$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $88daf2a39afbf88c$var$D(3);
    }, e;
}(), $88daf2a39afbf88c$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(function(t, n) {
        var o = (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$2c657da244d00bd6), i = e.defaultProps, a = $88daf2a39afbf88c$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(e, $88daf2a39afbf88c$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($73bbc0bea28e4f9a$exports)))(t, e), t.displayName = "WithTheme(" + $88daf2a39afbf88c$var$b(e) + ")", t;
}, $88daf2a39afbf88c$export$93d4e7f90805808f = function() {
    return (0, $4Iuzv.useContext)($88daf2a39afbf88c$export$2c657da244d00bd6);
}, $88daf2a39afbf88c$export$5c87cfe6c475f500 = {
    StyleSheet: $88daf2a39afbf88c$var$X,
    masterSheet: $88daf2a39afbf88c$var$de
};
var $88daf2a39afbf88c$export$2e2bcd8739ae039 = $88daf2a39afbf88c$var$qe;


const $17a9bc5f129a30aa$export$3817b7a54a07cec7 = (0, $88daf2a39afbf88c$export$2e2bcd8739ae039).styled || (0, $88daf2a39afbf88c$export$2e2bcd8739ae039).default || (0, $88daf2a39afbf88c$export$2e2bcd8739ae039);


function $f57a66bb0a1cbd43$var$Identicon({ address: address, className: className = "", size: size, style: style = {} }) {
    const imgSrc = (0, $4Iuzv.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bf089e35853ea7b7$exports)))(address), [
        address
    ]);
    return (0, $3c47adbabe8a32cb$exports.jsx)($f57a66bb0a1cbd43$var$StyledImg, {
        className: className,
        size: size,
        src: imgSrc,
        style: style
    });
}
const $f57a66bb0a1cbd43$var$StyledImg = (0, $17a9bc5f129a30aa$export$3817b7a54a07cec7).img(({ size: size })=>`
  display: block;
  height: ${size}px;
  width: ${size}px;
`);
const $f57a66bb0a1cbd43$export$aa318bacd7f710c5 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo($f57a66bb0a1cbd43$var$Identicon);


var $13374e707bb24dca$exports = {};
/**
 * Jdenticon 3.2.0
 * http://jdenticon.com
 *
 * Built: 2022-08-07T11:23:11.640Z
 * 
 * MIT License
 * 
 * Copyright (c) 2014-2021 Daniel Mester Pirttijärvi
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ "use strict";
/**
 * Parses a substring of the hash as a number.
 * @param {number} startPosition 
 * @param {number=} octets
 */ function $13374e707bb24dca$var$parseHex(hash, startPosition, octets) {
    return parseInt(hash.substr(startPosition, octets), 16);
}
function $13374e707bb24dca$var$decToHex(v) {
    v |= 0; // Ensure integer value
    return v < 0 ? "00" : v < 16 ? "0" + v.toString(16) : v < 256 ? v.toString(16) : "ff";
}
function $13374e707bb24dca$var$hueToRgb(m1, m2, h) {
    h = h < 0 ? h + 6 : h > 6 ? h - 6 : h;
    return $13374e707bb24dca$var$decToHex(255 * (h < 1 ? m1 + (m2 - m1) * h : h < 3 ? m2 : h < 4 ? m1 + (m2 - m1) * (4 - h) : m1));
}
/**
 * @param {string} color  Color value to parse. Currently hexadecimal strings on the format #rgb[a] and #rrggbb[aa] are supported.
 * @returns {string}
 */ function $13374e707bb24dca$var$parseColor(color) {
    if (/^#[0-9a-f]{3,8}$/i.test(color)) {
        var result;
        var colorLength = color.length;
        if (colorLength < 6) {
            var r = color[1], g = color[2], b = color[3], a = color[4] || "";
            result = "#" + r + r + g + g + b + b + a + a;
        }
        if (colorLength == 7 || colorLength > 8) result = color;
        return result;
    }
}
/**
 * Converts a hexadecimal color to a CSS3 compatible color.
 * @param {string} hexColor  Color on the format "#RRGGBB" or "#RRGGBBAA"
 * @returns {string}
 */ function $13374e707bb24dca$var$toCss3Color(hexColor) {
    var a = $13374e707bb24dca$var$parseHex(hexColor, 7, 2);
    var result;
    if (isNaN(a)) result = hexColor;
    else {
        var r = $13374e707bb24dca$var$parseHex(hexColor, 1, 2), g = $13374e707bb24dca$var$parseHex(hexColor, 3, 2), b = $13374e707bb24dca$var$parseHex(hexColor, 5, 2);
        result = "rgba(" + r + "," + g + "," + b + "," + (a / 255).toFixed(2) + ")";
    }
    return result;
}
/**
 * Converts an HSL color to a hexadecimal RGB color.
 * @param {number} hue  Hue in range [0, 1]
 * @param {number} saturation  Saturation in range [0, 1]
 * @param {number} lightness  Lightness in range [0, 1]
 * @returns {string}
 */ function $13374e707bb24dca$var$hsl(hue, saturation, lightness) {
    // Based on http://www.w3.org/TR/2011/REC-css3-color-20110607/#hsl-color
    var result;
    if (saturation == 0) {
        var partialHex = $13374e707bb24dca$var$decToHex(lightness * 255);
        result = partialHex + partialHex + partialHex;
    } else {
        var m2 = lightness <= 0.5 ? lightness * (saturation + 1) : lightness + saturation - lightness * saturation, m1 = lightness * 2 - m2;
        result = $13374e707bb24dca$var$hueToRgb(m1, m2, hue * 6 + 2) + $13374e707bb24dca$var$hueToRgb(m1, m2, hue * 6) + $13374e707bb24dca$var$hueToRgb(m1, m2, hue * 6 - 2);
    }
    return "#" + result;
}
/**
 * Converts an HSL color to a hexadecimal RGB color. This function will correct the lightness for the "dark" hues
 * @param {number} hue  Hue in range [0, 1]
 * @param {number} saturation  Saturation in range [0, 1]
 * @param {number} lightness  Lightness in range [0, 1]
 * @returns {string}
 */ function $13374e707bb24dca$var$correctedHsl(hue, saturation, lightness) {
    // The corrector specifies the perceived middle lightness for each hue
    var correctors = [
        0.55,
        0.5,
        0.5,
        0.46,
        0.6,
        0.55,
        0.55
    ], corrector = correctors[hue * 6 + 0.5 | 0];
    // Adjust the input lightness relative to the corrector
    lightness = lightness < 0.5 ? lightness * corrector * 2 : corrector + (lightness - 0.5) * (1 - corrector) * 2;
    return $13374e707bb24dca$var$hsl(hue, saturation, lightness);
}
// In the future we can replace `GLOBAL` with `globalThis`, but for now use the old school global detection for
// backward compatibility.
var $13374e707bb24dca$var$GLOBAL = typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : typeof $parcel$global !== "undefined" ? $parcel$global : {};
/**
 * @typedef {Object} ParsedConfiguration
 * @property {number} colorSaturation
 * @property {number} grayscaleSaturation
 * @property {string} backColor
 * @property {number} iconPadding
 * @property {function(number):number} hue
 * @property {function(number):number} colorLightness
 * @property {function(number):number} grayscaleLightness
 */ var $13374e707bb24dca$var$CONFIG_PROPERTIES = {
    W: "jdenticon_config",
    n: "config"
};
var $13374e707bb24dca$var$rootConfigurationHolder = {};
/**
 * Defines the deprecated `config` property on the root Jdenticon object without printing a warning in the console
 * when it is being used.
 * @param {!Object} rootObject 
 */ function $13374e707bb24dca$var$defineConfigProperty(rootObject) {
    $13374e707bb24dca$var$rootConfigurationHolder = rootObject;
}
/**
 * Sets a new icon style configuration. The new configuration is not merged with the previous one. * 
 * @param {Object} newConfiguration - New configuration object.
 */ function $13374e707bb24dca$var$configure(newConfiguration) {
    if (arguments.length) $13374e707bb24dca$var$rootConfigurationHolder[$13374e707bb24dca$var$CONFIG_PROPERTIES.n /*MODULE*/ ] = newConfiguration;
    return $13374e707bb24dca$var$rootConfigurationHolder[$13374e707bb24dca$var$CONFIG_PROPERTIES.n /*MODULE*/ ];
}
/**
 * Gets the normalized current Jdenticon color configuration. Missing fields have default values.
 * @param {Object|number|undefined} paddingOrLocalConfig - Configuration passed to the called API method. A
 *    local configuration overrides the global configuration in it entirety. This parameter can for backward
 *    compatibility also contain a padding value. A padding value only overrides the global padding, not the
 *    entire global configuration.
 * @param {number} defaultPadding - Padding used if no padding is specified in neither the configuration nor
 *    explicitly to the API method.
 * @returns {ParsedConfiguration}
 */ function $13374e707bb24dca$var$getConfiguration(paddingOrLocalConfig, defaultPadding) {
    var configObject = typeof paddingOrLocalConfig == "object" && paddingOrLocalConfig || $13374e707bb24dca$var$rootConfigurationHolder[$13374e707bb24dca$var$CONFIG_PROPERTIES.n /*MODULE*/ ] || $13374e707bb24dca$var$GLOBAL[$13374e707bb24dca$var$CONFIG_PROPERTIES.W /*GLOBAL*/ ] || {}, lightnessConfig = configObject["lightness"] || {}, // In versions < 2.1.0 there was no grayscale saturation -
    // saturation was the color saturation.
    saturation = configObject["saturation"] || {}, colorSaturation = "color" in saturation ? saturation["color"] : saturation, grayscaleSaturation = saturation["grayscale"], backColor = configObject["backColor"], padding = configObject["padding"];
    /**
     * Creates a lightness range.
     */ function lightness(configName, defaultRange) {
        var range = lightnessConfig[configName];
        // Check if the lightness range is an array-like object. This way we ensure the
        // array contain two values at the same time.
        if (!(range && range.length > 1)) range = defaultRange;
        /**
         * Gets a lightness relative the specified value in the specified lightness range.
         */ return function(value) {
            value = range[0] + value * (range[1] - range[0]);
            return value < 0 ? 0 : value > 1 ? 1 : value;
        };
    }
    /**
     * Gets a hue allowed by the configured hue restriction,
     * provided the originally computed hue.
     */ function hueFunction(originalHue) {
        var hueConfig = configObject["hues"];
        var hue;
        // Check if 'hues' is an array-like object. This way we also ensure that
        // the array is not empty, which would mean no hue restriction.
        if (hueConfig && hueConfig.length > 0) // originalHue is in the range [0, 1]
        // Multiply with 0.999 to change the range to [0, 1) and then truncate the index.
        hue = hueConfig[0 | 0.999 * originalHue * hueConfig.length];
        return typeof hue == "number" ? // A hue was specified. We need to convert the hue from
        // degrees on any turn - e.g. 746° is a perfectly valid hue -
        // to turns in the range [0, 1).
        (hue / 360 % 1 + 1) % 1 : // No hue configured => use original hue
        originalHue;
    }
    return {
        X: hueFunction,
        o: typeof colorSaturation == "number" ? colorSaturation : 0.5,
        F: typeof grayscaleSaturation == "number" ? grayscaleSaturation : 0,
        p: lightness("color", [
            0.4,
            0.8
        ]),
        G: lightness("grayscale", [
            0.3,
            0.9
        ]),
        H: $13374e707bb24dca$var$parseColor(backColor),
        Y: typeof paddingOrLocalConfig == "number" ? paddingOrLocalConfig : typeof padding == "number" ? padding : defaultPadding
    };
}
/**
 * Represents a point.
 */ function $13374e707bb24dca$var$Point(x, y) {
    this.x = x;
    this.y = y;
}
/**
 * Translates and rotates a point before being passed on to the canvas context. This was previously done by the canvas context itself, 
 * but this caused a rendering issue in Chrome on sizes > 256 where the rotation transformation of inverted paths was not done properly.
 */ function $13374e707bb24dca$var$Transform(x, y, size, rotation) {
    this.q /*_x*/  = x;
    this.t /*_y*/  = y;
    this.I /*_size*/  = size;
    this.Z /*_rotation*/  = rotation;
}
/**
 * Transforms the specified point based on the translation and rotation specification for this Transform.
 * @param {number} x x-coordinate
 * @param {number} y y-coordinate
 * @param {number=} w The width of the transformed rectangle. If greater than 0, this will ensure the returned point is of the upper left corner of the transformed rectangle.
 * @param {number=} h The height of the transformed rectangle. If greater than 0, this will ensure the returned point is of the upper left corner of the transformed rectangle.
 */ $13374e707bb24dca$var$Transform.prototype.J /*transformIconPoint*/  = function transformIconPoint(x, y, w, h) {
    var right = this.q /*_x*/  + this.I /*_size*/ , bottom = this.t /*_y*/  + this.I /*_size*/ , rotation = this.Z /*_rotation*/ ;
    return rotation === 1 ? new $13374e707bb24dca$var$Point(right - y - (h || 0), this.t /*_y*/  + x) : rotation === 2 ? new $13374e707bb24dca$var$Point(right - x - (w || 0), bottom - y - (h || 0)) : rotation === 3 ? new $13374e707bb24dca$var$Point(this.q /*_x*/  + y, bottom - x - (w || 0)) : new $13374e707bb24dca$var$Point(this.q /*_x*/  + x, this.t /*_y*/  + y);
};
var $13374e707bb24dca$var$NO_TRANSFORM = new $13374e707bb24dca$var$Transform(0, 0, 0, 0);
/**
 * Provides helper functions for rendering common basic shapes.
 */ function $13374e707bb24dca$var$Graphics(renderer) {
    /**
     * @type {Renderer}
     * @private
     */ this.K /*_renderer*/  = renderer;
    /**
     * @type {Transform}
     */ this.u /*currentTransform*/  = $13374e707bb24dca$var$NO_TRANSFORM;
}
var $13374e707bb24dca$var$Graphics__prototype = $13374e707bb24dca$var$Graphics.prototype;
/**
 * Adds a polygon to the underlying renderer.
 * @param {Array<number>} points The points of the polygon clockwise on the format [ x0, y0, x1, y1, ..., xn, yn ]
 * @param {boolean=} invert Specifies if the polygon will be inverted.
 */ $13374e707bb24dca$var$Graphics__prototype.g /*addPolygon*/  = function addPolygon(points, invert) {
    var this$1 = this;
    var di = invert ? -2 : 2, transformedPoints = [];
    for(var i = invert ? points.length - 2 : 0; i < points.length && i >= 0; i += di)transformedPoints.push(this$1.u /*currentTransform*/ .J /*transformIconPoint*/ (points[i], points[i + 1]));
    this.K /*_renderer*/ .g /*addPolygon*/ (transformedPoints);
};
/**
 * Adds a polygon to the underlying renderer.
 * Source: http://stackoverflow.com/a/2173084
 * @param {number} x The x-coordinate of the upper left corner of the rectangle holding the entire ellipse.
 * @param {number} y The y-coordinate of the upper left corner of the rectangle holding the entire ellipse.
 * @param {number} size The size of the ellipse.
 * @param {boolean=} invert Specifies if the ellipse will be inverted.
 */ $13374e707bb24dca$var$Graphics__prototype.h /*addCircle*/  = function addCircle(x, y, size, invert) {
    var p = this.u /*currentTransform*/ .J /*transformIconPoint*/ (x, y, size, size);
    this.K /*_renderer*/ .h /*addCircle*/ (p, size, invert);
};
/**
 * Adds a rectangle to the underlying renderer.
 * @param {number} x The x-coordinate of the upper left corner of the rectangle.
 * @param {number} y The y-coordinate of the upper left corner of the rectangle.
 * @param {number} w The width of the rectangle.
 * @param {number} h The height of the rectangle.
 * @param {boolean=} invert Specifies if the rectangle will be inverted.
 */ $13374e707bb24dca$var$Graphics__prototype.i /*addRectangle*/  = function addRectangle(x, y, w, h, invert) {
    this.g /*addPolygon*/ ([
        x,
        y,
        x + w,
        y,
        x + w,
        y + h,
        x,
        y + h
    ], invert);
};
/**
 * Adds a right triangle to the underlying renderer.
 * @param {number} x The x-coordinate of the upper left corner of the rectangle holding the triangle.
 * @param {number} y The y-coordinate of the upper left corner of the rectangle holding the triangle.
 * @param {number} w The width of the triangle.
 * @param {number} h The height of the triangle.
 * @param {number} r The rotation of the triangle (clockwise). 0 = right corner of the triangle in the lower left corner of the bounding rectangle.
 * @param {boolean=} invert Specifies if the triangle will be inverted.
 */ $13374e707bb24dca$var$Graphics__prototype.j /*addTriangle*/  = function addTriangle(x, y, w, h, r, invert) {
    var points = [
        x + w,
        y,
        x + w,
        y + h,
        x,
        y + h,
        x,
        y
    ];
    points.splice((r || 0) % 4 * 2, 2);
    this.g /*addPolygon*/ (points, invert);
};
/**
 * Adds a rhombus to the underlying renderer.
 * @param {number} x The x-coordinate of the upper left corner of the rectangle holding the rhombus.
 * @param {number} y The y-coordinate of the upper left corner of the rectangle holding the rhombus.
 * @param {number} w The width of the rhombus.
 * @param {number} h The height of the rhombus.
 * @param {boolean=} invert Specifies if the rhombus will be inverted.
 */ $13374e707bb24dca$var$Graphics__prototype.L /*addRhombus*/  = function addRhombus(x, y, w, h, invert) {
    this.g /*addPolygon*/ ([
        x + w / 2,
        y,
        x + w,
        y + h / 2,
        x + w / 2,
        y + h,
        x,
        y + h / 2
    ], invert);
};
/**
 * @param {number} index
 * @param {Graphics} g
 * @param {number} cell
 * @param {number} positionIndex
 */ function $13374e707bb24dca$var$centerShape(index, g, cell, positionIndex) {
    index = index % 14;
    var k, m, w, h, inner, outer;
    !index ? (k = cell * 0.42, g.g /*addPolygon*/ ([
        0,
        0,
        cell,
        0,
        cell,
        cell - k * 2,
        cell - k,
        cell,
        0,
        cell
    ])) : index == 1 ? (w = 0 | cell * 0.5, h = 0 | cell * 0.8, g.j /*addTriangle*/ (cell - w, 0, w, h, 2)) : index == 2 ? (w = 0 | cell / 3, g.i /*addRectangle*/ (w, w, cell - w, cell - w)) : index == 3 ? (inner = cell * 0.1, // Use fixed outer border widths in small icons to ensure the border is drawn
    outer = cell < 6 ? 1 : cell < 8 ? 2 : 0 | cell * 0.25, inner = inner > 1 ? 0 | inner : inner > 0.5 ? 1 : inner, g.i /*addRectangle*/ (outer, outer, cell - inner - outer, cell - inner - outer)) : index == 4 ? (m = 0 | cell * 0.15, w = 0 | cell * 0.5, g.h /*addCircle*/ (cell - w - m, cell - w - m, w)) : index == 5 ? (inner = cell * 0.1, outer = inner * 4, // Align edge to nearest pixel in large icons
    outer > 3 && (outer = 0 | outer), g.i /*addRectangle*/ (0, 0, cell, cell), g.g /*addPolygon*/ ([
        outer,
        outer,
        cell - inner,
        outer,
        outer + (cell - outer - inner) / 2,
        cell - inner
    ], true)) : index == 6 ? g.g /*addPolygon*/ ([
        0,
        0,
        cell,
        0,
        cell,
        cell * 0.7,
        cell * 0.4,
        cell * 0.4,
        cell * 0.7,
        cell,
        0,
        cell
    ]) : index == 7 ? g.j /*addTriangle*/ (cell / 2, cell / 2, cell / 2, cell / 2, 3) : index == 8 ? (g.i /*addRectangle*/ (0, 0, cell, cell / 2), g.i /*addRectangle*/ (0, cell / 2, cell / 2, cell / 2), g.j /*addTriangle*/ (cell / 2, cell / 2, cell / 2, cell / 2, 1)) : index == 9 ? (inner = cell * 0.14, // Use fixed outer border widths in small icons to ensure the border is drawn
    outer = cell < 4 ? 1 : cell < 6 ? 2 : 0 | cell * 0.35, inner = cell < 8 ? inner : 0 | inner, g.i /*addRectangle*/ (0, 0, cell, cell), g.i /*addRectangle*/ (outer, outer, cell - outer - inner, cell - outer - inner, true)) : index == 10 ? (inner = cell * 0.12, outer = inner * 3, g.i /*addRectangle*/ (0, 0, cell, cell), g.h /*addCircle*/ (outer, outer, cell - inner - outer, true)) : index == 11 ? g.j /*addTriangle*/ (cell / 2, cell / 2, cell / 2, cell / 2, 3) : index == 12 ? (m = cell * 0.25, g.i /*addRectangle*/ (0, 0, cell, cell), g.L /*addRhombus*/ (m, m, cell - m, cell - m, true)) : // 13
    !positionIndex && (m = cell * 0.4, w = cell * 1.2, g.h /*addCircle*/ (m, m, w));
}
/**
 * @param {number} index
 * @param {Graphics} g
 * @param {number} cell
 */ function $13374e707bb24dca$var$outerShape(index, g, cell) {
    index = index % 4;
    var m;
    !index ? g.j /*addTriangle*/ (0, 0, cell, cell, 0) : index == 1 ? g.j /*addTriangle*/ (0, cell / 2, cell, cell / 2, 0) : index == 2 ? g.L /*addRhombus*/ (0, 0, cell, cell) : // 3
    (m = cell / 6, g.h /*addCircle*/ (m, m, cell - 2 * m));
}
/**
 * Gets a set of identicon color candidates for a specified hue and config.
 * @param {number} hue
 * @param {ParsedConfiguration} config
 */ function $13374e707bb24dca$var$colorTheme(hue, config) {
    hue = config.X /*hue*/ (hue);
    return [
        // Dark gray
        $13374e707bb24dca$var$correctedHsl(hue, config.F /*grayscaleSaturation*/ , config.G /*grayscaleLightness*/ (0)),
        // Mid color
        $13374e707bb24dca$var$correctedHsl(hue, config.o /*colorSaturation*/ , config.p /*colorLightness*/ (0.5)),
        // Light gray
        $13374e707bb24dca$var$correctedHsl(hue, config.F /*grayscaleSaturation*/ , config.G /*grayscaleLightness*/ (1)),
        // Light color
        $13374e707bb24dca$var$correctedHsl(hue, config.o /*colorSaturation*/ , config.p /*colorLightness*/ (1)),
        // Dark color
        $13374e707bb24dca$var$correctedHsl(hue, config.o /*colorSaturation*/ , config.p /*colorLightness*/ (0))
    ];
}
/**
 * Draws an identicon to a specified renderer.
 * @param {Renderer} renderer
 * @param {string} hash
 * @param {Object|number=} config
 */ function $13374e707bb24dca$var$iconGenerator(renderer, hash, config) {
    var parsedConfig = $13374e707bb24dca$var$getConfiguration(config, 0.08);
    // Set background color
    if (parsedConfig.H /*backColor*/ ) renderer.m /*setBackground*/ (parsedConfig.H /*backColor*/ );
    // Calculate padding and round to nearest integer
    var size = renderer.k /*iconSize*/ ;
    var padding = 0.5 + size * parsedConfig.Y /*iconPadding*/  | 0;
    size -= padding * 2;
    var graphics = new $13374e707bb24dca$var$Graphics(renderer);
    // Calculate cell size and ensure it is an integer
    var cell = 0 | size / 4;
    // Since the cell size is integer based, the actual icon will be slightly smaller than specified => center icon
    var x = 0 | padding + size / 2 - cell * 2;
    var y = 0 | padding + size / 2 - cell * 2;
    function renderShape(colorIndex, shapes, index, rotationIndex, positions) {
        var shapeIndex = $13374e707bb24dca$var$parseHex(hash, index, 1);
        var r = rotationIndex ? $13374e707bb24dca$var$parseHex(hash, rotationIndex, 1) : 0;
        renderer.M /*beginShape*/ (availableColors[selectedColorIndexes[colorIndex]]);
        for(var i = 0; i < positions.length; i++){
            graphics.u /*currentTransform*/  = new $13374e707bb24dca$var$Transform(x + positions[i][0] * cell, y + positions[i][1] * cell, cell, r++ % 4);
            shapes(shapeIndex, graphics, cell, i);
        }
        renderer.N /*endShape*/ ();
    }
    // AVAILABLE COLORS
    var hue = $13374e707bb24dca$var$parseHex(hash, -7) / 0xfffffff, // Available colors for this icon
    availableColors = $13374e707bb24dca$var$colorTheme(hue, parsedConfig), // The index of the selected colors
    selectedColorIndexes = [];
    var index;
    function isDuplicate(values) {
        if (values.indexOf(index) >= 0) for(var i = 0; i < values.length; i++){
            if (selectedColorIndexes.indexOf(values[i]) >= 0) return true;
        }
    }
    for(var i = 0; i < 3; i++){
        index = $13374e707bb24dca$var$parseHex(hash, 8 + i, 1) % availableColors.length;
        if (isDuplicate([
            0,
            4
        ]) || // Disallow dark gray and dark color combo
        isDuplicate([
            2,
            3
        ])) index = 1;
        selectedColorIndexes.push(index);
    }
    // ACTUAL RENDERING
    // Sides
    renderShape(0, $13374e707bb24dca$var$outerShape, 2, 3, [
        [
            1,
            0
        ],
        [
            2,
            0
        ],
        [
            2,
            3
        ],
        [
            1,
            3
        ],
        [
            0,
            1
        ],
        [
            3,
            1
        ],
        [
            3,
            2
        ],
        [
            0,
            2
        ]
    ]);
    // Corners
    renderShape(1, $13374e707bb24dca$var$outerShape, 4, 5, [
        [
            0,
            0
        ],
        [
            3,
            0
        ],
        [
            3,
            3
        ],
        [
            0,
            3
        ]
    ]);
    // Center
    renderShape(2, $13374e707bb24dca$var$centerShape, 1, null, [
        [
            1,
            1
        ],
        [
            2,
            1
        ],
        [
            2,
            2
        ],
        [
            1,
            2
        ]
    ]);
    renderer.finish();
}
/**
 * Computes a SHA1 hash for any value and returns it as a hexadecimal string.
 * 
 * This function is optimized for minimal code size and rather short messages.
 * 
 * @param {string} message 
 */ function $13374e707bb24dca$var$sha1(message) {
    var HASH_SIZE_HALF_BYTES = 40;
    var BLOCK_SIZE_WORDS = 16;
    // Variables
    // `var` is used to be able to minimize the number of `var` keywords.
    var i = 0, f = 0, // Use `encodeURI` to UTF8 encode the message without any additional libraries
    // We could use `unescape` + `encodeURI` to minimize the code, but that would be slightly risky
    // since `unescape` is deprecated.
    urlEncodedMessage = encodeURI(message) + "%80", // This can be changed to a preallocated Uint32Array array for greater performance and larger code size
    data = [], dataSize, hashBuffer = [], a = 0x67452301, b = 0xefcdab89, c = ~a, d = ~b, e = 0xc3d2e1f0, hash = [
        a,
        b,
        c,
        d,
        e
    ], blockStartIndex = 0, hexHash = "";
    /**
     * Rotates the value a specified number of bits to the left.
     * @param {number} value  Value to rotate
     * @param {number} shift  Bit count to shift.
     */ function rotl(value, shift) {
        return value << shift | value >>> 32 - shift;
    }
    // Message data
    for(; i < urlEncodedMessage.length; f++)data[f >> 2] = data[f >> 2] | (urlEncodedMessage[i] == "%" ? parseInt(urlEncodedMessage.substring(i + 1, i += 3), 16) : urlEncodedMessage.charCodeAt(i++)) << (3 - (f & 3)) * 8;
    // f is now the length of the utf8 encoded message
    // 7 = 8 bytes (64 bit) for message size, -1 to round down
    // >> 6 = integer division with block size
    dataSize = ((f + 7 >> 6) + 1) * BLOCK_SIZE_WORDS;
    // Message size in bits.
    // SHA1 uses a 64 bit integer to represent the size, but since we only support short messages only the least
    // significant 32 bits are set. -8 is for the '1' bit padding byte.
    data[dataSize - 1] = f * 8 - 8;
    // Compute hash
    for(; blockStartIndex < dataSize; blockStartIndex += BLOCK_SIZE_WORDS){
        for(i = 0; i < 80; i++){
            f = rotl(a, 5) + e + // Ch
            (i < 20 ? (b & c ^ ~b & d) + 0x5a827999 : // Parity
            i < 40 ? (b ^ c ^ d) + 0x6ed9eba1 : // Maj
            i < 60 ? (b & c ^ b & d ^ c & d) + 0x8f1bbcdc : // Parity
            (b ^ c ^ d) + 0xca62c1d6) + (hashBuffer[i] = i < BLOCK_SIZE_WORDS ? data[blockStartIndex + i] | 0 : rotl(hashBuffer[i - 3] ^ hashBuffer[i - 8] ^ hashBuffer[i - 14] ^ hashBuffer[i - 16], 1));
            e = d;
            d = c;
            c = rotl(b, 30);
            b = a;
            a = f;
        }
        hash[0] = a = hash[0] + a | 0;
        hash[1] = b = hash[1] + b | 0;
        hash[2] = c = hash[2] + c | 0;
        hash[3] = d = hash[3] + d | 0;
        hash[4] = e = hash[4] + e | 0;
    }
    // Format hex hash
    for(i = 0; i < HASH_SIZE_HALF_BYTES; i++)hexHash += (// Get word (2^3 half-bytes per word)
    hash[i >> 3] >>> // Append half-bytes in reverse order
    (7 - (i & 7)) * 4 & 0xf).toString(16);
    return hexHash;
}
/**
 * Inputs a value that might be a valid hash string for Jdenticon and returns it 
 * if it is determined valid, otherwise a falsy value is returned.
 */ function $13374e707bb24dca$var$isValidHash(hashCandidate) {
    return /^[0-9a-f]{11,}$/i.test(hashCandidate) && hashCandidate;
}
/**
 * Computes a hash for the specified value. Currently SHA1 is used. This function
 * always returns a valid hash.
 */ function $13374e707bb24dca$var$computeHash(value) {
    return $13374e707bb24dca$var$sha1(value == null ? "" : "" + value);
}
/**
 * Renderer redirecting drawing commands to a canvas context.
 * @implements {Renderer}
 */ function $13374e707bb24dca$var$CanvasRenderer(ctx, iconSize) {
    var canvas = ctx.canvas;
    var width = canvas.width;
    var height = canvas.height;
    ctx.save();
    if (!iconSize) {
        iconSize = Math.min(width, height);
        ctx.translate((width - iconSize) / 2 | 0, (height - iconSize) / 2 | 0);
    }
    /**
     * @private
     */ this.l /*_ctx*/  = ctx;
    this.k /*iconSize*/  = iconSize;
    ctx.clearRect(0, 0, iconSize, iconSize);
}
var $13374e707bb24dca$var$CanvasRenderer__prototype = $13374e707bb24dca$var$CanvasRenderer.prototype;
/**
 * Fills the background with the specified color.
 * @param {string} fillColor  Fill color on the format #rrggbb[aa].
 */ $13374e707bb24dca$var$CanvasRenderer__prototype.m /*setBackground*/  = function setBackground(fillColor) {
    var ctx = this.l /*_ctx*/ ;
    var iconSize = this.k /*iconSize*/ ;
    ctx.fillStyle = $13374e707bb24dca$var$toCss3Color(fillColor);
    ctx.fillRect(0, 0, iconSize, iconSize);
};
/**
 * Marks the beginning of a new shape of the specified color. Should be ended with a call to endShape.
 * @param {string} fillColor Fill color on format #rrggbb[aa].
 */ $13374e707bb24dca$var$CanvasRenderer__prototype.M /*beginShape*/  = function beginShape(fillColor) {
    var ctx = this.l /*_ctx*/ ;
    ctx.fillStyle = $13374e707bb24dca$var$toCss3Color(fillColor);
    ctx.beginPath();
};
/**
 * Marks the end of the currently drawn shape. This causes the queued paths to be rendered on the canvas.
 */ $13374e707bb24dca$var$CanvasRenderer__prototype.N /*endShape*/  = function endShape() {
    this.l /*_ctx*/ .fill();
};
/**
 * Adds a polygon to the rendering queue.
 * @param points An array of Point objects.
 */ $13374e707bb24dca$var$CanvasRenderer__prototype.g /*addPolygon*/  = function addPolygon(points) {
    var ctx = this.l /*_ctx*/ ;
    ctx.moveTo(points[0].x, points[0].y);
    for(var i = 1; i < points.length; i++)ctx.lineTo(points[i].x, points[i].y);
    ctx.closePath();
};
/**
 * Adds a circle to the rendering queue.
 * @param {Point} point The upper left corner of the circle bounding box.
 * @param {number} diameter The diameter of the circle.
 * @param {boolean} counterClockwise True if the circle is drawn counter-clockwise (will result in a hole if rendered on a clockwise path).
 */ $13374e707bb24dca$var$CanvasRenderer__prototype.h /*addCircle*/  = function addCircle(point, diameter, counterClockwise) {
    var ctx = this.l /*_ctx*/ , radius = diameter / 2;
    ctx.moveTo(point.x + radius, point.y + radius);
    ctx.arc(point.x + radius, point.y + radius, radius, 0, Math.PI * 2, counterClockwise);
    ctx.closePath();
};
/**
 * Called when the icon has been completely drawn.
 */ $13374e707bb24dca$var$CanvasRenderer__prototype.finish = function finish() {
    this.l /*_ctx*/ .restore();
};
/**
 * Draws an identicon to a context.
 * @param {CanvasRenderingContext2D} ctx - Canvas context on which the icon will be drawn at location (0, 0).
 * @param {*} hashOrValue - A hexadecimal hash string or any value that will be hashed by Jdenticon.
 * @param {number} size - Icon size in pixels.
 * @param {Object|number=} config - Optional configuration. If specified, this configuration object overrides any
 *    global configuration in its entirety. For backward compatibility a padding value in the range [0.0, 0.5) can be
 *    specified in place of a configuration object.
 */ function $13374e707bb24dca$var$drawIcon(ctx, hashOrValue, size, config) {
    if (!ctx) throw new Error("No canvas specified.");
    $13374e707bb24dca$var$iconGenerator(new $13374e707bb24dca$var$CanvasRenderer(ctx, size), $13374e707bb24dca$var$isValidHash(hashOrValue) || $13374e707bb24dca$var$computeHash(hashOrValue), config);
}
/**
 * Prepares a measure to be used as a measure in an SVG path, by
 * rounding the measure to a single decimal. This reduces the file
 * size of the generated SVG with more than 50% in some cases.
 */ function $13374e707bb24dca$var$svgValue(value) {
    return (value * 10 + 0.5 | 0) / 10;
}
/**
 * Represents an SVG path element.
 */ function $13374e707bb24dca$var$SvgPath() {
    /**
     * This property holds the data string (path.d) of the SVG path.
     * @type {string}
     */ this.v /*dataString*/  = "";
}
var $13374e707bb24dca$var$SvgPath__prototype = $13374e707bb24dca$var$SvgPath.prototype;
/**
 * Adds a polygon with the current fill color to the SVG path.
 * @param points An array of Point objects.
 */ $13374e707bb24dca$var$SvgPath__prototype.g /*addPolygon*/  = function addPolygon(points) {
    var dataString = "";
    for(var i = 0; i < points.length; i++)dataString += (i ? "L" : "M") + $13374e707bb24dca$var$svgValue(points[i].x) + " " + $13374e707bb24dca$var$svgValue(points[i].y);
    this.v /*dataString*/  += dataString + "Z";
};
/**
 * Adds a circle with the current fill color to the SVG path.
 * @param {Point} point The upper left corner of the circle bounding box.
 * @param {number} diameter The diameter of the circle.
 * @param {boolean} counterClockwise True if the circle is drawn counter-clockwise (will result in a hole if rendered on a clockwise path).
 */ $13374e707bb24dca$var$SvgPath__prototype.h /*addCircle*/  = function addCircle(point, diameter, counterClockwise) {
    var sweepFlag = counterClockwise ? 0 : 1, svgRadius = $13374e707bb24dca$var$svgValue(diameter / 2), svgDiameter = $13374e707bb24dca$var$svgValue(diameter), svgArc = "a" + svgRadius + "," + svgRadius + " 0 1," + sweepFlag + " ";
    this.v /*dataString*/  += "M" + $13374e707bb24dca$var$svgValue(point.x) + " " + $13374e707bb24dca$var$svgValue(point.y + diameter / 2) + svgArc + svgDiameter + ",0" + svgArc + -svgDiameter + ",0";
};
/**
 * Renderer producing SVG output.
 * @implements {Renderer}
 */ function $13374e707bb24dca$var$SvgRenderer(target) {
    /**
     * @type {SvgPath}
     * @private
     */ this.A /*_path*/ ;
    /**
     * @type {Object.<string,SvgPath>}
     * @private
     */ this.B /*_pathsByColor*/  = {};
    /**
     * @type {SvgElement|SvgWriter}
     * @private
     */ this.O /*_target*/  = target;
    /**
     * @type {number}
     */ this.k /*iconSize*/  = target.k /*iconSize*/ ;
}
var $13374e707bb24dca$var$SvgRenderer__prototype = $13374e707bb24dca$var$SvgRenderer.prototype;
/**
 * Fills the background with the specified color.
 * @param {string} fillColor  Fill color on the format #rrggbb[aa].
 */ $13374e707bb24dca$var$SvgRenderer__prototype.m /*setBackground*/  = function setBackground(fillColor) {
    var match = /^(#......)(..)?/.exec(fillColor), opacity = match[2] ? $13374e707bb24dca$var$parseHex(match[2], 0) / 255 : 1;
    this.O /*_target*/ .m /*setBackground*/ (match[1], opacity);
};
/**
 * Marks the beginning of a new shape of the specified color. Should be ended with a call to endShape.
 * @param {string} color Fill color on format #xxxxxx.
 */ $13374e707bb24dca$var$SvgRenderer__prototype.M /*beginShape*/  = function beginShape(color) {
    this.A /*_path*/  = this.B /*_pathsByColor*/ [color] || (this.B /*_pathsByColor*/ [color] = new $13374e707bb24dca$var$SvgPath());
};
/**
 * Marks the end of the currently drawn shape.
 */ $13374e707bb24dca$var$SvgRenderer__prototype.N /*endShape*/  = function endShape() {};
/**
 * Adds a polygon with the current fill color to the SVG.
 * @param points An array of Point objects.
 */ $13374e707bb24dca$var$SvgRenderer__prototype.g /*addPolygon*/  = function addPolygon(points) {
    this.A /*_path*/ .g /*addPolygon*/ (points);
};
/**
 * Adds a circle with the current fill color to the SVG.
 * @param {Point} point The upper left corner of the circle bounding box.
 * @param {number} diameter The diameter of the circle.
 * @param {boolean} counterClockwise True if the circle is drawn counter-clockwise (will result in a hole if rendered on a clockwise path).
 */ $13374e707bb24dca$var$SvgRenderer__prototype.h /*addCircle*/  = function addCircle(point, diameter, counterClockwise) {
    this.A /*_path*/ .h /*addCircle*/ (point, diameter, counterClockwise);
};
/**
 * Called when the icon has been completely drawn.
 */ $13374e707bb24dca$var$SvgRenderer__prototype.finish = function finish() {
    var this$1 = this;
    var pathsByColor = this.B /*_pathsByColor*/ ;
    for(var color in pathsByColor)// hasOwnProperty cannot be shadowed in pathsByColor
    // eslint-disable-next-line no-prototype-builtins
    if (pathsByColor.hasOwnProperty(color)) this$1.O /*_target*/ .P /*appendPath*/ (color, pathsByColor[color].v /*dataString*/ );
};
var $13374e707bb24dca$var$SVG_CONSTANTS = {
    R: "http://www.w3.org/2000/svg",
    S: "width",
    T: "height"
};
/**
 * Renderer producing SVG output.
 */ function $13374e707bb24dca$var$SvgWriter(iconSize) {
    /**
     * @type {number}
     */ this.k /*iconSize*/  = iconSize;
    /**
     * @type {string}
     * @private
     */ this.C /*_s*/  = '<svg xmlns="' + $13374e707bb24dca$var$SVG_CONSTANTS.R /*XMLNS*/  + '" width="' + iconSize + '" height="' + iconSize + '" viewBox="0 0 ' + iconSize + " " + iconSize + '">';
}
var $13374e707bb24dca$var$SvgWriter__prototype = $13374e707bb24dca$var$SvgWriter.prototype;
/**
 * Fills the background with the specified color.
 * @param {string} fillColor  Fill color on the format #rrggbb.
 * @param {number} opacity  Opacity in the range [0.0, 1.0].
 */ $13374e707bb24dca$var$SvgWriter__prototype.m /*setBackground*/  = function setBackground(fillColor, opacity) {
    if (opacity) this.C /*_s*/  += '<rect width="100%" height="100%" fill="' + fillColor + '" opacity="' + opacity.toFixed(2) + '"/>';
};
/**
 * Writes a path to the SVG string.
 * @param {string} color Fill color on format #rrggbb.
 * @param {string} dataString The SVG path data string.
 */ $13374e707bb24dca$var$SvgWriter__prototype.P /*appendPath*/  = function appendPath(color, dataString) {
    this.C /*_s*/  += '<path fill="' + color + '" d="' + dataString + '"/>';
};
/**
 * Gets the rendered image as an SVG string.
 */ $13374e707bb24dca$var$SvgWriter__prototype.toString = function toString() {
    return this.C /*_s*/  + "</svg>";
};
/**
 * Draws an identicon as an SVG string.
 * @param {*} hashOrValue - A hexadecimal hash string or any value that will be hashed by Jdenticon.
 * @param {number} size - Icon size in pixels.
 * @param {Object|number=} config - Optional configuration. If specified, this configuration object overrides any
 *    global configuration in its entirety. For backward compatibility a padding value in the range [0.0, 0.5) can be
 *    specified in place of a configuration object.
 * @returns {string} SVG string
 */ function $13374e707bb24dca$var$toSvg(hashOrValue, size, config) {
    var writer = new $13374e707bb24dca$var$SvgWriter(size);
    $13374e707bb24dca$var$iconGenerator(new $13374e707bb24dca$var$SvgRenderer(writer), $13374e707bb24dca$var$isValidHash(hashOrValue) || $13374e707bb24dca$var$computeHash(hashOrValue), config);
    return writer.toString();
}
var $13374e707bb24dca$var$ICON_TYPE_SVG = 1;
var $13374e707bb24dca$var$ICON_TYPE_CANVAS = 2;
var $13374e707bb24dca$var$ATTRIBUTES = {
    U: "data-jdenticon-hash",
    D: "data-jdenticon-value"
};
var $13374e707bb24dca$var$ICON_SELECTOR = "[" + $13374e707bb24dca$var$ATTRIBUTES.U /*HASH*/  + "],[" + $13374e707bb24dca$var$ATTRIBUTES.D /*VALUE*/  + "]";
var $13374e707bb24dca$var$documentQuerySelectorAll = /** @type {!Function} */ typeof document !== "undefined" && document.querySelectorAll.bind(document);
function $13374e707bb24dca$var$getIdenticonType(el) {
    if (el) {
        var tagName = el["tagName"];
        if (/^svg$/i.test(tagName)) return $13374e707bb24dca$var$ICON_TYPE_SVG;
        if (/^canvas$/i.test(tagName) && "getContext" in el) return $13374e707bb24dca$var$ICON_TYPE_CANVAS;
    }
}
/**
 * Creates a new element and adds it to the specified parent.
 * @param {Element} parentNode
 * @param {string} name
 * @param {...(string|number)} keyValuePairs
 */ function $13374e707bb24dca$var$SvgElement_append(parentNode, name) {
    var keyValuePairs = [], len = arguments.length - 2;
    while(len-- > 0)keyValuePairs[len] = arguments[len + 2];
    var el = document.createElementNS($13374e707bb24dca$var$SVG_CONSTANTS.R /*XMLNS*/ , name);
    for(var i = 0; i + 1 < keyValuePairs.length; i += 2)el.setAttribute(/** @type {string} */ keyValuePairs[i], /** @type {string} */ keyValuePairs[i + 1]);
    parentNode.appendChild(el);
}
/**
 * Renderer producing SVG output.
 */ function $13374e707bb24dca$var$SvgElement(element) {
    // Don't use the clientWidth and clientHeight properties on SVG elements
    // since Firefox won't serve a proper value of these properties on SVG
    // elements (https://bugzilla.mozilla.org/show_bug.cgi?id=874811)
    // Instead use 100px as a hardcoded size (the svg viewBox will rescale 
    // the icon to the correct dimensions)
    var iconSize = this.k /*iconSize*/  = Math.min(Number(element.getAttribute($13374e707bb24dca$var$SVG_CONSTANTS.S /*WIDTH*/ )) || 100, Number(element.getAttribute($13374e707bb24dca$var$SVG_CONSTANTS.T /*HEIGHT*/ )) || 100);
    /**
     * @type {Element}
     * @private
     */ this.V /*_el*/  = element;
    // Clear current SVG child elements
    while(element.firstChild)element.removeChild(element.firstChild);
    // Set viewBox attribute to ensure the svg scales nicely.
    element.setAttribute("viewBox", "0 0 " + iconSize + " " + iconSize);
    element.setAttribute("preserveAspectRatio", "xMidYMid meet");
}
var $13374e707bb24dca$var$SvgElement__prototype = $13374e707bb24dca$var$SvgElement.prototype;
/**
 * Fills the background with the specified color.
 * @param {string} fillColor  Fill color on the format #rrggbb.
 * @param {number} opacity  Opacity in the range [0.0, 1.0].
 */ $13374e707bb24dca$var$SvgElement__prototype.m /*setBackground*/  = function setBackground(fillColor, opacity) {
    if (opacity) $13374e707bb24dca$var$SvgElement_append(this.V /*_el*/ , "rect", $13374e707bb24dca$var$SVG_CONSTANTS.S /*WIDTH*/ , "100%", $13374e707bb24dca$var$SVG_CONSTANTS.T /*HEIGHT*/ , "100%", "fill", fillColor, "opacity", opacity);
};
/**
 * Appends a path to the SVG element.
 * @param {string} color Fill color on format #xxxxxx.
 * @param {string} dataString The SVG path data string.
 */ $13374e707bb24dca$var$SvgElement__prototype.P /*appendPath*/  = function appendPath(color, dataString) {
    $13374e707bb24dca$var$SvgElement_append(this.V /*_el*/ , "path", "fill", color, "d", dataString);
};
/**
 * Updates all canvas elements with the `data-jdenticon-hash` or `data-jdenticon-value` attribute.
 */ function $13374e707bb24dca$var$updateAll() {
    if ($13374e707bb24dca$var$documentQuerySelectorAll) $13374e707bb24dca$var$update($13374e707bb24dca$var$ICON_SELECTOR);
}
/**
 * Updates the identicon in the specified `<canvas>` or `<svg>` elements.
 * @param {(string|Element)} el - Specifies the container in which the icon is rendered as a DOM element of the type
 *    `<svg>` or `<canvas>`, or a CSS selector to such an element.
 * @param {*=} hashOrValue - Optional hash or value to be rendered. If not specified, the `data-jdenticon-hash` or
 *    `data-jdenticon-value` attribute will be evaluated.
 * @param {Object|number=} config - Optional configuration. If specified, this configuration object overrides any
 *    global configuration in its entirety. For backward compability a padding value in the range [0.0, 0.5) can be
 *    specified in place of a configuration object.
 */ function $13374e707bb24dca$var$update(el, hashOrValue, config) {
    $13374e707bb24dca$var$renderDomElement(el, hashOrValue, config, function(el, iconType) {
        if (iconType) return iconType == $13374e707bb24dca$var$ICON_TYPE_SVG ? new $13374e707bb24dca$var$SvgRenderer(new $13374e707bb24dca$var$SvgElement(el)) : new $13374e707bb24dca$var$CanvasRenderer(/** @type {HTMLCanvasElement} */ el.getContext("2d"));
    });
}
/**
 * Updates the identicon in the specified `<canvas>` elements.
 * @param {(string|Element)} el - Specifies the container in which the icon is rendered as a DOM element of the type
 *    `<canvas>`, or a CSS selector to such an element.
 * @param {*=} hashOrValue - Optional hash or value to be rendered. If not specified, the `data-jdenticon-hash` or
 *    `data-jdenticon-value` attribute will be evaluated.
 * @param {Object|number=} config - Optional configuration. If specified, this configuration object overrides any
 *    global configuration in its entirety. For backward compability a padding value in the range [0.0, 0.5) can be
 *    specified in place of a configuration object.
 */ function $13374e707bb24dca$var$updateCanvas(el, hashOrValue, config) {
    $13374e707bb24dca$var$renderDomElement(el, hashOrValue, config, function(el, iconType) {
        if (iconType == $13374e707bb24dca$var$ICON_TYPE_CANVAS) return new $13374e707bb24dca$var$CanvasRenderer(/** @type {HTMLCanvasElement} */ el.getContext("2d"));
    });
}
/**
 * Updates the identicon in the specified `<svg>` elements.
 * @param {(string|Element)} el - Specifies the container in which the icon is rendered as a DOM element of the type
 *    `<svg>`, or a CSS selector to such an element.
 * @param {*=} hashOrValue - Optional hash or value to be rendered. If not specified, the `data-jdenticon-hash` or
 *    `data-jdenticon-value` attribute will be evaluated.
 * @param {Object|number=} config - Optional configuration. If specified, this configuration object overrides any
 *    global configuration in its entirety. For backward compability a padding value in the range [0.0, 0.5) can be
 *    specified in place of a configuration object.
 */ function $13374e707bb24dca$var$updateSvg(el, hashOrValue, config) {
    $13374e707bb24dca$var$renderDomElement(el, hashOrValue, config, function(el, iconType) {
        if (iconType == $13374e707bb24dca$var$ICON_TYPE_SVG) return new $13374e707bb24dca$var$SvgRenderer(new $13374e707bb24dca$var$SvgElement(el));
    });
}
/**
 * Updates the identicon in the specified canvas or svg elements.
 * @param {(string|Element)} el - Specifies the container in which the icon is rendered as a DOM element of the type
 *    `<svg>` or `<canvas>`, or a CSS selector to such an element.
 * @param {*} hashOrValue - Optional hash or value to be rendered. If not specified, the `data-jdenticon-hash` or
 *    `data-jdenticon-value` attribute will be evaluated.
 * @param {Object|number|undefined} config
 * @param {function(Element,number):Renderer} rendererFactory - Factory function for creating an icon renderer.
 */ function $13374e707bb24dca$var$renderDomElement(el, hashOrValue, config, rendererFactory) {
    if (typeof el === "string") {
        if ($13374e707bb24dca$var$documentQuerySelectorAll) {
            var elements = $13374e707bb24dca$var$documentQuerySelectorAll(el);
            for(var i = 0; i < elements.length; i++)$13374e707bb24dca$var$renderDomElement(elements[i], hashOrValue, config, rendererFactory);
        }
        return;
    }
    // Hash selection. The result from getValidHash or computeHash is 
    // accepted as a valid hash.
    var hash = // 1. Explicit valid hash
    $13374e707bb24dca$var$isValidHash(hashOrValue) || // 2. Explicit value (`!= null` catches both null and undefined)
    hashOrValue != null && $13374e707bb24dca$var$computeHash(hashOrValue) || // 3. `data-jdenticon-hash` attribute
    $13374e707bb24dca$var$isValidHash(el.getAttribute($13374e707bb24dca$var$ATTRIBUTES.U /*HASH*/ )) || // 4. `data-jdenticon-value` attribute. 
    // We want to treat an empty attribute as an empty value. 
    // Some browsers return empty string even if the attribute 
    // is not specified, so use hasAttribute to determine if 
    // the attribute is specified.
    el.hasAttribute($13374e707bb24dca$var$ATTRIBUTES.D /*VALUE*/ ) && $13374e707bb24dca$var$computeHash(el.getAttribute($13374e707bb24dca$var$ATTRIBUTES.D /*VALUE*/ ));
    if (!hash) // No hash specified. Don't render an icon.
    return;
    var renderer = rendererFactory(el, $13374e707bb24dca$var$getIdenticonType(el));
    if (renderer) // Draw icon
    $13374e707bb24dca$var$iconGenerator(renderer, hash, config);
}
// This file is compiled to dist/jdenticon-module.js
var $13374e707bb24dca$var$jdenticon = $13374e707bb24dca$var$updateAll;
$13374e707bb24dca$var$defineConfigProperty($13374e707bb24dca$var$jdenticon);
// Export public API
$13374e707bb24dca$var$jdenticon["configure"] = $13374e707bb24dca$var$configure;
$13374e707bb24dca$var$jdenticon["drawIcon"] = $13374e707bb24dca$var$drawIcon;
$13374e707bb24dca$var$jdenticon["toSvg"] = $13374e707bb24dca$var$toSvg;
$13374e707bb24dca$var$jdenticon["update"] = $13374e707bb24dca$var$update;
$13374e707bb24dca$var$jdenticon["updateCanvas"] = $13374e707bb24dca$var$updateCanvas;
$13374e707bb24dca$var$jdenticon["updateSvg"] = $13374e707bb24dca$var$updateSvg;
/**
 * Specifies the version of the Jdenticon package in use.
 * @type {string}
 */ $13374e707bb24dca$var$jdenticon["version"] = "3.2.0";
/**
 * Specifies which bundle of Jdenticon that is used.
 * @type {string}
 */ $13374e707bb24dca$var$jdenticon["bundle"] = "browser-cjs";
$13374e707bb24dca$exports = $13374e707bb24dca$var$jdenticon;



var $4Iuzv = parcelRequire("4Iuzv");
function $4197f28cee2bd5b1$var$Identicon({ className: className = "", publicKey: publicKey, size: size, style: style = {} }) {
    const html = (0, $4Iuzv.useMemo)(()=>({
            __html: $13374e707bb24dca$exports.toSvg(publicKey.substring(2), size)
        }), [
        publicKey,
        size
    ]);
    return (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: className,
        dangerouslySetInnerHTML: html,
        style: style
    });
}
const $4197f28cee2bd5b1$export$43779234950f6207 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo($4197f28cee2bd5b1$var$Identicon);



var $4Iuzv = parcelRequire("4Iuzv");

const $5934e11ee923f924$var$S = 64;
const $5934e11ee923f924$var$C = $5934e11ee923f924$var$S / 2;
const $5934e11ee923f924$var$Z = $5934e11ee923f924$var$S / 64 * 5;
const $5934e11ee923f924$var$SCHEMES = [
    /* target  */ {
        colors: [
            0,
            28,
            0,
            0,
            28,
            0,
            0,
            28,
            0,
            0,
            28,
            0,
            0,
            28,
            0,
            0,
            28,
            0,
            1
        ],
        freq: 1
    },
    /* cube    */ {
        colors: [
            0,
            1,
            3,
            2,
            4,
            3,
            0,
            1,
            3,
            2,
            4,
            3,
            0,
            1,
            3,
            2,
            4,
            3,
            5
        ],
        freq: 20
    },
    /* quazar  */ {
        colors: [
            1,
            2,
            3,
            1,
            2,
            4,
            5,
            5,
            4,
            1,
            2,
            3,
            1,
            2,
            4,
            5,
            5,
            4,
            0
        ],
        freq: 16
    },
    /* flower  */ {
        colors: [
            0,
            1,
            2,
            0,
            1,
            2,
            0,
            1,
            2,
            0,
            1,
            2,
            0,
            1,
            2,
            0,
            1,
            2,
            3
        ],
        freq: 32
    },
    /* cyclic  */ {
        colors: [
            0,
            1,
            2,
            3,
            4,
            5,
            0,
            1,
            2,
            3,
            4,
            5,
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ],
        freq: 32
    },
    /* vmirror */ {
        colors: [
            0,
            1,
            2,
            3,
            4,
            5,
            3,
            4,
            2,
            0,
            1,
            6,
            7,
            8,
            9,
            7,
            8,
            6,
            10
        ],
        freq: 128
    },
    /* hmirror */ {
        colors: [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            8,
            6,
            7,
            5,
            3,
            4,
            2,
            11
        ],
        freq: 128
    }
];
const $5934e11ee923f924$var$SCHEMES_TOTAL = $5934e11ee923f924$var$SCHEMES.map((s)=>s.freq).reduce((a, b)=>a + b);
const $5934e11ee923f924$var$OUTER_CIRCLE = {
    cx: $5934e11ee923f924$var$C,
    cy: $5934e11ee923f924$var$C,
    fill: "#eee",
    r: $5934e11ee923f924$var$C
};
let $5934e11ee923f924$var$zeroHash = new Uint8Array();
function $5934e11ee923f924$var$getRotation(isSixPoint) {
    const r = isSixPoint ? $5934e11ee923f924$var$C / 8 * 5 : $5934e11ee923f924$var$C / 4 * 3;
    const rroot3o2 = r * Math.sqrt(3) / 2;
    const ro2 = r / 2;
    const rroot3o4 = r * Math.sqrt(3) / 4;
    const ro4 = r / 4;
    const r3o4 = r * 3 / 4;
    return {
        r: r,
        r3o4: r3o4,
        ro2: ro2,
        ro4: ro4,
        rroot3o2: rroot3o2,
        rroot3o4: rroot3o4
    };
}
function $5934e11ee923f924$var$getCircleXY(isSixPoint = false) {
    const { r: r, r3o4: r3o4, ro2: ro2, ro4: ro4, rroot3o2: rroot3o2, rroot3o4: rroot3o4 } = $5934e11ee923f924$var$getRotation(isSixPoint);
    return [
        [
            $5934e11ee923f924$var$C,
            $5934e11ee923f924$var$C - r
        ],
        [
            $5934e11ee923f924$var$C,
            $5934e11ee923f924$var$C - ro2
        ],
        [
            $5934e11ee923f924$var$C - rroot3o4,
            $5934e11ee923f924$var$C - r3o4
        ],
        [
            $5934e11ee923f924$var$C - rroot3o2,
            $5934e11ee923f924$var$C - ro2
        ],
        [
            $5934e11ee923f924$var$C - rroot3o4,
            $5934e11ee923f924$var$C - ro4
        ],
        [
            $5934e11ee923f924$var$C - rroot3o2,
            $5934e11ee923f924$var$C
        ],
        [
            $5934e11ee923f924$var$C - rroot3o2,
            $5934e11ee923f924$var$C + ro2
        ],
        [
            $5934e11ee923f924$var$C - rroot3o4,
            $5934e11ee923f924$var$C + ro4
        ],
        [
            $5934e11ee923f924$var$C - rroot3o4,
            $5934e11ee923f924$var$C + r3o4
        ],
        [
            $5934e11ee923f924$var$C,
            $5934e11ee923f924$var$C + r
        ],
        [
            $5934e11ee923f924$var$C,
            $5934e11ee923f924$var$C + ro2
        ],
        [
            $5934e11ee923f924$var$C + rroot3o4,
            $5934e11ee923f924$var$C + r3o4
        ],
        [
            $5934e11ee923f924$var$C + rroot3o2,
            $5934e11ee923f924$var$C + ro2
        ],
        [
            $5934e11ee923f924$var$C + rroot3o4,
            $5934e11ee923f924$var$C + ro4
        ],
        [
            $5934e11ee923f924$var$C + rroot3o2,
            $5934e11ee923f924$var$C
        ],
        [
            $5934e11ee923f924$var$C + rroot3o2,
            $5934e11ee923f924$var$C - ro2
        ],
        [
            $5934e11ee923f924$var$C + rroot3o4,
            $5934e11ee923f924$var$C - ro4
        ],
        [
            $5934e11ee923f924$var$C + rroot3o4,
            $5934e11ee923f924$var$C - r3o4
        ],
        [
            $5934e11ee923f924$var$C,
            $5934e11ee923f924$var$C
        ]
    ];
}
function $5934e11ee923f924$var$findScheme(d) {
    let cum = 0;
    const schema = $5934e11ee923f924$var$SCHEMES.find((schema)=>{
        cum += schema.freq;
        return d < cum;
    });
    if (!schema) throw new Error("Unable to find schema");
    return schema;
}
function $5934e11ee923f924$var$addressToId(address) {
    if (!$5934e11ee923f924$var$zeroHash.length) $5934e11ee923f924$var$zeroHash = (0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)(new Uint8Array(32), 512);
    return (0, $dcbcf4e1d1853689$export$5faebd53a9e0f952)((0, $75dfbb1cb93569bf$export$63e61a72b498228b)(address), 512).map((x, i)=>(x + 256 - $5934e11ee923f924$var$zeroHash[i]) % 256);
}
function $5934e11ee923f924$var$getColors(address) {
    const id = $5934e11ee923f924$var$addressToId(address);
    const d = Math.floor((id[30] + id[31] * 256) % $5934e11ee923f924$var$SCHEMES_TOTAL);
    const rot = id[28] % 6 * 3;
    const sat = Math.floor(id[29] * 70 / 256 + 26) % 80 + 30;
    const scheme = $5934e11ee923f924$var$findScheme(d);
    const palette = Array.from(id).map((x, i)=>{
        const b = (x + i % 28 * 58) % 256;
        if (b === 0) return "#444";
        else if (b === 255) return "transparent";
        const h = Math.floor(b % 64 * 360 / 64);
        const l = [
            53,
            15,
            35,
            75
        ][Math.floor(b / 64)];
        return `hsl(${h}, ${sat}%, ${l}%)`;
    });
    return scheme.colors.map((_, i)=>palette[scheme.colors[i < 18 ? (i + rot) % 18 : 18]]);
}
function $5934e11ee923f924$export$232768a07fb38f5b(address, { isAlternative: isAlternative }) {
    const xy = $5934e11ee923f924$var$getCircleXY(isAlternative);
    let colors;
    try {
        // in some cases, e.g. RN where crypto may not be initialized, chaos can
        // happen when hashing, in these cases we just fill with a placeholder
        colors = $5934e11ee923f924$var$getColors(address);
    } catch  {
        colors = new Array(xy.length).fill("#ddd");
    }
    return [
        $5934e11ee923f924$var$OUTER_CIRCLE
    ].concat(xy.map(([cx, cy], index)=>({
            cx: cx,
            cy: cy,
            fill: colors[index],
            r: $5934e11ee923f924$var$Z
        })));
}


function $6c27eac3a08f7a3f$var$renderCircle({ cx: cx, cy: cy, fill: fill, r: r }, key) {
    return (0, $3c47adbabe8a32cb$exports.jsx)("circle", {
        cx: cx,
        cy: cy,
        fill: fill,
        r: r
    }, key);
}
function $6c27eac3a08f7a3f$var$Identicon({ address: address, className: className = "", isAlternative: isAlternative = false, size: size, style: style = {} }) {
    const circles = (0, $4Iuzv.useMemo)(()=>(0, $5934e11ee923f924$export$232768a07fb38f5b)(address, {
            isAlternative: isAlternative
        }), [
        address,
        isAlternative
    ]);
    return (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        height: size,
        id: address,
        name: address,
        style: style,
        viewBox: "0 0 64 64",
        width: size,
        children: circles.map($6c27eac3a08f7a3f$var$renderCircle)
    });
}
const $6c27eac3a08f7a3f$export$33b45215951af2b5 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo($6c27eac3a08f7a3f$var$Identicon);



const $4596480952151877$var$Fallback = (0, $76fca3c684e0769f$export$cdad1aec2bf7dbc3);
const $4596480952151877$var$DEFAULT_SIZE = 64;
const $4596480952151877$var$Components = {
    beachball: (0, $76fca3c684e0769f$export$cdad1aec2bf7dbc3),
    empty: (0, $c2d773e70b8269a4$export$1f74963c34e8bfec),
    ethereum: (0, $f57a66bb0a1cbd43$export$aa318bacd7f710c5),
    jdenticon: (0, $4197f28cee2bd5b1$export$43779234950f6207),
    polkadot: (0, $6c27eac3a08f7a3f$export$33b45215951af2b5),
    substrate: (0, $4197f28cee2bd5b1$export$43779234950f6207)
};
class $4596480952151877$var$BaseIcon extends (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).PureComponent {
    constructor(){
        super(...arguments);
        this.state = {
            address: "",
            publicKey: "0x"
        };
        this.onCopy = ()=>{
            const { onCopy: onCopy } = this.props;
            const { address: address } = this.state;
            if (address && onCopy) onCopy(address);
        };
    }
    static setDefaultPrefix(prefix) {
        $4596480952151877$var$BaseIcon.prefix = prefix;
    }
    static getDerivedStateFromProps({ prefix: prefix = $4596480952151877$var$BaseIcon.prefix, theme: theme, value: value }, prevState) {
        if (theme === "ethereum") {
            const address = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) ? (0, $f91b87c3e225bdcf$export$2d4f4037b7611bc7)(value) : value || "";
            return {
                address: address,
                publicKey: ""
            };
        }
        try {
            const address = (0, $ad964ef63ebabd4e$export$f5328759db5e050d)(value) || (0, $de053f8bd7fe9927$export$8a9b6341a7c96bc)(value) ? (0, $c22d2e6736a2594b$export$b149ba8ff44e4e70)(value, prefix) : value || "";
            const publicKey = (0, $1e2cfad286c009ca$export$4429d284633899e1)((0, $75dfbb1cb93569bf$export$63e61a72b498228b)(address, false, prefix));
            return address === prevState.address ? null : {
                address: address,
                publicKey: publicKey
            };
        } catch  {
            return {
                address: "",
                publicKey: "0x"
            };
        }
    }
    render() {
        const { address: address } = this.state;
        const wrapped = this.getWrapped(this.state, this.props);
        return !address ? wrapped : (0, $3c47adbabe8a32cb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($542cb45932491e02$exports))), {
            onCopy: this.onCopy,
            text: address,
            children: wrapped
        });
    }
    getWrapped({ address: address, publicKey: publicKey }, { Custom: Custom }) {
        const { className: className = "", isAlternative: isAlternative, isHighlight: isHighlight, size: size = $4596480952151877$var$DEFAULT_SIZE, style: style = {}, theme: theme = (0, $2228a38573058660$export$a5a6e0b888b2c992).icon } = this.props;
        const Component = !address ? (0, $c2d773e70b8269a4$export$1f74963c34e8bfec) : Custom || $4596480952151877$var$Components[theme === "default" ? (0, $ad93b1a428581336$export$1e716925a55d2873) : theme] || $4596480952151877$var$Fallback;
        return (0, $3c47adbabe8a32cb$exports.jsx)($4596480952151877$var$StyledDiv, {
            className: `ui--IdentityIcon  ${className}`,
            style: style,
            children: (0, $3c47adbabe8a32cb$exports.jsx)(Component, {
                address: address,
                className: isHighlight ? "highlight" : "",
                isAlternative: isAlternative,
                publicKey: publicKey,
                size: size
            })
        }, address);
    }
}
$4596480952151877$var$BaseIcon.prefix = undefined;
function $4596480952151877$var$Icon(props) {
    return (0, $3c47adbabe8a32cb$exports.jsx)($4596480952151877$var$BaseIcon, {
        ...props
    });
}
const $4596480952151877$var$StyledDiv = (0, $17a9bc5f129a30aa$export$3817b7a54a07cec7).div`
  cursor: copy;
  display: inline-block;
  line-height: 0;

  > .container {
    position: relative;

    > div,
    > svg {
      position: relative;
    }

    &.highlight:before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 50%;
      box-shadow: 0 0 5px 2px #aaa;
      content: '';
    }
  }
`;
const $4596480952151877$export$88550efb59f40d8a = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).memo($4596480952151877$var$Icon);


var $0942b75a53548d8d$export$2e2bcd8739ae039 = (0, $4596480952151877$export$88550efb59f40d8a);



function $8005f4acee16c419$var$variantStyles(type, disabled = false) {
    switch(type){
        case "primary":
            return `flex min-w-min appearance-none items-center  justify-center  gap-2 rounded-full bg-fill-primary ${!disabled ? "hover:bg-fill-primary-hover active:bg-fill-primary-pressed" : ""} px-4 py-2 text-sm  text-white disabled:opacity-50 `;
        case "secondary":
            return `flex min-w-min appearance-none items-center justify-center  gap-2 rounded-full bg-fill-secondary ${!disabled ? "hover:bg-fill-secondary-hover active:bg-fill-secondary-pres" : ""} px-4 py-2 text-sm text-white  disabled:bg-gray-200 disabled:text-fg-disabled`;
        case "outline":
            return `flex min-w-min appearance-none items-center justify-center gap-2 rounded-full border border-solid px-4 py-2 ${!disabled ? "hover:border-primary" : ""} disabled:text-fg-disabled`;
        case "ghost":
            return `flex min-w-min appearance-none items-center bg-white/70 justify-center gap-2 rounded-full px-4 py-2 ${!disabled ? "hover:bg-white" : ""} disabled:bg-white/70 disabled:text-fg-disabled `;
    }
}
function $8005f4acee16c419$export$353f5b6fc5456de1({ children: children, style: style, onClick: onClick, variant: variant = "secondary", className: className, disabled: disabled, ...rest }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
        className: `${$8005f4acee16c419$var$variantStyles(variant, disabled)} ${className}`,
        style: {
            ...style
        },
        onClick: !disabled ? onClick : undefined,
        disabled: disabled,
        ...rest,
        children: children
    });
}



function $b97b7432295b195f$export$60332b2344f7fe41({ className: className, children: children, style: style }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: `rounded-2xl bg-white p-2 shadow ${className || ""}`,
        style: style,
        children: children
    });
}



function $9146fa2a579f8b85$export$669f6ea7d267feaf({ className: className, size: size = "md", style: style }) {
    const sizeClasses = {
        xs: "h-4 w-4",
        sm: "h-8 w-8",
        md: "h-12 w-12",
        lg: "h-24 w-24",
        xl: "h-36 w-36"
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
                "aria-hidden": "true",
                className: `inline ${sizeClasses[size]} m-auto animate-spin fill-primary text-gray-200 ${className || ""}`,
                style: style,
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");
function $1a4e1b3b9f930c16$var$useEscapeHandler(callback) {
    (0, $4Iuzv.useEffect)(()=>{
        function handleEscape(event) {
            if (event.key === "Escape") callback();
        }
        document.addEventListener("keydown", handleEscape);
        return ()=>{
            document.removeEventListener("keydown", handleEscape);
        };
    }, [
        callback
    ]);
}
var $1a4e1b3b9f930c16$export$2e2bcd8739ae039 = $1a4e1b3b9f930c16$var$useEscapeHandler;


const $7b51a257e986fbd2$var$sizeClasses = {
    sm: "w-[416px]",
    md: "w-[640px]",
    lg: "w-[864px]",
    xl: "w-[1248px]",
    full: "w-full"
};
const $7b51a257e986fbd2$export$2b77a92f1a5ad772 = ({ className: className, children: children, size: size, open: open, closeOnEsc: closeOnEsc = true, onClose: onClose })=>{
    size = size || "md";
    (0, $1a4e1b3b9f930c16$export$2e2bcd8739ae039)(()=>{
        closeOnEsc && onClose?.();
    });
    const closeHandler = (e)=>{
        e.stopPropagation();
        onClose?.();
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: open && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
            tabIndex: -1,
            className: `fixed left-0 right-0 top-0 z-[100] flex h-full w-full animate-[fadeIn_0.23s] overflow-y-auto overflow-x-hidden bg-[rgba(0,0,0,0.85)] p-4 md:inset-0`,
            onClick: closeHandler,
            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `relative mx-auto max-w-full animate-[lift_ease-out_0.1s] self-center rounded-xl bg-white p-2 shadow-xl transition-all ${$7b51a257e986fbd2$var$sizeClasses[size]} ${className || ""}`,
                onClick: (e)=>{
                    e.stopPropagation();
                },
                children: children
            })
        })
    });
};




var $4Iuzv = parcelRequire("4Iuzv");
const $49762cb87c2f3a11$var$navbarContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({
    collapsed: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggle: ()=>{}
});
const $49762cb87c2f3a11$var$useNavbar = ()=>(0, $4Iuzv.useContext)($49762cb87c2f3a11$var$navbarContext);
const $49762cb87c2f3a11$var$NavbarContextProvider = ({ children: children })=>{
    const [collapsed, setCollapsed] = (0, $4Iuzv.useState)(true);
    const toggle = ()=>{
        setCollapsed((collapsed)=>!collapsed);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($49762cb87c2f3a11$var$navbarContext.Provider, {
        value: {
            collapsed: collapsed,
            toggle: toggle
        },
        children: children
    });
};
const $49762cb87c2f3a11$var$Brand = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `flex items-center ${className || ""}`,
        children: [
            " ",
            children
        ]
    });
};
const $49762cb87c2f3a11$var$Item = ({ children: children, className: className, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
        onClick: onClick,
        className: `block rounded py-2 pl-3 pr-4 text-gray-700 md:p-0  ${className || ""}`,
        children: children
    });
};
const $49762cb87c2f3a11$var$Content = ({ children: children, className: className })=>{
    const { collapsed: collapsed } = $49762cb87c2f3a11$var$useNavbar();
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: `${collapsed ? "hidden" : "flex"} absolute left-0 top-full z-20 order-last h-full min-h-screen w-full basis-full flex-col items-center justify-between overflow-y-auto overflow-x-hidden bg-white  md:static md:order-none md:flex md:h-auto md:min-h-min md:w-auto md:basis-auto md:flex-row md:bg-inherit`,
        id: "navbar-content",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
            className: `mt-4 flex flex-col md:mt-0 md:flex-row md:space-x-8 md:border-0  md:text-sm md:font-medium ${className}`,
            children: children
        })
    });
};
const $49762cb87c2f3a11$var$Component = /*#__PURE__*/ (0, $4Iuzv.forwardRef)(({ className: className, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
        className: `fixed z-10 w-full rounded bg-bg-default px-2  md:px-4 ${className || ""}`,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "mx-auto flex w-full flex-wrap items-center justify-between  py-2 md:py-6",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($49762cb87c2f3a11$var$NavbarContextProvider, {
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "h-[1px] w-full bg-[#E9E9E9]"
            })
        ]
    });
});
const $49762cb87c2f3a11$export$42cfbb80f7861e77 = Object.assign($49762cb87c2f3a11$var$Component, {
    Item: $49762cb87c2f3a11$var$Item,
    Brand: $49762cb87c2f3a11$var$Brand,
    Content: $49762cb87c2f3a11$var$Content
});




var $4Iuzv = parcelRequire("4Iuzv");

function $b42cfec9fe4e6e2e$export$4857d3f3f5f8319b({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "3",
        viewBox: "0 0 29 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M25.988 8.563l-11.01 13-10.99-13",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$7f01a6cbee61a0f2({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "3",
        viewBox: "0 0 29 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M3 21.1309L14.011 8.13086L25 21.1309",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$b837bd7eac09a33e({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M9 6l9 7.508L9 21",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$a6b7c34d56975de0({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M13.988 2c6.628 0 12 5.373 12 12s-5.372 12-12 12c-6.627 0-12-5.373-12-12s5.373-12 12-12zM8.794 13.46l10.39.057M14.018 8.295l-.057 10.39"
        })
    });
}
function $b42cfec9fe4e6e2e$export$cae179f078f4b4a4({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M4.893 4.231l19.799 19.8M24.692 4.231l-19.8 19.8",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$27367e37ecc5fa05({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                strokeMiterlimit: "10",
                d: "M25.473 16l-10 10M12 2.62l-10 10M2.107 26L25.5 2.607",
                "data-nofill": "true"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M20.448 15.399l5.534-.018.018 5.55M6.975 2.018L12.509 2l.018 5.55M20.448 2.018L25.982 2 26 7.55",
                "data-nofill": "true"
            })
        ]
    });
}
function $b42cfec9fe4e6e2e$export$7dd004358974b05d({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M3 13.946L10.766 21 25 7",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$deff84e7338ee5a5({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M26.76 3.25H1.24v21.5h25.52V3.25z"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M26.774 8.98H17.77a5.02 5.02 0 000 10.04h9.005V8.98z"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("circle", {
                cx: "18",
                cy: "14",
                r: "1"
            })
        ]
    });
}
function $b42cfec9fe4e6e2e$export$541a84723b7db0e9({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M11.45 9H6.73A4.73 4.73 0 002 13.73v0a4.73 4.73 0 004.73 4.73h4.72M16.497 18.497h4.773a4.73 4.73 0 004.73-4.73v0a4.73 4.73 0 00-4.73-4.73h-4.773M20.108 13.736H7.862M3 2l22 24",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$2789403f16b80e3({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M17.468 18.628h4.773a4.73 4.73 0 004.73-4.73v0a4.73 4.73 0 00-4.73-4.73h-4.773M12.42 9.13H7.7a4.73 4.73 0 00-4.73 4.73v0a4.73 4.73 0 004.73 4.73h4.72M21.079 13.867H8.833",
            "data-nofill": "true"
        })
    });
}
function $b42cfec9fe4e6e2e$export$5bf9f996ff81a819({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        viewBox: "0 0 23 23",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            fill: "#E6007A",
            d: "M11.064 5.3c2.106 0 3.813-.996 3.813-2.225 0-1.23-1.707-2.226-3.813-2.226S7.25 1.846 7.25 3.075 8.958 5.3 11.064 5.3zM11.064 22.064c2.106 0 3.813-.996 3.813-2.225 0-1.23-1.707-2.226-3.813-2.226s-3.813.997-3.813 2.226 1.707 2.225 3.813 2.225zM5.75 8.378c1.052-1.83 1.046-3.81-.015-4.425-1.062-.615-2.775.37-3.828 2.2s-1.047 3.81.015 4.425c1.06.615 2.775-.37 3.827-2.2zM20.221 16.76c1.053-1.829 1.047-3.81-.015-4.425-1.06-.615-2.774.37-3.827 2.2s-1.047 3.81.015 4.425c1.06.615 2.775-.37 3.827-2.2zM5.735 18.96c1.06-.614 1.067-2.596.014-4.425-1.052-1.83-2.766-2.814-3.827-2.2-1.062.615-1.068 2.596-.015 4.426 1.053 1.83 2.766 2.814 3.828 2.2zM20.206 10.578c1.062-.615 1.068-2.596.015-4.425-1.052-1.83-2.766-2.815-3.827-2.2-1.062.614-1.068 2.596-.015 4.425 1.053 1.83 2.766 2.815 3.827 2.2z"
        })
    });
}
function $b42cfec9fe4e6e2e$export$c941445333056a94({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 28",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M7.02 19.893v5.589l7.337-5.59h12.395V2.25h-25.5v17.644H7.02z"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("circle", {
                cx: "7.5",
                cy: "11.5",
                r: "1.5"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("circle", {
                cx: "13.5",
                cy: "11.5",
                r: "1.5"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("circle", {
                cx: "19.5",
                cy: "11.5",
                r: "1.5"
            })
        ]
    });
}
function $b42cfec9fe4e6e2e$export$dbf4042b40a603ee({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M14.988 26.676c6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12-6.627 0-12 5.372-12 12 0 6.627 5.373 12 12 12z"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                strokeMiterlimit: "10",
                d: "M14.998 13.082l.01 7.13M14.988 8.676l.018.018"
            })
        ]
    });
}
function $b42cfec9fe4e6e2e$export$51b6cd98f8778f0d({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M8.99414 8.5V2H25.9941V19H19.4941"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M18.9941 9H1.99414V26H18.9941V9Z"
                })
            ]
        })
    });
}
function $b42cfec9fe4e6e2e$export$9ca09caa9c849d9c({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M25 14.0086L2 14.0086",
                fill: "none",
                "data-nofill": "true"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M15.8003 4L26 14.0086L15.8003 24",
                fill: "none",
                "data-nofill": "true"
            })
        ]
    });
}
function $b42cfec9fe4e6e2e$export$8afed21ef5c2afa5({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M3 13.9914L26 13.9914",
                fill: "none",
                "data-nofill": "true"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                d: "M12.1997 24L2 13.9914L12.1997 4",
                fill: "none",
                "data-nofill": "true"
            })
        ]
    });
}
function $b42cfec9fe4e6e2e$export$1c5b0383ec045924({ size: size, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size ? size : "16",
        height: size ? size : "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 28 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M1.99997 27L26.2441 27L26.2441 3L1.99997 3L1.99997 27Z"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M26.2371 9.57935H2.00026"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M9.32502 6.46778L9.30768 6.45044",
                    strokeMiterlimit: "10"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M5.50117 6.46778L5.48383 6.45044",
                    strokeMiterlimit: "10"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M10.2498 20.2866L7.39581 17.9107L10.2498 15.53"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M18.2633 15.5205L21.1268 17.906L18.2633 20.2866"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
                    d: "M15.8593 13.1421L12.6537 22.674"
                })
            ]
        })
    });
}


const $46855caad664cddd$export$931cbfb6bfb85fc = ({ options: options, className: className, onSelect: onSelect, menuAlign: menuAlign = "left" })=>{
    const [isOpen, setIsOpen] = (0, $4Iuzv.useState)(false);
    const [selectedOption, setSelectedOption] = (0, $4Iuzv.useState)(options.filter((o)=>o.active)[0]);
    const alignClass = {
        right: "right-0",
        left: "left-0",
        center: "left-1/2 translate-x-[-50%]"
    };
    const handleOptionClick = (option)=>{
        setSelectedOption(option);
        onSelect(option);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: `flex min-w-min cursor-pointer select-none appearance-none items-center gap-2 rounded-full bg-white/70 px-4 py-2 text-body hover:bg-white ${className || ""}`,
                onClick: ()=>setIsOpen(!isOpen),
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "grow whitespace-nowrap",
                        children: selectedOption ? selectedOption.label : ""
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        children: isOpen ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$7f01a6cbee61a0f2), {}) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$4857d3f3f5f8319b), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "relative mt-1 h-0",
                children: isOpen && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                    className: `absolute top-1 flex w-full min-w-max flex-col rounded-lg bg-white/80 py-2 shadow-lg backdrop-blur-3xl duration-300 ${alignClass[menuAlign]}`,
                    children: options.map((option, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                            className: "cursor-pointer select-none px-4 py-2 hover:bg-bg-default/80",
                            onClick: ()=>handleOptionClick(option),
                            children: option.label
                        }, idx))
                })
            })
        ]
    });
};






var $4Iuzv = parcelRequire("4Iuzv");



var $4Iuzv = parcelRequire("4Iuzv");
class $4e06c94991d4d709$export$a423590dd7c65f17 {
    constructor(providers){
        this.walletProviders = providers;
    }
    getWallets() {
        let wallets = [];
        for (let provider of this.walletProviders)wallets.push(...provider.getWallets());
        return wallets;
    }
}


var $5bee2f1ff871147d$export$5d6973e21e6f88d9;
(function(WalletType) {
    WalletType["INJECTED"] = "INJECTED";
    WalletType["WALLET_CONNECT"] = "WALLET_CONNECT";
    WalletType["LEDGER"] = "LEDGER";
})($5bee2f1ff871147d$export$5d6973e21e6f88d9 || ($5bee2f1ff871147d$export$5d6973e21e6f88d9 = {}));





const $cbeee4cd6ae8d2ea$var$toWalletAccount = (account)=>{
    return account;
};
class $cbeee4cd6ae8d2ea$var$InjectedWallet {
    constructor(extension, appName){
        this.type = (0, $5bee2f1ff871147d$export$5d6973e21e6f88d9).INJECTED;
        this.extension = extension;
        this.metadata = {
            ...extension.metadata
        };
        this.appName = appName;
    }
    async getAccounts() {
        let injectedAccounts = await this.injected?.accounts.get();
        let walletAccounts = injectedAccounts?.map((account)=>$cbeee4cd6ae8d2ea$var$toWalletAccount(account));
        return walletAccounts || [];
    }
    async connect() {
        try {
            let injected;
            if (this.extension?.connect) injected = await this.extension.connect(this.appName);
            else if (this.extension?.enable) injected = await this.extension.enable(this.appName);
            else throw new Error("No connect(..) or enable(...) hook found");
            this.injected = injected;
            this.signer = injected.signer;
        } catch ({ message: message }) {
            console.error(`Error initializing ${this.metadata.title}: ${message}`);
        }
    }
    async disconnect() {}
    isConnected() {
        return false;
    }
}
class $cbeee4cd6ae8d2ea$export$d9901a977773197b {
    constructor(config, appName, supportedOnly = false){
        this.config = config;
        this.supportedOnly = supportedOnly;
        this.appName = appName;
    }
    getExtensions() {
        const injectedWindow = window;
        const knownExtensions = [];
        const otherExtensions = [];
        if (injectedWindow.injectedWeb3) Object.keys(injectedWindow.injectedWeb3).forEach((extensionId)=>{
            if (!this.config.disallowed?.includes(extensionId)) {
                const foundExtension = this.config.supported?.find(({ id: id })=>id === extensionId);
                if (foundExtension) knownExtensions.push({
                    ...injectedWindow.injectedWeb3[extensionId],
                    metadata: foundExtension
                });
                else otherExtensions.push({
                    ...injectedWindow.injectedWeb3[extensionId],
                    metadata: {
                        id: extensionId,
                        title: extensionId
                    }
                });
            }
        });
        else console.info("no extension was detected!");
        return {
            known: knownExtensions,
            other: otherExtensions
        };
    }
    getWallets() {
        let injectedWallets = [];
        let { known: known, other: other } = this.getExtensions();
        let extensions = [
            ...known
        ];
        if (!this.supportedOnly) extensions = [
            ...extensions,
            ...other
        ];
        injectedWallets = extensions.map((ext)=>new $cbeee4cd6ae8d2ea$var$InjectedWallet(ext, this.appName));
        return injectedWallets;
    }
}








var $4Iuzv = parcelRequire("4Iuzv");
const $f5c8ce4d99fc0a63$var$PolkadotWalletsContext = (0, $4Iuzv.createContext)({
    wallets: undefined
});
const $f5c8ce4d99fc0a63$export$934951b5ed2ebf82 = ()=>(0, $4Iuzv.useContext)($f5c8ce4d99fc0a63$var$PolkadotWalletsContext);
const $f5c8ce4d99fc0a63$export$3e8ea749cd1c9302 = ({ children: children, walletAggregator: walletAggregator, initialWaitMs: initialWaitMs = 5 /* the default is set to 5ms to give extensions enough lead time to inject their providers */  })=>{
    const [wallets, setWallets] = (0, $4Iuzv.useState)();
    (0, $4Iuzv.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setWallets(walletAggregator.getWallets());
        }, initialWaitMs);
        return ()=>clearTimeout(timeoutId);
    }, [
        walletAggregator
    ]);
    const contextData = (0, $4Iuzv.useMemo)(()=>({
            wallets: wallets
        }), [
        wallets
    ]);
    return (0, $3c47adbabe8a32cb$exports.jsx)($f5c8ce4d99fc0a63$var$PolkadotWalletsContext.Provider, {
        value: contextData,
        children: children
    });
};




const $2096fa05de40502f$var$APP_NAME = "Polkadot Delegation Dashboard";
const $2096fa05de40502f$var$WalletContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({});
const $2096fa05de40502f$export$934951b5ed2ebf82 = ()=>(0, $4Iuzv.useContext)($2096fa05de40502f$var$WalletContext);
class $2096fa05de40502f$export$a933ec36ba950330 {
    static getStateStorageKey(walletTitle) {
        return `wallet#${walletTitle}`;
    }
    static set(walletTitle, state) {
        const sKey = this.getStateStorageKey(walletTitle);
        localStorage.setItem(sKey, state);
    }
    static get(walletTitle) {
        const sKey = this.getStateStorageKey(walletTitle);
        return localStorage.getItem(sKey);
    }
}
const $2096fa05de40502f$var$WalletProviderInner = ({ children: children })=>{
    const { wallets: wallets } = (0, $f5c8ce4d99fc0a63$export$934951b5ed2ebf82)();
    const [walletState, _setWalletState] = (0, $4Iuzv.useState)(new Map());
    const setWalletState = (title, state)=>{
        _setWalletState((oldState)=>new Map([
                ...oldState,
                [
                    title,
                    state
                ]
            ]));
        $2096fa05de40502f$export$a933ec36ba950330.set(title, state);
    };
    const initiateWallets = async (wallets)=>{
        const walletState = new Map();
        for (const wallet of wallets){
            const title = wallet.metadata?.title;
            if (title) {
                const state = $2096fa05de40502f$export$a933ec36ba950330.get(title);
                if (state === "connected") {
                    await wallet.connect();
                    walletState.set(title, "connected");
                }
            }
        }
        _setWalletState(walletState);
    };
    (0, $4Iuzv.useEffect)(()=>{
        if (wallets) initiateWallets(wallets);
    }, [
        wallets
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($2096fa05de40502f$var$WalletContext.Provider, {
        value: {
            wallets: wallets || [],
            walletState: walletState,
            setWalletState: setWalletState
        },
        children: children
    });
};
const $2096fa05de40502f$var$WalletProvider = ({ children: children })=>{
    const walletAggregator = new (0, $4e06c94991d4d709$export$a423590dd7c65f17)([
        new (0, $cbeee4cd6ae8d2ea$export$d9901a977773197b)({}, $2096fa05de40502f$var$APP_NAME)
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $f5c8ce4d99fc0a63$export$3e8ea749cd1c9302), {
        walletAggregator: walletAggregator,
        initialWaitMs: 1000,
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($2096fa05de40502f$var$WalletProviderInner, {
            children: children
        })
    });
};
var $2096fa05de40502f$export$2e2bcd8739ae039 = $2096fa05de40502f$var$WalletProvider;



// account context
const $47acec667174acda$var$accountContext = /*#__PURE__*/ (0, $4Iuzv.createContext)({});
const $47acec667174acda$export$83a8e409853da004 = ()=>(0, $4Iuzv.useContext)($47acec667174acda$var$accountContext);
class $47acec667174acda$export$fc366a8d0c299696 {
    static CONNECTED_ADRR_STORAGE_KEY = "connectedAddress";
    static getConnectedAddress = ()=>localStorage.getItem(this.CONNECTED_ADRR_STORAGE_KEY);
    static setConnectedAddress = (address)=>localStorage.setItem(this.CONNECTED_ADRR_STORAGE_KEY, address);
}
const $47acec667174acda$var$AccountProvider = ({ children: children })=>{
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { genesisHash: genesisHash } = (0, $ff275152c44ce822$export$4a6dbf642db5266c)(state) || {};
    const [_connectedAccount, _setConnectedAccount] = (0, $4Iuzv.useState)();
    const { wallets: wallets, walletState: walletState } = (0, $2096fa05de40502f$export$934951b5ed2ebf82)();
    const [walletsAccounts, setWalletsAccounts] = (0, $4Iuzv.useState)(new Map());
    const loadConnectedAccount = async ()=>{
        const walletsAccounts = await getWalletsAccounts();
        const connectedAddress = $47acec667174acda$export$fc366a8d0c299696.getConnectedAddress();
        if (connectedAddress) return walletsAccounts.get(connectedAddress);
    };
    const getWalletsAccounts = async ()=>{
        let signingAccounts = new Map();
        for (const wallet of wallets){
            const { signer: signer, metadata: { title: title } } = wallet;
            if (signer && walletState.get(title) === "connected") {
                const walletSigningAccounts = new Map();
                // filter accounts that match the genesis hash.
                const accounts = (await wallet.getAccounts()).filter((account)=>(0, $526c1cdc475b977f$export$4c8c026bbd58385)(account) && (0, $526c1cdc475b977f$export$fa91a32fb7d0a473)(account, genesisHash));
                if (accounts.length > 0) {
                    for (const account of accounts)walletSigningAccounts.set(account.address, {
                        account: account,
                        signer: signer,
                        sourceMetadata: wallet.metadata
                    });
                    signingAccounts = new Map([
                        ...signingAccounts,
                        ...walletSigningAccounts
                    ]);
                }
            }
        }
        return signingAccounts;
    };
    const accountSourceIsConnected = (signingAccount)=>{
        const { sourceMetadata: { title: title } } = signingAccount;
        return walletState.get(title) === "connected";
    };
    const setConnectedAccount = (signingAccount, persist = true)=>{
        const connectedAddress = signingAccount?.account.address;
        persist && $47acec667174acda$export$fc366a8d0c299696.setConnectedAddress(connectedAddress || "");
        _setConnectedAccount(signingAccount);
        updater.setConnectedAddress(connectedAddress || null);
    };
    // load connected account from storage
    const storedConnectedAddress = $47acec667174acda$export$fc366a8d0c299696.getConnectedAddress();
    (0, $4Iuzv.useEffect)(()=>{
        if (storedConnectedAddress) loadConnectedAccount().then((signingAccount)=>{
            if (signingAccount) // connected account might have changed, persist the address in storage
            setConnectedAccount(signingAccount, true);
            else // was not able to load the connected account based on storedConnectedAddress,
            // hence (persist=false) to reset the state but not clearing the local storage value .
            setConnectedAccount(undefined, false);
        });
    }, [
        storedConnectedAddress,
        walletsAccounts
    ]);
    // load accounts from connected wallets
    (0, $4Iuzv.useEffect)(()=>{
        getWalletsAccounts().then((accounts)=>{
            setWalletsAccounts(accounts);
        });
    }, [
        wallets,
        walletState,
        genesisHash
    ]);
    const connectedAccount = _connectedAccount && accountSourceIsConnected(_connectedAccount) ? _connectedAccount : undefined;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($47acec667174acda$var$accountContext.Provider, {
        value: {
            connectedAccount: connectedAccount,
            setConnectedAccount: setConnectedAccount,
            walletsAccounts: walletsAccounts
        },
        children: children
    });
};
var $47acec667174acda$export$2e2bcd8739ae039 = $47acec667174acda$var$AccountProvider;





var $4Iuzv = parcelRequire("4Iuzv");
class $0d0c7aa829ece5a3$export$2d9921d8d94967bf {
    static track = (event, metadata)=>{
        window.sa_event && window.sa_event(event, metadata);
    };
}


const $f3b2482085a85b83$export$30f246ed904de259 = (section)=>{
    section?.current?.scrollIntoView({
        behavior: "smooth"
    });
};
const $f3b2482085a85b83$var$delegationContextDefault = {
    selectedTrackIndexes: new Set([]),
    sectionRefs: new Map(),
    setTrackSelection: ()=>{
        console.error("DelegationContext is used outside of its provider boundary.");
    },
    clearTrackSelection: ()=>{
        console.error("DelegationContext is used outside of its provider boundary.");
    },
    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    scrollToSection: (section)=>{
        console.error("DelegationContext is used outside of its provider boundary.");
    }
};
const $f3b2482085a85b83$var$DelegationContext = /*#__PURE__*/ (0, $4Iuzv.createContext)($f3b2482085a85b83$var$delegationContextDefault);
const $f3b2482085a85b83$export$59cb04417d5d11ae = ()=>(0, $4Iuzv.useContext)($f3b2482085a85b83$var$DelegationContext);
function $f3b2482085a85b83$export$4081c9b75e732995({ children: children }) {
    const [selectedTrackIndexes, _setSelectedTrackIndexes] = (0, $4Iuzv.useState)(new Set());
    // refrences to sections of the app that needs to be acessible to scroll to.
    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    const [sectionRefs, _] = (0, $4Iuzv.useState)(new Map([
        [
            "top",
            (0, $4Iuzv.useRef)()
        ],
        [
            "delegation",
            (0, $4Iuzv.useRef)()
        ]
    ]));
    const setTrackSelection = (id, selection)=>{
        _setSelectedTrackIndexes((oldSelection)=>{
            const newSelection = new Set(oldSelection);
            selection ? newSelection.add(id) : newSelection.delete(id);
            return newSelection;
        });
    };
    const clearTrackSelection = ()=>{
        _setSelectedTrackIndexes(new Set([]));
    };
    const scrollToSection = (0, $4Iuzv.useCallback)((section)=>{
        const sectionRef = sectionRefs.get(section);
        if (sectionRef?.current) {
            $f3b2482085a85b83$export$30f246ed904de259(sectionRef);
            (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Scroll", {
                target: section
            });
        } else console.error(`No ${section} section was found to scroll to.`);
    }, [
        sectionRefs
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($f3b2482085a85b83$var$DelegationContext.Provider, {
        value: {
            selectedTrackIndexes: selectedTrackIndexes,
            setTrackSelection: setTrackSelection,
            clearTrackSelection: clearTrackSelection,
            sectionRefs: sectionRefs,
            scrollToSection: scrollToSection
        },
        children: children
    });
}






var $4Iuzv = parcelRequire("4Iuzv");


/**
 * @name stringShorten
 * @summary Returns a string with maximum length
 * @description
 * Checks the string against the `prefixLength`, if longer than double this, shortens it by placing `..` in the middle of it
 * @example
 * <BR>
 *
 * ```javascript
 * import { stringShorten } from '@polkadot/util';
 *
 * stringShorten('1234567890', 2); // => 12..90
 * ```
 */ function $040aa2aac62aeba3$export$3f31304a17a4ea9a(value, prefixLength = 6) {
    return value.length <= 2 + 2 * prefixLength ? value.toString() : `${value.substring(0, prefixLength)}…${value.slice(-prefixLength)}`;
}




function $38948fe540839acb$export$3e04609c77d2f57e({ className: className, children: children, style: style, onClick: onClick }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: `rounded-lg bg-gray-100 ${className || ""}`,
        style: style,
        onClick: onClick,
        children: children
    });
}


const $91e8716f1d2ced51$var$Account = ({ name: name, address: address, clickHandler: clickHandler, state: state })=>{
    const { isConnected: isConnected } = state || {};
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $38948fe540839acb$export$3e04609c77d2f57e), {
        onClick: clickHandler,
        className: "flex cursor-pointer flex-nowrap p-1",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "m-1 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0942b75a53548d8d$export$2e2bcd8739ae039), {
                    style: {
                        cursor: "unset"
                    },
                    value: address,
                    theme: "polkadot",
                    size: 32
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "m-1 flex flex-auto flex-col text-xs",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "uppercase ",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        children: (0, $040aa2aac62aeba3$export$3f31304a17a4ea9a)(address, 10)
                    })
                ]
            }),
            isConnected ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "nowrap m-1 flex flex-row items-center justify-center gap-1 text-xs text-primary",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        children: "Disconnect"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$541a84723b7db0e9), {})
                ]
            }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "nowrap m-1 flex flex-row items-center justify-center gap-1 text-xs text-secondary",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        children: "Connect"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$2789403f16b80e3), {})
                ]
            })
        ]
    });
};
var $91e8716f1d2ced51$export$2e2bcd8739ae039 = $91e8716f1d2ced51$var$Account;



const $2dcaa35ce649a68d$export$fe248f600fa897e6 = ({ accounts: accounts, connectedAccount: connectedAccount, ss58Format: ss58Format, accountConnectHandler: accountConnectHandler })=>{
    const otherAccounts = (0, $4Iuzv.useMemo)(()=>{
        return [
            ...accounts.values()
        ].filter(({ account: account })=>account?.address !== connectedAccount?.account?.address);
    }, [
        accounts,
        connectedAccount
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "my-4 border-b pb-2",
                children: connectedAccount?.account && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $91e8716f1d2ced51$export$2e2bcd8739ae039), {
                    name: connectedAccount.account.name || "",
                    address: (0, $c22d2e6736a2594b$export$b149ba8ff44e4e70)(connectedAccount.account.address, ss58Format),
                    state: {
                        isConnected: true
                    },
                    clickHandler: ()=>{
                        // disconnect
                        accountConnectHandler(undefined);
                    }
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "my-2 flex flex-col gap-2 overflow-auto",
                children: otherAccounts.map((signingAccount)=>{
                    const { account: account } = signingAccount;
                    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $91e8716f1d2ced51$export$2e2bcd8739ae039), {
                        name: account.name || "",
                        address: (0, $c22d2e6736a2594b$export$b149ba8ff44e4e70)(account.address, ss58Format),
                        state: {
                            isConnected: false
                        },
                        clickHandler: ()=>accountConnectHandler(signingAccount)
                    }, account.address);
                })
            })
        ]
    });
};






const $aa6f3068915f024f$var$Wallet = ({ name: name, state: state, iconUrl: iconUrl, clickHandler: clickHandler })=>{
    const isConnected = state === "connected";
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $38948fe540839acb$export$3e04609c77d2f57e), {
        onClick: clickHandler,
        className: "flex cursor-pointer flex-nowrap gap-2 p-2",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: " flex items-center justify-center",
                children: iconUrl ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                    src: iconUrl
                }) : null
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "flex-auto",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    children: name
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "flex min-w-[1.5rem] items-center justify-center",
                children: isConnected ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "text-[0.5rem] text-green-500",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$2789403f16b80e3), {})
                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "text-gray-500",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$a6b7c34d56975de0), {})
                })
            })
        ]
    });
};
var $aa6f3068915f024f$export$2e2bcd8739ae039 = $aa6f3068915f024f$var$Wallet;



const $3ec0af3604717490$export$c289dd7d4d6c7aaf = ({ wallets: wallets, walletState: walletState, walletConnectHandler: walletConnectHandler })=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "my-2 flex flex-col gap-2",
        children: wallets?.map((wallet, index)=>{
            const name = (0, $aa0d921ca162e481$export$d07f57595c356899)(wallet?.metadata.title);
            const iconUrl = wallet?.metadata.iconUrl;
            const state = walletState.get(wallet?.metadata.title) || "disconnected";
            return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $aa6f3068915f024f$export$2e2bcd8739ae039), {
                name: name,
                state: state,
                clickHandler: ()=>walletConnectHandler(wallet),
                iconUrl: iconUrl
            }, index);
        })
    });
};





const $380529cee7df9747$var$WalletView = ({ gotoAccountsView: gotoAccountsView, walletConnectHandler: walletConnectHandler })=>{
    const { wallets: wallets, walletState: walletState } = (0, $2096fa05de40502f$export$934951b5ed2ebf82)();
    const { walletsAccounts: walletsAccounts } = (0, $47acec667174acda$export$83a8e409853da004)();
    const loadedAccountsCount = walletsAccounts ? walletsAccounts.size : 0;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex flex-col items-start gap-4 border-b",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "font-brand font-semibold",
                        children: "Wallet"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $38948fe540839acb$export$3e04609c77d2f57e), {
                        onClick: gotoAccountsView,
                        className: "my-2 flex w-full cursor-pointer flex-row items-center justify-between p-2",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                children: `${loadedAccountsCount} Imported Accounts`
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$b837bd7eac09a33e), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3ec0af3604717490$export$c289dd7d4d6c7aaf), {
                wallets: wallets,
                walletState: walletState,
                walletConnectHandler: walletConnectHandler
            })
        ]
    });
};
const $380529cee7df9747$var$AccountView = ({ gotoWalletsView: gotoWalletsView, accountConnectHandler: accountConnectHandler })=>{
    const { state: state } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { ss58: ss58 } = (0, $ff275152c44ce822$export$4a6dbf642db5266c)(state) || {};
    const { connectedAccount: connectedAccount, walletsAccounts: walletsAccounts } = (0, $47acec667174acda$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "font-brand uppercase",
                        children: "Accounts"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex cursor-pointer flex-row items-center justify-center gap-2 rounded-2xl border border-solid px-4 py-1 ",
                        onClick: ()=>gotoWalletsView(),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$deff84e7338ee5a5), {}),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "text-xs font-semibold",
                                children: "Wallets"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2dcaa35ce649a68d$export$fe248f600fa897e6), {
                accounts: walletsAccounts,
                connectedAccount: connectedAccount,
                accountConnectHandler: accountConnectHandler,
                ss58Format: ss58
            })
        ]
    });
};
const $380529cee7df9747$export$79b5060180039794 = ()=>{
    const [visible, setVisible] = (0, $4Iuzv.useState)(false);
    const [currentView, setCurrentView] = (0, $4Iuzv.useState)();
    const { walletState: walletState, setWalletState: setWalletState } = (0, $2096fa05de40502f$export$934951b5ed2ebf82)();
    const { connectedAccount: connectedAccount, setConnectedAccount: setConnectedAccount, walletsAccounts: walletsAccounts } = (0, $47acec667174acda$export$83a8e409853da004)();
    const loadedAccountsCount = walletsAccounts ? walletsAccounts.size : 0;
    const initialView = loadedAccountsCount > 0 ? "accounts" : "wallets";
    const toggleView = ()=>{
        setCurrentView((oldView)=>oldView === "wallets" ? "accounts" : "wallets");
    };
    const accountConnectHandler = async (signingAccount)=>{
        setConnectedAccount(signingAccount);
        closeModal();
    };
    const walletConnectHandler = async (wallet)=>{
        if (walletState.get(wallet?.metadata.title) == "connected") {
            await wallet.disconnect();
            setWalletState(wallet?.metadata.title, "disconnected");
        } else {
            await wallet.connect();
            setWalletState(wallet?.metadata.title, "connected");
        }
    };
    const closeModal = ()=>{
        setVisible(false);
    };
    const openModal = ()=>{
        setCurrentView(initialView);
        setVisible(true);
    };
    (0, $4Iuzv.useEffect)(()=>{
        setCurrentView(initialView);
    }, [
        initialView
    ]);
    const btnClickHandler = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        openModal();
    };
    const { name: name, address: address } = connectedAccount?.account || {};
    const btnTitle = connectedAccount?.account ? name || address : "Connect";
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                onClick: btnClickHandler,
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex flex-nowrap items-center gap-1",
                    children: [
                        address && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0942b75a53548d8d$export$2e2bcd8739ae039), {
                            style: {
                                cursor: "unset"
                            },
                            value: address,
                            theme: "polkadot",
                            size: 18
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "text-sm",
                            children: btnTitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7b51a257e986fbd2$export$2b77a92f1a5ad772), {
                open: visible,
                onClose: ()=>closeModal(),
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "flex max-h-[90vh] flex-col px-1 py-2",
                    children: currentView === "accounts" ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($380529cee7df9747$var$AccountView, {
                        gotoWalletsView: ()=>toggleView(),
                        accountConnectHandler: accountConnectHandler
                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($380529cee7df9747$var$WalletView, {
                        gotoAccountsView: ()=>toggleView(),
                        walletConnectHandler: walletConnectHandler
                    })
                })
            })
        ]
    });
};




var $4Iuzv = parcelRequire("4Iuzv");
class $c50366e9c4b532e1$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (error !== null) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex h-screen items-center justify-center",
            children: [
                "Unhandled error: ",
                error.toString()
            ]
        });
        return this.props.children;
    }
}





/**
 * React Router DOM v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @remix-run/router v1.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f29acb16f05b6a44$var$_extends() {
    $f29acb16f05b6a44$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f29acb16f05b6a44$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f29acb16f05b6a44$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f29acb16f05b6a44$export$e19cd5f9376f8cee || ($f29acb16f05b6a44$export$e19cd5f9376f8cee = {}));
const $f29acb16f05b6a44$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f29acb16f05b6a44$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f29acb16f05b6a44$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f29acb16f05b6a44$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f29acb16f05b6a44$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f29acb16f05b6a44$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $f29acb16f05b6a44$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f29acb16f05b6a44$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f29acb16f05b6a44$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f29acb16f05b6a44$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f29acb16f05b6a44$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f29acb16f05b6a44$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f29acb16f05b6a44$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f29acb16f05b6a44$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f29acb16f05b6a44$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f29acb16f05b6a44$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f29acb16f05b6a44$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let location = $f29acb16f05b6a44$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f29acb16f05b6a44$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f29acb16f05b6a44$export$fe53371bee54353d(to);
        $f29acb16f05b6a44$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f29acb16f05b6a44$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f29acb16f05b6a44$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f29acb16f05b6a44$var$ResultType || ($f29acb16f05b6a44$var$ResultType = {}));
const $f29acb16f05b6a44$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f29acb16f05b6a44$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f29acb16f05b6a44$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f29acb16f05b6a44$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($f29acb16f05b6a44$var$isIndexRoute(route)) {
            let indexRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f29acb16f05b6a44$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f29acb16f05b6a44$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $f29acb16f05b6a44$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f29acb16f05b6a44$var$flattenRoutes(routes);
    $f29acb16f05b6a44$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $f29acb16f05b6a44$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $f29acb16f05b6a44$var$safelyDecodeURI(pathname));
    return matches;
}
function $f29acb16f05b6a44$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f29acb16f05b6a44$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $f29acb16f05b6a44$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f29acb16f05b6a44$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f29acb16f05b6a44$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f29acb16f05b6a44$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f29acb16f05b6a44$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f29acb16f05b6a44$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f29acb16f05b6a44$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f29acb16f05b6a44$var$paramRe = /^:\w+$/;
const $f29acb16f05b6a44$var$dynamicSegmentValue = 3;
const $f29acb16f05b6a44$var$indexRouteValue = 2;
const $f29acb16f05b6a44$var$emptySegmentValue = 1;
const $f29acb16f05b6a44$var$staticSegmentValue = 10;
const $f29acb16f05b6a44$var$splatPenalty = -2;
const $f29acb16f05b6a44$var$isSplat = (s)=>s === "*";
function $f29acb16f05b6a44$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f29acb16f05b6a44$var$isSplat)) initialScore += $f29acb16f05b6a44$var$splatPenalty;
    if (index) initialScore += $f29acb16f05b6a44$var$indexRouteValue;
    return segments.filter((s)=>!$f29acb16f05b6a44$var$isSplat(s)).reduce((score, segment)=>score + ($f29acb16f05b6a44$var$paramRe.test(segment) ? $f29acb16f05b6a44$var$dynamicSegmentValue : segment === "" ? $f29acb16f05b6a44$var$emptySegmentValue : $f29acb16f05b6a44$var$staticSegmentValue), initialScore);
}
function $f29acb16f05b6a44$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f29acb16f05b6a44$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f29acb16f05b6a44$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f29acb16f05b6a44$export$a5c6d149b50c1d86($f29acb16f05b6a44$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f29acb16f05b6a44$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $f29acb16f05b6a44$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f29acb16f05b6a44$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $f29acb16f05b6a44$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $f29acb16f05b6a44$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $f29acb16f05b6a44$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f29acb16f05b6a44$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f29acb16f05b6a44$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $f29acb16f05b6a44$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $f29acb16f05b6a44$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $f29acb16f05b6a44$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f29acb16f05b6a44$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f29acb16f05b6a44$var$normalizeSearch(search),
        hash: $f29acb16f05b6a44$var$normalizeHash(hash)
    };
}
function $f29acb16f05b6a44$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f29acb16f05b6a44$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f29acb16f05b6a44$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f29acb16f05b6a44$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f29acb16f05b6a44$var$_extends({}, toArg);
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f29acb16f05b6a44$var$getInvalidPathError("?", "pathname", "search", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "pathname", "hash", to));
        $f29acb16f05b6a44$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f29acb16f05b6a44$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f29acb16f05b6a44$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f29acb16f05b6a44$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f29acb16f05b6a44$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f29acb16f05b6a44$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $f29acb16f05b6a44$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f29acb16f05b6a44$export$42a99a7a4bc0e76a extends Error {
}
class $f29acb16f05b6a44$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f29acb16f05b6a44$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f29acb16f05b6a44$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f29acb16f05b6a44$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f29acb16f05b6a44$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $f29acb16f05b6a44$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f29acb16f05b6a44$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f29acb16f05b6a44$var$unwrapTrackedPromise(value) {
    if (!$f29acb16f05b6a44$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $f29acb16f05b6a44$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f29acb16f05b6a44$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f29acb16f05b6a44$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f29acb16f05b6a44$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $f29acb16f05b6a44$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f29acb16f05b6a44$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f29acb16f05b6a44$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f29acb16f05b6a44$var$validMutationMethods = new Set($f29acb16f05b6a44$var$validMutationMethodsArr);
const $f29acb16f05b6a44$var$validRequestMethodsArr = [
    "get",
    ...$f29acb16f05b6a44$var$validMutationMethodsArr
];
const $f29acb16f05b6a44$var$validRequestMethods = new Set($f29acb16f05b6a44$var$validRequestMethodsArr);
const $f29acb16f05b6a44$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f29acb16f05b6a44$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f29acb16f05b6a44$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f29acb16f05b6a44$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f29acb16f05b6a44$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f29acb16f05b6a44$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f29acb16f05b6a44$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $f29acb16f05b6a44$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $f29acb16f05b6a44$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f29acb16f05b6a44$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $f29acb16f05b6a44$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f29acb16f05b6a44$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f29acb16f05b6a44$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($f29acb16f05b6a44$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f29acb16f05b6a44$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f29acb16f05b6a44$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f29acb16f05b6a44$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f29acb16f05b6a44$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $f29acb16f05b6a44$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f29acb16f05b6a44$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$f29acb16f05b6a44$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $f29acb16f05b6a44$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $f29acb16f05b6a44$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f29acb16f05b6a44$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f29acb16f05b6a44$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $f29acb16f05b6a44$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f29acb16f05b6a44$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f29acb16f05b6a44$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f29acb16f05b6a44$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($f29acb16f05b6a44$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f29acb16f05b6a44$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f29acb16f05b6a44$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $f29acb16f05b6a44$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f29acb16f05b6a44$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $f29acb16f05b6a44$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $f29acb16f05b6a44$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $f29acb16f05b6a44$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $f29acb16f05b6a44$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(submission);
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($f29acb16f05b6a44$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($f29acb16f05b6a44$var$isDeferredResult(actionResult)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f29acb16f05b6a44$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f29acb16f05b6a44$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f29acb16f05b6a44$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f29acb16f05b6a44$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($f29acb16f05b6a44$var$_extends({
                errors: errors,
                loaderData: $f29acb16f05b6a44$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $f29acb16f05b6a44$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $f29acb16f05b6a44$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $f29acb16f05b6a44$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) result = await $f29acb16f05b6a44$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $f29acb16f05b6a44$var$createLocation(state.location, redirect.location, $f29acb16f05b6a44$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $f29acb16f05b6a44$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $f29acb16f05b6a44$export$e19cd5f9376f8cee.Replace : $f29acb16f05b6a44$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $f29acb16f05b6a44$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($f29acb16f05b6a44$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $f29acb16f05b6a44$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f29acb16f05b6a44$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $f29acb16f05b6a44$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $f29acb16f05b6a44$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$f29acb16f05b6a44$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $f29acb16f05b6a44$var$callLoaderOrAction("loader", $f29acb16f05b6a44$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $f29acb16f05b6a44$var$ResultType.error,
                        error: $f29acb16f05b6a44$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $f29acb16f05b6a44$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f29acb16f05b6a44$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f29acb16f05b6a44$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f29acb16f05b6a44$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f29acb16f05b6a44$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f29acb16f05b6a44$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f29acb16f05b6a44$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f29acb16f05b6a44$export$4d0306f8f6a4585b = Symbol("deferred");
function $f29acb16f05b6a44$export$3336b097a6fbc59a(routes, opts) {
    $f29acb16f05b6a44$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f29acb16f05b6a44$var$defaultMapRouteProperties;
    let dataRoutes = $f29acb16f05b6a44$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f29acb16f05b6a44$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f29acb16f05b6a44$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f29acb16f05b6a44$var$createLocation("", $f29acb16f05b6a44$export$fe53371bee54353d(url), null, "default");
        let matches = $f29acb16f05b6a44$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f29acb16f05b6a44$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f29acb16f05b6a44$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f29acb16f05b6a44$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($f29acb16f05b6a44$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f29acb16f05b6a44$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $f29acb16f05b6a44$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f29acb16f05b6a44$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f29acb16f05b6a44$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $f29acb16f05b6a44$var$isResponse(result) ? result : $f29acb16f05b6a44$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($f29acb16f05b6a44$var$isQueryRouteResponse(e)) {
                if (e.type === $f29acb16f05b6a44$var$ResultType.error && !$f29acb16f05b6a44$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f29acb16f05b6a44$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        } else {
            result = await $f29acb16f05b6a44$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
            let error = $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f29acb16f05b6a44$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f29acb16f05b6a44$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $f29acb16f05b6a44$var$_extends({}, context, {
                statusCode: $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $f29acb16f05b6a44$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $f29acb16f05b6a44$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $f29acb16f05b6a44$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f29acb16f05b6a44$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$f29acb16f05b6a44$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f29acb16f05b6a44$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f29acb16f05b6a44$export$fec11da027c70692(routes, context, error) {
    let newContext = $f29acb16f05b6a44$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f29acb16f05b6a44$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f29acb16f05b6a44$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f29acb16f05b6a44$export$cae722b0cc860f13(to ? to : ".", $f29acb16f05b6a44$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $f29acb16f05b6a44$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$f29acb16f05b6a44$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f29acb16f05b6a44$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f29acb16f05b6a44$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f29acb16f05b6a44$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f29acb16f05b6a44$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f29acb16f05b6a44$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f29acb16f05b6a44$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f29acb16f05b6a44$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f29acb16f05b6a44$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f29acb16f05b6a44$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f29acb16f05b6a44$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f29acb16f05b6a44$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f29acb16f05b6a44$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f29acb16f05b6a44$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f29acb16f05b6a44$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f29acb16f05b6a44$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $f29acb16f05b6a44$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $f29acb16f05b6a44$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($f29acb16f05b6a44$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f29acb16f05b6a44$var$shouldRevalidateLoader(match, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f29acb16f05b6a44$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $f29acb16f05b6a44$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They only set `defaultShouldRevalidate` on
        // explicit revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        //
        // They automatically revalidate without even calling shouldRevalidate if:
        // - They were cancelled
        // - They're in the middle of their first load and therefore this is still
        //   an initial load and not a revalidation
        //
        // If neither of those is true, then they _always_ check shouldRevalidate
        let fetcher = state.fetchers.get(key);
        let isPerformingInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === undefined && // If a fetcher.load redirected then it'll be "loading" without any data
        // so ensure we're not processing the redirect from this fetcher
        !fetchRedirectIds.has(key);
        let fetcherMatch = $f29acb16f05b6a44$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = cancelledFetcherLoads.includes(key) || isPerformingInitialLoad || $f29acb16f05b6a44$var$shouldRevalidateLoader(fetcherMatch, $f29acb16f05b6a44$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f29acb16f05b6a44$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f29acb16f05b6a44$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f29acb16f05b6a44$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f29acb16f05b6a44$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f29acb16f05b6a44$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$f29acb16f05b6a44$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f29acb16f05b6a44$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $f29acb16f05b6a44$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $f29acb16f05b6a44$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f29acb16f05b6a44$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f29acb16f05b6a44$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f29acb16f05b6a44$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f29acb16f05b6a44$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $f29acb16f05b6a44$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($f29acb16f05b6a44$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($f29acb16f05b6a44$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $f29acb16f05b6a44$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$f29acb16f05b6a44$var$ABSOLUTE_URL_REGEX.test(location)) location = $f29acb16f05b6a44$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $f29acb16f05b6a44$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $f29acb16f05b6a44$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $f29acb16f05b6a44$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $f29acb16f05b6a44$var$ResultType.error) return {
            type: resultType,
            error: new $f29acb16f05b6a44$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $f29acb16f05b6a44$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($f29acb16f05b6a44$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $f29acb16f05b6a44$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f29acb16f05b6a44$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f29acb16f05b6a44$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f29acb16f05b6a44$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f29acb16f05b6a44$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f29acb16f05b6a44$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f29acb16f05b6a44$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $f29acb16f05b6a44$export$3e9cee6b33872309(!$f29acb16f05b6a44$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f29acb16f05b6a44$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($f29acb16f05b6a44$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f29acb16f05b6a44$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f29acb16f05b6a44$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $f29acb16f05b6a44$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($f29acb16f05b6a44$var$isErrorResult(result)) {
            let boundaryMatch = $f29acb16f05b6a44$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f29acb16f05b6a44$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f29acb16f05b6a44$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f29acb16f05b6a44$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f29acb16f05b6a44$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f29acb16f05b6a44$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f29acb16f05b6a44$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f29acb16f05b6a44$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f29acb16f05b6a44$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f29acb16f05b6a44$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f29acb16f05b6a44$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $f29acb16f05b6a44$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f29acb16f05b6a44$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($f29acb16f05b6a44$var$isRedirectResult(result)) return result;
    }
}
function $f29acb16f05b6a44$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(path) : path;
    return $f29acb16f05b6a44$export$fe53371bee54353d($f29acb16f05b6a44$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f29acb16f05b6a44$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f29acb16f05b6a44$var$isDeferredResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.deferred;
}
function $f29acb16f05b6a44$var$isErrorResult(result) {
    return result.type === $f29acb16f05b6a44$var$ResultType.error;
}
function $f29acb16f05b6a44$var$isRedirectResult(result) {
    return (result && result.type) === $f29acb16f05b6a44$var$ResultType.redirect;
}
function $f29acb16f05b6a44$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f29acb16f05b6a44$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f29acb16f05b6a44$var$isRedirectResponse(result) {
    if (!$f29acb16f05b6a44$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f29acb16f05b6a44$var$isQueryRouteResponse(obj) {
    return obj && $f29acb16f05b6a44$var$isResponse(obj.response) && (obj.type === $f29acb16f05b6a44$var$ResultType.data || $f29acb16f05b6a44$var$ResultType.error);
}
function $f29acb16f05b6a44$var$isValidMethod(method) {
    return $f29acb16f05b6a44$var$validRequestMethods.has(method.toLowerCase());
}
function $f29acb16f05b6a44$var$isMutationMethod(method) {
    return $f29acb16f05b6a44$var$validMutationMethods.has(method.toLowerCase());
}
async function $f29acb16f05b6a44$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f29acb16f05b6a44$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f29acb16f05b6a44$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $f29acb16f05b6a44$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $f29acb16f05b6a44$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $f29acb16f05b6a44$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f29acb16f05b6a44$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f29acb16f05b6a44$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f29acb16f05b6a44$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f29acb16f05b6a44$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $f29acb16f05b6a44$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f29acb16f05b6a44$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f29acb16f05b6a44$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f29acb16f05b6a44$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f29acb16f05b6a44$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f29acb16f05b6a44$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f29acb16f05b6a44$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f29acb16f05b6a44$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f29acb16f05b6a44$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $f29acb16f05b6a44$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $f29acb16f05b6a44$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");

function $175a2504a1bf07a5$var$_extends() {
    $175a2504a1bf07a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $175a2504a1bf07a5$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $175a2504a1bf07a5$export$3add0d5dce533e2e = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$145dfa71566a64dc = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$var$AwaitContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $175a2504a1bf07a5$export$26749e8557646306 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$c7914228fb69b0f5 = /*#__PURE__*/ $4Iuzv.createContext(null);
const $175a2504a1bf07a5$export$9072aa6dd1f93057 = /*#__PURE__*/ $4Iuzv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $175a2504a1bf07a5$var$RouteErrorContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $175a2504a1bf07a5$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $175a2504a1bf07a5$export$9c954a9d03d32f4a() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $175a2504a1bf07a5$export$45d76561a5302f2b() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $175a2504a1bf07a5$export$1b3f31771c5d07c() {
    return $4Iuzv.useContext($175a2504a1bf07a5$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $175a2504a1bf07a5$export$6c330e8992e8a295(pattern) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $175a2504a1bf07a5$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4Iuzv.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $175a2504a1bf07a5$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $175a2504a1bf07a5$var$useNavigateStable() : $175a2504a1bf07a5$var$useNavigateUnstable();
}
function $175a2504a1bf07a5$var$useNavigateUnstable() {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$OutletContext = /*#__PURE__*/ $4Iuzv.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $175a2504a1bf07a5$export$4138103a3ae699cc() {
    return $4Iuzv.useContext($175a2504a1bf07a5$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $175a2504a1bf07a5$export$a3be3530d8e40d0b(context) {
    let outlet = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $175a2504a1bf07a5$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $175a2504a1bf07a5$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f29acb16f05b6a44$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $4Iuzv.useMemo(()=>(0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $175a2504a1bf07a5$export$5d3fca4a98652595(routes, locationArg) {
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4Iuzv.useContext($175a2504a1bf07a5$export$26749e8557646306);
    let { matches: parentMatches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $f29acb16f05b6a44$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $175a2504a1bf07a5$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $175a2504a1bf07a5$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $175a2504a1bf07a5$var$DefaultErrorComponent() {
    let error = $175a2504a1bf07a5$export$ed527bf60f6e05f2();
    let message = (0, $f29acb16f05b6a44$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4Iuzv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4Iuzv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $175a2504a1bf07a5$var$defaultErrorElement = /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DefaultErrorComponent, null);
class $175a2504a1bf07a5$var$RenderErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $175a2504a1bf07a5$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $175a2504a1bf07a5$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $175a2504a1bf07a5$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4Iuzv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $175a2504a1bf07a5$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($175a2504a1bf07a5$var$DataRouterHook || ($175a2504a1bf07a5$var$DataRouterHook = {}));
var $175a2504a1bf07a5$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($175a2504a1bf07a5$var$DataRouterStateHook || ($175a2504a1bf07a5$var$DataRouterStateHook = {}));
function $175a2504a1bf07a5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $175a2504a1bf07a5$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext($175a2504a1bf07a5$export$3add0d5dce533e2e);
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $175a2504a1bf07a5$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext($175a2504a1bf07a5$export$145dfa71566a64dc);
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
function $175a2504a1bf07a5$var$useRouteContext(hookName) {
    let route = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $175a2504a1bf07a5$var$useCurrentRouteId(hookName) {
    let route = $175a2504a1bf07a5$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $175a2504a1bf07a5$export$5fc8298006ad9e58() {
    return $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $175a2504a1bf07a5$export$d0fd4b7106de2769() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $175a2504a1bf07a5$export$600dc272ed516c15() {
    let dataRouterContext = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseRevalidator);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $175a2504a1bf07a5$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseMatches);
    return $4Iuzv.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $175a2504a1bf07a5$export$1448a5050d252c4d() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $175a2504a1bf07a5$export$fd5d37484eab868d(routeId) {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $175a2504a1bf07a5$export$fdc00f3f26066d5e() {
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseActionData);
    let route = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $175a2504a1bf07a5$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4Iuzv.useContext($175a2504a1bf07a5$var$RouteErrorContext);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    let routeId = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $175a2504a1bf07a5$export$78a72ddb39bdd145() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $175a2504a1bf07a5$export$17f53340677d5831() {
    let value = $4Iuzv.useContext($175a2504a1bf07a5$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $175a2504a1bf07a5$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $175a2504a1bf07a5$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseBlocker);
    let state = $175a2504a1bf07a5$var$useDataRouterState($175a2504a1bf07a5$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4Iuzv.useState("");
    let blockerFunction = $4Iuzv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $175a2504a1bf07a5$var$_extends({}, currentLocation, {
                pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $175a2504a1bf07a5$var$_extends({}, nextLocation, {
                pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4Iuzv.useEffect(()=>{
        let key = String(++$175a2504a1bf07a5$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4Iuzv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f29acb16f05b6a44$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $175a2504a1bf07a5$var$useNavigateStable() {
    let { router: router } = $175a2504a1bf07a5$var$useDataRouterContext($175a2504a1bf07a5$var$DataRouterHook.UseNavigateStable);
    let id = $175a2504a1bf07a5$var$useCurrentRouteId($175a2504a1bf07a5$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4Iuzv.useRef(false);
    $175a2504a1bf07a5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $175a2504a1bf07a5$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $175a2504a1bf07a5$var$alreadyWarned = {};
function $175a2504a1bf07a5$var$warningOnce(key, cond, message) {
    if (!cond && !$175a2504a1bf07a5$var$alreadyWarned[key]) $175a2504a1bf07a5$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $175a2504a1bf07a5$var$START_TRANSITION = "startTransition";
const $175a2504a1bf07a5$var$startTransitionImpl = $4Iuzv[$175a2504a1bf07a5$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $175a2504a1bf07a5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $175a2504a1bf07a5$var$startTransitionImpl ? $175a2504a1bf07a5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $175a2504a1bf07a5$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $175a2504a1bf07a5$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $175a2504a1bf07a5$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $175a2504a1bf07a5$var$startTransitionImpl ? $175a2504a1bf07a5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $175a2504a1bf07a5$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let { matches: matches } = $4Iuzv.useContext($175a2504a1bf07a5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $175a2504a1bf07a5$export$45d76561a5302f2b();
    let navigate = $175a2504a1bf07a5$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f29acb16f05b6a44$export$cae722b0cc860f13)(to, (0, $f29acb16f05b6a44$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4Iuzv.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $175a2504a1bf07a5$export$910ae8079b2c2852(props) {
    return $175a2504a1bf07a5$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $175a2504a1bf07a5$export$e7b0ac011bb776c6(_props) {
    (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $175a2504a1bf07a5$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f29acb16f05b6a44$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$175a2504a1bf07a5$export$9c954a9d03d32f4a() && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4Iuzv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f29acb16f05b6a44$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4Iuzv.useMemo(()=>{
        let trailingPathname = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $175a2504a1bf07a5$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $175a2504a1bf07a5$export$5d3fca4a98652595($175a2504a1bf07a5$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $175a2504a1bf07a5$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$ResolveAwait, null, children));
}
var $175a2504a1bf07a5$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($175a2504a1bf07a5$var$AwaitRenderStatus || ($175a2504a1bf07a5$var$AwaitRenderStatus = {}));
const $175a2504a1bf07a5$var$neverSettledPromise = new Promise(()=>{});
class $175a2504a1bf07a5$var$AwaitErrorBoundary extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $175a2504a1bf07a5$var$AwaitRenderStatus.error : promise._data !== undefined ? $175a2504a1bf07a5$var$AwaitRenderStatus.success : $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $175a2504a1bf07a5$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && promise._error instanceof (0, $f29acb16f05b6a44$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $175a2504a1bf07a5$var$neverSettledPromise;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $175a2504a1bf07a5$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4Iuzv.createElement($175a2504a1bf07a5$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $175a2504a1bf07a5$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $175a2504a1bf07a5$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4Iuzv.createElement($4Iuzv.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $175a2504a1bf07a5$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4Iuzv.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4Iuzv.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4Iuzv.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $175a2504a1bf07a5$export$e7b0ac011bb776c6) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $175a2504a1bf07a5$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $175a2504a1bf07a5$export$daf73786167a7f72(matches) {
    return $175a2504a1bf07a5$var$_renderMatches(matches);
}
function $175a2504a1bf07a5$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4Iuzv.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4Iuzv.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $175a2504a1bf07a5$export$f30f7e456d254e83(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $175a2504a1bf07a5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $175a2504a1bf07a5$export$52b333d321859367
    }).initialize();
}



function $c34e9f2261c19895$var$_extends() {
    $c34e9f2261c19895$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c34e9f2261c19895$var$_extends.apply(this, arguments);
}
function $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c34e9f2261c19895$var$defaultMethod = "get";
const $c34e9f2261c19895$var$defaultEncType = "application/x-www-form-urlencoded";
function $c34e9f2261c19895$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c34e9f2261c19895$var$isButtonElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c34e9f2261c19895$var$isFormElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c34e9f2261c19895$var$isInputElement(object) {
    return $c34e9f2261c19895$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c34e9f2261c19895$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c34e9f2261c19895$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c34e9f2261c19895$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c34e9f2261c19895$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $c34e9f2261c19895$var$_formDataSupportsSubmitter = null;
function $c34e9f2261c19895$var$isFormDataSubmitterSupported() {
    if ($c34e9f2261c19895$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c34e9f2261c19895$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c34e9f2261c19895$var$_formDataSupportsSubmitter = true;
    }
    return $c34e9f2261c19895$var$_formDataSupportsSubmitter;
}
const $c34e9f2261c19895$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c34e9f2261c19895$var$getFormEncType(encType) {
    if (encType != null && !$c34e9f2261c19895$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c34e9f2261c19895$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = $c34e9f2261c19895$var$getFormEncType(target.getAttribute("enctype")) || $c34e9f2261c19895$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c34e9f2261c19895$var$isButtonElement(target) || $c34e9f2261c19895$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c34e9f2261c19895$var$defaultMethod;
        encType = $c34e9f2261c19895$var$getFormEncType(target.getAttribute("formenctype")) || $c34e9f2261c19895$var$getFormEncType(form.getAttribute("enctype")) || $c34e9f2261c19895$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c34e9f2261c19895$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c34e9f2261c19895$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c34e9f2261c19895$var$defaultMethod;
        action = null;
        encType = $c34e9f2261c19895$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c34e9f2261c19895$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $c34e9f2261c19895$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $c34e9f2261c19895$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $c34e9f2261c19895$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367)
    }).initialize();
}
function $c34e9f2261c19895$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f29acb16f05b6a44$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c34e9f2261c19895$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c34e9f2261c19895$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $175a2504a1bf07a5$export$52b333d321859367)
    }).initialize();
}
function $c34e9f2261c19895$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c34e9f2261c19895$var$_extends({}, state, {
        errors: $c34e9f2261c19895$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c34e9f2261c19895$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f29acb16f05b6a44$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c34e9f2261c19895$var$START_TRANSITION = "startTransition";
const $c34e9f2261c19895$var$startTransitionImpl = $4Iuzv[$c34e9f2261c19895$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c34e9f2261c19895$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c34e9f2261c19895$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f29acb16f05b6a44$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c34e9f2261c19895$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4Iuzv.useCallback((newState)=>{
        v7_startTransition && $c34e9f2261c19895$var$startTransitionImpl ? $c34e9f2261c19895$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Iuzv.createElement((0, $175a2504a1bf07a5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $c34e9f2261c19895$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $c34e9f2261c19895$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4Iuzv.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref4, $c34e9f2261c19895$var$_excluded);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c34e9f2261c19895$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c34e9f2261c19895$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $175a2504a1bf07a5$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c34e9f2261c19895$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4Iuzv.createElement("a", $c34e9f2261c19895$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $c34e9f2261c19895$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4Iuzv.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref5, $c34e9f2261c19895$var$_excluded2);
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let routerState = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    let { navigator: navigator } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$export$a6c7ac8248d6e38a, $c34e9f2261c19895$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c34e9f2261c19895$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4Iuzv.forwardRef((props, ref)=>{
    let submit = $c34e9f2261c19895$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$var$FormImpl, $c34e9f2261c19895$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $c34e9f2261c19895$var$FormImpl = /*#__PURE__*/ $4Iuzv.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $c34e9f2261c19895$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $c34e9f2261c19895$var$_objectWithoutPropertiesLoose(_ref6, $c34e9f2261c19895$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $c34e9f2261c19895$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $4Iuzv.createElement("form", $c34e9f2261c19895$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c34e9f2261c19895$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $c34e9f2261c19895$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c34e9f2261c19895$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($c34e9f2261c19895$var$DataRouterHook || ($c34e9f2261c19895$var$DataRouterHook = {}));
var $c34e9f2261c19895$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c34e9f2261c19895$var$DataRouterStateHook || ($c34e9f2261c19895$var$DataRouterStateHook = {}));
function $c34e9f2261c19895$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c34e9f2261c19895$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$3add0d5dce533e2e));
    !ctx && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c34e9f2261c19895$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$145dfa71566a64dc));
    !state && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c34e9f2261c19895$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let path = (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4Iuzv.useCallback((event)=>{
        if ($c34e9f2261c19895$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f29acb16f05b6a44$export$fe53371bee54353d)(location) === (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c34e9f2261c19895$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4Iuzv.useRef($c34e9f2261c19895$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4Iuzv.useRef(false);
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let searchParams = $4Iuzv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c34e9f2261c19895$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    let setSearchParams = $4Iuzv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c34e9f2261c19895$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c34e9f2261c19895$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c34e9f2261c19895$export$47c85c6e3a081d3() {
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let currentRouteId = (0, $175a2504a1bf07a5$export$5fc8298006ad9e58)();
    return $4Iuzv.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c34e9f2261c19895$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $c34e9f2261c19895$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    return $4Iuzv.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c34e9f2261c19895$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c34e9f2261c19895$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c34e9f2261c19895$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let routeContext = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    !routeContext && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c34e9f2261c19895$var$_extends({}, (0, $175a2504a1bf07a5$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f29acb16f05b6a44$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f29acb16f05b6a44$export$fe53371bee54353d)(path);
}
function $c34e9f2261c19895$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $4Iuzv.forwardRef((props, ref)=>{
        let submit = $c34e9f2261c19895$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $4Iuzv.createElement($c34e9f2261c19895$var$FormImpl, $c34e9f2261c19895$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $c34e9f2261c19895$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c34e9f2261c19895$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseFetcher);
    let route = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$9072aa6dd1f93057));
    !route && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $4Iuzv.useState(()=>String(++$c34e9f2261c19895$var$fetcherId));
    let [Form] = $4Iuzv.useState(()=>{
        !routeId && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
        return $c34e9f2261c19895$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $4Iuzv.useState(()=>(href)=>{
            !router && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
            !routeId && (0, $f29acb16f05b6a44$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $c34e9f2261c19895$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $4Iuzv.useMemo(()=>$c34e9f2261c19895$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $4Iuzv.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c34e9f2261c19895$export$fa996778a3a31087() {
    let state = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c34e9f2261c19895$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c34e9f2261c19895$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c34e9f2261c19895$var$useDataRouterContext($c34e9f2261c19895$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c34e9f2261c19895$var$useDataRouterState($c34e9f2261c19895$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4Iuzv.useContext((0, $175a2504a1bf07a5$export$26749e8557646306));
    let location = (0, $175a2504a1bf07a5$export$45d76561a5302f2b)();
    let matches = (0, $175a2504a1bf07a5$export$2378eb7f5ff86053)();
    let navigation = (0, $175a2504a1bf07a5$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4Iuzv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c34e9f2261c19895$var$usePageHide($4Iuzv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c34e9f2261c19895$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c34e9f2261c19895$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c34e9f2261c19895$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c34e9f2261c19895$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c34e9f2261c19895$var$_extends({}, location, {
                    pathname: (0, $f29acb16f05b6a44$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c34e9f2261c19895$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Iuzv.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c34e9f2261c19895$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c34e9f2261c19895$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $175a2504a1bf07a5$export$2af03a1de5c0910)(when);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}



var $dad04bf90bcccff8$exports = {};

$dad04bf90bcccff8$exports = new URL((parcelRequire("giU2u")).resolve("33mcs"), import.meta.url).toString();


const $94a6d822497ef9d9$var$logoUrl = new URL($dad04bf90bcccff8$exports).toString();
function $94a6d822497ef9d9$export$8b251419efc915eb({ activeDelegateCount: activeDelegateCount, withBackArrow: withBackArrow, headlineVisible: headlineVisible, setHeadlineVisible: setHeadlineVisible }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $49762cb87c2f3a11$export$42cfbb80f7861e77), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $49762cb87c2f3a11$export$42cfbb80f7861e77).Brand, {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "sticky top-0 -z-10 w-full",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex h-8 items-center gap-2",
                                children: [
                                    withBackArrow ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$8afed21ef5c2afa5), {
                                        className: "stroke-[4px]"
                                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                className: "inline h-full",
                                                src: $94a6d822497ef9d9$var$logoUrl,
                                                alt: "polkadot logo"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "h-6 w-[2px] bg-gray-400"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-h6 font-unbounded sm:text-h5",
                                        children: "Delegation Dashboard"
                                    }),
                                    !!activeDelegateCount && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "font-unbounded text-xl font-normal text-fg-disabled",
                                        children: `${activeDelegateCount} active`
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $49762cb87c2f3a11$export$42cfbb80f7861e77).Content, {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $49762cb87c2f3a11$export$42cfbb80f7861e77).Item, {
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center justify-start gap-2 md:justify-end",
                        children: [
                            headlineVisible === "true" && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                className: "flex h-fit w-fit cursor-pointer items-center justify-center rounded-full bg-white p-2",
                                onClick: ()=>setHeadlineVisible("false"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$dbf4042b40a603ee), {
                                    size: "20"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $380529cee7df9747$export$79b5060180039794), {})
                        ]
                    })
                })
            })
        ]
    });
}




function $49b40bea6aabf954$export$4b3eca7b8cc3633({ message: message }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex flex-col",
        role: "progressbar",
        "aria-busy": "true",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $9146fa2a579f8b85$export$669f6ea7d267feaf), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                children: message
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");



const $6e524aa2864e32b3$var$TRANSIENT_DISPLAY_TIME_MS = 3000; //milliseconds
function $6e524aa2864e32b3$var$Notification({ children: children }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "rounded-sd backdrop-blur-sd  z-50 flex w-full animate-[slideInRight_ease-out_0.23s] gap-2 bg-[rgba(0,0,0,0.85)] p-4 text-body-2 text-white ",
        children: children
    });
}
function $6e524aa2864e32b3$export$4cc4937c9c6837aa() {
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const reports = state?.reports || [];
    const processing = state?.processingReport;
    const removeReport = (index)=>updater?.removeReport(index);
    const resetProcessing = ()=>updater?.setProcessingReport(undefined);
    const current = reports?.at(0);
    const removeCurrent = ()=>{
        if (current) removeReport(0);
    };
    function isTransientReport(report) {
        return report.type === "Info" || report.type === "Warning";
    }
    (0, $4Iuzv.useEffect)(()=>{
        if (current && isTransientReport(current)) setTimeout(()=>{
            removeCurrent();
        }, $6e524aa2864e32b3$var$TRANSIENT_DISPLAY_TIME_MS);
    }, [
        current
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        if (processing?.isTransient) setTimeout(()=>{
            resetProcessing();
        }, $6e524aa2864e32b3$var$TRANSIENT_DISPLAY_TIME_MS);
    }, [
        processing
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "fixed bottom-12 right-4 z-50 flex w-[300px] flex-col gap-2",
        children: [
            current && current.type == "Error" && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)($6e524aa2864e32b3$var$Notification, {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "w-full",
                        children: current.message
                    }),
                    !isTransientReport(current) && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        onClick: removeCurrent,
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$cae179f078f4b4a4), {})
                    })
                ]
            }),
            processing && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)($6e524aa2864e32b3$var$Notification, {
                children: [
                    !processing.isTransient && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $9146fa2a579f8b85$export$669f6ea7d267feaf), {
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "w-full",
                        children: processing.message
                    })
                ]
            })
        ]
    });
}









var $4Iuzv = parcelRequire("4Iuzv");



function $d15fb0862e5cf421$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "fixed bottom-0 flex h-fit w-full items-center justify-between bg-white/50 p-2 text-[0.625rem] backdrop-blur-sm",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$5bf9f996ff81a819), {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        children: "\xa9 Web3 Foundation"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "h-3 w-[1px] bg-gray-500"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                        href: "https://polkadot.network/privacy/",
                        target: "_blank",
                        className: " underline",
                        rel: "noreferrer",
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "h-3 w-[1px] bg-gray-500"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                        href: "https://polkadot.network/legal-disclosures/",
                        target: "_blank",
                        className: " underline",
                        rel: "noreferrer",
                        children: "Legal Disclosures"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$c941445333056a94), {
                        size: "14"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                        href: "https://github.com/paritytech/governance-ui/discussions",
                        target: "_blank",
                        className: " underline",
                        rel: "noreferrer",
                        children: "Feedback"
                    })
                ]
            })
        ]
    });
}






var $4Iuzv = parcelRequire("4Iuzv");




function $384a056e5ce27cd7$export$2e2bcd8739ae039({ title: title, description: description, children: children, center: center, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `sticky top-14 flex h-auto flex-col-reverse items-center justify-between gap-3 bg-bg-default px-3 py-6 lg:top-20 lg:flex-row lg:gap-6 lg:px-8 ${className}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: `flex flex-col gap-2 ${center ? "justify-center" : "justify-start"}  gap-0`,
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "font-unbounded text-h5",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "text-body-2",
                        children: description
                    })
                ]
            }),
            children
        ]
    });
}
$384a056e5ce27cd7$export$2e2bcd8739ae039.defaultProps = {
    title: "Select Delegates",
    step: 0
};




function $021483ab580d6bff$export$2e2bcd8739ae039({ step: step, steps: steps }) {
    let lefIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "h-1 w-1 rounded-full bg-primary"
    });
    if (step > 0) lefIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$7dd004358974b05d), {});
    let middleIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "h-1 w-1 rounded-full bg-gray-400"
    });
    if (step === 1) middleIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "h-1 w-1 rounded-full bg-primary"
    });
    if (step === 2) middleIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$7dd004358974b05d), {});
    let rightIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "h-1 w-1 rounded-full bg-gray-400"
    });
    if (step === 2) rightIcon = /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "h-1 w-1 rounded-full bg-primary"
    });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex w-full flex-col gap-2 font-medium lg:w-1/2",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex h-[24px] rounded-full bg-gray-200 p-[1px]",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `flex items-center justify-center px-2 ${step < 1 ? "rounded-full" : " rounded-l-full"} bg-white text-primary`,
                        children: lefIcon
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `grow ${step < 1 ? `` : `bg-white`}`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `flex items-center justify-center px-2 ${step < 1 ? `w-[24px] rounded-full bg-none` : step < 2 ? "rounded-r-full bg-white " : "rounded-none bg-white"} text-primary`,
                        children: middleIcon
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `grow ${step < 2 ? `` : `bg-white`}`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `flex items-center justify-center px-2 ${step < 2 ? "bg-trans w-[24px] rounded-full bg-none" : "rounded-r-full bg-white"} text-primary`,
                        children: rightIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "flex justify-between whitespace-nowrap text-sm",
                children: steps.map((currentStep, index)=>{
                    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: `w-full ${index === 0 ? "text-left" : index === 1 ? "text-center" : "text-right"} ${index === step ? " text-primary" : "text-black"}`,
                        children: currentStep
                    }, index);
                })
            })
        ]
    });
}
$021483ab580d6bff$export$2e2bcd8739ae039.defaultProps = {
    step: 0,
    steps: [
        "Tracks",
        "Delegate",
        "Sign"
    ]
};






function $af1d92624e2a7343$export$769d3a2a5199587({ address: address, name: name, size: size, textClassName: textClassName, copy: copy = false }) {
    const { updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const btnTitle = name || address;
    const style = !copy ? {
        cursor: "unset"
    } : undefined;
    const onCopy = ()=>{
        updater.addReport({
            type: "Info",
            message: "Address copied to clipboard!"
        });
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex flex-nowrap items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0942b75a53548d8d$export$2e2bcd8739ae039), {
                    style: style,
                    value: address,
                    theme: "polkadot",
                    size: size || 18,
                    onCopy: copy ? onCopy : undefined
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `${textClassName || ""}`,
                children: (0, $040aa2aac62aeba3$export$3f31304a17a4ea9a)(btnTitle, 5)
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");









var $4Iuzv = parcelRequire("4Iuzv");


var $4Iuzv = parcelRequire("4Iuzv");


function $006e1caac8f7780a$export$2e2bcd8739ae039({ content: content, title: title }) {
    const [infoVisible, setInfoVisible] = (0, $4Iuzv.useState)(false);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex cursor-pointer items-center gap-2",
        onClick: ()=>infoVisible ? setInfoVisible(false) : setInfoVisible(true),
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$dbf4042b40a603ee), {}),
            infoVisible && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7b51a257e986fbd2$export$2b77a92f1a5ad772), {
                size: "lg",
                open: infoVisible,
                onClose: ()=>setInfoVisible(false),
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex max-h-[90vh] w-full flex-col gap-4 p-4",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                            className: "font-unbounded text-h5 capitalize",
                            children: title
                        }),
                        content
                    ]
                })
            })
        ]
    });
}



function $8adc43caa88c8c97$export$dc148b0502442707({ title: title, children: children, className: className, tooltipContent: tooltipContent }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: `flex flex-col gap-1 ${className}`,
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "text-sm",
                            children: title
                        }),
                        tooltipContent && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $006e1caac8f7780a$export$2e2bcd8739ae039), {
                            content: tooltipContent,
                            title: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "flex gap-2 text-base font-medium",
                    children: children
                })
            ]
        })
    });
}
const $8adc43caa88c8c97$export$321a3a223c3064d2 = /*#__PURE__*/ (0, $4Iuzv.memo)(function({ allTracksCount: allTracksCount, tracks: tracks, visibleCount: visibleCount }) {
    const tracksCaption = tracks.slice(0, visibleCount).map((track)=>track.title).join(", ");
    const remainingCount = visibleCount !== undefined ? Math.max(tracks.length - visibleCount, 0) : 0;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: allTracksCount && allTracksCount === tracks.length ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
            children: "All tracks"
        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            children: [
                tracksCaption,
                !!remainingCount && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                    children: [
                        " and",
                        " ",
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                            children: `${remainingCount} more`
                        })
                    ]
                })
            ]
        })
    });
});
function $8adc43caa88c8c97$export$2285b2873bbd5ff7({ balance: balance, decimals: decimals, unit: unit }) {
    if (balance && unit && decimals) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: (0, $526c1cdc475b977f$export$cc3bc0b518c1c6b8)(balance, decimals, unit)
    });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: "..."
    });
}


function $bf67e73480b6f731$export$e2481bc30224d09b({ address: address, tracks: tracks, open: open, onClose: onClose }) {
    const [fee, setFee] = (0, $4Iuzv.useState)();
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { connectedAccount: connectedAccount } = (0, $47acec667174acda$export$83a8e409853da004)();
    const connectedAddress = connectedAccount?.account?.address;
    const balance = (0, $ff275152c44ce822$export$9c0e4d1c0409ad69)(state);
    const { unit: unit, decimals: decimals } = (0, $ff275152c44ce822$export$4a6dbf642db5266c)(state) || {};
    const cancelHandler = ()=>onClose();
    // set fee
    (0, $4Iuzv.useEffect)(()=>{
        if (open && connectedAddress && balance && tracks.length > 0) {
            const trackIds = tracks.map((track)=>track.id);
            updater.undelegate(trackIds, connectedAddress).then(async (tx)=>{
                if (tx.type === "ok") {
                    const fee = await (0, $526c1cdc475b977f$export$f9a8254a7f017ec)(tx.value, connectedAddress);
                    setFee(fee);
                }
            });
        }
    }, [
        open
    ]);
    const undelegateHandler = async ({ account: { address: address }, signer: signer })=>{
        try {
            const trackIds = tracks.map((track)=>track.id);
            const txs = await updater.undelegate(trackIds, address);
            if (txs.type == "ok") {
                let before = Date.now();
                await (0, $526c1cdc475b977f$export$c52e4b551c4ab930)(address, {
                    signer: signer,
                    nonce: -1
                }, txs.value, async (result, unsub)=>{
                    console.debug(`Tx update: ${JSON.stringify(result)}`);
                    const { status: status, dispatchError: dispatchError } = result;
                    if (status.isReady) before = Date.now();
                    updater.handleCallResult(unsub, status, dispatchError);
                    if (status.isInBlock && !dispatchError) {
                        const duration = (Date.now() - before).toString();
                        (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Undelegate", {
                            duration: duration,
                            address: address,
                            tracks: trackIds.map((i)=>i.toString()).join(",")
                        });
                        console.debug(`Undelegation in block after ${duration} ms`);
                        await updater.removeVotings(new Set(trackIds));
                    }
                });
            } else updater.addReport({
                type: "Error",
                message: txs.error.message
            });
        } catch (e) {
            console.debug("Failed to send the transaction", e);
            updater.addReport({
                type: "Error",
                message: `Failed to send the transaction: ${e}`
            });
        } finally{
            // close modal
            onClose();
        }
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7b51a257e986fbd2$export$2b77a92f1a5ad772), {
        size: "md",
        open: open,
        onClose: ()=>onClose(),
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex w-full flex-col gap-12 p-4 md:p-12",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex flex-col items-start justify-start gap-6 ",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "text-left",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                    className: "mb-2 text-3xl font-medium",
                                    children: "Summary"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-base",
                                    children: "Submitting this transaction will undelegate the following tracks:"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "grid w-full grid-cols-3 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                    className: "col-span-2",
                                    title: "Tracks to undelegate",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$321a3a223c3064d2), {
                                        allTracksCount: (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).size,
                                        tracks: tracks,
                                        visibleCount: 2
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                    title: "Delegate",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                                        textClassName: "font-medium",
                                        address: address,
                                        size: 24
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("hr", {
                            className: "w-full bg-gray-400"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                title: "Undelegation fee (one time)",
                                children: unit && decimals && fee && (0, $526c1cdc475b977f$export$cc3bc0b518c1c6b8)(fee, decimals, unit) || "..."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex w-full flex-row justify-end gap-4",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                            onClick: cancelHandler,
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$cae179f078f4b4a4), {}),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                            variant: "primary",
                            onClick: ()=>connectedAccount && undelegateHandler(connectedAccount),
                            disabled: !connectedAccount || !balance?.gtn(0),
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    children: "Undelegate Tracks"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$b837bd7eac09a33e), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



function $081397004471dc15$export$75d8f5b437e63034({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: `flex flex-col rounded-xl p-3 ${className}`,
        children: children
    });
}







function $26831442b12dac3e$export$ea5f704b89d806f6({ title: title, checked: checked, onChange: onChange, background: background, disabled: disabled, tooltipContent: tooltipContent, tooltipTitle: tooltipTitle }) {
    const checkboxId = `${title}-checkbox`;
    const getCheckboxStyle = (checked, disabled)=>{
        let classNames = "flex h-4 w-4 rounded-sm border-[1px] p-[1px]";
        if (disabled) classNames = `${classNames} border-gray-300 text-fg-disabled ${checked ? "bg-gray-300" : "bg-white"} `;
        else classNames = `${classNames} ${checked ? "border-primary bg-primary hover:brightness-95" : "border-gray-500  bg-white hover:brightness-95"}`;
        return classNames;
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `rounded-sd flex h-fit w-fit items-center gap-3 ${background ? `rounded-md border bg-gray-200 px-2 py-2 lg:px-4` : ""} `,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                id: checkboxId,
                type: "checkbox",
                checked: checked,
                onChange: onChange,
                className: "hidden",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("label", {
                htmlFor: checkboxId,
                className: `flex w-full ${disabled ? "" : "cursor-pointer"} items-center justify-between gap-2`,
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: getCheckboxStyle(!!checked, !!disabled),
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$7dd004358974b05d), {
                            className: `h-full w-full ${checked ? "block" : "hidden"} text-white`
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: `select-none whitespace-nowrap text-body-2 font-semibold ${disabled ? "text-fg-disabled" : "text-gray-900"}`,
                        children: title
                    })
                ]
            }),
            tooltipTitle && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $006e1caac8f7780a$export$2e2bcd8739ae039), {
                content: tooltipContent,
                title: tooltipTitle
            })
        ]
    });
}




function $24210ae624608e08$var$referendaTitle(index, details) {
    const detail = details.get(index);
    const base = `# ${index}`;
    if (detail) return `${base} - ${detail.title || "Untitled"}`;
    else return base;
}
const $24210ae624608e08$var$TallyBadgeBox = /*#__PURE__*/ (0, $4Iuzv.memo)(function({ tally: tally }) {
    const { ayes: ayes, nays: nays } = tally;
    const total = ayes.add(nays);
    // if total===0 means no vote is casted
    const ayePerc = !total.eqn(0) ? ayes.muln(100).div(total).toNumber() : 0;
    const nayPerc = !total.eqn(0) ? 100 - ayePerc : 0;
    const ayeClass = ayePerc > nayPerc ? "rounded bg-green-500 text-white" : "text-green-500";
    const nayClass = nayPerc > ayePerc ? "rounded bg-red-500 text-white" : "text-red-500";
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex flex-row gap-1 text-sm font-semibold",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `p-1 text-center align-middle ${ayeClass}`,
                children: `${ayePerc}%`
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `p-1 text-center align-middle ${nayClass}`,
                children: `${nayPerc}%`
            })
        ]
    });
});
function $24210ae624608e08$var$ReferendaDetails({ index: index, details: details, referendum: referendum, network: network }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $081397004471dc15$export$75d8f5b437e63034), {
        className: "gap-2 border-[1px] border-solid border-gray-200 bg-white text-body-2 font-medium",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "flex flex-row gap-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                    className: "grow overflow-hidden text-ellipsis leading-tight",
                    href: `https://${network.toLowerCase()}.polkassembly.io/referenda/${index}`,
                    target: "_blank",
                    rel: "noreferrer",
                    children: $24210ae624608e08$var$referendaTitle(index, details)
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                        address: referendum.submissionDeposit.who,
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($24210ae624608e08$var$TallyBadgeBox, {
                        tally: referendum.tally
                    })
                ]
            })
        ]
    });
}
function $24210ae624608e08$var$TrackDelegation({ track: track, delegation: delegation }) {
    const { state: state } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const isProcessing = (0, $ff275152c44ce822$export$f21bf6b1fa1004ea)(state);
    const { target: target } = delegation;
    const [showModal, setShowModal] = (0, $4Iuzv.useState)(false);
    const closeModal = ()=>{
        setShowModal(false);
    };
    const openModal = ()=>{
        setShowModal(true);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $081397004471dc15$export$75d8f5b437e63034), {
                className: "gap-2 bg-[#FFE4F3]",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "text-sm font-normal",
                        children: "Delegated to"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                                textClassName: "font-semibold text-base",
                                address: target,
                                size: 24,
                                copy: true
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: `${!isProcessing ? "cursor-pointer hover:scale-[1.01]" : "text-fg-disabled"}`,
                                onClick: ()=>!isProcessing && openModal(),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$cae179f078f4b4a4), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $bf67e73480b6f731$export$e2481bc30224d09b), {
                onClose: closeModal,
                open: showModal,
                tracks: track && [
                    track
                ] || [],
                address: delegation.target
            })
        ]
    });
}
function $24210ae624608e08$export$a5c814852e56ea5f({ track: track, referenda: referenda, details: details, delegation: delegation, checked: checked, onChange: onChange, network: network }) {
    const { state: state } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const isProcessing = (0, $ff275152c44ce822$export$f21bf6b1fa1004ea)(state);
    const disabled = !!delegation || isProcessing;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex w-full flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "mb-4 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex w-full items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $26831442b12dac3e$export$ea5f704b89d806f6), {
                                        title: track?.title,
                                        checked: checked,
                                        onChange: onChange,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "select-none overflow-hidden text-ellipsis whitespace-nowrap text-body-2 text-fg-dim",
                                        children: referenda.size
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $006e1caac8f7780a$export$2e2bcd8739ae039), {
                                content: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                    children: track?.description
                                }),
                                title: track?.title
                            })
                        ]
                    }),
                    delegation && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($24210ae624608e08$var$TrackDelegation, {
                        track: track,
                        delegation: delegation
                    })
                ]
            }),
            referenda.size > 0 && Array.from(referenda.entries()).map(([index, referendum])=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($24210ae624608e08$var$ReferendaDetails, {
                    index: index,
                    details: details,
                    referendum: referendum,
                    network: network
                }, index))
        ]
    });
}
function $24210ae624608e08$var$partitionReferendaByTrack(referenda) {
    return Array.from(referenda.entries()).reduce((acc, [id, referendum])=>{
        const trackId = referendum.trackIndex;
        const tracks = acc.get(trackId) || new Map();
        tracks.set(id, referendum);
        acc.set(trackId, tracks);
        return acc;
    }, new Map());
}
function $24210ae624608e08$export$bcb0a125575d8e21({ className: className, network: network, referenda: referenda, details: details, tracks: tracks, delegateHandler: delegateHandler }) {
    const { state: state } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { connectedAccount: connectedAccount } = (0, $47acec667174acda$export$83a8e409853da004)();
    const isProcessing = (0, $ff275152c44ce822$export$f21bf6b1fa1004ea)(state);
    const delegations = (0, $ff275152c44ce822$export$d3f593c73a07d922)(state);
    const { selectedTrackIndexes: selectedTrackIndexes, setTrackSelection: setTrackSelection } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    const allTracks = (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(tracks);
    const undelegatedTracks = (0, $ff275152c44ce822$export$950bf1eaf02906d4)(state, allTracks);
    const allTrackCheckboxTitle = `All ${undelegatedTracks.length !== allTracks.size ? "undelegated" : ""} tracks`;
    const referendaByTrack = $24210ae624608e08$var$partitionReferendaByTrack(referenda);
    const delegatesWithTracks = (0, $ff275152c44ce822$export$bf095c2cbab9a226)(state);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex w-full flex-col gap-6 lg:gap-12",
        children: [
            delegatesWithTracks.size ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex snap-start flex-col items-center",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "px-3 font-unbounded text-h4",
                        children: "Expand your delegation"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                        className: "text-body",
                        children: "You can always delegate undelegated tracks without locking any more tokens."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$4857d3f3f5f8319b), {
                        className: "mt-4"
                    })
                ]
            }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex snap-start flex-col items-center",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "px-3 font-unbounded text-h4",
                        children: "Or Select tracks to delegate"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                        className: "px-4 text-body",
                        children: "First, select the tracks you would like to delegate, then pick the address you'd like to delegate to."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $384a056e5ce27cd7$export$2e2bcd8739ae039), {
                        className: "",
                        title: "Select a track",
                        description: referendaByTrack.size > 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                            children: [
                                "There are currently ",
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("b", {
                                    children: referendaByTrack.size
                                }),
                                " active tracks."
                            ]
                        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                            className: "text-fg-disabled",
                            children: "Failed to fetch proposals."
                        }),
                        step: 0,
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $021483ab580d6bff$export$2e2bcd8739ae039), {
                            step: 0
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex flex-col gap-2 lg:gap-4 ",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "sticky top-52 mb-4 flex flex-row justify-between overflow-visible bg-bg-default/80 px-3 py-3 backdrop-blur-sm lg:top-44 lg:px-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $26831442b12dac3e$export$ea5f704b89d806f6), {
                                        background: true,
                                        title: allTrackCheckboxTitle,
                                        checked: !!undelegatedTracks.length && selectedTrackIndexes.size === undelegatedTracks.length,
                                        onChange: (e)=>{
                                            const isChecked = e.target.checked;
                                            undelegatedTracks.map((track)=>{
                                                setTrackSelection(track.id, isChecked);
                                            });
                                            (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Select", {
                                                target: "AllTracks"
                                            });
                                        },
                                        disabled: isProcessing || connectedAccount && !undelegatedTracks.length
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "mx-0 hidden text-body-2 text-fg-disabled lg:mx-4 lg:block",
                                                children: selectedTrackIndexes.size > 0 ? selectedTrackIndexes.size == 1 ? `1 track selected` : `${selectedTrackIndexes.size} tracks selected` : "0 tracks selected"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                                                disabled: selectedTrackIndexes.size == 0,
                                                onClick: delegateHandler,
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex flex-row items-center justify-center gap-1 whitespace-nowrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            children: "Select delegate"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$4857d3f3f5f8319b), {})
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: `mb-12 flex w-full flex-col justify-between px-3 md:flex-row md:gap-12 lg:px-8 ${className}`,
                                children: tracks.map((category, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex w-full flex-col gap-6 md:w-1/4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "border-b-[1px] pb-3",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $26831442b12dac3e$export$ea5f704b89d806f6), {
                                                    title: category.title,
                                                    checked: category.tracks.every(({ id: id })=>selectedTrackIndexes.has(id) || delegations.has(id)),
                                                    onChange: (e)=>{
                                                        const isChecked = e.target.checked;
                                                        category.tracks.map(({ id: id })=>{
                                                            if (!delegations.has(id)) setTrackSelection(id, isChecked);
                                                        });
                                                        (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Select", {
                                                            target: "Category",
                                                            id: category.title
                                                        });
                                                    },
                                                    disabled: isProcessing || category.tracks.every((elem)=>delegations.has(elem.id))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "flex w-full flex-col gap-6 lg:gap-4",
                                                children: category.tracks.map((track, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($24210ae624608e08$export$a5c814852e56ea5f, {
                                                        track: track,
                                                        details: details,
                                                        referenda: referendaByTrack.get(track.id) || new Map(),
                                                        delegation: delegations.get(track.id),
                                                        checked: selectedTrackIndexes.has(track.id),
                                                        onChange: (e)=>{
                                                            const isChecked = e.target.checked;
                                                            setTrackSelection(track.id, isChecked);
                                                            (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Select", {
                                                                target: "Track",
                                                                id: track.id.toString()
                                                            });
                                                        },
                                                        network: network
                                                    }, idx))
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





var $568763a6863529f3$exports = {};

$568763a6863529f3$exports = new URL((parcelRequire("giU2u")).resolve("jGqM8"), import.meta.url).toString();


const $ec6f470086eeee77$var$headline1Url = new URL($568763a6863529f3$exports).toString();
var $73ac8a8fef4ad58b$exports = {};

$73ac8a8fef4ad58b$exports = new URL((parcelRequire("giU2u")).resolve("hzp0g"), import.meta.url).toString();


const $ec6f470086eeee77$var$headline2Url = new URL($73ac8a8fef4ad58b$exports).toString();
function $ec6f470086eeee77$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `flex w-full flex-col items-center justify-center gap-12 pt-12`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex w-full flex-col items-center gap-3 px-8 lg:gap-0 lg:px-0",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                        className: "text-center font-unbounded text-h3 lg:text-h1",
                        children: [
                            "Delegate ",
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "text-primary",
                                children: "your votes"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                        className: "px-3 text-center text-body",
                        children: [
                            "No time to vote? Keep Polkadot running smoothly by delegating to an expert.",
                            " ",
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                href: "https://www.youtube.com/watch?v=RapBYZc5ZPo",
                                children: "Watch video"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex w-full gap-32 px-6 xl:px-28",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex w-full items-center gap-2 px-4 lg:gap-4 lg:px-0",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                width: 200,
                                src: $ec6f470086eeee77$var$headline1Url,
                                alt: "Headline image 1"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex w-full flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-h6 font-semibold",
                                        children: "Make your vote count"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-body-2",
                                        children: "All DOT holders can participate in governance. You can also appoint a representative with expertise to delegate your votes to, as and when you please."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex w-full items-center gap-2 px-4  lg:gap-4 lg:px-0",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                width: 200,
                                src: $ec6f470086eeee77$var$headline2Url,
                                alt: "Headline image 1"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex w-full flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-h6 font-semibold",
                                        children: "Engage in governance"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-body-2",
                                        children: "Even when delegating your vote, you remain in full control. At any time, you can change delegates or take back your voting power completely."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");


var $4Iuzv = parcelRequire("4Iuzv");







var $4Iuzv = parcelRequire("4Iuzv");
var $408348b5067297f8$exports = {};
"use strict";
var $13124d7e64378762$exports = {};
"use strict";
$13124d7e64378762$exports = $13124d7e64378762$var$bail;
function $13124d7e64378762$var$bail(err) {
    if (err) throw err;
}



var $1vTdF = parcelRequire("1vTdF");
var $5e807552c8a5af43$exports = {};
"use strict";
var $5e807552c8a5af43$var$hasOwn = Object.prototype.hasOwnProperty;
var $5e807552c8a5af43$var$toStr = Object.prototype.toString;
var $5e807552c8a5af43$var$defineProperty = Object.defineProperty;
var $5e807552c8a5af43$var$gOPD = Object.getOwnPropertyDescriptor;
var $5e807552c8a5af43$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $5e807552c8a5af43$var$toStr.call(arr) === "[object Array]";
};
var $5e807552c8a5af43$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $5e807552c8a5af43$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $5e807552c8a5af43$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $5e807552c8a5af43$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $5e807552c8a5af43$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $5e807552c8a5af43$var$setProperty = function setProperty(target, options) {
    if ($5e807552c8a5af43$var$defineProperty && options.name === "__proto__") $5e807552c8a5af43$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $5e807552c8a5af43$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$5e807552c8a5af43$var$hasOwn.call(obj, name)) return void 0;
        else if ($5e807552c8a5af43$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $5e807552c8a5af43$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$5e807552c8a5af43$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $5e807552c8a5af43$var$getProperty(target, name);
            copy = $5e807552c8a5af43$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($5e807552c8a5af43$var$isPlainObject(copy) || (copyIsArray = $5e807552c8a5af43$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $5e807552c8a5af43$var$isArray(src) ? src : [];
                    } else clone = src && $5e807552c8a5af43$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $5e807552c8a5af43$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $5e807552c8a5af43$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


var $c60dcc02aad83def$exports = {};
"use strict";
$c60dcc02aad83def$exports = (value)=>{
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};


var $4b7c3ee2cdd644b3$exports = {};
"use strict";
var $7849545739c8c535$exports = {};
"use strict";
var $7849545739c8c535$var$slice = [].slice;
$7849545739c8c535$exports = $7849545739c8c535$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $7849545739c8c535$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $7849545739c8c535$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}


$4b7c3ee2cdd644b3$exports = $4b7c3ee2cdd644b3$var$trough;
$4b7c3ee2cdd644b3$var$trough.wrap = $7849545739c8c535$exports;
var $4b7c3ee2cdd644b3$var$slice = [].slice;
// Create new middleware.
function $4b7c3ee2cdd644b3$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $4b7c3ee2cdd644b3$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== "function") throw new Error("Expected function as last argument, not " + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $4b7c3ee2cdd644b3$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $7849545739c8c535$exports(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== "function") throw new Error("Expected `fn` to be a function, not " + fn);
        fns.push(fn);
        return middleware;
    }
}


var $0adc9cd53337575e$exports = {};
"use strict";

$0adc9cd53337575e$exports = (parcelRequire("34qAQ"));


// Expose a frozen processor.
$408348b5067297f8$exports = $408348b5067297f8$var$unified().freeze();
var $408348b5067297f8$var$slice = [].slice;
var $408348b5067297f8$var$own = {}.hasOwnProperty;
// Process pipeline.
var $408348b5067297f8$var$pipeline = $4b7c3ee2cdd644b3$exports().use($408348b5067297f8$var$pipelineParse).use($408348b5067297f8$var$pipelineRun).use($408348b5067297f8$var$pipelineStringify);
function $408348b5067297f8$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $408348b5067297f8$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $408348b5067297f8$var$pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === "string" || $1vTdF(result)) {
        if ("value" in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function $408348b5067297f8$var$unified() {
    var attachers = [];
    var transformers = $4b7c3ee2cdd644b3$exports();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $408348b5067297f8$var$unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data($5e807552c8a5af43$exports(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $408348b5067297f8$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $408348b5067297f8$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $408348b5067297f8$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $408348b5067297f8$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin.apply(null, arguments);
        else if (typeof value === "object") {
            if ("length" in value) addList(value);
            else addPreset(value);
        } else throw new Error("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = $5e807552c8a5af43$exports(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $5e807552c8a5af43$exports(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if ("length" in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error("Expected usable value, not `" + value + "`");
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === "object" && "length" in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error("Expected a list of plugins, not `" + plugins + "`");
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($c60dcc02aad83def$exports(entry[1]) && $c60dcc02aad83def$exports(value)) value = $5e807552c8a5af43$exports(true, entry[1], value);
                entry[1] = value;
            } else attachers.push($408348b5067297f8$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $0adc9cd53337575e$exports(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $408348b5067297f8$var$assertParser("parse", Parser);
        if ($408348b5067297f8$var$newable(Parser, "parse")) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $408348b5067297f8$var$assertNode(node);
        freeze();
        if (!cb && typeof file === "function") {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $0adc9cd53337575e$exports(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        $408348b5067297f8$var$assertDone("runSync", "run", complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            $13124d7e64378762$exports(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $0adc9cd53337575e$exports(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $408348b5067297f8$var$assertCompiler("stringify", Compiler);
        $408348b5067297f8$var$assertNode(node);
        if ($408348b5067297f8$var$newable(Compiler, "compile")) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $408348b5067297f8$var$assertParser("process", processor.Parser);
        $408348b5067297f8$var$assertCompiler("process", processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $0adc9cd53337575e$exports(doc);
            $408348b5067297f8$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        $408348b5067297f8$var$assertParser("processSync", processor.Parser);
        $408348b5067297f8$var$assertCompiler("processSync", processor.Compiler);
        file = $0adc9cd53337575e$exports(doc);
        process(file, done);
        $408348b5067297f8$var$assertDone("processSync", "process", complete);
        return file;
        function done(error) {
            complete = true;
            $13124d7e64378762$exports(error);
        }
    }
}
// Check if `value` is a constructor.
function $408348b5067297f8$var$newable(value, name) {
    return typeof value === "function" && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($408348b5067297f8$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $408348b5067297f8$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $408348b5067297f8$var$assertParser(name, Parser) {
    if (typeof Parser !== "function") throw new Error("Cannot `" + name + "` without `Parser`");
}
// Assert a compiler is available.
function $408348b5067297f8$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== "function") throw new Error("Cannot `" + name + "` without `Compiler`");
}
// Assert the processor is not frozen.
function $408348b5067297f8$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot invoke `" + name + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.");
}
// Assert `node` is a unist node.
function $408348b5067297f8$var$assertNode(node) {
    if (!node || typeof node.type !== "string") throw new Error("Expected node, got `" + node + "`");
}
// Assert that `complete` is `true`.
function $408348b5067297f8$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}


var $3da447a868c6e2f7$exports = {};
"use strict";
$3da447a868c6e2f7$exports = $3da447a868c6e2f7$var$parse;
var $d5bf26a7a9e9da52$exports = {};
"use strict";

$d5bf26a7a9e9da52$exports = (parcelRequire("iGt2x"));


function $3da447a868c6e2f7$var$parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return $d5bf26a7a9e9da52$exports(doc, Object.assign({}, self.data("settings"), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data("micromarkExtensions") || [],
            mdastExtensions: self.data("fromMarkdownExtensions") || []
        }));
    }
}


var $b370febd9318b830$exports = {};
"use strict";
var $06f1d1ab2f222679$exports = {};
"use strict";

$06f1d1ab2f222679$exports = (parcelRequire("6M2CY"));


$b370febd9318b830$exports = $b370febd9318b830$var$remark2rehype;
// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function $b370febd9318b830$var$remark2rehype(destination, options) {
    if (destination && !destination.process) {
        options = destination;
        destination = null;
    }
    return destination ? $b370febd9318b830$var$bridge(destination, options) : $b370febd9318b830$var$mutate(options);
}
// Bridge mode.
// Runs the destination with the new hast tree.
function $b370febd9318b830$var$bridge(destination, options) {
    return transformer;
    function transformer(node, file, next) {
        destination.run($06f1d1ab2f222679$exports(node, options), file, done);
        function done(error) {
            next(error);
        }
    }
}
// Mutate-mode.
// Further transformers run on the hast tree.
function $b370febd9318b830$var$mutate(options) {
    return transformer;
    function transformer(node) {
        return $06f1d1ab2f222679$exports(node, options);
    }
}


var $04ee50b1804dcfa6$exports = {};
"use strict";
var $8e73584c05f460db$exports = {};
"use strict";
var $1d1ab0195d78d073$exports = {};
"use strict";
var $7d80d4f0495cef02$exports = {};
"use strict";
var $2f7a80abc909ae5c$exports = {};
$2f7a80abc909ae5c$exports = $2f7a80abc909ae5c$var$extend;
var $2f7a80abc909ae5c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f7a80abc909ae5c$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($2f7a80abc909ae5c$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}


var $f008687448720f33$exports = {};
"use strict";
$f008687448720f33$exports = $f008687448720f33$var$Schema;
var $f008687448720f33$var$proto = $f008687448720f33$var$Schema.prototype;
$f008687448720f33$var$proto.space = null;
$f008687448720f33$var$proto.normal = {};
$f008687448720f33$var$proto.property = {};
function $f008687448720f33$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}


$7d80d4f0495cef02$exports = $7d80d4f0495cef02$var$merge;
function $7d80d4f0495cef02$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $f008687448720f33$exports($2f7a80abc909ae5c$exports.apply(null, property), $2f7a80abc909ae5c$exports.apply(null, normal), space);
}


var $75a233800c587948$exports = {};
"use strict";
var $c514304cd491e868$exports = {};
"use strict";
var $69235c9611e362af$exports = {};
"use strict";
$69235c9611e362af$exports = $69235c9611e362af$var$normalize;
function $69235c9611e362af$var$normalize(value) {
    return value.toLowerCase();
}



var $18c096c7cdbeda4b$exports = {};
"use strict";
var $3cd17794710d5cad$exports = {};
"use strict";
$3cd17794710d5cad$exports = $3cd17794710d5cad$var$Info;
var $3cd17794710d5cad$var$proto = $3cd17794710d5cad$var$Info.prototype;
$3cd17794710d5cad$var$proto.space = null;
$3cd17794710d5cad$var$proto.attribute = null;
$3cd17794710d5cad$var$proto.property = null;
$3cd17794710d5cad$var$proto.boolean = false;
$3cd17794710d5cad$var$proto.booleanish = false;
$3cd17794710d5cad$var$proto.overloadedBoolean = false;
$3cd17794710d5cad$var$proto.number = false;
$3cd17794710d5cad$var$proto.commaSeparated = false;
$3cd17794710d5cad$var$proto.spaceSeparated = false;
$3cd17794710d5cad$var$proto.commaOrSpaceSeparated = false;
$3cd17794710d5cad$var$proto.mustUseProperty = false;
$3cd17794710d5cad$var$proto.defined = false;
function $3cd17794710d5cad$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}


var $f7bd6597cb6b6184$exports = {};

$parcel$export($f7bd6597cb6b6184$exports, "boolean", function () { return $f7bd6597cb6b6184$export$4a21f16c33752377; }, function (v) { return $f7bd6597cb6b6184$export$4a21f16c33752377 = v; });
$parcel$export($f7bd6597cb6b6184$exports, "booleanish", function () { return $f7bd6597cb6b6184$export$55e9e1fbc638dc8f; }, function (v) { return $f7bd6597cb6b6184$export$55e9e1fbc638dc8f = v; });
$parcel$export($f7bd6597cb6b6184$exports, "overloadedBoolean", function () { return $f7bd6597cb6b6184$export$242ac3d3042558aa; }, function (v) { return $f7bd6597cb6b6184$export$242ac3d3042558aa = v; });
$parcel$export($f7bd6597cb6b6184$exports, "number", function () { return $f7bd6597cb6b6184$export$98e628dec113755e; }, function (v) { return $f7bd6597cb6b6184$export$98e628dec113755e = v; });
$parcel$export($f7bd6597cb6b6184$exports, "spaceSeparated", function () { return $f7bd6597cb6b6184$export$ab8645c862eb5a3e; }, function (v) { return $f7bd6597cb6b6184$export$ab8645c862eb5a3e = v; });
$parcel$export($f7bd6597cb6b6184$exports, "commaSeparated", function () { return $f7bd6597cb6b6184$export$9c8d678629b3d3; }, function (v) { return $f7bd6597cb6b6184$export$9c8d678629b3d3 = v; });
$parcel$export($f7bd6597cb6b6184$exports, "commaOrSpaceSeparated", function () { return $f7bd6597cb6b6184$export$2ad25cfebf36cacd; }, function (v) { return $f7bd6597cb6b6184$export$2ad25cfebf36cacd = v; });
var $f7bd6597cb6b6184$export$4a21f16c33752377;
var $f7bd6597cb6b6184$export$55e9e1fbc638dc8f;
var $f7bd6597cb6b6184$export$242ac3d3042558aa;
var $f7bd6597cb6b6184$export$98e628dec113755e;
var $f7bd6597cb6b6184$export$ab8645c862eb5a3e;
var $f7bd6597cb6b6184$export$9c8d678629b3d3;
var $f7bd6597cb6b6184$export$2ad25cfebf36cacd;
"use strict";
var $f7bd6597cb6b6184$var$powers = 0;
$f7bd6597cb6b6184$export$4a21f16c33752377 = $f7bd6597cb6b6184$var$increment();
$f7bd6597cb6b6184$export$55e9e1fbc638dc8f = $f7bd6597cb6b6184$var$increment();
$f7bd6597cb6b6184$export$242ac3d3042558aa = $f7bd6597cb6b6184$var$increment();
$f7bd6597cb6b6184$export$98e628dec113755e = $f7bd6597cb6b6184$var$increment();
$f7bd6597cb6b6184$export$ab8645c862eb5a3e = $f7bd6597cb6b6184$var$increment();
$f7bd6597cb6b6184$export$9c8d678629b3d3 = $f7bd6597cb6b6184$var$increment();
$f7bd6597cb6b6184$export$2ad25cfebf36cacd = $f7bd6597cb6b6184$var$increment();
function $f7bd6597cb6b6184$var$increment() {
    return Math.pow(2, ++$f7bd6597cb6b6184$var$powers);
}


$18c096c7cdbeda4b$exports = $18c096c7cdbeda4b$var$DefinedInfo;
$18c096c7cdbeda4b$var$DefinedInfo.prototype = new $3cd17794710d5cad$exports();
$18c096c7cdbeda4b$var$DefinedInfo.prototype.defined = true;
var $18c096c7cdbeda4b$var$checks = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
];
var $18c096c7cdbeda4b$var$checksLength = $18c096c7cdbeda4b$var$checks.length;
function $18c096c7cdbeda4b$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $18c096c7cdbeda4b$var$mark(this, "space", space);
    $3cd17794710d5cad$exports.call(this, property, attribute);
    while(++index < $18c096c7cdbeda4b$var$checksLength){
        check = $18c096c7cdbeda4b$var$checks[index];
        $18c096c7cdbeda4b$var$mark(this, check, (mask & $f7bd6597cb6b6184$exports[check]) === $f7bd6597cb6b6184$exports[check]);
    }
}
function $18c096c7cdbeda4b$var$mark(values, key, value) {
    if (value) values[key] = value;
}


$c514304cd491e868$exports = $c514304cd491e868$var$create;
function $c514304cd491e868$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $18c096c7cdbeda4b$exports(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$69235c9611e362af$exports(prop)] = prop;
        normal[$69235c9611e362af$exports(info.attribute)] = prop;
    }
    return new $f008687448720f33$exports(property, normal, space);
}


$75a233800c587948$exports = $c514304cd491e868$exports({
    space: "xlink",
    transform: $75a233800c587948$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $75a233800c587948$var$xlinkTransform(_, prop) {
    return "xlink:" + prop.slice(5).toLowerCase();
}


var $3926e95d8f92dc65$exports = {};
"use strict";

$3926e95d8f92dc65$exports = $c514304cd491e868$exports({
    space: "xml",
    transform: $3926e95d8f92dc65$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $3926e95d8f92dc65$var$xmlTransform(_, prop) {
    return "xml:" + prop.slice(3).toLowerCase();
}


var $aa9385cba583c934$exports = {};
"use strict";

var $cdb0f4e21b13d1f3$exports = {};
"use strict";
var $d43eda4f7e795d82$exports = {};
"use strict";
$d43eda4f7e795d82$exports = $d43eda4f7e795d82$var$caseSensitiveTransform;
function $d43eda4f7e795d82$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


$cdb0f4e21b13d1f3$exports = $cdb0f4e21b13d1f3$var$caseInsensitiveTransform;
function $cdb0f4e21b13d1f3$var$caseInsensitiveTransform(attributes, property) {
    return $d43eda4f7e795d82$exports(attributes, property.toLowerCase());
}


$aa9385cba583c934$exports = $c514304cd491e868$exports({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: $cdb0f4e21b13d1f3$exports,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});


var $014ffbb6615f09d3$exports = {};
"use strict";


var $014ffbb6615f09d3$var$booleanish = $f7bd6597cb6b6184$export$55e9e1fbc638dc8f;
var $014ffbb6615f09d3$var$number = $f7bd6597cb6b6184$export$98e628dec113755e;
var $014ffbb6615f09d3$var$spaceSeparated = $f7bd6597cb6b6184$export$ab8645c862eb5a3e;
$014ffbb6615f09d3$exports = $c514304cd491e868$exports({
    transform: $014ffbb6615f09d3$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $014ffbb6615f09d3$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $014ffbb6615f09d3$var$booleanish,
        ariaChecked: $014ffbb6615f09d3$var$booleanish,
        ariaColCount: $014ffbb6615f09d3$var$number,
        ariaColIndex: $014ffbb6615f09d3$var$number,
        ariaColSpan: $014ffbb6615f09d3$var$number,
        ariaControls: $014ffbb6615f09d3$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $014ffbb6615f09d3$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $014ffbb6615f09d3$var$booleanish,
        ariaDropEffect: $014ffbb6615f09d3$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $014ffbb6615f09d3$var$booleanish,
        ariaFlowTo: $014ffbb6615f09d3$var$spaceSeparated,
        ariaGrabbed: $014ffbb6615f09d3$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $014ffbb6615f09d3$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $014ffbb6615f09d3$var$spaceSeparated,
        ariaLevel: $014ffbb6615f09d3$var$number,
        ariaLive: null,
        ariaModal: $014ffbb6615f09d3$var$booleanish,
        ariaMultiLine: $014ffbb6615f09d3$var$booleanish,
        ariaMultiSelectable: $014ffbb6615f09d3$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $014ffbb6615f09d3$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $014ffbb6615f09d3$var$number,
        ariaPressed: $014ffbb6615f09d3$var$booleanish,
        ariaReadOnly: $014ffbb6615f09d3$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $014ffbb6615f09d3$var$booleanish,
        ariaRoleDescription: $014ffbb6615f09d3$var$spaceSeparated,
        ariaRowCount: $014ffbb6615f09d3$var$number,
        ariaRowIndex: $014ffbb6615f09d3$var$number,
        ariaRowSpan: $014ffbb6615f09d3$var$number,
        ariaSelected: $014ffbb6615f09d3$var$booleanish,
        ariaSetSize: $014ffbb6615f09d3$var$number,
        ariaSort: null,
        ariaValueMax: $014ffbb6615f09d3$var$number,
        ariaValueMin: $014ffbb6615f09d3$var$number,
        ariaValueNow: $014ffbb6615f09d3$var$number,
        ariaValueText: null,
        role: null
    }
});
function $014ffbb6615f09d3$var$ariaTransform(_, prop) {
    return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
}


var $3a6899b5d77dce40$exports = {};
"use strict";



var $3a6899b5d77dce40$var$boolean = $f7bd6597cb6b6184$export$4a21f16c33752377;
var $3a6899b5d77dce40$var$overloadedBoolean = $f7bd6597cb6b6184$export$242ac3d3042558aa;
var $3a6899b5d77dce40$var$booleanish = $f7bd6597cb6b6184$export$55e9e1fbc638dc8f;
var $3a6899b5d77dce40$var$number = $f7bd6597cb6b6184$export$98e628dec113755e;
var $3a6899b5d77dce40$var$spaceSeparated = $f7bd6597cb6b6184$export$ab8645c862eb5a3e;
var $3a6899b5d77dce40$var$commaSeparated = $f7bd6597cb6b6184$export$9c8d678629b3d3;
$3a6899b5d77dce40$exports = $c514304cd491e868$exports({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: $cdb0f4e21b13d1f3$exports,
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $3a6899b5d77dce40$var$commaSeparated,
        acceptCharset: $3a6899b5d77dce40$var$spaceSeparated,
        accessKey: $3a6899b5d77dce40$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $3a6899b5d77dce40$var$boolean,
        allowPaymentRequest: $3a6899b5d77dce40$var$boolean,
        allowUserMedia: $3a6899b5d77dce40$var$boolean,
        alt: null,
        as: null,
        async: $3a6899b5d77dce40$var$boolean,
        autoCapitalize: null,
        autoComplete: $3a6899b5d77dce40$var$spaceSeparated,
        autoFocus: $3a6899b5d77dce40$var$boolean,
        autoPlay: $3a6899b5d77dce40$var$boolean,
        capture: $3a6899b5d77dce40$var$boolean,
        charSet: null,
        checked: $3a6899b5d77dce40$var$boolean,
        cite: null,
        className: $3a6899b5d77dce40$var$spaceSeparated,
        cols: $3a6899b5d77dce40$var$number,
        colSpan: null,
        content: null,
        contentEditable: $3a6899b5d77dce40$var$booleanish,
        controls: $3a6899b5d77dce40$var$boolean,
        controlsList: $3a6899b5d77dce40$var$spaceSeparated,
        coords: $3a6899b5d77dce40$var$number | $3a6899b5d77dce40$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $3a6899b5d77dce40$var$boolean,
        defer: $3a6899b5d77dce40$var$boolean,
        dir: null,
        dirName: null,
        disabled: $3a6899b5d77dce40$var$boolean,
        download: $3a6899b5d77dce40$var$overloadedBoolean,
        draggable: $3a6899b5d77dce40$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $3a6899b5d77dce40$var$boolean,
        formTarget: null,
        headers: $3a6899b5d77dce40$var$spaceSeparated,
        height: $3a6899b5d77dce40$var$number,
        hidden: $3a6899b5d77dce40$var$boolean,
        high: $3a6899b5d77dce40$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $3a6899b5d77dce40$var$spaceSeparated,
        httpEquiv: $3a6899b5d77dce40$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $3a6899b5d77dce40$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $3a6899b5d77dce40$var$boolean,
        itemId: null,
        itemProp: $3a6899b5d77dce40$var$spaceSeparated,
        itemRef: $3a6899b5d77dce40$var$spaceSeparated,
        itemScope: $3a6899b5d77dce40$var$boolean,
        itemType: $3a6899b5d77dce40$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $3a6899b5d77dce40$var$boolean,
        low: $3a6899b5d77dce40$var$number,
        manifest: null,
        max: null,
        maxLength: $3a6899b5d77dce40$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $3a6899b5d77dce40$var$number,
        multiple: $3a6899b5d77dce40$var$boolean,
        muted: $3a6899b5d77dce40$var$boolean,
        name: null,
        nonce: null,
        noModule: $3a6899b5d77dce40$var$boolean,
        noValidate: $3a6899b5d77dce40$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $3a6899b5d77dce40$var$boolean,
        optimum: $3a6899b5d77dce40$var$number,
        pattern: null,
        ping: $3a6899b5d77dce40$var$spaceSeparated,
        placeholder: null,
        playsInline: $3a6899b5d77dce40$var$boolean,
        poster: null,
        preload: null,
        readOnly: $3a6899b5d77dce40$var$boolean,
        referrerPolicy: null,
        rel: $3a6899b5d77dce40$var$spaceSeparated,
        required: $3a6899b5d77dce40$var$boolean,
        reversed: $3a6899b5d77dce40$var$boolean,
        rows: $3a6899b5d77dce40$var$number,
        rowSpan: $3a6899b5d77dce40$var$number,
        sandbox: $3a6899b5d77dce40$var$spaceSeparated,
        scope: null,
        scoped: $3a6899b5d77dce40$var$boolean,
        seamless: $3a6899b5d77dce40$var$boolean,
        selected: $3a6899b5d77dce40$var$boolean,
        shape: null,
        size: $3a6899b5d77dce40$var$number,
        sizes: null,
        slot: null,
        span: $3a6899b5d77dce40$var$number,
        spellCheck: $3a6899b5d77dce40$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $3a6899b5d77dce40$var$commaSeparated,
        start: $3a6899b5d77dce40$var$number,
        step: null,
        style: null,
        tabIndex: $3a6899b5d77dce40$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $3a6899b5d77dce40$var$boolean,
        useMap: null,
        value: $3a6899b5d77dce40$var$booleanish,
        width: $3a6899b5d77dce40$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $3a6899b5d77dce40$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $3a6899b5d77dce40$var$number,
        borderColor: null,
        bottomMargin: $3a6899b5d77dce40$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $3a6899b5d77dce40$var$boolean,
        declare: $3a6899b5d77dce40$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $3a6899b5d77dce40$var$number,
        leftMargin: $3a6899b5d77dce40$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $3a6899b5d77dce40$var$number,
        marginWidth: $3a6899b5d77dce40$var$number,
        noResize: $3a6899b5d77dce40$var$boolean,
        noHref: $3a6899b5d77dce40$var$boolean,
        noShade: $3a6899b5d77dce40$var$boolean,
        noWrap: $3a6899b5d77dce40$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $3a6899b5d77dce40$var$number,
        rules: null,
        scheme: null,
        scrolling: $3a6899b5d77dce40$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $3a6899b5d77dce40$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $3a6899b5d77dce40$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $3a6899b5d77dce40$var$boolean,
        disableRemotePlayback: $3a6899b5d77dce40$var$boolean,
        prefix: null,
        property: null,
        results: $3a6899b5d77dce40$var$number,
        security: null,
        unselectable: null
    }
});


$1d1ab0195d78d073$exports = $7d80d4f0495cef02$exports([
    $3926e95d8f92dc65$exports,
    $75a233800c587948$exports,
    $aa9385cba583c934$exports,
    $014ffbb6615f09d3$exports,
    $3a6899b5d77dce40$exports
]);


var $34a5aa9c5328a79d$exports = {};
"use strict";





var $d111215002ebbe77$exports = {};
"use strict";



var $d111215002ebbe77$var$boolean = $f7bd6597cb6b6184$export$4a21f16c33752377;
var $d111215002ebbe77$var$number = $f7bd6597cb6b6184$export$98e628dec113755e;
var $d111215002ebbe77$var$spaceSeparated = $f7bd6597cb6b6184$export$ab8645c862eb5a3e;
var $d111215002ebbe77$var$commaSeparated = $f7bd6597cb6b6184$export$9c8d678629b3d3;
var $d111215002ebbe77$var$commaOrSpaceSeparated = $f7bd6597cb6b6184$export$2ad25cfebf36cacd;
$d111215002ebbe77$exports = $c514304cd491e868$exports({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: $d43eda4f7e795d82$exports,
    properties: {
        about: $d111215002ebbe77$var$commaOrSpaceSeparated,
        accentHeight: $d111215002ebbe77$var$number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $d111215002ebbe77$var$number,
        amplitude: $d111215002ebbe77$var$number,
        arabicForm: null,
        ascent: $d111215002ebbe77$var$number,
        attributeName: null,
        attributeType: null,
        azimuth: $d111215002ebbe77$var$number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $d111215002ebbe77$var$number,
        by: null,
        calcMode: null,
        capHeight: $d111215002ebbe77$var$number,
        className: $d111215002ebbe77$var$spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $d111215002ebbe77$var$number,
        diffuseConstant: $d111215002ebbe77$var$number,
        direction: null,
        display: null,
        dur: null,
        divisor: $d111215002ebbe77$var$number,
        dominantBaseline: null,
        download: $d111215002ebbe77$var$boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $d111215002ebbe77$var$number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $d111215002ebbe77$var$number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $d111215002ebbe77$var$number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $d111215002ebbe77$var$commaSeparated,
        g2: $d111215002ebbe77$var$commaSeparated,
        glyphName: $d111215002ebbe77$var$commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $d111215002ebbe77$var$number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $d111215002ebbe77$var$number,
        horizOriginX: $d111215002ebbe77$var$number,
        horizOriginY: $d111215002ebbe77$var$number,
        id: null,
        ideographic: $d111215002ebbe77$var$number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $d111215002ebbe77$var$number,
        k: $d111215002ebbe77$var$number,
        k1: $d111215002ebbe77$var$number,
        k2: $d111215002ebbe77$var$number,
        k3: $d111215002ebbe77$var$number,
        k4: $d111215002ebbe77$var$number,
        kernelMatrix: $d111215002ebbe77$var$commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $d111215002ebbe77$var$number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $d111215002ebbe77$var$number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $d111215002ebbe77$var$number,
        overlineThickness: $d111215002ebbe77$var$number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $d111215002ebbe77$var$number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $d111215002ebbe77$var$spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $d111215002ebbe77$var$number,
        pointsAtY: $d111215002ebbe77$var$number,
        pointsAtZ: $d111215002ebbe77$var$number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $d111215002ebbe77$var$commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $d111215002ebbe77$var$commaOrSpaceSeparated,
        rev: $d111215002ebbe77$var$commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $d111215002ebbe77$var$commaOrSpaceSeparated,
        requiredFeatures: $d111215002ebbe77$var$commaOrSpaceSeparated,
        requiredFonts: $d111215002ebbe77$var$commaOrSpaceSeparated,
        requiredFormats: $d111215002ebbe77$var$commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $d111215002ebbe77$var$number,
        specularExponent: $d111215002ebbe77$var$number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $d111215002ebbe77$var$number,
        strikethroughThickness: $d111215002ebbe77$var$number,
        string: null,
        stroke: null,
        strokeDashArray: $d111215002ebbe77$var$commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $d111215002ebbe77$var$number,
        strokeOpacity: $d111215002ebbe77$var$number,
        strokeWidth: null,
        style: null,
        surfaceScale: $d111215002ebbe77$var$number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $d111215002ebbe77$var$commaOrSpaceSeparated,
        tabIndex: $d111215002ebbe77$var$number,
        tableValues: null,
        target: null,
        targetX: $d111215002ebbe77$var$number,
        targetY: $d111215002ebbe77$var$number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $d111215002ebbe77$var$commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $d111215002ebbe77$var$number,
        underlineThickness: $d111215002ebbe77$var$number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $d111215002ebbe77$var$number,
        values: null,
        vAlphabetic: $d111215002ebbe77$var$number,
        vMathematical: $d111215002ebbe77$var$number,
        vectorEffect: null,
        vHanging: $d111215002ebbe77$var$number,
        vIdeographic: $d111215002ebbe77$var$number,
        version: null,
        vertAdvY: $d111215002ebbe77$var$number,
        vertOriginX: $d111215002ebbe77$var$number,
        vertOriginY: $d111215002ebbe77$var$number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $d111215002ebbe77$var$number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


$34a5aa9c5328a79d$exports = $7d80d4f0495cef02$exports([
    $3926e95d8f92dc65$exports,
    $75a233800c587948$exports,
    $aa9385cba583c934$exports,
    $014ffbb6615f09d3$exports,
    $d111215002ebbe77$exports
]);


var $baee9a79cab95f9e$exports = {};
"use strict";



var $baee9a79cab95f9e$var$data = "data";
$baee9a79cab95f9e$exports = $baee9a79cab95f9e$var$find;
var $baee9a79cab95f9e$var$valid = /^data[-\w.:]+$/i;
var $baee9a79cab95f9e$var$dash = /-[a-z]/g;
var $baee9a79cab95f9e$var$cap = /[A-Z]/g;
function $baee9a79cab95f9e$var$find(schema, value) {
    var normal = $69235c9611e362af$exports(value);
    var prop = value;
    var Type = $3cd17794710d5cad$exports;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $baee9a79cab95f9e$var$data && $baee9a79cab95f9e$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") prop = $baee9a79cab95f9e$var$datasetToProperty(value);
        else value = $baee9a79cab95f9e$var$datasetToAttribute(value);
        Type = $18c096c7cdbeda4b$exports;
    }
    return new Type(prop, value);
}
function $baee9a79cab95f9e$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($baee9a79cab95f9e$var$dash, $baee9a79cab95f9e$var$camelcase);
    return $baee9a79cab95f9e$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $baee9a79cab95f9e$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($baee9a79cab95f9e$var$dash.test(value)) return property;
    value = value.replace($baee9a79cab95f9e$var$cap, $baee9a79cab95f9e$var$kebab);
    if (value.charAt(0) !== "-") value = "-" + value;
    return $baee9a79cab95f9e$var$data + value;
}
function $baee9a79cab95f9e$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
function $baee9a79cab95f9e$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


var $47b23474234e65b9$exports = {};
$47b23474234e65b9$exports = JSON.parse('{"classId":"classID","dataType":"datatype","itemId":"itemID","strokeDashArray":"strokeDasharray","strokeDashOffset":"strokeDashoffset","strokeLineCap":"strokeLinecap","strokeLineJoin":"strokeLinejoin","strokeMiterLimit":"strokeMiterlimit","typeOf":"typeof","xLinkActuate":"xlinkActuate","xLinkArcRole":"xlinkArcrole","xLinkHref":"xlinkHref","xLinkRole":"xlinkRole","xLinkShow":"xlinkShow","xLinkTitle":"xlinkTitle","xLinkType":"xlinkType","xmlnsXLink":"xmlnsXlink"}');


var $d3600c974c0b46e9$exports = {};

$parcel$export($d3600c974c0b46e9$exports, "parse", function () { return $d3600c974c0b46e9$export$98e6a39c04603d36; }, function (v) { return $d3600c974c0b46e9$export$98e6a39c04603d36 = v; });
$parcel$export($d3600c974c0b46e9$exports, "stringify", function () { return $d3600c974c0b46e9$export$fac44ee5b035f737; }, function (v) { return $d3600c974c0b46e9$export$fac44ee5b035f737 = v; });
var $d3600c974c0b46e9$export$98e6a39c04603d36;
var $d3600c974c0b46e9$export$fac44ee5b035f737;
"use strict";
$d3600c974c0b46e9$export$98e6a39c04603d36 = $d3600c974c0b46e9$var$parse;
$d3600c974c0b46e9$export$fac44ee5b035f737 = $d3600c974c0b46e9$var$stringify;
var $d3600c974c0b46e9$var$empty = "";
var $d3600c974c0b46e9$var$space = " ";
var $d3600c974c0b46e9$var$whiteSpace = /[ \t\n\r\f]+/g;
function $d3600c974c0b46e9$var$parse(value) {
    var input = String(value || $d3600c974c0b46e9$var$empty).trim();
    return input === $d3600c974c0b46e9$var$empty ? [] : input.split($d3600c974c0b46e9$var$whiteSpace);
}
function $d3600c974c0b46e9$var$stringify(values) {
    return values.join($d3600c974c0b46e9$var$space).trim();
}


var $726b852568c70b0d$exports = {};

$parcel$export($726b852568c70b0d$exports, "parse", function () { return $726b852568c70b0d$export$98e6a39c04603d36; }, function (v) { return $726b852568c70b0d$export$98e6a39c04603d36 = v; });
$parcel$export($726b852568c70b0d$exports, "stringify", function () { return $726b852568c70b0d$export$fac44ee5b035f737; }, function (v) { return $726b852568c70b0d$export$fac44ee5b035f737 = v; });
var $726b852568c70b0d$export$98e6a39c04603d36;
var $726b852568c70b0d$export$fac44ee5b035f737;
"use strict";
$726b852568c70b0d$export$98e6a39c04603d36 = $726b852568c70b0d$var$parse;
$726b852568c70b0d$export$fac44ee5b035f737 = $726b852568c70b0d$var$stringify;
var $726b852568c70b0d$var$comma = ",";
var $726b852568c70b0d$var$space = " ";
var $726b852568c70b0d$var$empty = "";
// Parse comma-separated tokens to an array.
function $726b852568c70b0d$var$parse(value) {
    var values = [];
    var input = String(value || $726b852568c70b0d$var$empty);
    var index = input.indexOf($726b852568c70b0d$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($726b852568c70b0d$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $726b852568c70b0d$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $726b852568c70b0d$var$empty : $726b852568c70b0d$var$space;
    var right = settings.padRight ? $726b852568c70b0d$var$space : $726b852568c70b0d$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $726b852568c70b0d$var$empty) values = values.concat($726b852568c70b0d$var$empty);
    return values.join(right + $726b852568c70b0d$var$comma + left).trim();
}


var $bd97bb0fa792d4ae$exports = {};
var $0f03aa49cddaf058$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $0f03aa49cddaf058$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $0f03aa49cddaf058$var$NEWLINE_REGEX = /\n/g;
var $0f03aa49cddaf058$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $0f03aa49cddaf058$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $0f03aa49cddaf058$var$COLON_REGEX = /^:\s*/;
var $0f03aa49cddaf058$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $0f03aa49cddaf058$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $0f03aa49cddaf058$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $0f03aa49cddaf058$var$NEWLINE = "\n";
var $0f03aa49cddaf058$var$FORWARD_SLASH = "/";
var $0f03aa49cddaf058$var$ASTERISK = "*";
var $0f03aa49cddaf058$var$EMPTY_STRING = "";
// types
var $0f03aa49cddaf058$var$TYPE_COMMENT = "comment";
var $0f03aa49cddaf058$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $0f03aa49cddaf058$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($0f03aa49cddaf058$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($0f03aa49cddaf058$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($0f03aa49cddaf058$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($0f03aa49cddaf058$var$FORWARD_SLASH != style.charAt(0) || $0f03aa49cddaf058$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($0f03aa49cddaf058$var$EMPTY_STRING != style.charAt(i) && ($0f03aa49cddaf058$var$ASTERISK != style.charAt(i) || $0f03aa49cddaf058$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($0f03aa49cddaf058$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $0f03aa49cddaf058$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($0f03aa49cddaf058$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($0f03aa49cddaf058$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($0f03aa49cddaf058$var$VALUE_REGEX);
        var ret = pos({
            type: $0f03aa49cddaf058$var$TYPE_DECLARATION,
            property: $0f03aa49cddaf058$var$trim(prop[0].replace($0f03aa49cddaf058$var$COMMENT_REGEX, $0f03aa49cddaf058$var$EMPTY_STRING)),
            value: val ? $0f03aa49cddaf058$var$trim(val[0].replace($0f03aa49cddaf058$var$COMMENT_REGEX, $0f03aa49cddaf058$var$EMPTY_STRING)) : $0f03aa49cddaf058$var$EMPTY_STRING
        });
        // ;
        match($0f03aa49cddaf058$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $0f03aa49cddaf058$var$trim(str) {
    return str ? str.replace($0f03aa49cddaf058$var$TRIM_REGEX, $0f03aa49cddaf058$var$EMPTY_STRING) : $0f03aa49cddaf058$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $bd97bb0fa792d4ae$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $0f03aa49cddaf058$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$bd97bb0fa792d4ae$exports = $bd97bb0fa792d4ae$var$StyleToObject;


var $70b74246c1c42bf2$exports = {};
$70b74246c1c42bf2$exports = JSON.parse('{"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}');



var $7MLLw = parcelRequire("7MLLw");
var $8e73584c05f460db$var$root = $7MLLw("root");
var $8e73584c05f460db$var$element = $7MLLw("element");
var $8e73584c05f460db$var$text = $7MLLw("text");
$8e73584c05f460db$exports = $8e73584c05f460db$var$wrapper;
function $8e73584c05f460db$var$wrapper(h, node, options) {
    var settings = options || {};
    var r = $8e73584c05f460db$var$react(h);
    var v = $8e73584c05f460db$var$vue(h);
    var vd = $8e73584c05f460db$var$vdom(h);
    var prefix;
    if (typeof h !== "function") throw new Error("h is not a function");
    if (typeof settings === "string" || typeof settings === "boolean") {
        prefix = settings;
        settings = {};
    } else prefix = settings.prefix;
    if ($8e73584c05f460db$var$root(node)) node = node.children.length === 1 && $8e73584c05f460db$var$element(node.children[0]) ? node.children[0] : {
        type: "element",
        tagName: "div",
        properties: {},
        children: node.children
    };
    else if (!$8e73584c05f460db$var$element(node)) throw new Error("Expected root or element, not `" + (node && node.type || node) + "`");
    return $8e73584c05f460db$var$toH(h, node, {
        schema: settings.space === "svg" ? $34a5aa9c5328a79d$exports : $1d1ab0195d78d073$exports,
        prefix: prefix == null ? r || v || vd ? "h-" : null : prefix,
        key: 0,
        react: r,
        vue: v,
        vdom: vd,
        hyperscript: $8e73584c05f460db$var$hyperscript(h)
    });
}
// Transform a hast node through a hyperscript interface to *anything*!
function $8e73584c05f460db$var$toH(h, node, ctx) {
    var parentSchema = ctx.schema;
    var schema = parentSchema;
    var name = node.tagName;
    var attributes = {};
    var nodes = [];
    var index = -1;
    var key;
    var value;
    if (parentSchema.space === "html" && name.toLowerCase() === "svg") {
        schema = $34a5aa9c5328a79d$exports;
        ctx.schema = schema;
    }
    for(key in node.properties)$8e73584c05f460db$var$addAttribute(attributes, key, node.properties[key], ctx, name);
    if (ctx.vdom) {
        if (schema.space === "html") name = name.toUpperCase();
        else attributes.namespace = $70b74246c1c42bf2$exports[schema.space];
    }
    if (ctx.prefix) {
        ctx.key++;
        attributes.key = ctx.prefix + ctx.key;
    }
    if (node.children) while(++index < node.children.length){
        value = node.children[index];
        if ($8e73584c05f460db$var$element(value)) nodes.push($8e73584c05f460db$var$toH(h, value, ctx));
        else if ($8e73584c05f460db$var$text(value)) nodes.push(value.value);
    }
    // Restore parent schema.
    ctx.schema = parentSchema;
    // Ensure no React warnings are triggered for void elements having children
    // passed in.
    return nodes.length ? h.call(node, name, attributes, nodes) : h.call(node, name, attributes);
}
function $8e73584c05f460db$var$addAttribute(props, prop, value, ctx, name) {
    var info = $baee9a79cab95f9e$exports(ctx.schema, prop);
    var subprop;
    // Ignore nullish and `NaN` values.
    // Ignore `false` and falsey known booleans for hyperlike DSLs.
    if (value == null || value !== value || value === false && (ctx.vue || ctx.vdom || ctx.hyperscript) || !value && info.boolean && (ctx.vue || ctx.vdom || ctx.hyperscript)) return;
    if (value && typeof value === "object" && "length" in value) // Accept `array`.
    // Most props are space-separated.
    value = (info.commaSeparated ? $726b852568c70b0d$exports : $d3600c974c0b46e9$exports).stringify(value);
    // Treat `true` and truthy known booleans.
    if (info.boolean && ctx.hyperscript) value = "";
    // VDOM, Vue, and React accept `style` as object.
    if (info.property === "style" && typeof value === "string" && (ctx.react || ctx.vue || ctx.vdom)) value = $8e73584c05f460db$var$parseStyle(value, name);
    if (ctx.vue) {
        if (info.property !== "style") subprop = "attrs";
    } else if (!info.mustUseProperty) {
        if (ctx.vdom) {
            if (info.property !== "style") subprop = "attributes";
        } else if (ctx.hyperscript) subprop = "attrs";
    }
    if (subprop) {
        if (!props[subprop]) props[subprop] = {};
        props[subprop][info.attribute] = value;
    } else if (info.space && ctx.react) props[$47b23474234e65b9$exports[info.property] || info.property] = value;
    else props[info.attribute] = value;
}
// Check if `h` is `react.createElement`.
function $8e73584c05f460db$var$react(h) {
    var node = h && h("div");
    return Boolean(node && ("_owner" in node || "_store" in node) && node.key == null);
}
// Check if `h` is `hyperscript`.
function $8e73584c05f460db$var$hyperscript(h) {
    return Boolean(h && h.context && h.cleanup);
}
// Check if `h` is `virtual-dom/h`.
function $8e73584c05f460db$var$vdom(h) {
    return h && h("div").type === "VirtualNode";
}
function $8e73584c05f460db$var$vue(h) {
    var node = h && h("div");
    return Boolean(node && node.context && node.context._isVue);
}
function $8e73584c05f460db$var$parseStyle(value, tagName) {
    var result = {};
    try {
        $bd97bb0fa792d4ae$exports(value, iterator);
    } catch (error) {
        error.message = tagName + "[style]" + error.message.slice(9);
        throw error;
    }
    return result;
    function iterator(name, value) {
        if (name.slice(0, 4) === "-ms-") name = "ms-" + name.slice(4);
        result[name.replace(/-([a-z])/g, $8e73584c05f460db$var$styleReplacer)] = value;
    }
}
function $8e73584c05f460db$var$styleReplacer($0, $1) {
    return $1.toUpperCase();
}


var $7c3a4736923c1df2$exports = {};
"use strict";
var $797757b0e14c5ed0$exports = {};
"use strict";
$797757b0e14c5ed0$exports = $797757b0e14c5ed0$var$visit;
var $057938910b8746d3$exports = {};
"use strict";
$057938910b8746d3$exports = $057938910b8746d3$var$visitParents;
var $2990dd3ba53b77bc$exports = {};
"use strict";
$2990dd3ba53b77bc$exports = $2990dd3ba53b77bc$var$convert;
function $2990dd3ba53b77bc$var$convert(test) {
    if (typeof test === "string") return $2990dd3ba53b77bc$var$typeFactory(test);
    if (test === null || test === undefined) return $2990dd3ba53b77bc$var$ok;
    if (typeof test === "object") return ("length" in test ? $2990dd3ba53b77bc$var$anyFactory : $2990dd3ba53b77bc$var$matchesFactory)(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
function $2990dd3ba53b77bc$var$convertAll(tests) {
    var results = [];
    var length = tests.length;
    var index = -1;
    while(++index < length)results[index] = $2990dd3ba53b77bc$var$convert(tests[index]);
    return results;
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $2990dd3ba53b77bc$var$matchesFactory(test) {
    return matches;
    function matches(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $2990dd3ba53b77bc$var$anyFactory(tests) {
    var checks = $2990dd3ba53b77bc$var$convertAll(tests);
    var length = checks.length;
    return matches;
    function matches() {
        var index = -1;
        while(++index < length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $2990dd3ba53b77bc$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $2990dd3ba53b77bc$var$ok() {
    return true;
}


var $057938910b8746d3$var$CONTINUE = true;
var $057938910b8746d3$var$SKIP = "skip";
var $057938910b8746d3$var$EXIT = false;
$057938910b8746d3$var$visitParents.CONTINUE = $057938910b8746d3$var$CONTINUE;
$057938910b8746d3$var$visitParents.SKIP = $057938910b8746d3$var$SKIP;
$057938910b8746d3$var$visitParents.EXIT = $057938910b8746d3$var$EXIT;
function $057938910b8746d3$var$visitParents(tree, test, visitor, reverse) {
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $2990dd3ba53b77bc$exports(test);
    one(tree, null, []);
    // Visit a single node.
    function one(node, index, parents) {
        var result = [];
        var subresult;
        if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = $057938910b8746d3$var$toResult(visitor(node, parents));
            if (result[0] === $057938910b8746d3$var$EXIT) return result;
        }
        if (node.children && result[0] !== $057938910b8746d3$var$SKIP) {
            subresult = $057938910b8746d3$var$toResult(all(node.children, parents.concat(node)));
            return subresult[0] === $057938910b8746d3$var$EXIT ? subresult : result;
        }
        return result;
    }
    // Visit children in `parent`.
    function all(children, parents) {
        var min = -1;
        var step = reverse ? -1 : 1;
        var index = (reverse ? children.length : min) + step;
        var result;
        while(index > min && index < children.length){
            result = one(children[index], index, parents);
            if (result[0] === $057938910b8746d3$var$EXIT) return result;
            index = typeof result[1] === "number" ? result[1] : index + step;
        }
    }
}
function $057938910b8746d3$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $057938910b8746d3$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}


var $797757b0e14c5ed0$var$CONTINUE = $057938910b8746d3$exports.CONTINUE;
var $797757b0e14c5ed0$var$SKIP = $057938910b8746d3$exports.SKIP;
var $797757b0e14c5ed0$var$EXIT = $057938910b8746d3$exports.EXIT;
$797757b0e14c5ed0$var$visit.CONTINUE = $797757b0e14c5ed0$var$CONTINUE;
$797757b0e14c5ed0$var$visit.SKIP = $797757b0e14c5ed0$var$SKIP;
$797757b0e14c5ed0$var$visit.EXIT = $797757b0e14c5ed0$var$EXIT;
function $797757b0e14c5ed0$var$visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $057938910b8746d3$exports(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}


var $7c3a4736923c1df2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $7c3a4736923c1df2$var$hastCssPropertyMap = {
    align: "text-align",
    valign: "vertical-align",
    height: "height",
    width: "width"
};
$7c3a4736923c1df2$exports = function tableCellStyle(node) {
    $797757b0e14c5ed0$exports(node, "element", $7c3a4736923c1df2$var$visitor);
    return node;
};
function $7c3a4736923c1df2$var$visitor(node) {
    if (node.tagName !== "tr" && node.tagName !== "td" && node.tagName !== "th") return;
    var hastName;
    var cssName;
    for(hastName in $7c3a4736923c1df2$var$hastCssPropertyMap){
        if (!$7c3a4736923c1df2$var$hasOwnProperty.call($7c3a4736923c1df2$var$hastCssPropertyMap, hastName) || node.properties[hastName] === undefined) continue;
        cssName = $7c3a4736923c1df2$var$hastCssPropertyMap[hastName];
        $7c3a4736923c1df2$var$appendStyle(node, cssName, node.properties[hastName]);
        delete node.properties[hastName];
    }
}
function $7c3a4736923c1df2$var$appendStyle(node, property, value) {
    var prevStyle = (node.properties.style || "").trim();
    if (prevStyle && !/;\s*/.test(prevStyle)) prevStyle += ";";
    if (prevStyle) prevStyle += " ";
    var nextStyle = prevStyle + property + ": " + value + ";";
    node.properties.style = nextStyle;
}


$04ee50b1804dcfa6$exports = $04ee50b1804dcfa6$var$rehypeReact;
var $04ee50b1804dcfa6$var$own = {}.hasOwnProperty;
var $04ee50b1804dcfa6$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr",
    "th",
    "td"
]);
// Add a React compiler.
function $04ee50b1804dcfa6$var$rehypeReact(options) {
    var settings = options || {};
    var createElement = settings.createElement;
    this.Compiler = compiler;
    function compiler(node) {
        var result = $8e73584c05f460db$exports(h, $7c3a4736923c1df2$exports(node), settings.prefix);
        if (node.type === "root") {
            // Invert <https://github.com/syntax-tree/hast-to-hyperscript/blob/d227372/index.js#L46-L56>.
            result = result.type === "div" && (node.children.length !== 1 || node.children[0].type !== "element") ? result.props.children : [
                result
            ];
            return createElement(settings.Fragment || "div", {}, result);
        }
        return result;
    }
    // Wrap `createElement` to pass components in.
    function h(name, props, children) {
        var component = name;
        // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we remove the pretty lines for now.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        if (children && $04ee50b1804dcfa6$var$tableElements.has(name)) children = children.filter(function(child) {
            return child !== "\n";
        });
        if (settings.components && $04ee50b1804dcfa6$var$own.call(settings.components, name)) {
            component = settings.components[name];
            if (settings.passNode) props.node = this;
        }
        return createElement(component, props, children);
    }
}


function $a7fc90c90f223aea$var$_extends() {
    $a7fc90c90f223aea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a7fc90c90f223aea$var$_extends.apply(this, arguments);
}
function $a7fc90c90f223aea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a7fc90c90f223aea$var$_excluded = [
    "children"
];
var $a7fc90c90f223aea$export$a4652479f83b55e3 = function useRemarkSync(source, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, remarkParseOptions = _ref.remarkParseOptions, remarkToRehypeOptions = _ref.remarkToRehypeOptions, rehypeReactOptions = _ref.rehypeReactOptions, _ref$remarkPlugins = _ref.remarkPlugins, remarkPlugins = _ref$remarkPlugins === void 0 ? [] : _ref$remarkPlugins, _ref$rehypePlugins = _ref.rehypePlugins, rehypePlugins = _ref$rehypePlugins === void 0 ? [] : _ref$rehypePlugins;
    return (0, (/*@__PURE__*/$parcel$interopDefault($408348b5067297f8$exports)))().use((0, (/*@__PURE__*/$parcel$interopDefault($3da447a868c6e2f7$exports))), remarkParseOptions).use(remarkPlugins).use((0, (/*@__PURE__*/$parcel$interopDefault($b370febd9318b830$exports))), remarkToRehypeOptions).use(rehypePlugins).use((0, (/*@__PURE__*/$parcel$interopDefault($04ee50b1804dcfa6$exports))), $a7fc90c90f223aea$var$_extends({
        createElement: (0, $4Iuzv.createElement),
        Fragment: (0, $4Iuzv.Fragment)
    }, rehypeReactOptions)).processSync(source).result;
};
var $a7fc90c90f223aea$export$7df5abb26bb177c1 = function useRemark(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, remarkParseOptions = _ref2.remarkParseOptions, remarkToRehypeOptions = _ref2.remarkToRehypeOptions, rehypeReactOptions = _ref2.rehypeReactOptions, _ref2$remarkPlugins = _ref2.remarkPlugins, remarkPlugins = _ref2$remarkPlugins === void 0 ? [] : _ref2$remarkPlugins, _ref2$rehypePlugins = _ref2.rehypePlugins, rehypePlugins = _ref2$rehypePlugins === void 0 ? [] : _ref2$rehypePlugins, _ref2$onError = _ref2.onError, onError = _ref2$onError === void 0 ? function() {} : _ref2$onError;
    var _useState = (0, $4Iuzv.useState)(null), reactContent = _useState[0], setReactContent = _useState[1];
    var setMarkdownSource = (0, $4Iuzv.useCallback)(function(source) {
        (0, (/*@__PURE__*/$parcel$interopDefault($408348b5067297f8$exports)))().use((0, (/*@__PURE__*/$parcel$interopDefault($3da447a868c6e2f7$exports))), remarkParseOptions).use(remarkPlugins).use((0, (/*@__PURE__*/$parcel$interopDefault($b370febd9318b830$exports))), remarkToRehypeOptions).use(rehypePlugins).use((0, (/*@__PURE__*/$parcel$interopDefault($04ee50b1804dcfa6$exports))), $a7fc90c90f223aea$var$_extends({
            createElement: (0, $4Iuzv.createElement),
            Fragment: (0, $4Iuzv.Fragment)
        }, rehypeReactOptions)).process(source).then(function(vfile) {
            return setReactContent(vfile.result);
        })["catch"](onError);
    }, []);
    return [
        reactContent,
        setMarkdownSource
    ];
};
var $a7fc90c90f223aea$export$21212e7778d9e5ba = function Remark(_ref3) {
    var children = _ref3.children, useRemarkOptions = $a7fc90c90f223aea$var$_objectWithoutPropertiesLoose(_ref3, $a7fc90c90f223aea$var$_excluded);
    var _useRemark = $a7fc90c90f223aea$export$7df5abb26bb177c1(useRemarkOptions), reactContent = _useRemark[0], setMarkdownSource = _useRemark[1];
    (0, $4Iuzv.useEffect)(function() {
        setMarkdownSource(children);
    }, [
        children,
        setMarkdownSource
    ]);
    return reactContent;
};


function $a625e5305397e1e0$export$9426763fa11b144e({ delegate: delegate, open: open, onClose: onClose, children: children }) {
    const { address: address, manifesto: manifesto, name: name } = delegate;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7b51a257e986fbd2$export$2b77a92f1a5ad772), {
        size: "md",
        open: open,
        onClose: ()=>onClose(),
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex max-h-[90vh] w-full flex-col gap-12 p-4 md:p-12",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex h-full flex-col items-start justify-start gap-6 overflow-hidden ",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "flex items-start justify-between",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-xl capitalize",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                                        address: address,
                                        size: 24,
                                        textClassName: "font-semibold my-2",
                                        copy: true
                                    })
                                ]
                            })
                        }),
                        manifesto && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: `relative h-full overflow-auto text-base`,
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a7fc90c90f223aea$export$21212e7778d9e5ba), {
                                children: manifesto
                            })
                        })
                    ]
                }),
                children
            ]
        })
    });
}







var $4Iuzv = parcelRequire("4Iuzv");

const $7a91c664dd3fa463$var$EllipsisTextbox = ({ text: text, expandLinkTitle: expandLinkTitle, className: className })=>{
    const containerRef = (0, $4Iuzv.useRef)(null);
    const [isOverflowed, setIsOverflowed] = (0, $4Iuzv.useState)(false);
    const scrollHeight = containerRef.current?.scrollHeight;
    const clientHeight = containerRef.current?.clientHeight;
    (0, $4Iuzv.useEffect)(()=>{
        if (scrollHeight !== undefined && clientHeight !== undefined) setIsOverflowed(scrollHeight > clientHeight);
    }, [
        scrollHeight,
        clientHeight
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            tabIndex: -1,
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: `overflow-hidden text-ellipsis text-body-2 md:text-body ${isOverflowed ? "cursor-pointer" : ""} ${className}`,
                    ref: containerRef,
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a7fc90c90f223aea$export$21212e7778d9e5ba), {
                        children: text
                    })
                }),
                isOverflowed && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "mt-2 w-full text-primary",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "cursor-pointer",
                        children: expandLinkTitle
                    })
                })
            ]
        })
    });
};
var $7a91c664dd3fa463$export$2e2bcd8739ae039 = $7a91c664dd3fa463$var$EllipsisTextbox;






var $7aRnb = parcelRequire("7aRnb");

var $4Iuzv = parcelRequire("4Iuzv");












function $37fd5f9b026a9eee$export$49bc501e2d4eb5e2({ delegate: delegate, selectedTracks: selectedTracks, open: open, onClose: onClose }) {
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { connectedAccount: connectedAccount } = (0, $47acec667174acda$export$83a8e409853da004)();
    const { clearTrackSelection: clearTrackSelection, scrollToSection: scrollToSection } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    const [usableBalance, setUsableBalance] = (0, $4Iuzv.useState)();
    const [fee, setFee] = (0, $4Iuzv.useState)();
    const balance = (0, $ff275152c44ce822$export$9c0e4d1c0409ad69)(state);
    const { unit: unit, decimals: decimals } = (0, $ff275152c44ce822$export$4a6dbf642db5266c)(state) || {};
    const delegateAddress = typeof delegate === "object" ? delegate.address : delegate;
    const name = typeof delegate === "object" ? delegate.name : null;
    const connectedAddress = connectedAccount?.account?.address;
    const conviction = (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).None;
    // set fee and balance
    (0, $4Iuzv.useEffect)(()=>{
        if (open && delegateAddress && connectedAddress && balance && selectedTracks.length > 0) {
            const getFees = async ()=>{
                const selectedTrackIds = selectedTracks.map((track)=>track.id);
                const allTrackIds = Array.from((0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).keys());
                const [delegateSelectedFee, undelegateAllFee] = await Promise.all([
                    updater.delegateFee(connectedAddress, delegateAddress, selectedTrackIds, balance, conviction),
                    updater.undelegateFee(connectedAddress, allTrackIds)
                ]);
                const usableBalance = delegateSelectedFee && undelegateAllFee && (0, $526c1cdc475b977f$export$4c62941f84ce88)(balance, delegateSelectedFee, undelegateAllFee);
                return {
                    fee: delegateSelectedFee,
                    usableBalance: usableBalance
                };
            };
            getFees().then(({ fee: fee, usableBalance: usableBalance })=>{
                setFee(fee);
                setUsableBalance(usableBalance);
            });
        }
    }, [
        open,
        delegateAddress,
        connectedAddress,
        JSON.stringify(balance),
        JSON.stringify(selectedTracks)
    ]);
    const cancelHandler = ()=>onClose();
    const delegateHandler = async ({ account: { address: address }, signer: signer }, amount)=>{
        try {
            const trackIds = selectedTracks.map((track)=>track.id);
            const tx = await updater.delegate(delegateAddress, trackIds, amount, conviction);
            if (tx.type === "ok") {
                let before = Date.now();
                await (0, $526c1cdc475b977f$export$c52e4b551c4ab930)(address, {
                    signer: signer,
                    nonce: -1
                }, tx.value, async (result, unsub)=>{
                    console.debug(`Tx update: ${JSON.stringify(result)}`);
                    const { status: status, dispatchError: dispatchError } = result;
                    if (status.isReady) before = Date.now();
                    updater.handleCallResult(unsub, status, dispatchError);
                    if (status.isInBlock) {
                        clearTrackSelection();
                        scrollToSection("top");
                        if (!dispatchError) {
                            const duration = (Date.now() - before).toString();
                            (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Delegate", {
                                duration: duration,
                                address: address,
                                amount: amount.toString(),
                                tracks: trackIds.map((i)=>i.toString()).join(",")
                            });
                            (0, (/*@__PURE__*/$parcel$interopDefault($7aRnb))).confetti(document.body, {
                                count: (0, (/*@__PURE__*/$parcel$interopDefault($7aRnb))).variation.range(20, 40)
                            });
                            console.debug(`Delegation in block after ${duration} ms`);
                            const votings = new Map();
                            trackIds.forEach((trackId)=>votings.set(trackId, (0, $86de7a8a6ebe9447$export$390edb77df1bcd07)(amount, delegateAddress, conviction)));
                            await updater.addVotings(votings);
                        }
                    }
                });
                updater.setProcessingReport({
                    isTransient: false,
                    message: "The transaction has been sent"
                });
            } else updater.addReport({
                type: "Error",
                message: tx.error.message
            });
        } catch (e) {
            console.debug("Failed to send the transaction", e);
            updater.addReport({
                type: "Error",
                message: `Failed to send the transaction: ${e}`
            });
        } finally{
            // close modal
            onClose();
        }
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7b51a257e986fbd2$export$2b77a92f1a5ad772), {
        size: "md",
        open: open,
        onClose: ()=>onClose(),
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex w-full flex-col gap-12 p-4 md:p-12",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex flex-col items-start justify-start gap-6 ",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "text-left",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                    className: "mb-2 text-3xl font-medium",
                                    children: "Summary"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                    className: "text-base",
                                    children: [
                                        "Submitting this transaction will delegate your voting power to",
                                        " ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("b", {
                                            children: name || delegateAddress
                                        }),
                                        " for the following tracks:"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "grid w-full grid-cols-3 grid-rows-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                    className: "col-span-2",
                                    title: "Tracks to delegate",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$321a3a223c3064d2), {
                                        allTracksCount: (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).size,
                                        tracks: selectedTracks,
                                        visibleCount: 2
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                    title: "Tokens to delegate",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$2285b2873bbd5ff7), {
                                        balance: usableBalance,
                                        decimals: decimals,
                                        unit: unit
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                    className: "col-span-2",
                                    title: "Your delegate",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "flex gap-2",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                                            textClassName: "font-medium",
                                            address: delegateAddress,
                                            size: 24,
                                            copy: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                    title: "Conviction",
                                    tooltipContent: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                        children: [
                                            "No conviction means your tokens are only locked while they are delegated. ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                            " Once you unlock them, you can use them again.",
                                            " "
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        children: (0, $526c1cdc475b977f$export$121bfd3c744d638e)(conviction)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("hr", {
                            className: "w-full bg-gray-400"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                title: "Delegation fee (one time)",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$2285b2873bbd5ff7), {
                                    balance: fee,
                                    decimals: decimals,
                                    unit: unit
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex w-full flex-row justify-end gap-4",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                            onClick: cancelHandler,
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$cae179f078f4b4a4), {}),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    children: "Cancel"
                                })
                            ]
                        }),
                        connectedAddress ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                            variant: "primary",
                            onClick: ()=>connectedAccount && usableBalance && delegateHandler(connectedAccount, usableBalance),
                            disabled: !connectedAccount || !usableBalance?.gtn(0),
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    children: !usableBalance?.gtn(0) ? "Insufficient tokens to delegate" : "Delegate now"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$b837bd7eac09a33e), {})
                            ]
                        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $380529cee7df9747$export$79b5060180039794), {})
                    ]
                })
            ]
        })
    });
}





function $02a4c318ea9c42fd$var$retainByIndex(map, indexes) {
    const newMap = new Map();
    indexes.forEach((index)=>newMap.set(index, map.get(index)));
    return newMap;
}
function $02a4c318ea9c42fd$var$DelegatedTracks({ disabled: disabled, allTracksCount: allTracksCount, tracks: tracks, delegate: delegate }) {
    const [showModal, setShowModal] = (0, $4Iuzv.useState)(false);
    const closeModal = ()=>{
        setShowModal(false);
    };
    const openModal = ()=>{
        setShowModal(true);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $081397004471dc15$export$75d8f5b437e63034), {
                className: "gap-2 bg-[#FFE4F3]",
                children: [
                    tracks.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                        title: "Tracks delegated",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$321a3a223c3064d2), {
                            allTracksCount: allTracksCount,
                            tracks: tracks,
                            visibleCount: 2
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        disabled: disabled,
                        onClick: (e)=>{
                            openModal();
                            e.stopPropagation();
                        },
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$cae179f078f4b4a4), {}),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                children: "Undelegate All"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $bf67e73480b6f731$export$e2481bc30224d09b), {
                onClose: closeModal,
                open: showModal,
                tracks: tracks,
                address: delegate.address
            })
        ]
    });
}
function $02a4c318ea9c42fd$export$8b45b31ba7d26d1c({ delegate: delegate, state: state, delegatedTracks: delegatedTracks = [], variant: variant, className: className }) {
    const { name: name, address: address, manifesto: manifesto } = delegate;
    const isProcessing = (0, $ff275152c44ce822$export$f21bf6b1fa1004ea)(state);
    const { connectedAccount: connectedAccount } = (0, $47acec667174acda$export$83a8e409853da004)();
    const [txVisible, setTxVisible] = (0, $4Iuzv.useState)(false);
    const [infoVisible, setInfoVisible] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $175a2504a1bf07a5$export$9770f232ac06a008)();
    const connectedAddress = connectedAccount?.account?.address;
    // transaction Modal handlers
    const closeTxModal = ()=>{
        setTxVisible(false);
    };
    const openTxModal = ()=>{
        setTxVisible(true);
    };
    const delegateHandler = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        openTxModal();
        setInfoVisible(false); //have to close info modal to make tx modal visible - not ideal, should be replacing content within 1 modal
        (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("Click", {
            target: "Delegate",
            variant: variant
        });
    };
    // more info Modal handlers
    const closeInfoModal = ()=>{
        setInfoVisible(false);
    };
    // extract tracks yet to be delegated
    const { selectedTrackIndexes: selectedTrackIndexes } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    const allTracks = (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks);
    const allSelectedTracks = $02a4c318ea9c42fd$var$retainByIndex(allTracks, Array.from(selectedTrackIndexes.keys()));
    // If variant is 'all', select all not yet delegated tracks. If not, rely on current selection
    const selectedTracks = (0, $ff275152c44ce822$export$950bf1eaf02906d4)(state, variant === "all" ? allTracks : allSelectedTracks);
    const navigationTarget = `/${address}`;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `flex min-h-full shrink-0  ${className} ${variant === "all" ? "w-[320px] md:w-[420px]" : "w-full"}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b97b7432295b195f$export$60332b2344f7fe41), {
                className: ` shadow-sd flex w-full flex-col gap-2 p-6 md:gap-4`,
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                        to: navigationTarget,
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex cursor-pointer items-start justify-between",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                            className: "text-xl capitalize",
                                            children: name || "Anonymous"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                                            address: address,
                                            size: 24,
                                            textClassName: "text-body font-semibold my-2"
                                        })
                                    ]
                                }),
                                variant === "some" && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                                    onClick: delegateHandler,
                                    disabled: isProcessing,
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex w-full flex-nowrap items-center justify-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                children: "Select"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$b837bd7eac09a33e), {})
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    manifesto && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        onClick: ()=>navigate(navigationTarget),
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7a91c664dd3fa463$export$2e2bcd8739ae039), {
                            className: "max-h-[6rem] lg:h-[6rem]",
                            text: manifesto,
                            expandLinkTitle: "Read more ->"
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "grow"
                    }),
                    delegatedTracks.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($02a4c318ea9c42fd$var$DelegatedTracks, {
                        disabled: isProcessing,
                        allTracksCount: (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).size,
                        delegate: delegate,
                        tracks: delegatedTracks
                    }),
                    variant === "all" && (connectedAddress ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: delegateHandler,
                        disabled: isProcessing,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                children: "Delegate all tracks"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$27367e37ecc5fa05), {})
                        ]
                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $380529cee7df9747$export$79b5060180039794), {}))
                ]
            }),
            txVisible && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37fd5f9b026a9eee$export$49bc501e2d4eb5e2), {
                open: txVisible,
                onClose: closeTxModal,
                delegate: delegate,
                selectedTracks: selectedTracks
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a625e5305397e1e0$export$9426763fa11b144e), {
                open: infoVisible,
                onClose: closeInfoModal,
                delegate: delegate,
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                    className: "w-fit",
                    onClick: delegateHandler,
                    disabled: isProcessing,
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex w-full flex-nowrap items-center justify-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                children: "Select"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$b837bd7eac09a33e), {})
                        ]
                    })
                })
            })
        ]
    });
}






var $4Iuzv = parcelRequire("4Iuzv");




function $0614e03e80daf747$export$d375e7057784ba03({ open: open, onAddressValidated: onAddressValidated, onClose: onClose }) {
    const { updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const [address, setAddress] = (0, $4Iuzv.useState)();
    const cancelHandler = ()=>onClose();
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7b51a257e986fbd2$export$2b77a92f1a5ad772), {
        size: "md",
        open: open,
        onClose: ()=>onClose(),
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex w-full flex-col gap-12 p-4 md:p-12",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex flex-col items-start justify-start gap-6",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "text-left",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                    className: "mb-2 text-3xl font-medium",
                                    children: "Add a delegate"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-base",
                                    children: "Don't see your delegate in the list? No problem, add them below."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex w-full flex-col",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                                    htmlFor: "address",
                                    className: "flex items-center py-2 text-sm",
                                    children: "Delegate Address"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                                    id: "address",
                                    placeholder: "Polkadot Address",
                                    className: "w-full self-stretch rounded-lg bg-[#ebeaea] px-4 py-2 text-left text-sm text-black opacity-70",
                                    onChange: (event)=>setAddress(event.target.value)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex w-full flex-row justify-end gap-4",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                            onClick: cancelHandler,
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$cae179f078f4b4a4), {}),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                            onClick: ()=>{
                                if (address) {
                                    onAddressValidated(address);
                                    updater.addCustomDelegate({
                                        address: address
                                    });
                                }
                            },
                            disabled: !(address && (0, $526c1cdc475b977f$export$1987372119294ebb)(address)),
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    children: "Add delegate"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$b837bd7eac09a33e), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
}





function $e8cb6ed9cb30ec88$var$filterVisibleDelegates(delegates) {
    return new Array(...delegates).sort(()=>0.5 - Math.random());
}
function $e8cb6ed9cb30ec88$export$14877970f9c0e5bd({ state: state, delegates: delegates }) {
    const visibleDelegates = (0, $4Iuzv.useMemo)(()=>$e8cb6ed9cb30ec88$var$filterVisibleDelegates(delegates), [
        delegates
    ]);
    const [addAddressVisible, setAddAddressVisible] = (0, $4Iuzv.useState)(false);
    const [delegateVisible, setDelegateVisible] = (0, $4Iuzv.useState)(false);
    const [delegate, setDelegate] = (0, $4Iuzv.useState)("");
    const { selectedTrackIndexes: selectedTrackIndexes } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    const allTracks = (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks);
    const selectedTracks = Array.from(selectedTrackIndexes.entries()).map(([id])=>allTracks.get(id));
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        className: `flex w-full flex-col items-center justify-center gap-6 bg-gray-200 py-8 ${visibleDelegates.length > 0 ? "md:gap-12" : "md:gap-6"}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex w-full justify-between gap-0 px-6",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "w-24"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "px-3 font-unbounded text-h4",
                        children: "Delegate all votes to an expert"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: "w-fit",
                        onClick: ()=>setAddAddressVisible(true),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$a6b7c34d56975de0), {}),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "whitespace-nowrap",
                                children: "Add a delegate"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "flex max-w-full snap-x scroll-pl-6 gap-7 overflow-x-auto px-3 pb-1 lg:px-6 ",
                children: visibleDelegates.length > 0 ? visibleDelegates.map((delegate, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $02a4c318ea9c42fd$export$8b45b31ba7d26d1c), {
                        className: "snap-start",
                        delegate: delegate,
                        state: state,
                        variant: "all"
                    }, idx)) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "text-body-2 text-fg-disabled",
                    children: "Failed to fetch delegates."
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0614e03e80daf747$export$d375e7057784ba03), {
                open: addAddressVisible,
                onClose: ()=>setAddAddressVisible(false),
                onAddressValidated: (address)=>{
                    setDelegate(address);
                    setAddAddressVisible(false);
                    setDelegateVisible(true);
                }
            }),
            delegateVisible && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37fd5f9b026a9eee$export$49bc501e2d4eb5e2), {
                open: delegateVisible,
                onClose: ()=>setDelegateVisible(false),
                delegate: delegate,
                selectedTracks: selectedTracks
            })
        ]
    });
}





const $57cc1ae6399b7e9c$export$c3d606494c505e29 = ({ state: state, delegatesWithTracks: delegatesWithTracks })=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex w-full snap-start flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $384a056e5ce27cd7$export$2e2bcd8739ae039), {
                    title: "Active Delegates"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "px-3 pb-2 lg:px-8",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "grid grid-cols-1 place-items-center  gap-2 md:grid-cols-2 lg:grid-cols-3 lg:gap-4",
                        children: Array.from(delegatesWithTracks.entries()).map(([delegate, delegatedTracks], idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $02a4c318ea9c42fd$export$8b45b31ba7d26d1c), {
                                delegate: delegate,
                                delegatedTracks: delegatedTracks,
                                state: state,
                                variant: "none"
                            }, idx))
                    })
                })
            ]
        })
    });
};




var $4Iuzv = parcelRequire("4Iuzv");









const $834d68cc475258da$export$b57a26af1404503a = ({ state: state, delegates: delegates })=>{
    const [search, setSearch] = (0, $4Iuzv.useState)();
    const [addAddressVisible, setAddAddressVisible] = (0, $4Iuzv.useState)(false);
    const [delegateVisible, setDelegateVisible] = (0, $4Iuzv.useState)(false);
    const [delegate, setDelegate] = (0, $4Iuzv.useState)("");
    const { selectedTrackIndexes: selectedTrackIndexes } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    const allTracks = (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks);
    const selectedTracks = Array.from(selectedTrackIndexes.entries()).map(([id])=>allTracks.get(id));
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex w-full flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $384a056e5ce27cd7$export$2e2bcd8739ae039), {
                        title: "Browse Delegates",
                        description: delegates.length > 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                            children: [
                                "There are currently ",
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("b", {
                                    children: delegates.length
                                }),
                                " delegates."
                            ]
                        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                            className: "text-fg-disabled",
                            children: "Failed to fetch delegates."
                        }),
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $021483ab580d6bff$export$2e2bcd8739ae039), {
                            step: 1
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex flex-col gap-12",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "sticky flex w-full flex-col items-center justify-between gap-4 bg-bg-default/80 px-3 py-3 backdrop-blur-sm md:flex-row lg:top-44 lg:px-8",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex w-full flex-row items-center justify-between gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                                            variant: "ghost",
                                            className: "w-fit",
                                            onClick: ()=>setAddAddressVisible(true),
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$a6b7c34d56975de0), {}),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "whitespace-nowrap",
                                                    children: "Add a delegate"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                                            placeholder: "Search",
                                            className: "w-full self-stretch rounded-lg bg-[#ebeaea] px-4 py-2 text-left text-sm text-black opacity-70 lg:w-fit",
                                            onChange: (event)=>setSearch(event.target.value)
                                        })
                                    ]
                                })
                            }),
                            state.customDelegates?.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col gap-4 px-3 lg:px-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "text-sm",
                                        children: "Added manually"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "grid grid-cols-1 place-items-center  gap-2 md:grid-cols-2 lg:grid-cols-3 lg:gap-4",
                                        children: state.customDelegates.map((delegate, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $02a4c318ea9c42fd$export$8b45b31ba7d26d1c), {
                                                delegate: delegate,
                                                state: state,
                                                variant: "some"
                                            }, idx))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    state.customDelegates?.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "px-3 text-sm lg:px-8",
                                        children: "Public Delegates"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "grid grid-cols-1 place-items-center gap-2 px-3 md:grid-cols-2 lg:grid-cols-3 lg:gap-4 lg:px-8",
                                        children: delegates.filter((delegate)=>search ? delegate.name?.toLowerCase().includes(search.toLowerCase()) : true).map((delegate, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $02a4c318ea9c42fd$export$8b45b31ba7d26d1c), {
                                                delegate: delegate,
                                                state: state,
                                                variant: "some"
                                            }, idx))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0614e03e80daf747$export$d375e7057784ba03), {
                open: addAddressVisible,
                onClose: ()=>setAddAddressVisible(false),
                onAddressValidated: (address)=>{
                    setDelegate(address);
                    setAddAddressVisible(false);
                    setDelegateVisible(true);
                }
            }),
            delegateVisible && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37fd5f9b026a9eee$export$49bc501e2d4eb5e2), {
                open: delegateVisible,
                onClose: ()=>setDelegateVisible(false),
                delegate: delegate,
                selectedTracks: selectedTracks
            })
        ]
    });
};


function $85d4094de36eb8bc$export$cae179f078f4b4a4() {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 29 29",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("path", {
            d: "M4.893 4.231l19.799 19.8M24.692 4.231l-19.8 19.8",
            "data-nofill": "true"
        })
    });
}
function $85d4094de36eb8bc$var$exportReferenda(state) {
    if (state.type === "ConnectedState") return (0, $ff275152c44ce822$export$8c9f51735fe4c232)(state.chain.referenda);
    return new Map();
}
function $85d4094de36eb8bc$export$c1e5ff2d5ab163a0({ headlineVisible: headlineVisible, setHeadlineVisible: setHeadlineVisible }) {
    const { state: state } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { delegates: delegates } = state;
    // A map of delegates with asociated tracks. Empty if no tracks are currently delegated.
    const delegatesWithTracks = (0, $ff275152c44ce822$export$bf095c2cbab9a226)(state);
    const network = state.network;
    const { selectedTrackIndexes: selectedTrackIndexes, sectionRefs: sectionRefs, scrollToSection: scrollToSection } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    // If user has some active delegation,
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex w-full flex-col gap-12",
        children: [
            delegatesWithTracks.size ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $57cc1ae6399b7e9c$export$c3d606494c505e29), {
                delegatesWithTracks: delegatesWithTracks,
                state: state
            }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex w-full flex-col gap-12",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: `flex w-full justify-between px-6 ${headlineVisible === "true" ? "hidden" : "block"}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-10"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ec6f470086eeee77$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "mt-6 flex h-fit w-fit cursor-pointer items-center justify-center rounded-full bg-white p-3",
                                onClick: ()=>setHeadlineVisible("true"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($85d4094de36eb8bc$export$cae179f078f4b4a4, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e8cb6ed9cb30ec88$export$14877970f9c0e5bd), {
                        delegates: delegates,
                        state: state
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $24210ae624608e08$export$bcb0a125575d8e21), {
                network: network,
                details: state.details,
                referenda: $85d4094de36eb8bc$var$exportReferenda(state),
                tracks: state.tracks,
                delegateHandler: ()=>scrollToSection("delegation")
            }),
            selectedTrackIndexes.size > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-12",
                ref: sectionRefs.get("delegation"),
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $834d68cc475258da$export$b57a26af1404503a), {
                    state: state,
                    delegates: delegates
                })
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");














function $0d970ff29a80f5de$export$4d96a3a5267fc3a8({ delegate: delegate }) {
    const { address: address, manifesto: manifesto, name: name } = delegate;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex flex-col items-start justify-start gap-6 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "flex items-start justify-between",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex flex-col items-start",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                            className: "text-xl capitalize",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                            address: address,
                            size: 24,
                            textClassName: "font-semibold my-2",
                            copy: true
                        })
                    ]
                })
            }),
            manifesto && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `h-full overflow-auto text-base`,
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a7fc90c90f223aea$export$21212e7778d9e5ba), {
                    children: manifesto
                })
            })
        ]
    });
}
function $0d970ff29a80f5de$export$cb867a2874c5a693({ delegate: delegate }) {
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const { connectedAccount: connectedAccount } = (0, $47acec667174acda$export$83a8e409853da004)();
    const [txVisible, setTxVisible] = (0, $4Iuzv.useState)(false);
    const { unit: unit, decimals: decimals } = (0, $ff275152c44ce822$export$4a6dbf642db5266c)(state) || {};
    const isProcessing = (0, $ff275152c44ce822$export$f21bf6b1fa1004ea)(state);
    const [usableBalance, setUsableBalance] = (0, $4Iuzv.useState)();
    const [fee, setFee] = (0, $4Iuzv.useState)();
    /* Memoized states */ // ToDo: use a set of hooks
    const allTracks = (0, $4Iuzv.useMemo)(()=>(0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks), [
        state.tracks
    ]);
    const undelegatedTracks = (0, $4Iuzv.useMemo)(()=>(0, $ff275152c44ce822$export$950bf1eaf02906d4)(state, allTracks), [
        state,
        allTracks
    ]);
    const balance = (0, $4Iuzv.useMemo)(()=>(0, $ff275152c44ce822$export$9c0e4d1c0409ad69)(state), [
        state
    ]);
    const connectedAddress = connectedAccount?.account?.address;
    const delegateAddress = delegate.address;
    const conviction = (0, $ea63bfbf68f64a41$export$1cf59a6acd43f5f).None;
    // set fee and delegatable balance
    (0, $4Iuzv.useEffect)(()=>{
        if (delegateAddress && connectedAddress && balance && undelegatedTracks.length > 0) {
            const getFees = async ()=>{
                const selectedTrackIds = undelegatedTracks.map((track)=>track.id);
                const allTrackIds = Array.from((0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).keys());
                const [delegateSelectedFee, undelegateAllFee] = await Promise.all([
                    updater.delegateFee(connectedAddress, delegateAddress, selectedTrackIds, balance, conviction),
                    updater.undelegateFee(connectedAddress, allTrackIds)
                ]);
                const usableBalance = delegateSelectedFee && undelegateAllFee && (0, $526c1cdc475b977f$export$4c62941f84ce88)(balance, delegateSelectedFee, undelegateAllFee);
                return {
                    fee: delegateSelectedFee,
                    usableBalance: usableBalance
                };
            };
            getFees().then(({ fee: fee, usableBalance: usableBalance })=>{
                setFee(fee);
                setUsableBalance(usableBalance);
            });
        }
    }, [
        delegateAddress,
        connectedAddress,
        balance,
        undelegatedTracks
    ]);
    // transaction Modal handlers
    const closeTxModal = ()=>{
        setTxVisible(false);
    };
    const openTxModal = ()=>{
        setTxVisible(true);
    };
    const delegateHandler = (e)=>{
        e.stopPropagation();
        openTxModal();
    };
    const delegatesWithTracks = (0, $ff275152c44ce822$export$bf095c2cbab9a226)(state);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b97b7432295b195f$export$60332b2344f7fe41), {
                    className: "w-[445px]",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex w-full flex-col gap-8 p-4 md:p-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col items-start justify-start gap-6 ",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "text-left",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                            className: "mb-2 text-3xl font-medium",
                                            children: "Delegate"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                        title: "Your delegate",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "flex gap-2",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $af1d92624e2a7343$export$769d3a2a5199587), {
                                                textClassName: "font-medium",
                                                address: delegate.address,
                                                size: 24,
                                                copy: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                        title: "Tracks to delegate",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$321a3a223c3064d2), {
                                            allTracksCount: (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).size,
                                            tracks: undelegatedTracks,
                                            visibleCount: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "grid w-full grid-cols-2 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                                title: "Tokens to delegate",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$2285b2873bbd5ff7), {
                                                    balance: usableBalance,
                                                    decimals: decimals,
                                                    unit: unit
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                                title: "Conviction",
                                                tooltipContent: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                                    children: [
                                                        "No conviction means your tokens are only locked while they are delegated. ",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                        " Once you unlock them, you can use them again.",
                                                        " "
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    children: (0, $526c1cdc475b977f$export$121bfd3c744d638e)(conviction)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("hr", {
                                        className: "w-full bg-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                                            title: "Delegation fee (one time)",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$2285b2873bbd5ff7), {
                                                balance: fee,
                                                unit: unit,
                                                decimals: decimals
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex w-full flex-row justify-end gap-4",
                                children: connectedAddress ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                                    className: "w-full",
                                    variant: "primary",
                                    onClick: (event)=>connectedAccount && usableBalance && delegateHandler(event),
                                    disabled: isProcessing || !connectedAccount || !usableBalance?.gtn(0),
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            children: !usableBalance?.gtn(0) ? "Insufficient tokens to delegate" : "Delegate now"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$9ca09caa9c849d9c), {})
                                    ]
                                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $380529cee7df9747$export$79b5060180039794), {})
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex w-full flex-col gap-2 text-sm",
                                children: delegatesWithTracks.size ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    className: "flex flex-row items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            children: "Manage your active delegations"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$9ca09caa9c849d9c), {})
                                    ]
                                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $c34e9f2261c19895$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    className: "flex flex-row items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            children: "Discover other delegates"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$9ca09caa9c849d9c), {})
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37fd5f9b026a9eee$export$49bc501e2d4eb5e2), {
                    open: txVisible,
                    onClose: closeTxModal,
                    delegate: delegate,
                    selectedTracks: undelegatedTracks
                })
            ]
        })
    });
}
function $0d970ff29a80f5de$export$4a1895bbf14a576e({ selectedDelegate: selectedDelegate }) {
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    // lookup delegate
    let delegate = selectedDelegate && (0, $ff275152c44ce822$export$338e8628bf39a38a)(state.delegates, selectedDelegate);
    if (!delegate) delegate = {
        name: "Anonymous",
        address: selectedDelegate,
        manifesto: "This delegate is not currently registered in our registry. However, you can still choose to delegate your votes to them if you trust them and have confidence in their abilities."
    };
    function generateShareLink() {
        return location.href;
    }
    const delegatesWithTracks = (0, $ff275152c44ce822$export$bf095c2cbab9a226)(state);
    const tracks = Array.from(delegatesWithTracks.entries()).find(([delegate])=>delegate.address == selectedDelegate)?.[1] || [];
    const [copied, setCopied] = (0, $4Iuzv.useState)(false);
    const allTracksCount = (0, $ff275152c44ce822$export$60cb0fea1fbc7c9f)(state.tracks).size;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex w-full max-w-[1280px] flex-row gap-32 p-8 pt-10",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex w-full flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex w-full flex-row justify-between",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "font-unbounded text-h4",
                                children: delegate.name
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $542cb45932491e02$exports.CopyToClipboard), {
                                text: generateShareLink(),
                                onCopy: ()=>updater.addReport({
                                        type: "Info",
                                        message: "Profile link copied to clipboard!"
                                    }),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                                    variant: "ghost",
                                    onClick: ()=>setCopied(true),
                                    children: [
                                        copied ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$7dd004358974b05d), {}) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$51b6cd98f8778f0d), {}),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            children: copied ? "Copied to clipboard" : "Copy profile link"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    tracks.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$dc148b0502442707), {
                        title: "Tracks delegated",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $8adc43caa88c8c97$export$321a3a223c3064d2), {
                            allTracksCount: allTracksCount,
                            tracks: tracks,
                            visibleCount: 2
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a7fc90c90f223aea$export$21212e7778d9e5ba), {
                        children: delegate.manifesto || ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($0d970ff29a80f5de$export$cb867a2874c5a693, {
                delegate: delegate
            })
        ]
    });
}









function $edb665c91c036e02$export$7cadb06ba645b788({ selectedDelegate: selectedDelegate }) {
    const [headlineVisible, setHeadlineVisible] = (0, $4Iuzv.useState)(localStorage.getItem("headlineVisible"));
    function setHeadlineVisibleAndPersist(visible) {
        setHeadlineVisible(visible);
        localStorage.setItem("headlineVisible", visible);
    }
    const { sectionRefs: sectionRefs } = (0, $f3b2482085a85b83$export$59cb04417d5d11ae)();
    const { state: state, updater: updater } = (0, $ff275152c44ce822$export$f941bf1beb8c8ec2)();
    const delegatesWithTracks = (0, $4Iuzv.useMemo)(()=>(0, $ff275152c44ce822$export$bf095c2cbab9a226)(state), [
        state
    ]);
    const withBackArrow = (0, $4Iuzv.useMemo)(()=>!!selectedDelegate && (0, $526c1cdc475b977f$export$1987372119294ebb)(selectedDelegate), [
        selectedDelegate
    ]);
    function generateShareLink() {
        return location.href;
    }
    (0, $4Iuzv.useEffect)(()=>{
        if (selectedDelegate) (0, $0d0c7aa829ece5a3$export$2d9921d8d94967bf).track("SelectedDelegateLanding", {
            address: selectedDelegate
        });
    }, [
        selectedDelegate
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $94a6d822497ef9d9$export$8b251419efc915eb), {
                activeDelegateCount: delegatesWithTracks.size,
                withBackArrow: withBackArrow,
                headlineVisible: headlineVisible,
                setHeadlineVisible: setHeadlineVisibleAndPersist
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6e524aa2864e32b3$export$4cc4937c9c6837aa), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
                ref: sectionRefs.get("top"),
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c34e9f2261c19895$export$11aac1aab828f1fa), {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mx-1 flex h-screen flex-col content-center justify-center space-y-12 text-center sm:hidden",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex content-center justify-center",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$1c5b0383ec045924), {
                                    size: "60"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                children: "Please visit Delegation Dashboard from your Desktop computer."
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($542cb45932491e02$exports))), {
                                text: generateShareLink(),
                                onCopy: ()=>updater.addReport({
                                        type: "Info",
                                        message: "Page link copied to clipboard!"
                                    }),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $8005f4acee16c419$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    className: "mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b42cfec9fe4e6e2e$export$51b6cd98f8778f0d), {}),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            children: "Copy page link"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: " hidden w-full flex-auto flex-col items-center justify-center gap-8 pb-48 pt-14 sm:flex sm:pt-20 lg:gap-16",
                        children: selectedDelegate && (0, $526c1cdc475b977f$export$1987372119294ebb)(selectedDelegate) ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0d970ff29a80f5de$export$4a1895bbf14a576e), {
                            selectedDelegate: selectedDelegate
                        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $85d4094de36eb8bc$export$c1e5ff2d5ab163a0), {
                            headlineVisible: headlineVisible,
                            setHeadlineVisible: setHeadlineVisibleAndPersist
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d15fb0862e5cf421$export$2e2bcd8739ae039), {})
        ]
    });
}
function $edb665c91c036e02$var$InnerLayoutWithAddress() {
    const { address: address } = (0, $175a2504a1bf07a5$export$99eaa27ddbbb95ef)();
    if (address && (0, $526c1cdc475b977f$export$1987372119294ebb)(address)) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($edb665c91c036e02$export$7cadb06ba645b788, {
        selectedDelegate: address
    });
    else return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $175a2504a1bf07a5$export$444b3ab0cb9aec40), {
        replace: true,
        to: "/"
    });
}
const $edb665c91c036e02$var$router = (0, $c34e9f2261c19895$export$1ba7ed8a3a7b3765)((0, $175a2504a1bf07a5$export$16da398f5434bdec)(/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
    children: [
        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $175a2504a1bf07a5$export$e7b0ac011bb776c6), {
            path: "/",
            element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($edb665c91c036e02$export$7cadb06ba645b788, {})
        }),
        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $175a2504a1bf07a5$export$e7b0ac011bb776c6), {
            path: "/:address",
            element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($edb665c91c036e02$var$InnerLayoutWithAddress, {})
        })
    ]
})));
function $edb665c91c036e02$export$31ce737da6920b0f() {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $175a2504a1bf07a5$export$323e4fc2fa4753fb), {
        router: $edb665c91c036e02$var$router
    });
}


function $2463f3eb8754fd21$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c50366e9c4b532e1$export$e926676385687eaf), {
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ff275152c44ce822$export$e78b73c32cb1e19f), {
            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2096fa05de40502f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $47acec667174acda$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $f3b2482085a85b83$export$4081c9b75e732995), {
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $edb665c91c036e02$export$31ce737da6920b0f), {})
                    })
                })
            })
        })
    });
}


var $ff71506dd59e0e9d$exports = {};

$ff71506dd59e0e9d$exports = new URL((parcelRequire("giU2u")).resolve("hmMpa"), import.meta.url).toString();


async function $d9afeb39c3341425$export$c6245babf0c60892() {
    const reg = await navigator.serviceWorker.register($ff71506dd59e0e9d$exports);
    // Wait for the service worker to be ready
    await navigator.serviceWorker.ready;
    reg.addEventListener("updatefound", ()=>{
        // A wild service worker has appeared in reg.installing!
        const newWorker = reg.installing;
        if (newWorker) {
            newWorker.state;
            // "installing" - the install event has fired, but not yet complete
            // "installed"  - install complete
            // "activating" - the activate event has fired, but not yet complete
            // "activated"  - fully active
            // "redundant"  - discarded. Either failed install, or it's been
            //                replaced by a newer version
            newWorker.addEventListener("statechange", ()=>{
            // newWorker.state has changed
            });
        }
    });
    navigator.serviceWorker.addEventListener("controllerchange", (e)=>{
        // This fires when the service worker controlling this page
        // changes, eg a new worker has skipped waiting and become
        // the new active worker.
        console.debug("ServiceWorker has been activated", e);
    });
    navigator.serviceWorker.addEventListener("message", ()=>{
        console.debug("New message");
    });
    navigator.serviceWorker.addEventListener("messageerror", ()=>{
        console.debug("New message error");
    });
    window.addEventListener("beforeinstallprompt", ()=>{
        // This fires when the service worker controlling this page
        // changes, eg a new worker has skipped waiting and become
        // the new active worker.
        console.debug("About to be installed");
    });
    window.addEventListener("appinstalled", ()=>{
        // This fires when the app has been installed
        console.debug("App installed");
    });
}


console.log(`Version ${"df21e0a"}`);
const $35a2b2932262f3ea$var$container = document.createElement("div");
document.body.appendChild($35a2b2932262f3ea$var$container);
$21fa618cfc67d6ae$export$882461b6382ed46c($35a2b2932262f3ea$var$container).render(/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).StrictMode, {
    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2463f3eb8754fd21$export$86fbec116b87613f), {})
}));
(0, $d9afeb39c3341425$export$c6245babf0c60892)().catch((e)=>{
    console.warn(`Browser doesn't support ServiceWorker; App won't be available offline: ${e.toString()}`);
    console.log(e.stack);
});


//# sourceMappingURL=index.39fbe3cd.js.map
